import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  bpchar: { input: any; output: any; }
  bytea: { input: any; output: any; }
  citext: { input: any; output: any; }
  date: { input: any; output: any; }
  float8: { input: any; output: any; }
  geography: { input: any; output: any; }
  geometry: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

export type ActivePropertiesOutput = {
  __typename?: 'ActivePropertiesOutput';
  active_properties_count?: Maybe<Scalars['Int']['output']>;
  limit_reached?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddListerLeadsInput = {
  organization_id: Scalars['uuid']['input'];
};

export type AddListerLeadsOutput = {
  __typename?: 'AddListerLeadsOutput';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Agency_Action_Type = {
  __typename?: 'Agency_Action_Type';
  name?: Maybe<Scalars['String']['output']>;
};

export enum AttributeTypeEnumAction {
  Both = 'both',
  Description = 'description',
  Title = 'title'
}

export enum AuthRoles_ActionsType {
  Agency = 'AGENCY',
  Lister = 'LISTER',
  Seeker = 'SEEKER'
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type ChangeUserRoleInput = {
  orgToken?: InputMaybe<Scalars['String']['input']>;
  organization_data?: InputMaybe<OrganizationDataActionType>;
  plan_id?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeUserRoleOutput = {
  __typename?: 'ChangeUserRoleOutput';
  message?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckListerInput = {
  organization_id: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  phone_number_type?: InputMaybe<Phone_Number_Type_ActionType>;
};

export type CheckListerOutput = {
  __typename?: 'CheckListerOutput';
  eligible: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  property_lists?: Maybe<Array<Maybe<Property_List_ActionType>>>;
  response_type?: Maybe<Lister_Claim_Response_ActionType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckPostAvailabilityOutput = {
  __typename?: 'CheckPostAvailabilityOutput';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type City_Zone_Action_Type = {
  __typename?: 'City_Zone_Action_Type';
  formatted_address?: Maybe<Scalars['String']['output']>;
};

export type Coords_Action_Type = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export enum CurrencyEnum_ActionsType {
  Eur = 'EUR',
  Gbp = 'GBP',
  Leke = 'LEKE',
  Usd = 'USD'
}

export type DashboardStatisticsActionInput = {
  organization_id?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<PeriodEnumActionType>;
  property_list_id?: InputMaybe<Scalars['String']['input']>;
  statistic_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StatisticQueryEnumActionType>;
};

export type DashboardStatisticsActionOutput = {
  __typename?: 'DashboardStatisticsActionOutput';
  aggregator_properties?: Maybe<Scalars['Int']['output']>;
  graphic_stats?: Maybe<Array<Maybe<GraphicStatsActionType>>>;
  kaktu_properties?: Maybe<Scalars['Int']['output']>;
  total_views?: Maybe<Scalars['Int']['output']>;
};

export type DuplicateSearchSessionInput = {
  session_id: Scalars['uuid']['input'];
};

export type DuplicateSearchSessionOutput = {
  __typename?: 'DuplicateSearchSessionOutput';
  details?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  new_session_id: Scalars['uuid']['output'];
  success: Scalars['Boolean']['output'];
};

export type ExtractedFiltersOutput_Actions_Type = {
  __typename?: 'ExtractedFiltersOutput_actions_type';
  area_max?: Maybe<Scalars['Float']['output']>;
  area_min?: Maybe<Scalars['Float']['output']>;
  city_name?: Maybe<Scalars['String']['output']>;
  city_zone_id?: Maybe<Scalars['String']['output']>;
  construction_status?: Maybe<Construction_Status_ActionType>;
  currency?: Maybe<CurrencyEnum_ActionsType>;
  drawed_zone?: Maybe<Scalars['jsonb']['output']>;
  furnishing_status?: Maybe<Furnishing_Status_ActionType>;
  location_string?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<Location_Object_Action_Type>>>;
  max_bathrooms?: Maybe<Scalars['Float']['output']>;
  max_rooms?: Maybe<Scalars['Float']['output']>;
  min_bathrooms?: Maybe<Scalars['Float']['output']>;
  min_rooms?: Maybe<Scalars['Float']['output']>;
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  property_cluster?: Maybe<PropertyClusterEnum_ActionsType>;
  property_composition?: Maybe<Scalars['String']['output']>;
  property_status?: Maybe<PropertyStatusEnum_ActionsType>;
  property_type?: Maybe<PropertyTypeEnum_ActionsType>;
};

export type ExtractedFilters_Actions_Type = {
  aggregated_bounds?: InputMaybe<Array<InputMaybe<Coords_Action_Type>>>;
  area_max?: InputMaybe<Scalars['Float']['input']>;
  area_min?: InputMaybe<Scalars['Float']['input']>;
  city_name?: InputMaybe<Scalars['String']['input']>;
  city_zone_id?: InputMaybe<Scalars['String']['input']>;
  construction_status?: InputMaybe<Array<InputMaybe<Construction_Status_ActionType>>>;
  currency?: InputMaybe<CurrencyEnum_ActionsType>;
  drawed_zone?: InputMaybe<Scalars['jsonb']['input']>;
  floor_max?: InputMaybe<Scalars['Int']['input']>;
  floor_min?: InputMaybe<Scalars['Int']['input']>;
  furnishing_status?: InputMaybe<Array<InputMaybe<Furnishing_Status_ActionType>>>;
  location_string?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Location_ObjectInput_Action_Type>>>;
  max_bathrooms?: InputMaybe<Scalars['Float']['input']>;
  max_rooms?: InputMaybe<Scalars['Float']['input']>;
  min_bathrooms?: InputMaybe<Scalars['Float']['input']>;
  min_rooms?: InputMaybe<Scalars['Float']['input']>;
  price_max?: InputMaybe<Scalars['Float']['input']>;
  price_min?: InputMaybe<Scalars['Float']['input']>;
  property_cluster?: InputMaybe<PropertyClusterEnum_ActionsType>;
  property_composition?: InputMaybe<Scalars['String']['input']>;
  property_feature_abbrvs?: InputMaybe<Array<Scalars['String']['input']>>;
  property_status?: InputMaybe<PropertyStatusEnum_ActionsType>;
  property_type?: InputMaybe<Array<InputMaybe<PropertyTypeEnum_ActionsType>>>;
};

export type FreeTrialInput = {
  role?: InputMaybe<AuthRoles_ActionsType>;
};

export type FreeTrialOutput = {
  __typename?: 'FreeTrialOutput';
  lister_id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateQueryInput = {
  filters_object?: InputMaybe<ExtractedFilters_Actions_Type>;
  session_id?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateQueryOutput = {
  __typename?: 'GenerateQueryOutput';
  filters_object?: Maybe<ExtractedFiltersOutput_Actions_Type>;
  query?: Maybe<Natural_Language_Queries>;
  query_id?: Maybe<Scalars['String']['output']>;
  query_type?: Maybe<Scalars['String']['output']>;
};

export type GenerateTextOutput = {
  __typename?: 'GenerateTextOutput';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  text: Scalars['String']['output'];
};

export type Geom_Action_Type = {
  __typename?: 'Geom_Action_Type';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  crs?: Maybe<Scalars['jsonb']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GetActiveSubscriptionOutput = {
  __typename?: 'GetActiveSubscriptionOutput';
  active?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  plan_id?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Subscription>;
  subscription_id?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetOrganizationLeadPropertiesAgencyOrderBy = {
  address?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_phone_numbers_aggregate?: InputMaybe<GetOrganizationLeadPropertiesContactPhoneNumberAggregateOrderBy>;
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  display_name?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  name?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parent_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  phone_number?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  profile_image_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_sources_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertySourceAggregateOrderBy>;
  type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesCityOrderBy = {
  center_location?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  city_name?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  country_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  display_name?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  viewport?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesCityZoneOrderBy = {
  bounds?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  city?: InputMaybe<GetOrganizationLeadPropertiesCityOrderBy>;
  city_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  data_method?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  formatted_address?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  geometry?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  is_problematic?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  location?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  location_type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  origin?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  place_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  surface_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  types?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  viewport?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  zone_data_method?: InputMaybe<GetOrganizationLeadPropertiesZoneDataMethodOrderBy>;
  zone_name?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesContactOrderBy = {
  contact_phone_numbers_aggregate?: InputMaybe<GetOrganizationLeadPropertiesContactPhoneNumberAggregateOrderBy>;
  contact_type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  email?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  full_name?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_lists_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyListAggregateOrderBy>;
};

export type GetOrganizationLeadPropertiesContactPhoneNumberAggregateOrderBy = {
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesContactPhoneNumberMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesContactPhoneNumberMinOrderBy>;
};

export type GetOrganizationLeadPropertiesContactPhoneNumberMaxOrderBy = {
  agency_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  phone_number?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesContactPhoneNumberMinOrderBy = {
  agency_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  phone_number?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesLocationOrderBy = {
  administrative_area_level_1?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  administrative_area_level_2?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  city_zone?: InputMaybe<GetOrganizationLeadPropertiesCityZoneOrderBy>;
  city_zone_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  confidence?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  country?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  exact_location?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  formatted_address?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  geom?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  lat?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  lng?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  locality?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  place_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  postal_code?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_lists_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyListAggregateOrderBy>;
  raw_location_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  route?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  street_number?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export enum GetOrganizationLeadPropertiesOrderBy {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type GetOrganizationLeadPropertiesOrganizationLeadPropertyOrderBy = {
  category?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  opened?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  organization_lead_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_list?: InputMaybe<GetOrganizationLeadPropertiesPropertyListOrderBy>;
  property_list_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesOutput = {
  __typename?: 'GetOrganizationLeadPropertiesOutput';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organization_lead_property?: Maybe<Organization_Lead_Property>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type GetOrganizationLeadPropertiesPropertyAggregateOrderBy = {
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesPropertyMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesPropertyMinOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyClusterOrderBy = {
  cluster?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_types_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyTypeAggregateOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyCompositionOrderBy = {
  balconies?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  bathrooms?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  bedrooms?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  kitchens?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  living_rooms?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyFeatureAggregateOrderBy = {
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesPropertyFeatureMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesPropertyFeatureMinOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyFeatureMaxOrderBy = {
  feature_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_list_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyFeatureMinOrderBy = {
  feature_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_list_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyImageAggregateOrderBy = {
  avg?: InputMaybe<GetOrganizationLeadPropertiesPropertyImageAvgOrderBy>;
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesPropertyImageMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesPropertyImageMinOrderBy>;
  stddev?: InputMaybe<GetOrganizationLeadPropertiesPropertyImageStddevOrderBy>;
  stddev_pop?: InputMaybe<GetOrganizationLeadPropertiesPropertyImageStddevPopOrderBy>;
  stddev_samp?: InputMaybe<GetOrganizationLeadPropertiesPropertyImageStddevSampOrderBy>;
  sum?: InputMaybe<GetOrganizationLeadPropertiesPropertyImageSumOrderBy>;
  var_pop?: InputMaybe<GetOrganizationLeadPropertiesPropertyImageVarPopOrderBy>;
  var_samp?: InputMaybe<GetOrganizationLeadPropertiesPropertyImageVarSampOrderBy>;
  variance?: InputMaybe<GetOrganizationLeadPropertiesPropertyImageVarianceOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyImageAvgOrderBy = {
  index?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyImageMaxOrderBy = {
  blurhash?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  image?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  index?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  origin_url?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  playback_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_list_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyImageMinOrderBy = {
  blurhash?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  image?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  index?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  origin_url?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  playback_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_list_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyImageOrderBy = {
  blurhash?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  image?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  index?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  is_main?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  metadata?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  origin_url?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  playback_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  processed?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property?: InputMaybe<GetOrganizationLeadPropertiesPropertyOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_list?: InputMaybe<GetOrganizationLeadPropertiesPropertyListOrderBy>;
  property_list_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_lists_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyListAggregateOrderBy>;
  type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyImageStddevOrderBy = {
  index?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyImageStddevPopOrderBy = {
  index?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyImageStddevSampOrderBy = {
  index?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyImageSumOrderBy = {
  index?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyImageVarPopOrderBy = {
  index?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyImageVarSampOrderBy = {
  index?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyImageVarianceOrderBy = {
  index?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListAggregateOrderBy = {
  avg?: InputMaybe<GetOrganizationLeadPropertiesPropertyListAvgOrderBy>;
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesPropertyListMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesPropertyListMinOrderBy>;
  stddev?: InputMaybe<GetOrganizationLeadPropertiesPropertyListStddevOrderBy>;
  stddev_pop?: InputMaybe<GetOrganizationLeadPropertiesPropertyListStddevPopOrderBy>;
  stddev_samp?: InputMaybe<GetOrganizationLeadPropertiesPropertyListStddevSampOrderBy>;
  sum?: InputMaybe<GetOrganizationLeadPropertiesPropertyListSumOrderBy>;
  var_pop?: InputMaybe<GetOrganizationLeadPropertiesPropertyListVarPopOrderBy>;
  var_samp?: InputMaybe<GetOrganizationLeadPropertiesPropertyListVarSampOrderBy>;
  variance?: InputMaybe<GetOrganizationLeadPropertiesPropertyListVarianceOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListAvgOrderBy = {
  building_floors?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  construction_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  floor?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_renovation_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  living_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parking_spaces?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  plot_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url_clicked?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  total_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  views?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListFolderAggregateOrderBy = {
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesPropertyListFolderMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesPropertyListFolderMinOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListFolderMaxOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  folder_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_list_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListFolderMinOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  folder_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_list_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListMaxOrderBy = {
  building_floors?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  canonical_url?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  construction_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_email?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_name?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_phone_1?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_phone_2?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  content_location?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_by_user_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  description_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  disapproved_comment?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  floor?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  generated_title_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  heating_type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_renovation_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_seen?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  lister_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  living_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  location_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  lot_size?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  main_image_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  organization_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parent_property?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parking_spaces?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  plot_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  posted_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_composition_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  rental_terms?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  sale_terms?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  search_vector?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url_clicked?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  task_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  title_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  total_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  views?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListMinOrderBy = {
  building_floors?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  canonical_url?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  construction_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_email?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_name?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_phone_1?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_phone_2?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  content_location?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_by_user_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  description_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  disapproved_comment?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  floor?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  generated_title_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  heating_type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_renovation_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_seen?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  lister_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  living_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  location_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  lot_size?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  main_image_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  organization_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parent_property?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parking_spaces?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  plot_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  posted_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_composition_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  rental_terms?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  sale_terms?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  search_vector?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url_clicked?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  task_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  title_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  total_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  views?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListOrderBy = {
  archived?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  building_floors?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  canonical_url?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  construction_status?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  construction_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact?: InputMaybe<GetOrganizationLeadPropertiesContactOrderBy>;
  contact_email?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_name?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_phone_1?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  contact_phone_2?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  content_location?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  created_by_user_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  deleted?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  description_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  description_text_content?: InputMaybe<GetOrganizationLeadPropertiesTextContentOrderBy>;
  disapproved_comment?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  featured?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  features?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  features_array?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  features_json?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  floor?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  furnishing_status?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  generated_title?: InputMaybe<GetOrganizationLeadPropertiesTextContentOrderBy>;
  generated_title_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  has_balcony?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  has_carport?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  has_elevator?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  has_garage?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  has_garden?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  has_parking_space?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  has_property_title?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  has_terrace?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  heating_type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  is_active?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  is_barrier_free?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  json_ld?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_renovation_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_seen?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  lister_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  living_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  location?: InputMaybe<GetOrganizationLeadPropertiesLocationOrderBy>;
  location_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  lot_size?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  main_image?: InputMaybe<GetOrganizationLeadPropertiesPropertyImageOrderBy>;
  main_image_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  organization_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parent_property?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parking_spaces?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parking_type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  pets_allowed?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  plot_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  posted_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price_currency?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price_exchange?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  properties_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyAggregateOrderBy>;
  property?: InputMaybe<GetOrganizationLeadPropertiesPropertyOrderBy>;
  property_composition?: InputMaybe<GetOrganizationLeadPropertiesPropertyCompositionOrderBy>;
  property_composition_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_features_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyFeatureAggregateOrderBy>;
  property_images_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyImageAggregateOrderBy>;
  property_list_folders_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyListFolderAggregateOrderBy>;
  property_origin_type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_price_histories_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyPriceHistoryAggregateOrderBy>;
  property_source?: InputMaybe<GetOrganizationLeadPropertiesPropertySourceOrderBy>;
  property_status?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_type_rel?: InputMaybe<GetOrganizationLeadPropertiesPropertyTypeOrderBy>;
  rental_terms?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  sale_terms?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  search_vector?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  smoking_allowed?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url_clicked?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  sponsored?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  sponsored_property_lists_aggregate?: InputMaybe<GetOrganizationLeadPropertiesSponsoredPropertyListAggregateOrderBy>;
  task_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  title_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  title_text_content?: InputMaybe<GetOrganizationLeadPropertiesTextContentOrderBy>;
  total_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  views?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  visibility_status?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListStddevOrderBy = {
  building_floors?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  construction_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  floor?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_renovation_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  living_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parking_spaces?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  plot_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url_clicked?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  total_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  views?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListStddevPopOrderBy = {
  building_floors?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  construction_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  floor?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_renovation_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  living_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parking_spaces?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  plot_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url_clicked?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  total_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  views?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListStddevSampOrderBy = {
  building_floors?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  construction_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  floor?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_renovation_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  living_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parking_spaces?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  plot_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url_clicked?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  total_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  views?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListSumOrderBy = {
  building_floors?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  construction_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  floor?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_renovation_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  living_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parking_spaces?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  plot_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url_clicked?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  total_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  views?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListVarPopOrderBy = {
  building_floors?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  construction_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  floor?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_renovation_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  living_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parking_spaces?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  plot_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url_clicked?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  total_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  views?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListVarSampOrderBy = {
  building_floors?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  construction_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  floor?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_renovation_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  living_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parking_spaces?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  plot_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url_clicked?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  total_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  views?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyListVarianceOrderBy = {
  building_floors?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  construction_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  floor?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_renovation_year?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  living_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  parking_spaces?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  plot_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  source_url_clicked?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  total_area?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  views?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyMaxOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  json_ld?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_seen?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  main_listing_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyMinOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  json_ld?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_seen?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  main_listing_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  json_ld?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  last_seen?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  main_listing_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  main_property?: InputMaybe<GetOrganizationLeadPropertiesPropertyListOrderBy>;
  property_features_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyFeatureAggregateOrderBy>;
  property_images_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyImageAggregateOrderBy>;
  property_lists_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyListAggregateOrderBy>;
  property_price_histories_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyPriceHistoryAggregateOrderBy>;
  property_views_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyViewsAggregateOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  url_slugs_aggregate?: InputMaybe<GetOrganizationLeadPropertiesUrlSlugAggregateOrderBy>;
  user_saved_properties_aggregate?: InputMaybe<GetOrganizationLeadPropertiesUserSavedPropertiesAggregateOrderBy>;
  user_seen_properties_aggregate?: InputMaybe<GetOrganizationLeadPropertiesUserSeenPropertyAggregateOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyPriceHistoryAggregateOrderBy = {
  avg?: InputMaybe<GetOrganizationLeadPropertiesPropertyPriceHistoryAvgOrderBy>;
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesPropertyPriceHistoryMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesPropertyPriceHistoryMinOrderBy>;
  stddev?: InputMaybe<GetOrganizationLeadPropertiesPropertyPriceHistoryStddevOrderBy>;
  stddev_pop?: InputMaybe<GetOrganizationLeadPropertiesPropertyPriceHistoryStddevPopOrderBy>;
  stddev_samp?: InputMaybe<GetOrganizationLeadPropertiesPropertyPriceHistoryStddevSampOrderBy>;
  sum?: InputMaybe<GetOrganizationLeadPropertiesPropertyPriceHistorySumOrderBy>;
  var_pop?: InputMaybe<GetOrganizationLeadPropertiesPropertyPriceHistoryVarPopOrderBy>;
  var_samp?: InputMaybe<GetOrganizationLeadPropertiesPropertyPriceHistoryVarSampOrderBy>;
  variance?: InputMaybe<GetOrganizationLeadPropertiesPropertyPriceHistoryVarianceOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyPriceHistoryAvgOrderBy = {
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyPriceHistoryMaxOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  date_recorded?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_list_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyPriceHistoryMinOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  date_recorded?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_list_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyPriceHistoryStddevOrderBy = {
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyPriceHistoryStddevPopOrderBy = {
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyPriceHistoryStddevSampOrderBy = {
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyPriceHistorySumOrderBy = {
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyPriceHistoryVarPopOrderBy = {
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyPriceHistoryVarSampOrderBy = {
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyPriceHistoryVarianceOrderBy = {
  price?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertySourceAggregateOrderBy = {
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesPropertySourceMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesPropertySourceMinOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertySourceMaxOrderBy = {
  agency_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertySourceMinOrderBy = {
  agency_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertySourceOrderBy = {
  agency?: InputMaybe<GetOrganizationLeadPropertiesAgencyOrderBy>;
  agency_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  origin?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_lists_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyListAggregateOrderBy>;
  type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyTypeAggregateOrderBy = {
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesPropertyTypeMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesPropertyTypeMinOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyTypeMaxOrderBy = {
  type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyTypeMinOrderBy = {
  type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyTypeOrderBy = {
  cluster?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_cluster?: InputMaybe<GetOrganizationLeadPropertiesPropertyClusterOrderBy>;
  property_lists_aggregate?: InputMaybe<GetOrganizationLeadPropertiesPropertyListAggregateOrderBy>;
  type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyViewsAggregateOrderBy = {
  avg?: InputMaybe<GetOrganizationLeadPropertiesPropertyViewsAvgOrderBy>;
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesPropertyViewsMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesPropertyViewsMinOrderBy>;
  stddev?: InputMaybe<GetOrganizationLeadPropertiesPropertyViewsStddevOrderBy>;
  stddev_pop?: InputMaybe<GetOrganizationLeadPropertiesPropertyViewsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<GetOrganizationLeadPropertiesPropertyViewsStddevSampOrderBy>;
  sum?: InputMaybe<GetOrganizationLeadPropertiesPropertyViewsSumOrderBy>;
  var_pop?: InputMaybe<GetOrganizationLeadPropertiesPropertyViewsVarPopOrderBy>;
  var_samp?: InputMaybe<GetOrganizationLeadPropertiesPropertyViewsVarSampOrderBy>;
  variance?: InputMaybe<GetOrganizationLeadPropertiesPropertyViewsVarianceOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyViewsAvgOrderBy = {
  view_count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyViewsMaxOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  date?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  view_count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyViewsMinOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  date?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  view_count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyViewsStddevOrderBy = {
  view_count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyViewsStddevPopOrderBy = {
  view_count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyViewsStddevSampOrderBy = {
  view_count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyViewsSumOrderBy = {
  view_count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyViewsVarPopOrderBy = {
  view_count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyViewsVarSampOrderBy = {
  view_count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesPropertyViewsVarianceOrderBy = {
  view_count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesSponsoredPropertyListAggregateOrderBy = {
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesSponsoredPropertyListMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesSponsoredPropertyListMinOrderBy>;
};

export type GetOrganizationLeadPropertiesSponsoredPropertyListMaxOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  end_date?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  product_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_list_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  start_date?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesSponsoredPropertyListMinOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  end_date?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  product_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_list_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  start_date?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesTextContentOrderBy = {
  content_type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  entity_type?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  original_language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  original_text?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  seo_meta?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  translations_aggregate?: InputMaybe<GetOrganizationLeadPropertiesTranslationsAggregateOrderBy>;
};

export type GetOrganizationLeadPropertiesTranslationsAggregateOrderBy = {
  avg?: InputMaybe<GetOrganizationLeadPropertiesTranslationsAvgOrderBy>;
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesTranslationsMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesTranslationsMinOrderBy>;
  stddev?: InputMaybe<GetOrganizationLeadPropertiesTranslationsStddevOrderBy>;
  stddev_pop?: InputMaybe<GetOrganizationLeadPropertiesTranslationsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<GetOrganizationLeadPropertiesTranslationsStddevSampOrderBy>;
  sum?: InputMaybe<GetOrganizationLeadPropertiesTranslationsSumOrderBy>;
  var_pop?: InputMaybe<GetOrganizationLeadPropertiesTranslationsVarPopOrderBy>;
  var_samp?: InputMaybe<GetOrganizationLeadPropertiesTranslationsVarSampOrderBy>;
  variance?: InputMaybe<GetOrganizationLeadPropertiesTranslationsVarianceOrderBy>;
};

export type GetOrganizationLeadPropertiesTranslationsAvgOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesTranslationsMaxOrderBy = {
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  seo_meta?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  text_content_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  translation?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesTranslationsMinOrderBy = {
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  seo_meta?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  text_content_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  translation?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesTranslationsStddevOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesTranslationsStddevPopOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesTranslationsStddevSampOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesTranslationsSumOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesTranslationsVarPopOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesTranslationsVarSampOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesTranslationsVarianceOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUrlSlugAggregateOrderBy = {
  avg?: InputMaybe<GetOrganizationLeadPropertiesUrlSlugAvgOrderBy>;
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesUrlSlugMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesUrlSlugMinOrderBy>;
  stddev?: InputMaybe<GetOrganizationLeadPropertiesUrlSlugStddevOrderBy>;
  stddev_pop?: InputMaybe<GetOrganizationLeadPropertiesUrlSlugStddevPopOrderBy>;
  stddev_samp?: InputMaybe<GetOrganizationLeadPropertiesUrlSlugStddevSampOrderBy>;
  sum?: InputMaybe<GetOrganizationLeadPropertiesUrlSlugSumOrderBy>;
  var_pop?: InputMaybe<GetOrganizationLeadPropertiesUrlSlugVarPopOrderBy>;
  var_samp?: InputMaybe<GetOrganizationLeadPropertiesUrlSlugVarSampOrderBy>;
  variance?: InputMaybe<GetOrganizationLeadPropertiesUrlSlugVarianceOrderBy>;
};

export type GetOrganizationLeadPropertiesUrlSlugAvgOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUrlSlugMaxOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  redirect_to?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  redirect_to_slug?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  slug?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUrlSlugMinOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  redirect_to?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  redirect_to_slug?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  slug?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUrlSlugStddevOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUrlSlugStddevPopOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUrlSlugStddevSampOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUrlSlugSumOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUrlSlugVarPopOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUrlSlugVarSampOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUrlSlugVarianceOrderBy = {
  language_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUserSavedPropertiesAggregateOrderBy = {
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesUserSavedPropertiesMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesUserSavedPropertiesMinOrderBy>;
};

export type GetOrganizationLeadPropertiesUserSavedPropertiesMaxOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  user_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUserSavedPropertiesMinOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  user_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUserSeenPropertyAggregateOrderBy = {
  count?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  max?: InputMaybe<GetOrganizationLeadPropertiesUserSeenPropertyMaxOrderBy>;
  min?: InputMaybe<GetOrganizationLeadPropertiesUserSeenPropertyMinOrderBy>;
};

export type GetOrganizationLeadPropertiesUserSeenPropertyMaxOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  user_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesUserSeenPropertyMinOrderBy = {
  created_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  property_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  updated_at?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
  user_id?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GetOrganizationLeadPropertiesZoneDataMethodOrderBy = {
  method?: InputMaybe<GetOrganizationLeadPropertiesOrderBy>;
};

export type GraphicStatsActionType = {
  __typename?: 'GraphicStatsActionType';
  total_views?: Maybe<Scalars['Int']['output']>;
  view_date?: Maybe<Scalars['String']['output']>;
};

export enum IncrementPropertyStatsIncrementType {
  PhoneClick = 'phone_click',
  SourceClick = 'source_click',
  View = 'view'
}

export type IncrementPropertyStatsInput = {
  incrementType: IncrementPropertyStatsIncrementType;
  metadata?: InputMaybe<IncrementPropertyStatsMetadataInput>;
  propertyListId: Scalars['uuid']['input'];
};

export type IncrementPropertyStatsMetadataInput = {
  ip?: InputMaybe<Scalars['String']['input']>;
  referer?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type IncrementPropertyStatsOutput = {
  __typename?: 'IncrementPropertyStatsOutput';
  incrementType: IncrementPropertyStatsIncrementType;
  message?: Maybe<Scalars['String']['output']>;
  newValue: Scalars['Int']['output'];
  propertyListId: Scalars['uuid']['output'];
  success: Scalars['Boolean']['output'];
};

export type Input = {
  amenities_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  features_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nlq_id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type InsertOrderOrderInsertInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  membership_package_id?: InputMaybe<Scalars['uuid']['input']>;
  order_response?: InputMaybe<Scalars['jsonb']['input']>;
  sdkOrderId?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertOrderOutput = {
  __typename?: 'InsertOrderOutput';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  membership_package_id?: Maybe<Scalars['uuid']['output']>;
  order_response?: Maybe<Scalars['jsonb']['output']>;
  sdkOrderId?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

export type InsertPropertyListAgencyBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListAgencyBoolExp>>;
  _not?: InputMaybe<InsertPropertyListAgencyBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListAgencyBoolExp>>;
  address?: InputMaybe<InsertPropertyListStringComparisonExp>;
  contact_phone_numbers?: InputMaybe<InsertPropertyListContactPhoneNumberBoolExp>;
  contact_phone_numbers_aggregate?: InputMaybe<InsertPropertyListContactPhoneNumberAggregateBoolExp>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  display_name?: InputMaybe<InsertPropertyListStringComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  name?: InputMaybe<InsertPropertyListStringComparisonExp>;
  parent_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  phone_number?: InputMaybe<InsertPropertyListStringComparisonExp>;
  profile_image_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  property_sources?: InputMaybe<InsertPropertyListPropertySourceBoolExp>;
  property_sources_aggregate?: InputMaybe<InsertPropertyListPropertySourceAggregateBoolExp>;
  type?: InputMaybe<InsertPropertyListStringComparisonExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
};

export enum InsertPropertyListAgencyConstraint {
  /** unique or primary key constraint on columns "name" */
  AgencyNameKey = 'agency_name_key',
  /** unique or primary key constraint on columns "id" */
  AgencyPkey = 'agency_pkey'
}

export type InsertPropertyListAgencyInsertInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  contact_phone_numbers?: InputMaybe<InsertPropertyListContactPhoneNumberArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_image_id?: InputMaybe<Scalars['uuid']['input']>;
  property_sources?: InputMaybe<InsertPropertyListPropertySourceArrRelInsertInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertPropertyListAgencyObjRelInsertInput = {
  data: InsertPropertyListAgencyInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListAgencyOnConflict>;
};

export type InsertPropertyListAgencyOnConflict = {
  constraint: InsertPropertyListAgencyConstraint;
  update_columns: Array<InsertPropertyListAgencyUpdateColumn>;
  where?: InputMaybe<InsertPropertyListAgencyBoolExp>;
};

export enum InsertPropertyListAgencyUpdateColumn {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  ProfileImageId = 'profile_image_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertPropertyListAmenitiesBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListAmenitiesBoolExp>>;
  _not?: InputMaybe<InsertPropertyListAmenitiesBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListAmenitiesBoolExp>>;
  amenity_name_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  category?: InputMaybe<InsertPropertyListStringComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  text_content?: InputMaybe<InsertPropertyListTextContentBoolExp>;
};

export enum InsertPropertyListAmenitiesConstraint {
  /** unique or primary key constraint on columns "id" */
  AmenitiesPkey = 'amenities_pkey'
}

export type InsertPropertyListAmenitiesInsertInput = {
  amenity_name_id?: InputMaybe<Scalars['uuid']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  text_content?: InputMaybe<InsertPropertyListTextContentObjRelInsertInput>;
};

export type InsertPropertyListAmenitiesObjRelInsertInput = {
  data: InsertPropertyListAmenitiesInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListAmenitiesOnConflict>;
};

export type InsertPropertyListAmenitiesOnConflict = {
  constraint: InsertPropertyListAmenitiesConstraint;
  update_columns: Array<InsertPropertyListAmenitiesUpdateColumn>;
  where?: InputMaybe<InsertPropertyListAmenitiesBoolExp>;
};

export enum InsertPropertyListAmenitiesUpdateColumn {
  /** column name */
  AmenityNameId = 'amenity_name_id',
  /** column name */
  Category = 'category',
  /** column name */
  Id = 'id'
}

export type InsertPropertyListBooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type InsertPropertyListBpcharComparisonExp = {
  _eq?: InputMaybe<Scalars['bpchar']['input']>;
  _gt?: InputMaybe<Scalars['bpchar']['input']>;
  _gte?: InputMaybe<Scalars['bpchar']['input']>;
  _ilike?: InputMaybe<Scalars['bpchar']['input']>;
  _in?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  _iregex?: InputMaybe<Scalars['bpchar']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _like?: InputMaybe<Scalars['bpchar']['input']>;
  _lt?: InputMaybe<Scalars['bpchar']['input']>;
  _lte?: InputMaybe<Scalars['bpchar']['input']>;
  _neq?: InputMaybe<Scalars['bpchar']['input']>;
  _nilike?: InputMaybe<Scalars['bpchar']['input']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  _niregex?: InputMaybe<Scalars['bpchar']['input']>;
  _nlike?: InputMaybe<Scalars['bpchar']['input']>;
  _nregex?: InputMaybe<Scalars['bpchar']['input']>;
  _nsimilar?: InputMaybe<Scalars['bpchar']['input']>;
  _regex?: InputMaybe<Scalars['bpchar']['input']>;
  _similar?: InputMaybe<Scalars['bpchar']['input']>;
};

export type InsertPropertyListCityBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListCityBoolExp>>;
  _not?: InputMaybe<InsertPropertyListCityBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListCityBoolExp>>;
  city_name?: InputMaybe<InsertPropertyListStringComparisonExp>;
  country_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  display_name?: InputMaybe<InsertPropertyListStringComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
};

export enum InsertPropertyListCityConstraint {
  /** unique or primary key constraint on columns "city_name" */
  CityCityNameKey = 'city_city_name_key',
  /** unique or primary key constraint on columns "id" */
  CityPkey = 'city_pkey'
}

export type InsertPropertyListCityInsertInput = {
  city_name?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertPropertyListCityObjRelInsertInput = {
  data: InsertPropertyListCityInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListCityOnConflict>;
};

export type InsertPropertyListCityOnConflict = {
  constraint: InsertPropertyListCityConstraint;
  update_columns: Array<InsertPropertyListCityUpdateColumn>;
  where?: InputMaybe<InsertPropertyListCityBoolExp>;
};

export enum InsertPropertyListCityUpdateColumn {
  /** column name */
  CityName = 'city_name',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id'
}

export type InsertPropertyListCityZoneBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListCityZoneBoolExp>>;
  _not?: InputMaybe<InsertPropertyListCityZoneBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListCityZoneBoolExp>>;
  bounds?: InputMaybe<InsertPropertyListJsonbComparisonExp>;
  city?: InputMaybe<InsertPropertyListCityBoolExp>;
  city_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  data_method?: InputMaybe<InsertPropertyListZoneDataMethodEnumComparisonExp>;
  formatted_address?: InputMaybe<InsertPropertyListStringComparisonExp>;
  geometry?: InputMaybe<InsertPropertyListGeographyComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  is_problematic?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  location?: InputMaybe<InsertPropertyListJsonbComparisonExp>;
  location_type?: InputMaybe<InsertPropertyListStringComparisonExp>;
  origin?: InputMaybe<InsertPropertyListCityZoneOriginEnumComparisonExp>;
  place_id?: InputMaybe<InsertPropertyListStringComparisonExp>;
  property_count?: InputMaybe<InsertPropertyListIntComparisonExp>;
  surface_area?: InputMaybe<InsertPropertyListFloat8ComparisonExp>;
  types?: InputMaybe<InsertPropertyListJsonbComparisonExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  viewport?: InputMaybe<InsertPropertyListJsonbComparisonExp>;
  zone_data_method?: InputMaybe<InsertPropertyListZoneDataMethodBoolExp>;
  zone_name?: InputMaybe<InsertPropertyListStringComparisonExp>;
};

export enum InsertPropertyListCityZoneConstraint {
  /** unique or primary key constraint on columns "id" */
  CityZonePkey = 'city_zone_pkey',
  /** unique or primary key constraint on columns "zone_name", "city_id" */
  CityZoneZoneNameCityIdKey = 'city_zone_zone_name_city_id_key'
}

export type InsertPropertyListCityZoneInsertInput = {
  bounds?: InputMaybe<Scalars['jsonb']['input']>;
  city?: InputMaybe<InsertPropertyListCityObjRelInsertInput>;
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_method?: InputMaybe<InsertPropertyListZoneDataMethodEnum>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  geometry?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_problematic?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  location_type?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<InsertPropertyListCityZoneOriginEnum>;
  place_id?: InputMaybe<Scalars['String']['input']>;
  surface_area?: InputMaybe<Scalars['float8']['input']>;
  types?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  viewport?: InputMaybe<Scalars['jsonb']['input']>;
  zone_data_method?: InputMaybe<InsertPropertyListZoneDataMethodObjRelInsertInput>;
  zone_name?: InputMaybe<Scalars['String']['input']>;
};

export type InsertPropertyListCityZoneObjRelInsertInput = {
  data: InsertPropertyListCityZoneInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListCityZoneOnConflict>;
};

export type InsertPropertyListCityZoneOnConflict = {
  constraint: InsertPropertyListCityZoneConstraint;
  update_columns: Array<InsertPropertyListCityZoneUpdateColumn>;
  where?: InputMaybe<InsertPropertyListCityZoneBoolExp>;
};

export enum InsertPropertyListCityZoneOriginEnum {
  Pipeline = 'PIPELINE',
  Seeded = 'SEEDED',
  User = 'USER'
}

export type InsertPropertyListCityZoneOriginEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListCityZoneOriginEnum>;
  _in?: InputMaybe<Array<InsertPropertyListCityZoneOriginEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListCityZoneOriginEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListCityZoneOriginEnum>>;
};

export enum InsertPropertyListCityZoneUpdateColumn {
  /** column name */
  Bounds = 'bounds',
  /** column name */
  CityId = 'city_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataMethod = 'data_method',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  IsProblematic = 'is_problematic',
  /** column name */
  Location = 'location',
  /** column name */
  LocationType = 'location_type',
  /** column name */
  Origin = 'origin',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  SurfaceArea = 'surface_area',
  /** column name */
  Types = 'types',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Viewport = 'viewport',
  /** column name */
  ZoneName = 'zone_name'
}

export enum InsertPropertyListConstructionStatusEnum {
  InProgress = 'in_progress',
  NewBuilding = 'new_building',
  OldBuilding = 'old_building',
  UnderConstruction = 'under_construction'
}

export type InsertPropertyListConstructionStatusEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListConstructionStatusEnum>;
  _in?: InputMaybe<Array<InsertPropertyListConstructionStatusEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListConstructionStatusEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListConstructionStatusEnum>>;
};

export type InsertPropertyListContactBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListContactBoolExp>>;
  _not?: InputMaybe<InsertPropertyListContactBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListContactBoolExp>>;
  contact_phone_numbers?: InputMaybe<InsertPropertyListContactPhoneNumberBoolExp>;
  contact_phone_numbers_aggregate?: InputMaybe<InsertPropertyListContactPhoneNumberAggregateBoolExp>;
  contact_type?: InputMaybe<InsertPropertyListContactTypeEnumComparisonExp>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  email?: InputMaybe<InsertPropertyListStringComparisonExp>;
  full_name?: InputMaybe<InsertPropertyListStringComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  property_lists_aggregate?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExp>;
};

export enum InsertPropertyListContactConstraint {
  /** unique or primary key constraint on columns "id" */
  ContactPkey = 'contact_pkey'
}

export type InsertPropertyListContactInsertInput = {
  contact_phone_numbers?: InputMaybe<InsertPropertyListContactPhoneNumberArrRelInsertInput>;
  contact_type?: InputMaybe<InsertPropertyListContactTypeEnum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListArrRelInsertInput>;
};

export type InsertPropertyListContactObjRelInsertInput = {
  data: InsertPropertyListContactInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListContactOnConflict>;
};

export type InsertPropertyListContactOnConflict = {
  constraint: InsertPropertyListContactConstraint;
  update_columns: Array<InsertPropertyListContactUpdateColumn>;
  where?: InputMaybe<InsertPropertyListContactBoolExp>;
};

export type InsertPropertyListContactPhoneNumberAggregateBoolExp = {
  count?: InputMaybe<InsertPropertyListContactPhoneNumberAggregateBoolExpCount>;
};

export type InsertPropertyListContactPhoneNumberAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListContactPhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListContactPhoneNumberBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListContactPhoneNumberArrRelInsertInput = {
  data: Array<InsertPropertyListContactPhoneNumberInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListContactPhoneNumberOnConflict>;
};

export type InsertPropertyListContactPhoneNumberBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListContactPhoneNumberBoolExp>>;
  _not?: InputMaybe<InsertPropertyListContactPhoneNumberBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListContactPhoneNumberBoolExp>>;
  agency?: InputMaybe<InsertPropertyListAgencyBoolExp>;
  agency_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  contact?: InputMaybe<InsertPropertyListContactBoolExp>;
  contact_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  phone_number?: InputMaybe<InsertPropertyListStringComparisonExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
};

export enum InsertPropertyListContactPhoneNumberConstraint {
  /** unique or primary key constraint on columns "contact_id", "phone_number", "agency_id" */
  ContactPhoneNumberContactIdPhoneNumberAgencyIdKey = 'contact_phone_number_contact_id_phone_number_agency_id_key',
  /** unique or primary key constraint on columns "id" */
  ContactPhoneNumberPkey = 'contact_phone_number_pkey'
}

export type InsertPropertyListContactPhoneNumberInsertInput = {
  agency?: InputMaybe<InsertPropertyListAgencyObjRelInsertInput>;
  agency_id?: InputMaybe<Scalars['uuid']['input']>;
  contact?: InputMaybe<InsertPropertyListContactObjRelInsertInput>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertPropertyListContactPhoneNumberOnConflict = {
  constraint: InsertPropertyListContactPhoneNumberConstraint;
  update_columns: Array<InsertPropertyListContactPhoneNumberUpdateColumn>;
  where?: InputMaybe<InsertPropertyListContactPhoneNumberBoolExp>;
};

export enum InsertPropertyListContactPhoneNumberSelectColumn {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertPropertyListContactPhoneNumberUpdateColumn {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertPropertyListContactTypeEnum {
  Agent = 'agent'
}

export type InsertPropertyListContactTypeEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListContactTypeEnum>;
  _in?: InputMaybe<Array<InsertPropertyListContactTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListContactTypeEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListContactTypeEnum>>;
};

export enum InsertPropertyListContactUpdateColumn {
  /** column name */
  ContactType = 'contact_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id'
}

export enum InsertPropertyListContentTypeEnum {
  Description = 'description',
  Notification = 'notification',
  SeoDescription = 'seo_description',
  SeoKeywords = 'seo_keywords',
  SeoTitle = 'seo_title',
  Title = 'title'
}

export type InsertPropertyListContentTypeEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListContentTypeEnum>;
  _in?: InputMaybe<Array<InsertPropertyListContentTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListContentTypeEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListContentTypeEnum>>;
};

export enum InsertPropertyListCurrencyEnum {
  Eur = 'EUR',
  Gbp = 'GBP',
  Leke = 'LEKE',
  Usd = 'USD'
}

export type InsertPropertyListCurrencyEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListCurrencyEnum>;
  _in?: InputMaybe<Array<InsertPropertyListCurrencyEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListCurrencyEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListCurrencyEnum>>;
};

export type InsertPropertyListDateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

export enum InsertPropertyListEntitiesEnum {
  Notification = 'notification',
  Property = 'property',
  User = 'user'
}

export type InsertPropertyListEntitiesEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListEntitiesEnum>;
  _in?: InputMaybe<Array<InsertPropertyListEntitiesEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListEntitiesEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListEntitiesEnum>>;
};

export type InsertPropertyListFloat8ComparisonExp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

export enum InsertPropertyListFurnishingStatusEnum {
  FullyFurnished = 'fully_furnished',
  PartiallyFurnished = 'partially_furnished',
  Unfurnished = 'unfurnished'
}

export type InsertPropertyListFurnishingStatusEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListFurnishingStatusEnum>;
  _in?: InputMaybe<Array<InsertPropertyListFurnishingStatusEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListFurnishingStatusEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListFurnishingStatusEnum>>;
};

export type InsertPropertyListGeographyCastExp = {
  geometry?: InputMaybe<InsertPropertyListGeometryComparisonExp>;
};

export type InsertPropertyListGeographyComparisonExp = {
  _cast?: InputMaybe<InsertPropertyListGeographyCastExp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  _st_d_within?: InputMaybe<InsertPropertyListStDWithinGeographyInput>;
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type InsertPropertyListGeometryCastExp = {
  geography?: InputMaybe<InsertPropertyListGeographyComparisonExp>;
};

export type InsertPropertyListGeometryComparisonExp = {
  _cast?: InputMaybe<InsertPropertyListGeometryCastExp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _st_3d_d_within?: InputMaybe<InsertPropertyListStDWithinInput>;
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  _st_d_within?: InputMaybe<InsertPropertyListStDWithinInput>;
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

export type InsertPropertyListIntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InsertPropertyListJsonbCastExp = {
  String?: InputMaybe<InsertPropertyListStringComparisonExp>;
};

export type InsertPropertyListJsonbComparisonExp = {
  _cast?: InputMaybe<InsertPropertyListJsonbCastExp>;
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  _has_key?: InputMaybe<Scalars['String']['input']>;
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

export type InsertPropertyListLanguagesBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListLanguagesBoolExp>>;
  _not?: InputMaybe<InsertPropertyListLanguagesBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListLanguagesBoolExp>>;
  language_code?: InputMaybe<InsertPropertyListBpcharComparisonExp>;
  language_id?: InputMaybe<InsertPropertyListIntComparisonExp>;
  language_name?: InputMaybe<InsertPropertyListStringComparisonExp>;
};

export enum InsertPropertyListLanguagesConstraint {
  /** unique or primary key constraint on columns "language_name" */
  LanguagesLanguageNameKey = 'languages_language_name_key',
  /** unique or primary key constraint on columns "language_id" */
  LanguagesPkey = 'languages_pkey'
}

export type InsertPropertyListLanguagesInsertInput = {
  language_code?: InputMaybe<Scalars['bpchar']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  language_name?: InputMaybe<Scalars['String']['input']>;
};

export type InsertPropertyListLanguagesObjRelInsertInput = {
  data: InsertPropertyListLanguagesInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListLanguagesOnConflict>;
};

export type InsertPropertyListLanguagesOnConflict = {
  constraint: InsertPropertyListLanguagesConstraint;
  update_columns: Array<InsertPropertyListLanguagesUpdateColumn>;
  where?: InputMaybe<InsertPropertyListLanguagesBoolExp>;
};

export enum InsertPropertyListLanguagesUpdateColumn {
  /** column name */
  LanguageCode = 'language_code',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  LanguageName = 'language_name'
}

export type InsertPropertyListListerBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListListerBoolExp>>;
  _not?: InputMaybe<InsertPropertyListListerBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListListerBoolExp>>;
  builder_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  clering_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  display_name?: InputMaybe<InsertPropertyListStringComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  lister_phone_numbers?: InputMaybe<InsertPropertyListListerPhoneNumberBoolExp>;
  lister_phone_numbers_aggregate?: InputMaybe<InsertPropertyListListerPhoneNumberAggregateBoolExp>;
  owner?: InputMaybe<InsertPropertyListListerOwnerEnumComparisonExp>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  property_lists_aggregate?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExp>;
  role?: InputMaybe<InsertPropertyListStringComparisonExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  user_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
};

export enum InsertPropertyListListerConstraint {
  /** unique or primary key constraint on columns "id" */
  ListerPkey = 'lister_pkey',
  /** unique or primary key constraint on columns "user_id" */
  ListerUserIdKey = 'lister_user_id_key'
}

export type InsertPropertyListListerInsertInput = {
  builder_id?: InputMaybe<Scalars['uuid']['input']>;
  clering_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lister_phone_numbers?: InputMaybe<InsertPropertyListListerPhoneNumberArrRelInsertInput>;
  owner?: InputMaybe<InsertPropertyListListerOwnerEnum>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListArrRelInsertInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertPropertyListListerObjRelInsertInput = {
  data: InsertPropertyListListerInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListListerOnConflict>;
};

export type InsertPropertyListListerOnConflict = {
  constraint: InsertPropertyListListerConstraint;
  update_columns: Array<InsertPropertyListListerUpdateColumn>;
  where?: InputMaybe<InsertPropertyListListerBoolExp>;
};

export enum InsertPropertyListListerOwnerEnum {
  Agency = 'agency',
  Builder = 'builder',
  Clering = 'clering',
  Freelance = 'freelance'
}

export type InsertPropertyListListerOwnerEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListListerOwnerEnum>;
  _in?: InputMaybe<Array<InsertPropertyListListerOwnerEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListListerOwnerEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListListerOwnerEnum>>;
};

export type InsertPropertyListListerPhoneNumberAggregateBoolExp = {
  bool_and?: InputMaybe<InsertPropertyListListerPhoneNumberAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertPropertyListListerPhoneNumberAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertPropertyListListerPhoneNumberAggregateBoolExpCount>;
};

export type InsertPropertyListListerPhoneNumberAggregateBoolExpBoolAnd = {
  arguments: InsertPropertyListListerPhoneNumberSelectColumnListerPhoneNumberAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListListerPhoneNumberBoolExp>;
  predicate: InsertPropertyListBooleanComparisonExp;
};

export type InsertPropertyListListerPhoneNumberAggregateBoolExpBoolOr = {
  arguments: InsertPropertyListListerPhoneNumberSelectColumnListerPhoneNumberAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListListerPhoneNumberBoolExp>;
  predicate: InsertPropertyListBooleanComparisonExp;
};

export type InsertPropertyListListerPhoneNumberAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListListerPhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListListerPhoneNumberBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListListerPhoneNumberArrRelInsertInput = {
  data: Array<InsertPropertyListListerPhoneNumberInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListListerPhoneNumberOnConflict>;
};

export type InsertPropertyListListerPhoneNumberBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListListerPhoneNumberBoolExp>>;
  _not?: InputMaybe<InsertPropertyListListerPhoneNumberBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListListerPhoneNumberBoolExp>>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  lister_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  phone_number?: InputMaybe<InsertPropertyListStringComparisonExp>;
  type?: InputMaybe<InsertPropertyListPhoneNumberTypeEnumComparisonExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  verified?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
};

export enum InsertPropertyListListerPhoneNumberConstraint {
  /** unique or primary key constraint on columns "phone_number", "lister_id" */
  ListerPhoneNumberListerIdPhoneNumberKey = 'lister_phone_number_lister_id_phone_number_key',
  /** unique or primary key constraint on columns "id" */
  ListerPhoneNumberPkey = 'lister_phone_number_pkey'
}

export type InsertPropertyListListerPhoneNumberInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lister_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<InsertPropertyListPhoneNumberTypeEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsertPropertyListListerPhoneNumberOnConflict = {
  constraint: InsertPropertyListListerPhoneNumberConstraint;
  update_columns: Array<InsertPropertyListListerPhoneNumberUpdateColumn>;
  where?: InputMaybe<InsertPropertyListListerPhoneNumberBoolExp>;
};

export enum InsertPropertyListListerPhoneNumberSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ListerId = 'lister_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Verified = 'verified'
}

export enum InsertPropertyListListerPhoneNumberSelectColumnListerPhoneNumberAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Verified = 'verified'
}

export enum InsertPropertyListListerPhoneNumberSelectColumnListerPhoneNumberAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Verified = 'verified'
}

export enum InsertPropertyListListerPhoneNumberUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ListerId = 'lister_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Verified = 'verified'
}

export enum InsertPropertyListListerUpdateColumn {
  /** column name */
  BuilderId = 'builder_id',
  /** column name */
  CleringId = 'clering_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type InsertPropertyListLocationBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListLocationBoolExp>>;
  _not?: InputMaybe<InsertPropertyListLocationBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListLocationBoolExp>>;
  administrative_area_level_1?: InputMaybe<InsertPropertyListStringComparisonExp>;
  administrative_area_level_2?: InputMaybe<InsertPropertyListStringComparisonExp>;
  city_zone?: InputMaybe<InsertPropertyListCityZoneBoolExp>;
  city_zone_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  confidence?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  country?: InputMaybe<InsertPropertyListStringComparisonExp>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  formatted_address?: InputMaybe<InsertPropertyListStringComparisonExp>;
  geom?: InputMaybe<InsertPropertyListGeographyComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  lat?: InputMaybe<InsertPropertyListFloat8ComparisonExp>;
  lng?: InputMaybe<InsertPropertyListFloat8ComparisonExp>;
  locality?: InputMaybe<InsertPropertyListStringComparisonExp>;
  place_id?: InputMaybe<InsertPropertyListStringComparisonExp>;
  postal_code?: InputMaybe<InsertPropertyListStringComparisonExp>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  property_lists_aggregate?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExp>;
  raw_location_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  route?: InputMaybe<InsertPropertyListStringComparisonExp>;
  street_number?: InputMaybe<InsertPropertyListStringComparisonExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
};

export enum InsertPropertyListLocationConstraint {
  /** unique or primary key constraint on columns "id" */
  LocationPkey = 'location_pkey'
}

export type InsertPropertyListLocationInsertInput = {
  administrative_area_level_1?: InputMaybe<Scalars['String']['input']>;
  administrative_area_level_2?: InputMaybe<Scalars['String']['input']>;
  city_zone?: InputMaybe<InsertPropertyListCityZoneObjRelInsertInput>;
  city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  confidence?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  place_id?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListArrRelInsertInput>;
  raw_location_id?: InputMaybe<Scalars['uuid']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertPropertyListLocationObjRelInsertInput = {
  data: InsertPropertyListLocationInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListLocationOnConflict>;
};

export type InsertPropertyListLocationOnConflict = {
  constraint: InsertPropertyListLocationConstraint;
  update_columns: Array<InsertPropertyListLocationUpdateColumn>;
  where?: InputMaybe<InsertPropertyListLocationBoolExp>;
};

export enum InsertPropertyListLocationUpdateColumn {
  /** column name */
  AdministrativeAreaLevel_1 = 'administrative_area_level_1',
  /** column name */
  AdministrativeAreaLevel_2 = 'administrative_area_level_2',
  /** column name */
  CityZoneId = 'city_zone_id',
  /** column name */
  Confidence = 'confidence',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  RawLocationId = 'raw_location_id',
  /** column name */
  Route = 'route',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertPropertyListNumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

export type InsertPropertyListOutput = {
  __typename?: 'InsertPropertyListOutput';
  id: Scalars['uuid']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum InsertPropertyListParkingTypeEnum {
  Garage = 'garage',
  NoParking = 'no_parking',
  StreetParking = 'street_parking',
  Underground = 'underground'
}

export type InsertPropertyListParkingTypeEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListParkingTypeEnum>;
  _in?: InputMaybe<Array<InsertPropertyListParkingTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListParkingTypeEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListParkingTypeEnum>>;
};

export enum InsertPropertyListPhoneNumberTypeEnum {
  AdditionalContact = 'ADDITIONAL_CONTACT',
  ProfileContact = 'PROFILE_CONTACT'
}

export type InsertPropertyListPhoneNumberTypeEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListPhoneNumberTypeEnum>;
  _in?: InputMaybe<Array<InsertPropertyListPhoneNumberTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListPhoneNumberTypeEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListPhoneNumberTypeEnum>>;
};

export type InsertPropertyListPropertyAggregateBoolExp = {
  count?: InputMaybe<InsertPropertyListPropertyAggregateBoolExpCount>;
};

export type InsertPropertyListPropertyAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListPropertySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListPropertyAmenitiesAggregateBoolExp = {
  count?: InputMaybe<InsertPropertyListPropertyAmenitiesAggregateBoolExpCount>;
};

export type InsertPropertyListPropertyAmenitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListPropertyAmenitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyAmenitiesBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListPropertyAmenitiesArrRelInsertInput = {
  data: Array<InsertPropertyListPropertyAmenitiesInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListPropertyAmenitiesOnConflict>;
};

export type InsertPropertyListPropertyAmenitiesBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListPropertyAmenitiesBoolExp>>;
  _not?: InputMaybe<InsertPropertyListPropertyAmenitiesBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListPropertyAmenitiesBoolExp>>;
  amenity?: InputMaybe<InsertPropertyListAmenitiesBoolExp>;
  amenity_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  property_list?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  property_list_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
};

export enum InsertPropertyListPropertyAmenitiesConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertyAmenitiesPkey = 'property_amenities_pkey',
  /** unique or primary key constraint on columns "property_list_id", "amenity_id" */
  PropertyAmenitiesPropertyListIdAmenityIdKey = 'property_amenities_property_list_id_amenity_id_key'
}

export type InsertPropertyListPropertyAmenitiesInsertInput = {
  amenity?: InputMaybe<InsertPropertyListAmenitiesObjRelInsertInput>;
  amenity_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_list?: InputMaybe<InsertPropertyListPropertyListObjRelInsertInput>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertPropertyListPropertyAmenitiesOnConflict = {
  constraint: InsertPropertyListPropertyAmenitiesConstraint;
  update_columns: Array<InsertPropertyListPropertyAmenitiesUpdateColumn>;
  where?: InputMaybe<InsertPropertyListPropertyAmenitiesBoolExp>;
};

export enum InsertPropertyListPropertyAmenitiesSelectColumn {
  /** column name */
  AmenityId = 'amenity_id',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyListId = 'property_list_id'
}

export enum InsertPropertyListPropertyAmenitiesUpdateColumn {
  /** column name */
  AmenityId = 'amenity_id',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyListId = 'property_list_id'
}

export type InsertPropertyListPropertyArrRelInsertInput = {
  data: Array<InsertPropertyListPropertyInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListPropertyOnConflict>;
};

export type InsertPropertyListPropertyBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListPropertyBoolExp>>;
  _not?: InputMaybe<InsertPropertyListPropertyBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListPropertyBoolExp>>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  json_ld?: InputMaybe<InsertPropertyListStringComparisonExp>;
  last_seen?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  main_listing_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  main_property?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  property_features?: InputMaybe<InsertPropertyListPropertyFeatureBoolExp>;
  property_features_aggregate?: InputMaybe<InsertPropertyListPropertyFeatureAggregateBoolExp>;
  property_images?: InputMaybe<InsertPropertyListPropertyImageBoolExp>;
  property_images_aggregate?: InputMaybe<InsertPropertyListPropertyImageAggregateBoolExp>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  property_lists_aggregate?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExp>;
  property_price_histories?: InputMaybe<InsertPropertyListPropertyPriceHistoryBoolExp>;
  property_price_histories_aggregate?: InputMaybe<InsertPropertyListPropertyPriceHistoryAggregateBoolExp>;
  property_views?: InputMaybe<InsertPropertyListPropertyViewsBoolExp>;
  property_views_aggregate?: InputMaybe<InsertPropertyListPropertyViewsAggregateBoolExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  url_slugs?: InputMaybe<InsertPropertyListUrlSlugBoolExp>;
  url_slugs_aggregate?: InputMaybe<InsertPropertyListUrlSlugAggregateBoolExp>;
  user_saved_properties?: InputMaybe<InsertPropertyListUserSavedPropertiesBoolExp>;
  user_saved_properties_aggregate?: InputMaybe<InsertPropertyListUserSavedPropertiesAggregateBoolExp>;
  user_seen_properties?: InputMaybe<InsertPropertyListUserSeenPropertyBoolExp>;
  user_seen_properties_aggregate?: InputMaybe<InsertPropertyListUserSeenPropertyAggregateBoolExp>;
};

export type InsertPropertyListPropertyClusterBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListPropertyClusterBoolExp>>;
  _not?: InputMaybe<InsertPropertyListPropertyClusterBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListPropertyClusterBoolExp>>;
  cluster?: InputMaybe<InsertPropertyListStringComparisonExp>;
  property_types?: InputMaybe<InsertPropertyListPropertyTypeBoolExp>;
  property_types_aggregate?: InputMaybe<InsertPropertyListPropertyTypeAggregateBoolExp>;
};

export enum InsertPropertyListPropertyClusterConstraint {
  /** unique or primary key constraint on columns "cluster" */
  PropertyClusterPkey = 'property_cluster_pkey'
}

export enum InsertPropertyListPropertyClusterEnum {
  Commercial = 'commercial',
  Industrial = 'industrial',
  Land = 'land',
  Parking = 'parking',
  Residential = 'residential'
}

export type InsertPropertyListPropertyClusterEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListPropertyClusterEnum>;
  _in?: InputMaybe<Array<InsertPropertyListPropertyClusterEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListPropertyClusterEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListPropertyClusterEnum>>;
};

export type InsertPropertyListPropertyClusterInsertInput = {
  cluster?: InputMaybe<Scalars['String']['input']>;
  property_types?: InputMaybe<InsertPropertyListPropertyTypeArrRelInsertInput>;
};

export type InsertPropertyListPropertyClusterObjRelInsertInput = {
  data: InsertPropertyListPropertyClusterInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListPropertyClusterOnConflict>;
};

export type InsertPropertyListPropertyClusterOnConflict = {
  constraint: InsertPropertyListPropertyClusterConstraint;
  update_columns: Array<InsertPropertyListPropertyClusterUpdateColumn>;
  where?: InputMaybe<InsertPropertyListPropertyClusterBoolExp>;
};

export enum InsertPropertyListPropertyClusterUpdateColumn {
  /** column name */
  Cluster = 'cluster'
}

export type InsertPropertyListPropertyCompositionBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListPropertyCompositionBoolExp>>;
  _not?: InputMaybe<InsertPropertyListPropertyCompositionBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListPropertyCompositionBoolExp>>;
  balconies?: InputMaybe<InsertPropertyListIntComparisonExp>;
  bathrooms?: InputMaybe<InsertPropertyListIntComparisonExp>;
  bedrooms?: InputMaybe<InsertPropertyListIntComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  kitchens?: InputMaybe<InsertPropertyListIntComparisonExp>;
  living_rooms?: InputMaybe<InsertPropertyListIntComparisonExp>;
};

export enum InsertPropertyListPropertyCompositionConstraint {
  /** unique or primary key constraint on columns "kitchens", "balconies", "bathrooms", "bedrooms", "living_rooms" */
  PropertyCompositionBedroomsBalconiesKitchensLivingRoomsB = 'property_composition_bedrooms_balconies_kitchens_living_rooms_b',
  /** unique or primary key constraint on columns "id" */
  PropertyCompositionPkey = 'property_composition_pkey'
}

export type InsertPropertyListPropertyCompositionInsertInput = {
  balconies?: InputMaybe<Scalars['Int']['input']>;
  bathrooms?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kitchens?: InputMaybe<Scalars['Int']['input']>;
  living_rooms?: InputMaybe<Scalars['Int']['input']>;
};

export type InsertPropertyListPropertyCompositionObjRelInsertInput = {
  data: InsertPropertyListPropertyCompositionInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListPropertyCompositionOnConflict>;
};

export type InsertPropertyListPropertyCompositionOnConflict = {
  constraint: InsertPropertyListPropertyCompositionConstraint;
  update_columns: Array<InsertPropertyListPropertyCompositionUpdateColumn>;
  where?: InputMaybe<InsertPropertyListPropertyCompositionBoolExp>;
};

export enum InsertPropertyListPropertyCompositionUpdateColumn {
  /** column name */
  Balconies = 'balconies',
  /** column name */
  Bathrooms = 'bathrooms',
  /** column name */
  Bedrooms = 'bedrooms',
  /** column name */
  Id = 'id',
  /** column name */
  Kitchens = 'kitchens',
  /** column name */
  LivingRooms = 'living_rooms'
}

export enum InsertPropertyListPropertyConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertyPkey = 'property_pkey'
}

export type InsertPropertyListPropertyFeatureAggregateBoolExp = {
  bool_and?: InputMaybe<InsertPropertyListPropertyFeatureAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertPropertyListPropertyFeatureAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertPropertyListPropertyFeatureAggregateBoolExpCount>;
};

export type InsertPropertyListPropertyFeatureAggregateBoolExpBoolAnd = {
  arguments: InsertPropertyListPropertyFeatureSelectColumnPropertyFeatureAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyFeatureBoolExp>;
  predicate: InsertPropertyListBooleanComparisonExp;
};

export type InsertPropertyListPropertyFeatureAggregateBoolExpBoolOr = {
  arguments: InsertPropertyListPropertyFeatureSelectColumnPropertyFeatureAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyFeatureBoolExp>;
  predicate: InsertPropertyListBooleanComparisonExp;
};

export type InsertPropertyListPropertyFeatureAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListPropertyFeatureSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyFeatureBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListPropertyFeatureArrRelInsertInput = {
  data: Array<InsertPropertyListPropertyFeatureInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListPropertyFeatureOnConflict>;
};

export type InsertPropertyListPropertyFeatureBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListPropertyFeatureBoolExp>>;
  _not?: InputMaybe<InsertPropertyListPropertyFeatureBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListPropertyFeatureBoolExp>>;
  feature_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  property_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  property_list_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  value?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
};

export enum InsertPropertyListPropertyFeatureConstraint {
  /** unique or primary key constraint on columns "property_id", "feature_id" */
  PropertyFeatureFeatureIdPropertyIdKey = 'property_feature_feature_id_property_id_key',
  /** unique or primary key constraint on columns "feature_id", "property_list_id" */
  PropertyFeatureFeatureIdPropertyListIdKey = 'property_feature_feature_id_property_list_id_key',
  /** unique or primary key constraint on columns "id" */
  PropertyFeaturePkey = 'property_feature_pkey'
}

export type InsertPropertyListPropertyFeatureInsertInput = {
  feature_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsertPropertyListPropertyFeatureOnConflict = {
  constraint: InsertPropertyListPropertyFeatureConstraint;
  update_columns: Array<InsertPropertyListPropertyFeatureUpdateColumn>;
  where?: InputMaybe<InsertPropertyListPropertyFeatureBoolExp>;
};

export enum InsertPropertyListPropertyFeatureSelectColumn {
  /** column name */
  FeatureId = 'feature_id',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  Value = 'value'
}

export enum InsertPropertyListPropertyFeatureSelectColumnPropertyFeatureAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Value = 'value'
}

export enum InsertPropertyListPropertyFeatureSelectColumnPropertyFeatureAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Value = 'value'
}

export enum InsertPropertyListPropertyFeatureUpdateColumn {
  /** column name */
  FeatureId = 'feature_id',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  Value = 'value'
}

export type InsertPropertyListPropertyImageAggregateBoolExp = {
  count?: InputMaybe<InsertPropertyListPropertyImageAggregateBoolExpCount>;
};

export type InsertPropertyListPropertyImageAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListPropertyImageSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyImageBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListPropertyImageArrRelInsertInput = {
  data: Array<InsertPropertyListPropertyImageInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListPropertyImageOnConflict>;
};

export type InsertPropertyListPropertyImageBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListPropertyImageBoolExp>>;
  _not?: InputMaybe<InsertPropertyListPropertyImageBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListPropertyImageBoolExp>>;
  blurhash?: InputMaybe<InsertPropertyListStringComparisonExp>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  image?: InputMaybe<InsertPropertyListStringComparisonExp>;
  origin_url?: InputMaybe<InsertPropertyListStringComparisonExp>;
  property?: InputMaybe<InsertPropertyListPropertyBoolExp>;
  property_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  property_list?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  property_list_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  property_lists_aggregate?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
};

export enum InsertPropertyListPropertyImageConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertyImgrPkey = 'property_imgr_pkey',
  /** unique or primary key constraint on columns "image", "property_list_id" */
  PropertyImgrPropertyListIdImageKey = 'property_imgr_property_list_id_image_key'
}

export type InsertPropertyListPropertyImageInsertInput = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  origin_url?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<InsertPropertyListPropertyObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list?: InputMaybe<InsertPropertyListPropertyListObjRelInsertInput>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListArrRelInsertInput>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertPropertyListPropertyImageObjRelInsertInput = {
  data: InsertPropertyListPropertyImageInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListPropertyImageOnConflict>;
};

export type InsertPropertyListPropertyImageOnConflict = {
  constraint: InsertPropertyListPropertyImageConstraint;
  update_columns: Array<InsertPropertyListPropertyImageUpdateColumn>;
  where?: InputMaybe<InsertPropertyListPropertyImageBoolExp>;
};

export enum InsertPropertyListPropertyImageSelectColumn {
  /** column name */
  Blurhash = 'blurhash',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  OriginUrl = 'origin_url',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertPropertyListPropertyImageUpdateColumn {
  /** column name */
  Blurhash = 'blurhash',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  OriginUrl = 'origin_url',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertPropertyListPropertyInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  json_ld?: InputMaybe<Scalars['String']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  main_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  main_property?: InputMaybe<InsertPropertyListPropertyListObjRelInsertInput>;
  property_features?: InputMaybe<InsertPropertyListPropertyFeatureArrRelInsertInput>;
  property_images?: InputMaybe<InsertPropertyListPropertyImageArrRelInsertInput>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListArrRelInsertInput>;
  property_price_histories?: InputMaybe<InsertPropertyListPropertyPriceHistoryArrRelInsertInput>;
  property_views?: InputMaybe<InsertPropertyListPropertyViewsArrRelInsertInput>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url_slugs?: InputMaybe<InsertPropertyListUrlSlugArrRelInsertInput>;
  user_saved_properties?: InputMaybe<InsertPropertyListUserSavedPropertiesArrRelInsertInput>;
  user_seen_properties?: InputMaybe<InsertPropertyListUserSeenPropertyArrRelInsertInput>;
};

export type InsertPropertyListPropertyListAggregateBoolExp = {
  avg?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExpAvg>;
  bool_and?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExpBoolOr>;
  corr?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExpCorr>;
  count?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExpMax>;
  min?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExpVarSamp>;
};

export type InsertPropertyListPropertyListAggregateBoolExpAvg = {
  arguments: InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyListAggregateBoolExpBoolAnd = {
  arguments: InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  predicate: InsertPropertyListBooleanComparisonExp;
};

export type InsertPropertyListPropertyListAggregateBoolExpBoolOr = {
  arguments: InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  predicate: InsertPropertyListBooleanComparisonExp;
};

export type InsertPropertyListPropertyListAggregateBoolExpCorr = {
  arguments: InsertPropertyListPropertyListAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyListAggregateBoolExpCorrArguments = {
  X: InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpCorrArgumentsColumns;
  Y: InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpCorrArgumentsColumns;
};

export type InsertPropertyListPropertyListAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListPropertyListSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListPropertyListAggregateBoolExpCovarSamp = {
  arguments: InsertPropertyListPropertyListAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyListAggregateBoolExpCovarSampArguments = {
  X: InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertPropertyListPropertyListAggregateBoolExpMax = {
  arguments: InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyListAggregateBoolExpMin = {
  arguments: InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyListAggregateBoolExpStddevSamp = {
  arguments: InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyListAggregateBoolExpSum = {
  arguments: InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyListAggregateBoolExpVarSamp = {
  arguments: InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyListArrRelInsertInput = {
  data: Array<InsertPropertyListPropertyListInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListPropertyListOnConflict>;
};

export type InsertPropertyListPropertyListBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListPropertyListBoolExp>>;
  _not?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListPropertyListBoolExp>>;
  building_floors?: InputMaybe<InsertPropertyListIntComparisonExp>;
  canonical_url?: InputMaybe<InsertPropertyListStringComparisonExp>;
  construction_status?: InputMaybe<InsertPropertyListConstructionStatusEnumComparisonExp>;
  construction_year?: InputMaybe<InsertPropertyListIntComparisonExp>;
  contact?: InputMaybe<InsertPropertyListContactBoolExp>;
  contact_email?: InputMaybe<InsertPropertyListStringComparisonExp>;
  contact_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  contact_name?: InputMaybe<InsertPropertyListStringComparisonExp>;
  contact_phone_1?: InputMaybe<InsertPropertyListStringComparisonExp>;
  contact_phone_2?: InputMaybe<InsertPropertyListStringComparisonExp>;
  content_location?: InputMaybe<InsertPropertyListStringComparisonExp>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  description_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  description_text_content?: InputMaybe<InsertPropertyListTextContentBoolExp>;
  features_array?: InputMaybe<InsertPropertyListJsonbComparisonExp>;
  features_json?: InputMaybe<InsertPropertyListJsonbComparisonExp>;
  floor?: InputMaybe<InsertPropertyListIntComparisonExp>;
  furnishing_status?: InputMaybe<InsertPropertyListFurnishingStatusEnumComparisonExp>;
  generated_title?: InputMaybe<InsertPropertyListTextContentBoolExp>;
  generated_title_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  has_balcony?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  has_carport?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  has_elevator?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  has_garage?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  has_garden?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  has_parking_space?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  has_terrace?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  heating_type?: InputMaybe<InsertPropertyListStringComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  is_active?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  is_barrier_free?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  json_ld?: InputMaybe<InsertPropertyListJsonbComparisonExp>;
  last_renovation_year?: InputMaybe<InsertPropertyListIntComparisonExp>;
  last_seen?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  lister?: InputMaybe<InsertPropertyListListerBoolExp>;
  lister_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  living_area?: InputMaybe<InsertPropertyListFloat8ComparisonExp>;
  location?: InputMaybe<InsertPropertyListLocationBoolExp>;
  location_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  lot_size?: InputMaybe<InsertPropertyListStringComparisonExp>;
  main_image?: InputMaybe<InsertPropertyListPropertyImageBoolExp>;
  main_image_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  parent_property?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  parking_spaces?: InputMaybe<InsertPropertyListIntComparisonExp>;
  parking_type?: InputMaybe<InsertPropertyListParkingTypeEnumComparisonExp>;
  pets_allowed?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  plot_area?: InputMaybe<InsertPropertyListFloat8ComparisonExp>;
  price?: InputMaybe<InsertPropertyListFloat8ComparisonExp>;
  price_currency?: InputMaybe<InsertPropertyListCurrencyEnumComparisonExp>;
  price_exchange?: InputMaybe<InsertPropertyListNumericComparisonExp>;
  project_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  properties?: InputMaybe<InsertPropertyListPropertyBoolExp>;
  properties_aggregate?: InputMaybe<InsertPropertyListPropertyAggregateBoolExp>;
  property?: InputMaybe<InsertPropertyListPropertyBoolExp>;
  property_amenities?: InputMaybe<InsertPropertyListPropertyAmenitiesBoolExp>;
  property_amenities_aggregate?: InputMaybe<InsertPropertyListPropertyAmenitiesAggregateBoolExp>;
  property_composition?: InputMaybe<InsertPropertyListPropertyCompositionBoolExp>;
  property_composition_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  property_features?: InputMaybe<InsertPropertyListPropertyFeatureBoolExp>;
  property_features_aggregate?: InputMaybe<InsertPropertyListPropertyFeatureAggregateBoolExp>;
  property_folder_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  property_images?: InputMaybe<InsertPropertyListPropertyImageBoolExp>;
  property_images_aggregate?: InputMaybe<InsertPropertyListPropertyImageAggregateBoolExp>;
  property_origin_type?: InputMaybe<InsertPropertyListPropertyOriginTypeEnumComparisonExp>;
  property_price_histories?: InputMaybe<InsertPropertyListPropertyPriceHistoryBoolExp>;
  property_price_histories_aggregate?: InputMaybe<InsertPropertyListPropertyPriceHistoryAggregateBoolExp>;
  property_source?: InputMaybe<InsertPropertyListPropertySourceBoolExp>;
  property_status?: InputMaybe<InsertPropertyListPropertyStatusEnumComparisonExp>;
  property_type?: InputMaybe<InsertPropertyListPropertyTypeEnumComparisonExp>;
  property_type_rel?: InputMaybe<InsertPropertyListPropertyTypeBoolExp>;
  rental_terms?: InputMaybe<InsertPropertyListStringComparisonExp>;
  sale_terms?: InputMaybe<InsertPropertyListStringComparisonExp>;
  search_vector?: InputMaybe<InsertPropertyListStringComparisonExp>;
  smoking_allowed?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  source_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  source_url?: InputMaybe<InsertPropertyListStringComparisonExp>;
  task_id?: InputMaybe<InsertPropertyListStringComparisonExp>;
  title_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  title_text_content?: InputMaybe<InsertPropertyListTextContentBoolExp>;
  total_area?: InputMaybe<InsertPropertyListFloat8ComparisonExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  views?: InputMaybe<InsertPropertyListIntComparisonExp>;
};

export enum InsertPropertyListPropertyListConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertyListPkey = 'property_list_pkey',
  /** unique or primary key constraint on columns "title_id", "source_id" */
  PropertyListTitleIdSourceIdKey = 'property_list_title_id_source_id_key'
}

export type InsertPropertyListPropertyListInsertInput = {
  building_floors?: InputMaybe<Scalars['Int']['input']>;
  canonical_url?: InputMaybe<Scalars['String']['input']>;
  construction_status?: InputMaybe<InsertPropertyListConstructionStatusEnum>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  contact?: InputMaybe<InsertPropertyListContactObjRelInsertInput>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone_1?: InputMaybe<Scalars['String']['input']>;
  contact_phone_2?: InputMaybe<Scalars['String']['input']>;
  content_location?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description_id?: InputMaybe<Scalars['uuid']['input']>;
  description_text?: InputMaybe<Scalars['String']['input']>;
  description_text_content?: InputMaybe<InsertPropertyListTextContentObjRelInsertInput>;
  features_json?: InputMaybe<Scalars['jsonb']['input']>;
  floor?: InputMaybe<Scalars['Int']['input']>;
  furnishing_status?: InputMaybe<InsertPropertyListFurnishingStatusEnum>;
  generated_title?: InputMaybe<InsertPropertyListTextContentObjRelInsertInput>;
  generated_title_id?: InputMaybe<Scalars['uuid']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_carport?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking_space?: InputMaybe<Scalars['Boolean']['input']>;
  has_terrace?: InputMaybe<Scalars['Boolean']['input']>;
  heating_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  images?: InputMaybe<Array<InputMaybe<PropertyImagesDataActionType>>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_barrier_free?: InputMaybe<Scalars['Boolean']['input']>;
  json_ld?: InputMaybe<Scalars['jsonb']['input']>;
  last_renovation_year?: InputMaybe<Scalars['Int']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  lister?: InputMaybe<InsertPropertyListListerObjRelInsertInput>;
  lister_id?: InputMaybe<Scalars['uuid']['input']>;
  living_area?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<InsertPropertyListLocationObjRelInsertInput>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  lot_size?: InputMaybe<Scalars['String']['input']>;
  main_image?: InputMaybe<InsertPropertyListPropertyImageObjRelInsertInput>;
  main_image_id?: InputMaybe<Scalars['uuid']['input']>;
  nr_balconies?: InputMaybe<Scalars['Int']['input']>;
  nr_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  nr_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  nr_kitchens?: InputMaybe<Scalars['Int']['input']>;
  nr_living_rooms?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['uuid']['input'];
  parent_property?: InputMaybe<Scalars['uuid']['input']>;
  parking_spaces?: InputMaybe<Scalars['Int']['input']>;
  parking_type?: InputMaybe<InsertPropertyListParkingTypeEnum>;
  pets_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  plot_area?: InputMaybe<Scalars['float8']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  price_currency?: InputMaybe<InsertPropertyListCurrencyEnum>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  properties?: InputMaybe<InsertPropertyListPropertyArrRelInsertInput>;
  property?: InputMaybe<InsertPropertyListPropertyObjRelInsertInput>;
  property_amenities?: InputMaybe<InsertPropertyListPropertyAmenitiesArrRelInsertInput>;
  property_composition?: InputMaybe<InsertPropertyListPropertyCompositionObjRelInsertInput>;
  property_composition_id?: InputMaybe<Scalars['uuid']['input']>;
  property_features?: InputMaybe<InsertPropertyListPropertyFeatureArrRelInsertInput>;
  property_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  property_images?: InputMaybe<InsertPropertyListPropertyImageArrRelInsertInput>;
  property_origin_type?: InputMaybe<InsertPropertyListPropertyOriginTypeEnum>;
  property_price_histories?: InputMaybe<InsertPropertyListPropertyPriceHistoryArrRelInsertInput>;
  property_source?: InputMaybe<InsertPropertyListPropertySourceObjRelInsertInput>;
  property_status?: InputMaybe<InsertPropertyListPropertyStatusEnum>;
  property_type?: InputMaybe<InsertPropertyListPropertyTypeEnum>;
  property_type_rel?: InputMaybe<InsertPropertyListPropertyTypeObjRelInsertInput>;
  rental_terms?: InputMaybe<Scalars['String']['input']>;
  sale_terms?: InputMaybe<Scalars['String']['input']>;
  search_vector?: InputMaybe<Scalars['String']['input']>;
  smoking_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  source_url?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['String']['input']>;
  title_id?: InputMaybe<Scalars['uuid']['input']>;
  title_text?: InputMaybe<Scalars['String']['input']>;
  title_text_content?: InputMaybe<InsertPropertyListTextContentObjRelInsertInput>;
  total_area?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

export type InsertPropertyListPropertyListObjRelInsertInput = {
  data: InsertPropertyListPropertyListInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListPropertyListOnConflict>;
};

export type InsertPropertyListPropertyListOnConflict = {
  constraint: InsertPropertyListPropertyListConstraint;
  update_columns: Array<InsertPropertyListPropertyListUpdateColumn>;
  where?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
};

export enum InsertPropertyListPropertyListSelectColumn {
  /** column name */
  BuildingFloors = 'building_floors',
  /** column name */
  CanonicalUrl = 'canonical_url',
  /** column name */
  ConstructionStatus = 'construction_status',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  ContactPhone_1 = 'contact_phone_1',
  /** column name */
  ContactPhone_2 = 'contact_phone_2',
  /** column name */
  ContentLocation = 'content_location',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  FeaturesJson = 'features_json',
  /** column name */
  Floor = 'floor',
  /** column name */
  FurnishingStatus = 'furnishing_status',
  /** column name */
  GeneratedTitleId = 'generated_title_id',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCarport = 'has_carport',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasParkingSpace = 'has_parking_space',
  /** column name */
  HasTerrace = 'has_terrace',
  /** column name */
  HeatingType = 'heating_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBarrierFree = 'is_barrier_free',
  /** column name */
  JsonLd = 'json_ld',
  /** column name */
  LastRenovationYear = 'last_renovation_year',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  ListerId = 'lister_id',
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  LotSize = 'lot_size',
  /** column name */
  MainImageId = 'main_image_id',
  /** column name */
  ParentProperty = 'parent_property',
  /** column name */
  ParkingSpaces = 'parking_spaces',
  /** column name */
  ParkingType = 'parking_type',
  /** column name */
  PetsAllowed = 'pets_allowed',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  PriceCurrency = 'price_currency',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  PropertyCompositionId = 'property_composition_id',
  /** column name */
  PropertyFolderId = 'property_folder_id',
  /** column name */
  PropertyOriginType = 'property_origin_type',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  RentalTerms = 'rental_terms',
  /** column name */
  SaleTerms = 'sale_terms',
  /** column name */
  SearchVector = 'search_vector',
  /** column name */
  SmokingAllowed = 'smoking_allowed',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  SourceUrl = 'source_url',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  TitleId = 'title_id',
  /** column name */
  TotalArea = 'total_area',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Views = 'views'
}

export enum InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

export enum InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCarport = 'has_carport',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasParkingSpace = 'has_parking_space',
  /** column name */
  HasTerrace = 'has_terrace',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBarrierFree = 'is_barrier_free',
  /** column name */
  PetsAllowed = 'pets_allowed',
  /** column name */
  SmokingAllowed = 'smoking_allowed'
}

export enum InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCarport = 'has_carport',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasParkingSpace = 'has_parking_space',
  /** column name */
  HasTerrace = 'has_terrace',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBarrierFree = 'is_barrier_free',
  /** column name */
  PetsAllowed = 'pets_allowed',
  /** column name */
  SmokingAllowed = 'smoking_allowed'
}

export enum InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

export enum InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

export enum InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

export enum InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpMinArgumentsColumns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

export enum InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

export enum InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpSumArgumentsColumns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

export enum InsertPropertyListPropertyListSelectColumnPropertyListAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

export enum InsertPropertyListPropertyListUpdateColumn {
  /** column name */
  BuildingFloors = 'building_floors',
  /** column name */
  CanonicalUrl = 'canonical_url',
  /** column name */
  ConstructionStatus = 'construction_status',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  ContactPhone_1 = 'contact_phone_1',
  /** column name */
  ContactPhone_2 = 'contact_phone_2',
  /** column name */
  ContentLocation = 'content_location',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  FeaturesJson = 'features_json',
  /** column name */
  Floor = 'floor',
  /** column name */
  FurnishingStatus = 'furnishing_status',
  /** column name */
  GeneratedTitleId = 'generated_title_id',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCarport = 'has_carport',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasParkingSpace = 'has_parking_space',
  /** column name */
  HasTerrace = 'has_terrace',
  /** column name */
  HeatingType = 'heating_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBarrierFree = 'is_barrier_free',
  /** column name */
  JsonLd = 'json_ld',
  /** column name */
  LastRenovationYear = 'last_renovation_year',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  ListerId = 'lister_id',
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  LotSize = 'lot_size',
  /** column name */
  MainImageId = 'main_image_id',
  /** column name */
  ParentProperty = 'parent_property',
  /** column name */
  ParkingSpaces = 'parking_spaces',
  /** column name */
  ParkingType = 'parking_type',
  /** column name */
  PetsAllowed = 'pets_allowed',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  PriceCurrency = 'price_currency',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  PropertyCompositionId = 'property_composition_id',
  /** column name */
  PropertyFolderId = 'property_folder_id',
  /** column name */
  PropertyOriginType = 'property_origin_type',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  RentalTerms = 'rental_terms',
  /** column name */
  SaleTerms = 'sale_terms',
  /** column name */
  SearchVector = 'search_vector',
  /** column name */
  SmokingAllowed = 'smoking_allowed',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  SourceUrl = 'source_url',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  TitleId = 'title_id',
  /** column name */
  TotalArea = 'total_area',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Views = 'views'
}

export type InsertPropertyListPropertyObjRelInsertInput = {
  data: InsertPropertyListPropertyInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListPropertyOnConflict>;
};

export type InsertPropertyListPropertyOnConflict = {
  constraint: InsertPropertyListPropertyConstraint;
  update_columns: Array<InsertPropertyListPropertyUpdateColumn>;
  where?: InputMaybe<InsertPropertyListPropertyBoolExp>;
};

export enum InsertPropertyListPropertyOriginEnum {
  /** 22 */
  Catia = 'CATIA',
  /** 8 */
  Celesi = 'CELESI',
  /** 1 */
  Century_21 = 'CENTURY_21',
  /** 20 */
  DesrealAl = 'DESREAL_AL',
  /** 19 */
  Devinf = 'DEVINF',
  /** 21 */
  Duashpi = 'DUASHPI',
  /** 6 */
  Dupron = 'DUPRON',
  /** 15 */
  FutureHome = 'FUTURE_HOME',
  /** 18 */
  IndomioAl = 'INDOMIO_AL',
  /** 13 */
  Inf_93 = 'INF_93',
  /** 3 */
  Kw = 'KW',
  /** 14 */
  MeiAl = 'MEI_AL',
  /** 7 */
  MerrJep = 'MERR_JEP',
  /** 12 */
  NjoftimeAl = 'NJOFTIME_AL',
  /** 10 */
  NjoftimeCom = 'NJOFTIME_COM',
  /** 11 */
  NjoftimeFalas = 'NJOFTIME_FALAS',
  /** 17 */
  RealpassAl = 'REALPASS_AL',
  /** 9 */
  RealEstateAl = 'REAL_ESTATE_AL',
  /** 4 */
  Remax = 'REMAX',
  /** 16 */
  ShpiAl = 'SHPI_AL',
  /** 5 */
  ThePoint = 'THE_POINT'
}

export type InsertPropertyListPropertyOriginEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListPropertyOriginEnum>;
  _in?: InputMaybe<Array<InsertPropertyListPropertyOriginEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListPropertyOriginEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListPropertyOriginEnum>>;
};

export enum InsertPropertyListPropertyOriginTypeEnum {
  Agency = 'agency',
  Aggregator = 'aggregator'
}

export type InsertPropertyListPropertyOriginTypeEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListPropertyOriginTypeEnum>;
  _in?: InputMaybe<Array<InsertPropertyListPropertyOriginTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListPropertyOriginTypeEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListPropertyOriginTypeEnum>>;
};

export type InsertPropertyListPropertyPriceHistoryAggregateBoolExp = {
  avg?: InputMaybe<InsertPropertyListPropertyPriceHistoryAggregateBoolExpAvg>;
  corr?: InputMaybe<InsertPropertyListPropertyPriceHistoryAggregateBoolExpCorr>;
  count?: InputMaybe<InsertPropertyListPropertyPriceHistoryAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertPropertyListPropertyPriceHistoryAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertPropertyListPropertyPriceHistoryAggregateBoolExpMax>;
  min?: InputMaybe<InsertPropertyListPropertyPriceHistoryAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertPropertyListPropertyPriceHistoryAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertPropertyListPropertyPriceHistoryAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertPropertyListPropertyPriceHistoryAggregateBoolExpVarSamp>;
};

export type InsertPropertyListPropertyPriceHistoryAggregateBoolExpAvg = {
  arguments: InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyPriceHistoryBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyPriceHistoryAggregateBoolExpCorr = {
  arguments: InsertPropertyListPropertyPriceHistoryAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyPriceHistoryBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyPriceHistoryAggregateBoolExpCorrArguments = {
  X: InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpCorrArgumentsColumns;
  Y: InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpCorrArgumentsColumns;
};

export type InsertPropertyListPropertyPriceHistoryAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListPropertyPriceHistorySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyPriceHistoryBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListPropertyPriceHistoryAggregateBoolExpCovarSamp = {
  arguments: InsertPropertyListPropertyPriceHistoryAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyPriceHistoryBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyPriceHistoryAggregateBoolExpCovarSampArguments = {
  X: InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertPropertyListPropertyPriceHistoryAggregateBoolExpMax = {
  arguments: InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyPriceHistoryBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyPriceHistoryAggregateBoolExpMin = {
  arguments: InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyPriceHistoryBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyPriceHistoryAggregateBoolExpStddevSamp = {
  arguments: InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyPriceHistoryBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyPriceHistoryAggregateBoolExpSum = {
  arguments: InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyPriceHistoryBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyPriceHistoryAggregateBoolExpVarSamp = {
  arguments: InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyPriceHistoryBoolExp>;
  predicate: InsertPropertyListFloat8ComparisonExp;
};

export type InsertPropertyListPropertyPriceHistoryArrRelInsertInput = {
  data: Array<InsertPropertyListPropertyPriceHistoryInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListPropertyPriceHistoryOnConflict>;
};

export type InsertPropertyListPropertyPriceHistoryBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListPropertyPriceHistoryBoolExp>>;
  _not?: InputMaybe<InsertPropertyListPropertyPriceHistoryBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListPropertyPriceHistoryBoolExp>>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  date_recorded?: InputMaybe<InsertPropertyListDateComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  price?: InputMaybe<InsertPropertyListFloat8ComparisonExp>;
  price_currency?: InputMaybe<InsertPropertyListCurrencyEnumComparisonExp>;
  property?: InputMaybe<InsertPropertyListPropertyBoolExp>;
  property_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  property_list?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  property_list_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
};

export enum InsertPropertyListPropertyPriceHistoryConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertyPriceHistoryPkey = 'property_price_history_pkey',
  /** unique or primary key constraint on columns "price", "property_list_id" */
  PropertyPriceHistoryPropertyListIdPriceKey = 'property_price_history_property_list_id_price_key'
}

export type InsertPropertyListPropertyPriceHistoryInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_recorded?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  price_currency?: InputMaybe<InsertPropertyListCurrencyEnum>;
  property?: InputMaybe<InsertPropertyListPropertyObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list?: InputMaybe<InsertPropertyListPropertyListObjRelInsertInput>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertPropertyListPropertyPriceHistoryOnConflict = {
  constraint: InsertPropertyListPropertyPriceHistoryConstraint;
  update_columns: Array<InsertPropertyListPropertyPriceHistoryUpdateColumn>;
  where?: InputMaybe<InsertPropertyListPropertyPriceHistoryBoolExp>;
};

export enum InsertPropertyListPropertyPriceHistorySelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateRecorded = 'date_recorded',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  PriceCurrency = 'price_currency',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  Price = 'price'
}

export enum InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  Price = 'price'
}

export enum InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  Price = 'price'
}

export enum InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  Price = 'price'
}

export enum InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpMinArgumentsColumns {
  /** column name */
  Price = 'price'
}

export enum InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  Price = 'price'
}

export enum InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpSumArgumentsColumns {
  /** column name */
  Price = 'price'
}

export enum InsertPropertyListPropertyPriceHistorySelectColumnPropertyPriceHistoryAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  Price = 'price'
}

export enum InsertPropertyListPropertyPriceHistoryUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateRecorded = 'date_recorded',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  PriceCurrency = 'price_currency',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertPropertyListPropertySelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  JsonLd = 'json_ld',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  MainListingId = 'main_listing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertPropertyListPropertySourceAggregateBoolExp = {
  count?: InputMaybe<InsertPropertyListPropertySourceAggregateBoolExpCount>;
};

export type InsertPropertyListPropertySourceAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListPropertySourceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertySourceBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListPropertySourceArrRelInsertInput = {
  data: Array<InsertPropertyListPropertySourceInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListPropertySourceOnConflict>;
};

export type InsertPropertyListPropertySourceBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListPropertySourceBoolExp>>;
  _not?: InputMaybe<InsertPropertyListPropertySourceBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListPropertySourceBoolExp>>;
  agency?: InputMaybe<InsertPropertyListAgencyBoolExp>;
  agency_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  origin?: InputMaybe<InsertPropertyListPropertyOriginEnumComparisonExp>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  property_lists_aggregate?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExp>;
  type?: InputMaybe<InsertPropertyListPropertyOriginTypeEnumComparisonExp>;
};

export enum InsertPropertyListPropertySourceConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertySourcePkey = 'property_source_pkey'
}

export type InsertPropertyListPropertySourceInsertInput = {
  agency?: InputMaybe<InsertPropertyListAgencyObjRelInsertInput>;
  agency_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  origin?: InputMaybe<InsertPropertyListPropertyOriginEnum>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListArrRelInsertInput>;
  type?: InputMaybe<InsertPropertyListPropertyOriginTypeEnum>;
};

export type InsertPropertyListPropertySourceObjRelInsertInput = {
  data: InsertPropertyListPropertySourceInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListPropertySourceOnConflict>;
};

export type InsertPropertyListPropertySourceOnConflict = {
  constraint: InsertPropertyListPropertySourceConstraint;
  update_columns: Array<InsertPropertyListPropertySourceUpdateColumn>;
  where?: InputMaybe<InsertPropertyListPropertySourceBoolExp>;
};

export enum InsertPropertyListPropertySourceSelectColumn {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  Id = 'id',
  /** column name */
  Origin = 'origin',
  /** column name */
  Type = 'type'
}

export enum InsertPropertyListPropertySourceUpdateColumn {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  Id = 'id',
  /** column name */
  Origin = 'origin',
  /** column name */
  Type = 'type'
}

export enum InsertPropertyListPropertyStatusEnum {
  ForRent = 'for_rent',
  ForSale = 'for_sale',
  Rented = 'rented',
  Sold = 'sold',
  UnderOffer = 'under_offer'
}

export type InsertPropertyListPropertyStatusEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListPropertyStatusEnum>;
  _in?: InputMaybe<Array<InsertPropertyListPropertyStatusEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListPropertyStatusEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListPropertyStatusEnum>>;
};

export type InsertPropertyListPropertyTypeAggregateBoolExp = {
  count?: InputMaybe<InsertPropertyListPropertyTypeAggregateBoolExpCount>;
};

export type InsertPropertyListPropertyTypeAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListPropertyTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyTypeBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListPropertyTypeArrRelInsertInput = {
  data: Array<InsertPropertyListPropertyTypeInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListPropertyTypeOnConflict>;
};

export type InsertPropertyListPropertyTypeBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListPropertyTypeBoolExp>>;
  _not?: InputMaybe<InsertPropertyListPropertyTypeBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListPropertyTypeBoolExp>>;
  cluster?: InputMaybe<InsertPropertyListPropertyClusterEnumComparisonExp>;
  property_cluster?: InputMaybe<InsertPropertyListPropertyClusterBoolExp>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListBoolExp>;
  property_lists_aggregate?: InputMaybe<InsertPropertyListPropertyListAggregateBoolExp>;
  type?: InputMaybe<InsertPropertyListStringComparisonExp>;
};

export enum InsertPropertyListPropertyTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  PropertyTypePkey = 'property_type_pkey'
}

export enum InsertPropertyListPropertyTypeEnum {
  /** residential */
  Apartment = 'apartment',
  /** residential */
  Building = 'building',
  /** residential */
  Bungalow = 'bungalow',
  /** commercial */
  Commercial = 'commercial',
  /** residential */
  Duplex = 'duplex',
  /** industrial */
  Factory = 'factory',
  /** land */
  Farm = 'farm',
  /** residential */
  Farmhouse = 'farmhouse',
  /** land */
  Farmland = 'farmland',
  /** commercial */
  Hotel = 'hotel',
  /** land */
  Land = 'land',
  /** commercial */
  MultipurposeSpace = 'multipurpose_space',
  /** commercial */
  Office = 'office',
  /** parking */
  Parking = 'parking',
  /** residential */
  PrivateHouse = 'private_house',
  /** commercial */
  Restaurant = 'restaurant',
  /** commercial */
  Shop = 'shop',
  /** commercial */
  ShoppingCenter = 'shopping_center',
  /** residential */
  Studio = 'studio',
  /** residential */
  Villa = 'villa',
  /** industrial */
  Warehouse = 'warehouse'
}

export type InsertPropertyListPropertyTypeEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListPropertyTypeEnum>;
  _in?: InputMaybe<Array<InsertPropertyListPropertyTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListPropertyTypeEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListPropertyTypeEnum>>;
};

export type InsertPropertyListPropertyTypeInsertInput = {
  cluster?: InputMaybe<InsertPropertyListPropertyClusterEnum>;
  property_cluster?: InputMaybe<InsertPropertyListPropertyClusterObjRelInsertInput>;
  property_lists?: InputMaybe<InsertPropertyListPropertyListArrRelInsertInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InsertPropertyListPropertyTypeObjRelInsertInput = {
  data: InsertPropertyListPropertyTypeInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListPropertyTypeOnConflict>;
};

export type InsertPropertyListPropertyTypeOnConflict = {
  constraint: InsertPropertyListPropertyTypeConstraint;
  update_columns: Array<InsertPropertyListPropertyTypeUpdateColumn>;
  where?: InputMaybe<InsertPropertyListPropertyTypeBoolExp>;
};

export enum InsertPropertyListPropertyTypeSelectColumn {
  /** column name */
  Cluster = 'cluster',
  /** column name */
  Type = 'type'
}

export enum InsertPropertyListPropertyTypeUpdateColumn {
  /** column name */
  Cluster = 'cluster',
  /** column name */
  Type = 'type'
}

export enum InsertPropertyListPropertyUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  JsonLd = 'json_ld',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  MainListingId = 'main_listing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertPropertyListPropertyViewsAggregateBoolExp = {
  count?: InputMaybe<InsertPropertyListPropertyViewsAggregateBoolExpCount>;
};

export type InsertPropertyListPropertyViewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListPropertyViewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListPropertyViewsBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListPropertyViewsArrRelInsertInput = {
  data: Array<InsertPropertyListPropertyViewsInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListPropertyViewsOnConflict>;
};

export type InsertPropertyListPropertyViewsBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListPropertyViewsBoolExp>>;
  _not?: InputMaybe<InsertPropertyListPropertyViewsBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListPropertyViewsBoolExp>>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  date?: InputMaybe<InsertPropertyListDateComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  property_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  view_count?: InputMaybe<InsertPropertyListIntComparisonExp>;
};

export enum InsertPropertyListPropertyViewsConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertyViewsPkey = 'property_views_pkey'
}

export type InsertPropertyListPropertyViewsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  view_count?: InputMaybe<Scalars['Int']['input']>;
};

export type InsertPropertyListPropertyViewsOnConflict = {
  constraint: InsertPropertyListPropertyViewsConstraint;
  update_columns: Array<InsertPropertyListPropertyViewsUpdateColumn>;
  where?: InputMaybe<InsertPropertyListPropertyViewsBoolExp>;
};

export enum InsertPropertyListPropertyViewsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViewCount = 'view_count'
}

export enum InsertPropertyListPropertyViewsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViewCount = 'view_count'
}

export type InsertPropertyListStDWithinGeographyInput = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsertPropertyListStDWithinInput = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

export type InsertPropertyListStringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  _niregex?: InputMaybe<Scalars['String']['input']>;
  _nlike?: InputMaybe<Scalars['String']['input']>;
  _nregex?: InputMaybe<Scalars['String']['input']>;
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  _regex?: InputMaybe<Scalars['String']['input']>;
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type InsertPropertyListTextContentBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListTextContentBoolExp>>;
  _not?: InputMaybe<InsertPropertyListTextContentBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListTextContentBoolExp>>;
  content_type?: InputMaybe<InsertPropertyListContentTypeEnumComparisonExp>;
  entity_type?: InputMaybe<InsertPropertyListEntitiesEnumComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  original_language_id?: InputMaybe<InsertPropertyListIntComparisonExp>;
  original_text?: InputMaybe<InsertPropertyListStringComparisonExp>;
  seo_meta?: InputMaybe<InsertPropertyListStringComparisonExp>;
  translations?: InputMaybe<InsertPropertyListTranslationsBoolExp>;
  translations_aggregate?: InputMaybe<InsertPropertyListTranslationsAggregateBoolExp>;
};

export enum InsertPropertyListTextContentConstraint {
  /** unique or primary key constraint on columns "id" */
  TextContentPkey = 'text_content_pkey'
}

export type InsertPropertyListTextContentInsertInput = {
  content_type?: InputMaybe<InsertPropertyListContentTypeEnum>;
  entity_type?: InputMaybe<InsertPropertyListEntitiesEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  original_language_id?: InputMaybe<Scalars['Int']['input']>;
  original_text?: InputMaybe<Scalars['String']['input']>;
  seo_meta?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<InsertPropertyListTranslationsArrRelInsertInput>;
};

export type InsertPropertyListTextContentObjRelInsertInput = {
  data: InsertPropertyListTextContentInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListTextContentOnConflict>;
};

export type InsertPropertyListTextContentOnConflict = {
  constraint: InsertPropertyListTextContentConstraint;
  update_columns: Array<InsertPropertyListTextContentUpdateColumn>;
  where?: InputMaybe<InsertPropertyListTextContentBoolExp>;
};

export enum InsertPropertyListTextContentUpdateColumn {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalLanguageId = 'original_language_id',
  /** column name */
  OriginalText = 'original_text',
  /** column name */
  SeoMeta = 'seo_meta'
}

export type InsertPropertyListTimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

export type InsertPropertyListTranslationsAggregateBoolExp = {
  count?: InputMaybe<InsertPropertyListTranslationsAggregateBoolExpCount>;
};

export type InsertPropertyListTranslationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListTranslationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListTranslationsBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListTranslationsArrRelInsertInput = {
  data: Array<InsertPropertyListTranslationsInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListTranslationsOnConflict>;
};

export type InsertPropertyListTranslationsBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListTranslationsBoolExp>>;
  _not?: InputMaybe<InsertPropertyListTranslationsBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListTranslationsBoolExp>>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  language?: InputMaybe<InsertPropertyListLanguagesBoolExp>;
  language_id?: InputMaybe<InsertPropertyListIntComparisonExp>;
  seo_meta?: InputMaybe<InsertPropertyListStringComparisonExp>;
  text_content?: InputMaybe<InsertPropertyListTextContentBoolExp>;
  text_content_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  translation?: InputMaybe<InsertPropertyListStringComparisonExp>;
};

export enum InsertPropertyListTranslationsConstraint {
  /** unique or primary key constraint on columns "text_content_id", "language_id" */
  TranslationsLanguageIdTextContentIdKey = 'translations_language_id_text_content_id_key',
  /** unique or primary key constraint on columns "id" */
  TranslationsPkey = 'translations_pkey'
}

export type InsertPropertyListTranslationsInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<InsertPropertyListLanguagesObjRelInsertInput>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  seo_meta?: InputMaybe<Scalars['String']['input']>;
  text_content?: InputMaybe<InsertPropertyListTextContentObjRelInsertInput>;
  text_content_id?: InputMaybe<Scalars['uuid']['input']>;
  translation?: InputMaybe<Scalars['String']['input']>;
};

export type InsertPropertyListTranslationsOnConflict = {
  constraint: InsertPropertyListTranslationsConstraint;
  update_columns: Array<InsertPropertyListTranslationsUpdateColumn>;
  where?: InputMaybe<InsertPropertyListTranslationsBoolExp>;
};

export enum InsertPropertyListTranslationsSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  SeoMeta = 'seo_meta',
  /** column name */
  TextContentId = 'text_content_id',
  /** column name */
  Translation = 'translation'
}

export enum InsertPropertyListTranslationsUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  SeoMeta = 'seo_meta',
  /** column name */
  TextContentId = 'text_content_id',
  /** column name */
  Translation = 'translation'
}

export type InsertPropertyListUrlSlugAggregateBoolExp = {
  bool_and?: InputMaybe<InsertPropertyListUrlSlugAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertPropertyListUrlSlugAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertPropertyListUrlSlugAggregateBoolExpCount>;
};

export type InsertPropertyListUrlSlugAggregateBoolExpBoolAnd = {
  arguments: InsertPropertyListUrlSlugSelectColumnUrlSlugAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListUrlSlugBoolExp>;
  predicate: InsertPropertyListBooleanComparisonExp;
};

export type InsertPropertyListUrlSlugAggregateBoolExpBoolOr = {
  arguments: InsertPropertyListUrlSlugSelectColumnUrlSlugAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListUrlSlugBoolExp>;
  predicate: InsertPropertyListBooleanComparisonExp;
};

export type InsertPropertyListUrlSlugAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListUrlSlugSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListUrlSlugBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListUrlSlugArrRelInsertInput = {
  data: Array<InsertPropertyListUrlSlugInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListUrlSlugOnConflict>;
};

export type InsertPropertyListUrlSlugBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListUrlSlugBoolExp>>;
  _not?: InputMaybe<InsertPropertyListUrlSlugBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListUrlSlugBoolExp>>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  is_active?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  language?: InputMaybe<InsertPropertyListLanguagesBoolExp>;
  language_id?: InputMaybe<InsertPropertyListIntComparisonExp>;
  property?: InputMaybe<InsertPropertyListPropertyBoolExp>;
  property_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  slug?: InputMaybe<InsertPropertyListStringComparisonExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
};

export enum InsertPropertyListUrlSlugConstraint {
  /** unique or primary key constraint on columns "id" */
  UrlSlugPkey = 'url_slug_pkey',
  /** unique or primary key constraint on columns "slug" */
  UrlSlugSlugKey = 'url_slug_slug_key'
}

export type InsertPropertyListUrlSlugInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<InsertPropertyListLanguagesObjRelInsertInput>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<InsertPropertyListPropertyObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertPropertyListUrlSlugOnConflict = {
  constraint: InsertPropertyListUrlSlugConstraint;
  update_columns: Array<InsertPropertyListUrlSlugUpdateColumn>;
  where?: InputMaybe<InsertPropertyListUrlSlugBoolExp>;
};

export enum InsertPropertyListUrlSlugSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertPropertyListUrlSlugSelectColumnUrlSlugAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsActive = 'is_active'
}

export enum InsertPropertyListUrlSlugSelectColumnUrlSlugAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsActive = 'is_active'
}

export enum InsertPropertyListUrlSlugUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertPropertyListUserSavedPropertiesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertPropertyListUserSavedPropertiesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertPropertyListUserSavedPropertiesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertPropertyListUserSavedPropertiesAggregateBoolExpCount>;
};

export type InsertPropertyListUserSavedPropertiesAggregateBoolExpBoolAnd = {
  arguments: InsertPropertyListUserSavedPropertiesSelectColumnUserSavedPropertiesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListUserSavedPropertiesBoolExp>;
  predicate: InsertPropertyListBooleanComparisonExp;
};

export type InsertPropertyListUserSavedPropertiesAggregateBoolExpBoolOr = {
  arguments: InsertPropertyListUserSavedPropertiesSelectColumnUserSavedPropertiesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListUserSavedPropertiesBoolExp>;
  predicate: InsertPropertyListBooleanComparisonExp;
};

export type InsertPropertyListUserSavedPropertiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListUserSavedPropertiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListUserSavedPropertiesBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListUserSavedPropertiesArrRelInsertInput = {
  data: Array<InsertPropertyListUserSavedPropertiesInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListUserSavedPropertiesOnConflict>;
};

export type InsertPropertyListUserSavedPropertiesBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListUserSavedPropertiesBoolExp>>;
  _not?: InputMaybe<InsertPropertyListUserSavedPropertiesBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListUserSavedPropertiesBoolExp>>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  is_deleted?: InputMaybe<InsertPropertyListBooleanComparisonExp>;
  property?: InputMaybe<InsertPropertyListPropertyBoolExp>;
  property_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  user_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
};

export enum InsertPropertyListUserSavedPropertiesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserSavedPropertiesIdKey = 'user_saved_properties_id_key',
  /** unique or primary key constraint on columns "id" */
  UserSavedPropertiesPkey = 'user_saved_properties_pkey',
  /** unique or primary key constraint on columns "property_id", "user_id" */
  UserSavedPropertiesPropertyIdUserIdKey = 'user_saved_properties_property_id_user_id_key'
}

export type InsertPropertyListUserSavedPropertiesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  property?: InputMaybe<InsertPropertyListPropertyObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertPropertyListUserSavedPropertiesOnConflict = {
  constraint: InsertPropertyListUserSavedPropertiesConstraint;
  update_columns: Array<InsertPropertyListUserSavedPropertiesUpdateColumn>;
  where?: InputMaybe<InsertPropertyListUserSavedPropertiesBoolExp>;
};

export enum InsertPropertyListUserSavedPropertiesSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertPropertyListUserSavedPropertiesSelectColumnUserSavedPropertiesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsDeleted = 'is_deleted'
}

export enum InsertPropertyListUserSavedPropertiesSelectColumnUserSavedPropertiesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsDeleted = 'is_deleted'
}

export enum InsertPropertyListUserSavedPropertiesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type InsertPropertyListUserSeenPropertyAggregateBoolExp = {
  count?: InputMaybe<InsertPropertyListUserSeenPropertyAggregateBoolExpCount>;
};

export type InsertPropertyListUserSeenPropertyAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertPropertyListUserSeenPropertySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertPropertyListUserSeenPropertyBoolExp>;
  predicate: InsertPropertyListIntComparisonExp;
};

export type InsertPropertyListUserSeenPropertyArrRelInsertInput = {
  data: Array<InsertPropertyListUserSeenPropertyInsertInput>;
  on_conflict?: InputMaybe<InsertPropertyListUserSeenPropertyOnConflict>;
};

export type InsertPropertyListUserSeenPropertyBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListUserSeenPropertyBoolExp>>;
  _not?: InputMaybe<InsertPropertyListUserSeenPropertyBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListUserSeenPropertyBoolExp>>;
  created_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  property?: InputMaybe<InsertPropertyListPropertyBoolExp>;
  property_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
  updated_at?: InputMaybe<InsertPropertyListTimestamptzComparisonExp>;
  user_id?: InputMaybe<InsertPropertyListUuidComparisonExp>;
};

export enum InsertPropertyListUserSeenPropertyConstraint {
  /** unique or primary key constraint on columns "id" */
  UserSeenPropertyPkey = 'user_seen_property_pkey',
  /** unique or primary key constraint on columns "property_id", "user_id" */
  UserSeenPropertyUserIdPropertyIdKey = 'user_seen_property_user_id_property_id_key'
}

export type InsertPropertyListUserSeenPropertyInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property?: InputMaybe<InsertPropertyListPropertyObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertPropertyListUserSeenPropertyOnConflict = {
  constraint: InsertPropertyListUserSeenPropertyConstraint;
  update_columns: Array<InsertPropertyListUserSeenPropertyUpdateColumn>;
  where?: InputMaybe<InsertPropertyListUserSeenPropertyBoolExp>;
};

export enum InsertPropertyListUserSeenPropertySelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertPropertyListUserSeenPropertyUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type InsertPropertyListUuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type InsertPropertyListZoneDataMethodBoolExp = {
  _and?: InputMaybe<Array<InsertPropertyListZoneDataMethodBoolExp>>;
  _not?: InputMaybe<InsertPropertyListZoneDataMethodBoolExp>;
  _or?: InputMaybe<Array<InsertPropertyListZoneDataMethodBoolExp>>;
  method?: InputMaybe<InsertPropertyListStringComparisonExp>;
};

export enum InsertPropertyListZoneDataMethodConstraint {
  /** unique or primary key constraint on columns "method" */
  ZoneDataMethodPkey = 'zone_data_method_pkey'
}

export enum InsertPropertyListZoneDataMethodEnum {
  Custom = 'custom',
  GoogleMapsGeocodingApi = 'google_maps_geocoding_api',
  GoogleMapsPlacesApi = 'google_maps_places_api'
}

export type InsertPropertyListZoneDataMethodEnumComparisonExp = {
  _eq?: InputMaybe<InsertPropertyListZoneDataMethodEnum>;
  _in?: InputMaybe<Array<InsertPropertyListZoneDataMethodEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertPropertyListZoneDataMethodEnum>;
  _nin?: InputMaybe<Array<InsertPropertyListZoneDataMethodEnum>>;
};

export type InsertPropertyListZoneDataMethodInsertInput = {
  method?: InputMaybe<Scalars['String']['input']>;
};

export type InsertPropertyListZoneDataMethodObjRelInsertInput = {
  data: InsertPropertyListZoneDataMethodInsertInput;
  on_conflict?: InputMaybe<InsertPropertyListZoneDataMethodOnConflict>;
};

export type InsertPropertyListZoneDataMethodOnConflict = {
  constraint: InsertPropertyListZoneDataMethodConstraint;
  update_columns: Array<InsertPropertyListZoneDataMethodUpdateColumn>;
  where?: InputMaybe<InsertPropertyListZoneDataMethodBoolExp>;
};

export enum InsertPropertyListZoneDataMethodUpdateColumn {
  /** column name */
  Method = 'method'
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Language_Action_Type = {
  __typename?: 'Language_Action_Type';
  language_code?: Maybe<Scalars['String']['output']>;
};

export type Location_Action_Type = {
  __typename?: 'Location_Action_Type';
  city_zone?: Maybe<City_Zone_Action_Type>;
  country?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Geom_Action_Type>;
  locality?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
};

export type Location_ObjectInput_Action_Type = {
  bounds?: InputMaybe<Array<InputMaybe<Coords_Action_Type>>>;
  city_name?: InputMaybe<Scalars['String']['input']>;
  city_zone_id?: InputMaybe<Scalars['String']['input']>;
  location_string?: InputMaybe<Scalars['String']['input']>;
};

export type Location_Object_Action_Type = {
  __typename?: 'Location_Object_Action_Type';
  city_name?: Maybe<Scalars['String']['output']>;
  city_zone_id?: Maybe<Scalars['String']['output']>;
  location_string?: Maybe<Scalars['String']['output']>;
};

export type MainImage_Action_Type = {
  __typename?: 'MainImage_Action_Type';
  image?: Maybe<Scalars['String']['output']>;
};

export type MainProperty_Action_Type = {
  __typename?: 'MainProperty_Action_Type';
  created_at?: Maybe<Scalars['String']['output']>;
  generated_title?: Maybe<TitleTextContent_Action_Type>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_seen: Scalars['timestamptz']['output'];
  living_area?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Location_Action_Type>;
  main_image?: Maybe<MainImage_Action_Type>;
  price?: Maybe<Scalars['Int']['output']>;
  price_currency?: Maybe<Scalars['String']['output']>;
  price_exchange?: Maybe<Scalars['String']['output']>;
  property_composition?: Maybe<PropertyComposition_Action_Type>;
  property_source?: Maybe<PropertySource_Action_Type>;
  title_text_content?: Maybe<TitleTextContent_Action_Type>;
  total_area?: Maybe<Scalars['Int']['output']>;
};

export type ManualSubscriptionInput = {
  agency_name?: InputMaybe<Scalars['String']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<OriginEnumActionType>;
  plan_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RoleContractActionType>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  users_to_add?: InputMaybe<Scalars['Int']['input']>;
};

export type ManualSubscriptionOutput = {
  __typename?: 'ManualSubscriptionOutput';
  message?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MuxAssetCreateParams = {
  property_image_id?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MuxAssetCreateResult = {
  __typename?: 'MuxAssetCreateResult';
  errors?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationDataActionType = {
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<OriginEnumActionType>;
  role?: InputMaybe<OrganizationRoleEnumActionType>;
  type?: InputMaybe<OrganizationTypeEnumActionType>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export enum OrganizationRoleEnumActionType {
  Admin = 'admin',
  Lister = 'lister'
}

export enum OrganizationTypeEnumActionType {
  Agency = 'agency',
  Clering = 'clering',
  Personal = 'personal'
}

export enum OriginEnumActionType {
  Catia = 'CATIA',
  Celesi = 'CELESI',
  Century_21 = 'CENTURY_21',
  DesrealAl = 'DESREAL_AL',
  Devinf = 'DEVINF',
  Duashpi = 'DUASHPI',
  Dupron = 'DUPRON',
  FutureHome = 'FUTURE_HOME',
  IndomioAl = 'INDOMIO_AL',
  Inf_93 = 'INF_93',
  MeiAl = 'MEI_AL',
  MerrJep = 'MERR_JEP',
  NjoftimeAl = 'NJOFTIME_AL',
  NjoftimeCom = 'NJOFTIME_COM',
  NjoftimeFalas = 'NJOFTIME_FALAS',
  RealEstateAl = 'REAL_ESTATE_AL',
  RealPassAl = 'REAL_PASS_AL',
  Remax = 'REMAX',
  ShpiAl = 'SHPI_AL',
  ThePoint = 'THE_POINT'
}

export type Output = {
  __typename?: 'Output';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  notification_id?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['String']['output']>;
};

export type PaymentSuccessInput = {
  order_id?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentSuccessOutput = {
  __typename?: 'PaymentSuccessOutput';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum PeriodEnumActionType {
  Monthly = 'monthly',
  Weekly = 'weekly',
  Yearly = 'yearly'
}

export type PhoneInput = {
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneOutput = {
  __typename?: 'PhoneOutput';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PotentialBuyerPropertiesInput = {
  buyer_id?: InputMaybe<Scalars['String']['input']>;
};

export type PotentialBuyerPropertiesOutput = {
  __typename?: 'PotentialBuyerPropertiesOutput';
  message?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['String']['output']>;
};

export type Properties_Output = {
  __typename?: 'Properties_Output';
  properties?: Maybe<Array<Maybe<Property_Action_Type>>>;
  total_found_properties?: Maybe<Scalars['numeric']['output']>;
};

export type PropertyAttributesInput = {
  attribute_type?: InputMaybe<AttributeTypeEnumAction>;
  attributes?: InputMaybe<PropertyCheckInput>;
  property_list_id?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyAttributesOutput = {
  __typename?: 'PropertyAttributesOutput';
  description_content?: Maybe<Text_Content>;
  description_content_id?: Maybe<Scalars['uuid']['output']>;
  description_en?: Maybe<Scalars['String']['output']>;
  description_sq?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  title_content?: Maybe<Text_Content>;
  title_content_id?: Maybe<Scalars['uuid']['output']>;
  title_en?: Maybe<Scalars['String']['output']>;
  title_sq?: Maybe<Scalars['String']['output']>;
};

export type PropertyCheckInput = {
  construction_status?: InputMaybe<Scalars['String']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['Int']['input']>;
  furnishing_status?: InputMaybe<Scalars['String']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking_space?: InputMaybe<Scalars['Boolean']['input']>;
  living_area?: InputMaybe<Scalars['Int']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  nr_balconies?: InputMaybe<Scalars['Int']['input']>;
  nr_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  nr_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  nr_kitchens?: InputMaybe<Scalars['Int']['input']>;
  nr_living_rooms?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  price_currency?: InputMaybe<Scalars['String']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
  total_area?: InputMaybe<Scalars['Int']['input']>;
};

export enum PropertyClusterEnum_ActionsType {
  Commercial = 'commercial',
  Industrial = 'industrial',
  Land = 'land',
  Parking = 'parking',
  Residential = 'residential'
}

export type PropertyComposition_Action_Type = {
  __typename?: 'PropertyComposition_Action_Type';
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  living_rooms?: Maybe<Scalars['Int']['output']>;
};

export type PropertyDuplicateApproveInput = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  is_duplicate?: InputMaybe<Scalars['Boolean']['input']>;
  matched_property_list_id?: InputMaybe<Scalars['String']['input']>;
  property_list_id?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyDuplicateApproveOutput = {
  __typename?: 'PropertyDuplicateApproveOutput';
  limit_reached?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PropertyDuplicateCheckInput = {
  property_id?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyDuplicateCheckOutput = {
  __typename?: 'PropertyDuplicateCheckOutput';
  is_duplicate?: Maybe<Scalars['Boolean']['output']>;
  limit_reached?: Maybe<Scalars['Boolean']['output']>;
  matched_property_list_id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  property_list?: Maybe<Property_List>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PropertyImagesDataActionType = {
  file?: InputMaybe<Scalars['String']['input']>;
  is_main?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertySource_Action_Type = {
  __typename?: 'PropertySource_Action_Type';
  agency?: Maybe<Agency_Action_Type>;
};

export enum PropertyStatusEnum_ActionsType {
  ForRent = 'for_rent',
  ForSale = 'for_sale'
}

export enum PropertyTypeEnum_ActionsType {
  Apartment = 'apartment',
  Building = 'building',
  Bungalow = 'bungalow',
  Commercial = 'commercial',
  Duplex = 'duplex',
  Factory = 'factory',
  Farm = 'farm',
  Farmhouse = 'farmhouse',
  Farmland = 'farmland',
  Hotel = 'hotel',
  Land = 'land',
  MultipurposeSpace = 'multipurpose_space',
  Office = 'office',
  Parking = 'parking',
  PrivateHouse = 'private_house',
  Restaurant = 'restaurant',
  Shop = 'shop',
  ShoppingCenter = 'shopping_center',
  Studio = 'studio',
  Villa = 'villa',
  Warehouse = 'warehouse'
}

export type PropertyVisibilityActionInput = {
  property_list_id: Scalars['uuid']['input'];
  status: VisibilityStatusEnumAction;
};

export type PropertyVisibilityActionOutput = {
  __typename?: 'PropertyVisibilityActionOutput';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  visibility_status?: Maybe<VisibilityStatusEnumAction>;
};

export type Property_Action_Type = {
  __typename?: 'Property_Action_Type';
  id: Scalars['uuid']['output'];
  last_seen: Scalars['timestamptz']['output'];
  main_property?: Maybe<MainProperty_Action_Type>;
  user_saved_properties?: Maybe<Array<Maybe<UserSavedProperties_Action_Type>>>;
  user_seen_properties?: Maybe<Array<Maybe<UserSeenProperties_Action_Type>>>;
};

export type QuestionInput = {
  drawed_zone?: InputMaybe<Scalars['jsonb']['input']>;
  filters?: InputMaybe<SearchFilters_ActionType>;
  is_engine_search?: InputMaybe<Scalars['Boolean']['input']>;
  old_session_id?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  query_id?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionOutput = {
  __typename?: 'QuestionOutput';
  location_id?: Maybe<Scalars['String']['output']>;
  map_center_location?: Maybe<Map_Location>;
  message?: Maybe<Scalars['String']['output']>;
  natural_language_query?: Maybe<Natural_Language_Queries>;
  nlq_id?: Maybe<Scalars['String']['output']>;
  query_properties: Array<Queries_Property_Result>;
  query_properties_aggregate: Queries_Property_Result_Aggregate;
  response?: Maybe<Scalars['String']['output']>;
  response_type?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total_found_properties?: Maybe<Scalars['Int']['output']>;
  whereObject?: Maybe<Scalars['String']['output']>;
};


export type QuestionOutputQuery_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<Queries_Property_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queries_Property_Result_Order_By>>;
  where?: InputMaybe<Queries_Property_Result_Bool_Exp>;
};


export type QuestionOutputQuery_Properties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queries_Property_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queries_Property_Result_Order_By>>;
  where?: InputMaybe<Queries_Property_Result_Bool_Exp>;
};

export type RegenerateInput = {
  query_id: Scalars['String']['input'];
};

export type ResendInvitationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type ResendInvitationOutput = {
  __typename?: 'ResendInvitationOutput';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum RoleContractActionType {
  Agency = 'agency',
  AgencyAgent = 'agency_agent',
  IndependentAgent = 'independent_agent'
}

export type SampleInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SampleOutput = {
  __typename?: 'SampleOutput';
  accessToken: Scalars['String']['output'];
};

export type SearchFilters_ActionType = {
  area_max?: InputMaybe<Scalars['Float']['input']>;
  area_min?: InputMaybe<Scalars['Float']['input']>;
  city_name?: InputMaybe<Scalars['String']['input']>;
  city_zone_id?: InputMaybe<Scalars['String']['input']>;
  construction_status?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['Int']['input']>;
  furnishing_status?: InputMaybe<Scalars['String']['input']>;
  location_string?: InputMaybe<Scalars['String']['input']>;
  max_bathrooms?: InputMaybe<Scalars['Float']['input']>;
  max_rooms?: InputMaybe<Scalars['Float']['input']>;
  min_bathrooms?: InputMaybe<Scalars['Float']['input']>;
  min_rooms?: InputMaybe<Scalars['Float']['input']>;
  price_max?: InputMaybe<Scalars['Float']['input']>;
  price_min?: InputMaybe<Scalars['Float']['input']>;
  property_cluster?: InputMaybe<Scalars['String']['input']>;
  property_composition?: InputMaybe<Scalars['String']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
};

export type SearchPaginationInput = {
  limit: Scalars['numeric']['input'];
  offset: Scalars['numeric']['input'];
  question_id: Scalars['String']['input'];
};

export type SocialMediaInput = {
  description: Scalars['String']['input'];
  language: Scalars['String']['input'];
  maximumCharacters?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type SponsoredLimitOutput = {
  __typename?: 'SponsoredLimitOutput';
  canSponsor?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  periodEndDate?: Maybe<Scalars['String']['output']>;
  periodStartDate?: Maybe<Scalars['String']['output']>;
  remainingSlots?: Maybe<Scalars['Int']['output']>;
  totalSlots?: Maybe<Scalars['Int']['output']>;
  usedSlots?: Maybe<Scalars['Int']['output']>;
};

export enum StatisticQueryEnumActionType {
  HeaderStatistics = 'header_statistics',
  ViewsGraphic = 'views_graphic'
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type TitleTextContent_Action_Type = {
  __typename?: 'TitleTextContent_Action_Type';
  translations?: Maybe<Array<Maybe<Translations_Action_Type>>>;
};

export type TranslateInput = {
  language_source?: InputMaybe<Scalars['String']['input']>;
  language_target?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type TranslateOutput = {
  __typename?: 'TranslateOutput';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  translatedText?: Maybe<Scalars['String']['output']>;
};

export type Translations_Action_Type = {
  __typename?: 'Translations_Action_Type';
  language?: Maybe<Language_Action_Type>;
  translation?: Maybe<Scalars['String']['output']>;
};

export type UserSavedProperties_Action_Type = {
  __typename?: 'UserSavedProperties_Action_Type';
  id: Scalars['uuid']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  property_id?: Maybe<Scalars['String']['output']>;
};

export type UserSeenProperties_Action_Type = {
  __typename?: 'UserSeenProperties_Action_Type';
  id: Scalars['uuid']['output'];
};

export type VerfiyCodeInput = {
  phone_number?: InputMaybe<Scalars['String']['input']>;
  verification_code?: InputMaybe<Scalars['String']['input']>;
};

export type VerfiyCodeOutput = {
  __typename?: 'VerfiyCodeOutput';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum VisibilityStatusEnumAction {
  Active = 'active',
  Archived = 'archived',
  Deleted = 'deleted',
  Draft = 'draft',
  Private = 'private',
  Review = 'review'
}

/** columns and relationships of "address_types" */
export type Address_Types = {
  __typename?: 'address_types';
  type: Scalars['String']['output'];
};

/** aggregated selection of "address_types" */
export type Address_Types_Aggregate = {
  __typename?: 'address_types_aggregate';
  aggregate?: Maybe<Address_Types_Aggregate_Fields>;
  nodes: Array<Address_Types>;
};

/** aggregate fields of "address_types" */
export type Address_Types_Aggregate_Fields = {
  __typename?: 'address_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Address_Types_Max_Fields>;
  min?: Maybe<Address_Types_Min_Fields>;
};


/** aggregate fields of "address_types" */
export type Address_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "address_types". All fields are combined with a logical 'AND'. */
export type Address_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Types_Bool_Exp>>;
  _not?: InputMaybe<Address_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Types_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "address_types" */
export enum Address_Types_Constraint {
  /** unique or primary key constraint on columns "type" */
  AddressTypesPkey = 'address_types_pkey'
}

/** input type for inserting data into table "address_types" */
export type Address_Types_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Address_Types_Max_Fields = {
  __typename?: 'address_types_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Address_Types_Min_Fields = {
  __typename?: 'address_types_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "address_types" */
export type Address_Types_Mutation_Response = {
  __typename?: 'address_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Address_Types>;
};

/** on_conflict condition type for table "address_types" */
export type Address_Types_On_Conflict = {
  constraint: Address_Types_Constraint;
  update_columns?: Array<Address_Types_Update_Column>;
  where?: InputMaybe<Address_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "address_types". */
export type Address_Types_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address_types */
export type Address_Types_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "address_types" */
export enum Address_Types_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "address_types" */
export type Address_Types_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "address_types" */
export type Address_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Types_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "address_types" */
export enum Address_Types_Update_Column {
  /** column name */
  Type = 'type'
}

export type Address_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Address_Types_Bool_Exp;
};

/** columns and relationships of "agency" */
export type Agency = {
  __typename?: 'agency';
  address?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  children: Array<Agency>;
  /** An aggregate relationship */
  children_aggregate: Agency_Aggregate;
  /** An array relationship */
  contact_phone_numbers: Array<Contact_Phone_Number>;
  /** An aggregate relationship */
  contact_phone_numbers_aggregate: Contact_Phone_Number_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  name_norm?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  parent?: Maybe<Agency>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_image_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  property_sources: Array<Property_Source>;
  /** An aggregate relationship */
  property_sources_aggregate: Property_Source_Aggregate;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "agency" */
export type AgencyChildrenArgs = {
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


/** columns and relationships of "agency" */
export type AgencyChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


/** columns and relationships of "agency" */
export type AgencyContact_Phone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Contact_Phone_Number_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Phone_Number_Order_By>>;
  where?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
};


/** columns and relationships of "agency" */
export type AgencyContact_Phone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Phone_Number_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Phone_Number_Order_By>>;
  where?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
};


/** columns and relationships of "agency" */
export type AgencyProperty_SourcesArgs = {
  distinct_on?: InputMaybe<Array<Property_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Source_Order_By>>;
  where?: InputMaybe<Property_Source_Bool_Exp>;
};


/** columns and relationships of "agency" */
export type AgencyProperty_Sources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Source_Order_By>>;
  where?: InputMaybe<Property_Source_Bool_Exp>;
};

/** agencyDashboardStatisticsNative Query Arguments */
export type AgencyDashboardStatistics_Arguments = {
  organization_ids: Scalars['String']['input'];
};

/** agencyViewsGraphicNative Query Arguments */
export type AgencyViewsGraphic_Arguments = {
  organization_ids: Scalars['String']['input'];
  period: Scalars['String']['input'];
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregated selection of "agency" */
export type Agency_Aggregate = {
  __typename?: 'agency_aggregate';
  aggregate?: Maybe<Agency_Aggregate_Fields>;
  nodes: Array<Agency>;
};

export type Agency_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Agency_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Agency_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Agency_Aggregate_Bool_Exp_Count>;
};

export type Agency_Aggregate_Bool_Exp_Bool_And = {
  arguments: Agency_Select_Column_Agency_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Agency_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Agency_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Agency_Select_Column_Agency_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Agency_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Agency_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Agency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Agency_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "agency" */
export type Agency_Aggregate_Fields = {
  __typename?: 'agency_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Agency_Max_Fields>;
  min?: Maybe<Agency_Min_Fields>;
};


/** aggregate fields of "agency" */
export type Agency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "agency" */
export type Agency_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agency_Max_Order_By>;
  min?: InputMaybe<Agency_Min_Order_By>;
};

/** input type for inserting array relation for remote table "agency" */
export type Agency_Arr_Rel_Insert_Input = {
  data: Array<Agency_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agency_On_Conflict>;
};

/** Boolean expression to filter rows from the table "agency". All fields are combined with a logical 'AND'. */
export type Agency_Bool_Exp = {
  _and?: InputMaybe<Array<Agency_Bool_Exp>>;
  _not?: InputMaybe<Agency_Bool_Exp>;
  _or?: InputMaybe<Array<Agency_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  children?: InputMaybe<Agency_Bool_Exp>;
  children_aggregate?: InputMaybe<Agency_Aggregate_Bool_Exp>;
  contact_phone_numbers?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
  contact_phone_numbers_aggregate?: InputMaybe<Contact_Phone_Number_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_norm?: InputMaybe<String_Comparison_Exp>;
  parent?: InputMaybe<Agency_Bool_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  profile_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_sources?: InputMaybe<Property_Source_Bool_Exp>;
  property_sources_aggregate?: InputMaybe<Property_Source_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "agency" */
export enum Agency_Constraint {
  /** unique or primary key constraint on columns "name" */
  AgencyNameKey = 'agency_name_key',
  /** unique or primary key constraint on columns "id" */
  AgencyPkey = 'agency_pkey'
}

/** columns and relationships of "agency_health" */
export type Agency_Health = {
  __typename?: 'agency_health';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shared_contacts?: Maybe<Scalars['bigint']['output']>;
  shared_phone_numbers?: Maybe<Scalars['bigint']['output']>;
  total_contacts?: Maybe<Scalars['bigint']['output']>;
  total_phone_numbers?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "agency_health" */
export type Agency_Health_Aggregate = {
  __typename?: 'agency_health_aggregate';
  aggregate?: Maybe<Agency_Health_Aggregate_Fields>;
  nodes: Array<Agency_Health>;
};

/** aggregate fields of "agency_health" */
export type Agency_Health_Aggregate_Fields = {
  __typename?: 'agency_health_aggregate_fields';
  avg?: Maybe<Agency_Health_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Agency_Health_Max_Fields>;
  min?: Maybe<Agency_Health_Min_Fields>;
  stddev?: Maybe<Agency_Health_Stddev_Fields>;
  stddev_pop?: Maybe<Agency_Health_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agency_Health_Stddev_Samp_Fields>;
  sum?: Maybe<Agency_Health_Sum_Fields>;
  var_pop?: Maybe<Agency_Health_Var_Pop_Fields>;
  var_samp?: Maybe<Agency_Health_Var_Samp_Fields>;
  variance?: Maybe<Agency_Health_Variance_Fields>;
};


/** aggregate fields of "agency_health" */
export type Agency_Health_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agency_Health_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Agency_Health_Avg_Fields = {
  __typename?: 'agency_health_avg_fields';
  shared_contacts?: Maybe<Scalars['Float']['output']>;
  shared_phone_numbers?: Maybe<Scalars['Float']['output']>;
  total_contacts?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "agency_health". All fields are combined with a logical 'AND'. */
export type Agency_Health_Bool_Exp = {
  _and?: InputMaybe<Array<Agency_Health_Bool_Exp>>;
  _not?: InputMaybe<Agency_Health_Bool_Exp>;
  _or?: InputMaybe<Array<Agency_Health_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  shared_contacts?: InputMaybe<Bigint_Comparison_Exp>;
  shared_phone_numbers?: InputMaybe<Bigint_Comparison_Exp>;
  total_contacts?: InputMaybe<Bigint_Comparison_Exp>;
  total_phone_numbers?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Agency_Health_Max_Fields = {
  __typename?: 'agency_health_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shared_contacts?: Maybe<Scalars['bigint']['output']>;
  shared_phone_numbers?: Maybe<Scalars['bigint']['output']>;
  total_contacts?: Maybe<Scalars['bigint']['output']>;
  total_phone_numbers?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Agency_Health_Min_Fields = {
  __typename?: 'agency_health_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shared_contacts?: Maybe<Scalars['bigint']['output']>;
  shared_phone_numbers?: Maybe<Scalars['bigint']['output']>;
  total_contacts?: Maybe<Scalars['bigint']['output']>;
  total_phone_numbers?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "agency_health". */
export type Agency_Health_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  shared_contacts?: InputMaybe<Order_By>;
  shared_phone_numbers?: InputMaybe<Order_By>;
  total_contacts?: InputMaybe<Order_By>;
  total_phone_numbers?: InputMaybe<Order_By>;
};

/** select columns of table "agency_health" */
export enum Agency_Health_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SharedContacts = 'shared_contacts',
  /** column name */
  SharedPhoneNumbers = 'shared_phone_numbers',
  /** column name */
  TotalContacts = 'total_contacts',
  /** column name */
  TotalPhoneNumbers = 'total_phone_numbers'
}

/** aggregate stddev on columns */
export type Agency_Health_Stddev_Fields = {
  __typename?: 'agency_health_stddev_fields';
  shared_contacts?: Maybe<Scalars['Float']['output']>;
  shared_phone_numbers?: Maybe<Scalars['Float']['output']>;
  total_contacts?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Agency_Health_Stddev_Pop_Fields = {
  __typename?: 'agency_health_stddev_pop_fields';
  shared_contacts?: Maybe<Scalars['Float']['output']>;
  shared_phone_numbers?: Maybe<Scalars['Float']['output']>;
  total_contacts?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Agency_Health_Stddev_Samp_Fields = {
  __typename?: 'agency_health_stddev_samp_fields';
  shared_contacts?: Maybe<Scalars['Float']['output']>;
  shared_phone_numbers?: Maybe<Scalars['Float']['output']>;
  total_contacts?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "agency_health" */
export type Agency_Health_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agency_Health_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agency_Health_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shared_contacts?: InputMaybe<Scalars['bigint']['input']>;
  shared_phone_numbers?: InputMaybe<Scalars['bigint']['input']>;
  total_contacts?: InputMaybe<Scalars['bigint']['input']>;
  total_phone_numbers?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Agency_Health_Sum_Fields = {
  __typename?: 'agency_health_sum_fields';
  shared_contacts?: Maybe<Scalars['bigint']['output']>;
  shared_phone_numbers?: Maybe<Scalars['bigint']['output']>;
  total_contacts?: Maybe<Scalars['bigint']['output']>;
  total_phone_numbers?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Agency_Health_Var_Pop_Fields = {
  __typename?: 'agency_health_var_pop_fields';
  shared_contacts?: Maybe<Scalars['Float']['output']>;
  shared_phone_numbers?: Maybe<Scalars['Float']['output']>;
  total_contacts?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Agency_Health_Var_Samp_Fields = {
  __typename?: 'agency_health_var_samp_fields';
  shared_contacts?: Maybe<Scalars['Float']['output']>;
  shared_phone_numbers?: Maybe<Scalars['Float']['output']>;
  total_contacts?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Agency_Health_Variance_Fields = {
  __typename?: 'agency_health_variance_fields';
  shared_contacts?: Maybe<Scalars['Float']['output']>;
  shared_phone_numbers?: Maybe<Scalars['Float']['output']>;
  total_contacts?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
};

/** input type for inserting data into table "agency" */
export type Agency_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Agency_Arr_Rel_Insert_Input>;
  contact_phone_numbers?: InputMaybe<Contact_Phone_Number_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_norm?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Agency_Obj_Rel_Insert_Input>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_image_id?: InputMaybe<Scalars['uuid']['input']>;
  property_sources?: InputMaybe<Property_Source_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Agency_Max_Fields = {
  __typename?: 'agency_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name_norm?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_image_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "agency" */
export type Agency_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_norm?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  profile_image_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agency_Min_Fields = {
  __typename?: 'agency_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name_norm?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_image_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "agency" */
export type Agency_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_norm?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  profile_image_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agency" */
export type Agency_Mutation_Response = {
  __typename?: 'agency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Agency>;
};

/** input type for inserting object relation for remote table "agency" */
export type Agency_Obj_Rel_Insert_Input = {
  data: Agency_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Agency_On_Conflict>;
};

/** on_conflict condition type for table "agency" */
export type Agency_On_Conflict = {
  constraint: Agency_Constraint;
  update_columns?: Array<Agency_Update_Column>;
  where?: InputMaybe<Agency_Bool_Exp>;
};

/** Ordering options when selecting data from "agency". */
export type Agency_Order_By = {
  address?: InputMaybe<Order_By>;
  children_aggregate?: InputMaybe<Agency_Aggregate_Order_By>;
  contact_phone_numbers_aggregate?: InputMaybe<Contact_Phone_Number_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_norm?: InputMaybe<Order_By>;
  parent?: InputMaybe<Agency_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  profile_image_id?: InputMaybe<Order_By>;
  property_sources_aggregate?: InputMaybe<Property_Source_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agency */
export type Agency_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

export type Agency_Properties_Model = {
  __typename?: 'agency_properties_model';
  agency_name?: Maybe<Scalars['String']['output']>;
  total_properties?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the logical model for "agency_properties_model". All fields are combined with a logical 'AND'. */
export type Agency_Properties_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Agency_Properties_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Agency_Properties_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Agency_Properties_Model_Bool_Exp_Bool_Exp>>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  total_properties?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Agency_Properties_Model_Enum_Name {
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  TotalProperties = 'total_properties'
}

/** Ordering options when selecting data from "agency_properties_model". */
export type Agency_Properties_Model_Order_By = {
  agency_name?: InputMaybe<Order_By>;
  total_properties?: InputMaybe<Order_By>;
};

/** select columns of table "agency" */
export enum Agency_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameNorm = 'name_norm',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  ProfileImageId = 'profile_image_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Verified = 'verified'
}

/** select "agency_aggregate_bool_exp_bool_and_arguments_columns" columns of table "agency" */
export enum Agency_Select_Column_Agency_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Verified = 'verified'
}

/** select "agency_aggregate_bool_exp_bool_or_arguments_columns" columns of table "agency" */
export enum Agency_Select_Column_Agency_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "agency" */
export type Agency_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_norm?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_image_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "agency" */
export type Agency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agency_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_norm?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_image_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "agency_type" */
export type Agency_Type = {
  __typename?: 'agency_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "agency_type" */
export type Agency_Type_Aggregate = {
  __typename?: 'agency_type_aggregate';
  aggregate?: Maybe<Agency_Type_Aggregate_Fields>;
  nodes: Array<Agency_Type>;
};

/** aggregate fields of "agency_type" */
export type Agency_Type_Aggregate_Fields = {
  __typename?: 'agency_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Agency_Type_Max_Fields>;
  min?: Maybe<Agency_Type_Min_Fields>;
};


/** aggregate fields of "agency_type" */
export type Agency_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agency_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "agency_type". All fields are combined with a logical 'AND'. */
export type Agency_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Agency_Type_Bool_Exp>>;
  _not?: InputMaybe<Agency_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Agency_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "agency_type" */
export enum Agency_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  AgencyTypePkey = 'agency_type_pkey'
}

/** input type for inserting data into table "agency_type" */
export type Agency_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Agency_Type_Max_Fields = {
  __typename?: 'agency_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Agency_Type_Min_Fields = {
  __typename?: 'agency_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "agency_type" */
export type Agency_Type_Mutation_Response = {
  __typename?: 'agency_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Agency_Type>;
};

/** on_conflict condition type for table "agency_type" */
export type Agency_Type_On_Conflict = {
  constraint: Agency_Type_Constraint;
  update_columns?: Array<Agency_Type_Update_Column>;
  where?: InputMaybe<Agency_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "agency_type". */
export type Agency_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agency_type */
export type Agency_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "agency_type" */
export enum Agency_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "agency_type" */
export type Agency_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "agency_type" */
export type Agency_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agency_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agency_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "agency_type" */
export enum Agency_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Agency_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agency_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Agency_Type_Bool_Exp;
};

/** update columns of table "agency" */
export enum Agency_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameNorm = 'name_norm',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  ProfileImageId = 'profile_image_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Verified = 'verified'
}

export type Agency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agency_Set_Input>;
  /** filter the rows which have to be updated */
  where: Agency_Bool_Exp;
};

/** columns and relationships of "agent_action" */
export type Agent_Action = {
  __typename?: 'agent_action';
  action_type: Scalars['String']['output'];
  /** An object relationship */
  agent_user?: Maybe<Users>;
  agent_user_id?: Maybe<Scalars['uuid']['output']>;
  applied_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  execution_error?: Maybe<Scalars['String']['output']>;
  execution_status: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  idempotency_key: Scalars['String']['output'];
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  payload: Scalars['jsonb']['output'];
  /** An object relationship */
  task: Agent_Task;
  task_id: Scalars['uuid']['output'];
};


/** columns and relationships of "agent_action" */
export type Agent_ActionPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "agent_action" */
export type Agent_Action_Aggregate = {
  __typename?: 'agent_action_aggregate';
  aggregate?: Maybe<Agent_Action_Aggregate_Fields>;
  nodes: Array<Agent_Action>;
};

export type Agent_Action_Aggregate_Bool_Exp = {
  count?: InputMaybe<Agent_Action_Aggregate_Bool_Exp_Count>;
};

export type Agent_Action_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Agent_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Agent_Action_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "agent_action" */
export type Agent_Action_Aggregate_Fields = {
  __typename?: 'agent_action_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Agent_Action_Max_Fields>;
  min?: Maybe<Agent_Action_Min_Fields>;
};


/** aggregate fields of "agent_action" */
export type Agent_Action_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agent_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "agent_action" */
export type Agent_Action_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agent_Action_Max_Order_By>;
  min?: InputMaybe<Agent_Action_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Agent_Action_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "agent_action" */
export type Agent_Action_Arr_Rel_Insert_Input = {
  data: Array<Agent_Action_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agent_Action_On_Conflict>;
};

/** Boolean expression to filter rows from the table "agent_action". All fields are combined with a logical 'AND'. */
export type Agent_Action_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_Action_Bool_Exp>>;
  _not?: InputMaybe<Agent_Action_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_Action_Bool_Exp>>;
  action_type?: InputMaybe<String_Comparison_Exp>;
  agent_user?: InputMaybe<Users_Bool_Exp>;
  agent_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  applied_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  execution_error?: InputMaybe<String_Comparison_Exp>;
  execution_status?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idempotency_key?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  task?: InputMaybe<Agent_Task_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "agent_action" */
export enum Agent_Action_Constraint {
  /** unique or primary key constraint on columns "id" */
  AgentActionPkey = 'agent_action_pkey',
  /** unique or primary key constraint on columns "task_id", "action_type", "idempotency_key" */
  AgentActionTaskIdActionTypeIdempotencyKeyKey = 'agent_action_task_id_action_type_idempotency_key_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Agent_Action_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Agent_Action_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Agent_Action_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "agent_action" */
export type Agent_Action_Insert_Input = {
  action_type?: InputMaybe<Scalars['String']['input']>;
  agent_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  agent_user_id?: InputMaybe<Scalars['uuid']['input']>;
  applied_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  execution_error?: InputMaybe<Scalars['String']['input']>;
  execution_status?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idempotency_key?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  task?: InputMaybe<Agent_Task_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Agent_Action_Max_Fields = {
  __typename?: 'agent_action_max_fields';
  action_type?: Maybe<Scalars['String']['output']>;
  agent_user_id?: Maybe<Scalars['uuid']['output']>;
  applied_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  execution_error?: Maybe<Scalars['String']['output']>;
  execution_status?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idempotency_key?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "agent_action" */
export type Agent_Action_Max_Order_By = {
  action_type?: InputMaybe<Order_By>;
  agent_user_id?: InputMaybe<Order_By>;
  applied_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  execution_error?: InputMaybe<Order_By>;
  execution_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotency_key?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agent_Action_Min_Fields = {
  __typename?: 'agent_action_min_fields';
  action_type?: Maybe<Scalars['String']['output']>;
  agent_user_id?: Maybe<Scalars['uuid']['output']>;
  applied_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  execution_error?: Maybe<Scalars['String']['output']>;
  execution_status?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idempotency_key?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "agent_action" */
export type Agent_Action_Min_Order_By = {
  action_type?: InputMaybe<Order_By>;
  agent_user_id?: InputMaybe<Order_By>;
  applied_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  execution_error?: InputMaybe<Order_By>;
  execution_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotency_key?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agent_action" */
export type Agent_Action_Mutation_Response = {
  __typename?: 'agent_action_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Agent_Action>;
};

/** on_conflict condition type for table "agent_action" */
export type Agent_Action_On_Conflict = {
  constraint: Agent_Action_Constraint;
  update_columns?: Array<Agent_Action_Update_Column>;
  where?: InputMaybe<Agent_Action_Bool_Exp>;
};

/** Ordering options when selecting data from "agent_action". */
export type Agent_Action_Order_By = {
  action_type?: InputMaybe<Order_By>;
  agent_user?: InputMaybe<Users_Order_By>;
  agent_user_id?: InputMaybe<Order_By>;
  applied_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  execution_error?: InputMaybe<Order_By>;
  execution_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotency_key?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  task?: InputMaybe<Agent_Task_Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agent_action */
export type Agent_Action_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Agent_Action_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "agent_action" */
export enum Agent_Action_Select_Column {
  /** column name */
  ActionType = 'action_type',
  /** column name */
  AgentUserId = 'agent_user_id',
  /** column name */
  AppliedAt = 'applied_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExecutionError = 'execution_error',
  /** column name */
  ExecutionStatus = 'execution_status',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotencyKey = 'idempotency_key',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Payload = 'payload',
  /** column name */
  TaskId = 'task_id'
}

/** input type for updating data in table "agent_action" */
export type Agent_Action_Set_Input = {
  action_type?: InputMaybe<Scalars['String']['input']>;
  agent_user_id?: InputMaybe<Scalars['uuid']['input']>;
  applied_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  execution_error?: InputMaybe<Scalars['String']['input']>;
  execution_status?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idempotency_key?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "agent_action" */
export type Agent_Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_Action_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_Action_Stream_Cursor_Value_Input = {
  action_type?: InputMaybe<Scalars['String']['input']>;
  agent_user_id?: InputMaybe<Scalars['uuid']['input']>;
  applied_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  execution_error?: InputMaybe<Scalars['String']['input']>;
  execution_status?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idempotency_key?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "agent_action" */
export enum Agent_Action_Update_Column {
  /** column name */
  ActionType = 'action_type',
  /** column name */
  AgentUserId = 'agent_user_id',
  /** column name */
  AppliedAt = 'applied_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExecutionError = 'execution_error',
  /** column name */
  ExecutionStatus = 'execution_status',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotencyKey = 'idempotency_key',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Payload = 'payload',
  /** column name */
  TaskId = 'task_id'
}

export type Agent_Action_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Agent_Action_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Agent_Action_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Agent_Action_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Agent_Action_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Agent_Action_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agent_Action_Set_Input>;
  /** filter the rows which have to be updated */
  where: Agent_Action_Bool_Exp;
};

/** columns and relationships of "agent_task" */
export type Agent_Task = {
  __typename?: 'agent_task';
  /** An array relationship */
  actions: Array<Agent_Action>;
  /** An aggregate relationship */
  actions_aggregate: Agent_Action_Aggregate;
  /** An object relationship */
  assignee_user?: Maybe<Users>;
  assignee_user_id?: Maybe<Scalars['uuid']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone: Scalars['String']['output'];
  context_messages: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  dedup_key: Scalars['String']['output'];
  evolution_instance?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  metadata: Scalars['jsonb']['output'];
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  organization_lead?: Maybe<Organization_Leads>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  preferred_time_text?: Maybe<Scalars['String']['output']>;
  priority: Scalars['String']['output'];
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_title?: Maybe<Scalars['String']['output']>;
  property_url?: Maybe<Scalars['String']['output']>;
  question_text?: Maybe<Scalars['String']['output']>;
  resolved_at?: Maybe<Scalars['timestamptz']['output']>;
  source_message_id?: Maybe<Scalars['String']['output']>;
  source_turn_id?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  task_type: Scalars['String']['output'];
  /** An object relationship */
  thread?: Maybe<Search_Sessions>;
  thread_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "agent_task" */
export type Agent_TaskActionsArgs = {
  distinct_on?: InputMaybe<Array<Agent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Action_Order_By>>;
  where?: InputMaybe<Agent_Action_Bool_Exp>;
};


/** columns and relationships of "agent_task" */
export type Agent_TaskActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Action_Order_By>>;
  where?: InputMaybe<Agent_Action_Bool_Exp>;
};


/** columns and relationships of "agent_task" */
export type Agent_TaskContext_MessagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "agent_task" */
export type Agent_TaskMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "agent_task" */
export type Agent_Task_Aggregate = {
  __typename?: 'agent_task_aggregate';
  aggregate?: Maybe<Agent_Task_Aggregate_Fields>;
  nodes: Array<Agent_Task>;
};

export type Agent_Task_Aggregate_Bool_Exp = {
  count?: InputMaybe<Agent_Task_Aggregate_Bool_Exp_Count>;
};

export type Agent_Task_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Agent_Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Agent_Task_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "agent_task" */
export type Agent_Task_Aggregate_Fields = {
  __typename?: 'agent_task_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Agent_Task_Max_Fields>;
  min?: Maybe<Agent_Task_Min_Fields>;
};


/** aggregate fields of "agent_task" */
export type Agent_Task_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agent_Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "agent_task" */
export type Agent_Task_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agent_Task_Max_Order_By>;
  min?: InputMaybe<Agent_Task_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Agent_Task_Append_Input = {
  context_messages?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "agent_task" */
export type Agent_Task_Arr_Rel_Insert_Input = {
  data: Array<Agent_Task_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agent_Task_On_Conflict>;
};

/** Boolean expression to filter rows from the table "agent_task". All fields are combined with a logical 'AND'. */
export type Agent_Task_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_Task_Bool_Exp>>;
  _not?: InputMaybe<Agent_Task_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_Task_Bool_Exp>>;
  actions?: InputMaybe<Agent_Action_Bool_Exp>;
  actions_aggregate?: InputMaybe<Agent_Action_Aggregate_Bool_Exp>;
  assignee_user?: InputMaybe<Users_Bool_Exp>;
  assignee_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact_name?: InputMaybe<String_Comparison_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  context_messages?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  dedup_key?: InputMaybe<String_Comparison_Exp>;
  evolution_instance?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_lead?: InputMaybe<Organization_Leads_Bool_Exp>;
  organization_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  preferred_time_text?: InputMaybe<String_Comparison_Exp>;
  priority?: InputMaybe<String_Comparison_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_title?: InputMaybe<String_Comparison_Exp>;
  property_url?: InputMaybe<String_Comparison_Exp>;
  question_text?: InputMaybe<String_Comparison_Exp>;
  resolved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  source_message_id?: InputMaybe<String_Comparison_Exp>;
  source_turn_id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  task_type?: InputMaybe<String_Comparison_Exp>;
  thread?: InputMaybe<Search_Sessions_Bool_Exp>;
  thread_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "agent_task" */
export enum Agent_Task_Constraint {
  /** unique or primary key constraint on columns "dedup_key" */
  AgentTaskDedupKeyKey = 'agent_task_dedup_key_key',
  /** unique or primary key constraint on columns "id" */
  AgentTaskPkey = 'agent_task_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Agent_Task_Delete_At_Path_Input = {
  context_messages?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Agent_Task_Delete_Elem_Input = {
  context_messages?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Agent_Task_Delete_Key_Input = {
  context_messages?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "agent_task" */
export type Agent_Task_Insert_Input = {
  actions?: InputMaybe<Agent_Action_Arr_Rel_Insert_Input>;
  assignee_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  assignee_user_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  context_messages?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  dedup_key?: InputMaybe<Scalars['String']['input']>;
  evolution_instance?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_lead?: InputMaybe<Organization_Leads_Obj_Rel_Insert_Input>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  preferred_time_text?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_title?: InputMaybe<Scalars['String']['input']>;
  property_url?: InputMaybe<Scalars['String']['input']>;
  question_text?: InputMaybe<Scalars['String']['input']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  source_message_id?: InputMaybe<Scalars['String']['input']>;
  source_turn_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  task_type?: InputMaybe<Scalars['String']['input']>;
  thread?: InputMaybe<Search_Sessions_Obj_Rel_Insert_Input>;
  thread_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Agent_Task_Max_Fields = {
  __typename?: 'agent_task_max_fields';
  assignee_user_id?: Maybe<Scalars['uuid']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  dedup_key?: Maybe<Scalars['String']['output']>;
  evolution_instance?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  preferred_time_text?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_title?: Maybe<Scalars['String']['output']>;
  property_url?: Maybe<Scalars['String']['output']>;
  question_text?: Maybe<Scalars['String']['output']>;
  resolved_at?: Maybe<Scalars['timestamptz']['output']>;
  source_message_id?: Maybe<Scalars['String']['output']>;
  source_turn_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  task_type?: Maybe<Scalars['String']['output']>;
  thread_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "agent_task" */
export type Agent_Task_Max_Order_By = {
  assignee_user_id?: InputMaybe<Order_By>;
  contact_name?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  dedup_key?: InputMaybe<Order_By>;
  evolution_instance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_lead_id?: InputMaybe<Order_By>;
  preferred_time_text?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_title?: InputMaybe<Order_By>;
  property_url?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  source_message_id?: InputMaybe<Order_By>;
  source_turn_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  task_type?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agent_Task_Min_Fields = {
  __typename?: 'agent_task_min_fields';
  assignee_user_id?: Maybe<Scalars['uuid']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  dedup_key?: Maybe<Scalars['String']['output']>;
  evolution_instance?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  preferred_time_text?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_title?: Maybe<Scalars['String']['output']>;
  property_url?: Maybe<Scalars['String']['output']>;
  question_text?: Maybe<Scalars['String']['output']>;
  resolved_at?: Maybe<Scalars['timestamptz']['output']>;
  source_message_id?: Maybe<Scalars['String']['output']>;
  source_turn_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  task_type?: Maybe<Scalars['String']['output']>;
  thread_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "agent_task" */
export type Agent_Task_Min_Order_By = {
  assignee_user_id?: InputMaybe<Order_By>;
  contact_name?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  dedup_key?: InputMaybe<Order_By>;
  evolution_instance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_lead_id?: InputMaybe<Order_By>;
  preferred_time_text?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_title?: InputMaybe<Order_By>;
  property_url?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  source_message_id?: InputMaybe<Order_By>;
  source_turn_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  task_type?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agent_task" */
export type Agent_Task_Mutation_Response = {
  __typename?: 'agent_task_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Agent_Task>;
};

/** input type for inserting object relation for remote table "agent_task" */
export type Agent_Task_Obj_Rel_Insert_Input = {
  data: Agent_Task_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Agent_Task_On_Conflict>;
};

/** on_conflict condition type for table "agent_task" */
export type Agent_Task_On_Conflict = {
  constraint: Agent_Task_Constraint;
  update_columns?: Array<Agent_Task_Update_Column>;
  where?: InputMaybe<Agent_Task_Bool_Exp>;
};

/** Ordering options when selecting data from "agent_task". */
export type Agent_Task_Order_By = {
  actions_aggregate?: InputMaybe<Agent_Action_Aggregate_Order_By>;
  assignee_user?: InputMaybe<Users_Order_By>;
  assignee_user_id?: InputMaybe<Order_By>;
  contact_name?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  context_messages?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  dedup_key?: InputMaybe<Order_By>;
  evolution_instance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_lead?: InputMaybe<Organization_Leads_Order_By>;
  organization_lead_id?: InputMaybe<Order_By>;
  preferred_time_text?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_title?: InputMaybe<Order_By>;
  property_url?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  source_message_id?: InputMaybe<Order_By>;
  source_turn_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  task_type?: InputMaybe<Order_By>;
  thread?: InputMaybe<Search_Sessions_Order_By>;
  thread_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agent_task */
export type Agent_Task_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Agent_Task_Prepend_Input = {
  context_messages?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "agent_task" */
export enum Agent_Task_Select_Column {
  /** column name */
  AssigneeUserId = 'assignee_user_id',
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContextMessages = 'context_messages',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DedupKey = 'dedup_key',
  /** column name */
  EvolutionInstance = 'evolution_instance',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationLeadId = 'organization_lead_id',
  /** column name */
  PreferredTimeText = 'preferred_time_text',
  /** column name */
  Priority = 'priority',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyTitle = 'property_title',
  /** column name */
  PropertyUrl = 'property_url',
  /** column name */
  QuestionText = 'question_text',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  SourceMessageId = 'source_message_id',
  /** column name */
  SourceTurnId = 'source_turn_id',
  /** column name */
  Status = 'status',
  /** column name */
  TaskType = 'task_type',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "agent_task" */
export type Agent_Task_Set_Input = {
  assignee_user_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  context_messages?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  dedup_key?: InputMaybe<Scalars['String']['input']>;
  evolution_instance?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  preferred_time_text?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_title?: InputMaybe<Scalars['String']['input']>;
  property_url?: InputMaybe<Scalars['String']['input']>;
  question_text?: InputMaybe<Scalars['String']['input']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  source_message_id?: InputMaybe<Scalars['String']['input']>;
  source_turn_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  task_type?: InputMaybe<Scalars['String']['input']>;
  thread_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "agent_task" */
export type Agent_Task_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_Task_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_Task_Stream_Cursor_Value_Input = {
  assignee_user_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  context_messages?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  dedup_key?: InputMaybe<Scalars['String']['input']>;
  evolution_instance?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  preferred_time_text?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_title?: InputMaybe<Scalars['String']['input']>;
  property_url?: InputMaybe<Scalars['String']['input']>;
  question_text?: InputMaybe<Scalars['String']['input']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  source_message_id?: InputMaybe<Scalars['String']['input']>;
  source_turn_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  task_type?: InputMaybe<Scalars['String']['input']>;
  thread_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "agent_task" */
export enum Agent_Task_Update_Column {
  /** column name */
  AssigneeUserId = 'assignee_user_id',
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContextMessages = 'context_messages',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DedupKey = 'dedup_key',
  /** column name */
  EvolutionInstance = 'evolution_instance',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationLeadId = 'organization_lead_id',
  /** column name */
  PreferredTimeText = 'preferred_time_text',
  /** column name */
  Priority = 'priority',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyTitle = 'property_title',
  /** column name */
  PropertyUrl = 'property_url',
  /** column name */
  QuestionText = 'question_text',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  SourceMessageId = 'source_message_id',
  /** column name */
  SourceTurnId = 'source_turn_id',
  /** column name */
  Status = 'status',
  /** column name */
  TaskType = 'task_type',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Agent_Task_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Agent_Task_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Agent_Task_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Agent_Task_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Agent_Task_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Agent_Task_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agent_Task_Set_Input>;
  /** filter the rows which have to be updated */
  where: Agent_Task_Bool_Exp;
};

/** columns and relationships of "amenities" */
export type Amenities = {
  __typename?: 'amenities';
  amenity: Scalars['String']['output'];
};

/** aggregated selection of "amenities" */
export type Amenities_Aggregate = {
  __typename?: 'amenities_aggregate';
  aggregate?: Maybe<Amenities_Aggregate_Fields>;
  nodes: Array<Amenities>;
};

/** aggregate fields of "amenities" */
export type Amenities_Aggregate_Fields = {
  __typename?: 'amenities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Amenities_Max_Fields>;
  min?: Maybe<Amenities_Min_Fields>;
};


/** aggregate fields of "amenities" */
export type Amenities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Amenities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "amenities". All fields are combined with a logical 'AND'. */
export type Amenities_Bool_Exp = {
  _and?: InputMaybe<Array<Amenities_Bool_Exp>>;
  _not?: InputMaybe<Amenities_Bool_Exp>;
  _or?: InputMaybe<Array<Amenities_Bool_Exp>>;
  amenity?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "amenities" */
export enum Amenities_Constraint {
  /** unique or primary key constraint on columns "amenity" */
  AmenitiesPkey = 'amenities_pkey'
}

export enum Amenities_Enum {
  Gym = 'gym'
}

/** Boolean expression to compare columns of type "amenities_enum". All fields are combined with logical 'AND'. */
export type Amenities_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Amenities_Enum>;
  _in?: InputMaybe<Array<Amenities_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Amenities_Enum>;
  _nin?: InputMaybe<Array<Amenities_Enum>>;
};

/** input type for inserting data into table "amenities" */
export type Amenities_Insert_Input = {
  amenity?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Amenities_Max_Fields = {
  __typename?: 'amenities_max_fields';
  amenity?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Amenities_Min_Fields = {
  __typename?: 'amenities_min_fields';
  amenity?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "amenities" */
export type Amenities_Mutation_Response = {
  __typename?: 'amenities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Amenities>;
};

/** on_conflict condition type for table "amenities" */
export type Amenities_On_Conflict = {
  constraint: Amenities_Constraint;
  update_columns?: Array<Amenities_Update_Column>;
  where?: InputMaybe<Amenities_Bool_Exp>;
};

/** Ordering options when selecting data from "amenities". */
export type Amenities_Order_By = {
  amenity?: InputMaybe<Order_By>;
};

/** primary key columns input for table: amenities */
export type Amenities_Pk_Columns_Input = {
  amenity: Scalars['String']['input'];
};

/** select columns of table "amenities" */
export enum Amenities_Select_Column {
  /** column name */
  Amenity = 'amenity'
}

/** input type for updating data in table "amenities" */
export type Amenities_Set_Input = {
  amenity?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "amenities" */
export type Amenities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Amenities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Amenities_Stream_Cursor_Value_Input = {
  amenity?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "amenities" */
export enum Amenities_Update_Column {
  /** column name */
  Amenity = 'amenity'
}

export type Amenities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Amenities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Amenities_Bool_Exp;
};

/** columns and relationships of "app_config" */
export type App_Config = {
  __typename?: 'app_config';
  min_version: Scalars['String']['output'];
  platform: Scalars['String']['output'];
};

/** aggregated selection of "app_config" */
export type App_Config_Aggregate = {
  __typename?: 'app_config_aggregate';
  aggregate?: Maybe<App_Config_Aggregate_Fields>;
  nodes: Array<App_Config>;
};

/** aggregate fields of "app_config" */
export type App_Config_Aggregate_Fields = {
  __typename?: 'app_config_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Config_Max_Fields>;
  min?: Maybe<App_Config_Min_Fields>;
};


/** aggregate fields of "app_config" */
export type App_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "app_config". All fields are combined with a logical 'AND'. */
export type App_Config_Bool_Exp = {
  _and?: InputMaybe<Array<App_Config_Bool_Exp>>;
  _not?: InputMaybe<App_Config_Bool_Exp>;
  _or?: InputMaybe<Array<App_Config_Bool_Exp>>;
  min_version?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "app_config" */
export enum App_Config_Constraint {
  /** unique or primary key constraint on columns "platform" */
  AppConfigPkey = 'app_config_pkey'
}

/** input type for inserting data into table "app_config" */
export type App_Config_Insert_Input = {
  min_version?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Config_Max_Fields = {
  __typename?: 'app_config_max_fields';
  min_version?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Config_Min_Fields = {
  __typename?: 'app_config_min_fields';
  min_version?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "app_config" */
export type App_Config_Mutation_Response = {
  __typename?: 'app_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Config>;
};

/** on_conflict condition type for table "app_config" */
export type App_Config_On_Conflict = {
  constraint: App_Config_Constraint;
  update_columns?: Array<App_Config_Update_Column>;
  where?: InputMaybe<App_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "app_config". */
export type App_Config_Order_By = {
  min_version?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
};

/** primary key columns input for table: app_config */
export type App_Config_Pk_Columns_Input = {
  platform: Scalars['String']['input'];
};

/** select columns of table "app_config" */
export enum App_Config_Select_Column {
  /** column name */
  MinVersion = 'min_version',
  /** column name */
  Platform = 'platform'
}

/** input type for updating data in table "app_config" */
export type App_Config_Set_Input = {
  min_version?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "app_config" */
export type App_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Config_Stream_Cursor_Value_Input = {
  min_version?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "app_config" */
export enum App_Config_Update_Column {
  /** column name */
  MinVersion = 'min_version',
  /** column name */
  Platform = 'platform'
}

export type App_Config_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Config_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Config_Bool_Exp;
};

export type Approve_Place_Reference_Proposal_Args = {
  proposal_id?: InputMaybe<Scalars['uuid']['input']>;
  reviewer?: InputMaybe<Scalars['String']['input']>;
};

/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequests = {
  __typename?: 'authProviderRequests';
  id: Scalars['uuid']['output'];
  options?: Maybe<Scalars['jsonb']['output']>;
};


/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequestsOptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate = {
  __typename?: 'authProviderRequests_aggregate';
  aggregate?: Maybe<AuthProviderRequests_Aggregate_Fields>;
  nodes: Array<AuthProviderRequests>;
};

/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_Fields = {
  __typename?: 'authProviderRequests_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthProviderRequests_Max_Fields>;
  min?: Maybe<AuthProviderRequests_Min_Fields>;
};


/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "auth.provider_requests". All fields are combined with a logical 'AND'. */
export type AuthProviderRequests_Bool_Exp = {
  _and?: InputMaybe<Array<AuthProviderRequests_Bool_Exp>>;
  _not?: InputMaybe<AuthProviderRequests_Bool_Exp>;
  _or?: InputMaybe<Array<AuthProviderRequests_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.provider_requests" */
export enum AuthProviderRequests_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderRequestsPkey = 'provider_requests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthProviderRequests_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthProviderRequests_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthProviderRequests_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.provider_requests" */
export type AuthProviderRequests_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type AuthProviderRequests_Max_Fields = {
  __typename?: 'authProviderRequests_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type AuthProviderRequests_Min_Fields = {
  __typename?: 'authProviderRequests_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "auth.provider_requests" */
export type AuthProviderRequests_Mutation_Response = {
  __typename?: 'authProviderRequests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviderRequests>;
};

/** on_conflict condition type for table "auth.provider_requests" */
export type AuthProviderRequests_On_Conflict = {
  constraint: AuthProviderRequests_Constraint;
  update_columns?: Array<AuthProviderRequests_Update_Column>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.provider_requests". */
export type AuthProviderRequests_Order_By = {
  id?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.provider_requests */
export type AuthProviderRequests_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

/** input type for updating data in table "auth.provider_requests" */
export type AuthProviderRequests_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "authProviderRequests" */
export type AuthProviderRequests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviderRequests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviderRequests_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

export type AuthProviderRequests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthProviderRequests_Bool_Exp;
};

/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviders = {
  __typename?: 'authProviders';
  id: Scalars['String']['output'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};

/** aggregated selection of "auth.providers" */
export type AuthProviders_Aggregate = {
  __typename?: 'authProviders_aggregate';
  aggregate?: Maybe<AuthProviders_Aggregate_Fields>;
  nodes: Array<AuthProviders>;
};

/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_Fields = {
  __typename?: 'authProviders_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthProviders_Max_Fields>;
  min?: Maybe<AuthProviders_Min_Fields>;
};


/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export type AuthProviders_Bool_Exp = {
  _and?: InputMaybe<Array<AuthProviders_Bool_Exp>>;
  _not?: InputMaybe<AuthProviders_Bool_Exp>;
  _or?: InputMaybe<Array<AuthProviders_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.providers" */
export enum AuthProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProvidersPkey = 'providers_pkey'
}

/** input type for inserting data into table "auth.providers" */
export type AuthProviders_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AuthProviders_Max_Fields = {
  __typename?: 'authProviders_max_fields';
  id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthProviders_Min_Fields = {
  __typename?: 'authProviders_min_fields';
  id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.providers" */
export type AuthProviders_Mutation_Response = {
  __typename?: 'authProviders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviders>;
};

/** input type for inserting object relation for remote table "auth.providers" */
export type AuthProviders_Obj_Rel_Insert_Input = {
  data: AuthProviders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};

/** on_conflict condition type for table "auth.providers" */
export type AuthProviders_On_Conflict = {
  constraint: AuthProviders_Constraint;
  update_columns?: Array<AuthProviders_Update_Column>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.providers". */
export type AuthProviders_Order_By = {
  id?: InputMaybe<Order_By>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.providers */
export type AuthProviders_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "auth.providers" */
export enum AuthProviders_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "auth.providers" */
export type AuthProviders_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authProviders" */
export type AuthProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviders_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.providers" */
export enum AuthProviders_Update_Column {
  /** column name */
  Id = 'id'
}

export type AuthProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviders_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthProviders_Bool_Exp;
};

/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes = {
  __typename?: 'authRefreshTokenTypes';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

/** aggregated selection of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate = {
  __typename?: 'authRefreshTokenTypes_aggregate';
  aggregate?: Maybe<AuthRefreshTokenTypes_Aggregate_Fields>;
  nodes: Array<AuthRefreshTokenTypes>;
};

/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_Fields = {
  __typename?: 'authRefreshTokenTypes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRefreshTokenTypes_Max_Fields>;
  min?: Maybe<AuthRefreshTokenTypes_Min_Fields>;
};


/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.refresh_token_types". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokenTypes_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp>>;
  _not?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Constraint {
  /** unique or primary key constraint on columns "value" */
  RefreshTokenTypesPkey = 'refresh_token_types_pkey'
}

export enum AuthRefreshTokenTypes_Enum {
  /** Personal access token */
  Pat = 'pat',
  /** Regular refresh token */
  Regular = 'regular'
}

/** Boolean expression to compare columns of type "authRefreshTokenTypes_enum". All fields are combined with logical 'AND'. */
export type AuthRefreshTokenTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  _in?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  _nin?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>;
};

/** input type for inserting data into table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AuthRefreshTokenTypes_Max_Fields = {
  __typename?: 'authRefreshTokenTypes_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthRefreshTokenTypes_Min_Fields = {
  __typename?: 'authRefreshTokenTypes_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Mutation_Response = {
  __typename?: 'authRefreshTokenTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokenTypes>;
};

/** on_conflict condition type for table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_On_Conflict = {
  constraint: AuthRefreshTokenTypes_Constraint;
  update_columns?: Array<AuthRefreshTokenTypes_Update_Column>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.refresh_token_types". */
export type AuthRefreshTokenTypes_Order_By = {
  comment?: InputMaybe<Order_By>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.refresh_token_types */
export type AuthRefreshTokenTypes_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authRefreshTokenTypes" */
export type AuthRefreshTokenTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokenTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokenTypes_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type AuthRefreshTokenTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRefreshTokenTypes_Bool_Exp;
};

/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokens = {
  __typename?: 'authRefreshTokens';
  createdAt: Scalars['timestamptz']['output'];
  expiresAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  type: AuthRefreshTokenTypes_Enum;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};


/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokensMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate = {
  __typename?: 'authRefreshTokens_aggregate';
  aggregate?: Maybe<AuthRefreshTokens_Aggregate_Fields>;
  nodes: Array<AuthRefreshTokens>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp_Count>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Fields = {
  __typename?: 'authRefreshTokens_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRefreshTokens_Max_Fields>;
  min?: Maybe<AuthRefreshTokens_Min_Fields>;
};


/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthRefreshTokens_Max_Order_By>;
  min?: InputMaybe<AuthRefreshTokens_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export type AuthRefreshTokens_Arr_Rel_Insert_Input = {
  data: Array<AuthRefreshTokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokens_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>;
  _not?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  refreshTokenHash?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  RefreshTokensPkey = 'refresh_tokens_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthRefreshTokens_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthRefreshTokens_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthRefreshTokens_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.refresh_tokens" */
export type AuthRefreshTokens_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthRefreshTokens_Max_Fields = {
  __typename?: 'authRefreshTokens_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthRefreshTokens_Min_Fields = {
  __typename?: 'authRefreshTokens_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.refresh_tokens" */
export type AuthRefreshTokens_Mutation_Response = {
  __typename?: 'authRefreshTokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokens>;
};

/** on_conflict condition type for table "auth.refresh_tokens" */
export type AuthRefreshTokens_On_Conflict = {
  constraint: AuthRefreshTokens_Constraint;
  update_columns?: Array<AuthRefreshTokens_Update_Column>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type AuthRefreshTokens_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.refresh_tokens */
export type AuthRefreshTokens_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RefreshTokenHash = 'refreshTokenHash',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.refresh_tokens" */
export type AuthRefreshTokens_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authRefreshTokens" */
export type AuthRefreshTokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokens_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RefreshTokenHash = 'refreshTokenHash',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

export type AuthRefreshTokens_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRefreshTokens_Bool_Exp;
};

/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRoles = {
  __typename?: 'authRoles';
  role: Scalars['String']['output'];
  /** An array relationship */
  userRoles: Array<AuthUserRoles>;
  /** An aggregate relationship */
  userRoles_aggregate: AuthUserRoles_Aggregate;
  /** An array relationship */
  usersByDefaultRole: Array<Users>;
  /** An aggregate relationship */
  usersByDefaultRole_aggregate: Users_Aggregate;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRoleArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "auth.roles" */
export type AuthRoles_Aggregate = {
  __typename?: 'authRoles_aggregate';
  aggregate?: Maybe<AuthRoles_Aggregate_Fields>;
  nodes: Array<AuthRoles>;
};

/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_Fields = {
  __typename?: 'authRoles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRoles_Max_Fields>;
  min?: Maybe<AuthRoles_Min_Fields>;
};


/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export type AuthRoles_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRoles_Bool_Exp>>;
  _not?: InputMaybe<AuthRoles_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRoles_Bool_Exp>>;
  role?: InputMaybe<String_Comparison_Exp>;
  userRoles?: InputMaybe<AuthUserRoles_Bool_Exp>;
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp>;
  usersByDefaultRole?: InputMaybe<Users_Bool_Exp>;
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.roles" */
export enum AuthRoles_Constraint {
  /** unique or primary key constraint on columns "role" */
  RolesPkey = 'roles_pkey'
}

export enum AuthRoles_Enum {
  Agency = 'AGENCY',
  Investor = 'INVESTOR',
  Lister = 'LISTER',
  Seeker = 'SEEKER',
  SeoAdmin = 'SEO_ADMIN',
  Admin = 'admin',
  Anonymous = 'anonymous',
  Me = 'me',
  Public = 'public',
  User = 'user'
}

/** Boolean expression to compare columns of type "authRoles_enum". All fields are combined with logical 'AND'. */
export type AuthRoles_Enum_Comparison_Exp = {
  _eq?: InputMaybe<AuthRoles_Enum>;
  _in?: InputMaybe<Array<AuthRoles_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AuthRoles_Enum>;
  _nin?: InputMaybe<Array<AuthRoles_Enum>>;
};

/** input type for inserting data into table "auth.roles" */
export type AuthRoles_Insert_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
  userRoles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input>;
  usersByDefaultRole?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AuthRoles_Max_Fields = {
  __typename?: 'authRoles_max_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthRoles_Min_Fields = {
  __typename?: 'authRoles_min_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.roles" */
export type AuthRoles_Mutation_Response = {
  __typename?: 'authRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRoles>;
};

/** input type for inserting object relation for remote table "auth.roles" */
export type AuthRoles_Obj_Rel_Insert_Input = {
  data: AuthRoles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};

/** on_conflict condition type for table "auth.roles" */
export type AuthRoles_On_Conflict = {
  constraint: AuthRoles_Constraint;
  update_columns?: Array<AuthRoles_Update_Column>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.roles". */
export type AuthRoles_Order_By = {
  role?: InputMaybe<Order_By>;
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By>;
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.roles */
export type AuthRoles_Pk_Columns_Input = {
  role: Scalars['String']['input'];
};

/** select columns of table "auth.roles" */
export enum AuthRoles_Select_Column {
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "auth.roles" */
export type AuthRoles_Set_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authRoles" */
export type AuthRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRoles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRoles_Stream_Cursor_Value_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.roles" */
export enum AuthRoles_Update_Column {
  /** column name */
  Role = 'role'
}

export type AuthRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRoles_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRoles_Bool_Exp;
};

/** Active providers for a given user. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserProviders = {
  __typename?: 'authUserProviders';
  accessToken: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  provider: AuthProviders;
  providerId: Scalars['String']['output'];
  providerUserId: Scalars['String']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_providers" */
export type AuthUserProviders_Aggregate = {
  __typename?: 'authUserProviders_aggregate';
  aggregate?: Maybe<AuthUserProviders_Aggregate_Fields>;
  nodes: Array<AuthUserProviders>;
};

export type AuthUserProviders_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp_Count>;
};

export type AuthUserProviders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserProviders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_Fields = {
  __typename?: 'authUserProviders_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserProviders_Max_Fields>;
  min?: Maybe<AuthUserProviders_Min_Fields>;
};


/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_providers" */
export type AuthUserProviders_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserProviders_Max_Order_By>;
  min?: InputMaybe<AuthUserProviders_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_providers" */
export type AuthUserProviders_Arr_Rel_Insert_Input = {
  data: Array<AuthUserProviders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_providers". All fields are combined with a logical 'AND'. */
export type AuthUserProviders_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserProviders_Bool_Exp>>;
  _not?: InputMaybe<AuthUserProviders_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserProviders_Bool_Exp>>;
  accessToken?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<AuthProviders_Bool_Exp>;
  providerId?: InputMaybe<String_Comparison_Exp>;
  providerUserId?: InputMaybe<String_Comparison_Exp>;
  refreshToken?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_providers" */
export enum AuthUserProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProvidersPkey = 'user_providers_pkey',
  /** unique or primary key constraint on columns "provider_user_id", "provider_id" */
  UserProvidersProviderIdProviderUserIdKey = 'user_providers_provider_id_provider_user_id_key'
}

/** input type for inserting data into table "auth.user_providers" */
export type AuthUserProviders_Insert_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<AuthProviders_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserProviders_Max_Fields = {
  __typename?: 'authUserProviders_max_fields';
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_providers" */
export type AuthUserProviders_Max_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserProviders_Min_Fields = {
  __typename?: 'authUserProviders_min_fields';
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_providers" */
export type AuthUserProviders_Min_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_providers" */
export type AuthUserProviders_Mutation_Response = {
  __typename?: 'authUserProviders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserProviders>;
};

/** on_conflict condition type for table "auth.user_providers" */
export type AuthUserProviders_On_Conflict = {
  constraint: AuthUserProviders_Constraint;
  update_columns?: Array<AuthUserProviders_Update_Column>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_providers". */
export type AuthUserProviders_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<AuthProviders_Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_providers */
export type AuthUserProviders_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_providers" */
export enum AuthUserProviders_Select_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_providers" */
export type AuthUserProviders_Set_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authUserProviders" */
export type AuthUserProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserProviders_Stream_Cursor_Value_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.user_providers" */
export enum AuthUserProviders_Update_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type AuthUserProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserProviders_Bool_Exp;
};

/** Roles of users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserRoles = {
  __typename?: 'authUserRoles';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  role: AuthRoles_Enum;
  /** An object relationship */
  roleByRole: AuthRoles;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_roles" */
export type AuthUserRoles_Aggregate = {
  __typename?: 'authUserRoles_aggregate';
  aggregate?: Maybe<AuthUserRoles_Aggregate_Fields>;
  nodes: Array<AuthUserRoles>;
};

export type AuthUserRoles_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp_Count>;
};

export type AuthUserRoles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserRoles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_Fields = {
  __typename?: 'authUserRoles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserRoles_Max_Fields>;
  min?: Maybe<AuthUserRoles_Min_Fields>;
};


/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_roles" */
export type AuthUserRoles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserRoles_Max_Order_By>;
  min?: InputMaybe<AuthUserRoles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_roles" */
export type AuthUserRoles_Arr_Rel_Insert_Input = {
  data: Array<AuthUserRoles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_roles". All fields are combined with a logical 'AND'. */
export type AuthUserRoles_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserRoles_Bool_Exp>>;
  _not?: InputMaybe<AuthUserRoles_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserRoles_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<AuthRoles_Enum_Comparison_Exp>;
  roleByRole?: InputMaybe<AuthRoles_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_roles" */
export enum AuthUserRoles_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserRolesPkey = 'user_roles_pkey',
  /** unique or primary key constraint on columns "user_id", "role" */
  UserRolesUserIdRoleKey = 'user_roles_user_id_role_key'
}

/** input type for inserting data into table "auth.user_roles" */
export type AuthUserRoles_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<AuthRoles_Enum>;
  roleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserRoles_Max_Fields = {
  __typename?: 'authUserRoles_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_roles" */
export type AuthUserRoles_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserRoles_Min_Fields = {
  __typename?: 'authUserRoles_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_roles" */
export type AuthUserRoles_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_roles" */
export type AuthUserRoles_Mutation_Response = {
  __typename?: 'authUserRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserRoles>;
};

/** on_conflict condition type for table "auth.user_roles" */
export type AuthUserRoles_On_Conflict = {
  constraint: AuthUserRoles_Constraint;
  update_columns?: Array<AuthUserRoles_Update_Column>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_roles". */
export type AuthUserRoles_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  roleByRole?: InputMaybe<AuthRoles_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_roles */
export type AuthUserRoles_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_roles" */
export enum AuthUserRoles_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_roles" */
export type AuthUserRoles_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<AuthRoles_Enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authUserRoles" */
export type AuthUserRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserRoles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserRoles_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<AuthRoles_Enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.user_roles" */
export enum AuthUserRoles_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

export type AuthUserRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserRoles_Bool_Exp;
};

/** User webauthn security keys. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserSecurityKeys = {
  __typename?: 'authUserSecurityKeys';
  counter: Scalars['bigint']['output'];
  credentialId: Scalars['String']['output'];
  credentialPublicKey?: Maybe<Scalars['bytea']['output']>;
  id: Scalars['uuid']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  transports: Scalars['String']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate = {
  __typename?: 'authUserSecurityKeys_aggregate';
  aggregate?: Maybe<AuthUserSecurityKeys_Aggregate_Fields>;
  nodes: Array<AuthUserSecurityKeys>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp_Count>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Fields = {
  __typename?: 'authUserSecurityKeys_aggregate_fields';
  avg?: Maybe<AuthUserSecurityKeys_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserSecurityKeys_Max_Fields>;
  min?: Maybe<AuthUserSecurityKeys_Min_Fields>;
  stddev?: Maybe<AuthUserSecurityKeys_Stddev_Fields>;
  stddev_pop?: Maybe<AuthUserSecurityKeys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AuthUserSecurityKeys_Stddev_Samp_Fields>;
  sum?: Maybe<AuthUserSecurityKeys_Sum_Fields>;
  var_pop?: Maybe<AuthUserSecurityKeys_Var_Pop_Fields>;
  var_samp?: Maybe<AuthUserSecurityKeys_Var_Samp_Fields>;
  variance?: Maybe<AuthUserSecurityKeys_Variance_Fields>;
};


/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Order_By = {
  avg?: InputMaybe<AuthUserSecurityKeys_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserSecurityKeys_Max_Order_By>;
  min?: InputMaybe<AuthUserSecurityKeys_Min_Order_By>;
  stddev?: InputMaybe<AuthUserSecurityKeys_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AuthUserSecurityKeys_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AuthUserSecurityKeys_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AuthUserSecurityKeys_Sum_Order_By>;
  var_pop?: InputMaybe<AuthUserSecurityKeys_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AuthUserSecurityKeys_Var_Samp_Order_By>;
  variance?: InputMaybe<AuthUserSecurityKeys_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Arr_Rel_Insert_Input = {
  data: Array<AuthUserSecurityKeys_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};

/** aggregate avg on columns */
export type AuthUserSecurityKeys_Avg_Fields = {
  __typename?: 'authUserSecurityKeys_avg_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Avg_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth.user_security_keys". All fields are combined with a logical 'AND'. */
export type AuthUserSecurityKeys_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp>>;
  _not?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp>>;
  counter?: InputMaybe<Bigint_Comparison_Exp>;
  credentialId?: InputMaybe<String_Comparison_Exp>;
  credentialPublicKey?: InputMaybe<Bytea_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nickname?: InputMaybe<String_Comparison_Exp>;
  transports?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Constraint {
  /** unique or primary key constraint on columns "credential_id" */
  UserSecurityKeyCredentialIdKey = 'user_security_key_credential_id_key',
  /** unique or primary key constraint on columns "id" */
  UserSecurityKeysPkey = 'user_security_keys_pkey'
}

/** input type for incrementing numeric columns in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Inc_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Insert_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserSecurityKeys_Max_Fields = {
  __typename?: 'authUserSecurityKeys_max_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
  credentialId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  transports?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Max_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserSecurityKeys_Min_Fields = {
  __typename?: 'authUserSecurityKeys_min_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
  credentialId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  transports?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Min_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Mutation_Response = {
  __typename?: 'authUserSecurityKeys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserSecurityKeys>;
};

/** on_conflict condition type for table "auth.user_security_keys" */
export type AuthUserSecurityKeys_On_Conflict = {
  constraint: AuthUserSecurityKeys_Constraint;
  update_columns?: Array<AuthUserSecurityKeys_Update_Column>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_security_keys". */
export type AuthUserSecurityKeys_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  credentialPublicKey?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_security_keys */
export type AuthUserSecurityKeys_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Select_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Set_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type AuthUserSecurityKeys_Stddev_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AuthUserSecurityKeys_Stddev_Pop_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_pop_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Pop_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AuthUserSecurityKeys_Stddev_Samp_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_samp_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Samp_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "authUserSecurityKeys" */
export type AuthUserSecurityKeys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserSecurityKeys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserSecurityKeys_Stream_Cursor_Value_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type AuthUserSecurityKeys_Sum_Fields = {
  __typename?: 'authUserSecurityKeys_sum_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Sum_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** update columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Update_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId'
}

export type AuthUserSecurityKeys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserSecurityKeys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AuthUserSecurityKeys_Var_Pop_Fields = {
  __typename?: 'authUserSecurityKeys_var_pop_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Pop_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AuthUserSecurityKeys_Var_Samp_Fields = {
  __typename?: 'authUserSecurityKeys_var_samp_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Samp_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AuthUserSecurityKeys_Variance_Fields = {
  __typename?: 'authUserSecurityKeys_variance_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Variance_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "blog" */
export type Blog = {
  __typename?: 'blog';
  al_metadata: Scalars['jsonb']['output'];
  al_sections: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  slug: Scalars['String']['output'];
  status?: Maybe<Blog_Status_Enum>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "blog" */
export type BlogAl_MetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "blog" */
export type BlogAl_SectionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "blog" */
export type Blog_Aggregate = {
  __typename?: 'blog_aggregate';
  aggregate?: Maybe<Blog_Aggregate_Fields>;
  nodes: Array<Blog>;
};

/** aggregate fields of "blog" */
export type Blog_Aggregate_Fields = {
  __typename?: 'blog_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Blog_Max_Fields>;
  min?: Maybe<Blog_Min_Fields>;
};


/** aggregate fields of "blog" */
export type Blog_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Blog_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Blog_Append_Input = {
  al_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  al_sections?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "blog". All fields are combined with a logical 'AND'. */
export type Blog_Bool_Exp = {
  _and?: InputMaybe<Array<Blog_Bool_Exp>>;
  _not?: InputMaybe<Blog_Bool_Exp>;
  _or?: InputMaybe<Array<Blog_Bool_Exp>>;
  al_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  al_sections?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Blog_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "blog" */
export enum Blog_Constraint {
  /** unique or primary key constraint on columns "id" */
  BlogPkey = 'blog_pkey',
  /** unique or primary key constraint on columns "slug" */
  BlogSlugKey = 'blog_slug_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Blog_Delete_At_Path_Input = {
  al_metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  al_sections?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Blog_Delete_Elem_Input = {
  al_metadata?: InputMaybe<Scalars['Int']['input']>;
  al_sections?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Blog_Delete_Key_Input = {
  al_metadata?: InputMaybe<Scalars['String']['input']>;
  al_sections?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "blog" */
export type Blog_Insert_Input = {
  al_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  al_sections?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Blog_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Blog_Max_Fields = {
  __typename?: 'blog_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Blog_Min_Fields = {
  __typename?: 'blog_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "blog" */
export type Blog_Mutation_Response = {
  __typename?: 'blog_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Blog>;
};

/** on_conflict condition type for table "blog" */
export type Blog_On_Conflict = {
  constraint: Blog_Constraint;
  update_columns?: Array<Blog_Update_Column>;
  where?: InputMaybe<Blog_Bool_Exp>;
};

/** Ordering options when selecting data from "blog". */
export type Blog_Order_By = {
  al_metadata?: InputMaybe<Order_By>;
  al_sections?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: blog */
export type Blog_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "blog_post" */
export type Blog_Post = {
  __typename?: 'blog_post';
  author: Scalars['String']['output'];
  colorPalette?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['String']['output']>;
  readingTime?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  sections: Array<Blog_Section>;
  /** An aggregate relationship */
  sections_aggregate: Blog_Section_Aggregate;
  tags?: Maybe<Scalars['jsonb']['output']>;
  targetAudience?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tone?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "blog_post" */
export type Blog_PostSectionsArgs = {
  distinct_on?: InputMaybe<Array<Blog_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Section_Order_By>>;
  where?: InputMaybe<Blog_Section_Bool_Exp>;
};


/** columns and relationships of "blog_post" */
export type Blog_PostSections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blog_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Section_Order_By>>;
  where?: InputMaybe<Blog_Section_Bool_Exp>;
};


/** columns and relationships of "blog_post" */
export type Blog_PostTagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "blog_post" */
export type Blog_Post_Aggregate = {
  __typename?: 'blog_post_aggregate';
  aggregate?: Maybe<Blog_Post_Aggregate_Fields>;
  nodes: Array<Blog_Post>;
};

/** aggregate fields of "blog_post" */
export type Blog_Post_Aggregate_Fields = {
  __typename?: 'blog_post_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Blog_Post_Max_Fields>;
  min?: Maybe<Blog_Post_Min_Fields>;
};


/** aggregate fields of "blog_post" */
export type Blog_Post_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Blog_Post_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Blog_Post_Append_Input = {
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "blog_post". All fields are combined with a logical 'AND'. */
export type Blog_Post_Bool_Exp = {
  _and?: InputMaybe<Array<Blog_Post_Bool_Exp>>;
  _not?: InputMaybe<Blog_Post_Bool_Exp>;
  _or?: InputMaybe<Array<Blog_Post_Bool_Exp>>;
  author?: InputMaybe<String_Comparison_Exp>;
  colorPalette?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metaDescription?: InputMaybe<String_Comparison_Exp>;
  publishDate?: InputMaybe<String_Comparison_Exp>;
  readingTime?: InputMaybe<String_Comparison_Exp>;
  sections?: InputMaybe<Blog_Section_Bool_Exp>;
  sections_aggregate?: InputMaybe<Blog_Section_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  targetAudience?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  tone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "blog_post" */
export enum Blog_Post_Constraint {
  /** unique or primary key constraint on columns "id" */
  BlogPostPkey = 'blog_post_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Blog_Post_Delete_At_Path_Input = {
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Blog_Post_Delete_Elem_Input = {
  tags?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Blog_Post_Delete_Key_Input = {
  tags?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "blog_post" */
export type Blog_Post_Insert_Input = {
  author?: InputMaybe<Scalars['String']['input']>;
  colorPalette?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['String']['input']>;
  readingTime?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Blog_Section_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Blog_Post_Max_Fields = {
  __typename?: 'blog_post_max_fields';
  author?: Maybe<Scalars['String']['output']>;
  colorPalette?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['String']['output']>;
  readingTime?: Maybe<Scalars['String']['output']>;
  targetAudience?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Blog_Post_Min_Fields = {
  __typename?: 'blog_post_min_fields';
  author?: Maybe<Scalars['String']['output']>;
  colorPalette?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['String']['output']>;
  readingTime?: Maybe<Scalars['String']['output']>;
  targetAudience?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "blog_post" */
export type Blog_Post_Mutation_Response = {
  __typename?: 'blog_post_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Blog_Post>;
};

/** input type for inserting object relation for remote table "blog_post" */
export type Blog_Post_Obj_Rel_Insert_Input = {
  data: Blog_Post_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Blog_Post_On_Conflict>;
};

/** on_conflict condition type for table "blog_post" */
export type Blog_Post_On_Conflict = {
  constraint: Blog_Post_Constraint;
  update_columns?: Array<Blog_Post_Update_Column>;
  where?: InputMaybe<Blog_Post_Bool_Exp>;
};

/** Ordering options when selecting data from "blog_post". */
export type Blog_Post_Order_By = {
  author?: InputMaybe<Order_By>;
  colorPalette?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metaDescription?: InputMaybe<Order_By>;
  publishDate?: InputMaybe<Order_By>;
  readingTime?: InputMaybe<Order_By>;
  sections_aggregate?: InputMaybe<Blog_Section_Aggregate_Order_By>;
  tags?: InputMaybe<Order_By>;
  targetAudience?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  tone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: blog_post */
export type Blog_Post_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Blog_Post_Prepend_Input = {
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "blog_post" */
export enum Blog_Post_Select_Column {
  /** column name */
  Author = 'author',
  /** column name */
  ColorPalette = 'colorPalette',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MetaDescription = 'metaDescription',
  /** column name */
  PublishDate = 'publishDate',
  /** column name */
  ReadingTime = 'readingTime',
  /** column name */
  Tags = 'tags',
  /** column name */
  TargetAudience = 'targetAudience',
  /** column name */
  Title = 'title',
  /** column name */
  Tone = 'tone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "blog_post" */
export type Blog_Post_Set_Input = {
  author?: InputMaybe<Scalars['String']['input']>;
  colorPalette?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['String']['input']>;
  readingTime?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "blog_post" */
export type Blog_Post_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Blog_Post_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Blog_Post_Stream_Cursor_Value_Input = {
  author?: InputMaybe<Scalars['String']['input']>;
  colorPalette?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['String']['input']>;
  readingTime?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "blog_post" */
export enum Blog_Post_Update_Column {
  /** column name */
  Author = 'author',
  /** column name */
  ColorPalette = 'colorPalette',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MetaDescription = 'metaDescription',
  /** column name */
  PublishDate = 'publishDate',
  /** column name */
  ReadingTime = 'readingTime',
  /** column name */
  Tags = 'tags',
  /** column name */
  TargetAudience = 'targetAudience',
  /** column name */
  Title = 'title',
  /** column name */
  Tone = 'tone',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Blog_Post_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Blog_Post_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Blog_Post_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Blog_Post_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Blog_Post_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Blog_Post_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Blog_Post_Set_Input>;
  /** filter the rows which have to be updated */
  where: Blog_Post_Bool_Exp;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Blog_Prepend_Input = {
  al_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  al_sections?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "blog_section" */
export type Blog_Section = {
  __typename?: 'blog_section';
  /** An object relationship */
  blog_post?: Maybe<Blog_Post>;
  blog_post_id?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  imageAlt?: Maybe<Scalars['String']['output']>;
  imageCaption?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "blog_section" */
export type Blog_Section_Aggregate = {
  __typename?: 'blog_section_aggregate';
  aggregate?: Maybe<Blog_Section_Aggregate_Fields>;
  nodes: Array<Blog_Section>;
};

export type Blog_Section_Aggregate_Bool_Exp = {
  count?: InputMaybe<Blog_Section_Aggregate_Bool_Exp_Count>;
};

export type Blog_Section_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Blog_Section_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Blog_Section_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "blog_section" */
export type Blog_Section_Aggregate_Fields = {
  __typename?: 'blog_section_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Blog_Section_Max_Fields>;
  min?: Maybe<Blog_Section_Min_Fields>;
};


/** aggregate fields of "blog_section" */
export type Blog_Section_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Blog_Section_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "blog_section" */
export type Blog_Section_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Blog_Section_Max_Order_By>;
  min?: InputMaybe<Blog_Section_Min_Order_By>;
};

/** input type for inserting array relation for remote table "blog_section" */
export type Blog_Section_Arr_Rel_Insert_Input = {
  data: Array<Blog_Section_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Blog_Section_On_Conflict>;
};

/** Boolean expression to filter rows from the table "blog_section". All fields are combined with a logical 'AND'. */
export type Blog_Section_Bool_Exp = {
  _and?: InputMaybe<Array<Blog_Section_Bool_Exp>>;
  _not?: InputMaybe<Blog_Section_Bool_Exp>;
  _or?: InputMaybe<Array<Blog_Section_Bool_Exp>>;
  blog_post?: InputMaybe<Blog_Post_Bool_Exp>;
  blog_post_id?: InputMaybe<Uuid_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  heading?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imageAlt?: InputMaybe<String_Comparison_Exp>;
  imageCaption?: InputMaybe<String_Comparison_Exp>;
  imageUrl?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "blog_section" */
export enum Blog_Section_Constraint {
  /** unique or primary key constraint on columns "id" */
  BlogSectionPkey = 'blog_section_pkey'
}

/** input type for inserting data into table "blog_section" */
export type Blog_Section_Insert_Input = {
  blog_post?: InputMaybe<Blog_Post_Obj_Rel_Insert_Input>;
  blog_post_id?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  imageCaption?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Blog_Section_Max_Fields = {
  __typename?: 'blog_section_max_fields';
  blog_post_id?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imageAlt?: Maybe<Scalars['String']['output']>;
  imageCaption?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "blog_section" */
export type Blog_Section_Max_Order_By = {
  blog_post_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageAlt?: InputMaybe<Order_By>;
  imageCaption?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Blog_Section_Min_Fields = {
  __typename?: 'blog_section_min_fields';
  blog_post_id?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imageAlt?: Maybe<Scalars['String']['output']>;
  imageCaption?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "blog_section" */
export type Blog_Section_Min_Order_By = {
  blog_post_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageAlt?: InputMaybe<Order_By>;
  imageCaption?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "blog_section" */
export type Blog_Section_Mutation_Response = {
  __typename?: 'blog_section_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Blog_Section>;
};

/** on_conflict condition type for table "blog_section" */
export type Blog_Section_On_Conflict = {
  constraint: Blog_Section_Constraint;
  update_columns?: Array<Blog_Section_Update_Column>;
  where?: InputMaybe<Blog_Section_Bool_Exp>;
};

/** Ordering options when selecting data from "blog_section". */
export type Blog_Section_Order_By = {
  blog_post?: InputMaybe<Blog_Post_Order_By>;
  blog_post_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageAlt?: InputMaybe<Order_By>;
  imageCaption?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: blog_section */
export type Blog_Section_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "blog_section" */
export enum Blog_Section_Select_Column {
  /** column name */
  BlogPostId = 'blog_post_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Heading = 'heading',
  /** column name */
  Id = 'id',
  /** column name */
  ImageAlt = 'imageAlt',
  /** column name */
  ImageCaption = 'imageCaption',
  /** column name */
  ImageUrl = 'imageUrl',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "blog_section" */
export type Blog_Section_Set_Input = {
  blog_post_id?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  imageCaption?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "blog_section" */
export type Blog_Section_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Blog_Section_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Blog_Section_Stream_Cursor_Value_Input = {
  blog_post_id?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  imageCaption?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "blog_section" */
export enum Blog_Section_Update_Column {
  /** column name */
  BlogPostId = 'blog_post_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Heading = 'heading',
  /** column name */
  Id = 'id',
  /** column name */
  ImageAlt = 'imageAlt',
  /** column name */
  ImageCaption = 'imageCaption',
  /** column name */
  ImageUrl = 'imageUrl',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Blog_Section_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Blog_Section_Set_Input>;
  /** filter the rows which have to be updated */
  where: Blog_Section_Bool_Exp;
};

/** select columns of table "blog" */
export enum Blog_Select_Column {
  /** column name */
  AlMetadata = 'al_metadata',
  /** column name */
  AlSections = 'al_sections',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "blog" */
export type Blog_Set_Input = {
  al_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  al_sections?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Blog_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "blog_status" */
export type Blog_Status = {
  __typename?: 'blog_status';
  status: Scalars['String']['output'];
};

/** aggregated selection of "blog_status" */
export type Blog_Status_Aggregate = {
  __typename?: 'blog_status_aggregate';
  aggregate?: Maybe<Blog_Status_Aggregate_Fields>;
  nodes: Array<Blog_Status>;
};

/** aggregate fields of "blog_status" */
export type Blog_Status_Aggregate_Fields = {
  __typename?: 'blog_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Blog_Status_Max_Fields>;
  min?: Maybe<Blog_Status_Min_Fields>;
};


/** aggregate fields of "blog_status" */
export type Blog_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Blog_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "blog_status". All fields are combined with a logical 'AND'. */
export type Blog_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Blog_Status_Bool_Exp>>;
  _not?: InputMaybe<Blog_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Blog_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "blog_status" */
export enum Blog_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  BlogStatusPkey = 'blog_status_pkey'
}

export enum Blog_Status_Enum {
  Archived = 'archived',
  Draft = 'draft',
  Published = 'published'
}

/** Boolean expression to compare columns of type "blog_status_enum". All fields are combined with logical 'AND'. */
export type Blog_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Blog_Status_Enum>;
  _in?: InputMaybe<Array<Blog_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Blog_Status_Enum>;
  _nin?: InputMaybe<Array<Blog_Status_Enum>>;
};

/** input type for inserting data into table "blog_status" */
export type Blog_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Blog_Status_Max_Fields = {
  __typename?: 'blog_status_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Blog_Status_Min_Fields = {
  __typename?: 'blog_status_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "blog_status" */
export type Blog_Status_Mutation_Response = {
  __typename?: 'blog_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Blog_Status>;
};

/** on_conflict condition type for table "blog_status" */
export type Blog_Status_On_Conflict = {
  constraint: Blog_Status_Constraint;
  update_columns?: Array<Blog_Status_Update_Column>;
  where?: InputMaybe<Blog_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "blog_status". */
export type Blog_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: blog_status */
export type Blog_Status_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "blog_status" */
export enum Blog_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "blog_status" */
export type Blog_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "blog_status" */
export type Blog_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Blog_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Blog_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "blog_status" */
export enum Blog_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Blog_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Blog_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Blog_Status_Bool_Exp;
};

/** Streaming cursor of the table "blog" */
export type Blog_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Blog_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Blog_Stream_Cursor_Value_Input = {
  al_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  al_sections?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Blog_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "blog" */
export enum Blog_Update_Column {
  /** column name */
  AlMetadata = 'al_metadata',
  /** column name */
  AlSections = 'al_sections',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Blog_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Blog_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Blog_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Blog_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Blog_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Blog_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Blog_Set_Input>;
  /** filter the rows which have to be updated */
  where: Blog_Bool_Exp;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bpchar']['input']>;
  _gt?: InputMaybe<Scalars['bpchar']['input']>;
  _gte?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']['input']>;
  _in?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']['input']>;
  _lt?: InputMaybe<Scalars['bpchar']['input']>;
  _lte?: InputMaybe<Scalars['bpchar']['input']>;
  _neq?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']['input']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']['input']>;
};

/** columns and relationships of "storage.buckets" */
export type Buckets = {
  __typename?: 'buckets';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  downloadExpiration: Scalars['Int']['output'];
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  id: Scalars['String']['output'];
  maxUploadFileSize: Scalars['Int']['output'];
  minUploadFileSize: Scalars['Int']['output'];
  presignedUrlsEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "storage.buckets" */
export type BucketsFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "storage.buckets" */
export type BucketsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** aggregated selection of "storage.buckets" */
export type Buckets_Aggregate = {
  __typename?: 'buckets_aggregate';
  aggregate?: Maybe<Buckets_Aggregate_Fields>;
  nodes: Array<Buckets>;
};

/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_Fields = {
  __typename?: 'buckets_aggregate_fields';
  avg?: Maybe<Buckets_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Buckets_Max_Fields>;
  min?: Maybe<Buckets_Min_Fields>;
  stddev?: Maybe<Buckets_Stddev_Fields>;
  stddev_pop?: Maybe<Buckets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Buckets_Stddev_Samp_Fields>;
  sum?: Maybe<Buckets_Sum_Fields>;
  var_pop?: Maybe<Buckets_Var_Pop_Fields>;
  var_samp?: Maybe<Buckets_Var_Samp_Fields>;
  variance?: Maybe<Buckets_Variance_Fields>;
};


/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buckets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Buckets_Avg_Fields = {
  __typename?: 'buckets_avg_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type Buckets_Bool_Exp = {
  _and?: InputMaybe<Array<Buckets_Bool_Exp>>;
  _not?: InputMaybe<Buckets_Bool_Exp>;
  _or?: InputMaybe<Array<Buckets_Bool_Exp>>;
  cacheControl?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  downloadExpiration?: InputMaybe<Int_Comparison_Exp>;
  files?: InputMaybe<Files_Bool_Exp>;
  files_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  maxUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  minUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  presignedUrlsEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.buckets" */
export enum Buckets_Constraint {
  /** unique or primary key constraint on columns "id" */
  BucketsPkey = 'buckets_pkey'
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type Buckets_Inc_Input = {
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.buckets" */
export type Buckets_Insert_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Buckets_Max_Fields = {
  __typename?: 'buckets_max_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Buckets_Min_Fields = {
  __typename?: 'buckets_min_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "storage.buckets" */
export type Buckets_Mutation_Response = {
  __typename?: 'buckets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buckets>;
};

/** input type for inserting object relation for remote table "storage.buckets" */
export type Buckets_Obj_Rel_Insert_Input = {
  data: Buckets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};

/** on_conflict condition type for table "storage.buckets" */
export type Buckets_On_Conflict = {
  constraint: Buckets_Constraint;
  update_columns?: Array<Buckets_Update_Column>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.buckets". */
export type Buckets_Order_By = {
  cacheControl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  downloadExpiration?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  maxUploadFileSize?: InputMaybe<Order_By>;
  minUploadFileSize?: InputMaybe<Order_By>;
  presignedUrlsEnabled?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.buckets */
export type Buckets_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "storage.buckets" */
export enum Buckets_Select_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "storage.buckets" */
export type Buckets_Set_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Buckets_Stddev_Fields = {
  __typename?: 'buckets_stddev_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Buckets_Stddev_Pop_Fields = {
  __typename?: 'buckets_stddev_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Buckets_Stddev_Samp_Fields = {
  __typename?: 'buckets_stddev_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "buckets" */
export type Buckets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buckets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buckets_Stream_Cursor_Value_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Buckets_Sum_Fields = {
  __typename?: 'buckets_sum_fields';
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "storage.buckets" */
export enum Buckets_Update_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Buckets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Buckets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buckets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Buckets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Buckets_Var_Pop_Fields = {
  __typename?: 'buckets_var_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Buckets_Var_Samp_Fields = {
  __typename?: 'buckets_var_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Buckets_Variance_Fields = {
  __typename?: 'buckets_variance_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "builder" */
export type Builder = {
  __typename?: 'builder';
  created_at: Scalars['timestamptz']['output'];
  display_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  profile_image_url?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "builder" */
export type Builder_Aggregate = {
  __typename?: 'builder_aggregate';
  aggregate?: Maybe<Builder_Aggregate_Fields>;
  nodes: Array<Builder>;
};

/** aggregate fields of "builder" */
export type Builder_Aggregate_Fields = {
  __typename?: 'builder_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Builder_Max_Fields>;
  min?: Maybe<Builder_Min_Fields>;
};


/** aggregate fields of "builder" */
export type Builder_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Builder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "builder". All fields are combined with a logical 'AND'. */
export type Builder_Bool_Exp = {
  _and?: InputMaybe<Array<Builder_Bool_Exp>>;
  _not?: InputMaybe<Builder_Bool_Exp>;
  _or?: InputMaybe<Array<Builder_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile_image_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "builder" */
export enum Builder_Constraint {
  /** unique or primary key constraint on columns "id" */
  BuilderPkey = 'builder_pkey'
}

/** input type for inserting data into table "builder" */
export type Builder_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Builder_Max_Fields = {
  __typename?: 'builder_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Builder_Min_Fields = {
  __typename?: 'builder_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "builder" */
export type Builder_Mutation_Response = {
  __typename?: 'builder_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Builder>;
};

/** on_conflict condition type for table "builder" */
export type Builder_On_Conflict = {
  constraint: Builder_Constraint;
  update_columns?: Array<Builder_Update_Column>;
  where?: InputMaybe<Builder_Bool_Exp>;
};

/** Ordering options when selecting data from "builder". */
export type Builder_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: builder */
export type Builder_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "builder" */
export enum Builder_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "builder" */
export type Builder_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "builder" */
export type Builder_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Builder_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Builder_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "builder" */
export enum Builder_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Builder_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Builder_Set_Input>;
  /** filter the rows which have to be updated */
  where: Builder_Bool_Exp;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bytea']['input']>;
  _gt?: InputMaybe<Scalars['bytea']['input']>;
  _gte?: InputMaybe<Scalars['bytea']['input']>;
  _in?: InputMaybe<Array<Scalars['bytea']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bytea']['input']>;
  _lte?: InputMaybe<Scalars['bytea']['input']>;
  _neq?: InputMaybe<Scalars['bytea']['input']>;
  _nin?: InputMaybe<Array<Scalars['bytea']['input']>>;
};

/** columns and relationships of "certified_agent" */
export type Certified_Agent = {
  __typename?: 'certified_agent';
  certificate_number: Scalars['numeric']['output'];
  certified_date: Scalars['date']['output'];
  created_at: Scalars['timestamptz']['output'];
  display_name: Scalars['String']['output'];
  father_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "certified_agent" */
export type Certified_Agent_Aggregate = {
  __typename?: 'certified_agent_aggregate';
  aggregate?: Maybe<Certified_Agent_Aggregate_Fields>;
  nodes: Array<Certified_Agent>;
};

/** aggregate fields of "certified_agent" */
export type Certified_Agent_Aggregate_Fields = {
  __typename?: 'certified_agent_aggregate_fields';
  avg?: Maybe<Certified_Agent_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Certified_Agent_Max_Fields>;
  min?: Maybe<Certified_Agent_Min_Fields>;
  stddev?: Maybe<Certified_Agent_Stddev_Fields>;
  stddev_pop?: Maybe<Certified_Agent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Certified_Agent_Stddev_Samp_Fields>;
  sum?: Maybe<Certified_Agent_Sum_Fields>;
  var_pop?: Maybe<Certified_Agent_Var_Pop_Fields>;
  var_samp?: Maybe<Certified_Agent_Var_Samp_Fields>;
  variance?: Maybe<Certified_Agent_Variance_Fields>;
};


/** aggregate fields of "certified_agent" */
export type Certified_Agent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Certified_Agent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Certified_Agent_Avg_Fields = {
  __typename?: 'certified_agent_avg_fields';
  certificate_number?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "certified_agent". All fields are combined with a logical 'AND'. */
export type Certified_Agent_Bool_Exp = {
  _and?: InputMaybe<Array<Certified_Agent_Bool_Exp>>;
  _not?: InputMaybe<Certified_Agent_Bool_Exp>;
  _or?: InputMaybe<Array<Certified_Agent_Bool_Exp>>;
  certificate_number?: InputMaybe<Numeric_Comparison_Exp>;
  certified_date?: InputMaybe<Date_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  father_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "certified_agent" */
export enum Certified_Agent_Constraint {
  /** unique or primary key constraint on columns "id" */
  CertifiedAgentPkey = 'certified_agent_pkey'
}

/** input type for incrementing numeric columns in table "certified_agent" */
export type Certified_Agent_Inc_Input = {
  certificate_number?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "certified_agent" */
export type Certified_Agent_Insert_Input = {
  certificate_number?: InputMaybe<Scalars['numeric']['input']>;
  certified_date?: InputMaybe<Scalars['date']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  father_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Certified_Agent_Max_Fields = {
  __typename?: 'certified_agent_max_fields';
  certificate_number?: Maybe<Scalars['numeric']['output']>;
  certified_date?: Maybe<Scalars['date']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  father_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Certified_Agent_Min_Fields = {
  __typename?: 'certified_agent_min_fields';
  certificate_number?: Maybe<Scalars['numeric']['output']>;
  certified_date?: Maybe<Scalars['date']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  father_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "certified_agent" */
export type Certified_Agent_Mutation_Response = {
  __typename?: 'certified_agent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Certified_Agent>;
};

/** on_conflict condition type for table "certified_agent" */
export type Certified_Agent_On_Conflict = {
  constraint: Certified_Agent_Constraint;
  update_columns?: Array<Certified_Agent_Update_Column>;
  where?: InputMaybe<Certified_Agent_Bool_Exp>;
};

/** Ordering options when selecting data from "certified_agent". */
export type Certified_Agent_Order_By = {
  certificate_number?: InputMaybe<Order_By>;
  certified_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  father_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: certified_agent */
export type Certified_Agent_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "certified_agent" */
export enum Certified_Agent_Select_Column {
  /** column name */
  CertificateNumber = 'certificate_number',
  /** column name */
  CertifiedDate = 'certified_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  FatherName = 'father_name',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "certified_agent" */
export type Certified_Agent_Set_Input = {
  certificate_number?: InputMaybe<Scalars['numeric']['input']>;
  certified_date?: InputMaybe<Scalars['date']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  father_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Certified_Agent_Stddev_Fields = {
  __typename?: 'certified_agent_stddev_fields';
  certificate_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Certified_Agent_Stddev_Pop_Fields = {
  __typename?: 'certified_agent_stddev_pop_fields';
  certificate_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Certified_Agent_Stddev_Samp_Fields = {
  __typename?: 'certified_agent_stddev_samp_fields';
  certificate_number?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "certified_agent" */
export type Certified_Agent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Certified_Agent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Certified_Agent_Stream_Cursor_Value_Input = {
  certificate_number?: InputMaybe<Scalars['numeric']['input']>;
  certified_date?: InputMaybe<Scalars['date']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  father_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Certified_Agent_Sum_Fields = {
  __typename?: 'certified_agent_sum_fields';
  certificate_number?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "certified_agent" */
export enum Certified_Agent_Update_Column {
  /** column name */
  CertificateNumber = 'certificate_number',
  /** column name */
  CertifiedDate = 'certified_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  FatherName = 'father_name',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Certified_Agent_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Certified_Agent_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Certified_Agent_Set_Input>;
  /** filter the rows which have to be updated */
  where: Certified_Agent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Certified_Agent_Var_Pop_Fields = {
  __typename?: 'certified_agent_var_pop_fields';
  certificate_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Certified_Agent_Var_Samp_Fields = {
  __typename?: 'certified_agent_var_samp_fields';
  certificate_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Certified_Agent_Variance_Fields = {
  __typename?: 'certified_agent_variance_fields';
  certificate_number?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "chat_response_type" */
export type Chat_Response_Type = {
  __typename?: 'chat_response_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "chat_response_type" */
export type Chat_Response_Type_Aggregate = {
  __typename?: 'chat_response_type_aggregate';
  aggregate?: Maybe<Chat_Response_Type_Aggregate_Fields>;
  nodes: Array<Chat_Response_Type>;
};

/** aggregate fields of "chat_response_type" */
export type Chat_Response_Type_Aggregate_Fields = {
  __typename?: 'chat_response_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Response_Type_Max_Fields>;
  min?: Maybe<Chat_Response_Type_Min_Fields>;
};


/** aggregate fields of "chat_response_type" */
export type Chat_Response_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Response_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "chat_response_type". All fields are combined with a logical 'AND'. */
export type Chat_Response_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Response_Type_Bool_Exp>>;
  _not?: InputMaybe<Chat_Response_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Response_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_response_type" */
export enum Chat_Response_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  ChatResponseTypePkey = 'chat_response_type_pkey'
}

export enum Chat_Response_Type_Enum {
  LocationNotFound = 'LOCATION_NOT_FOUND',
  NewConversation = 'NEW_CONVERSATION',
  OutOfContext = 'OUT_OF_CONTEXT',
  PromptLimitReached = 'PROMPT_LIMIT_REACHED',
  PropertyList = 'PROPERTY_LIST',
  PropertyStatusAndTypeMissing = 'PROPERTY_STATUS_AND_TYPE_MISSING',
  PropertyStatusMissing = 'PROPERTY_STATUS_MISSING',
  PropertyTypeMissing = 'PROPERTY_TYPE_MISSING',
  StatisticalIntelligence = 'STATISTICAL_INTELLIGENCE'
}

/** Boolean expression to compare columns of type "chat_response_type_enum". All fields are combined with logical 'AND'. */
export type Chat_Response_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Chat_Response_Type_Enum>;
  _in?: InputMaybe<Array<Chat_Response_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Chat_Response_Type_Enum>;
  _nin?: InputMaybe<Array<Chat_Response_Type_Enum>>;
};

/** input type for inserting data into table "chat_response_type" */
export type Chat_Response_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Chat_Response_Type_Max_Fields = {
  __typename?: 'chat_response_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Chat_Response_Type_Min_Fields = {
  __typename?: 'chat_response_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "chat_response_type" */
export type Chat_Response_Type_Mutation_Response = {
  __typename?: 'chat_response_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Response_Type>;
};

/** on_conflict condition type for table "chat_response_type" */
export type Chat_Response_Type_On_Conflict = {
  constraint: Chat_Response_Type_Constraint;
  update_columns?: Array<Chat_Response_Type_Update_Column>;
  where?: InputMaybe<Chat_Response_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_response_type". */
export type Chat_Response_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_response_type */
export type Chat_Response_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "chat_response_type" */
export enum Chat_Response_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "chat_response_type" */
export type Chat_Response_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "chat_response_type" */
export type Chat_Response_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Response_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Response_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "chat_response_type" */
export enum Chat_Response_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Chat_Response_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chat_Response_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Chat_Response_Type_Bool_Exp;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']['input']>;
  _gt?: InputMaybe<Scalars['citext']['input']>;
  _gte?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']['input']>;
  _in?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']['input']>;
  _lt?: InputMaybe<Scalars['citext']['input']>;
  _lte?: InputMaybe<Scalars['citext']['input']>;
  _neq?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']['input']>;
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']['input']>;
};

/**
 * @foreignKey (construction_status) references public.construction_status(statuzs)
 * @foreignKey (contact_id) references public.contact(id)
 * @foreignKey (furnishing_status) references public.furnishing_status(status)
 * @foreignKey (location_id) references public.location(id)
 * @foreignKey (main_image_id) references public.property_image(id)
 * @foreignKey (parent_property) references public.property(id)
 * @foreignKey (price_currency) references public.currency(currency)
 * @foreignKey (property_composition_id) references public.property_composition(id)
 * @foreignKey (property_origin_type) references public.property_origin_type(type)
 * @foreignKey (property_status) references public.property_status(status)
 * @foreignKey (property_type) references public.property_type(type)
 * @foreignKey (source_id) references public.property_source(id)
 * @foreignKey (visibility_status) references public.visibility_status(status)
 * @foreignKey (organization_id) references public.organization(id)
 */
export type Citizens_Property_List_View = {
  __typename?: 'citizens_property_list_view';
  archived?: Maybe<Scalars['Boolean']['output']>;
  building_floors?: Maybe<Scalars['Int']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  construction_status?: Maybe<Scalars['String']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  contact?: Maybe<Contact>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone_1?: Maybe<Scalars['String']['output']>;
  contact_phone_2?: Maybe<Scalars['String']['output']>;
  content_location?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description_id?: Maybe<Scalars['uuid']['output']>;
  disapproved_comment?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  features_json?: Maybe<Scalars['jsonb']['output']>;
  floor?: Maybe<Scalars['Int']['output']>;
  furnishing_status?: Maybe<Scalars['String']['output']>;
  generated_title_id?: Maybe<Scalars['uuid']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_carport?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_parking_space?: Maybe<Scalars['Boolean']['output']>;
  has_property_title?: Maybe<Scalars['Boolean']['output']>;
  has_terrace?: Maybe<Scalars['Boolean']['output']>;
  heating_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_barrier_free?: Maybe<Scalars['Boolean']['output']>;
  json_ld?: Maybe<Scalars['jsonb']['output']>;
  last_renovation_year?: Maybe<Scalars['Int']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  lister_id?: Maybe<Scalars['uuid']['output']>;
  living_area?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  lot_size?: Maybe<Scalars['String']['output']>;
  main_image_id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  parent_property?: Maybe<Scalars['uuid']['output']>;
  parking_spaces?: Maybe<Scalars['Int']['output']>;
  parking_type?: Maybe<Scalars['String']['output']>;
  pets_allowed?: Maybe<Scalars['Boolean']['output']>;
  plot_area?: Maybe<Scalars['float8']['output']>;
  posted_at?: Maybe<Scalars['date']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  price_currency?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  property?: Maybe<Property>;
  /** An object relationship */
  property_composition?: Maybe<Property_Composition>;
  property_composition_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  property_features: Array<Property_Feature>;
  /** An aggregate relationship */
  property_features_aggregate: Property_Feature_Aggregate;
  property_origin_type?: Maybe<Scalars['String']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  rental_terms?: Maybe<Scalars['String']['output']>;
  sale_terms?: Maybe<Scalars['String']['output']>;
  search_vector?: Maybe<Scalars['String']['output']>;
  smoking_allowed?: Maybe<Scalars['Boolean']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  source_url?: Maybe<Scalars['String']['output']>;
  source_url_clicked?: Maybe<Scalars['Int']['output']>;
  task_id?: Maybe<Scalars['String']['output']>;
  title_id?: Maybe<Scalars['uuid']['output']>;
  total_area?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
  visibility_status?: Maybe<Scalars['String']['output']>;
};


/**
 * @foreignKey (construction_status) references public.construction_status(statuzs)
 * @foreignKey (contact_id) references public.contact(id)
 * @foreignKey (furnishing_status) references public.furnishing_status(status)
 * @foreignKey (location_id) references public.location(id)
 * @foreignKey (main_image_id) references public.property_image(id)
 * @foreignKey (parent_property) references public.property(id)
 * @foreignKey (price_currency) references public.currency(currency)
 * @foreignKey (property_composition_id) references public.property_composition(id)
 * @foreignKey (property_origin_type) references public.property_origin_type(type)
 * @foreignKey (property_status) references public.property_status(status)
 * @foreignKey (property_type) references public.property_type(type)
 * @foreignKey (source_id) references public.property_source(id)
 * @foreignKey (visibility_status) references public.visibility_status(status)
 * @foreignKey (organization_id) references public.organization(id)
 */
export type Citizens_Property_List_ViewFeatures_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/**
 * @foreignKey (construction_status) references public.construction_status(statuzs)
 * @foreignKey (contact_id) references public.contact(id)
 * @foreignKey (furnishing_status) references public.furnishing_status(status)
 * @foreignKey (location_id) references public.location(id)
 * @foreignKey (main_image_id) references public.property_image(id)
 * @foreignKey (parent_property) references public.property(id)
 * @foreignKey (price_currency) references public.currency(currency)
 * @foreignKey (property_composition_id) references public.property_composition(id)
 * @foreignKey (property_origin_type) references public.property_origin_type(type)
 * @foreignKey (property_status) references public.property_status(status)
 * @foreignKey (property_type) references public.property_type(type)
 * @foreignKey (source_id) references public.property_source(id)
 * @foreignKey (visibility_status) references public.visibility_status(status)
 * @foreignKey (organization_id) references public.organization(id)
 */
export type Citizens_Property_List_ViewJson_LdArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/**
 * @foreignKey (construction_status) references public.construction_status(statuzs)
 * @foreignKey (contact_id) references public.contact(id)
 * @foreignKey (furnishing_status) references public.furnishing_status(status)
 * @foreignKey (location_id) references public.location(id)
 * @foreignKey (main_image_id) references public.property_image(id)
 * @foreignKey (parent_property) references public.property(id)
 * @foreignKey (price_currency) references public.currency(currency)
 * @foreignKey (property_composition_id) references public.property_composition(id)
 * @foreignKey (property_origin_type) references public.property_origin_type(type)
 * @foreignKey (property_status) references public.property_status(status)
 * @foreignKey (property_type) references public.property_type(type)
 * @foreignKey (source_id) references public.property_source(id)
 * @foreignKey (visibility_status) references public.visibility_status(status)
 * @foreignKey (organization_id) references public.organization(id)
 */
export type Citizens_Property_List_ViewProperty_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Property_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Feature_Order_By>>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};


/**
 * @foreignKey (construction_status) references public.construction_status(statuzs)
 * @foreignKey (contact_id) references public.contact(id)
 * @foreignKey (furnishing_status) references public.furnishing_status(status)
 * @foreignKey (location_id) references public.location(id)
 * @foreignKey (main_image_id) references public.property_image(id)
 * @foreignKey (parent_property) references public.property(id)
 * @foreignKey (price_currency) references public.currency(currency)
 * @foreignKey (property_composition_id) references public.property_composition(id)
 * @foreignKey (property_origin_type) references public.property_origin_type(type)
 * @foreignKey (property_status) references public.property_status(status)
 * @foreignKey (property_type) references public.property_type(type)
 * @foreignKey (source_id) references public.property_source(id)
 * @foreignKey (visibility_status) references public.visibility_status(status)
 * @foreignKey (organization_id) references public.organization(id)
 */
export type Citizens_Property_List_ViewProperty_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Feature_Order_By>>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};

/** aggregated selection of "citizens_property_list_view" */
export type Citizens_Property_List_View_Aggregate = {
  __typename?: 'citizens_property_list_view_aggregate';
  aggregate?: Maybe<Citizens_Property_List_View_Aggregate_Fields>;
  nodes: Array<Citizens_Property_List_View>;
};

/** aggregate fields of "citizens_property_list_view" */
export type Citizens_Property_List_View_Aggregate_Fields = {
  __typename?: 'citizens_property_list_view_aggregate_fields';
  avg?: Maybe<Citizens_Property_List_View_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Citizens_Property_List_View_Max_Fields>;
  min?: Maybe<Citizens_Property_List_View_Min_Fields>;
  stddev?: Maybe<Citizens_Property_List_View_Stddev_Fields>;
  stddev_pop?: Maybe<Citizens_Property_List_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Citizens_Property_List_View_Stddev_Samp_Fields>;
  sum?: Maybe<Citizens_Property_List_View_Sum_Fields>;
  var_pop?: Maybe<Citizens_Property_List_View_Var_Pop_Fields>;
  var_samp?: Maybe<Citizens_Property_List_View_Var_Samp_Fields>;
  variance?: Maybe<Citizens_Property_List_View_Variance_Fields>;
};


/** aggregate fields of "citizens_property_list_view" */
export type Citizens_Property_List_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Citizens_Property_List_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Citizens_Property_List_View_Avg_Fields = {
  __typename?: 'citizens_property_list_view_avg_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "citizens_property_list_view". All fields are combined with a logical 'AND'. */
export type Citizens_Property_List_View_Bool_Exp = {
  _and?: InputMaybe<Array<Citizens_Property_List_View_Bool_Exp>>;
  _not?: InputMaybe<Citizens_Property_List_View_Bool_Exp>;
  _or?: InputMaybe<Array<Citizens_Property_List_View_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  building_floors?: InputMaybe<Int_Comparison_Exp>;
  canonical_url?: InputMaybe<String_Comparison_Exp>;
  construction_status?: InputMaybe<String_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact_name?: InputMaybe<String_Comparison_Exp>;
  contact_phone_1?: InputMaybe<String_Comparison_Exp>;
  contact_phone_2?: InputMaybe<String_Comparison_Exp>;
  content_location?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  description_id?: InputMaybe<Uuid_Comparison_Exp>;
  disapproved_comment?: InputMaybe<String_Comparison_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  features_json?: InputMaybe<Jsonb_Comparison_Exp>;
  floor?: InputMaybe<Int_Comparison_Exp>;
  furnishing_status?: InputMaybe<String_Comparison_Exp>;
  generated_title_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_carport?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking_space?: InputMaybe<Boolean_Comparison_Exp>;
  has_property_title?: InputMaybe<Boolean_Comparison_Exp>;
  has_terrace?: InputMaybe<Boolean_Comparison_Exp>;
  heating_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_barrier_free?: InputMaybe<Boolean_Comparison_Exp>;
  json_ld?: InputMaybe<Jsonb_Comparison_Exp>;
  last_renovation_year?: InputMaybe<Int_Comparison_Exp>;
  last_seen?: InputMaybe<Timestamptz_Comparison_Exp>;
  lister_id?: InputMaybe<Uuid_Comparison_Exp>;
  living_area?: InputMaybe<Float8_Comparison_Exp>;
  location?: InputMaybe<Location_Bool_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_size?: InputMaybe<String_Comparison_Exp>;
  main_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_property?: InputMaybe<Uuid_Comparison_Exp>;
  parking_spaces?: InputMaybe<Int_Comparison_Exp>;
  parking_type?: InputMaybe<String_Comparison_Exp>;
  pets_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  plot_area?: InputMaybe<Float8_Comparison_Exp>;
  posted_at?: InputMaybe<Date_Comparison_Exp>;
  price?: InputMaybe<Float8_Comparison_Exp>;
  price_currency?: InputMaybe<String_Comparison_Exp>;
  property?: InputMaybe<Property_Bool_Exp>;
  property_composition?: InputMaybe<Property_Composition_Bool_Exp>;
  property_composition_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_features?: InputMaybe<Property_Feature_Bool_Exp>;
  property_features_aggregate?: InputMaybe<Property_Feature_Aggregate_Bool_Exp>;
  property_origin_type?: InputMaybe<String_Comparison_Exp>;
  property_status?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  rental_terms?: InputMaybe<String_Comparison_Exp>;
  sale_terms?: InputMaybe<String_Comparison_Exp>;
  search_vector?: InputMaybe<String_Comparison_Exp>;
  smoking_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  source_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_url?: InputMaybe<String_Comparison_Exp>;
  source_url_clicked?: InputMaybe<Int_Comparison_Exp>;
  task_id?: InputMaybe<String_Comparison_Exp>;
  title_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_area?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  views?: InputMaybe<Int_Comparison_Exp>;
  visibility_status?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Citizens_Property_List_View_Max_Fields = {
  __typename?: 'citizens_property_list_view_max_fields';
  building_floors?: Maybe<Scalars['Int']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  construction_status?: Maybe<Scalars['String']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone_1?: Maybe<Scalars['String']['output']>;
  contact_phone_2?: Maybe<Scalars['String']['output']>;
  content_location?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  description_id?: Maybe<Scalars['uuid']['output']>;
  disapproved_comment?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['Int']['output']>;
  furnishing_status?: Maybe<Scalars['String']['output']>;
  generated_title_id?: Maybe<Scalars['uuid']['output']>;
  heating_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_renovation_year?: Maybe<Scalars['Int']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  lister_id?: Maybe<Scalars['uuid']['output']>;
  living_area?: Maybe<Scalars['float8']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  lot_size?: Maybe<Scalars['String']['output']>;
  main_image_id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  parent_property?: Maybe<Scalars['uuid']['output']>;
  parking_spaces?: Maybe<Scalars['Int']['output']>;
  parking_type?: Maybe<Scalars['String']['output']>;
  plot_area?: Maybe<Scalars['float8']['output']>;
  posted_at?: Maybe<Scalars['date']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  price_currency?: Maybe<Scalars['String']['output']>;
  property_composition_id?: Maybe<Scalars['uuid']['output']>;
  property_origin_type?: Maybe<Scalars['String']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  rental_terms?: Maybe<Scalars['String']['output']>;
  sale_terms?: Maybe<Scalars['String']['output']>;
  search_vector?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  source_url?: Maybe<Scalars['String']['output']>;
  source_url_clicked?: Maybe<Scalars['Int']['output']>;
  task_id?: Maybe<Scalars['String']['output']>;
  title_id?: Maybe<Scalars['uuid']['output']>;
  total_area?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
  visibility_status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Citizens_Property_List_View_Min_Fields = {
  __typename?: 'citizens_property_list_view_min_fields';
  building_floors?: Maybe<Scalars['Int']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  construction_status?: Maybe<Scalars['String']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone_1?: Maybe<Scalars['String']['output']>;
  contact_phone_2?: Maybe<Scalars['String']['output']>;
  content_location?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  description_id?: Maybe<Scalars['uuid']['output']>;
  disapproved_comment?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['Int']['output']>;
  furnishing_status?: Maybe<Scalars['String']['output']>;
  generated_title_id?: Maybe<Scalars['uuid']['output']>;
  heating_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_renovation_year?: Maybe<Scalars['Int']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  lister_id?: Maybe<Scalars['uuid']['output']>;
  living_area?: Maybe<Scalars['float8']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  lot_size?: Maybe<Scalars['String']['output']>;
  main_image_id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  parent_property?: Maybe<Scalars['uuid']['output']>;
  parking_spaces?: Maybe<Scalars['Int']['output']>;
  parking_type?: Maybe<Scalars['String']['output']>;
  plot_area?: Maybe<Scalars['float8']['output']>;
  posted_at?: Maybe<Scalars['date']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  price_currency?: Maybe<Scalars['String']['output']>;
  property_composition_id?: Maybe<Scalars['uuid']['output']>;
  property_origin_type?: Maybe<Scalars['String']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  rental_terms?: Maybe<Scalars['String']['output']>;
  sale_terms?: Maybe<Scalars['String']['output']>;
  search_vector?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  source_url?: Maybe<Scalars['String']['output']>;
  source_url_clicked?: Maybe<Scalars['Int']['output']>;
  task_id?: Maybe<Scalars['String']['output']>;
  title_id?: Maybe<Scalars['uuid']['output']>;
  total_area?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
  visibility_status?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "citizens_property_list_view". */
export type Citizens_Property_List_View_Order_By = {
  archived?: InputMaybe<Order_By>;
  building_floors?: InputMaybe<Order_By>;
  canonical_url?: InputMaybe<Order_By>;
  construction_status?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  contact_name?: InputMaybe<Order_By>;
  contact_phone_1?: InputMaybe<Order_By>;
  contact_phone_2?: InputMaybe<Order_By>;
  content_location?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  description_id?: InputMaybe<Order_By>;
  disapproved_comment?: InputMaybe<Order_By>;
  featured?: InputMaybe<Order_By>;
  features_json?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  furnishing_status?: InputMaybe<Order_By>;
  generated_title_id?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_carport?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_parking_space?: InputMaybe<Order_By>;
  has_property_title?: InputMaybe<Order_By>;
  has_terrace?: InputMaybe<Order_By>;
  heating_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_barrier_free?: InputMaybe<Order_By>;
  json_ld?: InputMaybe<Order_By>;
  last_renovation_year?: InputMaybe<Order_By>;
  last_seen?: InputMaybe<Order_By>;
  lister_id?: InputMaybe<Order_By>;
  living_area?: InputMaybe<Order_By>;
  location?: InputMaybe<Location_Order_By>;
  location_id?: InputMaybe<Order_By>;
  lot_size?: InputMaybe<Order_By>;
  main_image_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parent_property?: InputMaybe<Order_By>;
  parking_spaces?: InputMaybe<Order_By>;
  parking_type?: InputMaybe<Order_By>;
  pets_allowed?: InputMaybe<Order_By>;
  plot_area?: InputMaybe<Order_By>;
  posted_at?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_currency?: InputMaybe<Order_By>;
  property?: InputMaybe<Property_Order_By>;
  property_composition?: InputMaybe<Property_Composition_Order_By>;
  property_composition_id?: InputMaybe<Order_By>;
  property_features_aggregate?: InputMaybe<Property_Feature_Aggregate_Order_By>;
  property_origin_type?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  rental_terms?: InputMaybe<Order_By>;
  sale_terms?: InputMaybe<Order_By>;
  search_vector?: InputMaybe<Order_By>;
  smoking_allowed?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_url?: InputMaybe<Order_By>;
  source_url_clicked?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  title_id?: InputMaybe<Order_By>;
  total_area?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
  visibility_status?: InputMaybe<Order_By>;
};

/** select columns of table "citizens_property_list_view" */
export enum Citizens_Property_List_View_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  BuildingFloors = 'building_floors',
  /** column name */
  CanonicalUrl = 'canonical_url',
  /** column name */
  ConstructionStatus = 'construction_status',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  ContactPhone_1 = 'contact_phone_1',
  /** column name */
  ContactPhone_2 = 'contact_phone_2',
  /** column name */
  ContentLocation = 'content_location',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  DisapprovedComment = 'disapproved_comment',
  /** column name */
  Featured = 'featured',
  /** column name */
  FeaturesJson = 'features_json',
  /** column name */
  Floor = 'floor',
  /** column name */
  FurnishingStatus = 'furnishing_status',
  /** column name */
  GeneratedTitleId = 'generated_title_id',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCarport = 'has_carport',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasParkingSpace = 'has_parking_space',
  /** column name */
  HasPropertyTitle = 'has_property_title',
  /** column name */
  HasTerrace = 'has_terrace',
  /** column name */
  HeatingType = 'heating_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBarrierFree = 'is_barrier_free',
  /** column name */
  JsonLd = 'json_ld',
  /** column name */
  LastRenovationYear = 'last_renovation_year',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  ListerId = 'lister_id',
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  LotSize = 'lot_size',
  /** column name */
  MainImageId = 'main_image_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ParentProperty = 'parent_property',
  /** column name */
  ParkingSpaces = 'parking_spaces',
  /** column name */
  ParkingType = 'parking_type',
  /** column name */
  PetsAllowed = 'pets_allowed',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  PostedAt = 'posted_at',
  /** column name */
  Price = 'price',
  /** column name */
  PriceCurrency = 'price_currency',
  /** column name */
  PropertyCompositionId = 'property_composition_id',
  /** column name */
  PropertyOriginType = 'property_origin_type',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  RentalTerms = 'rental_terms',
  /** column name */
  SaleTerms = 'sale_terms',
  /** column name */
  SearchVector = 'search_vector',
  /** column name */
  SmokingAllowed = 'smoking_allowed',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  SourceUrl = 'source_url',
  /** column name */
  SourceUrlClicked = 'source_url_clicked',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  TitleId = 'title_id',
  /** column name */
  TotalArea = 'total_area',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Views = 'views',
  /** column name */
  VisibilityStatus = 'visibility_status'
}

/** aggregate stddev on columns */
export type Citizens_Property_List_View_Stddev_Fields = {
  __typename?: 'citizens_property_list_view_stddev_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Citizens_Property_List_View_Stddev_Pop_Fields = {
  __typename?: 'citizens_property_list_view_stddev_pop_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Citizens_Property_List_View_Stddev_Samp_Fields = {
  __typename?: 'citizens_property_list_view_stddev_samp_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "citizens_property_list_view" */
export type Citizens_Property_List_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Citizens_Property_List_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Citizens_Property_List_View_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  building_floors?: InputMaybe<Scalars['Int']['input']>;
  canonical_url?: InputMaybe<Scalars['String']['input']>;
  construction_status?: InputMaybe<Scalars['String']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone_1?: InputMaybe<Scalars['String']['input']>;
  contact_phone_2?: InputMaybe<Scalars['String']['input']>;
  content_location?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description_id?: InputMaybe<Scalars['uuid']['input']>;
  disapproved_comment?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  features_json?: InputMaybe<Scalars['jsonb']['input']>;
  floor?: InputMaybe<Scalars['Int']['input']>;
  furnishing_status?: InputMaybe<Scalars['String']['input']>;
  generated_title_id?: InputMaybe<Scalars['uuid']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_carport?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking_space?: InputMaybe<Scalars['Boolean']['input']>;
  has_property_title?: InputMaybe<Scalars['Boolean']['input']>;
  has_terrace?: InputMaybe<Scalars['Boolean']['input']>;
  heating_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_barrier_free?: InputMaybe<Scalars['Boolean']['input']>;
  json_ld?: InputMaybe<Scalars['jsonb']['input']>;
  last_renovation_year?: InputMaybe<Scalars['Int']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  lister_id?: InputMaybe<Scalars['uuid']['input']>;
  living_area?: InputMaybe<Scalars['float8']['input']>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  lot_size?: InputMaybe<Scalars['String']['input']>;
  main_image_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_property?: InputMaybe<Scalars['uuid']['input']>;
  parking_spaces?: InputMaybe<Scalars['Int']['input']>;
  parking_type?: InputMaybe<Scalars['String']['input']>;
  pets_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  plot_area?: InputMaybe<Scalars['float8']['input']>;
  posted_at?: InputMaybe<Scalars['date']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  price_currency?: InputMaybe<Scalars['String']['input']>;
  property_composition_id?: InputMaybe<Scalars['uuid']['input']>;
  property_origin_type?: InputMaybe<Scalars['String']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
  rental_terms?: InputMaybe<Scalars['String']['input']>;
  sale_terms?: InputMaybe<Scalars['String']['input']>;
  search_vector?: InputMaybe<Scalars['String']['input']>;
  smoking_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  source_url?: InputMaybe<Scalars['String']['input']>;
  source_url_clicked?: InputMaybe<Scalars['Int']['input']>;
  task_id?: InputMaybe<Scalars['String']['input']>;
  title_id?: InputMaybe<Scalars['uuid']['input']>;
  total_area?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
  visibility_status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Citizens_Property_List_View_Sum_Fields = {
  __typename?: 'citizens_property_list_view_sum_fields';
  building_floors?: Maybe<Scalars['Int']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  floor?: Maybe<Scalars['Int']['output']>;
  last_renovation_year?: Maybe<Scalars['Int']['output']>;
  living_area?: Maybe<Scalars['float8']['output']>;
  parking_spaces?: Maybe<Scalars['Int']['output']>;
  plot_area?: Maybe<Scalars['float8']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  source_url_clicked?: Maybe<Scalars['Int']['output']>;
  total_area?: Maybe<Scalars['float8']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Citizens_Property_List_View_Var_Pop_Fields = {
  __typename?: 'citizens_property_list_view_var_pop_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Citizens_Property_List_View_Var_Samp_Fields = {
  __typename?: 'citizens_property_list_view_var_samp_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Citizens_Property_List_View_Variance_Fields = {
  __typename?: 'citizens_property_list_view_variance_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "city" */
export type City = {
  __typename?: 'city';
  center_location?: Maybe<Scalars['jsonb']['output']>;
  city_name: Scalars['String']['output'];
  country_id: Scalars['uuid']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  viewport?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "city" */
export type CityCenter_LocationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "city" */
export type CityViewportArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "city" */
export type City_Aggregate = {
  __typename?: 'city_aggregate';
  aggregate?: Maybe<City_Aggregate_Fields>;
  nodes: Array<City>;
};

/** aggregate fields of "city" */
export type City_Aggregate_Fields = {
  __typename?: 'city_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<City_Max_Fields>;
  min?: Maybe<City_Min_Fields>;
};


/** aggregate fields of "city" */
export type City_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<City_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type City_Append_Input = {
  center_location?: InputMaybe<Scalars['jsonb']['input']>;
  viewport?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "city". All fields are combined with a logical 'AND'. */
export type City_Bool_Exp = {
  _and?: InputMaybe<Array<City_Bool_Exp>>;
  _not?: InputMaybe<City_Bool_Exp>;
  _or?: InputMaybe<Array<City_Bool_Exp>>;
  center_location?: InputMaybe<Jsonb_Comparison_Exp>;
  city_name?: InputMaybe<String_Comparison_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  viewport?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "city" */
export enum City_Constraint {
  /** unique or primary key constraint on columns "city_name" */
  CityCityNameKey = 'city_city_name_key',
  /** unique or primary key constraint on columns "id" */
  CityPkey = 'city_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type City_Delete_At_Path_Input = {
  center_location?: InputMaybe<Array<Scalars['String']['input']>>;
  viewport?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type City_Delete_Elem_Input = {
  center_location?: InputMaybe<Scalars['Int']['input']>;
  viewport?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type City_Delete_Key_Input = {
  center_location?: InputMaybe<Scalars['String']['input']>;
  viewport?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "city" */
export type City_Insert_Input = {
  center_location?: InputMaybe<Scalars['jsonb']['input']>;
  city_name?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  viewport?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type City_Max_Fields = {
  __typename?: 'city_max_fields';
  city_name?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type City_Min_Fields = {
  __typename?: 'city_min_fields';
  city_name?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "city" */
export type City_Mutation_Response = {
  __typename?: 'city_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<City>;
};

/** input type for inserting object relation for remote table "city" */
export type City_Obj_Rel_Insert_Input = {
  data: City_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<City_On_Conflict>;
};

/** on_conflict condition type for table "city" */
export type City_On_Conflict = {
  constraint: City_Constraint;
  update_columns?: Array<City_Update_Column>;
  where?: InputMaybe<City_Bool_Exp>;
};

/** Ordering options when selecting data from "city". */
export type City_Order_By = {
  center_location?: InputMaybe<Order_By>;
  city_name?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  viewport?: InputMaybe<Order_By>;
};

/** primary key columns input for table: city */
export type City_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type City_Prepend_Input = {
  center_location?: InputMaybe<Scalars['jsonb']['input']>;
  viewport?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "city" */
export enum City_Select_Column {
  /** column name */
  CenterLocation = 'center_location',
  /** column name */
  CityName = 'city_name',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Viewport = 'viewport'
}

/** input type for updating data in table "city" */
export type City_Set_Input = {
  center_location?: InputMaybe<Scalars['jsonb']['input']>;
  city_name?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  viewport?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "city" */
export type City_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: City_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type City_Stream_Cursor_Value_Input = {
  center_location?: InputMaybe<Scalars['jsonb']['input']>;
  city_name?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  viewport?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "city" */
export enum City_Update_Column {
  /** column name */
  CenterLocation = 'center_location',
  /** column name */
  CityName = 'city_name',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Viewport = 'viewport'
}

export type City_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<City_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<City_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<City_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<City_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<City_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<City_Set_Input>;
  /** filter the rows which have to be updated */
  where: City_Bool_Exp;
};

/** columns and relationships of "city_zone" */
export type City_Zone = {
  __typename?: 'city_zone';
  bounds?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  city: City;
  city_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_method?: Maybe<Zone_Data_Method_Enum>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  geometry?: Maybe<Scalars['geography']['output']>;
  id: Scalars['uuid']['output'];
  is_problematic?: Maybe<Scalars['Boolean']['output']>;
  /** True only when the row is a geographic area suitable for containment search. */
  is_search_area: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['jsonb']['output']>;
  location_type?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<City_Zone_Origin_Enum>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  place_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  place_references: Array<Place_Reference>;
  /** An aggregate relationship */
  place_references_aggregate: Place_Reference_Aggregate;
  /** A computed field, executes function "has_any_property_in_city_zone" */
  property_count?: Maybe<Scalars['Boolean']['output']>;
  surface_area?: Maybe<Scalars['float8']['output']>;
  types?: Maybe<Scalars['jsonb']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  viewport?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  zone_data_method?: Maybe<Zone_Data_Method>;
  zone_name: Scalars['String']['output'];
};


/** columns and relationships of "city_zone" */
export type City_ZoneBoundsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "city_zone" */
export type City_ZoneLocationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "city_zone" */
export type City_ZonePlace_ReferencesArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Order_By>>;
  where?: InputMaybe<Place_Reference_Bool_Exp>;
};


/** columns and relationships of "city_zone" */
export type City_ZonePlace_References_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Order_By>>;
  where?: InputMaybe<Place_Reference_Bool_Exp>;
};


/** columns and relationships of "city_zone" */
export type City_ZoneTypesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "city_zone" */
export type City_ZoneViewportArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "city_zone" */
export type City_Zone_Aggregate = {
  __typename?: 'city_zone_aggregate';
  aggregate?: Maybe<City_Zone_Aggregate_Fields>;
  nodes: Array<City_Zone>;
};

/** aggregate fields of "city_zone" */
export type City_Zone_Aggregate_Fields = {
  __typename?: 'city_zone_aggregate_fields';
  avg?: Maybe<City_Zone_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<City_Zone_Max_Fields>;
  min?: Maybe<City_Zone_Min_Fields>;
  stddev?: Maybe<City_Zone_Stddev_Fields>;
  stddev_pop?: Maybe<City_Zone_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<City_Zone_Stddev_Samp_Fields>;
  sum?: Maybe<City_Zone_Sum_Fields>;
  var_pop?: Maybe<City_Zone_Var_Pop_Fields>;
  var_samp?: Maybe<City_Zone_Var_Samp_Fields>;
  variance?: Maybe<City_Zone_Variance_Fields>;
};


/** aggregate fields of "city_zone" */
export type City_Zone_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<City_Zone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type City_Zone_Append_Input = {
  bounds?: InputMaybe<Scalars['jsonb']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  types?: InputMaybe<Scalars['jsonb']['input']>;
  viewport?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type City_Zone_Avg_Fields = {
  __typename?: 'city_zone_avg_fields';
  surface_area?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "city_zone". All fields are combined with a logical 'AND'. */
export type City_Zone_Bool_Exp = {
  _and?: InputMaybe<Array<City_Zone_Bool_Exp>>;
  _not?: InputMaybe<City_Zone_Bool_Exp>;
  _or?: InputMaybe<Array<City_Zone_Bool_Exp>>;
  bounds?: InputMaybe<Jsonb_Comparison_Exp>;
  city?: InputMaybe<City_Bool_Exp>;
  city_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_method?: InputMaybe<Zone_Data_Method_Enum_Comparison_Exp>;
  formatted_address?: InputMaybe<String_Comparison_Exp>;
  geometry?: InputMaybe<Geography_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_problematic?: InputMaybe<Boolean_Comparison_Exp>;
  is_search_area?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<Jsonb_Comparison_Exp>;
  location_type?: InputMaybe<String_Comparison_Exp>;
  origin?: InputMaybe<City_Zone_Origin_Enum_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_id?: InputMaybe<String_Comparison_Exp>;
  place_references?: InputMaybe<Place_Reference_Bool_Exp>;
  place_references_aggregate?: InputMaybe<Place_Reference_Aggregate_Bool_Exp>;
  property_count?: InputMaybe<Boolean_Comparison_Exp>;
  surface_area?: InputMaybe<Float8_Comparison_Exp>;
  types?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  viewport?: InputMaybe<Jsonb_Comparison_Exp>;
  zone_data_method?: InputMaybe<Zone_Data_Method_Bool_Exp>;
  zone_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "city_zone" */
export enum City_Zone_Constraint {
  /** unique or primary key constraint on columns "id" */
  CityZonePkey = 'city_zone_pkey',
  /** unique or primary key constraint on columns "zone_name", "city_id" */
  CityZoneZoneNameCityIdKey = 'city_zone_zone_name_city_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type City_Zone_Delete_At_Path_Input = {
  bounds?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  viewport?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type City_Zone_Delete_Elem_Input = {
  bounds?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Scalars['Int']['input']>;
  viewport?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type City_Zone_Delete_Key_Input = {
  bounds?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Scalars['String']['input']>;
  viewport?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "city_zone" */
export type City_Zone_Inc_Input = {
  surface_area?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "city_zone" */
export type City_Zone_Insert_Input = {
  bounds?: InputMaybe<Scalars['jsonb']['input']>;
  city?: InputMaybe<City_Obj_Rel_Insert_Input>;
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_method?: InputMaybe<Zone_Data_Method_Enum>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  geometry?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_problematic?: InputMaybe<Scalars['Boolean']['input']>;
  /** True only when the row is a geographic area suitable for containment search. */
  is_search_area?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  location_type?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<City_Zone_Origin_Enum>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  place_id?: InputMaybe<Scalars['String']['input']>;
  place_references?: InputMaybe<Place_Reference_Arr_Rel_Insert_Input>;
  surface_area?: InputMaybe<Scalars['float8']['input']>;
  types?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  viewport?: InputMaybe<Scalars['jsonb']['input']>;
  zone_data_method?: InputMaybe<Zone_Data_Method_Obj_Rel_Insert_Input>;
  zone_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type City_Zone_Max_Fields = {
  __typename?: 'city_zone_max_fields';
  city_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_type?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  place_id?: Maybe<Scalars['String']['output']>;
  surface_area?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  zone_name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type City_Zone_Min_Fields = {
  __typename?: 'city_zone_min_fields';
  city_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_type?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  place_id?: Maybe<Scalars['String']['output']>;
  surface_area?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  zone_name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "city_zone" */
export type City_Zone_Mutation_Response = {
  __typename?: 'city_zone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<City_Zone>;
};

/** input type for inserting object relation for remote table "city_zone" */
export type City_Zone_Obj_Rel_Insert_Input = {
  data: City_Zone_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<City_Zone_On_Conflict>;
};

export type City_Zone_Object = {
  __typename?: 'city_zone_object';
  bounds?: Maybe<Scalars['jsonb']['output']>;
  city_name?: Maybe<Scalars['String']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['jsonb']['output']>;
  viewport?: Maybe<Scalars['jsonb']['output']>;
  zone_name?: Maybe<Scalars['String']['output']>;
};


export type City_Zone_ObjectBoundsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type City_Zone_ObjectLocationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type City_Zone_ObjectViewportArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "city_zone_object". All fields are combined with a logical 'AND'. */
export type City_Zone_Object_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<City_Zone_Object_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<City_Zone_Object_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<City_Zone_Object_Bool_Exp_Bool_Exp>>;
  bounds?: InputMaybe<Jsonb_Comparison_Exp>;
  city_name?: InputMaybe<String_Comparison_Exp>;
  formatted_address?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Jsonb_Comparison_Exp>;
  viewport?: InputMaybe<Jsonb_Comparison_Exp>;
  zone_name?: InputMaybe<String_Comparison_Exp>;
};

export enum City_Zone_Object_Enum_Name {
  /** column name */
  Bounds = 'bounds',
  /** column name */
  CityName = 'city_name',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Viewport = 'viewport',
  /** column name */
  ZoneName = 'zone_name'
}

/** Ordering options when selecting data from "city_zone_object". */
export type City_Zone_Object_Order_By = {
  bounds?: InputMaybe<Order_By>;
  city_name?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  viewport?: InputMaybe<Order_By>;
  zone_name?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "city_zone" */
export type City_Zone_On_Conflict = {
  constraint: City_Zone_Constraint;
  update_columns?: Array<City_Zone_Update_Column>;
  where?: InputMaybe<City_Zone_Bool_Exp>;
};

/** Ordering options when selecting data from "city_zone". */
export type City_Zone_Order_By = {
  bounds?: InputMaybe<Order_By>;
  city?: InputMaybe<City_Order_By>;
  city_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_method?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  geometry?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_problematic?: InputMaybe<Order_By>;
  is_search_area?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  location_type?: InputMaybe<Order_By>;
  origin?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_references_aggregate?: InputMaybe<Place_Reference_Aggregate_Order_By>;
  property_count?: InputMaybe<Order_By>;
  surface_area?: InputMaybe<Order_By>;
  types?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  viewport?: InputMaybe<Order_By>;
  zone_data_method?: InputMaybe<Zone_Data_Method_Order_By>;
  zone_name?: InputMaybe<Order_By>;
};

/** columns and relationships of "city_zone_origin" */
export type City_Zone_Origin = {
  __typename?: 'city_zone_origin';
  origin: Scalars['String']['output'];
};

/** aggregated selection of "city_zone_origin" */
export type City_Zone_Origin_Aggregate = {
  __typename?: 'city_zone_origin_aggregate';
  aggregate?: Maybe<City_Zone_Origin_Aggregate_Fields>;
  nodes: Array<City_Zone_Origin>;
};

/** aggregate fields of "city_zone_origin" */
export type City_Zone_Origin_Aggregate_Fields = {
  __typename?: 'city_zone_origin_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<City_Zone_Origin_Max_Fields>;
  min?: Maybe<City_Zone_Origin_Min_Fields>;
};


/** aggregate fields of "city_zone_origin" */
export type City_Zone_Origin_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<City_Zone_Origin_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "city_zone_origin". All fields are combined with a logical 'AND'. */
export type City_Zone_Origin_Bool_Exp = {
  _and?: InputMaybe<Array<City_Zone_Origin_Bool_Exp>>;
  _not?: InputMaybe<City_Zone_Origin_Bool_Exp>;
  _or?: InputMaybe<Array<City_Zone_Origin_Bool_Exp>>;
  origin?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "city_zone_origin" */
export enum City_Zone_Origin_Constraint {
  /** unique or primary key constraint on columns "origin" */
  CityZoneOriginPkey = 'city_zone_origin_pkey'
}

export enum City_Zone_Origin_Enum {
  Pipeline = 'PIPELINE',
  Seeded = 'SEEDED',
  User = 'USER'
}

/** Boolean expression to compare columns of type "city_zone_origin_enum". All fields are combined with logical 'AND'. */
export type City_Zone_Origin_Enum_Comparison_Exp = {
  _eq?: InputMaybe<City_Zone_Origin_Enum>;
  _in?: InputMaybe<Array<City_Zone_Origin_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<City_Zone_Origin_Enum>;
  _nin?: InputMaybe<Array<City_Zone_Origin_Enum>>;
};

/** input type for inserting data into table "city_zone_origin" */
export type City_Zone_Origin_Insert_Input = {
  origin?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type City_Zone_Origin_Max_Fields = {
  __typename?: 'city_zone_origin_max_fields';
  origin?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type City_Zone_Origin_Min_Fields = {
  __typename?: 'city_zone_origin_min_fields';
  origin?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "city_zone_origin" */
export type City_Zone_Origin_Mutation_Response = {
  __typename?: 'city_zone_origin_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<City_Zone_Origin>;
};

/** on_conflict condition type for table "city_zone_origin" */
export type City_Zone_Origin_On_Conflict = {
  constraint: City_Zone_Origin_Constraint;
  update_columns?: Array<City_Zone_Origin_Update_Column>;
  where?: InputMaybe<City_Zone_Origin_Bool_Exp>;
};

/** Ordering options when selecting data from "city_zone_origin". */
export type City_Zone_Origin_Order_By = {
  origin?: InputMaybe<Order_By>;
};

/** primary key columns input for table: city_zone_origin */
export type City_Zone_Origin_Pk_Columns_Input = {
  origin: Scalars['String']['input'];
};

/** select columns of table "city_zone_origin" */
export enum City_Zone_Origin_Select_Column {
  /** column name */
  Origin = 'origin'
}

/** input type for updating data in table "city_zone_origin" */
export type City_Zone_Origin_Set_Input = {
  origin?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "city_zone_origin" */
export type City_Zone_Origin_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: City_Zone_Origin_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type City_Zone_Origin_Stream_Cursor_Value_Input = {
  origin?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "city_zone_origin" */
export enum City_Zone_Origin_Update_Column {
  /** column name */
  Origin = 'origin'
}

export type City_Zone_Origin_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<City_Zone_Origin_Set_Input>;
  /** filter the rows which have to be updated */
  where: City_Zone_Origin_Bool_Exp;
};

/** primary key columns input for table: city_zone */
export type City_Zone_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type City_Zone_Prepend_Input = {
  bounds?: InputMaybe<Scalars['jsonb']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  types?: InputMaybe<Scalars['jsonb']['input']>;
  viewport?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "city_zone" */
export enum City_Zone_Select_Column {
  /** column name */
  Bounds = 'bounds',
  /** column name */
  CityId = 'city_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataMethod = 'data_method',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  IsProblematic = 'is_problematic',
  /** column name */
  IsSearchArea = 'is_search_area',
  /** column name */
  Location = 'location',
  /** column name */
  LocationType = 'location_type',
  /** column name */
  Origin = 'origin',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  SurfaceArea = 'surface_area',
  /** column name */
  Types = 'types',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Viewport = 'viewport',
  /** column name */
  ZoneName = 'zone_name'
}

/** input type for updating data in table "city_zone" */
export type City_Zone_Set_Input = {
  bounds?: InputMaybe<Scalars['jsonb']['input']>;
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_method?: InputMaybe<Zone_Data_Method_Enum>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  geometry?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_problematic?: InputMaybe<Scalars['Boolean']['input']>;
  /** True only when the row is a geographic area suitable for containment search. */
  is_search_area?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  location_type?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<City_Zone_Origin_Enum>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  place_id?: InputMaybe<Scalars['String']['input']>;
  surface_area?: InputMaybe<Scalars['float8']['input']>;
  types?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  viewport?: InputMaybe<Scalars['jsonb']['input']>;
  zone_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type City_Zone_Stddev_Fields = {
  __typename?: 'city_zone_stddev_fields';
  surface_area?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type City_Zone_Stddev_Pop_Fields = {
  __typename?: 'city_zone_stddev_pop_fields';
  surface_area?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type City_Zone_Stddev_Samp_Fields = {
  __typename?: 'city_zone_stddev_samp_fields';
  surface_area?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "city_zone" */
export type City_Zone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: City_Zone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type City_Zone_Stream_Cursor_Value_Input = {
  bounds?: InputMaybe<Scalars['jsonb']['input']>;
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_method?: InputMaybe<Zone_Data_Method_Enum>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  geometry?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_problematic?: InputMaybe<Scalars['Boolean']['input']>;
  /** True only when the row is a geographic area suitable for containment search. */
  is_search_area?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  location_type?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<City_Zone_Origin_Enum>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  place_id?: InputMaybe<Scalars['String']['input']>;
  surface_area?: InputMaybe<Scalars['float8']['input']>;
  types?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  viewport?: InputMaybe<Scalars['jsonb']['input']>;
  zone_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type City_Zone_Sum_Fields = {
  __typename?: 'city_zone_sum_fields';
  surface_area?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "city_zone" */
export enum City_Zone_Update_Column {
  /** column name */
  Bounds = 'bounds',
  /** column name */
  CityId = 'city_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataMethod = 'data_method',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  IsProblematic = 'is_problematic',
  /** column name */
  IsSearchArea = 'is_search_area',
  /** column name */
  Location = 'location',
  /** column name */
  LocationType = 'location_type',
  /** column name */
  Origin = 'origin',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  SurfaceArea = 'surface_area',
  /** column name */
  Types = 'types',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Viewport = 'viewport',
  /** column name */
  ZoneName = 'zone_name'
}

export type City_Zone_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<City_Zone_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<City_Zone_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<City_Zone_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<City_Zone_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<City_Zone_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<City_Zone_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<City_Zone_Set_Input>;
  /** filter the rows which have to be updated */
  where: City_Zone_Bool_Exp;
};

/** aggregate var_pop on columns */
export type City_Zone_Var_Pop_Fields = {
  __typename?: 'city_zone_var_pop_fields';
  surface_area?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type City_Zone_Var_Samp_Fields = {
  __typename?: 'city_zone_var_samp_fields';
  surface_area?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type City_Zone_Variance_Fields = {
  __typename?: 'city_zone_variance_fields';
  surface_area?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "claim_request_status" */
export type Claim_Request_Status = {
  __typename?: 'claim_request_status';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** aggregated selection of "claim_request_status" */
export type Claim_Request_Status_Aggregate = {
  __typename?: 'claim_request_status_aggregate';
  aggregate?: Maybe<Claim_Request_Status_Aggregate_Fields>;
  nodes: Array<Claim_Request_Status>;
};

/** aggregate fields of "claim_request_status" */
export type Claim_Request_Status_Aggregate_Fields = {
  __typename?: 'claim_request_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Claim_Request_Status_Max_Fields>;
  min?: Maybe<Claim_Request_Status_Min_Fields>;
};


/** aggregate fields of "claim_request_status" */
export type Claim_Request_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Claim_Request_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "claim_request_status". All fields are combined with a logical 'AND'. */
export type Claim_Request_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Claim_Request_Status_Bool_Exp>>;
  _not?: InputMaybe<Claim_Request_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Claim_Request_Status_Bool_Exp>>;
  message?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "claim_request_status" */
export enum Claim_Request_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  ClaimRequestStatusPkey = 'claim_request_status_pkey'
}

export enum Claim_Request_Status_Enum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
  UnderReview = 'UNDER_REVIEW'
}

/** Boolean expression to compare columns of type "claim_request_status_enum". All fields are combined with logical 'AND'. */
export type Claim_Request_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Claim_Request_Status_Enum>;
  _in?: InputMaybe<Array<Claim_Request_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Claim_Request_Status_Enum>;
  _nin?: InputMaybe<Array<Claim_Request_Status_Enum>>;
};

/** input type for inserting data into table "claim_request_status" */
export type Claim_Request_Status_Insert_Input = {
  message?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Claim_Request_Status_Max_Fields = {
  __typename?: 'claim_request_status_max_fields';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Claim_Request_Status_Min_Fields = {
  __typename?: 'claim_request_status_min_fields';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "claim_request_status" */
export type Claim_Request_Status_Mutation_Response = {
  __typename?: 'claim_request_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Claim_Request_Status>;
};

/** on_conflict condition type for table "claim_request_status" */
export type Claim_Request_Status_On_Conflict = {
  constraint: Claim_Request_Status_Constraint;
  update_columns?: Array<Claim_Request_Status_Update_Column>;
  where?: InputMaybe<Claim_Request_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "claim_request_status". */
export type Claim_Request_Status_Order_By = {
  message?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claim_request_status */
export type Claim_Request_Status_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "claim_request_status" */
export enum Claim_Request_Status_Select_Column {
  /** column name */
  Message = 'message',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "claim_request_status" */
export type Claim_Request_Status_Set_Input = {
  message?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "claim_request_status" */
export type Claim_Request_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Claim_Request_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Claim_Request_Status_Stream_Cursor_Value_Input = {
  message?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "claim_request_status" */
export enum Claim_Request_Status_Update_Column {
  /** column name */
  Message = 'message',
  /** column name */
  Status = 'status'
}

export type Claim_Request_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Claim_Request_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Claim_Request_Status_Bool_Exp;
};

export type Claim_Whatsapp_Ai_Ambiguous_Outbox_Part_Args = {
  p_lease_seconds?: InputMaybe<Scalars['Int']['input']>;
  p_worker_id?: InputMaybe<Scalars['String']['input']>;
};

export type Claim_Whatsapp_Ai_Outbox_Part_Args = {
  p_lease_seconds?: InputMaybe<Scalars['Int']['input']>;
  p_max_attempts?: InputMaybe<Scalars['Int']['input']>;
  p_worker_id?: InputMaybe<Scalars['String']['input']>;
};

/** classifiedPropertiesNative Query Arguments */
export type ClassifiedProperties_Arguments = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

export type Classified_Properties_Model = {
  __typename?: 'classified_properties_model';
  kaktu_properties?: Maybe<Scalars['bigint']['output']>;
  report_date?: Maybe<Scalars['date']['output']>;
  scraped_properties?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the logical model for "classified_properties_model". All fields are combined with a logical 'AND'. */
export type Classified_Properties_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Classified_Properties_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Classified_Properties_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Classified_Properties_Model_Bool_Exp_Bool_Exp>>;
  kaktu_properties?: InputMaybe<Bigint_Comparison_Exp>;
  report_date?: InputMaybe<Date_Comparison_Exp>;
  scraped_properties?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Classified_Properties_Model_Enum_Name {
  /** column name */
  KaktuProperties = 'kaktu_properties',
  /** column name */
  ReportDate = 'report_date',
  /** column name */
  ScrapedProperties = 'scraped_properties'
}

/** Ordering options when selecting data from "classified_properties_model". */
export type Classified_Properties_Model_Order_By = {
  kaktu_properties?: InputMaybe<Order_By>;
  report_date?: InputMaybe<Order_By>;
  scraped_properties?: InputMaybe<Order_By>;
};

/** columns and relationships of "clering" */
export type Clering = {
  __typename?: 'clering';
  address: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  display_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  profile_image_url: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "clering" */
export type Clering_Aggregate = {
  __typename?: 'clering_aggregate';
  aggregate?: Maybe<Clering_Aggregate_Fields>;
  nodes: Array<Clering>;
};

/** aggregate fields of "clering" */
export type Clering_Aggregate_Fields = {
  __typename?: 'clering_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Clering_Max_Fields>;
  min?: Maybe<Clering_Min_Fields>;
};


/** aggregate fields of "clering" */
export type Clering_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Clering_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "clering". All fields are combined with a logical 'AND'. */
export type Clering_Bool_Exp = {
  _and?: InputMaybe<Array<Clering_Bool_Exp>>;
  _not?: InputMaybe<Clering_Bool_Exp>;
  _or?: InputMaybe<Array<Clering_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile_image_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "clering" */
export enum Clering_Constraint {
  /** unique or primary key constraint on columns "id" */
  CleringPkey = 'clering_pkey'
}

/** input type for inserting data into table "clering" */
export type Clering_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Clering_Max_Fields = {
  __typename?: 'clering_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Clering_Min_Fields = {
  __typename?: 'clering_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "clering" */
export type Clering_Mutation_Response = {
  __typename?: 'clering_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Clering>;
};

/** on_conflict condition type for table "clering" */
export type Clering_On_Conflict = {
  constraint: Clering_Constraint;
  update_columns?: Array<Clering_Update_Column>;
  where?: InputMaybe<Clering_Bool_Exp>;
};

/** Ordering options when selecting data from "clering". */
export type Clering_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: clering */
export type Clering_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "clering" */
export enum Clering_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "clering" */
export type Clering_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "clering" */
export type Clering_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clering_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clering_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "clering" */
export enum Clering_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Clering_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clering_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clering_Bool_Exp;
};

export type Complete_Whatsapp_Ai_Outbox_Part_Args = {
  p_part_id?: InputMaybe<Scalars['uuid']['input']>;
  p_provider_message_id?: InputMaybe<Scalars['String']['input']>;
  p_worker_id?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "construction_status" */
export type Construction_Status = {
  __typename?: 'construction_status';
  status: Scalars['String']['output'];
};

export enum Construction_Status_ActionType {
  NewBuilding = 'new_building',
  OldBuilding = 'old_building',
  UnderConstruction = 'under_construction'
}

/** aggregated selection of "construction_status" */
export type Construction_Status_Aggregate = {
  __typename?: 'construction_status_aggregate';
  aggregate?: Maybe<Construction_Status_Aggregate_Fields>;
  nodes: Array<Construction_Status>;
};

/** aggregate fields of "construction_status" */
export type Construction_Status_Aggregate_Fields = {
  __typename?: 'construction_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Construction_Status_Max_Fields>;
  min?: Maybe<Construction_Status_Min_Fields>;
};


/** aggregate fields of "construction_status" */
export type Construction_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Construction_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "construction_status". All fields are combined with a logical 'AND'. */
export type Construction_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Construction_Status_Bool_Exp>>;
  _not?: InputMaybe<Construction_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Construction_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_status" */
export enum Construction_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  ConstructionStatusPkey = 'construction_status_pkey'
}

export enum Construction_Status_Enum {
  NewBuilding = 'new_building',
  OldBuilding = 'old_building',
  UnderConstruction = 'under_construction'
}

/** Boolean expression to compare columns of type "construction_status_enum". All fields are combined with logical 'AND'. */
export type Construction_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Construction_Status_Enum>;
  _in?: InputMaybe<Array<Construction_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Construction_Status_Enum>;
  _nin?: InputMaybe<Array<Construction_Status_Enum>>;
};

/** input type for inserting data into table "construction_status" */
export type Construction_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Construction_Status_Max_Fields = {
  __typename?: 'construction_status_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Construction_Status_Min_Fields = {
  __typename?: 'construction_status_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "construction_status" */
export type Construction_Status_Mutation_Response = {
  __typename?: 'construction_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Construction_Status>;
};

/** on_conflict condition type for table "construction_status" */
export type Construction_Status_On_Conflict = {
  constraint: Construction_Status_Constraint;
  update_columns?: Array<Construction_Status_Update_Column>;
  where?: InputMaybe<Construction_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_status". */
export type Construction_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_status */
export type Construction_Status_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "construction_status" */
export enum Construction_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "construction_status" */
export type Construction_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "construction_status" */
export type Construction_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Construction_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Construction_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "construction_status" */
export enum Construction_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Construction_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Construction_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Construction_Status_Bool_Exp;
};

/** columns and relationships of "contact" */
export type Contact = {
  __typename?: 'contact';
  /** An array relationship */
  contact_phone_numbers: Array<Contact_Phone_Number>;
  /** An aggregate relationship */
  contact_phone_numbers_aggregate: Contact_Phone_Number_Aggregate;
  contact_type?: Maybe<Contact_Type_Enum>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  property_lists: Array<Property_List>;
  /** An aggregate relationship */
  property_lists_aggregate: Property_List_Aggregate;
};


/** columns and relationships of "contact" */
export type ContactContact_Phone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Contact_Phone_Number_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Phone_Number_Order_By>>;
  where?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactContact_Phone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Phone_Number_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Phone_Number_Order_By>>;
  where?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactProperty_ListsArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactProperty_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};

/** aggregated selection of "contact" */
export type Contact_Aggregate = {
  __typename?: 'contact_aggregate';
  aggregate?: Maybe<Contact_Aggregate_Fields>;
  nodes: Array<Contact>;
};

/** aggregate fields of "contact" */
export type Contact_Aggregate_Fields = {
  __typename?: 'contact_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Contact_Max_Fields>;
  min?: Maybe<Contact_Min_Fields>;
};


/** aggregate fields of "contact" */
export type Contact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "contact". All fields are combined with a logical 'AND'. */
export type Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Contact_Bool_Exp>>;
  _not?: InputMaybe<Contact_Bool_Exp>;
  _or?: InputMaybe<Array<Contact_Bool_Exp>>;
  contact_phone_numbers?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
  contact_phone_numbers_aggregate?: InputMaybe<Contact_Phone_Number_Aggregate_Bool_Exp>;
  contact_type?: InputMaybe<Contact_Type_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  property_lists?: InputMaybe<Property_List_Bool_Exp>;
  property_lists_aggregate?: InputMaybe<Property_List_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "contact" */
export enum Contact_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContactPkey = 'contact_pkey'
}

/** columns and relationships of "contact_health" */
export type Contact_Health = {
  __typename?: 'contact_health';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invalid_phones?: Maybe<Scalars['bigint']['output']>;
  total_phone_numbers?: Maybe<Scalars['bigint']['output']>;
  unassigned_phones?: Maybe<Scalars['bigint']['output']>;
  unique_agencies?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "contact_health" */
export type Contact_Health_Aggregate = {
  __typename?: 'contact_health_aggregate';
  aggregate?: Maybe<Contact_Health_Aggregate_Fields>;
  nodes: Array<Contact_Health>;
};

/** aggregate fields of "contact_health" */
export type Contact_Health_Aggregate_Fields = {
  __typename?: 'contact_health_aggregate_fields';
  avg?: Maybe<Contact_Health_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Contact_Health_Max_Fields>;
  min?: Maybe<Contact_Health_Min_Fields>;
  stddev?: Maybe<Contact_Health_Stddev_Fields>;
  stddev_pop?: Maybe<Contact_Health_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contact_Health_Stddev_Samp_Fields>;
  sum?: Maybe<Contact_Health_Sum_Fields>;
  var_pop?: Maybe<Contact_Health_Var_Pop_Fields>;
  var_samp?: Maybe<Contact_Health_Var_Samp_Fields>;
  variance?: Maybe<Contact_Health_Variance_Fields>;
};


/** aggregate fields of "contact_health" */
export type Contact_Health_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contact_Health_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Contact_Health_Avg_Fields = {
  __typename?: 'contact_health_avg_fields';
  invalid_phones?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
  unassigned_phones?: Maybe<Scalars['Float']['output']>;
  unique_agencies?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "contact_health". All fields are combined with a logical 'AND'. */
export type Contact_Health_Bool_Exp = {
  _and?: InputMaybe<Array<Contact_Health_Bool_Exp>>;
  _not?: InputMaybe<Contact_Health_Bool_Exp>;
  _or?: InputMaybe<Array<Contact_Health_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invalid_phones?: InputMaybe<Bigint_Comparison_Exp>;
  total_phone_numbers?: InputMaybe<Bigint_Comparison_Exp>;
  unassigned_phones?: InputMaybe<Bigint_Comparison_Exp>;
  unique_agencies?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Contact_Health_Max_Fields = {
  __typename?: 'contact_health_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invalid_phones?: Maybe<Scalars['bigint']['output']>;
  total_phone_numbers?: Maybe<Scalars['bigint']['output']>;
  unassigned_phones?: Maybe<Scalars['bigint']['output']>;
  unique_agencies?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Contact_Health_Min_Fields = {
  __typename?: 'contact_health_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invalid_phones?: Maybe<Scalars['bigint']['output']>;
  total_phone_numbers?: Maybe<Scalars['bigint']['output']>;
  unassigned_phones?: Maybe<Scalars['bigint']['output']>;
  unique_agencies?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "contact_health". */
export type Contact_Health_Order_By = {
  created_at?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invalid_phones?: InputMaybe<Order_By>;
  total_phone_numbers?: InputMaybe<Order_By>;
  unassigned_phones?: InputMaybe<Order_By>;
  unique_agencies?: InputMaybe<Order_By>;
};

/** select columns of table "contact_health" */
export enum Contact_Health_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  InvalidPhones = 'invalid_phones',
  /** column name */
  TotalPhoneNumbers = 'total_phone_numbers',
  /** column name */
  UnassignedPhones = 'unassigned_phones',
  /** column name */
  UniqueAgencies = 'unique_agencies'
}

/** aggregate stddev on columns */
export type Contact_Health_Stddev_Fields = {
  __typename?: 'contact_health_stddev_fields';
  invalid_phones?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
  unassigned_phones?: Maybe<Scalars['Float']['output']>;
  unique_agencies?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Contact_Health_Stddev_Pop_Fields = {
  __typename?: 'contact_health_stddev_pop_fields';
  invalid_phones?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
  unassigned_phones?: Maybe<Scalars['Float']['output']>;
  unique_agencies?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Contact_Health_Stddev_Samp_Fields = {
  __typename?: 'contact_health_stddev_samp_fields';
  invalid_phones?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
  unassigned_phones?: Maybe<Scalars['Float']['output']>;
  unique_agencies?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "contact_health" */
export type Contact_Health_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contact_Health_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contact_Health_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalid_phones?: InputMaybe<Scalars['bigint']['input']>;
  total_phone_numbers?: InputMaybe<Scalars['bigint']['input']>;
  unassigned_phones?: InputMaybe<Scalars['bigint']['input']>;
  unique_agencies?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Contact_Health_Sum_Fields = {
  __typename?: 'contact_health_sum_fields';
  invalid_phones?: Maybe<Scalars['bigint']['output']>;
  total_phone_numbers?: Maybe<Scalars['bigint']['output']>;
  unassigned_phones?: Maybe<Scalars['bigint']['output']>;
  unique_agencies?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Contact_Health_Var_Pop_Fields = {
  __typename?: 'contact_health_var_pop_fields';
  invalid_phones?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
  unassigned_phones?: Maybe<Scalars['Float']['output']>;
  unique_agencies?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Contact_Health_Var_Samp_Fields = {
  __typename?: 'contact_health_var_samp_fields';
  invalid_phones?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
  unassigned_phones?: Maybe<Scalars['Float']['output']>;
  unique_agencies?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Contact_Health_Variance_Fields = {
  __typename?: 'contact_health_variance_fields';
  invalid_phones?: Maybe<Scalars['Float']['output']>;
  total_phone_numbers?: Maybe<Scalars['Float']['output']>;
  unassigned_phones?: Maybe<Scalars['Float']['output']>;
  unique_agencies?: Maybe<Scalars['Float']['output']>;
};

/** input type for inserting data into table "contact" */
export type Contact_Insert_Input = {
  contact_phone_numbers?: InputMaybe<Contact_Phone_Number_Arr_Rel_Insert_Input>;
  contact_type?: InputMaybe<Contact_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_lists?: InputMaybe<Property_List_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Contact_Max_Fields = {
  __typename?: 'contact_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Contact_Min_Fields = {
  __typename?: 'contact_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "contact" */
export type Contact_Mutation_Response = {
  __typename?: 'contact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Contact>;
};

/** input type for inserting object relation for remote table "contact" */
export type Contact_Obj_Rel_Insert_Input = {
  data: Contact_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Contact_On_Conflict>;
};

/** on_conflict condition type for table "contact" */
export type Contact_On_Conflict = {
  constraint: Contact_Constraint;
  update_columns?: Array<Contact_Update_Column>;
  where?: InputMaybe<Contact_Bool_Exp>;
};

/** Ordering options when selecting data from "contact". */
export type Contact_Order_By = {
  contact_phone_numbers_aggregate?: InputMaybe<Contact_Phone_Number_Aggregate_Order_By>;
  contact_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_lists_aggregate?: InputMaybe<Property_List_Aggregate_Order_By>;
};

/** Tabele per lidhjen e numrit te telefonit me kontaktin dhe agjensine perkatese */
export type Contact_Phone_Number = {
  __typename?: 'contact_phone_number';
  /** An object relationship */
  agency: Agency;
  agency_id: Scalars['uuid']['output'];
  /** An object relationship */
  contact?: Maybe<Contact>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  phone_number: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "contact_phone_number" */
export type Contact_Phone_Number_Aggregate = {
  __typename?: 'contact_phone_number_aggregate';
  aggregate?: Maybe<Contact_Phone_Number_Aggregate_Fields>;
  nodes: Array<Contact_Phone_Number>;
};

export type Contact_Phone_Number_Aggregate_Bool_Exp = {
  count?: InputMaybe<Contact_Phone_Number_Aggregate_Bool_Exp_Count>;
};

export type Contact_Phone_Number_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Contact_Phone_Number_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "contact_phone_number" */
export type Contact_Phone_Number_Aggregate_Fields = {
  __typename?: 'contact_phone_number_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Contact_Phone_Number_Max_Fields>;
  min?: Maybe<Contact_Phone_Number_Min_Fields>;
};


/** aggregate fields of "contact_phone_number" */
export type Contact_Phone_Number_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contact_Phone_Number_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "contact_phone_number" */
export type Contact_Phone_Number_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Contact_Phone_Number_Max_Order_By>;
  min?: InputMaybe<Contact_Phone_Number_Min_Order_By>;
};

/** input type for inserting array relation for remote table "contact_phone_number" */
export type Contact_Phone_Number_Arr_Rel_Insert_Input = {
  data: Array<Contact_Phone_Number_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Contact_Phone_Number_On_Conflict>;
};

/** Boolean expression to filter rows from the table "contact_phone_number". All fields are combined with a logical 'AND'. */
export type Contact_Phone_Number_Bool_Exp = {
  _and?: InputMaybe<Array<Contact_Phone_Number_Bool_Exp>>;
  _not?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
  _or?: InputMaybe<Array<Contact_Phone_Number_Bool_Exp>>;
  agency?: InputMaybe<Agency_Bool_Exp>;
  agency_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "contact_phone_number" */
export enum Contact_Phone_Number_Constraint {
  /** unique or primary key constraint on columns "phone_number", "agency_id" */
  ContactPhoneNumberPhoneNumberAgencyIdKey = 'contact_phone_number_phone_number_agency_id_key',
  /** unique or primary key constraint on columns "id" */
  ContactPhoneNumberPkey = 'contact_phone_number_pkey'
}

/** input type for inserting data into table "contact_phone_number" */
export type Contact_Phone_Number_Insert_Input = {
  agency?: InputMaybe<Agency_Obj_Rel_Insert_Input>;
  agency_id?: InputMaybe<Scalars['uuid']['input']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Contact_Phone_Number_Max_Fields = {
  __typename?: 'contact_phone_number_max_fields';
  agency_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "contact_phone_number" */
export type Contact_Phone_Number_Max_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Contact_Phone_Number_Min_Fields = {
  __typename?: 'contact_phone_number_min_fields';
  agency_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "contact_phone_number" */
export type Contact_Phone_Number_Min_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "contact_phone_number" */
export type Contact_Phone_Number_Mutation_Response = {
  __typename?: 'contact_phone_number_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Contact_Phone_Number>;
};

/** on_conflict condition type for table "contact_phone_number" */
export type Contact_Phone_Number_On_Conflict = {
  constraint: Contact_Phone_Number_Constraint;
  update_columns?: Array<Contact_Phone_Number_Update_Column>;
  where?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
};

/** Ordering options when selecting data from "contact_phone_number". */
export type Contact_Phone_Number_Order_By = {
  agency?: InputMaybe<Agency_Order_By>;
  agency_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contact_phone_number */
export type Contact_Phone_Number_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "contact_phone_number" */
export enum Contact_Phone_Number_Select_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "contact_phone_number" */
export type Contact_Phone_Number_Set_Input = {
  agency_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "contact_phone_number" */
export type Contact_Phone_Number_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contact_Phone_Number_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contact_Phone_Number_Stream_Cursor_Value_Input = {
  agency_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "contact_phone_number" */
export enum Contact_Phone_Number_Update_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Contact_Phone_Number_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contact_Phone_Number_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contact_Phone_Number_Bool_Exp;
};

/** primary key columns input for table: contact */
export type Contact_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "contact" */
export enum Contact_Select_Column {
  /** column name */
  ContactType = 'contact_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "contact" */
export type Contact_Set_Input = {
  contact_type?: InputMaybe<Contact_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "contact" */
export type Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contact_Stream_Cursor_Value_Input = {
  contact_type?: InputMaybe<Contact_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "contact_type" */
export type Contact_Type = {
  __typename?: 'contact_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "contact_type" */
export type Contact_Type_Aggregate = {
  __typename?: 'contact_type_aggregate';
  aggregate?: Maybe<Contact_Type_Aggregate_Fields>;
  nodes: Array<Contact_Type>;
};

/** aggregate fields of "contact_type" */
export type Contact_Type_Aggregate_Fields = {
  __typename?: 'contact_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Contact_Type_Max_Fields>;
  min?: Maybe<Contact_Type_Min_Fields>;
};


/** aggregate fields of "contact_type" */
export type Contact_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contact_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "contact_type". All fields are combined with a logical 'AND'. */
export type Contact_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Contact_Type_Bool_Exp>>;
  _not?: InputMaybe<Contact_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Contact_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "contact_type" */
export enum Contact_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  ContactTypePkey = 'contact_type_pkey'
}

export enum Contact_Type_Enum {
  Agent = 'agent'
}

/** Boolean expression to compare columns of type "contact_type_enum". All fields are combined with logical 'AND'. */
export type Contact_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Contact_Type_Enum>;
  _in?: InputMaybe<Array<Contact_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Contact_Type_Enum>;
  _nin?: InputMaybe<Array<Contact_Type_Enum>>;
};

/** input type for inserting data into table "contact_type" */
export type Contact_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Contact_Type_Max_Fields = {
  __typename?: 'contact_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Contact_Type_Min_Fields = {
  __typename?: 'contact_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "contact_type" */
export type Contact_Type_Mutation_Response = {
  __typename?: 'contact_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Contact_Type>;
};

/** on_conflict condition type for table "contact_type" */
export type Contact_Type_On_Conflict = {
  constraint: Contact_Type_Constraint;
  update_columns?: Array<Contact_Type_Update_Column>;
  where?: InputMaybe<Contact_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "contact_type". */
export type Contact_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contact_type */
export type Contact_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "contact_type" */
export enum Contact_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "contact_type" */
export type Contact_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "contact_type" */
export type Contact_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contact_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contact_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "contact_type" */
export enum Contact_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Contact_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contact_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contact_Type_Bool_Exp;
};

/** update columns of table "contact" */
export enum Contact_Update_Column {
  /** column name */
  ContactType = 'contact_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id'
}

export type Contact_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contact_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contact_Bool_Exp;
};

/** in conjunction with translate and entities it specifies what part of a table is translated ex title, description etc */
export type Content_Type = {
  __typename?: 'content_type';
  content_type: Scalars['String']['output'];
};

/** aggregated selection of "content_type" */
export type Content_Type_Aggregate = {
  __typename?: 'content_type_aggregate';
  aggregate?: Maybe<Content_Type_Aggregate_Fields>;
  nodes: Array<Content_Type>;
};

/** aggregate fields of "content_type" */
export type Content_Type_Aggregate_Fields = {
  __typename?: 'content_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Content_Type_Max_Fields>;
  min?: Maybe<Content_Type_Min_Fields>;
};


/** aggregate fields of "content_type" */
export type Content_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Content_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "content_type". All fields are combined with a logical 'AND'. */
export type Content_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Content_Type_Bool_Exp>>;
  _not?: InputMaybe<Content_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Content_Type_Bool_Exp>>;
  content_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "content_type" */
export enum Content_Type_Constraint {
  /** unique or primary key constraint on columns "content_type" */
  ContentTypePkey = 'content_type_pkey'
}

export enum Content_Type_Enum {
  Description = 'description',
  Name = 'name',
  Notification = 'notification',
  SeoDescription = 'seo_description',
  SeoKeywords = 'seo_keywords',
  SeoTitle = 'seo_title',
  Title = 'title'
}

/** Boolean expression to compare columns of type "content_type_enum". All fields are combined with logical 'AND'. */
export type Content_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Content_Type_Enum>;
  _in?: InputMaybe<Array<Content_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Content_Type_Enum>;
  _nin?: InputMaybe<Array<Content_Type_Enum>>;
};

/** input type for inserting data into table "content_type" */
export type Content_Type_Insert_Input = {
  content_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Content_Type_Max_Fields = {
  __typename?: 'content_type_max_fields';
  content_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Content_Type_Min_Fields = {
  __typename?: 'content_type_min_fields';
  content_type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "content_type" */
export type Content_Type_Mutation_Response = {
  __typename?: 'content_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Content_Type>;
};

/** on_conflict condition type for table "content_type" */
export type Content_Type_On_Conflict = {
  constraint: Content_Type_Constraint;
  update_columns?: Array<Content_Type_Update_Column>;
  where?: InputMaybe<Content_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "content_type". */
export type Content_Type_Order_By = {
  content_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: content_type */
export type Content_Type_Pk_Columns_Input = {
  content_type: Scalars['String']['input'];
};

/** select columns of table "content_type" */
export enum Content_Type_Select_Column {
  /** column name */
  ContentType = 'content_type'
}

/** input type for updating data in table "content_type" */
export type Content_Type_Set_Input = {
  content_type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "content_type" */
export type Content_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Content_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Content_Type_Stream_Cursor_Value_Input = {
  content_type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "content_type" */
export enum Content_Type_Update_Column {
  /** column name */
  ContentType = 'content_type'
}

export type Content_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Content_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Content_Type_Bool_Exp;
};

/** columns and relationships of "countries" */
export type Countries = {
  __typename?: 'countries';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  phone_code: Scalars['String']['output'];
};

/** aggregated selection of "countries" */
export type Countries_Aggregate = {
  __typename?: 'countries_aggregate';
  aggregate?: Maybe<Countries_Aggregate_Fields>;
  nodes: Array<Countries>;
};

/** aggregate fields of "countries" */
export type Countries_Aggregate_Fields = {
  __typename?: 'countries_aggregate_fields';
  avg?: Maybe<Countries_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Countries_Max_Fields>;
  min?: Maybe<Countries_Min_Fields>;
  stddev?: Maybe<Countries_Stddev_Fields>;
  stddev_pop?: Maybe<Countries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Countries_Stddev_Samp_Fields>;
  sum?: Maybe<Countries_Sum_Fields>;
  var_pop?: Maybe<Countries_Var_Pop_Fields>;
  var_samp?: Maybe<Countries_Var_Samp_Fields>;
  variance?: Maybe<Countries_Variance_Fields>;
};


/** aggregate fields of "countries" */
export type Countries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Countries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Countries_Avg_Fields = {
  __typename?: 'countries_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "countries". All fields are combined with a logical 'AND'. */
export type Countries_Bool_Exp = {
  _and?: InputMaybe<Array<Countries_Bool_Exp>>;
  _not?: InputMaybe<Countries_Bool_Exp>;
  _or?: InputMaybe<Array<Countries_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone_code?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "countries" */
export enum Countries_Constraint {
  /** unique or primary key constraint on columns "id" */
  CountriesPkey = 'countries_pkey'
}

/** input type for incrementing numeric columns in table "countries" */
export type Countries_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "countries" */
export type Countries_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_code?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Countries_Max_Fields = {
  __typename?: 'countries_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_code?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Countries_Min_Fields = {
  __typename?: 'countries_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_code?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "countries" */
export type Countries_Mutation_Response = {
  __typename?: 'countries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Countries>;
};

/** on_conflict condition type for table "countries" */
export type Countries_On_Conflict = {
  constraint: Countries_Constraint;
  update_columns?: Array<Countries_Update_Column>;
  where?: InputMaybe<Countries_Bool_Exp>;
};

/** Ordering options when selecting data from "countries". */
export type Countries_Order_By = {
  code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone_code?: InputMaybe<Order_By>;
};

/** primary key columns input for table: countries */
export type Countries_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "countries" */
export enum Countries_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneCode = 'phone_code'
}

/** input type for updating data in table "countries" */
export type Countries_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_code?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Countries_Stddev_Fields = {
  __typename?: 'countries_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Countries_Stddev_Pop_Fields = {
  __typename?: 'countries_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Countries_Stddev_Samp_Fields = {
  __typename?: 'countries_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "countries" */
export type Countries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Countries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Countries_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_code?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Countries_Sum_Fields = {
  __typename?: 'countries_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "countries" */
export enum Countries_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneCode = 'phone_code'
}

export type Countries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Countries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Countries_Set_Input>;
  /** filter the rows which have to be updated */
  where: Countries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Countries_Var_Pop_Fields = {
  __typename?: 'countries_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Countries_Var_Samp_Fields = {
  __typename?: 'countries_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Countries_Variance_Fields = {
  __typename?: 'countries_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "country" */
export type Country = {
  __typename?: 'country';
  country_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "country" */
export type Country_Aggregate = {
  __typename?: 'country_aggregate';
  aggregate?: Maybe<Country_Aggregate_Fields>;
  nodes: Array<Country>;
};

/** aggregate fields of "country" */
export type Country_Aggregate_Fields = {
  __typename?: 'country_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Country_Max_Fields>;
  min?: Maybe<Country_Min_Fields>;
};


/** aggregate fields of "country" */
export type Country_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Country_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "country". All fields are combined with a logical 'AND'. */
export type Country_Bool_Exp = {
  _and?: InputMaybe<Array<Country_Bool_Exp>>;
  _not?: InputMaybe<Country_Bool_Exp>;
  _or?: InputMaybe<Array<Country_Bool_Exp>>;
  country_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "country" */
export enum Country_Constraint {
  /** unique or primary key constraint on columns "country_name" */
  CountryCountryNameKey = 'country_country_name_key',
  /** unique or primary key constraint on columns "id" */
  CountryPkey = 'country_pkey'
}

/** input type for inserting data into table "country" */
export type Country_Insert_Input = {
  country_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Country_Max_Fields = {
  __typename?: 'country_max_fields';
  country_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Country_Min_Fields = {
  __typename?: 'country_min_fields';
  country_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "country" */
export type Country_Mutation_Response = {
  __typename?: 'country_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Country>;
};

/** on_conflict condition type for table "country" */
export type Country_On_Conflict = {
  constraint: Country_Constraint;
  update_columns?: Array<Country_Update_Column>;
  where?: InputMaybe<Country_Bool_Exp>;
};

/** Ordering options when selecting data from "country". */
export type Country_Order_By = {
  country_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: country */
export type Country_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "country" */
export enum Country_Select_Column {
  /** column name */
  CountryName = 'country_name',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "country" */
export type Country_Set_Input = {
  country_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "country" */
export type Country_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Country_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Country_Stream_Cursor_Value_Input = {
  country_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "country" */
export enum Country_Update_Column {
  /** column name */
  CountryName = 'country_name',
  /** column name */
  Id = 'id'
}

export type Country_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Country_Set_Input>;
  /** filter the rows which have to be updated */
  where: Country_Bool_Exp;
};

/** columns and relationships of "currency" */
export type Currency = {
  __typename?: 'currency';
  currency: Scalars['String']['output'];
};

export type Currency_ActionType = {
  __typename?: 'currency_ActionType';
  currency: Scalars['String']['output'];
};

/** aggregated selection of "currency" */
export type Currency_Aggregate = {
  __typename?: 'currency_aggregate';
  aggregate?: Maybe<Currency_Aggregate_Fields>;
  nodes: Array<Currency>;
};

/** aggregate fields of "currency" */
export type Currency_Aggregate_Fields = {
  __typename?: 'currency_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Currency_Max_Fields>;
  min?: Maybe<Currency_Min_Fields>;
};


/** aggregate fields of "currency" */
export type Currency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Currency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "currency". All fields are combined with a logical 'AND'. */
export type Currency_Bool_Exp = {
  _and?: InputMaybe<Array<Currency_Bool_Exp>>;
  _not?: InputMaybe<Currency_Bool_Exp>;
  _or?: InputMaybe<Array<Currency_Bool_Exp>>;
  currency?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "currency" */
export enum Currency_Constraint {
  /** unique or primary key constraint on columns "currency" */
  CurrencyPkey = 'currency_pkey'
}

export enum Currency_Enum {
  Eur = 'EUR',
  Gbp = 'GBP',
  Leke = 'LEKE',
  Usd = 'USD'
}

/** Boolean expression to compare columns of type "currency_enum". All fields are combined with logical 'AND'. */
export type Currency_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Currency_Enum>;
  _in?: InputMaybe<Array<Currency_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Currency_Enum>;
  _nin?: InputMaybe<Array<Currency_Enum>>;
};

/** currency exchange rates updated */
export type Currency_Exchange_Rates = {
  __typename?: 'currency_exchange_rates';
  base_currency_code: Main_Currency_Enum;
  exchange_rate: Scalars['numeric']['output'];
  id: Scalars['Int']['output'];
  target_currency_code: Main_Currency_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "currency_exchange_rates" */
export type Currency_Exchange_Rates_Aggregate = {
  __typename?: 'currency_exchange_rates_aggregate';
  aggregate?: Maybe<Currency_Exchange_Rates_Aggregate_Fields>;
  nodes: Array<Currency_Exchange_Rates>;
};

/** aggregate fields of "currency_exchange_rates" */
export type Currency_Exchange_Rates_Aggregate_Fields = {
  __typename?: 'currency_exchange_rates_aggregate_fields';
  avg?: Maybe<Currency_Exchange_Rates_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Currency_Exchange_Rates_Max_Fields>;
  min?: Maybe<Currency_Exchange_Rates_Min_Fields>;
  stddev?: Maybe<Currency_Exchange_Rates_Stddev_Fields>;
  stddev_pop?: Maybe<Currency_Exchange_Rates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Currency_Exchange_Rates_Stddev_Samp_Fields>;
  sum?: Maybe<Currency_Exchange_Rates_Sum_Fields>;
  var_pop?: Maybe<Currency_Exchange_Rates_Var_Pop_Fields>;
  var_samp?: Maybe<Currency_Exchange_Rates_Var_Samp_Fields>;
  variance?: Maybe<Currency_Exchange_Rates_Variance_Fields>;
};


/** aggregate fields of "currency_exchange_rates" */
export type Currency_Exchange_Rates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Currency_Exchange_Rates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Currency_Exchange_Rates_Avg_Fields = {
  __typename?: 'currency_exchange_rates_avg_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "currency_exchange_rates". All fields are combined with a logical 'AND'. */
export type Currency_Exchange_Rates_Bool_Exp = {
  _and?: InputMaybe<Array<Currency_Exchange_Rates_Bool_Exp>>;
  _not?: InputMaybe<Currency_Exchange_Rates_Bool_Exp>;
  _or?: InputMaybe<Array<Currency_Exchange_Rates_Bool_Exp>>;
  base_currency_code?: InputMaybe<Main_Currency_Enum_Comparison_Exp>;
  exchange_rate?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  target_currency_code?: InputMaybe<Main_Currency_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "currency_exchange_rates" */
export enum Currency_Exchange_Rates_Constraint {
  /** unique or primary key constraint on columns "target_currency_code", "base_currency_code" */
  CurrencyExchangeRatesBaseCurrencyCodeTargetCurrencyKey = 'currency_exchange_rates_base_currency_code_target_currency__key',
  /** unique or primary key constraint on columns "id" */
  CurrencyExchangeRatesPkey = 'currency_exchange_rates_pkey'
}

/** input type for incrementing numeric columns in table "currency_exchange_rates" */
export type Currency_Exchange_Rates_Inc_Input = {
  exchange_rate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "currency_exchange_rates" */
export type Currency_Exchange_Rates_Insert_Input = {
  base_currency_code?: InputMaybe<Main_Currency_Enum>;
  exchange_rate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  target_currency_code?: InputMaybe<Main_Currency_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Currency_Exchange_Rates_Max_Fields = {
  __typename?: 'currency_exchange_rates_max_fields';
  exchange_rate?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Currency_Exchange_Rates_Min_Fields = {
  __typename?: 'currency_exchange_rates_min_fields';
  exchange_rate?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "currency_exchange_rates" */
export type Currency_Exchange_Rates_Mutation_Response = {
  __typename?: 'currency_exchange_rates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Currency_Exchange_Rates>;
};

/** on_conflict condition type for table "currency_exchange_rates" */
export type Currency_Exchange_Rates_On_Conflict = {
  constraint: Currency_Exchange_Rates_Constraint;
  update_columns?: Array<Currency_Exchange_Rates_Update_Column>;
  where?: InputMaybe<Currency_Exchange_Rates_Bool_Exp>;
};

/** Ordering options when selecting data from "currency_exchange_rates". */
export type Currency_Exchange_Rates_Order_By = {
  base_currency_code?: InputMaybe<Order_By>;
  exchange_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  target_currency_code?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: currency_exchange_rates */
export type Currency_Exchange_Rates_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "currency_exchange_rates" */
export enum Currency_Exchange_Rates_Select_Column {
  /** column name */
  BaseCurrencyCode = 'base_currency_code',
  /** column name */
  ExchangeRate = 'exchange_rate',
  /** column name */
  Id = 'id',
  /** column name */
  TargetCurrencyCode = 'target_currency_code',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "currency_exchange_rates" */
export type Currency_Exchange_Rates_Set_Input = {
  base_currency_code?: InputMaybe<Main_Currency_Enum>;
  exchange_rate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  target_currency_code?: InputMaybe<Main_Currency_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Currency_Exchange_Rates_Stddev_Fields = {
  __typename?: 'currency_exchange_rates_stddev_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Currency_Exchange_Rates_Stddev_Pop_Fields = {
  __typename?: 'currency_exchange_rates_stddev_pop_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Currency_Exchange_Rates_Stddev_Samp_Fields = {
  __typename?: 'currency_exchange_rates_stddev_samp_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "currency_exchange_rates" */
export type Currency_Exchange_Rates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Currency_Exchange_Rates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Currency_Exchange_Rates_Stream_Cursor_Value_Input = {
  base_currency_code?: InputMaybe<Main_Currency_Enum>;
  exchange_rate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  target_currency_code?: InputMaybe<Main_Currency_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Currency_Exchange_Rates_Sum_Fields = {
  __typename?: 'currency_exchange_rates_sum_fields';
  exchange_rate?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "currency_exchange_rates" */
export enum Currency_Exchange_Rates_Update_Column {
  /** column name */
  BaseCurrencyCode = 'base_currency_code',
  /** column name */
  ExchangeRate = 'exchange_rate',
  /** column name */
  Id = 'id',
  /** column name */
  TargetCurrencyCode = 'target_currency_code',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Currency_Exchange_Rates_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Currency_Exchange_Rates_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Currency_Exchange_Rates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Currency_Exchange_Rates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Currency_Exchange_Rates_Var_Pop_Fields = {
  __typename?: 'currency_exchange_rates_var_pop_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Currency_Exchange_Rates_Var_Samp_Fields = {
  __typename?: 'currency_exchange_rates_var_samp_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Currency_Exchange_Rates_Variance_Fields = {
  __typename?: 'currency_exchange_rates_variance_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** input type for inserting data into table "currency" */
export type Currency_Insert_Input = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Currency_Max_Fields = {
  __typename?: 'currency_max_fields';
  currency?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Currency_Min_Fields = {
  __typename?: 'currency_min_fields';
  currency?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "currency" */
export type Currency_Mutation_Response = {
  __typename?: 'currency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Currency>;
};

/** on_conflict condition type for table "currency" */
export type Currency_On_Conflict = {
  constraint: Currency_Constraint;
  update_columns?: Array<Currency_Update_Column>;
  where?: InputMaybe<Currency_Bool_Exp>;
};

/** Ordering options when selecting data from "currency". */
export type Currency_Order_By = {
  currency?: InputMaybe<Order_By>;
};

/** primary key columns input for table: currency */
export type Currency_Pk_Columns_Input = {
  currency: Scalars['String']['input'];
};

/** select columns of table "currency" */
export enum Currency_Select_Column {
  /** column name */
  Currency = 'currency'
}

/** input type for updating data in table "currency" */
export type Currency_Set_Input = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "currency" */
export type Currency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Currency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Currency_Stream_Cursor_Value_Input = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "currency" */
export enum Currency_Update_Column {
  /** column name */
  Currency = 'currency'
}

export type Currency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Currency_Set_Input>;
  /** filter the rows which have to be updated */
  where: Currency_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** dailyRegisteredUsersNative Query Arguments */
export type DailyRegisteredUsers_Arguments = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

export type Daily_Active_Users_Model = {
  __typename?: 'daily_active_users_model';
  agencies_nr?: Maybe<Scalars['bigint']['output']>;
  listers_nr?: Maybe<Scalars['bigint']['output']>;
  report_date?: Maybe<Scalars['date']['output']>;
  seeker_nr?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the logical model for "daily_active_users_model". All fields are combined with a logical 'AND'. */
export type Daily_Active_Users_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Daily_Active_Users_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Daily_Active_Users_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Daily_Active_Users_Model_Bool_Exp_Bool_Exp>>;
  agencies_nr?: InputMaybe<Bigint_Comparison_Exp>;
  listers_nr?: InputMaybe<Bigint_Comparison_Exp>;
  report_date?: InputMaybe<Date_Comparison_Exp>;
  seeker_nr?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Daily_Active_Users_Model_Enum_Name {
  /** column name */
  AgenciesNr = 'agencies_nr',
  /** column name */
  ListersNr = 'listers_nr',
  /** column name */
  ReportDate = 'report_date',
  /** column name */
  SeekerNr = 'seeker_nr'
}

/** Ordering options when selecting data from "daily_active_users_model". */
export type Daily_Active_Users_Model_Order_By = {
  agencies_nr?: InputMaybe<Order_By>;
  listers_nr?: InputMaybe<Order_By>;
  report_date?: InputMaybe<Order_By>;
  seeker_nr?: InputMaybe<Order_By>;
};

export type Daily_Views = {
  __typename?: 'daily_views';
  total_views?: Maybe<Scalars['bigint']['output']>;
  view_date?: Maybe<Scalars['date']['output']>;
};

/** Boolean expression to filter rows from the logical model for "daily_views". All fields are combined with a logical 'AND'. */
export type Daily_Views_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Daily_Views_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Daily_Views_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Daily_Views_Bool_Exp_Bool_Exp>>;
  total_views?: InputMaybe<Bigint_Comparison_Exp>;
  view_date?: InputMaybe<Date_Comparison_Exp>;
};

export enum Daily_Views_Enum_Name {
  /** column name */
  TotalViews = 'total_views',
  /** column name */
  ViewDate = 'view_date'
}

/** Ordering options when selecting data from "daily_views". */
export type Daily_Views_Order_By = {
  total_views?: InputMaybe<Order_By>;
  view_date?: InputMaybe<Order_By>;
};

/** daliyActiveUsersNative Query Arguments */
export type DaliyActiveUsers_Arguments = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

/** daliyQueriesStatisticsNative Query Arguments */
export type DaliyQueriesStatistics_Arguments = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

export type Daliy_Queries_Statistics_Model = {
  __typename?: 'daliy_queries_statistics_model';
  report_date?: Maybe<Scalars['date']['output']>;
  total_queries?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the logical model for "daliy_queries_statistics_model". All fields are combined with a logical 'AND'. */
export type Daliy_Queries_Statistics_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Daliy_Queries_Statistics_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Daliy_Queries_Statistics_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Daliy_Queries_Statistics_Model_Bool_Exp_Bool_Exp>>;
  report_date?: InputMaybe<Date_Comparison_Exp>;
  total_queries?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Daliy_Queries_Statistics_Model_Enum_Name {
  /** column name */
  ReportDate = 'report_date',
  /** column name */
  TotalQueries = 'total_queries'
}

/** Ordering options when selecting data from "daliy_queries_statistics_model". */
export type Daliy_Queries_Statistics_Model_Order_By = {
  report_date?: InputMaybe<Order_By>;
  total_queries?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "duplicate_cfn_with_null_cname" */
export type Duplicate_Cfn_With_Null_Cname = {
  __typename?: 'duplicate_cfn_with_null_cname';
  agency_id?: Maybe<Scalars['uuid']['output']>;
  contact_ids?: Maybe<Array<Scalars['uuid']['output']>>;
  contact_names?: Maybe<Array<Scalars['String']['output']>>;
  contact_phone_count?: Maybe<Scalars['bigint']['output']>;
  first_created?: Maybe<Scalars['timestamptz']['output']>;
  has_null_name_contact?: Maybe<Scalars['Boolean']['output']>;
  last_created?: Maybe<Scalars['timestamptz']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "duplicate_cfn_with_null_cname" */
export type Duplicate_Cfn_With_Null_Cname_Aggregate = {
  __typename?: 'duplicate_cfn_with_null_cname_aggregate';
  aggregate?: Maybe<Duplicate_Cfn_With_Null_Cname_Aggregate_Fields>;
  nodes: Array<Duplicate_Cfn_With_Null_Cname>;
};

/** aggregate fields of "duplicate_cfn_with_null_cname" */
export type Duplicate_Cfn_With_Null_Cname_Aggregate_Fields = {
  __typename?: 'duplicate_cfn_with_null_cname_aggregate_fields';
  avg?: Maybe<Duplicate_Cfn_With_Null_Cname_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Duplicate_Cfn_With_Null_Cname_Max_Fields>;
  min?: Maybe<Duplicate_Cfn_With_Null_Cname_Min_Fields>;
  stddev?: Maybe<Duplicate_Cfn_With_Null_Cname_Stddev_Fields>;
  stddev_pop?: Maybe<Duplicate_Cfn_With_Null_Cname_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Duplicate_Cfn_With_Null_Cname_Stddev_Samp_Fields>;
  sum?: Maybe<Duplicate_Cfn_With_Null_Cname_Sum_Fields>;
  var_pop?: Maybe<Duplicate_Cfn_With_Null_Cname_Var_Pop_Fields>;
  var_samp?: Maybe<Duplicate_Cfn_With_Null_Cname_Var_Samp_Fields>;
  variance?: Maybe<Duplicate_Cfn_With_Null_Cname_Variance_Fields>;
};


/** aggregate fields of "duplicate_cfn_with_null_cname" */
export type Duplicate_Cfn_With_Null_Cname_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Duplicate_Cfn_With_Null_Cname_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Duplicate_Cfn_With_Null_Cname_Avg_Fields = {
  __typename?: 'duplicate_cfn_with_null_cname_avg_fields';
  contact_phone_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "duplicate_cfn_with_null_cname". All fields are combined with a logical 'AND'. */
export type Duplicate_Cfn_With_Null_Cname_Bool_Exp = {
  _and?: InputMaybe<Array<Duplicate_Cfn_With_Null_Cname_Bool_Exp>>;
  _not?: InputMaybe<Duplicate_Cfn_With_Null_Cname_Bool_Exp>;
  _or?: InputMaybe<Array<Duplicate_Cfn_With_Null_Cname_Bool_Exp>>;
  agency_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact_ids?: InputMaybe<Uuid_Array_Comparison_Exp>;
  contact_names?: InputMaybe<String_Array_Comparison_Exp>;
  contact_phone_count?: InputMaybe<Bigint_Comparison_Exp>;
  first_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  has_null_name_contact?: InputMaybe<Boolean_Comparison_Exp>;
  last_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Duplicate_Cfn_With_Null_Cname_Max_Fields = {
  __typename?: 'duplicate_cfn_with_null_cname_max_fields';
  agency_id?: Maybe<Scalars['uuid']['output']>;
  contact_ids?: Maybe<Array<Scalars['uuid']['output']>>;
  contact_names?: Maybe<Array<Scalars['String']['output']>>;
  contact_phone_count?: Maybe<Scalars['bigint']['output']>;
  first_created?: Maybe<Scalars['timestamptz']['output']>;
  last_created?: Maybe<Scalars['timestamptz']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Duplicate_Cfn_With_Null_Cname_Min_Fields = {
  __typename?: 'duplicate_cfn_with_null_cname_min_fields';
  agency_id?: Maybe<Scalars['uuid']['output']>;
  contact_ids?: Maybe<Array<Scalars['uuid']['output']>>;
  contact_names?: Maybe<Array<Scalars['String']['output']>>;
  contact_phone_count?: Maybe<Scalars['bigint']['output']>;
  first_created?: Maybe<Scalars['timestamptz']['output']>;
  last_created?: Maybe<Scalars['timestamptz']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "duplicate_cfn_with_null_cname". */
export type Duplicate_Cfn_With_Null_Cname_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  contact_ids?: InputMaybe<Order_By>;
  contact_names?: InputMaybe<Order_By>;
  contact_phone_count?: InputMaybe<Order_By>;
  first_created?: InputMaybe<Order_By>;
  has_null_name_contact?: InputMaybe<Order_By>;
  last_created?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
};

/** select columns of table "duplicate_cfn_with_null_cname" */
export enum Duplicate_Cfn_With_Null_Cname_Select_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  ContactIds = 'contact_ids',
  /** column name */
  ContactNames = 'contact_names',
  /** column name */
  ContactPhoneCount = 'contact_phone_count',
  /** column name */
  FirstCreated = 'first_created',
  /** column name */
  HasNullNameContact = 'has_null_name_contact',
  /** column name */
  LastCreated = 'last_created',
  /** column name */
  PhoneNumber = 'phone_number'
}

/** aggregate stddev on columns */
export type Duplicate_Cfn_With_Null_Cname_Stddev_Fields = {
  __typename?: 'duplicate_cfn_with_null_cname_stddev_fields';
  contact_phone_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Duplicate_Cfn_With_Null_Cname_Stddev_Pop_Fields = {
  __typename?: 'duplicate_cfn_with_null_cname_stddev_pop_fields';
  contact_phone_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Duplicate_Cfn_With_Null_Cname_Stddev_Samp_Fields = {
  __typename?: 'duplicate_cfn_with_null_cname_stddev_samp_fields';
  contact_phone_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "duplicate_cfn_with_null_cname" */
export type Duplicate_Cfn_With_Null_Cname_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Duplicate_Cfn_With_Null_Cname_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Duplicate_Cfn_With_Null_Cname_Stream_Cursor_Value_Input = {
  agency_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  contact_names?: InputMaybe<Array<Scalars['String']['input']>>;
  contact_phone_count?: InputMaybe<Scalars['bigint']['input']>;
  first_created?: InputMaybe<Scalars['timestamptz']['input']>;
  has_null_name_contact?: InputMaybe<Scalars['Boolean']['input']>;
  last_created?: InputMaybe<Scalars['timestamptz']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Duplicate_Cfn_With_Null_Cname_Sum_Fields = {
  __typename?: 'duplicate_cfn_with_null_cname_sum_fields';
  contact_phone_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Duplicate_Cfn_With_Null_Cname_Var_Pop_Fields = {
  __typename?: 'duplicate_cfn_with_null_cname_var_pop_fields';
  contact_phone_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Duplicate_Cfn_With_Null_Cname_Var_Samp_Fields = {
  __typename?: 'duplicate_cfn_with_null_cname_var_samp_fields';
  contact_phone_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Duplicate_Cfn_With_Null_Cname_Variance_Fields = {
  __typename?: 'duplicate_cfn_with_null_cname_variance_fields';
  contact_phone_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "duplicate_phone_numbers" */
export type Duplicate_Phone_Numbers = {
  __typename?: 'duplicate_phone_numbers';
  agency_count?: Maybe<Scalars['bigint']['output']>;
  agency_ids?: Maybe<Array<Scalars['uuid']['output']>>;
  contact_count?: Maybe<Scalars['bigint']['output']>;
  contact_ids?: Maybe<Array<Scalars['uuid']['output']>>;
  first_created?: Maybe<Scalars['timestamptz']['output']>;
  last_created?: Maybe<Scalars['timestamptz']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "duplicate_phone_numbers" */
export type Duplicate_Phone_Numbers_Aggregate = {
  __typename?: 'duplicate_phone_numbers_aggregate';
  aggregate?: Maybe<Duplicate_Phone_Numbers_Aggregate_Fields>;
  nodes: Array<Duplicate_Phone_Numbers>;
};

/** aggregate fields of "duplicate_phone_numbers" */
export type Duplicate_Phone_Numbers_Aggregate_Fields = {
  __typename?: 'duplicate_phone_numbers_aggregate_fields';
  avg?: Maybe<Duplicate_Phone_Numbers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Duplicate_Phone_Numbers_Max_Fields>;
  min?: Maybe<Duplicate_Phone_Numbers_Min_Fields>;
  stddev?: Maybe<Duplicate_Phone_Numbers_Stddev_Fields>;
  stddev_pop?: Maybe<Duplicate_Phone_Numbers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Duplicate_Phone_Numbers_Stddev_Samp_Fields>;
  sum?: Maybe<Duplicate_Phone_Numbers_Sum_Fields>;
  var_pop?: Maybe<Duplicate_Phone_Numbers_Var_Pop_Fields>;
  var_samp?: Maybe<Duplicate_Phone_Numbers_Var_Samp_Fields>;
  variance?: Maybe<Duplicate_Phone_Numbers_Variance_Fields>;
};


/** aggregate fields of "duplicate_phone_numbers" */
export type Duplicate_Phone_Numbers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Duplicate_Phone_Numbers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Duplicate_Phone_Numbers_Avg_Fields = {
  __typename?: 'duplicate_phone_numbers_avg_fields';
  agency_count?: Maybe<Scalars['Float']['output']>;
  contact_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "duplicate_phone_numbers". All fields are combined with a logical 'AND'. */
export type Duplicate_Phone_Numbers_Bool_Exp = {
  _and?: InputMaybe<Array<Duplicate_Phone_Numbers_Bool_Exp>>;
  _not?: InputMaybe<Duplicate_Phone_Numbers_Bool_Exp>;
  _or?: InputMaybe<Array<Duplicate_Phone_Numbers_Bool_Exp>>;
  agency_count?: InputMaybe<Bigint_Comparison_Exp>;
  agency_ids?: InputMaybe<Uuid_Array_Comparison_Exp>;
  contact_count?: InputMaybe<Bigint_Comparison_Exp>;
  contact_ids?: InputMaybe<Uuid_Array_Comparison_Exp>;
  first_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Duplicate_Phone_Numbers_Max_Fields = {
  __typename?: 'duplicate_phone_numbers_max_fields';
  agency_count?: Maybe<Scalars['bigint']['output']>;
  agency_ids?: Maybe<Array<Scalars['uuid']['output']>>;
  contact_count?: Maybe<Scalars['bigint']['output']>;
  contact_ids?: Maybe<Array<Scalars['uuid']['output']>>;
  first_created?: Maybe<Scalars['timestamptz']['output']>;
  last_created?: Maybe<Scalars['timestamptz']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Duplicate_Phone_Numbers_Min_Fields = {
  __typename?: 'duplicate_phone_numbers_min_fields';
  agency_count?: Maybe<Scalars['bigint']['output']>;
  agency_ids?: Maybe<Array<Scalars['uuid']['output']>>;
  contact_count?: Maybe<Scalars['bigint']['output']>;
  contact_ids?: Maybe<Array<Scalars['uuid']['output']>>;
  first_created?: Maybe<Scalars['timestamptz']['output']>;
  last_created?: Maybe<Scalars['timestamptz']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "duplicate_phone_numbers". */
export type Duplicate_Phone_Numbers_Order_By = {
  agency_count?: InputMaybe<Order_By>;
  agency_ids?: InputMaybe<Order_By>;
  contact_count?: InputMaybe<Order_By>;
  contact_ids?: InputMaybe<Order_By>;
  first_created?: InputMaybe<Order_By>;
  last_created?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
};

/** select columns of table "duplicate_phone_numbers" */
export enum Duplicate_Phone_Numbers_Select_Column {
  /** column name */
  AgencyCount = 'agency_count',
  /** column name */
  AgencyIds = 'agency_ids',
  /** column name */
  ContactCount = 'contact_count',
  /** column name */
  ContactIds = 'contact_ids',
  /** column name */
  FirstCreated = 'first_created',
  /** column name */
  LastCreated = 'last_created',
  /** column name */
  PhoneNumber = 'phone_number'
}

/** aggregate stddev on columns */
export type Duplicate_Phone_Numbers_Stddev_Fields = {
  __typename?: 'duplicate_phone_numbers_stddev_fields';
  agency_count?: Maybe<Scalars['Float']['output']>;
  contact_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Duplicate_Phone_Numbers_Stddev_Pop_Fields = {
  __typename?: 'duplicate_phone_numbers_stddev_pop_fields';
  agency_count?: Maybe<Scalars['Float']['output']>;
  contact_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Duplicate_Phone_Numbers_Stddev_Samp_Fields = {
  __typename?: 'duplicate_phone_numbers_stddev_samp_fields';
  agency_count?: Maybe<Scalars['Float']['output']>;
  contact_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "duplicate_phone_numbers" */
export type Duplicate_Phone_Numbers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Duplicate_Phone_Numbers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Duplicate_Phone_Numbers_Stream_Cursor_Value_Input = {
  agency_count?: InputMaybe<Scalars['bigint']['input']>;
  agency_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  contact_count?: InputMaybe<Scalars['bigint']['input']>;
  contact_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  first_created?: InputMaybe<Scalars['timestamptz']['input']>;
  last_created?: InputMaybe<Scalars['timestamptz']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Duplicate_Phone_Numbers_Sum_Fields = {
  __typename?: 'duplicate_phone_numbers_sum_fields';
  agency_count?: Maybe<Scalars['bigint']['output']>;
  contact_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Duplicate_Phone_Numbers_Var_Pop_Fields = {
  __typename?: 'duplicate_phone_numbers_var_pop_fields';
  agency_count?: Maybe<Scalars['Float']['output']>;
  contact_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Duplicate_Phone_Numbers_Var_Samp_Fields = {
  __typename?: 'duplicate_phone_numbers_var_samp_fields';
  agency_count?: Maybe<Scalars['Float']['output']>;
  contact_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Duplicate_Phone_Numbers_Variance_Fields = {
  __typename?: 'duplicate_phone_numbers_variance_fields';
  agency_count?: Maybe<Scalars['Float']['output']>;
  contact_count?: Maybe<Scalars['Float']['output']>;
};

/** is used in conjunction with translate to point out what translation is about, user, property etc */
export type Entities = {
  __typename?: 'entities';
  entity_type: Scalars['String']['output'];
};

/** aggregated selection of "entities" */
export type Entities_Aggregate = {
  __typename?: 'entities_aggregate';
  aggregate?: Maybe<Entities_Aggregate_Fields>;
  nodes: Array<Entities>;
};

/** aggregate fields of "entities" */
export type Entities_Aggregate_Fields = {
  __typename?: 'entities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Entities_Max_Fields>;
  min?: Maybe<Entities_Min_Fields>;
};


/** aggregate fields of "entities" */
export type Entities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Entities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "entities". All fields are combined with a logical 'AND'. */
export type Entities_Bool_Exp = {
  _and?: InputMaybe<Array<Entities_Bool_Exp>>;
  _not?: InputMaybe<Entities_Bool_Exp>;
  _or?: InputMaybe<Array<Entities_Bool_Exp>>;
  entity_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "entities" */
export enum Entities_Constraint {
  /** unique or primary key constraint on columns "entity_type" */
  EntitiesPkey = 'entities_pkey'
}

export enum Entities_Enum {
  Feature = 'feature',
  Notification = 'notification',
  Property = 'property',
  User = 'user'
}

/** Boolean expression to compare columns of type "entities_enum". All fields are combined with logical 'AND'. */
export type Entities_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Entities_Enum>;
  _in?: InputMaybe<Array<Entities_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Entities_Enum>;
  _nin?: InputMaybe<Array<Entities_Enum>>;
};

/** input type for inserting data into table "entities" */
export type Entities_Insert_Input = {
  entity_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Entities_Max_Fields = {
  __typename?: 'entities_max_fields';
  entity_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Entities_Min_Fields = {
  __typename?: 'entities_min_fields';
  entity_type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "entities" */
export type Entities_Mutation_Response = {
  __typename?: 'entities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Entities>;
};

/** on_conflict condition type for table "entities" */
export type Entities_On_Conflict = {
  constraint: Entities_Constraint;
  update_columns?: Array<Entities_Update_Column>;
  where?: InputMaybe<Entities_Bool_Exp>;
};

/** Ordering options when selecting data from "entities". */
export type Entities_Order_By = {
  entity_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entities */
export type Entities_Pk_Columns_Input = {
  entity_type: Scalars['String']['input'];
};

/** select columns of table "entities" */
export enum Entities_Select_Column {
  /** column name */
  EntityType = 'entity_type'
}

/** input type for updating data in table "entities" */
export type Entities_Set_Input = {
  entity_type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "entities" */
export type Entities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Entities_Stream_Cursor_Value_Input = {
  entity_type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "entities" */
export enum Entities_Update_Column {
  /** column name */
  EntityType = 'entity_type'
}

export type Entities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Entities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Entities_Bool_Exp;
};

/** columns and relationships of "exchange_rates" */
export type Exchange_Rates = {
  __typename?: 'exchange_rates';
  base_currency_code: Currency_Enum;
  created_at: Scalars['timestamptz']['output'];
  exchange_rate: Scalars['numeric']['output'];
  id: Scalars['Int']['output'];
  target_currency_code: Currency_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "exchange_rates" */
export type Exchange_Rates_Aggregate = {
  __typename?: 'exchange_rates_aggregate';
  aggregate?: Maybe<Exchange_Rates_Aggregate_Fields>;
  nodes: Array<Exchange_Rates>;
};

/** aggregate fields of "exchange_rates" */
export type Exchange_Rates_Aggregate_Fields = {
  __typename?: 'exchange_rates_aggregate_fields';
  avg?: Maybe<Exchange_Rates_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Exchange_Rates_Max_Fields>;
  min?: Maybe<Exchange_Rates_Min_Fields>;
  stddev?: Maybe<Exchange_Rates_Stddev_Fields>;
  stddev_pop?: Maybe<Exchange_Rates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Exchange_Rates_Stddev_Samp_Fields>;
  sum?: Maybe<Exchange_Rates_Sum_Fields>;
  var_pop?: Maybe<Exchange_Rates_Var_Pop_Fields>;
  var_samp?: Maybe<Exchange_Rates_Var_Samp_Fields>;
  variance?: Maybe<Exchange_Rates_Variance_Fields>;
};


/** aggregate fields of "exchange_rates" */
export type Exchange_Rates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Exchange_Rates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Exchange_Rates_Avg_Fields = {
  __typename?: 'exchange_rates_avg_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "exchange_rates". All fields are combined with a logical 'AND'. */
export type Exchange_Rates_Bool_Exp = {
  _and?: InputMaybe<Array<Exchange_Rates_Bool_Exp>>;
  _not?: InputMaybe<Exchange_Rates_Bool_Exp>;
  _or?: InputMaybe<Array<Exchange_Rates_Bool_Exp>>;
  base_currency_code?: InputMaybe<Currency_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  exchange_rate?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  target_currency_code?: InputMaybe<Currency_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "exchange_rates" */
export enum Exchange_Rates_Constraint {
  /** unique or primary key constraint on columns "target_currency_code", "base_currency_code" */
  ExchangeRatesBaseCurrencyCodeTargetCurrencyCodeKey = 'exchange_rates_base_currency_code_target_currency_code_key',
  /** unique or primary key constraint on columns "id" */
  ExchangeRatesPkey = 'exchange_rates_pkey'
}

/** input type for incrementing numeric columns in table "exchange_rates" */
export type Exchange_Rates_Inc_Input = {
  exchange_rate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "exchange_rates" */
export type Exchange_Rates_Insert_Input = {
  base_currency_code?: InputMaybe<Currency_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exchange_rate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  target_currency_code?: InputMaybe<Currency_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Exchange_Rates_Max_Fields = {
  __typename?: 'exchange_rates_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  exchange_rate?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Exchange_Rates_Min_Fields = {
  __typename?: 'exchange_rates_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  exchange_rate?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "exchange_rates" */
export type Exchange_Rates_Mutation_Response = {
  __typename?: 'exchange_rates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Exchange_Rates>;
};

/** on_conflict condition type for table "exchange_rates" */
export type Exchange_Rates_On_Conflict = {
  constraint: Exchange_Rates_Constraint;
  update_columns?: Array<Exchange_Rates_Update_Column>;
  where?: InputMaybe<Exchange_Rates_Bool_Exp>;
};

/** Ordering options when selecting data from "exchange_rates". */
export type Exchange_Rates_Order_By = {
  base_currency_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  exchange_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  target_currency_code?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exchange_rates */
export type Exchange_Rates_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "exchange_rates" */
export enum Exchange_Rates_Select_Column {
  /** column name */
  BaseCurrencyCode = 'base_currency_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExchangeRate = 'exchange_rate',
  /** column name */
  Id = 'id',
  /** column name */
  TargetCurrencyCode = 'target_currency_code',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "exchange_rates" */
export type Exchange_Rates_Set_Input = {
  base_currency_code?: InputMaybe<Currency_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exchange_rate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  target_currency_code?: InputMaybe<Currency_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Exchange_Rates_Stddev_Fields = {
  __typename?: 'exchange_rates_stddev_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Exchange_Rates_Stddev_Pop_Fields = {
  __typename?: 'exchange_rates_stddev_pop_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Exchange_Rates_Stddev_Samp_Fields = {
  __typename?: 'exchange_rates_stddev_samp_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "exchange_rates" */
export type Exchange_Rates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Exchange_Rates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Exchange_Rates_Stream_Cursor_Value_Input = {
  base_currency_code?: InputMaybe<Currency_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exchange_rate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  target_currency_code?: InputMaybe<Currency_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Exchange_Rates_Sum_Fields = {
  __typename?: 'exchange_rates_sum_fields';
  exchange_rate?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "exchange_rates" */
export enum Exchange_Rates_Update_Column {
  /** column name */
  BaseCurrencyCode = 'base_currency_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExchangeRate = 'exchange_rate',
  /** column name */
  Id = 'id',
  /** column name */
  TargetCurrencyCode = 'target_currency_code',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Exchange_Rates_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Exchange_Rates_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Exchange_Rates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Exchange_Rates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Exchange_Rates_Var_Pop_Fields = {
  __typename?: 'exchange_rates_var_pop_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Exchange_Rates_Var_Samp_Fields = {
  __typename?: 'exchange_rates_var_samp_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Exchange_Rates_Variance_Fields = {
  __typename?: 'exchange_rates_variance_fields';
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type Fail_Whatsapp_Ai_Outbox_Part_Args = {
  p_error_code?: InputMaybe<Scalars['String']['input']>;
  p_part_id?: InputMaybe<Scalars['uuid']['input']>;
  p_retryable?: InputMaybe<Scalars['Boolean']['input']>;
  p_worker_id?: InputMaybe<Scalars['String']['input']>;
};

export type Fail_Whatsapp_Ai_Turn_Args = {
  p_error_code?: InputMaybe<Scalars['String']['input']>;
  p_retryable?: InputMaybe<Scalars['Boolean']['input']>;
  p_turn_id?: InputMaybe<Scalars['uuid']['input']>;
  p_worker_id?: InputMaybe<Scalars['String']['input']>;
};

/** favouritePropertiesTrendNative Query Arguments */
export type FavouritePropertiesTrend_Arguments = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

export type Favourite_Properties_Trend_Model = {
  __typename?: 'favourite_properties_trend_model';
  properties_added?: Maybe<Scalars['bigint']['output']>;
  properties_removed?: Maybe<Scalars['bigint']['output']>;
  report_date?: Maybe<Scalars['date']['output']>;
};

/** Boolean expression to filter rows from the logical model for "favourite_properties_trend_model". All fields are combined with a logical 'AND'. */
export type Favourite_Properties_Trend_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Favourite_Properties_Trend_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Favourite_Properties_Trend_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Favourite_Properties_Trend_Model_Bool_Exp_Bool_Exp>>;
  properties_added?: InputMaybe<Bigint_Comparison_Exp>;
  properties_removed?: InputMaybe<Bigint_Comparison_Exp>;
  report_date?: InputMaybe<Date_Comparison_Exp>;
};

export enum Favourite_Properties_Trend_Model_Enum_Name {
  /** column name */
  PropertiesAdded = 'properties_added',
  /** column name */
  PropertiesRemoved = 'properties_removed',
  /** column name */
  ReportDate = 'report_date'
}

/** Ordering options when selecting data from "favourite_properties_trend_model". */
export type Favourite_Properties_Trend_Model_Order_By = {
  properties_added?: InputMaybe<Order_By>;
  properties_removed?: InputMaybe<Order_By>;
  report_date?: InputMaybe<Order_By>;
};

/** columns and relationships of "feature" */
export type Feature = {
  __typename?: 'feature';
  abbrv?: Maybe<Scalars['String']['output']>;
  feature_name_id?: Maybe<Scalars['uuid']['output']>;
  feature_type: Feature_Type_Enum;
  id: Scalars['uuid']['output'];
  importance?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  property_features: Array<Property_Feature>;
  /** An aggregate relationship */
  property_features_aggregate: Property_Feature_Aggregate;
  /** An object relationship */
  text_content?: Maybe<Text_Content>;
};


/** columns and relationships of "feature" */
export type FeatureProperty_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Property_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Feature_Order_By>>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};


/** columns and relationships of "feature" */
export type FeatureProperty_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Feature_Order_By>>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};

/** aggregated selection of "feature" */
export type Feature_Aggregate = {
  __typename?: 'feature_aggregate';
  aggregate?: Maybe<Feature_Aggregate_Fields>;
  nodes: Array<Feature>;
};

/** aggregate fields of "feature" */
export type Feature_Aggregate_Fields = {
  __typename?: 'feature_aggregate_fields';
  avg?: Maybe<Feature_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Feature_Max_Fields>;
  min?: Maybe<Feature_Min_Fields>;
  stddev?: Maybe<Feature_Stddev_Fields>;
  stddev_pop?: Maybe<Feature_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feature_Stddev_Samp_Fields>;
  sum?: Maybe<Feature_Sum_Fields>;
  var_pop?: Maybe<Feature_Var_Pop_Fields>;
  var_samp?: Maybe<Feature_Var_Samp_Fields>;
  variance?: Maybe<Feature_Variance_Fields>;
};


/** aggregate fields of "feature" */
export type Feature_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feature_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Feature_Avg_Fields = {
  __typename?: 'feature_avg_fields';
  importance?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "feature". All fields are combined with a logical 'AND'. */
export type Feature_Bool_Exp = {
  _and?: InputMaybe<Array<Feature_Bool_Exp>>;
  _not?: InputMaybe<Feature_Bool_Exp>;
  _or?: InputMaybe<Array<Feature_Bool_Exp>>;
  abbrv?: InputMaybe<String_Comparison_Exp>;
  feature_name_id?: InputMaybe<Uuid_Comparison_Exp>;
  feature_type?: InputMaybe<Feature_Type_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  importance?: InputMaybe<Numeric_Comparison_Exp>;
  property_features?: InputMaybe<Property_Feature_Bool_Exp>;
  property_features_aggregate?: InputMaybe<Property_Feature_Aggregate_Bool_Exp>;
  text_content?: InputMaybe<Text_Content_Bool_Exp>;
};

/** unique or primary key constraints on table "feature" */
export enum Feature_Constraint {
  /** unique or primary key constraint on columns "abbrv" */
  FeatureAbbrvKey = 'feature_abbrv_key',
  /** unique or primary key constraint on columns "feature_name_id" */
  FeatureFeatureNameIdKey = 'feature_feature_name_id_key',
  /** unique or primary key constraint on columns "id" */
  FeaturePkey = 'feature_pkey'
}

/** input type for incrementing numeric columns in table "feature" */
export type Feature_Inc_Input = {
  importance?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "feature" */
export type Feature_Insert_Input = {
  abbrv?: InputMaybe<Scalars['String']['input']>;
  feature_name_id?: InputMaybe<Scalars['uuid']['input']>;
  feature_type?: InputMaybe<Feature_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  importance?: InputMaybe<Scalars['numeric']['input']>;
  property_features?: InputMaybe<Property_Feature_Arr_Rel_Insert_Input>;
  text_content?: InputMaybe<Text_Content_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Feature_Max_Fields = {
  __typename?: 'feature_max_fields';
  abbrv?: Maybe<Scalars['String']['output']>;
  feature_name_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  importance?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Feature_Min_Fields = {
  __typename?: 'feature_min_fields';
  abbrv?: Maybe<Scalars['String']['output']>;
  feature_name_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  importance?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "feature" */
export type Feature_Mutation_Response = {
  __typename?: 'feature_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Feature>;
};

/** input type for inserting object relation for remote table "feature" */
export type Feature_Obj_Rel_Insert_Input = {
  data: Feature_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Feature_On_Conflict>;
};

/** on_conflict condition type for table "feature" */
export type Feature_On_Conflict = {
  constraint: Feature_Constraint;
  update_columns?: Array<Feature_Update_Column>;
  where?: InputMaybe<Feature_Bool_Exp>;
};

/** Ordering options when selecting data from "feature". */
export type Feature_Order_By = {
  abbrv?: InputMaybe<Order_By>;
  feature_name_id?: InputMaybe<Order_By>;
  feature_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  importance?: InputMaybe<Order_By>;
  property_features_aggregate?: InputMaybe<Property_Feature_Aggregate_Order_By>;
  text_content?: InputMaybe<Text_Content_Order_By>;
};

/** primary key columns input for table: feature */
export type Feature_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "feature" */
export enum Feature_Select_Column {
  /** column name */
  Abbrv = 'abbrv',
  /** column name */
  FeatureNameId = 'feature_name_id',
  /** column name */
  FeatureType = 'feature_type',
  /** column name */
  Id = 'id',
  /** column name */
  Importance = 'importance'
}

/** input type for updating data in table "feature" */
export type Feature_Set_Input = {
  abbrv?: InputMaybe<Scalars['String']['input']>;
  feature_name_id?: InputMaybe<Scalars['uuid']['input']>;
  feature_type?: InputMaybe<Feature_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  importance?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Feature_Stddev_Fields = {
  __typename?: 'feature_stddev_fields';
  importance?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Feature_Stddev_Pop_Fields = {
  __typename?: 'feature_stddev_pop_fields';
  importance?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Feature_Stddev_Samp_Fields = {
  __typename?: 'feature_stddev_samp_fields';
  importance?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "feature" */
export type Feature_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feature_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feature_Stream_Cursor_Value_Input = {
  abbrv?: InputMaybe<Scalars['String']['input']>;
  feature_name_id?: InputMaybe<Scalars['uuid']['input']>;
  feature_type?: InputMaybe<Feature_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  importance?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Feature_Sum_Fields = {
  __typename?: 'feature_sum_fields';
  importance?: Maybe<Scalars['numeric']['output']>;
};

/** columns and relationships of "feature_type" */
export type Feature_Type = {
  __typename?: 'feature_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "feature_type" */
export type Feature_Type_Aggregate = {
  __typename?: 'feature_type_aggregate';
  aggregate?: Maybe<Feature_Type_Aggregate_Fields>;
  nodes: Array<Feature_Type>;
};

/** aggregate fields of "feature_type" */
export type Feature_Type_Aggregate_Fields = {
  __typename?: 'feature_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Feature_Type_Max_Fields>;
  min?: Maybe<Feature_Type_Min_Fields>;
};


/** aggregate fields of "feature_type" */
export type Feature_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feature_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "feature_type". All fields are combined with a logical 'AND'. */
export type Feature_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Feature_Type_Bool_Exp>>;
  _not?: InputMaybe<Feature_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Feature_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "feature_type" */
export enum Feature_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  FeatureTypePkey = 'feature_type_pkey'
}

export enum Feature_Type_Enum {
  BathroomFeatures = 'bathroom_features',
  BuildingCommunity = 'building_community',
  ExteriorLot = 'exterior_lot',
  InteriorFeatures = 'interior_features',
  KitchenFeatures = 'kitchen_features',
  Parking = 'parking',
  UtilitiesEcoFriendly = 'utilities_eco_friendly'
}

/** Boolean expression to compare columns of type "feature_type_enum". All fields are combined with logical 'AND'. */
export type Feature_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Feature_Type_Enum>;
  _in?: InputMaybe<Array<Feature_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Feature_Type_Enum>;
  _nin?: InputMaybe<Array<Feature_Type_Enum>>;
};

/** input type for inserting data into table "feature_type" */
export type Feature_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Feature_Type_Max_Fields = {
  __typename?: 'feature_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Feature_Type_Min_Fields = {
  __typename?: 'feature_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "feature_type" */
export type Feature_Type_Mutation_Response = {
  __typename?: 'feature_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Feature_Type>;
};

/** on_conflict condition type for table "feature_type" */
export type Feature_Type_On_Conflict = {
  constraint: Feature_Type_Constraint;
  update_columns?: Array<Feature_Type_Update_Column>;
  where?: InputMaybe<Feature_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "feature_type". */
export type Feature_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feature_type */
export type Feature_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "feature_type" */
export enum Feature_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "feature_type" */
export type Feature_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "feature_type" */
export type Feature_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feature_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feature_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "feature_type" */
export enum Feature_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Feature_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feature_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feature_Type_Bool_Exp;
};

/** update columns of table "feature" */
export enum Feature_Update_Column {
  /** column name */
  Abbrv = 'abbrv',
  /** column name */
  FeatureNameId = 'feature_name_id',
  /** column name */
  FeatureType = 'feature_type',
  /** column name */
  Id = 'id',
  /** column name */
  Importance = 'importance'
}

export type Feature_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feature_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feature_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feature_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feature_Var_Pop_Fields = {
  __typename?: 'feature_var_pop_fields';
  importance?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Feature_Var_Samp_Fields = {
  __typename?: 'feature_var_samp_fields';
  importance?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Feature_Variance_Fields = {
  __typename?: 'feature_variance_fields';
  importance?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "file_type" */
export type File_Type = {
  __typename?: 'file_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "file_type" */
export type File_Type_Aggregate = {
  __typename?: 'file_type_aggregate';
  aggregate?: Maybe<File_Type_Aggregate_Fields>;
  nodes: Array<File_Type>;
};

/** aggregate fields of "file_type" */
export type File_Type_Aggregate_Fields = {
  __typename?: 'file_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<File_Type_Max_Fields>;
  min?: Maybe<File_Type_Min_Fields>;
};


/** aggregate fields of "file_type" */
export type File_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "file_type". All fields are combined with a logical 'AND'. */
export type File_Type_Bool_Exp = {
  _and?: InputMaybe<Array<File_Type_Bool_Exp>>;
  _not?: InputMaybe<File_Type_Bool_Exp>;
  _or?: InputMaybe<Array<File_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "file_type" */
export enum File_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  FileTypePkey = 'file_type_pkey'
}

export enum File_Type_Enum {
  Image = 'image',
  Video = 'video'
}

/** Boolean expression to compare columns of type "file_type_enum". All fields are combined with logical 'AND'. */
export type File_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<File_Type_Enum>;
  _in?: InputMaybe<Array<File_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<File_Type_Enum>;
  _nin?: InputMaybe<Array<File_Type_Enum>>;
};

/** input type for inserting data into table "file_type" */
export type File_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type File_Type_Max_Fields = {
  __typename?: 'file_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type File_Type_Min_Fields = {
  __typename?: 'file_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "file_type" */
export type File_Type_Mutation_Response = {
  __typename?: 'file_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<File_Type>;
};

/** on_conflict condition type for table "file_type" */
export type File_Type_On_Conflict = {
  constraint: File_Type_Constraint;
  update_columns?: Array<File_Type_Update_Column>;
  where?: InputMaybe<File_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "file_type". */
export type File_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: file_type */
export type File_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "file_type" */
export enum File_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "file_type" */
export type File_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "file_type" */
export type File_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "file_type" */
export enum File_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type File_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<File_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: File_Type_Bool_Exp;
};

/** columns and relationships of "storage.files" */
export type Files = {
  __typename?: 'files';
  /** An object relationship */
  bucket: Buckets;
  bucketId: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "storage.files" */
export type FilesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate';
  aggregate?: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

export type Files_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Files_Aggregate_Bool_Exp_Count>;
};

export type Files_Aggregate_Bool_Exp_Bool_And = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storage.files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields';
  avg?: Maybe<Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Files_Max_Fields>;
  min?: Maybe<Files_Min_Fields>;
  stddev?: Maybe<Files_Stddev_Fields>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields>;
  sum?: Maybe<Files_Sum_Fields>;
  var_pop?: Maybe<Files_Var_Pop_Fields>;
  var_samp?: Maybe<Files_Var_Samp_Fields>;
  variance?: Maybe<Files_Variance_Fields>;
};


/** aggregate fields of "storage.files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storage.files" */
export type Files_Aggregate_Order_By = {
  avg?: InputMaybe<Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Files_Max_Order_By>;
  min?: InputMaybe<Files_Min_Order_By>;
  stddev?: InputMaybe<Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Files_Sum_Order_By>;
  var_pop?: InputMaybe<Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Files_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Files_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "storage.files" */
export type Files_Arr_Rel_Insert_Input = {
  data: Array<Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  __typename?: 'files_avg_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "storage.files" */
export type Files_Avg_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  bucket?: InputMaybe<Buckets_Bool_Exp>;
  bucketId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  etag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isUploaded?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mimeType?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadedByUserId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Files_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Files_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Files_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "storage.files" */
export type Files_Inc_Input = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.files" */
export type Files_Insert_Input = {
  bucket?: InputMaybe<Buckets_Obj_Rel_Insert_Input>;
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "storage.files" */
export type Files_Max_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "storage.files" */
export type Files_Min_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storage.files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "storage.files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "storage.files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.files". */
export type Files_Order_By = {
  bucket?: InputMaybe<Buckets_Order_By>;
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isUploaded?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Files_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.files" */
export enum Files_Select_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** input type for updating data in table "storage.files" */
export type Files_Set_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  __typename?: 'files_stddev_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "storage.files" */
export type Files_Stddev_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  __typename?: 'files_stddev_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "storage.files" */
export type Files_Stddev_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  __typename?: 'files_stddev_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "storage.files" */
export type Files_Stddev_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  __typename?: 'files_sum_fields';
  size?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "storage.files" */
export type Files_Sum_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** update columns of table "storage.files" */
export enum Files_Update_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

export type Files_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Files_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Files_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  __typename?: 'files_var_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "storage.files" */
export type Files_Var_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  __typename?: 'files_var_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "storage.files" */
export type Files_Var_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  __typename?: 'files_variance_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "storage.files" */
export type Files_Variance_Order_By = {
  size?: InputMaybe<Order_By>;
};

export type Finalize_Whatsapp_Ai_Turn_Args = {
  p_no_reply_reason?: InputMaybe<Scalars['String']['input']>;
  p_outcome?: InputMaybe<Scalars['String']['input']>;
  p_parts?: InputMaybe<Scalars['jsonb']['input']>;
  p_turn_id?: InputMaybe<Scalars['uuid']['input']>;
  p_worker_id?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "folder_amenities" */
export type Folder_Amenities = {
  __typename?: 'folder_amenities';
  amenity?: Maybe<Amenities_Enum>;
  created_at: Scalars['timestamptz']['output'];
  folder_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  property_folder: Property_Folder;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "folder_amenities" */
export type Folder_Amenities_Aggregate = {
  __typename?: 'folder_amenities_aggregate';
  aggregate?: Maybe<Folder_Amenities_Aggregate_Fields>;
  nodes: Array<Folder_Amenities>;
};

export type Folder_Amenities_Aggregate_Bool_Exp = {
  count?: InputMaybe<Folder_Amenities_Aggregate_Bool_Exp_Count>;
};

export type Folder_Amenities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Folder_Amenities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Folder_Amenities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "folder_amenities" */
export type Folder_Amenities_Aggregate_Fields = {
  __typename?: 'folder_amenities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Folder_Amenities_Max_Fields>;
  min?: Maybe<Folder_Amenities_Min_Fields>;
};


/** aggregate fields of "folder_amenities" */
export type Folder_Amenities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Folder_Amenities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "folder_amenities" */
export type Folder_Amenities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Folder_Amenities_Max_Order_By>;
  min?: InputMaybe<Folder_Amenities_Min_Order_By>;
};

/** input type for inserting array relation for remote table "folder_amenities" */
export type Folder_Amenities_Arr_Rel_Insert_Input = {
  data: Array<Folder_Amenities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Folder_Amenities_On_Conflict>;
};

/** Boolean expression to filter rows from the table "folder_amenities". All fields are combined with a logical 'AND'. */
export type Folder_Amenities_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Amenities_Bool_Exp>>;
  _not?: InputMaybe<Folder_Amenities_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Amenities_Bool_Exp>>;
  amenity?: InputMaybe<Amenities_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  property_folder?: InputMaybe<Property_Folder_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "folder_amenities" */
export enum Folder_Amenities_Constraint {
  /** unique or primary key constraint on columns "amenity", "folder_id" */
  FolderAmenitiesAmenityFolderIdKey = 'folder_amenities_amenity_folder_id_key',
  /** unique or primary key constraint on columns "id" */
  FolderAmenitiesPkey = 'folder_amenities_pkey'
}

/** input type for inserting data into table "folder_amenities" */
export type Folder_Amenities_Insert_Input = {
  amenity?: InputMaybe<Amenities_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_folder?: InputMaybe<Property_Folder_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Folder_Amenities_Max_Fields = {
  __typename?: 'folder_amenities_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "folder_amenities" */
export type Folder_Amenities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Folder_Amenities_Min_Fields = {
  __typename?: 'folder_amenities_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "folder_amenities" */
export type Folder_Amenities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "folder_amenities" */
export type Folder_Amenities_Mutation_Response = {
  __typename?: 'folder_amenities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Folder_Amenities>;
};

/** on_conflict condition type for table "folder_amenities" */
export type Folder_Amenities_On_Conflict = {
  constraint: Folder_Amenities_Constraint;
  update_columns?: Array<Folder_Amenities_Update_Column>;
  where?: InputMaybe<Folder_Amenities_Bool_Exp>;
};

/** Ordering options when selecting data from "folder_amenities". */
export type Folder_Amenities_Order_By = {
  amenity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_folder?: InputMaybe<Property_Folder_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: folder_amenities */
export type Folder_Amenities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "folder_amenities" */
export enum Folder_Amenities_Select_Column {
  /** column name */
  Amenity = 'amenity',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "folder_amenities" */
export type Folder_Amenities_Set_Input = {
  amenity?: InputMaybe<Amenities_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "folder_amenities" */
export type Folder_Amenities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Folder_Amenities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Folder_Amenities_Stream_Cursor_Value_Input = {
  amenity?: InputMaybe<Amenities_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "folder_amenities" */
export enum Folder_Amenities_Update_Column {
  /** column name */
  Amenity = 'amenity',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Folder_Amenities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Folder_Amenities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Folder_Amenities_Bool_Exp;
};

/** columns and relationships of "folder_image" */
export type Folder_Image = {
  __typename?: 'folder_image';
  created_at: Scalars['timestamptz']['output'];
  folder_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  image_url: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "folder_image" */
export type Folder_Image_Aggregate = {
  __typename?: 'folder_image_aggregate';
  aggregate?: Maybe<Folder_Image_Aggregate_Fields>;
  nodes: Array<Folder_Image>;
};

export type Folder_Image_Aggregate_Bool_Exp = {
  count?: InputMaybe<Folder_Image_Aggregate_Bool_Exp_Count>;
};

export type Folder_Image_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Folder_Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Folder_Image_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "folder_image" */
export type Folder_Image_Aggregate_Fields = {
  __typename?: 'folder_image_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Folder_Image_Max_Fields>;
  min?: Maybe<Folder_Image_Min_Fields>;
};


/** aggregate fields of "folder_image" */
export type Folder_Image_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Folder_Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "folder_image" */
export type Folder_Image_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Folder_Image_Max_Order_By>;
  min?: InputMaybe<Folder_Image_Min_Order_By>;
};

/** input type for inserting array relation for remote table "folder_image" */
export type Folder_Image_Arr_Rel_Insert_Input = {
  data: Array<Folder_Image_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Folder_Image_On_Conflict>;
};

/** Boolean expression to filter rows from the table "folder_image". All fields are combined with a logical 'AND'. */
export type Folder_Image_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Image_Bool_Exp>>;
  _not?: InputMaybe<Folder_Image_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Image_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "folder_image" */
export enum Folder_Image_Constraint {
  /** unique or primary key constraint on columns "id" */
  FolderImagePkey = 'folder_image_pkey'
}

/** input type for inserting data into table "folder_image" */
export type Folder_Image_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Folder_Image_Max_Fields = {
  __typename?: 'folder_image_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "folder_image" */
export type Folder_Image_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Folder_Image_Min_Fields = {
  __typename?: 'folder_image_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "folder_image" */
export type Folder_Image_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "folder_image" */
export type Folder_Image_Mutation_Response = {
  __typename?: 'folder_image_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Folder_Image>;
};

/** on_conflict condition type for table "folder_image" */
export type Folder_Image_On_Conflict = {
  constraint: Folder_Image_Constraint;
  update_columns?: Array<Folder_Image_Update_Column>;
  where?: InputMaybe<Folder_Image_Bool_Exp>;
};

/** Ordering options when selecting data from "folder_image". */
export type Folder_Image_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: folder_image */
export type Folder_Image_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "folder_image" */
export enum Folder_Image_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "folder_image" */
export type Folder_Image_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "folder_image" */
export type Folder_Image_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Folder_Image_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Folder_Image_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "folder_image" */
export enum Folder_Image_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Folder_Image_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Folder_Image_Set_Input>;
  /** filter the rows which have to be updated */
  where: Folder_Image_Bool_Exp;
};

/** columns and relationships of "folder_properties_type" */
export type Folder_Properties_Type = {
  __typename?: 'folder_properties_type';
  baths_max?: Maybe<Scalars['Int']['output']>;
  baths_min?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  folder_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  rooms_max?: Maybe<Scalars['Int']['output']>;
  rooms_min?: Maybe<Scalars['Int']['output']>;
  sq_max?: Maybe<Scalars['Int']['output']>;
  sq_min?: Maybe<Scalars['Int']['output']>;
  type: Property_Type_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "folder_properties_type" */
export type Folder_Properties_Type_Aggregate = {
  __typename?: 'folder_properties_type_aggregate';
  aggregate?: Maybe<Folder_Properties_Type_Aggregate_Fields>;
  nodes: Array<Folder_Properties_Type>;
};

export type Folder_Properties_Type_Aggregate_Bool_Exp = {
  count?: InputMaybe<Folder_Properties_Type_Aggregate_Bool_Exp_Count>;
};

export type Folder_Properties_Type_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Folder_Properties_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Folder_Properties_Type_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "folder_properties_type" */
export type Folder_Properties_Type_Aggregate_Fields = {
  __typename?: 'folder_properties_type_aggregate_fields';
  avg?: Maybe<Folder_Properties_Type_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Folder_Properties_Type_Max_Fields>;
  min?: Maybe<Folder_Properties_Type_Min_Fields>;
  stddev?: Maybe<Folder_Properties_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Folder_Properties_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Folder_Properties_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Folder_Properties_Type_Sum_Fields>;
  var_pop?: Maybe<Folder_Properties_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Folder_Properties_Type_Var_Samp_Fields>;
  variance?: Maybe<Folder_Properties_Type_Variance_Fields>;
};


/** aggregate fields of "folder_properties_type" */
export type Folder_Properties_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Folder_Properties_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "folder_properties_type" */
export type Folder_Properties_Type_Aggregate_Order_By = {
  avg?: InputMaybe<Folder_Properties_Type_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Folder_Properties_Type_Max_Order_By>;
  min?: InputMaybe<Folder_Properties_Type_Min_Order_By>;
  stddev?: InputMaybe<Folder_Properties_Type_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Folder_Properties_Type_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Folder_Properties_Type_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Folder_Properties_Type_Sum_Order_By>;
  var_pop?: InputMaybe<Folder_Properties_Type_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Folder_Properties_Type_Var_Samp_Order_By>;
  variance?: InputMaybe<Folder_Properties_Type_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "folder_properties_type" */
export type Folder_Properties_Type_Arr_Rel_Insert_Input = {
  data: Array<Folder_Properties_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Folder_Properties_Type_On_Conflict>;
};

/** aggregate avg on columns */
export type Folder_Properties_Type_Avg_Fields = {
  __typename?: 'folder_properties_type_avg_fields';
  baths_max?: Maybe<Scalars['Float']['output']>;
  baths_min?: Maybe<Scalars['Float']['output']>;
  rooms_max?: Maybe<Scalars['Float']['output']>;
  rooms_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "folder_properties_type" */
export type Folder_Properties_Type_Avg_Order_By = {
  baths_max?: InputMaybe<Order_By>;
  baths_min?: InputMaybe<Order_By>;
  rooms_max?: InputMaybe<Order_By>;
  rooms_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "folder_properties_type". All fields are combined with a logical 'AND'. */
export type Folder_Properties_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Properties_Type_Bool_Exp>>;
  _not?: InputMaybe<Folder_Properties_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Properties_Type_Bool_Exp>>;
  baths_max?: InputMaybe<Int_Comparison_Exp>;
  baths_min?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rooms_max?: InputMaybe<Int_Comparison_Exp>;
  rooms_min?: InputMaybe<Int_Comparison_Exp>;
  sq_max?: InputMaybe<Int_Comparison_Exp>;
  sq_min?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Property_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "folder_properties_type" */
export enum Folder_Properties_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  FolderPropertiesTypePkey = 'folder_properties_type_pkey'
}

/** input type for incrementing numeric columns in table "folder_properties_type" */
export type Folder_Properties_Type_Inc_Input = {
  baths_max?: InputMaybe<Scalars['Int']['input']>;
  baths_min?: InputMaybe<Scalars['Int']['input']>;
  rooms_max?: InputMaybe<Scalars['Int']['input']>;
  rooms_min?: InputMaybe<Scalars['Int']['input']>;
  sq_max?: InputMaybe<Scalars['Int']['input']>;
  sq_min?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "folder_properties_type" */
export type Folder_Properties_Type_Insert_Input = {
  baths_max?: InputMaybe<Scalars['Int']['input']>;
  baths_min?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rooms_max?: InputMaybe<Scalars['Int']['input']>;
  rooms_min?: InputMaybe<Scalars['Int']['input']>;
  sq_max?: InputMaybe<Scalars['Int']['input']>;
  sq_min?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Property_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Folder_Properties_Type_Max_Fields = {
  __typename?: 'folder_properties_type_max_fields';
  baths_max?: Maybe<Scalars['Int']['output']>;
  baths_min?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  rooms_max?: Maybe<Scalars['Int']['output']>;
  rooms_min?: Maybe<Scalars['Int']['output']>;
  sq_max?: Maybe<Scalars['Int']['output']>;
  sq_min?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "folder_properties_type" */
export type Folder_Properties_Type_Max_Order_By = {
  baths_max?: InputMaybe<Order_By>;
  baths_min?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rooms_max?: InputMaybe<Order_By>;
  rooms_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Folder_Properties_Type_Min_Fields = {
  __typename?: 'folder_properties_type_min_fields';
  baths_max?: Maybe<Scalars['Int']['output']>;
  baths_min?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  rooms_max?: Maybe<Scalars['Int']['output']>;
  rooms_min?: Maybe<Scalars['Int']['output']>;
  sq_max?: Maybe<Scalars['Int']['output']>;
  sq_min?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "folder_properties_type" */
export type Folder_Properties_Type_Min_Order_By = {
  baths_max?: InputMaybe<Order_By>;
  baths_min?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rooms_max?: InputMaybe<Order_By>;
  rooms_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "folder_properties_type" */
export type Folder_Properties_Type_Mutation_Response = {
  __typename?: 'folder_properties_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Folder_Properties_Type>;
};

/** on_conflict condition type for table "folder_properties_type" */
export type Folder_Properties_Type_On_Conflict = {
  constraint: Folder_Properties_Type_Constraint;
  update_columns?: Array<Folder_Properties_Type_Update_Column>;
  where?: InputMaybe<Folder_Properties_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "folder_properties_type". */
export type Folder_Properties_Type_Order_By = {
  baths_max?: InputMaybe<Order_By>;
  baths_min?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rooms_max?: InputMaybe<Order_By>;
  rooms_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: folder_properties_type */
export type Folder_Properties_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "folder_properties_type" */
export enum Folder_Properties_Type_Select_Column {
  /** column name */
  BathsMax = 'baths_max',
  /** column name */
  BathsMin = 'baths_min',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  RoomsMax = 'rooms_max',
  /** column name */
  RoomsMin = 'rooms_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "folder_properties_type" */
export type Folder_Properties_Type_Set_Input = {
  baths_max?: InputMaybe<Scalars['Int']['input']>;
  baths_min?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rooms_max?: InputMaybe<Scalars['Int']['input']>;
  rooms_min?: InputMaybe<Scalars['Int']['input']>;
  sq_max?: InputMaybe<Scalars['Int']['input']>;
  sq_min?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Property_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Folder_Properties_Type_Stddev_Fields = {
  __typename?: 'folder_properties_type_stddev_fields';
  baths_max?: Maybe<Scalars['Float']['output']>;
  baths_min?: Maybe<Scalars['Float']['output']>;
  rooms_max?: Maybe<Scalars['Float']['output']>;
  rooms_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "folder_properties_type" */
export type Folder_Properties_Type_Stddev_Order_By = {
  baths_max?: InputMaybe<Order_By>;
  baths_min?: InputMaybe<Order_By>;
  rooms_max?: InputMaybe<Order_By>;
  rooms_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Folder_Properties_Type_Stddev_Pop_Fields = {
  __typename?: 'folder_properties_type_stddev_pop_fields';
  baths_max?: Maybe<Scalars['Float']['output']>;
  baths_min?: Maybe<Scalars['Float']['output']>;
  rooms_max?: Maybe<Scalars['Float']['output']>;
  rooms_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "folder_properties_type" */
export type Folder_Properties_Type_Stddev_Pop_Order_By = {
  baths_max?: InputMaybe<Order_By>;
  baths_min?: InputMaybe<Order_By>;
  rooms_max?: InputMaybe<Order_By>;
  rooms_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Folder_Properties_Type_Stddev_Samp_Fields = {
  __typename?: 'folder_properties_type_stddev_samp_fields';
  baths_max?: Maybe<Scalars['Float']['output']>;
  baths_min?: Maybe<Scalars['Float']['output']>;
  rooms_max?: Maybe<Scalars['Float']['output']>;
  rooms_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "folder_properties_type" */
export type Folder_Properties_Type_Stddev_Samp_Order_By = {
  baths_max?: InputMaybe<Order_By>;
  baths_min?: InputMaybe<Order_By>;
  rooms_max?: InputMaybe<Order_By>;
  rooms_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "folder_properties_type" */
export type Folder_Properties_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Folder_Properties_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Folder_Properties_Type_Stream_Cursor_Value_Input = {
  baths_max?: InputMaybe<Scalars['Int']['input']>;
  baths_min?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rooms_max?: InputMaybe<Scalars['Int']['input']>;
  rooms_min?: InputMaybe<Scalars['Int']['input']>;
  sq_max?: InputMaybe<Scalars['Int']['input']>;
  sq_min?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Property_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Folder_Properties_Type_Sum_Fields = {
  __typename?: 'folder_properties_type_sum_fields';
  baths_max?: Maybe<Scalars['Int']['output']>;
  baths_min?: Maybe<Scalars['Int']['output']>;
  rooms_max?: Maybe<Scalars['Int']['output']>;
  rooms_min?: Maybe<Scalars['Int']['output']>;
  sq_max?: Maybe<Scalars['Int']['output']>;
  sq_min?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "folder_properties_type" */
export type Folder_Properties_Type_Sum_Order_By = {
  baths_max?: InputMaybe<Order_By>;
  baths_min?: InputMaybe<Order_By>;
  rooms_max?: InputMaybe<Order_By>;
  rooms_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** update columns of table "folder_properties_type" */
export enum Folder_Properties_Type_Update_Column {
  /** column name */
  BathsMax = 'baths_max',
  /** column name */
  BathsMin = 'baths_min',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  RoomsMax = 'rooms_max',
  /** column name */
  RoomsMin = 'rooms_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Folder_Properties_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Folder_Properties_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Folder_Properties_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Folder_Properties_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Folder_Properties_Type_Var_Pop_Fields = {
  __typename?: 'folder_properties_type_var_pop_fields';
  baths_max?: Maybe<Scalars['Float']['output']>;
  baths_min?: Maybe<Scalars['Float']['output']>;
  rooms_max?: Maybe<Scalars['Float']['output']>;
  rooms_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "folder_properties_type" */
export type Folder_Properties_Type_Var_Pop_Order_By = {
  baths_max?: InputMaybe<Order_By>;
  baths_min?: InputMaybe<Order_By>;
  rooms_max?: InputMaybe<Order_By>;
  rooms_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Folder_Properties_Type_Var_Samp_Fields = {
  __typename?: 'folder_properties_type_var_samp_fields';
  baths_max?: Maybe<Scalars['Float']['output']>;
  baths_min?: Maybe<Scalars['Float']['output']>;
  rooms_max?: Maybe<Scalars['Float']['output']>;
  rooms_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "folder_properties_type" */
export type Folder_Properties_Type_Var_Samp_Order_By = {
  baths_max?: InputMaybe<Order_By>;
  baths_min?: InputMaybe<Order_By>;
  rooms_max?: InputMaybe<Order_By>;
  rooms_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Folder_Properties_Type_Variance_Fields = {
  __typename?: 'folder_properties_type_variance_fields';
  baths_max?: Maybe<Scalars['Float']['output']>;
  baths_min?: Maybe<Scalars['Float']['output']>;
  rooms_max?: Maybe<Scalars['Float']['output']>;
  rooms_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "folder_properties_type" */
export type Folder_Properties_Type_Variance_Order_By = {
  baths_max?: InputMaybe<Order_By>;
  baths_min?: InputMaybe<Order_By>;
  rooms_max?: InputMaybe<Order_By>;
  rooms_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** columns and relationships of "folder_status" */
export type Folder_Status = {
  __typename?: 'folder_status';
  status: Scalars['String']['output'];
};

/** aggregated selection of "folder_status" */
export type Folder_Status_Aggregate = {
  __typename?: 'folder_status_aggregate';
  aggregate?: Maybe<Folder_Status_Aggregate_Fields>;
  nodes: Array<Folder_Status>;
};

/** aggregate fields of "folder_status" */
export type Folder_Status_Aggregate_Fields = {
  __typename?: 'folder_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Folder_Status_Max_Fields>;
  min?: Maybe<Folder_Status_Min_Fields>;
};


/** aggregate fields of "folder_status" */
export type Folder_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Folder_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "folder_status". All fields are combined with a logical 'AND'. */
export type Folder_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Status_Bool_Exp>>;
  _not?: InputMaybe<Folder_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "folder_status" */
export enum Folder_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  FolderStatusPkey = 'folder_status_pkey'
}

export enum Folder_Status_Enum {
  Both = 'both',
  Rent = 'rent',
  Sale = 'sale'
}

/** Boolean expression to compare columns of type "folder_status_enum". All fields are combined with logical 'AND'. */
export type Folder_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Folder_Status_Enum>;
  _in?: InputMaybe<Array<Folder_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Folder_Status_Enum>;
  _nin?: InputMaybe<Array<Folder_Status_Enum>>;
};

/** input type for inserting data into table "folder_status" */
export type Folder_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Folder_Status_Max_Fields = {
  __typename?: 'folder_status_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Folder_Status_Min_Fields = {
  __typename?: 'folder_status_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "folder_status" */
export type Folder_Status_Mutation_Response = {
  __typename?: 'folder_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Folder_Status>;
};

/** on_conflict condition type for table "folder_status" */
export type Folder_Status_On_Conflict = {
  constraint: Folder_Status_Constraint;
  update_columns?: Array<Folder_Status_Update_Column>;
  where?: InputMaybe<Folder_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "folder_status". */
export type Folder_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: folder_status */
export type Folder_Status_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "folder_status" */
export enum Folder_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "folder_status" */
export type Folder_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "folder_status" */
export type Folder_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Folder_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Folder_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "folder_status" */
export enum Folder_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Folder_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Folder_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Folder_Status_Bool_Exp;
};

/** columns and relationships of "folder_type" */
export type Folder_Type = {
  __typename?: 'folder_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "folder_type" */
export type Folder_Type_Aggregate = {
  __typename?: 'folder_type_aggregate';
  aggregate?: Maybe<Folder_Type_Aggregate_Fields>;
  nodes: Array<Folder_Type>;
};

/** aggregate fields of "folder_type" */
export type Folder_Type_Aggregate_Fields = {
  __typename?: 'folder_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Folder_Type_Max_Fields>;
  min?: Maybe<Folder_Type_Min_Fields>;
};


/** aggregate fields of "folder_type" */
export type Folder_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Folder_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "folder_type". All fields are combined with a logical 'AND'. */
export type Folder_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Type_Bool_Exp>>;
  _not?: InputMaybe<Folder_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "folder_type" */
export enum Folder_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  FolderTypePkey = 'folder_type_pkey'
}

export enum Folder_Type_Enum {
  Claimed = 'claimed',
  Collection = 'collection',
  Project = 'project'
}

/** Boolean expression to compare columns of type "folder_type_enum". All fields are combined with logical 'AND'. */
export type Folder_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Folder_Type_Enum>;
  _in?: InputMaybe<Array<Folder_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Folder_Type_Enum>;
  _nin?: InputMaybe<Array<Folder_Type_Enum>>;
};

/** input type for inserting data into table "folder_type" */
export type Folder_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Folder_Type_Max_Fields = {
  __typename?: 'folder_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Folder_Type_Min_Fields = {
  __typename?: 'folder_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "folder_type" */
export type Folder_Type_Mutation_Response = {
  __typename?: 'folder_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Folder_Type>;
};

/** on_conflict condition type for table "folder_type" */
export type Folder_Type_On_Conflict = {
  constraint: Folder_Type_Constraint;
  update_columns?: Array<Folder_Type_Update_Column>;
  where?: InputMaybe<Folder_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "folder_type". */
export type Folder_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: folder_type */
export type Folder_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "folder_type" */
export enum Folder_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "folder_type" */
export type Folder_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "folder_type" */
export type Folder_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Folder_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Folder_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "folder_type" */
export enum Folder_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Folder_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Folder_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Folder_Type_Bool_Exp;
};

/** columns and relationships of "furnishing_status" */
export type Furnishing_Status = {
  __typename?: 'furnishing_status';
  status: Scalars['String']['output'];
};

export enum Furnishing_Status_ActionType {
  FullyFurnished = 'fully_furnished',
  PartiallyFurnished = 'partially_furnished',
  Unfurnished = 'unfurnished'
}

/** aggregated selection of "furnishing_status" */
export type Furnishing_Status_Aggregate = {
  __typename?: 'furnishing_status_aggregate';
  aggregate?: Maybe<Furnishing_Status_Aggregate_Fields>;
  nodes: Array<Furnishing_Status>;
};

/** aggregate fields of "furnishing_status" */
export type Furnishing_Status_Aggregate_Fields = {
  __typename?: 'furnishing_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Furnishing_Status_Max_Fields>;
  min?: Maybe<Furnishing_Status_Min_Fields>;
};


/** aggregate fields of "furnishing_status" */
export type Furnishing_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Furnishing_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "furnishing_status". All fields are combined with a logical 'AND'. */
export type Furnishing_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Furnishing_Status_Bool_Exp>>;
  _not?: InputMaybe<Furnishing_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Furnishing_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "furnishing_status" */
export enum Furnishing_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  FurnishingStatusPkey = 'furnishing_status_pkey'
}

export enum Furnishing_Status_Enum {
  FullyFurnished = 'fully_furnished',
  PartiallyFurnished = 'partially_furnished',
  Unfurnished = 'unfurnished'
}

/** Boolean expression to compare columns of type "furnishing_status_enum". All fields are combined with logical 'AND'. */
export type Furnishing_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Furnishing_Status_Enum>;
  _in?: InputMaybe<Array<Furnishing_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Furnishing_Status_Enum>;
  _nin?: InputMaybe<Array<Furnishing_Status_Enum>>;
};

/** input type for inserting data into table "furnishing_status" */
export type Furnishing_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Furnishing_Status_Max_Fields = {
  __typename?: 'furnishing_status_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Furnishing_Status_Min_Fields = {
  __typename?: 'furnishing_status_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "furnishing_status" */
export type Furnishing_Status_Mutation_Response = {
  __typename?: 'furnishing_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Furnishing_Status>;
};

/** on_conflict condition type for table "furnishing_status" */
export type Furnishing_Status_On_Conflict = {
  constraint: Furnishing_Status_Constraint;
  update_columns?: Array<Furnishing_Status_Update_Column>;
  where?: InputMaybe<Furnishing_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "furnishing_status". */
export type Furnishing_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: furnishing_status */
export type Furnishing_Status_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "furnishing_status" */
export enum Furnishing_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "furnishing_status" */
export type Furnishing_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "furnishing_status" */
export type Furnishing_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Furnishing_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Furnishing_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "furnishing_status" */
export enum Furnishing_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Furnishing_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Furnishing_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Furnishing_Status_Bool_Exp;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

/** getCityZoneForCoordsNative Query Arguments */
export type GetCityZoneForCoords_Arguments = {
  lat: Scalars['numeric']['input'];
  lng: Scalars['numeric']['input'];
};

/** getOrderByRelevanceCityZonesNative Query Arguments */
export type GetOrderByRelevanceCityZones_Arguments = {
  is_problematic: Scalars['Boolean']['input'];
  search_term: Scalars['String']['input'];
};

/** getOrderByRelevanceFormattedAddressCityZonesNative Query Arguments */
export type GetOrderByRelevanceFormattedAddressCityZones_Arguments = {
  is_problematic: Scalars['Boolean']['input'];
  search_term: Scalars['String']['input'];
};

export type Get_Folders_Without_Property_List_Args = {
  p_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  p_property_list_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Get_Similar_Agencies_By_Name_Args = {
  p_text?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Similar_Properties_Args = {
  ref_property_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Get_Similar_Properties_By_Slug_Args = {
  property_url_slug?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Top_Neighborhood_For_City_Zone_Args = {
  zone_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Get_User_Activity_Args = {
  order_by_type?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "google_calendar" */
export type Google_Calendar = {
  __typename?: 'google_calendar';
  calendar_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  refresh_token?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  token_expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "google_calendar" */
export type Google_Calendar_Aggregate = {
  __typename?: 'google_calendar_aggregate';
  aggregate?: Maybe<Google_Calendar_Aggregate_Fields>;
  nodes: Array<Google_Calendar>;
};

/** aggregate fields of "google_calendar" */
export type Google_Calendar_Aggregate_Fields = {
  __typename?: 'google_calendar_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Google_Calendar_Max_Fields>;
  min?: Maybe<Google_Calendar_Min_Fields>;
};


/** aggregate fields of "google_calendar" */
export type Google_Calendar_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Google_Calendar_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "google_calendar". All fields are combined with a logical 'AND'. */
export type Google_Calendar_Bool_Exp = {
  _and?: InputMaybe<Array<Google_Calendar_Bool_Exp>>;
  _not?: InputMaybe<Google_Calendar_Bool_Exp>;
  _or?: InputMaybe<Array<Google_Calendar_Bool_Exp>>;
  calendar_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  refresh_token?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  token_expiry_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "google_calendar" */
export enum Google_Calendar_Constraint {
  /** unique or primary key constraint on columns "user_id" */
  GoogleCalendarPkey = 'google_calendar_pkey'
}

/** input type for inserting data into table "google_calendar" */
export type Google_Calendar_Insert_Input = {
  calendar_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Google_Calendar_Max_Fields = {
  __typename?: 'google_calendar_max_fields';
  calendar_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  token_expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Google_Calendar_Min_Fields = {
  __typename?: 'google_calendar_min_fields';
  calendar_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  token_expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "google_calendar" */
export type Google_Calendar_Mutation_Response = {
  __typename?: 'google_calendar_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Google_Calendar>;
};

/** on_conflict condition type for table "google_calendar" */
export type Google_Calendar_On_Conflict = {
  constraint: Google_Calendar_Constraint;
  update_columns?: Array<Google_Calendar_Update_Column>;
  where?: InputMaybe<Google_Calendar_Bool_Exp>;
};

/** Ordering options when selecting data from "google_calendar". */
export type Google_Calendar_Order_By = {
  calendar_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refresh_token?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  token_expiry_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: google_calendar */
export type Google_Calendar_Pk_Columns_Input = {
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "google_calendar" */
export enum Google_Calendar_Select_Column {
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  Token = 'token',
  /** column name */
  TokenExpiryDate = 'token_expiry_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "google_calendar" */
export type Google_Calendar_Set_Input = {
  calendar_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "google_calendar" */
export type Google_Calendar_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Google_Calendar_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Google_Calendar_Stream_Cursor_Value_Input = {
  calendar_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "google_calendar" */
export enum Google_Calendar_Update_Column {
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  Token = 'token',
  /** column name */
  TokenExpiryDate = 'token_expiry_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Google_Calendar_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Google_Calendar_Set_Input>;
  /** filter the rows which have to be updated */
  where: Google_Calendar_Bool_Exp;
};

/** columns and relationships of "heatingType" */
export type HeatingType = {
  __typename?: 'heatingType';
  type: Scalars['String']['output'];
};

/** aggregated selection of "heatingType" */
export type HeatingType_Aggregate = {
  __typename?: 'heatingType_aggregate';
  aggregate?: Maybe<HeatingType_Aggregate_Fields>;
  nodes: Array<HeatingType>;
};

/** aggregate fields of "heatingType" */
export type HeatingType_Aggregate_Fields = {
  __typename?: 'heatingType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<HeatingType_Max_Fields>;
  min?: Maybe<HeatingType_Min_Fields>;
};


/** aggregate fields of "heatingType" */
export type HeatingType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<HeatingType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "heatingType". All fields are combined with a logical 'AND'. */
export type HeatingType_Bool_Exp = {
  _and?: InputMaybe<Array<HeatingType_Bool_Exp>>;
  _not?: InputMaybe<HeatingType_Bool_Exp>;
  _or?: InputMaybe<Array<HeatingType_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "heatingType" */
export enum HeatingType_Constraint {
  /** unique or primary key constraint on columns "type" */
  HeatingTypePkey = 'heatingType_pkey'
}

/** input type for inserting data into table "heatingType" */
export type HeatingType_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type HeatingType_Max_Fields = {
  __typename?: 'heatingType_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type HeatingType_Min_Fields = {
  __typename?: 'heatingType_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "heatingType" */
export type HeatingType_Mutation_Response = {
  __typename?: 'heatingType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<HeatingType>;
};

/** on_conflict condition type for table "heatingType" */
export type HeatingType_On_Conflict = {
  constraint: HeatingType_Constraint;
  update_columns?: Array<HeatingType_Update_Column>;
  where?: InputMaybe<HeatingType_Bool_Exp>;
};

/** Ordering options when selecting data from "heatingType". */
export type HeatingType_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: heatingType */
export type HeatingType_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "heatingType" */
export enum HeatingType_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "heatingType" */
export type HeatingType_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "heatingType" */
export type HeatingType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: HeatingType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type HeatingType_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "heatingType" */
export enum HeatingType_Update_Column {
  /** column name */
  Type = 'type'
}

export type HeatingType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<HeatingType_Set_Input>;
  /** filter the rows which have to be updated */
  where: HeatingType_Bool_Exp;
};

/** columns and relationships of "image" */
export type Image = {
  __typename?: 'image';
  blurhash?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  image: Scalars['String']['output'];
  origin_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "image" */
export type Image_Aggregate = {
  __typename?: 'image_aggregate';
  aggregate?: Maybe<Image_Aggregate_Fields>;
  nodes: Array<Image>;
};

/** aggregate fields of "image" */
export type Image_Aggregate_Fields = {
  __typename?: 'image_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Image_Max_Fields>;
  min?: Maybe<Image_Min_Fields>;
};


/** aggregate fields of "image" */
export type Image_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "image". All fields are combined with a logical 'AND'. */
export type Image_Bool_Exp = {
  _and?: InputMaybe<Array<Image_Bool_Exp>>;
  _not?: InputMaybe<Image_Bool_Exp>;
  _or?: InputMaybe<Array<Image_Bool_Exp>>;
  blurhash?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  origin_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "image" */
export enum Image_Constraint {
  /** unique or primary key constraint on columns "id" */
  ImagePkey = 'image_pkey'
}

/** input type for inserting data into table "image" */
export type Image_Insert_Input = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  origin_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Image_Max_Fields = {
  __typename?: 'image_max_fields';
  blurhash?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  origin_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Image_Min_Fields = {
  __typename?: 'image_min_fields';
  blurhash?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  origin_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "image" */
export type Image_Mutation_Response = {
  __typename?: 'image_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Image>;
};

/** on_conflict condition type for table "image" */
export type Image_On_Conflict = {
  constraint: Image_Constraint;
  update_columns?: Array<Image_Update_Column>;
  where?: InputMaybe<Image_Bool_Exp>;
};

/** Ordering options when selecting data from "image". */
export type Image_Order_By = {
  blurhash?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  origin_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: image */
export type Image_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "image" */
export enum Image_Select_Column {
  /** column name */
  Blurhash = 'blurhash',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  OriginUrl = 'origin_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "image" */
export type Image_Set_Input = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  origin_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "image" */
export type Image_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Image_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Image_Stream_Cursor_Value_Input = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  origin_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "image" */
export enum Image_Update_Column {
  /** column name */
  Blurhash = 'blurhash',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  OriginUrl = 'origin_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Image_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Image_Set_Input>;
  /** filter the rows which have to be updated */
  where: Image_Bool_Exp;
};

/** columns and relationships of "invoice_status" */
export type Invoice_Status = {
  __typename?: 'invoice_status';
  status: Scalars['String']['output'];
};

/** aggregated selection of "invoice_status" */
export type Invoice_Status_Aggregate = {
  __typename?: 'invoice_status_aggregate';
  aggregate?: Maybe<Invoice_Status_Aggregate_Fields>;
  nodes: Array<Invoice_Status>;
};

/** aggregate fields of "invoice_status" */
export type Invoice_Status_Aggregate_Fields = {
  __typename?: 'invoice_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Invoice_Status_Max_Fields>;
  min?: Maybe<Invoice_Status_Min_Fields>;
};


/** aggregate fields of "invoice_status" */
export type Invoice_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "invoice_status". All fields are combined with a logical 'AND'. */
export type Invoice_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Status_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "invoice_status" */
export enum Invoice_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  InvoiceStatusPkey = 'invoice_status_pkey'
}

/** input type for inserting data into table "invoice_status" */
export type Invoice_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Invoice_Status_Max_Fields = {
  __typename?: 'invoice_status_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Invoice_Status_Min_Fields = {
  __typename?: 'invoice_status_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "invoice_status" */
export type Invoice_Status_Mutation_Response = {
  __typename?: 'invoice_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice_Status>;
};

/** on_conflict condition type for table "invoice_status" */
export type Invoice_Status_On_Conflict = {
  constraint: Invoice_Status_Constraint;
  update_columns?: Array<Invoice_Status_Update_Column>;
  where?: InputMaybe<Invoice_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "invoice_status". */
export type Invoice_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invoice_status */
export type Invoice_Status_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "invoice_status" */
export enum Invoice_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "invoice_status" */
export type Invoice_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "invoice_status" */
export type Invoice_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "invoice_status" */
export enum Invoice_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Invoice_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoice_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoice_Status_Bool_Exp;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "languages" */
export type Languages = {
  __typename?: 'languages';
  language_code: Scalars['bpchar']['output'];
  language_id: Scalars['Int']['output'];
  language_name: Scalars['String']['output'];
};

/** aggregated selection of "languages" */
export type Languages_Aggregate = {
  __typename?: 'languages_aggregate';
  aggregate?: Maybe<Languages_Aggregate_Fields>;
  nodes: Array<Languages>;
};

/** aggregate fields of "languages" */
export type Languages_Aggregate_Fields = {
  __typename?: 'languages_aggregate_fields';
  avg?: Maybe<Languages_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Languages_Max_Fields>;
  min?: Maybe<Languages_Min_Fields>;
  stddev?: Maybe<Languages_Stddev_Fields>;
  stddev_pop?: Maybe<Languages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Languages_Stddev_Samp_Fields>;
  sum?: Maybe<Languages_Sum_Fields>;
  var_pop?: Maybe<Languages_Var_Pop_Fields>;
  var_samp?: Maybe<Languages_Var_Samp_Fields>;
  variance?: Maybe<Languages_Variance_Fields>;
};


/** aggregate fields of "languages" */
export type Languages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Languages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Languages_Avg_Fields = {
  __typename?: 'languages_avg_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "languages". All fields are combined with a logical 'AND'. */
export type Languages_Bool_Exp = {
  _and?: InputMaybe<Array<Languages_Bool_Exp>>;
  _not?: InputMaybe<Languages_Bool_Exp>;
  _or?: InputMaybe<Array<Languages_Bool_Exp>>;
  language_code?: InputMaybe<Bpchar_Comparison_Exp>;
  language_id?: InputMaybe<Int_Comparison_Exp>;
  language_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "languages" */
export enum Languages_Constraint {
  /** unique or primary key constraint on columns "language_code" */
  LanguagesLanguageCodeKey = 'languages_language_code_key',
  /** unique or primary key constraint on columns "language_name" */
  LanguagesLanguageNameKey = 'languages_language_name_key',
  /** unique or primary key constraint on columns "language_id" */
  LanguagesPkey = 'languages_pkey'
}

/** input type for incrementing numeric columns in table "languages" */
export type Languages_Inc_Input = {
  language_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "languages" */
export type Languages_Insert_Input = {
  language_code?: InputMaybe<Scalars['bpchar']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  language_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Languages_Max_Fields = {
  __typename?: 'languages_max_fields';
  language_code?: Maybe<Scalars['bpchar']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  language_name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Languages_Min_Fields = {
  __typename?: 'languages_min_fields';
  language_code?: Maybe<Scalars['bpchar']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  language_name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "languages" */
export type Languages_Mutation_Response = {
  __typename?: 'languages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Languages>;
};

/** input type for inserting object relation for remote table "languages" */
export type Languages_Obj_Rel_Insert_Input = {
  data: Languages_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Languages_On_Conflict>;
};

/** on_conflict condition type for table "languages" */
export type Languages_On_Conflict = {
  constraint: Languages_Constraint;
  update_columns?: Array<Languages_Update_Column>;
  where?: InputMaybe<Languages_Bool_Exp>;
};

/** Ordering options when selecting data from "languages". */
export type Languages_Order_By = {
  language_code?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  language_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: languages */
export type Languages_Pk_Columns_Input = {
  language_id: Scalars['Int']['input'];
};

/** select columns of table "languages" */
export enum Languages_Select_Column {
  /** column name */
  LanguageCode = 'language_code',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  LanguageName = 'language_name'
}

/** input type for updating data in table "languages" */
export type Languages_Set_Input = {
  language_code?: InputMaybe<Scalars['bpchar']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  language_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Languages_Stddev_Fields = {
  __typename?: 'languages_stddev_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Languages_Stddev_Pop_Fields = {
  __typename?: 'languages_stddev_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Languages_Stddev_Samp_Fields = {
  __typename?: 'languages_stddev_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "languages" */
export type Languages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Languages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Languages_Stream_Cursor_Value_Input = {
  language_code?: InputMaybe<Scalars['bpchar']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  language_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Languages_Sum_Fields = {
  __typename?: 'languages_sum_fields';
  language_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "languages" */
export enum Languages_Update_Column {
  /** column name */
  LanguageCode = 'language_code',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  LanguageName = 'language_name'
}

export type Languages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Languages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Languages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Languages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Languages_Var_Pop_Fields = {
  __typename?: 'languages_var_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Languages_Var_Samp_Fields = {
  __typename?: 'languages_var_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Languages_Variance_Fields = {
  __typename?: 'languages_variance_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "lead_property_category" */
export type Lead_Property_Category = {
  __typename?: 'lead_property_category';
  category: Scalars['String']['output'];
};

/** aggregated selection of "lead_property_category" */
export type Lead_Property_Category_Aggregate = {
  __typename?: 'lead_property_category_aggregate';
  aggregate?: Maybe<Lead_Property_Category_Aggregate_Fields>;
  nodes: Array<Lead_Property_Category>;
};

/** aggregate fields of "lead_property_category" */
export type Lead_Property_Category_Aggregate_Fields = {
  __typename?: 'lead_property_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Lead_Property_Category_Max_Fields>;
  min?: Maybe<Lead_Property_Category_Min_Fields>;
};


/** aggregate fields of "lead_property_category" */
export type Lead_Property_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lead_Property_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "lead_property_category". All fields are combined with a logical 'AND'. */
export type Lead_Property_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Lead_Property_Category_Bool_Exp>>;
  _not?: InputMaybe<Lead_Property_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Lead_Property_Category_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "lead_property_category" */
export enum Lead_Property_Category_Constraint {
  /** unique or primary key constraint on columns "category" */
  LeadPropertyCategoryPkey = 'lead_property_category_pkey'
}

export enum Lead_Property_Category_Enum {
  Citizen = 'citizen',
  Owner = 'owner'
}

/** Boolean expression to compare columns of type "lead_property_category_enum". All fields are combined with logical 'AND'. */
export type Lead_Property_Category_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Lead_Property_Category_Enum>;
  _in?: InputMaybe<Array<Lead_Property_Category_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Lead_Property_Category_Enum>;
  _nin?: InputMaybe<Array<Lead_Property_Category_Enum>>;
};

/** input type for inserting data into table "lead_property_category" */
export type Lead_Property_Category_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Lead_Property_Category_Max_Fields = {
  __typename?: 'lead_property_category_max_fields';
  category?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Lead_Property_Category_Min_Fields = {
  __typename?: 'lead_property_category_min_fields';
  category?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "lead_property_category" */
export type Lead_Property_Category_Mutation_Response = {
  __typename?: 'lead_property_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lead_Property_Category>;
};

/** on_conflict condition type for table "lead_property_category" */
export type Lead_Property_Category_On_Conflict = {
  constraint: Lead_Property_Category_Constraint;
  update_columns?: Array<Lead_Property_Category_Update_Column>;
  where?: InputMaybe<Lead_Property_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "lead_property_category". */
export type Lead_Property_Category_Order_By = {
  category?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lead_property_category */
export type Lead_Property_Category_Pk_Columns_Input = {
  category: Scalars['String']['input'];
};

/** select columns of table "lead_property_category" */
export enum Lead_Property_Category_Select_Column {
  /** column name */
  Category = 'category'
}

/** input type for updating data in table "lead_property_category" */
export type Lead_Property_Category_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "lead_property_category" */
export type Lead_Property_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lead_Property_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lead_Property_Category_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "lead_property_category" */
export enum Lead_Property_Category_Update_Column {
  /** column name */
  Category = 'category'
}

export type Lead_Property_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lead_Property_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lead_Property_Category_Bool_Exp;
};

/** columns and relationships of "lead_status" */
export type Lead_Status = {
  __typename?: 'lead_status';
  status: Scalars['String']['output'];
};

/** aggregated selection of "lead_status" */
export type Lead_Status_Aggregate = {
  __typename?: 'lead_status_aggregate';
  aggregate?: Maybe<Lead_Status_Aggregate_Fields>;
  nodes: Array<Lead_Status>;
};

/** aggregate fields of "lead_status" */
export type Lead_Status_Aggregate_Fields = {
  __typename?: 'lead_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Lead_Status_Max_Fields>;
  min?: Maybe<Lead_Status_Min_Fields>;
};


/** aggregate fields of "lead_status" */
export type Lead_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lead_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "lead_status". All fields are combined with a logical 'AND'. */
export type Lead_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Lead_Status_Bool_Exp>>;
  _not?: InputMaybe<Lead_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Lead_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "lead_status" */
export enum Lead_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  LeadStatusPkey = 'lead_status_pkey'
}

export enum Lead_Status_Enum {
  Contacted = 'CONTACTED',
  Deleted = 'DELETED',
  Interested = 'INTERESTED'
}

/** Boolean expression to compare columns of type "lead_status_enum". All fields are combined with logical 'AND'. */
export type Lead_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Lead_Status_Enum>;
  _in?: InputMaybe<Array<Lead_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Lead_Status_Enum>;
  _nin?: InputMaybe<Array<Lead_Status_Enum>>;
};

/** input type for inserting data into table "lead_status" */
export type Lead_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Lead_Status_Max_Fields = {
  __typename?: 'lead_status_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Lead_Status_Min_Fields = {
  __typename?: 'lead_status_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "lead_status" */
export type Lead_Status_Mutation_Response = {
  __typename?: 'lead_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lead_Status>;
};

/** on_conflict condition type for table "lead_status" */
export type Lead_Status_On_Conflict = {
  constraint: Lead_Status_Constraint;
  update_columns?: Array<Lead_Status_Update_Column>;
  where?: InputMaybe<Lead_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "lead_status". */
export type Lead_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lead_status */
export type Lead_Status_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "lead_status" */
export enum Lead_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "lead_status" */
export type Lead_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "lead_status" */
export type Lead_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lead_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lead_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "lead_status" */
export enum Lead_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Lead_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lead_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lead_Status_Bool_Exp;
};

/** columns and relationships of "lead_type" */
export type Lead_Type = {
  __typename?: 'lead_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "lead_type" */
export type Lead_Type_Aggregate = {
  __typename?: 'lead_type_aggregate';
  aggregate?: Maybe<Lead_Type_Aggregate_Fields>;
  nodes: Array<Lead_Type>;
};

/** aggregate fields of "lead_type" */
export type Lead_Type_Aggregate_Fields = {
  __typename?: 'lead_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Lead_Type_Max_Fields>;
  min?: Maybe<Lead_Type_Min_Fields>;
};


/** aggregate fields of "lead_type" */
export type Lead_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lead_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "lead_type". All fields are combined with a logical 'AND'. */
export type Lead_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Lead_Type_Bool_Exp>>;
  _not?: InputMaybe<Lead_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Lead_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "lead_type" */
export enum Lead_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  LeadTypePkey = 'lead_type_pkey'
}

export enum Lead_Type_Enum {
  Notify = 'NOTIFY',
  PotentialBuyer = 'POTENTIAL_BUYER',
  Saved = 'SAVED',
  Seen = 'SEEN',
  Whatsapp = 'WHATSAPP'
}

/** Boolean expression to compare columns of type "lead_type_enum". All fields are combined with logical 'AND'. */
export type Lead_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Lead_Type_Enum>;
  _in?: InputMaybe<Array<Lead_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Lead_Type_Enum>;
  _nin?: InputMaybe<Array<Lead_Type_Enum>>;
};

/** input type for inserting data into table "lead_type" */
export type Lead_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Lead_Type_Max_Fields = {
  __typename?: 'lead_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Lead_Type_Min_Fields = {
  __typename?: 'lead_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "lead_type" */
export type Lead_Type_Mutation_Response = {
  __typename?: 'lead_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lead_Type>;
};

/** on_conflict condition type for table "lead_type" */
export type Lead_Type_On_Conflict = {
  constraint: Lead_Type_Constraint;
  update_columns?: Array<Lead_Type_Update_Column>;
  where?: InputMaybe<Lead_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "lead_type". */
export type Lead_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lead_type */
export type Lead_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "lead_type" */
export enum Lead_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "lead_type" */
export type Lead_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "lead_type" */
export type Lead_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lead_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lead_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "lead_type" */
export enum Lead_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Lead_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lead_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lead_Type_Bool_Exp;
};

/** leads_statisticsNative Query Arguments */
export type Leads_Statistics_Arguments = {
  organization_id: Scalars['uuid']['input'];
};

export type Leads_Statistics_Model = {
  __typename?: 'leads_statistics_model';
  kaktu_leads?: Maybe<Scalars['bigint']['output']>;
  leads_contacted?: Maybe<Scalars['bigint']['output']>;
  potential_leads?: Maybe<Scalars['bigint']['output']>;
  total_leads?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the logical model for "leads_statistics_model". All fields are combined with a logical 'AND'. */
export type Leads_Statistics_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Leads_Statistics_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Leads_Statistics_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Leads_Statistics_Model_Bool_Exp_Bool_Exp>>;
  kaktu_leads?: InputMaybe<Bigint_Comparison_Exp>;
  leads_contacted?: InputMaybe<Bigint_Comparison_Exp>;
  potential_leads?: InputMaybe<Bigint_Comparison_Exp>;
  total_leads?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Leads_Statistics_Model_Enum_Name {
  /** column name */
  KaktuLeads = 'kaktu_leads',
  /** column name */
  LeadsContacted = 'leads_contacted',
  /** column name */
  PotentialLeads = 'potential_leads',
  /** column name */
  TotalLeads = 'total_leads'
}

/** Ordering options when selecting data from "leads_statistics_model". */
export type Leads_Statistics_Model_Order_By = {
  kaktu_leads?: InputMaybe<Order_By>;
  leads_contacted?: InputMaybe<Order_By>;
  potential_leads?: InputMaybe<Order_By>;
  total_leads?: InputMaybe<Order_By>;
};

/** columns and relationships of "lister_claim_request" */
export type Lister_Claim_Request = {
  __typename?: 'lister_claim_request';
  agency_name: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  status?: Maybe<Claim_Request_Status_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "lister_claim_request_activity" */
export type Lister_Claim_Request_Activity = {
  __typename?: 'lister_claim_request_activity';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  lister_claim_request_id: Scalars['uuid']['output'];
  new_status: Claim_Request_Status_Enum;
  old_status: Claim_Request_Status_Enum;
  updated_at: Scalars['timestamptz']['output'];
  user_updated_by_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "lister_claim_request_activity" */
export type Lister_Claim_Request_Activity_Aggregate = {
  __typename?: 'lister_claim_request_activity_aggregate';
  aggregate?: Maybe<Lister_Claim_Request_Activity_Aggregate_Fields>;
  nodes: Array<Lister_Claim_Request_Activity>;
};

/** aggregate fields of "lister_claim_request_activity" */
export type Lister_Claim_Request_Activity_Aggregate_Fields = {
  __typename?: 'lister_claim_request_activity_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Lister_Claim_Request_Activity_Max_Fields>;
  min?: Maybe<Lister_Claim_Request_Activity_Min_Fields>;
};


/** aggregate fields of "lister_claim_request_activity" */
export type Lister_Claim_Request_Activity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lister_Claim_Request_Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "lister_claim_request_activity". All fields are combined with a logical 'AND'. */
export type Lister_Claim_Request_Activity_Bool_Exp = {
  _and?: InputMaybe<Array<Lister_Claim_Request_Activity_Bool_Exp>>;
  _not?: InputMaybe<Lister_Claim_Request_Activity_Bool_Exp>;
  _or?: InputMaybe<Array<Lister_Claim_Request_Activity_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lister_claim_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  new_status?: InputMaybe<Claim_Request_Status_Enum_Comparison_Exp>;
  old_status?: InputMaybe<Claim_Request_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_updated_by_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "lister_claim_request_activity" */
export enum Lister_Claim_Request_Activity_Constraint {
  /** unique or primary key constraint on columns "id" */
  ListerClaimRequestActivityPkey = 'lister_claim_request_activity_pkey'
}

/** input type for inserting data into table "lister_claim_request_activity" */
export type Lister_Claim_Request_Activity_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lister_claim_request_id?: InputMaybe<Scalars['uuid']['input']>;
  new_status?: InputMaybe<Claim_Request_Status_Enum>;
  old_status?: InputMaybe<Claim_Request_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Lister_Claim_Request_Activity_Max_Fields = {
  __typename?: 'lister_claim_request_activity_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lister_claim_request_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_updated_by_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Lister_Claim_Request_Activity_Min_Fields = {
  __typename?: 'lister_claim_request_activity_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lister_claim_request_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_updated_by_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "lister_claim_request_activity" */
export type Lister_Claim_Request_Activity_Mutation_Response = {
  __typename?: 'lister_claim_request_activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lister_Claim_Request_Activity>;
};

/** on_conflict condition type for table "lister_claim_request_activity" */
export type Lister_Claim_Request_Activity_On_Conflict = {
  constraint: Lister_Claim_Request_Activity_Constraint;
  update_columns?: Array<Lister_Claim_Request_Activity_Update_Column>;
  where?: InputMaybe<Lister_Claim_Request_Activity_Bool_Exp>;
};

/** Ordering options when selecting data from "lister_claim_request_activity". */
export type Lister_Claim_Request_Activity_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lister_claim_request_id?: InputMaybe<Order_By>;
  new_status?: InputMaybe<Order_By>;
  old_status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lister_claim_request_activity */
export type Lister_Claim_Request_Activity_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lister_claim_request_activity" */
export enum Lister_Claim_Request_Activity_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ListerClaimRequestId = 'lister_claim_request_id',
  /** column name */
  NewStatus = 'new_status',
  /** column name */
  OldStatus = 'old_status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserUpdatedById = 'user_updated_by_id'
}

/** input type for updating data in table "lister_claim_request_activity" */
export type Lister_Claim_Request_Activity_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lister_claim_request_id?: InputMaybe<Scalars['uuid']['input']>;
  new_status?: InputMaybe<Claim_Request_Status_Enum>;
  old_status?: InputMaybe<Claim_Request_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "lister_claim_request_activity" */
export type Lister_Claim_Request_Activity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lister_Claim_Request_Activity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lister_Claim_Request_Activity_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lister_claim_request_id?: InputMaybe<Scalars['uuid']['input']>;
  new_status?: InputMaybe<Claim_Request_Status_Enum>;
  old_status?: InputMaybe<Claim_Request_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "lister_claim_request_activity" */
export enum Lister_Claim_Request_Activity_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ListerClaimRequestId = 'lister_claim_request_id',
  /** column name */
  NewStatus = 'new_status',
  /** column name */
  OldStatus = 'old_status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserUpdatedById = 'user_updated_by_id'
}

export type Lister_Claim_Request_Activity_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lister_Claim_Request_Activity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lister_Claim_Request_Activity_Bool_Exp;
};

/** aggregated selection of "lister_claim_request" */
export type Lister_Claim_Request_Aggregate = {
  __typename?: 'lister_claim_request_aggregate';
  aggregate?: Maybe<Lister_Claim_Request_Aggregate_Fields>;
  nodes: Array<Lister_Claim_Request>;
};

/** aggregate fields of "lister_claim_request" */
export type Lister_Claim_Request_Aggregate_Fields = {
  __typename?: 'lister_claim_request_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Lister_Claim_Request_Max_Fields>;
  min?: Maybe<Lister_Claim_Request_Min_Fields>;
};


/** aggregate fields of "lister_claim_request" */
export type Lister_Claim_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lister_Claim_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "lister_claim_request". All fields are combined with a logical 'AND'. */
export type Lister_Claim_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Lister_Claim_Request_Bool_Exp>>;
  _not?: InputMaybe<Lister_Claim_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Lister_Claim_Request_Bool_Exp>>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Claim_Request_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "lister_claim_request" */
export enum Lister_Claim_Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  ListerClaimRequestPkey = 'lister_claim_request_pkey'
}

/** input type for inserting data into table "lister_claim_request" */
export type Lister_Claim_Request_Insert_Input = {
  agency_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Claim_Request_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Lister_Claim_Request_Max_Fields = {
  __typename?: 'lister_claim_request_max_fields';
  agency_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Lister_Claim_Request_Min_Fields = {
  __typename?: 'lister_claim_request_min_fields';
  agency_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "lister_claim_request" */
export type Lister_Claim_Request_Mutation_Response = {
  __typename?: 'lister_claim_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lister_Claim_Request>;
};

/** on_conflict condition type for table "lister_claim_request" */
export type Lister_Claim_Request_On_Conflict = {
  constraint: Lister_Claim_Request_Constraint;
  update_columns?: Array<Lister_Claim_Request_Update_Column>;
  where?: InputMaybe<Lister_Claim_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "lister_claim_request". */
export type Lister_Claim_Request_Order_By = {
  agency_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lister_claim_request */
export type Lister_Claim_Request_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lister_claim_request" */
export enum Lister_Claim_Request_Select_Column {
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "lister_claim_request" */
export type Lister_Claim_Request_Set_Input = {
  agency_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Claim_Request_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "lister_claim_request" */
export type Lister_Claim_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lister_Claim_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lister_Claim_Request_Stream_Cursor_Value_Input = {
  agency_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Claim_Request_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "lister_claim_request" */
export enum Lister_Claim_Request_Update_Column {
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Lister_Claim_Request_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lister_Claim_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lister_Claim_Request_Bool_Exp;
};

export enum Lister_Claim_Response_ActionType {
  Lister = 'LISTER',
  NotALister = 'NOT_A_LISTER',
  PhoneNotVerified = 'PHONE_NOT_VERIFIED'
}

/** columns and relationships of "lister_contact" */
export type Lister_Contact = {
  __typename?: 'lister_contact';
  budget_range?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  desired_features?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  last_qualification_stage?: Maybe<Scalars['String']['output']>;
  lead_score?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  lister_contact_meetings: Array<Lister_Contact_Meeting>;
  /** An aggregate relationship */
  lister_contact_meetings_aggregate: Lister_Contact_Meeting_Aggregate;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  owner?: Maybe<Users>;
  owner_id?: Maybe<Scalars['uuid']['output']>;
  phone: Scalars['String']['output'];
  phone_number_verified: Scalars['Boolean']['output'];
  preferred_areas?: Maybe<Scalars['String']['output']>;
  purpuse?: Maybe<Scalars['String']['output']>;
  source: Lister_Contact_Source_Enum;
  timeline?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "lister_contact" */
export type Lister_ContactLister_Contact_MeetingsArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Meeting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Meeting_Order_By>>;
  where?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
};


/** columns and relationships of "lister_contact" */
export type Lister_ContactLister_Contact_Meetings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Meeting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Meeting_Order_By>>;
  where?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
};


/** columns and relationships of "lister_contact" */
export type Lister_ContactMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "lister_contact" */
export type Lister_Contact_Aggregate = {
  __typename?: 'lister_contact_aggregate';
  aggregate?: Maybe<Lister_Contact_Aggregate_Fields>;
  nodes: Array<Lister_Contact>;
};

/** aggregate fields of "lister_contact" */
export type Lister_Contact_Aggregate_Fields = {
  __typename?: 'lister_contact_aggregate_fields';
  avg?: Maybe<Lister_Contact_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lister_Contact_Max_Fields>;
  min?: Maybe<Lister_Contact_Min_Fields>;
  stddev?: Maybe<Lister_Contact_Stddev_Fields>;
  stddev_pop?: Maybe<Lister_Contact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lister_Contact_Stddev_Samp_Fields>;
  sum?: Maybe<Lister_Contact_Sum_Fields>;
  var_pop?: Maybe<Lister_Contact_Var_Pop_Fields>;
  var_samp?: Maybe<Lister_Contact_Var_Samp_Fields>;
  variance?: Maybe<Lister_Contact_Variance_Fields>;
};


/** aggregate fields of "lister_contact" */
export type Lister_Contact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lister_Contact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Lister_Contact_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Lister_Contact_Avg_Fields = {
  __typename?: 'lister_contact_avg_fields';
  lead_score?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "lister_contact". All fields are combined with a logical 'AND'. */
export type Lister_Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Lister_Contact_Bool_Exp>>;
  _not?: InputMaybe<Lister_Contact_Bool_Exp>;
  _or?: InputMaybe<Array<Lister_Contact_Bool_Exp>>;
  budget_range?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  desired_features?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_qualification_stage?: InputMaybe<String_Comparison_Exp>;
  lead_score?: InputMaybe<Int_Comparison_Exp>;
  lister_contact_meetings?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
  lister_contact_meetings_aggregate?: InputMaybe<Lister_Contact_Meeting_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<Users_Bool_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  phone_number_verified?: InputMaybe<Boolean_Comparison_Exp>;
  preferred_areas?: InputMaybe<String_Comparison_Exp>;
  purpuse?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<Lister_Contact_Source_Enum_Comparison_Exp>;
  timeline?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "lister_contact" */
export enum Lister_Contact_Constraint {
  /** unique or primary key constraint on columns "id" */
  ListerClientPkey = 'lister_client_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Lister_Contact_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Lister_Contact_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Lister_Contact_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "lister_contact" */
export type Lister_Contact_Inc_Input = {
  lead_score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "lister_contact" */
export type Lister_Contact_Insert_Input = {
  budget_range?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  desired_features?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_qualification_stage?: InputMaybe<Scalars['String']['input']>;
  lead_score?: InputMaybe<Scalars['Int']['input']>;
  lister_contact_meetings?: InputMaybe<Lister_Contact_Meeting_Arr_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
  preferred_areas?: InputMaybe<Scalars['String']['input']>;
  purpuse?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Lister_Contact_Source_Enum>;
  timeline?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Lister_Contact_Max_Fields = {
  __typename?: 'lister_contact_max_fields';
  budget_range?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  desired_features?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_qualification_stage?: Maybe<Scalars['String']['output']>;
  lead_score?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['uuid']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferred_areas?: Maybe<Scalars['String']['output']>;
  purpuse?: Maybe<Scalars['String']['output']>;
  timeline?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** columns and relationships of "lister_contact_meeting" */
export type Lister_Contact_Meeting = {
  __typename?: 'lister_contact_meeting';
  contact_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lister_contact: Lister_Contact;
  /** An object relationship */
  lister_meeting: Lister_Meeting;
  meeting_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "lister_contact_meeting" */
export type Lister_Contact_Meeting_Aggregate = {
  __typename?: 'lister_contact_meeting_aggregate';
  aggregate?: Maybe<Lister_Contact_Meeting_Aggregate_Fields>;
  nodes: Array<Lister_Contact_Meeting>;
};

export type Lister_Contact_Meeting_Aggregate_Bool_Exp = {
  count?: InputMaybe<Lister_Contact_Meeting_Aggregate_Bool_Exp_Count>;
};

export type Lister_Contact_Meeting_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lister_Contact_Meeting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lister_contact_meeting" */
export type Lister_Contact_Meeting_Aggregate_Fields = {
  __typename?: 'lister_contact_meeting_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Lister_Contact_Meeting_Max_Fields>;
  min?: Maybe<Lister_Contact_Meeting_Min_Fields>;
};


/** aggregate fields of "lister_contact_meeting" */
export type Lister_Contact_Meeting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lister_Contact_Meeting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lister_contact_meeting" */
export type Lister_Contact_Meeting_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lister_Contact_Meeting_Max_Order_By>;
  min?: InputMaybe<Lister_Contact_Meeting_Min_Order_By>;
};

/** input type for inserting array relation for remote table "lister_contact_meeting" */
export type Lister_Contact_Meeting_Arr_Rel_Insert_Input = {
  data: Array<Lister_Contact_Meeting_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lister_Contact_Meeting_On_Conflict>;
};

/** Boolean expression to filter rows from the table "lister_contact_meeting". All fields are combined with a logical 'AND'. */
export type Lister_Contact_Meeting_Bool_Exp = {
  _and?: InputMaybe<Array<Lister_Contact_Meeting_Bool_Exp>>;
  _not?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
  _or?: InputMaybe<Array<Lister_Contact_Meeting_Bool_Exp>>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lister_contact?: InputMaybe<Lister_Contact_Bool_Exp>;
  lister_meeting?: InputMaybe<Lister_Meeting_Bool_Exp>;
  meeting_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "lister_contact_meeting" */
export enum Lister_Contact_Meeting_Constraint {
  /** unique or primary key constraint on columns "id" */
  ListerContactMeetingPkey = 'lister_contact_meeting_pkey'
}

/** input type for inserting data into table "lister_contact_meeting" */
export type Lister_Contact_Meeting_Insert_Input = {
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lister_contact?: InputMaybe<Lister_Contact_Obj_Rel_Insert_Input>;
  lister_meeting?: InputMaybe<Lister_Meeting_Obj_Rel_Insert_Input>;
  meeting_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Lister_Contact_Meeting_Max_Fields = {
  __typename?: 'lister_contact_meeting_max_fields';
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  meeting_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "lister_contact_meeting" */
export type Lister_Contact_Meeting_Max_Order_By = {
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meeting_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lister_Contact_Meeting_Min_Fields = {
  __typename?: 'lister_contact_meeting_min_fields';
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  meeting_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "lister_contact_meeting" */
export type Lister_Contact_Meeting_Min_Order_By = {
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meeting_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lister_contact_meeting" */
export type Lister_Contact_Meeting_Mutation_Response = {
  __typename?: 'lister_contact_meeting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lister_Contact_Meeting>;
};

/** on_conflict condition type for table "lister_contact_meeting" */
export type Lister_Contact_Meeting_On_Conflict = {
  constraint: Lister_Contact_Meeting_Constraint;
  update_columns?: Array<Lister_Contact_Meeting_Update_Column>;
  where?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
};

/** Ordering options when selecting data from "lister_contact_meeting". */
export type Lister_Contact_Meeting_Order_By = {
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lister_contact?: InputMaybe<Lister_Contact_Order_By>;
  lister_meeting?: InputMaybe<Lister_Meeting_Order_By>;
  meeting_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lister_contact_meeting */
export type Lister_Contact_Meeting_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lister_contact_meeting" */
export enum Lister_Contact_Meeting_Select_Column {
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MeetingId = 'meeting_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "lister_contact_meeting" */
export type Lister_Contact_Meeting_Set_Input = {
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  meeting_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "lister_contact_meeting" */
export type Lister_Contact_Meeting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lister_Contact_Meeting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lister_Contact_Meeting_Stream_Cursor_Value_Input = {
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  meeting_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "lister_contact_meeting" */
export enum Lister_Contact_Meeting_Update_Column {
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MeetingId = 'meeting_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Lister_Contact_Meeting_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lister_Contact_Meeting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lister_Contact_Meeting_Bool_Exp;
};

/** aggregate min on columns */
export type Lister_Contact_Min_Fields = {
  __typename?: 'lister_contact_min_fields';
  budget_range?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  desired_features?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_qualification_stage?: Maybe<Scalars['String']['output']>;
  lead_score?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['uuid']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferred_areas?: Maybe<Scalars['String']['output']>;
  purpuse?: Maybe<Scalars['String']['output']>;
  timeline?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "lister_contact" */
export type Lister_Contact_Mutation_Response = {
  __typename?: 'lister_contact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lister_Contact>;
};

/** input type for inserting object relation for remote table "lister_contact" */
export type Lister_Contact_Obj_Rel_Insert_Input = {
  data: Lister_Contact_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Lister_Contact_On_Conflict>;
};

/** on_conflict condition type for table "lister_contact" */
export type Lister_Contact_On_Conflict = {
  constraint: Lister_Contact_Constraint;
  update_columns?: Array<Lister_Contact_Update_Column>;
  where?: InputMaybe<Lister_Contact_Bool_Exp>;
};

/** Ordering options when selecting data from "lister_contact". */
export type Lister_Contact_Order_By = {
  budget_range?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  desired_features?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_qualification_stage?: InputMaybe<Order_By>;
  lead_score?: InputMaybe<Order_By>;
  lister_contact_meetings_aggregate?: InputMaybe<Lister_Contact_Meeting_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Users_Order_By>;
  owner_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  phone_number_verified?: InputMaybe<Order_By>;
  preferred_areas?: InputMaybe<Order_By>;
  purpuse?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  timeline?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lister_contact */
export type Lister_Contact_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Lister_Contact_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "lister_contact" */
export enum Lister_Contact_Select_Column {
  /** column name */
  BudgetRange = 'budget_range',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DesiredFeatures = 'desired_features',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  LastQualificationStage = 'last_qualification_stage',
  /** column name */
  LeadScore = 'lead_score',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  PhoneNumberVerified = 'phone_number_verified',
  /** column name */
  PreferredAreas = 'preferred_areas',
  /** column name */
  Purpuse = 'purpuse',
  /** column name */
  Source = 'source',
  /** column name */
  Timeline = 'timeline',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "lister_contact" */
export type Lister_Contact_Set_Input = {
  budget_range?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  desired_features?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_qualification_stage?: InputMaybe<Scalars['String']['input']>;
  lead_score?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
  preferred_areas?: InputMaybe<Scalars['String']['input']>;
  purpuse?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Lister_Contact_Source_Enum>;
  timeline?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "lister_contact_source" */
export type Lister_Contact_Source = {
  __typename?: 'lister_contact_source';
  source: Scalars['String']['output'];
};

/** aggregated selection of "lister_contact_source" */
export type Lister_Contact_Source_Aggregate = {
  __typename?: 'lister_contact_source_aggregate';
  aggregate?: Maybe<Lister_Contact_Source_Aggregate_Fields>;
  nodes: Array<Lister_Contact_Source>;
};

/** aggregate fields of "lister_contact_source" */
export type Lister_Contact_Source_Aggregate_Fields = {
  __typename?: 'lister_contact_source_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Lister_Contact_Source_Max_Fields>;
  min?: Maybe<Lister_Contact_Source_Min_Fields>;
};


/** aggregate fields of "lister_contact_source" */
export type Lister_Contact_Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lister_Contact_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "lister_contact_source". All fields are combined with a logical 'AND'. */
export type Lister_Contact_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Lister_Contact_Source_Bool_Exp>>;
  _not?: InputMaybe<Lister_Contact_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Lister_Contact_Source_Bool_Exp>>;
  source?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "lister_contact_source" */
export enum Lister_Contact_Source_Constraint {
  /** unique or primary key constraint on columns "source" */
  ListerContactSourcePkey = 'lister_contact_source_pkey'
}

export enum Lister_Contact_Source_Enum {
  Bot = 'BOT',
  Lister = 'LISTER'
}

/** Boolean expression to compare columns of type "lister_contact_source_enum". All fields are combined with logical 'AND'. */
export type Lister_Contact_Source_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Lister_Contact_Source_Enum>;
  _in?: InputMaybe<Array<Lister_Contact_Source_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Lister_Contact_Source_Enum>;
  _nin?: InputMaybe<Array<Lister_Contact_Source_Enum>>;
};

/** input type for inserting data into table "lister_contact_source" */
export type Lister_Contact_Source_Insert_Input = {
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Lister_Contact_Source_Max_Fields = {
  __typename?: 'lister_contact_source_max_fields';
  source?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Lister_Contact_Source_Min_Fields = {
  __typename?: 'lister_contact_source_min_fields';
  source?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "lister_contact_source" */
export type Lister_Contact_Source_Mutation_Response = {
  __typename?: 'lister_contact_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lister_Contact_Source>;
};

/** on_conflict condition type for table "lister_contact_source" */
export type Lister_Contact_Source_On_Conflict = {
  constraint: Lister_Contact_Source_Constraint;
  update_columns?: Array<Lister_Contact_Source_Update_Column>;
  where?: InputMaybe<Lister_Contact_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "lister_contact_source". */
export type Lister_Contact_Source_Order_By = {
  source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lister_contact_source */
export type Lister_Contact_Source_Pk_Columns_Input = {
  source: Scalars['String']['input'];
};

/** select columns of table "lister_contact_source" */
export enum Lister_Contact_Source_Select_Column {
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "lister_contact_source" */
export type Lister_Contact_Source_Set_Input = {
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "lister_contact_source" */
export type Lister_Contact_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lister_Contact_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lister_Contact_Source_Stream_Cursor_Value_Input = {
  source?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "lister_contact_source" */
export enum Lister_Contact_Source_Update_Column {
  /** column name */
  Source = 'source'
}

export type Lister_Contact_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lister_Contact_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lister_Contact_Source_Bool_Exp;
};

/** aggregate stddev on columns */
export type Lister_Contact_Stddev_Fields = {
  __typename?: 'lister_contact_stddev_fields';
  lead_score?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Lister_Contact_Stddev_Pop_Fields = {
  __typename?: 'lister_contact_stddev_pop_fields';
  lead_score?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Lister_Contact_Stddev_Samp_Fields = {
  __typename?: 'lister_contact_stddev_samp_fields';
  lead_score?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "lister_contact" */
export type Lister_Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lister_Contact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lister_Contact_Stream_Cursor_Value_Input = {
  budget_range?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  desired_features?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_qualification_stage?: InputMaybe<Scalars['String']['input']>;
  lead_score?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_id?: InputMaybe<Scalars['uuid']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
  preferred_areas?: InputMaybe<Scalars['String']['input']>;
  purpuse?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Lister_Contact_Source_Enum>;
  timeline?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Lister_Contact_Sum_Fields = {
  __typename?: 'lister_contact_sum_fields';
  lead_score?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "lister_contact" */
export enum Lister_Contact_Update_Column {
  /** column name */
  BudgetRange = 'budget_range',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DesiredFeatures = 'desired_features',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  LastQualificationStage = 'last_qualification_stage',
  /** column name */
  LeadScore = 'lead_score',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  PhoneNumberVerified = 'phone_number_verified',
  /** column name */
  PreferredAreas = 'preferred_areas',
  /** column name */
  Purpuse = 'purpuse',
  /** column name */
  Source = 'source',
  /** column name */
  Timeline = 'timeline',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Lister_Contact_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Lister_Contact_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Lister_Contact_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Lister_Contact_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Lister_Contact_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lister_Contact_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Lister_Contact_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lister_Contact_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lister_Contact_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lister_Contact_Var_Pop_Fields = {
  __typename?: 'lister_contact_var_pop_fields';
  lead_score?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Lister_Contact_Var_Samp_Fields = {
  __typename?: 'lister_contact_var_samp_fields';
  lead_score?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Lister_Contact_Variance_Fields = {
  __typename?: 'lister_contact_variance_fields';
  lead_score?: Maybe<Scalars['Float']['output']>;
};

export type Lister_Dashboard_Model = {
  __typename?: 'lister_dashboard_model';
  aggregator_total?: Maybe<Scalars['bigint']['output']>;
  kaktu_total?: Maybe<Scalars['bigint']['output']>;
  lister_total?: Maybe<Scalars['bigint']['output']>;
  total_views?: Maybe<Scalars['bigint']['output']>;
  unavailable_properties?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the logical model for "lister_dashboard_model". All fields are combined with a logical 'AND'. */
export type Lister_Dashboard_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Lister_Dashboard_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Lister_Dashboard_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Lister_Dashboard_Model_Bool_Exp_Bool_Exp>>;
  aggregator_total?: InputMaybe<Bigint_Comparison_Exp>;
  kaktu_total?: InputMaybe<Bigint_Comparison_Exp>;
  lister_total?: InputMaybe<Bigint_Comparison_Exp>;
  total_views?: InputMaybe<Bigint_Comparison_Exp>;
  unavailable_properties?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Lister_Dashboard_Model_Enum_Name {
  /** column name */
  AggregatorTotal = 'aggregator_total',
  /** column name */
  KaktuTotal = 'kaktu_total',
  /** column name */
  ListerTotal = 'lister_total',
  /** column name */
  TotalViews = 'total_views',
  /** column name */
  UnavailableProperties = 'unavailable_properties'
}

/** Ordering options when selecting data from "lister_dashboard_model". */
export type Lister_Dashboard_Model_Order_By = {
  aggregator_total?: InputMaybe<Order_By>;
  kaktu_total?: InputMaybe<Order_By>;
  lister_total?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
  unavailable_properties?: InputMaybe<Order_By>;
};

/** columns and relationships of "lister_leads" */
export type Lister_Leads = {
  __typename?: 'lister_leads';
  avatar_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  inquiry_date: Scalars['date']['output'];
  /** An object relationship */
  lister_user?: Maybe<Users>;
  lister_user_id?: Maybe<Scalars['uuid']['output']>;
  property_list?: Maybe<Property_List>;
  property_list_id: Scalars['uuid']['output'];
  status: Lead_Status_Enum;
  type: Lead_Type_Enum;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_display_name?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_phone_number?: Maybe<Scalars['String']['output']>;
  user_phone_number_verified?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "lister_leads" */
export type Lister_Leads_Aggregate = {
  __typename?: 'lister_leads_aggregate';
  aggregate?: Maybe<Lister_Leads_Aggregate_Fields>;
  nodes: Array<Lister_Leads>;
};

/** aggregate fields of "lister_leads" */
export type Lister_Leads_Aggregate_Fields = {
  __typename?: 'lister_leads_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Lister_Leads_Max_Fields>;
  min?: Maybe<Lister_Leads_Min_Fields>;
};


/** aggregate fields of "lister_leads" */
export type Lister_Leads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lister_Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "lister_leads". All fields are combined with a logical 'AND'. */
export type Lister_Leads_Bool_Exp = {
  _and?: InputMaybe<Array<Lister_Leads_Bool_Exp>>;
  _not?: InputMaybe<Lister_Leads_Bool_Exp>;
  _or?: InputMaybe<Array<Lister_Leads_Bool_Exp>>;
  avatar_url?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inquiry_date?: InputMaybe<Date_Comparison_Exp>;
  lister_user?: InputMaybe<Users_Bool_Exp>;
  lister_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Lead_Status_Enum_Comparison_Exp>;
  type?: InputMaybe<Lead_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_display_name?: InputMaybe<String_Comparison_Exp>;
  user_email?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_phone_number?: InputMaybe<String_Comparison_Exp>;
  user_phone_number_verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "lister_leads" */
export enum Lister_Leads_Constraint {
  /** unique or primary key constraint on columns "id" */
  ListerLeadesPkey = 'lister_leades_pkey'
}

/** input type for inserting data into table "lister_leads" */
export type Lister_Leads_Insert_Input = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inquiry_date?: InputMaybe<Scalars['date']['input']>;
  lister_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  lister_user_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Lead_Status_Enum>;
  type?: InputMaybe<Lead_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_display_name?: InputMaybe<Scalars['String']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_phone_number?: InputMaybe<Scalars['String']['input']>;
  user_phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Lister_Leads_Max_Fields = {
  __typename?: 'lister_leads_max_fields';
  avatar_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inquiry_date?: Maybe<Scalars['date']['output']>;
  lister_user_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_display_name?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_phone_number?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Lister_Leads_Min_Fields = {
  __typename?: 'lister_leads_min_fields';
  avatar_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inquiry_date?: Maybe<Scalars['date']['output']>;
  lister_user_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_display_name?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_phone_number?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "lister_leads" */
export type Lister_Leads_Mutation_Response = {
  __typename?: 'lister_leads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lister_Leads>;
};

/** on_conflict condition type for table "lister_leads" */
export type Lister_Leads_On_Conflict = {
  constraint: Lister_Leads_Constraint;
  update_columns?: Array<Lister_Leads_Update_Column>;
  where?: InputMaybe<Lister_Leads_Bool_Exp>;
};

/** Ordering options when selecting data from "lister_leads". */
export type Lister_Leads_Order_By = {
  avatar_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inquiry_date?: InputMaybe<Order_By>;
  lister_user?: InputMaybe<Users_Order_By>;
  lister_user_id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_display_name?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_phone_number?: InputMaybe<Order_By>;
  user_phone_number_verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lister_leads */
export type Lister_Leads_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lister_leads" */
export enum Lister_Leads_Select_Column {
  /** column name */
  AvatarUrl = 'avatar_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InquiryDate = 'inquiry_date',
  /** column name */
  ListerUserId = 'lister_user_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserDisplayName = 'user_display_name',
  /** column name */
  UserEmail = 'user_email',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserPhoneNumber = 'user_phone_number',
  /** column name */
  UserPhoneNumberVerified = 'user_phone_number_verified'
}

/** input type for updating data in table "lister_leads" */
export type Lister_Leads_Set_Input = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inquiry_date?: InputMaybe<Scalars['date']['input']>;
  lister_user_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Lead_Status_Enum>;
  type?: InputMaybe<Lead_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_display_name?: InputMaybe<Scalars['String']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_phone_number?: InputMaybe<Scalars['String']['input']>;
  user_phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "lister_leads" */
export type Lister_Leads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lister_Leads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lister_Leads_Stream_Cursor_Value_Input = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inquiry_date?: InputMaybe<Scalars['date']['input']>;
  lister_user_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Lead_Status_Enum>;
  type?: InputMaybe<Lead_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_display_name?: InputMaybe<Scalars['String']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_phone_number?: InputMaybe<Scalars['String']['input']>;
  user_phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "lister_leads" */
export enum Lister_Leads_Update_Column {
  /** column name */
  AvatarUrl = 'avatar_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InquiryDate = 'inquiry_date',
  /** column name */
  ListerUserId = 'lister_user_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserDisplayName = 'user_display_name',
  /** column name */
  UserEmail = 'user_email',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserPhoneNumber = 'user_phone_number',
  /** column name */
  UserPhoneNumberVerified = 'user_phone_number_verified'
}

export type Lister_Leads_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lister_Leads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lister_Leads_Bool_Exp;
};

/** columns and relationships of "lister_meeting" */
export type Lister_Meeting = {
  __typename?: 'lister_meeting';
  /** An object relationship */
  agent_task?: Maybe<Agent_Task>;
  agent_task_id?: Maybe<Scalars['uuid']['output']>;
  appointment_status?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  attendees: Array<Lister_Contact_Meeting>;
  /** An aggregate relationship */
  attendees_aggregate: Lister_Contact_Meeting_Aggregate;
  confirmed_end_at?: Maybe<Scalars['timestamptz']['output']>;
  confirmed_start_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  event_id: Scalars['String']['output'];
  html_link?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization_lead?: Maybe<Organization_Leads>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  proposed_end_at?: Maybe<Scalars['timestamptz']['output']>;
  proposed_start_at?: Maybe<Scalars['timestamptz']['output']>;
  requested_time_text?: Maybe<Scalars['String']['output']>;
  source_channel?: Maybe<Scalars['String']['output']>;
  start_date: Scalars['timestamptz']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "lister_meeting" */
export type Lister_MeetingAttendeesArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Meeting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Meeting_Order_By>>;
  where?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
};


/** columns and relationships of "lister_meeting" */
export type Lister_MeetingAttendees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Meeting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Meeting_Order_By>>;
  where?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
};

/** aggregated selection of "lister_meeting" */
export type Lister_Meeting_Aggregate = {
  __typename?: 'lister_meeting_aggregate';
  aggregate?: Maybe<Lister_Meeting_Aggregate_Fields>;
  nodes: Array<Lister_Meeting>;
};

/** aggregate fields of "lister_meeting" */
export type Lister_Meeting_Aggregate_Fields = {
  __typename?: 'lister_meeting_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Lister_Meeting_Max_Fields>;
  min?: Maybe<Lister_Meeting_Min_Fields>;
};


/** aggregate fields of "lister_meeting" */
export type Lister_Meeting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lister_Meeting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "lister_meeting". All fields are combined with a logical 'AND'. */
export type Lister_Meeting_Bool_Exp = {
  _and?: InputMaybe<Array<Lister_Meeting_Bool_Exp>>;
  _not?: InputMaybe<Lister_Meeting_Bool_Exp>;
  _or?: InputMaybe<Array<Lister_Meeting_Bool_Exp>>;
  agent_task?: InputMaybe<Agent_Task_Bool_Exp>;
  agent_task_id?: InputMaybe<Uuid_Comparison_Exp>;
  appointment_status?: InputMaybe<String_Comparison_Exp>;
  attendees?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
  attendees_aggregate?: InputMaybe<Lister_Contact_Meeting_Aggregate_Bool_Exp>;
  confirmed_end_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  confirmed_start_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  event_id?: InputMaybe<String_Comparison_Exp>;
  html_link?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  organization_lead?: InputMaybe<Organization_Leads_Bool_Exp>;
  organization_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  proposed_end_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  proposed_start_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  requested_time_text?: InputMaybe<String_Comparison_Exp>;
  source_channel?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "lister_meeting" */
export enum Lister_Meeting_Constraint {
  /** unique or primary key constraint on columns "id" */
  ListerMeetingPkey = 'lister_meeting_pkey'
}

/** input type for inserting data into table "lister_meeting" */
export type Lister_Meeting_Insert_Input = {
  agent_task?: InputMaybe<Agent_Task_Obj_Rel_Insert_Input>;
  agent_task_id?: InputMaybe<Scalars['uuid']['input']>;
  appointment_status?: InputMaybe<Scalars['String']['input']>;
  attendees?: InputMaybe<Lister_Contact_Meeting_Arr_Rel_Insert_Input>;
  confirmed_end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  confirmed_start_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  creator_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  html_link?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organization_lead?: InputMaybe<Organization_Leads_Obj_Rel_Insert_Input>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  proposed_end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  proposed_start_at?: InputMaybe<Scalars['timestamptz']['input']>;
  requested_time_text?: InputMaybe<Scalars['String']['input']>;
  source_channel?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Lister_Meeting_Max_Fields = {
  __typename?: 'lister_meeting_max_fields';
  agent_task_id?: Maybe<Scalars['uuid']['output']>;
  appointment_status?: Maybe<Scalars['String']['output']>;
  confirmed_end_at?: Maybe<Scalars['timestamptz']['output']>;
  confirmed_start_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['String']['output']>;
  html_link?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  proposed_end_at?: Maybe<Scalars['timestamptz']['output']>;
  proposed_start_at?: Maybe<Scalars['timestamptz']['output']>;
  requested_time_text?: Maybe<Scalars['String']['output']>;
  source_channel?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Lister_Meeting_Min_Fields = {
  __typename?: 'lister_meeting_min_fields';
  agent_task_id?: Maybe<Scalars['uuid']['output']>;
  appointment_status?: Maybe<Scalars['String']['output']>;
  confirmed_end_at?: Maybe<Scalars['timestamptz']['output']>;
  confirmed_start_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['String']['output']>;
  html_link?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  proposed_end_at?: Maybe<Scalars['timestamptz']['output']>;
  proposed_start_at?: Maybe<Scalars['timestamptz']['output']>;
  requested_time_text?: Maybe<Scalars['String']['output']>;
  source_channel?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "lister_meeting" */
export type Lister_Meeting_Mutation_Response = {
  __typename?: 'lister_meeting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lister_Meeting>;
};

/** input type for inserting object relation for remote table "lister_meeting" */
export type Lister_Meeting_Obj_Rel_Insert_Input = {
  data: Lister_Meeting_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Lister_Meeting_On_Conflict>;
};

/** on_conflict condition type for table "lister_meeting" */
export type Lister_Meeting_On_Conflict = {
  constraint: Lister_Meeting_Constraint;
  update_columns?: Array<Lister_Meeting_Update_Column>;
  where?: InputMaybe<Lister_Meeting_Bool_Exp>;
};

/** Ordering options when selecting data from "lister_meeting". */
export type Lister_Meeting_Order_By = {
  agent_task?: InputMaybe<Agent_Task_Order_By>;
  agent_task_id?: InputMaybe<Order_By>;
  appointment_status?: InputMaybe<Order_By>;
  attendees_aggregate?: InputMaybe<Lister_Contact_Meeting_Aggregate_Order_By>;
  confirmed_end_at?: InputMaybe<Order_By>;
  confirmed_start_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  html_link?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  organization_lead?: InputMaybe<Organization_Leads_Order_By>;
  organization_lead_id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  proposed_end_at?: InputMaybe<Order_By>;
  proposed_start_at?: InputMaybe<Order_By>;
  requested_time_text?: InputMaybe<Order_By>;
  source_channel?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lister_meeting */
export type Lister_Meeting_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lister_meeting" */
export enum Lister_Meeting_Select_Column {
  /** column name */
  AgentTaskId = 'agent_task_id',
  /** column name */
  AppointmentStatus = 'appointment_status',
  /** column name */
  ConfirmedEndAt = 'confirmed_end_at',
  /** column name */
  ConfirmedStartAt = 'confirmed_start_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Description = 'description',
  /** column name */
  EventId = 'event_id',
  /** column name */
  HtmlLink = 'html_link',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Location = 'location',
  /** column name */
  OrganizationLeadId = 'organization_lead_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  ProposedEndAt = 'proposed_end_at',
  /** column name */
  ProposedStartAt = 'proposed_start_at',
  /** column name */
  RequestedTimeText = 'requested_time_text',
  /** column name */
  SourceChannel = 'source_channel',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "lister_meeting" */
export type Lister_Meeting_Set_Input = {
  agent_task_id?: InputMaybe<Scalars['uuid']['input']>;
  appointment_status?: InputMaybe<Scalars['String']['input']>;
  confirmed_end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  confirmed_start_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creator_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  html_link?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  proposed_end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  proposed_start_at?: InputMaybe<Scalars['timestamptz']['input']>;
  requested_time_text?: InputMaybe<Scalars['String']['input']>;
  source_channel?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "lister_meeting" */
export type Lister_Meeting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lister_Meeting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lister_Meeting_Stream_Cursor_Value_Input = {
  agent_task_id?: InputMaybe<Scalars['uuid']['input']>;
  appointment_status?: InputMaybe<Scalars['String']['input']>;
  confirmed_end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  confirmed_start_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creator_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  html_link?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  proposed_end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  proposed_start_at?: InputMaybe<Scalars['timestamptz']['input']>;
  requested_time_text?: InputMaybe<Scalars['String']['input']>;
  source_channel?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "lister_meeting" */
export enum Lister_Meeting_Update_Column {
  /** column name */
  AgentTaskId = 'agent_task_id',
  /** column name */
  AppointmentStatus = 'appointment_status',
  /** column name */
  ConfirmedEndAt = 'confirmed_end_at',
  /** column name */
  ConfirmedStartAt = 'confirmed_start_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Description = 'description',
  /** column name */
  EventId = 'event_id',
  /** column name */
  HtmlLink = 'html_link',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Location = 'location',
  /** column name */
  OrganizationLeadId = 'organization_lead_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  ProposedEndAt = 'proposed_end_at',
  /** column name */
  ProposedStartAt = 'proposed_start_at',
  /** column name */
  RequestedTimeText = 'requested_time_text',
  /** column name */
  SourceChannel = 'source_channel',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Lister_Meeting_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lister_Meeting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lister_Meeting_Bool_Exp;
};

/** columns and relationships of "lister_role" */
export type Lister_Role = {
  __typename?: 'lister_role';
  role: Scalars['String']['output'];
};

/** aggregated selection of "lister_role" */
export type Lister_Role_Aggregate = {
  __typename?: 'lister_role_aggregate';
  aggregate?: Maybe<Lister_Role_Aggregate_Fields>;
  nodes: Array<Lister_Role>;
};

/** aggregate fields of "lister_role" */
export type Lister_Role_Aggregate_Fields = {
  __typename?: 'lister_role_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Lister_Role_Max_Fields>;
  min?: Maybe<Lister_Role_Min_Fields>;
};


/** aggregate fields of "lister_role" */
export type Lister_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lister_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "lister_role". All fields are combined with a logical 'AND'. */
export type Lister_Role_Bool_Exp = {
  _and?: InputMaybe<Array<Lister_Role_Bool_Exp>>;
  _not?: InputMaybe<Lister_Role_Bool_Exp>;
  _or?: InputMaybe<Array<Lister_Role_Bool_Exp>>;
  role?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "lister_role" */
export enum Lister_Role_Constraint {
  /** unique or primary key constraint on columns "role" */
  ListerRolePkey = 'lister_role_pkey'
}

/** input type for inserting data into table "lister_role" */
export type Lister_Role_Insert_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Lister_Role_Max_Fields = {
  __typename?: 'lister_role_max_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Lister_Role_Min_Fields = {
  __typename?: 'lister_role_min_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "lister_role" */
export type Lister_Role_Mutation_Response = {
  __typename?: 'lister_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lister_Role>;
};

/** on_conflict condition type for table "lister_role" */
export type Lister_Role_On_Conflict = {
  constraint: Lister_Role_Constraint;
  update_columns?: Array<Lister_Role_Update_Column>;
  where?: InputMaybe<Lister_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "lister_role". */
export type Lister_Role_Order_By = {
  role?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lister_role */
export type Lister_Role_Pk_Columns_Input = {
  role: Scalars['String']['input'];
};

/** select columns of table "lister_role" */
export enum Lister_Role_Select_Column {
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "lister_role" */
export type Lister_Role_Set_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "lister_role" */
export type Lister_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lister_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lister_Role_Stream_Cursor_Value_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "lister_role" */
export enum Lister_Role_Update_Column {
  /** column name */
  Role = 'role'
}

export type Lister_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lister_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lister_Role_Bool_Exp;
};

/** columns and relationships of "location" */
export type Location = {
  __typename?: 'location';
  administrative_area_level_1?: Maybe<Scalars['String']['output']>;
  administrative_area_level_2?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  city_zone?: Maybe<City_Zone>;
  city_zone_id?: Maybe<Scalars['uuid']['output']>;
  confidence?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  exact_location?: Maybe<Scalars['Boolean']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['geography']['output']>;
  id: Scalars['uuid']['output'];
  lat: Scalars['float8']['output'];
  lng: Scalars['float8']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  place_id?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  property_lists: Array<Property_List>;
  /** An aggregate relationship */
  property_lists_aggregate: Property_List_Aggregate;
  raw_location_id?: Maybe<Scalars['uuid']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Location_Type_Enum>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "location" */
export type LocationProperty_ListsArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationProperty_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};

/** aggregated selection of "location" */
export type Location_Aggregate = {
  __typename?: 'location_aggregate';
  aggregate?: Maybe<Location_Aggregate_Fields>;
  nodes: Array<Location>;
};

/** aggregate fields of "location" */
export type Location_Aggregate_Fields = {
  __typename?: 'location_aggregate_fields';
  avg?: Maybe<Location_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Location_Max_Fields>;
  min?: Maybe<Location_Min_Fields>;
  stddev?: Maybe<Location_Stddev_Fields>;
  stddev_pop?: Maybe<Location_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Location_Stddev_Samp_Fields>;
  sum?: Maybe<Location_Sum_Fields>;
  var_pop?: Maybe<Location_Var_Pop_Fields>;
  var_samp?: Maybe<Location_Var_Samp_Fields>;
  variance?: Maybe<Location_Variance_Fields>;
};


/** aggregate fields of "location" */
export type Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Location_Avg_Fields = {
  __typename?: 'location_avg_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "location". All fields are combined with a logical 'AND'. */
export type Location_Bool_Exp = {
  _and?: InputMaybe<Array<Location_Bool_Exp>>;
  _not?: InputMaybe<Location_Bool_Exp>;
  _or?: InputMaybe<Array<Location_Bool_Exp>>;
  administrative_area_level_1?: InputMaybe<String_Comparison_Exp>;
  administrative_area_level_2?: InputMaybe<String_Comparison_Exp>;
  city_zone?: InputMaybe<City_Zone_Bool_Exp>;
  city_zone_id?: InputMaybe<Uuid_Comparison_Exp>;
  confidence?: InputMaybe<Boolean_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  exact_location?: InputMaybe<Boolean_Comparison_Exp>;
  formatted_address?: InputMaybe<String_Comparison_Exp>;
  geom?: InputMaybe<Geography_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  place_id?: InputMaybe<String_Comparison_Exp>;
  postal_code?: InputMaybe<String_Comparison_Exp>;
  property_lists?: InputMaybe<Property_List_Bool_Exp>;
  property_lists_aggregate?: InputMaybe<Property_List_Aggregate_Bool_Exp>;
  raw_location_id?: InputMaybe<Uuid_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Location_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "location" */
export enum Location_Constraint {
  /** unique or primary key constraint on columns "id" */
  LocationPkey = 'location_pkey'
}

/** input type for incrementing numeric columns in table "location" */
export type Location_Inc_Input = {
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "location" */
export type Location_Insert_Input = {
  administrative_area_level_1?: InputMaybe<Scalars['String']['input']>;
  administrative_area_level_2?: InputMaybe<Scalars['String']['input']>;
  city_zone?: InputMaybe<City_Zone_Obj_Rel_Insert_Input>;
  city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  confidence?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exact_location?: InputMaybe<Scalars['Boolean']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  place_id?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  property_lists?: InputMaybe<Property_List_Arr_Rel_Insert_Input>;
  raw_location_id?: InputMaybe<Scalars['uuid']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Location_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Location_Max_Fields = {
  __typename?: 'location_max_fields';
  administrative_area_level_1?: Maybe<Scalars['String']['output']>;
  administrative_area_level_2?: Maybe<Scalars['String']['output']>;
  city_zone_id?: Maybe<Scalars['uuid']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  place_id?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  raw_location_id?: Maybe<Scalars['uuid']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Location_Min_Fields = {
  __typename?: 'location_min_fields';
  administrative_area_level_1?: Maybe<Scalars['String']['output']>;
  administrative_area_level_2?: Maybe<Scalars['String']['output']>;
  city_zone_id?: Maybe<Scalars['uuid']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  place_id?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  raw_location_id?: Maybe<Scalars['uuid']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "location" */
export type Location_Mutation_Response = {
  __typename?: 'location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Location>;
};

/** input type for inserting object relation for remote table "location" */
export type Location_Obj_Rel_Insert_Input = {
  data: Location_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_On_Conflict>;
};

/** on_conflict condition type for table "location" */
export type Location_On_Conflict = {
  constraint: Location_Constraint;
  update_columns?: Array<Location_Update_Column>;
  where?: InputMaybe<Location_Bool_Exp>;
};

/** Ordering options when selecting data from "location". */
export type Location_Order_By = {
  administrative_area_level_1?: InputMaybe<Order_By>;
  administrative_area_level_2?: InputMaybe<Order_By>;
  city_zone?: InputMaybe<City_Zone_Order_By>;
  city_zone_id?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  exact_location?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  property_lists_aggregate?: InputMaybe<Property_List_Aggregate_Order_By>;
  raw_location_id?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: location */
export type Location_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "location" */
export enum Location_Select_Column {
  /** column name */
  AdministrativeAreaLevel_1 = 'administrative_area_level_1',
  /** column name */
  AdministrativeAreaLevel_2 = 'administrative_area_level_2',
  /** column name */
  CityZoneId = 'city_zone_id',
  /** column name */
  Confidence = 'confidence',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExactLocation = 'exact_location',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  RawLocationId = 'raw_location_id',
  /** column name */
  Route = 'route',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "location" */
export type Location_Set_Input = {
  administrative_area_level_1?: InputMaybe<Scalars['String']['input']>;
  administrative_area_level_2?: InputMaybe<Scalars['String']['input']>;
  city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  confidence?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exact_location?: InputMaybe<Scalars['Boolean']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  place_id?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  raw_location_id?: InputMaybe<Scalars['uuid']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Location_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Location_Stddev_Fields = {
  __typename?: 'location_stddev_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Location_Stddev_Pop_Fields = {
  __typename?: 'location_stddev_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Location_Stddev_Samp_Fields = {
  __typename?: 'location_stddev_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "location" */
export type Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Location_Stream_Cursor_Value_Input = {
  administrative_area_level_1?: InputMaybe<Scalars['String']['input']>;
  administrative_area_level_2?: InputMaybe<Scalars['String']['input']>;
  city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  confidence?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exact_location?: InputMaybe<Scalars['Boolean']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  place_id?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  raw_location_id?: InputMaybe<Scalars['uuid']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Location_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Location_Sum_Fields = {
  __typename?: 'location_sum_fields';
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** columns and relationships of "location_type" */
export type Location_Type = {
  __typename?: 'location_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "location_type" */
export type Location_Type_Aggregate = {
  __typename?: 'location_type_aggregate';
  aggregate?: Maybe<Location_Type_Aggregate_Fields>;
  nodes: Array<Location_Type>;
};

/** aggregate fields of "location_type" */
export type Location_Type_Aggregate_Fields = {
  __typename?: 'location_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Location_Type_Max_Fields>;
  min?: Maybe<Location_Type_Min_Fields>;
};


/** aggregate fields of "location_type" */
export type Location_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Location_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "location_type". All fields are combined with a logical 'AND'. */
export type Location_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Location_Type_Bool_Exp>>;
  _not?: InputMaybe<Location_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Location_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "location_type" */
export enum Location_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  LocationTypePkey = 'location_type_pkey'
}

export enum Location_Type_Enum {
  Other = 'other',
  Residence = 'residence'
}

/** Boolean expression to compare columns of type "location_type_enum". All fields are combined with logical 'AND'. */
export type Location_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Location_Type_Enum>;
  _in?: InputMaybe<Array<Location_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Location_Type_Enum>;
  _nin?: InputMaybe<Array<Location_Type_Enum>>;
};

/** input type for inserting data into table "location_type" */
export type Location_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Location_Type_Max_Fields = {
  __typename?: 'location_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Location_Type_Min_Fields = {
  __typename?: 'location_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "location_type" */
export type Location_Type_Mutation_Response = {
  __typename?: 'location_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Location_Type>;
};

/** on_conflict condition type for table "location_type" */
export type Location_Type_On_Conflict = {
  constraint: Location_Type_Constraint;
  update_columns?: Array<Location_Type_Update_Column>;
  where?: InputMaybe<Location_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "location_type". */
export type Location_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: location_type */
export type Location_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "location_type" */
export enum Location_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "location_type" */
export type Location_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "location_type" */
export type Location_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Location_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Location_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "location_type" */
export enum Location_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Location_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Location_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Location_Type_Bool_Exp;
};

/** update columns of table "location" */
export enum Location_Update_Column {
  /** column name */
  AdministrativeAreaLevel_1 = 'administrative_area_level_1',
  /** column name */
  AdministrativeAreaLevel_2 = 'administrative_area_level_2',
  /** column name */
  CityZoneId = 'city_zone_id',
  /** column name */
  Confidence = 'confidence',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExactLocation = 'exact_location',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  RawLocationId = 'raw_location_id',
  /** column name */
  Route = 'route',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Location_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Location_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Location_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Location_Var_Pop_Fields = {
  __typename?: 'location_var_pop_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Location_Var_Samp_Fields = {
  __typename?: 'location_var_samp_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Location_Variance_Fields = {
  __typename?: 'location_variance_fields';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "main_currency" */
export type Main_Currency = {
  __typename?: 'main_currency';
  currency: Scalars['String']['output'];
};

/** aggregated selection of "main_currency" */
export type Main_Currency_Aggregate = {
  __typename?: 'main_currency_aggregate';
  aggregate?: Maybe<Main_Currency_Aggregate_Fields>;
  nodes: Array<Main_Currency>;
};

/** aggregate fields of "main_currency" */
export type Main_Currency_Aggregate_Fields = {
  __typename?: 'main_currency_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Main_Currency_Max_Fields>;
  min?: Maybe<Main_Currency_Min_Fields>;
};


/** aggregate fields of "main_currency" */
export type Main_Currency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Main_Currency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "main_currency". All fields are combined with a logical 'AND'. */
export type Main_Currency_Bool_Exp = {
  _and?: InputMaybe<Array<Main_Currency_Bool_Exp>>;
  _not?: InputMaybe<Main_Currency_Bool_Exp>;
  _or?: InputMaybe<Array<Main_Currency_Bool_Exp>>;
  currency?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "main_currency" */
export enum Main_Currency_Constraint {
  /** unique or primary key constraint on columns "currency" */
  MainCurrencyPkey = 'main_currency_pkey'
}

export enum Main_Currency_Enum {
  Eur = 'EUR',
  Gbp = 'GBP',
  Leke = 'LEKE',
  Usd = 'USD'
}

/** Boolean expression to compare columns of type "main_currency_enum". All fields are combined with logical 'AND'. */
export type Main_Currency_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Main_Currency_Enum>;
  _in?: InputMaybe<Array<Main_Currency_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Main_Currency_Enum>;
  _nin?: InputMaybe<Array<Main_Currency_Enum>>;
};

/** input type for inserting data into table "main_currency" */
export type Main_Currency_Insert_Input = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Main_Currency_Max_Fields = {
  __typename?: 'main_currency_max_fields';
  currency?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Main_Currency_Min_Fields = {
  __typename?: 'main_currency_min_fields';
  currency?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "main_currency" */
export type Main_Currency_Mutation_Response = {
  __typename?: 'main_currency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Main_Currency>;
};

/** on_conflict condition type for table "main_currency" */
export type Main_Currency_On_Conflict = {
  constraint: Main_Currency_Constraint;
  update_columns?: Array<Main_Currency_Update_Column>;
  where?: InputMaybe<Main_Currency_Bool_Exp>;
};

/** Ordering options when selecting data from "main_currency". */
export type Main_Currency_Order_By = {
  currency?: InputMaybe<Order_By>;
};

/** primary key columns input for table: main_currency */
export type Main_Currency_Pk_Columns_Input = {
  currency: Scalars['String']['input'];
};

/** select columns of table "main_currency" */
export enum Main_Currency_Select_Column {
  /** column name */
  Currency = 'currency'
}

/** input type for updating data in table "main_currency" */
export type Main_Currency_Set_Input = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "main_currency" */
export type Main_Currency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Main_Currency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Main_Currency_Stream_Cursor_Value_Input = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "main_currency" */
export enum Main_Currency_Update_Column {
  /** column name */
  Currency = 'currency'
}

export type Main_Currency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Main_Currency_Set_Input>;
  /** filter the rows which have to be updated */
  where: Main_Currency_Bool_Exp;
};

export type Maintain_Whatsapp_Ai_Ledger_Args = {
  p_limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Map_Location = {
  __typename?: 'map_location';
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
};

export type Mark_Whatsapp_Ai_Outbox_Part_Ambiguous_Args = {
  p_error_code?: InputMaybe<Scalars['String']['input']>;
  p_part_id?: InputMaybe<Scalars['uuid']['input']>;
  p_worker_id?: InputMaybe<Scalars['String']['input']>;
};

export type Mark_Whatsapp_Ai_Outbox_Part_Dispatched_Args = {
  p_dispatched_at?: InputMaybe<Scalars['timestamptz']['input']>;
  p_part_id?: InputMaybe<Scalars['uuid']['input']>;
  p_worker_id?: InputMaybe<Scalars['String']['input']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  add_lister_leads?: Maybe<AddListerLeadsOutput>;
  /** execute VOLATILE function "approve_place_reference_proposal" which returns "place_reference" */
  approve_place_reference_proposal: Array<Place_Reference>;
  check_lister_profile_claim?: Maybe<CheckListerOutput>;
  claim_lister_profile?: Maybe<CheckListerOutput>;
  /** execute VOLATILE function "claim_whatsapp_ai_ambiguous_outbox_part" which returns "whatsapp_ai_outbox_part" */
  claim_whatsapp_ai_ambiguous_outbox_part: Array<Whatsapp_Ai_Outbox_Part>;
  /** execute VOLATILE function "claim_whatsapp_ai_outbox_part" which returns "whatsapp_ai_outbox_part" */
  claim_whatsapp_ai_outbox_part: Array<Whatsapp_Ai_Outbox_Part>;
  /** execute VOLATILE function "complete_whatsapp_ai_outbox_part" which returns "whatsapp_ai_outbox_part" */
  complete_whatsapp_ai_outbox_part: Array<Whatsapp_Ai_Outbox_Part>;
  create_manual_subscription?: Maybe<ManualSubscriptionOutput>;
  create_organization?: Maybe<ChangeUserRoleOutput>;
  /** delete single row from the table: "auth.providers" */
  deleteAuthProvider?: Maybe<AuthProviders>;
  /** delete single row from the table: "auth.provider_requests" */
  deleteAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** delete data from the table: "auth.provider_requests" */
  deleteAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** delete data from the table: "auth.providers" */
  deleteAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** delete single row from the table: "auth.refresh_tokens" */
  deleteAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** delete single row from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** delete data from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** delete data from the table: "auth.refresh_tokens" */
  deleteAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** delete single row from the table: "auth.roles" */
  deleteAuthRole?: Maybe<AuthRoles>;
  /** delete data from the table: "auth.roles" */
  deleteAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** delete single row from the table: "auth.user_providers" */
  deleteAuthUserProvider?: Maybe<AuthUserProviders>;
  /** delete data from the table: "auth.user_providers" */
  deleteAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** delete single row from the table: "auth.user_roles" */
  deleteAuthUserRole?: Maybe<AuthUserRoles>;
  /** delete data from the table: "auth.user_roles" */
  deleteAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** delete single row from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** delete data from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** delete single row from the table: "storage.buckets" */
  deleteBucket?: Maybe<Buckets>;
  /** delete data from the table: "storage.buckets" */
  deleteBuckets?: Maybe<Buckets_Mutation_Response>;
  /** delete single row from the table: "storage.files" */
  deleteFile?: Maybe<Files>;
  /** delete data from the table: "storage.files" */
  deleteFiles?: Maybe<Files_Mutation_Response>;
  /** delete single row from the table: "auth.users" */
  deleteUser?: Maybe<Users>;
  /** delete data from the table: "auth.users" */
  deleteUsers?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "storage.virus" */
  deleteVirus?: Maybe<Virus>;
  /** delete data from the table: "storage.virus" */
  deleteViruses?: Maybe<Virus_Mutation_Response>;
  /** delete data from the table: "address_types" */
  delete_address_types?: Maybe<Address_Types_Mutation_Response>;
  /** delete single row from the table: "address_types" */
  delete_address_types_by_pk?: Maybe<Address_Types>;
  /** delete data from the table: "agency" */
  delete_agency?: Maybe<Agency_Mutation_Response>;
  /** delete single row from the table: "agency" */
  delete_agency_by_pk?: Maybe<Agency>;
  /** delete data from the table: "agency_type" */
  delete_agency_type?: Maybe<Agency_Type_Mutation_Response>;
  /** delete single row from the table: "agency_type" */
  delete_agency_type_by_pk?: Maybe<Agency_Type>;
  /** delete data from the table: "agent_action" */
  delete_agent_action?: Maybe<Agent_Action_Mutation_Response>;
  /** delete single row from the table: "agent_action" */
  delete_agent_action_by_pk?: Maybe<Agent_Action>;
  /** delete data from the table: "agent_task" */
  delete_agent_task?: Maybe<Agent_Task_Mutation_Response>;
  /** delete single row from the table: "agent_task" */
  delete_agent_task_by_pk?: Maybe<Agent_Task>;
  /** delete data from the table: "amenities" */
  delete_amenities?: Maybe<Amenities_Mutation_Response>;
  /** delete single row from the table: "amenities" */
  delete_amenities_by_pk?: Maybe<Amenities>;
  /** delete data from the table: "app_config" */
  delete_app_config?: Maybe<App_Config_Mutation_Response>;
  /** delete single row from the table: "app_config" */
  delete_app_config_by_pk?: Maybe<App_Config>;
  /** delete data from the table: "blog" */
  delete_blog?: Maybe<Blog_Mutation_Response>;
  /** delete single row from the table: "blog" */
  delete_blog_by_pk?: Maybe<Blog>;
  /** delete data from the table: "blog_post" */
  delete_blog_post?: Maybe<Blog_Post_Mutation_Response>;
  /** delete single row from the table: "blog_post" */
  delete_blog_post_by_pk?: Maybe<Blog_Post>;
  /** delete data from the table: "blog_section" */
  delete_blog_section?: Maybe<Blog_Section_Mutation_Response>;
  /** delete single row from the table: "blog_section" */
  delete_blog_section_by_pk?: Maybe<Blog_Section>;
  /** delete data from the table: "blog_status" */
  delete_blog_status?: Maybe<Blog_Status_Mutation_Response>;
  /** delete single row from the table: "blog_status" */
  delete_blog_status_by_pk?: Maybe<Blog_Status>;
  /** delete data from the table: "builder" */
  delete_builder?: Maybe<Builder_Mutation_Response>;
  /** delete single row from the table: "builder" */
  delete_builder_by_pk?: Maybe<Builder>;
  /** delete data from the table: "certified_agent" */
  delete_certified_agent?: Maybe<Certified_Agent_Mutation_Response>;
  /** delete single row from the table: "certified_agent" */
  delete_certified_agent_by_pk?: Maybe<Certified_Agent>;
  /** delete data from the table: "chat_response_type" */
  delete_chat_response_type?: Maybe<Chat_Response_Type_Mutation_Response>;
  /** delete single row from the table: "chat_response_type" */
  delete_chat_response_type_by_pk?: Maybe<Chat_Response_Type>;
  /** delete data from the table: "city" */
  delete_city?: Maybe<City_Mutation_Response>;
  /** delete single row from the table: "city" */
  delete_city_by_pk?: Maybe<City>;
  /** delete data from the table: "city_zone" */
  delete_city_zone?: Maybe<City_Zone_Mutation_Response>;
  /** delete single row from the table: "city_zone" */
  delete_city_zone_by_pk?: Maybe<City_Zone>;
  /** delete data from the table: "city_zone_origin" */
  delete_city_zone_origin?: Maybe<City_Zone_Origin_Mutation_Response>;
  /** delete single row from the table: "city_zone_origin" */
  delete_city_zone_origin_by_pk?: Maybe<City_Zone_Origin>;
  /** delete data from the table: "claim_request_status" */
  delete_claim_request_status?: Maybe<Claim_Request_Status_Mutation_Response>;
  /** delete single row from the table: "claim_request_status" */
  delete_claim_request_status_by_pk?: Maybe<Claim_Request_Status>;
  /** delete data from the table: "clering" */
  delete_clering?: Maybe<Clering_Mutation_Response>;
  /** delete single row from the table: "clering" */
  delete_clering_by_pk?: Maybe<Clering>;
  /** delete data from the table: "construction_status" */
  delete_construction_status?: Maybe<Construction_Status_Mutation_Response>;
  /** delete single row from the table: "construction_status" */
  delete_construction_status_by_pk?: Maybe<Construction_Status>;
  /** delete data from the table: "contact" */
  delete_contact?: Maybe<Contact_Mutation_Response>;
  /** delete single row from the table: "contact" */
  delete_contact_by_pk?: Maybe<Contact>;
  /** delete data from the table: "contact_phone_number" */
  delete_contact_phone_number?: Maybe<Contact_Phone_Number_Mutation_Response>;
  /** delete single row from the table: "contact_phone_number" */
  delete_contact_phone_number_by_pk?: Maybe<Contact_Phone_Number>;
  /** delete data from the table: "contact_type" */
  delete_contact_type?: Maybe<Contact_Type_Mutation_Response>;
  /** delete single row from the table: "contact_type" */
  delete_contact_type_by_pk?: Maybe<Contact_Type>;
  /** delete data from the table: "content_type" */
  delete_content_type?: Maybe<Content_Type_Mutation_Response>;
  /** delete single row from the table: "content_type" */
  delete_content_type_by_pk?: Maybe<Content_Type>;
  /** delete data from the table: "countries" */
  delete_countries?: Maybe<Countries_Mutation_Response>;
  /** delete single row from the table: "countries" */
  delete_countries_by_pk?: Maybe<Countries>;
  /** delete data from the table: "country" */
  delete_country?: Maybe<Country_Mutation_Response>;
  /** delete single row from the table: "country" */
  delete_country_by_pk?: Maybe<Country>;
  /** delete data from the table: "currency" */
  delete_currency?: Maybe<Currency_Mutation_Response>;
  /** delete single row from the table: "currency" */
  delete_currency_by_pk?: Maybe<Currency>;
  /** delete data from the table: "currency_exchange_rates" */
  delete_currency_exchange_rates?: Maybe<Currency_Exchange_Rates_Mutation_Response>;
  /** delete single row from the table: "currency_exchange_rates" */
  delete_currency_exchange_rates_by_pk?: Maybe<Currency_Exchange_Rates>;
  /** delete data from the table: "entities" */
  delete_entities?: Maybe<Entities_Mutation_Response>;
  /** delete single row from the table: "entities" */
  delete_entities_by_pk?: Maybe<Entities>;
  /** delete data from the table: "exchange_rates" */
  delete_exchange_rates?: Maybe<Exchange_Rates_Mutation_Response>;
  /** delete single row from the table: "exchange_rates" */
  delete_exchange_rates_by_pk?: Maybe<Exchange_Rates>;
  /** delete data from the table: "feature" */
  delete_feature?: Maybe<Feature_Mutation_Response>;
  /** delete single row from the table: "feature" */
  delete_feature_by_pk?: Maybe<Feature>;
  /** delete data from the table: "feature_type" */
  delete_feature_type?: Maybe<Feature_Type_Mutation_Response>;
  /** delete single row from the table: "feature_type" */
  delete_feature_type_by_pk?: Maybe<Feature_Type>;
  /** delete data from the table: "file_type" */
  delete_file_type?: Maybe<File_Type_Mutation_Response>;
  /** delete single row from the table: "file_type" */
  delete_file_type_by_pk?: Maybe<File_Type>;
  /** delete data from the table: "folder_amenities" */
  delete_folder_amenities?: Maybe<Folder_Amenities_Mutation_Response>;
  /** delete single row from the table: "folder_amenities" */
  delete_folder_amenities_by_pk?: Maybe<Folder_Amenities>;
  /** delete data from the table: "folder_image" */
  delete_folder_image?: Maybe<Folder_Image_Mutation_Response>;
  /** delete single row from the table: "folder_image" */
  delete_folder_image_by_pk?: Maybe<Folder_Image>;
  /** delete data from the table: "folder_properties_type" */
  delete_folder_properties_type?: Maybe<Folder_Properties_Type_Mutation_Response>;
  /** delete single row from the table: "folder_properties_type" */
  delete_folder_properties_type_by_pk?: Maybe<Folder_Properties_Type>;
  /** delete data from the table: "folder_status" */
  delete_folder_status?: Maybe<Folder_Status_Mutation_Response>;
  /** delete single row from the table: "folder_status" */
  delete_folder_status_by_pk?: Maybe<Folder_Status>;
  /** delete data from the table: "folder_type" */
  delete_folder_type?: Maybe<Folder_Type_Mutation_Response>;
  /** delete single row from the table: "folder_type" */
  delete_folder_type_by_pk?: Maybe<Folder_Type>;
  /** delete data from the table: "furnishing_status" */
  delete_furnishing_status?: Maybe<Furnishing_Status_Mutation_Response>;
  /** delete single row from the table: "furnishing_status" */
  delete_furnishing_status_by_pk?: Maybe<Furnishing_Status>;
  /** delete data from the table: "google_calendar" */
  delete_google_calendar?: Maybe<Google_Calendar_Mutation_Response>;
  /** delete single row from the table: "google_calendar" */
  delete_google_calendar_by_pk?: Maybe<Google_Calendar>;
  /** delete data from the table: "heatingType" */
  delete_heatingType?: Maybe<HeatingType_Mutation_Response>;
  /** delete single row from the table: "heatingType" */
  delete_heatingType_by_pk?: Maybe<HeatingType>;
  /** delete data from the table: "image" */
  delete_image?: Maybe<Image_Mutation_Response>;
  /** delete single row from the table: "image" */
  delete_image_by_pk?: Maybe<Image>;
  /** delete data from the table: "invoice_status" */
  delete_invoice_status?: Maybe<Invoice_Status_Mutation_Response>;
  /** delete single row from the table: "invoice_status" */
  delete_invoice_status_by_pk?: Maybe<Invoice_Status>;
  /** delete data from the table: "languages" */
  delete_languages?: Maybe<Languages_Mutation_Response>;
  /** delete single row from the table: "languages" */
  delete_languages_by_pk?: Maybe<Languages>;
  /** delete data from the table: "lead_property_category" */
  delete_lead_property_category?: Maybe<Lead_Property_Category_Mutation_Response>;
  /** delete single row from the table: "lead_property_category" */
  delete_lead_property_category_by_pk?: Maybe<Lead_Property_Category>;
  /** delete data from the table: "lead_status" */
  delete_lead_status?: Maybe<Lead_Status_Mutation_Response>;
  /** delete single row from the table: "lead_status" */
  delete_lead_status_by_pk?: Maybe<Lead_Status>;
  /** delete data from the table: "lead_type" */
  delete_lead_type?: Maybe<Lead_Type_Mutation_Response>;
  /** delete single row from the table: "lead_type" */
  delete_lead_type_by_pk?: Maybe<Lead_Type>;
  /** delete data from the table: "lister_claim_request" */
  delete_lister_claim_request?: Maybe<Lister_Claim_Request_Mutation_Response>;
  /** delete data from the table: "lister_claim_request_activity" */
  delete_lister_claim_request_activity?: Maybe<Lister_Claim_Request_Activity_Mutation_Response>;
  /** delete single row from the table: "lister_claim_request_activity" */
  delete_lister_claim_request_activity_by_pk?: Maybe<Lister_Claim_Request_Activity>;
  /** delete single row from the table: "lister_claim_request" */
  delete_lister_claim_request_by_pk?: Maybe<Lister_Claim_Request>;
  /** delete data from the table: "lister_contact" */
  delete_lister_contact?: Maybe<Lister_Contact_Mutation_Response>;
  /** delete single row from the table: "lister_contact" */
  delete_lister_contact_by_pk?: Maybe<Lister_Contact>;
  /** delete data from the table: "lister_contact_meeting" */
  delete_lister_contact_meeting?: Maybe<Lister_Contact_Meeting_Mutation_Response>;
  /** delete single row from the table: "lister_contact_meeting" */
  delete_lister_contact_meeting_by_pk?: Maybe<Lister_Contact_Meeting>;
  /** delete data from the table: "lister_contact_source" */
  delete_lister_contact_source?: Maybe<Lister_Contact_Source_Mutation_Response>;
  /** delete single row from the table: "lister_contact_source" */
  delete_lister_contact_source_by_pk?: Maybe<Lister_Contact_Source>;
  /** delete data from the table: "lister_leads" */
  delete_lister_leads?: Maybe<Lister_Leads_Mutation_Response>;
  /** delete single row from the table: "lister_leads" */
  delete_lister_leads_by_pk?: Maybe<Lister_Leads>;
  /** delete data from the table: "lister_meeting" */
  delete_lister_meeting?: Maybe<Lister_Meeting_Mutation_Response>;
  /** delete single row from the table: "lister_meeting" */
  delete_lister_meeting_by_pk?: Maybe<Lister_Meeting>;
  /** delete data from the table: "lister_role" */
  delete_lister_role?: Maybe<Lister_Role_Mutation_Response>;
  /** delete single row from the table: "lister_role" */
  delete_lister_role_by_pk?: Maybe<Lister_Role>;
  /** delete data from the table: "location" */
  delete_location?: Maybe<Location_Mutation_Response>;
  /** delete single row from the table: "location" */
  delete_location_by_pk?: Maybe<Location>;
  /** delete data from the table: "location_type" */
  delete_location_type?: Maybe<Location_Type_Mutation_Response>;
  /** delete single row from the table: "location_type" */
  delete_location_type_by_pk?: Maybe<Location_Type>;
  /** delete data from the table: "main_currency" */
  delete_main_currency?: Maybe<Main_Currency_Mutation_Response>;
  /** delete single row from the table: "main_currency" */
  delete_main_currency_by_pk?: Maybe<Main_Currency>;
  /** delete data from the table: "natural_language_queries" */
  delete_natural_language_queries?: Maybe<Natural_Language_Queries_Mutation_Response>;
  /** delete single row from the table: "natural_language_queries" */
  delete_natural_language_queries_by_pk?: Maybe<Natural_Language_Queries>;
  /** delete data from the table: "notification" */
  delete_notification?: Maybe<Notification_Mutation_Response>;
  /** delete data from the table: "notification_amenities" */
  delete_notification_amenities?: Maybe<Notification_Amenities_Mutation_Response>;
  /** delete single row from the table: "notification_amenities" */
  delete_notification_amenities_by_pk?: Maybe<Notification_Amenities>;
  /** delete single row from the table: "notification" */
  delete_notification_by_pk?: Maybe<Notification>;
  /** delete data from the table: "notification_feature" */
  delete_notification_feature?: Maybe<Notification_Feature_Mutation_Response>;
  /** delete single row from the table: "notification_feature" */
  delete_notification_feature_by_pk?: Maybe<Notification_Feature>;
  /** delete data from the table: "notification_property_type" */
  delete_notification_property_type?: Maybe<Notification_Property_Type_Mutation_Response>;
  /** delete single row from the table: "notification_property_type" */
  delete_notification_property_type_by_pk?: Maybe<Notification_Property_Type>;
  /** delete data from the table: "notification_type" */
  delete_notification_type?: Maybe<Notification_Type_Mutation_Response>;
  /** delete single row from the table: "notification_type" */
  delete_notification_type_by_pk?: Maybe<Notification_Type>;
  /** delete data from the table: "order" */
  delete_order?: Maybe<Order_Mutation_Response>;
  /** delete single row from the table: "order" */
  delete_order_by_pk?: Maybe<Order>;
  /** delete data from the table: "order_status" */
  delete_order_status?: Maybe<Order_Status_Mutation_Response>;
  /** delete single row from the table: "order_status" */
  delete_order_status_by_pk?: Maybe<Order_Status>;
  /** delete data from the table: "organization" */
  delete_organization?: Maybe<Organization_Mutation_Response>;
  /** delete single row from the table: "organization" */
  delete_organization_by_pk?: Maybe<Organization>;
  /** delete data from the table: "organization_lead_location" */
  delete_organization_lead_location?: Maybe<Organization_Lead_Location_Mutation_Response>;
  /** delete single row from the table: "organization_lead_location" */
  delete_organization_lead_location_by_pk?: Maybe<Organization_Lead_Location>;
  /** delete data from the table: "organization_lead_property" */
  delete_organization_lead_property?: Maybe<Organization_Lead_Property_Mutation_Response>;
  /** delete single row from the table: "organization_lead_property" */
  delete_organization_lead_property_by_pk?: Maybe<Organization_Lead_Property>;
  /** delete data from the table: "organization_leads" */
  delete_organization_leads?: Maybe<Organization_Leads_Mutation_Response>;
  /** delete single row from the table: "organization_leads" */
  delete_organization_leads_by_pk?: Maybe<Organization_Leads>;
  /** delete data from the table: "organization_role" */
  delete_organization_role?: Maybe<Organization_Role_Mutation_Response>;
  /** delete single row from the table: "organization_role" */
  delete_organization_role_by_pk?: Maybe<Organization_Role>;
  /** delete data from the table: "organization_status" */
  delete_organization_status?: Maybe<Organization_Status_Mutation_Response>;
  /** delete single row from the table: "organization_status" */
  delete_organization_status_by_pk?: Maybe<Organization_Status>;
  /** delete data from the table: "organization_telegram_agent_link" */
  delete_organization_telegram_agent_link?: Maybe<Organization_Telegram_Agent_Link_Mutation_Response>;
  /** delete single row from the table: "organization_telegram_agent_link" */
  delete_organization_telegram_agent_link_by_pk?: Maybe<Organization_Telegram_Agent_Link>;
  /** delete data from the table: "organization_type" */
  delete_organization_type?: Maybe<Organization_Type_Mutation_Response>;
  /** delete single row from the table: "organization_type" */
  delete_organization_type_by_pk?: Maybe<Organization_Type>;
  /** delete data from the table: "organization_whatsapp_ai_allowlist" */
  delete_organization_whatsapp_ai_allowlist?: Maybe<Organization_Whatsapp_Ai_Allowlist_Mutation_Response>;
  /** delete single row from the table: "organization_whatsapp_ai_allowlist" */
  delete_organization_whatsapp_ai_allowlist_by_pk?: Maybe<Organization_Whatsapp_Ai_Allowlist>;
  /** delete data from the table: "organization_whatsapp_ai_config" */
  delete_organization_whatsapp_ai_config?: Maybe<Organization_Whatsapp_Ai_Config_Mutation_Response>;
  /** delete single row from the table: "organization_whatsapp_ai_config" */
  delete_organization_whatsapp_ai_config_by_pk?: Maybe<Organization_Whatsapp_Ai_Config>;
  /** delete data from the table: "parking_type" */
  delete_parking_type?: Maybe<Parking_Type_Mutation_Response>;
  /** delete single row from the table: "parking_type" */
  delete_parking_type_by_pk?: Maybe<Parking_Type>;
  /** delete data from the table: "phone_number_type" */
  delete_phone_number_type?: Maybe<Phone_Number_Type_Mutation_Response>;
  /** delete single row from the table: "phone_number_type" */
  delete_phone_number_type_by_pk?: Maybe<Phone_Number_Type>;
  /** delete data from the table: "place_reference" */
  delete_place_reference?: Maybe<Place_Reference_Mutation_Response>;
  /** delete data from the table: "place_reference_alias" */
  delete_place_reference_alias?: Maybe<Place_Reference_Alias_Mutation_Response>;
  /** delete single row from the table: "place_reference_alias" */
  delete_place_reference_alias_by_pk?: Maybe<Place_Reference_Alias>;
  /** delete single row from the table: "place_reference" */
  delete_place_reference_by_pk?: Maybe<Place_Reference>;
  /** delete data from the table: "place_reference_proposal" */
  delete_place_reference_proposal?: Maybe<Place_Reference_Proposal_Mutation_Response>;
  /** delete single row from the table: "place_reference_proposal" */
  delete_place_reference_proposal_by_pk?: Maybe<Place_Reference_Proposal>;
  /** delete data from the table: "plan" */
  delete_plan?: Maybe<Plan_Mutation_Response>;
  /** delete single row from the table: "plan" */
  delete_plan_by_pk?: Maybe<Plan>;
  /** delete data from the table: "plan_type" */
  delete_plan_type?: Maybe<Plan_Type_Mutation_Response>;
  /** delete single row from the table: "plan_type" */
  delete_plan_type_by_pk?: Maybe<Plan_Type>;
  /** delete data from the table: "product" */
  delete_product?: Maybe<Product_Mutation_Response>;
  /** delete single row from the table: "product" */
  delete_product_by_pk?: Maybe<Product>;
  /** delete data from the table: "product_purchase" */
  delete_product_purchase?: Maybe<Product_Purchase_Mutation_Response>;
  /** delete single row from the table: "product_purchase" */
  delete_product_purchase_by_pk?: Maybe<Product_Purchase>;
  /** delete data from the table: "product_type" */
  delete_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** delete single row from the table: "product_type" */
  delete_product_type_by_pk?: Maybe<Product_Type>;
  /** delete data from the table: "property" */
  delete_property?: Maybe<Property_Mutation_Response>;
  /** delete single row from the table: "property" */
  delete_property_by_pk?: Maybe<Property>;
  /** delete data from the table: "property_cluster" */
  delete_property_cluster?: Maybe<Property_Cluster_Mutation_Response>;
  /** delete single row from the table: "property_cluster" */
  delete_property_cluster_by_pk?: Maybe<Property_Cluster>;
  /** delete data from the table: "property_composition" */
  delete_property_composition?: Maybe<Property_Composition_Mutation_Response>;
  /** delete single row from the table: "property_composition" */
  delete_property_composition_by_pk?: Maybe<Property_Composition>;
  /** delete data from the table: "property_feature" */
  delete_property_feature?: Maybe<Property_Feature_Mutation_Response>;
  /** delete single row from the table: "property_feature" */
  delete_property_feature_by_pk?: Maybe<Property_Feature>;
  /** delete data from the table: "property_folder" */
  delete_property_folder?: Maybe<Property_Folder_Mutation_Response>;
  /** delete single row from the table: "property_folder" */
  delete_property_folder_by_pk?: Maybe<Property_Folder>;
  /** delete data from the table: "property_folder_public_profile" */
  delete_property_folder_public_profile?: Maybe<Property_Folder_Public_Profile_Mutation_Response>;
  /** delete single row from the table: "property_folder_public_profile" */
  delete_property_folder_public_profile_by_pk?: Maybe<Property_Folder_Public_Profile>;
  /** delete data from the table: "property_folder_public_profile_faq" */
  delete_property_folder_public_profile_faq?: Maybe<Property_Folder_Public_Profile_Faq_Mutation_Response>;
  /** delete single row from the table: "property_folder_public_profile_faq" */
  delete_property_folder_public_profile_faq_by_pk?: Maybe<Property_Folder_Public_Profile_Faq>;
  /** delete data from the table: "property_folder_public_profile_highlight" */
  delete_property_folder_public_profile_highlight?: Maybe<Property_Folder_Public_Profile_Highlight_Mutation_Response>;
  /** delete single row from the table: "property_folder_public_profile_highlight" */
  delete_property_folder_public_profile_highlight_by_pk?: Maybe<Property_Folder_Public_Profile_Highlight>;
  /** delete data from the table: "property_folder_public_profile_listing_example" */
  delete_property_folder_public_profile_listing_example?: Maybe<Property_Folder_Public_Profile_Listing_Example_Mutation_Response>;
  /** delete single row from the table: "property_folder_public_profile_listing_example" */
  delete_property_folder_public_profile_listing_example_by_pk?: Maybe<Property_Folder_Public_Profile_Listing_Example>;
  /** delete data from the table: "property_folder_public_profile_nearby_place" */
  delete_property_folder_public_profile_nearby_place?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Mutation_Response>;
  /** delete single row from the table: "property_folder_public_profile_nearby_place" */
  delete_property_folder_public_profile_nearby_place_by_pk?: Maybe<Property_Folder_Public_Profile_Nearby_Place>;
  /** delete data from the table: "property_folder_public_profile_related" */
  delete_property_folder_public_profile_related?: Maybe<Property_Folder_Public_Profile_Related_Mutation_Response>;
  /** delete single row from the table: "property_folder_public_profile_related" */
  delete_property_folder_public_profile_related_by_pk?: Maybe<Property_Folder_Public_Profile_Related>;
  /** delete data from the table: "property_folder_public_profile_translation" */
  delete_property_folder_public_profile_translation?: Maybe<Property_Folder_Public_Profile_Translation_Mutation_Response>;
  /** delete single row from the table: "property_folder_public_profile_translation" */
  delete_property_folder_public_profile_translation_by_pk?: Maybe<Property_Folder_Public_Profile_Translation>;
  /** delete data from the table: "property_image" */
  delete_property_image?: Maybe<Property_Image_Mutation_Response>;
  /** delete single row from the table: "property_image" */
  delete_property_image_by_pk?: Maybe<Property_Image>;
  /** delete data from the table: "property_list" */
  delete_property_list?: Maybe<Property_List_Mutation_Response>;
  /** delete data from the table: "property_list_activity" */
  delete_property_list_activity?: Maybe<Property_List_Activity_Mutation_Response>;
  /** delete single row from the table: "property_list_activity" */
  delete_property_list_activity_by_pk?: Maybe<Property_List_Activity>;
  /** delete single row from the table: "property_list" */
  delete_property_list_by_pk?: Maybe<Property_List>;
  /** delete data from the table: "property_list_folder" */
  delete_property_list_folder?: Maybe<Property_List_Folder_Mutation_Response>;
  /** delete single row from the table: "property_list_folder" */
  delete_property_list_folder_by_pk?: Maybe<Property_List_Folder>;
  /** delete data from the table: "property_list_report" */
  delete_property_list_report?: Maybe<Property_List_Report_Mutation_Response>;
  /** delete single row from the table: "property_list_report" */
  delete_property_list_report_by_pk?: Maybe<Property_List_Report>;
  /** delete data from the table: "property_origin" */
  delete_property_origin?: Maybe<Property_Origin_Mutation_Response>;
  /** delete single row from the table: "property_origin" */
  delete_property_origin_by_pk?: Maybe<Property_Origin>;
  /** delete data from the table: "property_origin_type" */
  delete_property_origin_type?: Maybe<Property_Origin_Type_Mutation_Response>;
  /** delete single row from the table: "property_origin_type" */
  delete_property_origin_type_by_pk?: Maybe<Property_Origin_Type>;
  /** delete data from the table: "property_owner" */
  delete_property_owner?: Maybe<Property_Owner_Mutation_Response>;
  /** delete single row from the table: "property_owner" */
  delete_property_owner_by_pk?: Maybe<Property_Owner>;
  /** delete data from the table: "property_place_reference" */
  delete_property_place_reference?: Maybe<Property_Place_Reference_Mutation_Response>;
  /** delete single row from the table: "property_place_reference" */
  delete_property_place_reference_by_pk?: Maybe<Property_Place_Reference>;
  /** delete data from the table: "property_price_history" */
  delete_property_price_history?: Maybe<Property_Price_History_Mutation_Response>;
  /** delete single row from the table: "property_price_history" */
  delete_property_price_history_by_pk?: Maybe<Property_Price_History>;
  /** delete data from the table: "property_report_type" */
  delete_property_report_type?: Maybe<Property_Report_Type_Mutation_Response>;
  /** delete single row from the table: "property_report_type" */
  delete_property_report_type_by_pk?: Maybe<Property_Report_Type>;
  /** delete data from the table: "property_source" */
  delete_property_source?: Maybe<Property_Source_Mutation_Response>;
  /** delete single row from the table: "property_source" */
  delete_property_source_by_pk?: Maybe<Property_Source>;
  /** delete data from the table: "property_status" */
  delete_property_status?: Maybe<Property_Status_Mutation_Response>;
  /** delete single row from the table: "property_status" */
  delete_property_status_by_pk?: Maybe<Property_Status>;
  /** delete data from the table: "property_type" */
  delete_property_type?: Maybe<Property_Type_Mutation_Response>;
  /** delete single row from the table: "property_type" */
  delete_property_type_by_pk?: Maybe<Property_Type>;
  /** delete data from the table: "property_views" */
  delete_property_views?: Maybe<Property_Views_Mutation_Response>;
  /** delete single row from the table: "property_views" */
  delete_property_views_by_pk?: Maybe<Property_Views>;
  /** delete data from the table: "queries_property_result" */
  delete_queries_property_result?: Maybe<Queries_Property_Result_Mutation_Response>;
  /** delete single row from the table: "queries_property_result" */
  delete_queries_property_result_by_pk?: Maybe<Queries_Property_Result>;
  /** delete data from the table: "queries_property_result_re" */
  delete_queries_property_result_re?: Maybe<Queries_Property_Result_Re_Mutation_Response>;
  /** delete single row from the table: "queries_property_result_re" */
  delete_queries_property_result_re_by_pk?: Maybe<Queries_Property_Result_Re>;
  /** delete data from the table: "query_classification" */
  delete_query_classification?: Maybe<Query_Classification_Mutation_Response>;
  /** delete single row from the table: "query_classification" */
  delete_query_classification_by_pk?: Maybe<Query_Classification>;
  /** delete data from the table: "query_classification_re" */
  delete_query_classification_re?: Maybe<Query_Classification_Re_Mutation_Response>;
  /** delete single row from the table: "query_classification_re" */
  delete_query_classification_re_by_pk?: Maybe<Query_Classification_Re>;
  /** delete data from the table: "raw_location" */
  delete_raw_location?: Maybe<Raw_Location_Mutation_Response>;
  /** delete single row from the table: "raw_location" */
  delete_raw_location_by_pk?: Maybe<Raw_Location>;
  /** delete data from the table: "redirect" */
  delete_redirect?: Maybe<Redirect_Mutation_Response>;
  /** delete single row from the table: "redirect" */
  delete_redirect_by_pk?: Maybe<Redirect>;
  /** delete data from the table: "reference_price_history" */
  delete_reference_price_history?: Maybe<Reference_Price_History_Mutation_Response>;
  /** delete single row from the table: "reference_price_history" */
  delete_reference_price_history_by_pk?: Maybe<Reference_Price_History>;
  /** delete data from the table: "reference_zone" */
  delete_reference_zone?: Maybe<Reference_Zone_Mutation_Response>;
  /** delete single row from the table: "reference_zone" */
  delete_reference_zone_by_pk?: Maybe<Reference_Zone>;
  /** delete data from the table: "search_context" */
  delete_search_context?: Maybe<Search_Context_Mutation_Response>;
  /** delete single row from the table: "search_context" */
  delete_search_context_by_pk?: Maybe<Search_Context>;
  /** delete data from the table: "search_context_location" */
  delete_search_context_location?: Maybe<Search_Context_Location_Mutation_Response>;
  /** delete single row from the table: "search_context_location" */
  delete_search_context_location_by_pk?: Maybe<Search_Context_Location>;
  /** delete data from the table: "search_domain" */
  delete_search_domain?: Maybe<Search_Domain_Mutation_Response>;
  /** delete single row from the table: "search_domain" */
  delete_search_domain_by_pk?: Maybe<Search_Domain>;
  /** delete data from the table: "search_sessions" */
  delete_search_sessions?: Maybe<Search_Sessions_Mutation_Response>;
  /** delete single row from the table: "search_sessions" */
  delete_search_sessions_by_pk?: Maybe<Search_Sessions>;
  /** delete data from the table: "search_slugs" */
  delete_search_slugs?: Maybe<Search_Slugs_Mutation_Response>;
  /** delete single row from the table: "search_slugs" */
  delete_search_slugs_by_pk?: Maybe<Search_Slugs>;
  /** delete data from the table: "seo_city" */
  delete_seo_city?: Maybe<Seo_City_Mutation_Response>;
  /** delete single row from the table: "seo_city" */
  delete_seo_city_by_pk?: Maybe<Seo_City>;
  /** delete data from the table: "session_origin" */
  delete_session_origin?: Maybe<Session_Origin_Mutation_Response>;
  /** delete single row from the table: "session_origin" */
  delete_session_origin_by_pk?: Maybe<Session_Origin>;
  /** delete data from the table: "sponsored_property_list" */
  delete_sponsored_property_list?: Maybe<Sponsored_Property_List_Mutation_Response>;
  /** delete single row from the table: "sponsored_property_list" */
  delete_sponsored_property_list_by_pk?: Maybe<Sponsored_Property_List>;
  /** delete data from the table: "subscription" */
  delete_subscription?: Maybe<Subscription_Mutation_Response>;
  /** delete single row from the table: "subscription" */
  delete_subscription_by_pk?: Maybe<Subscription>;
  /** delete data from the table: "subscription_invoice" */
  delete_subscription_invoice?: Maybe<Subscription_Invoice_Mutation_Response>;
  /** delete single row from the table: "subscription_invoice" */
  delete_subscription_invoice_by_pk?: Maybe<Subscription_Invoice>;
  /** delete data from the table: "subscription_source" */
  delete_subscription_source?: Maybe<Subscription_Source_Mutation_Response>;
  /** delete single row from the table: "subscription_source" */
  delete_subscription_source_by_pk?: Maybe<Subscription_Source>;
  /** delete data from the table: "subscription_status" */
  delete_subscription_status?: Maybe<Subscription_Status_Mutation_Response>;
  /** delete single row from the table: "subscription_status" */
  delete_subscription_status_by_pk?: Maybe<Subscription_Status>;
  /** delete data from the table: "text_content" */
  delete_text_content?: Maybe<Text_Content_Mutation_Response>;
  /** delete single row from the table: "text_content" */
  delete_text_content_by_pk?: Maybe<Text_Content>;
  /** delete data from the table: "translations" */
  delete_translations?: Maybe<Translations_Mutation_Response>;
  /** delete single row from the table: "translations" */
  delete_translations_by_pk?: Maybe<Translations>;
  /** delete data from the table: "url_slug" */
  delete_url_slug?: Maybe<Url_Slug_Mutation_Response>;
  /** delete single row from the table: "url_slug" */
  delete_url_slug_by_pk?: Maybe<Url_Slug>;
  /** delete data from the table: "user_filters" */
  delete_user_filters?: Maybe<User_Filters_Mutation_Response>;
  /** delete single row from the table: "user_filters" */
  delete_user_filters_by_pk?: Maybe<User_Filters>;
  /** delete data from the table: "user_filters_features" */
  delete_user_filters_features?: Maybe<User_Filters_Features_Mutation_Response>;
  /** delete single row from the table: "user_filters_features" */
  delete_user_filters_features_by_pk?: Maybe<User_Filters_Features>;
  /** delete data from the table: "user_organization" */
  delete_user_organization?: Maybe<User_Organization_Mutation_Response>;
  /** delete single row from the table: "user_organization" */
  delete_user_organization_by_pk?: Maybe<User_Organization>;
  /** delete data from the table: "user_preferences" */
  delete_user_preferences?: Maybe<User_Preferences_Mutation_Response>;
  /** delete single row from the table: "user_preferences" */
  delete_user_preferences_by_pk?: Maybe<User_Preferences>;
  /** delete data from the table: "user_property_notifiation" */
  delete_user_property_notifiation?: Maybe<User_Property_Notifiation_Mutation_Response>;
  /** delete single row from the table: "user_property_notifiation" */
  delete_user_property_notifiation_by_pk?: Maybe<User_Property_Notifiation>;
  /** delete data from the table: "user_saved_properties" */
  delete_user_saved_properties?: Maybe<User_Saved_Properties_Mutation_Response>;
  /** delete single row from the table: "user_saved_properties" */
  delete_user_saved_properties_by_pk?: Maybe<User_Saved_Properties>;
  /** delete data from the table: "user_seen_property" */
  delete_user_seen_property?: Maybe<User_Seen_Property_Mutation_Response>;
  /** delete single row from the table: "user_seen_property" */
  delete_user_seen_property_by_pk?: Maybe<User_Seen_Property>;
  /** delete data from the table: "users_activity_summary" */
  delete_users_activity_summary?: Maybe<Users_Activity_Summary_Mutation_Response>;
  /** delete single row from the table: "users_activity_summary" */
  delete_users_activity_summary_by_pk?: Maybe<Users_Activity_Summary>;
  /** delete data from the table: "visibility_status" */
  delete_visibility_status?: Maybe<Visibility_Status_Mutation_Response>;
  /** delete single row from the table: "visibility_status" */
  delete_visibility_status_by_pk?: Maybe<Visibility_Status>;
  /** delete data from the table: "whatsapp_ai_inbound_message" */
  delete_whatsapp_ai_inbound_message?: Maybe<Whatsapp_Ai_Inbound_Message_Mutation_Response>;
  /** delete single row from the table: "whatsapp_ai_inbound_message" */
  delete_whatsapp_ai_inbound_message_by_pk?: Maybe<Whatsapp_Ai_Inbound_Message>;
  /** delete data from the table: "whatsapp_ai_outbox_part" */
  delete_whatsapp_ai_outbox_part?: Maybe<Whatsapp_Ai_Outbox_Part_Mutation_Response>;
  /** delete single row from the table: "whatsapp_ai_outbox_part" */
  delete_whatsapp_ai_outbox_part_by_pk?: Maybe<Whatsapp_Ai_Outbox_Part>;
  /** delete data from the table: "whatsapp_ai_turn" */
  delete_whatsapp_ai_turn?: Maybe<Whatsapp_Ai_Turn_Mutation_Response>;
  /** delete single row from the table: "whatsapp_ai_turn" */
  delete_whatsapp_ai_turn_by_pk?: Maybe<Whatsapp_Ai_Turn>;
  /** delete data from the table: "whatsapp_chat" */
  delete_whatsapp_chat?: Maybe<Whatsapp_Chat_Mutation_Response>;
  /** delete single row from the table: "whatsapp_chat" */
  delete_whatsapp_chat_by_pk?: Maybe<Whatsapp_Chat>;
  /** delete data from the table: "whatsapp_human" */
  delete_whatsapp_human?: Maybe<Whatsapp_Human_Mutation_Response>;
  /** delete single row from the table: "whatsapp_human" */
  delete_whatsapp_human_by_pk?: Maybe<Whatsapp_Human>;
  /** delete data from the table: "zone_contains" */
  delete_zone_contains?: Maybe<Zone_Contains_Mutation_Response>;
  /** delete single row from the table: "zone_contains" */
  delete_zone_contains_by_pk?: Maybe<Zone_Contains>;
  /** delete data from the table: "zone_data_method" */
  delete_zone_data_method?: Maybe<Zone_Data_Method_Mutation_Response>;
  /** delete single row from the table: "zone_data_method" */
  delete_zone_data_method_by_pk?: Maybe<Zone_Data_Method>;
  /** Duplicate a user's search session and make it public (user_id = NULL) */
  duplicate_search_session?: Maybe<DuplicateSearchSessionOutput>;
  /** execute VOLATILE function "fail_whatsapp_ai_outbox_part" which returns "whatsapp_ai_outbox_part" */
  fail_whatsapp_ai_outbox_part: Array<Whatsapp_Ai_Outbox_Part>;
  /** execute VOLATILE function "fail_whatsapp_ai_turn" which returns "whatsapp_ai_turn" */
  fail_whatsapp_ai_turn: Array<Whatsapp_Ai_Turn>;
  /** execute VOLATILE function "finalize_whatsapp_ai_turn" which returns "whatsapp_ai_turn" */
  finalize_whatsapp_ai_turn: Array<Whatsapp_Ai_Turn>;
  generate_property_attributes?: Maybe<PropertyAttributesOutput>;
  /** generate_query */
  generate_query?: Maybe<GenerateQueryOutput>;
  generate_social_media?: Maybe<GenerateTextOutput>;
  /** Generate text based on filters of a query */
  generate_text?: Maybe<GenerateTextOutput>;
  /** Atomically increment property engagement stats (views, source clicks, phone clicks) */
  increment_property_stats?: Maybe<IncrementPropertyStatsOutput>;
  /** Initialize order for a membership */
  initialize_order?: Maybe<InsertOrderOutput>;
  /** insert a single row into the table: "auth.providers" */
  insertAuthProvider?: Maybe<AuthProviders>;
  /** insert a single row into the table: "auth.provider_requests" */
  insertAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** insert data into the table: "auth.provider_requests" */
  insertAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** insert data into the table: "auth.providers" */
  insertAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insertAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** insert a single row into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** insert data into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** insert data into the table: "auth.refresh_tokens" */
  insertAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** insert a single row into the table: "auth.roles" */
  insertAuthRole?: Maybe<AuthRoles>;
  /** insert data into the table: "auth.roles" */
  insertAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** insert a single row into the table: "auth.user_providers" */
  insertAuthUserProvider?: Maybe<AuthUserProviders>;
  /** insert data into the table: "auth.user_providers" */
  insertAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** insert a single row into the table: "auth.user_roles" */
  insertAuthUserRole?: Maybe<AuthUserRoles>;
  /** insert data into the table: "auth.user_roles" */
  insertAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** insert a single row into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** insert data into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** insert a single row into the table: "storage.buckets" */
  insertBucket?: Maybe<Buckets>;
  /** insert data into the table: "storage.buckets" */
  insertBuckets?: Maybe<Buckets_Mutation_Response>;
  /** insert a single row into the table: "storage.files" */
  insertFile?: Maybe<Files>;
  /** insert data into the table: "storage.files" */
  insertFiles?: Maybe<Files_Mutation_Response>;
  /** Action for lister to add a new proeprty */
  insertPropertyList?: Maybe<InsertPropertyListOutput>;
  /** insert a single row into the table: "auth.users" */
  insertUser?: Maybe<Users>;
  /** insert data into the table: "auth.users" */
  insertUsers?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "storage.virus" */
  insertVirus?: Maybe<Virus>;
  /** insert data into the table: "storage.virus" */
  insertViruses?: Maybe<Virus_Mutation_Response>;
  /** insert data into the table: "address_types" */
  insert_address_types?: Maybe<Address_Types_Mutation_Response>;
  /** insert a single row into the table: "address_types" */
  insert_address_types_one?: Maybe<Address_Types>;
  /** insert data into the table: "agency" */
  insert_agency?: Maybe<Agency_Mutation_Response>;
  /** insert a single row into the table: "agency" */
  insert_agency_one?: Maybe<Agency>;
  /** insert data into the table: "agency_type" */
  insert_agency_type?: Maybe<Agency_Type_Mutation_Response>;
  /** insert a single row into the table: "agency_type" */
  insert_agency_type_one?: Maybe<Agency_Type>;
  /** insert data into the table: "agent_action" */
  insert_agent_action?: Maybe<Agent_Action_Mutation_Response>;
  /** insert a single row into the table: "agent_action" */
  insert_agent_action_one?: Maybe<Agent_Action>;
  /** insert data into the table: "agent_task" */
  insert_agent_task?: Maybe<Agent_Task_Mutation_Response>;
  /** insert a single row into the table: "agent_task" */
  insert_agent_task_one?: Maybe<Agent_Task>;
  /** insert data into the table: "amenities" */
  insert_amenities?: Maybe<Amenities_Mutation_Response>;
  /** insert a single row into the table: "amenities" */
  insert_amenities_one?: Maybe<Amenities>;
  /** insert data into the table: "app_config" */
  insert_app_config?: Maybe<App_Config_Mutation_Response>;
  /** insert a single row into the table: "app_config" */
  insert_app_config_one?: Maybe<App_Config>;
  /** insert data into the table: "blog" */
  insert_blog?: Maybe<Blog_Mutation_Response>;
  /** insert a single row into the table: "blog" */
  insert_blog_one?: Maybe<Blog>;
  /** insert data into the table: "blog_post" */
  insert_blog_post?: Maybe<Blog_Post_Mutation_Response>;
  /** insert a single row into the table: "blog_post" */
  insert_blog_post_one?: Maybe<Blog_Post>;
  /** insert data into the table: "blog_section" */
  insert_blog_section?: Maybe<Blog_Section_Mutation_Response>;
  /** insert a single row into the table: "blog_section" */
  insert_blog_section_one?: Maybe<Blog_Section>;
  /** insert data into the table: "blog_status" */
  insert_blog_status?: Maybe<Blog_Status_Mutation_Response>;
  /** insert a single row into the table: "blog_status" */
  insert_blog_status_one?: Maybe<Blog_Status>;
  /** insert data into the table: "builder" */
  insert_builder?: Maybe<Builder_Mutation_Response>;
  /** insert a single row into the table: "builder" */
  insert_builder_one?: Maybe<Builder>;
  /** insert data into the table: "certified_agent" */
  insert_certified_agent?: Maybe<Certified_Agent_Mutation_Response>;
  /** insert a single row into the table: "certified_agent" */
  insert_certified_agent_one?: Maybe<Certified_Agent>;
  /** insert data into the table: "chat_response_type" */
  insert_chat_response_type?: Maybe<Chat_Response_Type_Mutation_Response>;
  /** insert a single row into the table: "chat_response_type" */
  insert_chat_response_type_one?: Maybe<Chat_Response_Type>;
  /** insert data into the table: "city" */
  insert_city?: Maybe<City_Mutation_Response>;
  /** insert a single row into the table: "city" */
  insert_city_one?: Maybe<City>;
  /** insert data into the table: "city_zone" */
  insert_city_zone?: Maybe<City_Zone_Mutation_Response>;
  /** insert a single row into the table: "city_zone" */
  insert_city_zone_one?: Maybe<City_Zone>;
  /** insert data into the table: "city_zone_origin" */
  insert_city_zone_origin?: Maybe<City_Zone_Origin_Mutation_Response>;
  /** insert a single row into the table: "city_zone_origin" */
  insert_city_zone_origin_one?: Maybe<City_Zone_Origin>;
  /** insert data into the table: "claim_request_status" */
  insert_claim_request_status?: Maybe<Claim_Request_Status_Mutation_Response>;
  /** insert a single row into the table: "claim_request_status" */
  insert_claim_request_status_one?: Maybe<Claim_Request_Status>;
  /** insert data into the table: "clering" */
  insert_clering?: Maybe<Clering_Mutation_Response>;
  /** insert a single row into the table: "clering" */
  insert_clering_one?: Maybe<Clering>;
  /** insert data into the table: "construction_status" */
  insert_construction_status?: Maybe<Construction_Status_Mutation_Response>;
  /** insert a single row into the table: "construction_status" */
  insert_construction_status_one?: Maybe<Construction_Status>;
  /** insert data into the table: "contact" */
  insert_contact?: Maybe<Contact_Mutation_Response>;
  /** insert a single row into the table: "contact" */
  insert_contact_one?: Maybe<Contact>;
  /** insert data into the table: "contact_phone_number" */
  insert_contact_phone_number?: Maybe<Contact_Phone_Number_Mutation_Response>;
  /** insert a single row into the table: "contact_phone_number" */
  insert_contact_phone_number_one?: Maybe<Contact_Phone_Number>;
  /** insert data into the table: "contact_type" */
  insert_contact_type?: Maybe<Contact_Type_Mutation_Response>;
  /** insert a single row into the table: "contact_type" */
  insert_contact_type_one?: Maybe<Contact_Type>;
  /** insert data into the table: "content_type" */
  insert_content_type?: Maybe<Content_Type_Mutation_Response>;
  /** insert a single row into the table: "content_type" */
  insert_content_type_one?: Maybe<Content_Type>;
  /** insert data into the table: "countries" */
  insert_countries?: Maybe<Countries_Mutation_Response>;
  /** insert a single row into the table: "countries" */
  insert_countries_one?: Maybe<Countries>;
  /** insert data into the table: "country" */
  insert_country?: Maybe<Country_Mutation_Response>;
  /** insert a single row into the table: "country" */
  insert_country_one?: Maybe<Country>;
  /** insert data into the table: "currency" */
  insert_currency?: Maybe<Currency_Mutation_Response>;
  /** insert data into the table: "currency_exchange_rates" */
  insert_currency_exchange_rates?: Maybe<Currency_Exchange_Rates_Mutation_Response>;
  /** insert a single row into the table: "currency_exchange_rates" */
  insert_currency_exchange_rates_one?: Maybe<Currency_Exchange_Rates>;
  /** insert a single row into the table: "currency" */
  insert_currency_one?: Maybe<Currency>;
  /** insert data into the table: "entities" */
  insert_entities?: Maybe<Entities_Mutation_Response>;
  /** insert a single row into the table: "entities" */
  insert_entities_one?: Maybe<Entities>;
  /** insert data into the table: "exchange_rates" */
  insert_exchange_rates?: Maybe<Exchange_Rates_Mutation_Response>;
  /** insert a single row into the table: "exchange_rates" */
  insert_exchange_rates_one?: Maybe<Exchange_Rates>;
  /** insert data into the table: "feature" */
  insert_feature?: Maybe<Feature_Mutation_Response>;
  /** insert a single row into the table: "feature" */
  insert_feature_one?: Maybe<Feature>;
  /** insert data into the table: "feature_type" */
  insert_feature_type?: Maybe<Feature_Type_Mutation_Response>;
  /** insert a single row into the table: "feature_type" */
  insert_feature_type_one?: Maybe<Feature_Type>;
  /** insert data into the table: "file_type" */
  insert_file_type?: Maybe<File_Type_Mutation_Response>;
  /** insert a single row into the table: "file_type" */
  insert_file_type_one?: Maybe<File_Type>;
  /** insert data into the table: "folder_amenities" */
  insert_folder_amenities?: Maybe<Folder_Amenities_Mutation_Response>;
  /** insert a single row into the table: "folder_amenities" */
  insert_folder_amenities_one?: Maybe<Folder_Amenities>;
  /** insert data into the table: "folder_image" */
  insert_folder_image?: Maybe<Folder_Image_Mutation_Response>;
  /** insert a single row into the table: "folder_image" */
  insert_folder_image_one?: Maybe<Folder_Image>;
  /** insert data into the table: "folder_properties_type" */
  insert_folder_properties_type?: Maybe<Folder_Properties_Type_Mutation_Response>;
  /** insert a single row into the table: "folder_properties_type" */
  insert_folder_properties_type_one?: Maybe<Folder_Properties_Type>;
  /** insert data into the table: "folder_status" */
  insert_folder_status?: Maybe<Folder_Status_Mutation_Response>;
  /** insert a single row into the table: "folder_status" */
  insert_folder_status_one?: Maybe<Folder_Status>;
  /** insert data into the table: "folder_type" */
  insert_folder_type?: Maybe<Folder_Type_Mutation_Response>;
  /** insert a single row into the table: "folder_type" */
  insert_folder_type_one?: Maybe<Folder_Type>;
  /** insert data into the table: "furnishing_status" */
  insert_furnishing_status?: Maybe<Furnishing_Status_Mutation_Response>;
  /** insert a single row into the table: "furnishing_status" */
  insert_furnishing_status_one?: Maybe<Furnishing_Status>;
  /** insert data into the table: "google_calendar" */
  insert_google_calendar?: Maybe<Google_Calendar_Mutation_Response>;
  /** insert a single row into the table: "google_calendar" */
  insert_google_calendar_one?: Maybe<Google_Calendar>;
  /** insert data into the table: "heatingType" */
  insert_heatingType?: Maybe<HeatingType_Mutation_Response>;
  /** insert a single row into the table: "heatingType" */
  insert_heatingType_one?: Maybe<HeatingType>;
  /** insert data into the table: "image" */
  insert_image?: Maybe<Image_Mutation_Response>;
  /** insert a single row into the table: "image" */
  insert_image_one?: Maybe<Image>;
  /** insert data into the table: "invoice_status" */
  insert_invoice_status?: Maybe<Invoice_Status_Mutation_Response>;
  /** insert a single row into the table: "invoice_status" */
  insert_invoice_status_one?: Maybe<Invoice_Status>;
  /** insert data into the table: "languages" */
  insert_languages?: Maybe<Languages_Mutation_Response>;
  /** insert a single row into the table: "languages" */
  insert_languages_one?: Maybe<Languages>;
  /** insert data into the table: "lead_property_category" */
  insert_lead_property_category?: Maybe<Lead_Property_Category_Mutation_Response>;
  /** insert a single row into the table: "lead_property_category" */
  insert_lead_property_category_one?: Maybe<Lead_Property_Category>;
  /** insert data into the table: "lead_status" */
  insert_lead_status?: Maybe<Lead_Status_Mutation_Response>;
  /** insert a single row into the table: "lead_status" */
  insert_lead_status_one?: Maybe<Lead_Status>;
  /** insert data into the table: "lead_type" */
  insert_lead_type?: Maybe<Lead_Type_Mutation_Response>;
  /** insert a single row into the table: "lead_type" */
  insert_lead_type_one?: Maybe<Lead_Type>;
  /** insert data into the table: "lister_claim_request" */
  insert_lister_claim_request?: Maybe<Lister_Claim_Request_Mutation_Response>;
  /** insert data into the table: "lister_claim_request_activity" */
  insert_lister_claim_request_activity?: Maybe<Lister_Claim_Request_Activity_Mutation_Response>;
  /** insert a single row into the table: "lister_claim_request_activity" */
  insert_lister_claim_request_activity_one?: Maybe<Lister_Claim_Request_Activity>;
  /** insert a single row into the table: "lister_claim_request" */
  insert_lister_claim_request_one?: Maybe<Lister_Claim_Request>;
  /** insert data into the table: "lister_contact" */
  insert_lister_contact?: Maybe<Lister_Contact_Mutation_Response>;
  /** insert data into the table: "lister_contact_meeting" */
  insert_lister_contact_meeting?: Maybe<Lister_Contact_Meeting_Mutation_Response>;
  /** insert a single row into the table: "lister_contact_meeting" */
  insert_lister_contact_meeting_one?: Maybe<Lister_Contact_Meeting>;
  /** insert a single row into the table: "lister_contact" */
  insert_lister_contact_one?: Maybe<Lister_Contact>;
  /** insert data into the table: "lister_contact_source" */
  insert_lister_contact_source?: Maybe<Lister_Contact_Source_Mutation_Response>;
  /** insert a single row into the table: "lister_contact_source" */
  insert_lister_contact_source_one?: Maybe<Lister_Contact_Source>;
  /** insert data into the table: "lister_leads" */
  insert_lister_leads?: Maybe<Lister_Leads_Mutation_Response>;
  /** insert a single row into the table: "lister_leads" */
  insert_lister_leads_one?: Maybe<Lister_Leads>;
  /** insert data into the table: "lister_meeting" */
  insert_lister_meeting?: Maybe<Lister_Meeting_Mutation_Response>;
  /** insert a single row into the table: "lister_meeting" */
  insert_lister_meeting_one?: Maybe<Lister_Meeting>;
  /** insert data into the table: "lister_role" */
  insert_lister_role?: Maybe<Lister_Role_Mutation_Response>;
  /** insert a single row into the table: "lister_role" */
  insert_lister_role_one?: Maybe<Lister_Role>;
  /** insert data into the table: "location" */
  insert_location?: Maybe<Location_Mutation_Response>;
  /** insert a single row into the table: "location" */
  insert_location_one?: Maybe<Location>;
  /** insert data into the table: "location_type" */
  insert_location_type?: Maybe<Location_Type_Mutation_Response>;
  /** insert a single row into the table: "location_type" */
  insert_location_type_one?: Maybe<Location_Type>;
  /** insert data into the table: "main_currency" */
  insert_main_currency?: Maybe<Main_Currency_Mutation_Response>;
  /** insert a single row into the table: "main_currency" */
  insert_main_currency_one?: Maybe<Main_Currency>;
  /** insert data into the table: "natural_language_queries" */
  insert_natural_language_queries?: Maybe<Natural_Language_Queries_Mutation_Response>;
  /** insert a single row into the table: "natural_language_queries" */
  insert_natural_language_queries_one?: Maybe<Natural_Language_Queries>;
  /** insert data into the table: "notification" */
  insert_notification?: Maybe<Notification_Mutation_Response>;
  /** insert data into the table: "notification_amenities" */
  insert_notification_amenities?: Maybe<Notification_Amenities_Mutation_Response>;
  /** insert a single row into the table: "notification_amenities" */
  insert_notification_amenities_one?: Maybe<Notification_Amenities>;
  /** insert data into the table: "notification_feature" */
  insert_notification_feature?: Maybe<Notification_Feature_Mutation_Response>;
  /** insert a single row into the table: "notification_feature" */
  insert_notification_feature_one?: Maybe<Notification_Feature>;
  /** insert a single row into the table: "notification" */
  insert_notification_one?: Maybe<Notification>;
  /** insert data into the table: "notification_property_type" */
  insert_notification_property_type?: Maybe<Notification_Property_Type_Mutation_Response>;
  /** insert a single row into the table: "notification_property_type" */
  insert_notification_property_type_one?: Maybe<Notification_Property_Type>;
  /** insert data into the table: "notification_type" */
  insert_notification_type?: Maybe<Notification_Type_Mutation_Response>;
  /** insert a single row into the table: "notification_type" */
  insert_notification_type_one?: Maybe<Notification_Type>;
  /** insert data into the table: "order" */
  insert_order?: Maybe<Order_Mutation_Response>;
  /** insert a single row into the table: "order" */
  insert_order_one?: Maybe<Order>;
  /** insert data into the table: "order_status" */
  insert_order_status?: Maybe<Order_Status_Mutation_Response>;
  /** insert a single row into the table: "order_status" */
  insert_order_status_one?: Maybe<Order_Status>;
  /** insert data into the table: "organization" */
  insert_organization?: Maybe<Organization_Mutation_Response>;
  /** insert data into the table: "organization_lead_location" */
  insert_organization_lead_location?: Maybe<Organization_Lead_Location_Mutation_Response>;
  /** insert a single row into the table: "organization_lead_location" */
  insert_organization_lead_location_one?: Maybe<Organization_Lead_Location>;
  /** insert data into the table: "organization_lead_property" */
  insert_organization_lead_property?: Maybe<Organization_Lead_Property_Mutation_Response>;
  /** insert a single row into the table: "organization_lead_property" */
  insert_organization_lead_property_one?: Maybe<Organization_Lead_Property>;
  /** insert data into the table: "organization_leads" */
  insert_organization_leads?: Maybe<Organization_Leads_Mutation_Response>;
  /** insert a single row into the table: "organization_leads" */
  insert_organization_leads_one?: Maybe<Organization_Leads>;
  /** insert a single row into the table: "organization" */
  insert_organization_one?: Maybe<Organization>;
  /** insert data into the table: "organization_role" */
  insert_organization_role?: Maybe<Organization_Role_Mutation_Response>;
  /** insert a single row into the table: "organization_role" */
  insert_organization_role_one?: Maybe<Organization_Role>;
  /** insert data into the table: "organization_status" */
  insert_organization_status?: Maybe<Organization_Status_Mutation_Response>;
  /** insert a single row into the table: "organization_status" */
  insert_organization_status_one?: Maybe<Organization_Status>;
  /** insert data into the table: "organization_telegram_agent_link" */
  insert_organization_telegram_agent_link?: Maybe<Organization_Telegram_Agent_Link_Mutation_Response>;
  /** insert a single row into the table: "organization_telegram_agent_link" */
  insert_organization_telegram_agent_link_one?: Maybe<Organization_Telegram_Agent_Link>;
  /** insert data into the table: "organization_type" */
  insert_organization_type?: Maybe<Organization_Type_Mutation_Response>;
  /** insert a single row into the table: "organization_type" */
  insert_organization_type_one?: Maybe<Organization_Type>;
  /** insert data into the table: "organization_whatsapp_ai_allowlist" */
  insert_organization_whatsapp_ai_allowlist?: Maybe<Organization_Whatsapp_Ai_Allowlist_Mutation_Response>;
  /** insert a single row into the table: "organization_whatsapp_ai_allowlist" */
  insert_organization_whatsapp_ai_allowlist_one?: Maybe<Organization_Whatsapp_Ai_Allowlist>;
  /** insert data into the table: "organization_whatsapp_ai_config" */
  insert_organization_whatsapp_ai_config?: Maybe<Organization_Whatsapp_Ai_Config_Mutation_Response>;
  /** insert a single row into the table: "organization_whatsapp_ai_config" */
  insert_organization_whatsapp_ai_config_one?: Maybe<Organization_Whatsapp_Ai_Config>;
  /** insert data into the table: "parking_type" */
  insert_parking_type?: Maybe<Parking_Type_Mutation_Response>;
  /** insert a single row into the table: "parking_type" */
  insert_parking_type_one?: Maybe<Parking_Type>;
  /** insert data into the table: "phone_number_type" */
  insert_phone_number_type?: Maybe<Phone_Number_Type_Mutation_Response>;
  /** insert a single row into the table: "phone_number_type" */
  insert_phone_number_type_one?: Maybe<Phone_Number_Type>;
  /** insert data into the table: "place_reference" */
  insert_place_reference?: Maybe<Place_Reference_Mutation_Response>;
  /** insert data into the table: "place_reference_alias" */
  insert_place_reference_alias?: Maybe<Place_Reference_Alias_Mutation_Response>;
  /** insert a single row into the table: "place_reference_alias" */
  insert_place_reference_alias_one?: Maybe<Place_Reference_Alias>;
  /** insert a single row into the table: "place_reference" */
  insert_place_reference_one?: Maybe<Place_Reference>;
  /** insert data into the table: "place_reference_proposal" */
  insert_place_reference_proposal?: Maybe<Place_Reference_Proposal_Mutation_Response>;
  /** insert a single row into the table: "place_reference_proposal" */
  insert_place_reference_proposal_one?: Maybe<Place_Reference_Proposal>;
  /** insert data into the table: "plan" */
  insert_plan?: Maybe<Plan_Mutation_Response>;
  /** insert a single row into the table: "plan" */
  insert_plan_one?: Maybe<Plan>;
  /** insert data into the table: "plan_type" */
  insert_plan_type?: Maybe<Plan_Type_Mutation_Response>;
  /** insert a single row into the table: "plan_type" */
  insert_plan_type_one?: Maybe<Plan_Type>;
  /** insert data into the table: "product" */
  insert_product?: Maybe<Product_Mutation_Response>;
  /** insert a single row into the table: "product" */
  insert_product_one?: Maybe<Product>;
  /** insert data into the table: "product_purchase" */
  insert_product_purchase?: Maybe<Product_Purchase_Mutation_Response>;
  /** insert a single row into the table: "product_purchase" */
  insert_product_purchase_one?: Maybe<Product_Purchase>;
  /** insert data into the table: "product_type" */
  insert_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** insert a single row into the table: "product_type" */
  insert_product_type_one?: Maybe<Product_Type>;
  /** insert data into the table: "property" */
  insert_property?: Maybe<Property_Mutation_Response>;
  /** insert data into the table: "property_cluster" */
  insert_property_cluster?: Maybe<Property_Cluster_Mutation_Response>;
  /** insert a single row into the table: "property_cluster" */
  insert_property_cluster_one?: Maybe<Property_Cluster>;
  /** insert data into the table: "property_composition" */
  insert_property_composition?: Maybe<Property_Composition_Mutation_Response>;
  /** insert a single row into the table: "property_composition" */
  insert_property_composition_one?: Maybe<Property_Composition>;
  /** insert data into the table: "property_feature" */
  insert_property_feature?: Maybe<Property_Feature_Mutation_Response>;
  /** insert a single row into the table: "property_feature" */
  insert_property_feature_one?: Maybe<Property_Feature>;
  /** insert data into the table: "property_folder" */
  insert_property_folder?: Maybe<Property_Folder_Mutation_Response>;
  /** insert a single row into the table: "property_folder" */
  insert_property_folder_one?: Maybe<Property_Folder>;
  /** insert data into the table: "property_folder_public_profile" */
  insert_property_folder_public_profile?: Maybe<Property_Folder_Public_Profile_Mutation_Response>;
  /** insert data into the table: "property_folder_public_profile_faq" */
  insert_property_folder_public_profile_faq?: Maybe<Property_Folder_Public_Profile_Faq_Mutation_Response>;
  /** insert a single row into the table: "property_folder_public_profile_faq" */
  insert_property_folder_public_profile_faq_one?: Maybe<Property_Folder_Public_Profile_Faq>;
  /** insert data into the table: "property_folder_public_profile_highlight" */
  insert_property_folder_public_profile_highlight?: Maybe<Property_Folder_Public_Profile_Highlight_Mutation_Response>;
  /** insert a single row into the table: "property_folder_public_profile_highlight" */
  insert_property_folder_public_profile_highlight_one?: Maybe<Property_Folder_Public_Profile_Highlight>;
  /** insert data into the table: "property_folder_public_profile_listing_example" */
  insert_property_folder_public_profile_listing_example?: Maybe<Property_Folder_Public_Profile_Listing_Example_Mutation_Response>;
  /** insert a single row into the table: "property_folder_public_profile_listing_example" */
  insert_property_folder_public_profile_listing_example_one?: Maybe<Property_Folder_Public_Profile_Listing_Example>;
  /** insert data into the table: "property_folder_public_profile_nearby_place" */
  insert_property_folder_public_profile_nearby_place?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Mutation_Response>;
  /** insert a single row into the table: "property_folder_public_profile_nearby_place" */
  insert_property_folder_public_profile_nearby_place_one?: Maybe<Property_Folder_Public_Profile_Nearby_Place>;
  /** insert a single row into the table: "property_folder_public_profile" */
  insert_property_folder_public_profile_one?: Maybe<Property_Folder_Public_Profile>;
  /** insert data into the table: "property_folder_public_profile_related" */
  insert_property_folder_public_profile_related?: Maybe<Property_Folder_Public_Profile_Related_Mutation_Response>;
  /** insert a single row into the table: "property_folder_public_profile_related" */
  insert_property_folder_public_profile_related_one?: Maybe<Property_Folder_Public_Profile_Related>;
  /** insert data into the table: "property_folder_public_profile_translation" */
  insert_property_folder_public_profile_translation?: Maybe<Property_Folder_Public_Profile_Translation_Mutation_Response>;
  /** insert a single row into the table: "property_folder_public_profile_translation" */
  insert_property_folder_public_profile_translation_one?: Maybe<Property_Folder_Public_Profile_Translation>;
  /** insert data into the table: "property_image" */
  insert_property_image?: Maybe<Property_Image_Mutation_Response>;
  /** insert a single row into the table: "property_image" */
  insert_property_image_one?: Maybe<Property_Image>;
  /** insert data into the table: "property_list" */
  insert_property_list?: Maybe<Property_List_Mutation_Response>;
  /** insert data into the table: "property_list_activity" */
  insert_property_list_activity?: Maybe<Property_List_Activity_Mutation_Response>;
  /** insert a single row into the table: "property_list_activity" */
  insert_property_list_activity_one?: Maybe<Property_List_Activity>;
  /** insert data into the table: "property_list_folder" */
  insert_property_list_folder?: Maybe<Property_List_Folder_Mutation_Response>;
  /** insert a single row into the table: "property_list_folder" */
  insert_property_list_folder_one?: Maybe<Property_List_Folder>;
  /** insert a single row into the table: "property_list" */
  insert_property_list_one?: Maybe<Property_List>;
  /** insert data into the table: "property_list_report" */
  insert_property_list_report?: Maybe<Property_List_Report_Mutation_Response>;
  /** insert a single row into the table: "property_list_report" */
  insert_property_list_report_one?: Maybe<Property_List_Report>;
  /** insert a single row into the table: "property" */
  insert_property_one?: Maybe<Property>;
  /** insert data into the table: "property_origin" */
  insert_property_origin?: Maybe<Property_Origin_Mutation_Response>;
  /** insert a single row into the table: "property_origin" */
  insert_property_origin_one?: Maybe<Property_Origin>;
  /** insert data into the table: "property_origin_type" */
  insert_property_origin_type?: Maybe<Property_Origin_Type_Mutation_Response>;
  /** insert a single row into the table: "property_origin_type" */
  insert_property_origin_type_one?: Maybe<Property_Origin_Type>;
  /** insert data into the table: "property_owner" */
  insert_property_owner?: Maybe<Property_Owner_Mutation_Response>;
  /** insert a single row into the table: "property_owner" */
  insert_property_owner_one?: Maybe<Property_Owner>;
  /** insert data into the table: "property_place_reference" */
  insert_property_place_reference?: Maybe<Property_Place_Reference_Mutation_Response>;
  /** insert a single row into the table: "property_place_reference" */
  insert_property_place_reference_one?: Maybe<Property_Place_Reference>;
  /** insert data into the table: "property_price_history" */
  insert_property_price_history?: Maybe<Property_Price_History_Mutation_Response>;
  /** insert a single row into the table: "property_price_history" */
  insert_property_price_history_one?: Maybe<Property_Price_History>;
  /** insert data into the table: "property_report_type" */
  insert_property_report_type?: Maybe<Property_Report_Type_Mutation_Response>;
  /** insert a single row into the table: "property_report_type" */
  insert_property_report_type_one?: Maybe<Property_Report_Type>;
  /** insert data into the table: "property_source" */
  insert_property_source?: Maybe<Property_Source_Mutation_Response>;
  /** insert a single row into the table: "property_source" */
  insert_property_source_one?: Maybe<Property_Source>;
  /** insert data into the table: "property_status" */
  insert_property_status?: Maybe<Property_Status_Mutation_Response>;
  /** insert a single row into the table: "property_status" */
  insert_property_status_one?: Maybe<Property_Status>;
  /** insert data into the table: "property_type" */
  insert_property_type?: Maybe<Property_Type_Mutation_Response>;
  /** insert a single row into the table: "property_type" */
  insert_property_type_one?: Maybe<Property_Type>;
  /** insert data into the table: "property_views" */
  insert_property_views?: Maybe<Property_Views_Mutation_Response>;
  /** insert a single row into the table: "property_views" */
  insert_property_views_one?: Maybe<Property_Views>;
  /** insert data into the table: "queries_property_result" */
  insert_queries_property_result?: Maybe<Queries_Property_Result_Mutation_Response>;
  /** insert a single row into the table: "queries_property_result" */
  insert_queries_property_result_one?: Maybe<Queries_Property_Result>;
  /** insert data into the table: "queries_property_result_re" */
  insert_queries_property_result_re?: Maybe<Queries_Property_Result_Re_Mutation_Response>;
  /** insert a single row into the table: "queries_property_result_re" */
  insert_queries_property_result_re_one?: Maybe<Queries_Property_Result_Re>;
  /** insert data into the table: "query_classification" */
  insert_query_classification?: Maybe<Query_Classification_Mutation_Response>;
  /** insert a single row into the table: "query_classification" */
  insert_query_classification_one?: Maybe<Query_Classification>;
  /** insert data into the table: "query_classification_re" */
  insert_query_classification_re?: Maybe<Query_Classification_Re_Mutation_Response>;
  /** insert a single row into the table: "query_classification_re" */
  insert_query_classification_re_one?: Maybe<Query_Classification_Re>;
  /** insert data into the table: "raw_location" */
  insert_raw_location?: Maybe<Raw_Location_Mutation_Response>;
  /** insert a single row into the table: "raw_location" */
  insert_raw_location_one?: Maybe<Raw_Location>;
  /** insert data into the table: "redirect" */
  insert_redirect?: Maybe<Redirect_Mutation_Response>;
  /** insert a single row into the table: "redirect" */
  insert_redirect_one?: Maybe<Redirect>;
  /** insert data into the table: "reference_price_history" */
  insert_reference_price_history?: Maybe<Reference_Price_History_Mutation_Response>;
  /** insert a single row into the table: "reference_price_history" */
  insert_reference_price_history_one?: Maybe<Reference_Price_History>;
  /** insert data into the table: "reference_zone" */
  insert_reference_zone?: Maybe<Reference_Zone_Mutation_Response>;
  /** insert a single row into the table: "reference_zone" */
  insert_reference_zone_one?: Maybe<Reference_Zone>;
  /** insert data into the table: "search_context" */
  insert_search_context?: Maybe<Search_Context_Mutation_Response>;
  /** insert data into the table: "search_context_location" */
  insert_search_context_location?: Maybe<Search_Context_Location_Mutation_Response>;
  /** insert a single row into the table: "search_context_location" */
  insert_search_context_location_one?: Maybe<Search_Context_Location>;
  /** insert a single row into the table: "search_context" */
  insert_search_context_one?: Maybe<Search_Context>;
  /** insert data into the table: "search_domain" */
  insert_search_domain?: Maybe<Search_Domain_Mutation_Response>;
  /** insert a single row into the table: "search_domain" */
  insert_search_domain_one?: Maybe<Search_Domain>;
  /** insert data into the table: "search_sessions" */
  insert_search_sessions?: Maybe<Search_Sessions_Mutation_Response>;
  /** insert a single row into the table: "search_sessions" */
  insert_search_sessions_one?: Maybe<Search_Sessions>;
  /** insert data into the table: "search_slugs" */
  insert_search_slugs?: Maybe<Search_Slugs_Mutation_Response>;
  /** insert a single row into the table: "search_slugs" */
  insert_search_slugs_one?: Maybe<Search_Slugs>;
  /** insert data into the table: "seo_city" */
  insert_seo_city?: Maybe<Seo_City_Mutation_Response>;
  /** insert a single row into the table: "seo_city" */
  insert_seo_city_one?: Maybe<Seo_City>;
  /** insert data into the table: "session_origin" */
  insert_session_origin?: Maybe<Session_Origin_Mutation_Response>;
  /** insert a single row into the table: "session_origin" */
  insert_session_origin_one?: Maybe<Session_Origin>;
  /** insert data into the table: "sponsored_property_list" */
  insert_sponsored_property_list?: Maybe<Sponsored_Property_List_Mutation_Response>;
  /** insert a single row into the table: "sponsored_property_list" */
  insert_sponsored_property_list_one?: Maybe<Sponsored_Property_List>;
  /** insert data into the table: "subscription" */
  insert_subscription?: Maybe<Subscription_Mutation_Response>;
  /** insert data into the table: "subscription_invoice" */
  insert_subscription_invoice?: Maybe<Subscription_Invoice_Mutation_Response>;
  /** insert a single row into the table: "subscription_invoice" */
  insert_subscription_invoice_one?: Maybe<Subscription_Invoice>;
  /** insert a single row into the table: "subscription" */
  insert_subscription_one?: Maybe<Subscription>;
  /** insert data into the table: "subscription_source" */
  insert_subscription_source?: Maybe<Subscription_Source_Mutation_Response>;
  /** insert a single row into the table: "subscription_source" */
  insert_subscription_source_one?: Maybe<Subscription_Source>;
  /** insert data into the table: "subscription_status" */
  insert_subscription_status?: Maybe<Subscription_Status_Mutation_Response>;
  /** insert a single row into the table: "subscription_status" */
  insert_subscription_status_one?: Maybe<Subscription_Status>;
  /** insert data into the table: "text_content" */
  insert_text_content?: Maybe<Text_Content_Mutation_Response>;
  /** insert a single row into the table: "text_content" */
  insert_text_content_one?: Maybe<Text_Content>;
  /** insert data into the table: "translations" */
  insert_translations?: Maybe<Translations_Mutation_Response>;
  /** insert a single row into the table: "translations" */
  insert_translations_one?: Maybe<Translations>;
  /** insert data into the table: "url_slug" */
  insert_url_slug?: Maybe<Url_Slug_Mutation_Response>;
  /** insert a single row into the table: "url_slug" */
  insert_url_slug_one?: Maybe<Url_Slug>;
  /** insert data into the table: "user_filters" */
  insert_user_filters?: Maybe<User_Filters_Mutation_Response>;
  /** insert data into the table: "user_filters_features" */
  insert_user_filters_features?: Maybe<User_Filters_Features_Mutation_Response>;
  /** insert a single row into the table: "user_filters_features" */
  insert_user_filters_features_one?: Maybe<User_Filters_Features>;
  /** insert a single row into the table: "user_filters" */
  insert_user_filters_one?: Maybe<User_Filters>;
  /** insert data into the table: "user_organization" */
  insert_user_organization?: Maybe<User_Organization_Mutation_Response>;
  /** insert a single row into the table: "user_organization" */
  insert_user_organization_one?: Maybe<User_Organization>;
  /** insert data into the table: "user_preferences" */
  insert_user_preferences?: Maybe<User_Preferences_Mutation_Response>;
  /** insert a single row into the table: "user_preferences" */
  insert_user_preferences_one?: Maybe<User_Preferences>;
  /** insert data into the table: "user_property_notifiation" */
  insert_user_property_notifiation?: Maybe<User_Property_Notifiation_Mutation_Response>;
  /** insert a single row into the table: "user_property_notifiation" */
  insert_user_property_notifiation_one?: Maybe<User_Property_Notifiation>;
  /** insert data into the table: "user_saved_properties" */
  insert_user_saved_properties?: Maybe<User_Saved_Properties_Mutation_Response>;
  /** insert a single row into the table: "user_saved_properties" */
  insert_user_saved_properties_one?: Maybe<User_Saved_Properties>;
  /** insert data into the table: "user_seen_property" */
  insert_user_seen_property?: Maybe<User_Seen_Property_Mutation_Response>;
  /** insert a single row into the table: "user_seen_property" */
  insert_user_seen_property_one?: Maybe<User_Seen_Property>;
  /** insert data into the table: "users_activity_summary" */
  insert_users_activity_summary?: Maybe<Users_Activity_Summary_Mutation_Response>;
  /** insert a single row into the table: "users_activity_summary" */
  insert_users_activity_summary_one?: Maybe<Users_Activity_Summary>;
  /** insert data into the table: "visibility_status" */
  insert_visibility_status?: Maybe<Visibility_Status_Mutation_Response>;
  /** insert a single row into the table: "visibility_status" */
  insert_visibility_status_one?: Maybe<Visibility_Status>;
  /** insert data into the table: "whatsapp_ai_inbound_message" */
  insert_whatsapp_ai_inbound_message?: Maybe<Whatsapp_Ai_Inbound_Message_Mutation_Response>;
  /** insert a single row into the table: "whatsapp_ai_inbound_message" */
  insert_whatsapp_ai_inbound_message_one?: Maybe<Whatsapp_Ai_Inbound_Message>;
  /** insert data into the table: "whatsapp_ai_outbox_part" */
  insert_whatsapp_ai_outbox_part?: Maybe<Whatsapp_Ai_Outbox_Part_Mutation_Response>;
  /** insert a single row into the table: "whatsapp_ai_outbox_part" */
  insert_whatsapp_ai_outbox_part_one?: Maybe<Whatsapp_Ai_Outbox_Part>;
  /** insert data into the table: "whatsapp_ai_turn" */
  insert_whatsapp_ai_turn?: Maybe<Whatsapp_Ai_Turn_Mutation_Response>;
  /** insert a single row into the table: "whatsapp_ai_turn" */
  insert_whatsapp_ai_turn_one?: Maybe<Whatsapp_Ai_Turn>;
  /** insert data into the table: "whatsapp_chat" */
  insert_whatsapp_chat?: Maybe<Whatsapp_Chat_Mutation_Response>;
  /** insert a single row into the table: "whatsapp_chat" */
  insert_whatsapp_chat_one?: Maybe<Whatsapp_Chat>;
  /** insert data into the table: "whatsapp_human" */
  insert_whatsapp_human?: Maybe<Whatsapp_Human_Mutation_Response>;
  /** insert a single row into the table: "whatsapp_human" */
  insert_whatsapp_human_one?: Maybe<Whatsapp_Human>;
  /** insert data into the table: "zone_contains" */
  insert_zone_contains?: Maybe<Zone_Contains_Mutation_Response>;
  /** insert a single row into the table: "zone_contains" */
  insert_zone_contains_one?: Maybe<Zone_Contains>;
  /** insert data into the table: "zone_data_method" */
  insert_zone_data_method?: Maybe<Zone_Data_Method_Mutation_Response>;
  /** insert a single row into the table: "zone_data_method" */
  insert_zone_data_method_one?: Maybe<Zone_Data_Method>;
  /** execute VOLATILE function "maintain_whatsapp_ai_ledger" which returns "whatsapp_ai_outbox_part" */
  maintain_whatsapp_ai_ledger: Array<Whatsapp_Ai_Outbox_Part>;
  /** execute VOLATILE function "mark_whatsapp_ai_outbox_part_ambiguous" which returns "whatsapp_ai_outbox_part" */
  mark_whatsapp_ai_outbox_part_ambiguous: Array<Whatsapp_Ai_Outbox_Part>;
  /** execute VOLATILE function "mark_whatsapp_ai_outbox_part_dispatched" which returns "whatsapp_ai_outbox_part" */
  mark_whatsapp_ai_outbox_part_dispatched: Array<Whatsapp_Ai_Outbox_Part>;
  membership_free_trial?: Maybe<FreeTrialOutput>;
  paginated_search?: Maybe<Properties_Output>;
  payment_success?: Maybe<PaymentSuccessOutput>;
  /** potential_buyer_properties */
  potential_buyer_properties?: Maybe<PotentialBuyerPropertiesOutput>;
  process_user_notification?: Maybe<Output>;
  promptSearch?: Maybe<QuestionOutput>;
  property_duplicate_approve?: Maybe<PropertyDuplicateApproveOutput>;
  property_duplicate_check?: Maybe<PropertyDuplicateCheckOutput>;
  querySearch?: Maybe<SampleOutput>;
  /** execute VOLATILE function "rebuild_zone_contains_for_zone" which returns "zone_contains" */
  rebuild_zone_contains_for_zone: Array<Zone_Contains>;
  /** execute VOLATILE function "reconcile_whatsapp_ai_outbox_echo" which returns "whatsapp_ai_outbox_part" */
  reconcile_whatsapp_ai_outbox_echo: Array<Whatsapp_Ai_Outbox_Part>;
  /** execute VOLATILE function "reconcile_whatsapp_ai_outbox_part" which returns "whatsapp_ai_outbox_part" */
  reconcile_whatsapp_ai_outbox_part: Array<Whatsapp_Ai_Outbox_Part>;
  /** execute VOLATILE function "redact_expired_whatsapp_ai_inbound_metadata" which returns "whatsapp_ai_inbound_message" */
  redact_expired_whatsapp_ai_inbound_metadata: Array<Whatsapp_Ai_Inbound_Message>;
  /** execute VOLATILE function "redact_expired_whatsapp_ai_outbox_payloads" which returns "whatsapp_ai_outbox_part" */
  redact_expired_whatsapp_ai_outbox_payloads: Array<Whatsapp_Ai_Outbox_Part>;
  /** execute VOLATILE function "redact_expired_whatsapp_ai_turn_metadata" which returns "whatsapp_ai_turn" */
  redact_expired_whatsapp_ai_turn_metadata: Array<Whatsapp_Ai_Turn>;
  /** Regenerate results of a query */
  regenerate_query_results?: Maybe<QuestionOutput>;
  /** execute VOLATILE function "register_whatsapp_ai_turn" which returns "whatsapp_ai_turn" */
  register_whatsapp_ai_turn: Array<Whatsapp_Ai_Turn>;
  /** execute VOLATILE function "renew_whatsapp_ai_turn_lease" which returns "whatsapp_ai_turn" */
  renew_whatsapp_ai_turn_lease: Array<Whatsapp_Ai_Turn>;
  resend_invitation?: Maybe<ResendInvitationOutput>;
  /** Action to send SMS verify code using twilio */
  send_verification_code?: Maybe<PhoneOutput>;
  translate_text?: Maybe<TranslateOutput>;
  /** update single row of the table: "auth.providers" */
  updateAuthProvider?: Maybe<AuthProviders>;
  /** update single row of the table: "auth.provider_requests" */
  updateAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** update data of the table: "auth.provider_requests" */
  updateAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** update data of the table: "auth.providers" */
  updateAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** update single row of the table: "auth.refresh_tokens" */
  updateAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** update single row of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** update data of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** update data of the table: "auth.refresh_tokens" */
  updateAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** update single row of the table: "auth.roles" */
  updateAuthRole?: Maybe<AuthRoles>;
  /** update data of the table: "auth.roles" */
  updateAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** update single row of the table: "auth.user_providers" */
  updateAuthUserProvider?: Maybe<AuthUserProviders>;
  /** update data of the table: "auth.user_providers" */
  updateAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** update single row of the table: "auth.user_roles" */
  updateAuthUserRole?: Maybe<AuthUserRoles>;
  /** update data of the table: "auth.user_roles" */
  updateAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** update single row of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** update data of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** update single row of the table: "storage.buckets" */
  updateBucket?: Maybe<Buckets>;
  /** update data of the table: "storage.buckets" */
  updateBuckets?: Maybe<Buckets_Mutation_Response>;
  /** update single row of the table: "storage.files" */
  updateFile?: Maybe<Files>;
  /** update data of the table: "storage.files" */
  updateFiles?: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "auth.users" */
  updateUser?: Maybe<Users>;
  /** update data of the table: "auth.users" */
  updateUsers?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "storage.virus" */
  updateVirus?: Maybe<Virus>;
  /** update data of the table: "storage.virus" */
  updateViruses?: Maybe<Virus_Mutation_Response>;
  /** update data of the table: "address_types" */
  update_address_types?: Maybe<Address_Types_Mutation_Response>;
  /** update single row of the table: "address_types" */
  update_address_types_by_pk?: Maybe<Address_Types>;
  /** update multiples rows of table: "address_types" */
  update_address_types_many?: Maybe<Array<Maybe<Address_Types_Mutation_Response>>>;
  /** update data of the table: "agency" */
  update_agency?: Maybe<Agency_Mutation_Response>;
  /** update single row of the table: "agency" */
  update_agency_by_pk?: Maybe<Agency>;
  /** update multiples rows of table: "agency" */
  update_agency_many?: Maybe<Array<Maybe<Agency_Mutation_Response>>>;
  /** update data of the table: "agency_type" */
  update_agency_type?: Maybe<Agency_Type_Mutation_Response>;
  /** update single row of the table: "agency_type" */
  update_agency_type_by_pk?: Maybe<Agency_Type>;
  /** update multiples rows of table: "agency_type" */
  update_agency_type_many?: Maybe<Array<Maybe<Agency_Type_Mutation_Response>>>;
  /** update data of the table: "agent_action" */
  update_agent_action?: Maybe<Agent_Action_Mutation_Response>;
  /** update single row of the table: "agent_action" */
  update_agent_action_by_pk?: Maybe<Agent_Action>;
  /** update multiples rows of table: "agent_action" */
  update_agent_action_many?: Maybe<Array<Maybe<Agent_Action_Mutation_Response>>>;
  /** update data of the table: "agent_task" */
  update_agent_task?: Maybe<Agent_Task_Mutation_Response>;
  /** update single row of the table: "agent_task" */
  update_agent_task_by_pk?: Maybe<Agent_Task>;
  /** update multiples rows of table: "agent_task" */
  update_agent_task_many?: Maybe<Array<Maybe<Agent_Task_Mutation_Response>>>;
  /** update data of the table: "amenities" */
  update_amenities?: Maybe<Amenities_Mutation_Response>;
  /** update single row of the table: "amenities" */
  update_amenities_by_pk?: Maybe<Amenities>;
  /** update multiples rows of table: "amenities" */
  update_amenities_many?: Maybe<Array<Maybe<Amenities_Mutation_Response>>>;
  /** update data of the table: "app_config" */
  update_app_config?: Maybe<App_Config_Mutation_Response>;
  /** update single row of the table: "app_config" */
  update_app_config_by_pk?: Maybe<App_Config>;
  /** update multiples rows of table: "app_config" */
  update_app_config_many?: Maybe<Array<Maybe<App_Config_Mutation_Response>>>;
  /** update multiples rows of table: "auth.provider_requests" */
  update_authProviderRequests_many?: Maybe<Array<Maybe<AuthProviderRequests_Mutation_Response>>>;
  /** update multiples rows of table: "auth.providers" */
  update_authProviders_many?: Maybe<Array<Maybe<AuthProviders_Mutation_Response>>>;
  /** update multiples rows of table: "auth.refresh_token_types" */
  update_authRefreshTokenTypes_many?: Maybe<Array<Maybe<AuthRefreshTokenTypes_Mutation_Response>>>;
  /** update multiples rows of table: "auth.refresh_tokens" */
  update_authRefreshTokens_many?: Maybe<Array<Maybe<AuthRefreshTokens_Mutation_Response>>>;
  /** update multiples rows of table: "auth.roles" */
  update_authRoles_many?: Maybe<Array<Maybe<AuthRoles_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_providers" */
  update_authUserProviders_many?: Maybe<Array<Maybe<AuthUserProviders_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_roles" */
  update_authUserRoles_many?: Maybe<Array<Maybe<AuthUserRoles_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_security_keys" */
  update_authUserSecurityKeys_many?: Maybe<Array<Maybe<AuthUserSecurityKeys_Mutation_Response>>>;
  /** update data of the table: "blog" */
  update_blog?: Maybe<Blog_Mutation_Response>;
  /** update single row of the table: "blog" */
  update_blog_by_pk?: Maybe<Blog>;
  /** update multiples rows of table: "blog" */
  update_blog_many?: Maybe<Array<Maybe<Blog_Mutation_Response>>>;
  /** update data of the table: "blog_post" */
  update_blog_post?: Maybe<Blog_Post_Mutation_Response>;
  /** update single row of the table: "blog_post" */
  update_blog_post_by_pk?: Maybe<Blog_Post>;
  /** update multiples rows of table: "blog_post" */
  update_blog_post_many?: Maybe<Array<Maybe<Blog_Post_Mutation_Response>>>;
  /** update data of the table: "blog_section" */
  update_blog_section?: Maybe<Blog_Section_Mutation_Response>;
  /** update single row of the table: "blog_section" */
  update_blog_section_by_pk?: Maybe<Blog_Section>;
  /** update multiples rows of table: "blog_section" */
  update_blog_section_many?: Maybe<Array<Maybe<Blog_Section_Mutation_Response>>>;
  /** update data of the table: "blog_status" */
  update_blog_status?: Maybe<Blog_Status_Mutation_Response>;
  /** update single row of the table: "blog_status" */
  update_blog_status_by_pk?: Maybe<Blog_Status>;
  /** update multiples rows of table: "blog_status" */
  update_blog_status_many?: Maybe<Array<Maybe<Blog_Status_Mutation_Response>>>;
  /** update multiples rows of table: "storage.buckets" */
  update_buckets_many?: Maybe<Array<Maybe<Buckets_Mutation_Response>>>;
  /** update data of the table: "builder" */
  update_builder?: Maybe<Builder_Mutation_Response>;
  /** update single row of the table: "builder" */
  update_builder_by_pk?: Maybe<Builder>;
  /** update multiples rows of table: "builder" */
  update_builder_many?: Maybe<Array<Maybe<Builder_Mutation_Response>>>;
  /** update data of the table: "certified_agent" */
  update_certified_agent?: Maybe<Certified_Agent_Mutation_Response>;
  /** update single row of the table: "certified_agent" */
  update_certified_agent_by_pk?: Maybe<Certified_Agent>;
  /** update multiples rows of table: "certified_agent" */
  update_certified_agent_many?: Maybe<Array<Maybe<Certified_Agent_Mutation_Response>>>;
  /** update data of the table: "chat_response_type" */
  update_chat_response_type?: Maybe<Chat_Response_Type_Mutation_Response>;
  /** update single row of the table: "chat_response_type" */
  update_chat_response_type_by_pk?: Maybe<Chat_Response_Type>;
  /** update multiples rows of table: "chat_response_type" */
  update_chat_response_type_many?: Maybe<Array<Maybe<Chat_Response_Type_Mutation_Response>>>;
  /** update data of the table: "city" */
  update_city?: Maybe<City_Mutation_Response>;
  /** update single row of the table: "city" */
  update_city_by_pk?: Maybe<City>;
  /** update multiples rows of table: "city" */
  update_city_many?: Maybe<Array<Maybe<City_Mutation_Response>>>;
  /** update data of the table: "city_zone" */
  update_city_zone?: Maybe<City_Zone_Mutation_Response>;
  /** update single row of the table: "city_zone" */
  update_city_zone_by_pk?: Maybe<City_Zone>;
  /** update multiples rows of table: "city_zone" */
  update_city_zone_many?: Maybe<Array<Maybe<City_Zone_Mutation_Response>>>;
  /** update data of the table: "city_zone_origin" */
  update_city_zone_origin?: Maybe<City_Zone_Origin_Mutation_Response>;
  /** update single row of the table: "city_zone_origin" */
  update_city_zone_origin_by_pk?: Maybe<City_Zone_Origin>;
  /** update multiples rows of table: "city_zone_origin" */
  update_city_zone_origin_many?: Maybe<Array<Maybe<City_Zone_Origin_Mutation_Response>>>;
  /** update data of the table: "claim_request_status" */
  update_claim_request_status?: Maybe<Claim_Request_Status_Mutation_Response>;
  /** update single row of the table: "claim_request_status" */
  update_claim_request_status_by_pk?: Maybe<Claim_Request_Status>;
  /** update multiples rows of table: "claim_request_status" */
  update_claim_request_status_many?: Maybe<Array<Maybe<Claim_Request_Status_Mutation_Response>>>;
  /** update data of the table: "clering" */
  update_clering?: Maybe<Clering_Mutation_Response>;
  /** update single row of the table: "clering" */
  update_clering_by_pk?: Maybe<Clering>;
  /** update multiples rows of table: "clering" */
  update_clering_many?: Maybe<Array<Maybe<Clering_Mutation_Response>>>;
  /** update data of the table: "construction_status" */
  update_construction_status?: Maybe<Construction_Status_Mutation_Response>;
  /** update single row of the table: "construction_status" */
  update_construction_status_by_pk?: Maybe<Construction_Status>;
  /** update multiples rows of table: "construction_status" */
  update_construction_status_many?: Maybe<Array<Maybe<Construction_Status_Mutation_Response>>>;
  /** update data of the table: "contact" */
  update_contact?: Maybe<Contact_Mutation_Response>;
  /** update single row of the table: "contact" */
  update_contact_by_pk?: Maybe<Contact>;
  /** update multiples rows of table: "contact" */
  update_contact_many?: Maybe<Array<Maybe<Contact_Mutation_Response>>>;
  /** update data of the table: "contact_phone_number" */
  update_contact_phone_number?: Maybe<Contact_Phone_Number_Mutation_Response>;
  /** update single row of the table: "contact_phone_number" */
  update_contact_phone_number_by_pk?: Maybe<Contact_Phone_Number>;
  /** update multiples rows of table: "contact_phone_number" */
  update_contact_phone_number_many?: Maybe<Array<Maybe<Contact_Phone_Number_Mutation_Response>>>;
  /** update data of the table: "contact_type" */
  update_contact_type?: Maybe<Contact_Type_Mutation_Response>;
  /** update single row of the table: "contact_type" */
  update_contact_type_by_pk?: Maybe<Contact_Type>;
  /** update multiples rows of table: "contact_type" */
  update_contact_type_many?: Maybe<Array<Maybe<Contact_Type_Mutation_Response>>>;
  /** update data of the table: "content_type" */
  update_content_type?: Maybe<Content_Type_Mutation_Response>;
  /** update single row of the table: "content_type" */
  update_content_type_by_pk?: Maybe<Content_Type>;
  /** update multiples rows of table: "content_type" */
  update_content_type_many?: Maybe<Array<Maybe<Content_Type_Mutation_Response>>>;
  /** update data of the table: "countries" */
  update_countries?: Maybe<Countries_Mutation_Response>;
  /** update single row of the table: "countries" */
  update_countries_by_pk?: Maybe<Countries>;
  /** update multiples rows of table: "countries" */
  update_countries_many?: Maybe<Array<Maybe<Countries_Mutation_Response>>>;
  /** update data of the table: "country" */
  update_country?: Maybe<Country_Mutation_Response>;
  /** update single row of the table: "country" */
  update_country_by_pk?: Maybe<Country>;
  /** update multiples rows of table: "country" */
  update_country_many?: Maybe<Array<Maybe<Country_Mutation_Response>>>;
  /** update data of the table: "currency" */
  update_currency?: Maybe<Currency_Mutation_Response>;
  /** update single row of the table: "currency" */
  update_currency_by_pk?: Maybe<Currency>;
  /** update data of the table: "currency_exchange_rates" */
  update_currency_exchange_rates?: Maybe<Currency_Exchange_Rates_Mutation_Response>;
  /** update single row of the table: "currency_exchange_rates" */
  update_currency_exchange_rates_by_pk?: Maybe<Currency_Exchange_Rates>;
  /** update multiples rows of table: "currency_exchange_rates" */
  update_currency_exchange_rates_many?: Maybe<Array<Maybe<Currency_Exchange_Rates_Mutation_Response>>>;
  /** update multiples rows of table: "currency" */
  update_currency_many?: Maybe<Array<Maybe<Currency_Mutation_Response>>>;
  /** update data of the table: "entities" */
  update_entities?: Maybe<Entities_Mutation_Response>;
  /** update single row of the table: "entities" */
  update_entities_by_pk?: Maybe<Entities>;
  /** update multiples rows of table: "entities" */
  update_entities_many?: Maybe<Array<Maybe<Entities_Mutation_Response>>>;
  /** update data of the table: "exchange_rates" */
  update_exchange_rates?: Maybe<Exchange_Rates_Mutation_Response>;
  /** update single row of the table: "exchange_rates" */
  update_exchange_rates_by_pk?: Maybe<Exchange_Rates>;
  /** update multiples rows of table: "exchange_rates" */
  update_exchange_rates_many?: Maybe<Array<Maybe<Exchange_Rates_Mutation_Response>>>;
  /** update data of the table: "feature" */
  update_feature?: Maybe<Feature_Mutation_Response>;
  /** update single row of the table: "feature" */
  update_feature_by_pk?: Maybe<Feature>;
  /** update multiples rows of table: "feature" */
  update_feature_many?: Maybe<Array<Maybe<Feature_Mutation_Response>>>;
  /** update data of the table: "feature_type" */
  update_feature_type?: Maybe<Feature_Type_Mutation_Response>;
  /** update single row of the table: "feature_type" */
  update_feature_type_by_pk?: Maybe<Feature_Type>;
  /** update multiples rows of table: "feature_type" */
  update_feature_type_many?: Maybe<Array<Maybe<Feature_Type_Mutation_Response>>>;
  /** update data of the table: "file_type" */
  update_file_type?: Maybe<File_Type_Mutation_Response>;
  /** update single row of the table: "file_type" */
  update_file_type_by_pk?: Maybe<File_Type>;
  /** update multiples rows of table: "file_type" */
  update_file_type_many?: Maybe<Array<Maybe<File_Type_Mutation_Response>>>;
  /** update multiples rows of table: "storage.files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "folder_amenities" */
  update_folder_amenities?: Maybe<Folder_Amenities_Mutation_Response>;
  /** update single row of the table: "folder_amenities" */
  update_folder_amenities_by_pk?: Maybe<Folder_Amenities>;
  /** update multiples rows of table: "folder_amenities" */
  update_folder_amenities_many?: Maybe<Array<Maybe<Folder_Amenities_Mutation_Response>>>;
  /** update data of the table: "folder_image" */
  update_folder_image?: Maybe<Folder_Image_Mutation_Response>;
  /** update single row of the table: "folder_image" */
  update_folder_image_by_pk?: Maybe<Folder_Image>;
  /** update multiples rows of table: "folder_image" */
  update_folder_image_many?: Maybe<Array<Maybe<Folder_Image_Mutation_Response>>>;
  /** update data of the table: "folder_properties_type" */
  update_folder_properties_type?: Maybe<Folder_Properties_Type_Mutation_Response>;
  /** update single row of the table: "folder_properties_type" */
  update_folder_properties_type_by_pk?: Maybe<Folder_Properties_Type>;
  /** update multiples rows of table: "folder_properties_type" */
  update_folder_properties_type_many?: Maybe<Array<Maybe<Folder_Properties_Type_Mutation_Response>>>;
  /** update data of the table: "folder_status" */
  update_folder_status?: Maybe<Folder_Status_Mutation_Response>;
  /** update single row of the table: "folder_status" */
  update_folder_status_by_pk?: Maybe<Folder_Status>;
  /** update multiples rows of table: "folder_status" */
  update_folder_status_many?: Maybe<Array<Maybe<Folder_Status_Mutation_Response>>>;
  /** update data of the table: "folder_type" */
  update_folder_type?: Maybe<Folder_Type_Mutation_Response>;
  /** update single row of the table: "folder_type" */
  update_folder_type_by_pk?: Maybe<Folder_Type>;
  /** update multiples rows of table: "folder_type" */
  update_folder_type_many?: Maybe<Array<Maybe<Folder_Type_Mutation_Response>>>;
  /** update data of the table: "furnishing_status" */
  update_furnishing_status?: Maybe<Furnishing_Status_Mutation_Response>;
  /** update single row of the table: "furnishing_status" */
  update_furnishing_status_by_pk?: Maybe<Furnishing_Status>;
  /** update multiples rows of table: "furnishing_status" */
  update_furnishing_status_many?: Maybe<Array<Maybe<Furnishing_Status_Mutation_Response>>>;
  /** update data of the table: "google_calendar" */
  update_google_calendar?: Maybe<Google_Calendar_Mutation_Response>;
  /** update single row of the table: "google_calendar" */
  update_google_calendar_by_pk?: Maybe<Google_Calendar>;
  /** update multiples rows of table: "google_calendar" */
  update_google_calendar_many?: Maybe<Array<Maybe<Google_Calendar_Mutation_Response>>>;
  /** update data of the table: "heatingType" */
  update_heatingType?: Maybe<HeatingType_Mutation_Response>;
  /** update single row of the table: "heatingType" */
  update_heatingType_by_pk?: Maybe<HeatingType>;
  /** update multiples rows of table: "heatingType" */
  update_heatingType_many?: Maybe<Array<Maybe<HeatingType_Mutation_Response>>>;
  /** update data of the table: "image" */
  update_image?: Maybe<Image_Mutation_Response>;
  /** update single row of the table: "image" */
  update_image_by_pk?: Maybe<Image>;
  /** update multiples rows of table: "image" */
  update_image_many?: Maybe<Array<Maybe<Image_Mutation_Response>>>;
  /** update data of the table: "invoice_status" */
  update_invoice_status?: Maybe<Invoice_Status_Mutation_Response>;
  /** update single row of the table: "invoice_status" */
  update_invoice_status_by_pk?: Maybe<Invoice_Status>;
  /** update multiples rows of table: "invoice_status" */
  update_invoice_status_many?: Maybe<Array<Maybe<Invoice_Status_Mutation_Response>>>;
  /** update data of the table: "languages" */
  update_languages?: Maybe<Languages_Mutation_Response>;
  /** update single row of the table: "languages" */
  update_languages_by_pk?: Maybe<Languages>;
  /** update multiples rows of table: "languages" */
  update_languages_many?: Maybe<Array<Maybe<Languages_Mutation_Response>>>;
  /** update data of the table: "lead_property_category" */
  update_lead_property_category?: Maybe<Lead_Property_Category_Mutation_Response>;
  /** update single row of the table: "lead_property_category" */
  update_lead_property_category_by_pk?: Maybe<Lead_Property_Category>;
  /** update multiples rows of table: "lead_property_category" */
  update_lead_property_category_many?: Maybe<Array<Maybe<Lead_Property_Category_Mutation_Response>>>;
  /** update data of the table: "lead_status" */
  update_lead_status?: Maybe<Lead_Status_Mutation_Response>;
  /** update single row of the table: "lead_status" */
  update_lead_status_by_pk?: Maybe<Lead_Status>;
  /** update multiples rows of table: "lead_status" */
  update_lead_status_many?: Maybe<Array<Maybe<Lead_Status_Mutation_Response>>>;
  /** update data of the table: "lead_type" */
  update_lead_type?: Maybe<Lead_Type_Mutation_Response>;
  /** update single row of the table: "lead_type" */
  update_lead_type_by_pk?: Maybe<Lead_Type>;
  /** update multiples rows of table: "lead_type" */
  update_lead_type_many?: Maybe<Array<Maybe<Lead_Type_Mutation_Response>>>;
  /** update data of the table: "lister_claim_request" */
  update_lister_claim_request?: Maybe<Lister_Claim_Request_Mutation_Response>;
  /** update data of the table: "lister_claim_request_activity" */
  update_lister_claim_request_activity?: Maybe<Lister_Claim_Request_Activity_Mutation_Response>;
  /** update single row of the table: "lister_claim_request_activity" */
  update_lister_claim_request_activity_by_pk?: Maybe<Lister_Claim_Request_Activity>;
  /** update multiples rows of table: "lister_claim_request_activity" */
  update_lister_claim_request_activity_many?: Maybe<Array<Maybe<Lister_Claim_Request_Activity_Mutation_Response>>>;
  /** update single row of the table: "lister_claim_request" */
  update_lister_claim_request_by_pk?: Maybe<Lister_Claim_Request>;
  /** update multiples rows of table: "lister_claim_request" */
  update_lister_claim_request_many?: Maybe<Array<Maybe<Lister_Claim_Request_Mutation_Response>>>;
  /** update data of the table: "lister_contact" */
  update_lister_contact?: Maybe<Lister_Contact_Mutation_Response>;
  /** update single row of the table: "lister_contact" */
  update_lister_contact_by_pk?: Maybe<Lister_Contact>;
  /** update multiples rows of table: "lister_contact" */
  update_lister_contact_many?: Maybe<Array<Maybe<Lister_Contact_Mutation_Response>>>;
  /** update data of the table: "lister_contact_meeting" */
  update_lister_contact_meeting?: Maybe<Lister_Contact_Meeting_Mutation_Response>;
  /** update single row of the table: "lister_contact_meeting" */
  update_lister_contact_meeting_by_pk?: Maybe<Lister_Contact_Meeting>;
  /** update multiples rows of table: "lister_contact_meeting" */
  update_lister_contact_meeting_many?: Maybe<Array<Maybe<Lister_Contact_Meeting_Mutation_Response>>>;
  /** update data of the table: "lister_contact_source" */
  update_lister_contact_source?: Maybe<Lister_Contact_Source_Mutation_Response>;
  /** update single row of the table: "lister_contact_source" */
  update_lister_contact_source_by_pk?: Maybe<Lister_Contact_Source>;
  /** update multiples rows of table: "lister_contact_source" */
  update_lister_contact_source_many?: Maybe<Array<Maybe<Lister_Contact_Source_Mutation_Response>>>;
  /** update data of the table: "lister_leads" */
  update_lister_leads?: Maybe<Lister_Leads_Mutation_Response>;
  /** update single row of the table: "lister_leads" */
  update_lister_leads_by_pk?: Maybe<Lister_Leads>;
  /** update multiples rows of table: "lister_leads" */
  update_lister_leads_many?: Maybe<Array<Maybe<Lister_Leads_Mutation_Response>>>;
  /** update data of the table: "lister_meeting" */
  update_lister_meeting?: Maybe<Lister_Meeting_Mutation_Response>;
  /** update single row of the table: "lister_meeting" */
  update_lister_meeting_by_pk?: Maybe<Lister_Meeting>;
  /** update multiples rows of table: "lister_meeting" */
  update_lister_meeting_many?: Maybe<Array<Maybe<Lister_Meeting_Mutation_Response>>>;
  /** update data of the table: "lister_role" */
  update_lister_role?: Maybe<Lister_Role_Mutation_Response>;
  /** update single row of the table: "lister_role" */
  update_lister_role_by_pk?: Maybe<Lister_Role>;
  /** update multiples rows of table: "lister_role" */
  update_lister_role_many?: Maybe<Array<Maybe<Lister_Role_Mutation_Response>>>;
  /** update data of the table: "location" */
  update_location?: Maybe<Location_Mutation_Response>;
  /** update single row of the table: "location" */
  update_location_by_pk?: Maybe<Location>;
  /** update multiples rows of table: "location" */
  update_location_many?: Maybe<Array<Maybe<Location_Mutation_Response>>>;
  /** update data of the table: "location_type" */
  update_location_type?: Maybe<Location_Type_Mutation_Response>;
  /** update single row of the table: "location_type" */
  update_location_type_by_pk?: Maybe<Location_Type>;
  /** update multiples rows of table: "location_type" */
  update_location_type_many?: Maybe<Array<Maybe<Location_Type_Mutation_Response>>>;
  /** update data of the table: "main_currency" */
  update_main_currency?: Maybe<Main_Currency_Mutation_Response>;
  /** update single row of the table: "main_currency" */
  update_main_currency_by_pk?: Maybe<Main_Currency>;
  /** update multiples rows of table: "main_currency" */
  update_main_currency_many?: Maybe<Array<Maybe<Main_Currency_Mutation_Response>>>;
  /** update data of the table: "natural_language_queries" */
  update_natural_language_queries?: Maybe<Natural_Language_Queries_Mutation_Response>;
  /** update single row of the table: "natural_language_queries" */
  update_natural_language_queries_by_pk?: Maybe<Natural_Language_Queries>;
  /** update multiples rows of table: "natural_language_queries" */
  update_natural_language_queries_many?: Maybe<Array<Maybe<Natural_Language_Queries_Mutation_Response>>>;
  /** update data of the table: "notification" */
  update_notification?: Maybe<Notification_Mutation_Response>;
  /** update data of the table: "notification_amenities" */
  update_notification_amenities?: Maybe<Notification_Amenities_Mutation_Response>;
  /** update single row of the table: "notification_amenities" */
  update_notification_amenities_by_pk?: Maybe<Notification_Amenities>;
  /** update multiples rows of table: "notification_amenities" */
  update_notification_amenities_many?: Maybe<Array<Maybe<Notification_Amenities_Mutation_Response>>>;
  /** update single row of the table: "notification" */
  update_notification_by_pk?: Maybe<Notification>;
  /** update data of the table: "notification_feature" */
  update_notification_feature?: Maybe<Notification_Feature_Mutation_Response>;
  /** update single row of the table: "notification_feature" */
  update_notification_feature_by_pk?: Maybe<Notification_Feature>;
  /** update multiples rows of table: "notification_feature" */
  update_notification_feature_many?: Maybe<Array<Maybe<Notification_Feature_Mutation_Response>>>;
  /** update multiples rows of table: "notification" */
  update_notification_many?: Maybe<Array<Maybe<Notification_Mutation_Response>>>;
  /** update data of the table: "notification_property_type" */
  update_notification_property_type?: Maybe<Notification_Property_Type_Mutation_Response>;
  /** update single row of the table: "notification_property_type" */
  update_notification_property_type_by_pk?: Maybe<Notification_Property_Type>;
  /** update multiples rows of table: "notification_property_type" */
  update_notification_property_type_many?: Maybe<Array<Maybe<Notification_Property_Type_Mutation_Response>>>;
  /** update data of the table: "notification_type" */
  update_notification_type?: Maybe<Notification_Type_Mutation_Response>;
  /** update single row of the table: "notification_type" */
  update_notification_type_by_pk?: Maybe<Notification_Type>;
  /** update multiples rows of table: "notification_type" */
  update_notification_type_many?: Maybe<Array<Maybe<Notification_Type_Mutation_Response>>>;
  /** update data of the table: "order" */
  update_order?: Maybe<Order_Mutation_Response>;
  /** update single row of the table: "order" */
  update_order_by_pk?: Maybe<Order>;
  /** update multiples rows of table: "order" */
  update_order_many?: Maybe<Array<Maybe<Order_Mutation_Response>>>;
  /** update data of the table: "order_status" */
  update_order_status?: Maybe<Order_Status_Mutation_Response>;
  /** update single row of the table: "order_status" */
  update_order_status_by_pk?: Maybe<Order_Status>;
  /** update multiples rows of table: "order_status" */
  update_order_status_many?: Maybe<Array<Maybe<Order_Status_Mutation_Response>>>;
  /** update data of the table: "organization" */
  update_organization?: Maybe<Organization_Mutation_Response>;
  /** update single row of the table: "organization" */
  update_organization_by_pk?: Maybe<Organization>;
  /** update data of the table: "organization_lead_location" */
  update_organization_lead_location?: Maybe<Organization_Lead_Location_Mutation_Response>;
  /** update single row of the table: "organization_lead_location" */
  update_organization_lead_location_by_pk?: Maybe<Organization_Lead_Location>;
  /** update multiples rows of table: "organization_lead_location" */
  update_organization_lead_location_many?: Maybe<Array<Maybe<Organization_Lead_Location_Mutation_Response>>>;
  /** update data of the table: "organization_lead_property" */
  update_organization_lead_property?: Maybe<Organization_Lead_Property_Mutation_Response>;
  /** update single row of the table: "organization_lead_property" */
  update_organization_lead_property_by_pk?: Maybe<Organization_Lead_Property>;
  /** update multiples rows of table: "organization_lead_property" */
  update_organization_lead_property_many?: Maybe<Array<Maybe<Organization_Lead_Property_Mutation_Response>>>;
  /** update data of the table: "organization_leads" */
  update_organization_leads?: Maybe<Organization_Leads_Mutation_Response>;
  /** update single row of the table: "organization_leads" */
  update_organization_leads_by_pk?: Maybe<Organization_Leads>;
  /** update multiples rows of table: "organization_leads" */
  update_organization_leads_many?: Maybe<Array<Maybe<Organization_Leads_Mutation_Response>>>;
  /** update multiples rows of table: "organization" */
  update_organization_many?: Maybe<Array<Maybe<Organization_Mutation_Response>>>;
  /** update data of the table: "organization_role" */
  update_organization_role?: Maybe<Organization_Role_Mutation_Response>;
  /** update single row of the table: "organization_role" */
  update_organization_role_by_pk?: Maybe<Organization_Role>;
  /** update multiples rows of table: "organization_role" */
  update_organization_role_many?: Maybe<Array<Maybe<Organization_Role_Mutation_Response>>>;
  /** update data of the table: "organization_status" */
  update_organization_status?: Maybe<Organization_Status_Mutation_Response>;
  /** update single row of the table: "organization_status" */
  update_organization_status_by_pk?: Maybe<Organization_Status>;
  /** update multiples rows of table: "organization_status" */
  update_organization_status_many?: Maybe<Array<Maybe<Organization_Status_Mutation_Response>>>;
  /** update data of the table: "organization_telegram_agent_link" */
  update_organization_telegram_agent_link?: Maybe<Organization_Telegram_Agent_Link_Mutation_Response>;
  /** update single row of the table: "organization_telegram_agent_link" */
  update_organization_telegram_agent_link_by_pk?: Maybe<Organization_Telegram_Agent_Link>;
  /** update multiples rows of table: "organization_telegram_agent_link" */
  update_organization_telegram_agent_link_many?: Maybe<Array<Maybe<Organization_Telegram_Agent_Link_Mutation_Response>>>;
  /** update data of the table: "organization_type" */
  update_organization_type?: Maybe<Organization_Type_Mutation_Response>;
  /** update single row of the table: "organization_type" */
  update_organization_type_by_pk?: Maybe<Organization_Type>;
  /** update multiples rows of table: "organization_type" */
  update_organization_type_many?: Maybe<Array<Maybe<Organization_Type_Mutation_Response>>>;
  /** update data of the table: "organization_whatsapp_ai_allowlist" */
  update_organization_whatsapp_ai_allowlist?: Maybe<Organization_Whatsapp_Ai_Allowlist_Mutation_Response>;
  /** update single row of the table: "organization_whatsapp_ai_allowlist" */
  update_organization_whatsapp_ai_allowlist_by_pk?: Maybe<Organization_Whatsapp_Ai_Allowlist>;
  /** update multiples rows of table: "organization_whatsapp_ai_allowlist" */
  update_organization_whatsapp_ai_allowlist_many?: Maybe<Array<Maybe<Organization_Whatsapp_Ai_Allowlist_Mutation_Response>>>;
  /** update data of the table: "organization_whatsapp_ai_config" */
  update_organization_whatsapp_ai_config?: Maybe<Organization_Whatsapp_Ai_Config_Mutation_Response>;
  /** update single row of the table: "organization_whatsapp_ai_config" */
  update_organization_whatsapp_ai_config_by_pk?: Maybe<Organization_Whatsapp_Ai_Config>;
  /** update multiples rows of table: "organization_whatsapp_ai_config" */
  update_organization_whatsapp_ai_config_many?: Maybe<Array<Maybe<Organization_Whatsapp_Ai_Config_Mutation_Response>>>;
  /** update data of the table: "parking_type" */
  update_parking_type?: Maybe<Parking_Type_Mutation_Response>;
  /** update single row of the table: "parking_type" */
  update_parking_type_by_pk?: Maybe<Parking_Type>;
  /** update multiples rows of table: "parking_type" */
  update_parking_type_many?: Maybe<Array<Maybe<Parking_Type_Mutation_Response>>>;
  /** update data of the table: "phone_number_type" */
  update_phone_number_type?: Maybe<Phone_Number_Type_Mutation_Response>;
  /** update single row of the table: "phone_number_type" */
  update_phone_number_type_by_pk?: Maybe<Phone_Number_Type>;
  /** update multiples rows of table: "phone_number_type" */
  update_phone_number_type_many?: Maybe<Array<Maybe<Phone_Number_Type_Mutation_Response>>>;
  /** update data of the table: "place_reference" */
  update_place_reference?: Maybe<Place_Reference_Mutation_Response>;
  /** update data of the table: "place_reference_alias" */
  update_place_reference_alias?: Maybe<Place_Reference_Alias_Mutation_Response>;
  /** update single row of the table: "place_reference_alias" */
  update_place_reference_alias_by_pk?: Maybe<Place_Reference_Alias>;
  /** update multiples rows of table: "place_reference_alias" */
  update_place_reference_alias_many?: Maybe<Array<Maybe<Place_Reference_Alias_Mutation_Response>>>;
  /** update single row of the table: "place_reference" */
  update_place_reference_by_pk?: Maybe<Place_Reference>;
  /** update multiples rows of table: "place_reference" */
  update_place_reference_many?: Maybe<Array<Maybe<Place_Reference_Mutation_Response>>>;
  /** update data of the table: "place_reference_proposal" */
  update_place_reference_proposal?: Maybe<Place_Reference_Proposal_Mutation_Response>;
  /** update single row of the table: "place_reference_proposal" */
  update_place_reference_proposal_by_pk?: Maybe<Place_Reference_Proposal>;
  /** update multiples rows of table: "place_reference_proposal" */
  update_place_reference_proposal_many?: Maybe<Array<Maybe<Place_Reference_Proposal_Mutation_Response>>>;
  /** update data of the table: "plan" */
  update_plan?: Maybe<Plan_Mutation_Response>;
  /** update single row of the table: "plan" */
  update_plan_by_pk?: Maybe<Plan>;
  /** update multiples rows of table: "plan" */
  update_plan_many?: Maybe<Array<Maybe<Plan_Mutation_Response>>>;
  /** update data of the table: "plan_type" */
  update_plan_type?: Maybe<Plan_Type_Mutation_Response>;
  /** update single row of the table: "plan_type" */
  update_plan_type_by_pk?: Maybe<Plan_Type>;
  /** update multiples rows of table: "plan_type" */
  update_plan_type_many?: Maybe<Array<Maybe<Plan_Type_Mutation_Response>>>;
  /** update data of the table: "product" */
  update_product?: Maybe<Product_Mutation_Response>;
  /** update single row of the table: "product" */
  update_product_by_pk?: Maybe<Product>;
  /** update multiples rows of table: "product" */
  update_product_many?: Maybe<Array<Maybe<Product_Mutation_Response>>>;
  /** update data of the table: "product_purchase" */
  update_product_purchase?: Maybe<Product_Purchase_Mutation_Response>;
  /** update single row of the table: "product_purchase" */
  update_product_purchase_by_pk?: Maybe<Product_Purchase>;
  /** update multiples rows of table: "product_purchase" */
  update_product_purchase_many?: Maybe<Array<Maybe<Product_Purchase_Mutation_Response>>>;
  /** update data of the table: "product_type" */
  update_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** update single row of the table: "product_type" */
  update_product_type_by_pk?: Maybe<Product_Type>;
  /** update multiples rows of table: "product_type" */
  update_product_type_many?: Maybe<Array<Maybe<Product_Type_Mutation_Response>>>;
  /** update data of the table: "property" */
  update_property?: Maybe<Property_Mutation_Response>;
  /** update single row of the table: "property" */
  update_property_by_pk?: Maybe<Property>;
  /** update data of the table: "property_cluster" */
  update_property_cluster?: Maybe<Property_Cluster_Mutation_Response>;
  /** update single row of the table: "property_cluster" */
  update_property_cluster_by_pk?: Maybe<Property_Cluster>;
  /** update multiples rows of table: "property_cluster" */
  update_property_cluster_many?: Maybe<Array<Maybe<Property_Cluster_Mutation_Response>>>;
  /** update data of the table: "property_composition" */
  update_property_composition?: Maybe<Property_Composition_Mutation_Response>;
  /** update single row of the table: "property_composition" */
  update_property_composition_by_pk?: Maybe<Property_Composition>;
  /** update multiples rows of table: "property_composition" */
  update_property_composition_many?: Maybe<Array<Maybe<Property_Composition_Mutation_Response>>>;
  /** update data of the table: "property_feature" */
  update_property_feature?: Maybe<Property_Feature_Mutation_Response>;
  /** update single row of the table: "property_feature" */
  update_property_feature_by_pk?: Maybe<Property_Feature>;
  /** update multiples rows of table: "property_feature" */
  update_property_feature_many?: Maybe<Array<Maybe<Property_Feature_Mutation_Response>>>;
  /** update data of the table: "property_folder" */
  update_property_folder?: Maybe<Property_Folder_Mutation_Response>;
  /** update single row of the table: "property_folder" */
  update_property_folder_by_pk?: Maybe<Property_Folder>;
  /** update multiples rows of table: "property_folder" */
  update_property_folder_many?: Maybe<Array<Maybe<Property_Folder_Mutation_Response>>>;
  /** update data of the table: "property_folder_public_profile" */
  update_property_folder_public_profile?: Maybe<Property_Folder_Public_Profile_Mutation_Response>;
  /** update single row of the table: "property_folder_public_profile" */
  update_property_folder_public_profile_by_pk?: Maybe<Property_Folder_Public_Profile>;
  /** update data of the table: "property_folder_public_profile_faq" */
  update_property_folder_public_profile_faq?: Maybe<Property_Folder_Public_Profile_Faq_Mutation_Response>;
  /** update single row of the table: "property_folder_public_profile_faq" */
  update_property_folder_public_profile_faq_by_pk?: Maybe<Property_Folder_Public_Profile_Faq>;
  /** update multiples rows of table: "property_folder_public_profile_faq" */
  update_property_folder_public_profile_faq_many?: Maybe<Array<Maybe<Property_Folder_Public_Profile_Faq_Mutation_Response>>>;
  /** update data of the table: "property_folder_public_profile_highlight" */
  update_property_folder_public_profile_highlight?: Maybe<Property_Folder_Public_Profile_Highlight_Mutation_Response>;
  /** update single row of the table: "property_folder_public_profile_highlight" */
  update_property_folder_public_profile_highlight_by_pk?: Maybe<Property_Folder_Public_Profile_Highlight>;
  /** update multiples rows of table: "property_folder_public_profile_highlight" */
  update_property_folder_public_profile_highlight_many?: Maybe<Array<Maybe<Property_Folder_Public_Profile_Highlight_Mutation_Response>>>;
  /** update data of the table: "property_folder_public_profile_listing_example" */
  update_property_folder_public_profile_listing_example?: Maybe<Property_Folder_Public_Profile_Listing_Example_Mutation_Response>;
  /** update single row of the table: "property_folder_public_profile_listing_example" */
  update_property_folder_public_profile_listing_example_by_pk?: Maybe<Property_Folder_Public_Profile_Listing_Example>;
  /** update multiples rows of table: "property_folder_public_profile_listing_example" */
  update_property_folder_public_profile_listing_example_many?: Maybe<Array<Maybe<Property_Folder_Public_Profile_Listing_Example_Mutation_Response>>>;
  /** update multiples rows of table: "property_folder_public_profile" */
  update_property_folder_public_profile_many?: Maybe<Array<Maybe<Property_Folder_Public_Profile_Mutation_Response>>>;
  /** update data of the table: "property_folder_public_profile_nearby_place" */
  update_property_folder_public_profile_nearby_place?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Mutation_Response>;
  /** update single row of the table: "property_folder_public_profile_nearby_place" */
  update_property_folder_public_profile_nearby_place_by_pk?: Maybe<Property_Folder_Public_Profile_Nearby_Place>;
  /** update multiples rows of table: "property_folder_public_profile_nearby_place" */
  update_property_folder_public_profile_nearby_place_many?: Maybe<Array<Maybe<Property_Folder_Public_Profile_Nearby_Place_Mutation_Response>>>;
  /** update data of the table: "property_folder_public_profile_related" */
  update_property_folder_public_profile_related?: Maybe<Property_Folder_Public_Profile_Related_Mutation_Response>;
  /** update single row of the table: "property_folder_public_profile_related" */
  update_property_folder_public_profile_related_by_pk?: Maybe<Property_Folder_Public_Profile_Related>;
  /** update multiples rows of table: "property_folder_public_profile_related" */
  update_property_folder_public_profile_related_many?: Maybe<Array<Maybe<Property_Folder_Public_Profile_Related_Mutation_Response>>>;
  /** update data of the table: "property_folder_public_profile_translation" */
  update_property_folder_public_profile_translation?: Maybe<Property_Folder_Public_Profile_Translation_Mutation_Response>;
  /** update single row of the table: "property_folder_public_profile_translation" */
  update_property_folder_public_profile_translation_by_pk?: Maybe<Property_Folder_Public_Profile_Translation>;
  /** update multiples rows of table: "property_folder_public_profile_translation" */
  update_property_folder_public_profile_translation_many?: Maybe<Array<Maybe<Property_Folder_Public_Profile_Translation_Mutation_Response>>>;
  /** update data of the table: "property_image" */
  update_property_image?: Maybe<Property_Image_Mutation_Response>;
  /** update single row of the table: "property_image" */
  update_property_image_by_pk?: Maybe<Property_Image>;
  /** update multiples rows of table: "property_image" */
  update_property_image_many?: Maybe<Array<Maybe<Property_Image_Mutation_Response>>>;
  /** update data of the table: "property_list" */
  update_property_list?: Maybe<Property_List_Mutation_Response>;
  /** update data of the table: "property_list_activity" */
  update_property_list_activity?: Maybe<Property_List_Activity_Mutation_Response>;
  /** update single row of the table: "property_list_activity" */
  update_property_list_activity_by_pk?: Maybe<Property_List_Activity>;
  /** update multiples rows of table: "property_list_activity" */
  update_property_list_activity_many?: Maybe<Array<Maybe<Property_List_Activity_Mutation_Response>>>;
  /** update single row of the table: "property_list" */
  update_property_list_by_pk?: Maybe<Property_List>;
  /** update data of the table: "property_list_folder" */
  update_property_list_folder?: Maybe<Property_List_Folder_Mutation_Response>;
  /** update single row of the table: "property_list_folder" */
  update_property_list_folder_by_pk?: Maybe<Property_List_Folder>;
  /** update multiples rows of table: "property_list_folder" */
  update_property_list_folder_many?: Maybe<Array<Maybe<Property_List_Folder_Mutation_Response>>>;
  /** update multiples rows of table: "property_list" */
  update_property_list_many?: Maybe<Array<Maybe<Property_List_Mutation_Response>>>;
  /** update data of the table: "property_list_report" */
  update_property_list_report?: Maybe<Property_List_Report_Mutation_Response>;
  /** update single row of the table: "property_list_report" */
  update_property_list_report_by_pk?: Maybe<Property_List_Report>;
  /** update multiples rows of table: "property_list_report" */
  update_property_list_report_many?: Maybe<Array<Maybe<Property_List_Report_Mutation_Response>>>;
  /** update multiples rows of table: "property" */
  update_property_many?: Maybe<Array<Maybe<Property_Mutation_Response>>>;
  /** update data of the table: "property_origin" */
  update_property_origin?: Maybe<Property_Origin_Mutation_Response>;
  /** update single row of the table: "property_origin" */
  update_property_origin_by_pk?: Maybe<Property_Origin>;
  /** update multiples rows of table: "property_origin" */
  update_property_origin_many?: Maybe<Array<Maybe<Property_Origin_Mutation_Response>>>;
  /** update data of the table: "property_origin_type" */
  update_property_origin_type?: Maybe<Property_Origin_Type_Mutation_Response>;
  /** update single row of the table: "property_origin_type" */
  update_property_origin_type_by_pk?: Maybe<Property_Origin_Type>;
  /** update multiples rows of table: "property_origin_type" */
  update_property_origin_type_many?: Maybe<Array<Maybe<Property_Origin_Type_Mutation_Response>>>;
  /** update data of the table: "property_owner" */
  update_property_owner?: Maybe<Property_Owner_Mutation_Response>;
  /** update single row of the table: "property_owner" */
  update_property_owner_by_pk?: Maybe<Property_Owner>;
  /** update multiples rows of table: "property_owner" */
  update_property_owner_many?: Maybe<Array<Maybe<Property_Owner_Mutation_Response>>>;
  /** update data of the table: "property_place_reference" */
  update_property_place_reference?: Maybe<Property_Place_Reference_Mutation_Response>;
  /** update single row of the table: "property_place_reference" */
  update_property_place_reference_by_pk?: Maybe<Property_Place_Reference>;
  /** update multiples rows of table: "property_place_reference" */
  update_property_place_reference_many?: Maybe<Array<Maybe<Property_Place_Reference_Mutation_Response>>>;
  /** update data of the table: "property_price_history" */
  update_property_price_history?: Maybe<Property_Price_History_Mutation_Response>;
  /** update single row of the table: "property_price_history" */
  update_property_price_history_by_pk?: Maybe<Property_Price_History>;
  /** update multiples rows of table: "property_price_history" */
  update_property_price_history_many?: Maybe<Array<Maybe<Property_Price_History_Mutation_Response>>>;
  /** update data of the table: "property_report_type" */
  update_property_report_type?: Maybe<Property_Report_Type_Mutation_Response>;
  /** update single row of the table: "property_report_type" */
  update_property_report_type_by_pk?: Maybe<Property_Report_Type>;
  /** update multiples rows of table: "property_report_type" */
  update_property_report_type_many?: Maybe<Array<Maybe<Property_Report_Type_Mutation_Response>>>;
  /** update data of the table: "property_source" */
  update_property_source?: Maybe<Property_Source_Mutation_Response>;
  /** update single row of the table: "property_source" */
  update_property_source_by_pk?: Maybe<Property_Source>;
  /** update multiples rows of table: "property_source" */
  update_property_source_many?: Maybe<Array<Maybe<Property_Source_Mutation_Response>>>;
  /** update data of the table: "property_status" */
  update_property_status?: Maybe<Property_Status_Mutation_Response>;
  /** update single row of the table: "property_status" */
  update_property_status_by_pk?: Maybe<Property_Status>;
  /** update multiples rows of table: "property_status" */
  update_property_status_many?: Maybe<Array<Maybe<Property_Status_Mutation_Response>>>;
  /** update data of the table: "property_type" */
  update_property_type?: Maybe<Property_Type_Mutation_Response>;
  /** update single row of the table: "property_type" */
  update_property_type_by_pk?: Maybe<Property_Type>;
  /** update multiples rows of table: "property_type" */
  update_property_type_many?: Maybe<Array<Maybe<Property_Type_Mutation_Response>>>;
  /** update data of the table: "property_views" */
  update_property_views?: Maybe<Property_Views_Mutation_Response>;
  /** update single row of the table: "property_views" */
  update_property_views_by_pk?: Maybe<Property_Views>;
  /** update multiples rows of table: "property_views" */
  update_property_views_many?: Maybe<Array<Maybe<Property_Views_Mutation_Response>>>;
  update_property_visibility?: Maybe<PropertyVisibilityActionOutput>;
  /** update data of the table: "queries_property_result" */
  update_queries_property_result?: Maybe<Queries_Property_Result_Mutation_Response>;
  /** update single row of the table: "queries_property_result" */
  update_queries_property_result_by_pk?: Maybe<Queries_Property_Result>;
  /** update multiples rows of table: "queries_property_result" */
  update_queries_property_result_many?: Maybe<Array<Maybe<Queries_Property_Result_Mutation_Response>>>;
  /** update data of the table: "queries_property_result_re" */
  update_queries_property_result_re?: Maybe<Queries_Property_Result_Re_Mutation_Response>;
  /** update single row of the table: "queries_property_result_re" */
  update_queries_property_result_re_by_pk?: Maybe<Queries_Property_Result_Re>;
  /** update multiples rows of table: "queries_property_result_re" */
  update_queries_property_result_re_many?: Maybe<Array<Maybe<Queries_Property_Result_Re_Mutation_Response>>>;
  /** update data of the table: "query_classification" */
  update_query_classification?: Maybe<Query_Classification_Mutation_Response>;
  /** update single row of the table: "query_classification" */
  update_query_classification_by_pk?: Maybe<Query_Classification>;
  /** update multiples rows of table: "query_classification" */
  update_query_classification_many?: Maybe<Array<Maybe<Query_Classification_Mutation_Response>>>;
  /** update data of the table: "query_classification_re" */
  update_query_classification_re?: Maybe<Query_Classification_Re_Mutation_Response>;
  /** update single row of the table: "query_classification_re" */
  update_query_classification_re_by_pk?: Maybe<Query_Classification_Re>;
  /** update multiples rows of table: "query_classification_re" */
  update_query_classification_re_many?: Maybe<Array<Maybe<Query_Classification_Re_Mutation_Response>>>;
  /** update data of the table: "raw_location" */
  update_raw_location?: Maybe<Raw_Location_Mutation_Response>;
  /** update single row of the table: "raw_location" */
  update_raw_location_by_pk?: Maybe<Raw_Location>;
  /** update multiples rows of table: "raw_location" */
  update_raw_location_many?: Maybe<Array<Maybe<Raw_Location_Mutation_Response>>>;
  /** update data of the table: "redirect" */
  update_redirect?: Maybe<Redirect_Mutation_Response>;
  /** update single row of the table: "redirect" */
  update_redirect_by_pk?: Maybe<Redirect>;
  /** update multiples rows of table: "redirect" */
  update_redirect_many?: Maybe<Array<Maybe<Redirect_Mutation_Response>>>;
  /** update data of the table: "reference_price_history" */
  update_reference_price_history?: Maybe<Reference_Price_History_Mutation_Response>;
  /** update single row of the table: "reference_price_history" */
  update_reference_price_history_by_pk?: Maybe<Reference_Price_History>;
  /** update multiples rows of table: "reference_price_history" */
  update_reference_price_history_many?: Maybe<Array<Maybe<Reference_Price_History_Mutation_Response>>>;
  /** update data of the table: "reference_zone" */
  update_reference_zone?: Maybe<Reference_Zone_Mutation_Response>;
  /** update single row of the table: "reference_zone" */
  update_reference_zone_by_pk?: Maybe<Reference_Zone>;
  /** update multiples rows of table: "reference_zone" */
  update_reference_zone_many?: Maybe<Array<Maybe<Reference_Zone_Mutation_Response>>>;
  /** update data of the table: "search_context" */
  update_search_context?: Maybe<Search_Context_Mutation_Response>;
  /** update single row of the table: "search_context" */
  update_search_context_by_pk?: Maybe<Search_Context>;
  /** update data of the table: "search_context_location" */
  update_search_context_location?: Maybe<Search_Context_Location_Mutation_Response>;
  /** update single row of the table: "search_context_location" */
  update_search_context_location_by_pk?: Maybe<Search_Context_Location>;
  /** update multiples rows of table: "search_context_location" */
  update_search_context_location_many?: Maybe<Array<Maybe<Search_Context_Location_Mutation_Response>>>;
  /** update multiples rows of table: "search_context" */
  update_search_context_many?: Maybe<Array<Maybe<Search_Context_Mutation_Response>>>;
  /** update data of the table: "search_domain" */
  update_search_domain?: Maybe<Search_Domain_Mutation_Response>;
  /** update single row of the table: "search_domain" */
  update_search_domain_by_pk?: Maybe<Search_Domain>;
  /** update multiples rows of table: "search_domain" */
  update_search_domain_many?: Maybe<Array<Maybe<Search_Domain_Mutation_Response>>>;
  /** update data of the table: "search_sessions" */
  update_search_sessions?: Maybe<Search_Sessions_Mutation_Response>;
  /** update single row of the table: "search_sessions" */
  update_search_sessions_by_pk?: Maybe<Search_Sessions>;
  /** update multiples rows of table: "search_sessions" */
  update_search_sessions_many?: Maybe<Array<Maybe<Search_Sessions_Mutation_Response>>>;
  /** update data of the table: "search_slugs" */
  update_search_slugs?: Maybe<Search_Slugs_Mutation_Response>;
  /** update single row of the table: "search_slugs" */
  update_search_slugs_by_pk?: Maybe<Search_Slugs>;
  /** update multiples rows of table: "search_slugs" */
  update_search_slugs_many?: Maybe<Array<Maybe<Search_Slugs_Mutation_Response>>>;
  /** update data of the table: "seo_city" */
  update_seo_city?: Maybe<Seo_City_Mutation_Response>;
  /** update single row of the table: "seo_city" */
  update_seo_city_by_pk?: Maybe<Seo_City>;
  /** update multiples rows of table: "seo_city" */
  update_seo_city_many?: Maybe<Array<Maybe<Seo_City_Mutation_Response>>>;
  /** update data of the table: "session_origin" */
  update_session_origin?: Maybe<Session_Origin_Mutation_Response>;
  /** update single row of the table: "session_origin" */
  update_session_origin_by_pk?: Maybe<Session_Origin>;
  /** update multiples rows of table: "session_origin" */
  update_session_origin_many?: Maybe<Array<Maybe<Session_Origin_Mutation_Response>>>;
  /** update data of the table: "sponsored_property_list" */
  update_sponsored_property_list?: Maybe<Sponsored_Property_List_Mutation_Response>;
  /** update single row of the table: "sponsored_property_list" */
  update_sponsored_property_list_by_pk?: Maybe<Sponsored_Property_List>;
  /** update multiples rows of table: "sponsored_property_list" */
  update_sponsored_property_list_many?: Maybe<Array<Maybe<Sponsored_Property_List_Mutation_Response>>>;
  /** update data of the table: "subscription" */
  update_subscription?: Maybe<Subscription_Mutation_Response>;
  /** update single row of the table: "subscription" */
  update_subscription_by_pk?: Maybe<Subscription>;
  /** update data of the table: "subscription_invoice" */
  update_subscription_invoice?: Maybe<Subscription_Invoice_Mutation_Response>;
  /** update single row of the table: "subscription_invoice" */
  update_subscription_invoice_by_pk?: Maybe<Subscription_Invoice>;
  /** update multiples rows of table: "subscription_invoice" */
  update_subscription_invoice_many?: Maybe<Array<Maybe<Subscription_Invoice_Mutation_Response>>>;
  /** update multiples rows of table: "subscription" */
  update_subscription_many?: Maybe<Array<Maybe<Subscription_Mutation_Response>>>;
  /** update data of the table: "subscription_source" */
  update_subscription_source?: Maybe<Subscription_Source_Mutation_Response>;
  /** update single row of the table: "subscription_source" */
  update_subscription_source_by_pk?: Maybe<Subscription_Source>;
  /** update multiples rows of table: "subscription_source" */
  update_subscription_source_many?: Maybe<Array<Maybe<Subscription_Source_Mutation_Response>>>;
  /** update data of the table: "subscription_status" */
  update_subscription_status?: Maybe<Subscription_Status_Mutation_Response>;
  /** update single row of the table: "subscription_status" */
  update_subscription_status_by_pk?: Maybe<Subscription_Status>;
  /** update multiples rows of table: "subscription_status" */
  update_subscription_status_many?: Maybe<Array<Maybe<Subscription_Status_Mutation_Response>>>;
  /** update data of the table: "text_content" */
  update_text_content?: Maybe<Text_Content_Mutation_Response>;
  /** update single row of the table: "text_content" */
  update_text_content_by_pk?: Maybe<Text_Content>;
  /** update multiples rows of table: "text_content" */
  update_text_content_many?: Maybe<Array<Maybe<Text_Content_Mutation_Response>>>;
  /** update data of the table: "translations" */
  update_translations?: Maybe<Translations_Mutation_Response>;
  /** update single row of the table: "translations" */
  update_translations_by_pk?: Maybe<Translations>;
  /** update multiples rows of table: "translations" */
  update_translations_many?: Maybe<Array<Maybe<Translations_Mutation_Response>>>;
  /** update data of the table: "url_slug" */
  update_url_slug?: Maybe<Url_Slug_Mutation_Response>;
  /** update single row of the table: "url_slug" */
  update_url_slug_by_pk?: Maybe<Url_Slug>;
  /** update multiples rows of table: "url_slug" */
  update_url_slug_many?: Maybe<Array<Maybe<Url_Slug_Mutation_Response>>>;
  /** update data of the table: "user_filters" */
  update_user_filters?: Maybe<User_Filters_Mutation_Response>;
  /** update single row of the table: "user_filters" */
  update_user_filters_by_pk?: Maybe<User_Filters>;
  /** update data of the table: "user_filters_features" */
  update_user_filters_features?: Maybe<User_Filters_Features_Mutation_Response>;
  /** update single row of the table: "user_filters_features" */
  update_user_filters_features_by_pk?: Maybe<User_Filters_Features>;
  /** update multiples rows of table: "user_filters_features" */
  update_user_filters_features_many?: Maybe<Array<Maybe<User_Filters_Features_Mutation_Response>>>;
  /** update multiples rows of table: "user_filters" */
  update_user_filters_many?: Maybe<Array<Maybe<User_Filters_Mutation_Response>>>;
  /** update data of the table: "user_organization" */
  update_user_organization?: Maybe<User_Organization_Mutation_Response>;
  /** update single row of the table: "user_organization" */
  update_user_organization_by_pk?: Maybe<User_Organization>;
  /** update multiples rows of table: "user_organization" */
  update_user_organization_many?: Maybe<Array<Maybe<User_Organization_Mutation_Response>>>;
  /** update data of the table: "user_preferences" */
  update_user_preferences?: Maybe<User_Preferences_Mutation_Response>;
  /** update single row of the table: "user_preferences" */
  update_user_preferences_by_pk?: Maybe<User_Preferences>;
  /** update multiples rows of table: "user_preferences" */
  update_user_preferences_many?: Maybe<Array<Maybe<User_Preferences_Mutation_Response>>>;
  /** update data of the table: "user_property_notifiation" */
  update_user_property_notifiation?: Maybe<User_Property_Notifiation_Mutation_Response>;
  /** update single row of the table: "user_property_notifiation" */
  update_user_property_notifiation_by_pk?: Maybe<User_Property_Notifiation>;
  /** update multiples rows of table: "user_property_notifiation" */
  update_user_property_notifiation_many?: Maybe<Array<Maybe<User_Property_Notifiation_Mutation_Response>>>;
  /** update data of the table: "user_saved_properties" */
  update_user_saved_properties?: Maybe<User_Saved_Properties_Mutation_Response>;
  /** update single row of the table: "user_saved_properties" */
  update_user_saved_properties_by_pk?: Maybe<User_Saved_Properties>;
  /** update multiples rows of table: "user_saved_properties" */
  update_user_saved_properties_many?: Maybe<Array<Maybe<User_Saved_Properties_Mutation_Response>>>;
  /** update data of the table: "user_seen_property" */
  update_user_seen_property?: Maybe<User_Seen_Property_Mutation_Response>;
  /** update single row of the table: "user_seen_property" */
  update_user_seen_property_by_pk?: Maybe<User_Seen_Property>;
  /** update multiples rows of table: "user_seen_property" */
  update_user_seen_property_many?: Maybe<Array<Maybe<User_Seen_Property_Mutation_Response>>>;
  /** update data of the table: "users_activity_summary" */
  update_users_activity_summary?: Maybe<Users_Activity_Summary_Mutation_Response>;
  /** update single row of the table: "users_activity_summary" */
  update_users_activity_summary_by_pk?: Maybe<Users_Activity_Summary>;
  /** update multiples rows of table: "users_activity_summary" */
  update_users_activity_summary_many?: Maybe<Array<Maybe<Users_Activity_Summary_Mutation_Response>>>;
  /** update multiples rows of table: "auth.users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update multiples rows of table: "storage.virus" */
  update_virus_many?: Maybe<Array<Maybe<Virus_Mutation_Response>>>;
  /** update data of the table: "visibility_status" */
  update_visibility_status?: Maybe<Visibility_Status_Mutation_Response>;
  /** update single row of the table: "visibility_status" */
  update_visibility_status_by_pk?: Maybe<Visibility_Status>;
  /** update multiples rows of table: "visibility_status" */
  update_visibility_status_many?: Maybe<Array<Maybe<Visibility_Status_Mutation_Response>>>;
  /** update data of the table: "whatsapp_ai_inbound_message" */
  update_whatsapp_ai_inbound_message?: Maybe<Whatsapp_Ai_Inbound_Message_Mutation_Response>;
  /** update single row of the table: "whatsapp_ai_inbound_message" */
  update_whatsapp_ai_inbound_message_by_pk?: Maybe<Whatsapp_Ai_Inbound_Message>;
  /** update multiples rows of table: "whatsapp_ai_inbound_message" */
  update_whatsapp_ai_inbound_message_many?: Maybe<Array<Maybe<Whatsapp_Ai_Inbound_Message_Mutation_Response>>>;
  /** update data of the table: "whatsapp_ai_outbox_part" */
  update_whatsapp_ai_outbox_part?: Maybe<Whatsapp_Ai_Outbox_Part_Mutation_Response>;
  /** update single row of the table: "whatsapp_ai_outbox_part" */
  update_whatsapp_ai_outbox_part_by_pk?: Maybe<Whatsapp_Ai_Outbox_Part>;
  /** update multiples rows of table: "whatsapp_ai_outbox_part" */
  update_whatsapp_ai_outbox_part_many?: Maybe<Array<Maybe<Whatsapp_Ai_Outbox_Part_Mutation_Response>>>;
  /** update data of the table: "whatsapp_ai_turn" */
  update_whatsapp_ai_turn?: Maybe<Whatsapp_Ai_Turn_Mutation_Response>;
  /** update single row of the table: "whatsapp_ai_turn" */
  update_whatsapp_ai_turn_by_pk?: Maybe<Whatsapp_Ai_Turn>;
  /** update multiples rows of table: "whatsapp_ai_turn" */
  update_whatsapp_ai_turn_many?: Maybe<Array<Maybe<Whatsapp_Ai_Turn_Mutation_Response>>>;
  /** update data of the table: "whatsapp_chat" */
  update_whatsapp_chat?: Maybe<Whatsapp_Chat_Mutation_Response>;
  /** update single row of the table: "whatsapp_chat" */
  update_whatsapp_chat_by_pk?: Maybe<Whatsapp_Chat>;
  /** update multiples rows of table: "whatsapp_chat" */
  update_whatsapp_chat_many?: Maybe<Array<Maybe<Whatsapp_Chat_Mutation_Response>>>;
  /** update data of the table: "whatsapp_human" */
  update_whatsapp_human?: Maybe<Whatsapp_Human_Mutation_Response>;
  /** update single row of the table: "whatsapp_human" */
  update_whatsapp_human_by_pk?: Maybe<Whatsapp_Human>;
  /** update multiples rows of table: "whatsapp_human" */
  update_whatsapp_human_many?: Maybe<Array<Maybe<Whatsapp_Human_Mutation_Response>>>;
  /** update data of the table: "zone_contains" */
  update_zone_contains?: Maybe<Zone_Contains_Mutation_Response>;
  /** update single row of the table: "zone_contains" */
  update_zone_contains_by_pk?: Maybe<Zone_Contains>;
  /** update multiples rows of table: "zone_contains" */
  update_zone_contains_many?: Maybe<Array<Maybe<Zone_Contains_Mutation_Response>>>;
  /** update data of the table: "zone_data_method" */
  update_zone_data_method?: Maybe<Zone_Data_Method_Mutation_Response>;
  /** update single row of the table: "zone_data_method" */
  update_zone_data_method_by_pk?: Maybe<Zone_Data_Method>;
  /** update multiples rows of table: "zone_data_method" */
  update_zone_data_method_many?: Maybe<Array<Maybe<Zone_Data_Method_Mutation_Response>>>;
  upload_to_mux?: Maybe<MuxAssetCreateResult>;
  /** Action to verify code */
  verify_sms_code?: Maybe<VerfiyCodeOutput>;
};


/** mutation root */
export type Mutation_RootAdd_Lister_LeadsArgs = {
  body: AddListerLeadsInput;
};


/** mutation root */
export type Mutation_RootApprove_Place_Reference_ProposalArgs = {
  args: Approve_Place_Reference_Proposal_Args;
  distinct_on?: InputMaybe<Array<Place_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Order_By>>;
  where?: InputMaybe<Place_Reference_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootCheck_Lister_Profile_ClaimArgs = {
  body: CheckListerInput;
};


/** mutation root */
export type Mutation_RootClaim_Lister_ProfileArgs = {
  body: CheckListerInput;
};


/** mutation root */
export type Mutation_RootClaim_Whatsapp_Ai_Ambiguous_Outbox_PartArgs = {
  args: Claim_Whatsapp_Ai_Ambiguous_Outbox_Part_Args;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootClaim_Whatsapp_Ai_Outbox_PartArgs = {
  args: Claim_Whatsapp_Ai_Outbox_Part_Args;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootComplete_Whatsapp_Ai_Outbox_PartArgs = {
  args: Complete_Whatsapp_Ai_Outbox_Part_Args;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootCreate_Manual_SubscriptionArgs = {
  body: ManualSubscriptionInput;
};


/** mutation root */
export type Mutation_RootCreate_OrganizationArgs = {
  body: ChangeUserRoleInput;
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestsArgs = {
  where: AuthProviderRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthProvidersArgs = {
  where: AuthProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypesArgs = {
  where: AuthRefreshTokenTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokensArgs = {
  where: AuthRefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRoleArgs = {
  role: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRolesArgs = {
  where: AuthRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProviderArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProvidersArgs = {
  where: AuthUserProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRoleArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRolesArgs = {
  where: AuthUserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeysArgs = {
  where: AuthUserSecurityKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteBucketArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBucketsArgs = {
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFileArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteFilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteVirusArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteVirusesArgs = {
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_TypesArgs = {
  where: Address_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AgencyArgs = {
  where: Agency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agency_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Agency_TypeArgs = {
  where: Agency_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agency_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Agent_ActionArgs = {
  where: Agent_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agent_Action_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Agent_TaskArgs = {
  where: Agent_Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agent_Task_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AmenitiesArgs = {
  where: Amenities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Amenities_By_PkArgs = {
  amenity: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_App_ConfigArgs = {
  where: App_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_App_Config_By_PkArgs = {
  platform: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BlogArgs = {
  where: Blog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Blog_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Blog_PostArgs = {
  where: Blog_Post_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Blog_Post_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Blog_SectionArgs = {
  where: Blog_Section_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Blog_Section_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Blog_StatusArgs = {
  where: Blog_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Blog_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BuilderArgs = {
  where: Builder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Builder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Certified_AgentArgs = {
  where: Certified_Agent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Certified_Agent_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_Response_TypeArgs = {
  where: Chat_Response_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Response_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CityArgs = {
  where: City_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_City_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_City_ZoneArgs = {
  where: City_Zone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_City_Zone_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_City_Zone_OriginArgs = {
  where: City_Zone_Origin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_City_Zone_Origin_By_PkArgs = {
  origin: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Claim_Request_StatusArgs = {
  where: Claim_Request_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Claim_Request_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CleringArgs = {
  where: Clering_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Clering_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Construction_StatusArgs = {
  where: Construction_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Construction_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ContactArgs = {
  where: Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contact_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Contact_Phone_NumberArgs = {
  where: Contact_Phone_Number_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contact_Phone_Number_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Contact_TypeArgs = {
  where: Contact_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contact_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Content_TypeArgs = {
  where: Content_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Content_Type_By_PkArgs = {
  content_type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CountriesArgs = {
  where: Countries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Countries_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CountryArgs = {
  where: Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Country_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CurrencyArgs = {
  where: Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Currency_By_PkArgs = {
  currency: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Currency_Exchange_RatesArgs = {
  where: Currency_Exchange_Rates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Currency_Exchange_Rates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EntitiesArgs = {
  where: Entities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Entities_By_PkArgs = {
  entity_type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Exchange_RatesArgs = {
  where: Exchange_Rates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exchange_Rates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FeatureArgs = {
  where: Feature_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feature_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Feature_TypeArgs = {
  where: Feature_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feature_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_File_TypeArgs = {
  where: File_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Folder_AmenitiesArgs = {
  where: Folder_Amenities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Folder_Amenities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Folder_ImageArgs = {
  where: Folder_Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Folder_Image_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Folder_Properties_TypeArgs = {
  where: Folder_Properties_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Folder_Properties_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Folder_StatusArgs = {
  where: Folder_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Folder_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Folder_TypeArgs = {
  where: Folder_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Folder_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Furnishing_StatusArgs = {
  where: Furnishing_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Furnishing_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Google_CalendarArgs = {
  where: Google_Calendar_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Google_Calendar_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_HeatingTypeArgs = {
  where: HeatingType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_HeatingType_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ImageArgs = {
  where: Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Image_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Invoice_StatusArgs = {
  where: Invoice_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoice_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LanguagesArgs = {
  where: Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Languages_By_PkArgs = {
  language_id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lead_Property_CategoryArgs = {
  where: Lead_Property_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lead_Property_Category_By_PkArgs = {
  category: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lead_StatusArgs = {
  where: Lead_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lead_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lead_TypeArgs = {
  where: Lead_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lead_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lister_Claim_RequestArgs = {
  where: Lister_Claim_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lister_Claim_Request_ActivityArgs = {
  where: Lister_Claim_Request_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lister_Claim_Request_Activity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lister_Claim_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lister_ContactArgs = {
  where: Lister_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lister_Contact_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lister_Contact_MeetingArgs = {
  where: Lister_Contact_Meeting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lister_Contact_Meeting_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lister_Contact_SourceArgs = {
  where: Lister_Contact_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lister_Contact_Source_By_PkArgs = {
  source: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lister_LeadsArgs = {
  where: Lister_Leads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lister_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lister_MeetingArgs = {
  where: Lister_Meeting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lister_Meeting_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lister_RoleArgs = {
  where: Lister_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lister_Role_By_PkArgs = {
  role: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LocationArgs = {
  where: Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Location_TypeArgs = {
  where: Location_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Location_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Main_CurrencyArgs = {
  where: Main_Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Main_Currency_By_PkArgs = {
  currency: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Natural_Language_QueriesArgs = {
  where: Natural_Language_Queries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Natural_Language_Queries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationArgs = {
  where: Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_AmenitiesArgs = {
  where: Notification_Amenities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Amenities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_FeatureArgs = {
  where: Notification_Feature_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Feature_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_Property_TypeArgs = {
  where: Notification_Property_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Property_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_TypeArgs = {
  where: Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrderArgs = {
  where: Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Order_StatusArgs = {
  where: Order_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationArgs = {
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Lead_LocationArgs = {
  where: Organization_Lead_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Lead_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Lead_PropertyArgs = {
  where: Organization_Lead_Property_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Lead_Property_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_LeadsArgs = {
  where: Organization_Leads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_RoleArgs = {
  where: Organization_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Role_By_PkArgs = {
  role: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_StatusArgs = {
  where: Organization_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Telegram_Agent_LinkArgs = {
  where: Organization_Telegram_Agent_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Telegram_Agent_Link_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_TypeArgs = {
  where: Organization_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Whatsapp_Ai_AllowlistArgs = {
  where: Organization_Whatsapp_Ai_Allowlist_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Whatsapp_Ai_Allowlist_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Whatsapp_Ai_ConfigArgs = {
  where: Organization_Whatsapp_Ai_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Whatsapp_Ai_Config_By_PkArgs = {
  organization_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parking_TypeArgs = {
  where: Parking_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parking_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Phone_Number_TypeArgs = {
  where: Phone_Number_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Phone_Number_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Place_ReferenceArgs = {
  where: Place_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Place_Reference_AliasArgs = {
  where: Place_Reference_Alias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Place_Reference_Alias_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Place_Reference_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Place_Reference_ProposalArgs = {
  where: Place_Reference_Proposal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Place_Reference_Proposal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PlanArgs = {
  where: Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Plan_TypeArgs = {
  where: Plan_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plan_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProductArgs = {
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_PurchaseArgs = {
  where: Product_Purchase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Purchase_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_TypeArgs = {
  where: Product_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PropertyArgs = {
  where: Property_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_ClusterArgs = {
  where: Property_Cluster_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Cluster_By_PkArgs = {
  cluster: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_CompositionArgs = {
  where: Property_Composition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Composition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_FeatureArgs = {
  where: Property_Feature_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Feature_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_FolderArgs = {
  where: Property_Folder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_ProfileArgs = {
  where: Property_Folder_Public_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_Profile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_Profile_FaqArgs = {
  where: Property_Folder_Public_Profile_Faq_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_Profile_Faq_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_Profile_HighlightArgs = {
  where: Property_Folder_Public_Profile_Highlight_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_Profile_Highlight_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_Profile_Listing_ExampleArgs = {
  where: Property_Folder_Public_Profile_Listing_Example_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_Profile_Listing_Example_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_Profile_Nearby_PlaceArgs = {
  where: Property_Folder_Public_Profile_Nearby_Place_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_Profile_Nearby_Place_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_Profile_RelatedArgs = {
  where: Property_Folder_Public_Profile_Related_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_Profile_Related_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_Profile_TranslationArgs = {
  where: Property_Folder_Public_Profile_Translation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Folder_Public_Profile_Translation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_ImageArgs = {
  where: Property_Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Image_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_ListArgs = {
  where: Property_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_List_ActivityArgs = {
  where: Property_List_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_List_Activity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_List_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_List_FolderArgs = {
  where: Property_List_Folder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_List_Folder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_List_ReportArgs = {
  where: Property_List_Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_List_Report_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_OriginArgs = {
  where: Property_Origin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Origin_By_PkArgs = {
  origin: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Origin_TypeArgs = {
  where: Property_Origin_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Origin_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_OwnerArgs = {
  where: Property_Owner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Owner_By_PkArgs = {
  owner: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Place_ReferenceArgs = {
  where: Property_Place_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Place_Reference_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Price_HistoryArgs = {
  where: Property_Price_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Price_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Report_TypeArgs = {
  where: Property_Report_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Report_Type_By_PkArgs = {
  report_type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_SourceArgs = {
  where: Property_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Source_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_StatusArgs = {
  where: Property_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_TypeArgs = {
  where: Property_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_ViewsArgs = {
  where: Property_Views_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Views_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Queries_Property_ResultArgs = {
  where: Queries_Property_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Queries_Property_Result_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Queries_Property_Result_ReArgs = {
  where: Queries_Property_Result_Re_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Queries_Property_Result_Re_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Query_ClassificationArgs = {
  where: Query_Classification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Query_Classification_By_PkArgs = {
  class: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Query_Classification_ReArgs = {
  where: Query_Classification_Re_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Query_Classification_Re_By_PkArgs = {
  class: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Raw_LocationArgs = {
  where: Raw_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Raw_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RedirectArgs = {
  where: Redirect_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Redirect_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Reference_Price_HistoryArgs = {
  where: Reference_Price_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reference_Price_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Reference_ZoneArgs = {
  where: Reference_Zone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reference_Zone_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Search_ContextArgs = {
  where: Search_Context_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Context_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Search_Context_LocationArgs = {
  where: Search_Context_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Context_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Search_DomainArgs = {
  where: Search_Domain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Domain_By_PkArgs = {
  domain: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Search_SessionsArgs = {
  where: Search_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Sessions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Search_SlugsArgs = {
  where: Search_Slugs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Slugs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Seo_CityArgs = {
  where: Seo_City_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Seo_City_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Session_OriginArgs = {
  where: Session_Origin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Session_Origin_By_PkArgs = {
  origin: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sponsored_Property_ListArgs = {
  where: Sponsored_Property_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sponsored_Property_List_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SubscriptionArgs = {
  where: Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_InvoiceArgs = {
  where: Subscription_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Invoice_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_SourceArgs = {
  where: Subscription_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Source_By_PkArgs = {
  source: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_StatusArgs = {
  where: Subscription_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Text_ContentArgs = {
  where: Text_Content_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Text_Content_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TranslationsArgs = {
  where: Translations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Translations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Url_SlugArgs = {
  where: Url_Slug_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Url_Slug_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_FiltersArgs = {
  where: User_Filters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Filters_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Filters_FeaturesArgs = {
  where: User_Filters_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Filters_Features_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_OrganizationArgs = {
  where: User_Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Organization_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_PreferencesArgs = {
  where: User_Preferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Preferences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Property_NotifiationArgs = {
  where: User_Property_Notifiation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Property_Notifiation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Saved_PropertiesArgs = {
  where: User_Saved_Properties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Saved_Properties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Seen_PropertyArgs = {
  where: User_Seen_Property_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Seen_Property_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Users_Activity_SummaryArgs = {
  where: Users_Activity_Summary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_Activity_Summary_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Visibility_StatusArgs = {
  where: Visibility_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Visibility_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Ai_Inbound_MessageArgs = {
  where: Whatsapp_Ai_Inbound_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Ai_Inbound_Message_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Ai_Outbox_PartArgs = {
  where: Whatsapp_Ai_Outbox_Part_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Ai_Outbox_Part_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Ai_TurnArgs = {
  where: Whatsapp_Ai_Turn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Ai_Turn_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_ChatArgs = {
  where: Whatsapp_Chat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Chat_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_HumanArgs = {
  where: Whatsapp_Human_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Human_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Zone_ContainsArgs = {
  where: Zone_Contains_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Zone_Contains_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Zone_Data_MethodArgs = {
  where: Zone_Data_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Zone_Data_Method_By_PkArgs = {
  method: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDuplicate_Search_SessionArgs = {
  body: DuplicateSearchSessionInput;
};


/** mutation root */
export type Mutation_RootFail_Whatsapp_Ai_Outbox_PartArgs = {
  args: Fail_Whatsapp_Ai_Outbox_Part_Args;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootFail_Whatsapp_Ai_TurnArgs = {
  args: Fail_Whatsapp_Ai_Turn_Args;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Turn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Turn_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootFinalize_Whatsapp_Ai_TurnArgs = {
  args: Finalize_Whatsapp_Ai_Turn_Args;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Turn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Turn_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootGenerate_Property_AttributesArgs = {
  body: PropertyAttributesInput;
};


/** mutation root */
export type Mutation_RootGenerate_QueryArgs = {
  body: GenerateQueryInput;
};


/** mutation root */
export type Mutation_RootGenerate_Social_MediaArgs = {
  body: SocialMediaInput;
};


/** mutation root */
export type Mutation_RootGenerate_TextArgs = {
  body: RegenerateInput;
};


/** mutation root */
export type Mutation_RootIncrement_Property_StatsArgs = {
  body: IncrementPropertyStatsInput;
};


/** mutation root */
export type Mutation_RootInitialize_OrderArgs = {
  object: InsertOrderOrderInsertInput;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderArgs = {
  object: AuthProviders_Insert_Input;
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestArgs = {
  object: AuthProviderRequests_Insert_Input;
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestsArgs = {
  objects: Array<AuthProviderRequests_Insert_Input>;
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProvidersArgs = {
  objects: Array<AuthProviders_Insert_Input>;
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenArgs = {
  object: AuthRefreshTokens_Insert_Input;
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypeArgs = {
  object: AuthRefreshTokenTypes_Insert_Input;
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypesArgs = {
  objects: Array<AuthRefreshTokenTypes_Insert_Input>;
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokensArgs = {
  objects: Array<AuthRefreshTokens_Insert_Input>;
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRoleArgs = {
  object: AuthRoles_Insert_Input;
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRolesArgs = {
  objects: Array<AuthRoles_Insert_Input>;
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProviderArgs = {
  object: AuthUserProviders_Insert_Input;
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProvidersArgs = {
  objects: Array<AuthUserProviders_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRoleArgs = {
  object: AuthUserRoles_Insert_Input;
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRolesArgs = {
  objects: Array<AuthUserRoles_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeyArgs = {
  object: AuthUserSecurityKeys_Insert_Input;
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeysArgs = {
  objects: Array<AuthUserSecurityKeys_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketArgs = {
  object: Buckets_Insert_Input;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketsArgs = {
  objects: Array<Buckets_Insert_Input>;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFileArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPropertyListArgs = {
  object: InsertPropertyListPropertyListInsertInput;
};


/** mutation root */
export type Mutation_RootInsertUserArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusArgs = {
  object: Virus_Insert_Input;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusesArgs = {
  objects: Array<Virus_Insert_Input>;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_TypesArgs = {
  objects: Array<Address_Types_Insert_Input>;
  on_conflict?: InputMaybe<Address_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_Types_OneArgs = {
  object: Address_Types_Insert_Input;
  on_conflict?: InputMaybe<Address_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AgencyArgs = {
  objects: Array<Agency_Insert_Input>;
  on_conflict?: InputMaybe<Agency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agency_OneArgs = {
  object: Agency_Insert_Input;
  on_conflict?: InputMaybe<Agency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agency_TypeArgs = {
  objects: Array<Agency_Type_Insert_Input>;
  on_conflict?: InputMaybe<Agency_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agency_Type_OneArgs = {
  object: Agency_Type_Insert_Input;
  on_conflict?: InputMaybe<Agency_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_ActionArgs = {
  objects: Array<Agent_Action_Insert_Input>;
  on_conflict?: InputMaybe<Agent_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_Action_OneArgs = {
  object: Agent_Action_Insert_Input;
  on_conflict?: InputMaybe<Agent_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_TaskArgs = {
  objects: Array<Agent_Task_Insert_Input>;
  on_conflict?: InputMaybe<Agent_Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_Task_OneArgs = {
  object: Agent_Task_Insert_Input;
  on_conflict?: InputMaybe<Agent_Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AmenitiesArgs = {
  objects: Array<Amenities_Insert_Input>;
  on_conflict?: InputMaybe<Amenities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Amenities_OneArgs = {
  object: Amenities_Insert_Input;
  on_conflict?: InputMaybe<Amenities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_App_ConfigArgs = {
  objects: Array<App_Config_Insert_Input>;
  on_conflict?: InputMaybe<App_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_App_Config_OneArgs = {
  object: App_Config_Insert_Input;
  on_conflict?: InputMaybe<App_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BlogArgs = {
  objects: Array<Blog_Insert_Input>;
  on_conflict?: InputMaybe<Blog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Blog_OneArgs = {
  object: Blog_Insert_Input;
  on_conflict?: InputMaybe<Blog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Blog_PostArgs = {
  objects: Array<Blog_Post_Insert_Input>;
  on_conflict?: InputMaybe<Blog_Post_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Blog_Post_OneArgs = {
  object: Blog_Post_Insert_Input;
  on_conflict?: InputMaybe<Blog_Post_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Blog_SectionArgs = {
  objects: Array<Blog_Section_Insert_Input>;
  on_conflict?: InputMaybe<Blog_Section_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Blog_Section_OneArgs = {
  object: Blog_Section_Insert_Input;
  on_conflict?: InputMaybe<Blog_Section_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Blog_StatusArgs = {
  objects: Array<Blog_Status_Insert_Input>;
  on_conflict?: InputMaybe<Blog_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Blog_Status_OneArgs = {
  object: Blog_Status_Insert_Input;
  on_conflict?: InputMaybe<Blog_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuilderArgs = {
  objects: Array<Builder_Insert_Input>;
  on_conflict?: InputMaybe<Builder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Builder_OneArgs = {
  object: Builder_Insert_Input;
  on_conflict?: InputMaybe<Builder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Certified_AgentArgs = {
  objects: Array<Certified_Agent_Insert_Input>;
  on_conflict?: InputMaybe<Certified_Agent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Certified_Agent_OneArgs = {
  object: Certified_Agent_Insert_Input;
  on_conflict?: InputMaybe<Certified_Agent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Response_TypeArgs = {
  objects: Array<Chat_Response_Type_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Response_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Response_Type_OneArgs = {
  object: Chat_Response_Type_Insert_Input;
  on_conflict?: InputMaybe<Chat_Response_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CityArgs = {
  objects: Array<City_Insert_Input>;
  on_conflict?: InputMaybe<City_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_City_OneArgs = {
  object: City_Insert_Input;
  on_conflict?: InputMaybe<City_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_City_ZoneArgs = {
  objects: Array<City_Zone_Insert_Input>;
  on_conflict?: InputMaybe<City_Zone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_City_Zone_OneArgs = {
  object: City_Zone_Insert_Input;
  on_conflict?: InputMaybe<City_Zone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_City_Zone_OriginArgs = {
  objects: Array<City_Zone_Origin_Insert_Input>;
  on_conflict?: InputMaybe<City_Zone_Origin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_City_Zone_Origin_OneArgs = {
  object: City_Zone_Origin_Insert_Input;
  on_conflict?: InputMaybe<City_Zone_Origin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Claim_Request_StatusArgs = {
  objects: Array<Claim_Request_Status_Insert_Input>;
  on_conflict?: InputMaybe<Claim_Request_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Claim_Request_Status_OneArgs = {
  object: Claim_Request_Status_Insert_Input;
  on_conflict?: InputMaybe<Claim_Request_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CleringArgs = {
  objects: Array<Clering_Insert_Input>;
  on_conflict?: InputMaybe<Clering_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clering_OneArgs = {
  object: Clering_Insert_Input;
  on_conflict?: InputMaybe<Clering_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Construction_StatusArgs = {
  objects: Array<Construction_Status_Insert_Input>;
  on_conflict?: InputMaybe<Construction_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Construction_Status_OneArgs = {
  object: Construction_Status_Insert_Input;
  on_conflict?: InputMaybe<Construction_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ContactArgs = {
  objects: Array<Contact_Insert_Input>;
  on_conflict?: InputMaybe<Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contact_OneArgs = {
  object: Contact_Insert_Input;
  on_conflict?: InputMaybe<Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contact_Phone_NumberArgs = {
  objects: Array<Contact_Phone_Number_Insert_Input>;
  on_conflict?: InputMaybe<Contact_Phone_Number_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contact_Phone_Number_OneArgs = {
  object: Contact_Phone_Number_Insert_Input;
  on_conflict?: InputMaybe<Contact_Phone_Number_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contact_TypeArgs = {
  objects: Array<Contact_Type_Insert_Input>;
  on_conflict?: InputMaybe<Contact_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contact_Type_OneArgs = {
  object: Contact_Type_Insert_Input;
  on_conflict?: InputMaybe<Contact_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_TypeArgs = {
  objects: Array<Content_Type_Insert_Input>;
  on_conflict?: InputMaybe<Content_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Content_Type_OneArgs = {
  object: Content_Type_Insert_Input;
  on_conflict?: InputMaybe<Content_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CountriesArgs = {
  objects: Array<Countries_Insert_Input>;
  on_conflict?: InputMaybe<Countries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Countries_OneArgs = {
  object: Countries_Insert_Input;
  on_conflict?: InputMaybe<Countries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CountryArgs = {
  objects: Array<Country_Insert_Input>;
  on_conflict?: InputMaybe<Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Country_OneArgs = {
  object: Country_Insert_Input;
  on_conflict?: InputMaybe<Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CurrencyArgs = {
  objects: Array<Currency_Insert_Input>;
  on_conflict?: InputMaybe<Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Currency_Exchange_RatesArgs = {
  objects: Array<Currency_Exchange_Rates_Insert_Input>;
  on_conflict?: InputMaybe<Currency_Exchange_Rates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Currency_Exchange_Rates_OneArgs = {
  object: Currency_Exchange_Rates_Insert_Input;
  on_conflict?: InputMaybe<Currency_Exchange_Rates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Currency_OneArgs = {
  object: Currency_Insert_Input;
  on_conflict?: InputMaybe<Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EntitiesArgs = {
  objects: Array<Entities_Insert_Input>;
  on_conflict?: InputMaybe<Entities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entities_OneArgs = {
  object: Entities_Insert_Input;
  on_conflict?: InputMaybe<Entities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exchange_RatesArgs = {
  objects: Array<Exchange_Rates_Insert_Input>;
  on_conflict?: InputMaybe<Exchange_Rates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exchange_Rates_OneArgs = {
  object: Exchange_Rates_Insert_Input;
  on_conflict?: InputMaybe<Exchange_Rates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FeatureArgs = {
  objects: Array<Feature_Insert_Input>;
  on_conflict?: InputMaybe<Feature_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_OneArgs = {
  object: Feature_Insert_Input;
  on_conflict?: InputMaybe<Feature_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_TypeArgs = {
  objects: Array<Feature_Type_Insert_Input>;
  on_conflict?: InputMaybe<Feature_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_Type_OneArgs = {
  object: Feature_Type_Insert_Input;
  on_conflict?: InputMaybe<Feature_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_TypeArgs = {
  objects: Array<File_Type_Insert_Input>;
  on_conflict?: InputMaybe<File_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_Type_OneArgs = {
  object: File_Type_Insert_Input;
  on_conflict?: InputMaybe<File_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folder_AmenitiesArgs = {
  objects: Array<Folder_Amenities_Insert_Input>;
  on_conflict?: InputMaybe<Folder_Amenities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folder_Amenities_OneArgs = {
  object: Folder_Amenities_Insert_Input;
  on_conflict?: InputMaybe<Folder_Amenities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folder_ImageArgs = {
  objects: Array<Folder_Image_Insert_Input>;
  on_conflict?: InputMaybe<Folder_Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folder_Image_OneArgs = {
  object: Folder_Image_Insert_Input;
  on_conflict?: InputMaybe<Folder_Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folder_Properties_TypeArgs = {
  objects: Array<Folder_Properties_Type_Insert_Input>;
  on_conflict?: InputMaybe<Folder_Properties_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folder_Properties_Type_OneArgs = {
  object: Folder_Properties_Type_Insert_Input;
  on_conflict?: InputMaybe<Folder_Properties_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folder_StatusArgs = {
  objects: Array<Folder_Status_Insert_Input>;
  on_conflict?: InputMaybe<Folder_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folder_Status_OneArgs = {
  object: Folder_Status_Insert_Input;
  on_conflict?: InputMaybe<Folder_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folder_TypeArgs = {
  objects: Array<Folder_Type_Insert_Input>;
  on_conflict?: InputMaybe<Folder_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folder_Type_OneArgs = {
  object: Folder_Type_Insert_Input;
  on_conflict?: InputMaybe<Folder_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Furnishing_StatusArgs = {
  objects: Array<Furnishing_Status_Insert_Input>;
  on_conflict?: InputMaybe<Furnishing_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Furnishing_Status_OneArgs = {
  object: Furnishing_Status_Insert_Input;
  on_conflict?: InputMaybe<Furnishing_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Google_CalendarArgs = {
  objects: Array<Google_Calendar_Insert_Input>;
  on_conflict?: InputMaybe<Google_Calendar_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Google_Calendar_OneArgs = {
  object: Google_Calendar_Insert_Input;
  on_conflict?: InputMaybe<Google_Calendar_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_HeatingTypeArgs = {
  objects: Array<HeatingType_Insert_Input>;
  on_conflict?: InputMaybe<HeatingType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_HeatingType_OneArgs = {
  object: HeatingType_Insert_Input;
  on_conflict?: InputMaybe<HeatingType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ImageArgs = {
  objects: Array<Image_Insert_Input>;
  on_conflict?: InputMaybe<Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Image_OneArgs = {
  object: Image_Insert_Input;
  on_conflict?: InputMaybe<Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_StatusArgs = {
  objects: Array<Invoice_Status_Insert_Input>;
  on_conflict?: InputMaybe<Invoice_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_Status_OneArgs = {
  object: Invoice_Status_Insert_Input;
  on_conflict?: InputMaybe<Invoice_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LanguagesArgs = {
  objects: Array<Languages_Insert_Input>;
  on_conflict?: InputMaybe<Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Languages_OneArgs = {
  object: Languages_Insert_Input;
  on_conflict?: InputMaybe<Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_Property_CategoryArgs = {
  objects: Array<Lead_Property_Category_Insert_Input>;
  on_conflict?: InputMaybe<Lead_Property_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_Property_Category_OneArgs = {
  object: Lead_Property_Category_Insert_Input;
  on_conflict?: InputMaybe<Lead_Property_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_StatusArgs = {
  objects: Array<Lead_Status_Insert_Input>;
  on_conflict?: InputMaybe<Lead_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_Status_OneArgs = {
  object: Lead_Status_Insert_Input;
  on_conflict?: InputMaybe<Lead_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_TypeArgs = {
  objects: Array<Lead_Type_Insert_Input>;
  on_conflict?: InputMaybe<Lead_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_Type_OneArgs = {
  object: Lead_Type_Insert_Input;
  on_conflict?: InputMaybe<Lead_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_Claim_RequestArgs = {
  objects: Array<Lister_Claim_Request_Insert_Input>;
  on_conflict?: InputMaybe<Lister_Claim_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_Claim_Request_ActivityArgs = {
  objects: Array<Lister_Claim_Request_Activity_Insert_Input>;
  on_conflict?: InputMaybe<Lister_Claim_Request_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_Claim_Request_Activity_OneArgs = {
  object: Lister_Claim_Request_Activity_Insert_Input;
  on_conflict?: InputMaybe<Lister_Claim_Request_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_Claim_Request_OneArgs = {
  object: Lister_Claim_Request_Insert_Input;
  on_conflict?: InputMaybe<Lister_Claim_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_ContactArgs = {
  objects: Array<Lister_Contact_Insert_Input>;
  on_conflict?: InputMaybe<Lister_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_Contact_MeetingArgs = {
  objects: Array<Lister_Contact_Meeting_Insert_Input>;
  on_conflict?: InputMaybe<Lister_Contact_Meeting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_Contact_Meeting_OneArgs = {
  object: Lister_Contact_Meeting_Insert_Input;
  on_conflict?: InputMaybe<Lister_Contact_Meeting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_Contact_OneArgs = {
  object: Lister_Contact_Insert_Input;
  on_conflict?: InputMaybe<Lister_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_Contact_SourceArgs = {
  objects: Array<Lister_Contact_Source_Insert_Input>;
  on_conflict?: InputMaybe<Lister_Contact_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_Contact_Source_OneArgs = {
  object: Lister_Contact_Source_Insert_Input;
  on_conflict?: InputMaybe<Lister_Contact_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_LeadsArgs = {
  objects: Array<Lister_Leads_Insert_Input>;
  on_conflict?: InputMaybe<Lister_Leads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_Leads_OneArgs = {
  object: Lister_Leads_Insert_Input;
  on_conflict?: InputMaybe<Lister_Leads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_MeetingArgs = {
  objects: Array<Lister_Meeting_Insert_Input>;
  on_conflict?: InputMaybe<Lister_Meeting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_Meeting_OneArgs = {
  object: Lister_Meeting_Insert_Input;
  on_conflict?: InputMaybe<Lister_Meeting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_RoleArgs = {
  objects: Array<Lister_Role_Insert_Input>;
  on_conflict?: InputMaybe<Lister_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lister_Role_OneArgs = {
  object: Lister_Role_Insert_Input;
  on_conflict?: InputMaybe<Lister_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LocationArgs = {
  objects: Array<Location_Insert_Input>;
  on_conflict?: InputMaybe<Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_OneArgs = {
  object: Location_Insert_Input;
  on_conflict?: InputMaybe<Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_TypeArgs = {
  objects: Array<Location_Type_Insert_Input>;
  on_conflict?: InputMaybe<Location_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_Type_OneArgs = {
  object: Location_Type_Insert_Input;
  on_conflict?: InputMaybe<Location_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Main_CurrencyArgs = {
  objects: Array<Main_Currency_Insert_Input>;
  on_conflict?: InputMaybe<Main_Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Main_Currency_OneArgs = {
  object: Main_Currency_Insert_Input;
  on_conflict?: InputMaybe<Main_Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Natural_Language_QueriesArgs = {
  objects: Array<Natural_Language_Queries_Insert_Input>;
  on_conflict?: InputMaybe<Natural_Language_Queries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Natural_Language_Queries_OneArgs = {
  object: Natural_Language_Queries_Insert_Input;
  on_conflict?: InputMaybe<Natural_Language_Queries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationArgs = {
  objects: Array<Notification_Insert_Input>;
  on_conflict?: InputMaybe<Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_AmenitiesArgs = {
  objects: Array<Notification_Amenities_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Amenities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Amenities_OneArgs = {
  object: Notification_Amenities_Insert_Input;
  on_conflict?: InputMaybe<Notification_Amenities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_FeatureArgs = {
  objects: Array<Notification_Feature_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Feature_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Feature_OneArgs = {
  object: Notification_Feature_Insert_Input;
  on_conflict?: InputMaybe<Notification_Feature_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_OneArgs = {
  object: Notification_Insert_Input;
  on_conflict?: InputMaybe<Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Property_TypeArgs = {
  objects: Array<Notification_Property_Type_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Property_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Property_Type_OneArgs = {
  object: Notification_Property_Type_Insert_Input;
  on_conflict?: InputMaybe<Notification_Property_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_TypeArgs = {
  objects: Array<Notification_Type_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Type_OneArgs = {
  object: Notification_Type_Insert_Input;
  on_conflict?: InputMaybe<Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrderArgs = {
  objects: Array<Order_Insert_Input>;
  on_conflict?: InputMaybe<Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_OneArgs = {
  object: Order_Insert_Input;
  on_conflict?: InputMaybe<Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_StatusArgs = {
  objects: Array<Order_Status_Insert_Input>;
  on_conflict?: InputMaybe<Order_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Status_OneArgs = {
  object: Order_Status_Insert_Input;
  on_conflict?: InputMaybe<Order_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationArgs = {
  objects: Array<Organization_Insert_Input>;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Lead_LocationArgs = {
  objects: Array<Organization_Lead_Location_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Lead_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Lead_Location_OneArgs = {
  object: Organization_Lead_Location_Insert_Input;
  on_conflict?: InputMaybe<Organization_Lead_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Lead_PropertyArgs = {
  objects: Array<Organization_Lead_Property_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Lead_Property_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Lead_Property_OneArgs = {
  object: Organization_Lead_Property_Insert_Input;
  on_conflict?: InputMaybe<Organization_Lead_Property_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_LeadsArgs = {
  objects: Array<Organization_Leads_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Leads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Leads_OneArgs = {
  object: Organization_Leads_Insert_Input;
  on_conflict?: InputMaybe<Organization_Leads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_OneArgs = {
  object: Organization_Insert_Input;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_RoleArgs = {
  objects: Array<Organization_Role_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Role_OneArgs = {
  object: Organization_Role_Insert_Input;
  on_conflict?: InputMaybe<Organization_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_StatusArgs = {
  objects: Array<Organization_Status_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Status_OneArgs = {
  object: Organization_Status_Insert_Input;
  on_conflict?: InputMaybe<Organization_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Telegram_Agent_LinkArgs = {
  objects: Array<Organization_Telegram_Agent_Link_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Telegram_Agent_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Telegram_Agent_Link_OneArgs = {
  object: Organization_Telegram_Agent_Link_Insert_Input;
  on_conflict?: InputMaybe<Organization_Telegram_Agent_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_TypeArgs = {
  objects: Array<Organization_Type_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Type_OneArgs = {
  object: Organization_Type_Insert_Input;
  on_conflict?: InputMaybe<Organization_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Whatsapp_Ai_AllowlistArgs = {
  objects: Array<Organization_Whatsapp_Ai_Allowlist_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Whatsapp_Ai_Allowlist_OneArgs = {
  object: Organization_Whatsapp_Ai_Allowlist_Insert_Input;
  on_conflict?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Whatsapp_Ai_ConfigArgs = {
  objects: Array<Organization_Whatsapp_Ai_Config_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Whatsapp_Ai_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Whatsapp_Ai_Config_OneArgs = {
  object: Organization_Whatsapp_Ai_Config_Insert_Input;
  on_conflict?: InputMaybe<Organization_Whatsapp_Ai_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parking_TypeArgs = {
  objects: Array<Parking_Type_Insert_Input>;
  on_conflict?: InputMaybe<Parking_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parking_Type_OneArgs = {
  object: Parking_Type_Insert_Input;
  on_conflict?: InputMaybe<Parking_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_Number_TypeArgs = {
  objects: Array<Phone_Number_Type_Insert_Input>;
  on_conflict?: InputMaybe<Phone_Number_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_Number_Type_OneArgs = {
  object: Phone_Number_Type_Insert_Input;
  on_conflict?: InputMaybe<Phone_Number_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Place_ReferenceArgs = {
  objects: Array<Place_Reference_Insert_Input>;
  on_conflict?: InputMaybe<Place_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Place_Reference_AliasArgs = {
  objects: Array<Place_Reference_Alias_Insert_Input>;
  on_conflict?: InputMaybe<Place_Reference_Alias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Place_Reference_Alias_OneArgs = {
  object: Place_Reference_Alias_Insert_Input;
  on_conflict?: InputMaybe<Place_Reference_Alias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Place_Reference_OneArgs = {
  object: Place_Reference_Insert_Input;
  on_conflict?: InputMaybe<Place_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Place_Reference_ProposalArgs = {
  objects: Array<Place_Reference_Proposal_Insert_Input>;
  on_conflict?: InputMaybe<Place_Reference_Proposal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Place_Reference_Proposal_OneArgs = {
  object: Place_Reference_Proposal_Insert_Input;
  on_conflict?: InputMaybe<Place_Reference_Proposal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlanArgs = {
  objects: Array<Plan_Insert_Input>;
  on_conflict?: InputMaybe<Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plan_OneArgs = {
  object: Plan_Insert_Input;
  on_conflict?: InputMaybe<Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plan_TypeArgs = {
  objects: Array<Plan_Type_Insert_Input>;
  on_conflict?: InputMaybe<Plan_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plan_Type_OneArgs = {
  object: Plan_Type_Insert_Input;
  on_conflict?: InputMaybe<Plan_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductArgs = {
  objects: Array<Product_Insert_Input>;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_OneArgs = {
  object: Product_Insert_Input;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_PurchaseArgs = {
  objects: Array<Product_Purchase_Insert_Input>;
  on_conflict?: InputMaybe<Product_Purchase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Purchase_OneArgs = {
  object: Product_Purchase_Insert_Input;
  on_conflict?: InputMaybe<Product_Purchase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_TypeArgs = {
  objects: Array<Product_Type_Insert_Input>;
  on_conflict?: InputMaybe<Product_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Type_OneArgs = {
  object: Product_Type_Insert_Input;
  on_conflict?: InputMaybe<Product_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PropertyArgs = {
  objects: Array<Property_Insert_Input>;
  on_conflict?: InputMaybe<Property_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_ClusterArgs = {
  objects: Array<Property_Cluster_Insert_Input>;
  on_conflict?: InputMaybe<Property_Cluster_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Cluster_OneArgs = {
  object: Property_Cluster_Insert_Input;
  on_conflict?: InputMaybe<Property_Cluster_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_CompositionArgs = {
  objects: Array<Property_Composition_Insert_Input>;
  on_conflict?: InputMaybe<Property_Composition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Composition_OneArgs = {
  object: Property_Composition_Insert_Input;
  on_conflict?: InputMaybe<Property_Composition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_FeatureArgs = {
  objects: Array<Property_Feature_Insert_Input>;
  on_conflict?: InputMaybe<Property_Feature_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Feature_OneArgs = {
  object: Property_Feature_Insert_Input;
  on_conflict?: InputMaybe<Property_Feature_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_FolderArgs = {
  objects: Array<Property_Folder_Insert_Input>;
  on_conflict?: InputMaybe<Property_Folder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_OneArgs = {
  object: Property_Folder_Insert_Input;
  on_conflict?: InputMaybe<Property_Folder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_ProfileArgs = {
  objects: Array<Property_Folder_Public_Profile_Insert_Input>;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_Profile_FaqArgs = {
  objects: Array<Property_Folder_Public_Profile_Faq_Insert_Input>;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Faq_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_Profile_Faq_OneArgs = {
  object: Property_Folder_Public_Profile_Faq_Insert_Input;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Faq_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_Profile_HighlightArgs = {
  objects: Array<Property_Folder_Public_Profile_Highlight_Insert_Input>;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Highlight_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_Profile_Highlight_OneArgs = {
  object: Property_Folder_Public_Profile_Highlight_Insert_Input;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Highlight_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_Profile_Listing_ExampleArgs = {
  objects: Array<Property_Folder_Public_Profile_Listing_Example_Insert_Input>;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_Profile_Listing_Example_OneArgs = {
  object: Property_Folder_Public_Profile_Listing_Example_Insert_Input;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_Profile_Nearby_PlaceArgs = {
  objects: Array<Property_Folder_Public_Profile_Nearby_Place_Insert_Input>;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_Profile_Nearby_Place_OneArgs = {
  object: Property_Folder_Public_Profile_Nearby_Place_Insert_Input;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_Profile_OneArgs = {
  object: Property_Folder_Public_Profile_Insert_Input;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_Profile_RelatedArgs = {
  objects: Array<Property_Folder_Public_Profile_Related_Insert_Input>;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Related_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_Profile_Related_OneArgs = {
  object: Property_Folder_Public_Profile_Related_Insert_Input;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Related_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_Profile_TranslationArgs = {
  objects: Array<Property_Folder_Public_Profile_Translation_Insert_Input>;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Translation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Folder_Public_Profile_Translation_OneArgs = {
  object: Property_Folder_Public_Profile_Translation_Insert_Input;
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Translation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_ImageArgs = {
  objects: Array<Property_Image_Insert_Input>;
  on_conflict?: InputMaybe<Property_Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Image_OneArgs = {
  object: Property_Image_Insert_Input;
  on_conflict?: InputMaybe<Property_Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_ListArgs = {
  objects: Array<Property_List_Insert_Input>;
  on_conflict?: InputMaybe<Property_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_List_ActivityArgs = {
  objects: Array<Property_List_Activity_Insert_Input>;
  on_conflict?: InputMaybe<Property_List_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_List_Activity_OneArgs = {
  object: Property_List_Activity_Insert_Input;
  on_conflict?: InputMaybe<Property_List_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_List_FolderArgs = {
  objects: Array<Property_List_Folder_Insert_Input>;
  on_conflict?: InputMaybe<Property_List_Folder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_List_Folder_OneArgs = {
  object: Property_List_Folder_Insert_Input;
  on_conflict?: InputMaybe<Property_List_Folder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_List_OneArgs = {
  object: Property_List_Insert_Input;
  on_conflict?: InputMaybe<Property_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_List_ReportArgs = {
  objects: Array<Property_List_Report_Insert_Input>;
  on_conflict?: InputMaybe<Property_List_Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_List_Report_OneArgs = {
  object: Property_List_Report_Insert_Input;
  on_conflict?: InputMaybe<Property_List_Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_OneArgs = {
  object: Property_Insert_Input;
  on_conflict?: InputMaybe<Property_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_OriginArgs = {
  objects: Array<Property_Origin_Insert_Input>;
  on_conflict?: InputMaybe<Property_Origin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Origin_OneArgs = {
  object: Property_Origin_Insert_Input;
  on_conflict?: InputMaybe<Property_Origin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Origin_TypeArgs = {
  objects: Array<Property_Origin_Type_Insert_Input>;
  on_conflict?: InputMaybe<Property_Origin_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Origin_Type_OneArgs = {
  object: Property_Origin_Type_Insert_Input;
  on_conflict?: InputMaybe<Property_Origin_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_OwnerArgs = {
  objects: Array<Property_Owner_Insert_Input>;
  on_conflict?: InputMaybe<Property_Owner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Owner_OneArgs = {
  object: Property_Owner_Insert_Input;
  on_conflict?: InputMaybe<Property_Owner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Place_ReferenceArgs = {
  objects: Array<Property_Place_Reference_Insert_Input>;
  on_conflict?: InputMaybe<Property_Place_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Place_Reference_OneArgs = {
  object: Property_Place_Reference_Insert_Input;
  on_conflict?: InputMaybe<Property_Place_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Price_HistoryArgs = {
  objects: Array<Property_Price_History_Insert_Input>;
  on_conflict?: InputMaybe<Property_Price_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Price_History_OneArgs = {
  object: Property_Price_History_Insert_Input;
  on_conflict?: InputMaybe<Property_Price_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Report_TypeArgs = {
  objects: Array<Property_Report_Type_Insert_Input>;
  on_conflict?: InputMaybe<Property_Report_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Report_Type_OneArgs = {
  object: Property_Report_Type_Insert_Input;
  on_conflict?: InputMaybe<Property_Report_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_SourceArgs = {
  objects: Array<Property_Source_Insert_Input>;
  on_conflict?: InputMaybe<Property_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Source_OneArgs = {
  object: Property_Source_Insert_Input;
  on_conflict?: InputMaybe<Property_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_StatusArgs = {
  objects: Array<Property_Status_Insert_Input>;
  on_conflict?: InputMaybe<Property_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Status_OneArgs = {
  object: Property_Status_Insert_Input;
  on_conflict?: InputMaybe<Property_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_TypeArgs = {
  objects: Array<Property_Type_Insert_Input>;
  on_conflict?: InputMaybe<Property_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Type_OneArgs = {
  object: Property_Type_Insert_Input;
  on_conflict?: InputMaybe<Property_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_ViewsArgs = {
  objects: Array<Property_Views_Insert_Input>;
  on_conflict?: InputMaybe<Property_Views_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Views_OneArgs = {
  object: Property_Views_Insert_Input;
  on_conflict?: InputMaybe<Property_Views_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queries_Property_ResultArgs = {
  objects: Array<Queries_Property_Result_Insert_Input>;
  on_conflict?: InputMaybe<Queries_Property_Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queries_Property_Result_OneArgs = {
  object: Queries_Property_Result_Insert_Input;
  on_conflict?: InputMaybe<Queries_Property_Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queries_Property_Result_ReArgs = {
  objects: Array<Queries_Property_Result_Re_Insert_Input>;
  on_conflict?: InputMaybe<Queries_Property_Result_Re_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queries_Property_Result_Re_OneArgs = {
  object: Queries_Property_Result_Re_Insert_Input;
  on_conflict?: InputMaybe<Queries_Property_Result_Re_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Query_ClassificationArgs = {
  objects: Array<Query_Classification_Insert_Input>;
  on_conflict?: InputMaybe<Query_Classification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Query_Classification_OneArgs = {
  object: Query_Classification_Insert_Input;
  on_conflict?: InputMaybe<Query_Classification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Query_Classification_ReArgs = {
  objects: Array<Query_Classification_Re_Insert_Input>;
  on_conflict?: InputMaybe<Query_Classification_Re_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Query_Classification_Re_OneArgs = {
  object: Query_Classification_Re_Insert_Input;
  on_conflict?: InputMaybe<Query_Classification_Re_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Raw_LocationArgs = {
  objects: Array<Raw_Location_Insert_Input>;
  on_conflict?: InputMaybe<Raw_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Raw_Location_OneArgs = {
  object: Raw_Location_Insert_Input;
  on_conflict?: InputMaybe<Raw_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RedirectArgs = {
  objects: Array<Redirect_Insert_Input>;
  on_conflict?: InputMaybe<Redirect_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Redirect_OneArgs = {
  object: Redirect_Insert_Input;
  on_conflict?: InputMaybe<Redirect_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reference_Price_HistoryArgs = {
  objects: Array<Reference_Price_History_Insert_Input>;
  on_conflict?: InputMaybe<Reference_Price_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reference_Price_History_OneArgs = {
  object: Reference_Price_History_Insert_Input;
  on_conflict?: InputMaybe<Reference_Price_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reference_ZoneArgs = {
  objects: Array<Reference_Zone_Insert_Input>;
  on_conflict?: InputMaybe<Reference_Zone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reference_Zone_OneArgs = {
  object: Reference_Zone_Insert_Input;
  on_conflict?: InputMaybe<Reference_Zone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Search_ContextArgs = {
  objects: Array<Search_Context_Insert_Input>;
  on_conflict?: InputMaybe<Search_Context_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Context_LocationArgs = {
  objects: Array<Search_Context_Location_Insert_Input>;
  on_conflict?: InputMaybe<Search_Context_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Context_Location_OneArgs = {
  object: Search_Context_Location_Insert_Input;
  on_conflict?: InputMaybe<Search_Context_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Context_OneArgs = {
  object: Search_Context_Insert_Input;
  on_conflict?: InputMaybe<Search_Context_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Search_DomainArgs = {
  objects: Array<Search_Domain_Insert_Input>;
  on_conflict?: InputMaybe<Search_Domain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Domain_OneArgs = {
  object: Search_Domain_Insert_Input;
  on_conflict?: InputMaybe<Search_Domain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Search_SessionsArgs = {
  objects: Array<Search_Sessions_Insert_Input>;
  on_conflict?: InputMaybe<Search_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Sessions_OneArgs = {
  object: Search_Sessions_Insert_Input;
  on_conflict?: InputMaybe<Search_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Search_SlugsArgs = {
  objects: Array<Search_Slugs_Insert_Input>;
  on_conflict?: InputMaybe<Search_Slugs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Slugs_OneArgs = {
  object: Search_Slugs_Insert_Input;
  on_conflict?: InputMaybe<Search_Slugs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seo_CityArgs = {
  objects: Array<Seo_City_Insert_Input>;
  on_conflict?: InputMaybe<Seo_City_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seo_City_OneArgs = {
  object: Seo_City_Insert_Input;
  on_conflict?: InputMaybe<Seo_City_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Session_OriginArgs = {
  objects: Array<Session_Origin_Insert_Input>;
  on_conflict?: InputMaybe<Session_Origin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Session_Origin_OneArgs = {
  object: Session_Origin_Insert_Input;
  on_conflict?: InputMaybe<Session_Origin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sponsored_Property_ListArgs = {
  objects: Array<Sponsored_Property_List_Insert_Input>;
  on_conflict?: InputMaybe<Sponsored_Property_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sponsored_Property_List_OneArgs = {
  object: Sponsored_Property_List_Insert_Input;
  on_conflict?: InputMaybe<Sponsored_Property_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubscriptionArgs = {
  objects: Array<Subscription_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_InvoiceArgs = {
  objects: Array<Subscription_Invoice_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Invoice_OneArgs = {
  object: Subscription_Invoice_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_OneArgs = {
  object: Subscription_Insert_Input;
  on_conflict?: InputMaybe<Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_SourceArgs = {
  objects: Array<Subscription_Source_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Source_OneArgs = {
  object: Subscription_Source_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_StatusArgs = {
  objects: Array<Subscription_Status_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Status_OneArgs = {
  object: Subscription_Status_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Text_ContentArgs = {
  objects: Array<Text_Content_Insert_Input>;
  on_conflict?: InputMaybe<Text_Content_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Text_Content_OneArgs = {
  object: Text_Content_Insert_Input;
  on_conflict?: InputMaybe<Text_Content_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TranslationsArgs = {
  objects: Array<Translations_Insert_Input>;
  on_conflict?: InputMaybe<Translations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Translations_OneArgs = {
  object: Translations_Insert_Input;
  on_conflict?: InputMaybe<Translations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Url_SlugArgs = {
  objects: Array<Url_Slug_Insert_Input>;
  on_conflict?: InputMaybe<Url_Slug_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Url_Slug_OneArgs = {
  object: Url_Slug_Insert_Input;
  on_conflict?: InputMaybe<Url_Slug_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_FiltersArgs = {
  objects: Array<User_Filters_Insert_Input>;
  on_conflict?: InputMaybe<User_Filters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Filters_FeaturesArgs = {
  objects: Array<User_Filters_Features_Insert_Input>;
  on_conflict?: InputMaybe<User_Filters_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Filters_Features_OneArgs = {
  object: User_Filters_Features_Insert_Input;
  on_conflict?: InputMaybe<User_Filters_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Filters_OneArgs = {
  object: User_Filters_Insert_Input;
  on_conflict?: InputMaybe<User_Filters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OrganizationArgs = {
  objects: Array<User_Organization_Insert_Input>;
  on_conflict?: InputMaybe<User_Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Organization_OneArgs = {
  object: User_Organization_Insert_Input;
  on_conflict?: InputMaybe<User_Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_PreferencesArgs = {
  objects: Array<User_Preferences_Insert_Input>;
  on_conflict?: InputMaybe<User_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Preferences_OneArgs = {
  object: User_Preferences_Insert_Input;
  on_conflict?: InputMaybe<User_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Property_NotifiationArgs = {
  objects: Array<User_Property_Notifiation_Insert_Input>;
  on_conflict?: InputMaybe<User_Property_Notifiation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Property_Notifiation_OneArgs = {
  object: User_Property_Notifiation_Insert_Input;
  on_conflict?: InputMaybe<User_Property_Notifiation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Saved_PropertiesArgs = {
  objects: Array<User_Saved_Properties_Insert_Input>;
  on_conflict?: InputMaybe<User_Saved_Properties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Saved_Properties_OneArgs = {
  object: User_Saved_Properties_Insert_Input;
  on_conflict?: InputMaybe<User_Saved_Properties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Seen_PropertyArgs = {
  objects: Array<User_Seen_Property_Insert_Input>;
  on_conflict?: InputMaybe<User_Seen_Property_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Seen_Property_OneArgs = {
  object: User_Seen_Property_Insert_Input;
  on_conflict?: InputMaybe<User_Seen_Property_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Activity_SummaryArgs = {
  objects: Array<Users_Activity_Summary_Insert_Input>;
  on_conflict?: InputMaybe<Users_Activity_Summary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Activity_Summary_OneArgs = {
  object: Users_Activity_Summary_Insert_Input;
  on_conflict?: InputMaybe<Users_Activity_Summary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Visibility_StatusArgs = {
  objects: Array<Visibility_Status_Insert_Input>;
  on_conflict?: InputMaybe<Visibility_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Visibility_Status_OneArgs = {
  object: Visibility_Status_Insert_Input;
  on_conflict?: InputMaybe<Visibility_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Ai_Inbound_MessageArgs = {
  objects: Array<Whatsapp_Ai_Inbound_Message_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp_Ai_Inbound_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Ai_Inbound_Message_OneArgs = {
  object: Whatsapp_Ai_Inbound_Message_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp_Ai_Inbound_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Ai_Outbox_PartArgs = {
  objects: Array<Whatsapp_Ai_Outbox_Part_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp_Ai_Outbox_Part_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Ai_Outbox_Part_OneArgs = {
  object: Whatsapp_Ai_Outbox_Part_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp_Ai_Outbox_Part_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Ai_TurnArgs = {
  objects: Array<Whatsapp_Ai_Turn_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp_Ai_Turn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Ai_Turn_OneArgs = {
  object: Whatsapp_Ai_Turn_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp_Ai_Turn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_ChatArgs = {
  objects: Array<Whatsapp_Chat_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp_Chat_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Chat_OneArgs = {
  object: Whatsapp_Chat_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp_Chat_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_HumanArgs = {
  objects: Array<Whatsapp_Human_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp_Human_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Human_OneArgs = {
  object: Whatsapp_Human_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp_Human_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Zone_ContainsArgs = {
  objects: Array<Zone_Contains_Insert_Input>;
  on_conflict?: InputMaybe<Zone_Contains_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Zone_Contains_OneArgs = {
  object: Zone_Contains_Insert_Input;
  on_conflict?: InputMaybe<Zone_Contains_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Zone_Data_MethodArgs = {
  objects: Array<Zone_Data_Method_Insert_Input>;
  on_conflict?: InputMaybe<Zone_Data_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Zone_Data_Method_OneArgs = {
  object: Zone_Data_Method_Insert_Input;
  on_conflict?: InputMaybe<Zone_Data_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootMaintain_Whatsapp_Ai_LedgerArgs = {
  args?: InputMaybe<Maintain_Whatsapp_Ai_Ledger_Args>;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootMark_Whatsapp_Ai_Outbox_Part_AmbiguousArgs = {
  args: Mark_Whatsapp_Ai_Outbox_Part_Ambiguous_Args;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootMark_Whatsapp_Ai_Outbox_Part_DispatchedArgs = {
  args: Mark_Whatsapp_Ai_Outbox_Part_Dispatched_Args;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootMembership_Free_TrialArgs = {
  body: FreeTrialInput;
};


/** mutation root */
export type Mutation_RootPaginated_SearchArgs = {
  search_pagination: SearchPaginationInput;
};


/** mutation root */
export type Mutation_RootPayment_SuccessArgs = {
  body: PaymentSuccessInput;
};


/** mutation root */
export type Mutation_RootPotential_Buyer_PropertiesArgs = {
  body: PotentialBuyerPropertiesInput;
};


/** mutation root */
export type Mutation_RootProcess_User_NotificationArgs = {
  body: Input;
};


/** mutation root */
export type Mutation_RootPromptSearchArgs = {
  body?: InputMaybe<QuestionInput>;
};


/** mutation root */
export type Mutation_RootProperty_Duplicate_ApproveArgs = {
  body: PropertyDuplicateApproveInput;
};


/** mutation root */
export type Mutation_RootProperty_Duplicate_CheckArgs = {
  body: PropertyDuplicateCheckInput;
};


/** mutation root */
export type Mutation_RootQuerySearchArgs = {
  arg1: SampleInput;
};


/** mutation root */
export type Mutation_RootRebuild_Zone_Contains_For_ZoneArgs = {
  args: Rebuild_Zone_Contains_For_Zone_Args;
  distinct_on?: InputMaybe<Array<Zone_Contains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Contains_Order_By>>;
  where?: InputMaybe<Zone_Contains_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootReconcile_Whatsapp_Ai_Outbox_EchoArgs = {
  args: Reconcile_Whatsapp_Ai_Outbox_Echo_Args;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootReconcile_Whatsapp_Ai_Outbox_PartArgs = {
  args: Reconcile_Whatsapp_Ai_Outbox_Part_Args;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootRedact_Expired_Whatsapp_Ai_Inbound_MetadataArgs = {
  args?: InputMaybe<Redact_Expired_Whatsapp_Ai_Inbound_Metadata_Args>;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Inbound_Message_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootRedact_Expired_Whatsapp_Ai_Outbox_PayloadsArgs = {
  args?: InputMaybe<Redact_Expired_Whatsapp_Ai_Outbox_Payloads_Args>;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootRedact_Expired_Whatsapp_Ai_Turn_MetadataArgs = {
  args?: InputMaybe<Redact_Expired_Whatsapp_Ai_Turn_Metadata_Args>;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Turn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Turn_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootRegenerate_Query_ResultsArgs = {
  body?: InputMaybe<RegenerateInput>;
};


/** mutation root */
export type Mutation_RootRegister_Whatsapp_Ai_TurnArgs = {
  args: Register_Whatsapp_Ai_Turn_Args;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Turn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Turn_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootRenew_Whatsapp_Ai_Turn_LeaseArgs = {
  args: Renew_Whatsapp_Ai_Turn_Lease_Args;
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Turn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Turn_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootResend_InvitationArgs = {
  body: ResendInvitationInput;
};


/** mutation root */
export type Mutation_RootSend_Verification_CodeArgs = {
  body: PhoneInput;
};


/** mutation root */
export type Mutation_RootTranslate_TextArgs = {
  body: TranslateInput;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderArgs = {
  _set?: InputMaybe<AuthProviders_Set_Input>;
  pk_columns: AuthProviders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestArgs = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  pk_columns: AuthProviderRequests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestsArgs = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  where: AuthProviderRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthProvidersArgs = {
  _set?: InputMaybe<AuthProviders_Set_Input>;
  where: AuthProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenArgs = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  pk_columns: AuthRefreshTokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypeArgs = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  pk_columns: AuthRefreshTokenTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypesArgs = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  where: AuthRefreshTokenTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokensArgs = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  where: AuthRefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRoleArgs = {
  _set?: InputMaybe<AuthRoles_Set_Input>;
  pk_columns: AuthRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRolesArgs = {
  _set?: InputMaybe<AuthRoles_Set_Input>;
  where: AuthRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProviderArgs = {
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  pk_columns: AuthUserProviders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProvidersArgs = {
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  where: AuthUserProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRoleArgs = {
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  pk_columns: AuthUserRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRolesArgs = {
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  where: AuthUserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeyArgs = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  pk_columns: AuthUserSecurityKeys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeysArgs = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  where: AuthUserSecurityKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateBucketArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  pk_columns: Buckets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateBucketsArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFileArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFilesArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateVirusArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  pk_columns: Virus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateVirusesArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_TypesArgs = {
  _set?: InputMaybe<Address_Types_Set_Input>;
  where: Address_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Types_By_PkArgs = {
  _set?: InputMaybe<Address_Types_Set_Input>;
  pk_columns: Address_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Types_ManyArgs = {
  updates: Array<Address_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AgencyArgs = {
  _set?: InputMaybe<Agency_Set_Input>;
  where: Agency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agency_By_PkArgs = {
  _set?: InputMaybe<Agency_Set_Input>;
  pk_columns: Agency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agency_ManyArgs = {
  updates: Array<Agency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agency_TypeArgs = {
  _set?: InputMaybe<Agency_Type_Set_Input>;
  where: Agency_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agency_Type_By_PkArgs = {
  _set?: InputMaybe<Agency_Type_Set_Input>;
  pk_columns: Agency_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agency_Type_ManyArgs = {
  updates: Array<Agency_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_ActionArgs = {
  _append?: InputMaybe<Agent_Action_Append_Input>;
  _delete_at_path?: InputMaybe<Agent_Action_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Agent_Action_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Agent_Action_Delete_Key_Input>;
  _prepend?: InputMaybe<Agent_Action_Prepend_Input>;
  _set?: InputMaybe<Agent_Action_Set_Input>;
  where: Agent_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_Action_By_PkArgs = {
  _append?: InputMaybe<Agent_Action_Append_Input>;
  _delete_at_path?: InputMaybe<Agent_Action_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Agent_Action_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Agent_Action_Delete_Key_Input>;
  _prepend?: InputMaybe<Agent_Action_Prepend_Input>;
  _set?: InputMaybe<Agent_Action_Set_Input>;
  pk_columns: Agent_Action_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_Action_ManyArgs = {
  updates: Array<Agent_Action_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_TaskArgs = {
  _append?: InputMaybe<Agent_Task_Append_Input>;
  _delete_at_path?: InputMaybe<Agent_Task_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Agent_Task_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Agent_Task_Delete_Key_Input>;
  _prepend?: InputMaybe<Agent_Task_Prepend_Input>;
  _set?: InputMaybe<Agent_Task_Set_Input>;
  where: Agent_Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_Task_By_PkArgs = {
  _append?: InputMaybe<Agent_Task_Append_Input>;
  _delete_at_path?: InputMaybe<Agent_Task_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Agent_Task_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Agent_Task_Delete_Key_Input>;
  _prepend?: InputMaybe<Agent_Task_Prepend_Input>;
  _set?: InputMaybe<Agent_Task_Set_Input>;
  pk_columns: Agent_Task_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_Task_ManyArgs = {
  updates: Array<Agent_Task_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AmenitiesArgs = {
  _set?: InputMaybe<Amenities_Set_Input>;
  where: Amenities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Amenities_By_PkArgs = {
  _set?: InputMaybe<Amenities_Set_Input>;
  pk_columns: Amenities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Amenities_ManyArgs = {
  updates: Array<Amenities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_App_ConfigArgs = {
  _set?: InputMaybe<App_Config_Set_Input>;
  where: App_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_App_Config_By_PkArgs = {
  _set?: InputMaybe<App_Config_Set_Input>;
  pk_columns: App_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_App_Config_ManyArgs = {
  updates: Array<App_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviderRequests_ManyArgs = {
  updates: Array<AuthProviderRequests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviders_ManyArgs = {
  updates: Array<AuthProviders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokenTypes_ManyArgs = {
  updates: Array<AuthRefreshTokenTypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokens_ManyArgs = {
  updates: Array<AuthRefreshTokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRoles_ManyArgs = {
  updates: Array<AuthRoles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserProviders_ManyArgs = {
  updates: Array<AuthUserProviders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserRoles_ManyArgs = {
  updates: Array<AuthUserRoles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserSecurityKeys_ManyArgs = {
  updates: Array<AuthUserSecurityKeys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BlogArgs = {
  _append?: InputMaybe<Blog_Append_Input>;
  _delete_at_path?: InputMaybe<Blog_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Blog_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Blog_Delete_Key_Input>;
  _prepend?: InputMaybe<Blog_Prepend_Input>;
  _set?: InputMaybe<Blog_Set_Input>;
  where: Blog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Blog_By_PkArgs = {
  _append?: InputMaybe<Blog_Append_Input>;
  _delete_at_path?: InputMaybe<Blog_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Blog_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Blog_Delete_Key_Input>;
  _prepend?: InputMaybe<Blog_Prepend_Input>;
  _set?: InputMaybe<Blog_Set_Input>;
  pk_columns: Blog_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Blog_ManyArgs = {
  updates: Array<Blog_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Blog_PostArgs = {
  _append?: InputMaybe<Blog_Post_Append_Input>;
  _delete_at_path?: InputMaybe<Blog_Post_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Blog_Post_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Blog_Post_Delete_Key_Input>;
  _prepend?: InputMaybe<Blog_Post_Prepend_Input>;
  _set?: InputMaybe<Blog_Post_Set_Input>;
  where: Blog_Post_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Blog_Post_By_PkArgs = {
  _append?: InputMaybe<Blog_Post_Append_Input>;
  _delete_at_path?: InputMaybe<Blog_Post_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Blog_Post_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Blog_Post_Delete_Key_Input>;
  _prepend?: InputMaybe<Blog_Post_Prepend_Input>;
  _set?: InputMaybe<Blog_Post_Set_Input>;
  pk_columns: Blog_Post_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Blog_Post_ManyArgs = {
  updates: Array<Blog_Post_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Blog_SectionArgs = {
  _set?: InputMaybe<Blog_Section_Set_Input>;
  where: Blog_Section_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Blog_Section_By_PkArgs = {
  _set?: InputMaybe<Blog_Section_Set_Input>;
  pk_columns: Blog_Section_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Blog_Section_ManyArgs = {
  updates: Array<Blog_Section_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Blog_StatusArgs = {
  _set?: InputMaybe<Blog_Status_Set_Input>;
  where: Blog_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Blog_Status_By_PkArgs = {
  _set?: InputMaybe<Blog_Status_Set_Input>;
  pk_columns: Blog_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Blog_Status_ManyArgs = {
  updates: Array<Blog_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buckets_ManyArgs = {
  updates: Array<Buckets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BuilderArgs = {
  _set?: InputMaybe<Builder_Set_Input>;
  where: Builder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Builder_By_PkArgs = {
  _set?: InputMaybe<Builder_Set_Input>;
  pk_columns: Builder_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Builder_ManyArgs = {
  updates: Array<Builder_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Certified_AgentArgs = {
  _inc?: InputMaybe<Certified_Agent_Inc_Input>;
  _set?: InputMaybe<Certified_Agent_Set_Input>;
  where: Certified_Agent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Certified_Agent_By_PkArgs = {
  _inc?: InputMaybe<Certified_Agent_Inc_Input>;
  _set?: InputMaybe<Certified_Agent_Set_Input>;
  pk_columns: Certified_Agent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Certified_Agent_ManyArgs = {
  updates: Array<Certified_Agent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Response_TypeArgs = {
  _set?: InputMaybe<Chat_Response_Type_Set_Input>;
  where: Chat_Response_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Response_Type_By_PkArgs = {
  _set?: InputMaybe<Chat_Response_Type_Set_Input>;
  pk_columns: Chat_Response_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Response_Type_ManyArgs = {
  updates: Array<Chat_Response_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CityArgs = {
  _append?: InputMaybe<City_Append_Input>;
  _delete_at_path?: InputMaybe<City_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<City_Delete_Elem_Input>;
  _delete_key?: InputMaybe<City_Delete_Key_Input>;
  _prepend?: InputMaybe<City_Prepend_Input>;
  _set?: InputMaybe<City_Set_Input>;
  where: City_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_City_By_PkArgs = {
  _append?: InputMaybe<City_Append_Input>;
  _delete_at_path?: InputMaybe<City_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<City_Delete_Elem_Input>;
  _delete_key?: InputMaybe<City_Delete_Key_Input>;
  _prepend?: InputMaybe<City_Prepend_Input>;
  _set?: InputMaybe<City_Set_Input>;
  pk_columns: City_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_City_ManyArgs = {
  updates: Array<City_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_City_ZoneArgs = {
  _append?: InputMaybe<City_Zone_Append_Input>;
  _delete_at_path?: InputMaybe<City_Zone_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<City_Zone_Delete_Elem_Input>;
  _delete_key?: InputMaybe<City_Zone_Delete_Key_Input>;
  _inc?: InputMaybe<City_Zone_Inc_Input>;
  _prepend?: InputMaybe<City_Zone_Prepend_Input>;
  _set?: InputMaybe<City_Zone_Set_Input>;
  where: City_Zone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_City_Zone_By_PkArgs = {
  _append?: InputMaybe<City_Zone_Append_Input>;
  _delete_at_path?: InputMaybe<City_Zone_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<City_Zone_Delete_Elem_Input>;
  _delete_key?: InputMaybe<City_Zone_Delete_Key_Input>;
  _inc?: InputMaybe<City_Zone_Inc_Input>;
  _prepend?: InputMaybe<City_Zone_Prepend_Input>;
  _set?: InputMaybe<City_Zone_Set_Input>;
  pk_columns: City_Zone_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_City_Zone_ManyArgs = {
  updates: Array<City_Zone_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_City_Zone_OriginArgs = {
  _set?: InputMaybe<City_Zone_Origin_Set_Input>;
  where: City_Zone_Origin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_City_Zone_Origin_By_PkArgs = {
  _set?: InputMaybe<City_Zone_Origin_Set_Input>;
  pk_columns: City_Zone_Origin_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_City_Zone_Origin_ManyArgs = {
  updates: Array<City_Zone_Origin_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Claim_Request_StatusArgs = {
  _set?: InputMaybe<Claim_Request_Status_Set_Input>;
  where: Claim_Request_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Claim_Request_Status_By_PkArgs = {
  _set?: InputMaybe<Claim_Request_Status_Set_Input>;
  pk_columns: Claim_Request_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Claim_Request_Status_ManyArgs = {
  updates: Array<Claim_Request_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CleringArgs = {
  _set?: InputMaybe<Clering_Set_Input>;
  where: Clering_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Clering_By_PkArgs = {
  _set?: InputMaybe<Clering_Set_Input>;
  pk_columns: Clering_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Clering_ManyArgs = {
  updates: Array<Clering_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Construction_StatusArgs = {
  _set?: InputMaybe<Construction_Status_Set_Input>;
  where: Construction_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Construction_Status_By_PkArgs = {
  _set?: InputMaybe<Construction_Status_Set_Input>;
  pk_columns: Construction_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Construction_Status_ManyArgs = {
  updates: Array<Construction_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ContactArgs = {
  _set?: InputMaybe<Contact_Set_Input>;
  where: Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_By_PkArgs = {
  _set?: InputMaybe<Contact_Set_Input>;
  pk_columns: Contact_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_ManyArgs = {
  updates: Array<Contact_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_Phone_NumberArgs = {
  _set?: InputMaybe<Contact_Phone_Number_Set_Input>;
  where: Contact_Phone_Number_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_Phone_Number_By_PkArgs = {
  _set?: InputMaybe<Contact_Phone_Number_Set_Input>;
  pk_columns: Contact_Phone_Number_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_Phone_Number_ManyArgs = {
  updates: Array<Contact_Phone_Number_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_TypeArgs = {
  _set?: InputMaybe<Contact_Type_Set_Input>;
  where: Contact_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_Type_By_PkArgs = {
  _set?: InputMaybe<Contact_Type_Set_Input>;
  pk_columns: Contact_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_Type_ManyArgs = {
  updates: Array<Contact_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Content_TypeArgs = {
  _set?: InputMaybe<Content_Type_Set_Input>;
  where: Content_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Content_Type_By_PkArgs = {
  _set?: InputMaybe<Content_Type_Set_Input>;
  pk_columns: Content_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Content_Type_ManyArgs = {
  updates: Array<Content_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CountriesArgs = {
  _inc?: InputMaybe<Countries_Inc_Input>;
  _set?: InputMaybe<Countries_Set_Input>;
  where: Countries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Countries_By_PkArgs = {
  _inc?: InputMaybe<Countries_Inc_Input>;
  _set?: InputMaybe<Countries_Set_Input>;
  pk_columns: Countries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Countries_ManyArgs = {
  updates: Array<Countries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CountryArgs = {
  _set?: InputMaybe<Country_Set_Input>;
  where: Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Country_By_PkArgs = {
  _set?: InputMaybe<Country_Set_Input>;
  pk_columns: Country_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Country_ManyArgs = {
  updates: Array<Country_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CurrencyArgs = {
  _set?: InputMaybe<Currency_Set_Input>;
  where: Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Currency_By_PkArgs = {
  _set?: InputMaybe<Currency_Set_Input>;
  pk_columns: Currency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Currency_Exchange_RatesArgs = {
  _inc?: InputMaybe<Currency_Exchange_Rates_Inc_Input>;
  _set?: InputMaybe<Currency_Exchange_Rates_Set_Input>;
  where: Currency_Exchange_Rates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Currency_Exchange_Rates_By_PkArgs = {
  _inc?: InputMaybe<Currency_Exchange_Rates_Inc_Input>;
  _set?: InputMaybe<Currency_Exchange_Rates_Set_Input>;
  pk_columns: Currency_Exchange_Rates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Currency_Exchange_Rates_ManyArgs = {
  updates: Array<Currency_Exchange_Rates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Currency_ManyArgs = {
  updates: Array<Currency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntitiesArgs = {
  _set?: InputMaybe<Entities_Set_Input>;
  where: Entities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Entities_By_PkArgs = {
  _set?: InputMaybe<Entities_Set_Input>;
  pk_columns: Entities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Entities_ManyArgs = {
  updates: Array<Entities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_RatesArgs = {
  _inc?: InputMaybe<Exchange_Rates_Inc_Input>;
  _set?: InputMaybe<Exchange_Rates_Set_Input>;
  where: Exchange_Rates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_Rates_By_PkArgs = {
  _inc?: InputMaybe<Exchange_Rates_Inc_Input>;
  _set?: InputMaybe<Exchange_Rates_Set_Input>;
  pk_columns: Exchange_Rates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_Rates_ManyArgs = {
  updates: Array<Exchange_Rates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FeatureArgs = {
  _inc?: InputMaybe<Feature_Inc_Input>;
  _set?: InputMaybe<Feature_Set_Input>;
  where: Feature_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_By_PkArgs = {
  _inc?: InputMaybe<Feature_Inc_Input>;
  _set?: InputMaybe<Feature_Set_Input>;
  pk_columns: Feature_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_ManyArgs = {
  updates: Array<Feature_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_TypeArgs = {
  _set?: InputMaybe<Feature_Type_Set_Input>;
  where: Feature_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Type_By_PkArgs = {
  _set?: InputMaybe<Feature_Type_Set_Input>;
  pk_columns: Feature_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Type_ManyArgs = {
  updates: Array<Feature_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_File_TypeArgs = {
  _set?: InputMaybe<File_Type_Set_Input>;
  where: File_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_Type_By_PkArgs = {
  _set?: InputMaybe<File_Type_Set_Input>;
  pk_columns: File_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_File_Type_ManyArgs = {
  updates: Array<File_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_AmenitiesArgs = {
  _set?: InputMaybe<Folder_Amenities_Set_Input>;
  where: Folder_Amenities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_Amenities_By_PkArgs = {
  _set?: InputMaybe<Folder_Amenities_Set_Input>;
  pk_columns: Folder_Amenities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_Amenities_ManyArgs = {
  updates: Array<Folder_Amenities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_ImageArgs = {
  _set?: InputMaybe<Folder_Image_Set_Input>;
  where: Folder_Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_Image_By_PkArgs = {
  _set?: InputMaybe<Folder_Image_Set_Input>;
  pk_columns: Folder_Image_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_Image_ManyArgs = {
  updates: Array<Folder_Image_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_Properties_TypeArgs = {
  _inc?: InputMaybe<Folder_Properties_Type_Inc_Input>;
  _set?: InputMaybe<Folder_Properties_Type_Set_Input>;
  where: Folder_Properties_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_Properties_Type_By_PkArgs = {
  _inc?: InputMaybe<Folder_Properties_Type_Inc_Input>;
  _set?: InputMaybe<Folder_Properties_Type_Set_Input>;
  pk_columns: Folder_Properties_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_Properties_Type_ManyArgs = {
  updates: Array<Folder_Properties_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_StatusArgs = {
  _set?: InputMaybe<Folder_Status_Set_Input>;
  where: Folder_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_Status_By_PkArgs = {
  _set?: InputMaybe<Folder_Status_Set_Input>;
  pk_columns: Folder_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_Status_ManyArgs = {
  updates: Array<Folder_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_TypeArgs = {
  _set?: InputMaybe<Folder_Type_Set_Input>;
  where: Folder_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_Type_By_PkArgs = {
  _set?: InputMaybe<Folder_Type_Set_Input>;
  pk_columns: Folder_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Folder_Type_ManyArgs = {
  updates: Array<Folder_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Furnishing_StatusArgs = {
  _set?: InputMaybe<Furnishing_Status_Set_Input>;
  where: Furnishing_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Furnishing_Status_By_PkArgs = {
  _set?: InputMaybe<Furnishing_Status_Set_Input>;
  pk_columns: Furnishing_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Furnishing_Status_ManyArgs = {
  updates: Array<Furnishing_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Google_CalendarArgs = {
  _set?: InputMaybe<Google_Calendar_Set_Input>;
  where: Google_Calendar_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Google_Calendar_By_PkArgs = {
  _set?: InputMaybe<Google_Calendar_Set_Input>;
  pk_columns: Google_Calendar_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Google_Calendar_ManyArgs = {
  updates: Array<Google_Calendar_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_HeatingTypeArgs = {
  _set?: InputMaybe<HeatingType_Set_Input>;
  where: HeatingType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_HeatingType_By_PkArgs = {
  _set?: InputMaybe<HeatingType_Set_Input>;
  pk_columns: HeatingType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_HeatingType_ManyArgs = {
  updates: Array<HeatingType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ImageArgs = {
  _set?: InputMaybe<Image_Set_Input>;
  where: Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Image_By_PkArgs = {
  _set?: InputMaybe<Image_Set_Input>;
  pk_columns: Image_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Image_ManyArgs = {
  updates: Array<Image_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_StatusArgs = {
  _set?: InputMaybe<Invoice_Status_Set_Input>;
  where: Invoice_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Status_By_PkArgs = {
  _set?: InputMaybe<Invoice_Status_Set_Input>;
  pk_columns: Invoice_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Status_ManyArgs = {
  updates: Array<Invoice_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LanguagesArgs = {
  _inc?: InputMaybe<Languages_Inc_Input>;
  _set?: InputMaybe<Languages_Set_Input>;
  where: Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Languages_By_PkArgs = {
  _inc?: InputMaybe<Languages_Inc_Input>;
  _set?: InputMaybe<Languages_Set_Input>;
  pk_columns: Languages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Languages_ManyArgs = {
  updates: Array<Languages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Property_CategoryArgs = {
  _set?: InputMaybe<Lead_Property_Category_Set_Input>;
  where: Lead_Property_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Property_Category_By_PkArgs = {
  _set?: InputMaybe<Lead_Property_Category_Set_Input>;
  pk_columns: Lead_Property_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Property_Category_ManyArgs = {
  updates: Array<Lead_Property_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_StatusArgs = {
  _set?: InputMaybe<Lead_Status_Set_Input>;
  where: Lead_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Status_By_PkArgs = {
  _set?: InputMaybe<Lead_Status_Set_Input>;
  pk_columns: Lead_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Status_ManyArgs = {
  updates: Array<Lead_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_TypeArgs = {
  _set?: InputMaybe<Lead_Type_Set_Input>;
  where: Lead_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Type_By_PkArgs = {
  _set?: InputMaybe<Lead_Type_Set_Input>;
  pk_columns: Lead_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Type_ManyArgs = {
  updates: Array<Lead_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Claim_RequestArgs = {
  _set?: InputMaybe<Lister_Claim_Request_Set_Input>;
  where: Lister_Claim_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Claim_Request_ActivityArgs = {
  _set?: InputMaybe<Lister_Claim_Request_Activity_Set_Input>;
  where: Lister_Claim_Request_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Claim_Request_Activity_By_PkArgs = {
  _set?: InputMaybe<Lister_Claim_Request_Activity_Set_Input>;
  pk_columns: Lister_Claim_Request_Activity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Claim_Request_Activity_ManyArgs = {
  updates: Array<Lister_Claim_Request_Activity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Claim_Request_By_PkArgs = {
  _set?: InputMaybe<Lister_Claim_Request_Set_Input>;
  pk_columns: Lister_Claim_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Claim_Request_ManyArgs = {
  updates: Array<Lister_Claim_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_ContactArgs = {
  _append?: InputMaybe<Lister_Contact_Append_Input>;
  _delete_at_path?: InputMaybe<Lister_Contact_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Lister_Contact_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Lister_Contact_Delete_Key_Input>;
  _inc?: InputMaybe<Lister_Contact_Inc_Input>;
  _prepend?: InputMaybe<Lister_Contact_Prepend_Input>;
  _set?: InputMaybe<Lister_Contact_Set_Input>;
  where: Lister_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Contact_By_PkArgs = {
  _append?: InputMaybe<Lister_Contact_Append_Input>;
  _delete_at_path?: InputMaybe<Lister_Contact_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Lister_Contact_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Lister_Contact_Delete_Key_Input>;
  _inc?: InputMaybe<Lister_Contact_Inc_Input>;
  _prepend?: InputMaybe<Lister_Contact_Prepend_Input>;
  _set?: InputMaybe<Lister_Contact_Set_Input>;
  pk_columns: Lister_Contact_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Contact_ManyArgs = {
  updates: Array<Lister_Contact_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Contact_MeetingArgs = {
  _set?: InputMaybe<Lister_Contact_Meeting_Set_Input>;
  where: Lister_Contact_Meeting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Contact_Meeting_By_PkArgs = {
  _set?: InputMaybe<Lister_Contact_Meeting_Set_Input>;
  pk_columns: Lister_Contact_Meeting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Contact_Meeting_ManyArgs = {
  updates: Array<Lister_Contact_Meeting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Contact_SourceArgs = {
  _set?: InputMaybe<Lister_Contact_Source_Set_Input>;
  where: Lister_Contact_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Contact_Source_By_PkArgs = {
  _set?: InputMaybe<Lister_Contact_Source_Set_Input>;
  pk_columns: Lister_Contact_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Contact_Source_ManyArgs = {
  updates: Array<Lister_Contact_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_LeadsArgs = {
  _set?: InputMaybe<Lister_Leads_Set_Input>;
  where: Lister_Leads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Leads_By_PkArgs = {
  _set?: InputMaybe<Lister_Leads_Set_Input>;
  pk_columns: Lister_Leads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Leads_ManyArgs = {
  updates: Array<Lister_Leads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_MeetingArgs = {
  _set?: InputMaybe<Lister_Meeting_Set_Input>;
  where: Lister_Meeting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Meeting_By_PkArgs = {
  _set?: InputMaybe<Lister_Meeting_Set_Input>;
  pk_columns: Lister_Meeting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Meeting_ManyArgs = {
  updates: Array<Lister_Meeting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_RoleArgs = {
  _set?: InputMaybe<Lister_Role_Set_Input>;
  where: Lister_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Role_By_PkArgs = {
  _set?: InputMaybe<Lister_Role_Set_Input>;
  pk_columns: Lister_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lister_Role_ManyArgs = {
  updates: Array<Lister_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LocationArgs = {
  _inc?: InputMaybe<Location_Inc_Input>;
  _set?: InputMaybe<Location_Set_Input>;
  where: Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Location_By_PkArgs = {
  _inc?: InputMaybe<Location_Inc_Input>;
  _set?: InputMaybe<Location_Set_Input>;
  pk_columns: Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Location_ManyArgs = {
  updates: Array<Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Location_TypeArgs = {
  _set?: InputMaybe<Location_Type_Set_Input>;
  where: Location_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Location_Type_By_PkArgs = {
  _set?: InputMaybe<Location_Type_Set_Input>;
  pk_columns: Location_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Location_Type_ManyArgs = {
  updates: Array<Location_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Main_CurrencyArgs = {
  _set?: InputMaybe<Main_Currency_Set_Input>;
  where: Main_Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Main_Currency_By_PkArgs = {
  _set?: InputMaybe<Main_Currency_Set_Input>;
  pk_columns: Main_Currency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Main_Currency_ManyArgs = {
  updates: Array<Main_Currency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Natural_Language_QueriesArgs = {
  _append?: InputMaybe<Natural_Language_Queries_Append_Input>;
  _delete_at_path?: InputMaybe<Natural_Language_Queries_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Natural_Language_Queries_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Natural_Language_Queries_Delete_Key_Input>;
  _inc?: InputMaybe<Natural_Language_Queries_Inc_Input>;
  _prepend?: InputMaybe<Natural_Language_Queries_Prepend_Input>;
  _set?: InputMaybe<Natural_Language_Queries_Set_Input>;
  where: Natural_Language_Queries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Natural_Language_Queries_By_PkArgs = {
  _append?: InputMaybe<Natural_Language_Queries_Append_Input>;
  _delete_at_path?: InputMaybe<Natural_Language_Queries_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Natural_Language_Queries_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Natural_Language_Queries_Delete_Key_Input>;
  _inc?: InputMaybe<Natural_Language_Queries_Inc_Input>;
  _prepend?: InputMaybe<Natural_Language_Queries_Prepend_Input>;
  _set?: InputMaybe<Natural_Language_Queries_Set_Input>;
  pk_columns: Natural_Language_Queries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Natural_Language_Queries_ManyArgs = {
  updates: Array<Natural_Language_Queries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationArgs = {
  _inc?: InputMaybe<Notification_Inc_Input>;
  _set?: InputMaybe<Notification_Set_Input>;
  where: Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_AmenitiesArgs = {
  _set?: InputMaybe<Notification_Amenities_Set_Input>;
  where: Notification_Amenities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Amenities_By_PkArgs = {
  _set?: InputMaybe<Notification_Amenities_Set_Input>;
  pk_columns: Notification_Amenities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Amenities_ManyArgs = {
  updates: Array<Notification_Amenities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_By_PkArgs = {
  _inc?: InputMaybe<Notification_Inc_Input>;
  _set?: InputMaybe<Notification_Set_Input>;
  pk_columns: Notification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_FeatureArgs = {
  _set?: InputMaybe<Notification_Feature_Set_Input>;
  where: Notification_Feature_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Feature_By_PkArgs = {
  _set?: InputMaybe<Notification_Feature_Set_Input>;
  pk_columns: Notification_Feature_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Feature_ManyArgs = {
  updates: Array<Notification_Feature_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_ManyArgs = {
  updates: Array<Notification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Property_TypeArgs = {
  _set?: InputMaybe<Notification_Property_Type_Set_Input>;
  where: Notification_Property_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Property_Type_By_PkArgs = {
  _set?: InputMaybe<Notification_Property_Type_Set_Input>;
  pk_columns: Notification_Property_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Property_Type_ManyArgs = {
  updates: Array<Notification_Property_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_TypeArgs = {
  _set?: InputMaybe<Notification_Type_Set_Input>;
  where: Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Type_By_PkArgs = {
  _set?: InputMaybe<Notification_Type_Set_Input>;
  pk_columns: Notification_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Type_ManyArgs = {
  updates: Array<Notification_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrderArgs = {
  _append?: InputMaybe<Order_Append_Input>;
  _delete_at_path?: InputMaybe<Order_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Order_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Order_Delete_Key_Input>;
  _inc?: InputMaybe<Order_Inc_Input>;
  _prepend?: InputMaybe<Order_Prepend_Input>;
  _set?: InputMaybe<Order_Set_Input>;
  where: Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_By_PkArgs = {
  _append?: InputMaybe<Order_Append_Input>;
  _delete_at_path?: InputMaybe<Order_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Order_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Order_Delete_Key_Input>;
  _inc?: InputMaybe<Order_Inc_Input>;
  _prepend?: InputMaybe<Order_Prepend_Input>;
  _set?: InputMaybe<Order_Set_Input>;
  pk_columns: Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_ManyArgs = {
  updates: Array<Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_StatusArgs = {
  _set?: InputMaybe<Order_Status_Set_Input>;
  where: Order_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Status_By_PkArgs = {
  _set?: InputMaybe<Order_Status_Set_Input>;
  pk_columns: Order_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Status_ManyArgs = {
  updates: Array<Order_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationArgs = {
  _append?: InputMaybe<Organization_Append_Input>;
  _delete_at_path?: InputMaybe<Organization_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organization_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organization_Delete_Key_Input>;
  _inc?: InputMaybe<Organization_Inc_Input>;
  _prepend?: InputMaybe<Organization_Prepend_Input>;
  _set?: InputMaybe<Organization_Set_Input>;
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_By_PkArgs = {
  _append?: InputMaybe<Organization_Append_Input>;
  _delete_at_path?: InputMaybe<Organization_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organization_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organization_Delete_Key_Input>;
  _inc?: InputMaybe<Organization_Inc_Input>;
  _prepend?: InputMaybe<Organization_Prepend_Input>;
  _set?: InputMaybe<Organization_Set_Input>;
  pk_columns: Organization_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Lead_LocationArgs = {
  _set?: InputMaybe<Organization_Lead_Location_Set_Input>;
  where: Organization_Lead_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Lead_Location_By_PkArgs = {
  _set?: InputMaybe<Organization_Lead_Location_Set_Input>;
  pk_columns: Organization_Lead_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Lead_Location_ManyArgs = {
  updates: Array<Organization_Lead_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Lead_PropertyArgs = {
  _set?: InputMaybe<Organization_Lead_Property_Set_Input>;
  where: Organization_Lead_Property_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Lead_Property_By_PkArgs = {
  _set?: InputMaybe<Organization_Lead_Property_Set_Input>;
  pk_columns: Organization_Lead_Property_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Lead_Property_ManyArgs = {
  updates: Array<Organization_Lead_Property_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_LeadsArgs = {
  _append?: InputMaybe<Organization_Leads_Append_Input>;
  _delete_at_path?: InputMaybe<Organization_Leads_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organization_Leads_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organization_Leads_Delete_Key_Input>;
  _inc?: InputMaybe<Organization_Leads_Inc_Input>;
  _prepend?: InputMaybe<Organization_Leads_Prepend_Input>;
  _set?: InputMaybe<Organization_Leads_Set_Input>;
  where: Organization_Leads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Leads_By_PkArgs = {
  _append?: InputMaybe<Organization_Leads_Append_Input>;
  _delete_at_path?: InputMaybe<Organization_Leads_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organization_Leads_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organization_Leads_Delete_Key_Input>;
  _inc?: InputMaybe<Organization_Leads_Inc_Input>;
  _prepend?: InputMaybe<Organization_Leads_Prepend_Input>;
  _set?: InputMaybe<Organization_Leads_Set_Input>;
  pk_columns: Organization_Leads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Leads_ManyArgs = {
  updates: Array<Organization_Leads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_ManyArgs = {
  updates: Array<Organization_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_RoleArgs = {
  _set?: InputMaybe<Organization_Role_Set_Input>;
  where: Organization_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Role_By_PkArgs = {
  _set?: InputMaybe<Organization_Role_Set_Input>;
  pk_columns: Organization_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Role_ManyArgs = {
  updates: Array<Organization_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_StatusArgs = {
  _set?: InputMaybe<Organization_Status_Set_Input>;
  where: Organization_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Status_By_PkArgs = {
  _set?: InputMaybe<Organization_Status_Set_Input>;
  pk_columns: Organization_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Status_ManyArgs = {
  updates: Array<Organization_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Telegram_Agent_LinkArgs = {
  _inc?: InputMaybe<Organization_Telegram_Agent_Link_Inc_Input>;
  _set?: InputMaybe<Organization_Telegram_Agent_Link_Set_Input>;
  where: Organization_Telegram_Agent_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Telegram_Agent_Link_By_PkArgs = {
  _inc?: InputMaybe<Organization_Telegram_Agent_Link_Inc_Input>;
  _set?: InputMaybe<Organization_Telegram_Agent_Link_Set_Input>;
  pk_columns: Organization_Telegram_Agent_Link_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Telegram_Agent_Link_ManyArgs = {
  updates: Array<Organization_Telegram_Agent_Link_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_TypeArgs = {
  _set?: InputMaybe<Organization_Type_Set_Input>;
  where: Organization_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Type_By_PkArgs = {
  _set?: InputMaybe<Organization_Type_Set_Input>;
  pk_columns: Organization_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Type_ManyArgs = {
  updates: Array<Organization_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Whatsapp_Ai_AllowlistArgs = {
  _set?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Set_Input>;
  where: Organization_Whatsapp_Ai_Allowlist_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Whatsapp_Ai_Allowlist_By_PkArgs = {
  _set?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Set_Input>;
  pk_columns: Organization_Whatsapp_Ai_Allowlist_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Whatsapp_Ai_Allowlist_ManyArgs = {
  updates: Array<Organization_Whatsapp_Ai_Allowlist_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Whatsapp_Ai_ConfigArgs = {
  _append?: InputMaybe<Organization_Whatsapp_Ai_Config_Append_Input>;
  _delete_at_path?: InputMaybe<Organization_Whatsapp_Ai_Config_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organization_Whatsapp_Ai_Config_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organization_Whatsapp_Ai_Config_Delete_Key_Input>;
  _inc?: InputMaybe<Organization_Whatsapp_Ai_Config_Inc_Input>;
  _prepend?: InputMaybe<Organization_Whatsapp_Ai_Config_Prepend_Input>;
  _set?: InputMaybe<Organization_Whatsapp_Ai_Config_Set_Input>;
  where: Organization_Whatsapp_Ai_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Whatsapp_Ai_Config_By_PkArgs = {
  _append?: InputMaybe<Organization_Whatsapp_Ai_Config_Append_Input>;
  _delete_at_path?: InputMaybe<Organization_Whatsapp_Ai_Config_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organization_Whatsapp_Ai_Config_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organization_Whatsapp_Ai_Config_Delete_Key_Input>;
  _inc?: InputMaybe<Organization_Whatsapp_Ai_Config_Inc_Input>;
  _prepend?: InputMaybe<Organization_Whatsapp_Ai_Config_Prepend_Input>;
  _set?: InputMaybe<Organization_Whatsapp_Ai_Config_Set_Input>;
  pk_columns: Organization_Whatsapp_Ai_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Whatsapp_Ai_Config_ManyArgs = {
  updates: Array<Organization_Whatsapp_Ai_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_TypeArgs = {
  _set?: InputMaybe<Parking_Type_Set_Input>;
  where: Parking_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_Type_By_PkArgs = {
  _set?: InputMaybe<Parking_Type_Set_Input>;
  pk_columns: Parking_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_Type_ManyArgs = {
  updates: Array<Parking_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_Number_TypeArgs = {
  _set?: InputMaybe<Phone_Number_Type_Set_Input>;
  where: Phone_Number_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_Number_Type_By_PkArgs = {
  _set?: InputMaybe<Phone_Number_Type_Set_Input>;
  pk_columns: Phone_Number_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_Number_Type_ManyArgs = {
  updates: Array<Phone_Number_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Place_ReferenceArgs = {
  _append?: InputMaybe<Place_Reference_Append_Input>;
  _delete_at_path?: InputMaybe<Place_Reference_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Place_Reference_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Place_Reference_Delete_Key_Input>;
  _inc?: InputMaybe<Place_Reference_Inc_Input>;
  _prepend?: InputMaybe<Place_Reference_Prepend_Input>;
  _set?: InputMaybe<Place_Reference_Set_Input>;
  where: Place_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Place_Reference_AliasArgs = {
  _inc?: InputMaybe<Place_Reference_Alias_Inc_Input>;
  _set?: InputMaybe<Place_Reference_Alias_Set_Input>;
  where: Place_Reference_Alias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Place_Reference_Alias_By_PkArgs = {
  _inc?: InputMaybe<Place_Reference_Alias_Inc_Input>;
  _set?: InputMaybe<Place_Reference_Alias_Set_Input>;
  pk_columns: Place_Reference_Alias_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Place_Reference_Alias_ManyArgs = {
  updates: Array<Place_Reference_Alias_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Place_Reference_By_PkArgs = {
  _append?: InputMaybe<Place_Reference_Append_Input>;
  _delete_at_path?: InputMaybe<Place_Reference_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Place_Reference_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Place_Reference_Delete_Key_Input>;
  _inc?: InputMaybe<Place_Reference_Inc_Input>;
  _prepend?: InputMaybe<Place_Reference_Prepend_Input>;
  _set?: InputMaybe<Place_Reference_Set_Input>;
  pk_columns: Place_Reference_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Place_Reference_ManyArgs = {
  updates: Array<Place_Reference_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Place_Reference_ProposalArgs = {
  _append?: InputMaybe<Place_Reference_Proposal_Append_Input>;
  _delete_at_path?: InputMaybe<Place_Reference_Proposal_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Place_Reference_Proposal_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Place_Reference_Proposal_Delete_Key_Input>;
  _inc?: InputMaybe<Place_Reference_Proposal_Inc_Input>;
  _prepend?: InputMaybe<Place_Reference_Proposal_Prepend_Input>;
  _set?: InputMaybe<Place_Reference_Proposal_Set_Input>;
  where: Place_Reference_Proposal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Place_Reference_Proposal_By_PkArgs = {
  _append?: InputMaybe<Place_Reference_Proposal_Append_Input>;
  _delete_at_path?: InputMaybe<Place_Reference_Proposal_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Place_Reference_Proposal_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Place_Reference_Proposal_Delete_Key_Input>;
  _inc?: InputMaybe<Place_Reference_Proposal_Inc_Input>;
  _prepend?: InputMaybe<Place_Reference_Proposal_Prepend_Input>;
  _set?: InputMaybe<Place_Reference_Proposal_Set_Input>;
  pk_columns: Place_Reference_Proposal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Place_Reference_Proposal_ManyArgs = {
  updates: Array<Place_Reference_Proposal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlanArgs = {
  _inc?: InputMaybe<Plan_Inc_Input>;
  _set?: InputMaybe<Plan_Set_Input>;
  where: Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_By_PkArgs = {
  _inc?: InputMaybe<Plan_Inc_Input>;
  _set?: InputMaybe<Plan_Set_Input>;
  pk_columns: Plan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_ManyArgs = {
  updates: Array<Plan_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_TypeArgs = {
  _set?: InputMaybe<Plan_Type_Set_Input>;
  where: Plan_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_Type_By_PkArgs = {
  _set?: InputMaybe<Plan_Type_Set_Input>;
  pk_columns: Plan_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_Type_ManyArgs = {
  updates: Array<Plan_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductArgs = {
  _inc?: InputMaybe<Product_Inc_Input>;
  _set?: InputMaybe<Product_Set_Input>;
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_By_PkArgs = {
  _inc?: InputMaybe<Product_Inc_Input>;
  _set?: InputMaybe<Product_Set_Input>;
  pk_columns: Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_ManyArgs = {
  updates: Array<Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_PurchaseArgs = {
  _inc?: InputMaybe<Product_Purchase_Inc_Input>;
  _set?: InputMaybe<Product_Purchase_Set_Input>;
  where: Product_Purchase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Purchase_By_PkArgs = {
  _inc?: InputMaybe<Product_Purchase_Inc_Input>;
  _set?: InputMaybe<Product_Purchase_Set_Input>;
  pk_columns: Product_Purchase_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Purchase_ManyArgs = {
  updates: Array<Product_Purchase_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_TypeArgs = {
  _set?: InputMaybe<Product_Type_Set_Input>;
  where: Product_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Type_By_PkArgs = {
  _set?: InputMaybe<Product_Type_Set_Input>;
  pk_columns: Product_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Type_ManyArgs = {
  updates: Array<Product_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PropertyArgs = {
  _set?: InputMaybe<Property_Set_Input>;
  where: Property_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_By_PkArgs = {
  _set?: InputMaybe<Property_Set_Input>;
  pk_columns: Property_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_ClusterArgs = {
  _set?: InputMaybe<Property_Cluster_Set_Input>;
  where: Property_Cluster_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Cluster_By_PkArgs = {
  _set?: InputMaybe<Property_Cluster_Set_Input>;
  pk_columns: Property_Cluster_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Cluster_ManyArgs = {
  updates: Array<Property_Cluster_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_CompositionArgs = {
  _inc?: InputMaybe<Property_Composition_Inc_Input>;
  _set?: InputMaybe<Property_Composition_Set_Input>;
  where: Property_Composition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Composition_By_PkArgs = {
  _inc?: InputMaybe<Property_Composition_Inc_Input>;
  _set?: InputMaybe<Property_Composition_Set_Input>;
  pk_columns: Property_Composition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Composition_ManyArgs = {
  updates: Array<Property_Composition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_FeatureArgs = {
  _set?: InputMaybe<Property_Feature_Set_Input>;
  where: Property_Feature_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Feature_By_PkArgs = {
  _set?: InputMaybe<Property_Feature_Set_Input>;
  pk_columns: Property_Feature_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Feature_ManyArgs = {
  updates: Array<Property_Feature_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_FolderArgs = {
  _inc?: InputMaybe<Property_Folder_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Set_Input>;
  where: Property_Folder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_By_PkArgs = {
  _inc?: InputMaybe<Property_Folder_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Set_Input>;
  pk_columns: Property_Folder_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_ManyArgs = {
  updates: Array<Property_Folder_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_ProfileArgs = {
  _append?: InputMaybe<Property_Folder_Public_Profile_Append_Input>;
  _delete_at_path?: InputMaybe<Property_Folder_Public_Profile_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Property_Folder_Public_Profile_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Property_Folder_Public_Profile_Delete_Key_Input>;
  _prepend?: InputMaybe<Property_Folder_Public_Profile_Prepend_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Set_Input>;
  where: Property_Folder_Public_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_By_PkArgs = {
  _append?: InputMaybe<Property_Folder_Public_Profile_Append_Input>;
  _delete_at_path?: InputMaybe<Property_Folder_Public_Profile_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Property_Folder_Public_Profile_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Property_Folder_Public_Profile_Delete_Key_Input>;
  _prepend?: InputMaybe<Property_Folder_Public_Profile_Prepend_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Set_Input>;
  pk_columns: Property_Folder_Public_Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_FaqArgs = {
  _inc?: InputMaybe<Property_Folder_Public_Profile_Faq_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Faq_Set_Input>;
  where: Property_Folder_Public_Profile_Faq_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Faq_By_PkArgs = {
  _inc?: InputMaybe<Property_Folder_Public_Profile_Faq_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Faq_Set_Input>;
  pk_columns: Property_Folder_Public_Profile_Faq_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Faq_ManyArgs = {
  updates: Array<Property_Folder_Public_Profile_Faq_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_HighlightArgs = {
  _inc?: InputMaybe<Property_Folder_Public_Profile_Highlight_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Highlight_Set_Input>;
  where: Property_Folder_Public_Profile_Highlight_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Highlight_By_PkArgs = {
  _inc?: InputMaybe<Property_Folder_Public_Profile_Highlight_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Highlight_Set_Input>;
  pk_columns: Property_Folder_Public_Profile_Highlight_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Highlight_ManyArgs = {
  updates: Array<Property_Folder_Public_Profile_Highlight_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Listing_ExampleArgs = {
  _inc?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Set_Input>;
  where: Property_Folder_Public_Profile_Listing_Example_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Listing_Example_By_PkArgs = {
  _inc?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Set_Input>;
  pk_columns: Property_Folder_Public_Profile_Listing_Example_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Listing_Example_ManyArgs = {
  updates: Array<Property_Folder_Public_Profile_Listing_Example_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_ManyArgs = {
  updates: Array<Property_Folder_Public_Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Nearby_PlaceArgs = {
  _inc?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Set_Input>;
  where: Property_Folder_Public_Profile_Nearby_Place_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Nearby_Place_By_PkArgs = {
  _inc?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Set_Input>;
  pk_columns: Property_Folder_Public_Profile_Nearby_Place_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Nearby_Place_ManyArgs = {
  updates: Array<Property_Folder_Public_Profile_Nearby_Place_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_RelatedArgs = {
  _inc?: InputMaybe<Property_Folder_Public_Profile_Related_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Related_Set_Input>;
  where: Property_Folder_Public_Profile_Related_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Related_By_PkArgs = {
  _inc?: InputMaybe<Property_Folder_Public_Profile_Related_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Related_Set_Input>;
  pk_columns: Property_Folder_Public_Profile_Related_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Related_ManyArgs = {
  updates: Array<Property_Folder_Public_Profile_Related_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_TranslationArgs = {
  _inc?: InputMaybe<Property_Folder_Public_Profile_Translation_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Translation_Set_Input>;
  where: Property_Folder_Public_Profile_Translation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Translation_By_PkArgs = {
  _inc?: InputMaybe<Property_Folder_Public_Profile_Translation_Inc_Input>;
  _set?: InputMaybe<Property_Folder_Public_Profile_Translation_Set_Input>;
  pk_columns: Property_Folder_Public_Profile_Translation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Folder_Public_Profile_Translation_ManyArgs = {
  updates: Array<Property_Folder_Public_Profile_Translation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_ImageArgs = {
  _append?: InputMaybe<Property_Image_Append_Input>;
  _delete_at_path?: InputMaybe<Property_Image_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Property_Image_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Property_Image_Delete_Key_Input>;
  _inc?: InputMaybe<Property_Image_Inc_Input>;
  _prepend?: InputMaybe<Property_Image_Prepend_Input>;
  _set?: InputMaybe<Property_Image_Set_Input>;
  where: Property_Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Image_By_PkArgs = {
  _append?: InputMaybe<Property_Image_Append_Input>;
  _delete_at_path?: InputMaybe<Property_Image_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Property_Image_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Property_Image_Delete_Key_Input>;
  _inc?: InputMaybe<Property_Image_Inc_Input>;
  _prepend?: InputMaybe<Property_Image_Prepend_Input>;
  _set?: InputMaybe<Property_Image_Set_Input>;
  pk_columns: Property_Image_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Image_ManyArgs = {
  updates: Array<Property_Image_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_ListArgs = {
  _append?: InputMaybe<Property_List_Append_Input>;
  _delete_at_path?: InputMaybe<Property_List_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Property_List_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Property_List_Delete_Key_Input>;
  _inc?: InputMaybe<Property_List_Inc_Input>;
  _prepend?: InputMaybe<Property_List_Prepend_Input>;
  _set?: InputMaybe<Property_List_Set_Input>;
  where: Property_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_List_ActivityArgs = {
  _append?: InputMaybe<Property_List_Activity_Append_Input>;
  _delete_at_path?: InputMaybe<Property_List_Activity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Property_List_Activity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Property_List_Activity_Delete_Key_Input>;
  _prepend?: InputMaybe<Property_List_Activity_Prepend_Input>;
  _set?: InputMaybe<Property_List_Activity_Set_Input>;
  where: Property_List_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_List_Activity_By_PkArgs = {
  _append?: InputMaybe<Property_List_Activity_Append_Input>;
  _delete_at_path?: InputMaybe<Property_List_Activity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Property_List_Activity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Property_List_Activity_Delete_Key_Input>;
  _prepend?: InputMaybe<Property_List_Activity_Prepend_Input>;
  _set?: InputMaybe<Property_List_Activity_Set_Input>;
  pk_columns: Property_List_Activity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_List_Activity_ManyArgs = {
  updates: Array<Property_List_Activity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_List_By_PkArgs = {
  _append?: InputMaybe<Property_List_Append_Input>;
  _delete_at_path?: InputMaybe<Property_List_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Property_List_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Property_List_Delete_Key_Input>;
  _inc?: InputMaybe<Property_List_Inc_Input>;
  _prepend?: InputMaybe<Property_List_Prepend_Input>;
  _set?: InputMaybe<Property_List_Set_Input>;
  pk_columns: Property_List_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_List_FolderArgs = {
  _set?: InputMaybe<Property_List_Folder_Set_Input>;
  where: Property_List_Folder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_List_Folder_By_PkArgs = {
  _set?: InputMaybe<Property_List_Folder_Set_Input>;
  pk_columns: Property_List_Folder_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_List_Folder_ManyArgs = {
  updates: Array<Property_List_Folder_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_List_ManyArgs = {
  updates: Array<Property_List_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_List_ReportArgs = {
  _set?: InputMaybe<Property_List_Report_Set_Input>;
  where: Property_List_Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_List_Report_By_PkArgs = {
  _set?: InputMaybe<Property_List_Report_Set_Input>;
  pk_columns: Property_List_Report_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_List_Report_ManyArgs = {
  updates: Array<Property_List_Report_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_ManyArgs = {
  updates: Array<Property_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_OriginArgs = {
  _set?: InputMaybe<Property_Origin_Set_Input>;
  where: Property_Origin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Origin_By_PkArgs = {
  _set?: InputMaybe<Property_Origin_Set_Input>;
  pk_columns: Property_Origin_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Origin_ManyArgs = {
  updates: Array<Property_Origin_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Origin_TypeArgs = {
  _set?: InputMaybe<Property_Origin_Type_Set_Input>;
  where: Property_Origin_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Origin_Type_By_PkArgs = {
  _set?: InputMaybe<Property_Origin_Type_Set_Input>;
  pk_columns: Property_Origin_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Origin_Type_ManyArgs = {
  updates: Array<Property_Origin_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_OwnerArgs = {
  _set?: InputMaybe<Property_Owner_Set_Input>;
  where: Property_Owner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Owner_By_PkArgs = {
  _set?: InputMaybe<Property_Owner_Set_Input>;
  pk_columns: Property_Owner_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Owner_ManyArgs = {
  updates: Array<Property_Owner_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Place_ReferenceArgs = {
  _inc?: InputMaybe<Property_Place_Reference_Inc_Input>;
  _set?: InputMaybe<Property_Place_Reference_Set_Input>;
  where: Property_Place_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Place_Reference_By_PkArgs = {
  _inc?: InputMaybe<Property_Place_Reference_Inc_Input>;
  _set?: InputMaybe<Property_Place_Reference_Set_Input>;
  pk_columns: Property_Place_Reference_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Place_Reference_ManyArgs = {
  updates: Array<Property_Place_Reference_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Price_HistoryArgs = {
  _inc?: InputMaybe<Property_Price_History_Inc_Input>;
  _set?: InputMaybe<Property_Price_History_Set_Input>;
  where: Property_Price_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Price_History_By_PkArgs = {
  _inc?: InputMaybe<Property_Price_History_Inc_Input>;
  _set?: InputMaybe<Property_Price_History_Set_Input>;
  pk_columns: Property_Price_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Price_History_ManyArgs = {
  updates: Array<Property_Price_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Report_TypeArgs = {
  _set?: InputMaybe<Property_Report_Type_Set_Input>;
  where: Property_Report_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Report_Type_By_PkArgs = {
  _set?: InputMaybe<Property_Report_Type_Set_Input>;
  pk_columns: Property_Report_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Report_Type_ManyArgs = {
  updates: Array<Property_Report_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_SourceArgs = {
  _set?: InputMaybe<Property_Source_Set_Input>;
  where: Property_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Source_By_PkArgs = {
  _set?: InputMaybe<Property_Source_Set_Input>;
  pk_columns: Property_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Source_ManyArgs = {
  updates: Array<Property_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_StatusArgs = {
  _set?: InputMaybe<Property_Status_Set_Input>;
  where: Property_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Status_By_PkArgs = {
  _set?: InputMaybe<Property_Status_Set_Input>;
  pk_columns: Property_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Status_ManyArgs = {
  updates: Array<Property_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_TypeArgs = {
  _set?: InputMaybe<Property_Type_Set_Input>;
  where: Property_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Type_By_PkArgs = {
  _set?: InputMaybe<Property_Type_Set_Input>;
  pk_columns: Property_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Type_ManyArgs = {
  updates: Array<Property_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_ViewsArgs = {
  _inc?: InputMaybe<Property_Views_Inc_Input>;
  _set?: InputMaybe<Property_Views_Set_Input>;
  where: Property_Views_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Views_By_PkArgs = {
  _inc?: InputMaybe<Property_Views_Inc_Input>;
  _set?: InputMaybe<Property_Views_Set_Input>;
  pk_columns: Property_Views_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Views_ManyArgs = {
  updates: Array<Property_Views_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_VisibilityArgs = {
  body?: InputMaybe<PropertyVisibilityActionInput>;
};


/** mutation root */
export type Mutation_RootUpdate_Queries_Property_ResultArgs = {
  _inc?: InputMaybe<Queries_Property_Result_Inc_Input>;
  _set?: InputMaybe<Queries_Property_Result_Set_Input>;
  where: Queries_Property_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Queries_Property_Result_By_PkArgs = {
  _inc?: InputMaybe<Queries_Property_Result_Inc_Input>;
  _set?: InputMaybe<Queries_Property_Result_Set_Input>;
  pk_columns: Queries_Property_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Queries_Property_Result_ManyArgs = {
  updates: Array<Queries_Property_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Queries_Property_Result_ReArgs = {
  _inc?: InputMaybe<Queries_Property_Result_Re_Inc_Input>;
  _set?: InputMaybe<Queries_Property_Result_Re_Set_Input>;
  where: Queries_Property_Result_Re_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Queries_Property_Result_Re_By_PkArgs = {
  _inc?: InputMaybe<Queries_Property_Result_Re_Inc_Input>;
  _set?: InputMaybe<Queries_Property_Result_Re_Set_Input>;
  pk_columns: Queries_Property_Result_Re_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Queries_Property_Result_Re_ManyArgs = {
  updates: Array<Queries_Property_Result_Re_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Query_ClassificationArgs = {
  _set?: InputMaybe<Query_Classification_Set_Input>;
  where: Query_Classification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Query_Classification_By_PkArgs = {
  _set?: InputMaybe<Query_Classification_Set_Input>;
  pk_columns: Query_Classification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Query_Classification_ManyArgs = {
  updates: Array<Query_Classification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Query_Classification_ReArgs = {
  _set?: InputMaybe<Query_Classification_Re_Set_Input>;
  where: Query_Classification_Re_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Query_Classification_Re_By_PkArgs = {
  _set?: InputMaybe<Query_Classification_Re_Set_Input>;
  pk_columns: Query_Classification_Re_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Query_Classification_Re_ManyArgs = {
  updates: Array<Query_Classification_Re_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Raw_LocationArgs = {
  _append?: InputMaybe<Raw_Location_Append_Input>;
  _delete_at_path?: InputMaybe<Raw_Location_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Raw_Location_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Raw_Location_Delete_Key_Input>;
  _prepend?: InputMaybe<Raw_Location_Prepend_Input>;
  _set?: InputMaybe<Raw_Location_Set_Input>;
  where: Raw_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Raw_Location_By_PkArgs = {
  _append?: InputMaybe<Raw_Location_Append_Input>;
  _delete_at_path?: InputMaybe<Raw_Location_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Raw_Location_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Raw_Location_Delete_Key_Input>;
  _prepend?: InputMaybe<Raw_Location_Prepend_Input>;
  _set?: InputMaybe<Raw_Location_Set_Input>;
  pk_columns: Raw_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Raw_Location_ManyArgs = {
  updates: Array<Raw_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RedirectArgs = {
  _inc?: InputMaybe<Redirect_Inc_Input>;
  _set?: InputMaybe<Redirect_Set_Input>;
  where: Redirect_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Redirect_By_PkArgs = {
  _inc?: InputMaybe<Redirect_Inc_Input>;
  _set?: InputMaybe<Redirect_Set_Input>;
  pk_columns: Redirect_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Redirect_ManyArgs = {
  updates: Array<Redirect_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reference_Price_HistoryArgs = {
  _inc?: InputMaybe<Reference_Price_History_Inc_Input>;
  _set?: InputMaybe<Reference_Price_History_Set_Input>;
  where: Reference_Price_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reference_Price_History_By_PkArgs = {
  _inc?: InputMaybe<Reference_Price_History_Inc_Input>;
  _set?: InputMaybe<Reference_Price_History_Set_Input>;
  pk_columns: Reference_Price_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reference_Price_History_ManyArgs = {
  updates: Array<Reference_Price_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reference_ZoneArgs = {
  _append?: InputMaybe<Reference_Zone_Append_Input>;
  _delete_at_path?: InputMaybe<Reference_Zone_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Reference_Zone_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Reference_Zone_Delete_Key_Input>;
  _prepend?: InputMaybe<Reference_Zone_Prepend_Input>;
  _set?: InputMaybe<Reference_Zone_Set_Input>;
  where: Reference_Zone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reference_Zone_By_PkArgs = {
  _append?: InputMaybe<Reference_Zone_Append_Input>;
  _delete_at_path?: InputMaybe<Reference_Zone_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Reference_Zone_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Reference_Zone_Delete_Key_Input>;
  _prepend?: InputMaybe<Reference_Zone_Prepend_Input>;
  _set?: InputMaybe<Reference_Zone_Set_Input>;
  pk_columns: Reference_Zone_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reference_Zone_ManyArgs = {
  updates: Array<Reference_Zone_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_ContextArgs = {
  _append?: InputMaybe<Search_Context_Append_Input>;
  _delete_at_path?: InputMaybe<Search_Context_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Search_Context_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Search_Context_Delete_Key_Input>;
  _prepend?: InputMaybe<Search_Context_Prepend_Input>;
  _set?: InputMaybe<Search_Context_Set_Input>;
  where: Search_Context_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Context_By_PkArgs = {
  _append?: InputMaybe<Search_Context_Append_Input>;
  _delete_at_path?: InputMaybe<Search_Context_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Search_Context_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Search_Context_Delete_Key_Input>;
  _prepend?: InputMaybe<Search_Context_Prepend_Input>;
  _set?: InputMaybe<Search_Context_Set_Input>;
  pk_columns: Search_Context_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Context_LocationArgs = {
  _set?: InputMaybe<Search_Context_Location_Set_Input>;
  where: Search_Context_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Context_Location_By_PkArgs = {
  _set?: InputMaybe<Search_Context_Location_Set_Input>;
  pk_columns: Search_Context_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Context_Location_ManyArgs = {
  updates: Array<Search_Context_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Context_ManyArgs = {
  updates: Array<Search_Context_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_DomainArgs = {
  _set?: InputMaybe<Search_Domain_Set_Input>;
  where: Search_Domain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Domain_By_PkArgs = {
  _set?: InputMaybe<Search_Domain_Set_Input>;
  pk_columns: Search_Domain_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Domain_ManyArgs = {
  updates: Array<Search_Domain_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_SessionsArgs = {
  _set?: InputMaybe<Search_Sessions_Set_Input>;
  where: Search_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Sessions_By_PkArgs = {
  _set?: InputMaybe<Search_Sessions_Set_Input>;
  pk_columns: Search_Sessions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Sessions_ManyArgs = {
  updates: Array<Search_Sessions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_SlugsArgs = {
  _append?: InputMaybe<Search_Slugs_Append_Input>;
  _delete_at_path?: InputMaybe<Search_Slugs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Search_Slugs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Search_Slugs_Delete_Key_Input>;
  _inc?: InputMaybe<Search_Slugs_Inc_Input>;
  _prepend?: InputMaybe<Search_Slugs_Prepend_Input>;
  _set?: InputMaybe<Search_Slugs_Set_Input>;
  where: Search_Slugs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Slugs_By_PkArgs = {
  _append?: InputMaybe<Search_Slugs_Append_Input>;
  _delete_at_path?: InputMaybe<Search_Slugs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Search_Slugs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Search_Slugs_Delete_Key_Input>;
  _inc?: InputMaybe<Search_Slugs_Inc_Input>;
  _prepend?: InputMaybe<Search_Slugs_Prepend_Input>;
  _set?: InputMaybe<Search_Slugs_Set_Input>;
  pk_columns: Search_Slugs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Slugs_ManyArgs = {
  updates: Array<Search_Slugs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Seo_CityArgs = {
  _append?: InputMaybe<Seo_City_Append_Input>;
  _delete_at_path?: InputMaybe<Seo_City_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Seo_City_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Seo_City_Delete_Key_Input>;
  _prepend?: InputMaybe<Seo_City_Prepend_Input>;
  _set?: InputMaybe<Seo_City_Set_Input>;
  where: Seo_City_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Seo_City_By_PkArgs = {
  _append?: InputMaybe<Seo_City_Append_Input>;
  _delete_at_path?: InputMaybe<Seo_City_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Seo_City_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Seo_City_Delete_Key_Input>;
  _prepend?: InputMaybe<Seo_City_Prepend_Input>;
  _set?: InputMaybe<Seo_City_Set_Input>;
  pk_columns: Seo_City_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Seo_City_ManyArgs = {
  updates: Array<Seo_City_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Session_OriginArgs = {
  _set?: InputMaybe<Session_Origin_Set_Input>;
  where: Session_Origin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Session_Origin_By_PkArgs = {
  _set?: InputMaybe<Session_Origin_Set_Input>;
  pk_columns: Session_Origin_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Session_Origin_ManyArgs = {
  updates: Array<Session_Origin_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsored_Property_ListArgs = {
  _set?: InputMaybe<Sponsored_Property_List_Set_Input>;
  where: Sponsored_Property_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsored_Property_List_By_PkArgs = {
  _set?: InputMaybe<Sponsored_Property_List_Set_Input>;
  pk_columns: Sponsored_Property_List_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsored_Property_List_ManyArgs = {
  updates: Array<Sponsored_Property_List_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubscriptionArgs = {
  _append?: InputMaybe<Subscription_Append_Input>;
  _delete_at_path?: InputMaybe<Subscription_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Subscription_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Subscription_Delete_Key_Input>;
  _inc?: InputMaybe<Subscription_Inc_Input>;
  _prepend?: InputMaybe<Subscription_Prepend_Input>;
  _set?: InputMaybe<Subscription_Set_Input>;
  where: Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_By_PkArgs = {
  _append?: InputMaybe<Subscription_Append_Input>;
  _delete_at_path?: InputMaybe<Subscription_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Subscription_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Subscription_Delete_Key_Input>;
  _inc?: InputMaybe<Subscription_Inc_Input>;
  _prepend?: InputMaybe<Subscription_Prepend_Input>;
  _set?: InputMaybe<Subscription_Set_Input>;
  pk_columns: Subscription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_InvoiceArgs = {
  _append?: InputMaybe<Subscription_Invoice_Append_Input>;
  _delete_at_path?: InputMaybe<Subscription_Invoice_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Subscription_Invoice_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Subscription_Invoice_Delete_Key_Input>;
  _inc?: InputMaybe<Subscription_Invoice_Inc_Input>;
  _prepend?: InputMaybe<Subscription_Invoice_Prepend_Input>;
  _set?: InputMaybe<Subscription_Invoice_Set_Input>;
  where: Subscription_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Invoice_By_PkArgs = {
  _append?: InputMaybe<Subscription_Invoice_Append_Input>;
  _delete_at_path?: InputMaybe<Subscription_Invoice_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Subscription_Invoice_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Subscription_Invoice_Delete_Key_Input>;
  _inc?: InputMaybe<Subscription_Invoice_Inc_Input>;
  _prepend?: InputMaybe<Subscription_Invoice_Prepend_Input>;
  _set?: InputMaybe<Subscription_Invoice_Set_Input>;
  pk_columns: Subscription_Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Invoice_ManyArgs = {
  updates: Array<Subscription_Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_ManyArgs = {
  updates: Array<Subscription_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_SourceArgs = {
  _set?: InputMaybe<Subscription_Source_Set_Input>;
  where: Subscription_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Source_By_PkArgs = {
  _set?: InputMaybe<Subscription_Source_Set_Input>;
  pk_columns: Subscription_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Source_ManyArgs = {
  updates: Array<Subscription_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_StatusArgs = {
  _set?: InputMaybe<Subscription_Status_Set_Input>;
  where: Subscription_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Status_By_PkArgs = {
  _set?: InputMaybe<Subscription_Status_Set_Input>;
  pk_columns: Subscription_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Status_ManyArgs = {
  updates: Array<Subscription_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Text_ContentArgs = {
  _inc?: InputMaybe<Text_Content_Inc_Input>;
  _set?: InputMaybe<Text_Content_Set_Input>;
  where: Text_Content_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Text_Content_By_PkArgs = {
  _inc?: InputMaybe<Text_Content_Inc_Input>;
  _set?: InputMaybe<Text_Content_Set_Input>;
  pk_columns: Text_Content_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Text_Content_ManyArgs = {
  updates: Array<Text_Content_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TranslationsArgs = {
  _inc?: InputMaybe<Translations_Inc_Input>;
  _set?: InputMaybe<Translations_Set_Input>;
  where: Translations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Translations_By_PkArgs = {
  _inc?: InputMaybe<Translations_Inc_Input>;
  _set?: InputMaybe<Translations_Set_Input>;
  pk_columns: Translations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Translations_ManyArgs = {
  updates: Array<Translations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Url_SlugArgs = {
  _inc?: InputMaybe<Url_Slug_Inc_Input>;
  _set?: InputMaybe<Url_Slug_Set_Input>;
  where: Url_Slug_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Url_Slug_By_PkArgs = {
  _inc?: InputMaybe<Url_Slug_Inc_Input>;
  _set?: InputMaybe<Url_Slug_Set_Input>;
  pk_columns: Url_Slug_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Url_Slug_ManyArgs = {
  updates: Array<Url_Slug_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_FiltersArgs = {
  _inc?: InputMaybe<User_Filters_Inc_Input>;
  _set?: InputMaybe<User_Filters_Set_Input>;
  where: User_Filters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Filters_By_PkArgs = {
  _inc?: InputMaybe<User_Filters_Inc_Input>;
  _set?: InputMaybe<User_Filters_Set_Input>;
  pk_columns: User_Filters_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Filters_FeaturesArgs = {
  _set?: InputMaybe<User_Filters_Features_Set_Input>;
  where: User_Filters_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Filters_Features_By_PkArgs = {
  _set?: InputMaybe<User_Filters_Features_Set_Input>;
  pk_columns: User_Filters_Features_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Filters_Features_ManyArgs = {
  updates: Array<User_Filters_Features_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Filters_ManyArgs = {
  updates: Array<User_Filters_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_OrganizationArgs = {
  _set?: InputMaybe<User_Organization_Set_Input>;
  where: User_Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Organization_By_PkArgs = {
  _set?: InputMaybe<User_Organization_Set_Input>;
  pk_columns: User_Organization_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Organization_ManyArgs = {
  updates: Array<User_Organization_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_PreferencesArgs = {
  _set?: InputMaybe<User_Preferences_Set_Input>;
  where: User_Preferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Preferences_By_PkArgs = {
  _set?: InputMaybe<User_Preferences_Set_Input>;
  pk_columns: User_Preferences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Preferences_ManyArgs = {
  updates: Array<User_Preferences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Property_NotifiationArgs = {
  _set?: InputMaybe<User_Property_Notifiation_Set_Input>;
  where: User_Property_Notifiation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Property_Notifiation_By_PkArgs = {
  _set?: InputMaybe<User_Property_Notifiation_Set_Input>;
  pk_columns: User_Property_Notifiation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Property_Notifiation_ManyArgs = {
  updates: Array<User_Property_Notifiation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Saved_PropertiesArgs = {
  _set?: InputMaybe<User_Saved_Properties_Set_Input>;
  where: User_Saved_Properties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Saved_Properties_By_PkArgs = {
  _set?: InputMaybe<User_Saved_Properties_Set_Input>;
  pk_columns: User_Saved_Properties_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Saved_Properties_ManyArgs = {
  updates: Array<User_Saved_Properties_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Seen_PropertyArgs = {
  _set?: InputMaybe<User_Seen_Property_Set_Input>;
  where: User_Seen_Property_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Seen_Property_By_PkArgs = {
  _set?: InputMaybe<User_Seen_Property_Set_Input>;
  pk_columns: User_Seen_Property_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Seen_Property_ManyArgs = {
  updates: Array<User_Seen_Property_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Activity_SummaryArgs = {
  _inc?: InputMaybe<Users_Activity_Summary_Inc_Input>;
  _set?: InputMaybe<Users_Activity_Summary_Set_Input>;
  where: Users_Activity_Summary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Activity_Summary_By_PkArgs = {
  _inc?: InputMaybe<Users_Activity_Summary_Inc_Input>;
  _set?: InputMaybe<Users_Activity_Summary_Set_Input>;
  pk_columns: Users_Activity_Summary_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Activity_Summary_ManyArgs = {
  updates: Array<Users_Activity_Summary_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Virus_ManyArgs = {
  updates: Array<Virus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Visibility_StatusArgs = {
  _set?: InputMaybe<Visibility_Status_Set_Input>;
  where: Visibility_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Visibility_Status_By_PkArgs = {
  _set?: InputMaybe<Visibility_Status_Set_Input>;
  pk_columns: Visibility_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Visibility_Status_ManyArgs = {
  updates: Array<Visibility_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Ai_Inbound_MessageArgs = {
  _append?: InputMaybe<Whatsapp_Ai_Inbound_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Whatsapp_Ai_Inbound_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Whatsapp_Ai_Inbound_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Whatsapp_Ai_Inbound_Message_Delete_Key_Input>;
  _prepend?: InputMaybe<Whatsapp_Ai_Inbound_Message_Prepend_Input>;
  _set?: InputMaybe<Whatsapp_Ai_Inbound_Message_Set_Input>;
  where: Whatsapp_Ai_Inbound_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Ai_Inbound_Message_By_PkArgs = {
  _append?: InputMaybe<Whatsapp_Ai_Inbound_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Whatsapp_Ai_Inbound_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Whatsapp_Ai_Inbound_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Whatsapp_Ai_Inbound_Message_Delete_Key_Input>;
  _prepend?: InputMaybe<Whatsapp_Ai_Inbound_Message_Prepend_Input>;
  _set?: InputMaybe<Whatsapp_Ai_Inbound_Message_Set_Input>;
  pk_columns: Whatsapp_Ai_Inbound_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Ai_Inbound_Message_ManyArgs = {
  updates: Array<Whatsapp_Ai_Inbound_Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Ai_Outbox_PartArgs = {
  _append?: InputMaybe<Whatsapp_Ai_Outbox_Part_Append_Input>;
  _delete_at_path?: InputMaybe<Whatsapp_Ai_Outbox_Part_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Whatsapp_Ai_Outbox_Part_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Whatsapp_Ai_Outbox_Part_Delete_Key_Input>;
  _inc?: InputMaybe<Whatsapp_Ai_Outbox_Part_Inc_Input>;
  _prepend?: InputMaybe<Whatsapp_Ai_Outbox_Part_Prepend_Input>;
  _set?: InputMaybe<Whatsapp_Ai_Outbox_Part_Set_Input>;
  where: Whatsapp_Ai_Outbox_Part_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Ai_Outbox_Part_By_PkArgs = {
  _append?: InputMaybe<Whatsapp_Ai_Outbox_Part_Append_Input>;
  _delete_at_path?: InputMaybe<Whatsapp_Ai_Outbox_Part_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Whatsapp_Ai_Outbox_Part_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Whatsapp_Ai_Outbox_Part_Delete_Key_Input>;
  _inc?: InputMaybe<Whatsapp_Ai_Outbox_Part_Inc_Input>;
  _prepend?: InputMaybe<Whatsapp_Ai_Outbox_Part_Prepend_Input>;
  _set?: InputMaybe<Whatsapp_Ai_Outbox_Part_Set_Input>;
  pk_columns: Whatsapp_Ai_Outbox_Part_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Ai_Outbox_Part_ManyArgs = {
  updates: Array<Whatsapp_Ai_Outbox_Part_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Ai_TurnArgs = {
  _append?: InputMaybe<Whatsapp_Ai_Turn_Append_Input>;
  _delete_at_path?: InputMaybe<Whatsapp_Ai_Turn_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Whatsapp_Ai_Turn_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Whatsapp_Ai_Turn_Delete_Key_Input>;
  _inc?: InputMaybe<Whatsapp_Ai_Turn_Inc_Input>;
  _prepend?: InputMaybe<Whatsapp_Ai_Turn_Prepend_Input>;
  _set?: InputMaybe<Whatsapp_Ai_Turn_Set_Input>;
  where: Whatsapp_Ai_Turn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Ai_Turn_By_PkArgs = {
  _append?: InputMaybe<Whatsapp_Ai_Turn_Append_Input>;
  _delete_at_path?: InputMaybe<Whatsapp_Ai_Turn_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Whatsapp_Ai_Turn_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Whatsapp_Ai_Turn_Delete_Key_Input>;
  _inc?: InputMaybe<Whatsapp_Ai_Turn_Inc_Input>;
  _prepend?: InputMaybe<Whatsapp_Ai_Turn_Prepend_Input>;
  _set?: InputMaybe<Whatsapp_Ai_Turn_Set_Input>;
  pk_columns: Whatsapp_Ai_Turn_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Ai_Turn_ManyArgs = {
  updates: Array<Whatsapp_Ai_Turn_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_ChatArgs = {
  _set?: InputMaybe<Whatsapp_Chat_Set_Input>;
  where: Whatsapp_Chat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Chat_By_PkArgs = {
  _set?: InputMaybe<Whatsapp_Chat_Set_Input>;
  pk_columns: Whatsapp_Chat_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Chat_ManyArgs = {
  updates: Array<Whatsapp_Chat_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_HumanArgs = {
  _set?: InputMaybe<Whatsapp_Human_Set_Input>;
  where: Whatsapp_Human_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Human_By_PkArgs = {
  _set?: InputMaybe<Whatsapp_Human_Set_Input>;
  pk_columns: Whatsapp_Human_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Human_ManyArgs = {
  updates: Array<Whatsapp_Human_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Zone_ContainsArgs = {
  _inc?: InputMaybe<Zone_Contains_Inc_Input>;
  _set?: InputMaybe<Zone_Contains_Set_Input>;
  where: Zone_Contains_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Zone_Contains_By_PkArgs = {
  _inc?: InputMaybe<Zone_Contains_Inc_Input>;
  _set?: InputMaybe<Zone_Contains_Set_Input>;
  pk_columns: Zone_Contains_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Zone_Contains_ManyArgs = {
  updates: Array<Zone_Contains_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Zone_Data_MethodArgs = {
  _set?: InputMaybe<Zone_Data_Method_Set_Input>;
  where: Zone_Data_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Zone_Data_Method_By_PkArgs = {
  _set?: InputMaybe<Zone_Data_Method_Set_Input>;
  pk_columns: Zone_Data_Method_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Zone_Data_Method_ManyArgs = {
  updates: Array<Zone_Data_Method_Updates>;
};


/** mutation root */
export type Mutation_RootUpload_To_MuxArgs = {
  object: MuxAssetCreateParams;
};


/** mutation root */
export type Mutation_RootVerify_Sms_CodeArgs = {
  body: VerfiyCodeInput;
};

/** natural language text user types */
export type Natural_Language_Queries = {
  __typename?: 'natural_language_queries';
  amenities_ids?: Maybe<Scalars['jsonb']['output']>;
  chat_response_type?: Maybe<Chat_Response_Type_Enum>;
  class?: Maybe<Query_Classification_Enum>;
  created_at: Scalars['timestamptz']['output'];
  features_ids?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Languages>;
  language_id?: Maybe<Scalars['Int']['output']>;
  map_center_location?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  notifications: Array<Notification>;
  /** An aggregate relationship */
  notifications_aggregate: Notification_Aggregate;
  notify?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  queries_property_results: Array<Queries_Property_Result>;
  /** An aggregate relationship */
  queries_property_results_aggregate: Queries_Property_Result_Aggregate;
  query: Scalars['String']['output'];
  /** An object relationship */
  query_classification?: Maybe<Query_Classification>;
  response?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  search_contexts: Array<Search_Context>;
  /** An aggregate relationship */
  search_contexts_aggregate: Search_Context_Aggregate;
  search_keywords?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  search_session: Search_Sessions;
  session_id: Scalars['uuid']['output'];
  total_found_properties?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  user_notifiations: Array<User_Property_Notifiation>;
  /** An aggregate relationship */
  user_notifiations_aggregate: User_Property_Notifiation_Aggregate;
  where_bool_exp?: Maybe<Scalars['jsonb']['output']>;
};


/** natural language text user types */
export type Natural_Language_QueriesAmenities_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** natural language text user types */
export type Natural_Language_QueriesFeatures_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** natural language text user types */
export type Natural_Language_QueriesMap_Center_LocationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** natural language text user types */
export type Natural_Language_QueriesNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


/** natural language text user types */
export type Natural_Language_QueriesNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


/** natural language text user types */
export type Natural_Language_QueriesQueries_Property_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Queries_Property_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queries_Property_Result_Order_By>>;
  where?: InputMaybe<Queries_Property_Result_Bool_Exp>;
};


/** natural language text user types */
export type Natural_Language_QueriesQueries_Property_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queries_Property_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queries_Property_Result_Order_By>>;
  where?: InputMaybe<Queries_Property_Result_Bool_Exp>;
};


/** natural language text user types */
export type Natural_Language_QueriesSearch_ContextsArgs = {
  distinct_on?: InputMaybe<Array<Search_Context_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Context_Order_By>>;
  where?: InputMaybe<Search_Context_Bool_Exp>;
};


/** natural language text user types */
export type Natural_Language_QueriesSearch_Contexts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Context_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Context_Order_By>>;
  where?: InputMaybe<Search_Context_Bool_Exp>;
};


/** natural language text user types */
export type Natural_Language_QueriesSearch_KeywordsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** natural language text user types */
export type Natural_Language_QueriesUser_NotifiationsArgs = {
  distinct_on?: InputMaybe<Array<User_Property_Notifiation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Property_Notifiation_Order_By>>;
  where?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
};


/** natural language text user types */
export type Natural_Language_QueriesUser_Notifiations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Property_Notifiation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Property_Notifiation_Order_By>>;
  where?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
};


/** natural language text user types */
export type Natural_Language_QueriesWhere_Bool_ExpArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "natural_language_queries" */
export type Natural_Language_Queries_Aggregate = {
  __typename?: 'natural_language_queries_aggregate';
  aggregate?: Maybe<Natural_Language_Queries_Aggregate_Fields>;
  nodes: Array<Natural_Language_Queries>;
};

export type Natural_Language_Queries_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Natural_Language_Queries_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Natural_Language_Queries_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Natural_Language_Queries_Aggregate_Bool_Exp_Count>;
};

export type Natural_Language_Queries_Aggregate_Bool_Exp_Bool_And = {
  arguments: Natural_Language_Queries_Select_Column_Natural_Language_Queries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Natural_Language_Queries_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Natural_Language_Queries_Select_Column_Natural_Language_Queries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Natural_Language_Queries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Natural_Language_Queries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "natural_language_queries" */
export type Natural_Language_Queries_Aggregate_Fields = {
  __typename?: 'natural_language_queries_aggregate_fields';
  avg?: Maybe<Natural_Language_Queries_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Natural_Language_Queries_Max_Fields>;
  min?: Maybe<Natural_Language_Queries_Min_Fields>;
  stddev?: Maybe<Natural_Language_Queries_Stddev_Fields>;
  stddev_pop?: Maybe<Natural_Language_Queries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Natural_Language_Queries_Stddev_Samp_Fields>;
  sum?: Maybe<Natural_Language_Queries_Sum_Fields>;
  var_pop?: Maybe<Natural_Language_Queries_Var_Pop_Fields>;
  var_samp?: Maybe<Natural_Language_Queries_Var_Samp_Fields>;
  variance?: Maybe<Natural_Language_Queries_Variance_Fields>;
};


/** aggregate fields of "natural_language_queries" */
export type Natural_Language_Queries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Natural_Language_Queries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "natural_language_queries" */
export type Natural_Language_Queries_Aggregate_Order_By = {
  avg?: InputMaybe<Natural_Language_Queries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Natural_Language_Queries_Max_Order_By>;
  min?: InputMaybe<Natural_Language_Queries_Min_Order_By>;
  stddev?: InputMaybe<Natural_Language_Queries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Natural_Language_Queries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Natural_Language_Queries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Natural_Language_Queries_Sum_Order_By>;
  var_pop?: InputMaybe<Natural_Language_Queries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Natural_Language_Queries_Var_Samp_Order_By>;
  variance?: InputMaybe<Natural_Language_Queries_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Natural_Language_Queries_Append_Input = {
  amenities_ids?: InputMaybe<Scalars['jsonb']['input']>;
  features_ids?: InputMaybe<Scalars['jsonb']['input']>;
  map_center_location?: InputMaybe<Scalars['jsonb']['input']>;
  search_keywords?: InputMaybe<Scalars['jsonb']['input']>;
  where_bool_exp?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "natural_language_queries" */
export type Natural_Language_Queries_Arr_Rel_Insert_Input = {
  data: Array<Natural_Language_Queries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Natural_Language_Queries_On_Conflict>;
};

/** aggregate avg on columns */
export type Natural_Language_Queries_Avg_Fields = {
  __typename?: 'natural_language_queries_avg_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  total_found_properties?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "natural_language_queries" */
export type Natural_Language_Queries_Avg_Order_By = {
  language_id?: InputMaybe<Order_By>;
  total_found_properties?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "natural_language_queries". All fields are combined with a logical 'AND'. */
export type Natural_Language_Queries_Bool_Exp = {
  _and?: InputMaybe<Array<Natural_Language_Queries_Bool_Exp>>;
  _not?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
  _or?: InputMaybe<Array<Natural_Language_Queries_Bool_Exp>>;
  amenities_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  chat_response_type?: InputMaybe<Chat_Response_Type_Enum_Comparison_Exp>;
  class?: InputMaybe<Query_Classification_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  features_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  language_id?: InputMaybe<Int_Comparison_Exp>;
  map_center_location?: InputMaybe<Jsonb_Comparison_Exp>;
  notifications?: InputMaybe<Notification_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notification_Aggregate_Bool_Exp>;
  notify?: InputMaybe<Boolean_Comparison_Exp>;
  queries_property_results?: InputMaybe<Queries_Property_Result_Bool_Exp>;
  queries_property_results_aggregate?: InputMaybe<Queries_Property_Result_Aggregate_Bool_Exp>;
  query?: InputMaybe<String_Comparison_Exp>;
  query_classification?: InputMaybe<Query_Classification_Bool_Exp>;
  response?: InputMaybe<String_Comparison_Exp>;
  search_contexts?: InputMaybe<Search_Context_Bool_Exp>;
  search_contexts_aggregate?: InputMaybe<Search_Context_Aggregate_Bool_Exp>;
  search_keywords?: InputMaybe<Jsonb_Comparison_Exp>;
  search_session?: InputMaybe<Search_Sessions_Bool_Exp>;
  session_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_found_properties?: InputMaybe<Int_Comparison_Exp>;
  user_notifiations?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
  user_notifiations_aggregate?: InputMaybe<User_Property_Notifiation_Aggregate_Bool_Exp>;
  where_bool_exp?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "natural_language_queries" */
export enum Natural_Language_Queries_Constraint {
  /** unique or primary key constraint on columns "id" */
  NaturalLanguageQueriesPkey = 'natural_language_queries_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Natural_Language_Queries_Delete_At_Path_Input = {
  amenities_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  features_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  map_center_location?: InputMaybe<Array<Scalars['String']['input']>>;
  search_keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  where_bool_exp?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Natural_Language_Queries_Delete_Elem_Input = {
  amenities_ids?: InputMaybe<Scalars['Int']['input']>;
  features_ids?: InputMaybe<Scalars['Int']['input']>;
  map_center_location?: InputMaybe<Scalars['Int']['input']>;
  search_keywords?: InputMaybe<Scalars['Int']['input']>;
  where_bool_exp?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Natural_Language_Queries_Delete_Key_Input = {
  amenities_ids?: InputMaybe<Scalars['String']['input']>;
  features_ids?: InputMaybe<Scalars['String']['input']>;
  map_center_location?: InputMaybe<Scalars['String']['input']>;
  search_keywords?: InputMaybe<Scalars['String']['input']>;
  where_bool_exp?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "natural_language_queries" */
export type Natural_Language_Queries_Inc_Input = {
  language_id?: InputMaybe<Scalars['Int']['input']>;
  total_found_properties?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "natural_language_queries" */
export type Natural_Language_Queries_Insert_Input = {
  amenities_ids?: InputMaybe<Scalars['jsonb']['input']>;
  chat_response_type?: InputMaybe<Chat_Response_Type_Enum>;
  class?: InputMaybe<Query_Classification_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  features_ids?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  map_center_location?: InputMaybe<Scalars['jsonb']['input']>;
  notifications?: InputMaybe<Notification_Arr_Rel_Insert_Input>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  queries_property_results?: InputMaybe<Queries_Property_Result_Arr_Rel_Insert_Input>;
  query?: InputMaybe<Scalars['String']['input']>;
  query_classification?: InputMaybe<Query_Classification_Obj_Rel_Insert_Input>;
  response?: InputMaybe<Scalars['String']['input']>;
  search_contexts?: InputMaybe<Search_Context_Arr_Rel_Insert_Input>;
  search_keywords?: InputMaybe<Scalars['jsonb']['input']>;
  search_session?: InputMaybe<Search_Sessions_Obj_Rel_Insert_Input>;
  session_id?: InputMaybe<Scalars['uuid']['input']>;
  total_found_properties?: InputMaybe<Scalars['Int']['input']>;
  user_notifiations?: InputMaybe<User_Property_Notifiation_Arr_Rel_Insert_Input>;
  where_bool_exp?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Natural_Language_Queries_Max_Fields = {
  __typename?: 'natural_language_queries_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['uuid']['output']>;
  total_found_properties?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "natural_language_queries" */
export type Natural_Language_Queries_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  query?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  total_found_properties?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Natural_Language_Queries_Min_Fields = {
  __typename?: 'natural_language_queries_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['uuid']['output']>;
  total_found_properties?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "natural_language_queries" */
export type Natural_Language_Queries_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  query?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  total_found_properties?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "natural_language_queries" */
export type Natural_Language_Queries_Mutation_Response = {
  __typename?: 'natural_language_queries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Natural_Language_Queries>;
};

/** input type for inserting object relation for remote table "natural_language_queries" */
export type Natural_Language_Queries_Obj_Rel_Insert_Input = {
  data: Natural_Language_Queries_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Natural_Language_Queries_On_Conflict>;
};

/** on_conflict condition type for table "natural_language_queries" */
export type Natural_Language_Queries_On_Conflict = {
  constraint: Natural_Language_Queries_Constraint;
  update_columns?: Array<Natural_Language_Queries_Update_Column>;
  where?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
};

/** Ordering options when selecting data from "natural_language_queries". */
export type Natural_Language_Queries_Order_By = {
  amenities_ids?: InputMaybe<Order_By>;
  chat_response_type?: InputMaybe<Order_By>;
  class?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  features_ids?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  map_center_location?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notification_Aggregate_Order_By>;
  notify?: InputMaybe<Order_By>;
  queries_property_results_aggregate?: InputMaybe<Queries_Property_Result_Aggregate_Order_By>;
  query?: InputMaybe<Order_By>;
  query_classification?: InputMaybe<Query_Classification_Order_By>;
  response?: InputMaybe<Order_By>;
  search_contexts_aggregate?: InputMaybe<Search_Context_Aggregate_Order_By>;
  search_keywords?: InputMaybe<Order_By>;
  search_session?: InputMaybe<Search_Sessions_Order_By>;
  session_id?: InputMaybe<Order_By>;
  total_found_properties?: InputMaybe<Order_By>;
  user_notifiations_aggregate?: InputMaybe<User_Property_Notifiation_Aggregate_Order_By>;
  where_bool_exp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: natural_language_queries */
export type Natural_Language_Queries_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Natural_Language_Queries_Prepend_Input = {
  amenities_ids?: InputMaybe<Scalars['jsonb']['input']>;
  features_ids?: InputMaybe<Scalars['jsonb']['input']>;
  map_center_location?: InputMaybe<Scalars['jsonb']['input']>;
  search_keywords?: InputMaybe<Scalars['jsonb']['input']>;
  where_bool_exp?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "natural_language_queries" */
export enum Natural_Language_Queries_Select_Column {
  /** column name */
  AmenitiesIds = 'amenities_ids',
  /** column name */
  ChatResponseType = 'chat_response_type',
  /** column name */
  Class = 'class',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeaturesIds = 'features_ids',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  MapCenterLocation = 'map_center_location',
  /** column name */
  Notify = 'notify',
  /** column name */
  Query = 'query',
  /** column name */
  Response = 'response',
  /** column name */
  SearchKeywords = 'search_keywords',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TotalFoundProperties = 'total_found_properties',
  /** column name */
  WhereBoolExp = 'where_bool_exp'
}

/** select "natural_language_queries_aggregate_bool_exp_bool_and_arguments_columns" columns of table "natural_language_queries" */
export enum Natural_Language_Queries_Select_Column_Natural_Language_Queries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Notify = 'notify'
}

/** select "natural_language_queries_aggregate_bool_exp_bool_or_arguments_columns" columns of table "natural_language_queries" */
export enum Natural_Language_Queries_Select_Column_Natural_Language_Queries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Notify = 'notify'
}

/** input type for updating data in table "natural_language_queries" */
export type Natural_Language_Queries_Set_Input = {
  amenities_ids?: InputMaybe<Scalars['jsonb']['input']>;
  chat_response_type?: InputMaybe<Chat_Response_Type_Enum>;
  class?: InputMaybe<Query_Classification_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  features_ids?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  map_center_location?: InputMaybe<Scalars['jsonb']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  search_keywords?: InputMaybe<Scalars['jsonb']['input']>;
  session_id?: InputMaybe<Scalars['uuid']['input']>;
  total_found_properties?: InputMaybe<Scalars['Int']['input']>;
  where_bool_exp?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Natural_Language_Queries_Stddev_Fields = {
  __typename?: 'natural_language_queries_stddev_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  total_found_properties?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "natural_language_queries" */
export type Natural_Language_Queries_Stddev_Order_By = {
  language_id?: InputMaybe<Order_By>;
  total_found_properties?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Natural_Language_Queries_Stddev_Pop_Fields = {
  __typename?: 'natural_language_queries_stddev_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  total_found_properties?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "natural_language_queries" */
export type Natural_Language_Queries_Stddev_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
  total_found_properties?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Natural_Language_Queries_Stddev_Samp_Fields = {
  __typename?: 'natural_language_queries_stddev_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  total_found_properties?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "natural_language_queries" */
export type Natural_Language_Queries_Stddev_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
  total_found_properties?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "natural_language_queries" */
export type Natural_Language_Queries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Natural_Language_Queries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Natural_Language_Queries_Stream_Cursor_Value_Input = {
  amenities_ids?: InputMaybe<Scalars['jsonb']['input']>;
  chat_response_type?: InputMaybe<Chat_Response_Type_Enum>;
  class?: InputMaybe<Query_Classification_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  features_ids?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  map_center_location?: InputMaybe<Scalars['jsonb']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  search_keywords?: InputMaybe<Scalars['jsonb']['input']>;
  session_id?: InputMaybe<Scalars['uuid']['input']>;
  total_found_properties?: InputMaybe<Scalars['Int']['input']>;
  where_bool_exp?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Natural_Language_Queries_Sum_Fields = {
  __typename?: 'natural_language_queries_sum_fields';
  language_id?: Maybe<Scalars['Int']['output']>;
  total_found_properties?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "natural_language_queries" */
export type Natural_Language_Queries_Sum_Order_By = {
  language_id?: InputMaybe<Order_By>;
  total_found_properties?: InputMaybe<Order_By>;
};

/** update columns of table "natural_language_queries" */
export enum Natural_Language_Queries_Update_Column {
  /** column name */
  AmenitiesIds = 'amenities_ids',
  /** column name */
  ChatResponseType = 'chat_response_type',
  /** column name */
  Class = 'class',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeaturesIds = 'features_ids',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  MapCenterLocation = 'map_center_location',
  /** column name */
  Notify = 'notify',
  /** column name */
  Query = 'query',
  /** column name */
  Response = 'response',
  /** column name */
  SearchKeywords = 'search_keywords',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TotalFoundProperties = 'total_found_properties',
  /** column name */
  WhereBoolExp = 'where_bool_exp'
}

export type Natural_Language_Queries_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Natural_Language_Queries_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Natural_Language_Queries_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Natural_Language_Queries_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Natural_Language_Queries_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Natural_Language_Queries_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Natural_Language_Queries_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Natural_Language_Queries_Set_Input>;
  /** filter the rows which have to be updated */
  where: Natural_Language_Queries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Natural_Language_Queries_Var_Pop_Fields = {
  __typename?: 'natural_language_queries_var_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  total_found_properties?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "natural_language_queries" */
export type Natural_Language_Queries_Var_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
  total_found_properties?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Natural_Language_Queries_Var_Samp_Fields = {
  __typename?: 'natural_language_queries_var_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  total_found_properties?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "natural_language_queries" */
export type Natural_Language_Queries_Var_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
  total_found_properties?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Natural_Language_Queries_Variance_Fields = {
  __typename?: 'natural_language_queries_variance_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  total_found_properties?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "natural_language_queries" */
export type Natural_Language_Queries_Variance_Order_By = {
  language_id?: InputMaybe<Order_By>;
  total_found_properties?: InputMaybe<Order_By>;
};

/** columns and relationships of "notification" */
export type Notification = {
  __typename?: 'notification';
  city?: Maybe<City>;
  city_id?: Maybe<Scalars['uuid']['output']>;
  city_zone?: Maybe<City_Zone>;
  city_zone_id?: Maybe<Scalars['uuid']['output']>;
  cluster?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Main_Currency_Enum>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  geo_location_draw?: Maybe<Scalars['geography']['output']>;
  id: Scalars['uuid']['output'];
  max_bathrooms?: Maybe<Scalars['Int']['output']>;
  max_bedrooms?: Maybe<Scalars['Int']['output']>;
  min_bathrooms?: Maybe<Scalars['Int']['output']>;
  min_bedrooms?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  natural_language_query?: Maybe<Natural_Language_Queries>;
  nlq_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  notification_amenities: Array<Notification_Amenities>;
  /** An aggregate relationship */
  notification_amenities_aggregate: Notification_Amenities_Aggregate;
  /** An array relationship */
  notification_features: Array<Notification_Feature>;
  /** An aggregate relationship */
  notification_features_aggregate: Notification_Feature_Aggregate;
  /** An array relationship */
  notification_property_types: Array<Notification_Property_Type>;
  /** An aggregate relationship */
  notification_property_types_aggregate: Notification_Property_Type_Aggregate;
  opened?: Maybe<Scalars['Boolean']['output']>;
  price_max?: Maybe<Scalars['float8']['output']>;
  price_min?: Maybe<Scalars['float8']['output']>;
  property_clsuter?: Maybe<Property_Cluster>;
  property_composition?: Maybe<Property_Composition>;
  property_composition_id?: Maybe<Scalars['uuid']['output']>;
  property_origin_type?: Maybe<Scalars['String']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  sq_max?: Maybe<Scalars['float8']['output']>;
  sq_min?: Maybe<Scalars['float8']['output']>;
  status_property?: Maybe<Property_Status>;
  title?: Maybe<Scalars['String']['output']>;
  type_property_origin?: Maybe<Property_Origin_Type>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_membership_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  user_property_notifiations: Array<User_Property_Notifiation>;
  /** An aggregate relationship */
  user_property_notifiations_aggregate: User_Property_Notifiation_Aggregate;
};


/** columns and relationships of "notification" */
export type NotificationNotification_AmenitiesArgs = {
  distinct_on?: InputMaybe<Array<Notification_Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Amenities_Order_By>>;
  where?: InputMaybe<Notification_Amenities_Bool_Exp>;
};


/** columns and relationships of "notification" */
export type NotificationNotification_Amenities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Amenities_Order_By>>;
  where?: InputMaybe<Notification_Amenities_Bool_Exp>;
};


/** columns and relationships of "notification" */
export type NotificationNotification_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Notification_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Feature_Order_By>>;
  where?: InputMaybe<Notification_Feature_Bool_Exp>;
};


/** columns and relationships of "notification" */
export type NotificationNotification_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Feature_Order_By>>;
  where?: InputMaybe<Notification_Feature_Bool_Exp>;
};


/** columns and relationships of "notification" */
export type NotificationNotification_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Notification_Property_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Property_Type_Order_By>>;
  where?: InputMaybe<Notification_Property_Type_Bool_Exp>;
};


/** columns and relationships of "notification" */
export type NotificationNotification_Property_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Property_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Property_Type_Order_By>>;
  where?: InputMaybe<Notification_Property_Type_Bool_Exp>;
};


/** columns and relationships of "notification" */
export type NotificationUser_Property_NotifiationsArgs = {
  distinct_on?: InputMaybe<Array<User_Property_Notifiation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Property_Notifiation_Order_By>>;
  where?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
};


/** columns and relationships of "notification" */
export type NotificationUser_Property_Notifiations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Property_Notifiation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Property_Notifiation_Order_By>>;
  where?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
};

/** aggregated selection of "notification" */
export type Notification_Aggregate = {
  __typename?: 'notification_aggregate';
  aggregate?: Maybe<Notification_Aggregate_Fields>;
  nodes: Array<Notification>;
};

export type Notification_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Notification_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Notification_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Notification_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Notification_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Notification_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Notification_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Notification_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Notification_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Notification_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Notification_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Notification_Aggregate_Bool_Exp_Var_Samp>;
};

export type Notification_Aggregate_Bool_Exp_Avg = {
  arguments: Notification_Select_Column_Notification_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Notification_Aggregate_Bool_Exp_Bool_And = {
  arguments: Notification_Select_Column_Notification_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Notification_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Notification_Select_Column_Notification_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Notification_Aggregate_Bool_Exp_Corr = {
  arguments: Notification_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Notification_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Notification_Select_Column_Notification_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Notification_Select_Column_Notification_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Notification_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Notification_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Notification_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Notification_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Notification_Select_Column_Notification_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Notification_Select_Column_Notification_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Notification_Aggregate_Bool_Exp_Max = {
  arguments: Notification_Select_Column_Notification_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Notification_Aggregate_Bool_Exp_Min = {
  arguments: Notification_Select_Column_Notification_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Notification_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Notification_Select_Column_Notification_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Notification_Aggregate_Bool_Exp_Sum = {
  arguments: Notification_Select_Column_Notification_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Notification_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Notification_Select_Column_Notification_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "notification" */
export type Notification_Aggregate_Fields = {
  __typename?: 'notification_aggregate_fields';
  avg?: Maybe<Notification_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Notification_Max_Fields>;
  min?: Maybe<Notification_Min_Fields>;
  stddev?: Maybe<Notification_Stddev_Fields>;
  stddev_pop?: Maybe<Notification_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notification_Stddev_Samp_Fields>;
  sum?: Maybe<Notification_Sum_Fields>;
  var_pop?: Maybe<Notification_Var_Pop_Fields>;
  var_samp?: Maybe<Notification_Var_Samp_Fields>;
  variance?: Maybe<Notification_Variance_Fields>;
};


/** aggregate fields of "notification" */
export type Notification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "notification" */
export type Notification_Aggregate_Order_By = {
  avg?: InputMaybe<Notification_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notification_Max_Order_By>;
  min?: InputMaybe<Notification_Min_Order_By>;
  stddev?: InputMaybe<Notification_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Notification_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Notification_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Notification_Sum_Order_By>;
  var_pop?: InputMaybe<Notification_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Notification_Var_Samp_Order_By>;
  variance?: InputMaybe<Notification_Variance_Order_By>;
};

/** columns and relationships of "notification_amenities" */
export type Notification_Amenities = {
  __typename?: 'notification_amenities';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  notification: Notification;
  notification_id: Scalars['uuid']['output'];
  property_amenities_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "notification_amenities" */
export type Notification_Amenities_Aggregate = {
  __typename?: 'notification_amenities_aggregate';
  aggregate?: Maybe<Notification_Amenities_Aggregate_Fields>;
  nodes: Array<Notification_Amenities>;
};

export type Notification_Amenities_Aggregate_Bool_Exp = {
  count?: InputMaybe<Notification_Amenities_Aggregate_Bool_Exp_Count>;
};

export type Notification_Amenities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Notification_Amenities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Amenities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notification_amenities" */
export type Notification_Amenities_Aggregate_Fields = {
  __typename?: 'notification_amenities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Notification_Amenities_Max_Fields>;
  min?: Maybe<Notification_Amenities_Min_Fields>;
};


/** aggregate fields of "notification_amenities" */
export type Notification_Amenities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Amenities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "notification_amenities" */
export type Notification_Amenities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notification_Amenities_Max_Order_By>;
  min?: InputMaybe<Notification_Amenities_Min_Order_By>;
};

/** input type for inserting array relation for remote table "notification_amenities" */
export type Notification_Amenities_Arr_Rel_Insert_Input = {
  data: Array<Notification_Amenities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_Amenities_On_Conflict>;
};

/** Boolean expression to filter rows from the table "notification_amenities". All fields are combined with a logical 'AND'. */
export type Notification_Amenities_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Amenities_Bool_Exp>>;
  _not?: InputMaybe<Notification_Amenities_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Amenities_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notification?: InputMaybe<Notification_Bool_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_amenities_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_amenities" */
export enum Notification_Amenities_Constraint {
  /** unique or primary key constraint on columns "property_amenities_id", "notification_id" */
  NotificationAmenitiesNotificationIdPropertyAmenitiesIKey = 'notification_amenities_notification_id_property_amenities_i_key',
  /** unique or primary key constraint on columns "id" */
  NotificationAmenitiesPkey = 'notification_amenities_pkey'
}

/** input type for inserting data into table "notification_amenities" */
export type Notification_Amenities_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification?: InputMaybe<Notification_Obj_Rel_Insert_Input>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  property_amenities_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Notification_Amenities_Max_Fields = {
  __typename?: 'notification_amenities_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notification_id?: Maybe<Scalars['uuid']['output']>;
  property_amenities_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "notification_amenities" */
export type Notification_Amenities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  property_amenities_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notification_Amenities_Min_Fields = {
  __typename?: 'notification_amenities_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notification_id?: Maybe<Scalars['uuid']['output']>;
  property_amenities_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "notification_amenities" */
export type Notification_Amenities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  property_amenities_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_amenities" */
export type Notification_Amenities_Mutation_Response = {
  __typename?: 'notification_amenities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Amenities>;
};

/** on_conflict condition type for table "notification_amenities" */
export type Notification_Amenities_On_Conflict = {
  constraint: Notification_Amenities_Constraint;
  update_columns?: Array<Notification_Amenities_Update_Column>;
  where?: InputMaybe<Notification_Amenities_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_amenities". */
export type Notification_Amenities_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification?: InputMaybe<Notification_Order_By>;
  notification_id?: InputMaybe<Order_By>;
  property_amenities_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_amenities */
export type Notification_Amenities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "notification_amenities" */
export enum Notification_Amenities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  PropertyAmenitiesId = 'property_amenities_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "notification_amenities" */
export type Notification_Amenities_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  property_amenities_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "notification_amenities" */
export type Notification_Amenities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Amenities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Amenities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  property_amenities_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "notification_amenities" */
export enum Notification_Amenities_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  PropertyAmenitiesId = 'property_amenities_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Notification_Amenities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Amenities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Amenities_Bool_Exp;
};

/** input type for inserting array relation for remote table "notification" */
export type Notification_Arr_Rel_Insert_Input = {
  data: Array<Notification_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_On_Conflict>;
};

/** aggregate avg on columns */
export type Notification_Avg_Fields = {
  __typename?: 'notification_avg_fields';
  max_bathrooms?: Maybe<Scalars['Float']['output']>;
  max_bedrooms?: Maybe<Scalars['Float']['output']>;
  min_bathrooms?: Maybe<Scalars['Float']['output']>;
  min_bedrooms?: Maybe<Scalars['Float']['output']>;
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "notification" */
export type Notification_Avg_Order_By = {
  max_bathrooms?: InputMaybe<Order_By>;
  max_bedrooms?: InputMaybe<Order_By>;
  min_bathrooms?: InputMaybe<Order_By>;
  min_bedrooms?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notification". All fields are combined with a logical 'AND'. */
export type Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Bool_Exp>>;
  _not?: InputMaybe<Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Bool_Exp>>;
  city_id?: InputMaybe<Uuid_Comparison_Exp>;
  city_zone_id?: InputMaybe<Uuid_Comparison_Exp>;
  cluster?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<Main_Currency_Enum_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  geo_location_draw?: InputMaybe<Geography_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  max_bathrooms?: InputMaybe<Int_Comparison_Exp>;
  max_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  min_bathrooms?: InputMaybe<Int_Comparison_Exp>;
  min_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  natural_language_query?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
  nlq_id?: InputMaybe<Uuid_Comparison_Exp>;
  notification_amenities?: InputMaybe<Notification_Amenities_Bool_Exp>;
  notification_amenities_aggregate?: InputMaybe<Notification_Amenities_Aggregate_Bool_Exp>;
  notification_features?: InputMaybe<Notification_Feature_Bool_Exp>;
  notification_features_aggregate?: InputMaybe<Notification_Feature_Aggregate_Bool_Exp>;
  notification_property_types?: InputMaybe<Notification_Property_Type_Bool_Exp>;
  notification_property_types_aggregate?: InputMaybe<Notification_Property_Type_Aggregate_Bool_Exp>;
  opened?: InputMaybe<Boolean_Comparison_Exp>;
  price_max?: InputMaybe<Float8_Comparison_Exp>;
  price_min?: InputMaybe<Float8_Comparison_Exp>;
  property_composition_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_origin_type?: InputMaybe<String_Comparison_Exp>;
  property_status?: InputMaybe<String_Comparison_Exp>;
  sq_max?: InputMaybe<Float8_Comparison_Exp>;
  sq_min?: InputMaybe<Float8_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_membership_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_property_notifiations?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
  user_property_notifiations_aggregate?: InputMaybe<User_Property_Notifiation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "notification" */
export enum Notification_Constraint {
  /** unique or primary key constraint on columns "nlq_id" */
  NotificationNlqIdKey = 'notification_nlq_id_key',
  /** unique or primary key constraint on columns "id" */
  NotificationPkey = 'notification_pkey'
}

/** columns and relationships of "notification_feature" */
export type Notification_Feature = {
  __typename?: 'notification_feature';
  created_at: Scalars['timestamptz']['output'];
  feature?: Maybe<Feature>;
  feature_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  notification: Notification;
  notification_id: Scalars['uuid']['output'];
  removed: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "notification_feature" */
export type Notification_Feature_Aggregate = {
  __typename?: 'notification_feature_aggregate';
  aggregate?: Maybe<Notification_Feature_Aggregate_Fields>;
  nodes: Array<Notification_Feature>;
};

export type Notification_Feature_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Notification_Feature_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Notification_Feature_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Notification_Feature_Aggregate_Bool_Exp_Count>;
};

export type Notification_Feature_Aggregate_Bool_Exp_Bool_And = {
  arguments: Notification_Feature_Select_Column_Notification_Feature_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Feature_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Notification_Feature_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Notification_Feature_Select_Column_Notification_Feature_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Feature_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Notification_Feature_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Notification_Feature_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Feature_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notification_feature" */
export type Notification_Feature_Aggregate_Fields = {
  __typename?: 'notification_feature_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Notification_Feature_Max_Fields>;
  min?: Maybe<Notification_Feature_Min_Fields>;
};


/** aggregate fields of "notification_feature" */
export type Notification_Feature_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Feature_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "notification_feature" */
export type Notification_Feature_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notification_Feature_Max_Order_By>;
  min?: InputMaybe<Notification_Feature_Min_Order_By>;
};

/** input type for inserting array relation for remote table "notification_feature" */
export type Notification_Feature_Arr_Rel_Insert_Input = {
  data: Array<Notification_Feature_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_Feature_On_Conflict>;
};

/** Boolean expression to filter rows from the table "notification_feature". All fields are combined with a logical 'AND'. */
export type Notification_Feature_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Feature_Bool_Exp>>;
  _not?: InputMaybe<Notification_Feature_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Feature_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  feature_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notification?: InputMaybe<Notification_Bool_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_feature" */
export enum Notification_Feature_Constraint {
  /** unique or primary key constraint on columns "feature_id", "notification_id" */
  NotificationFeatureFeatureIdNotificationIdKey = 'notification_feature_feature_id_notification_id_key',
  /** unique or primary key constraint on columns "id" */
  NotificationFeaturePkey = 'notification_feature_pkey'
}

/** input type for inserting data into table "notification_feature" */
export type Notification_Feature_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feature_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification?: InputMaybe<Notification_Obj_Rel_Insert_Input>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  removed?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Notification_Feature_Max_Fields = {
  __typename?: 'notification_feature_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  feature_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notification_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "notification_feature" */
export type Notification_Feature_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  feature_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notification_Feature_Min_Fields = {
  __typename?: 'notification_feature_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  feature_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notification_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "notification_feature" */
export type Notification_Feature_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  feature_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_feature" */
export type Notification_Feature_Mutation_Response = {
  __typename?: 'notification_feature_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Feature>;
};

/** on_conflict condition type for table "notification_feature" */
export type Notification_Feature_On_Conflict = {
  constraint: Notification_Feature_Constraint;
  update_columns?: Array<Notification_Feature_Update_Column>;
  where?: InputMaybe<Notification_Feature_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_feature". */
export type Notification_Feature_Order_By = {
  created_at?: InputMaybe<Order_By>;
  feature_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification?: InputMaybe<Notification_Order_By>;
  notification_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_feature */
export type Notification_Feature_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "notification_feature" */
export enum Notification_Feature_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeatureId = 'feature_id',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "notification_feature_aggregate_bool_exp_bool_and_arguments_columns" columns of table "notification_feature" */
export enum Notification_Feature_Select_Column_Notification_Feature_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Removed = 'removed'
}

/** select "notification_feature_aggregate_bool_exp_bool_or_arguments_columns" columns of table "notification_feature" */
export enum Notification_Feature_Select_Column_Notification_Feature_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Removed = 'removed'
}

/** input type for updating data in table "notification_feature" */
export type Notification_Feature_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feature_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  removed?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "notification_feature" */
export type Notification_Feature_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Feature_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Feature_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feature_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  removed?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "notification_feature" */
export enum Notification_Feature_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeatureId = 'feature_id',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Notification_Feature_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Feature_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Feature_Bool_Exp;
};

/** input type for incrementing numeric columns in table "notification" */
export type Notification_Inc_Input = {
  max_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  max_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  min_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  min_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  price_max?: InputMaybe<Scalars['float8']['input']>;
  price_min?: InputMaybe<Scalars['float8']['input']>;
  sq_max?: InputMaybe<Scalars['float8']['input']>;
  sq_min?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "notification" */
export type Notification_Insert_Input = {
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  cluster?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Main_Currency_Enum>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  geo_location_draw?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  max_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  max_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  min_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  min_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  natural_language_query?: InputMaybe<Natural_Language_Queries_Obj_Rel_Insert_Input>;
  nlq_id?: InputMaybe<Scalars['uuid']['input']>;
  notification_amenities?: InputMaybe<Notification_Amenities_Arr_Rel_Insert_Input>;
  notification_features?: InputMaybe<Notification_Feature_Arr_Rel_Insert_Input>;
  notification_property_types?: InputMaybe<Notification_Property_Type_Arr_Rel_Insert_Input>;
  opened?: InputMaybe<Scalars['Boolean']['input']>;
  price_max?: InputMaybe<Scalars['float8']['input']>;
  price_min?: InputMaybe<Scalars['float8']['input']>;
  property_composition_id?: InputMaybe<Scalars['uuid']['input']>;
  property_origin_type?: InputMaybe<Scalars['String']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  sq_max?: InputMaybe<Scalars['float8']['input']>;
  sq_min?: InputMaybe<Scalars['float8']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_membership_id?: InputMaybe<Scalars['uuid']['input']>;
  user_property_notifiations?: InputMaybe<User_Property_Notifiation_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Notification_Max_Fields = {
  __typename?: 'notification_max_fields';
  city_id?: Maybe<Scalars['uuid']['output']>;
  city_zone_id?: Maybe<Scalars['uuid']['output']>;
  cluster?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  max_bathrooms?: Maybe<Scalars['Int']['output']>;
  max_bedrooms?: Maybe<Scalars['Int']['output']>;
  min_bathrooms?: Maybe<Scalars['Int']['output']>;
  min_bedrooms?: Maybe<Scalars['Int']['output']>;
  nlq_id?: Maybe<Scalars['uuid']['output']>;
  price_max?: Maybe<Scalars['float8']['output']>;
  price_min?: Maybe<Scalars['float8']['output']>;
  property_composition_id?: Maybe<Scalars['uuid']['output']>;
  property_origin_type?: Maybe<Scalars['String']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  sq_max?: Maybe<Scalars['float8']['output']>;
  sq_min?: Maybe<Scalars['float8']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_membership_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "notification" */
export type Notification_Max_Order_By = {
  city_id?: InputMaybe<Order_By>;
  city_zone_id?: InputMaybe<Order_By>;
  cluster?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_bathrooms?: InputMaybe<Order_By>;
  max_bedrooms?: InputMaybe<Order_By>;
  min_bathrooms?: InputMaybe<Order_By>;
  min_bedrooms?: InputMaybe<Order_By>;
  nlq_id?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  property_composition_id?: InputMaybe<Order_By>;
  property_origin_type?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_membership_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notification_Min_Fields = {
  __typename?: 'notification_min_fields';
  city_id?: Maybe<Scalars['uuid']['output']>;
  city_zone_id?: Maybe<Scalars['uuid']['output']>;
  cluster?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  max_bathrooms?: Maybe<Scalars['Int']['output']>;
  max_bedrooms?: Maybe<Scalars['Int']['output']>;
  min_bathrooms?: Maybe<Scalars['Int']['output']>;
  min_bedrooms?: Maybe<Scalars['Int']['output']>;
  nlq_id?: Maybe<Scalars['uuid']['output']>;
  price_max?: Maybe<Scalars['float8']['output']>;
  price_min?: Maybe<Scalars['float8']['output']>;
  property_composition_id?: Maybe<Scalars['uuid']['output']>;
  property_origin_type?: Maybe<Scalars['String']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  sq_max?: Maybe<Scalars['float8']['output']>;
  sq_min?: Maybe<Scalars['float8']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_membership_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "notification" */
export type Notification_Min_Order_By = {
  city_id?: InputMaybe<Order_By>;
  city_zone_id?: InputMaybe<Order_By>;
  cluster?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_bathrooms?: InputMaybe<Order_By>;
  max_bedrooms?: InputMaybe<Order_By>;
  min_bathrooms?: InputMaybe<Order_By>;
  min_bedrooms?: InputMaybe<Order_By>;
  nlq_id?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  property_composition_id?: InputMaybe<Order_By>;
  property_origin_type?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_membership_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification" */
export type Notification_Mutation_Response = {
  __typename?: 'notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification>;
};

/** input type for inserting object relation for remote table "notification" */
export type Notification_Obj_Rel_Insert_Input = {
  data: Notification_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_On_Conflict>;
};

/** on_conflict condition type for table "notification" */
export type Notification_On_Conflict = {
  constraint: Notification_Constraint;
  update_columns?: Array<Notification_Update_Column>;
  where?: InputMaybe<Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "notification". */
export type Notification_Order_By = {
  city_id?: InputMaybe<Order_By>;
  city_zone_id?: InputMaybe<Order_By>;
  cluster?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  geo_location_draw?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_bathrooms?: InputMaybe<Order_By>;
  max_bedrooms?: InputMaybe<Order_By>;
  min_bathrooms?: InputMaybe<Order_By>;
  min_bedrooms?: InputMaybe<Order_By>;
  natural_language_query?: InputMaybe<Natural_Language_Queries_Order_By>;
  nlq_id?: InputMaybe<Order_By>;
  notification_amenities_aggregate?: InputMaybe<Notification_Amenities_Aggregate_Order_By>;
  notification_features_aggregate?: InputMaybe<Notification_Feature_Aggregate_Order_By>;
  notification_property_types_aggregate?: InputMaybe<Notification_Property_Type_Aggregate_Order_By>;
  opened?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  property_composition_id?: InputMaybe<Order_By>;
  property_origin_type?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_membership_id?: InputMaybe<Order_By>;
  user_property_notifiations_aggregate?: InputMaybe<User_Property_Notifiation_Aggregate_Order_By>;
};

/** primary key columns input for table: notification */
export type Notification_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "notification_property_type" */
export type Notification_Property_Type = {
  __typename?: 'notification_property_type';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  notification: Notification;
  notification_id: Scalars['uuid']['output'];
  property_type: Scalars['String']['output'];
  type?: Maybe<Property_Type>;
};

/** aggregated selection of "notification_property_type" */
export type Notification_Property_Type_Aggregate = {
  __typename?: 'notification_property_type_aggregate';
  aggregate?: Maybe<Notification_Property_Type_Aggregate_Fields>;
  nodes: Array<Notification_Property_Type>;
};

export type Notification_Property_Type_Aggregate_Bool_Exp = {
  count?: InputMaybe<Notification_Property_Type_Aggregate_Bool_Exp_Count>;
};

export type Notification_Property_Type_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Notification_Property_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notification_Property_Type_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notification_property_type" */
export type Notification_Property_Type_Aggregate_Fields = {
  __typename?: 'notification_property_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Notification_Property_Type_Max_Fields>;
  min?: Maybe<Notification_Property_Type_Min_Fields>;
};


/** aggregate fields of "notification_property_type" */
export type Notification_Property_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Property_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "notification_property_type" */
export type Notification_Property_Type_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notification_Property_Type_Max_Order_By>;
  min?: InputMaybe<Notification_Property_Type_Min_Order_By>;
};

/** input type for inserting array relation for remote table "notification_property_type" */
export type Notification_Property_Type_Arr_Rel_Insert_Input = {
  data: Array<Notification_Property_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_Property_Type_On_Conflict>;
};

/** Boolean expression to filter rows from the table "notification_property_type". All fields are combined with a logical 'AND'. */
export type Notification_Property_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Property_Type_Bool_Exp>>;
  _not?: InputMaybe<Notification_Property_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Property_Type_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notification?: InputMaybe<Notification_Bool_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_property_type" */
export enum Notification_Property_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationPropertyTypePkey = 'notification_property_type_pkey'
}

/** input type for inserting data into table "notification_property_type" */
export type Notification_Property_Type_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification?: InputMaybe<Notification_Obj_Rel_Insert_Input>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Notification_Property_Type_Max_Fields = {
  __typename?: 'notification_property_type_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  notification_id?: Maybe<Scalars['uuid']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "notification_property_type" */
export type Notification_Property_Type_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notification_Property_Type_Min_Fields = {
  __typename?: 'notification_property_type_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  notification_id?: Maybe<Scalars['uuid']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "notification_property_type" */
export type Notification_Property_Type_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_property_type" */
export type Notification_Property_Type_Mutation_Response = {
  __typename?: 'notification_property_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Property_Type>;
};

/** on_conflict condition type for table "notification_property_type" */
export type Notification_Property_Type_On_Conflict = {
  constraint: Notification_Property_Type_Constraint;
  update_columns?: Array<Notification_Property_Type_Update_Column>;
  where?: InputMaybe<Notification_Property_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_property_type". */
export type Notification_Property_Type_Order_By = {
  id?: InputMaybe<Order_By>;
  notification?: InputMaybe<Notification_Order_By>;
  notification_id?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_property_type */
export type Notification_Property_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "notification_property_type" */
export enum Notification_Property_Type_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  PropertyType = 'property_type'
}

/** input type for updating data in table "notification_property_type" */
export type Notification_Property_Type_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "notification_property_type" */
export type Notification_Property_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Property_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Property_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "notification_property_type" */
export enum Notification_Property_Type_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  PropertyType = 'property_type'
}

export type Notification_Property_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Property_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Property_Type_Bool_Exp;
};

/** select columns of table "notification" */
export enum Notification_Select_Column {
  /** column name */
  CityId = 'city_id',
  /** column name */
  CityZoneId = 'city_zone_id',
  /** column name */
  Cluster = 'cluster',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GeoLocationDraw = 'geo_location_draw',
  /** column name */
  Id = 'id',
  /** column name */
  MaxBathrooms = 'max_bathrooms',
  /** column name */
  MaxBedrooms = 'max_bedrooms',
  /** column name */
  MinBathrooms = 'min_bathrooms',
  /** column name */
  MinBedrooms = 'min_bedrooms',
  /** column name */
  NlqId = 'nlq_id',
  /** column name */
  Opened = 'opened',
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  PropertyCompositionId = 'property_composition_id',
  /** column name */
  PropertyOriginType = 'property_origin_type',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserMembershipId = 'user_membership_id'
}

/** select "notification_aggregate_bool_exp_avg_arguments_columns" columns of table "notification" */
export enum Notification_Select_Column_Notification_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "notification_aggregate_bool_exp_bool_and_arguments_columns" columns of table "notification" */
export enum Notification_Select_Column_Notification_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Opened = 'opened'
}

/** select "notification_aggregate_bool_exp_bool_or_arguments_columns" columns of table "notification" */
export enum Notification_Select_Column_Notification_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Opened = 'opened'
}

/** select "notification_aggregate_bool_exp_corr_arguments_columns" columns of table "notification" */
export enum Notification_Select_Column_Notification_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "notification_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "notification" */
export enum Notification_Select_Column_Notification_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "notification_aggregate_bool_exp_max_arguments_columns" columns of table "notification" */
export enum Notification_Select_Column_Notification_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "notification_aggregate_bool_exp_min_arguments_columns" columns of table "notification" */
export enum Notification_Select_Column_Notification_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "notification_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "notification" */
export enum Notification_Select_Column_Notification_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "notification_aggregate_bool_exp_sum_arguments_columns" columns of table "notification" */
export enum Notification_Select_Column_Notification_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "notification_aggregate_bool_exp_var_samp_arguments_columns" columns of table "notification" */
export enum Notification_Select_Column_Notification_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** input type for updating data in table "notification" */
export type Notification_Set_Input = {
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  cluster?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Main_Currency_Enum>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  geo_location_draw?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  max_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  max_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  min_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  min_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  nlq_id?: InputMaybe<Scalars['uuid']['input']>;
  opened?: InputMaybe<Scalars['Boolean']['input']>;
  price_max?: InputMaybe<Scalars['float8']['input']>;
  price_min?: InputMaybe<Scalars['float8']['input']>;
  property_composition_id?: InputMaybe<Scalars['uuid']['input']>;
  property_origin_type?: InputMaybe<Scalars['String']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  sq_max?: InputMaybe<Scalars['float8']['input']>;
  sq_min?: InputMaybe<Scalars['float8']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_membership_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Notification_Stddev_Fields = {
  __typename?: 'notification_stddev_fields';
  max_bathrooms?: Maybe<Scalars['Float']['output']>;
  max_bedrooms?: Maybe<Scalars['Float']['output']>;
  min_bathrooms?: Maybe<Scalars['Float']['output']>;
  min_bedrooms?: Maybe<Scalars['Float']['output']>;
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "notification" */
export type Notification_Stddev_Order_By = {
  max_bathrooms?: InputMaybe<Order_By>;
  max_bedrooms?: InputMaybe<Order_By>;
  min_bathrooms?: InputMaybe<Order_By>;
  min_bedrooms?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Notification_Stddev_Pop_Fields = {
  __typename?: 'notification_stddev_pop_fields';
  max_bathrooms?: Maybe<Scalars['Float']['output']>;
  max_bedrooms?: Maybe<Scalars['Float']['output']>;
  min_bathrooms?: Maybe<Scalars['Float']['output']>;
  min_bedrooms?: Maybe<Scalars['Float']['output']>;
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "notification" */
export type Notification_Stddev_Pop_Order_By = {
  max_bathrooms?: InputMaybe<Order_By>;
  max_bedrooms?: InputMaybe<Order_By>;
  min_bathrooms?: InputMaybe<Order_By>;
  min_bedrooms?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Notification_Stddev_Samp_Fields = {
  __typename?: 'notification_stddev_samp_fields';
  max_bathrooms?: Maybe<Scalars['Float']['output']>;
  max_bedrooms?: Maybe<Scalars['Float']['output']>;
  min_bathrooms?: Maybe<Scalars['Float']['output']>;
  min_bedrooms?: Maybe<Scalars['Float']['output']>;
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "notification" */
export type Notification_Stddev_Samp_Order_By = {
  max_bathrooms?: InputMaybe<Order_By>;
  max_bedrooms?: InputMaybe<Order_By>;
  min_bathrooms?: InputMaybe<Order_By>;
  min_bedrooms?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notification" */
export type Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Stream_Cursor_Value_Input = {
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  cluster?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Main_Currency_Enum>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  geo_location_draw?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  max_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  max_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  min_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  min_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  nlq_id?: InputMaybe<Scalars['uuid']['input']>;
  opened?: InputMaybe<Scalars['Boolean']['input']>;
  price_max?: InputMaybe<Scalars['float8']['input']>;
  price_min?: InputMaybe<Scalars['float8']['input']>;
  property_composition_id?: InputMaybe<Scalars['uuid']['input']>;
  property_origin_type?: InputMaybe<Scalars['String']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  sq_max?: InputMaybe<Scalars['float8']['input']>;
  sq_min?: InputMaybe<Scalars['float8']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_membership_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Notification_Sum_Fields = {
  __typename?: 'notification_sum_fields';
  max_bathrooms?: Maybe<Scalars['Int']['output']>;
  max_bedrooms?: Maybe<Scalars['Int']['output']>;
  min_bathrooms?: Maybe<Scalars['Int']['output']>;
  min_bedrooms?: Maybe<Scalars['Int']['output']>;
  price_max?: Maybe<Scalars['float8']['output']>;
  price_min?: Maybe<Scalars['float8']['output']>;
  sq_max?: Maybe<Scalars['float8']['output']>;
  sq_min?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "notification" */
export type Notification_Sum_Order_By = {
  max_bathrooms?: InputMaybe<Order_By>;
  max_bedrooms?: InputMaybe<Order_By>;
  min_bathrooms?: InputMaybe<Order_By>;
  min_bedrooms?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** columns and relationships of "notification_type" */
export type Notification_Type = {
  __typename?: 'notification_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "notification_type" */
export type Notification_Type_Aggregate = {
  __typename?: 'notification_type_aggregate';
  aggregate?: Maybe<Notification_Type_Aggregate_Fields>;
  nodes: Array<Notification_Type>;
};

/** aggregate fields of "notification_type" */
export type Notification_Type_Aggregate_Fields = {
  __typename?: 'notification_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Notification_Type_Max_Fields>;
  min?: Maybe<Notification_Type_Min_Fields>;
};


/** aggregate fields of "notification_type" */
export type Notification_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "notification_type". All fields are combined with a logical 'AND'. */
export type Notification_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Type_Bool_Exp>>;
  _not?: InputMaybe<Notification_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_type" */
export enum Notification_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  NotificationTypePkey = 'notification_type_pkey'
}

/** input type for inserting data into table "notification_type" */
export type Notification_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Notification_Type_Max_Fields = {
  __typename?: 'notification_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Notification_Type_Min_Fields = {
  __typename?: 'notification_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "notification_type" */
export type Notification_Type_Mutation_Response = {
  __typename?: 'notification_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Type>;
};

/** on_conflict condition type for table "notification_type" */
export type Notification_Type_On_Conflict = {
  constraint: Notification_Type_Constraint;
  update_columns?: Array<Notification_Type_Update_Column>;
  where?: InputMaybe<Notification_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_type". */
export type Notification_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_type */
export type Notification_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "notification_type" */
export enum Notification_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "notification_type" */
export type Notification_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "notification_type" */
export type Notification_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "notification_type" */
export enum Notification_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Notification_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Type_Bool_Exp;
};

/** update columns of table "notification" */
export enum Notification_Update_Column {
  /** column name */
  CityId = 'city_id',
  /** column name */
  CityZoneId = 'city_zone_id',
  /** column name */
  Cluster = 'cluster',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  GeoLocationDraw = 'geo_location_draw',
  /** column name */
  Id = 'id',
  /** column name */
  MaxBathrooms = 'max_bathrooms',
  /** column name */
  MaxBedrooms = 'max_bedrooms',
  /** column name */
  MinBathrooms = 'min_bathrooms',
  /** column name */
  MinBedrooms = 'min_bedrooms',
  /** column name */
  NlqId = 'nlq_id',
  /** column name */
  Opened = 'opened',
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  PropertyCompositionId = 'property_composition_id',
  /** column name */
  PropertyOriginType = 'property_origin_type',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserMembershipId = 'user_membership_id'
}

export type Notification_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notification_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notification_Var_Pop_Fields = {
  __typename?: 'notification_var_pop_fields';
  max_bathrooms?: Maybe<Scalars['Float']['output']>;
  max_bedrooms?: Maybe<Scalars['Float']['output']>;
  min_bathrooms?: Maybe<Scalars['Float']['output']>;
  min_bedrooms?: Maybe<Scalars['Float']['output']>;
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "notification" */
export type Notification_Var_Pop_Order_By = {
  max_bathrooms?: InputMaybe<Order_By>;
  max_bedrooms?: InputMaybe<Order_By>;
  min_bathrooms?: InputMaybe<Order_By>;
  min_bedrooms?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Notification_Var_Samp_Fields = {
  __typename?: 'notification_var_samp_fields';
  max_bathrooms?: Maybe<Scalars['Float']['output']>;
  max_bedrooms?: Maybe<Scalars['Float']['output']>;
  min_bathrooms?: Maybe<Scalars['Float']['output']>;
  min_bedrooms?: Maybe<Scalars['Float']['output']>;
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "notification" */
export type Notification_Var_Samp_Order_By = {
  max_bathrooms?: InputMaybe<Order_By>;
  max_bedrooms?: InputMaybe<Order_By>;
  min_bathrooms?: InputMaybe<Order_By>;
  min_bedrooms?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Notification_Variance_Fields = {
  __typename?: 'notification_variance_fields';
  max_bathrooms?: Maybe<Scalars['Float']['output']>;
  max_bedrooms?: Maybe<Scalars['Float']['output']>;
  min_bathrooms?: Maybe<Scalars['Float']['output']>;
  min_bedrooms?: Maybe<Scalars['Float']['output']>;
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "notification" */
export type Notification_Variance_Order_By = {
  max_bathrooms?: InputMaybe<Order_By>;
  max_bedrooms?: InputMaybe<Order_By>;
  min_bathrooms?: InputMaybe<Order_By>;
  min_bedrooms?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "order" */
export type Order = {
  __typename?: 'order';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  order_response?: Maybe<Scalars['jsonb']['output']>;
  plan_id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Order_Status_Enum>;
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "order" */
export type OrderOrder_ResponseArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "order" */
export type Order_Aggregate = {
  __typename?: 'order_aggregate';
  aggregate?: Maybe<Order_Aggregate_Fields>;
  nodes: Array<Order>;
};

export type Order_Aggregate_Bool_Exp = {
  count?: InputMaybe<Order_Aggregate_Bool_Exp_Count>;
};

export type Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order" */
export type Order_Aggregate_Fields = {
  __typename?: 'order_aggregate_fields';
  avg?: Maybe<Order_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Max_Fields>;
  min?: Maybe<Order_Min_Fields>;
  stddev?: Maybe<Order_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Sum_Fields>;
  var_pop?: Maybe<Order_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Var_Samp_Fields>;
  variance?: Maybe<Order_Variance_Fields>;
};


/** aggregate fields of "order" */
export type Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "order" */
export type Order_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Max_Order_By>;
  min?: InputMaybe<Order_Min_Order_By>;
  stddev?: InputMaybe<Order_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Order_Append_Input = {
  order_response?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "order" */
export type Order_Arr_Rel_Insert_Input = {
  data: Array<Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Avg_Fields = {
  __typename?: 'order_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "order" */
export type Order_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order". All fields are combined with a logical 'AND'. */
export type Order_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Bool_Exp>>;
  _not?: InputMaybe<Order_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order_response?: InputMaybe<Jsonb_Comparison_Exp>;
  plan_id?: InputMaybe<Uuid_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Order_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** unique or primary key constraints on table "order" */
export enum Order_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderPkey = 'order_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Order_Delete_At_Path_Input = {
  order_response?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Order_Delete_Elem_Input = {
  order_response?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Order_Delete_Key_Input = {
  order_response?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "order" */
export type Order_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "order" */
export type Order_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_response?: InputMaybe<Scalars['jsonb']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Order_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Order_Max_Fields = {
  __typename?: 'order_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  plan_id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "order" */
export type Order_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Min_Fields = {
  __typename?: 'order_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  plan_id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "order" */
export type Order_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order" */
export type Order_Mutation_Response = {
  __typename?: 'order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order>;
};

/** input type for inserting object relation for remote table "order" */
export type Order_Obj_Rel_Insert_Input = {
  data: Order_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_On_Conflict>;
};

/** on_conflict condition type for table "order" */
export type Order_On_Conflict = {
  constraint: Order_Constraint;
  update_columns?: Array<Order_Update_Column>;
  where?: InputMaybe<Order_Bool_Exp>;
};

/** Ordering options when selecting data from "order". */
export type Order_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_response?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order */
export type Order_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Order_Prepend_Input = {
  order_response?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "order" */
export enum Order_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrderResponse = 'order_response',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "order" */
export type Order_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_response?: InputMaybe<Scalars['jsonb']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Order_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "order_status" */
export type Order_Status = {
  __typename?: 'order_status';
  status: Scalars['String']['output'];
};

/** aggregated selection of "order_status" */
export type Order_Status_Aggregate = {
  __typename?: 'order_status_aggregate';
  aggregate?: Maybe<Order_Status_Aggregate_Fields>;
  nodes: Array<Order_Status>;
};

/** aggregate fields of "order_status" */
export type Order_Status_Aggregate_Fields = {
  __typename?: 'order_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Status_Max_Fields>;
  min?: Maybe<Order_Status_Min_Fields>;
};


/** aggregate fields of "order_status" */
export type Order_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "order_status". All fields are combined with a logical 'AND'. */
export type Order_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Status_Bool_Exp>>;
  _not?: InputMaybe<Order_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_status" */
export enum Order_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  OrderStatusPkey = 'order_status_pkey'
}

export enum Order_Status_Enum {
  Complete = 'complete',
  Expired = 'expired',
  Failed = 'failed',
  Open = 'open'
}

/** Boolean expression to compare columns of type "order_status_enum". All fields are combined with logical 'AND'. */
export type Order_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Order_Status_Enum>;
  _in?: InputMaybe<Array<Order_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Order_Status_Enum>;
  _nin?: InputMaybe<Array<Order_Status_Enum>>;
};

/** input type for inserting data into table "order_status" */
export type Order_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Order_Status_Max_Fields = {
  __typename?: 'order_status_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Order_Status_Min_Fields = {
  __typename?: 'order_status_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "order_status" */
export type Order_Status_Mutation_Response = {
  __typename?: 'order_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Status>;
};

/** on_conflict condition type for table "order_status" */
export type Order_Status_On_Conflict = {
  constraint: Order_Status_Constraint;
  update_columns?: Array<Order_Status_Update_Column>;
  where?: InputMaybe<Order_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "order_status". */
export type Order_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_status */
export type Order_Status_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "order_status" */
export enum Order_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "order_status" */
export type Order_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "order_status" */
export type Order_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "order_status" */
export enum Order_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Order_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Order_Stddev_Fields = {
  __typename?: 'order_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "order" */
export type Order_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Stddev_Pop_Fields = {
  __typename?: 'order_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "order" */
export type Order_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Stddev_Samp_Fields = {
  __typename?: 'order_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "order" */
export type Order_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order" */
export type Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_response?: InputMaybe<Scalars['jsonb']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Order_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Order_Sum_Fields = {
  __typename?: 'order_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "order" */
export type Order_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "order" */
export enum Order_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrderResponse = 'order_response',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Order_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Order_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Order_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Order_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Order_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Order_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Var_Pop_Fields = {
  __typename?: 'order_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "order" */
export type Order_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Var_Samp_Fields = {
  __typename?: 'order_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "order" */
export type Order_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Variance_Fields = {
  __typename?: 'order_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "order" */
export type Order_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "organization" */
export type Organization = {
  __typename?: 'organization';
  address?: Maybe<Scalars['String']['output']>;
  agency_position?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  agent_tasks: Array<Agent_Task>;
  /** An aggregate relationship */
  agent_tasks_aggregate: Agent_Task_Aggregate;
  /** An array relationship */
  children: Array<Organization>;
  /** An aggregate relationship */
  children_aggregate: Organization_Aggregate;
  clients?: Maybe<Scalars['Int']['output']>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_name: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  experience_years?: Maybe<Scalars['Int']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  free_trial_activated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  instagram_url?: Maybe<Scalars['String']['output']>;
  license_number?: Maybe<Scalars['String']['output']>;
  license_verified?: Maybe<Scalars['Boolean']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  organization_leads: Array<Organization_Leads>;
  /** An aggregate relationship */
  organization_leads_aggregate: Organization_Leads_Aggregate;
  /** An array relationship */
  organization_telegram_agent_links: Array<Organization_Telegram_Agent_Link>;
  /** An aggregate relationship */
  organization_telegram_agent_links_aggregate: Organization_Telegram_Agent_Link_Aggregate;
  /** An array relationship */
  organization_whatsapp_ai_allowlists: Array<Organization_Whatsapp_Ai_Allowlist>;
  /** An aggregate relationship */
  organization_whatsapp_ai_allowlists_aggregate: Organization_Whatsapp_Ai_Allowlist_Aggregate;
  origin?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  parent?: Maybe<Organization>;
  parent_organization_id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  postiz_org_id?: Maybe<Scalars['uuid']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  properties: Array<Property_List>;
  properties_aggregate: Property_List_Aggregate;
  signature?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  source_origin?: Maybe<Property_Origin>;
  status?: Maybe<Organization_Status_Enum>;
  stripe_costumer_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  subscriptions: Array<Subscription>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscription_Aggregate;
  type?: Maybe<Organization_Type_Enum>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  user_organizations: Array<User_Organization>;
  /** An aggregate relationship */
  user_organizations_aggregate: User_Organization_Aggregate;
  user_original_email?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  user_preferences: Array<User_Preferences>;
  /** An aggregate relationship */
  user_preferences_aggregate: User_Preferences_Aggregate;
  verified?: Maybe<Scalars['Boolean']['output']>;
  wa_instance_id?: Maybe<Scalars['String']['output']>;
  wa_instance_name?: Maybe<Scalars['String']['output']>;
  wa_token?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  whatsapp_ai_config?: Maybe<Organization_Whatsapp_Ai_Config>;
};


/** columns and relationships of "organization" */
export type OrganizationAgent_TasksArgs = {
  distinct_on?: InputMaybe<Array<Agent_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Task_Order_By>>;
  where?: InputMaybe<Agent_Task_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationAgent_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Task_Order_By>>;
  where?: InputMaybe<Agent_Task_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationChildrenArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationModulesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Leads_Order_By>>;
  where?: InputMaybe<Organization_Leads_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Leads_Order_By>>;
  where?: InputMaybe<Organization_Leads_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Telegram_Agent_LinksArgs = {
  distinct_on?: InputMaybe<Array<Organization_Telegram_Agent_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Telegram_Agent_Link_Order_By>>;
  where?: InputMaybe<Organization_Telegram_Agent_Link_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Telegram_Agent_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Telegram_Agent_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Telegram_Agent_Link_Order_By>>;
  where?: InputMaybe<Organization_Telegram_Agent_Link_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Whatsapp_Ai_AllowlistsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Order_By>>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Whatsapp_Ai_Allowlists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Order_By>>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp_Remote_Rel_Organizationproperties>;
};


/** columns and relationships of "organization" */
export type OrganizationProperties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp_Remote_Rel_Organizationproperties_Aggregate>;
};


/** columns and relationships of "organization" */
export type OrganizationSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Order_By>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Order_By>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUser_OrganizationsArgs = {
  distinct_on?: InputMaybe<Array<User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Organization_Order_By>>;
  where?: InputMaybe<User_Organization_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUser_Organizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Organization_Order_By>>;
  where?: InputMaybe<User_Organization_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUser_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<User_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Preferences_Order_By>>;
  where?: InputMaybe<User_Preferences_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUser_Preferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Preferences_Order_By>>;
  where?: InputMaybe<User_Preferences_Bool_Exp>;
};

/** organizationDashboardStatisticsNative Query Arguments */
export type OrganizationDashboardStatistics_Arguments = {
  organization_id: Scalars['uuid']['input'];
};

/** organizationViewsGraphicNative Query Arguments */
export type OrganizationViewsGraphic_Arguments = {
  organization_id: Scalars['uuid']['input'];
  period: Scalars['String']['input'];
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregated selection of "organization" */
export type Organization_Aggregate = {
  __typename?: 'organization_aggregate';
  aggregate?: Maybe<Organization_Aggregate_Fields>;
  nodes: Array<Organization>;
};

export type Organization_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Aggregate_Bool_Exp_Count>;
};

export type Organization_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization" */
export type Organization_Aggregate_Fields = {
  __typename?: 'organization_aggregate_fields';
  avg?: Maybe<Organization_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Max_Fields>;
  min?: Maybe<Organization_Min_Fields>;
  stddev?: Maybe<Organization_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Sum_Fields>;
  var_pop?: Maybe<Organization_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Var_Samp_Fields>;
  variance?: Maybe<Organization_Variance_Fields>;
};


/** aggregate fields of "organization" */
export type Organization_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization" */
export type Organization_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Max_Order_By>;
  min?: InputMaybe<Organization_Min_Order_By>;
  stddev?: InputMaybe<Organization_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Organization_Append_Input = {
  modules?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "organization" */
export type Organization_Arr_Rel_Insert_Input = {
  data: Array<Organization_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};

/** aggregate avg on columns */
export type Organization_Avg_Fields = {
  __typename?: 'organization_avg_fields';
  clients?: Maybe<Scalars['Float']['output']>;
  experience_years?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organization" */
export type Organization_Avg_Order_By = {
  clients?: InputMaybe<Order_By>;
  experience_years?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization". All fields are combined with a logical 'AND'. */
export type Organization_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Bool_Exp>>;
  _not?: InputMaybe<Organization_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_position?: InputMaybe<String_Comparison_Exp>;
  agent_tasks?: InputMaybe<Agent_Task_Bool_Exp>;
  agent_tasks_aggregate?: InputMaybe<Agent_Task_Aggregate_Bool_Exp>;
  children?: InputMaybe<Organization_Bool_Exp>;
  children_aggregate?: InputMaybe<Organization_Aggregate_Bool_Exp>;
  clients?: InputMaybe<Int_Comparison_Exp>;
  cover_image_url?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  experience_years?: InputMaybe<Int_Comparison_Exp>;
  facebook_url?: InputMaybe<String_Comparison_Exp>;
  free_trial_activated?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  instagram_url?: InputMaybe<String_Comparison_Exp>;
  license_number?: InputMaybe<String_Comparison_Exp>;
  license_verified?: InputMaybe<Boolean_Comparison_Exp>;
  linkedin_url?: InputMaybe<String_Comparison_Exp>;
  modules?: InputMaybe<Jsonb_Comparison_Exp>;
  organization_leads?: InputMaybe<Organization_Leads_Bool_Exp>;
  organization_leads_aggregate?: InputMaybe<Organization_Leads_Aggregate_Bool_Exp>;
  organization_telegram_agent_links?: InputMaybe<Organization_Telegram_Agent_Link_Bool_Exp>;
  organization_telegram_agent_links_aggregate?: InputMaybe<Organization_Telegram_Agent_Link_Aggregate_Bool_Exp>;
  organization_whatsapp_ai_allowlists?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>;
  organization_whatsapp_ai_allowlists_aggregate?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Aggregate_Bool_Exp>;
  origin?: InputMaybe<String_Comparison_Exp>;
  parent?: InputMaybe<Organization_Bool_Exp>;
  parent_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  postiz_org_id?: InputMaybe<Uuid_Comparison_Exp>;
  profile_image_url?: InputMaybe<String_Comparison_Exp>;
  signature?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Organization_Status_Enum_Comparison_Exp>;
  stripe_costumer_id?: InputMaybe<String_Comparison_Exp>;
  subscriptions?: InputMaybe<Subscription_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscription_Aggregate_Bool_Exp>;
  type?: InputMaybe<Organization_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_organizations?: InputMaybe<User_Organization_Bool_Exp>;
  user_organizations_aggregate?: InputMaybe<User_Organization_Aggregate_Bool_Exp>;
  user_original_email?: InputMaybe<String_Comparison_Exp>;
  user_preferences?: InputMaybe<User_Preferences_Bool_Exp>;
  user_preferences_aggregate?: InputMaybe<User_Preferences_Aggregate_Bool_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
  wa_instance_id?: InputMaybe<String_Comparison_Exp>;
  wa_instance_name?: InputMaybe<String_Comparison_Exp>;
  wa_token?: InputMaybe<String_Comparison_Exp>;
  whatsapp_ai_config?: InputMaybe<Organization_Whatsapp_Ai_Config_Bool_Exp>;
};

/** unique or primary key constraints on table "organization" */
export enum Organization_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationPkey = 'organization_pkey',
  /** unique or primary key constraint on columns "slug" */
  OrganizationSlugKey = 'organization_slug_key',
  /** unique or primary key constraint on columns "user_original_email" */
  OrganizationUserOriginalEmailKey = 'organization_user_original_email_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Organization_Delete_At_Path_Input = {
  modules?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Organization_Delete_Elem_Input = {
  modules?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Organization_Delete_Key_Input = {
  modules?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "organization" */
export type Organization_Inc_Input = {
  clients?: InputMaybe<Scalars['Int']['input']>;
  experience_years?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organization" */
export type Organization_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  agency_position?: InputMaybe<Scalars['String']['input']>;
  agent_tasks?: InputMaybe<Agent_Task_Arr_Rel_Insert_Input>;
  children?: InputMaybe<Organization_Arr_Rel_Insert_Input>;
  clients?: InputMaybe<Scalars['Int']['input']>;
  cover_image_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience_years?: InputMaybe<Scalars['Int']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  free_trial_activated?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  license_number?: InputMaybe<Scalars['String']['input']>;
  license_verified?: InputMaybe<Scalars['Boolean']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Scalars['jsonb']['input']>;
  organization_leads?: InputMaybe<Organization_Leads_Arr_Rel_Insert_Input>;
  organization_telegram_agent_links?: InputMaybe<Organization_Telegram_Agent_Link_Arr_Rel_Insert_Input>;
  organization_whatsapp_ai_allowlists?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Arr_Rel_Insert_Input>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  parent_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  postiz_org_id?: InputMaybe<Scalars['uuid']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Organization_Status_Enum>;
  stripe_costumer_id?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<Subscription_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Organization_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_organizations?: InputMaybe<User_Organization_Arr_Rel_Insert_Input>;
  user_original_email?: InputMaybe<Scalars['String']['input']>;
  user_preferences?: InputMaybe<User_Preferences_Arr_Rel_Insert_Input>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  wa_instance_id?: InputMaybe<Scalars['String']['input']>;
  wa_instance_name?: InputMaybe<Scalars['String']['input']>;
  wa_token?: InputMaybe<Scalars['String']['input']>;
  whatsapp_ai_config?: InputMaybe<Organization_Whatsapp_Ai_Config_Obj_Rel_Insert_Input>;
};

/** columns and relationships of "organization_lead_location" */
export type Organization_Lead_Location = {
  __typename?: 'organization_lead_location';
  /** An object relationship */
  city_zone: City_Zone;
  city_zone_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organization_lead_id: Scalars['uuid']['output'];
};

/** aggregated selection of "organization_lead_location" */
export type Organization_Lead_Location_Aggregate = {
  __typename?: 'organization_lead_location_aggregate';
  aggregate?: Maybe<Organization_Lead_Location_Aggregate_Fields>;
  nodes: Array<Organization_Lead_Location>;
};

/** aggregate fields of "organization_lead_location" */
export type Organization_Lead_Location_Aggregate_Fields = {
  __typename?: 'organization_lead_location_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Lead_Location_Max_Fields>;
  min?: Maybe<Organization_Lead_Location_Min_Fields>;
};


/** aggregate fields of "organization_lead_location" */
export type Organization_Lead_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Lead_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organization_lead_location". All fields are combined with a logical 'AND'. */
export type Organization_Lead_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Lead_Location_Bool_Exp>>;
  _not?: InputMaybe<Organization_Lead_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Lead_Location_Bool_Exp>>;
  city_zone?: InputMaybe<City_Zone_Bool_Exp>;
  city_zone_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "organization_lead_location". All fields are combined with a logical 'AND'. */
export type Organization_Lead_Location_Bool_Exp_Remote_Rel_Organization_Leadslocations = {
  _and?: InputMaybe<Array<Organization_Lead_Location_Bool_Exp>>;
  _not?: InputMaybe<Organization_Lead_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Lead_Location_Bool_Exp>>;
  city_zone?: InputMaybe<City_Zone_Bool_Exp>;
  city_zone_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_lead_id?: InputMaybe<Uuid_Comparison_Exp_Remote_Rel_Organization_Leadslocations>;
};

/** unique or primary key constraints on table "organization_lead_location" */
export enum Organization_Lead_Location_Constraint {
  /** unique or primary key constraint on columns "city_zone_id", "organization_lead_id" */
  OrganizationLeadLocationOrganizationLeadIdCityZoneIdKe = 'organization_lead_location_organization_lead_id_city_zone_id_ke',
  /** unique or primary key constraint on columns "id" */
  OrganizationLeadLocationPkey = 'organization_lead_location_pkey'
}

/** input type for inserting data into table "organization_lead_location" */
export type Organization_Lead_Location_Insert_Input = {
  city_zone?: InputMaybe<City_Zone_Obj_Rel_Insert_Input>;
  city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organization_Lead_Location_Max_Fields = {
  __typename?: 'organization_lead_location_max_fields';
  city_zone_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Organization_Lead_Location_Min_Fields = {
  __typename?: 'organization_lead_location_min_fields';
  city_zone_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "organization_lead_location" */
export type Organization_Lead_Location_Mutation_Response = {
  __typename?: 'organization_lead_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Lead_Location>;
};

/** on_conflict condition type for table "organization_lead_location" */
export type Organization_Lead_Location_On_Conflict = {
  constraint: Organization_Lead_Location_Constraint;
  update_columns?: Array<Organization_Lead_Location_Update_Column>;
  where?: InputMaybe<Organization_Lead_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_lead_location". */
export type Organization_Lead_Location_Order_By = {
  city_zone?: InputMaybe<City_Zone_Order_By>;
  city_zone_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_lead_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_lead_location */
export type Organization_Lead_Location_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_lead_location" */
export enum Organization_Lead_Location_Select_Column {
  /** column name */
  CityZoneId = 'city_zone_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationLeadId = 'organization_lead_id'
}

/** input type for updating data in table "organization_lead_location" */
export type Organization_Lead_Location_Set_Input = {
  city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organization_lead_location" */
export type Organization_Lead_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Lead_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Lead_Location_Stream_Cursor_Value_Input = {
  city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organization_lead_location" */
export enum Organization_Lead_Location_Update_Column {
  /** column name */
  CityZoneId = 'city_zone_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationLeadId = 'organization_lead_id'
}

export type Organization_Lead_Location_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Lead_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Lead_Location_Bool_Exp;
};

/** columns and relationships of "organization_lead_property" */
export type Organization_Lead_Property = {
  __typename?: 'organization_lead_property';
  category?: Maybe<Lead_Property_Category_Enum>;
  created_at: Scalars['timestamptz']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  opened?: Maybe<Scalars['Boolean']['output']>;
  organization_lead?: Maybe<Organization_Leads>;
  organization_lead_id: Scalars['uuid']['output'];
  /** An object relationship */
  property_list?: Maybe<Property_List>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "organization_lead_property" */
export type Organization_Lead_Property_Aggregate = {
  __typename?: 'organization_lead_property_aggregate';
  aggregate?: Maybe<Organization_Lead_Property_Aggregate_Fields>;
  nodes: Array<Organization_Lead_Property>;
};

/** aggregate fields of "organization_lead_property" */
export type Organization_Lead_Property_Aggregate_Fields = {
  __typename?: 'organization_lead_property_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Lead_Property_Max_Fields>;
  min?: Maybe<Organization_Lead_Property_Min_Fields>;
};


/** aggregate fields of "organization_lead_property" */
export type Organization_Lead_Property_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Lead_Property_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organization_lead_property". All fields are combined with a logical 'AND'. */
export type Organization_Lead_Property_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Lead_Property_Bool_Exp>>;
  _not?: InputMaybe<Organization_Lead_Property_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Lead_Property_Bool_Exp>>;
  category?: InputMaybe<Lead_Property_Category_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  opened?: InputMaybe<Boolean_Comparison_Exp>;
  organization_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_list?: InputMaybe<Property_List_Bool_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "organization_lead_property". All fields are combined with a logical 'AND'. */
export type Organization_Lead_Property_Bool_Exp_Remote_Rel_Organization_Leadsproperties_Matched = {
  _and?: InputMaybe<Array<Organization_Lead_Property_Bool_Exp>>;
  _not?: InputMaybe<Organization_Lead_Property_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Lead_Property_Bool_Exp>>;
  category?: InputMaybe<Lead_Property_Category_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  opened?: InputMaybe<Boolean_Comparison_Exp>;
  organization_lead_id?: InputMaybe<Uuid_Comparison_Exp_Remote_Rel_Organization_Leadsproperties_Matched>;
  property_list?: InputMaybe<Property_List_Bool_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "organization_lead_property". All fields are combined with a logical 'AND'. */
export type Organization_Lead_Property_Bool_Exp_Remote_Rel_Organization_Leadsproperties_Matched_Aggregate = {
  _and?: InputMaybe<Array<Organization_Lead_Property_Bool_Exp>>;
  _not?: InputMaybe<Organization_Lead_Property_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Lead_Property_Bool_Exp>>;
  category?: InputMaybe<Lead_Property_Category_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  opened?: InputMaybe<Boolean_Comparison_Exp>;
  organization_lead_id?: InputMaybe<Uuid_Comparison_Exp_Remote_Rel_Organization_Leadsproperties_Matched_Aggregate>;
  property_list?: InputMaybe<Property_List_Bool_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_lead_property" */
export enum Organization_Lead_Property_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationLeadPropertyPkey = 'organization_lead_property_pkey',
  /** unique or primary key constraint on columns "organization_lead_id", "property_list_id" */
  OrganizationLeadPropertyPropertyListIdOrganizationLeadI = 'organization_lead_property_property_list_id_organization_lead_i'
}

/** input type for inserting data into table "organization_lead_property" */
export type Organization_Lead_Property_Insert_Input = {
  category?: InputMaybe<Lead_Property_Category_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  opened?: InputMaybe<Scalars['Boolean']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list?: InputMaybe<Property_List_Obj_Rel_Insert_Input>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Organization_Lead_Property_Max_Fields = {
  __typename?: 'organization_lead_property_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Organization_Lead_Property_Min_Fields = {
  __typename?: 'organization_lead_property_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "organization_lead_property" */
export type Organization_Lead_Property_Mutation_Response = {
  __typename?: 'organization_lead_property_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Lead_Property>;
};

/** on_conflict condition type for table "organization_lead_property" */
export type Organization_Lead_Property_On_Conflict = {
  constraint: Organization_Lead_Property_Constraint;
  update_columns?: Array<Organization_Lead_Property_Update_Column>;
  where?: InputMaybe<Organization_Lead_Property_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_lead_property". */
export type Organization_Lead_Property_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  opened?: InputMaybe<Order_By>;
  organization_lead_id?: InputMaybe<Order_By>;
  property_list?: InputMaybe<Property_List_Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_lead_property */
export type Organization_Lead_Property_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_lead_property" */
export enum Organization_Lead_Property_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Opened = 'opened',
  /** column name */
  OrganizationLeadId = 'organization_lead_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "organization_lead_property" */
export type Organization_Lead_Property_Set_Input = {
  category?: InputMaybe<Lead_Property_Category_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  opened?: InputMaybe<Scalars['Boolean']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organization_lead_property" */
export type Organization_Lead_Property_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Lead_Property_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Lead_Property_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Lead_Property_Category_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  opened?: InputMaybe<Scalars['Boolean']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_lead_property" */
export enum Organization_Lead_Property_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Opened = 'opened',
  /** column name */
  OrganizationLeadId = 'organization_lead_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Organization_Lead_Property_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Lead_Property_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Lead_Property_Bool_Exp;
};

/** columns and relationships of "organization_leads" */
export type Organization_Leads = {
  __typename?: 'organization_leads';
  /** Persistent client memory: name, language, tone, preferences, interaction history. Never cleared by session reset. Populated incrementally by the AI agent. */
  client_profile?: Maybe<Scalars['jsonb']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Main_Currency_Enum>;
  id: Scalars['uuid']['output'];
  inquiry_date: Scalars['date']['output'];
  locations: Array<Organization_Lead_Location>;
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  preferences?: Maybe<Scalars['jsonb']['output']>;
  price_max?: Maybe<Scalars['float8']['output']>;
  price_min?: Maybe<Scalars['float8']['output']>;
  properties_matched: Array<Organization_Lead_Property>;
  properties_matched_aggregate: Organization_Lead_Property_Aggregate;
  property_list?: Maybe<Property_List>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  rooms?: Maybe<Scalars['Int']['output']>;
  status: Lead_Status_Enum;
  tualete?: Maybe<Scalars['Int']['output']>;
  type: Lead_Type_Enum;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_avatar_url?: Maybe<Scalars['String']['output']>;
  user_display_name?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_phone_number?: Maybe<Scalars['String']['output']>;
  user_phone_number_verified?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "organization_leads" */
export type Organization_LeadsClient_ProfileArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "organization_leads" */
export type Organization_LeadsLocationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Lead_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Lead_Location_Order_By>>;
  where?: InputMaybe<Organization_Lead_Location_Bool_Exp_Remote_Rel_Organization_Leadslocations>;
};


/** columns and relationships of "organization_leads" */
export type Organization_LeadsPreferencesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "organization_leads" */
export type Organization_LeadsProperties_MatchedArgs = {
  distinct_on?: InputMaybe<Array<Organization_Lead_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Lead_Property_Order_By>>;
  where?: InputMaybe<Organization_Lead_Property_Bool_Exp_Remote_Rel_Organization_Leadsproperties_Matched>;
};


/** columns and relationships of "organization_leads" */
export type Organization_LeadsProperties_Matched_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Lead_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Lead_Property_Order_By>>;
  where?: InputMaybe<Organization_Lead_Property_Bool_Exp_Remote_Rel_Organization_Leadsproperties_Matched_Aggregate>;
};

/** aggregated selection of "organization_leads" */
export type Organization_Leads_Aggregate = {
  __typename?: 'organization_leads_aggregate';
  aggregate?: Maybe<Organization_Leads_Aggregate_Fields>;
  nodes: Array<Organization_Leads>;
};

export type Organization_Leads_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Organization_Leads_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Organization_Leads_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Leads_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Organization_Leads_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Organization_Leads_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Organization_Leads_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Organization_Leads_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Organization_Leads_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Organization_Leads_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Organization_Leads_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Organization_Leads_Aggregate_Bool_Exp_Var_Samp>;
};

export type Organization_Leads_Aggregate_Bool_Exp_Avg = {
  arguments: Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Organization_Leads_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Leads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Leads_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Leads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Leads_Aggregate_Bool_Exp_Corr = {
  arguments: Organization_Leads_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Organization_Leads_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Organization_Leads_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Leads_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Organization_Leads_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Organization_Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Organization_Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Organization_Leads_Aggregate_Bool_Exp_Max = {
  arguments: Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Organization_Leads_Aggregate_Bool_Exp_Min = {
  arguments: Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Organization_Leads_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Organization_Leads_Aggregate_Bool_Exp_Sum = {
  arguments: Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Organization_Leads_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "organization_leads" */
export type Organization_Leads_Aggregate_Fields = {
  __typename?: 'organization_leads_aggregate_fields';
  avg?: Maybe<Organization_Leads_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Leads_Max_Fields>;
  min?: Maybe<Organization_Leads_Min_Fields>;
  stddev?: Maybe<Organization_Leads_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Leads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Leads_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Leads_Sum_Fields>;
  var_pop?: Maybe<Organization_Leads_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Leads_Var_Samp_Fields>;
  variance?: Maybe<Organization_Leads_Variance_Fields>;
};


/** aggregate fields of "organization_leads" */
export type Organization_Leads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_leads" */
export type Organization_Leads_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Leads_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Leads_Max_Order_By>;
  min?: InputMaybe<Organization_Leads_Min_Order_By>;
  stddev?: InputMaybe<Organization_Leads_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Leads_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Leads_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Leads_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Leads_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Leads_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Leads_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Organization_Leads_Append_Input = {
  /** Persistent client memory: name, language, tone, preferences, interaction history. Never cleared by session reset. Populated incrementally by the AI agent. */
  client_profile?: InputMaybe<Scalars['jsonb']['input']>;
  preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "organization_leads" */
export type Organization_Leads_Arr_Rel_Insert_Input = {
  data: Array<Organization_Leads_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Leads_On_Conflict>;
};

/** aggregate avg on columns */
export type Organization_Leads_Avg_Fields = {
  __typename?: 'organization_leads_avg_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  rooms?: Maybe<Scalars['Float']['output']>;
  tualete?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organization_leads" */
export type Organization_Leads_Avg_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  tualete?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization_leads". All fields are combined with a logical 'AND'. */
export type Organization_Leads_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Leads_Bool_Exp>>;
  _not?: InputMaybe<Organization_Leads_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Leads_Bool_Exp>>;
  client_profile?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<Main_Currency_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inquiry_date?: InputMaybe<Date_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  preferences?: InputMaybe<Jsonb_Comparison_Exp>;
  price_max?: InputMaybe<Float8_Comparison_Exp>;
  price_min?: InputMaybe<Float8_Comparison_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_status?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  rooms?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Lead_Status_Enum_Comparison_Exp>;
  tualete?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Lead_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_avatar_url?: InputMaybe<String_Comparison_Exp>;
  user_display_name?: InputMaybe<String_Comparison_Exp>;
  user_email?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_phone_number?: InputMaybe<String_Comparison_Exp>;
  user_phone_number_verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_leads" */
export enum Organization_Leads_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationLeadsPkey = 'organization_leads_pkey',
  /** unique or primary key constraint on columns "user_id", "type", "property_list_id" */
  OrganizationLeadsPropertyListIdUserIdTypeKey = 'organization_leads_property_list_id_user_id_type_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Organization_Leads_Delete_At_Path_Input = {
  /** Persistent client memory: name, language, tone, preferences, interaction history. Never cleared by session reset. Populated incrementally by the AI agent. */
  client_profile?: InputMaybe<Array<Scalars['String']['input']>>;
  preferences?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Organization_Leads_Delete_Elem_Input = {
  /** Persistent client memory: name, language, tone, preferences, interaction history. Never cleared by session reset. Populated incrementally by the AI agent. */
  client_profile?: InputMaybe<Scalars['Int']['input']>;
  preferences?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Organization_Leads_Delete_Key_Input = {
  /** Persistent client memory: name, language, tone, preferences, interaction history. Never cleared by session reset. Populated incrementally by the AI agent. */
  client_profile?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "organization_leads" */
export type Organization_Leads_Inc_Input = {
  price_max?: InputMaybe<Scalars['float8']['input']>;
  price_min?: InputMaybe<Scalars['float8']['input']>;
  rooms?: InputMaybe<Scalars['Int']['input']>;
  tualete?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organization_leads" */
export type Organization_Leads_Insert_Input = {
  /** Persistent client memory: name, language, tone, preferences, interaction history. Never cleared by session reset. Populated incrementally by the AI agent. */
  client_profile?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Main_Currency_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inquiry_date?: InputMaybe<Scalars['date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  preferences?: InputMaybe<Scalars['jsonb']['input']>;
  price_max?: InputMaybe<Scalars['float8']['input']>;
  price_min?: InputMaybe<Scalars['float8']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
  rooms?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Lead_Status_Enum>;
  tualete?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Lead_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_avatar_url?: InputMaybe<Scalars['String']['input']>;
  user_display_name?: InputMaybe<Scalars['String']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_phone_number?: InputMaybe<Scalars['String']['input']>;
  user_phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Organization_Leads_Max_Fields = {
  __typename?: 'organization_leads_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inquiry_date?: Maybe<Scalars['date']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  price_max?: Maybe<Scalars['float8']['output']>;
  price_min?: Maybe<Scalars['float8']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  rooms?: Maybe<Scalars['Int']['output']>;
  tualete?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_avatar_url?: Maybe<Scalars['String']['output']>;
  user_display_name?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_phone_number?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "organization_leads" */
export type Organization_Leads_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inquiry_date?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  tualete?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_avatar_url?: InputMaybe<Order_By>;
  user_display_name?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_phone_number?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Leads_Min_Fields = {
  __typename?: 'organization_leads_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inquiry_date?: Maybe<Scalars['date']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  price_max?: Maybe<Scalars['float8']['output']>;
  price_min?: Maybe<Scalars['float8']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  rooms?: Maybe<Scalars['Int']['output']>;
  tualete?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_avatar_url?: Maybe<Scalars['String']['output']>;
  user_display_name?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_phone_number?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "organization_leads" */
export type Organization_Leads_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inquiry_date?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  tualete?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_avatar_url?: InputMaybe<Order_By>;
  user_display_name?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_phone_number?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_leads" */
export type Organization_Leads_Mutation_Response = {
  __typename?: 'organization_leads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Leads>;
};

/** input type for inserting object relation for remote table "organization_leads" */
export type Organization_Leads_Obj_Rel_Insert_Input = {
  data: Organization_Leads_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Leads_On_Conflict>;
};

/** on_conflict condition type for table "organization_leads" */
export type Organization_Leads_On_Conflict = {
  constraint: Organization_Leads_Constraint;
  update_columns?: Array<Organization_Leads_Update_Column>;
  where?: InputMaybe<Organization_Leads_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_leads". */
export type Organization_Leads_Order_By = {
  client_profile?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inquiry_date?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  preferences?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tualete?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_avatar_url?: InputMaybe<Order_By>;
  user_display_name?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_phone_number?: InputMaybe<Order_By>;
  user_phone_number_verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_leads */
export type Organization_Leads_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Organization_Leads_Prepend_Input = {
  /** Persistent client memory: name, language, tone, preferences, interaction history. Never cleared by session reset. Populated incrementally by the AI agent. */
  client_profile?: InputMaybe<Scalars['jsonb']['input']>;
  preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "organization_leads" */
export enum Organization_Leads_Select_Column {
  /** column name */
  ClientProfile = 'client_profile',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  InquiryDate = 'inquiry_date',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Rooms = 'rooms',
  /** column name */
  Status = 'status',
  /** column name */
  Tualete = 'tualete',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserAvatarUrl = 'user_avatar_url',
  /** column name */
  UserDisplayName = 'user_display_name',
  /** column name */
  UserEmail = 'user_email',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserPhoneNumber = 'user_phone_number',
  /** column name */
  UserPhoneNumberVerified = 'user_phone_number_verified'
}

/** select "organization_leads_aggregate_bool_exp_avg_arguments_columns" columns of table "organization_leads" */
export enum Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min'
}

/** select "organization_leads_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_leads" */
export enum Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  UserPhoneNumberVerified = 'user_phone_number_verified'
}

/** select "organization_leads_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_leads" */
export enum Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  UserPhoneNumberVerified = 'user_phone_number_verified'
}

/** select "organization_leads_aggregate_bool_exp_corr_arguments_columns" columns of table "organization_leads" */
export enum Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min'
}

/** select "organization_leads_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "organization_leads" */
export enum Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min'
}

/** select "organization_leads_aggregate_bool_exp_max_arguments_columns" columns of table "organization_leads" */
export enum Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min'
}

/** select "organization_leads_aggregate_bool_exp_min_arguments_columns" columns of table "organization_leads" */
export enum Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min'
}

/** select "organization_leads_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "organization_leads" */
export enum Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min'
}

/** select "organization_leads_aggregate_bool_exp_sum_arguments_columns" columns of table "organization_leads" */
export enum Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min'
}

/** select "organization_leads_aggregate_bool_exp_var_samp_arguments_columns" columns of table "organization_leads" */
export enum Organization_Leads_Select_Column_Organization_Leads_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min'
}

/** input type for updating data in table "organization_leads" */
export type Organization_Leads_Set_Input = {
  /** Persistent client memory: name, language, tone, preferences, interaction history. Never cleared by session reset. Populated incrementally by the AI agent. */
  client_profile?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Main_Currency_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inquiry_date?: InputMaybe<Scalars['date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  preferences?: InputMaybe<Scalars['jsonb']['input']>;
  price_max?: InputMaybe<Scalars['float8']['input']>;
  price_min?: InputMaybe<Scalars['float8']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
  rooms?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Lead_Status_Enum>;
  tualete?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Lead_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_avatar_url?: InputMaybe<Scalars['String']['input']>;
  user_display_name?: InputMaybe<Scalars['String']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_phone_number?: InputMaybe<Scalars['String']['input']>;
  user_phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Organization_Leads_Stddev_Fields = {
  __typename?: 'organization_leads_stddev_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  rooms?: Maybe<Scalars['Float']['output']>;
  tualete?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organization_leads" */
export type Organization_Leads_Stddev_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  tualete?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_Leads_Stddev_Pop_Fields = {
  __typename?: 'organization_leads_stddev_pop_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  rooms?: Maybe<Scalars['Float']['output']>;
  tualete?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organization_leads" */
export type Organization_Leads_Stddev_Pop_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  tualete?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_Leads_Stddev_Samp_Fields = {
  __typename?: 'organization_leads_stddev_samp_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  rooms?: Maybe<Scalars['Float']['output']>;
  tualete?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organization_leads" */
export type Organization_Leads_Stddev_Samp_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  tualete?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization_leads" */
export type Organization_Leads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Leads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Leads_Stream_Cursor_Value_Input = {
  /** Persistent client memory: name, language, tone, preferences, interaction history. Never cleared by session reset. Populated incrementally by the AI agent. */
  client_profile?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Main_Currency_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inquiry_date?: InputMaybe<Scalars['date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  preferences?: InputMaybe<Scalars['jsonb']['input']>;
  price_max?: InputMaybe<Scalars['float8']['input']>;
  price_min?: InputMaybe<Scalars['float8']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
  rooms?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Lead_Status_Enum>;
  tualete?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Lead_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_avatar_url?: InputMaybe<Scalars['String']['input']>;
  user_display_name?: InputMaybe<Scalars['String']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_phone_number?: InputMaybe<Scalars['String']['input']>;
  user_phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Organization_Leads_Sum_Fields = {
  __typename?: 'organization_leads_sum_fields';
  price_max?: Maybe<Scalars['float8']['output']>;
  price_min?: Maybe<Scalars['float8']['output']>;
  rooms?: Maybe<Scalars['Int']['output']>;
  tualete?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "organization_leads" */
export type Organization_Leads_Sum_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  tualete?: InputMaybe<Order_By>;
};

/** update columns of table "organization_leads" */
export enum Organization_Leads_Update_Column {
  /** column name */
  ClientProfile = 'client_profile',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  InquiryDate = 'inquiry_date',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Rooms = 'rooms',
  /** column name */
  Status = 'status',
  /** column name */
  Tualete = 'tualete',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserAvatarUrl = 'user_avatar_url',
  /** column name */
  UserDisplayName = 'user_display_name',
  /** column name */
  UserEmail = 'user_email',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserPhoneNumber = 'user_phone_number',
  /** column name */
  UserPhoneNumberVerified = 'user_phone_number_verified'
}

export type Organization_Leads_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Organization_Leads_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Organization_Leads_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Organization_Leads_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Organization_Leads_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Leads_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Organization_Leads_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Leads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Leads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Leads_Var_Pop_Fields = {
  __typename?: 'organization_leads_var_pop_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  rooms?: Maybe<Scalars['Float']['output']>;
  tualete?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organization_leads" */
export type Organization_Leads_Var_Pop_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  tualete?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_Leads_Var_Samp_Fields = {
  __typename?: 'organization_leads_var_samp_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  rooms?: Maybe<Scalars['Float']['output']>;
  tualete?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organization_leads" */
export type Organization_Leads_Var_Samp_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  tualete?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_Leads_Variance_Fields = {
  __typename?: 'organization_leads_variance_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  rooms?: Maybe<Scalars['Float']['output']>;
  tualete?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organization_leads" */
export type Organization_Leads_Variance_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  tualete?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Organization_Max_Fields = {
  __typename?: 'organization_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  agency_position?: Maybe<Scalars['String']['output']>;
  clients?: Maybe<Scalars['Int']['output']>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  experience_years?: Maybe<Scalars['Int']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  instagram_url?: Maybe<Scalars['String']['output']>;
  license_number?: Maybe<Scalars['String']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  parent_organization_id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  postiz_org_id?: Maybe<Scalars['uuid']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stripe_costumer_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_original_email?: Maybe<Scalars['String']['output']>;
  wa_instance_id?: Maybe<Scalars['String']['output']>;
  wa_instance_name?: Maybe<Scalars['String']['output']>;
  wa_token?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "organization" */
export type Organization_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_position?: InputMaybe<Order_By>;
  clients?: InputMaybe<Order_By>;
  cover_image_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  experience_years?: InputMaybe<Order_By>;
  facebook_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instagram_url?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  linkedin_url?: InputMaybe<Order_By>;
  origin?: InputMaybe<Order_By>;
  parent_organization_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  postiz_org_id?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  signature?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  stripe_costumer_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_original_email?: InputMaybe<Order_By>;
  wa_instance_id?: InputMaybe<Order_By>;
  wa_instance_name?: InputMaybe<Order_By>;
  wa_token?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Min_Fields = {
  __typename?: 'organization_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  agency_position?: Maybe<Scalars['String']['output']>;
  clients?: Maybe<Scalars['Int']['output']>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  experience_years?: Maybe<Scalars['Int']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  instagram_url?: Maybe<Scalars['String']['output']>;
  license_number?: Maybe<Scalars['String']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  parent_organization_id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  postiz_org_id?: Maybe<Scalars['uuid']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stripe_costumer_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_original_email?: Maybe<Scalars['String']['output']>;
  wa_instance_id?: Maybe<Scalars['String']['output']>;
  wa_instance_name?: Maybe<Scalars['String']['output']>;
  wa_token?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "organization" */
export type Organization_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_position?: InputMaybe<Order_By>;
  clients?: InputMaybe<Order_By>;
  cover_image_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  experience_years?: InputMaybe<Order_By>;
  facebook_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instagram_url?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  linkedin_url?: InputMaybe<Order_By>;
  origin?: InputMaybe<Order_By>;
  parent_organization_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  postiz_org_id?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  signature?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  stripe_costumer_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_original_email?: InputMaybe<Order_By>;
  wa_instance_id?: InputMaybe<Order_By>;
  wa_instance_name?: InputMaybe<Order_By>;
  wa_token?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization" */
export type Organization_Mutation_Response = {
  __typename?: 'organization_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization>;
};

/** input type for inserting object relation for remote table "organization" */
export type Organization_Obj_Rel_Insert_Input = {
  data: Organization_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};

/** on_conflict condition type for table "organization" */
export type Organization_On_Conflict = {
  constraint: Organization_Constraint;
  update_columns?: Array<Organization_Update_Column>;
  where?: InputMaybe<Organization_Bool_Exp>;
};

/** Ordering options when selecting data from "organization". */
export type Organization_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_position?: InputMaybe<Order_By>;
  agent_tasks_aggregate?: InputMaybe<Agent_Task_Aggregate_Order_By>;
  children_aggregate?: InputMaybe<Organization_Aggregate_Order_By>;
  clients?: InputMaybe<Order_By>;
  cover_image_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  experience_years?: InputMaybe<Order_By>;
  facebook_url?: InputMaybe<Order_By>;
  free_trial_activated?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instagram_url?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  license_verified?: InputMaybe<Order_By>;
  linkedin_url?: InputMaybe<Order_By>;
  modules?: InputMaybe<Order_By>;
  organization_leads_aggregate?: InputMaybe<Organization_Leads_Aggregate_Order_By>;
  organization_telegram_agent_links_aggregate?: InputMaybe<Organization_Telegram_Agent_Link_Aggregate_Order_By>;
  organization_whatsapp_ai_allowlists_aggregate?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Aggregate_Order_By>;
  origin?: InputMaybe<Order_By>;
  parent?: InputMaybe<Organization_Order_By>;
  parent_organization_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  postiz_org_id?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  signature?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_costumer_id?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscription_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_organizations_aggregate?: InputMaybe<User_Organization_Aggregate_Order_By>;
  user_original_email?: InputMaybe<Order_By>;
  user_preferences_aggregate?: InputMaybe<User_Preferences_Aggregate_Order_By>;
  verified?: InputMaybe<Order_By>;
  wa_instance_id?: InputMaybe<Order_By>;
  wa_instance_name?: InputMaybe<Order_By>;
  wa_token?: InputMaybe<Order_By>;
  whatsapp_ai_config?: InputMaybe<Organization_Whatsapp_Ai_Config_Order_By>;
};

/** primary key columns input for table: organization */
export type Organization_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Organization_Prepend_Input = {
  modules?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "organization_role" */
export type Organization_Role = {
  __typename?: 'organization_role';
  role: Scalars['String']['output'];
};

/** aggregated selection of "organization_role" */
export type Organization_Role_Aggregate = {
  __typename?: 'organization_role_aggregate';
  aggregate?: Maybe<Organization_Role_Aggregate_Fields>;
  nodes: Array<Organization_Role>;
};

/** aggregate fields of "organization_role" */
export type Organization_Role_Aggregate_Fields = {
  __typename?: 'organization_role_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Role_Max_Fields>;
  min?: Maybe<Organization_Role_Min_Fields>;
};


/** aggregate fields of "organization_role" */
export type Organization_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organization_role". All fields are combined with a logical 'AND'. */
export type Organization_Role_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Role_Bool_Exp>>;
  _not?: InputMaybe<Organization_Role_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Role_Bool_Exp>>;
  role?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_role" */
export enum Organization_Role_Constraint {
  /** unique or primary key constraint on columns "role" */
  OrganizationRolePkey = 'organization_role_pkey'
}

export enum Organization_Role_Enum {
  AccountHolder = 'account_holder',
  Admin = 'admin',
  Lister = 'lister'
}

/** Boolean expression to compare columns of type "organization_role_enum". All fields are combined with logical 'AND'. */
export type Organization_Role_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Organization_Role_Enum>;
  _in?: InputMaybe<Array<Organization_Role_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Organization_Role_Enum>;
  _nin?: InputMaybe<Array<Organization_Role_Enum>>;
};

/** input type for inserting data into table "organization_role" */
export type Organization_Role_Insert_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organization_Role_Max_Fields = {
  __typename?: 'organization_role_max_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Organization_Role_Min_Fields = {
  __typename?: 'organization_role_min_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "organization_role" */
export type Organization_Role_Mutation_Response = {
  __typename?: 'organization_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Role>;
};

/** on_conflict condition type for table "organization_role" */
export type Organization_Role_On_Conflict = {
  constraint: Organization_Role_Constraint;
  update_columns?: Array<Organization_Role_Update_Column>;
  where?: InputMaybe<Organization_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_role". */
export type Organization_Role_Order_By = {
  role?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_role */
export type Organization_Role_Pk_Columns_Input = {
  role: Scalars['String']['input'];
};

/** select columns of table "organization_role" */
export enum Organization_Role_Select_Column {
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "organization_role" */
export type Organization_Role_Set_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_role" */
export type Organization_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Role_Stream_Cursor_Value_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organization_role" */
export enum Organization_Role_Update_Column {
  /** column name */
  Role = 'role'
}

export type Organization_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Role_Bool_Exp;
};

/** select columns of table "organization" */
export enum Organization_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyPosition = 'agency_position',
  /** column name */
  Clients = 'clients',
  /** column name */
  CoverImageUrl = 'cover_image_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  ExperienceYears = 'experience_years',
  /** column name */
  FacebookUrl = 'facebook_url',
  /** column name */
  FreeTrialActivated = 'free_trial_activated',
  /** column name */
  Id = 'id',
  /** column name */
  InstagramUrl = 'instagram_url',
  /** column name */
  LicenseNumber = 'license_number',
  /** column name */
  LicenseVerified = 'license_verified',
  /** column name */
  LinkedinUrl = 'linkedin_url',
  /** column name */
  Modules = 'modules',
  /** column name */
  Origin = 'origin',
  /** column name */
  ParentOrganizationId = 'parent_organization_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PostizOrgId = 'postiz_org_id',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  Signature = 'signature',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCostumerId = 'stripe_costumer_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserOriginalEmail = 'user_original_email',
  /** column name */
  Verified = 'verified',
  /** column name */
  WaInstanceId = 'wa_instance_id',
  /** column name */
  WaInstanceName = 'wa_instance_name',
  /** column name */
  WaToken = 'wa_token'
}

/** select "organization_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization" */
export enum Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FreeTrialActivated = 'free_trial_activated',
  /** column name */
  LicenseVerified = 'license_verified',
  /** column name */
  Verified = 'verified'
}

/** select "organization_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization" */
export enum Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FreeTrialActivated = 'free_trial_activated',
  /** column name */
  LicenseVerified = 'license_verified',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "organization" */
export type Organization_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  agency_position?: InputMaybe<Scalars['String']['input']>;
  clients?: InputMaybe<Scalars['Int']['input']>;
  cover_image_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience_years?: InputMaybe<Scalars['Int']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  free_trial_activated?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  license_number?: InputMaybe<Scalars['String']['input']>;
  license_verified?: InputMaybe<Scalars['Boolean']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Scalars['jsonb']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parent_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  postiz_org_id?: InputMaybe<Scalars['uuid']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Organization_Status_Enum>;
  stripe_costumer_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Organization_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_original_email?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  wa_instance_id?: InputMaybe<Scalars['String']['input']>;
  wa_instance_name?: InputMaybe<Scalars['String']['input']>;
  wa_token?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "organization_status" */
export type Organization_Status = {
  __typename?: 'organization_status';
  status: Scalars['String']['output'];
};

/** aggregated selection of "organization_status" */
export type Organization_Status_Aggregate = {
  __typename?: 'organization_status_aggregate';
  aggregate?: Maybe<Organization_Status_Aggregate_Fields>;
  nodes: Array<Organization_Status>;
};

/** aggregate fields of "organization_status" */
export type Organization_Status_Aggregate_Fields = {
  __typename?: 'organization_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Status_Max_Fields>;
  min?: Maybe<Organization_Status_Min_Fields>;
};


/** aggregate fields of "organization_status" */
export type Organization_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organization_status". All fields are combined with a logical 'AND'. */
export type Organization_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Status_Bool_Exp>>;
  _not?: InputMaybe<Organization_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_status" */
export enum Organization_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  OrganizationStatusPkey = 'organization_status_pkey'
}

export enum Organization_Status_Enum {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
  Suspended = 'suspended'
}

/** Boolean expression to compare columns of type "organization_status_enum". All fields are combined with logical 'AND'. */
export type Organization_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Organization_Status_Enum>;
  _in?: InputMaybe<Array<Organization_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Organization_Status_Enum>;
  _nin?: InputMaybe<Array<Organization_Status_Enum>>;
};

/** input type for inserting data into table "organization_status" */
export type Organization_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organization_Status_Max_Fields = {
  __typename?: 'organization_status_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Organization_Status_Min_Fields = {
  __typename?: 'organization_status_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "organization_status" */
export type Organization_Status_Mutation_Response = {
  __typename?: 'organization_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Status>;
};

/** on_conflict condition type for table "organization_status" */
export type Organization_Status_On_Conflict = {
  constraint: Organization_Status_Constraint;
  update_columns?: Array<Organization_Status_Update_Column>;
  where?: InputMaybe<Organization_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_status". */
export type Organization_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_status */
export type Organization_Status_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "organization_status" */
export enum Organization_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "organization_status" */
export type Organization_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_status" */
export type Organization_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organization_status" */
export enum Organization_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Organization_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Organization_Stddev_Fields = {
  __typename?: 'organization_stddev_fields';
  clients?: Maybe<Scalars['Float']['output']>;
  experience_years?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organization" */
export type Organization_Stddev_Order_By = {
  clients?: InputMaybe<Order_By>;
  experience_years?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_Stddev_Pop_Fields = {
  __typename?: 'organization_stddev_pop_fields';
  clients?: Maybe<Scalars['Float']['output']>;
  experience_years?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organization" */
export type Organization_Stddev_Pop_Order_By = {
  clients?: InputMaybe<Order_By>;
  experience_years?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_Stddev_Samp_Fields = {
  __typename?: 'organization_stddev_samp_fields';
  clients?: Maybe<Scalars['Float']['output']>;
  experience_years?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organization" */
export type Organization_Stddev_Samp_Order_By = {
  clients?: InputMaybe<Order_By>;
  experience_years?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization" */
export type Organization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  agency_position?: InputMaybe<Scalars['String']['input']>;
  clients?: InputMaybe<Scalars['Int']['input']>;
  cover_image_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience_years?: InputMaybe<Scalars['Int']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  free_trial_activated?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  license_number?: InputMaybe<Scalars['String']['input']>;
  license_verified?: InputMaybe<Scalars['Boolean']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Scalars['jsonb']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parent_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  postiz_org_id?: InputMaybe<Scalars['uuid']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Organization_Status_Enum>;
  stripe_costumer_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Organization_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_original_email?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  wa_instance_id?: InputMaybe<Scalars['String']['input']>;
  wa_instance_name?: InputMaybe<Scalars['String']['input']>;
  wa_token?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Organization_Sum_Fields = {
  __typename?: 'organization_sum_fields';
  clients?: Maybe<Scalars['Int']['output']>;
  experience_years?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "organization" */
export type Organization_Sum_Order_By = {
  clients?: InputMaybe<Order_By>;
  experience_years?: InputMaybe<Order_By>;
};

/** columns and relationships of "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link = {
  __typename?: 'organization_telegram_agent_link';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  telegram_chat_id: Scalars['bigint']['output'];
  telegram_username?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Aggregate = {
  __typename?: 'organization_telegram_agent_link_aggregate';
  aggregate?: Maybe<Organization_Telegram_Agent_Link_Aggregate_Fields>;
  nodes: Array<Organization_Telegram_Agent_Link>;
};

export type Organization_Telegram_Agent_Link_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Telegram_Agent_Link_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Telegram_Agent_Link_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Telegram_Agent_Link_Aggregate_Bool_Exp_Count>;
};

export type Organization_Telegram_Agent_Link_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Telegram_Agent_Link_Select_Column_Organization_Telegram_Agent_Link_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Telegram_Agent_Link_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Telegram_Agent_Link_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Telegram_Agent_Link_Select_Column_Organization_Telegram_Agent_Link_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Telegram_Agent_Link_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Telegram_Agent_Link_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Telegram_Agent_Link_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Telegram_Agent_Link_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Aggregate_Fields = {
  __typename?: 'organization_telegram_agent_link_aggregate_fields';
  avg?: Maybe<Organization_Telegram_Agent_Link_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Telegram_Agent_Link_Max_Fields>;
  min?: Maybe<Organization_Telegram_Agent_Link_Min_Fields>;
  stddev?: Maybe<Organization_Telegram_Agent_Link_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Telegram_Agent_Link_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Telegram_Agent_Link_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Telegram_Agent_Link_Sum_Fields>;
  var_pop?: Maybe<Organization_Telegram_Agent_Link_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Telegram_Agent_Link_Var_Samp_Fields>;
  variance?: Maybe<Organization_Telegram_Agent_Link_Variance_Fields>;
};


/** aggregate fields of "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Telegram_Agent_Link_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Telegram_Agent_Link_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Telegram_Agent_Link_Max_Order_By>;
  min?: InputMaybe<Organization_Telegram_Agent_Link_Min_Order_By>;
  stddev?: InputMaybe<Organization_Telegram_Agent_Link_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Telegram_Agent_Link_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Telegram_Agent_Link_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Telegram_Agent_Link_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Telegram_Agent_Link_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Telegram_Agent_Link_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Telegram_Agent_Link_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Arr_Rel_Insert_Input = {
  data: Array<Organization_Telegram_Agent_Link_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Telegram_Agent_Link_On_Conflict>;
};

/** aggregate avg on columns */
export type Organization_Telegram_Agent_Link_Avg_Fields = {
  __typename?: 'organization_telegram_agent_link_avg_fields';
  telegram_chat_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Avg_Order_By = {
  telegram_chat_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization_telegram_agent_link". All fields are combined with a logical 'AND'. */
export type Organization_Telegram_Agent_Link_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Telegram_Agent_Link_Bool_Exp>>;
  _not?: InputMaybe<Organization_Telegram_Agent_Link_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Telegram_Agent_Link_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  telegram_chat_id?: InputMaybe<Bigint_Comparison_Exp>;
  telegram_username?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_telegram_agent_link" */
export enum Organization_Telegram_Agent_Link_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationTelegramAgentLinkPkey = 'organization_telegram_agent_link_pkey',
  /** unique or primary key constraint on columns "telegram_chat_id" */
  OrganizationTelegramAgentLinkTelegramChatIdKey = 'organization_telegram_agent_link_telegram_chat_id_key'
}

/** input type for incrementing numeric columns in table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Inc_Input = {
  telegram_chat_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  telegram_chat_id?: InputMaybe<Scalars['bigint']['input']>;
  telegram_username?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organization_Telegram_Agent_Link_Max_Fields = {
  __typename?: 'organization_telegram_agent_link_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  telegram_chat_id?: Maybe<Scalars['bigint']['output']>;
  telegram_username?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  telegram_chat_id?: InputMaybe<Order_By>;
  telegram_username?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Telegram_Agent_Link_Min_Fields = {
  __typename?: 'organization_telegram_agent_link_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  telegram_chat_id?: Maybe<Scalars['bigint']['output']>;
  telegram_username?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  telegram_chat_id?: InputMaybe<Order_By>;
  telegram_username?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Mutation_Response = {
  __typename?: 'organization_telegram_agent_link_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Telegram_Agent_Link>;
};

/** on_conflict condition type for table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_On_Conflict = {
  constraint: Organization_Telegram_Agent_Link_Constraint;
  update_columns?: Array<Organization_Telegram_Agent_Link_Update_Column>;
  where?: InputMaybe<Organization_Telegram_Agent_Link_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_telegram_agent_link". */
export type Organization_Telegram_Agent_Link_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  telegram_chat_id?: InputMaybe<Order_By>;
  telegram_username?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_telegram_agent_link */
export type Organization_Telegram_Agent_Link_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_telegram_agent_link" */
export enum Organization_Telegram_Agent_Link_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  TelegramChatId = 'telegram_chat_id',
  /** column name */
  TelegramUsername = 'telegram_username',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "organization_telegram_agent_link_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_telegram_agent_link" */
export enum Organization_Telegram_Agent_Link_Select_Column_Organization_Telegram_Agent_Link_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "organization_telegram_agent_link_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_telegram_agent_link" */
export enum Organization_Telegram_Agent_Link_Select_Column_Organization_Telegram_Agent_Link_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  telegram_chat_id?: InputMaybe<Scalars['bigint']['input']>;
  telegram_username?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Organization_Telegram_Agent_Link_Stddev_Fields = {
  __typename?: 'organization_telegram_agent_link_stddev_fields';
  telegram_chat_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Stddev_Order_By = {
  telegram_chat_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_Telegram_Agent_Link_Stddev_Pop_Fields = {
  __typename?: 'organization_telegram_agent_link_stddev_pop_fields';
  telegram_chat_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Stddev_Pop_Order_By = {
  telegram_chat_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_Telegram_Agent_Link_Stddev_Samp_Fields = {
  __typename?: 'organization_telegram_agent_link_stddev_samp_fields';
  telegram_chat_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Stddev_Samp_Order_By = {
  telegram_chat_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Telegram_Agent_Link_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Telegram_Agent_Link_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  telegram_chat_id?: InputMaybe<Scalars['bigint']['input']>;
  telegram_username?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Organization_Telegram_Agent_Link_Sum_Fields = {
  __typename?: 'organization_telegram_agent_link_sum_fields';
  telegram_chat_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Sum_Order_By = {
  telegram_chat_id?: InputMaybe<Order_By>;
};

/** update columns of table "organization_telegram_agent_link" */
export enum Organization_Telegram_Agent_Link_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  TelegramChatId = 'telegram_chat_id',
  /** column name */
  TelegramUsername = 'telegram_username',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Organization_Telegram_Agent_Link_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Telegram_Agent_Link_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Telegram_Agent_Link_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Telegram_Agent_Link_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Telegram_Agent_Link_Var_Pop_Fields = {
  __typename?: 'organization_telegram_agent_link_var_pop_fields';
  telegram_chat_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Var_Pop_Order_By = {
  telegram_chat_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_Telegram_Agent_Link_Var_Samp_Fields = {
  __typename?: 'organization_telegram_agent_link_var_samp_fields';
  telegram_chat_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Var_Samp_Order_By = {
  telegram_chat_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_Telegram_Agent_Link_Variance_Fields = {
  __typename?: 'organization_telegram_agent_link_variance_fields';
  telegram_chat_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organization_telegram_agent_link" */
export type Organization_Telegram_Agent_Link_Variance_Order_By = {
  telegram_chat_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "organization_type" */
export type Organization_Type = {
  __typename?: 'organization_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "organization_type" */
export type Organization_Type_Aggregate = {
  __typename?: 'organization_type_aggregate';
  aggregate?: Maybe<Organization_Type_Aggregate_Fields>;
  nodes: Array<Organization_Type>;
};

/** aggregate fields of "organization_type" */
export type Organization_Type_Aggregate_Fields = {
  __typename?: 'organization_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Type_Max_Fields>;
  min?: Maybe<Organization_Type_Min_Fields>;
};


/** aggregate fields of "organization_type" */
export type Organization_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organization_type". All fields are combined with a logical 'AND'. */
export type Organization_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Type_Bool_Exp>>;
  _not?: InputMaybe<Organization_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_type" */
export enum Organization_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  OrganizationTypePkey = 'organization_type_pkey'
}

export enum Organization_Type_Enum {
  Agency = 'agency',
  Agent = 'agent',
  Clering = 'clering',
  Personal = 'personal'
}

/** Boolean expression to compare columns of type "organization_type_enum". All fields are combined with logical 'AND'. */
export type Organization_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Organization_Type_Enum>;
  _in?: InputMaybe<Array<Organization_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Organization_Type_Enum>;
  _nin?: InputMaybe<Array<Organization_Type_Enum>>;
};

/** input type for inserting data into table "organization_type" */
export type Organization_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organization_Type_Max_Fields = {
  __typename?: 'organization_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Organization_Type_Min_Fields = {
  __typename?: 'organization_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "organization_type" */
export type Organization_Type_Mutation_Response = {
  __typename?: 'organization_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Type>;
};

/** on_conflict condition type for table "organization_type" */
export type Organization_Type_On_Conflict = {
  constraint: Organization_Type_Constraint;
  update_columns?: Array<Organization_Type_Update_Column>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_type". */
export type Organization_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_type */
export type Organization_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "organization_type" */
export enum Organization_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "organization_type" */
export type Organization_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_type" */
export type Organization_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organization_type" */
export enum Organization_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Organization_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Type_Bool_Exp;
};

/** update columns of table "organization" */
export enum Organization_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyPosition = 'agency_position',
  /** column name */
  Clients = 'clients',
  /** column name */
  CoverImageUrl = 'cover_image_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  ExperienceYears = 'experience_years',
  /** column name */
  FacebookUrl = 'facebook_url',
  /** column name */
  FreeTrialActivated = 'free_trial_activated',
  /** column name */
  Id = 'id',
  /** column name */
  InstagramUrl = 'instagram_url',
  /** column name */
  LicenseNumber = 'license_number',
  /** column name */
  LicenseVerified = 'license_verified',
  /** column name */
  LinkedinUrl = 'linkedin_url',
  /** column name */
  Modules = 'modules',
  /** column name */
  Origin = 'origin',
  /** column name */
  ParentOrganizationId = 'parent_organization_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PostizOrgId = 'postiz_org_id',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  Signature = 'signature',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCostumerId = 'stripe_costumer_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserOriginalEmail = 'user_original_email',
  /** column name */
  Verified = 'verified',
  /** column name */
  WaInstanceId = 'wa_instance_id',
  /** column name */
  WaInstanceName = 'wa_instance_name',
  /** column name */
  WaToken = 'wa_token'
}

export type Organization_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Organization_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Organization_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Organization_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Organization_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Organization_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Var_Pop_Fields = {
  __typename?: 'organization_var_pop_fields';
  clients?: Maybe<Scalars['Float']['output']>;
  experience_years?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organization" */
export type Organization_Var_Pop_Order_By = {
  clients?: InputMaybe<Order_By>;
  experience_years?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_Var_Samp_Fields = {
  __typename?: 'organization_var_samp_fields';
  clients?: Maybe<Scalars['Float']['output']>;
  experience_years?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organization" */
export type Organization_Var_Samp_Order_By = {
  clients?: InputMaybe<Order_By>;
  experience_years?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_Variance_Fields = {
  __typename?: 'organization_variance_fields';
  clients?: Maybe<Scalars['Float']['output']>;
  experience_years?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organization" */
export type Organization_Variance_Order_By = {
  clients?: InputMaybe<Order_By>;
  experience_years?: InputMaybe<Order_By>;
};

/** columns and relationships of "organization_whatsapp_ai_allowlist" */
export type Organization_Whatsapp_Ai_Allowlist = {
  __typename?: 'organization_whatsapp_ai_allowlist';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  phone_e164: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "organization_whatsapp_ai_allowlist" */
export type Organization_Whatsapp_Ai_Allowlist_Aggregate = {
  __typename?: 'organization_whatsapp_ai_allowlist_aggregate';
  aggregate?: Maybe<Organization_Whatsapp_Ai_Allowlist_Aggregate_Fields>;
  nodes: Array<Organization_Whatsapp_Ai_Allowlist>;
};

export type Organization_Whatsapp_Ai_Allowlist_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Aggregate_Bool_Exp_Count>;
};

export type Organization_Whatsapp_Ai_Allowlist_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Whatsapp_Ai_Allowlist_Select_Column_Organization_Whatsapp_Ai_Allowlist_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Whatsapp_Ai_Allowlist_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Whatsapp_Ai_Allowlist_Select_Column_Organization_Whatsapp_Ai_Allowlist_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Whatsapp_Ai_Allowlist_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_whatsapp_ai_allowlist" */
export type Organization_Whatsapp_Ai_Allowlist_Aggregate_Fields = {
  __typename?: 'organization_whatsapp_ai_allowlist_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Whatsapp_Ai_Allowlist_Max_Fields>;
  min?: Maybe<Organization_Whatsapp_Ai_Allowlist_Min_Fields>;
};


/** aggregate fields of "organization_whatsapp_ai_allowlist" */
export type Organization_Whatsapp_Ai_Allowlist_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_whatsapp_ai_allowlist" */
export type Organization_Whatsapp_Ai_Allowlist_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Max_Order_By>;
  min?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_whatsapp_ai_allowlist" */
export type Organization_Whatsapp_Ai_Allowlist_Arr_Rel_Insert_Input = {
  data: Array<Organization_Whatsapp_Ai_Allowlist_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_whatsapp_ai_allowlist". All fields are combined with a logical 'AND'. */
export type Organization_Whatsapp_Ai_Allowlist_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>>;
  _not?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_e164?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_whatsapp_ai_allowlist" */
export enum Organization_Whatsapp_Ai_Allowlist_Constraint {
  /** unique or primary key constraint on columns "phone_e164", "organization_id" */
  OrganizationWhatsappAiAllowlistOrganizationIdPhoneE164K = 'organization_whatsapp_ai_allowlist_organization_id_phone_e164_k',
  /** unique or primary key constraint on columns "id" */
  OrganizationWhatsappAiAllowlistPkey = 'organization_whatsapp_ai_allowlist_pkey'
}

/** input type for inserting data into table "organization_whatsapp_ai_allowlist" */
export type Organization_Whatsapp_Ai_Allowlist_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_e164?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Organization_Whatsapp_Ai_Allowlist_Max_Fields = {
  __typename?: 'organization_whatsapp_ai_allowlist_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  phone_e164?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "organization_whatsapp_ai_allowlist" */
export type Organization_Whatsapp_Ai_Allowlist_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  phone_e164?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Whatsapp_Ai_Allowlist_Min_Fields = {
  __typename?: 'organization_whatsapp_ai_allowlist_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  phone_e164?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "organization_whatsapp_ai_allowlist" */
export type Organization_Whatsapp_Ai_Allowlist_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  phone_e164?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_whatsapp_ai_allowlist" */
export type Organization_Whatsapp_Ai_Allowlist_Mutation_Response = {
  __typename?: 'organization_whatsapp_ai_allowlist_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Whatsapp_Ai_Allowlist>;
};

/** on_conflict condition type for table "organization_whatsapp_ai_allowlist" */
export type Organization_Whatsapp_Ai_Allowlist_On_Conflict = {
  constraint: Organization_Whatsapp_Ai_Allowlist_Constraint;
  update_columns?: Array<Organization_Whatsapp_Ai_Allowlist_Update_Column>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_whatsapp_ai_allowlist". */
export type Organization_Whatsapp_Ai_Allowlist_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  phone_e164?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_whatsapp_ai_allowlist */
export type Organization_Whatsapp_Ai_Allowlist_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_whatsapp_ai_allowlist" */
export enum Organization_Whatsapp_Ai_Allowlist_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Label = 'label',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PhoneE164 = 'phone_e164',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "organization_whatsapp_ai_allowlist_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_whatsapp_ai_allowlist" */
export enum Organization_Whatsapp_Ai_Allowlist_Select_Column_Organization_Whatsapp_Ai_Allowlist_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "organization_whatsapp_ai_allowlist_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_whatsapp_ai_allowlist" */
export enum Organization_Whatsapp_Ai_Allowlist_Select_Column_Organization_Whatsapp_Ai_Allowlist_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "organization_whatsapp_ai_allowlist" */
export type Organization_Whatsapp_Ai_Allowlist_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_e164?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organization_whatsapp_ai_allowlist" */
export type Organization_Whatsapp_Ai_Allowlist_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Whatsapp_Ai_Allowlist_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Whatsapp_Ai_Allowlist_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_e164?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_whatsapp_ai_allowlist" */
export enum Organization_Whatsapp_Ai_Allowlist_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Label = 'label',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PhoneE164 = 'phone_e164',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Organization_Whatsapp_Ai_Allowlist_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Whatsapp_Ai_Allowlist_Bool_Exp;
};

/** columns and relationships of "organization_whatsapp_ai_config" */
export type Organization_Whatsapp_Ai_Config = {
  __typename?: 'organization_whatsapp_ai_config';
  /** Agent/company profile for LLM personalization. JSON with: agency_name, agent_name, tone (casual/formal/mixed), greeting_style, language, custom_instructions. Injected into all LLM prompts. */
  agent_profile?: Maybe<Scalars['jsonb']['output']>;
  ai_enabled: Scalars['Boolean']['output'];
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes: Scalars['Int']['output'];
  heartbeat_assistant_cooldown_hours: Scalars['Int']['output'];
  heartbeat_enabled: Scalars['Boolean']['output'];
  heartbeat_human_agent_cooldown_hours: Scalars['Int']['output'];
  langgraph_url_override?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  /** Controls whether WhatsApp property search is scoped by listing origin, the current organization, the parent organization, or the grandparent organization. */
  property_search_scope_mode: Scalars['String']['output'];
  /** List of property portal domains the bot will process. URLs from other domains trigger alternative suggestions from the catalog instead of scraping. Default: kaktu.al, century21albania.com. */
  supported_property_domains?: Maybe<Scalars['jsonb']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  whitelist_mode: Scalars['String']['output'];
};


/** columns and relationships of "organization_whatsapp_ai_config" */
export type Organization_Whatsapp_Ai_ConfigAgent_ProfileArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "organization_whatsapp_ai_config" */
export type Organization_Whatsapp_Ai_ConfigSupported_Property_DomainsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "organization_whatsapp_ai_config" */
export type Organization_Whatsapp_Ai_Config_Aggregate = {
  __typename?: 'organization_whatsapp_ai_config_aggregate';
  aggregate?: Maybe<Organization_Whatsapp_Ai_Config_Aggregate_Fields>;
  nodes: Array<Organization_Whatsapp_Ai_Config>;
};

/** aggregate fields of "organization_whatsapp_ai_config" */
export type Organization_Whatsapp_Ai_Config_Aggregate_Fields = {
  __typename?: 'organization_whatsapp_ai_config_aggregate_fields';
  avg?: Maybe<Organization_Whatsapp_Ai_Config_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Whatsapp_Ai_Config_Max_Fields>;
  min?: Maybe<Organization_Whatsapp_Ai_Config_Min_Fields>;
  stddev?: Maybe<Organization_Whatsapp_Ai_Config_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Whatsapp_Ai_Config_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Whatsapp_Ai_Config_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Whatsapp_Ai_Config_Sum_Fields>;
  var_pop?: Maybe<Organization_Whatsapp_Ai_Config_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Whatsapp_Ai_Config_Var_Samp_Fields>;
  variance?: Maybe<Organization_Whatsapp_Ai_Config_Variance_Fields>;
};


/** aggregate fields of "organization_whatsapp_ai_config" */
export type Organization_Whatsapp_Ai_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Whatsapp_Ai_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Organization_Whatsapp_Ai_Config_Append_Input = {
  /** Agent/company profile for LLM personalization. JSON with: agency_name, agent_name, tone (casual/formal/mixed), greeting_style, language, custom_instructions. Injected into all LLM prompts. */
  agent_profile?: InputMaybe<Scalars['jsonb']['input']>;
  /** List of property portal domains the bot will process. URLs from other domains trigger alternative suggestions from the catalog instead of scraping. Default: kaktu.al, century21albania.com. */
  supported_property_domains?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Organization_Whatsapp_Ai_Config_Avg_Fields = {
  __typename?: 'organization_whatsapp_ai_config_avg_fields';
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: Maybe<Scalars['Float']['output']>;
  heartbeat_assistant_cooldown_hours?: Maybe<Scalars['Float']['output']>;
  heartbeat_human_agent_cooldown_hours?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "organization_whatsapp_ai_config". All fields are combined with a logical 'AND'. */
export type Organization_Whatsapp_Ai_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Whatsapp_Ai_Config_Bool_Exp>>;
  _not?: InputMaybe<Organization_Whatsapp_Ai_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Whatsapp_Ai_Config_Bool_Exp>>;
  agent_profile?: InputMaybe<Jsonb_Comparison_Exp>;
  ai_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  auto_whitelist_timeout_minutes?: InputMaybe<Int_Comparison_Exp>;
  heartbeat_assistant_cooldown_hours?: InputMaybe<Int_Comparison_Exp>;
  heartbeat_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  heartbeat_human_agent_cooldown_hours?: InputMaybe<Int_Comparison_Exp>;
  langgraph_url_override?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_search_scope_mode?: InputMaybe<String_Comparison_Exp>;
  supported_property_domains?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  updated_by_user?: InputMaybe<Users_Bool_Exp>;
  whitelist_mode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_whatsapp_ai_config" */
export enum Organization_Whatsapp_Ai_Config_Constraint {
  /** unique or primary key constraint on columns "organization_id" */
  OrganizationWhatsappAiConfigPkey = 'organization_whatsapp_ai_config_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Organization_Whatsapp_Ai_Config_Delete_At_Path_Input = {
  /** Agent/company profile for LLM personalization. JSON with: agency_name, agent_name, tone (casual/formal/mixed), greeting_style, language, custom_instructions. Injected into all LLM prompts. */
  agent_profile?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of property portal domains the bot will process. URLs from other domains trigger alternative suggestions from the catalog instead of scraping. Default: kaktu.al, century21albania.com. */
  supported_property_domains?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Organization_Whatsapp_Ai_Config_Delete_Elem_Input = {
  /** Agent/company profile for LLM personalization. JSON with: agency_name, agent_name, tone (casual/formal/mixed), greeting_style, language, custom_instructions. Injected into all LLM prompts. */
  agent_profile?: InputMaybe<Scalars['Int']['input']>;
  /** List of property portal domains the bot will process. URLs from other domains trigger alternative suggestions from the catalog instead of scraping. Default: kaktu.al, century21albania.com. */
  supported_property_domains?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Organization_Whatsapp_Ai_Config_Delete_Key_Input = {
  /** Agent/company profile for LLM personalization. JSON with: agency_name, agent_name, tone (casual/formal/mixed), greeting_style, language, custom_instructions. Injected into all LLM prompts. */
  agent_profile?: InputMaybe<Scalars['String']['input']>;
  /** List of property portal domains the bot will process. URLs from other domains trigger alternative suggestions from the catalog instead of scraping. Default: kaktu.al, century21albania.com. */
  supported_property_domains?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "organization_whatsapp_ai_config" */
export type Organization_Whatsapp_Ai_Config_Inc_Input = {
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: InputMaybe<Scalars['Int']['input']>;
  heartbeat_assistant_cooldown_hours?: InputMaybe<Scalars['Int']['input']>;
  heartbeat_human_agent_cooldown_hours?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organization_whatsapp_ai_config" */
export type Organization_Whatsapp_Ai_Config_Insert_Input = {
  /** Agent/company profile for LLM personalization. JSON with: agency_name, agent_name, tone (casual/formal/mixed), greeting_style, language, custom_instructions. Injected into all LLM prompts. */
  agent_profile?: InputMaybe<Scalars['jsonb']['input']>;
  ai_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: InputMaybe<Scalars['Int']['input']>;
  heartbeat_assistant_cooldown_hours?: InputMaybe<Scalars['Int']['input']>;
  heartbeat_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  heartbeat_human_agent_cooldown_hours?: InputMaybe<Scalars['Int']['input']>;
  langgraph_url_override?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Controls whether WhatsApp property search is scoped by listing origin, the current organization, the parent organization, or the grandparent organization. */
  property_search_scope_mode?: InputMaybe<Scalars['String']['input']>;
  /** List of property portal domains the bot will process. URLs from other domains trigger alternative suggestions from the catalog instead of scraping. Default: kaktu.al, century21albania.com. */
  supported_property_domains?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
  updated_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  whitelist_mode?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organization_Whatsapp_Ai_Config_Max_Fields = {
  __typename?: 'organization_whatsapp_ai_config_max_fields';
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: Maybe<Scalars['Int']['output']>;
  heartbeat_assistant_cooldown_hours?: Maybe<Scalars['Int']['output']>;
  heartbeat_human_agent_cooldown_hours?: Maybe<Scalars['Int']['output']>;
  langgraph_url_override?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  /** Controls whether WhatsApp property search is scoped by listing origin, the current organization, the parent organization, or the grandparent organization. */
  property_search_scope_mode?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['uuid']['output']>;
  whitelist_mode?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Organization_Whatsapp_Ai_Config_Min_Fields = {
  __typename?: 'organization_whatsapp_ai_config_min_fields';
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: Maybe<Scalars['Int']['output']>;
  heartbeat_assistant_cooldown_hours?: Maybe<Scalars['Int']['output']>;
  heartbeat_human_agent_cooldown_hours?: Maybe<Scalars['Int']['output']>;
  langgraph_url_override?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  /** Controls whether WhatsApp property search is scoped by listing origin, the current organization, the parent organization, or the grandparent organization. */
  property_search_scope_mode?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['uuid']['output']>;
  whitelist_mode?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "organization_whatsapp_ai_config" */
export type Organization_Whatsapp_Ai_Config_Mutation_Response = {
  __typename?: 'organization_whatsapp_ai_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Whatsapp_Ai_Config>;
};

/** input type for inserting object relation for remote table "organization_whatsapp_ai_config" */
export type Organization_Whatsapp_Ai_Config_Obj_Rel_Insert_Input = {
  data: Organization_Whatsapp_Ai_Config_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Whatsapp_Ai_Config_On_Conflict>;
};

/** on_conflict condition type for table "organization_whatsapp_ai_config" */
export type Organization_Whatsapp_Ai_Config_On_Conflict = {
  constraint: Organization_Whatsapp_Ai_Config_Constraint;
  update_columns?: Array<Organization_Whatsapp_Ai_Config_Update_Column>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_whatsapp_ai_config". */
export type Organization_Whatsapp_Ai_Config_Order_By = {
  agent_profile?: InputMaybe<Order_By>;
  ai_enabled?: InputMaybe<Order_By>;
  auto_whitelist_timeout_minutes?: InputMaybe<Order_By>;
  heartbeat_assistant_cooldown_hours?: InputMaybe<Order_By>;
  heartbeat_enabled?: InputMaybe<Order_By>;
  heartbeat_human_agent_cooldown_hours?: InputMaybe<Order_By>;
  langgraph_url_override?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  property_search_scope_mode?: InputMaybe<Order_By>;
  supported_property_domains?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<Users_Order_By>;
  whitelist_mode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_whatsapp_ai_config */
export type Organization_Whatsapp_Ai_Config_Pk_Columns_Input = {
  organization_id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Organization_Whatsapp_Ai_Config_Prepend_Input = {
  /** Agent/company profile for LLM personalization. JSON with: agency_name, agent_name, tone (casual/formal/mixed), greeting_style, language, custom_instructions. Injected into all LLM prompts. */
  agent_profile?: InputMaybe<Scalars['jsonb']['input']>;
  /** List of property portal domains the bot will process. URLs from other domains trigger alternative suggestions from the catalog instead of scraping. Default: kaktu.al, century21albania.com. */
  supported_property_domains?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "organization_whatsapp_ai_config" */
export enum Organization_Whatsapp_Ai_Config_Select_Column {
  /** column name */
  AgentProfile = 'agent_profile',
  /** column name */
  AiEnabled = 'ai_enabled',
  /** column name */
  AutoWhitelistTimeoutMinutes = 'auto_whitelist_timeout_minutes',
  /** column name */
  HeartbeatAssistantCooldownHours = 'heartbeat_assistant_cooldown_hours',
  /** column name */
  HeartbeatEnabled = 'heartbeat_enabled',
  /** column name */
  HeartbeatHumanAgentCooldownHours = 'heartbeat_human_agent_cooldown_hours',
  /** column name */
  LanggraphUrlOverride = 'langgraph_url_override',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PropertySearchScopeMode = 'property_search_scope_mode',
  /** column name */
  SupportedPropertyDomains = 'supported_property_domains',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  WhitelistMode = 'whitelist_mode'
}

/** input type for updating data in table "organization_whatsapp_ai_config" */
export type Organization_Whatsapp_Ai_Config_Set_Input = {
  /** Agent/company profile for LLM personalization. JSON with: agency_name, agent_name, tone (casual/formal/mixed), greeting_style, language, custom_instructions. Injected into all LLM prompts. */
  agent_profile?: InputMaybe<Scalars['jsonb']['input']>;
  ai_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: InputMaybe<Scalars['Int']['input']>;
  heartbeat_assistant_cooldown_hours?: InputMaybe<Scalars['Int']['input']>;
  heartbeat_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  heartbeat_human_agent_cooldown_hours?: InputMaybe<Scalars['Int']['input']>;
  langgraph_url_override?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Controls whether WhatsApp property search is scoped by listing origin, the current organization, the parent organization, or the grandparent organization. */
  property_search_scope_mode?: InputMaybe<Scalars['String']['input']>;
  /** List of property portal domains the bot will process. URLs from other domains trigger alternative suggestions from the catalog instead of scraping. Default: kaktu.al, century21albania.com. */
  supported_property_domains?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
  whitelist_mode?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Organization_Whatsapp_Ai_Config_Stddev_Fields = {
  __typename?: 'organization_whatsapp_ai_config_stddev_fields';
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: Maybe<Scalars['Float']['output']>;
  heartbeat_assistant_cooldown_hours?: Maybe<Scalars['Float']['output']>;
  heartbeat_human_agent_cooldown_hours?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Organization_Whatsapp_Ai_Config_Stddev_Pop_Fields = {
  __typename?: 'organization_whatsapp_ai_config_stddev_pop_fields';
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: Maybe<Scalars['Float']['output']>;
  heartbeat_assistant_cooldown_hours?: Maybe<Scalars['Float']['output']>;
  heartbeat_human_agent_cooldown_hours?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Organization_Whatsapp_Ai_Config_Stddev_Samp_Fields = {
  __typename?: 'organization_whatsapp_ai_config_stddev_samp_fields';
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: Maybe<Scalars['Float']['output']>;
  heartbeat_assistant_cooldown_hours?: Maybe<Scalars['Float']['output']>;
  heartbeat_human_agent_cooldown_hours?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "organization_whatsapp_ai_config" */
export type Organization_Whatsapp_Ai_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Whatsapp_Ai_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Whatsapp_Ai_Config_Stream_Cursor_Value_Input = {
  /** Agent/company profile for LLM personalization. JSON with: agency_name, agent_name, tone (casual/formal/mixed), greeting_style, language, custom_instructions. Injected into all LLM prompts. */
  agent_profile?: InputMaybe<Scalars['jsonb']['input']>;
  ai_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: InputMaybe<Scalars['Int']['input']>;
  heartbeat_assistant_cooldown_hours?: InputMaybe<Scalars['Int']['input']>;
  heartbeat_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  heartbeat_human_agent_cooldown_hours?: InputMaybe<Scalars['Int']['input']>;
  langgraph_url_override?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Controls whether WhatsApp property search is scoped by listing origin, the current organization, the parent organization, or the grandparent organization. */
  property_search_scope_mode?: InputMaybe<Scalars['String']['input']>;
  /** List of property portal domains the bot will process. URLs from other domains trigger alternative suggestions from the catalog instead of scraping. Default: kaktu.al, century21albania.com. */
  supported_property_domains?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
  whitelist_mode?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Organization_Whatsapp_Ai_Config_Sum_Fields = {
  __typename?: 'organization_whatsapp_ai_config_sum_fields';
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: Maybe<Scalars['Int']['output']>;
  heartbeat_assistant_cooldown_hours?: Maybe<Scalars['Int']['output']>;
  heartbeat_human_agent_cooldown_hours?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "organization_whatsapp_ai_config" */
export enum Organization_Whatsapp_Ai_Config_Update_Column {
  /** column name */
  AgentProfile = 'agent_profile',
  /** column name */
  AiEnabled = 'ai_enabled',
  /** column name */
  AutoWhitelistTimeoutMinutes = 'auto_whitelist_timeout_minutes',
  /** column name */
  HeartbeatAssistantCooldownHours = 'heartbeat_assistant_cooldown_hours',
  /** column name */
  HeartbeatEnabled = 'heartbeat_enabled',
  /** column name */
  HeartbeatHumanAgentCooldownHours = 'heartbeat_human_agent_cooldown_hours',
  /** column name */
  LanggraphUrlOverride = 'langgraph_url_override',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PropertySearchScopeMode = 'property_search_scope_mode',
  /** column name */
  SupportedPropertyDomains = 'supported_property_domains',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  WhitelistMode = 'whitelist_mode'
}

export type Organization_Whatsapp_Ai_Config_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Organization_Whatsapp_Ai_Config_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Organization_Whatsapp_Ai_Config_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Organization_Whatsapp_Ai_Config_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Organization_Whatsapp_Ai_Config_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Whatsapp_Ai_Config_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Organization_Whatsapp_Ai_Config_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Whatsapp_Ai_Config_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Whatsapp_Ai_Config_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Whatsapp_Ai_Config_Var_Pop_Fields = {
  __typename?: 'organization_whatsapp_ai_config_var_pop_fields';
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: Maybe<Scalars['Float']['output']>;
  heartbeat_assistant_cooldown_hours?: Maybe<Scalars['Float']['output']>;
  heartbeat_human_agent_cooldown_hours?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Organization_Whatsapp_Ai_Config_Var_Samp_Fields = {
  __typename?: 'organization_whatsapp_ai_config_var_samp_fields';
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: Maybe<Scalars['Float']['output']>;
  heartbeat_assistant_cooldown_hours?: Maybe<Scalars['Float']['output']>;
  heartbeat_human_agent_cooldown_hours?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Organization_Whatsapp_Ai_Config_Variance_Fields = {
  __typename?: 'organization_whatsapp_ai_config_variance_fields';
  /** Minutes to wait before auto-whitelisting a new contact. 0 = disabled (hold forever until agent decides). */
  auto_whitelist_timeout_minutes?: Maybe<Scalars['Float']['output']>;
  heartbeat_assistant_cooldown_hours?: Maybe<Scalars['Float']['output']>;
  heartbeat_human_agent_cooldown_hours?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "parking_type" */
export type Parking_Type = {
  __typename?: 'parking_type';
  type: Scalars['String']['output'];
};

export type Parking_Type_ActionType = {
  __typename?: 'parking_type_ActionType';
  type: Scalars['String']['output'];
};

/** aggregated selection of "parking_type" */
export type Parking_Type_Aggregate = {
  __typename?: 'parking_type_aggregate';
  aggregate?: Maybe<Parking_Type_Aggregate_Fields>;
  nodes: Array<Parking_Type>;
};

/** aggregate fields of "parking_type" */
export type Parking_Type_Aggregate_Fields = {
  __typename?: 'parking_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Parking_Type_Max_Fields>;
  min?: Maybe<Parking_Type_Min_Fields>;
};


/** aggregate fields of "parking_type" */
export type Parking_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parking_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "parking_type". All fields are combined with a logical 'AND'. */
export type Parking_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Parking_Type_Bool_Exp>>;
  _not?: InputMaybe<Parking_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Parking_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "parking_type" */
export enum Parking_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  ParkingTypePkey = 'parking_type_pkey'
}

export enum Parking_Type_Enum {
  Garage = 'garage',
  NoParking = 'no_parking',
  StreetParking = 'street_parking',
  Underground = 'underground'
}

/** Boolean expression to compare columns of type "parking_type_enum". All fields are combined with logical 'AND'. */
export type Parking_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Parking_Type_Enum>;
  _in?: InputMaybe<Array<Parking_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Parking_Type_Enum>;
  _nin?: InputMaybe<Array<Parking_Type_Enum>>;
};

/** input type for inserting data into table "parking_type" */
export type Parking_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Parking_Type_Max_Fields = {
  __typename?: 'parking_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Parking_Type_Min_Fields = {
  __typename?: 'parking_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "parking_type" */
export type Parking_Type_Mutation_Response = {
  __typename?: 'parking_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parking_Type>;
};

/** on_conflict condition type for table "parking_type" */
export type Parking_Type_On_Conflict = {
  constraint: Parking_Type_Constraint;
  update_columns?: Array<Parking_Type_Update_Column>;
  where?: InputMaybe<Parking_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "parking_type". */
export type Parking_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parking_type */
export type Parking_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "parking_type" */
export enum Parking_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "parking_type" */
export type Parking_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "parking_type" */
export type Parking_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parking_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parking_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "parking_type" */
export enum Parking_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Parking_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parking_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parking_Type_Bool_Exp;
};

/** columns and relationships of "phone_number_type" */
export type Phone_Number_Type = {
  __typename?: 'phone_number_type';
  type: Scalars['String']['output'];
};

export enum Phone_Number_Type_ActionType {
  AdditionalContact = 'ADDITIONAL_CONTACT',
  ProfileContact = 'PROFILE_CONTACT'
}

/** aggregated selection of "phone_number_type" */
export type Phone_Number_Type_Aggregate = {
  __typename?: 'phone_number_type_aggregate';
  aggregate?: Maybe<Phone_Number_Type_Aggregate_Fields>;
  nodes: Array<Phone_Number_Type>;
};

/** aggregate fields of "phone_number_type" */
export type Phone_Number_Type_Aggregate_Fields = {
  __typename?: 'phone_number_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Phone_Number_Type_Max_Fields>;
  min?: Maybe<Phone_Number_Type_Min_Fields>;
};


/** aggregate fields of "phone_number_type" */
export type Phone_Number_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Phone_Number_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "phone_number_type". All fields are combined with a logical 'AND'. */
export type Phone_Number_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Phone_Number_Type_Bool_Exp>>;
  _not?: InputMaybe<Phone_Number_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Phone_Number_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "phone_number_type" */
export enum Phone_Number_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  PhoneNumberTypePkey = 'phone_number_type_pkey'
}

/** input type for inserting data into table "phone_number_type" */
export type Phone_Number_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Phone_Number_Type_Max_Fields = {
  __typename?: 'phone_number_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Phone_Number_Type_Min_Fields = {
  __typename?: 'phone_number_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "phone_number_type" */
export type Phone_Number_Type_Mutation_Response = {
  __typename?: 'phone_number_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Phone_Number_Type>;
};

/** on_conflict condition type for table "phone_number_type" */
export type Phone_Number_Type_On_Conflict = {
  constraint: Phone_Number_Type_Constraint;
  update_columns?: Array<Phone_Number_Type_Update_Column>;
  where?: InputMaybe<Phone_Number_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "phone_number_type". */
export type Phone_Number_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: phone_number_type */
export type Phone_Number_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "phone_number_type" */
export enum Phone_Number_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "phone_number_type" */
export type Phone_Number_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "phone_number_type" */
export type Phone_Number_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Phone_Number_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Phone_Number_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "phone_number_type" */
export enum Phone_Number_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Phone_Number_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Phone_Number_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Phone_Number_Type_Bool_Exp;
};

/** Canonical Albanian landmark and residence identities used for proximity and membership search. */
export type Place_Reference = {
  __typename?: 'place_reference';
  active: Scalars['Boolean']['output'];
  /** An array relationship */
  aliases: Array<Place_Reference_Alias>;
  /** An aggregate relationship */
  aliases_aggregate: Place_Reference_Alias_Aggregate;
  canonical_name: Scalars['String']['output'];
  /** An object relationship */
  center_location: Location;
  center_location_id: Scalars['uuid']['output'];
  /** An object relationship */
  city: City;
  city_id: Scalars['uuid']['output'];
  confidence?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  default_radius_m: Scalars['Int']['output'];
  footprint?: Maybe<Scalars['geometry']['output']>;
  id: Scalars['uuid']['output'];
  is_problematic: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  /** An object relationship */
  legacy_city_zone?: Maybe<City_Zone>;
  /** Optional link to a historical POI-like city_zone row during non-destructive migration. */
  legacy_city_zone_id?: Maybe<Scalars['uuid']['output']>;
  normalized_name: Scalars['String']['output'];
  /** An object relationship */
  parent_city_zone: City_Zone;
  parent_city_zone_id: Scalars['uuid']['output'];
  /** An array relationship */
  property_relations: Array<Property_Place_Reference>;
  /** An aggregate relationship */
  property_relations_aggregate: Property_Place_Reference_Aggregate;
  provenance: Scalars['jsonb']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  provider_place_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** Canonical Albanian landmark and residence identities used for proximity and membership search. */
export type Place_ReferenceAliasesArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Alias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Alias_Order_By>>;
  where?: InputMaybe<Place_Reference_Alias_Bool_Exp>;
};


/** Canonical Albanian landmark and residence identities used for proximity and membership search. */
export type Place_ReferenceAliases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Alias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Alias_Order_By>>;
  where?: InputMaybe<Place_Reference_Alias_Bool_Exp>;
};


/** Canonical Albanian landmark and residence identities used for proximity and membership search. */
export type Place_ReferenceProperty_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Property_Place_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Place_Reference_Order_By>>;
  where?: InputMaybe<Property_Place_Reference_Bool_Exp>;
};


/** Canonical Albanian landmark and residence identities used for proximity and membership search. */
export type Place_ReferenceProperty_Relations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Place_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Place_Reference_Order_By>>;
  where?: InputMaybe<Property_Place_Reference_Bool_Exp>;
};


/** Canonical Albanian landmark and residence identities used for proximity and membership search. */
export type Place_ReferenceProvenanceArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "place_reference" */
export type Place_Reference_Aggregate = {
  __typename?: 'place_reference_aggregate';
  aggregate?: Maybe<Place_Reference_Aggregate_Fields>;
  nodes: Array<Place_Reference>;
};

export type Place_Reference_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Place_Reference_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Place_Reference_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Place_Reference_Aggregate_Bool_Exp_Count>;
};

export type Place_Reference_Aggregate_Bool_Exp_Bool_And = {
  arguments: Place_Reference_Select_Column_Place_Reference_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Place_Reference_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Place_Reference_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Place_Reference_Select_Column_Place_Reference_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Place_Reference_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Place_Reference_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Place_Reference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Place_Reference_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "place_reference" */
export type Place_Reference_Aggregate_Fields = {
  __typename?: 'place_reference_aggregate_fields';
  avg?: Maybe<Place_Reference_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Place_Reference_Max_Fields>;
  min?: Maybe<Place_Reference_Min_Fields>;
  stddev?: Maybe<Place_Reference_Stddev_Fields>;
  stddev_pop?: Maybe<Place_Reference_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Place_Reference_Stddev_Samp_Fields>;
  sum?: Maybe<Place_Reference_Sum_Fields>;
  var_pop?: Maybe<Place_Reference_Var_Pop_Fields>;
  var_samp?: Maybe<Place_Reference_Var_Samp_Fields>;
  variance?: Maybe<Place_Reference_Variance_Fields>;
};


/** aggregate fields of "place_reference" */
export type Place_Reference_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Place_Reference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "place_reference" */
export type Place_Reference_Aggregate_Order_By = {
  avg?: InputMaybe<Place_Reference_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Place_Reference_Max_Order_By>;
  min?: InputMaybe<Place_Reference_Min_Order_By>;
  stddev?: InputMaybe<Place_Reference_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Place_Reference_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Place_Reference_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Place_Reference_Sum_Order_By>;
  var_pop?: InputMaybe<Place_Reference_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Place_Reference_Var_Samp_Order_By>;
  variance?: InputMaybe<Place_Reference_Variance_Order_By>;
};

/** columns and relationships of "place_reference_alias" */
export type Place_Reference_Alias = {
  __typename?: 'place_reference_alias';
  alias: Scalars['String']['output'];
  confidence?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  language?: Maybe<Languages>;
  language_id?: Maybe<Scalars['Int']['output']>;
  normalized_alias: Scalars['String']['output'];
  /** An object relationship */
  place_reference: Place_Reference;
  place_reference_id: Scalars['uuid']['output'];
  source: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "place_reference_alias" */
export type Place_Reference_Alias_Aggregate = {
  __typename?: 'place_reference_alias_aggregate';
  aggregate?: Maybe<Place_Reference_Alias_Aggregate_Fields>;
  nodes: Array<Place_Reference_Alias>;
};

export type Place_Reference_Alias_Aggregate_Bool_Exp = {
  count?: InputMaybe<Place_Reference_Alias_Aggregate_Bool_Exp_Count>;
};

export type Place_Reference_Alias_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Place_Reference_Alias_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Place_Reference_Alias_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "place_reference_alias" */
export type Place_Reference_Alias_Aggregate_Fields = {
  __typename?: 'place_reference_alias_aggregate_fields';
  avg?: Maybe<Place_Reference_Alias_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Place_Reference_Alias_Max_Fields>;
  min?: Maybe<Place_Reference_Alias_Min_Fields>;
  stddev?: Maybe<Place_Reference_Alias_Stddev_Fields>;
  stddev_pop?: Maybe<Place_Reference_Alias_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Place_Reference_Alias_Stddev_Samp_Fields>;
  sum?: Maybe<Place_Reference_Alias_Sum_Fields>;
  var_pop?: Maybe<Place_Reference_Alias_Var_Pop_Fields>;
  var_samp?: Maybe<Place_Reference_Alias_Var_Samp_Fields>;
  variance?: Maybe<Place_Reference_Alias_Variance_Fields>;
};


/** aggregate fields of "place_reference_alias" */
export type Place_Reference_Alias_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Place_Reference_Alias_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "place_reference_alias" */
export type Place_Reference_Alias_Aggregate_Order_By = {
  avg?: InputMaybe<Place_Reference_Alias_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Place_Reference_Alias_Max_Order_By>;
  min?: InputMaybe<Place_Reference_Alias_Min_Order_By>;
  stddev?: InputMaybe<Place_Reference_Alias_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Place_Reference_Alias_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Place_Reference_Alias_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Place_Reference_Alias_Sum_Order_By>;
  var_pop?: InputMaybe<Place_Reference_Alias_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Place_Reference_Alias_Var_Samp_Order_By>;
  variance?: InputMaybe<Place_Reference_Alias_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "place_reference_alias" */
export type Place_Reference_Alias_Arr_Rel_Insert_Input = {
  data: Array<Place_Reference_Alias_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Place_Reference_Alias_On_Conflict>;
};

/** aggregate avg on columns */
export type Place_Reference_Alias_Avg_Fields = {
  __typename?: 'place_reference_alias_avg_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "place_reference_alias" */
export type Place_Reference_Alias_Avg_Order_By = {
  confidence?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "place_reference_alias". All fields are combined with a logical 'AND'. */
export type Place_Reference_Alias_Bool_Exp = {
  _and?: InputMaybe<Array<Place_Reference_Alias_Bool_Exp>>;
  _not?: InputMaybe<Place_Reference_Alias_Bool_Exp>;
  _or?: InputMaybe<Array<Place_Reference_Alias_Bool_Exp>>;
  alias?: InputMaybe<String_Comparison_Exp>;
  confidence?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<Languages_Bool_Exp>;
  language_id?: InputMaybe<Int_Comparison_Exp>;
  normalized_alias?: InputMaybe<String_Comparison_Exp>;
  place_reference?: InputMaybe<Place_Reference_Bool_Exp>;
  place_reference_id?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "place_reference_alias" */
export enum Place_Reference_Alias_Constraint {
  /** unique or primary key constraint on columns "normalized_alias", "place_reference_id" */
  PlaceReferenceAliasLanguageNeutralKey = 'place_reference_alias_language_neutral_key',
  /** unique or primary key constraint on columns "id" */
  PlaceReferenceAliasPkey = 'place_reference_alias_pkey',
  /** unique or primary key constraint on columns "language_id", "normalized_alias", "place_reference_id" */
  PlaceReferenceAliasPlaceReferenceIdNormalizedAliasLKey = 'place_reference_alias_place_reference_id_normalized_alias_l_key'
}

/** input type for incrementing numeric columns in table "place_reference_alias" */
export type Place_Reference_Alias_Inc_Input = {
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "place_reference_alias" */
export type Place_Reference_Alias_Insert_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Languages_Obj_Rel_Insert_Input>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  normalized_alias?: InputMaybe<Scalars['String']['input']>;
  place_reference?: InputMaybe<Place_Reference_Obj_Rel_Insert_Input>;
  place_reference_id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Place_Reference_Alias_Max_Fields = {
  __typename?: 'place_reference_alias_max_fields';
  alias?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  normalized_alias?: Maybe<Scalars['String']['output']>;
  place_reference_id?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "place_reference_alias" */
export type Place_Reference_Alias_Max_Order_By = {
  alias?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  normalized_alias?: InputMaybe<Order_By>;
  place_reference_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Place_Reference_Alias_Min_Fields = {
  __typename?: 'place_reference_alias_min_fields';
  alias?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  normalized_alias?: Maybe<Scalars['String']['output']>;
  place_reference_id?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "place_reference_alias" */
export type Place_Reference_Alias_Min_Order_By = {
  alias?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  normalized_alias?: InputMaybe<Order_By>;
  place_reference_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "place_reference_alias" */
export type Place_Reference_Alias_Mutation_Response = {
  __typename?: 'place_reference_alias_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Place_Reference_Alias>;
};

/** on_conflict condition type for table "place_reference_alias" */
export type Place_Reference_Alias_On_Conflict = {
  constraint: Place_Reference_Alias_Constraint;
  update_columns?: Array<Place_Reference_Alias_Update_Column>;
  where?: InputMaybe<Place_Reference_Alias_Bool_Exp>;
};

/** Ordering options when selecting data from "place_reference_alias". */
export type Place_Reference_Alias_Order_By = {
  alias?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Languages_Order_By>;
  language_id?: InputMaybe<Order_By>;
  normalized_alias?: InputMaybe<Order_By>;
  place_reference?: InputMaybe<Place_Reference_Order_By>;
  place_reference_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: place_reference_alias */
export type Place_Reference_Alias_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "place_reference_alias" */
export enum Place_Reference_Alias_Select_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  Confidence = 'confidence',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  NormalizedAlias = 'normalized_alias',
  /** column name */
  PlaceReferenceId = 'place_reference_id',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "place_reference_alias" */
export type Place_Reference_Alias_Set_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  normalized_alias?: InputMaybe<Scalars['String']['input']>;
  place_reference_id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Place_Reference_Alias_Stddev_Fields = {
  __typename?: 'place_reference_alias_stddev_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "place_reference_alias" */
export type Place_Reference_Alias_Stddev_Order_By = {
  confidence?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Place_Reference_Alias_Stddev_Pop_Fields = {
  __typename?: 'place_reference_alias_stddev_pop_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "place_reference_alias" */
export type Place_Reference_Alias_Stddev_Pop_Order_By = {
  confidence?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Place_Reference_Alias_Stddev_Samp_Fields = {
  __typename?: 'place_reference_alias_stddev_samp_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "place_reference_alias" */
export type Place_Reference_Alias_Stddev_Samp_Order_By = {
  confidence?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "place_reference_alias" */
export type Place_Reference_Alias_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Place_Reference_Alias_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Place_Reference_Alias_Stream_Cursor_Value_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  normalized_alias?: InputMaybe<Scalars['String']['input']>;
  place_reference_id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Place_Reference_Alias_Sum_Fields = {
  __typename?: 'place_reference_alias_sum_fields';
  confidence?: Maybe<Scalars['numeric']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "place_reference_alias" */
export type Place_Reference_Alias_Sum_Order_By = {
  confidence?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
};

/** update columns of table "place_reference_alias" */
export enum Place_Reference_Alias_Update_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  Confidence = 'confidence',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  NormalizedAlias = 'normalized_alias',
  /** column name */
  PlaceReferenceId = 'place_reference_id',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Place_Reference_Alias_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Place_Reference_Alias_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Place_Reference_Alias_Set_Input>;
  /** filter the rows which have to be updated */
  where: Place_Reference_Alias_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Place_Reference_Alias_Var_Pop_Fields = {
  __typename?: 'place_reference_alias_var_pop_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "place_reference_alias" */
export type Place_Reference_Alias_Var_Pop_Order_By = {
  confidence?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Place_Reference_Alias_Var_Samp_Fields = {
  __typename?: 'place_reference_alias_var_samp_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "place_reference_alias" */
export type Place_Reference_Alias_Var_Samp_Order_By = {
  confidence?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Place_Reference_Alias_Variance_Fields = {
  __typename?: 'place_reference_alias_variance_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "place_reference_alias" */
export type Place_Reference_Alias_Variance_Order_By = {
  confidence?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Place_Reference_Append_Input = {
  provenance?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "place_reference" */
export type Place_Reference_Arr_Rel_Insert_Input = {
  data: Array<Place_Reference_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Place_Reference_On_Conflict>;
};

/** aggregate avg on columns */
export type Place_Reference_Avg_Fields = {
  __typename?: 'place_reference_avg_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "place_reference" */
export type Place_Reference_Avg_Order_By = {
  confidence?: InputMaybe<Order_By>;
  default_radius_m?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "place_reference". All fields are combined with a logical 'AND'. */
export type Place_Reference_Bool_Exp = {
  _and?: InputMaybe<Array<Place_Reference_Bool_Exp>>;
  _not?: InputMaybe<Place_Reference_Bool_Exp>;
  _or?: InputMaybe<Array<Place_Reference_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  aliases?: InputMaybe<Place_Reference_Alias_Bool_Exp>;
  aliases_aggregate?: InputMaybe<Place_Reference_Alias_Aggregate_Bool_Exp>;
  canonical_name?: InputMaybe<String_Comparison_Exp>;
  center_location?: InputMaybe<Location_Bool_Exp>;
  center_location_id?: InputMaybe<Uuid_Comparison_Exp>;
  city?: InputMaybe<City_Bool_Exp>;
  city_id?: InputMaybe<Uuid_Comparison_Exp>;
  confidence?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  default_radius_m?: InputMaybe<Int_Comparison_Exp>;
  footprint?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_problematic?: InputMaybe<Boolean_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  legacy_city_zone?: InputMaybe<City_Zone_Bool_Exp>;
  legacy_city_zone_id?: InputMaybe<Uuid_Comparison_Exp>;
  normalized_name?: InputMaybe<String_Comparison_Exp>;
  parent_city_zone?: InputMaybe<City_Zone_Bool_Exp>;
  parent_city_zone_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_relations?: InputMaybe<Property_Place_Reference_Bool_Exp>;
  property_relations_aggregate?: InputMaybe<Property_Place_Reference_Aggregate_Bool_Exp>;
  provenance?: InputMaybe<Jsonb_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  provider_place_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "place_reference" */
export enum Place_Reference_Constraint {
  /** unique or primary key constraint on columns "legacy_city_zone_id" */
  PlaceReferenceLegacyCityZoneIdKey = 'place_reference_legacy_city_zone_id_key',
  /** unique or primary key constraint on columns "id" */
  PlaceReferencePkey = 'place_reference_pkey',
  /** unique or primary key constraint on columns "provider", "provider_place_id" */
  PlaceReferenceProviderProviderPlaceIdKey = 'place_reference_provider_provider_place_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Place_Reference_Delete_At_Path_Input = {
  provenance?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Place_Reference_Delete_Elem_Input = {
  provenance?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Place_Reference_Delete_Key_Input = {
  provenance?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "place_reference" */
export type Place_Reference_Inc_Input = {
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  default_radius_m?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "place_reference" */
export type Place_Reference_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  aliases?: InputMaybe<Place_Reference_Alias_Arr_Rel_Insert_Input>;
  canonical_name?: InputMaybe<Scalars['String']['input']>;
  center_location?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  center_location_id?: InputMaybe<Scalars['uuid']['input']>;
  city?: InputMaybe<City_Obj_Rel_Insert_Input>;
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  default_radius_m?: InputMaybe<Scalars['Int']['input']>;
  footprint?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_problematic?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  legacy_city_zone?: InputMaybe<City_Zone_Obj_Rel_Insert_Input>;
  /** Optional link to a historical POI-like city_zone row during non-destructive migration. */
  legacy_city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  normalized_name?: InputMaybe<Scalars['String']['input']>;
  parent_city_zone?: InputMaybe<City_Zone_Obj_Rel_Insert_Input>;
  parent_city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  property_relations?: InputMaybe<Property_Place_Reference_Arr_Rel_Insert_Input>;
  provenance?: InputMaybe<Scalars['jsonb']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_place_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Place_Reference_Max_Fields = {
  __typename?: 'place_reference_max_fields';
  canonical_name?: Maybe<Scalars['String']['output']>;
  center_location_id?: Maybe<Scalars['uuid']['output']>;
  city_id?: Maybe<Scalars['uuid']['output']>;
  confidence?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  default_radius_m?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  /** Optional link to a historical POI-like city_zone row during non-destructive migration. */
  legacy_city_zone_id?: Maybe<Scalars['uuid']['output']>;
  normalized_name?: Maybe<Scalars['String']['output']>;
  parent_city_zone_id?: Maybe<Scalars['uuid']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  provider_place_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "place_reference" */
export type Place_Reference_Max_Order_By = {
  canonical_name?: InputMaybe<Order_By>;
  center_location_id?: InputMaybe<Order_By>;
  city_id?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  default_radius_m?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  /** Optional link to a historical POI-like city_zone row during non-destructive migration. */
  legacy_city_zone_id?: InputMaybe<Order_By>;
  normalized_name?: InputMaybe<Order_By>;
  parent_city_zone_id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_place_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Place_Reference_Min_Fields = {
  __typename?: 'place_reference_min_fields';
  canonical_name?: Maybe<Scalars['String']['output']>;
  center_location_id?: Maybe<Scalars['uuid']['output']>;
  city_id?: Maybe<Scalars['uuid']['output']>;
  confidence?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  default_radius_m?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  /** Optional link to a historical POI-like city_zone row during non-destructive migration. */
  legacy_city_zone_id?: Maybe<Scalars['uuid']['output']>;
  normalized_name?: Maybe<Scalars['String']['output']>;
  parent_city_zone_id?: Maybe<Scalars['uuid']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  provider_place_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "place_reference" */
export type Place_Reference_Min_Order_By = {
  canonical_name?: InputMaybe<Order_By>;
  center_location_id?: InputMaybe<Order_By>;
  city_id?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  default_radius_m?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  /** Optional link to a historical POI-like city_zone row during non-destructive migration. */
  legacy_city_zone_id?: InputMaybe<Order_By>;
  normalized_name?: InputMaybe<Order_By>;
  parent_city_zone_id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_place_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "place_reference" */
export type Place_Reference_Mutation_Response = {
  __typename?: 'place_reference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Place_Reference>;
};

/** input type for inserting object relation for remote table "place_reference" */
export type Place_Reference_Obj_Rel_Insert_Input = {
  data: Place_Reference_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Place_Reference_On_Conflict>;
};

/** on_conflict condition type for table "place_reference" */
export type Place_Reference_On_Conflict = {
  constraint: Place_Reference_Constraint;
  update_columns?: Array<Place_Reference_Update_Column>;
  where?: InputMaybe<Place_Reference_Bool_Exp>;
};

/** Ordering options when selecting data from "place_reference". */
export type Place_Reference_Order_By = {
  active?: InputMaybe<Order_By>;
  aliases_aggregate?: InputMaybe<Place_Reference_Alias_Aggregate_Order_By>;
  canonical_name?: InputMaybe<Order_By>;
  center_location?: InputMaybe<Location_Order_By>;
  center_location_id?: InputMaybe<Order_By>;
  city?: InputMaybe<City_Order_By>;
  city_id?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  default_radius_m?: InputMaybe<Order_By>;
  footprint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_problematic?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  legacy_city_zone?: InputMaybe<City_Zone_Order_By>;
  legacy_city_zone_id?: InputMaybe<Order_By>;
  normalized_name?: InputMaybe<Order_By>;
  parent_city_zone?: InputMaybe<City_Zone_Order_By>;
  parent_city_zone_id?: InputMaybe<Order_By>;
  property_relations_aggregate?: InputMaybe<Property_Place_Reference_Aggregate_Order_By>;
  provenance?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_place_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: place_reference */
export type Place_Reference_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Place_Reference_Prepend_Input = {
  provenance?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Unreviewed or rejected pipeline place candidates. Only approved records are promoted into place_reference. */
export type Place_Reference_Proposal = {
  __typename?: 'place_reference_proposal';
  aliases: Scalars['jsonb']['output'];
  /** Stable pipeline deduplication key. It must be provider-based when available, otherwise city, kind, normalized name, parent area, and rounded center. */
  candidate_key: Scalars['String']['output'];
  canonical_name: Scalars['String']['output'];
  /** An object relationship */
  canonical_place_reference?: Maybe<Place_Reference>;
  canonical_place_reference_id?: Maybe<Scalars['uuid']['output']>;
  center_lat?: Maybe<Scalars['numeric']['output']>;
  center_lng?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  city?: Maybe<City>;
  city_id?: Maybe<Scalars['uuid']['output']>;
  confidence?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  default_radius_m?: Maybe<Scalars['Int']['output']>;
  evidence: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  kind: Scalars['String']['output'];
  /** An object relationship */
  merged_into_proposal?: Maybe<Place_Reference_Proposal>;
  merged_into_proposal_id?: Maybe<Scalars['uuid']['output']>;
  normalized_name: Scalars['String']['output'];
  /** An object relationship */
  parent_city_zone?: Maybe<City_Zone>;
  parent_city_zone_id?: Maybe<Scalars['uuid']['output']>;
  provenance: Scalars['jsonb']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  provider_place_id?: Maybe<Scalars['String']['output']>;
  review_reason?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  suggested_footprint?: Maybe<Scalars['geometry']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** Unreviewed or rejected pipeline place candidates. Only approved records are promoted into place_reference. */
export type Place_Reference_ProposalAliasesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Unreviewed or rejected pipeline place candidates. Only approved records are promoted into place_reference. */
export type Place_Reference_ProposalEvidenceArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Unreviewed or rejected pipeline place candidates. Only approved records are promoted into place_reference. */
export type Place_Reference_ProposalProvenanceArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "place_reference_proposal" */
export type Place_Reference_Proposal_Aggregate = {
  __typename?: 'place_reference_proposal_aggregate';
  aggregate?: Maybe<Place_Reference_Proposal_Aggregate_Fields>;
  nodes: Array<Place_Reference_Proposal>;
};

/** aggregate fields of "place_reference_proposal" */
export type Place_Reference_Proposal_Aggregate_Fields = {
  __typename?: 'place_reference_proposal_aggregate_fields';
  avg?: Maybe<Place_Reference_Proposal_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Place_Reference_Proposal_Max_Fields>;
  min?: Maybe<Place_Reference_Proposal_Min_Fields>;
  stddev?: Maybe<Place_Reference_Proposal_Stddev_Fields>;
  stddev_pop?: Maybe<Place_Reference_Proposal_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Place_Reference_Proposal_Stddev_Samp_Fields>;
  sum?: Maybe<Place_Reference_Proposal_Sum_Fields>;
  var_pop?: Maybe<Place_Reference_Proposal_Var_Pop_Fields>;
  var_samp?: Maybe<Place_Reference_Proposal_Var_Samp_Fields>;
  variance?: Maybe<Place_Reference_Proposal_Variance_Fields>;
};


/** aggregate fields of "place_reference_proposal" */
export type Place_Reference_Proposal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Place_Reference_Proposal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Place_Reference_Proposal_Append_Input = {
  aliases?: InputMaybe<Scalars['jsonb']['input']>;
  evidence?: InputMaybe<Scalars['jsonb']['input']>;
  provenance?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Place_Reference_Proposal_Avg_Fields = {
  __typename?: 'place_reference_proposal_avg_fields';
  center_lat?: Maybe<Scalars['Float']['output']>;
  center_lng?: Maybe<Scalars['Float']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "place_reference_proposal". All fields are combined with a logical 'AND'. */
export type Place_Reference_Proposal_Bool_Exp = {
  _and?: InputMaybe<Array<Place_Reference_Proposal_Bool_Exp>>;
  _not?: InputMaybe<Place_Reference_Proposal_Bool_Exp>;
  _or?: InputMaybe<Array<Place_Reference_Proposal_Bool_Exp>>;
  aliases?: InputMaybe<Jsonb_Comparison_Exp>;
  candidate_key?: InputMaybe<String_Comparison_Exp>;
  canonical_name?: InputMaybe<String_Comparison_Exp>;
  canonical_place_reference?: InputMaybe<Place_Reference_Bool_Exp>;
  canonical_place_reference_id?: InputMaybe<Uuid_Comparison_Exp>;
  center_lat?: InputMaybe<Numeric_Comparison_Exp>;
  center_lng?: InputMaybe<Numeric_Comparison_Exp>;
  city?: InputMaybe<City_Bool_Exp>;
  city_id?: InputMaybe<Uuid_Comparison_Exp>;
  confidence?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  default_radius_m?: InputMaybe<Int_Comparison_Exp>;
  evidence?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  merged_into_proposal?: InputMaybe<Place_Reference_Proposal_Bool_Exp>;
  merged_into_proposal_id?: InputMaybe<Uuid_Comparison_Exp>;
  normalized_name?: InputMaybe<String_Comparison_Exp>;
  parent_city_zone?: InputMaybe<City_Zone_Bool_Exp>;
  parent_city_zone_id?: InputMaybe<Uuid_Comparison_Exp>;
  provenance?: InputMaybe<Jsonb_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  provider_place_id?: InputMaybe<String_Comparison_Exp>;
  review_reason?: InputMaybe<String_Comparison_Exp>;
  reviewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewed_by?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  suggested_footprint?: InputMaybe<Geometry_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "place_reference_proposal" */
export enum Place_Reference_Proposal_Constraint {
  /** unique or primary key constraint on columns "candidate_key" */
  PlaceReferenceProposalCandidateKeyKey = 'place_reference_proposal_candidate_key_key',
  /** unique or primary key constraint on columns "id" */
  PlaceReferenceProposalPkey = 'place_reference_proposal_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Place_Reference_Proposal_Delete_At_Path_Input = {
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  evidence?: InputMaybe<Array<Scalars['String']['input']>>;
  provenance?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Place_Reference_Proposal_Delete_Elem_Input = {
  aliases?: InputMaybe<Scalars['Int']['input']>;
  evidence?: InputMaybe<Scalars['Int']['input']>;
  provenance?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Place_Reference_Proposal_Delete_Key_Input = {
  aliases?: InputMaybe<Scalars['String']['input']>;
  evidence?: InputMaybe<Scalars['String']['input']>;
  provenance?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "place_reference_proposal" */
export type Place_Reference_Proposal_Inc_Input = {
  center_lat?: InputMaybe<Scalars['numeric']['input']>;
  center_lng?: InputMaybe<Scalars['numeric']['input']>;
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  default_radius_m?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "place_reference_proposal" */
export type Place_Reference_Proposal_Insert_Input = {
  aliases?: InputMaybe<Scalars['jsonb']['input']>;
  /** Stable pipeline deduplication key. It must be provider-based when available, otherwise city, kind, normalized name, parent area, and rounded center. */
  candidate_key?: InputMaybe<Scalars['String']['input']>;
  canonical_name?: InputMaybe<Scalars['String']['input']>;
  canonical_place_reference?: InputMaybe<Place_Reference_Obj_Rel_Insert_Input>;
  canonical_place_reference_id?: InputMaybe<Scalars['uuid']['input']>;
  center_lat?: InputMaybe<Scalars['numeric']['input']>;
  center_lng?: InputMaybe<Scalars['numeric']['input']>;
  city?: InputMaybe<City_Obj_Rel_Insert_Input>;
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  default_radius_m?: InputMaybe<Scalars['Int']['input']>;
  evidence?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  merged_into_proposal?: InputMaybe<Place_Reference_Proposal_Obj_Rel_Insert_Input>;
  merged_into_proposal_id?: InputMaybe<Scalars['uuid']['input']>;
  normalized_name?: InputMaybe<Scalars['String']['input']>;
  parent_city_zone?: InputMaybe<City_Zone_Obj_Rel_Insert_Input>;
  parent_city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  provenance?: InputMaybe<Scalars['jsonb']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_place_id?: InputMaybe<Scalars['String']['input']>;
  review_reason?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suggested_footprint?: InputMaybe<Scalars['geometry']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Place_Reference_Proposal_Max_Fields = {
  __typename?: 'place_reference_proposal_max_fields';
  /** Stable pipeline deduplication key. It must be provider-based when available, otherwise city, kind, normalized name, parent area, and rounded center. */
  candidate_key?: Maybe<Scalars['String']['output']>;
  canonical_name?: Maybe<Scalars['String']['output']>;
  canonical_place_reference_id?: Maybe<Scalars['uuid']['output']>;
  center_lat?: Maybe<Scalars['numeric']['output']>;
  center_lng?: Maybe<Scalars['numeric']['output']>;
  city_id?: Maybe<Scalars['uuid']['output']>;
  confidence?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  default_radius_m?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  merged_into_proposal_id?: Maybe<Scalars['uuid']['output']>;
  normalized_name?: Maybe<Scalars['String']['output']>;
  parent_city_zone_id?: Maybe<Scalars['uuid']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  provider_place_id?: Maybe<Scalars['String']['output']>;
  review_reason?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Place_Reference_Proposal_Min_Fields = {
  __typename?: 'place_reference_proposal_min_fields';
  /** Stable pipeline deduplication key. It must be provider-based when available, otherwise city, kind, normalized name, parent area, and rounded center. */
  candidate_key?: Maybe<Scalars['String']['output']>;
  canonical_name?: Maybe<Scalars['String']['output']>;
  canonical_place_reference_id?: Maybe<Scalars['uuid']['output']>;
  center_lat?: Maybe<Scalars['numeric']['output']>;
  center_lng?: Maybe<Scalars['numeric']['output']>;
  city_id?: Maybe<Scalars['uuid']['output']>;
  confidence?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  default_radius_m?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  merged_into_proposal_id?: Maybe<Scalars['uuid']['output']>;
  normalized_name?: Maybe<Scalars['String']['output']>;
  parent_city_zone_id?: Maybe<Scalars['uuid']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  provider_place_id?: Maybe<Scalars['String']['output']>;
  review_reason?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "place_reference_proposal" */
export type Place_Reference_Proposal_Mutation_Response = {
  __typename?: 'place_reference_proposal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Place_Reference_Proposal>;
};

/** input type for inserting object relation for remote table "place_reference_proposal" */
export type Place_Reference_Proposal_Obj_Rel_Insert_Input = {
  data: Place_Reference_Proposal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Place_Reference_Proposal_On_Conflict>;
};

/** on_conflict condition type for table "place_reference_proposal" */
export type Place_Reference_Proposal_On_Conflict = {
  constraint: Place_Reference_Proposal_Constraint;
  update_columns?: Array<Place_Reference_Proposal_Update_Column>;
  where?: InputMaybe<Place_Reference_Proposal_Bool_Exp>;
};

/** Ordering options when selecting data from "place_reference_proposal". */
export type Place_Reference_Proposal_Order_By = {
  aliases?: InputMaybe<Order_By>;
  candidate_key?: InputMaybe<Order_By>;
  canonical_name?: InputMaybe<Order_By>;
  canonical_place_reference?: InputMaybe<Place_Reference_Order_By>;
  canonical_place_reference_id?: InputMaybe<Order_By>;
  center_lat?: InputMaybe<Order_By>;
  center_lng?: InputMaybe<Order_By>;
  city?: InputMaybe<City_Order_By>;
  city_id?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  default_radius_m?: InputMaybe<Order_By>;
  evidence?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  merged_into_proposal?: InputMaybe<Place_Reference_Proposal_Order_By>;
  merged_into_proposal_id?: InputMaybe<Order_By>;
  normalized_name?: InputMaybe<Order_By>;
  parent_city_zone?: InputMaybe<City_Zone_Order_By>;
  parent_city_zone_id?: InputMaybe<Order_By>;
  provenance?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_place_id?: InputMaybe<Order_By>;
  review_reason?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  suggested_footprint?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: place_reference_proposal */
export type Place_Reference_Proposal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Place_Reference_Proposal_Prepend_Input = {
  aliases?: InputMaybe<Scalars['jsonb']['input']>;
  evidence?: InputMaybe<Scalars['jsonb']['input']>;
  provenance?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "place_reference_proposal" */
export enum Place_Reference_Proposal_Select_Column {
  /** column name */
  Aliases = 'aliases',
  /** column name */
  CandidateKey = 'candidate_key',
  /** column name */
  CanonicalName = 'canonical_name',
  /** column name */
  CanonicalPlaceReferenceId = 'canonical_place_reference_id',
  /** column name */
  CenterLat = 'center_lat',
  /** column name */
  CenterLng = 'center_lng',
  /** column name */
  CityId = 'city_id',
  /** column name */
  Confidence = 'confidence',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultRadiusM = 'default_radius_m',
  /** column name */
  Evidence = 'evidence',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  MergedIntoProposalId = 'merged_into_proposal_id',
  /** column name */
  NormalizedName = 'normalized_name',
  /** column name */
  ParentCityZoneId = 'parent_city_zone_id',
  /** column name */
  Provenance = 'provenance',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderPlaceId = 'provider_place_id',
  /** column name */
  ReviewReason = 'review_reason',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedBy = 'reviewed_by',
  /** column name */
  Status = 'status',
  /** column name */
  SuggestedFootprint = 'suggested_footprint',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "place_reference_proposal" */
export type Place_Reference_Proposal_Set_Input = {
  aliases?: InputMaybe<Scalars['jsonb']['input']>;
  /** Stable pipeline deduplication key. It must be provider-based when available, otherwise city, kind, normalized name, parent area, and rounded center. */
  candidate_key?: InputMaybe<Scalars['String']['input']>;
  canonical_name?: InputMaybe<Scalars['String']['input']>;
  canonical_place_reference_id?: InputMaybe<Scalars['uuid']['input']>;
  center_lat?: InputMaybe<Scalars['numeric']['input']>;
  center_lng?: InputMaybe<Scalars['numeric']['input']>;
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  default_radius_m?: InputMaybe<Scalars['Int']['input']>;
  evidence?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  merged_into_proposal_id?: InputMaybe<Scalars['uuid']['input']>;
  normalized_name?: InputMaybe<Scalars['String']['input']>;
  parent_city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  provenance?: InputMaybe<Scalars['jsonb']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_place_id?: InputMaybe<Scalars['String']['input']>;
  review_reason?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suggested_footprint?: InputMaybe<Scalars['geometry']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Place_Reference_Proposal_Stddev_Fields = {
  __typename?: 'place_reference_proposal_stddev_fields';
  center_lat?: Maybe<Scalars['Float']['output']>;
  center_lng?: Maybe<Scalars['Float']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Place_Reference_Proposal_Stddev_Pop_Fields = {
  __typename?: 'place_reference_proposal_stddev_pop_fields';
  center_lat?: Maybe<Scalars['Float']['output']>;
  center_lng?: Maybe<Scalars['Float']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Place_Reference_Proposal_Stddev_Samp_Fields = {
  __typename?: 'place_reference_proposal_stddev_samp_fields';
  center_lat?: Maybe<Scalars['Float']['output']>;
  center_lng?: Maybe<Scalars['Float']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "place_reference_proposal" */
export type Place_Reference_Proposal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Place_Reference_Proposal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Place_Reference_Proposal_Stream_Cursor_Value_Input = {
  aliases?: InputMaybe<Scalars['jsonb']['input']>;
  /** Stable pipeline deduplication key. It must be provider-based when available, otherwise city, kind, normalized name, parent area, and rounded center. */
  candidate_key?: InputMaybe<Scalars['String']['input']>;
  canonical_name?: InputMaybe<Scalars['String']['input']>;
  canonical_place_reference_id?: InputMaybe<Scalars['uuid']['input']>;
  center_lat?: InputMaybe<Scalars['numeric']['input']>;
  center_lng?: InputMaybe<Scalars['numeric']['input']>;
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  default_radius_m?: InputMaybe<Scalars['Int']['input']>;
  evidence?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  merged_into_proposal_id?: InputMaybe<Scalars['uuid']['input']>;
  normalized_name?: InputMaybe<Scalars['String']['input']>;
  parent_city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  provenance?: InputMaybe<Scalars['jsonb']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_place_id?: InputMaybe<Scalars['String']['input']>;
  review_reason?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suggested_footprint?: InputMaybe<Scalars['geometry']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Place_Reference_Proposal_Sum_Fields = {
  __typename?: 'place_reference_proposal_sum_fields';
  center_lat?: Maybe<Scalars['numeric']['output']>;
  center_lng?: Maybe<Scalars['numeric']['output']>;
  confidence?: Maybe<Scalars['numeric']['output']>;
  default_radius_m?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "place_reference_proposal" */
export enum Place_Reference_Proposal_Update_Column {
  /** column name */
  Aliases = 'aliases',
  /** column name */
  CandidateKey = 'candidate_key',
  /** column name */
  CanonicalName = 'canonical_name',
  /** column name */
  CanonicalPlaceReferenceId = 'canonical_place_reference_id',
  /** column name */
  CenterLat = 'center_lat',
  /** column name */
  CenterLng = 'center_lng',
  /** column name */
  CityId = 'city_id',
  /** column name */
  Confidence = 'confidence',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultRadiusM = 'default_radius_m',
  /** column name */
  Evidence = 'evidence',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  MergedIntoProposalId = 'merged_into_proposal_id',
  /** column name */
  NormalizedName = 'normalized_name',
  /** column name */
  ParentCityZoneId = 'parent_city_zone_id',
  /** column name */
  Provenance = 'provenance',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderPlaceId = 'provider_place_id',
  /** column name */
  ReviewReason = 'review_reason',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedBy = 'reviewed_by',
  /** column name */
  Status = 'status',
  /** column name */
  SuggestedFootprint = 'suggested_footprint',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Place_Reference_Proposal_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Place_Reference_Proposal_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Place_Reference_Proposal_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Place_Reference_Proposal_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Place_Reference_Proposal_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Place_Reference_Proposal_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Place_Reference_Proposal_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Place_Reference_Proposal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Place_Reference_Proposal_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Place_Reference_Proposal_Var_Pop_Fields = {
  __typename?: 'place_reference_proposal_var_pop_fields';
  center_lat?: Maybe<Scalars['Float']['output']>;
  center_lng?: Maybe<Scalars['Float']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Place_Reference_Proposal_Var_Samp_Fields = {
  __typename?: 'place_reference_proposal_var_samp_fields';
  center_lat?: Maybe<Scalars['Float']['output']>;
  center_lng?: Maybe<Scalars['Float']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Place_Reference_Proposal_Variance_Fields = {
  __typename?: 'place_reference_proposal_variance_fields';
  center_lat?: Maybe<Scalars['Float']['output']>;
  center_lng?: Maybe<Scalars['Float']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "place_reference" */
export enum Place_Reference_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CanonicalName = 'canonical_name',
  /** column name */
  CenterLocationId = 'center_location_id',
  /** column name */
  CityId = 'city_id',
  /** column name */
  Confidence = 'confidence',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultRadiusM = 'default_radius_m',
  /** column name */
  Footprint = 'footprint',
  /** column name */
  Id = 'id',
  /** column name */
  IsProblematic = 'is_problematic',
  /** column name */
  Kind = 'kind',
  /** column name */
  LegacyCityZoneId = 'legacy_city_zone_id',
  /** column name */
  NormalizedName = 'normalized_name',
  /** column name */
  ParentCityZoneId = 'parent_city_zone_id',
  /** column name */
  Provenance = 'provenance',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderPlaceId = 'provider_place_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "place_reference_aggregate_bool_exp_bool_and_arguments_columns" columns of table "place_reference" */
export enum Place_Reference_Select_Column_Place_Reference_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  IsProblematic = 'is_problematic'
}

/** select "place_reference_aggregate_bool_exp_bool_or_arguments_columns" columns of table "place_reference" */
export enum Place_Reference_Select_Column_Place_Reference_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  IsProblematic = 'is_problematic'
}

/** input type for updating data in table "place_reference" */
export type Place_Reference_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_name?: InputMaybe<Scalars['String']['input']>;
  center_location_id?: InputMaybe<Scalars['uuid']['input']>;
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  default_radius_m?: InputMaybe<Scalars['Int']['input']>;
  footprint?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_problematic?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Optional link to a historical POI-like city_zone row during non-destructive migration. */
  legacy_city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  normalized_name?: InputMaybe<Scalars['String']['input']>;
  parent_city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  provenance?: InputMaybe<Scalars['jsonb']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_place_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Place_Reference_Stddev_Fields = {
  __typename?: 'place_reference_stddev_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "place_reference" */
export type Place_Reference_Stddev_Order_By = {
  confidence?: InputMaybe<Order_By>;
  default_radius_m?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Place_Reference_Stddev_Pop_Fields = {
  __typename?: 'place_reference_stddev_pop_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "place_reference" */
export type Place_Reference_Stddev_Pop_Order_By = {
  confidence?: InputMaybe<Order_By>;
  default_radius_m?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Place_Reference_Stddev_Samp_Fields = {
  __typename?: 'place_reference_stddev_samp_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "place_reference" */
export type Place_Reference_Stddev_Samp_Order_By = {
  confidence?: InputMaybe<Order_By>;
  default_radius_m?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "place_reference" */
export type Place_Reference_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Place_Reference_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Place_Reference_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_name?: InputMaybe<Scalars['String']['input']>;
  center_location_id?: InputMaybe<Scalars['uuid']['input']>;
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  default_radius_m?: InputMaybe<Scalars['Int']['input']>;
  footprint?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_problematic?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Optional link to a historical POI-like city_zone row during non-destructive migration. */
  legacy_city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  normalized_name?: InputMaybe<Scalars['String']['input']>;
  parent_city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  provenance?: InputMaybe<Scalars['jsonb']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_place_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Place_Reference_Sum_Fields = {
  __typename?: 'place_reference_sum_fields';
  confidence?: Maybe<Scalars['numeric']['output']>;
  default_radius_m?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "place_reference" */
export type Place_Reference_Sum_Order_By = {
  confidence?: InputMaybe<Order_By>;
  default_radius_m?: InputMaybe<Order_By>;
};

/** update columns of table "place_reference" */
export enum Place_Reference_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CanonicalName = 'canonical_name',
  /** column name */
  CenterLocationId = 'center_location_id',
  /** column name */
  CityId = 'city_id',
  /** column name */
  Confidence = 'confidence',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultRadiusM = 'default_radius_m',
  /** column name */
  Footprint = 'footprint',
  /** column name */
  Id = 'id',
  /** column name */
  IsProblematic = 'is_problematic',
  /** column name */
  Kind = 'kind',
  /** column name */
  LegacyCityZoneId = 'legacy_city_zone_id',
  /** column name */
  NormalizedName = 'normalized_name',
  /** column name */
  ParentCityZoneId = 'parent_city_zone_id',
  /** column name */
  Provenance = 'provenance',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderPlaceId = 'provider_place_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Place_Reference_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Place_Reference_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Place_Reference_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Place_Reference_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Place_Reference_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Place_Reference_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Place_Reference_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Place_Reference_Set_Input>;
  /** filter the rows which have to be updated */
  where: Place_Reference_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Place_Reference_Var_Pop_Fields = {
  __typename?: 'place_reference_var_pop_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "place_reference" */
export type Place_Reference_Var_Pop_Order_By = {
  confidence?: InputMaybe<Order_By>;
  default_radius_m?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Place_Reference_Var_Samp_Fields = {
  __typename?: 'place_reference_var_samp_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "place_reference" */
export type Place_Reference_Var_Samp_Order_By = {
  confidence?: InputMaybe<Order_By>;
  default_radius_m?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Place_Reference_Variance_Fields = {
  __typename?: 'place_reference_variance_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  default_radius_m?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "place_reference" */
export type Place_Reference_Variance_Order_By = {
  confidence?: InputMaybe<Order_By>;
  default_radius_m?: InputMaybe<Order_By>;
};

/** columns and relationships of "plan" */
export type Plan = {
  __typename?: 'plan';
  active: Scalars['Boolean']['output'];
  amount: Scalars['numeric']['output'];
  currency?: Maybe<Main_Currency_Enum>;
  description: Scalars['String']['output'];
  duration_in_days?: Maybe<Scalars['Int']['output']>;
  free_sponsored_posts?: Maybe<Scalars['Int']['output']>;
  free_trial?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  lookup_key?: Maybe<Scalars['String']['output']>;
  min_members?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  number_of_posts?: Maybe<Scalars['Int']['output']>;
  number_of_prompts?: Maybe<Scalars['Int']['output']>;
  number_of_social_channels?: Maybe<Scalars['Int']['output']>;
  number_of_social_posts?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  orders: Array<Order>;
  /** An aggregate relationship */
  orders_aggregate: Order_Aggregate;
  organization_type?: Maybe<Organization_Type_Enum>;
  self_service?: Maybe<Scalars['Boolean']['output']>;
  stripe_price_id?: Maybe<Scalars['String']['output']>;
  stripe_product_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Plan_Type_Enum>;
};


/** columns and relationships of "plan" */
export type PlanOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "plan" */
export type PlanOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};

/** aggregated selection of "plan" */
export type Plan_Aggregate = {
  __typename?: 'plan_aggregate';
  aggregate?: Maybe<Plan_Aggregate_Fields>;
  nodes: Array<Plan>;
};

/** aggregate fields of "plan" */
export type Plan_Aggregate_Fields = {
  __typename?: 'plan_aggregate_fields';
  avg?: Maybe<Plan_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Plan_Max_Fields>;
  min?: Maybe<Plan_Min_Fields>;
  stddev?: Maybe<Plan_Stddev_Fields>;
  stddev_pop?: Maybe<Plan_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plan_Stddev_Samp_Fields>;
  sum?: Maybe<Plan_Sum_Fields>;
  var_pop?: Maybe<Plan_Var_Pop_Fields>;
  var_samp?: Maybe<Plan_Var_Samp_Fields>;
  variance?: Maybe<Plan_Variance_Fields>;
};


/** aggregate fields of "plan" */
export type Plan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Plan_Avg_Fields = {
  __typename?: 'plan_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
  free_sponsored_posts?: Maybe<Scalars['Float']['output']>;
  min_members?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_prompts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "plan". All fields are combined with a logical 'AND'. */
export type Plan_Bool_Exp = {
  _and?: InputMaybe<Array<Plan_Bool_Exp>>;
  _not?: InputMaybe<Plan_Bool_Exp>;
  _or?: InputMaybe<Array<Plan_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  currency?: InputMaybe<Main_Currency_Enum_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  duration_in_days?: InputMaybe<Int_Comparison_Exp>;
  free_sponsored_posts?: InputMaybe<Int_Comparison_Exp>;
  free_trial?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lookup_key?: InputMaybe<String_Comparison_Exp>;
  min_members?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number_of_posts?: InputMaybe<Int_Comparison_Exp>;
  number_of_prompts?: InputMaybe<Int_Comparison_Exp>;
  number_of_social_channels?: InputMaybe<Int_Comparison_Exp>;
  number_of_social_posts?: InputMaybe<Int_Comparison_Exp>;
  orders?: InputMaybe<Order_Bool_Exp>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  organization_type?: InputMaybe<Organization_Type_Enum_Comparison_Exp>;
  self_service?: InputMaybe<Boolean_Comparison_Exp>;
  stripe_price_id?: InputMaybe<String_Comparison_Exp>;
  stripe_product_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Plan_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "plan" */
export enum Plan_Constraint {
  /** unique or primary key constraint on columns "id" */
  MembershipPackagePkey = 'membership_package_pkey',
  /** unique or primary key constraint on columns "stripe_product_id", "stripe_price_id" */
  PlanStripeProductIdStripePriceIdKey = 'plan_stripe_product_id_stripe_price_id_key'
}

/** input type for incrementing numeric columns in table "plan" */
export type Plan_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  duration_in_days?: InputMaybe<Scalars['Int']['input']>;
  free_sponsored_posts?: InputMaybe<Scalars['Int']['input']>;
  min_members?: InputMaybe<Scalars['Int']['input']>;
  number_of_posts?: InputMaybe<Scalars['Int']['input']>;
  number_of_prompts?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_channels?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_posts?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "plan" */
export type Plan_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  currency?: InputMaybe<Main_Currency_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration_in_days?: InputMaybe<Scalars['Int']['input']>;
  free_sponsored_posts?: InputMaybe<Scalars['Int']['input']>;
  free_trial?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookup_key?: InputMaybe<Scalars['String']['input']>;
  min_members?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number_of_posts?: InputMaybe<Scalars['Int']['input']>;
  number_of_prompts?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_channels?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_posts?: InputMaybe<Scalars['Int']['input']>;
  orders?: InputMaybe<Order_Arr_Rel_Insert_Input>;
  organization_type?: InputMaybe<Organization_Type_Enum>;
  self_service?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_price_id?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Plan_Type_Enum>;
};

/** aggregate max on columns */
export type Plan_Max_Fields = {
  __typename?: 'plan_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration_in_days?: Maybe<Scalars['Int']['output']>;
  free_sponsored_posts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lookup_key?: Maybe<Scalars['String']['output']>;
  min_members?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number_of_posts?: Maybe<Scalars['Int']['output']>;
  number_of_prompts?: Maybe<Scalars['Int']['output']>;
  number_of_social_channels?: Maybe<Scalars['Int']['output']>;
  number_of_social_posts?: Maybe<Scalars['Int']['output']>;
  stripe_price_id?: Maybe<Scalars['String']['output']>;
  stripe_product_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Plan_Min_Fields = {
  __typename?: 'plan_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration_in_days?: Maybe<Scalars['Int']['output']>;
  free_sponsored_posts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lookup_key?: Maybe<Scalars['String']['output']>;
  min_members?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number_of_posts?: Maybe<Scalars['Int']['output']>;
  number_of_prompts?: Maybe<Scalars['Int']['output']>;
  number_of_social_channels?: Maybe<Scalars['Int']['output']>;
  number_of_social_posts?: Maybe<Scalars['Int']['output']>;
  stripe_price_id?: Maybe<Scalars['String']['output']>;
  stripe_product_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "plan" */
export type Plan_Mutation_Response = {
  __typename?: 'plan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Plan>;
};

/** input type for inserting object relation for remote table "plan" */
export type Plan_Obj_Rel_Insert_Input = {
  data: Plan_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Plan_On_Conflict>;
};

/** on_conflict condition type for table "plan" */
export type Plan_On_Conflict = {
  constraint: Plan_Constraint;
  update_columns?: Array<Plan_Update_Column>;
  where?: InputMaybe<Plan_Bool_Exp>;
};

/** Ordering options when selecting data from "plan". */
export type Plan_Order_By = {
  active?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration_in_days?: InputMaybe<Order_By>;
  free_sponsored_posts?: InputMaybe<Order_By>;
  free_trial?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lookup_key?: InputMaybe<Order_By>;
  min_members?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number_of_posts?: InputMaybe<Order_By>;
  number_of_prompts?: InputMaybe<Order_By>;
  number_of_social_channels?: InputMaybe<Order_By>;
  number_of_social_posts?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  organization_type?: InputMaybe<Order_By>;
  self_service?: InputMaybe<Order_By>;
  stripe_price_id?: InputMaybe<Order_By>;
  stripe_product_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plan */
export type Plan_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "plan" */
export enum Plan_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Amount = 'amount',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DurationInDays = 'duration_in_days',
  /** column name */
  FreeSponsoredPosts = 'free_sponsored_posts',
  /** column name */
  FreeTrial = 'free_trial',
  /** column name */
  Id = 'id',
  /** column name */
  LookupKey = 'lookup_key',
  /** column name */
  MinMembers = 'min_members',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfPosts = 'number_of_posts',
  /** column name */
  NumberOfPrompts = 'number_of_prompts',
  /** column name */
  NumberOfSocialChannels = 'number_of_social_channels',
  /** column name */
  NumberOfSocialPosts = 'number_of_social_posts',
  /** column name */
  OrganizationType = 'organization_type',
  /** column name */
  SelfService = 'self_service',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "plan" */
export type Plan_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  currency?: InputMaybe<Main_Currency_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration_in_days?: InputMaybe<Scalars['Int']['input']>;
  free_sponsored_posts?: InputMaybe<Scalars['Int']['input']>;
  free_trial?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookup_key?: InputMaybe<Scalars['String']['input']>;
  min_members?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number_of_posts?: InputMaybe<Scalars['Int']['input']>;
  number_of_prompts?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_channels?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_posts?: InputMaybe<Scalars['Int']['input']>;
  organization_type?: InputMaybe<Organization_Type_Enum>;
  self_service?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_price_id?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Plan_Type_Enum>;
};

/** aggregate stddev on columns */
export type Plan_Stddev_Fields = {
  __typename?: 'plan_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
  free_sponsored_posts?: Maybe<Scalars['Float']['output']>;
  min_members?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_prompts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Plan_Stddev_Pop_Fields = {
  __typename?: 'plan_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
  free_sponsored_posts?: Maybe<Scalars['Float']['output']>;
  min_members?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_prompts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Plan_Stddev_Samp_Fields = {
  __typename?: 'plan_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
  free_sponsored_posts?: Maybe<Scalars['Float']['output']>;
  min_members?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_prompts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "plan" */
export type Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plan_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  currency?: InputMaybe<Main_Currency_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration_in_days?: InputMaybe<Scalars['Int']['input']>;
  free_sponsored_posts?: InputMaybe<Scalars['Int']['input']>;
  free_trial?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookup_key?: InputMaybe<Scalars['String']['input']>;
  min_members?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number_of_posts?: InputMaybe<Scalars['Int']['input']>;
  number_of_prompts?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_channels?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_posts?: InputMaybe<Scalars['Int']['input']>;
  organization_type?: InputMaybe<Organization_Type_Enum>;
  self_service?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_price_id?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Plan_Type_Enum>;
};

/** aggregate sum on columns */
export type Plan_Sum_Fields = {
  __typename?: 'plan_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  duration_in_days?: Maybe<Scalars['Int']['output']>;
  free_sponsored_posts?: Maybe<Scalars['Int']['output']>;
  min_members?: Maybe<Scalars['Int']['output']>;
  number_of_posts?: Maybe<Scalars['Int']['output']>;
  number_of_prompts?: Maybe<Scalars['Int']['output']>;
  number_of_social_channels?: Maybe<Scalars['Int']['output']>;
  number_of_social_posts?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "plan_type" */
export type Plan_Type = {
  __typename?: 'plan_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "plan_type" */
export type Plan_Type_Aggregate = {
  __typename?: 'plan_type_aggregate';
  aggregate?: Maybe<Plan_Type_Aggregate_Fields>;
  nodes: Array<Plan_Type>;
};

/** aggregate fields of "plan_type" */
export type Plan_Type_Aggregate_Fields = {
  __typename?: 'plan_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Plan_Type_Max_Fields>;
  min?: Maybe<Plan_Type_Min_Fields>;
};


/** aggregate fields of "plan_type" */
export type Plan_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plan_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "plan_type". All fields are combined with a logical 'AND'. */
export type Plan_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Plan_Type_Bool_Exp>>;
  _not?: InputMaybe<Plan_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Plan_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "plan_type" */
export enum Plan_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  PlanTypePkey = 'plan_type_pkey'
}

export enum Plan_Type_Enum {
  Monthly = 'monthly',
  Yearly = 'yearly'
}

/** Boolean expression to compare columns of type "plan_type_enum". All fields are combined with logical 'AND'. */
export type Plan_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Plan_Type_Enum>;
  _in?: InputMaybe<Array<Plan_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Plan_Type_Enum>;
  _nin?: InputMaybe<Array<Plan_Type_Enum>>;
};

/** input type for inserting data into table "plan_type" */
export type Plan_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Plan_Type_Max_Fields = {
  __typename?: 'plan_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Plan_Type_Min_Fields = {
  __typename?: 'plan_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "plan_type" */
export type Plan_Type_Mutation_Response = {
  __typename?: 'plan_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Plan_Type>;
};

/** on_conflict condition type for table "plan_type" */
export type Plan_Type_On_Conflict = {
  constraint: Plan_Type_Constraint;
  update_columns?: Array<Plan_Type_Update_Column>;
  where?: InputMaybe<Plan_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "plan_type". */
export type Plan_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plan_type */
export type Plan_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "plan_type" */
export enum Plan_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "plan_type" */
export type Plan_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "plan_type" */
export type Plan_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plan_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plan_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "plan_type" */
export enum Plan_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Plan_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plan_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Plan_Type_Bool_Exp;
};

/** update columns of table "plan" */
export enum Plan_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Amount = 'amount',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DurationInDays = 'duration_in_days',
  /** column name */
  FreeSponsoredPosts = 'free_sponsored_posts',
  /** column name */
  FreeTrial = 'free_trial',
  /** column name */
  Id = 'id',
  /** column name */
  LookupKey = 'lookup_key',
  /** column name */
  MinMembers = 'min_members',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfPosts = 'number_of_posts',
  /** column name */
  NumberOfPrompts = 'number_of_prompts',
  /** column name */
  NumberOfSocialChannels = 'number_of_social_channels',
  /** column name */
  NumberOfSocialPosts = 'number_of_social_posts',
  /** column name */
  OrganizationType = 'organization_type',
  /** column name */
  SelfService = 'self_service',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  Type = 'type'
}

export type Plan_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plan_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plan_Set_Input>;
  /** filter the rows which have to be updated */
  where: Plan_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plan_Var_Pop_Fields = {
  __typename?: 'plan_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
  free_sponsored_posts?: Maybe<Scalars['Float']['output']>;
  min_members?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_prompts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Plan_Var_Samp_Fields = {
  __typename?: 'plan_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
  free_sponsored_posts?: Maybe<Scalars['Float']['output']>;
  min_members?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_prompts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Plan_Variance_Fields = {
  __typename?: 'plan_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
  free_sponsored_posts?: Maybe<Scalars['Float']['output']>;
  min_members?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_prompts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "product" */
export type Product = {
  __typename?: 'product';
  active: Scalars['Boolean']['output'];
  amount: Scalars['float8']['output'];
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Main_Currency_Enum>;
  description?: Maybe<Scalars['String']['output']>;
  description_en?: Maybe<Scalars['String']['output']>;
  duration_in_days: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  name_en?: Maybe<Scalars['String']['output']>;
  stripe_price_id: Scalars['String']['output'];
  stripe_product_id: Scalars['String']['output'];
  type: Product_Type_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "product" */
export type Product_Aggregate = {
  __typename?: 'product_aggregate';
  aggregate?: Maybe<Product_Aggregate_Fields>;
  nodes: Array<Product>;
};

/** aggregate fields of "product" */
export type Product_Aggregate_Fields = {
  __typename?: 'product_aggregate_fields';
  avg?: Maybe<Product_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Max_Fields>;
  min?: Maybe<Product_Min_Fields>;
  stddev?: Maybe<Product_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Sum_Fields>;
  var_pop?: Maybe<Product_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Var_Samp_Fields>;
  variance?: Maybe<Product_Variance_Fields>;
};


/** aggregate fields of "product" */
export type Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Product_Avg_Fields = {
  __typename?: 'product_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "product". All fields are combined with a logical 'AND'. */
export type Product_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Bool_Exp>>;
  _not?: InputMaybe<Product_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<Main_Currency_Enum_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  description_en?: InputMaybe<String_Comparison_Exp>;
  duration_in_days?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  stripe_price_id?: InputMaybe<String_Comparison_Exp>;
  stripe_product_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Product_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product" */
export enum Product_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductPkey = 'product_pkey'
}

/** input type for incrementing numeric columns in table "product" */
export type Product_Inc_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  duration_in_days?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "product" */
export type Product_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Main_Currency_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  duration_in_days?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  stripe_price_id?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Product_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Product_Max_Fields = {
  __typename?: 'product_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  description_en?: Maybe<Scalars['String']['output']>;
  duration_in_days?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  stripe_price_id?: Maybe<Scalars['String']['output']>;
  stripe_product_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Product_Min_Fields = {
  __typename?: 'product_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  description_en?: Maybe<Scalars['String']['output']>;
  duration_in_days?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  stripe_price_id?: Maybe<Scalars['String']['output']>;
  stripe_product_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "product" */
export type Product_Mutation_Response = {
  __typename?: 'product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product>;
};

/** on_conflict condition type for table "product" */
export type Product_On_Conflict = {
  constraint: Product_Constraint;
  update_columns?: Array<Product_Update_Column>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** Ordering options when selecting data from "product". */
export type Product_Order_By = {
  active?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_en?: InputMaybe<Order_By>;
  duration_in_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  stripe_price_id?: InputMaybe<Order_By>;
  stripe_product_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product */
export type Product_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "product_purchase" */
export type Product_Purchase = {
  __typename?: 'product_purchase';
  amount_paid: Scalars['float8']['output'];
  created_at: Scalars['timestamptz']['output'];
  end_date: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  organization_id: Scalars['uuid']['output'];
  product_id: Scalars['uuid']['output'];
  property_list_id: Scalars['uuid']['output'];
  start_date: Scalars['date']['output'];
  status: Subscription_Status_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "product_purchase" */
export type Product_Purchase_Aggregate = {
  __typename?: 'product_purchase_aggregate';
  aggregate?: Maybe<Product_Purchase_Aggregate_Fields>;
  nodes: Array<Product_Purchase>;
};

/** aggregate fields of "product_purchase" */
export type Product_Purchase_Aggregate_Fields = {
  __typename?: 'product_purchase_aggregate_fields';
  avg?: Maybe<Product_Purchase_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Purchase_Max_Fields>;
  min?: Maybe<Product_Purchase_Min_Fields>;
  stddev?: Maybe<Product_Purchase_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Purchase_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Purchase_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Purchase_Sum_Fields>;
  var_pop?: Maybe<Product_Purchase_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Purchase_Var_Samp_Fields>;
  variance?: Maybe<Product_Purchase_Variance_Fields>;
};


/** aggregate fields of "product_purchase" */
export type Product_Purchase_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Product_Purchase_Avg_Fields = {
  __typename?: 'product_purchase_avg_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "product_purchase". All fields are combined with a logical 'AND'. */
export type Product_Purchase_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Purchase_Bool_Exp>>;
  _not?: InputMaybe<Product_Purchase_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Purchase_Bool_Exp>>;
  amount_paid?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Subscription_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_purchase" */
export enum Product_Purchase_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductPurchasePkey = 'product_purchase_pkey'
}

/** input type for incrementing numeric columns in table "product_purchase" */
export type Product_Purchase_Inc_Input = {
  amount_paid?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "product_purchase" */
export type Product_Purchase_Insert_Input = {
  amount_paid?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Subscription_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Product_Purchase_Max_Fields = {
  __typename?: 'product_purchase_max_fields';
  amount_paid?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Product_Purchase_Min_Fields = {
  __typename?: 'product_purchase_min_fields';
  amount_paid?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "product_purchase" */
export type Product_Purchase_Mutation_Response = {
  __typename?: 'product_purchase_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Purchase>;
};

/** on_conflict condition type for table "product_purchase" */
export type Product_Purchase_On_Conflict = {
  constraint: Product_Purchase_Constraint;
  update_columns?: Array<Product_Purchase_Update_Column>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};

/** Ordering options when selecting data from "product_purchase". */
export type Product_Purchase_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_purchase */
export type Product_Purchase_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product_purchase" */
export enum Product_Purchase_Select_Column {
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "product_purchase" */
export type Product_Purchase_Set_Input = {
  amount_paid?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Subscription_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Product_Purchase_Stddev_Fields = {
  __typename?: 'product_purchase_stddev_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Product_Purchase_Stddev_Pop_Fields = {
  __typename?: 'product_purchase_stddev_pop_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Product_Purchase_Stddev_Samp_Fields = {
  __typename?: 'product_purchase_stddev_samp_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "product_purchase" */
export type Product_Purchase_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Purchase_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Purchase_Stream_Cursor_Value_Input = {
  amount_paid?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Subscription_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Product_Purchase_Sum_Fields = {
  __typename?: 'product_purchase_sum_fields';
  amount_paid?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "product_purchase" */
export enum Product_Purchase_Update_Column {
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Product_Purchase_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Purchase_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Purchase_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Purchase_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Purchase_Var_Pop_Fields = {
  __typename?: 'product_purchase_var_pop_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Product_Purchase_Var_Samp_Fields = {
  __typename?: 'product_purchase_var_samp_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Product_Purchase_Variance_Fields = {
  __typename?: 'product_purchase_variance_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "product" */
export enum Product_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DurationInDays = 'duration_in_days',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "product" */
export type Product_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Main_Currency_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  duration_in_days?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  stripe_price_id?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Product_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Product_Stddev_Fields = {
  __typename?: 'product_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Product_Stddev_Pop_Fields = {
  __typename?: 'product_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Product_Stddev_Samp_Fields = {
  __typename?: 'product_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "product" */
export type Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Main_Currency_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  duration_in_days?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  stripe_price_id?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Product_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Product_Sum_Fields = {
  __typename?: 'product_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  duration_in_days?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "product_type" */
export type Product_Type = {
  __typename?: 'product_type';
  type: Scalars['String']['output'];
};

/** aggregated selection of "product_type" */
export type Product_Type_Aggregate = {
  __typename?: 'product_type_aggregate';
  aggregate?: Maybe<Product_Type_Aggregate_Fields>;
  nodes: Array<Product_Type>;
};

/** aggregate fields of "product_type" */
export type Product_Type_Aggregate_Fields = {
  __typename?: 'product_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Type_Max_Fields>;
  min?: Maybe<Product_Type_Min_Fields>;
};


/** aggregate fields of "product_type" */
export type Product_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "product_type". All fields are combined with a logical 'AND'. */
export type Product_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Type_Bool_Exp>>;
  _not?: InputMaybe<Product_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_type" */
export enum Product_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  ProductTypePkey = 'product_type_pkey'
}

export enum Product_Type_Enum {
  Sponsored = 'sponsored'
}

/** Boolean expression to compare columns of type "product_type_enum". All fields are combined with logical 'AND'. */
export type Product_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Product_Type_Enum>;
  _in?: InputMaybe<Array<Product_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Product_Type_Enum>;
  _nin?: InputMaybe<Array<Product_Type_Enum>>;
};

/** input type for inserting data into table "product_type" */
export type Product_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_Type_Max_Fields = {
  __typename?: 'product_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Product_Type_Min_Fields = {
  __typename?: 'product_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "product_type" */
export type Product_Type_Mutation_Response = {
  __typename?: 'product_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Type>;
};

/** on_conflict condition type for table "product_type" */
export type Product_Type_On_Conflict = {
  constraint: Product_Type_Constraint;
  update_columns?: Array<Product_Type_Update_Column>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "product_type". */
export type Product_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_type */
export type Product_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "product_type" */
export enum Product_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "product_type" */
export type Product_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "product_type" */
export type Product_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "product_type" */
export enum Product_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Product_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Type_Bool_Exp;
};

/** update columns of table "product" */
export enum Product_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DurationInDays = 'duration_in_days',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Product_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Var_Pop_Fields = {
  __typename?: 'product_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Product_Var_Samp_Fields = {
  __typename?: 'product_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Product_Variance_Fields = {
  __typename?: 'product_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "property" */
export type Property = {
  __typename?: 'property';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  json_ld?: Maybe<Scalars['String']['output']>;
  last_seen: Scalars['timestamptz']['output'];
  main_listing_id: Scalars['uuid']['output'];
  /** An object relationship */
  main_property: Property_List;
  /** An array relationship */
  property_features: Array<Property_Feature>;
  /** An aggregate relationship */
  property_features_aggregate: Property_Feature_Aggregate;
  /** An array relationship */
  property_images: Array<Property_Image>;
  /** An aggregate relationship */
  property_images_aggregate: Property_Image_Aggregate;
  /** An array relationship */
  property_lists: Array<Property_List>;
  /** An aggregate relationship */
  property_lists_aggregate: Property_List_Aggregate;
  /** An array relationship */
  property_price_histories: Array<Property_Price_History>;
  /** An aggregate relationship */
  property_price_histories_aggregate: Property_Price_History_Aggregate;
  /** An array relationship */
  property_views: Array<Property_Views>;
  /** An aggregate relationship */
  property_views_aggregate: Property_Views_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  url_slugs: Array<Url_Slug>;
  /** An aggregate relationship */
  url_slugs_aggregate: Url_Slug_Aggregate;
  /** An array relationship */
  user_saved_properties: Array<User_Saved_Properties>;
  /** An aggregate relationship */
  user_saved_properties_aggregate: User_Saved_Properties_Aggregate;
  /** An array relationship */
  user_seen_properties: Array<User_Seen_Property>;
  /** An aggregate relationship */
  user_seen_properties_aggregate: User_Seen_Property_Aggregate;
};


/** columns and relationships of "property" */
export type PropertyProperty_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Property_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Feature_Order_By>>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyProperty_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Feature_Order_By>>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyProperty_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Property_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Image_Order_By>>;
  where?: InputMaybe<Property_Image_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyProperty_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Image_Order_By>>;
  where?: InputMaybe<Property_Image_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyProperty_ListsArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyProperty_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyProperty_Price_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Property_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Price_History_Order_By>>;
  where?: InputMaybe<Property_Price_History_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyProperty_Price_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Price_History_Order_By>>;
  where?: InputMaybe<Property_Price_History_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyProperty_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Property_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Views_Order_By>>;
  where?: InputMaybe<Property_Views_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyProperty_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Views_Order_By>>;
  where?: InputMaybe<Property_Views_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyUrl_SlugsArgs = {
  distinct_on?: InputMaybe<Array<Url_Slug_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Url_Slug_Order_By>>;
  where?: InputMaybe<Url_Slug_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyUrl_Slugs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Url_Slug_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Url_Slug_Order_By>>;
  where?: InputMaybe<Url_Slug_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyUser_Saved_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<User_Saved_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Saved_Properties_Order_By>>;
  where?: InputMaybe<User_Saved_Properties_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyUser_Saved_Properties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Saved_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Saved_Properties_Order_By>>;
  where?: InputMaybe<User_Saved_Properties_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyUser_Seen_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<User_Seen_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Seen_Property_Order_By>>;
  where?: InputMaybe<User_Seen_Property_Bool_Exp>;
};


/** columns and relationships of "property" */
export type PropertyUser_Seen_Properties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Seen_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Seen_Property_Order_By>>;
  where?: InputMaybe<User_Seen_Property_Bool_Exp>;
};

/** propertyDailyViewsNative Query Arguments */
export type PropertyDailyViews_Arguments = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

export type Property_ActionType = {
  __typename?: 'property_ActionType';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  json_ld?: Maybe<Scalars['String']['output']>;
  last_seen: Scalars['timestamptz']['output'];
  main_listing_id: Scalars['uuid']['output'];
  main_property?: Maybe<MainProperty_Action_Type>;
  updated_at: Scalars['timestamptz']['output'];
  url_slugs?: Maybe<Array<Maybe<Url_Slug_ActionType>>>;
};

/** aggregated selection of "property" */
export type Property_Aggregate = {
  __typename?: 'property_aggregate';
  aggregate?: Maybe<Property_Aggregate_Fields>;
  nodes: Array<Property>;
};

export type Property_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Aggregate_Bool_Exp_Count>;
};

export type Property_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property" */
export type Property_Aggregate_Fields = {
  __typename?: 'property_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Max_Fields>;
  min?: Maybe<Property_Min_Fields>;
};


/** aggregate fields of "property" */
export type Property_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property" */
export type Property_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Max_Order_By>;
  min?: InputMaybe<Property_Min_Order_By>;
};

/** input type for inserting array relation for remote table "property" */
export type Property_Arr_Rel_Insert_Input = {
  data: Array<Property_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_On_Conflict>;
};

/** Boolean expression to filter rows from the table "property". All fields are combined with a logical 'AND'. */
export type Property_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Bool_Exp>>;
  _not?: InputMaybe<Property_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  json_ld?: InputMaybe<String_Comparison_Exp>;
  last_seen?: InputMaybe<Timestamptz_Comparison_Exp>;
  main_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  main_property?: InputMaybe<Property_List_Bool_Exp>;
  property_features?: InputMaybe<Property_Feature_Bool_Exp>;
  property_features_aggregate?: InputMaybe<Property_Feature_Aggregate_Bool_Exp>;
  property_images?: InputMaybe<Property_Image_Bool_Exp>;
  property_images_aggregate?: InputMaybe<Property_Image_Aggregate_Bool_Exp>;
  property_lists?: InputMaybe<Property_List_Bool_Exp>;
  property_lists_aggregate?: InputMaybe<Property_List_Aggregate_Bool_Exp>;
  property_price_histories?: InputMaybe<Property_Price_History_Bool_Exp>;
  property_price_histories_aggregate?: InputMaybe<Property_Price_History_Aggregate_Bool_Exp>;
  property_views?: InputMaybe<Property_Views_Bool_Exp>;
  property_views_aggregate?: InputMaybe<Property_Views_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url_slugs?: InputMaybe<Url_Slug_Bool_Exp>;
  url_slugs_aggregate?: InputMaybe<Url_Slug_Aggregate_Bool_Exp>;
  user_saved_properties?: InputMaybe<User_Saved_Properties_Bool_Exp>;
  user_saved_properties_aggregate?: InputMaybe<User_Saved_Properties_Aggregate_Bool_Exp>;
  user_seen_properties?: InputMaybe<User_Seen_Property_Bool_Exp>;
  user_seen_properties_aggregate?: InputMaybe<User_Seen_Property_Aggregate_Bool_Exp>;
};

/** columns and relationships of "property_cluster" */
export type Property_Cluster = {
  __typename?: 'property_cluster';
  cluster: Scalars['String']['output'];
  /** An array relationship */
  property_types: Array<Property_Type>;
  /** An aggregate relationship */
  property_types_aggregate: Property_Type_Aggregate;
};


/** columns and relationships of "property_cluster" */
export type Property_ClusterProperty_TypesArgs = {
  distinct_on?: InputMaybe<Array<Property_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Type_Order_By>>;
  where?: InputMaybe<Property_Type_Bool_Exp>;
};


/** columns and relationships of "property_cluster" */
export type Property_ClusterProperty_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Type_Order_By>>;
  where?: InputMaybe<Property_Type_Bool_Exp>;
};

export type Property_Cluster_ActionType = {
  __typename?: 'property_cluster_ActionType';
  cluster: Scalars['String']['output'];
};

/** aggregated selection of "property_cluster" */
export type Property_Cluster_Aggregate = {
  __typename?: 'property_cluster_aggregate';
  aggregate?: Maybe<Property_Cluster_Aggregate_Fields>;
  nodes: Array<Property_Cluster>;
};

/** aggregate fields of "property_cluster" */
export type Property_Cluster_Aggregate_Fields = {
  __typename?: 'property_cluster_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Cluster_Max_Fields>;
  min?: Maybe<Property_Cluster_Min_Fields>;
};


/** aggregate fields of "property_cluster" */
export type Property_Cluster_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Cluster_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "property_cluster". All fields are combined with a logical 'AND'. */
export type Property_Cluster_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Cluster_Bool_Exp>>;
  _not?: InputMaybe<Property_Cluster_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Cluster_Bool_Exp>>;
  cluster?: InputMaybe<String_Comparison_Exp>;
  property_types?: InputMaybe<Property_Type_Bool_Exp>;
  property_types_aggregate?: InputMaybe<Property_Type_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "property_cluster" */
export enum Property_Cluster_Constraint {
  /** unique or primary key constraint on columns "cluster" */
  PropertyClusterPkey = 'property_cluster_pkey'
}

export enum Property_Cluster_Enum {
  Commercial = 'commercial',
  Industrial = 'industrial',
  Land = 'land',
  Parking = 'parking',
  Residential = 'residential'
}

/** Boolean expression to compare columns of type "property_cluster_enum". All fields are combined with logical 'AND'. */
export type Property_Cluster_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Property_Cluster_Enum>;
  _in?: InputMaybe<Array<Property_Cluster_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Property_Cluster_Enum>;
  _nin?: InputMaybe<Array<Property_Cluster_Enum>>;
};

/** input type for inserting data into table "property_cluster" */
export type Property_Cluster_Insert_Input = {
  cluster?: InputMaybe<Scalars['String']['input']>;
  property_types?: InputMaybe<Property_Type_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Property_Cluster_Max_Fields = {
  __typename?: 'property_cluster_max_fields';
  cluster?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Property_Cluster_Min_Fields = {
  __typename?: 'property_cluster_min_fields';
  cluster?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "property_cluster" */
export type Property_Cluster_Mutation_Response = {
  __typename?: 'property_cluster_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Cluster>;
};

/** input type for inserting object relation for remote table "property_cluster" */
export type Property_Cluster_Obj_Rel_Insert_Input = {
  data: Property_Cluster_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Cluster_On_Conflict>;
};

/** on_conflict condition type for table "property_cluster" */
export type Property_Cluster_On_Conflict = {
  constraint: Property_Cluster_Constraint;
  update_columns?: Array<Property_Cluster_Update_Column>;
  where?: InputMaybe<Property_Cluster_Bool_Exp>;
};

/** Ordering options when selecting data from "property_cluster". */
export type Property_Cluster_Order_By = {
  cluster?: InputMaybe<Order_By>;
  property_types_aggregate?: InputMaybe<Property_Type_Aggregate_Order_By>;
};

/** primary key columns input for table: property_cluster */
export type Property_Cluster_Pk_Columns_Input = {
  cluster: Scalars['String']['input'];
};

/** select columns of table "property_cluster" */
export enum Property_Cluster_Select_Column {
  /** column name */
  Cluster = 'cluster'
}

/** input type for updating data in table "property_cluster" */
export type Property_Cluster_Set_Input = {
  cluster?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "property_cluster" */
export type Property_Cluster_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Cluster_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Cluster_Stream_Cursor_Value_Input = {
  cluster?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "property_cluster" */
export enum Property_Cluster_Update_Column {
  /** column name */
  Cluster = 'cluster'
}

export type Property_Cluster_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Cluster_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Cluster_Bool_Exp;
};

/** columns and relationships of "property_composition" */
export type Property_Composition = {
  __typename?: 'property_composition';
  balconies: Scalars['Int']['output'];
  bathrooms: Scalars['Int']['output'];
  bedrooms?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  kitchens: Scalars['Int']['output'];
  living_rooms: Scalars['Int']['output'];
};

export type Property_Composition_ActionType = {
  __typename?: 'property_composition_ActionType';
  balconies?: Maybe<Scalars['Int']['output']>;
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  kitchens?: Maybe<Scalars['Int']['output']>;
  living_rooms?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "property_composition" */
export type Property_Composition_Aggregate = {
  __typename?: 'property_composition_aggregate';
  aggregate?: Maybe<Property_Composition_Aggregate_Fields>;
  nodes: Array<Property_Composition>;
};

/** aggregate fields of "property_composition" */
export type Property_Composition_Aggregate_Fields = {
  __typename?: 'property_composition_aggregate_fields';
  avg?: Maybe<Property_Composition_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Composition_Max_Fields>;
  min?: Maybe<Property_Composition_Min_Fields>;
  stddev?: Maybe<Property_Composition_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Composition_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Composition_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Composition_Sum_Fields>;
  var_pop?: Maybe<Property_Composition_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Composition_Var_Samp_Fields>;
  variance?: Maybe<Property_Composition_Variance_Fields>;
};


/** aggregate fields of "property_composition" */
export type Property_Composition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Composition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Property_Composition_Avg_Fields = {
  __typename?: 'property_composition_avg_fields';
  balconies?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  kitchens?: Maybe<Scalars['Float']['output']>;
  living_rooms?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "property_composition". All fields are combined with a logical 'AND'. */
export type Property_Composition_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Composition_Bool_Exp>>;
  _not?: InputMaybe<Property_Composition_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Composition_Bool_Exp>>;
  balconies?: InputMaybe<Int_Comparison_Exp>;
  bathrooms?: InputMaybe<Int_Comparison_Exp>;
  bedrooms?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  kitchens?: InputMaybe<Int_Comparison_Exp>;
  living_rooms?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_composition" */
export enum Property_Composition_Constraint {
  /** unique or primary key constraint on columns "bedrooms", "balconies", "bathrooms", "living_rooms", "kitchens" */
  PropertyCompositionBedroomsBalconiesKitchensLivingRoomsB = 'property_composition_bedrooms_balconies_kitchens_living_rooms_b',
  /** unique or primary key constraint on columns "id" */
  PropertyCompositionPkey = 'property_composition_pkey'
}

/** input type for incrementing numeric columns in table "property_composition" */
export type Property_Composition_Inc_Input = {
  balconies?: InputMaybe<Scalars['Int']['input']>;
  bathrooms?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  kitchens?: InputMaybe<Scalars['Int']['input']>;
  living_rooms?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_composition" */
export type Property_Composition_Insert_Input = {
  balconies?: InputMaybe<Scalars['Int']['input']>;
  bathrooms?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kitchens?: InputMaybe<Scalars['Int']['input']>;
  living_rooms?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Property_Composition_Max_Fields = {
  __typename?: 'property_composition_max_fields';
  balconies?: Maybe<Scalars['Int']['output']>;
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kitchens?: Maybe<Scalars['Int']['output']>;
  living_rooms?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Property_Composition_Min_Fields = {
  __typename?: 'property_composition_min_fields';
  balconies?: Maybe<Scalars['Int']['output']>;
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kitchens?: Maybe<Scalars['Int']['output']>;
  living_rooms?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "property_composition" */
export type Property_Composition_Mutation_Response = {
  __typename?: 'property_composition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Composition>;
};

/** input type for inserting object relation for remote table "property_composition" */
export type Property_Composition_Obj_Rel_Insert_Input = {
  data: Property_Composition_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Composition_On_Conflict>;
};

/** on_conflict condition type for table "property_composition" */
export type Property_Composition_On_Conflict = {
  constraint: Property_Composition_Constraint;
  update_columns?: Array<Property_Composition_Update_Column>;
  where?: InputMaybe<Property_Composition_Bool_Exp>;
};

/** Ordering options when selecting data from "property_composition". */
export type Property_Composition_Order_By = {
  balconies?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  bedrooms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kitchens?: InputMaybe<Order_By>;
  living_rooms?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_composition */
export type Property_Composition_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_composition" */
export enum Property_Composition_Select_Column {
  /** column name */
  Balconies = 'balconies',
  /** column name */
  Bathrooms = 'bathrooms',
  /** column name */
  Bedrooms = 'bedrooms',
  /** column name */
  Id = 'id',
  /** column name */
  Kitchens = 'kitchens',
  /** column name */
  LivingRooms = 'living_rooms'
}

/** input type for updating data in table "property_composition" */
export type Property_Composition_Set_Input = {
  balconies?: InputMaybe<Scalars['Int']['input']>;
  bathrooms?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kitchens?: InputMaybe<Scalars['Int']['input']>;
  living_rooms?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Property_Composition_Stddev_Fields = {
  __typename?: 'property_composition_stddev_fields';
  balconies?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  kitchens?: Maybe<Scalars['Float']['output']>;
  living_rooms?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Property_Composition_Stddev_Pop_Fields = {
  __typename?: 'property_composition_stddev_pop_fields';
  balconies?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  kitchens?: Maybe<Scalars['Float']['output']>;
  living_rooms?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Property_Composition_Stddev_Samp_Fields = {
  __typename?: 'property_composition_stddev_samp_fields';
  balconies?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  kitchens?: Maybe<Scalars['Float']['output']>;
  living_rooms?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "property_composition" */
export type Property_Composition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Composition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Composition_Stream_Cursor_Value_Input = {
  balconies?: InputMaybe<Scalars['Int']['input']>;
  bathrooms?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kitchens?: InputMaybe<Scalars['Int']['input']>;
  living_rooms?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Property_Composition_Sum_Fields = {
  __typename?: 'property_composition_sum_fields';
  balconies?: Maybe<Scalars['Int']['output']>;
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  kitchens?: Maybe<Scalars['Int']['output']>;
  living_rooms?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "property_composition" */
export enum Property_Composition_Update_Column {
  /** column name */
  Balconies = 'balconies',
  /** column name */
  Bathrooms = 'bathrooms',
  /** column name */
  Bedrooms = 'bedrooms',
  /** column name */
  Id = 'id',
  /** column name */
  Kitchens = 'kitchens',
  /** column name */
  LivingRooms = 'living_rooms'
}

export type Property_Composition_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Composition_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Composition_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Composition_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Composition_Var_Pop_Fields = {
  __typename?: 'property_composition_var_pop_fields';
  balconies?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  kitchens?: Maybe<Scalars['Float']['output']>;
  living_rooms?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Property_Composition_Var_Samp_Fields = {
  __typename?: 'property_composition_var_samp_fields';
  balconies?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  kitchens?: Maybe<Scalars['Float']['output']>;
  living_rooms?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Property_Composition_Variance_Fields = {
  __typename?: 'property_composition_variance_fields';
  balconies?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  kitchens?: Maybe<Scalars['Float']['output']>;
  living_rooms?: Maybe<Scalars['Float']['output']>;
};

/** unique or primary key constraints on table "property" */
export enum Property_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyPkey = 'property_pkey'
}

/** columns and relationships of "property_feature" */
export type Property_Feature = {
  __typename?: 'property_feature';
  /** An object relationship */
  feature: Feature;
  feature_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  property_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  property_list?: Maybe<Property_List>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  value: Scalars['Boolean']['output'];
};

/** aggregated selection of "property_feature" */
export type Property_Feature_Aggregate = {
  __typename?: 'property_feature_aggregate';
  aggregate?: Maybe<Property_Feature_Aggregate_Fields>;
  nodes: Array<Property_Feature>;
};

export type Property_Feature_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Property_Feature_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Property_Feature_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Property_Feature_Aggregate_Bool_Exp_Count>;
};

export type Property_Feature_Aggregate_Bool_Exp_Bool_And = {
  arguments: Property_Feature_Select_Column_Property_Feature_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Feature_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Feature_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Property_Feature_Select_Column_Property_Feature_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Feature_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Feature_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Feature_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Feature_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_feature" */
export type Property_Feature_Aggregate_Fields = {
  __typename?: 'property_feature_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Feature_Max_Fields>;
  min?: Maybe<Property_Feature_Min_Fields>;
};


/** aggregate fields of "property_feature" */
export type Property_Feature_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Feature_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_feature" */
export type Property_Feature_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Feature_Max_Order_By>;
  min?: InputMaybe<Property_Feature_Min_Order_By>;
};

/** input type for inserting array relation for remote table "property_feature" */
export type Property_Feature_Arr_Rel_Insert_Input = {
  data: Array<Property_Feature_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Feature_On_Conflict>;
};

/** Boolean expression to filter rows from the table "property_feature". All fields are combined with a logical 'AND'. */
export type Property_Feature_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Feature_Bool_Exp>>;
  _not?: InputMaybe<Property_Feature_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Feature_Bool_Exp>>;
  feature?: InputMaybe<Feature_Bool_Exp>;
  feature_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_list?: InputMaybe<Property_List_Bool_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_feature" */
export enum Property_Feature_Constraint {
  /** unique or primary key constraint on columns "feature_id", "property_id" */
  PropertyFeatureFeatureIdPropertyIdKey = 'property_feature_feature_id_property_id_key',
  /** unique or primary key constraint on columns "feature_id", "property_list_id" */
  PropertyFeatureFeatureIdPropertyListIdKey = 'property_feature_feature_id_property_list_id_key',
  /** unique or primary key constraint on columns "id" */
  PropertyFeaturePkey = 'property_feature_pkey'
}

/** input type for inserting data into table "property_feature" */
export type Property_Feature_Insert_Input = {
  feature?: InputMaybe<Feature_Obj_Rel_Insert_Input>;
  feature_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list?: InputMaybe<Property_List_Obj_Rel_Insert_Input>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Property_Feature_Max_Fields = {
  __typename?: 'property_feature_max_fields';
  feature_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "property_feature" */
export type Property_Feature_Max_Order_By = {
  feature_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Feature_Min_Fields = {
  __typename?: 'property_feature_min_fields';
  feature_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "property_feature" */
export type Property_Feature_Min_Order_By = {
  feature_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_feature" */
export type Property_Feature_Mutation_Response = {
  __typename?: 'property_feature_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Feature>;
};

/** on_conflict condition type for table "property_feature" */
export type Property_Feature_On_Conflict = {
  constraint: Property_Feature_Constraint;
  update_columns?: Array<Property_Feature_Update_Column>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};

/** Ordering options when selecting data from "property_feature". */
export type Property_Feature_Order_By = {
  feature?: InputMaybe<Feature_Order_By>;
  feature_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_list?: InputMaybe<Property_List_Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_feature */
export type Property_Feature_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_feature" */
export enum Property_Feature_Select_Column {
  /** column name */
  FeatureId = 'feature_id',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  Value = 'value'
}

/** select "property_feature_aggregate_bool_exp_bool_and_arguments_columns" columns of table "property_feature" */
export enum Property_Feature_Select_Column_Property_Feature_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "property_feature_aggregate_bool_exp_bool_or_arguments_columns" columns of table "property_feature" */
export enum Property_Feature_Select_Column_Property_Feature_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "property_feature" */
export type Property_Feature_Set_Input = {
  feature_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "property_feature" */
export type Property_Feature_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Feature_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Feature_Stream_Cursor_Value_Input = {
  feature_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "property_feature" */
export enum Property_Feature_Update_Column {
  /** column name */
  FeatureId = 'feature_id',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  Value = 'value'
}

export type Property_Feature_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Feature_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Feature_Bool_Exp;
};

/** columns and relationships of "property_folder" */
export type Property_Folder = {
  __typename?: 'property_folder';
  active?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  building_floors?: Maybe<Scalars['Int']['output']>;
  claimed_folder?: Maybe<Scalars['Boolean']['output']>;
  cluster?: Maybe<Property_Cluster_Enum>;
  construction_status?: Maybe<Construction_Status_Enum>;
  construction_year?: Maybe<Scalars['String']['output']>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  created_by_user_organization_id?: Maybe<Scalars['uuid']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  folder_amenities: Array<Folder_Amenities>;
  /** An aggregate relationship */
  folder_amenities_aggregate: Folder_Amenities_Aggregate;
  /** An array relationship */
  folder_images: Array<Folder_Image>;
  /** An aggregate relationship */
  folder_images_aggregate: Folder_Image_Aggregate;
  /** An array relationship */
  folder_properties_types: Array<Folder_Properties_Type>;
  /** An aggregate relationship */
  folder_properties_types_aggregate: Folder_Properties_Type_Aggregate;
  geom?: Maybe<Scalars['geography']['output']>;
  id: Scalars['uuid']['output'];
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  main_image_url?: Maybe<Scalars['String']['output']>;
  min_price?: Maybe<Scalars['float8']['output']>;
  nr_apartments?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  parking_spaces?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  property_lists: Array<Property_List_Folder>;
  /** An aggregate relationship */
  property_lists_aggregate: Property_List_Folder_Aggregate;
  /** An object relationship */
  public_profile?: Maybe<Property_Folder_Public_Profile>;
  status?: Maybe<Folder_Status_Enum>;
  title: Scalars['String']['output'];
  type?: Maybe<Folder_Type_Enum>;
  updated_at: Scalars['timestamptz']['output'];
  visibility_status?: Maybe<Visibility_Status_Enum>;
};


/** columns and relationships of "property_folder" */
export type Property_FolderFolder_AmenitiesArgs = {
  distinct_on?: InputMaybe<Array<Folder_Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Amenities_Order_By>>;
  where?: InputMaybe<Folder_Amenities_Bool_Exp>;
};


/** columns and relationships of "property_folder" */
export type Property_FolderFolder_Amenities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Folder_Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Amenities_Order_By>>;
  where?: InputMaybe<Folder_Amenities_Bool_Exp>;
};


/** columns and relationships of "property_folder" */
export type Property_FolderFolder_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Folder_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Image_Order_By>>;
  where?: InputMaybe<Folder_Image_Bool_Exp>;
};


/** columns and relationships of "property_folder" */
export type Property_FolderFolder_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Folder_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Image_Order_By>>;
  where?: InputMaybe<Folder_Image_Bool_Exp>;
};


/** columns and relationships of "property_folder" */
export type Property_FolderFolder_Properties_TypesArgs = {
  distinct_on?: InputMaybe<Array<Folder_Properties_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Properties_Type_Order_By>>;
  where?: InputMaybe<Folder_Properties_Type_Bool_Exp>;
};


/** columns and relationships of "property_folder" */
export type Property_FolderFolder_Properties_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Folder_Properties_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Properties_Type_Order_By>>;
  where?: InputMaybe<Folder_Properties_Type_Bool_Exp>;
};


/** columns and relationships of "property_folder" */
export type Property_FolderProperty_ListsArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Folder_Order_By>>;
  where?: InputMaybe<Property_List_Folder_Bool_Exp>;
};


/** columns and relationships of "property_folder" */
export type Property_FolderProperty_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Folder_Order_By>>;
  where?: InputMaybe<Property_List_Folder_Bool_Exp>;
};

export type Property_Folder_Aggregate = {
  __typename?: 'property_folder_aggregate';
  aggregate?: Maybe<Property_Folder_Aggregate_Fields>;
  nodes: Array<Property_Folder>;
};

/** aggregate fields of "property_folder" */
export type Property_Folder_Aggregate_Fields = {
  __typename?: 'property_folder_aggregate_fields';
  avg?: Maybe<Property_Folder_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Folder_Max_Fields>;
  min?: Maybe<Property_Folder_Min_Fields>;
  stddev?: Maybe<Property_Folder_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Folder_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Folder_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Folder_Sum_Fields>;
  var_pop?: Maybe<Property_Folder_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Folder_Var_Samp_Fields>;
  variance?: Maybe<Property_Folder_Variance_Fields>;
};


/** aggregate fields of "property_folder" */
export type Property_Folder_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Folder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Property_Folder_Avg_Fields = {
  __typename?: 'property_folder_avg_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  min_price?: Maybe<Scalars['Float']['output']>;
  nr_apartments?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "property_folder". All fields are combined with a logical 'AND'. */
export type Property_Folder_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Folder_Bool_Exp>>;
  _not?: InputMaybe<Property_Folder_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Folder_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  building_floors?: InputMaybe<Int_Comparison_Exp>;
  claimed_folder?: InputMaybe<Boolean_Comparison_Exp>;
  cluster?: InputMaybe<Property_Cluster_Enum_Comparison_Exp>;
  construction_status?: InputMaybe<Construction_Status_Enum_Comparison_Exp>;
  construction_year?: InputMaybe<String_Comparison_Exp>;
  cover_image_url?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  folder_amenities?: InputMaybe<Folder_Amenities_Bool_Exp>;
  folder_amenities_aggregate?: InputMaybe<Folder_Amenities_Aggregate_Bool_Exp>;
  folder_images?: InputMaybe<Folder_Image_Bool_Exp>;
  folder_images_aggregate?: InputMaybe<Folder_Image_Aggregate_Bool_Exp>;
  folder_properties_types?: InputMaybe<Folder_Properties_Type_Bool_Exp>;
  folder_properties_types_aggregate?: InputMaybe<Folder_Properties_Type_Aggregate_Bool_Exp>;
  geom?: InputMaybe<Geography_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  location?: InputMaybe<Location_Bool_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  main_image_url?: InputMaybe<String_Comparison_Exp>;
  min_price?: InputMaybe<Float8_Comparison_Exp>;
  nr_apartments?: InputMaybe<Int_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  parking_spaces?: InputMaybe<Int_Comparison_Exp>;
  property_lists?: InputMaybe<Property_List_Folder_Bool_Exp>;
  property_lists_aggregate?: InputMaybe<Property_List_Folder_Aggregate_Bool_Exp>;
  public_profile?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
  status?: InputMaybe<Folder_Status_Enum_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Folder_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  visibility_status?: InputMaybe<Visibility_Status_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_folder" */
export enum Property_Folder_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyFolderPkey = 'property_folder_pkey'
}

/** input type for incrementing numeric columns in table "property_folder" */
export type Property_Folder_Inc_Input = {
  building_floors?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  min_price?: InputMaybe<Scalars['float8']['input']>;
  nr_apartments?: InputMaybe<Scalars['Int']['input']>;
  parking_spaces?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_folder" */
export type Property_Folder_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  building_floors?: InputMaybe<Scalars['Int']['input']>;
  claimed_folder?: InputMaybe<Scalars['Boolean']['input']>;
  cluster?: InputMaybe<Property_Cluster_Enum>;
  construction_status?: InputMaybe<Construction_Status_Enum>;
  construction_year?: InputMaybe<Scalars['String']['input']>;
  cover_image_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  folder_amenities?: InputMaybe<Folder_Amenities_Arr_Rel_Insert_Input>;
  folder_images?: InputMaybe<Folder_Image_Arr_Rel_Insert_Input>;
  folder_properties_types?: InputMaybe<Folder_Properties_Type_Arr_Rel_Insert_Input>;
  geom?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  main_image_url?: InputMaybe<Scalars['String']['input']>;
  min_price?: InputMaybe<Scalars['float8']['input']>;
  nr_apartments?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parking_spaces?: InputMaybe<Scalars['Int']['input']>;
  property_lists?: InputMaybe<Property_List_Folder_Arr_Rel_Insert_Input>;
  public_profile?: InputMaybe<Property_Folder_Public_Profile_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Folder_Status_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Folder_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  visibility_status?: InputMaybe<Visibility_Status_Enum>;
};

/** aggregate max on columns */
export type Property_Folder_Max_Fields = {
  __typename?: 'property_folder_max_fields';
  building_floors?: Maybe<Scalars['Int']['output']>;
  construction_year?: Maybe<Scalars['String']['output']>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  created_by_user_organization_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  main_image_url?: Maybe<Scalars['String']['output']>;
  min_price?: Maybe<Scalars['float8']['output']>;
  nr_apartments?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  parking_spaces?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Property_Folder_Min_Fields = {
  __typename?: 'property_folder_min_fields';
  building_floors?: Maybe<Scalars['Int']['output']>;
  construction_year?: Maybe<Scalars['String']['output']>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  created_by_user_organization_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  main_image_url?: Maybe<Scalars['String']['output']>;
  min_price?: Maybe<Scalars['float8']['output']>;
  nr_apartments?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  parking_spaces?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "property_folder" */
export type Property_Folder_Mutation_Response = {
  __typename?: 'property_folder_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Folder>;
};

/** input type for inserting object relation for remote table "property_folder" */
export type Property_Folder_Obj_Rel_Insert_Input = {
  data: Property_Folder_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Folder_On_Conflict>;
};

/** on_conflict condition type for table "property_folder" */
export type Property_Folder_On_Conflict = {
  constraint: Property_Folder_Constraint;
  update_columns?: Array<Property_Folder_Update_Column>;
  where?: InputMaybe<Property_Folder_Bool_Exp>;
};

/** Ordering options when selecting data from "property_folder". */
export type Property_Folder_Order_By = {
  active?: InputMaybe<Order_By>;
  archived?: InputMaybe<Order_By>;
  building_floors?: InputMaybe<Order_By>;
  claimed_folder?: InputMaybe<Order_By>;
  cluster?: InputMaybe<Order_By>;
  construction_status?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  cover_image_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  created_by_user_organization_id?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  folder_amenities_aggregate?: InputMaybe<Folder_Amenities_Aggregate_Order_By>;
  folder_images_aggregate?: InputMaybe<Folder_Image_Aggregate_Order_By>;
  folder_properties_types_aggregate?: InputMaybe<Folder_Properties_Type_Aggregate_Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  location?: InputMaybe<Location_Order_By>;
  location_id?: InputMaybe<Order_By>;
  main_image_url?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  nr_apartments?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parking_spaces?: InputMaybe<Order_By>;
  property_lists_aggregate?: InputMaybe<Property_List_Folder_Aggregate_Order_By>;
  public_profile?: InputMaybe<Property_Folder_Public_Profile_Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visibility_status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_folder */
export type Property_Folder_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_Profile = {
  __typename?: 'property_folder_public_profile';
  content_json: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  faqs: Array<Property_Folder_Public_Profile_Faq>;
  /** An aggregate relationship */
  faqs_aggregate: Property_Folder_Public_Profile_Faq_Aggregate;
  folder_id: Scalars['uuid']['output'];
  /** An array relationship */
  highlights: Array<Property_Folder_Public_Profile_Highlight>;
  /** An aggregate relationship */
  highlights_aggregate: Property_Folder_Public_Profile_Highlight_Aggregate;
  id: Scalars['uuid']['output'];
  indexable: Scalars['Boolean']['output'];
  /** An array relationship */
  listing_examples: Array<Property_Folder_Public_Profile_Listing_Example>;
  /** An aggregate relationship */
  listing_examples_aggregate: Property_Folder_Public_Profile_Listing_Example_Aggregate;
  listing_href?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  nearby_places: Array<Property_Folder_Public_Profile_Nearby_Place>;
  /** An aggregate relationship */
  nearby_places_aggregate: Property_Folder_Public_Profile_Nearby_Place_Aggregate;
  /** An object relationship */
  property_folder: Property_Folder;
  published: Scalars['Boolean']['output'];
  /** An array relationship */
  related_projects: Array<Property_Folder_Public_Profile_Related>;
  /** An aggregate relationship */
  related_projects_aggregate: Property_Folder_Public_Profile_Related_Aggregate;
  sales_email?: Maybe<Scalars['String']['output']>;
  sales_phone?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** An array relationship */
  translations: Array<Property_Folder_Public_Profile_Translation>;
  /** An aggregate relationship */
  translations_aggregate: Property_Folder_Public_Profile_Translation_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  website_label?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_ProfileContent_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_ProfileFaqsArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Faq_Bool_Exp>;
};


/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_ProfileFaqs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Faq_Bool_Exp>;
};


/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_ProfileHighlightsArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Highlight_Bool_Exp>;
};


/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_ProfileHighlights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Highlight_Bool_Exp>;
};


/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_ProfileListing_ExamplesArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Bool_Exp>;
};


/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_ProfileListing_Examples_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Bool_Exp>;
};


/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_ProfileNearby_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Bool_Exp>;
};


/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_ProfileNearby_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Bool_Exp>;
};


/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_ProfileRelated_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Related_Bool_Exp>;
};


/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_ProfileRelated_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Related_Bool_Exp>;
};


/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_ProfileTranslationsArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Translation_Bool_Exp>;
};


/** columns and relationships of "property_folder_public_profile" */
export type Property_Folder_Public_ProfileTranslations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Translation_Bool_Exp>;
};

/** aggregated selection of "property_folder_public_profile" */
export type Property_Folder_Public_Profile_Aggregate = {
  __typename?: 'property_folder_public_profile_aggregate';
  aggregate?: Maybe<Property_Folder_Public_Profile_Aggregate_Fields>;
  nodes: Array<Property_Folder_Public_Profile>;
};

/** aggregate fields of "property_folder_public_profile" */
export type Property_Folder_Public_Profile_Aggregate_Fields = {
  __typename?: 'property_folder_public_profile_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Folder_Public_Profile_Max_Fields>;
  min?: Maybe<Property_Folder_Public_Profile_Min_Fields>;
};


/** aggregate fields of "property_folder_public_profile" */
export type Property_Folder_Public_Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Folder_Public_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Property_Folder_Public_Profile_Append_Input = {
  content_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "property_folder_public_profile". All fields are combined with a logical 'AND'. */
export type Property_Folder_Public_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Folder_Public_Profile_Bool_Exp>>;
  _not?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Folder_Public_Profile_Bool_Exp>>;
  content_json?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  faqs?: InputMaybe<Property_Folder_Public_Profile_Faq_Bool_Exp>;
  faqs_aggregate?: InputMaybe<Property_Folder_Public_Profile_Faq_Aggregate_Bool_Exp>;
  folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  highlights?: InputMaybe<Property_Folder_Public_Profile_Highlight_Bool_Exp>;
  highlights_aggregate?: InputMaybe<Property_Folder_Public_Profile_Highlight_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indexable?: InputMaybe<Boolean_Comparison_Exp>;
  listing_examples?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Bool_Exp>;
  listing_examples_aggregate?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Aggregate_Bool_Exp>;
  listing_href?: InputMaybe<String_Comparison_Exp>;
  nearby_places?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Bool_Exp>;
  nearby_places_aggregate?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Aggregate_Bool_Exp>;
  property_folder?: InputMaybe<Property_Folder_Bool_Exp>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
  related_projects?: InputMaybe<Property_Folder_Public_Profile_Related_Bool_Exp>;
  related_projects_aggregate?: InputMaybe<Property_Folder_Public_Profile_Related_Aggregate_Bool_Exp>;
  sales_email?: InputMaybe<String_Comparison_Exp>;
  sales_phone?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  translations?: InputMaybe<Property_Folder_Public_Profile_Translation_Bool_Exp>;
  translations_aggregate?: InputMaybe<Property_Folder_Public_Profile_Translation_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  website_label?: InputMaybe<String_Comparison_Exp>;
  website_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_folder_public_profile" */
export enum Property_Folder_Public_Profile_Constraint {
  /** unique or primary key constraint on columns "folder_id" */
  PropertyFolderPublicProfileFolderIdKey = 'property_folder_public_profile_folder_id_key',
  /** unique or primary key constraint on columns "id" */
  PropertyFolderPublicProfilePkey = 'property_folder_public_profile_pkey',
  /** unique or primary key constraint on columns "slug" */
  PropertyFolderPublicProfileSlugKey = 'property_folder_public_profile_slug_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Property_Folder_Public_Profile_Delete_At_Path_Input = {
  content_json?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Property_Folder_Public_Profile_Delete_Elem_Input = {
  content_json?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Property_Folder_Public_Profile_Delete_Key_Input = {
  content_json?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq = {
  __typename?: 'property_folder_public_profile_faq';
  answer: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  language: Languages;
  language_id: Scalars['Int']['output'];
  /** An object relationship */
  profile: Property_Folder_Public_Profile;
  profile_id: Scalars['uuid']['output'];
  question: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Aggregate = {
  __typename?: 'property_folder_public_profile_faq_aggregate';
  aggregate?: Maybe<Property_Folder_Public_Profile_Faq_Aggregate_Fields>;
  nodes: Array<Property_Folder_Public_Profile_Faq>;
};

export type Property_Folder_Public_Profile_Faq_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Folder_Public_Profile_Faq_Aggregate_Bool_Exp_Count>;
};

export type Property_Folder_Public_Profile_Faq_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Folder_Public_Profile_Faq_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Aggregate_Fields = {
  __typename?: 'property_folder_public_profile_faq_aggregate_fields';
  avg?: Maybe<Property_Folder_Public_Profile_Faq_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Folder_Public_Profile_Faq_Max_Fields>;
  min?: Maybe<Property_Folder_Public_Profile_Faq_Min_Fields>;
  stddev?: Maybe<Property_Folder_Public_Profile_Faq_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Folder_Public_Profile_Faq_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Folder_Public_Profile_Faq_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Folder_Public_Profile_Faq_Sum_Fields>;
  var_pop?: Maybe<Property_Folder_Public_Profile_Faq_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Folder_Public_Profile_Faq_Var_Samp_Fields>;
  variance?: Maybe<Property_Folder_Public_Profile_Faq_Variance_Fields>;
};


/** aggregate fields of "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Folder_Public_Profile_Faq_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Folder_Public_Profile_Faq_Max_Order_By>;
  min?: InputMaybe<Property_Folder_Public_Profile_Faq_Min_Order_By>;
  stddev?: InputMaybe<Property_Folder_Public_Profile_Faq_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Folder_Public_Profile_Faq_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Folder_Public_Profile_Faq_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Folder_Public_Profile_Faq_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Folder_Public_Profile_Faq_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Folder_Public_Profile_Faq_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Folder_Public_Profile_Faq_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Arr_Rel_Insert_Input = {
  data: Array<Property_Folder_Public_Profile_Faq_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Faq_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Folder_Public_Profile_Faq_Avg_Fields = {
  __typename?: 'property_folder_public_profile_faq_avg_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Avg_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_folder_public_profile_faq". All fields are combined with a logical 'AND'. */
export type Property_Folder_Public_Profile_Faq_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Bool_Exp>>;
  _not?: InputMaybe<Property_Folder_Public_Profile_Faq_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Bool_Exp>>;
  answer?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<Languages_Bool_Exp>;
  language_id?: InputMaybe<Int_Comparison_Exp>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  question?: InputMaybe<String_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_folder_public_profile_faq" */
export enum Property_Folder_Public_Profile_Faq_Constraint {
  /** unique or primary key constraint on columns "sort_order", "language_id", "profile_id" */
  PropertyFolderPublicProfilProfileIdLanguageIdSortKey1 = 'property_folder_public_profil_profile_id_language_id_sort__key1',
  /** unique or primary key constraint on columns "id" */
  PropertyFolderPublicProfileFaqPkey = 'property_folder_public_profile_faq_pkey'
}

/** input type for incrementing numeric columns in table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Inc_Input = {
  language_id?: InputMaybe<Scalars['Int']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Insert_Input = {
  answer?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Languages_Obj_Rel_Insert_Input>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Obj_Rel_Insert_Input>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Property_Folder_Public_Profile_Faq_Max_Fields = {
  __typename?: 'property_folder_public_profile_faq_max_fields';
  answer?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Max_Order_By = {
  answer?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Folder_Public_Profile_Faq_Min_Fields = {
  __typename?: 'property_folder_public_profile_faq_min_fields';
  answer?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Min_Order_By = {
  answer?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Mutation_Response = {
  __typename?: 'property_folder_public_profile_faq_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Folder_Public_Profile_Faq>;
};

/** on_conflict condition type for table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_On_Conflict = {
  constraint: Property_Folder_Public_Profile_Faq_Constraint;
  update_columns?: Array<Property_Folder_Public_Profile_Faq_Update_Column>;
  where?: InputMaybe<Property_Folder_Public_Profile_Faq_Bool_Exp>;
};

/** Ordering options when selecting data from "property_folder_public_profile_faq". */
export type Property_Folder_Public_Profile_Faq_Order_By = {
  answer?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Languages_Order_By>;
  language_id?: InputMaybe<Order_By>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Order_By>;
  profile_id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_folder_public_profile_faq */
export type Property_Folder_Public_Profile_Faq_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_folder_public_profile_faq" */
export enum Property_Folder_Public_Profile_Faq_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Question = 'question',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Set_Input = {
  answer?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Property_Folder_Public_Profile_Faq_Stddev_Fields = {
  __typename?: 'property_folder_public_profile_faq_stddev_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Stddev_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Folder_Public_Profile_Faq_Stddev_Pop_Fields = {
  __typename?: 'property_folder_public_profile_faq_stddev_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Stddev_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Folder_Public_Profile_Faq_Stddev_Samp_Fields = {
  __typename?: 'property_folder_public_profile_faq_stddev_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Stddev_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Folder_Public_Profile_Faq_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Folder_Public_Profile_Faq_Stream_Cursor_Value_Input = {
  answer?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Property_Folder_Public_Profile_Faq_Sum_Fields = {
  __typename?: 'property_folder_public_profile_faq_sum_fields';
  language_id?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Sum_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** update columns of table "property_folder_public_profile_faq" */
export enum Property_Folder_Public_Profile_Faq_Update_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Question = 'question',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_Folder_Public_Profile_Faq_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Folder_Public_Profile_Faq_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Folder_Public_Profile_Faq_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Folder_Public_Profile_Faq_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Folder_Public_Profile_Faq_Var_Pop_Fields = {
  __typename?: 'property_folder_public_profile_faq_var_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Var_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Folder_Public_Profile_Faq_Var_Samp_Fields = {
  __typename?: 'property_folder_public_profile_faq_var_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Var_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Folder_Public_Profile_Faq_Variance_Fields = {
  __typename?: 'property_folder_public_profile_faq_variance_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_folder_public_profile_faq" */
export type Property_Folder_Public_Profile_Faq_Variance_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight = {
  __typename?: 'property_folder_public_profile_highlight';
  created_at: Scalars['timestamptz']['output'];
  highlight: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  language: Languages;
  language_id: Scalars['Int']['output'];
  /** An object relationship */
  profile: Property_Folder_Public_Profile;
  profile_id: Scalars['uuid']['output'];
  sort_order: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Aggregate = {
  __typename?: 'property_folder_public_profile_highlight_aggregate';
  aggregate?: Maybe<Property_Folder_Public_Profile_Highlight_Aggregate_Fields>;
  nodes: Array<Property_Folder_Public_Profile_Highlight>;
};

export type Property_Folder_Public_Profile_Highlight_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Folder_Public_Profile_Highlight_Aggregate_Bool_Exp_Count>;
};

export type Property_Folder_Public_Profile_Highlight_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Folder_Public_Profile_Highlight_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Aggregate_Fields = {
  __typename?: 'property_folder_public_profile_highlight_aggregate_fields';
  avg?: Maybe<Property_Folder_Public_Profile_Highlight_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Folder_Public_Profile_Highlight_Max_Fields>;
  min?: Maybe<Property_Folder_Public_Profile_Highlight_Min_Fields>;
  stddev?: Maybe<Property_Folder_Public_Profile_Highlight_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Folder_Public_Profile_Highlight_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Folder_Public_Profile_Highlight_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Folder_Public_Profile_Highlight_Sum_Fields>;
  var_pop?: Maybe<Property_Folder_Public_Profile_Highlight_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Folder_Public_Profile_Highlight_Var_Samp_Fields>;
  variance?: Maybe<Property_Folder_Public_Profile_Highlight_Variance_Fields>;
};


/** aggregate fields of "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Folder_Public_Profile_Highlight_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Folder_Public_Profile_Highlight_Max_Order_By>;
  min?: InputMaybe<Property_Folder_Public_Profile_Highlight_Min_Order_By>;
  stddev?: InputMaybe<Property_Folder_Public_Profile_Highlight_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Folder_Public_Profile_Highlight_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Folder_Public_Profile_Highlight_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Folder_Public_Profile_Highlight_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Folder_Public_Profile_Highlight_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Folder_Public_Profile_Highlight_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Folder_Public_Profile_Highlight_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Arr_Rel_Insert_Input = {
  data: Array<Property_Folder_Public_Profile_Highlight_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Highlight_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Folder_Public_Profile_Highlight_Avg_Fields = {
  __typename?: 'property_folder_public_profile_highlight_avg_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Avg_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_folder_public_profile_highlight". All fields are combined with a logical 'AND'. */
export type Property_Folder_Public_Profile_Highlight_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Bool_Exp>>;
  _not?: InputMaybe<Property_Folder_Public_Profile_Highlight_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  highlight?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<Languages_Bool_Exp>;
  language_id?: InputMaybe<Int_Comparison_Exp>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_folder_public_profile_highlight" */
export enum Property_Folder_Public_Profile_Highlight_Constraint {
  /** unique or primary key constraint on columns "sort_order", "language_id", "profile_id" */
  PropertyFolderPublicProfilProfileIdLanguageIdSortOKey = 'property_folder_public_profil_profile_id_language_id_sort_o_key',
  /** unique or primary key constraint on columns "id" */
  PropertyFolderPublicProfileHighlightPkey = 'property_folder_public_profile_highlight_pkey'
}

/** input type for incrementing numeric columns in table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Inc_Input = {
  language_id?: InputMaybe<Scalars['Int']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  highlight?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Languages_Obj_Rel_Insert_Input>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Obj_Rel_Insert_Input>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Property_Folder_Public_Profile_Highlight_Max_Fields = {
  __typename?: 'property_folder_public_profile_highlight_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  highlight?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  highlight?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Folder_Public_Profile_Highlight_Min_Fields = {
  __typename?: 'property_folder_public_profile_highlight_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  highlight?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  highlight?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Mutation_Response = {
  __typename?: 'property_folder_public_profile_highlight_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Folder_Public_Profile_Highlight>;
};

/** on_conflict condition type for table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_On_Conflict = {
  constraint: Property_Folder_Public_Profile_Highlight_Constraint;
  update_columns?: Array<Property_Folder_Public_Profile_Highlight_Update_Column>;
  where?: InputMaybe<Property_Folder_Public_Profile_Highlight_Bool_Exp>;
};

/** Ordering options when selecting data from "property_folder_public_profile_highlight". */
export type Property_Folder_Public_Profile_Highlight_Order_By = {
  created_at?: InputMaybe<Order_By>;
  highlight?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Languages_Order_By>;
  language_id?: InputMaybe<Order_By>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Order_By>;
  profile_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_folder_public_profile_highlight */
export type Property_Folder_Public_Profile_Highlight_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_folder_public_profile_highlight" */
export enum Property_Folder_Public_Profile_Highlight_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Highlight = 'highlight',
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  highlight?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Property_Folder_Public_Profile_Highlight_Stddev_Fields = {
  __typename?: 'property_folder_public_profile_highlight_stddev_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Stddev_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Folder_Public_Profile_Highlight_Stddev_Pop_Fields = {
  __typename?: 'property_folder_public_profile_highlight_stddev_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Stddev_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Folder_Public_Profile_Highlight_Stddev_Samp_Fields = {
  __typename?: 'property_folder_public_profile_highlight_stddev_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Stddev_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Folder_Public_Profile_Highlight_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Folder_Public_Profile_Highlight_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  highlight?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Property_Folder_Public_Profile_Highlight_Sum_Fields = {
  __typename?: 'property_folder_public_profile_highlight_sum_fields';
  language_id?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Sum_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** update columns of table "property_folder_public_profile_highlight" */
export enum Property_Folder_Public_Profile_Highlight_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Highlight = 'highlight',
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_Folder_Public_Profile_Highlight_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Folder_Public_Profile_Highlight_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Folder_Public_Profile_Highlight_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Folder_Public_Profile_Highlight_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Folder_Public_Profile_Highlight_Var_Pop_Fields = {
  __typename?: 'property_folder_public_profile_highlight_var_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Var_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Folder_Public_Profile_Highlight_Var_Samp_Fields = {
  __typename?: 'property_folder_public_profile_highlight_var_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Var_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Folder_Public_Profile_Highlight_Variance_Fields = {
  __typename?: 'property_folder_public_profile_highlight_variance_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_folder_public_profile_highlight" */
export type Property_Folder_Public_Profile_Highlight_Variance_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "property_folder_public_profile" */
export type Property_Folder_Public_Profile_Insert_Input = {
  content_json?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  faqs?: InputMaybe<Property_Folder_Public_Profile_Faq_Arr_Rel_Insert_Input>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  highlights?: InputMaybe<Property_Folder_Public_Profile_Highlight_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indexable?: InputMaybe<Scalars['Boolean']['input']>;
  listing_examples?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Arr_Rel_Insert_Input>;
  listing_href?: InputMaybe<Scalars['String']['input']>;
  nearby_places?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Arr_Rel_Insert_Input>;
  property_folder?: InputMaybe<Property_Folder_Obj_Rel_Insert_Input>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  related_projects?: InputMaybe<Property_Folder_Public_Profile_Related_Arr_Rel_Insert_Input>;
  sales_email?: InputMaybe<Scalars['String']['input']>;
  sales_phone?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Property_Folder_Public_Profile_Translation_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website_label?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example = {
  __typename?: 'property_folder_public_profile_listing_example';
  area?: Maybe<Scalars['numeric']['output']>;
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  floor?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  language: Languages;
  language_id: Scalars['Int']['output'];
  price?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  profile: Property_Folder_Public_Profile;
  profile_id: Scalars['uuid']['output'];
  sort_order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Aggregate = {
  __typename?: 'property_folder_public_profile_listing_example_aggregate';
  aggregate?: Maybe<Property_Folder_Public_Profile_Listing_Example_Aggregate_Fields>;
  nodes: Array<Property_Folder_Public_Profile_Listing_Example>;
};

export type Property_Folder_Public_Profile_Listing_Example_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Aggregate_Bool_Exp_Count>;
};

export type Property_Folder_Public_Profile_Listing_Example_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Aggregate_Fields = {
  __typename?: 'property_folder_public_profile_listing_example_aggregate_fields';
  avg?: Maybe<Property_Folder_Public_Profile_Listing_Example_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Folder_Public_Profile_Listing_Example_Max_Fields>;
  min?: Maybe<Property_Folder_Public_Profile_Listing_Example_Min_Fields>;
  stddev?: Maybe<Property_Folder_Public_Profile_Listing_Example_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Folder_Public_Profile_Listing_Example_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Folder_Public_Profile_Listing_Example_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Folder_Public_Profile_Listing_Example_Sum_Fields>;
  var_pop?: Maybe<Property_Folder_Public_Profile_Listing_Example_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Folder_Public_Profile_Listing_Example_Var_Samp_Fields>;
  variance?: Maybe<Property_Folder_Public_Profile_Listing_Example_Variance_Fields>;
};


/** aggregate fields of "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Max_Order_By>;
  min?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Min_Order_By>;
  stddev?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Arr_Rel_Insert_Input = {
  data: Array<Property_Folder_Public_Profile_Listing_Example_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Folder_Public_Profile_Listing_Example_Avg_Fields = {
  __typename?: 'property_folder_public_profile_listing_example_avg_fields';
  area?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Avg_Order_By = {
  area?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  bedrooms?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_folder_public_profile_listing_example". All fields are combined with a logical 'AND'. */
export type Property_Folder_Public_Profile_Listing_Example_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Bool_Exp>>;
  _not?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Bool_Exp>>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  bathrooms?: InputMaybe<Int_Comparison_Exp>;
  bedrooms?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  floor?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  language?: InputMaybe<Languages_Bool_Exp>;
  language_id?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_folder_public_profile_listing_example" */
export enum Property_Folder_Public_Profile_Listing_Example_Constraint {
  /** unique or primary key constraint on columns "sort_order", "language_id", "profile_id" */
  PropertyFolderPublicProfilProfileIdLanguageIdSortKey3 = 'property_folder_public_profil_profile_id_language_id_sort__key3',
  /** unique or primary key constraint on columns "id" */
  PropertyFolderPublicProfileListingExamplePkey = 'property_folder_public_profile_listing_example_pkey'
}

/** input type for incrementing numeric columns in table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Inc_Input = {
  area?: InputMaybe<Scalars['numeric']['input']>;
  bathrooms?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Insert_Input = {
  area?: InputMaybe<Scalars['numeric']['input']>;
  bathrooms?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Languages_Obj_Rel_Insert_Input>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Obj_Rel_Insert_Input>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Property_Folder_Public_Profile_Listing_Example_Max_Fields = {
  __typename?: 'property_folder_public_profile_listing_example_max_fields';
  area?: Maybe<Scalars['numeric']['output']>;
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Max_Order_By = {
  area?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  bedrooms?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Folder_Public_Profile_Listing_Example_Min_Fields = {
  __typename?: 'property_folder_public_profile_listing_example_min_fields';
  area?: Maybe<Scalars['numeric']['output']>;
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Min_Order_By = {
  area?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  bedrooms?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Mutation_Response = {
  __typename?: 'property_folder_public_profile_listing_example_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Folder_Public_Profile_Listing_Example>;
};

/** on_conflict condition type for table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_On_Conflict = {
  constraint: Property_Folder_Public_Profile_Listing_Example_Constraint;
  update_columns?: Array<Property_Folder_Public_Profile_Listing_Example_Update_Column>;
  where?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Bool_Exp>;
};

/** Ordering options when selecting data from "property_folder_public_profile_listing_example". */
export type Property_Folder_Public_Profile_Listing_Example_Order_By = {
  area?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  bedrooms?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  language?: InputMaybe<Languages_Order_By>;
  language_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Order_By>;
  profile_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_folder_public_profile_listing_example */
export type Property_Folder_Public_Profile_Listing_Example_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_folder_public_profile_listing_example" */
export enum Property_Folder_Public_Profile_Listing_Example_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  Bathrooms = 'bathrooms',
  /** column name */
  Bedrooms = 'bedrooms',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Floor = 'floor',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  Price = 'price',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Set_Input = {
  area?: InputMaybe<Scalars['numeric']['input']>;
  bathrooms?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Property_Folder_Public_Profile_Listing_Example_Stddev_Fields = {
  __typename?: 'property_folder_public_profile_listing_example_stddev_fields';
  area?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Stddev_Order_By = {
  area?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  bedrooms?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Folder_Public_Profile_Listing_Example_Stddev_Pop_Fields = {
  __typename?: 'property_folder_public_profile_listing_example_stddev_pop_fields';
  area?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Stddev_Pop_Order_By = {
  area?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  bedrooms?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Folder_Public_Profile_Listing_Example_Stddev_Samp_Fields = {
  __typename?: 'property_folder_public_profile_listing_example_stddev_samp_fields';
  area?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Stddev_Samp_Order_By = {
  area?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  bedrooms?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Folder_Public_Profile_Listing_Example_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Folder_Public_Profile_Listing_Example_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['numeric']['input']>;
  bathrooms?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Property_Folder_Public_Profile_Listing_Example_Sum_Fields = {
  __typename?: 'property_folder_public_profile_listing_example_sum_fields';
  area?: Maybe<Scalars['numeric']['output']>;
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Sum_Order_By = {
  area?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  bedrooms?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** update columns of table "property_folder_public_profile_listing_example" */
export enum Property_Folder_Public_Profile_Listing_Example_Update_Column {
  /** column name */
  Area = 'area',
  /** column name */
  Bathrooms = 'bathrooms',
  /** column name */
  Bedrooms = 'bedrooms',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Floor = 'floor',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  Price = 'price',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_Folder_Public_Profile_Listing_Example_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Folder_Public_Profile_Listing_Example_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Folder_Public_Profile_Listing_Example_Var_Pop_Fields = {
  __typename?: 'property_folder_public_profile_listing_example_var_pop_fields';
  area?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Var_Pop_Order_By = {
  area?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  bedrooms?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Folder_Public_Profile_Listing_Example_Var_Samp_Fields = {
  __typename?: 'property_folder_public_profile_listing_example_var_samp_fields';
  area?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Var_Samp_Order_By = {
  area?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  bedrooms?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Folder_Public_Profile_Listing_Example_Variance_Fields = {
  __typename?: 'property_folder_public_profile_listing_example_variance_fields';
  area?: Maybe<Scalars['Float']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_folder_public_profile_listing_example" */
export type Property_Folder_Public_Profile_Listing_Example_Variance_Order_By = {
  area?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  bedrooms?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Property_Folder_Public_Profile_Max_Fields = {
  __typename?: 'property_folder_public_profile_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_href?: Maybe<Scalars['String']['output']>;
  sales_email?: Maybe<Scalars['String']['output']>;
  sales_phone?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  website_label?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Property_Folder_Public_Profile_Min_Fields = {
  __typename?: 'property_folder_public_profile_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_href?: Maybe<Scalars['String']['output']>;
  sales_email?: Maybe<Scalars['String']['output']>;
  sales_phone?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  website_label?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "property_folder_public_profile" */
export type Property_Folder_Public_Profile_Mutation_Response = {
  __typename?: 'property_folder_public_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Folder_Public_Profile>;
};

/** columns and relationships of "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place = {
  __typename?: 'property_folder_public_profile_nearby_place';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  /** An object relationship */
  language: Languages;
  language_id: Scalars['Int']['output'];
  /** An object relationship */
  profile: Property_Folder_Public_Profile;
  profile_id: Scalars['uuid']['output'];
  sort_order: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Aggregate = {
  __typename?: 'property_folder_public_profile_nearby_place_aggregate';
  aggregate?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Aggregate_Fields>;
  nodes: Array<Property_Folder_Public_Profile_Nearby_Place>;
};

export type Property_Folder_Public_Profile_Nearby_Place_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Aggregate_Bool_Exp_Count>;
};

export type Property_Folder_Public_Profile_Nearby_Place_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Aggregate_Fields = {
  __typename?: 'property_folder_public_profile_nearby_place_aggregate_fields';
  avg?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Max_Fields>;
  min?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Min_Fields>;
  stddev?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Sum_Fields>;
  var_pop?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Var_Samp_Fields>;
  variance?: Maybe<Property_Folder_Public_Profile_Nearby_Place_Variance_Fields>;
};


/** aggregate fields of "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Max_Order_By>;
  min?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Min_Order_By>;
  stddev?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Arr_Rel_Insert_Input = {
  data: Array<Property_Folder_Public_Profile_Nearby_Place_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Folder_Public_Profile_Nearby_Place_Avg_Fields = {
  __typename?: 'property_folder_public_profile_nearby_place_avg_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Avg_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_folder_public_profile_nearby_place". All fields are combined with a logical 'AND'. */
export type Property_Folder_Public_Profile_Nearby_Place_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Bool_Exp>>;
  _not?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  language?: InputMaybe<Languages_Bool_Exp>;
  language_id?: InputMaybe<Int_Comparison_Exp>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_folder_public_profile_nearby_place" */
export enum Property_Folder_Public_Profile_Nearby_Place_Constraint {
  /** unique or primary key constraint on columns "sort_order", "language_id", "profile_id" */
  PropertyFolderPublicProfilProfileIdLanguageIdSortKey2 = 'property_folder_public_profil_profile_id_language_id_sort__key2',
  /** unique or primary key constraint on columns "id" */
  PropertyFolderPublicProfileNearbyPlacePkey = 'property_folder_public_profile_nearby_place_pkey'
}

/** input type for incrementing numeric columns in table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Inc_Input = {
  language_id?: InputMaybe<Scalars['Int']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Languages_Obj_Rel_Insert_Input>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Obj_Rel_Insert_Input>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Property_Folder_Public_Profile_Nearby_Place_Max_Fields = {
  __typename?: 'property_folder_public_profile_nearby_place_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Folder_Public_Profile_Nearby_Place_Min_Fields = {
  __typename?: 'property_folder_public_profile_nearby_place_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Mutation_Response = {
  __typename?: 'property_folder_public_profile_nearby_place_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Folder_Public_Profile_Nearby_Place>;
};

/** on_conflict condition type for table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_On_Conflict = {
  constraint: Property_Folder_Public_Profile_Nearby_Place_Constraint;
  update_columns?: Array<Property_Folder_Public_Profile_Nearby_Place_Update_Column>;
  where?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Bool_Exp>;
};

/** Ordering options when selecting data from "property_folder_public_profile_nearby_place". */
export type Property_Folder_Public_Profile_Nearby_Place_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  language?: InputMaybe<Languages_Order_By>;
  language_id?: InputMaybe<Order_By>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Order_By>;
  profile_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_folder_public_profile_nearby_place */
export type Property_Folder_Public_Profile_Nearby_Place_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_folder_public_profile_nearby_place" */
export enum Property_Folder_Public_Profile_Nearby_Place_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Property_Folder_Public_Profile_Nearby_Place_Stddev_Fields = {
  __typename?: 'property_folder_public_profile_nearby_place_stddev_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Stddev_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Folder_Public_Profile_Nearby_Place_Stddev_Pop_Fields = {
  __typename?: 'property_folder_public_profile_nearby_place_stddev_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Stddev_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Folder_Public_Profile_Nearby_Place_Stddev_Samp_Fields = {
  __typename?: 'property_folder_public_profile_nearby_place_stddev_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Stddev_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Folder_Public_Profile_Nearby_Place_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Folder_Public_Profile_Nearby_Place_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Property_Folder_Public_Profile_Nearby_Place_Sum_Fields = {
  __typename?: 'property_folder_public_profile_nearby_place_sum_fields';
  language_id?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Sum_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** update columns of table "property_folder_public_profile_nearby_place" */
export enum Property_Folder_Public_Profile_Nearby_Place_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Property_Folder_Public_Profile_Nearby_Place_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Folder_Public_Profile_Nearby_Place_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Folder_Public_Profile_Nearby_Place_Var_Pop_Fields = {
  __typename?: 'property_folder_public_profile_nearby_place_var_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Var_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Folder_Public_Profile_Nearby_Place_Var_Samp_Fields = {
  __typename?: 'property_folder_public_profile_nearby_place_var_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Var_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Folder_Public_Profile_Nearby_Place_Variance_Fields = {
  __typename?: 'property_folder_public_profile_nearby_place_variance_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_folder_public_profile_nearby_place" */
export type Property_Folder_Public_Profile_Nearby_Place_Variance_Order_By = {
  language_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "property_folder_public_profile" */
export type Property_Folder_Public_Profile_Obj_Rel_Insert_Input = {
  data: Property_Folder_Public_Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_On_Conflict>;
};

/** on_conflict condition type for table "property_folder_public_profile" */
export type Property_Folder_Public_Profile_On_Conflict = {
  constraint: Property_Folder_Public_Profile_Constraint;
  update_columns?: Array<Property_Folder_Public_Profile_Update_Column>;
  where?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "property_folder_public_profile". */
export type Property_Folder_Public_Profile_Order_By = {
  content_json?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  faqs_aggregate?: InputMaybe<Property_Folder_Public_Profile_Faq_Aggregate_Order_By>;
  folder_id?: InputMaybe<Order_By>;
  highlights_aggregate?: InputMaybe<Property_Folder_Public_Profile_Highlight_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  indexable?: InputMaybe<Order_By>;
  listing_examples_aggregate?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Aggregate_Order_By>;
  listing_href?: InputMaybe<Order_By>;
  nearby_places_aggregate?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Aggregate_Order_By>;
  property_folder?: InputMaybe<Property_Folder_Order_By>;
  published?: InputMaybe<Order_By>;
  related_projects_aggregate?: InputMaybe<Property_Folder_Public_Profile_Related_Aggregate_Order_By>;
  sales_email?: InputMaybe<Order_By>;
  sales_phone?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  translations_aggregate?: InputMaybe<Property_Folder_Public_Profile_Translation_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website_label?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_folder_public_profile */
export type Property_Folder_Public_Profile_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Property_Folder_Public_Profile_Prepend_Input = {
  content_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related = {
  __typename?: 'property_folder_public_profile_related';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  profile: Property_Folder_Public_Profile;
  profile_id: Scalars['uuid']['output'];
  /** An object relationship */
  related_profile: Property_Folder_Public_Profile;
  related_profile_id: Scalars['uuid']['output'];
  sort_order: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Aggregate = {
  __typename?: 'property_folder_public_profile_related_aggregate';
  aggregate?: Maybe<Property_Folder_Public_Profile_Related_Aggregate_Fields>;
  nodes: Array<Property_Folder_Public_Profile_Related>;
};

export type Property_Folder_Public_Profile_Related_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Folder_Public_Profile_Related_Aggregate_Bool_Exp_Count>;
};

export type Property_Folder_Public_Profile_Related_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Folder_Public_Profile_Related_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Aggregate_Fields = {
  __typename?: 'property_folder_public_profile_related_aggregate_fields';
  avg?: Maybe<Property_Folder_Public_Profile_Related_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Folder_Public_Profile_Related_Max_Fields>;
  min?: Maybe<Property_Folder_Public_Profile_Related_Min_Fields>;
  stddev?: Maybe<Property_Folder_Public_Profile_Related_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Folder_Public_Profile_Related_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Folder_Public_Profile_Related_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Folder_Public_Profile_Related_Sum_Fields>;
  var_pop?: Maybe<Property_Folder_Public_Profile_Related_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Folder_Public_Profile_Related_Var_Samp_Fields>;
  variance?: Maybe<Property_Folder_Public_Profile_Related_Variance_Fields>;
};


/** aggregate fields of "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Folder_Public_Profile_Related_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Folder_Public_Profile_Related_Max_Order_By>;
  min?: InputMaybe<Property_Folder_Public_Profile_Related_Min_Order_By>;
  stddev?: InputMaybe<Property_Folder_Public_Profile_Related_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Folder_Public_Profile_Related_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Folder_Public_Profile_Related_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Folder_Public_Profile_Related_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Folder_Public_Profile_Related_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Folder_Public_Profile_Related_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Folder_Public_Profile_Related_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Arr_Rel_Insert_Input = {
  data: Array<Property_Folder_Public_Profile_Related_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Related_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Folder_Public_Profile_Related_Avg_Fields = {
  __typename?: 'property_folder_public_profile_related_avg_fields';
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Avg_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_folder_public_profile_related". All fields are combined with a logical 'AND'. */
export type Property_Folder_Public_Profile_Related_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Bool_Exp>>;
  _not?: InputMaybe<Property_Folder_Public_Profile_Related_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  related_profile?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
  related_profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_folder_public_profile_related" */
export enum Property_Folder_Public_Profile_Related_Constraint {
  /** unique or primary key constraint on columns "related_profile_id", "profile_id" */
  PropertyFolderPublicProfilProfileIdRelatedProfileIdKey = 'property_folder_public_profil_profile_id_related_profile_id_key',
  /** unique or primary key constraint on columns "sort_order", "profile_id" */
  PropertyFolderPublicProfileRelateProfileIdSortOrderKey = 'property_folder_public_profile_relate_profile_id_sort_order_key',
  /** unique or primary key constraint on columns "id" */
  PropertyFolderPublicProfileRelatedPkey = 'property_folder_public_profile_related_pkey'
}

/** input type for incrementing numeric columns in table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Inc_Input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Obj_Rel_Insert_Input>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  related_profile?: InputMaybe<Property_Folder_Public_Profile_Obj_Rel_Insert_Input>;
  related_profile_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Property_Folder_Public_Profile_Related_Max_Fields = {
  __typename?: 'property_folder_public_profile_related_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  related_profile_id?: Maybe<Scalars['uuid']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  related_profile_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Folder_Public_Profile_Related_Min_Fields = {
  __typename?: 'property_folder_public_profile_related_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  related_profile_id?: Maybe<Scalars['uuid']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  related_profile_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Mutation_Response = {
  __typename?: 'property_folder_public_profile_related_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Folder_Public_Profile_Related>;
};

/** on_conflict condition type for table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_On_Conflict = {
  constraint: Property_Folder_Public_Profile_Related_Constraint;
  update_columns?: Array<Property_Folder_Public_Profile_Related_Update_Column>;
  where?: InputMaybe<Property_Folder_Public_Profile_Related_Bool_Exp>;
};

/** Ordering options when selecting data from "property_folder_public_profile_related". */
export type Property_Folder_Public_Profile_Related_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Order_By>;
  profile_id?: InputMaybe<Order_By>;
  related_profile?: InputMaybe<Property_Folder_Public_Profile_Order_By>;
  related_profile_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_folder_public_profile_related */
export type Property_Folder_Public_Profile_Related_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_folder_public_profile_related" */
export enum Property_Folder_Public_Profile_Related_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  RelatedProfileId = 'related_profile_id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  related_profile_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Property_Folder_Public_Profile_Related_Stddev_Fields = {
  __typename?: 'property_folder_public_profile_related_stddev_fields';
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Stddev_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Folder_Public_Profile_Related_Stddev_Pop_Fields = {
  __typename?: 'property_folder_public_profile_related_stddev_pop_fields';
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Stddev_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Folder_Public_Profile_Related_Stddev_Samp_Fields = {
  __typename?: 'property_folder_public_profile_related_stddev_samp_fields';
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Stddev_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Folder_Public_Profile_Related_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Folder_Public_Profile_Related_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  related_profile_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Property_Folder_Public_Profile_Related_Sum_Fields = {
  __typename?: 'property_folder_public_profile_related_sum_fields';
  sort_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Sum_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** update columns of table "property_folder_public_profile_related" */
export enum Property_Folder_Public_Profile_Related_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  RelatedProfileId = 'related_profile_id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_Folder_Public_Profile_Related_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Folder_Public_Profile_Related_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Folder_Public_Profile_Related_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Folder_Public_Profile_Related_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Folder_Public_Profile_Related_Var_Pop_Fields = {
  __typename?: 'property_folder_public_profile_related_var_pop_fields';
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Var_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Folder_Public_Profile_Related_Var_Samp_Fields = {
  __typename?: 'property_folder_public_profile_related_var_samp_fields';
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Var_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Folder_Public_Profile_Related_Variance_Fields = {
  __typename?: 'property_folder_public_profile_related_variance_fields';
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_folder_public_profile_related" */
export type Property_Folder_Public_Profile_Related_Variance_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** select columns of table "property_folder_public_profile" */
export enum Property_Folder_Public_Profile_Select_Column {
  /** column name */
  ContentJson = 'content_json',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  Indexable = 'indexable',
  /** column name */
  ListingHref = 'listing_href',
  /** column name */
  Published = 'published',
  /** column name */
  SalesEmail = 'sales_email',
  /** column name */
  SalesPhone = 'sales_phone',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebsiteLabel = 'website_label',
  /** column name */
  WebsiteUrl = 'website_url'
}

/** input type for updating data in table "property_folder_public_profile" */
export type Property_Folder_Public_Profile_Set_Input = {
  content_json?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indexable?: InputMaybe<Scalars['Boolean']['input']>;
  listing_href?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sales_email?: InputMaybe<Scalars['String']['input']>;
  sales_phone?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website_label?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "property_folder_public_profile" */
export type Property_Folder_Public_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Folder_Public_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Folder_Public_Profile_Stream_Cursor_Value_Input = {
  content_json?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indexable?: InputMaybe<Scalars['Boolean']['input']>;
  listing_href?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sales_email?: InputMaybe<Scalars['String']['input']>;
  sales_phone?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website_label?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation = {
  __typename?: 'property_folder_public_profile_translation';
  category?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  investor_angle?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  language: Languages;
  language_id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  profile: Property_Folder_Public_Profile;
  profile_id: Scalars['uuid']['output'];
  seo_description?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  status_label?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Aggregate = {
  __typename?: 'property_folder_public_profile_translation_aggregate';
  aggregate?: Maybe<Property_Folder_Public_Profile_Translation_Aggregate_Fields>;
  nodes: Array<Property_Folder_Public_Profile_Translation>;
};

export type Property_Folder_Public_Profile_Translation_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Folder_Public_Profile_Translation_Aggregate_Bool_Exp_Count>;
};

export type Property_Folder_Public_Profile_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Folder_Public_Profile_Translation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Aggregate_Fields = {
  __typename?: 'property_folder_public_profile_translation_aggregate_fields';
  avg?: Maybe<Property_Folder_Public_Profile_Translation_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Folder_Public_Profile_Translation_Max_Fields>;
  min?: Maybe<Property_Folder_Public_Profile_Translation_Min_Fields>;
  stddev?: Maybe<Property_Folder_Public_Profile_Translation_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Folder_Public_Profile_Translation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Folder_Public_Profile_Translation_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Folder_Public_Profile_Translation_Sum_Fields>;
  var_pop?: Maybe<Property_Folder_Public_Profile_Translation_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Folder_Public_Profile_Translation_Var_Samp_Fields>;
  variance?: Maybe<Property_Folder_Public_Profile_Translation_Variance_Fields>;
};


/** aggregate fields of "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Folder_Public_Profile_Translation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Folder_Public_Profile_Translation_Max_Order_By>;
  min?: InputMaybe<Property_Folder_Public_Profile_Translation_Min_Order_By>;
  stddev?: InputMaybe<Property_Folder_Public_Profile_Translation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Folder_Public_Profile_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Folder_Public_Profile_Translation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Folder_Public_Profile_Translation_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Folder_Public_Profile_Translation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Folder_Public_Profile_Translation_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Folder_Public_Profile_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Arr_Rel_Insert_Input = {
  data: Array<Property_Folder_Public_Profile_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Folder_Public_Profile_Translation_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Folder_Public_Profile_Translation_Avg_Fields = {
  __typename?: 'property_folder_public_profile_translation_avg_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Avg_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_folder_public_profile_translation". All fields are combined with a logical 'AND'. */
export type Property_Folder_Public_Profile_Translation_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Bool_Exp>>;
  _not?: InputMaybe<Property_Folder_Public_Profile_Translation_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  headline?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  investor_angle?: InputMaybe<String_Comparison_Exp>;
  language?: InputMaybe<Languages_Bool_Exp>;
  language_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  seo_description?: InputMaybe<String_Comparison_Exp>;
  seo_title?: InputMaybe<String_Comparison_Exp>;
  status_label?: InputMaybe<String_Comparison_Exp>;
  summary?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_folder_public_profile_translation" */
export enum Property_Folder_Public_Profile_Translation_Constraint {
  /** unique or primary key constraint on columns "language_id", "profile_id" */
  PropertyFolderPublicProfileTransProfileIdLanguageIdKey = 'property_folder_public_profile_trans_profile_id_language_id_key',
  /** unique or primary key constraint on columns "id" */
  PropertyFolderPublicProfileTranslationPkey = 'property_folder_public_profile_translation_pkey'
}

/** input type for incrementing numeric columns in table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Inc_Input = {
  language_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  investor_angle?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Languages_Obj_Rel_Insert_Input>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Obj_Rel_Insert_Input>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  seo_description?: InputMaybe<Scalars['String']['input']>;
  seo_title?: InputMaybe<Scalars['String']['input']>;
  status_label?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Property_Folder_Public_Profile_Translation_Max_Fields = {
  __typename?: 'property_folder_public_profile_translation_max_fields';
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  investor_angle?: Maybe<Scalars['String']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  seo_description?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  status_label?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Max_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  headline?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  investor_angle?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  seo_description?: InputMaybe<Order_By>;
  seo_title?: InputMaybe<Order_By>;
  status_label?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Folder_Public_Profile_Translation_Min_Fields = {
  __typename?: 'property_folder_public_profile_translation_min_fields';
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  investor_angle?: Maybe<Scalars['String']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  seo_description?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  status_label?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Min_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  headline?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  investor_angle?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  seo_description?: InputMaybe<Order_By>;
  seo_title?: InputMaybe<Order_By>;
  status_label?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Mutation_Response = {
  __typename?: 'property_folder_public_profile_translation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Folder_Public_Profile_Translation>;
};

/** on_conflict condition type for table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_On_Conflict = {
  constraint: Property_Folder_Public_Profile_Translation_Constraint;
  update_columns?: Array<Property_Folder_Public_Profile_Translation_Update_Column>;
  where?: InputMaybe<Property_Folder_Public_Profile_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "property_folder_public_profile_translation". */
export type Property_Folder_Public_Profile_Translation_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  headline?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  investor_angle?: InputMaybe<Order_By>;
  language?: InputMaybe<Languages_Order_By>;
  language_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  profile?: InputMaybe<Property_Folder_Public_Profile_Order_By>;
  profile_id?: InputMaybe<Order_By>;
  seo_description?: InputMaybe<Order_By>;
  seo_title?: InputMaybe<Order_By>;
  status_label?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_folder_public_profile_translation */
export type Property_Folder_Public_Profile_Translation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_folder_public_profile_translation" */
export enum Property_Folder_Public_Profile_Translation_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Headline = 'headline',
  /** column name */
  Id = 'id',
  /** column name */
  InvestorAngle = 'investor_angle',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  Name = 'name',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  SeoDescription = 'seo_description',
  /** column name */
  SeoTitle = 'seo_title',
  /** column name */
  StatusLabel = 'status_label',
  /** column name */
  Summary = 'summary',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  investor_angle?: InputMaybe<Scalars['String']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  seo_description?: InputMaybe<Scalars['String']['input']>;
  seo_title?: InputMaybe<Scalars['String']['input']>;
  status_label?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Property_Folder_Public_Profile_Translation_Stddev_Fields = {
  __typename?: 'property_folder_public_profile_translation_stddev_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Stddev_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Folder_Public_Profile_Translation_Stddev_Pop_Fields = {
  __typename?: 'property_folder_public_profile_translation_stddev_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Stddev_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Folder_Public_Profile_Translation_Stddev_Samp_Fields = {
  __typename?: 'property_folder_public_profile_translation_stddev_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Stddev_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Folder_Public_Profile_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Folder_Public_Profile_Translation_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  investor_angle?: InputMaybe<Scalars['String']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  seo_description?: InputMaybe<Scalars['String']['input']>;
  seo_title?: InputMaybe<Scalars['String']['input']>;
  status_label?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Property_Folder_Public_Profile_Translation_Sum_Fields = {
  __typename?: 'property_folder_public_profile_translation_sum_fields';
  language_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Sum_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** update columns of table "property_folder_public_profile_translation" */
export enum Property_Folder_Public_Profile_Translation_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Headline = 'headline',
  /** column name */
  Id = 'id',
  /** column name */
  InvestorAngle = 'investor_angle',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  Name = 'name',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  SeoDescription = 'seo_description',
  /** column name */
  SeoTitle = 'seo_title',
  /** column name */
  StatusLabel = 'status_label',
  /** column name */
  Summary = 'summary',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_Folder_Public_Profile_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Folder_Public_Profile_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Folder_Public_Profile_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Folder_Public_Profile_Translation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Folder_Public_Profile_Translation_Var_Pop_Fields = {
  __typename?: 'property_folder_public_profile_translation_var_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Var_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Folder_Public_Profile_Translation_Var_Samp_Fields = {
  __typename?: 'property_folder_public_profile_translation_var_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Var_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Folder_Public_Profile_Translation_Variance_Fields = {
  __typename?: 'property_folder_public_profile_translation_variance_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_folder_public_profile_translation" */
export type Property_Folder_Public_Profile_Translation_Variance_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** update columns of table "property_folder_public_profile" */
export enum Property_Folder_Public_Profile_Update_Column {
  /** column name */
  ContentJson = 'content_json',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  Indexable = 'indexable',
  /** column name */
  ListingHref = 'listing_href',
  /** column name */
  Published = 'published',
  /** column name */
  SalesEmail = 'sales_email',
  /** column name */
  SalesPhone = 'sales_phone',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebsiteLabel = 'website_label',
  /** column name */
  WebsiteUrl = 'website_url'
}

export type Property_Folder_Public_Profile_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Property_Folder_Public_Profile_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Property_Folder_Public_Profile_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Property_Folder_Public_Profile_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Property_Folder_Public_Profile_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Property_Folder_Public_Profile_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Folder_Public_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Folder_Public_Profile_Bool_Exp;
};

/** select columns of table "property_folder" */
export enum Property_Folder_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Archived = 'archived',
  /** column name */
  BuildingFloors = 'building_floors',
  /** column name */
  ClaimedFolder = 'claimed_folder',
  /** column name */
  Cluster = 'cluster',
  /** column name */
  ConstructionStatus = 'construction_status',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CoverImageUrl = 'cover_image_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  CreatedByUserOrganizationId = 'created_by_user_organization_id',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MainImageUrl = 'main_image_url',
  /** column name */
  MinPrice = 'min_price',
  /** column name */
  NrApartments = 'nr_apartments',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ParkingSpaces = 'parking_spaces',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisibilityStatus = 'visibility_status'
}

/** input type for updating data in table "property_folder" */
export type Property_Folder_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  building_floors?: InputMaybe<Scalars['Int']['input']>;
  claimed_folder?: InputMaybe<Scalars['Boolean']['input']>;
  cluster?: InputMaybe<Property_Cluster_Enum>;
  construction_status?: InputMaybe<Construction_Status_Enum>;
  construction_year?: InputMaybe<Scalars['String']['input']>;
  cover_image_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  main_image_url?: InputMaybe<Scalars['String']['input']>;
  min_price?: InputMaybe<Scalars['float8']['input']>;
  nr_apartments?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parking_spaces?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Folder_Status_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Folder_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  visibility_status?: InputMaybe<Visibility_Status_Enum>;
};

/** aggregate stddev on columns */
export type Property_Folder_Stddev_Fields = {
  __typename?: 'property_folder_stddev_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  min_price?: Maybe<Scalars['Float']['output']>;
  nr_apartments?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Property_Folder_Stddev_Pop_Fields = {
  __typename?: 'property_folder_stddev_pop_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  min_price?: Maybe<Scalars['Float']['output']>;
  nr_apartments?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Property_Folder_Stddev_Samp_Fields = {
  __typename?: 'property_folder_stddev_samp_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  min_price?: Maybe<Scalars['Float']['output']>;
  nr_apartments?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "property_folder" */
export type Property_Folder_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Folder_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Folder_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  building_floors?: InputMaybe<Scalars['Int']['input']>;
  claimed_folder?: InputMaybe<Scalars['Boolean']['input']>;
  cluster?: InputMaybe<Property_Cluster_Enum>;
  construction_status?: InputMaybe<Construction_Status_Enum>;
  construction_year?: InputMaybe<Scalars['String']['input']>;
  cover_image_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  main_image_url?: InputMaybe<Scalars['String']['input']>;
  min_price?: InputMaybe<Scalars['float8']['input']>;
  nr_apartments?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parking_spaces?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Folder_Status_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Folder_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  visibility_status?: InputMaybe<Visibility_Status_Enum>;
};

/** aggregate sum on columns */
export type Property_Folder_Sum_Fields = {
  __typename?: 'property_folder_sum_fields';
  building_floors?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  min_price?: Maybe<Scalars['float8']['output']>;
  nr_apartments?: Maybe<Scalars['Int']['output']>;
  parking_spaces?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "property_folder" */
export enum Property_Folder_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Archived = 'archived',
  /** column name */
  BuildingFloors = 'building_floors',
  /** column name */
  ClaimedFolder = 'claimed_folder',
  /** column name */
  Cluster = 'cluster',
  /** column name */
  ConstructionStatus = 'construction_status',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CoverImageUrl = 'cover_image_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  CreatedByUserOrganizationId = 'created_by_user_organization_id',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MainImageUrl = 'main_image_url',
  /** column name */
  MinPrice = 'min_price',
  /** column name */
  NrApartments = 'nr_apartments',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ParkingSpaces = 'parking_spaces',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisibilityStatus = 'visibility_status'
}

export type Property_Folder_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Folder_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Folder_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Folder_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Folder_Var_Pop_Fields = {
  __typename?: 'property_folder_var_pop_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  min_price?: Maybe<Scalars['Float']['output']>;
  nr_apartments?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Property_Folder_Var_Samp_Fields = {
  __typename?: 'property_folder_var_samp_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  min_price?: Maybe<Scalars['Float']['output']>;
  nr_apartments?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Property_Folder_Variance_Fields = {
  __typename?: 'property_folder_variance_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  min_price?: Maybe<Scalars['Float']['output']>;
  nr_apartments?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "property_image" */
export type Property_Image = {
  __typename?: 'property_image';
  blurhash?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  image: Scalars['String']['output'];
  image_phash?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  is_main?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  origin_url?: Maybe<Scalars['String']['output']>;
  playback_id?: Maybe<Scalars['String']['output']>;
  processed?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  property?: Maybe<Property>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  property_list?: Maybe<Property_List>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  property_lists: Array<Property_List>;
  /** An aggregate relationship */
  property_lists_aggregate: Property_List_Aggregate;
  type?: Maybe<File_Type_Enum>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "property_image" */
export type Property_ImageMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "property_image" */
export type Property_ImageProperty_ListsArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


/** columns and relationships of "property_image" */
export type Property_ImageProperty_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};

/** aggregated selection of "property_image" */
export type Property_Image_Aggregate = {
  __typename?: 'property_image_aggregate';
  aggregate?: Maybe<Property_Image_Aggregate_Fields>;
  nodes: Array<Property_Image>;
};

export type Property_Image_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Property_Image_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Property_Image_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Property_Image_Aggregate_Bool_Exp_Count>;
};

export type Property_Image_Aggregate_Bool_Exp_Bool_And = {
  arguments: Property_Image_Select_Column_Property_Image_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Image_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Image_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Property_Image_Select_Column_Property_Image_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Image_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Image_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Image_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_image" */
export type Property_Image_Aggregate_Fields = {
  __typename?: 'property_image_aggregate_fields';
  avg?: Maybe<Property_Image_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Image_Max_Fields>;
  min?: Maybe<Property_Image_Min_Fields>;
  stddev?: Maybe<Property_Image_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Image_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Image_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Image_Sum_Fields>;
  var_pop?: Maybe<Property_Image_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Image_Var_Samp_Fields>;
  variance?: Maybe<Property_Image_Variance_Fields>;
};


/** aggregate fields of "property_image" */
export type Property_Image_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_image" */
export type Property_Image_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Image_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Image_Max_Order_By>;
  min?: InputMaybe<Property_Image_Min_Order_By>;
  stddev?: InputMaybe<Property_Image_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Image_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Image_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Image_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Image_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Image_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Image_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Property_Image_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "property_image" */
export type Property_Image_Arr_Rel_Insert_Input = {
  data: Array<Property_Image_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Image_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Image_Avg_Fields = {
  __typename?: 'property_image_avg_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_image" */
export type Property_Image_Avg_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_image". All fields are combined with a logical 'AND'. */
export type Property_Image_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Image_Bool_Exp>>;
  _not?: InputMaybe<Property_Image_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Image_Bool_Exp>>;
  blurhash?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  image_phash?: InputMaybe<String_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  is_main?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  origin_url?: InputMaybe<String_Comparison_Exp>;
  playback_id?: InputMaybe<String_Comparison_Exp>;
  processed?: InputMaybe<Boolean_Comparison_Exp>;
  property?: InputMaybe<Property_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_list?: InputMaybe<Property_List_Bool_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_lists?: InputMaybe<Property_List_Bool_Exp>;
  property_lists_aggregate?: InputMaybe<Property_List_Aggregate_Bool_Exp>;
  type?: InputMaybe<File_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_image" */
export enum Property_Image_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyImgrPkey = 'property_imgr_pkey',
  /** unique or primary key constraint on columns "image", "property_list_id" */
  PropertyImgrPropertyListIdImageKey = 'property_imgr_property_list_id_image_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Property_Image_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Property_Image_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Property_Image_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "property_image" */
export type Property_Image_Inc_Input = {
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_image" */
export type Property_Image_Insert_Input = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  image_phash?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  is_main?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  origin_url?: InputMaybe<Scalars['String']['input']>;
  playback_id?: InputMaybe<Scalars['String']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  property?: InputMaybe<Property_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list?: InputMaybe<Property_List_Obj_Rel_Insert_Input>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  property_lists?: InputMaybe<Property_List_Arr_Rel_Insert_Input>;
  type?: InputMaybe<File_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Property_Image_Max_Fields = {
  __typename?: 'property_image_max_fields';
  blurhash?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  image_phash?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  origin_url?: Maybe<Scalars['String']['output']>;
  playback_id?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property_image" */
export type Property_Image_Max_Order_By = {
  blurhash?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  image_phash?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  origin_url?: InputMaybe<Order_By>;
  playback_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Image_Min_Fields = {
  __typename?: 'property_image_min_fields';
  blurhash?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  image_phash?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  origin_url?: Maybe<Scalars['String']['output']>;
  playback_id?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property_image" */
export type Property_Image_Min_Order_By = {
  blurhash?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  image_phash?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  origin_url?: InputMaybe<Order_By>;
  playback_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_image" */
export type Property_Image_Mutation_Response = {
  __typename?: 'property_image_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Image>;
};

/** input type for inserting object relation for remote table "property_image" */
export type Property_Image_Obj_Rel_Insert_Input = {
  data: Property_Image_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Image_On_Conflict>;
};

/** on_conflict condition type for table "property_image" */
export type Property_Image_On_Conflict = {
  constraint: Property_Image_Constraint;
  update_columns?: Array<Property_Image_Update_Column>;
  where?: InputMaybe<Property_Image_Bool_Exp>;
};

/** Ordering options when selecting data from "property_image". */
export type Property_Image_Order_By = {
  blurhash?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  image_phash?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  is_main?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  origin_url?: InputMaybe<Order_By>;
  playback_id?: InputMaybe<Order_By>;
  processed?: InputMaybe<Order_By>;
  property?: InputMaybe<Property_Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_list?: InputMaybe<Property_List_Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  property_lists_aggregate?: InputMaybe<Property_List_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_image */
export type Property_Image_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Property_Image_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "property_image" */
export enum Property_Image_Select_Column {
  /** column name */
  Blurhash = 'blurhash',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  ImagePhash = 'image_phash',
  /** column name */
  Index = 'index',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OriginUrl = 'origin_url',
  /** column name */
  PlaybackId = 'playback_id',
  /** column name */
  Processed = 'processed',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "property_image_aggregate_bool_exp_bool_and_arguments_columns" columns of table "property_image" */
export enum Property_Image_Select_Column_Property_Image_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsMain = 'is_main',
  /** column name */
  Processed = 'processed'
}

/** select "property_image_aggregate_bool_exp_bool_or_arguments_columns" columns of table "property_image" */
export enum Property_Image_Select_Column_Property_Image_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsMain = 'is_main',
  /** column name */
  Processed = 'processed'
}

/** input type for updating data in table "property_image" */
export type Property_Image_Set_Input = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  image_phash?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  is_main?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  origin_url?: InputMaybe<Scalars['String']['input']>;
  playback_id?: InputMaybe<Scalars['String']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<File_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Property_Image_Stddev_Fields = {
  __typename?: 'property_image_stddev_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_image" */
export type Property_Image_Stddev_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Image_Stddev_Pop_Fields = {
  __typename?: 'property_image_stddev_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_image" */
export type Property_Image_Stddev_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Image_Stddev_Samp_Fields = {
  __typename?: 'property_image_stddev_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_image" */
export type Property_Image_Stddev_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_image" */
export type Property_Image_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Image_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Image_Stream_Cursor_Value_Input = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  image_phash?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  is_main?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  origin_url?: InputMaybe<Scalars['String']['input']>;
  playback_id?: InputMaybe<Scalars['String']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<File_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Property_Image_Sum_Fields = {
  __typename?: 'property_image_sum_fields';
  index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_image" */
export type Property_Image_Sum_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** update columns of table "property_image" */
export enum Property_Image_Update_Column {
  /** column name */
  Blurhash = 'blurhash',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  ImagePhash = 'image_phash',
  /** column name */
  Index = 'index',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OriginUrl = 'origin_url',
  /** column name */
  PlaybackId = 'playback_id',
  /** column name */
  Processed = 'processed',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_Image_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Property_Image_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Property_Image_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Property_Image_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Property_Image_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Image_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Property_Image_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Image_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Image_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Image_Var_Pop_Fields = {
  __typename?: 'property_image_var_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_image" */
export type Property_Image_Var_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Image_Var_Samp_Fields = {
  __typename?: 'property_image_var_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_image" */
export type Property_Image_Var_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Image_Variance_Fields = {
  __typename?: 'property_image_variance_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_image" */
export type Property_Image_Variance_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "property" */
export type Property_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  json_ld?: InputMaybe<Scalars['String']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  main_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  main_property?: InputMaybe<Property_List_Obj_Rel_Insert_Input>;
  property_features?: InputMaybe<Property_Feature_Arr_Rel_Insert_Input>;
  property_images?: InputMaybe<Property_Image_Arr_Rel_Insert_Input>;
  property_lists?: InputMaybe<Property_List_Arr_Rel_Insert_Input>;
  property_price_histories?: InputMaybe<Property_Price_History_Arr_Rel_Insert_Input>;
  property_views?: InputMaybe<Property_Views_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url_slugs?: InputMaybe<Url_Slug_Arr_Rel_Insert_Input>;
  user_saved_properties?: InputMaybe<User_Saved_Properties_Arr_Rel_Insert_Input>;
  user_seen_properties?: InputMaybe<User_Seen_Property_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "property_list" */
export type Property_List = {
  __typename?: 'property_list';
  archived?: Maybe<Scalars['Boolean']['output']>;
  building_floors?: Maybe<Scalars['Int']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  construction_status?: Maybe<Construction_Status_Enum>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  contact?: Maybe<Contact>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone_1?: Maybe<Scalars['String']['output']>;
  contact_phone_2?: Maybe<Scalars['String']['output']>;
  contact_phone_clicked?: Maybe<Scalars['Int']['output']>;
  content_location?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  description_text_content?: Maybe<Text_Content>;
  disapproved_comment?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "get_property_abbrv_features" */
  features?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "get_property_features" */
  features_array?: Maybe<Scalars['jsonb']['output']>;
  features_json?: Maybe<Scalars['jsonb']['output']>;
  floor?: Maybe<Scalars['Int']['output']>;
  furnishing_status?: Maybe<Furnishing_Status_Enum>;
  /** An object relationship */
  generated_title?: Maybe<Text_Content>;
  generated_title_id?: Maybe<Scalars['uuid']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_carport?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_parking_space?: Maybe<Scalars['Boolean']['output']>;
  has_property_title?: Maybe<Scalars['Boolean']['output']>;
  has_terrace?: Maybe<Scalars['Boolean']['output']>;
  heating_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_barrier_free?: Maybe<Scalars['Boolean']['output']>;
  json_ld?: Maybe<Scalars['jsonb']['output']>;
  last_renovation_year?: Maybe<Scalars['Int']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  lister_id?: Maybe<Scalars['uuid']['output']>;
  living_area?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  lot_size?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  main_image?: Maybe<Property_Image>;
  main_image_id?: Maybe<Scalars['uuid']['output']>;
  organization?: Maybe<Organization>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  parent_property?: Maybe<Scalars['uuid']['output']>;
  parking_spaces?: Maybe<Scalars['Int']['output']>;
  parking_type?: Maybe<Parking_Type_Enum>;
  pets_allowed?: Maybe<Scalars['Boolean']['output']>;
  plot_area?: Maybe<Scalars['float8']['output']>;
  posted_at?: Maybe<Scalars['date']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  price_currency?: Maybe<Currency_Enum>;
  /** A computed field, executes function "price_exchanged" */
  price_exchange?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  properties: Array<Property>;
  /** An aggregate relationship */
  properties_aggregate: Property_Aggregate;
  /** An object relationship */
  property?: Maybe<Property>;
  /** An object relationship */
  property_composition?: Maybe<Property_Composition>;
  property_composition_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  property_features: Array<Property_Feature>;
  /** An aggregate relationship */
  property_features_aggregate: Property_Feature_Aggregate;
  /** An array relationship */
  property_images: Array<Property_Image>;
  /** An aggregate relationship */
  property_images_aggregate: Property_Image_Aggregate;
  /** An array relationship */
  property_list_folders: Array<Property_List_Folder>;
  /** An aggregate relationship */
  property_list_folders_aggregate: Property_List_Folder_Aggregate;
  property_origin_type?: Maybe<Property_Origin_Type_Enum>;
  /** An array relationship */
  property_price_histories: Array<Property_Price_History>;
  /** An aggregate relationship */
  property_price_histories_aggregate: Property_Price_History_Aggregate;
  /** An object relationship */
  property_source?: Maybe<Property_Source>;
  property_status?: Maybe<Property_Status_Enum>;
  property_type?: Maybe<Property_Type_Enum>;
  /** An object relationship */
  property_type_rel?: Maybe<Property_Type>;
  rental_terms?: Maybe<Scalars['String']['output']>;
  sale_terms?: Maybe<Scalars['String']['output']>;
  search_vector?: Maybe<Scalars['String']['output']>;
  smoking_allowed?: Maybe<Scalars['Boolean']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  source_url?: Maybe<Scalars['String']['output']>;
  source_url_clicked?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "is_property_sponsored" */
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  sponsored_property_lists: Array<Sponsored_Property_List>;
  /** An aggregate relationship */
  sponsored_property_lists_aggregate: Sponsored_Property_List_Aggregate;
  task_id?: Maybe<Scalars['String']['output']>;
  title_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  title_text_content?: Maybe<Text_Content>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: Maybe<Scalars['Int']['output']>;
  total_area?: Maybe<Scalars['float8']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  views?: Maybe<Scalars['Int']['output']>;
  visibility_status?: Maybe<Visibility_Status_Enum>;
};


/** columns and relationships of "property_list" */
export type Property_ListFeaturesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "property_list" */
export type Property_ListFeatures_ArrayArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "property_list" */
export type Property_ListFeatures_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "property_list" */
export type Property_ListJson_LdArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "property_list" */
export type Property_ListPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


/** columns and relationships of "property_list" */
export type Property_ListProperties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


/** columns and relationships of "property_list" */
export type Property_ListProperty_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Property_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Feature_Order_By>>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};


/** columns and relationships of "property_list" */
export type Property_ListProperty_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Feature_Order_By>>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};


/** columns and relationships of "property_list" */
export type Property_ListProperty_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Property_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Image_Order_By>>;
  where?: InputMaybe<Property_Image_Bool_Exp>;
};


/** columns and relationships of "property_list" */
export type Property_ListProperty_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Image_Order_By>>;
  where?: InputMaybe<Property_Image_Bool_Exp>;
};


/** columns and relationships of "property_list" */
export type Property_ListProperty_List_FoldersArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Folder_Order_By>>;
  where?: InputMaybe<Property_List_Folder_Bool_Exp>;
};


/** columns and relationships of "property_list" */
export type Property_ListProperty_List_Folders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Folder_Order_By>>;
  where?: InputMaybe<Property_List_Folder_Bool_Exp>;
};


/** columns and relationships of "property_list" */
export type Property_ListProperty_Price_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Property_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Price_History_Order_By>>;
  where?: InputMaybe<Property_Price_History_Bool_Exp>;
};


/** columns and relationships of "property_list" */
export type Property_ListProperty_Price_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Price_History_Order_By>>;
  where?: InputMaybe<Property_Price_History_Bool_Exp>;
};


/** columns and relationships of "property_list" */
export type Property_ListSponsored_Property_ListsArgs = {
  distinct_on?: InputMaybe<Array<Sponsored_Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sponsored_Property_List_Order_By>>;
  where?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
};


/** columns and relationships of "property_list" */
export type Property_ListSponsored_Property_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsored_Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sponsored_Property_List_Order_By>>;
  where?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
};

export type Property_List_ActionType = {
  __typename?: 'property_list_ActionType';
  building_floors?: Maybe<Scalars['Int']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  construction_status?: Maybe<Construction_Status_ActionType>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone_1?: Maybe<Scalars['String']['output']>;
  contact_phone_2?: Maybe<Scalars['String']['output']>;
  content_location?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description_id: Scalars['uuid']['output'];
  features_json?: Maybe<Scalars['jsonb']['output']>;
  floor?: Maybe<Scalars['Int']['output']>;
  furnishing_status?: Maybe<Furnishing_Status_ActionType>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_carport?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_parking_space?: Maybe<Scalars['Boolean']['output']>;
  has_terrace?: Maybe<Scalars['Boolean']['output']>;
  heating_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_barrier_free?: Maybe<Scalars['Boolean']['output']>;
  is_main_listing?: Maybe<Scalars['Boolean']['output']>;
  json_ld?: Maybe<Scalars['jsonb']['output']>;
  last_renovation_year?: Maybe<Scalars['Int']['output']>;
  last_seen: Scalars['timestamptz']['output'];
  living_area?: Maybe<Scalars['float8']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  lot_size?: Maybe<Scalars['String']['output']>;
  main_image?: Maybe<MainImage_Action_Type>;
  main_image_id?: Maybe<Scalars['uuid']['output']>;
  parent_property?: Maybe<Scalars['uuid']['output']>;
  parking_spaces?: Maybe<Scalars['Int']['output']>;
  parking_type?: Maybe<Parking_Type_ActionType>;
  pets_allowed?: Maybe<Scalars['Boolean']['output']>;
  plot_area?: Maybe<Scalars['float8']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  price_currency?: Maybe<Currency_ActionType>;
  property?: Maybe<Property_ActionType>;
  property_composition?: Maybe<Property_Composition_ActionType>;
  property_composition_id?: Maybe<Scalars['uuid']['output']>;
  property_origin_type?: Maybe<Property_Origin_Type_ActionType>;
  property_status?: Maybe<Property_Status_ActionType>;
  property_type?: Maybe<Property_Type_ActionType>;
  rental_terms?: Maybe<Scalars['String']['output']>;
  sale_terms?: Maybe<Scalars['String']['output']>;
  search_vector?: Maybe<Scalars['String']['output']>;
  seo_description?: Maybe<Scalars['String']['output']>;
  seo_keywords?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  smoking_allowed?: Maybe<Scalars['Boolean']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  source_url?: Maybe<Scalars['String']['output']>;
  title_id: Scalars['uuid']['output'];
  title_text_content?: Maybe<TitleTextContent_Action_Type>;
  total_area?: Maybe<Scalars['float8']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "property_list_activity" */
export type Property_List_Activity = {
  __typename?: 'property_list_activity';
  attribute_changed?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  done_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  new_json?: Maybe<Scalars['jsonb']['output']>;
  new_value?: Maybe<Scalars['String']['output']>;
  old_json?: Maybe<Scalars['jsonb']['output']>;
  old_value?: Maybe<Scalars['String']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "property_list_activity" */
export type Property_List_ActivityNew_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "property_list_activity" */
export type Property_List_ActivityOld_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "property_list_activity" */
export type Property_List_Activity_Aggregate = {
  __typename?: 'property_list_activity_aggregate';
  aggregate?: Maybe<Property_List_Activity_Aggregate_Fields>;
  nodes: Array<Property_List_Activity>;
};

/** aggregate fields of "property_list_activity" */
export type Property_List_Activity_Aggregate_Fields = {
  __typename?: 'property_list_activity_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_List_Activity_Max_Fields>;
  min?: Maybe<Property_List_Activity_Min_Fields>;
};


/** aggregate fields of "property_list_activity" */
export type Property_List_Activity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_List_Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Property_List_Activity_Append_Input = {
  new_json?: InputMaybe<Scalars['jsonb']['input']>;
  old_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "property_list_activity". All fields are combined with a logical 'AND'. */
export type Property_List_Activity_Bool_Exp = {
  _and?: InputMaybe<Array<Property_List_Activity_Bool_Exp>>;
  _not?: InputMaybe<Property_List_Activity_Bool_Exp>;
  _or?: InputMaybe<Array<Property_List_Activity_Bool_Exp>>;
  attribute_changed?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  done_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  new_json?: InputMaybe<Jsonb_Comparison_Exp>;
  new_value?: InputMaybe<String_Comparison_Exp>;
  old_json?: InputMaybe<Jsonb_Comparison_Exp>;
  old_value?: InputMaybe<String_Comparison_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_list_activity" */
export enum Property_List_Activity_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyListActivityPkey = 'property_list_activity_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Property_List_Activity_Delete_At_Path_Input = {
  new_json?: InputMaybe<Array<Scalars['String']['input']>>;
  old_json?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Property_List_Activity_Delete_Elem_Input = {
  new_json?: InputMaybe<Scalars['Int']['input']>;
  old_json?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Property_List_Activity_Delete_Key_Input = {
  new_json?: InputMaybe<Scalars['String']['input']>;
  old_json?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "property_list_activity" */
export type Property_List_Activity_Insert_Input = {
  attribute_changed?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  done_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  new_json?: InputMaybe<Scalars['jsonb']['input']>;
  new_value?: InputMaybe<Scalars['String']['input']>;
  old_json?: InputMaybe<Scalars['jsonb']['input']>;
  old_value?: InputMaybe<Scalars['String']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Property_List_Activity_Max_Fields = {
  __typename?: 'property_list_activity_max_fields';
  attribute_changed?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  done_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  new_value?: Maybe<Scalars['String']['output']>;
  old_value?: Maybe<Scalars['String']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Property_List_Activity_Min_Fields = {
  __typename?: 'property_list_activity_min_fields';
  attribute_changed?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  done_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  new_value?: Maybe<Scalars['String']['output']>;
  old_value?: Maybe<Scalars['String']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "property_list_activity" */
export type Property_List_Activity_Mutation_Response = {
  __typename?: 'property_list_activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_List_Activity>;
};

/** on_conflict condition type for table "property_list_activity" */
export type Property_List_Activity_On_Conflict = {
  constraint: Property_List_Activity_Constraint;
  update_columns?: Array<Property_List_Activity_Update_Column>;
  where?: InputMaybe<Property_List_Activity_Bool_Exp>;
};

/** Ordering options when selecting data from "property_list_activity". */
export type Property_List_Activity_Order_By = {
  attribute_changed?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  done_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_json?: InputMaybe<Order_By>;
  new_value?: InputMaybe<Order_By>;
  old_json?: InputMaybe<Order_By>;
  old_value?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_list_activity */
export type Property_List_Activity_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Property_List_Activity_Prepend_Input = {
  new_json?: InputMaybe<Scalars['jsonb']['input']>;
  old_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "property_list_activity" */
export enum Property_List_Activity_Select_Column {
  /** column name */
  AttributeChanged = 'attribute_changed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DoneByUserId = 'done_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  NewJson = 'new_json',
  /** column name */
  NewValue = 'new_value',
  /** column name */
  OldJson = 'old_json',
  /** column name */
  OldValue = 'old_value',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "property_list_activity" */
export type Property_List_Activity_Set_Input = {
  attribute_changed?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  done_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  new_json?: InputMaybe<Scalars['jsonb']['input']>;
  new_value?: InputMaybe<Scalars['String']['input']>;
  old_json?: InputMaybe<Scalars['jsonb']['input']>;
  old_value?: InputMaybe<Scalars['String']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "property_list_activity" */
export type Property_List_Activity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_List_Activity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_List_Activity_Stream_Cursor_Value_Input = {
  attribute_changed?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  done_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  new_json?: InputMaybe<Scalars['jsonb']['input']>;
  new_value?: InputMaybe<Scalars['String']['input']>;
  old_json?: InputMaybe<Scalars['jsonb']['input']>;
  old_value?: InputMaybe<Scalars['String']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "property_list_activity" */
export enum Property_List_Activity_Update_Column {
  /** column name */
  AttributeChanged = 'attribute_changed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DoneByUserId = 'done_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  NewJson = 'new_json',
  /** column name */
  NewValue = 'new_value',
  /** column name */
  OldJson = 'old_json',
  /** column name */
  OldValue = 'old_value',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_List_Activity_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Property_List_Activity_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Property_List_Activity_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Property_List_Activity_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Property_List_Activity_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Property_List_Activity_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_List_Activity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_List_Activity_Bool_Exp;
};

/** aggregated selection of "property_list" */
export type Property_List_Aggregate = {
  __typename?: 'property_list_aggregate';
  aggregate?: Maybe<Property_List_Aggregate_Fields>;
  nodes: Array<Property_List>;
};

export type Property_List_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Property_List_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Property_List_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Property_List_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Property_List_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Property_List_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Property_List_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Property_List_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Property_List_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Property_List_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Property_List_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Property_List_Aggregate_Bool_Exp_Var_Samp>;
};

export type Property_List_Aggregate_Bool_Exp_Avg = {
  arguments: Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_List_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_List_Aggregate_Bool_Exp_Bool_And = {
  arguments: Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_List_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_List_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_List_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_List_Aggregate_Bool_Exp_Corr = {
  arguments: Property_List_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_List_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_List_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Property_List_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_List_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Property_List_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Property_List_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_List_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_List_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Property_List_Aggregate_Bool_Exp_Max = {
  arguments: Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_List_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_List_Aggregate_Bool_Exp_Min = {
  arguments: Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_List_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_List_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_List_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_List_Aggregate_Bool_Exp_Sum = {
  arguments: Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_List_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_List_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_List_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "property_list" */
export type Property_List_Aggregate_Fields = {
  __typename?: 'property_list_aggregate_fields';
  avg?: Maybe<Property_List_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_List_Max_Fields>;
  min?: Maybe<Property_List_Min_Fields>;
  stddev?: Maybe<Property_List_Stddev_Fields>;
  stddev_pop?: Maybe<Property_List_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_List_Stddev_Samp_Fields>;
  sum?: Maybe<Property_List_Sum_Fields>;
  var_pop?: Maybe<Property_List_Var_Pop_Fields>;
  var_samp?: Maybe<Property_List_Var_Samp_Fields>;
  variance?: Maybe<Property_List_Variance_Fields>;
};


/** aggregate fields of "property_list" */
export type Property_List_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_list" */
export type Property_List_Aggregate_Order_By = {
  avg?: InputMaybe<Property_List_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_List_Max_Order_By>;
  min?: InputMaybe<Property_List_Min_Order_By>;
  stddev?: InputMaybe<Property_List_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_List_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_List_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_List_Sum_Order_By>;
  var_pop?: InputMaybe<Property_List_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_List_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_List_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Property_List_Append_Input = {
  features_json?: InputMaybe<Scalars['jsonb']['input']>;
  json_ld?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "property_list" */
export type Property_List_Arr_Rel_Insert_Input = {
  data: Array<Property_List_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_List_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_List_Avg_Fields = {
  __typename?: 'property_list_avg_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  contact_phone_clicked?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "price_exchanged" */
  price_exchange?: Maybe<Scalars['numeric']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_list" */
export type Property_List_Avg_Order_By = {
  building_floors?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  contact_phone_clicked?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  last_renovation_year?: InputMaybe<Order_By>;
  living_area?: InputMaybe<Order_By>;
  parking_spaces?: InputMaybe<Order_By>;
  plot_area?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  source_url_clicked?: InputMaybe<Order_By>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Order_By>;
  total_area?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_list". All fields are combined with a logical 'AND'. */
export type Property_List_Bool_Exp = {
  _and?: InputMaybe<Array<Property_List_Bool_Exp>>;
  _not?: InputMaybe<Property_List_Bool_Exp>;
  _or?: InputMaybe<Array<Property_List_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  building_floors?: InputMaybe<Int_Comparison_Exp>;
  canonical_url?: InputMaybe<String_Comparison_Exp>;
  construction_status?: InputMaybe<Construction_Status_Enum_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact_name?: InputMaybe<String_Comparison_Exp>;
  contact_phone_1?: InputMaybe<String_Comparison_Exp>;
  contact_phone_2?: InputMaybe<String_Comparison_Exp>;
  contact_phone_clicked?: InputMaybe<Int_Comparison_Exp>;
  content_location?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  description_id?: InputMaybe<Uuid_Comparison_Exp>;
  description_text_content?: InputMaybe<Text_Content_Bool_Exp>;
  disapproved_comment?: InputMaybe<String_Comparison_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  features?: InputMaybe<Jsonb_Comparison_Exp>;
  features_array?: InputMaybe<Jsonb_Comparison_Exp>;
  features_json?: InputMaybe<Jsonb_Comparison_Exp>;
  floor?: InputMaybe<Int_Comparison_Exp>;
  furnishing_status?: InputMaybe<Furnishing_Status_Enum_Comparison_Exp>;
  generated_title?: InputMaybe<Text_Content_Bool_Exp>;
  generated_title_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_carport?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking_space?: InputMaybe<Boolean_Comparison_Exp>;
  has_property_title?: InputMaybe<Boolean_Comparison_Exp>;
  has_terrace?: InputMaybe<Boolean_Comparison_Exp>;
  heating_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_barrier_free?: InputMaybe<Boolean_Comparison_Exp>;
  json_ld?: InputMaybe<Jsonb_Comparison_Exp>;
  last_renovation_year?: InputMaybe<Int_Comparison_Exp>;
  last_seen?: InputMaybe<Timestamptz_Comparison_Exp>;
  lister_id?: InputMaybe<Uuid_Comparison_Exp>;
  living_area?: InputMaybe<Float8_Comparison_Exp>;
  location?: InputMaybe<Location_Bool_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_size?: InputMaybe<String_Comparison_Exp>;
  main_image?: InputMaybe<Property_Image_Bool_Exp>;
  main_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_property?: InputMaybe<Uuid_Comparison_Exp>;
  parking_spaces?: InputMaybe<Int_Comparison_Exp>;
  parking_type?: InputMaybe<Parking_Type_Enum_Comparison_Exp>;
  pets_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  plot_area?: InputMaybe<Float8_Comparison_Exp>;
  posted_at?: InputMaybe<Date_Comparison_Exp>;
  price?: InputMaybe<Float8_Comparison_Exp>;
  price_currency?: InputMaybe<Currency_Enum_Comparison_Exp>;
  price_exchange?: InputMaybe<Numeric_Comparison_Exp>;
  properties?: InputMaybe<Property_Bool_Exp>;
  properties_aggregate?: InputMaybe<Property_Aggregate_Bool_Exp>;
  property?: InputMaybe<Property_Bool_Exp>;
  property_composition?: InputMaybe<Property_Composition_Bool_Exp>;
  property_composition_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_features?: InputMaybe<Property_Feature_Bool_Exp>;
  property_features_aggregate?: InputMaybe<Property_Feature_Aggregate_Bool_Exp>;
  property_images?: InputMaybe<Property_Image_Bool_Exp>;
  property_images_aggregate?: InputMaybe<Property_Image_Aggregate_Bool_Exp>;
  property_list_folders?: InputMaybe<Property_List_Folder_Bool_Exp>;
  property_list_folders_aggregate?: InputMaybe<Property_List_Folder_Aggregate_Bool_Exp>;
  property_origin_type?: InputMaybe<Property_Origin_Type_Enum_Comparison_Exp>;
  property_price_histories?: InputMaybe<Property_Price_History_Bool_Exp>;
  property_price_histories_aggregate?: InputMaybe<Property_Price_History_Aggregate_Bool_Exp>;
  property_source?: InputMaybe<Property_Source_Bool_Exp>;
  property_status?: InputMaybe<Property_Status_Enum_Comparison_Exp>;
  property_type?: InputMaybe<Property_Type_Enum_Comparison_Exp>;
  property_type_rel?: InputMaybe<Property_Type_Bool_Exp>;
  rental_terms?: InputMaybe<String_Comparison_Exp>;
  sale_terms?: InputMaybe<String_Comparison_Exp>;
  search_vector?: InputMaybe<String_Comparison_Exp>;
  smoking_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  source_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_url?: InputMaybe<String_Comparison_Exp>;
  source_url_clicked?: InputMaybe<Int_Comparison_Exp>;
  sponsored?: InputMaybe<Boolean_Comparison_Exp>;
  sponsored_property_lists?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
  sponsored_property_lists_aggregate?: InputMaybe<Sponsored_Property_List_Aggregate_Bool_Exp>;
  task_id?: InputMaybe<String_Comparison_Exp>;
  title_id?: InputMaybe<Uuid_Comparison_Exp>;
  title_text_content?: InputMaybe<Text_Content_Bool_Exp>;
  total_activity?: InputMaybe<Int_Comparison_Exp>;
  total_area?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  views?: InputMaybe<Int_Comparison_Exp>;
  visibility_status?: InputMaybe<Visibility_Status_Enum_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "property_list". All fields are combined with a logical 'AND'. */
export type Property_List_Bool_Exp_Remote_Rel_Organizationproperties = {
  _and?: InputMaybe<Array<Property_List_Bool_Exp>>;
  _not?: InputMaybe<Property_List_Bool_Exp>;
  _or?: InputMaybe<Array<Property_List_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  building_floors?: InputMaybe<Int_Comparison_Exp>;
  canonical_url?: InputMaybe<String_Comparison_Exp>;
  construction_status?: InputMaybe<Construction_Status_Enum_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact_name?: InputMaybe<String_Comparison_Exp>;
  contact_phone_1?: InputMaybe<String_Comparison_Exp>;
  contact_phone_2?: InputMaybe<String_Comparison_Exp>;
  contact_phone_clicked?: InputMaybe<Int_Comparison_Exp>;
  content_location?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  description_id?: InputMaybe<Uuid_Comparison_Exp>;
  description_text_content?: InputMaybe<Text_Content_Bool_Exp>;
  disapproved_comment?: InputMaybe<String_Comparison_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  features?: InputMaybe<Jsonb_Comparison_Exp>;
  features_array?: InputMaybe<Jsonb_Comparison_Exp>;
  features_json?: InputMaybe<Jsonb_Comparison_Exp>;
  floor?: InputMaybe<Int_Comparison_Exp>;
  furnishing_status?: InputMaybe<Furnishing_Status_Enum_Comparison_Exp>;
  generated_title?: InputMaybe<Text_Content_Bool_Exp>;
  generated_title_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_carport?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking_space?: InputMaybe<Boolean_Comparison_Exp>;
  has_property_title?: InputMaybe<Boolean_Comparison_Exp>;
  has_terrace?: InputMaybe<Boolean_Comparison_Exp>;
  heating_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_barrier_free?: InputMaybe<Boolean_Comparison_Exp>;
  json_ld?: InputMaybe<Jsonb_Comparison_Exp>;
  last_renovation_year?: InputMaybe<Int_Comparison_Exp>;
  last_seen?: InputMaybe<Timestamptz_Comparison_Exp>;
  lister_id?: InputMaybe<Uuid_Comparison_Exp>;
  living_area?: InputMaybe<Float8_Comparison_Exp>;
  location?: InputMaybe<Location_Bool_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_size?: InputMaybe<String_Comparison_Exp>;
  main_image?: InputMaybe<Property_Image_Bool_Exp>;
  main_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp_Remote_Rel_Organizationproperties>;
  parent_property?: InputMaybe<Uuid_Comparison_Exp>;
  parking_spaces?: InputMaybe<Int_Comparison_Exp>;
  parking_type?: InputMaybe<Parking_Type_Enum_Comparison_Exp>;
  pets_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  plot_area?: InputMaybe<Float8_Comparison_Exp>;
  posted_at?: InputMaybe<Date_Comparison_Exp>;
  price?: InputMaybe<Float8_Comparison_Exp>;
  price_currency?: InputMaybe<Currency_Enum_Comparison_Exp>;
  price_exchange?: InputMaybe<Numeric_Comparison_Exp>;
  properties?: InputMaybe<Property_Bool_Exp>;
  properties_aggregate?: InputMaybe<Property_Aggregate_Bool_Exp>;
  property?: InputMaybe<Property_Bool_Exp>;
  property_composition?: InputMaybe<Property_Composition_Bool_Exp>;
  property_composition_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_features?: InputMaybe<Property_Feature_Bool_Exp>;
  property_features_aggregate?: InputMaybe<Property_Feature_Aggregate_Bool_Exp>;
  property_images?: InputMaybe<Property_Image_Bool_Exp>;
  property_images_aggregate?: InputMaybe<Property_Image_Aggregate_Bool_Exp>;
  property_list_folders?: InputMaybe<Property_List_Folder_Bool_Exp>;
  property_list_folders_aggregate?: InputMaybe<Property_List_Folder_Aggregate_Bool_Exp>;
  property_origin_type?: InputMaybe<Property_Origin_Type_Enum_Comparison_Exp>;
  property_price_histories?: InputMaybe<Property_Price_History_Bool_Exp>;
  property_price_histories_aggregate?: InputMaybe<Property_Price_History_Aggregate_Bool_Exp>;
  property_source?: InputMaybe<Property_Source_Bool_Exp>;
  property_status?: InputMaybe<Property_Status_Enum_Comparison_Exp>;
  property_type?: InputMaybe<Property_Type_Enum_Comparison_Exp>;
  property_type_rel?: InputMaybe<Property_Type_Bool_Exp>;
  rental_terms?: InputMaybe<String_Comparison_Exp>;
  sale_terms?: InputMaybe<String_Comparison_Exp>;
  search_vector?: InputMaybe<String_Comparison_Exp>;
  smoking_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  source_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_url?: InputMaybe<String_Comparison_Exp>;
  source_url_clicked?: InputMaybe<Int_Comparison_Exp>;
  sponsored?: InputMaybe<Boolean_Comparison_Exp>;
  sponsored_property_lists?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
  sponsored_property_lists_aggregate?: InputMaybe<Sponsored_Property_List_Aggregate_Bool_Exp>;
  task_id?: InputMaybe<String_Comparison_Exp>;
  title_id?: InputMaybe<Uuid_Comparison_Exp>;
  title_text_content?: InputMaybe<Text_Content_Bool_Exp>;
  total_activity?: InputMaybe<Int_Comparison_Exp>;
  total_area?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  views?: InputMaybe<Int_Comparison_Exp>;
  visibility_status?: InputMaybe<Visibility_Status_Enum_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "property_list". All fields are combined with a logical 'AND'. */
export type Property_List_Bool_Exp_Remote_Rel_Organizationproperties_Aggregate = {
  _and?: InputMaybe<Array<Property_List_Bool_Exp>>;
  _not?: InputMaybe<Property_List_Bool_Exp>;
  _or?: InputMaybe<Array<Property_List_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  building_floors?: InputMaybe<Int_Comparison_Exp>;
  canonical_url?: InputMaybe<String_Comparison_Exp>;
  construction_status?: InputMaybe<Construction_Status_Enum_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact_name?: InputMaybe<String_Comparison_Exp>;
  contact_phone_1?: InputMaybe<String_Comparison_Exp>;
  contact_phone_2?: InputMaybe<String_Comparison_Exp>;
  contact_phone_clicked?: InputMaybe<Int_Comparison_Exp>;
  content_location?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  description_id?: InputMaybe<Uuid_Comparison_Exp>;
  description_text_content?: InputMaybe<Text_Content_Bool_Exp>;
  disapproved_comment?: InputMaybe<String_Comparison_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  features?: InputMaybe<Jsonb_Comparison_Exp>;
  features_array?: InputMaybe<Jsonb_Comparison_Exp>;
  features_json?: InputMaybe<Jsonb_Comparison_Exp>;
  floor?: InputMaybe<Int_Comparison_Exp>;
  furnishing_status?: InputMaybe<Furnishing_Status_Enum_Comparison_Exp>;
  generated_title?: InputMaybe<Text_Content_Bool_Exp>;
  generated_title_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_carport?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking_space?: InputMaybe<Boolean_Comparison_Exp>;
  has_property_title?: InputMaybe<Boolean_Comparison_Exp>;
  has_terrace?: InputMaybe<Boolean_Comparison_Exp>;
  heating_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_barrier_free?: InputMaybe<Boolean_Comparison_Exp>;
  json_ld?: InputMaybe<Jsonb_Comparison_Exp>;
  last_renovation_year?: InputMaybe<Int_Comparison_Exp>;
  last_seen?: InputMaybe<Timestamptz_Comparison_Exp>;
  lister_id?: InputMaybe<Uuid_Comparison_Exp>;
  living_area?: InputMaybe<Float8_Comparison_Exp>;
  location?: InputMaybe<Location_Bool_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_size?: InputMaybe<String_Comparison_Exp>;
  main_image?: InputMaybe<Property_Image_Bool_Exp>;
  main_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp_Remote_Rel_Organizationproperties_Aggregate>;
  parent_property?: InputMaybe<Uuid_Comparison_Exp>;
  parking_spaces?: InputMaybe<Int_Comparison_Exp>;
  parking_type?: InputMaybe<Parking_Type_Enum_Comparison_Exp>;
  pets_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  plot_area?: InputMaybe<Float8_Comparison_Exp>;
  posted_at?: InputMaybe<Date_Comparison_Exp>;
  price?: InputMaybe<Float8_Comparison_Exp>;
  price_currency?: InputMaybe<Currency_Enum_Comparison_Exp>;
  price_exchange?: InputMaybe<Numeric_Comparison_Exp>;
  properties?: InputMaybe<Property_Bool_Exp>;
  properties_aggregate?: InputMaybe<Property_Aggregate_Bool_Exp>;
  property?: InputMaybe<Property_Bool_Exp>;
  property_composition?: InputMaybe<Property_Composition_Bool_Exp>;
  property_composition_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_features?: InputMaybe<Property_Feature_Bool_Exp>;
  property_features_aggregate?: InputMaybe<Property_Feature_Aggregate_Bool_Exp>;
  property_images?: InputMaybe<Property_Image_Bool_Exp>;
  property_images_aggregate?: InputMaybe<Property_Image_Aggregate_Bool_Exp>;
  property_list_folders?: InputMaybe<Property_List_Folder_Bool_Exp>;
  property_list_folders_aggregate?: InputMaybe<Property_List_Folder_Aggregate_Bool_Exp>;
  property_origin_type?: InputMaybe<Property_Origin_Type_Enum_Comparison_Exp>;
  property_price_histories?: InputMaybe<Property_Price_History_Bool_Exp>;
  property_price_histories_aggregate?: InputMaybe<Property_Price_History_Aggregate_Bool_Exp>;
  property_source?: InputMaybe<Property_Source_Bool_Exp>;
  property_status?: InputMaybe<Property_Status_Enum_Comparison_Exp>;
  property_type?: InputMaybe<Property_Type_Enum_Comparison_Exp>;
  property_type_rel?: InputMaybe<Property_Type_Bool_Exp>;
  rental_terms?: InputMaybe<String_Comparison_Exp>;
  sale_terms?: InputMaybe<String_Comparison_Exp>;
  search_vector?: InputMaybe<String_Comparison_Exp>;
  smoking_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  source_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_url?: InputMaybe<String_Comparison_Exp>;
  source_url_clicked?: InputMaybe<Int_Comparison_Exp>;
  sponsored?: InputMaybe<Boolean_Comparison_Exp>;
  sponsored_property_lists?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
  sponsored_property_lists_aggregate?: InputMaybe<Sponsored_Property_List_Aggregate_Bool_Exp>;
  task_id?: InputMaybe<String_Comparison_Exp>;
  title_id?: InputMaybe<Uuid_Comparison_Exp>;
  title_text_content?: InputMaybe<Text_Content_Bool_Exp>;
  total_activity?: InputMaybe<Int_Comparison_Exp>;
  total_area?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  views?: InputMaybe<Int_Comparison_Exp>;
  visibility_status?: InputMaybe<Visibility_Status_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_list" */
export enum Property_List_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyListPkey = 'property_list_pkey',
  /** unique or primary key constraint on columns "title_id", "source_id" */
  PropertyListTitleIdSourceIdKey = 'property_list_title_id_source_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Property_List_Delete_At_Path_Input = {
  features_json?: InputMaybe<Array<Scalars['String']['input']>>;
  json_ld?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Property_List_Delete_Elem_Input = {
  features_json?: InputMaybe<Scalars['Int']['input']>;
  json_ld?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Property_List_Delete_Key_Input = {
  features_json?: InputMaybe<Scalars['String']['input']>;
  json_ld?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "property_list_folder" */
export type Property_List_Folder = {
  __typename?: 'property_list_folder';
  created_at: Scalars['timestamptz']['output'];
  folder_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  property_folder: Property_Folder;
  /** An object relationship */
  property_list: Property_List;
  property_list_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "property_list_folder" */
export type Property_List_Folder_Aggregate = {
  __typename?: 'property_list_folder_aggregate';
  aggregate?: Maybe<Property_List_Folder_Aggregate_Fields>;
  nodes: Array<Property_List_Folder>;
};

export type Property_List_Folder_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_List_Folder_Aggregate_Bool_Exp_Count>;
};

export type Property_List_Folder_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_List_Folder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_List_Folder_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_list_folder" */
export type Property_List_Folder_Aggregate_Fields = {
  __typename?: 'property_list_folder_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_List_Folder_Max_Fields>;
  min?: Maybe<Property_List_Folder_Min_Fields>;
};


/** aggregate fields of "property_list_folder" */
export type Property_List_Folder_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_List_Folder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_list_folder" */
export type Property_List_Folder_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_List_Folder_Max_Order_By>;
  min?: InputMaybe<Property_List_Folder_Min_Order_By>;
};

/** input type for inserting array relation for remote table "property_list_folder" */
export type Property_List_Folder_Arr_Rel_Insert_Input = {
  data: Array<Property_List_Folder_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_List_Folder_On_Conflict>;
};

/** Boolean expression to filter rows from the table "property_list_folder". All fields are combined with a logical 'AND'. */
export type Property_List_Folder_Bool_Exp = {
  _and?: InputMaybe<Array<Property_List_Folder_Bool_Exp>>;
  _not?: InputMaybe<Property_List_Folder_Bool_Exp>;
  _or?: InputMaybe<Array<Property_List_Folder_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  property_folder?: InputMaybe<Property_Folder_Bool_Exp>;
  property_list?: InputMaybe<Property_List_Bool_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_list_folder" */
export enum Property_List_Folder_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyListFolderPkey = 'property_list_folder_pkey',
  /** unique or primary key constraint on columns "folder_id", "property_list_id" */
  PropertyListFolderPropertyListIdFolderIdKey = 'property_list_folder_property_list_id_folder_id_key'
}

/** input type for inserting data into table "property_list_folder" */
export type Property_List_Folder_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_folder?: InputMaybe<Property_Folder_Obj_Rel_Insert_Input>;
  property_list?: InputMaybe<Property_List_Obj_Rel_Insert_Input>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Property_List_Folder_Max_Fields = {
  __typename?: 'property_list_folder_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property_list_folder" */
export type Property_List_Folder_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_List_Folder_Min_Fields = {
  __typename?: 'property_list_folder_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property_list_folder" */
export type Property_List_Folder_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_list_folder" */
export type Property_List_Folder_Mutation_Response = {
  __typename?: 'property_list_folder_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_List_Folder>;
};

/** on_conflict condition type for table "property_list_folder" */
export type Property_List_Folder_On_Conflict = {
  constraint: Property_List_Folder_Constraint;
  update_columns?: Array<Property_List_Folder_Update_Column>;
  where?: InputMaybe<Property_List_Folder_Bool_Exp>;
};

/** Ordering options when selecting data from "property_list_folder". */
export type Property_List_Folder_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_folder?: InputMaybe<Property_Folder_Order_By>;
  property_list?: InputMaybe<Property_List_Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_list_folder */
export type Property_List_Folder_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_list_folder" */
export enum Property_List_Folder_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "property_list_folder" */
export type Property_List_Folder_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "property_list_folder" */
export type Property_List_Folder_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_List_Folder_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_List_Folder_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "property_list_folder" */
export enum Property_List_Folder_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_List_Folder_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_List_Folder_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_List_Folder_Bool_Exp;
};

/** input type for incrementing numeric columns in table "property_list" */
export type Property_List_Inc_Input = {
  building_floors?: InputMaybe<Scalars['Int']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  contact_phone_clicked?: InputMaybe<Scalars['Int']['input']>;
  floor?: InputMaybe<Scalars['Int']['input']>;
  last_renovation_year?: InputMaybe<Scalars['Int']['input']>;
  living_area?: InputMaybe<Scalars['float8']['input']>;
  parking_spaces?: InputMaybe<Scalars['Int']['input']>;
  plot_area?: InputMaybe<Scalars['float8']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  source_url_clicked?: InputMaybe<Scalars['Int']['input']>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Scalars['Int']['input']>;
  total_area?: InputMaybe<Scalars['float8']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_list" */
export type Property_List_Insert_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  building_floors?: InputMaybe<Scalars['Int']['input']>;
  canonical_url?: InputMaybe<Scalars['String']['input']>;
  construction_status?: InputMaybe<Construction_Status_Enum>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone_1?: InputMaybe<Scalars['String']['input']>;
  contact_phone_2?: InputMaybe<Scalars['String']['input']>;
  contact_phone_clicked?: InputMaybe<Scalars['Int']['input']>;
  content_location?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description_id?: InputMaybe<Scalars['uuid']['input']>;
  description_text_content?: InputMaybe<Text_Content_Obj_Rel_Insert_Input>;
  disapproved_comment?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  features_json?: InputMaybe<Scalars['jsonb']['input']>;
  floor?: InputMaybe<Scalars['Int']['input']>;
  furnishing_status?: InputMaybe<Furnishing_Status_Enum>;
  generated_title?: InputMaybe<Text_Content_Obj_Rel_Insert_Input>;
  generated_title_id?: InputMaybe<Scalars['uuid']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_carport?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking_space?: InputMaybe<Scalars['Boolean']['input']>;
  has_property_title?: InputMaybe<Scalars['Boolean']['input']>;
  has_terrace?: InputMaybe<Scalars['Boolean']['input']>;
  heating_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_barrier_free?: InputMaybe<Scalars['Boolean']['input']>;
  json_ld?: InputMaybe<Scalars['jsonb']['input']>;
  last_renovation_year?: InputMaybe<Scalars['Int']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  lister_id?: InputMaybe<Scalars['uuid']['input']>;
  living_area?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  lot_size?: InputMaybe<Scalars['String']['input']>;
  main_image?: InputMaybe<Property_Image_Obj_Rel_Insert_Input>;
  main_image_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_property?: InputMaybe<Scalars['uuid']['input']>;
  parking_spaces?: InputMaybe<Scalars['Int']['input']>;
  parking_type?: InputMaybe<Parking_Type_Enum>;
  pets_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  plot_area?: InputMaybe<Scalars['float8']['input']>;
  posted_at?: InputMaybe<Scalars['date']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  price_currency?: InputMaybe<Currency_Enum>;
  properties?: InputMaybe<Property_Arr_Rel_Insert_Input>;
  property?: InputMaybe<Property_Obj_Rel_Insert_Input>;
  property_composition?: InputMaybe<Property_Composition_Obj_Rel_Insert_Input>;
  property_composition_id?: InputMaybe<Scalars['uuid']['input']>;
  property_features?: InputMaybe<Property_Feature_Arr_Rel_Insert_Input>;
  property_images?: InputMaybe<Property_Image_Arr_Rel_Insert_Input>;
  property_list_folders?: InputMaybe<Property_List_Folder_Arr_Rel_Insert_Input>;
  property_origin_type?: InputMaybe<Property_Origin_Type_Enum>;
  property_price_histories?: InputMaybe<Property_Price_History_Arr_Rel_Insert_Input>;
  property_source?: InputMaybe<Property_Source_Obj_Rel_Insert_Input>;
  property_status?: InputMaybe<Property_Status_Enum>;
  property_type?: InputMaybe<Property_Type_Enum>;
  property_type_rel?: InputMaybe<Property_Type_Obj_Rel_Insert_Input>;
  rental_terms?: InputMaybe<Scalars['String']['input']>;
  sale_terms?: InputMaybe<Scalars['String']['input']>;
  search_vector?: InputMaybe<Scalars['String']['input']>;
  smoking_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  source_url?: InputMaybe<Scalars['String']['input']>;
  source_url_clicked?: InputMaybe<Scalars['Int']['input']>;
  sponsored_property_lists?: InputMaybe<Sponsored_Property_List_Arr_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['String']['input']>;
  title_id?: InputMaybe<Scalars['uuid']['input']>;
  title_text_content?: InputMaybe<Text_Content_Obj_Rel_Insert_Input>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Scalars['Int']['input']>;
  total_area?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
  visibility_status?: InputMaybe<Visibility_Status_Enum>;
};

/** aggregate max on columns */
export type Property_List_Max_Fields = {
  __typename?: 'property_list_max_fields';
  building_floors?: Maybe<Scalars['Int']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone_1?: Maybe<Scalars['String']['output']>;
  contact_phone_2?: Maybe<Scalars['String']['output']>;
  contact_phone_clicked?: Maybe<Scalars['Int']['output']>;
  content_location?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  description_id?: Maybe<Scalars['uuid']['output']>;
  disapproved_comment?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['Int']['output']>;
  generated_title_id?: Maybe<Scalars['uuid']['output']>;
  heating_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_renovation_year?: Maybe<Scalars['Int']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  lister_id?: Maybe<Scalars['uuid']['output']>;
  living_area?: Maybe<Scalars['float8']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  lot_size?: Maybe<Scalars['String']['output']>;
  main_image_id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  parent_property?: Maybe<Scalars['uuid']['output']>;
  parking_spaces?: Maybe<Scalars['Int']['output']>;
  plot_area?: Maybe<Scalars['float8']['output']>;
  posted_at?: Maybe<Scalars['date']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "price_exchanged" */
  price_exchange?: Maybe<Scalars['numeric']['output']>;
  property_composition_id?: Maybe<Scalars['uuid']['output']>;
  rental_terms?: Maybe<Scalars['String']['output']>;
  sale_terms?: Maybe<Scalars['String']['output']>;
  search_vector?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  source_url?: Maybe<Scalars['String']['output']>;
  source_url_clicked?: Maybe<Scalars['Int']['output']>;
  task_id?: Maybe<Scalars['String']['output']>;
  title_id?: Maybe<Scalars['uuid']['output']>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: Maybe<Scalars['Int']['output']>;
  total_area?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "property_list" */
export type Property_List_Max_Order_By = {
  building_floors?: InputMaybe<Order_By>;
  canonical_url?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  contact_name?: InputMaybe<Order_By>;
  contact_phone_1?: InputMaybe<Order_By>;
  contact_phone_2?: InputMaybe<Order_By>;
  contact_phone_clicked?: InputMaybe<Order_By>;
  content_location?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  description_id?: InputMaybe<Order_By>;
  disapproved_comment?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  generated_title_id?: InputMaybe<Order_By>;
  heating_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_renovation_year?: InputMaybe<Order_By>;
  last_seen?: InputMaybe<Order_By>;
  lister_id?: InputMaybe<Order_By>;
  living_area?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  lot_size?: InputMaybe<Order_By>;
  main_image_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parent_property?: InputMaybe<Order_By>;
  parking_spaces?: InputMaybe<Order_By>;
  plot_area?: InputMaybe<Order_By>;
  posted_at?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  property_composition_id?: InputMaybe<Order_By>;
  rental_terms?: InputMaybe<Order_By>;
  sale_terms?: InputMaybe<Order_By>;
  search_vector?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_url?: InputMaybe<Order_By>;
  source_url_clicked?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  title_id?: InputMaybe<Order_By>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Order_By>;
  total_area?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_List_Min_Fields = {
  __typename?: 'property_list_min_fields';
  building_floors?: Maybe<Scalars['Int']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone_1?: Maybe<Scalars['String']['output']>;
  contact_phone_2?: Maybe<Scalars['String']['output']>;
  contact_phone_clicked?: Maybe<Scalars['Int']['output']>;
  content_location?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  description_id?: Maybe<Scalars['uuid']['output']>;
  disapproved_comment?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['Int']['output']>;
  generated_title_id?: Maybe<Scalars['uuid']['output']>;
  heating_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_renovation_year?: Maybe<Scalars['Int']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  lister_id?: Maybe<Scalars['uuid']['output']>;
  living_area?: Maybe<Scalars['float8']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  lot_size?: Maybe<Scalars['String']['output']>;
  main_image_id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  parent_property?: Maybe<Scalars['uuid']['output']>;
  parking_spaces?: Maybe<Scalars['Int']['output']>;
  plot_area?: Maybe<Scalars['float8']['output']>;
  posted_at?: Maybe<Scalars['date']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "price_exchanged" */
  price_exchange?: Maybe<Scalars['numeric']['output']>;
  property_composition_id?: Maybe<Scalars['uuid']['output']>;
  rental_terms?: Maybe<Scalars['String']['output']>;
  sale_terms?: Maybe<Scalars['String']['output']>;
  search_vector?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  source_url?: Maybe<Scalars['String']['output']>;
  source_url_clicked?: Maybe<Scalars['Int']['output']>;
  task_id?: Maybe<Scalars['String']['output']>;
  title_id?: Maybe<Scalars['uuid']['output']>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: Maybe<Scalars['Int']['output']>;
  total_area?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "property_list" */
export type Property_List_Min_Order_By = {
  building_floors?: InputMaybe<Order_By>;
  canonical_url?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  contact_name?: InputMaybe<Order_By>;
  contact_phone_1?: InputMaybe<Order_By>;
  contact_phone_2?: InputMaybe<Order_By>;
  contact_phone_clicked?: InputMaybe<Order_By>;
  content_location?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  description_id?: InputMaybe<Order_By>;
  disapproved_comment?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  generated_title_id?: InputMaybe<Order_By>;
  heating_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_renovation_year?: InputMaybe<Order_By>;
  last_seen?: InputMaybe<Order_By>;
  lister_id?: InputMaybe<Order_By>;
  living_area?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  lot_size?: InputMaybe<Order_By>;
  main_image_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parent_property?: InputMaybe<Order_By>;
  parking_spaces?: InputMaybe<Order_By>;
  plot_area?: InputMaybe<Order_By>;
  posted_at?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  property_composition_id?: InputMaybe<Order_By>;
  rental_terms?: InputMaybe<Order_By>;
  sale_terms?: InputMaybe<Order_By>;
  search_vector?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_url?: InputMaybe<Order_By>;
  source_url_clicked?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  title_id?: InputMaybe<Order_By>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Order_By>;
  total_area?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_list" */
export type Property_List_Mutation_Response = {
  __typename?: 'property_list_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_List>;
};

/** input type for inserting object relation for remote table "property_list" */
export type Property_List_Obj_Rel_Insert_Input = {
  data: Property_List_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_List_On_Conflict>;
};

/** on_conflict condition type for table "property_list" */
export type Property_List_On_Conflict = {
  constraint: Property_List_Constraint;
  update_columns?: Array<Property_List_Update_Column>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};

/** Ordering options when selecting data from "property_list". */
export type Property_List_Order_By = {
  archived?: InputMaybe<Order_By>;
  building_floors?: InputMaybe<Order_By>;
  canonical_url?: InputMaybe<Order_By>;
  construction_status?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  contact_name?: InputMaybe<Order_By>;
  contact_phone_1?: InputMaybe<Order_By>;
  contact_phone_2?: InputMaybe<Order_By>;
  contact_phone_clicked?: InputMaybe<Order_By>;
  content_location?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  description_id?: InputMaybe<Order_By>;
  description_text_content?: InputMaybe<Text_Content_Order_By>;
  disapproved_comment?: InputMaybe<Order_By>;
  featured?: InputMaybe<Order_By>;
  features?: InputMaybe<Order_By>;
  features_array?: InputMaybe<Order_By>;
  features_json?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  furnishing_status?: InputMaybe<Order_By>;
  generated_title?: InputMaybe<Text_Content_Order_By>;
  generated_title_id?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_carport?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_parking_space?: InputMaybe<Order_By>;
  has_property_title?: InputMaybe<Order_By>;
  has_terrace?: InputMaybe<Order_By>;
  heating_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_barrier_free?: InputMaybe<Order_By>;
  json_ld?: InputMaybe<Order_By>;
  last_renovation_year?: InputMaybe<Order_By>;
  last_seen?: InputMaybe<Order_By>;
  lister_id?: InputMaybe<Order_By>;
  living_area?: InputMaybe<Order_By>;
  location?: InputMaybe<Location_Order_By>;
  location_id?: InputMaybe<Order_By>;
  lot_size?: InputMaybe<Order_By>;
  main_image?: InputMaybe<Property_Image_Order_By>;
  main_image_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parent_property?: InputMaybe<Order_By>;
  parking_spaces?: InputMaybe<Order_By>;
  parking_type?: InputMaybe<Order_By>;
  pets_allowed?: InputMaybe<Order_By>;
  plot_area?: InputMaybe<Order_By>;
  posted_at?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_currency?: InputMaybe<Order_By>;
  price_exchange?: InputMaybe<Order_By>;
  properties_aggregate?: InputMaybe<Property_Aggregate_Order_By>;
  property?: InputMaybe<Property_Order_By>;
  property_composition?: InputMaybe<Property_Composition_Order_By>;
  property_composition_id?: InputMaybe<Order_By>;
  property_features_aggregate?: InputMaybe<Property_Feature_Aggregate_Order_By>;
  property_images_aggregate?: InputMaybe<Property_Image_Aggregate_Order_By>;
  property_list_folders_aggregate?: InputMaybe<Property_List_Folder_Aggregate_Order_By>;
  property_origin_type?: InputMaybe<Order_By>;
  property_price_histories_aggregate?: InputMaybe<Property_Price_History_Aggregate_Order_By>;
  property_source?: InputMaybe<Property_Source_Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  property_type_rel?: InputMaybe<Property_Type_Order_By>;
  rental_terms?: InputMaybe<Order_By>;
  sale_terms?: InputMaybe<Order_By>;
  search_vector?: InputMaybe<Order_By>;
  smoking_allowed?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_url?: InputMaybe<Order_By>;
  source_url_clicked?: InputMaybe<Order_By>;
  sponsored?: InputMaybe<Order_By>;
  sponsored_property_lists_aggregate?: InputMaybe<Sponsored_Property_List_Aggregate_Order_By>;
  task_id?: InputMaybe<Order_By>;
  title_id?: InputMaybe<Order_By>;
  title_text_content?: InputMaybe<Text_Content_Order_By>;
  total_activity?: InputMaybe<Order_By>;
  total_area?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
  visibility_status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_list */
export type Property_List_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Property_List_Prepend_Input = {
  features_json?: InputMaybe<Scalars['jsonb']['input']>;
  json_ld?: InputMaybe<Scalars['jsonb']['input']>;
};

/** reports by people for property problems */
export type Property_List_Report = {
  __typename?: 'property_list_report';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  property_list?: Maybe<Property_List>;
  property_list_id: Scalars['uuid']['output'];
  reporty_type: Property_Report_Type_Enum;
  seen?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "property_list_report" */
export type Property_List_Report_Aggregate = {
  __typename?: 'property_list_report_aggregate';
  aggregate?: Maybe<Property_List_Report_Aggregate_Fields>;
  nodes: Array<Property_List_Report>;
};

/** aggregate fields of "property_list_report" */
export type Property_List_Report_Aggregate_Fields = {
  __typename?: 'property_list_report_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_List_Report_Max_Fields>;
  min?: Maybe<Property_List_Report_Min_Fields>;
};


/** aggregate fields of "property_list_report" */
export type Property_List_Report_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_List_Report_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "property_list_report". All fields are combined with a logical 'AND'. */
export type Property_List_Report_Bool_Exp = {
  _and?: InputMaybe<Array<Property_List_Report_Bool_Exp>>;
  _not?: InputMaybe<Property_List_Report_Bool_Exp>;
  _or?: InputMaybe<Array<Property_List_Report_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  reporty_type?: InputMaybe<Property_Report_Type_Enum_Comparison_Exp>;
  seen?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_list_report" */
export enum Property_List_Report_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyListReportPkey = 'property_list_report_pkey'
}

/** input type for inserting data into table "property_list_report" */
export type Property_List_Report_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  reporty_type?: InputMaybe<Property_Report_Type_Enum>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Property_List_Report_Max_Fields = {
  __typename?: 'property_list_report_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Property_List_Report_Min_Fields = {
  __typename?: 'property_list_report_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "property_list_report" */
export type Property_List_Report_Mutation_Response = {
  __typename?: 'property_list_report_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_List_Report>;
};

/** on_conflict condition type for table "property_list_report" */
export type Property_List_Report_On_Conflict = {
  constraint: Property_List_Report_Constraint;
  update_columns?: Array<Property_List_Report_Update_Column>;
  where?: InputMaybe<Property_List_Report_Bool_Exp>;
};

/** Ordering options when selecting data from "property_list_report". */
export type Property_List_Report_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  reporty_type?: InputMaybe<Order_By>;
  seen?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_list_report */
export type Property_List_Report_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_list_report" */
export enum Property_List_Report_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  ReportyType = 'reporty_type',
  /** column name */
  Seen = 'seen',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "property_list_report" */
export type Property_List_Report_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  reporty_type?: InputMaybe<Property_Report_Type_Enum>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "property_list_report" */
export type Property_List_Report_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_List_Report_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_List_Report_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  reporty_type?: InputMaybe<Property_Report_Type_Enum>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "property_list_report" */
export enum Property_List_Report_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  ReportyType = 'reporty_type',
  /** column name */
  Seen = 'seen',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Property_List_Report_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_List_Report_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_List_Report_Bool_Exp;
};

/** select columns of table "property_list" */
export enum Property_List_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  BuildingFloors = 'building_floors',
  /** column name */
  CanonicalUrl = 'canonical_url',
  /** column name */
  ConstructionStatus = 'construction_status',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  ContactPhone_1 = 'contact_phone_1',
  /** column name */
  ContactPhone_2 = 'contact_phone_2',
  /** column name */
  ContactPhoneClicked = 'contact_phone_clicked',
  /** column name */
  ContentLocation = 'content_location',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  DisapprovedComment = 'disapproved_comment',
  /** column name */
  Featured = 'featured',
  /** column name */
  FeaturesJson = 'features_json',
  /** column name */
  Floor = 'floor',
  /** column name */
  FurnishingStatus = 'furnishing_status',
  /** column name */
  GeneratedTitleId = 'generated_title_id',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCarport = 'has_carport',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasParkingSpace = 'has_parking_space',
  /** column name */
  HasPropertyTitle = 'has_property_title',
  /** column name */
  HasTerrace = 'has_terrace',
  /** column name */
  HeatingType = 'heating_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBarrierFree = 'is_barrier_free',
  /** column name */
  JsonLd = 'json_ld',
  /** column name */
  LastRenovationYear = 'last_renovation_year',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  ListerId = 'lister_id',
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  LotSize = 'lot_size',
  /** column name */
  MainImageId = 'main_image_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ParentProperty = 'parent_property',
  /** column name */
  ParkingSpaces = 'parking_spaces',
  /** column name */
  ParkingType = 'parking_type',
  /** column name */
  PetsAllowed = 'pets_allowed',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  PostedAt = 'posted_at',
  /** column name */
  Price = 'price',
  /** column name */
  PriceCurrency = 'price_currency',
  /** column name */
  PropertyCompositionId = 'property_composition_id',
  /** column name */
  PropertyOriginType = 'property_origin_type',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  RentalTerms = 'rental_terms',
  /** column name */
  SaleTerms = 'sale_terms',
  /** column name */
  SearchVector = 'search_vector',
  /** column name */
  SmokingAllowed = 'smoking_allowed',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  SourceUrl = 'source_url',
  /** column name */
  SourceUrlClicked = 'source_url_clicked',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  TitleId = 'title_id',
  /** column name */
  TotalActivity = 'total_activity',
  /** column name */
  TotalArea = 'total_area',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Views = 'views',
  /** column name */
  VisibilityStatus = 'visibility_status'
}

/** select "property_list_aggregate_bool_exp_avg_arguments_columns" columns of table "property_list" */
export enum Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

/** select "property_list_aggregate_bool_exp_bool_and_arguments_columns" columns of table "property_list" */
export enum Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Featured = 'featured',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCarport = 'has_carport',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasParkingSpace = 'has_parking_space',
  /** column name */
  HasPropertyTitle = 'has_property_title',
  /** column name */
  HasTerrace = 'has_terrace',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBarrierFree = 'is_barrier_free',
  /** column name */
  PetsAllowed = 'pets_allowed',
  /** column name */
  SmokingAllowed = 'smoking_allowed'
}

/** select "property_list_aggregate_bool_exp_bool_or_arguments_columns" columns of table "property_list" */
export enum Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Featured = 'featured',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCarport = 'has_carport',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasParkingSpace = 'has_parking_space',
  /** column name */
  HasPropertyTitle = 'has_property_title',
  /** column name */
  HasTerrace = 'has_terrace',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBarrierFree = 'is_barrier_free',
  /** column name */
  PetsAllowed = 'pets_allowed',
  /** column name */
  SmokingAllowed = 'smoking_allowed'
}

/** select "property_list_aggregate_bool_exp_corr_arguments_columns" columns of table "property_list" */
export enum Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

/** select "property_list_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "property_list" */
export enum Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

/** select "property_list_aggregate_bool_exp_max_arguments_columns" columns of table "property_list" */
export enum Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

/** select "property_list_aggregate_bool_exp_min_arguments_columns" columns of table "property_list" */
export enum Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

/** select "property_list_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "property_list" */
export enum Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

/** select "property_list_aggregate_bool_exp_sum_arguments_columns" columns of table "property_list" */
export enum Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

/** select "property_list_aggregate_bool_exp_var_samp_arguments_columns" columns of table "property_list" */
export enum Property_List_Select_Column_Property_List_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  Price = 'price',
  /** column name */
  TotalArea = 'total_area'
}

/** input type for updating data in table "property_list" */
export type Property_List_Set_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  building_floors?: InputMaybe<Scalars['Int']['input']>;
  canonical_url?: InputMaybe<Scalars['String']['input']>;
  construction_status?: InputMaybe<Construction_Status_Enum>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone_1?: InputMaybe<Scalars['String']['input']>;
  contact_phone_2?: InputMaybe<Scalars['String']['input']>;
  contact_phone_clicked?: InputMaybe<Scalars['Int']['input']>;
  content_location?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description_id?: InputMaybe<Scalars['uuid']['input']>;
  disapproved_comment?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  features_json?: InputMaybe<Scalars['jsonb']['input']>;
  floor?: InputMaybe<Scalars['Int']['input']>;
  furnishing_status?: InputMaybe<Furnishing_Status_Enum>;
  generated_title_id?: InputMaybe<Scalars['uuid']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_carport?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking_space?: InputMaybe<Scalars['Boolean']['input']>;
  has_property_title?: InputMaybe<Scalars['Boolean']['input']>;
  has_terrace?: InputMaybe<Scalars['Boolean']['input']>;
  heating_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_barrier_free?: InputMaybe<Scalars['Boolean']['input']>;
  json_ld?: InputMaybe<Scalars['jsonb']['input']>;
  last_renovation_year?: InputMaybe<Scalars['Int']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  lister_id?: InputMaybe<Scalars['uuid']['input']>;
  living_area?: InputMaybe<Scalars['float8']['input']>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  lot_size?: InputMaybe<Scalars['String']['input']>;
  main_image_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_property?: InputMaybe<Scalars['uuid']['input']>;
  parking_spaces?: InputMaybe<Scalars['Int']['input']>;
  parking_type?: InputMaybe<Parking_Type_Enum>;
  pets_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  plot_area?: InputMaybe<Scalars['float8']['input']>;
  posted_at?: InputMaybe<Scalars['date']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  price_currency?: InputMaybe<Currency_Enum>;
  property_composition_id?: InputMaybe<Scalars['uuid']['input']>;
  property_origin_type?: InputMaybe<Property_Origin_Type_Enum>;
  property_status?: InputMaybe<Property_Status_Enum>;
  property_type?: InputMaybe<Property_Type_Enum>;
  rental_terms?: InputMaybe<Scalars['String']['input']>;
  sale_terms?: InputMaybe<Scalars['String']['input']>;
  search_vector?: InputMaybe<Scalars['String']['input']>;
  smoking_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  source_url?: InputMaybe<Scalars['String']['input']>;
  source_url_clicked?: InputMaybe<Scalars['Int']['input']>;
  task_id?: InputMaybe<Scalars['String']['input']>;
  title_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Scalars['Int']['input']>;
  total_area?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
  visibility_status?: InputMaybe<Visibility_Status_Enum>;
};

/** aggregate stddev on columns */
export type Property_List_Stddev_Fields = {
  __typename?: 'property_list_stddev_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  contact_phone_clicked?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "price_exchanged" */
  price_exchange?: Maybe<Scalars['numeric']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_list" */
export type Property_List_Stddev_Order_By = {
  building_floors?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  contact_phone_clicked?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  last_renovation_year?: InputMaybe<Order_By>;
  living_area?: InputMaybe<Order_By>;
  parking_spaces?: InputMaybe<Order_By>;
  plot_area?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  source_url_clicked?: InputMaybe<Order_By>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Order_By>;
  total_area?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_List_Stddev_Pop_Fields = {
  __typename?: 'property_list_stddev_pop_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  contact_phone_clicked?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "price_exchanged" */
  price_exchange?: Maybe<Scalars['numeric']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_list" */
export type Property_List_Stddev_Pop_Order_By = {
  building_floors?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  contact_phone_clicked?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  last_renovation_year?: InputMaybe<Order_By>;
  living_area?: InputMaybe<Order_By>;
  parking_spaces?: InputMaybe<Order_By>;
  plot_area?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  source_url_clicked?: InputMaybe<Order_By>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Order_By>;
  total_area?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_List_Stddev_Samp_Fields = {
  __typename?: 'property_list_stddev_samp_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  contact_phone_clicked?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "price_exchanged" */
  price_exchange?: Maybe<Scalars['numeric']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_list" */
export type Property_List_Stddev_Samp_Order_By = {
  building_floors?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  contact_phone_clicked?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  last_renovation_year?: InputMaybe<Order_By>;
  living_area?: InputMaybe<Order_By>;
  parking_spaces?: InputMaybe<Order_By>;
  plot_area?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  source_url_clicked?: InputMaybe<Order_By>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Order_By>;
  total_area?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_list" */
export type Property_List_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_List_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_List_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  building_floors?: InputMaybe<Scalars['Int']['input']>;
  canonical_url?: InputMaybe<Scalars['String']['input']>;
  construction_status?: InputMaybe<Construction_Status_Enum>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone_1?: InputMaybe<Scalars['String']['input']>;
  contact_phone_2?: InputMaybe<Scalars['String']['input']>;
  contact_phone_clicked?: InputMaybe<Scalars['Int']['input']>;
  content_location?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description_id?: InputMaybe<Scalars['uuid']['input']>;
  disapproved_comment?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  features_json?: InputMaybe<Scalars['jsonb']['input']>;
  floor?: InputMaybe<Scalars['Int']['input']>;
  furnishing_status?: InputMaybe<Furnishing_Status_Enum>;
  generated_title_id?: InputMaybe<Scalars['uuid']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_carport?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking_space?: InputMaybe<Scalars['Boolean']['input']>;
  has_property_title?: InputMaybe<Scalars['Boolean']['input']>;
  has_terrace?: InputMaybe<Scalars['Boolean']['input']>;
  heating_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_barrier_free?: InputMaybe<Scalars['Boolean']['input']>;
  json_ld?: InputMaybe<Scalars['jsonb']['input']>;
  last_renovation_year?: InputMaybe<Scalars['Int']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  lister_id?: InputMaybe<Scalars['uuid']['input']>;
  living_area?: InputMaybe<Scalars['float8']['input']>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  lot_size?: InputMaybe<Scalars['String']['input']>;
  main_image_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_property?: InputMaybe<Scalars['uuid']['input']>;
  parking_spaces?: InputMaybe<Scalars['Int']['input']>;
  parking_type?: InputMaybe<Parking_Type_Enum>;
  pets_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  plot_area?: InputMaybe<Scalars['float8']['input']>;
  posted_at?: InputMaybe<Scalars['date']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  price_currency?: InputMaybe<Currency_Enum>;
  property_composition_id?: InputMaybe<Scalars['uuid']['input']>;
  property_origin_type?: InputMaybe<Property_Origin_Type_Enum>;
  property_status?: InputMaybe<Property_Status_Enum>;
  property_type?: InputMaybe<Property_Type_Enum>;
  rental_terms?: InputMaybe<Scalars['String']['input']>;
  sale_terms?: InputMaybe<Scalars['String']['input']>;
  search_vector?: InputMaybe<Scalars['String']['input']>;
  smoking_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  source_url?: InputMaybe<Scalars['String']['input']>;
  source_url_clicked?: InputMaybe<Scalars['Int']['input']>;
  task_id?: InputMaybe<Scalars['String']['input']>;
  title_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Scalars['Int']['input']>;
  total_area?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
  visibility_status?: InputMaybe<Visibility_Status_Enum>;
};

/** aggregate sum on columns */
export type Property_List_Sum_Fields = {
  __typename?: 'property_list_sum_fields';
  building_floors?: Maybe<Scalars['Int']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  contact_phone_clicked?: Maybe<Scalars['Int']['output']>;
  floor?: Maybe<Scalars['Int']['output']>;
  last_renovation_year?: Maybe<Scalars['Int']['output']>;
  living_area?: Maybe<Scalars['float8']['output']>;
  parking_spaces?: Maybe<Scalars['Int']['output']>;
  plot_area?: Maybe<Scalars['float8']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "price_exchanged" */
  price_exchange?: Maybe<Scalars['numeric']['output']>;
  source_url_clicked?: Maybe<Scalars['Int']['output']>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: Maybe<Scalars['Int']['output']>;
  total_area?: Maybe<Scalars['float8']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_list" */
export type Property_List_Sum_Order_By = {
  building_floors?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  contact_phone_clicked?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  last_renovation_year?: InputMaybe<Order_By>;
  living_area?: InputMaybe<Order_By>;
  parking_spaces?: InputMaybe<Order_By>;
  plot_area?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  source_url_clicked?: InputMaybe<Order_By>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Order_By>;
  total_area?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** update columns of table "property_list" */
export enum Property_List_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  BuildingFloors = 'building_floors',
  /** column name */
  CanonicalUrl = 'canonical_url',
  /** column name */
  ConstructionStatus = 'construction_status',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  ContactPhone_1 = 'contact_phone_1',
  /** column name */
  ContactPhone_2 = 'contact_phone_2',
  /** column name */
  ContactPhoneClicked = 'contact_phone_clicked',
  /** column name */
  ContentLocation = 'content_location',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  DisapprovedComment = 'disapproved_comment',
  /** column name */
  Featured = 'featured',
  /** column name */
  FeaturesJson = 'features_json',
  /** column name */
  Floor = 'floor',
  /** column name */
  FurnishingStatus = 'furnishing_status',
  /** column name */
  GeneratedTitleId = 'generated_title_id',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCarport = 'has_carport',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasParkingSpace = 'has_parking_space',
  /** column name */
  HasPropertyTitle = 'has_property_title',
  /** column name */
  HasTerrace = 'has_terrace',
  /** column name */
  HeatingType = 'heating_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBarrierFree = 'is_barrier_free',
  /** column name */
  JsonLd = 'json_ld',
  /** column name */
  LastRenovationYear = 'last_renovation_year',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  ListerId = 'lister_id',
  /** column name */
  LivingArea = 'living_area',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  LotSize = 'lot_size',
  /** column name */
  MainImageId = 'main_image_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ParentProperty = 'parent_property',
  /** column name */
  ParkingSpaces = 'parking_spaces',
  /** column name */
  ParkingType = 'parking_type',
  /** column name */
  PetsAllowed = 'pets_allowed',
  /** column name */
  PlotArea = 'plot_area',
  /** column name */
  PostedAt = 'posted_at',
  /** column name */
  Price = 'price',
  /** column name */
  PriceCurrency = 'price_currency',
  /** column name */
  PropertyCompositionId = 'property_composition_id',
  /** column name */
  PropertyOriginType = 'property_origin_type',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  RentalTerms = 'rental_terms',
  /** column name */
  SaleTerms = 'sale_terms',
  /** column name */
  SearchVector = 'search_vector',
  /** column name */
  SmokingAllowed = 'smoking_allowed',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  SourceUrl = 'source_url',
  /** column name */
  SourceUrlClicked = 'source_url_clicked',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  TitleId = 'title_id',
  /** column name */
  TotalActivity = 'total_activity',
  /** column name */
  TotalArea = 'total_area',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Views = 'views',
  /** column name */
  VisibilityStatus = 'visibility_status'
}

export type Property_List_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Property_List_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Property_List_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Property_List_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Property_List_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_List_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Property_List_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_List_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_List_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_List_Var_Pop_Fields = {
  __typename?: 'property_list_var_pop_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  contact_phone_clicked?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "price_exchanged" */
  price_exchange?: Maybe<Scalars['numeric']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_list" */
export type Property_List_Var_Pop_Order_By = {
  building_floors?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  contact_phone_clicked?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  last_renovation_year?: InputMaybe<Order_By>;
  living_area?: InputMaybe<Order_By>;
  parking_spaces?: InputMaybe<Order_By>;
  plot_area?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  source_url_clicked?: InputMaybe<Order_By>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Order_By>;
  total_area?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_List_Var_Samp_Fields = {
  __typename?: 'property_list_var_samp_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  contact_phone_clicked?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "price_exchanged" */
  price_exchange?: Maybe<Scalars['numeric']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_list" */
export type Property_List_Var_Samp_Order_By = {
  building_floors?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  contact_phone_clicked?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  last_renovation_year?: InputMaybe<Order_By>;
  living_area?: InputMaybe<Order_By>;
  parking_spaces?: InputMaybe<Order_By>;
  plot_area?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  source_url_clicked?: InputMaybe<Order_By>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Order_By>;
  total_area?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_List_Variance_Fields = {
  __typename?: 'property_list_variance_fields';
  building_floors?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  contact_phone_clicked?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  last_renovation_year?: Maybe<Scalars['Float']['output']>;
  living_area?: Maybe<Scalars['Float']['output']>;
  parking_spaces?: Maybe<Scalars['Float']['output']>;
  plot_area?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "price_exchanged" */
  price_exchange?: Maybe<Scalars['numeric']['output']>;
  source_url_clicked?: Maybe<Scalars['Float']['output']>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: Maybe<Scalars['Float']['output']>;
  total_area?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_list" */
export type Property_List_Variance_Order_By = {
  building_floors?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  contact_phone_clicked?: InputMaybe<Order_By>;
  floor?: InputMaybe<Order_By>;
  last_renovation_year?: InputMaybe<Order_By>;
  living_area?: InputMaybe<Order_By>;
  parking_spaces?: InputMaybe<Order_By>;
  plot_area?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  source_url_clicked?: InputMaybe<Order_By>;
  /** Computed total of views + source_url_clicked + contact_phone_clicked for efficient sorting */
  total_activity?: InputMaybe<Order_By>;
  total_area?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Property_Max_Fields = {
  __typename?: 'property_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  json_ld?: Maybe<Scalars['String']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  main_listing_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property" */
export type Property_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  json_ld?: InputMaybe<Order_By>;
  last_seen?: InputMaybe<Order_By>;
  main_listing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Min_Fields = {
  __typename?: 'property_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  json_ld?: Maybe<Scalars['String']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  main_listing_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property" */
export type Property_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  json_ld?: InputMaybe<Order_By>;
  last_seen?: InputMaybe<Order_By>;
  main_listing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property" */
export type Property_Mutation_Response = {
  __typename?: 'property_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property>;
};

/** input type for inserting object relation for remote table "property" */
export type Property_Obj_Rel_Insert_Input = {
  data: Property_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_On_Conflict>;
};

/** on_conflict condition type for table "property" */
export type Property_On_Conflict = {
  constraint: Property_Constraint;
  update_columns?: Array<Property_Update_Column>;
  where?: InputMaybe<Property_Bool_Exp>;
};

/** Ordering options when selecting data from "property". */
export type Property_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  json_ld?: InputMaybe<Order_By>;
  last_seen?: InputMaybe<Order_By>;
  main_listing_id?: InputMaybe<Order_By>;
  main_property?: InputMaybe<Property_List_Order_By>;
  property_features_aggregate?: InputMaybe<Property_Feature_Aggregate_Order_By>;
  property_images_aggregate?: InputMaybe<Property_Image_Aggregate_Order_By>;
  property_lists_aggregate?: InputMaybe<Property_List_Aggregate_Order_By>;
  property_price_histories_aggregate?: InputMaybe<Property_Price_History_Aggregate_Order_By>;
  property_views_aggregate?: InputMaybe<Property_Views_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url_slugs_aggregate?: InputMaybe<Url_Slug_Aggregate_Order_By>;
  user_saved_properties_aggregate?: InputMaybe<User_Saved_Properties_Aggregate_Order_By>;
  user_seen_properties_aggregate?: InputMaybe<User_Seen_Property_Aggregate_Order_By>;
};

/** Enum per te ruajtur emertimin e origjines nga jane marre pronat */
export type Property_Origin = {
  __typename?: 'property_origin';
  origin: Scalars['String']['output'];
  ranking?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "property_origin" */
export type Property_Origin_Aggregate = {
  __typename?: 'property_origin_aggregate';
  aggregate?: Maybe<Property_Origin_Aggregate_Fields>;
  nodes: Array<Property_Origin>;
};

/** aggregate fields of "property_origin" */
export type Property_Origin_Aggregate_Fields = {
  __typename?: 'property_origin_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Origin_Max_Fields>;
  min?: Maybe<Property_Origin_Min_Fields>;
};


/** aggregate fields of "property_origin" */
export type Property_Origin_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Origin_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "property_origin". All fields are combined with a logical 'AND'. */
export type Property_Origin_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Origin_Bool_Exp>>;
  _not?: InputMaybe<Property_Origin_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Origin_Bool_Exp>>;
  origin?: InputMaybe<String_Comparison_Exp>;
  ranking?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_origin" */
export enum Property_Origin_Constraint {
  /** unique or primary key constraint on columns "origin" */
  PropertyOriginPkey = 'property_origin_pkey'
}

export enum Property_Origin_Enum {
  /** 20 */
  Catia = 'CATIA',
  /** 16 */
  Celesi = 'CELESI',
  /** 2 */
  Century_21 = 'CENTURY_21',
  /** 9 */
  DesrealAl = 'DESREAL_AL',
  /** 12 */
  Devinf = 'DEVINF',
  /** 22 */
  Duashpi = 'DUASHPI',
  /** 14 */
  Dupron = 'DUPRON',
  /** 13 */
  FutureHome = 'FUTURE_HOME',
  /** 19 */
  IndomioAl = 'INDOMIO_AL',
  /** 7 */
  Inf_93 = 'INF_93',
  /** 1 */
  IrgAl = 'IRG_AL',
  /** 4 */
  Kw = 'KW',
  /** 11 */
  MeiAl = 'MEI_AL',
  /** 18 */
  MerrJep = 'MERR_JEP',
  /** 3 */
  MikadoRealEstate = 'MIKADO_REAL_ESTATE',
  /** 21 */
  NjoftimeAl = 'NJOFTIME_AL',
  /** 15 */
  NjoftimeCom = 'NJOFTIME_COM',
  /** 23 */
  NjoftimeFalas = 'NJOFTIME_FALAS',
  /** 10 */
  RealEstateAl = 'REAL_ESTATE_AL',
  /** 8 */
  RealPassAl = 'REAL_PASS_AL',
  /** 5 */
  Remax = 'REMAX',
  /** 17 */
  ShpiAl = 'SHPI_AL',
  /** 6 */
  ThePoint = 'THE_POINT'
}

/** Boolean expression to compare columns of type "property_origin_enum". All fields are combined with logical 'AND'. */
export type Property_Origin_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Property_Origin_Enum>;
  _in?: InputMaybe<Array<Property_Origin_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Property_Origin_Enum>;
  _nin?: InputMaybe<Array<Property_Origin_Enum>>;
};

/** input type for inserting data into table "property_origin" */
export type Property_Origin_Insert_Input = {
  origin?: InputMaybe<Scalars['String']['input']>;
  ranking?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Property_Origin_Max_Fields = {
  __typename?: 'property_origin_max_fields';
  origin?: Maybe<Scalars['String']['output']>;
  ranking?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Property_Origin_Min_Fields = {
  __typename?: 'property_origin_min_fields';
  origin?: Maybe<Scalars['String']['output']>;
  ranking?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "property_origin" */
export type Property_Origin_Mutation_Response = {
  __typename?: 'property_origin_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Origin>;
};

/** on_conflict condition type for table "property_origin" */
export type Property_Origin_On_Conflict = {
  constraint: Property_Origin_Constraint;
  update_columns?: Array<Property_Origin_Update_Column>;
  where?: InputMaybe<Property_Origin_Bool_Exp>;
};

/** Ordering options when selecting data from "property_origin". */
export type Property_Origin_Order_By = {
  origin?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_origin */
export type Property_Origin_Pk_Columns_Input = {
  origin: Scalars['String']['input'];
};

/** select columns of table "property_origin" */
export enum Property_Origin_Select_Column {
  /** column name */
  Origin = 'origin',
  /** column name */
  Ranking = 'ranking'
}

/** input type for updating data in table "property_origin" */
export type Property_Origin_Set_Input = {
  origin?: InputMaybe<Scalars['String']['input']>;
  ranking?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "property_origin" */
export type Property_Origin_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Origin_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Origin_Stream_Cursor_Value_Input = {
  origin?: InputMaybe<Scalars['String']['input']>;
  ranking?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "property_origin_type" */
export type Property_Origin_Type = {
  __typename?: 'property_origin_type';
  type: Scalars['String']['output'];
};

export type Property_Origin_Type_ActionType = {
  __typename?: 'property_origin_type_ActionType';
  type: Scalars['String']['output'];
};

/** aggregated selection of "property_origin_type" */
export type Property_Origin_Type_Aggregate = {
  __typename?: 'property_origin_type_aggregate';
  aggregate?: Maybe<Property_Origin_Type_Aggregate_Fields>;
  nodes: Array<Property_Origin_Type>;
};

/** aggregate fields of "property_origin_type" */
export type Property_Origin_Type_Aggregate_Fields = {
  __typename?: 'property_origin_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Origin_Type_Max_Fields>;
  min?: Maybe<Property_Origin_Type_Min_Fields>;
};


/** aggregate fields of "property_origin_type" */
export type Property_Origin_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Origin_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "property_origin_type". All fields are combined with a logical 'AND'. */
export type Property_Origin_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Origin_Type_Bool_Exp>>;
  _not?: InputMaybe<Property_Origin_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Origin_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_origin_type" */
export enum Property_Origin_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  PropertyOriginTypePkey = 'property_origin_type_pkey'
}

export enum Property_Origin_Type_Enum {
  Agency = 'agency',
  Aggregator = 'aggregator',
  Kaktu = 'kaktu'
}

/** Boolean expression to compare columns of type "property_origin_type_enum". All fields are combined with logical 'AND'. */
export type Property_Origin_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Property_Origin_Type_Enum>;
  _in?: InputMaybe<Array<Property_Origin_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Property_Origin_Type_Enum>;
  _nin?: InputMaybe<Array<Property_Origin_Type_Enum>>;
};

/** input type for inserting data into table "property_origin_type" */
export type Property_Origin_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Property_Origin_Type_Max_Fields = {
  __typename?: 'property_origin_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Property_Origin_Type_Min_Fields = {
  __typename?: 'property_origin_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "property_origin_type" */
export type Property_Origin_Type_Mutation_Response = {
  __typename?: 'property_origin_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Origin_Type>;
};

/** on_conflict condition type for table "property_origin_type" */
export type Property_Origin_Type_On_Conflict = {
  constraint: Property_Origin_Type_Constraint;
  update_columns?: Array<Property_Origin_Type_Update_Column>;
  where?: InputMaybe<Property_Origin_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "property_origin_type". */
export type Property_Origin_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_origin_type */
export type Property_Origin_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "property_origin_type" */
export enum Property_Origin_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "property_origin_type" */
export type Property_Origin_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "property_origin_type" */
export type Property_Origin_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Origin_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Origin_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "property_origin_type" */
export enum Property_Origin_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Property_Origin_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Origin_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Origin_Type_Bool_Exp;
};

/** update columns of table "property_origin" */
export enum Property_Origin_Update_Column {
  /** column name */
  Origin = 'origin',
  /** column name */
  Ranking = 'ranking'
}

export type Property_Origin_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Origin_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Origin_Bool_Exp;
};

/** columns and relationships of "property_owner" */
export type Property_Owner = {
  __typename?: 'property_owner';
  owner: Scalars['String']['output'];
};

/** aggregated selection of "property_owner" */
export type Property_Owner_Aggregate = {
  __typename?: 'property_owner_aggregate';
  aggregate?: Maybe<Property_Owner_Aggregate_Fields>;
  nodes: Array<Property_Owner>;
};

/** aggregate fields of "property_owner" */
export type Property_Owner_Aggregate_Fields = {
  __typename?: 'property_owner_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Owner_Max_Fields>;
  min?: Maybe<Property_Owner_Min_Fields>;
};


/** aggregate fields of "property_owner" */
export type Property_Owner_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Owner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "property_owner". All fields are combined with a logical 'AND'. */
export type Property_Owner_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Owner_Bool_Exp>>;
  _not?: InputMaybe<Property_Owner_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Owner_Bool_Exp>>;
  owner?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_owner" */
export enum Property_Owner_Constraint {
  /** unique or primary key constraint on columns "owner" */
  PropertyOwnerPkey = 'property_owner_pkey'
}

/** input type for inserting data into table "property_owner" */
export type Property_Owner_Insert_Input = {
  owner?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Property_Owner_Max_Fields = {
  __typename?: 'property_owner_max_fields';
  owner?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Property_Owner_Min_Fields = {
  __typename?: 'property_owner_min_fields';
  owner?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "property_owner" */
export type Property_Owner_Mutation_Response = {
  __typename?: 'property_owner_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Owner>;
};

/** on_conflict condition type for table "property_owner" */
export type Property_Owner_On_Conflict = {
  constraint: Property_Owner_Constraint;
  update_columns?: Array<Property_Owner_Update_Column>;
  where?: InputMaybe<Property_Owner_Bool_Exp>;
};

/** Ordering options when selecting data from "property_owner". */
export type Property_Owner_Order_By = {
  owner?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_owner */
export type Property_Owner_Pk_Columns_Input = {
  owner: Scalars['String']['input'];
};

/** select columns of table "property_owner" */
export enum Property_Owner_Select_Column {
  /** column name */
  Owner = 'owner'
}

/** input type for updating data in table "property_owner" */
export type Property_Owner_Set_Input = {
  owner?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "property_owner" */
export type Property_Owner_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Owner_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Owner_Stream_Cursor_Value_Input = {
  owner?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "property_owner" */
export enum Property_Owner_Update_Column {
  /** column name */
  Owner = 'owner'
}

export type Property_Owner_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Owner_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Owner_Bool_Exp;
};

/** primary key columns input for table: property */
export type Property_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "property_place_reference" */
export type Property_Place_Reference = {
  __typename?: 'property_place_reference';
  confidence?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  evidence_text?: Maybe<Scalars['String']['output']>;
  extractor_version?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  place_reference: Place_Reference;
  place_reference_id: Scalars['uuid']['output'];
  /** An object relationship */
  property_list: Property_List;
  property_list_id: Scalars['uuid']['output'];
  relation: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "property_place_reference" */
export type Property_Place_Reference_Aggregate = {
  __typename?: 'property_place_reference_aggregate';
  aggregate?: Maybe<Property_Place_Reference_Aggregate_Fields>;
  nodes: Array<Property_Place_Reference>;
};

export type Property_Place_Reference_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Place_Reference_Aggregate_Bool_Exp_Count>;
};

export type Property_Place_Reference_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Place_Reference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Place_Reference_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_place_reference" */
export type Property_Place_Reference_Aggregate_Fields = {
  __typename?: 'property_place_reference_aggregate_fields';
  avg?: Maybe<Property_Place_Reference_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Place_Reference_Max_Fields>;
  min?: Maybe<Property_Place_Reference_Min_Fields>;
  stddev?: Maybe<Property_Place_Reference_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Place_Reference_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Place_Reference_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Place_Reference_Sum_Fields>;
  var_pop?: Maybe<Property_Place_Reference_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Place_Reference_Var_Samp_Fields>;
  variance?: Maybe<Property_Place_Reference_Variance_Fields>;
};


/** aggregate fields of "property_place_reference" */
export type Property_Place_Reference_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Place_Reference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_place_reference" */
export type Property_Place_Reference_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Place_Reference_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Place_Reference_Max_Order_By>;
  min?: InputMaybe<Property_Place_Reference_Min_Order_By>;
  stddev?: InputMaybe<Property_Place_Reference_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Place_Reference_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Place_Reference_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Place_Reference_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Place_Reference_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Place_Reference_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Place_Reference_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_place_reference" */
export type Property_Place_Reference_Arr_Rel_Insert_Input = {
  data: Array<Property_Place_Reference_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Place_Reference_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Place_Reference_Avg_Fields = {
  __typename?: 'property_place_reference_avg_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_place_reference" */
export type Property_Place_Reference_Avg_Order_By = {
  confidence?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_place_reference". All fields are combined with a logical 'AND'. */
export type Property_Place_Reference_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Place_Reference_Bool_Exp>>;
  _not?: InputMaybe<Property_Place_Reference_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Place_Reference_Bool_Exp>>;
  confidence?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  evidence_text?: InputMaybe<String_Comparison_Exp>;
  extractor_version?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  place_reference?: InputMaybe<Place_Reference_Bool_Exp>;
  place_reference_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_list?: InputMaybe<Property_List_Bool_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  relation?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_place_reference" */
export enum Property_Place_Reference_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyPlaceReferencePkey = 'property_place_reference_pkey',
  /** unique or primary key constraint on columns "relation", "place_reference_id", "property_list_id" */
  PropertyPlaceReferencePropertyListIdPlaceReferenceIKey = 'property_place_reference_property_list_id_place_reference_i_key'
}

/** input type for incrementing numeric columns in table "property_place_reference" */
export type Property_Place_Reference_Inc_Input = {
  confidence?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "property_place_reference" */
export type Property_Place_Reference_Insert_Input = {
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  evidence_text?: InputMaybe<Scalars['String']['input']>;
  extractor_version?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  place_reference?: InputMaybe<Place_Reference_Obj_Rel_Insert_Input>;
  place_reference_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list?: InputMaybe<Property_List_Obj_Rel_Insert_Input>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Property_Place_Reference_Max_Fields = {
  __typename?: 'property_place_reference_max_fields';
  confidence?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  evidence_text?: Maybe<Scalars['String']['output']>;
  extractor_version?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  place_reference_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property_place_reference" */
export type Property_Place_Reference_Max_Order_By = {
  confidence?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  evidence_text?: InputMaybe<Order_By>;
  extractor_version?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  place_reference_id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  relation?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Place_Reference_Min_Fields = {
  __typename?: 'property_place_reference_min_fields';
  confidence?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  evidence_text?: Maybe<Scalars['String']['output']>;
  extractor_version?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  place_reference_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property_place_reference" */
export type Property_Place_Reference_Min_Order_By = {
  confidence?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  evidence_text?: InputMaybe<Order_By>;
  extractor_version?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  place_reference_id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  relation?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_place_reference" */
export type Property_Place_Reference_Mutation_Response = {
  __typename?: 'property_place_reference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Place_Reference>;
};

/** on_conflict condition type for table "property_place_reference" */
export type Property_Place_Reference_On_Conflict = {
  constraint: Property_Place_Reference_Constraint;
  update_columns?: Array<Property_Place_Reference_Update_Column>;
  where?: InputMaybe<Property_Place_Reference_Bool_Exp>;
};

/** Ordering options when selecting data from "property_place_reference". */
export type Property_Place_Reference_Order_By = {
  confidence?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  evidence_text?: InputMaybe<Order_By>;
  extractor_version?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  place_reference?: InputMaybe<Place_Reference_Order_By>;
  place_reference_id?: InputMaybe<Order_By>;
  property_list?: InputMaybe<Property_List_Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  relation?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_place_reference */
export type Property_Place_Reference_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_place_reference" */
export enum Property_Place_Reference_Select_Column {
  /** column name */
  Confidence = 'confidence',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EvidenceText = 'evidence_text',
  /** column name */
  ExtractorVersion = 'extractor_version',
  /** column name */
  Id = 'id',
  /** column name */
  PlaceReferenceId = 'place_reference_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  Relation = 'relation',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "property_place_reference" */
export type Property_Place_Reference_Set_Input = {
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  evidence_text?: InputMaybe<Scalars['String']['input']>;
  extractor_version?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  place_reference_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Property_Place_Reference_Stddev_Fields = {
  __typename?: 'property_place_reference_stddev_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_place_reference" */
export type Property_Place_Reference_Stddev_Order_By = {
  confidence?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Place_Reference_Stddev_Pop_Fields = {
  __typename?: 'property_place_reference_stddev_pop_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_place_reference" */
export type Property_Place_Reference_Stddev_Pop_Order_By = {
  confidence?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Place_Reference_Stddev_Samp_Fields = {
  __typename?: 'property_place_reference_stddev_samp_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_place_reference" */
export type Property_Place_Reference_Stddev_Samp_Order_By = {
  confidence?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_place_reference" */
export type Property_Place_Reference_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Place_Reference_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Place_Reference_Stream_Cursor_Value_Input = {
  confidence?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  evidence_text?: InputMaybe<Scalars['String']['input']>;
  extractor_version?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  place_reference_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Property_Place_Reference_Sum_Fields = {
  __typename?: 'property_place_reference_sum_fields';
  confidence?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "property_place_reference" */
export type Property_Place_Reference_Sum_Order_By = {
  confidence?: InputMaybe<Order_By>;
};

/** update columns of table "property_place_reference" */
export enum Property_Place_Reference_Update_Column {
  /** column name */
  Confidence = 'confidence',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EvidenceText = 'evidence_text',
  /** column name */
  ExtractorVersion = 'extractor_version',
  /** column name */
  Id = 'id',
  /** column name */
  PlaceReferenceId = 'place_reference_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  Relation = 'relation',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_Place_Reference_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Place_Reference_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Place_Reference_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Place_Reference_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Place_Reference_Var_Pop_Fields = {
  __typename?: 'property_place_reference_var_pop_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_place_reference" */
export type Property_Place_Reference_Var_Pop_Order_By = {
  confidence?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Place_Reference_Var_Samp_Fields = {
  __typename?: 'property_place_reference_var_samp_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_place_reference" */
export type Property_Place_Reference_Var_Samp_Order_By = {
  confidence?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Place_Reference_Variance_Fields = {
  __typename?: 'property_place_reference_variance_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_place_reference" */
export type Property_Place_Reference_Variance_Order_By = {
  confidence?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_price_history" */
export type Property_Price_History = {
  __typename?: 'property_price_history';
  created_at: Scalars['timestamptz']['output'];
  date_recorded: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  price: Scalars['float8']['output'];
  price_currency: Currency_Enum;
  /** An object relationship */
  property?: Maybe<Property>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  property_list: Property_List;
  property_list_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "property_price_history" */
export type Property_Price_History_Aggregate = {
  __typename?: 'property_price_history_aggregate';
  aggregate?: Maybe<Property_Price_History_Aggregate_Fields>;
  nodes: Array<Property_Price_History>;
};

export type Property_Price_History_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Property_Price_History_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Property_Price_History_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Property_Price_History_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Property_Price_History_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Property_Price_History_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Property_Price_History_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Property_Price_History_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Property_Price_History_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Property_Price_History_Aggregate_Bool_Exp_Var_Samp>;
};

export type Property_Price_History_Aggregate_Bool_Exp_Avg = {
  arguments: Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Price_History_Aggregate_Bool_Exp_Corr = {
  arguments: Property_Price_History_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Price_History_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Property_Price_History_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Price_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Price_History_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Property_Price_History_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Property_Price_History_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Price_History_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Property_Price_History_Aggregate_Bool_Exp_Max = {
  arguments: Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Price_History_Aggregate_Bool_Exp_Min = {
  arguments: Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Price_History_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Price_History_Aggregate_Bool_Exp_Sum = {
  arguments: Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Price_History_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "property_price_history" */
export type Property_Price_History_Aggregate_Fields = {
  __typename?: 'property_price_history_aggregate_fields';
  avg?: Maybe<Property_Price_History_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Price_History_Max_Fields>;
  min?: Maybe<Property_Price_History_Min_Fields>;
  stddev?: Maybe<Property_Price_History_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Price_History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Price_History_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Price_History_Sum_Fields>;
  var_pop?: Maybe<Property_Price_History_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Price_History_Var_Samp_Fields>;
  variance?: Maybe<Property_Price_History_Variance_Fields>;
};


/** aggregate fields of "property_price_history" */
export type Property_Price_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Price_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_price_history" */
export type Property_Price_History_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Price_History_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Price_History_Max_Order_By>;
  min?: InputMaybe<Property_Price_History_Min_Order_By>;
  stddev?: InputMaybe<Property_Price_History_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Price_History_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Price_History_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Price_History_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Price_History_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Price_History_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Price_History_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_price_history" */
export type Property_Price_History_Arr_Rel_Insert_Input = {
  data: Array<Property_Price_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Price_History_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Price_History_Avg_Fields = {
  __typename?: 'property_price_history_avg_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_price_history" */
export type Property_Price_History_Avg_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_price_history". All fields are combined with a logical 'AND'. */
export type Property_Price_History_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Price_History_Bool_Exp>>;
  _not?: InputMaybe<Property_Price_History_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Price_History_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_recorded?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Float8_Comparison_Exp>;
  price_currency?: InputMaybe<Currency_Enum_Comparison_Exp>;
  property?: InputMaybe<Property_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_list?: InputMaybe<Property_List_Bool_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_price_history" */
export enum Property_Price_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyPriceHistoryPkey = 'property_price_history_pkey',
  /** unique or primary key constraint on columns "price", "property_list_id" */
  PropertyPriceHistoryPropertyListIdPriceKey = 'property_price_history_property_list_id_price_key'
}

/** input type for incrementing numeric columns in table "property_price_history" */
export type Property_Price_History_Inc_Input = {
  price?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "property_price_history" */
export type Property_Price_History_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_recorded?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  price_currency?: InputMaybe<Currency_Enum>;
  property?: InputMaybe<Property_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list?: InputMaybe<Property_List_Obj_Rel_Insert_Input>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Property_Price_History_Max_Fields = {
  __typename?: 'property_price_history_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_recorded?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property_price_history" */
export type Property_Price_History_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date_recorded?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Price_History_Min_Fields = {
  __typename?: 'property_price_history_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date_recorded?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property_price_history" */
export type Property_Price_History_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date_recorded?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_price_history" */
export type Property_Price_History_Mutation_Response = {
  __typename?: 'property_price_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Price_History>;
};

/** on_conflict condition type for table "property_price_history" */
export type Property_Price_History_On_Conflict = {
  constraint: Property_Price_History_Constraint;
  update_columns?: Array<Property_Price_History_Update_Column>;
  where?: InputMaybe<Property_Price_History_Bool_Exp>;
};

/** Ordering options when selecting data from "property_price_history". */
export type Property_Price_History_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date_recorded?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_currency?: InputMaybe<Order_By>;
  property?: InputMaybe<Property_Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_list?: InputMaybe<Property_List_Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_price_history */
export type Property_Price_History_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_price_history" */
export enum Property_Price_History_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateRecorded = 'date_recorded',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  PriceCurrency = 'price_currency',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "property_price_history_aggregate_bool_exp_avg_arguments_columns" columns of table "property_price_history" */
export enum Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "property_price_history_aggregate_bool_exp_corr_arguments_columns" columns of table "property_price_history" */
export enum Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "property_price_history_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "property_price_history" */
export enum Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "property_price_history_aggregate_bool_exp_max_arguments_columns" columns of table "property_price_history" */
export enum Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "property_price_history_aggregate_bool_exp_min_arguments_columns" columns of table "property_price_history" */
export enum Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "property_price_history_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "property_price_history" */
export enum Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "property_price_history_aggregate_bool_exp_sum_arguments_columns" columns of table "property_price_history" */
export enum Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "property_price_history_aggregate_bool_exp_var_samp_arguments_columns" columns of table "property_price_history" */
export enum Property_Price_History_Select_Column_Property_Price_History_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** input type for updating data in table "property_price_history" */
export type Property_Price_History_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_recorded?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  price_currency?: InputMaybe<Currency_Enum>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Property_Price_History_Stddev_Fields = {
  __typename?: 'property_price_history_stddev_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_price_history" */
export type Property_Price_History_Stddev_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Price_History_Stddev_Pop_Fields = {
  __typename?: 'property_price_history_stddev_pop_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_price_history" */
export type Property_Price_History_Stddev_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Price_History_Stddev_Samp_Fields = {
  __typename?: 'property_price_history_stddev_samp_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_price_history" */
export type Property_Price_History_Stddev_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_price_history" */
export type Property_Price_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Price_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Price_History_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_recorded?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  price_currency?: InputMaybe<Currency_Enum>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Property_Price_History_Sum_Fields = {
  __typename?: 'property_price_history_sum_fields';
  price?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "property_price_history" */
export type Property_Price_History_Sum_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** update columns of table "property_price_history" */
export enum Property_Price_History_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateRecorded = 'date_recorded',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  PriceCurrency = 'price_currency',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_Price_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Price_History_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Price_History_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Price_History_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Price_History_Var_Pop_Fields = {
  __typename?: 'property_price_history_var_pop_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_price_history" */
export type Property_Price_History_Var_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Price_History_Var_Samp_Fields = {
  __typename?: 'property_price_history_var_samp_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_price_history" */
export type Property_Price_History_Var_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Price_History_Variance_Fields = {
  __typename?: 'property_price_history_variance_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_price_history" */
export type Property_Price_History_Variance_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** reports for properties */
export type Property_Report_Type = {
  __typename?: 'property_report_type';
  report_type: Scalars['String']['output'];
};

/** aggregated selection of "property_report_type" */
export type Property_Report_Type_Aggregate = {
  __typename?: 'property_report_type_aggregate';
  aggregate?: Maybe<Property_Report_Type_Aggregate_Fields>;
  nodes: Array<Property_Report_Type>;
};

/** aggregate fields of "property_report_type" */
export type Property_Report_Type_Aggregate_Fields = {
  __typename?: 'property_report_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Report_Type_Max_Fields>;
  min?: Maybe<Property_Report_Type_Min_Fields>;
};


/** aggregate fields of "property_report_type" */
export type Property_Report_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Report_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "property_report_type". All fields are combined with a logical 'AND'. */
export type Property_Report_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Report_Type_Bool_Exp>>;
  _not?: InputMaybe<Property_Report_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Report_Type_Bool_Exp>>;
  report_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_report_type" */
export enum Property_Report_Type_Constraint {
  /** unique or primary key constraint on columns "report_type" */
  PropertyReportTypePkey = 'property_report_type_pkey'
}

export enum Property_Report_Type_Enum {
  Duplicate = 'DUPLICATE',
  Inappropriate = 'INAPPROPRIATE',
  Innacurate = 'INNACURATE',
  Other = 'OTHER',
  Scam = 'SCAM',
  Unavailable = 'UNAVAILABLE'
}

/** Boolean expression to compare columns of type "property_report_type_enum". All fields are combined with logical 'AND'. */
export type Property_Report_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Property_Report_Type_Enum>;
  _in?: InputMaybe<Array<Property_Report_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Property_Report_Type_Enum>;
  _nin?: InputMaybe<Array<Property_Report_Type_Enum>>;
};

/** input type for inserting data into table "property_report_type" */
export type Property_Report_Type_Insert_Input = {
  report_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Property_Report_Type_Max_Fields = {
  __typename?: 'property_report_type_max_fields';
  report_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Property_Report_Type_Min_Fields = {
  __typename?: 'property_report_type_min_fields';
  report_type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "property_report_type" */
export type Property_Report_Type_Mutation_Response = {
  __typename?: 'property_report_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Report_Type>;
};

/** on_conflict condition type for table "property_report_type" */
export type Property_Report_Type_On_Conflict = {
  constraint: Property_Report_Type_Constraint;
  update_columns?: Array<Property_Report_Type_Update_Column>;
  where?: InputMaybe<Property_Report_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "property_report_type". */
export type Property_Report_Type_Order_By = {
  report_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_report_type */
export type Property_Report_Type_Pk_Columns_Input = {
  report_type: Scalars['String']['input'];
};

/** select columns of table "property_report_type" */
export enum Property_Report_Type_Select_Column {
  /** column name */
  ReportType = 'report_type'
}

/** input type for updating data in table "property_report_type" */
export type Property_Report_Type_Set_Input = {
  report_type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "property_report_type" */
export type Property_Report_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Report_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Report_Type_Stream_Cursor_Value_Input = {
  report_type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "property_report_type" */
export enum Property_Report_Type_Update_Column {
  /** column name */
  ReportType = 'report_type'
}

export type Property_Report_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Report_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Report_Type_Bool_Exp;
};

/** select columns of table "property" */
export enum Property_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  JsonLd = 'json_ld',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  MainListingId = 'main_listing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "property" */
export type Property_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  json_ld?: InputMaybe<Scalars['String']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  main_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "property_source" */
export type Property_Source = {
  __typename?: 'property_source';
  /** An object relationship */
  agency?: Maybe<Agency>;
  agency_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  origin?: Maybe<Property_Origin_Enum>;
  /** An array relationship */
  property_lists: Array<Property_List>;
  /** An aggregate relationship */
  property_lists_aggregate: Property_List_Aggregate;
  type: Property_Origin_Type_Enum;
};


/** columns and relationships of "property_source" */
export type Property_SourceProperty_ListsArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


/** columns and relationships of "property_source" */
export type Property_SourceProperty_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};

/** aggregated selection of "property_source" */
export type Property_Source_Aggregate = {
  __typename?: 'property_source_aggregate';
  aggregate?: Maybe<Property_Source_Aggregate_Fields>;
  nodes: Array<Property_Source>;
};

export type Property_Source_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Source_Aggregate_Bool_Exp_Count>;
};

export type Property_Source_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Source_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_source" */
export type Property_Source_Aggregate_Fields = {
  __typename?: 'property_source_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Source_Max_Fields>;
  min?: Maybe<Property_Source_Min_Fields>;
};


/** aggregate fields of "property_source" */
export type Property_Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_source" */
export type Property_Source_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Source_Max_Order_By>;
  min?: InputMaybe<Property_Source_Min_Order_By>;
};

/** input type for inserting array relation for remote table "property_source" */
export type Property_Source_Arr_Rel_Insert_Input = {
  data: Array<Property_Source_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Source_On_Conflict>;
};

/** Boolean expression to filter rows from the table "property_source". All fields are combined with a logical 'AND'. */
export type Property_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Source_Bool_Exp>>;
  _not?: InputMaybe<Property_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Source_Bool_Exp>>;
  agency?: InputMaybe<Agency_Bool_Exp>;
  agency_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  origin?: InputMaybe<Property_Origin_Enum_Comparison_Exp>;
  property_lists?: InputMaybe<Property_List_Bool_Exp>;
  property_lists_aggregate?: InputMaybe<Property_List_Aggregate_Bool_Exp>;
  type?: InputMaybe<Property_Origin_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_source" */
export enum Property_Source_Constraint {
  /** unique or primary key constraint on columns "origin", "agency_id" */
  PropertySourceAgencyIdOriginKey = 'property_source_agency_id_origin_key',
  /** unique or primary key constraint on columns "id" */
  PropertySourcePkey = 'property_source_pkey'
}

/** input type for inserting data into table "property_source" */
export type Property_Source_Insert_Input = {
  agency?: InputMaybe<Agency_Obj_Rel_Insert_Input>;
  agency_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  origin?: InputMaybe<Property_Origin_Enum>;
  property_lists?: InputMaybe<Property_List_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Property_Origin_Type_Enum>;
};

/** aggregate max on columns */
export type Property_Source_Max_Fields = {
  __typename?: 'property_source_max_fields';
  agency_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "property_source" */
export type Property_Source_Max_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Source_Min_Fields = {
  __typename?: 'property_source_min_fields';
  agency_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "property_source" */
export type Property_Source_Min_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_source" */
export type Property_Source_Mutation_Response = {
  __typename?: 'property_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Source>;
};

/** input type for inserting object relation for remote table "property_source" */
export type Property_Source_Obj_Rel_Insert_Input = {
  data: Property_Source_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Source_On_Conflict>;
};

/** on_conflict condition type for table "property_source" */
export type Property_Source_On_Conflict = {
  constraint: Property_Source_Constraint;
  update_columns?: Array<Property_Source_Update_Column>;
  where?: InputMaybe<Property_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "property_source". */
export type Property_Source_Order_By = {
  agency?: InputMaybe<Agency_Order_By>;
  agency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  origin?: InputMaybe<Order_By>;
  property_lists_aggregate?: InputMaybe<Property_List_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_source */
export type Property_Source_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_source" */
export enum Property_Source_Select_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  Id = 'id',
  /** column name */
  Origin = 'origin',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "property_source" */
export type Property_Source_Set_Input = {
  agency_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  origin?: InputMaybe<Property_Origin_Enum>;
  type?: InputMaybe<Property_Origin_Type_Enum>;
};

/** Streaming cursor of the table "property_source" */
export type Property_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Source_Stream_Cursor_Value_Input = {
  agency_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  origin?: InputMaybe<Property_Origin_Enum>;
  type?: InputMaybe<Property_Origin_Type_Enum>;
};

/** update columns of table "property_source" */
export enum Property_Source_Update_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  Id = 'id',
  /** column name */
  Origin = 'origin',
  /** column name */
  Type = 'type'
}

export type Property_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Source_Bool_Exp;
};

/** columns and relationships of "property_status" */
export type Property_Status = {
  __typename?: 'property_status';
  status: Scalars['String']['output'];
};

export type Property_Status_ActionType = {
  __typename?: 'property_status_ActionType';
  status: Scalars['String']['output'];
};

/** aggregated selection of "property_status" */
export type Property_Status_Aggregate = {
  __typename?: 'property_status_aggregate';
  aggregate?: Maybe<Property_Status_Aggregate_Fields>;
  nodes: Array<Property_Status>;
};

/** aggregate fields of "property_status" */
export type Property_Status_Aggregate_Fields = {
  __typename?: 'property_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Status_Max_Fields>;
  min?: Maybe<Property_Status_Min_Fields>;
};


/** aggregate fields of "property_status" */
export type Property_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "property_status". All fields are combined with a logical 'AND'. */
export type Property_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Status_Bool_Exp>>;
  _not?: InputMaybe<Property_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_status" */
export enum Property_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  PropertyStatusPkey = 'property_status_pkey'
}

export enum Property_Status_Enum {
  ForRent = 'for_rent',
  ForSale = 'for_sale',
  Rented = 'rented',
  Sold = 'sold',
  UnderOffer = 'under_offer'
}

/** Boolean expression to compare columns of type "property_status_enum". All fields are combined with logical 'AND'. */
export type Property_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Property_Status_Enum>;
  _in?: InputMaybe<Array<Property_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Property_Status_Enum>;
  _nin?: InputMaybe<Array<Property_Status_Enum>>;
};

/** input type for inserting data into table "property_status" */
export type Property_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Property_Status_Max_Fields = {
  __typename?: 'property_status_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Property_Status_Min_Fields = {
  __typename?: 'property_status_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "property_status" */
export type Property_Status_Mutation_Response = {
  __typename?: 'property_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Status>;
};

/** on_conflict condition type for table "property_status" */
export type Property_Status_On_Conflict = {
  constraint: Property_Status_Constraint;
  update_columns?: Array<Property_Status_Update_Column>;
  where?: InputMaybe<Property_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "property_status". */
export type Property_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_status */
export type Property_Status_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "property_status" */
export enum Property_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "property_status" */
export type Property_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "property_status" */
export type Property_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "property_status" */
export enum Property_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Property_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Status_Bool_Exp;
};

/** Streaming cursor of the table "property" */
export type Property_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  json_ld?: InputMaybe<Scalars['String']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  main_listing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "property_type" */
export type Property_Type = {
  __typename?: 'property_type';
  cluster?: Maybe<Property_Cluster_Enum>;
  /** An object relationship */
  property_cluster?: Maybe<Property_Cluster>;
  /** An array relationship */
  property_lists: Array<Property_List>;
  /** An aggregate relationship */
  property_lists_aggregate: Property_List_Aggregate;
  type: Scalars['String']['output'];
};


/** columns and relationships of "property_type" */
export type Property_TypeProperty_ListsArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


/** columns and relationships of "property_type" */
export type Property_TypeProperty_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};

export type Property_Type_ActionType = {
  __typename?: 'property_type_ActionType';
  cluster?: Maybe<Property_Cluster_ActionType>;
  type: Scalars['String']['output'];
};

/** aggregated selection of "property_type" */
export type Property_Type_Aggregate = {
  __typename?: 'property_type_aggregate';
  aggregate?: Maybe<Property_Type_Aggregate_Fields>;
  nodes: Array<Property_Type>;
};

export type Property_Type_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Type_Aggregate_Bool_Exp_Count>;
};

export type Property_Type_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Type_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_type" */
export type Property_Type_Aggregate_Fields = {
  __typename?: 'property_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Type_Max_Fields>;
  min?: Maybe<Property_Type_Min_Fields>;
};


/** aggregate fields of "property_type" */
export type Property_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_type" */
export type Property_Type_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Type_Max_Order_By>;
  min?: InputMaybe<Property_Type_Min_Order_By>;
};

/** input type for inserting array relation for remote table "property_type" */
export type Property_Type_Arr_Rel_Insert_Input = {
  data: Array<Property_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Type_On_Conflict>;
};

/** Boolean expression to filter rows from the table "property_type". All fields are combined with a logical 'AND'. */
export type Property_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Type_Bool_Exp>>;
  _not?: InputMaybe<Property_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Type_Bool_Exp>>;
  cluster?: InputMaybe<Property_Cluster_Enum_Comparison_Exp>;
  property_cluster?: InputMaybe<Property_Cluster_Bool_Exp>;
  property_lists?: InputMaybe<Property_List_Bool_Exp>;
  property_lists_aggregate?: InputMaybe<Property_List_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_type" */
export enum Property_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  PropertyTypePkey = 'property_type_pkey'
}

export enum Property_Type_Enum {
  /** residential */
  Apartment = 'apartment',
  /** residential */
  Building = 'building',
  /** residential */
  Bungalow = 'bungalow',
  /** commercial */
  Commercial = 'commercial',
  /** residential */
  Duplex = 'duplex',
  /** industrial */
  Factory = 'factory',
  /** land */
  Farm = 'farm',
  /** residential */
  Farmhouse = 'farmhouse',
  /** land */
  Farmland = 'farmland',
  /** commercial */
  Hotel = 'hotel',
  /** land */
  Land = 'land',
  /** commercial */
  MultipurposeSpace = 'multipurpose_space',
  /** commercial */
  Office = 'office',
  /** parking */
  Parking = 'parking',
  /** residential */
  PrivateHouse = 'private_house',
  /** commercial */
  Restaurant = 'restaurant',
  /** commercial */
  Shop = 'shop',
  /** commercial */
  ShoppingCenter = 'shopping_center',
  /** residential */
  Studio = 'studio',
  /** residential */
  Villa = 'villa',
  /** industrial */
  Warehouse = 'warehouse'
}

/** Boolean expression to compare columns of type "property_type_enum". All fields are combined with logical 'AND'. */
export type Property_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Property_Type_Enum>;
  _in?: InputMaybe<Array<Property_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Property_Type_Enum>;
  _nin?: InputMaybe<Array<Property_Type_Enum>>;
};

/** input type for inserting data into table "property_type" */
export type Property_Type_Insert_Input = {
  cluster?: InputMaybe<Property_Cluster_Enum>;
  property_cluster?: InputMaybe<Property_Cluster_Obj_Rel_Insert_Input>;
  property_lists?: InputMaybe<Property_List_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Property_Type_Max_Fields = {
  __typename?: 'property_type_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "property_type" */
export type Property_Type_Max_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Type_Min_Fields = {
  __typename?: 'property_type_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "property_type" */
export type Property_Type_Min_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_type" */
export type Property_Type_Mutation_Response = {
  __typename?: 'property_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Type>;
};

/** input type for inserting object relation for remote table "property_type" */
export type Property_Type_Obj_Rel_Insert_Input = {
  data: Property_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Type_On_Conflict>;
};

/** on_conflict condition type for table "property_type" */
export type Property_Type_On_Conflict = {
  constraint: Property_Type_Constraint;
  update_columns?: Array<Property_Type_Update_Column>;
  where?: InputMaybe<Property_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "property_type". */
export type Property_Type_Order_By = {
  cluster?: InputMaybe<Order_By>;
  property_cluster?: InputMaybe<Property_Cluster_Order_By>;
  property_lists_aggregate?: InputMaybe<Property_List_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_type */
export type Property_Type_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "property_type" */
export enum Property_Type_Select_Column {
  /** column name */
  Cluster = 'cluster',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "property_type" */
export type Property_Type_Set_Input = {
  cluster?: InputMaybe<Property_Cluster_Enum>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "property_type" */
export type Property_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Type_Stream_Cursor_Value_Input = {
  cluster?: InputMaybe<Property_Cluster_Enum>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "property_type" */
export enum Property_Type_Update_Column {
  /** column name */
  Cluster = 'cluster',
  /** column name */
  Type = 'type'
}

export type Property_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Type_Bool_Exp;
};

export type Property_Types_Distribution_Model = {
  __typename?: 'property_types_distribution_model';
  cluster?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['numeric']['output']>;
  total_properties?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the logical model for "property_types_distribution_model". All fields are combined with a logical 'AND'. */
export type Property_Types_Distribution_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Types_Distribution_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Property_Types_Distribution_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Types_Distribution_Model_Bool_Exp_Bool_Exp>>;
  cluster?: InputMaybe<String_Comparison_Exp>;
  percentage?: InputMaybe<Numeric_Comparison_Exp>;
  total_properties?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Property_Types_Distribution_Model_Enum_Name {
  /** column name */
  Cluster = 'cluster',
  /** column name */
  Percentage = 'percentage',
  /** column name */
  TotalProperties = 'total_properties'
}

/** Ordering options when selecting data from "property_types_distribution_model". */
export type Property_Types_Distribution_Model_Order_By = {
  cluster?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  total_properties?: InputMaybe<Order_By>;
};

/** update columns of table "property" */
export enum Property_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  JsonLd = 'json_ld',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  MainListingId = 'main_listing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Bool_Exp;
};

/** columns and relationships of "property_views" */
export type Property_Views = {
  __typename?: 'property_views';
  created_at: Scalars['timestamptz']['output'];
  date: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  property_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  view_count: Scalars['Int']['output'];
};

/** aggregated selection of "property_views" */
export type Property_Views_Aggregate = {
  __typename?: 'property_views_aggregate';
  aggregate?: Maybe<Property_Views_Aggregate_Fields>;
  nodes: Array<Property_Views>;
};

export type Property_Views_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Views_Aggregate_Bool_Exp_Count>;
};

export type Property_Views_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Views_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Views_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_views" */
export type Property_Views_Aggregate_Fields = {
  __typename?: 'property_views_aggregate_fields';
  avg?: Maybe<Property_Views_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Views_Max_Fields>;
  min?: Maybe<Property_Views_Min_Fields>;
  stddev?: Maybe<Property_Views_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Views_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Views_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Views_Sum_Fields>;
  var_pop?: Maybe<Property_Views_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Views_Var_Samp_Fields>;
  variance?: Maybe<Property_Views_Variance_Fields>;
};


/** aggregate fields of "property_views" */
export type Property_Views_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Views_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_views" */
export type Property_Views_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Views_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Views_Max_Order_By>;
  min?: InputMaybe<Property_Views_Min_Order_By>;
  stddev?: InputMaybe<Property_Views_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Views_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Views_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Views_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Views_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Views_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Views_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_views" */
export type Property_Views_Arr_Rel_Insert_Input = {
  data: Array<Property_Views_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Views_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Views_Avg_Fields = {
  __typename?: 'property_views_avg_fields';
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_views" */
export type Property_Views_Avg_Order_By = {
  view_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_views". All fields are combined with a logical 'AND'. */
export type Property_Views_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Views_Bool_Exp>>;
  _not?: InputMaybe<Property_Views_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Views_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  view_count?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_views" */
export enum Property_Views_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyViewsPkey = 'property_views_pkey'
}

/** input type for incrementing numeric columns in table "property_views" */
export type Property_Views_Inc_Input = {
  view_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_views" */
export type Property_Views_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  view_count?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Property_Views_Max_Fields = {
  __typename?: 'property_views_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  view_count?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "property_views" */
export type Property_Views_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Views_Min_Fields = {
  __typename?: 'property_views_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  view_count?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "property_views" */
export type Property_Views_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

export type Property_Views_Model = {
  __typename?: 'property_views_model';
  report_date?: Maybe<Scalars['date']['output']>;
  views_nr?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the logical model for "property_views_model". All fields are combined with a logical 'AND'. */
export type Property_Views_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Views_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Property_Views_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Views_Model_Bool_Exp_Bool_Exp>>;
  report_date?: InputMaybe<Date_Comparison_Exp>;
  views_nr?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Property_Views_Model_Enum_Name {
  /** column name */
  ReportDate = 'report_date',
  /** column name */
  ViewsNr = 'views_nr'
}

/** Ordering options when selecting data from "property_views_model". */
export type Property_Views_Model_Order_By = {
  report_date?: InputMaybe<Order_By>;
  views_nr?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_views" */
export type Property_Views_Mutation_Response = {
  __typename?: 'property_views_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Views>;
};

/** on_conflict condition type for table "property_views" */
export type Property_Views_On_Conflict = {
  constraint: Property_Views_Constraint;
  update_columns?: Array<Property_Views_Update_Column>;
  where?: InputMaybe<Property_Views_Bool_Exp>;
};

/** Ordering options when selecting data from "property_views". */
export type Property_Views_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  view_count?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_views */
export type Property_Views_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_views" */
export enum Property_Views_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViewCount = 'view_count'
}

/** input type for updating data in table "property_views" */
export type Property_Views_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  view_count?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Property_Views_Stddev_Fields = {
  __typename?: 'property_views_stddev_fields';
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_views" */
export type Property_Views_Stddev_Order_By = {
  view_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Views_Stddev_Pop_Fields = {
  __typename?: 'property_views_stddev_pop_fields';
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_views" */
export type Property_Views_Stddev_Pop_Order_By = {
  view_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Views_Stddev_Samp_Fields = {
  __typename?: 'property_views_stddev_samp_fields';
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_views" */
export type Property_Views_Stddev_Samp_Order_By = {
  view_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_views" */
export type Property_Views_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Views_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Views_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  view_count?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Property_Views_Sum_Fields = {
  __typename?: 'property_views_sum_fields';
  view_count?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_views" */
export type Property_Views_Sum_Order_By = {
  view_count?: InputMaybe<Order_By>;
};

/** update columns of table "property_views" */
export enum Property_Views_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViewCount = 'view_count'
}

export type Property_Views_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Views_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Views_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Views_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Views_Var_Pop_Fields = {
  __typename?: 'property_views_var_pop_fields';
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_views" */
export type Property_Views_Var_Pop_Order_By = {
  view_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Views_Var_Samp_Fields = {
  __typename?: 'property_views_var_samp_fields';
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_views" */
export type Property_Views_Var_Samp_Order_By = {
  view_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Views_Variance_Fields = {
  __typename?: 'property_views_variance_fields';
  view_count?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_views" */
export type Property_Views_Variance_Order_By = {
  view_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "queries_property_result" */
export type Queries_Property_Result = {
  __typename?: 'queries_property_result';
  created_at: Scalars['timestamptz']['output'];
  featured?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  natural_language_query: Natural_Language_Queries;
  natural_language_query_id: Scalars['uuid']['output'];
  price?: Maybe<Scalars['float8']['output']>;
  property?: Maybe<Property>;
  property_id: Scalars['uuid']['output'];
  property_last_seen?: Maybe<Scalars['timestamptz']['output']>;
  score?: Maybe<Scalars['float8']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "queries_property_result" */
export type Queries_Property_Result_Aggregate = {
  __typename?: 'queries_property_result_aggregate';
  aggregate?: Maybe<Queries_Property_Result_Aggregate_Fields>;
  nodes: Array<Queries_Property_Result>;
};

export type Queries_Property_Result_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Queries_Property_Result_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Queries_Property_Result_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Queries_Property_Result_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Queries_Property_Result_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Queries_Property_Result_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Queries_Property_Result_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Queries_Property_Result_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Queries_Property_Result_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Queries_Property_Result_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Queries_Property_Result_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Queries_Property_Result_Aggregate_Bool_Exp_Var_Samp>;
};

export type Queries_Property_Result_Aggregate_Bool_Exp_Avg = {
  arguments: Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queries_Property_Result_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Queries_Property_Result_Aggregate_Bool_Exp_Bool_And = {
  arguments: Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queries_Property_Result_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Queries_Property_Result_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queries_Property_Result_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Queries_Property_Result_Aggregate_Bool_Exp_Corr = {
  arguments: Queries_Property_Result_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queries_Property_Result_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Queries_Property_Result_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Queries_Property_Result_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Queries_Property_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queries_Property_Result_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Queries_Property_Result_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Queries_Property_Result_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queries_Property_Result_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Queries_Property_Result_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Queries_Property_Result_Aggregate_Bool_Exp_Max = {
  arguments: Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queries_Property_Result_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Queries_Property_Result_Aggregate_Bool_Exp_Min = {
  arguments: Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queries_Property_Result_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Queries_Property_Result_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queries_Property_Result_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Queries_Property_Result_Aggregate_Bool_Exp_Sum = {
  arguments: Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queries_Property_Result_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Queries_Property_Result_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queries_Property_Result_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "queries_property_result" */
export type Queries_Property_Result_Aggregate_Fields = {
  __typename?: 'queries_property_result_aggregate_fields';
  avg?: Maybe<Queries_Property_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Queries_Property_Result_Max_Fields>;
  min?: Maybe<Queries_Property_Result_Min_Fields>;
  stddev?: Maybe<Queries_Property_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Queries_Property_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Queries_Property_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Queries_Property_Result_Sum_Fields>;
  var_pop?: Maybe<Queries_Property_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Queries_Property_Result_Var_Samp_Fields>;
  variance?: Maybe<Queries_Property_Result_Variance_Fields>;
};


/** aggregate fields of "queries_property_result" */
export type Queries_Property_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Queries_Property_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "queries_property_result" */
export type Queries_Property_Result_Aggregate_Order_By = {
  avg?: InputMaybe<Queries_Property_Result_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Queries_Property_Result_Max_Order_By>;
  min?: InputMaybe<Queries_Property_Result_Min_Order_By>;
  stddev?: InputMaybe<Queries_Property_Result_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Queries_Property_Result_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Queries_Property_Result_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Queries_Property_Result_Sum_Order_By>;
  var_pop?: InputMaybe<Queries_Property_Result_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Queries_Property_Result_Var_Samp_Order_By>;
  variance?: InputMaybe<Queries_Property_Result_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "queries_property_result" */
export type Queries_Property_Result_Arr_Rel_Insert_Input = {
  data: Array<Queries_Property_Result_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Queries_Property_Result_On_Conflict>;
};

/** aggregate avg on columns */
export type Queries_Property_Result_Avg_Fields = {
  __typename?: 'queries_property_result_avg_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "queries_property_result" */
export type Queries_Property_Result_Avg_Order_By = {
  price?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "queries_property_result". All fields are combined with a logical 'AND'. */
export type Queries_Property_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Queries_Property_Result_Bool_Exp>>;
  _not?: InputMaybe<Queries_Property_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Queries_Property_Result_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  natural_language_query?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
  natural_language_query_id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Float8_Comparison_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_last_seen?: InputMaybe<Timestamptz_Comparison_Exp>;
  score?: InputMaybe<Float8_Comparison_Exp>;
  sponsored?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "queries_property_result" */
export enum Queries_Property_Result_Constraint {
  /** unique or primary key constraint on columns "natural_language_query_id", "property_id" */
  QueriesPropertyResultNaturalLanguageQueryIdPropertyKey = 'queries_property_result_natural_language_query_id_property__key',
  /** unique or primary key constraint on columns "id" */
  QueriesPropertyResultPkey = 'queries_property_result_pkey'
}

/** input type for incrementing numeric columns in table "queries_property_result" */
export type Queries_Property_Result_Inc_Input = {
  price?: InputMaybe<Scalars['float8']['input']>;
  score?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "queries_property_result" */
export type Queries_Property_Result_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  natural_language_query?: InputMaybe<Natural_Language_Queries_Obj_Rel_Insert_Input>;
  natural_language_query_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  score?: InputMaybe<Scalars['float8']['input']>;
  sponsored?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Queries_Property_Result_Max_Fields = {
  __typename?: 'queries_property_result_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  natural_language_query_id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_last_seen?: Maybe<Scalars['timestamptz']['output']>;
  score?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "queries_property_result" */
export type Queries_Property_Result_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  natural_language_query_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_last_seen?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Queries_Property_Result_Min_Fields = {
  __typename?: 'queries_property_result_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  natural_language_query_id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_last_seen?: Maybe<Scalars['timestamptz']['output']>;
  score?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "queries_property_result" */
export type Queries_Property_Result_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  natural_language_query_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_last_seen?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "queries_property_result" */
export type Queries_Property_Result_Mutation_Response = {
  __typename?: 'queries_property_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Queries_Property_Result>;
};

/** on_conflict condition type for table "queries_property_result" */
export type Queries_Property_Result_On_Conflict = {
  constraint: Queries_Property_Result_Constraint;
  update_columns?: Array<Queries_Property_Result_Update_Column>;
  where?: InputMaybe<Queries_Property_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "queries_property_result". */
export type Queries_Property_Result_Order_By = {
  created_at?: InputMaybe<Order_By>;
  featured?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  natural_language_query?: InputMaybe<Natural_Language_Queries_Order_By>;
  natural_language_query_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_last_seen?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  sponsored?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: queries_property_result */
export type Queries_Property_Result_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "queries_property_result_re" */
export type Queries_Property_Result_Re = {
  __typename?: 'queries_property_result_re';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  natural_language_query_id: Scalars['uuid']['output'];
  price?: Maybe<Scalars['float8']['output']>;
  property_id: Scalars['uuid']['output'];
  property_last_seen?: Maybe<Scalars['timestamptz']['output']>;
  score?: Maybe<Scalars['float8']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "queries_property_result_re" */
export type Queries_Property_Result_Re_Aggregate = {
  __typename?: 'queries_property_result_re_aggregate';
  aggregate?: Maybe<Queries_Property_Result_Re_Aggregate_Fields>;
  nodes: Array<Queries_Property_Result_Re>;
};

/** aggregate fields of "queries_property_result_re" */
export type Queries_Property_Result_Re_Aggregate_Fields = {
  __typename?: 'queries_property_result_re_aggregate_fields';
  avg?: Maybe<Queries_Property_Result_Re_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Queries_Property_Result_Re_Max_Fields>;
  min?: Maybe<Queries_Property_Result_Re_Min_Fields>;
  stddev?: Maybe<Queries_Property_Result_Re_Stddev_Fields>;
  stddev_pop?: Maybe<Queries_Property_Result_Re_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Queries_Property_Result_Re_Stddev_Samp_Fields>;
  sum?: Maybe<Queries_Property_Result_Re_Sum_Fields>;
  var_pop?: Maybe<Queries_Property_Result_Re_Var_Pop_Fields>;
  var_samp?: Maybe<Queries_Property_Result_Re_Var_Samp_Fields>;
  variance?: Maybe<Queries_Property_Result_Re_Variance_Fields>;
};


/** aggregate fields of "queries_property_result_re" */
export type Queries_Property_Result_Re_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Queries_Property_Result_Re_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Queries_Property_Result_Re_Avg_Fields = {
  __typename?: 'queries_property_result_re_avg_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "queries_property_result_re". All fields are combined with a logical 'AND'. */
export type Queries_Property_Result_Re_Bool_Exp = {
  _and?: InputMaybe<Array<Queries_Property_Result_Re_Bool_Exp>>;
  _not?: InputMaybe<Queries_Property_Result_Re_Bool_Exp>;
  _or?: InputMaybe<Array<Queries_Property_Result_Re_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  natural_language_query_id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Float8_Comparison_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_last_seen?: InputMaybe<Timestamptz_Comparison_Exp>;
  score?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "queries_property_result_re" */
export enum Queries_Property_Result_Re_Constraint {
  /** unique or primary key constraint on columns "natural_language_query_id", "property_id" */
  QueriesPropertyResultReNaturalLanguageQueryIdProperKey = 'queries_property_result_re_natural_language_query_id_proper_key',
  /** unique or primary key constraint on columns "id" */
  QueriesPropertyResultRePkey = 'queries_property_result_re_pkey'
}

/** input type for incrementing numeric columns in table "queries_property_result_re" */
export type Queries_Property_Result_Re_Inc_Input = {
  price?: InputMaybe<Scalars['float8']['input']>;
  score?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "queries_property_result_re" */
export type Queries_Property_Result_Re_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  natural_language_query_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  score?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Queries_Property_Result_Re_Max_Fields = {
  __typename?: 'queries_property_result_re_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  natural_language_query_id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_last_seen?: Maybe<Scalars['timestamptz']['output']>;
  score?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Queries_Property_Result_Re_Min_Fields = {
  __typename?: 'queries_property_result_re_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  natural_language_query_id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_last_seen?: Maybe<Scalars['timestamptz']['output']>;
  score?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "queries_property_result_re" */
export type Queries_Property_Result_Re_Mutation_Response = {
  __typename?: 'queries_property_result_re_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Queries_Property_Result_Re>;
};

/** on_conflict condition type for table "queries_property_result_re" */
export type Queries_Property_Result_Re_On_Conflict = {
  constraint: Queries_Property_Result_Re_Constraint;
  update_columns?: Array<Queries_Property_Result_Re_Update_Column>;
  where?: InputMaybe<Queries_Property_Result_Re_Bool_Exp>;
};

/** Ordering options when selecting data from "queries_property_result_re". */
export type Queries_Property_Result_Re_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  natural_language_query_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_last_seen?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: queries_property_result_re */
export type Queries_Property_Result_Re_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "queries_property_result_re" */
export enum Queries_Property_Result_Re_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NaturalLanguageQueryId = 'natural_language_query_id',
  /** column name */
  Price = 'price',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyLastSeen = 'property_last_seen',
  /** column name */
  Score = 'score',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "queries_property_result_re" */
export type Queries_Property_Result_Re_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  natural_language_query_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  score?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Queries_Property_Result_Re_Stddev_Fields = {
  __typename?: 'queries_property_result_re_stddev_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Queries_Property_Result_Re_Stddev_Pop_Fields = {
  __typename?: 'queries_property_result_re_stddev_pop_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Queries_Property_Result_Re_Stddev_Samp_Fields = {
  __typename?: 'queries_property_result_re_stddev_samp_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "queries_property_result_re" */
export type Queries_Property_Result_Re_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Queries_Property_Result_Re_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Queries_Property_Result_Re_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  natural_language_query_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  score?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Queries_Property_Result_Re_Sum_Fields = {
  __typename?: 'queries_property_result_re_sum_fields';
  price?: Maybe<Scalars['float8']['output']>;
  score?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "queries_property_result_re" */
export enum Queries_Property_Result_Re_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NaturalLanguageQueryId = 'natural_language_query_id',
  /** column name */
  Price = 'price',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyLastSeen = 'property_last_seen',
  /** column name */
  Score = 'score',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Queries_Property_Result_Re_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Queries_Property_Result_Re_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Queries_Property_Result_Re_Set_Input>;
  /** filter the rows which have to be updated */
  where: Queries_Property_Result_Re_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Queries_Property_Result_Re_Var_Pop_Fields = {
  __typename?: 'queries_property_result_re_var_pop_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Queries_Property_Result_Re_Var_Samp_Fields = {
  __typename?: 'queries_property_result_re_var_samp_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Queries_Property_Result_Re_Variance_Fields = {
  __typename?: 'queries_property_result_re_variance_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "queries_property_result" */
export enum Queries_Property_Result_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Featured = 'featured',
  /** column name */
  Id = 'id',
  /** column name */
  NaturalLanguageQueryId = 'natural_language_query_id',
  /** column name */
  Price = 'price',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyLastSeen = 'property_last_seen',
  /** column name */
  Score = 'score',
  /** column name */
  Sponsored = 'sponsored',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "queries_property_result_aggregate_bool_exp_avg_arguments_columns" columns of table "queries_property_result" */
export enum Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Price = 'price',
  /** column name */
  Score = 'score'
}

/** select "queries_property_result_aggregate_bool_exp_bool_and_arguments_columns" columns of table "queries_property_result" */
export enum Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Featured = 'featured',
  /** column name */
  Sponsored = 'sponsored'
}

/** select "queries_property_result_aggregate_bool_exp_bool_or_arguments_columns" columns of table "queries_property_result" */
export enum Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Featured = 'featured',
  /** column name */
  Sponsored = 'sponsored'
}

/** select "queries_property_result_aggregate_bool_exp_corr_arguments_columns" columns of table "queries_property_result" */
export enum Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Price = 'price',
  /** column name */
  Score = 'score'
}

/** select "queries_property_result_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "queries_property_result" */
export enum Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Price = 'price',
  /** column name */
  Score = 'score'
}

/** select "queries_property_result_aggregate_bool_exp_max_arguments_columns" columns of table "queries_property_result" */
export enum Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Price = 'price',
  /** column name */
  Score = 'score'
}

/** select "queries_property_result_aggregate_bool_exp_min_arguments_columns" columns of table "queries_property_result" */
export enum Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Price = 'price',
  /** column name */
  Score = 'score'
}

/** select "queries_property_result_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "queries_property_result" */
export enum Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Price = 'price',
  /** column name */
  Score = 'score'
}

/** select "queries_property_result_aggregate_bool_exp_sum_arguments_columns" columns of table "queries_property_result" */
export enum Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Price = 'price',
  /** column name */
  Score = 'score'
}

/** select "queries_property_result_aggregate_bool_exp_var_samp_arguments_columns" columns of table "queries_property_result" */
export enum Queries_Property_Result_Select_Column_Queries_Property_Result_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Price = 'price',
  /** column name */
  Score = 'score'
}

/** input type for updating data in table "queries_property_result" */
export type Queries_Property_Result_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  natural_language_query_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  score?: InputMaybe<Scalars['float8']['input']>;
  sponsored?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Queries_Property_Result_Stddev_Fields = {
  __typename?: 'queries_property_result_stddev_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "queries_property_result" */
export type Queries_Property_Result_Stddev_Order_By = {
  price?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Queries_Property_Result_Stddev_Pop_Fields = {
  __typename?: 'queries_property_result_stddev_pop_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "queries_property_result" */
export type Queries_Property_Result_Stddev_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Queries_Property_Result_Stddev_Samp_Fields = {
  __typename?: 'queries_property_result_stddev_samp_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "queries_property_result" */
export type Queries_Property_Result_Stddev_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "queries_property_result" */
export type Queries_Property_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Queries_Property_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Queries_Property_Result_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  natural_language_query_id?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  score?: InputMaybe<Scalars['float8']['input']>;
  sponsored?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Queries_Property_Result_Sum_Fields = {
  __typename?: 'queries_property_result_sum_fields';
  price?: Maybe<Scalars['float8']['output']>;
  score?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "queries_property_result" */
export type Queries_Property_Result_Sum_Order_By = {
  price?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** update columns of table "queries_property_result" */
export enum Queries_Property_Result_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Featured = 'featured',
  /** column name */
  Id = 'id',
  /** column name */
  NaturalLanguageQueryId = 'natural_language_query_id',
  /** column name */
  Price = 'price',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyLastSeen = 'property_last_seen',
  /** column name */
  Score = 'score',
  /** column name */
  Sponsored = 'sponsored',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Queries_Property_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Queries_Property_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Queries_Property_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Queries_Property_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Queries_Property_Result_Var_Pop_Fields = {
  __typename?: 'queries_property_result_var_pop_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "queries_property_result" */
export type Queries_Property_Result_Var_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Queries_Property_Result_Var_Samp_Fields = {
  __typename?: 'queries_property_result_var_samp_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "queries_property_result" */
export type Queries_Property_Result_Var_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Queries_Property_Result_Variance_Fields = {
  __typename?: 'queries_property_result_variance_fields';
  price?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "queries_property_result" */
export type Queries_Property_Result_Variance_Order_By = {
  price?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Enum about the intention of the query */
export type Query_Classification = {
  __typename?: 'query_classification';
  class: Scalars['String']['output'];
};

/** aggregated selection of "query_classification" */
export type Query_Classification_Aggregate = {
  __typename?: 'query_classification_aggregate';
  aggregate?: Maybe<Query_Classification_Aggregate_Fields>;
  nodes: Array<Query_Classification>;
};

/** aggregate fields of "query_classification" */
export type Query_Classification_Aggregate_Fields = {
  __typename?: 'query_classification_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Query_Classification_Max_Fields>;
  min?: Maybe<Query_Classification_Min_Fields>;
};


/** aggregate fields of "query_classification" */
export type Query_Classification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Query_Classification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "query_classification". All fields are combined with a logical 'AND'. */
export type Query_Classification_Bool_Exp = {
  _and?: InputMaybe<Array<Query_Classification_Bool_Exp>>;
  _not?: InputMaybe<Query_Classification_Bool_Exp>;
  _or?: InputMaybe<Array<Query_Classification_Bool_Exp>>;
  class?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "query_classification" */
export enum Query_Classification_Constraint {
  /** unique or primary key constraint on columns "class" */
  QueryClassificationPkey = 'query_classification_pkey'
}

export enum Query_Classification_Enum {
  NotAboutRealEstate = 'NOT_ABOUT_REAL_ESTATE',
  RealEstateBasicQuery = 'REAL_ESTATE_BASIC_QUERY',
  RealEstateDescriptiveQuery = 'REAL_ESTATE_DESCRIPTIVE_QUERY',
  RealEstateStatistics = 'REAL_ESTATE_STATISTICS'
}

/** Boolean expression to compare columns of type "query_classification_enum". All fields are combined with logical 'AND'. */
export type Query_Classification_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Query_Classification_Enum>;
  _in?: InputMaybe<Array<Query_Classification_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Query_Classification_Enum>;
  _nin?: InputMaybe<Array<Query_Classification_Enum>>;
};

/** input type for inserting data into table "query_classification" */
export type Query_Classification_Insert_Input = {
  class?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Query_Classification_Max_Fields = {
  __typename?: 'query_classification_max_fields';
  class?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Query_Classification_Min_Fields = {
  __typename?: 'query_classification_min_fields';
  class?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "query_classification" */
export type Query_Classification_Mutation_Response = {
  __typename?: 'query_classification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Query_Classification>;
};

/** input type for inserting object relation for remote table "query_classification" */
export type Query_Classification_Obj_Rel_Insert_Input = {
  data: Query_Classification_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Query_Classification_On_Conflict>;
};

/** on_conflict condition type for table "query_classification" */
export type Query_Classification_On_Conflict = {
  constraint: Query_Classification_Constraint;
  update_columns?: Array<Query_Classification_Update_Column>;
  where?: InputMaybe<Query_Classification_Bool_Exp>;
};

/** Ordering options when selecting data from "query_classification". */
export type Query_Classification_Order_By = {
  class?: InputMaybe<Order_By>;
};

/** primary key columns input for table: query_classification */
export type Query_Classification_Pk_Columns_Input = {
  class: Scalars['String']['input'];
};

/** columns and relationships of "query_classification_re" */
export type Query_Classification_Re = {
  __typename?: 'query_classification_re';
  class: Scalars['String']['output'];
};

/** aggregated selection of "query_classification_re" */
export type Query_Classification_Re_Aggregate = {
  __typename?: 'query_classification_re_aggregate';
  aggregate?: Maybe<Query_Classification_Re_Aggregate_Fields>;
  nodes: Array<Query_Classification_Re>;
};

/** aggregate fields of "query_classification_re" */
export type Query_Classification_Re_Aggregate_Fields = {
  __typename?: 'query_classification_re_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Query_Classification_Re_Max_Fields>;
  min?: Maybe<Query_Classification_Re_Min_Fields>;
};


/** aggregate fields of "query_classification_re" */
export type Query_Classification_Re_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Query_Classification_Re_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "query_classification_re". All fields are combined with a logical 'AND'. */
export type Query_Classification_Re_Bool_Exp = {
  _and?: InputMaybe<Array<Query_Classification_Re_Bool_Exp>>;
  _not?: InputMaybe<Query_Classification_Re_Bool_Exp>;
  _or?: InputMaybe<Array<Query_Classification_Re_Bool_Exp>>;
  class?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "query_classification_re" */
export enum Query_Classification_Re_Constraint {
  /** unique or primary key constraint on columns "class" */
  QueryClassificationPkey = 'query_classification_pkey'
}

/** input type for inserting data into table "query_classification_re" */
export type Query_Classification_Re_Insert_Input = {
  class?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Query_Classification_Re_Max_Fields = {
  __typename?: 'query_classification_re_max_fields';
  class?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Query_Classification_Re_Min_Fields = {
  __typename?: 'query_classification_re_min_fields';
  class?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "query_classification_re" */
export type Query_Classification_Re_Mutation_Response = {
  __typename?: 'query_classification_re_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Query_Classification_Re>;
};

/** on_conflict condition type for table "query_classification_re" */
export type Query_Classification_Re_On_Conflict = {
  constraint: Query_Classification_Re_Constraint;
  update_columns?: Array<Query_Classification_Re_Update_Column>;
  where?: InputMaybe<Query_Classification_Re_Bool_Exp>;
};

/** Ordering options when selecting data from "query_classification_re". */
export type Query_Classification_Re_Order_By = {
  class?: InputMaybe<Order_By>;
};

/** primary key columns input for table: query_classification_re */
export type Query_Classification_Re_Pk_Columns_Input = {
  class: Scalars['String']['input'];
};

/** select columns of table "query_classification_re" */
export enum Query_Classification_Re_Select_Column {
  /** column name */
  Class = 'class'
}

/** input type for updating data in table "query_classification_re" */
export type Query_Classification_Re_Set_Input = {
  class?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "query_classification_re" */
export type Query_Classification_Re_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Query_Classification_Re_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Query_Classification_Re_Stream_Cursor_Value_Input = {
  class?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "query_classification_re" */
export enum Query_Classification_Re_Update_Column {
  /** column name */
  Class = 'class'
}

export type Query_Classification_Re_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Query_Classification_Re_Set_Input>;
  /** filter the rows which have to be updated */
  where: Query_Classification_Re_Bool_Exp;
};

/** select columns of table "query_classification" */
export enum Query_Classification_Select_Column {
  /** column name */
  Class = 'class'
}

/** input type for updating data in table "query_classification" */
export type Query_Classification_Set_Input = {
  class?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "query_classification" */
export type Query_Classification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Query_Classification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Query_Classification_Stream_Cursor_Value_Input = {
  class?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "query_classification" */
export enum Query_Classification_Update_Column {
  /** column name */
  Class = 'class'
}

export type Query_Classification_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Query_Classification_Set_Input>;
  /** filter the rows which have to be updated */
  where: Query_Classification_Bool_Exp;
};

export type Query_Root = {
  __typename?: 'query_root';
  active_properties_limit_check?: Maybe<ActivePropertiesOutput>;
  /** fetch data from the table: "address_types" */
  address_types: Array<Address_Types>;
  /** fetch aggregated fields from the table: "address_types" */
  address_types_aggregate: Address_Types_Aggregate;
  /** fetch data from the table: "address_types" using primary key columns */
  address_types_by_pk?: Maybe<Address_Types>;
  /** fetch data from the table: "agency" */
  agency: Array<Agency>;
  agencyDashboardStatistics: Array<Lister_Dashboard_Model>;
  agencyScrapedProperties: Array<Agency_Properties_Model>;
  agencyViewsGraphic: Array<Daily_Views>;
  /** fetch aggregated fields from the table: "agency" */
  agency_aggregate: Agency_Aggregate;
  /** fetch data from the table: "agency" using primary key columns */
  agency_by_pk?: Maybe<Agency>;
  /** fetch data from the table: "agency_health" */
  agency_health: Array<Agency_Health>;
  /** fetch aggregated fields from the table: "agency_health" */
  agency_health_aggregate: Agency_Health_Aggregate;
  /** fetch data from the table: "agency_type" */
  agency_type: Array<Agency_Type>;
  /** fetch aggregated fields from the table: "agency_type" */
  agency_type_aggregate: Agency_Type_Aggregate;
  /** fetch data from the table: "agency_type" using primary key columns */
  agency_type_by_pk?: Maybe<Agency_Type>;
  /** fetch data from the table: "agent_action" */
  agent_action: Array<Agent_Action>;
  /** fetch aggregated fields from the table: "agent_action" */
  agent_action_aggregate: Agent_Action_Aggregate;
  /** fetch data from the table: "agent_action" using primary key columns */
  agent_action_by_pk?: Maybe<Agent_Action>;
  /** fetch data from the table: "agent_task" */
  agent_task: Array<Agent_Task>;
  /** fetch aggregated fields from the table: "agent_task" */
  agent_task_aggregate: Agent_Task_Aggregate;
  /** fetch data from the table: "agent_task" using primary key columns */
  agent_task_by_pk?: Maybe<Agent_Task>;
  /** fetch data from the table: "amenities" */
  amenities: Array<Amenities>;
  /** fetch aggregated fields from the table: "amenities" */
  amenities_aggregate: Amenities_Aggregate;
  /** fetch data from the table: "amenities" using primary key columns */
  amenities_by_pk?: Maybe<Amenities>;
  /** fetch data from the table: "app_config" */
  app_config: Array<App_Config>;
  /** fetch aggregated fields from the table: "app_config" */
  app_config_aggregate: App_Config_Aggregate;
  /** fetch data from the table: "app_config" using primary key columns */
  app_config_by_pk?: Maybe<App_Config>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes>;
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate;
  /** fetch data from the table: "blog" */
  blog: Array<Blog>;
  /** fetch aggregated fields from the table: "blog" */
  blog_aggregate: Blog_Aggregate;
  /** fetch data from the table: "blog" using primary key columns */
  blog_by_pk?: Maybe<Blog>;
  /** fetch data from the table: "blog_post" */
  blog_post: Array<Blog_Post>;
  /** fetch aggregated fields from the table: "blog_post" */
  blog_post_aggregate: Blog_Post_Aggregate;
  /** fetch data from the table: "blog_post" using primary key columns */
  blog_post_by_pk?: Maybe<Blog_Post>;
  /** fetch data from the table: "blog_section" */
  blog_section: Array<Blog_Section>;
  /** fetch aggregated fields from the table: "blog_section" */
  blog_section_aggregate: Blog_Section_Aggregate;
  /** fetch data from the table: "blog_section" using primary key columns */
  blog_section_by_pk?: Maybe<Blog_Section>;
  /** fetch data from the table: "blog_status" */
  blog_status: Array<Blog_Status>;
  /** fetch aggregated fields from the table: "blog_status" */
  blog_status_aggregate: Blog_Status_Aggregate;
  /** fetch data from the table: "blog_status" using primary key columns */
  blog_status_by_pk?: Maybe<Blog_Status>;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table: "builder" */
  builder: Array<Builder>;
  /** fetch aggregated fields from the table: "builder" */
  builder_aggregate: Builder_Aggregate;
  /** fetch data from the table: "builder" using primary key columns */
  builder_by_pk?: Maybe<Builder>;
  /** fetch data from the table: "certified_agent" */
  certified_agent: Array<Certified_Agent>;
  /** fetch aggregated fields from the table: "certified_agent" */
  certified_agent_aggregate: Certified_Agent_Aggregate;
  /** fetch data from the table: "certified_agent" using primary key columns */
  certified_agent_by_pk?: Maybe<Certified_Agent>;
  /** fetch data from the table: "chat_response_type" */
  chat_response_type: Array<Chat_Response_Type>;
  /** fetch aggregated fields from the table: "chat_response_type" */
  chat_response_type_aggregate: Chat_Response_Type_Aggregate;
  /** fetch data from the table: "chat_response_type" using primary key columns */
  chat_response_type_by_pk?: Maybe<Chat_Response_Type>;
  check_property_post_availabitily?: Maybe<CheckPostAvailabilityOutput>;
  /** fetch data from the table: "citizens_property_list_view" */
  citizens_property_list_view: Array<Citizens_Property_List_View>;
  /** fetch aggregated fields from the table: "citizens_property_list_view" */
  citizens_property_list_view_aggregate: Citizens_Property_List_View_Aggregate;
  /** fetch data from the table: "city" */
  city: Array<City>;
  /** fetch aggregated fields from the table: "city" */
  city_aggregate: City_Aggregate;
  /** fetch data from the table: "city" using primary key columns */
  city_by_pk?: Maybe<City>;
  /** fetch data from the table: "city_zone" */
  city_zone: Array<City_Zone>;
  /** fetch aggregated fields from the table: "city_zone" */
  city_zone_aggregate: City_Zone_Aggregate;
  /** fetch data from the table: "city_zone" using primary key columns */
  city_zone_by_pk?: Maybe<City_Zone>;
  /** fetch data from the table: "city_zone_origin" */
  city_zone_origin: Array<City_Zone_Origin>;
  /** fetch aggregated fields from the table: "city_zone_origin" */
  city_zone_origin_aggregate: City_Zone_Origin_Aggregate;
  /** fetch data from the table: "city_zone_origin" using primary key columns */
  city_zone_origin_by_pk?: Maybe<City_Zone_Origin>;
  /** fetch data from the table: "claim_request_status" */
  claim_request_status: Array<Claim_Request_Status>;
  /** fetch aggregated fields from the table: "claim_request_status" */
  claim_request_status_aggregate: Claim_Request_Status_Aggregate;
  /** fetch data from the table: "claim_request_status" using primary key columns */
  claim_request_status_by_pk?: Maybe<Claim_Request_Status>;
  classifiedProperties: Array<Classified_Properties_Model>;
  /** fetch data from the table: "clering" */
  clering: Array<Clering>;
  /** fetch aggregated fields from the table: "clering" */
  clering_aggregate: Clering_Aggregate;
  /** fetch data from the table: "clering" using primary key columns */
  clering_by_pk?: Maybe<Clering>;
  /** fetch data from the table: "construction_status" */
  construction_status: Array<Construction_Status>;
  /** fetch aggregated fields from the table: "construction_status" */
  construction_status_aggregate: Construction_Status_Aggregate;
  /** fetch data from the table: "construction_status" using primary key columns */
  construction_status_by_pk?: Maybe<Construction_Status>;
  /** fetch data from the table: "contact" */
  contact: Array<Contact>;
  /** fetch aggregated fields from the table: "contact" */
  contact_aggregate: Contact_Aggregate;
  /** fetch data from the table: "contact" using primary key columns */
  contact_by_pk?: Maybe<Contact>;
  /** fetch data from the table: "contact_health" */
  contact_health: Array<Contact_Health>;
  /** fetch aggregated fields from the table: "contact_health" */
  contact_health_aggregate: Contact_Health_Aggregate;
  /** fetch data from the table: "contact_phone_number" */
  contact_phone_number: Array<Contact_Phone_Number>;
  /** fetch aggregated fields from the table: "contact_phone_number" */
  contact_phone_number_aggregate: Contact_Phone_Number_Aggregate;
  /** fetch data from the table: "contact_phone_number" using primary key columns */
  contact_phone_number_by_pk?: Maybe<Contact_Phone_Number>;
  /** fetch data from the table: "contact_type" */
  contact_type: Array<Contact_Type>;
  /** fetch aggregated fields from the table: "contact_type" */
  contact_type_aggregate: Contact_Type_Aggregate;
  /** fetch data from the table: "contact_type" using primary key columns */
  contact_type_by_pk?: Maybe<Contact_Type>;
  /** fetch data from the table: "content_type" */
  content_type: Array<Content_Type>;
  /** fetch aggregated fields from the table: "content_type" */
  content_type_aggregate: Content_Type_Aggregate;
  /** fetch data from the table: "content_type" using primary key columns */
  content_type_by_pk?: Maybe<Content_Type>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch aggregated fields from the table: "countries" */
  countries_aggregate: Countries_Aggregate;
  /** fetch data from the table: "countries" using primary key columns */
  countries_by_pk?: Maybe<Countries>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table: "currency" */
  currency: Array<Currency>;
  /** fetch aggregated fields from the table: "currency" */
  currency_aggregate: Currency_Aggregate;
  /** fetch data from the table: "currency" using primary key columns */
  currency_by_pk?: Maybe<Currency>;
  /** fetch data from the table: "currency_exchange_rates" */
  currency_exchange_rates: Array<Currency_Exchange_Rates>;
  /** fetch aggregated fields from the table: "currency_exchange_rates" */
  currency_exchange_rates_aggregate: Currency_Exchange_Rates_Aggregate;
  /** fetch data from the table: "currency_exchange_rates" using primary key columns */
  currency_exchange_rates_by_pk?: Maybe<Currency_Exchange_Rates>;
  dailyRegisteredUsers: Array<Daily_Active_Users_Model>;
  daliyActiveUsers: Array<Daily_Active_Users_Model>;
  daliyQueriesStatistics: Array<Daliy_Queries_Statistics_Model>;
  dashboard_statistics?: Maybe<DashboardStatisticsActionOutput>;
  /** fetch data from the table: "duplicate_cfn_with_null_cname" */
  duplicate_cfn_with_null_cname: Array<Duplicate_Cfn_With_Null_Cname>;
  /** fetch aggregated fields from the table: "duplicate_cfn_with_null_cname" */
  duplicate_cfn_with_null_cname_aggregate: Duplicate_Cfn_With_Null_Cname_Aggregate;
  /** fetch data from the table: "duplicate_phone_numbers" */
  duplicate_phone_numbers: Array<Duplicate_Phone_Numbers>;
  /** fetch aggregated fields from the table: "duplicate_phone_numbers" */
  duplicate_phone_numbers_aggregate: Duplicate_Phone_Numbers_Aggregate;
  /** fetch data from the table: "entities" */
  entities: Array<Entities>;
  /** fetch aggregated fields from the table: "entities" */
  entities_aggregate: Entities_Aggregate;
  /** fetch data from the table: "entities" using primary key columns */
  entities_by_pk?: Maybe<Entities>;
  /** fetch data from the table: "exchange_rates" */
  exchange_rates: Array<Exchange_Rates>;
  /** fetch aggregated fields from the table: "exchange_rates" */
  exchange_rates_aggregate: Exchange_Rates_Aggregate;
  /** fetch data from the table: "exchange_rates" using primary key columns */
  exchange_rates_by_pk?: Maybe<Exchange_Rates>;
  favouritePropertiesTrend: Array<Favourite_Properties_Trend_Model>;
  /** fetch data from the table: "feature" */
  feature: Array<Feature>;
  /** fetch aggregated fields from the table: "feature" */
  feature_aggregate: Feature_Aggregate;
  /** fetch data from the table: "feature" using primary key columns */
  feature_by_pk?: Maybe<Feature>;
  /** fetch data from the table: "feature_type" */
  feature_type: Array<Feature_Type>;
  /** fetch aggregated fields from the table: "feature_type" */
  feature_type_aggregate: Feature_Type_Aggregate;
  /** fetch data from the table: "feature_type" using primary key columns */
  feature_type_by_pk?: Maybe<Feature_Type>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** fetch data from the table: "file_type" */
  file_type: Array<File_Type>;
  /** fetch aggregated fields from the table: "file_type" */
  file_type_aggregate: File_Type_Aggregate;
  /** fetch data from the table: "file_type" using primary key columns */
  file_type_by_pk?: Maybe<File_Type>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** An array relationship */
  folder_amenities: Array<Folder_Amenities>;
  /** An aggregate relationship */
  folder_amenities_aggregate: Folder_Amenities_Aggregate;
  /** fetch data from the table: "folder_amenities" using primary key columns */
  folder_amenities_by_pk?: Maybe<Folder_Amenities>;
  /** fetch data from the table: "folder_image" */
  folder_image: Array<Folder_Image>;
  /** fetch aggregated fields from the table: "folder_image" */
  folder_image_aggregate: Folder_Image_Aggregate;
  /** fetch data from the table: "folder_image" using primary key columns */
  folder_image_by_pk?: Maybe<Folder_Image>;
  /** fetch data from the table: "folder_properties_type" */
  folder_properties_type: Array<Folder_Properties_Type>;
  /** fetch aggregated fields from the table: "folder_properties_type" */
  folder_properties_type_aggregate: Folder_Properties_Type_Aggregate;
  /** fetch data from the table: "folder_properties_type" using primary key columns */
  folder_properties_type_by_pk?: Maybe<Folder_Properties_Type>;
  /** fetch data from the table: "folder_status" */
  folder_status: Array<Folder_Status>;
  /** fetch aggregated fields from the table: "folder_status" */
  folder_status_aggregate: Folder_Status_Aggregate;
  /** fetch data from the table: "folder_status" using primary key columns */
  folder_status_by_pk?: Maybe<Folder_Status>;
  /** fetch data from the table: "folder_type" */
  folder_type: Array<Folder_Type>;
  /** fetch aggregated fields from the table: "folder_type" */
  folder_type_aggregate: Folder_Type_Aggregate;
  /** fetch data from the table: "folder_type" using primary key columns */
  folder_type_by_pk?: Maybe<Folder_Type>;
  /** fetch data from the table: "furnishing_status" */
  furnishing_status: Array<Furnishing_Status>;
  /** fetch aggregated fields from the table: "furnishing_status" */
  furnishing_status_aggregate: Furnishing_Status_Aggregate;
  /** fetch data from the table: "furnishing_status" using primary key columns */
  furnishing_status_by_pk?: Maybe<Furnishing_Status>;
  getCityZoneForCoords: Array<City_Zone_Object>;
  getOrderByRelevanceCityZones: Array<City_Zone_Object>;
  getOrderByRelevanceFormattedAddressCityZones: Array<City_Zone_Object>;
  getOrganizationLeadProperties?: Maybe<Array<Maybe<GetOrganizationLeadPropertiesOutput>>>;
  get_active_subscription?: Maybe<GetActiveSubscriptionOutput>;
  /** execute function "get_citizens_property_list_function" which returns "property_list" */
  get_citizens_property_list_function: Array<Property_List>;
  /** execute function "get_citizens_property_list_function" and query aggregates on result of table type "property_list" */
  get_citizens_property_list_function_aggregate: Property_List_Aggregate;
  /** execute function "get_folders_without_property_list" which returns "property_folder" */
  get_folders_without_property_list: Array<Property_Folder>;
  /** execute function "get_folders_without_property_list" and query aggregates on result of table type "property_folder" */
  get_folders_without_property_list_aggregate: Property_Folder_Aggregate;
  /** execute function "get_search_sessions_sorted_by_last_query" which returns "search_sessions" */
  get_search_sessions_sorted_by_last_query: Array<Search_Sessions>;
  /** execute function "get_search_sessions_sorted_by_last_query" and query aggregates on result of table type "search_sessions" */
  get_search_sessions_sorted_by_last_query_aggregate: Search_Sessions_Aggregate;
  /** execute function "get_similar_agencies_by_name" which returns "agency" */
  get_similar_agencies_by_name: Array<Agency>;
  /** execute function "get_similar_agencies_by_name" and query aggregates on result of table type "agency" */
  get_similar_agencies_by_name_aggregate: Agency_Aggregate;
  /** execute function "get_similar_properties" which returns "property" */
  get_similar_properties: Array<Property>;
  /** execute function "get_similar_properties" and query aggregates on result of table type "property" */
  get_similar_properties_aggregate: Property_Aggregate;
  /** execute function "get_similar_properties_by_slug" which returns "property" */
  get_similar_properties_by_slug: Array<Property>;
  /** execute function "get_similar_properties_by_slug" and query aggregates on result of table type "property" */
  get_similar_properties_by_slug_aggregate: Property_Aggregate;
  /** execute function "get_top_neighborhood_for_city_zone" which returns "city_zone" */
  get_top_neighborhood_for_city_zone: Array<City_Zone>;
  /** execute function "get_top_neighborhood_for_city_zone" and query aggregates on result of table type "city_zone" */
  get_top_neighborhood_for_city_zone_aggregate: City_Zone_Aggregate;
  /** execute function "get_user_activity" which returns "users_activity_summary" */
  get_user_activity: Array<Users_Activity_Summary>;
  /** execute function "get_user_activity" and query aggregates on result of table type "users_activity_summary" */
  get_user_activity_aggregate: Users_Activity_Summary_Aggregate;
  /** fetch data from the table: "google_calendar" */
  google_calendar: Array<Google_Calendar>;
  /** fetch aggregated fields from the table: "google_calendar" */
  google_calendar_aggregate: Google_Calendar_Aggregate;
  /** fetch data from the table: "google_calendar" using primary key columns */
  google_calendar_by_pk?: Maybe<Google_Calendar>;
  /** fetch data from the table: "heatingType" */
  heatingType: Array<HeatingType>;
  /** fetch aggregated fields from the table: "heatingType" */
  heatingType_aggregate: HeatingType_Aggregate;
  /** fetch data from the table: "heatingType" using primary key columns */
  heatingType_by_pk?: Maybe<HeatingType>;
  /** fetch data from the table: "image" */
  image: Array<Image>;
  /** fetch aggregated fields from the table: "image" */
  image_aggregate: Image_Aggregate;
  /** fetch data from the table: "image" using primary key columns */
  image_by_pk?: Maybe<Image>;
  /** fetch data from the table: "invoice_status" */
  invoice_status: Array<Invoice_Status>;
  /** fetch aggregated fields from the table: "invoice_status" */
  invoice_status_aggregate: Invoice_Status_Aggregate;
  /** fetch data from the table: "invoice_status" using primary key columns */
  invoice_status_by_pk?: Maybe<Invoice_Status>;
  /** fetch data from the table: "languages" */
  languages: Array<Languages>;
  /** fetch aggregated fields from the table: "languages" */
  languages_aggregate: Languages_Aggregate;
  /** fetch data from the table: "languages" using primary key columns */
  languages_by_pk?: Maybe<Languages>;
  /** fetch data from the table: "lead_property_category" */
  lead_property_category: Array<Lead_Property_Category>;
  /** fetch aggregated fields from the table: "lead_property_category" */
  lead_property_category_aggregate: Lead_Property_Category_Aggregate;
  /** fetch data from the table: "lead_property_category" using primary key columns */
  lead_property_category_by_pk?: Maybe<Lead_Property_Category>;
  /** fetch data from the table: "lead_status" */
  lead_status: Array<Lead_Status>;
  /** fetch aggregated fields from the table: "lead_status" */
  lead_status_aggregate: Lead_Status_Aggregate;
  /** fetch data from the table: "lead_status" using primary key columns */
  lead_status_by_pk?: Maybe<Lead_Status>;
  /** fetch data from the table: "lead_type" */
  lead_type: Array<Lead_Type>;
  /** fetch aggregated fields from the table: "lead_type" */
  lead_type_aggregate: Lead_Type_Aggregate;
  /** fetch data from the table: "lead_type" using primary key columns */
  lead_type_by_pk?: Maybe<Lead_Type>;
  leads_statistics: Array<Leads_Statistics_Model>;
  /** fetch data from the table: "lister_claim_request" */
  lister_claim_request: Array<Lister_Claim_Request>;
  /** fetch data from the table: "lister_claim_request_activity" */
  lister_claim_request_activity: Array<Lister_Claim_Request_Activity>;
  /** fetch aggregated fields from the table: "lister_claim_request_activity" */
  lister_claim_request_activity_aggregate: Lister_Claim_Request_Activity_Aggregate;
  /** fetch data from the table: "lister_claim_request_activity" using primary key columns */
  lister_claim_request_activity_by_pk?: Maybe<Lister_Claim_Request_Activity>;
  /** fetch aggregated fields from the table: "lister_claim_request" */
  lister_claim_request_aggregate: Lister_Claim_Request_Aggregate;
  /** fetch data from the table: "lister_claim_request" using primary key columns */
  lister_claim_request_by_pk?: Maybe<Lister_Claim_Request>;
  /** fetch data from the table: "lister_contact" */
  lister_contact: Array<Lister_Contact>;
  /** fetch aggregated fields from the table: "lister_contact" */
  lister_contact_aggregate: Lister_Contact_Aggregate;
  /** fetch data from the table: "lister_contact" using primary key columns */
  lister_contact_by_pk?: Maybe<Lister_Contact>;
  /** fetch data from the table: "lister_contact_meeting" */
  lister_contact_meeting: Array<Lister_Contact_Meeting>;
  /** fetch aggregated fields from the table: "lister_contact_meeting" */
  lister_contact_meeting_aggregate: Lister_Contact_Meeting_Aggregate;
  /** fetch data from the table: "lister_contact_meeting" using primary key columns */
  lister_contact_meeting_by_pk?: Maybe<Lister_Contact_Meeting>;
  /** fetch data from the table: "lister_contact_source" */
  lister_contact_source: Array<Lister_Contact_Source>;
  /** fetch aggregated fields from the table: "lister_contact_source" */
  lister_contact_source_aggregate: Lister_Contact_Source_Aggregate;
  /** fetch data from the table: "lister_contact_source" using primary key columns */
  lister_contact_source_by_pk?: Maybe<Lister_Contact_Source>;
  /** fetch data from the table: "lister_leads" */
  lister_leads: Array<Lister_Leads>;
  /** fetch aggregated fields from the table: "lister_leads" */
  lister_leads_aggregate: Lister_Leads_Aggregate;
  /** fetch data from the table: "lister_leads" using primary key columns */
  lister_leads_by_pk?: Maybe<Lister_Leads>;
  /** fetch data from the table: "lister_meeting" */
  lister_meeting: Array<Lister_Meeting>;
  /** fetch aggregated fields from the table: "lister_meeting" */
  lister_meeting_aggregate: Lister_Meeting_Aggregate;
  /** fetch data from the table: "lister_meeting" using primary key columns */
  lister_meeting_by_pk?: Maybe<Lister_Meeting>;
  /** fetch data from the table: "lister_role" */
  lister_role: Array<Lister_Role>;
  /** fetch aggregated fields from the table: "lister_role" */
  lister_role_aggregate: Lister_Role_Aggregate;
  /** fetch data from the table: "lister_role" using primary key columns */
  lister_role_by_pk?: Maybe<Lister_Role>;
  /** fetch data from the table: "location" */
  location: Array<Location>;
  /** fetch aggregated fields from the table: "location" */
  location_aggregate: Location_Aggregate;
  /** fetch data from the table: "location" using primary key columns */
  location_by_pk?: Maybe<Location>;
  /** fetch data from the table: "location_type" */
  location_type: Array<Location_Type>;
  /** fetch aggregated fields from the table: "location_type" */
  location_type_aggregate: Location_Type_Aggregate;
  /** fetch data from the table: "location_type" using primary key columns */
  location_type_by_pk?: Maybe<Location_Type>;
  /** fetch data from the table: "main_currency" */
  main_currency: Array<Main_Currency>;
  /** fetch aggregated fields from the table: "main_currency" */
  main_currency_aggregate: Main_Currency_Aggregate;
  /** fetch data from the table: "main_currency" using primary key columns */
  main_currency_by_pk?: Maybe<Main_Currency>;
  /** An array relationship */
  natural_language_queries: Array<Natural_Language_Queries>;
  /** An aggregate relationship */
  natural_language_queries_aggregate: Natural_Language_Queries_Aggregate;
  /** fetch data from the table: "natural_language_queries" using primary key columns */
  natural_language_queries_by_pk?: Maybe<Natural_Language_Queries>;
  /** fetch data from the table: "notification" */
  notification: Array<Notification>;
  /** fetch aggregated fields from the table: "notification" */
  notification_aggregate: Notification_Aggregate;
  /** An array relationship */
  notification_amenities: Array<Notification_Amenities>;
  /** An aggregate relationship */
  notification_amenities_aggregate: Notification_Amenities_Aggregate;
  /** fetch data from the table: "notification_amenities" using primary key columns */
  notification_amenities_by_pk?: Maybe<Notification_Amenities>;
  /** fetch data from the table: "notification" using primary key columns */
  notification_by_pk?: Maybe<Notification>;
  /** fetch data from the table: "notification_feature" */
  notification_feature: Array<Notification_Feature>;
  /** fetch aggregated fields from the table: "notification_feature" */
  notification_feature_aggregate: Notification_Feature_Aggregate;
  /** fetch data from the table: "notification_feature" using primary key columns */
  notification_feature_by_pk?: Maybe<Notification_Feature>;
  /** fetch data from the table: "notification_property_type" */
  notification_property_type: Array<Notification_Property_Type>;
  /** fetch aggregated fields from the table: "notification_property_type" */
  notification_property_type_aggregate: Notification_Property_Type_Aggregate;
  /** fetch data from the table: "notification_property_type" using primary key columns */
  notification_property_type_by_pk?: Maybe<Notification_Property_Type>;
  /** fetch data from the table: "notification_type" */
  notification_type: Array<Notification_Type>;
  /** fetch aggregated fields from the table: "notification_type" */
  notification_type_aggregate: Notification_Type_Aggregate;
  /** fetch data from the table: "notification_type" using primary key columns */
  notification_type_by_pk?: Maybe<Notification_Type>;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** fetch data from the table: "order_status" */
  order_status: Array<Order_Status>;
  /** fetch aggregated fields from the table: "order_status" */
  order_status_aggregate: Order_Status_Aggregate;
  /** fetch data from the table: "order_status" using primary key columns */
  order_status_by_pk?: Maybe<Order_Status>;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  organizationDashboardStatistics: Array<Lister_Dashboard_Model>;
  organizationViewsGraphic: Array<Daily_Views>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table: "organization_lead_location" */
  organization_lead_location: Array<Organization_Lead_Location>;
  /** fetch aggregated fields from the table: "organization_lead_location" */
  organization_lead_location_aggregate: Organization_Lead_Location_Aggregate;
  /** fetch data from the table: "organization_lead_location" using primary key columns */
  organization_lead_location_by_pk?: Maybe<Organization_Lead_Location>;
  /** fetch data from the table: "organization_lead_property" */
  organization_lead_property: Array<Organization_Lead_Property>;
  /** fetch aggregated fields from the table: "organization_lead_property" */
  organization_lead_property_aggregate: Organization_Lead_Property_Aggregate;
  /** fetch data from the table: "organization_lead_property" using primary key columns */
  organization_lead_property_by_pk?: Maybe<Organization_Lead_Property>;
  /** An array relationship */
  organization_leads: Array<Organization_Leads>;
  /** An aggregate relationship */
  organization_leads_aggregate: Organization_Leads_Aggregate;
  /** fetch data from the table: "organization_leads" using primary key columns */
  organization_leads_by_pk?: Maybe<Organization_Leads>;
  /** fetch data from the table: "organization_role" */
  organization_role: Array<Organization_Role>;
  /** fetch aggregated fields from the table: "organization_role" */
  organization_role_aggregate: Organization_Role_Aggregate;
  /** fetch data from the table: "organization_role" using primary key columns */
  organization_role_by_pk?: Maybe<Organization_Role>;
  /** fetch data from the table: "organization_status" */
  organization_status: Array<Organization_Status>;
  /** fetch aggregated fields from the table: "organization_status" */
  organization_status_aggregate: Organization_Status_Aggregate;
  /** fetch data from the table: "organization_status" using primary key columns */
  organization_status_by_pk?: Maybe<Organization_Status>;
  /** fetch data from the table: "organization_telegram_agent_link" */
  organization_telegram_agent_link: Array<Organization_Telegram_Agent_Link>;
  /** fetch aggregated fields from the table: "organization_telegram_agent_link" */
  organization_telegram_agent_link_aggregate: Organization_Telegram_Agent_Link_Aggregate;
  /** fetch data from the table: "organization_telegram_agent_link" using primary key columns */
  organization_telegram_agent_link_by_pk?: Maybe<Organization_Telegram_Agent_Link>;
  /** fetch data from the table: "organization_type" */
  organization_type: Array<Organization_Type>;
  /** fetch aggregated fields from the table: "organization_type" */
  organization_type_aggregate: Organization_Type_Aggregate;
  /** fetch data from the table: "organization_type" using primary key columns */
  organization_type_by_pk?: Maybe<Organization_Type>;
  /** fetch data from the table: "organization_whatsapp_ai_allowlist" */
  organization_whatsapp_ai_allowlist: Array<Organization_Whatsapp_Ai_Allowlist>;
  /** fetch aggregated fields from the table: "organization_whatsapp_ai_allowlist" */
  organization_whatsapp_ai_allowlist_aggregate: Organization_Whatsapp_Ai_Allowlist_Aggregate;
  /** fetch data from the table: "organization_whatsapp_ai_allowlist" using primary key columns */
  organization_whatsapp_ai_allowlist_by_pk?: Maybe<Organization_Whatsapp_Ai_Allowlist>;
  /** fetch data from the table: "organization_whatsapp_ai_config" */
  organization_whatsapp_ai_config: Array<Organization_Whatsapp_Ai_Config>;
  /** fetch aggregated fields from the table: "organization_whatsapp_ai_config" */
  organization_whatsapp_ai_config_aggregate: Organization_Whatsapp_Ai_Config_Aggregate;
  /** fetch data from the table: "organization_whatsapp_ai_config" using primary key columns */
  organization_whatsapp_ai_config_by_pk?: Maybe<Organization_Whatsapp_Ai_Config>;
  /** fetch data from the table: "parking_type" */
  parking_type: Array<Parking_Type>;
  /** fetch aggregated fields from the table: "parking_type" */
  parking_type_aggregate: Parking_Type_Aggregate;
  /** fetch data from the table: "parking_type" using primary key columns */
  parking_type_by_pk?: Maybe<Parking_Type>;
  /** fetch data from the table: "phone_number_type" */
  phone_number_type: Array<Phone_Number_Type>;
  /** fetch aggregated fields from the table: "phone_number_type" */
  phone_number_type_aggregate: Phone_Number_Type_Aggregate;
  /** fetch data from the table: "phone_number_type" using primary key columns */
  phone_number_type_by_pk?: Maybe<Phone_Number_Type>;
  /** fetch data from the table: "place_reference" */
  place_reference: Array<Place_Reference>;
  /** fetch aggregated fields from the table: "place_reference" */
  place_reference_aggregate: Place_Reference_Aggregate;
  /** fetch data from the table: "place_reference_alias" */
  place_reference_alias: Array<Place_Reference_Alias>;
  /** fetch aggregated fields from the table: "place_reference_alias" */
  place_reference_alias_aggregate: Place_Reference_Alias_Aggregate;
  /** fetch data from the table: "place_reference_alias" using primary key columns */
  place_reference_alias_by_pk?: Maybe<Place_Reference_Alias>;
  /** fetch data from the table: "place_reference" using primary key columns */
  place_reference_by_pk?: Maybe<Place_Reference>;
  /** fetch data from the table: "place_reference_proposal" */
  place_reference_proposal: Array<Place_Reference_Proposal>;
  /** fetch aggregated fields from the table: "place_reference_proposal" */
  place_reference_proposal_aggregate: Place_Reference_Proposal_Aggregate;
  /** fetch data from the table: "place_reference_proposal" using primary key columns */
  place_reference_proposal_by_pk?: Maybe<Place_Reference_Proposal>;
  /** fetch data from the table: "plan" */
  plan: Array<Plan>;
  /** fetch aggregated fields from the table: "plan" */
  plan_aggregate: Plan_Aggregate;
  /** fetch data from the table: "plan" using primary key columns */
  plan_by_pk?: Maybe<Plan>;
  /** fetch data from the table: "plan_type" */
  plan_type: Array<Plan_Type>;
  /** fetch aggregated fields from the table: "plan_type" */
  plan_type_aggregate: Plan_Type_Aggregate;
  /** fetch data from the table: "plan_type" using primary key columns */
  plan_type_by_pk?: Maybe<Plan_Type>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_purchase" */
  product_purchase: Array<Product_Purchase>;
  /** fetch aggregated fields from the table: "product_purchase" */
  product_purchase_aggregate: Product_Purchase_Aggregate;
  /** fetch data from the table: "product_purchase" using primary key columns */
  product_purchase_by_pk?: Maybe<Product_Purchase>;
  /** fetch data from the table: "product_type" */
  product_type: Array<Product_Type>;
  /** fetch aggregated fields from the table: "product_type" */
  product_type_aggregate: Product_Type_Aggregate;
  /** fetch data from the table: "product_type" using primary key columns */
  product_type_by_pk?: Maybe<Product_Type>;
  /** fetch data from the table: "property" */
  property: Array<Property>;
  propertyDailyViews: Array<Property_Views_Model>;
  propertyTypesDistribution: Array<Property_Types_Distribution_Model>;
  /** fetch aggregated fields from the table: "property" */
  property_aggregate: Property_Aggregate;
  /** fetch data from the table: "property" using primary key columns */
  property_by_pk?: Maybe<Property>;
  /** fetch data from the table: "property_cluster" */
  property_cluster: Array<Property_Cluster>;
  /** fetch aggregated fields from the table: "property_cluster" */
  property_cluster_aggregate: Property_Cluster_Aggregate;
  /** fetch data from the table: "property_cluster" using primary key columns */
  property_cluster_by_pk?: Maybe<Property_Cluster>;
  /** fetch data from the table: "property_composition" */
  property_composition: Array<Property_Composition>;
  /** fetch aggregated fields from the table: "property_composition" */
  property_composition_aggregate: Property_Composition_Aggregate;
  /** fetch data from the table: "property_composition" using primary key columns */
  property_composition_by_pk?: Maybe<Property_Composition>;
  /** fetch data from the table: "property_feature" */
  property_feature: Array<Property_Feature>;
  /** fetch aggregated fields from the table: "property_feature" */
  property_feature_aggregate: Property_Feature_Aggregate;
  /** fetch data from the table: "property_feature" using primary key columns */
  property_feature_by_pk?: Maybe<Property_Feature>;
  /** fetch data from the table: "property_folder" */
  property_folder: Array<Property_Folder>;
  /** fetch aggregated fields from the table: "property_folder" */
  property_folder_aggregate: Property_Folder_Aggregate;
  /** fetch data from the table: "property_folder" using primary key columns */
  property_folder_by_pk?: Maybe<Property_Folder>;
  /** fetch data from the table: "property_folder_public_profile" */
  property_folder_public_profile: Array<Property_Folder_Public_Profile>;
  /** fetch aggregated fields from the table: "property_folder_public_profile" */
  property_folder_public_profile_aggregate: Property_Folder_Public_Profile_Aggregate;
  /** fetch data from the table: "property_folder_public_profile" using primary key columns */
  property_folder_public_profile_by_pk?: Maybe<Property_Folder_Public_Profile>;
  /** fetch data from the table: "property_folder_public_profile_faq" */
  property_folder_public_profile_faq: Array<Property_Folder_Public_Profile_Faq>;
  /** fetch aggregated fields from the table: "property_folder_public_profile_faq" */
  property_folder_public_profile_faq_aggregate: Property_Folder_Public_Profile_Faq_Aggregate;
  /** fetch data from the table: "property_folder_public_profile_faq" using primary key columns */
  property_folder_public_profile_faq_by_pk?: Maybe<Property_Folder_Public_Profile_Faq>;
  /** fetch data from the table: "property_folder_public_profile_highlight" */
  property_folder_public_profile_highlight: Array<Property_Folder_Public_Profile_Highlight>;
  /** fetch aggregated fields from the table: "property_folder_public_profile_highlight" */
  property_folder_public_profile_highlight_aggregate: Property_Folder_Public_Profile_Highlight_Aggregate;
  /** fetch data from the table: "property_folder_public_profile_highlight" using primary key columns */
  property_folder_public_profile_highlight_by_pk?: Maybe<Property_Folder_Public_Profile_Highlight>;
  /** fetch data from the table: "property_folder_public_profile_listing_example" */
  property_folder_public_profile_listing_example: Array<Property_Folder_Public_Profile_Listing_Example>;
  /** fetch aggregated fields from the table: "property_folder_public_profile_listing_example" */
  property_folder_public_profile_listing_example_aggregate: Property_Folder_Public_Profile_Listing_Example_Aggregate;
  /** fetch data from the table: "property_folder_public_profile_listing_example" using primary key columns */
  property_folder_public_profile_listing_example_by_pk?: Maybe<Property_Folder_Public_Profile_Listing_Example>;
  /** fetch data from the table: "property_folder_public_profile_nearby_place" */
  property_folder_public_profile_nearby_place: Array<Property_Folder_Public_Profile_Nearby_Place>;
  /** fetch aggregated fields from the table: "property_folder_public_profile_nearby_place" */
  property_folder_public_profile_nearby_place_aggregate: Property_Folder_Public_Profile_Nearby_Place_Aggregate;
  /** fetch data from the table: "property_folder_public_profile_nearby_place" using primary key columns */
  property_folder_public_profile_nearby_place_by_pk?: Maybe<Property_Folder_Public_Profile_Nearby_Place>;
  /** fetch data from the table: "property_folder_public_profile_related" */
  property_folder_public_profile_related: Array<Property_Folder_Public_Profile_Related>;
  /** fetch aggregated fields from the table: "property_folder_public_profile_related" */
  property_folder_public_profile_related_aggregate: Property_Folder_Public_Profile_Related_Aggregate;
  /** fetch data from the table: "property_folder_public_profile_related" using primary key columns */
  property_folder_public_profile_related_by_pk?: Maybe<Property_Folder_Public_Profile_Related>;
  /** fetch data from the table: "property_folder_public_profile_translation" */
  property_folder_public_profile_translation: Array<Property_Folder_Public_Profile_Translation>;
  /** fetch aggregated fields from the table: "property_folder_public_profile_translation" */
  property_folder_public_profile_translation_aggregate: Property_Folder_Public_Profile_Translation_Aggregate;
  /** fetch data from the table: "property_folder_public_profile_translation" using primary key columns */
  property_folder_public_profile_translation_by_pk?: Maybe<Property_Folder_Public_Profile_Translation>;
  /** fetch data from the table: "property_image" */
  property_image: Array<Property_Image>;
  /** fetch aggregated fields from the table: "property_image" */
  property_image_aggregate: Property_Image_Aggregate;
  /** fetch data from the table: "property_image" using primary key columns */
  property_image_by_pk?: Maybe<Property_Image>;
  /** fetch data from the table: "property_list" */
  property_list: Array<Property_List>;
  /** fetch data from the table: "property_list_activity" */
  property_list_activity: Array<Property_List_Activity>;
  /** fetch aggregated fields from the table: "property_list_activity" */
  property_list_activity_aggregate: Property_List_Activity_Aggregate;
  /** fetch data from the table: "property_list_activity" using primary key columns */
  property_list_activity_by_pk?: Maybe<Property_List_Activity>;
  /** fetch aggregated fields from the table: "property_list" */
  property_list_aggregate: Property_List_Aggregate;
  /** fetch data from the table: "property_list" using primary key columns */
  property_list_by_pk?: Maybe<Property_List>;
  /** fetch data from the table: "property_list_folder" */
  property_list_folder: Array<Property_List_Folder>;
  /** fetch aggregated fields from the table: "property_list_folder" */
  property_list_folder_aggregate: Property_List_Folder_Aggregate;
  /** fetch data from the table: "property_list_folder" using primary key columns */
  property_list_folder_by_pk?: Maybe<Property_List_Folder>;
  /** fetch data from the table: "property_list_report" */
  property_list_report: Array<Property_List_Report>;
  /** fetch aggregated fields from the table: "property_list_report" */
  property_list_report_aggregate: Property_List_Report_Aggregate;
  /** fetch data from the table: "property_list_report" using primary key columns */
  property_list_report_by_pk?: Maybe<Property_List_Report>;
  property_list_sponsored_limit?: Maybe<SponsoredLimitOutput>;
  /** fetch data from the table: "property_origin" */
  property_origin: Array<Property_Origin>;
  /** fetch aggregated fields from the table: "property_origin" */
  property_origin_aggregate: Property_Origin_Aggregate;
  /** fetch data from the table: "property_origin" using primary key columns */
  property_origin_by_pk?: Maybe<Property_Origin>;
  /** fetch data from the table: "property_origin_type" */
  property_origin_type: Array<Property_Origin_Type>;
  /** fetch aggregated fields from the table: "property_origin_type" */
  property_origin_type_aggregate: Property_Origin_Type_Aggregate;
  /** fetch data from the table: "property_origin_type" using primary key columns */
  property_origin_type_by_pk?: Maybe<Property_Origin_Type>;
  /** fetch data from the table: "property_owner" */
  property_owner: Array<Property_Owner>;
  /** fetch aggregated fields from the table: "property_owner" */
  property_owner_aggregate: Property_Owner_Aggregate;
  /** fetch data from the table: "property_owner" using primary key columns */
  property_owner_by_pk?: Maybe<Property_Owner>;
  /** fetch data from the table: "property_place_reference" */
  property_place_reference: Array<Property_Place_Reference>;
  /** fetch aggregated fields from the table: "property_place_reference" */
  property_place_reference_aggregate: Property_Place_Reference_Aggregate;
  /** fetch data from the table: "property_place_reference" using primary key columns */
  property_place_reference_by_pk?: Maybe<Property_Place_Reference>;
  /** fetch data from the table: "property_price_history" */
  property_price_history: Array<Property_Price_History>;
  /** fetch aggregated fields from the table: "property_price_history" */
  property_price_history_aggregate: Property_Price_History_Aggregate;
  /** fetch data from the table: "property_price_history" using primary key columns */
  property_price_history_by_pk?: Maybe<Property_Price_History>;
  /** fetch data from the table: "property_report_type" */
  property_report_type: Array<Property_Report_Type>;
  /** fetch aggregated fields from the table: "property_report_type" */
  property_report_type_aggregate: Property_Report_Type_Aggregate;
  /** fetch data from the table: "property_report_type" using primary key columns */
  property_report_type_by_pk?: Maybe<Property_Report_Type>;
  /** fetch data from the table: "property_source" */
  property_source: Array<Property_Source>;
  /** fetch aggregated fields from the table: "property_source" */
  property_source_aggregate: Property_Source_Aggregate;
  /** fetch data from the table: "property_source" using primary key columns */
  property_source_by_pk?: Maybe<Property_Source>;
  /** fetch data from the table: "property_status" */
  property_status: Array<Property_Status>;
  /** fetch aggregated fields from the table: "property_status" */
  property_status_aggregate: Property_Status_Aggregate;
  /** fetch data from the table: "property_status" using primary key columns */
  property_status_by_pk?: Maybe<Property_Status>;
  /** fetch data from the table: "property_type" */
  property_type: Array<Property_Type>;
  /** fetch aggregated fields from the table: "property_type" */
  property_type_aggregate: Property_Type_Aggregate;
  /** fetch data from the table: "property_type" using primary key columns */
  property_type_by_pk?: Maybe<Property_Type>;
  /** An array relationship */
  property_views: Array<Property_Views>;
  /** An aggregate relationship */
  property_views_aggregate: Property_Views_Aggregate;
  /** fetch data from the table: "property_views" using primary key columns */
  property_views_by_pk?: Maybe<Property_Views>;
  /** fetch data from the table: "queries_property_result" */
  queries_property_result: Array<Queries_Property_Result>;
  /** fetch aggregated fields from the table: "queries_property_result" */
  queries_property_result_aggregate: Queries_Property_Result_Aggregate;
  /** fetch data from the table: "queries_property_result" using primary key columns */
  queries_property_result_by_pk?: Maybe<Queries_Property_Result>;
  /** fetch data from the table: "queries_property_result_re" */
  queries_property_result_re: Array<Queries_Property_Result_Re>;
  /** fetch aggregated fields from the table: "queries_property_result_re" */
  queries_property_result_re_aggregate: Queries_Property_Result_Re_Aggregate;
  /** fetch data from the table: "queries_property_result_re" using primary key columns */
  queries_property_result_re_by_pk?: Maybe<Queries_Property_Result_Re>;
  /** fetch data from the table: "query_classification" */
  query_classification: Array<Query_Classification>;
  /** fetch aggregated fields from the table: "query_classification" */
  query_classification_aggregate: Query_Classification_Aggregate;
  /** fetch data from the table: "query_classification" using primary key columns */
  query_classification_by_pk?: Maybe<Query_Classification>;
  /** fetch data from the table: "query_classification_re" */
  query_classification_re: Array<Query_Classification_Re>;
  /** fetch aggregated fields from the table: "query_classification_re" */
  query_classification_re_aggregate: Query_Classification_Re_Aggregate;
  /** fetch data from the table: "query_classification_re" using primary key columns */
  query_classification_re_by_pk?: Maybe<Query_Classification_Re>;
  /** fetch data from the table: "raw_location" */
  raw_location: Array<Raw_Location>;
  /** fetch aggregated fields from the table: "raw_location" */
  raw_location_aggregate: Raw_Location_Aggregate;
  /** fetch data from the table: "raw_location" using primary key columns */
  raw_location_by_pk?: Maybe<Raw_Location>;
  /** fetch data from the table: "redirect" */
  redirect: Array<Redirect>;
  /** fetch aggregated fields from the table: "redirect" */
  redirect_aggregate: Redirect_Aggregate;
  /** fetch data from the table: "redirect" using primary key columns */
  redirect_by_pk?: Maybe<Redirect>;
  /** fetch data from the table: "reference_price_history" */
  reference_price_history: Array<Reference_Price_History>;
  /** fetch aggregated fields from the table: "reference_price_history" */
  reference_price_history_aggregate: Reference_Price_History_Aggregate;
  /** fetch data from the table: "reference_price_history" using primary key columns */
  reference_price_history_by_pk?: Maybe<Reference_Price_History>;
  /** fetch data from the table: "reference_zone" */
  reference_zone: Array<Reference_Zone>;
  /** fetch aggregated fields from the table: "reference_zone" */
  reference_zone_aggregate: Reference_Zone_Aggregate;
  /** fetch data from the table: "reference_zone" using primary key columns */
  reference_zone_by_pk?: Maybe<Reference_Zone>;
  regionalPropertyDistribution: Array<Regional_Property_Model>;
  /** fetch data from the table: "search_context" */
  search_context: Array<Search_Context>;
  /** fetch aggregated fields from the table: "search_context" */
  search_context_aggregate: Search_Context_Aggregate;
  /** fetch data from the table: "search_context" using primary key columns */
  search_context_by_pk?: Maybe<Search_Context>;
  /** fetch data from the table: "search_context_location" */
  search_context_location: Array<Search_Context_Location>;
  /** fetch aggregated fields from the table: "search_context_location" */
  search_context_location_aggregate: Search_Context_Location_Aggregate;
  /** fetch data from the table: "search_context_location" using primary key columns */
  search_context_location_by_pk?: Maybe<Search_Context_Location>;
  /** fetch data from the table: "search_domain" */
  search_domain: Array<Search_Domain>;
  /** fetch aggregated fields from the table: "search_domain" */
  search_domain_aggregate: Search_Domain_Aggregate;
  /** fetch data from the table: "search_domain" using primary key columns */
  search_domain_by_pk?: Maybe<Search_Domain>;
  /** An array relationship */
  search_sessions: Array<Search_Sessions>;
  /** An aggregate relationship */
  search_sessions_aggregate: Search_Sessions_Aggregate;
  /** fetch data from the table: "search_sessions" using primary key columns */
  search_sessions_by_pk?: Maybe<Search_Sessions>;
  /** execute function "search_sessions_sorted_by_last_query" which returns "search_sessions" */
  search_sessions_sorted_by_last_query: Array<Search_Sessions>;
  /** execute function "search_sessions_sorted_by_last_query" and query aggregates on result of table type "search_sessions" */
  search_sessions_sorted_by_last_query_aggregate: Search_Sessions_Aggregate;
  /** An array relationship */
  search_slugs: Array<Search_Slugs>;
  /** An aggregate relationship */
  search_slugs_aggregate: Search_Slugs_Aggregate;
  /** fetch data from the table: "search_slugs" using primary key columns */
  search_slugs_by_pk?: Maybe<Search_Slugs>;
  /** fetch data from the table: "seo_city" */
  seo_city: Array<Seo_City>;
  /** fetch aggregated fields from the table: "seo_city" */
  seo_city_aggregate: Seo_City_Aggregate;
  /** fetch data from the table: "seo_city" using primary key columns */
  seo_city_by_pk?: Maybe<Seo_City>;
  /** fetch data from the table: "session_origin" */
  session_origin: Array<Session_Origin>;
  /** fetch aggregated fields from the table: "session_origin" */
  session_origin_aggregate: Session_Origin_Aggregate;
  /** fetch data from the table: "session_origin" using primary key columns */
  session_origin_by_pk?: Maybe<Session_Origin>;
  /** fetch data from the table: "sponsored_property_list" */
  sponsored_property_list: Array<Sponsored_Property_List>;
  /** fetch aggregated fields from the table: "sponsored_property_list" */
  sponsored_property_list_aggregate: Sponsored_Property_List_Aggregate;
  /** fetch data from the table: "sponsored_property_list" using primary key columns */
  sponsored_property_list_by_pk?: Maybe<Sponsored_Property_List>;
  /** fetch data from the table: "subscription" */
  subscription: Array<Subscription>;
  /** fetch aggregated fields from the table: "subscription" */
  subscription_aggregate: Subscription_Aggregate;
  /** fetch data from the table: "subscription" using primary key columns */
  subscription_by_pk?: Maybe<Subscription>;
  /** fetch data from the table: "subscription_invoice" */
  subscription_invoice: Array<Subscription_Invoice>;
  /** fetch aggregated fields from the table: "subscription_invoice" */
  subscription_invoice_aggregate: Subscription_Invoice_Aggregate;
  /** fetch data from the table: "subscription_invoice" using primary key columns */
  subscription_invoice_by_pk?: Maybe<Subscription_Invoice>;
  /** fetch data from the table: "subscription_source" */
  subscription_source: Array<Subscription_Source>;
  /** fetch aggregated fields from the table: "subscription_source" */
  subscription_source_aggregate: Subscription_Source_Aggregate;
  /** fetch data from the table: "subscription_source" using primary key columns */
  subscription_source_by_pk?: Maybe<Subscription_Source>;
  /** fetch data from the table: "subscription_status" */
  subscription_status: Array<Subscription_Status>;
  /** fetch aggregated fields from the table: "subscription_status" */
  subscription_status_aggregate: Subscription_Status_Aggregate;
  /** fetch data from the table: "subscription_status" using primary key columns */
  subscription_status_by_pk?: Maybe<Subscription_Status>;
  /** fetch data from the table: "text_content" */
  text_content: Array<Text_Content>;
  /** fetch aggregated fields from the table: "text_content" */
  text_content_aggregate: Text_Content_Aggregate;
  /** fetch data from the table: "text_content" using primary key columns */
  text_content_by_pk?: Maybe<Text_Content>;
  /** An array relationship */
  translations: Array<Translations>;
  /** An aggregate relationship */
  translations_aggregate: Translations_Aggregate;
  /** fetch data from the table: "translations" using primary key columns */
  translations_by_pk?: Maybe<Translations>;
  /** fetch data from the table: "url_slug" */
  url_slug: Array<Url_Slug>;
  /** fetch aggregated fields from the table: "url_slug" */
  url_slug_aggregate: Url_Slug_Aggregate;
  /** fetch data from the table: "url_slug" using primary key columns */
  url_slug_by_pk?: Maybe<Url_Slug>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** An array relationship */
  user_filters: Array<User_Filters>;
  /** An aggregate relationship */
  user_filters_aggregate: User_Filters_Aggregate;
  /** fetch data from the table: "user_filters" using primary key columns */
  user_filters_by_pk?: Maybe<User_Filters>;
  /** An array relationship */
  user_filters_features: Array<User_Filters_Features>;
  /** An aggregate relationship */
  user_filters_features_aggregate: User_Filters_Features_Aggregate;
  /** fetch data from the table: "user_filters_features" using primary key columns */
  user_filters_features_by_pk?: Maybe<User_Filters_Features>;
  /** fetch data from the table: "user_organization" */
  user_organization: Array<User_Organization>;
  /** fetch aggregated fields from the table: "user_organization" */
  user_organization_aggregate: User_Organization_Aggregate;
  /** fetch data from the table: "user_organization" using primary key columns */
  user_organization_by_pk?: Maybe<User_Organization>;
  /** An array relationship */
  user_preferences: Array<User_Preferences>;
  /** An aggregate relationship */
  user_preferences_aggregate: User_Preferences_Aggregate;
  /** fetch data from the table: "user_preferences" using primary key columns */
  user_preferences_by_pk?: Maybe<User_Preferences>;
  /** fetch data from the table: "user_property_notifiation" */
  user_property_notifiation: Array<User_Property_Notifiation>;
  /** fetch aggregated fields from the table: "user_property_notifiation" */
  user_property_notifiation_aggregate: User_Property_Notifiation_Aggregate;
  /** fetch data from the table: "user_property_notifiation" using primary key columns */
  user_property_notifiation_by_pk?: Maybe<User_Property_Notifiation>;
  /** An array relationship */
  user_saved_properties: Array<User_Saved_Properties>;
  /** An aggregate relationship */
  user_saved_properties_aggregate: User_Saved_Properties_Aggregate;
  /** fetch data from the table: "user_saved_properties" using primary key columns */
  user_saved_properties_by_pk?: Maybe<User_Saved_Properties>;
  /** fetch data from the table: "user_seen_property" */
  user_seen_property: Array<User_Seen_Property>;
  /** fetch aggregated fields from the table: "user_seen_property" */
  user_seen_property_aggregate: User_Seen_Property_Aggregate;
  /** fetch data from the table: "user_seen_property" using primary key columns */
  user_seen_property_by_pk?: Maybe<User_Seen_Property>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate;
  /** fetch data from the table: "users_activity_summary" */
  users_activity_summary: Array<Users_Activity_Summary>;
  /** fetch aggregated fields from the table: "users_activity_summary" */
  users_activity_summary_aggregate: Users_Activity_Summary_Aggregate;
  /** fetch data from the table: "users_activity_summary" using primary key columns */
  users_activity_summary_by_pk?: Maybe<Users_Activity_Summary>;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
  /** fetch data from the table: "visibility_status" */
  visibility_status: Array<Visibility_Status>;
  /** fetch aggregated fields from the table: "visibility_status" */
  visibility_status_aggregate: Visibility_Status_Aggregate;
  /** fetch data from the table: "visibility_status" using primary key columns */
  visibility_status_by_pk?: Maybe<Visibility_Status>;
  /** fetch data from the table: "whatsapp_ai_inbound_message" */
  whatsapp_ai_inbound_message: Array<Whatsapp_Ai_Inbound_Message>;
  /** fetch aggregated fields from the table: "whatsapp_ai_inbound_message" */
  whatsapp_ai_inbound_message_aggregate: Whatsapp_Ai_Inbound_Message_Aggregate;
  /** fetch data from the table: "whatsapp_ai_inbound_message" using primary key columns */
  whatsapp_ai_inbound_message_by_pk?: Maybe<Whatsapp_Ai_Inbound_Message>;
  /** fetch data from the table: "whatsapp_ai_outbox_part" */
  whatsapp_ai_outbox_part: Array<Whatsapp_Ai_Outbox_Part>;
  /** fetch aggregated fields from the table: "whatsapp_ai_outbox_part" */
  whatsapp_ai_outbox_part_aggregate: Whatsapp_Ai_Outbox_Part_Aggregate;
  /** fetch data from the table: "whatsapp_ai_outbox_part" using primary key columns */
  whatsapp_ai_outbox_part_by_pk?: Maybe<Whatsapp_Ai_Outbox_Part>;
  /** fetch data from the table: "whatsapp_ai_turn" */
  whatsapp_ai_turn: Array<Whatsapp_Ai_Turn>;
  /** fetch aggregated fields from the table: "whatsapp_ai_turn" */
  whatsapp_ai_turn_aggregate: Whatsapp_Ai_Turn_Aggregate;
  /** fetch data from the table: "whatsapp_ai_turn" using primary key columns */
  whatsapp_ai_turn_by_pk?: Maybe<Whatsapp_Ai_Turn>;
  /** fetch data from the table: "whatsapp_chat" */
  whatsapp_chat: Array<Whatsapp_Chat>;
  /** fetch aggregated fields from the table: "whatsapp_chat" */
  whatsapp_chat_aggregate: Whatsapp_Chat_Aggregate;
  /** fetch data from the table: "whatsapp_chat" using primary key columns */
  whatsapp_chat_by_pk?: Maybe<Whatsapp_Chat>;
  /** fetch data from the table: "whatsapp_human" */
  whatsapp_human: Array<Whatsapp_Human>;
  /** fetch aggregated fields from the table: "whatsapp_human" */
  whatsapp_human_aggregate: Whatsapp_Human_Aggregate;
  /** fetch data from the table: "whatsapp_human" using primary key columns */
  whatsapp_human_by_pk?: Maybe<Whatsapp_Human>;
  /** fetch data from the table: "zone_contains" */
  zone_contains: Array<Zone_Contains>;
  /** fetch aggregated fields from the table: "zone_contains" */
  zone_contains_aggregate: Zone_Contains_Aggregate;
  /** fetch data from the table: "zone_contains" using primary key columns */
  zone_contains_by_pk?: Maybe<Zone_Contains>;
  /** fetch data from the table: "zone_data_method" */
  zone_data_method: Array<Zone_Data_Method>;
  /** fetch aggregated fields from the table: "zone_data_method" */
  zone_data_method_aggregate: Zone_Data_Method_Aggregate;
  /** fetch data from the table: "zone_data_method" using primary key columns */
  zone_data_method_by_pk?: Maybe<Zone_Data_Method>;
};


export type Query_RootAddress_TypesArgs = {
  distinct_on?: InputMaybe<Array<Address_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Types_Order_By>>;
  where?: InputMaybe<Address_Types_Bool_Exp>;
};


export type Query_RootAddress_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Types_Order_By>>;
  where?: InputMaybe<Address_Types_Bool_Exp>;
};


export type Query_RootAddress_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootAgencyArgs = {
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Query_RootAgencyDashboardStatisticsArgs = {
  args: AgencyDashboardStatistics_Arguments;
  distinct_on?: InputMaybe<Array<Lister_Dashboard_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Dashboard_Model_Order_By>>;
  where?: InputMaybe<Lister_Dashboard_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootAgencyScrapedPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Agency_Properties_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Properties_Model_Order_By>>;
  where?: InputMaybe<Agency_Properties_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootAgencyViewsGraphicArgs = {
  args: AgencyViewsGraphic_Arguments;
  distinct_on?: InputMaybe<Array<Daily_Views_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Views_Order_By>>;
  where?: InputMaybe<Daily_Views_Bool_Exp_Bool_Exp>;
};


export type Query_RootAgency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Query_RootAgency_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAgency_HealthArgs = {
  distinct_on?: InputMaybe<Array<Agency_Health_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Health_Order_By>>;
  where?: InputMaybe<Agency_Health_Bool_Exp>;
};


export type Query_RootAgency_Health_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agency_Health_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Health_Order_By>>;
  where?: InputMaybe<Agency_Health_Bool_Exp>;
};


export type Query_RootAgency_TypeArgs = {
  distinct_on?: InputMaybe<Array<Agency_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Type_Order_By>>;
  where?: InputMaybe<Agency_Type_Bool_Exp>;
};


export type Query_RootAgency_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agency_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Type_Order_By>>;
  where?: InputMaybe<Agency_Type_Bool_Exp>;
};


export type Query_RootAgency_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootAgent_ActionArgs = {
  distinct_on?: InputMaybe<Array<Agent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Action_Order_By>>;
  where?: InputMaybe<Agent_Action_Bool_Exp>;
};


export type Query_RootAgent_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Action_Order_By>>;
  where?: InputMaybe<Agent_Action_Bool_Exp>;
};


export type Query_RootAgent_Action_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAgent_TaskArgs = {
  distinct_on?: InputMaybe<Array<Agent_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Task_Order_By>>;
  where?: InputMaybe<Agent_Task_Bool_Exp>;
};


export type Query_RootAgent_Task_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Task_Order_By>>;
  where?: InputMaybe<Agent_Task_Bool_Exp>;
};


export type Query_RootAgent_Task_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAmenitiesArgs = {
  distinct_on?: InputMaybe<Array<Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Amenities_Order_By>>;
  where?: InputMaybe<Amenities_Bool_Exp>;
};


export type Query_RootAmenities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Amenities_Order_By>>;
  where?: InputMaybe<Amenities_Bool_Exp>;
};


export type Query_RootAmenities_By_PkArgs = {
  amenity: Scalars['String']['input'];
};


export type Query_RootApp_ConfigArgs = {
  distinct_on?: InputMaybe<Array<App_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Config_Order_By>>;
  where?: InputMaybe<App_Config_Bool_Exp>;
};


export type Query_RootApp_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Config_Order_By>>;
  where?: InputMaybe<App_Config_Bool_Exp>;
};


export type Query_RootApp_Config_By_PkArgs = {
  platform: Scalars['String']['input'];
};


export type Query_RootAuthProviderArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootAuthProviderRequestArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthProviderRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Query_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Query_RootAuthProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Query_RootAuthProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Query_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAuthRefreshTokenTypesArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Query_RootAuthRefreshTokenTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Query_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Query_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Query_RootAuthRoleArgs = {
  role: Scalars['String']['input'];
};


export type Query_RootAuthRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Query_RootAuthRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Query_RootAuthUserProviderArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Query_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Query_RootAuthUserRoleArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Query_RootAuthUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Query_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Query_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Query_RootBlogArgs = {
  distinct_on?: InputMaybe<Array<Blog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Order_By>>;
  where?: InputMaybe<Blog_Bool_Exp>;
};


export type Query_RootBlog_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Order_By>>;
  where?: InputMaybe<Blog_Bool_Exp>;
};


export type Query_RootBlog_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBlog_PostArgs = {
  distinct_on?: InputMaybe<Array<Blog_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Post_Order_By>>;
  where?: InputMaybe<Blog_Post_Bool_Exp>;
};


export type Query_RootBlog_Post_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blog_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Post_Order_By>>;
  where?: InputMaybe<Blog_Post_Bool_Exp>;
};


export type Query_RootBlog_Post_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBlog_SectionArgs = {
  distinct_on?: InputMaybe<Array<Blog_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Section_Order_By>>;
  where?: InputMaybe<Blog_Section_Bool_Exp>;
};


export type Query_RootBlog_Section_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blog_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Section_Order_By>>;
  where?: InputMaybe<Blog_Section_Bool_Exp>;
};


export type Query_RootBlog_Section_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBlog_StatusArgs = {
  distinct_on?: InputMaybe<Array<Blog_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Status_Order_By>>;
  where?: InputMaybe<Blog_Status_Bool_Exp>;
};


export type Query_RootBlog_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blog_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Status_Order_By>>;
  where?: InputMaybe<Blog_Status_Bool_Exp>;
};


export type Query_RootBlog_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootBucketArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootBuilderArgs = {
  distinct_on?: InputMaybe<Array<Builder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Builder_Order_By>>;
  where?: InputMaybe<Builder_Bool_Exp>;
};


export type Query_RootBuilder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Builder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Builder_Order_By>>;
  where?: InputMaybe<Builder_Bool_Exp>;
};


export type Query_RootBuilder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCertified_AgentArgs = {
  distinct_on?: InputMaybe<Array<Certified_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Certified_Agent_Order_By>>;
  where?: InputMaybe<Certified_Agent_Bool_Exp>;
};


export type Query_RootCertified_Agent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certified_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Certified_Agent_Order_By>>;
  where?: InputMaybe<Certified_Agent_Bool_Exp>;
};


export type Query_RootCertified_Agent_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChat_Response_TypeArgs = {
  distinct_on?: InputMaybe<Array<Chat_Response_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Response_Type_Order_By>>;
  where?: InputMaybe<Chat_Response_Type_Bool_Exp>;
};


export type Query_RootChat_Response_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Response_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Response_Type_Order_By>>;
  where?: InputMaybe<Chat_Response_Type_Bool_Exp>;
};


export type Query_RootChat_Response_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootCitizens_Property_List_ViewArgs = {
  distinct_on?: InputMaybe<Array<Citizens_Property_List_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Citizens_Property_List_View_Order_By>>;
  where?: InputMaybe<Citizens_Property_List_View_Bool_Exp>;
};


export type Query_RootCitizens_Property_List_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Citizens_Property_List_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Citizens_Property_List_View_Order_By>>;
  where?: InputMaybe<Citizens_Property_List_View_Bool_Exp>;
};


export type Query_RootCityArgs = {
  distinct_on?: InputMaybe<Array<City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Order_By>>;
  where?: InputMaybe<City_Bool_Exp>;
};


export type Query_RootCity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Order_By>>;
  where?: InputMaybe<City_Bool_Exp>;
};


export type Query_RootCity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCity_ZoneArgs = {
  distinct_on?: InputMaybe<Array<City_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Order_By>>;
  where?: InputMaybe<City_Zone_Bool_Exp>;
};


export type Query_RootCity_Zone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Order_By>>;
  where?: InputMaybe<City_Zone_Bool_Exp>;
};


export type Query_RootCity_Zone_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCity_Zone_OriginArgs = {
  distinct_on?: InputMaybe<Array<City_Zone_Origin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Origin_Order_By>>;
  where?: InputMaybe<City_Zone_Origin_Bool_Exp>;
};


export type Query_RootCity_Zone_Origin_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Zone_Origin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Origin_Order_By>>;
  where?: InputMaybe<City_Zone_Origin_Bool_Exp>;
};


export type Query_RootCity_Zone_Origin_By_PkArgs = {
  origin: Scalars['String']['input'];
};


export type Query_RootClaim_Request_StatusArgs = {
  distinct_on?: InputMaybe<Array<Claim_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Claim_Request_Status_Order_By>>;
  where?: InputMaybe<Claim_Request_Status_Bool_Exp>;
};


export type Query_RootClaim_Request_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Claim_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Claim_Request_Status_Order_By>>;
  where?: InputMaybe<Claim_Request_Status_Bool_Exp>;
};


export type Query_RootClaim_Request_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootClassifiedPropertiesArgs = {
  args: ClassifiedProperties_Arguments;
  distinct_on?: InputMaybe<Array<Classified_Properties_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Classified_Properties_Model_Order_By>>;
  where?: InputMaybe<Classified_Properties_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootCleringArgs = {
  distinct_on?: InputMaybe<Array<Clering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clering_Order_By>>;
  where?: InputMaybe<Clering_Bool_Exp>;
};


export type Query_RootClering_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clering_Order_By>>;
  where?: InputMaybe<Clering_Bool_Exp>;
};


export type Query_RootClering_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstruction_StatusArgs = {
  distinct_on?: InputMaybe<Array<Construction_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Status_Order_By>>;
  where?: InputMaybe<Construction_Status_Bool_Exp>;
};


export type Query_RootConstruction_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Construction_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Status_Order_By>>;
  where?: InputMaybe<Construction_Status_Bool_Exp>;
};


export type Query_RootConstruction_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootContactArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Query_RootContact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Query_RootContact_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootContact_HealthArgs = {
  distinct_on?: InputMaybe<Array<Contact_Health_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Health_Order_By>>;
  where?: InputMaybe<Contact_Health_Bool_Exp>;
};


export type Query_RootContact_Health_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Health_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Health_Order_By>>;
  where?: InputMaybe<Contact_Health_Bool_Exp>;
};


export type Query_RootContact_Phone_NumberArgs = {
  distinct_on?: InputMaybe<Array<Contact_Phone_Number_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Phone_Number_Order_By>>;
  where?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
};


export type Query_RootContact_Phone_Number_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Phone_Number_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Phone_Number_Order_By>>;
  where?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
};


export type Query_RootContact_Phone_Number_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootContact_TypeArgs = {
  distinct_on?: InputMaybe<Array<Contact_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Type_Order_By>>;
  where?: InputMaybe<Contact_Type_Bool_Exp>;
};


export type Query_RootContact_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Type_Order_By>>;
  where?: InputMaybe<Contact_Type_Bool_Exp>;
};


export type Query_RootContact_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootContent_TypeArgs = {
  distinct_on?: InputMaybe<Array<Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Content_Type_Order_By>>;
  where?: InputMaybe<Content_Type_Bool_Exp>;
};


export type Query_RootContent_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Content_Type_Order_By>>;
  where?: InputMaybe<Content_Type_Bool_Exp>;
};


export type Query_RootContent_Type_By_PkArgs = {
  content_type: Scalars['String']['input'];
};


export type Query_RootCountriesArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Query_RootCountries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Query_RootCountries_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Query_RootCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Query_RootCountry_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCurrencyArgs = {
  distinct_on?: InputMaybe<Array<Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Order_By>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Query_RootCurrency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Order_By>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Query_RootCurrency_By_PkArgs = {
  currency: Scalars['String']['input'];
};


export type Query_RootCurrency_Exchange_RatesArgs = {
  distinct_on?: InputMaybe<Array<Currency_Exchange_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Exchange_Rates_Order_By>>;
  where?: InputMaybe<Currency_Exchange_Rates_Bool_Exp>;
};


export type Query_RootCurrency_Exchange_Rates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currency_Exchange_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Exchange_Rates_Order_By>>;
  where?: InputMaybe<Currency_Exchange_Rates_Bool_Exp>;
};


export type Query_RootCurrency_Exchange_Rates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDailyRegisteredUsersArgs = {
  args: DailyRegisteredUsers_Arguments;
  distinct_on?: InputMaybe<Array<Daily_Active_Users_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Active_Users_Model_Order_By>>;
  where?: InputMaybe<Daily_Active_Users_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootDaliyActiveUsersArgs = {
  args: DaliyActiveUsers_Arguments;
  distinct_on?: InputMaybe<Array<Daily_Active_Users_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Active_Users_Model_Order_By>>;
  where?: InputMaybe<Daily_Active_Users_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootDaliyQueriesStatisticsArgs = {
  args: DaliyQueriesStatistics_Arguments;
  distinct_on?: InputMaybe<Array<Daliy_Queries_Statistics_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daliy_Queries_Statistics_Model_Order_By>>;
  where?: InputMaybe<Daliy_Queries_Statistics_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootDashboard_StatisticsArgs = {
  body: DashboardStatisticsActionInput;
};


export type Query_RootDuplicate_Cfn_With_Null_CnameArgs = {
  distinct_on?: InputMaybe<Array<Duplicate_Cfn_With_Null_Cname_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Duplicate_Cfn_With_Null_Cname_Order_By>>;
  where?: InputMaybe<Duplicate_Cfn_With_Null_Cname_Bool_Exp>;
};


export type Query_RootDuplicate_Cfn_With_Null_Cname_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Duplicate_Cfn_With_Null_Cname_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Duplicate_Cfn_With_Null_Cname_Order_By>>;
  where?: InputMaybe<Duplicate_Cfn_With_Null_Cname_Bool_Exp>;
};


export type Query_RootDuplicate_Phone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Duplicate_Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Duplicate_Phone_Numbers_Order_By>>;
  where?: InputMaybe<Duplicate_Phone_Numbers_Bool_Exp>;
};


export type Query_RootDuplicate_Phone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Duplicate_Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Duplicate_Phone_Numbers_Order_By>>;
  where?: InputMaybe<Duplicate_Phone_Numbers_Bool_Exp>;
};


export type Query_RootEntitiesArgs = {
  distinct_on?: InputMaybe<Array<Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entities_Order_By>>;
  where?: InputMaybe<Entities_Bool_Exp>;
};


export type Query_RootEntities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entities_Order_By>>;
  where?: InputMaybe<Entities_Bool_Exp>;
};


export type Query_RootEntities_By_PkArgs = {
  entity_type: Scalars['String']['input'];
};


export type Query_RootExchange_RatesArgs = {
  distinct_on?: InputMaybe<Array<Exchange_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Exchange_Rates_Order_By>>;
  where?: InputMaybe<Exchange_Rates_Bool_Exp>;
};


export type Query_RootExchange_Rates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exchange_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Exchange_Rates_Order_By>>;
  where?: InputMaybe<Exchange_Rates_Bool_Exp>;
};


export type Query_RootExchange_Rates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFavouritePropertiesTrendArgs = {
  args: FavouritePropertiesTrend_Arguments;
  distinct_on?: InputMaybe<Array<Favourite_Properties_Trend_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favourite_Properties_Trend_Model_Order_By>>;
  where?: InputMaybe<Favourite_Properties_Trend_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootFeatureArgs = {
  distinct_on?: InputMaybe<Array<Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Order_By>>;
  where?: InputMaybe<Feature_Bool_Exp>;
};


export type Query_RootFeature_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Order_By>>;
  where?: InputMaybe<Feature_Bool_Exp>;
};


export type Query_RootFeature_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFeature_TypeArgs = {
  distinct_on?: InputMaybe<Array<Feature_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Type_Order_By>>;
  where?: InputMaybe<Feature_Type_Bool_Exp>;
};


export type Query_RootFeature_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Type_Order_By>>;
  where?: InputMaybe<Feature_Type_Bool_Exp>;
};


export type Query_RootFeature_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_TypeArgs = {
  distinct_on?: InputMaybe<Array<File_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Type_Order_By>>;
  where?: InputMaybe<File_Type_Bool_Exp>;
};


export type Query_RootFile_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Type_Order_By>>;
  where?: InputMaybe<File_Type_Bool_Exp>;
};


export type Query_RootFile_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFolder_AmenitiesArgs = {
  distinct_on?: InputMaybe<Array<Folder_Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Amenities_Order_By>>;
  where?: InputMaybe<Folder_Amenities_Bool_Exp>;
};


export type Query_RootFolder_Amenities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Folder_Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Amenities_Order_By>>;
  where?: InputMaybe<Folder_Amenities_Bool_Exp>;
};


export type Query_RootFolder_Amenities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolder_ImageArgs = {
  distinct_on?: InputMaybe<Array<Folder_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Image_Order_By>>;
  where?: InputMaybe<Folder_Image_Bool_Exp>;
};


export type Query_RootFolder_Image_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Folder_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Image_Order_By>>;
  where?: InputMaybe<Folder_Image_Bool_Exp>;
};


export type Query_RootFolder_Image_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolder_Properties_TypeArgs = {
  distinct_on?: InputMaybe<Array<Folder_Properties_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Properties_Type_Order_By>>;
  where?: InputMaybe<Folder_Properties_Type_Bool_Exp>;
};


export type Query_RootFolder_Properties_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Folder_Properties_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Properties_Type_Order_By>>;
  where?: InputMaybe<Folder_Properties_Type_Bool_Exp>;
};


export type Query_RootFolder_Properties_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolder_StatusArgs = {
  distinct_on?: InputMaybe<Array<Folder_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Status_Order_By>>;
  where?: InputMaybe<Folder_Status_Bool_Exp>;
};


export type Query_RootFolder_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Folder_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Status_Order_By>>;
  where?: InputMaybe<Folder_Status_Bool_Exp>;
};


export type Query_RootFolder_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootFolder_TypeArgs = {
  distinct_on?: InputMaybe<Array<Folder_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Type_Order_By>>;
  where?: InputMaybe<Folder_Type_Bool_Exp>;
};


export type Query_RootFolder_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Folder_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Type_Order_By>>;
  where?: InputMaybe<Folder_Type_Bool_Exp>;
};


export type Query_RootFolder_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootFurnishing_StatusArgs = {
  distinct_on?: InputMaybe<Array<Furnishing_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Furnishing_Status_Order_By>>;
  where?: InputMaybe<Furnishing_Status_Bool_Exp>;
};


export type Query_RootFurnishing_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Furnishing_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Furnishing_Status_Order_By>>;
  where?: InputMaybe<Furnishing_Status_Bool_Exp>;
};


export type Query_RootFurnishing_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootGetCityZoneForCoordsArgs = {
  args: GetCityZoneForCoords_Arguments;
  distinct_on?: InputMaybe<Array<City_Zone_Object_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Object_Order_By>>;
  where?: InputMaybe<City_Zone_Object_Bool_Exp_Bool_Exp>;
};


export type Query_RootGetOrderByRelevanceCityZonesArgs = {
  args: GetOrderByRelevanceCityZones_Arguments;
  distinct_on?: InputMaybe<Array<City_Zone_Object_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Object_Order_By>>;
  where?: InputMaybe<City_Zone_Object_Bool_Exp_Bool_Exp>;
};


export type Query_RootGetOrderByRelevanceFormattedAddressCityZonesArgs = {
  args: GetOrderByRelevanceFormattedAddressCityZones_Arguments;
  distinct_on?: InputMaybe<Array<City_Zone_Object_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Object_Order_By>>;
  where?: InputMaybe<City_Zone_Object_Bool_Exp_Bool_Exp>;
};


export type Query_RootGetOrganizationLeadPropertiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GetOrganizationLeadPropertiesOrganizationLeadPropertyOrderBy>>;
};


export type Query_RootGet_Citizens_Property_List_FunctionArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


export type Query_RootGet_Citizens_Property_List_Function_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


export type Query_RootGet_Folders_Without_Property_ListArgs = {
  args: Get_Folders_Without_Property_List_Args;
  distinct_on?: InputMaybe<Array<Property_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Order_By>>;
  where?: InputMaybe<Property_Folder_Bool_Exp>;
};


export type Query_RootGet_Folders_Without_Property_List_AggregateArgs = {
  args: Get_Folders_Without_Property_List_Args;
  distinct_on?: InputMaybe<Array<Property_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Order_By>>;
  where?: InputMaybe<Property_Folder_Bool_Exp>;
};


export type Query_RootGet_Search_Sessions_Sorted_By_Last_QueryArgs = {
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


export type Query_RootGet_Search_Sessions_Sorted_By_Last_Query_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


export type Query_RootGet_Similar_Agencies_By_NameArgs = {
  args: Get_Similar_Agencies_By_Name_Args;
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Query_RootGet_Similar_Agencies_By_Name_AggregateArgs = {
  args: Get_Similar_Agencies_By_Name_Args;
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Query_RootGet_Similar_PropertiesArgs = {
  args: Get_Similar_Properties_Args;
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


export type Query_RootGet_Similar_Properties_AggregateArgs = {
  args: Get_Similar_Properties_Args;
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


export type Query_RootGet_Similar_Properties_By_SlugArgs = {
  args: Get_Similar_Properties_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


export type Query_RootGet_Similar_Properties_By_Slug_AggregateArgs = {
  args: Get_Similar_Properties_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


export type Query_RootGet_Top_Neighborhood_For_City_ZoneArgs = {
  args: Get_Top_Neighborhood_For_City_Zone_Args;
  distinct_on?: InputMaybe<Array<City_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Order_By>>;
  where?: InputMaybe<City_Zone_Bool_Exp>;
};


export type Query_RootGet_Top_Neighborhood_For_City_Zone_AggregateArgs = {
  args: Get_Top_Neighborhood_For_City_Zone_Args;
  distinct_on?: InputMaybe<Array<City_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Order_By>>;
  where?: InputMaybe<City_Zone_Bool_Exp>;
};


export type Query_RootGet_User_ActivityArgs = {
  args: Get_User_Activity_Args;
  distinct_on?: InputMaybe<Array<Users_Activity_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Activity_Summary_Order_By>>;
  where?: InputMaybe<Users_Activity_Summary_Bool_Exp>;
};


export type Query_RootGet_User_Activity_AggregateArgs = {
  args: Get_User_Activity_Args;
  distinct_on?: InputMaybe<Array<Users_Activity_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Activity_Summary_Order_By>>;
  where?: InputMaybe<Users_Activity_Summary_Bool_Exp>;
};


export type Query_RootGoogle_CalendarArgs = {
  distinct_on?: InputMaybe<Array<Google_Calendar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Calendar_Order_By>>;
  where?: InputMaybe<Google_Calendar_Bool_Exp>;
};


export type Query_RootGoogle_Calendar_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Google_Calendar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Calendar_Order_By>>;
  where?: InputMaybe<Google_Calendar_Bool_Exp>;
};


export type Query_RootGoogle_Calendar_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Query_RootHeatingTypeArgs = {
  distinct_on?: InputMaybe<Array<HeatingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<HeatingType_Order_By>>;
  where?: InputMaybe<HeatingType_Bool_Exp>;
};


export type Query_RootHeatingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<HeatingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<HeatingType_Order_By>>;
  where?: InputMaybe<HeatingType_Bool_Exp>;
};


export type Query_RootHeatingType_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootImageArgs = {
  distinct_on?: InputMaybe<Array<Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_Order_By>>;
  where?: InputMaybe<Image_Bool_Exp>;
};


export type Query_RootImage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_Order_By>>;
  where?: InputMaybe<Image_Bool_Exp>;
};


export type Query_RootImage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInvoice_StatusArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Status_Order_By>>;
  where?: InputMaybe<Invoice_Status_Bool_Exp>;
};


export type Query_RootInvoice_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Status_Order_By>>;
  where?: InputMaybe<Invoice_Status_Bool_Exp>;
};


export type Query_RootInvoice_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootLanguagesArgs = {
  distinct_on?: InputMaybe<Array<Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Languages_Order_By>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Query_RootLanguages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Languages_Order_By>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Query_RootLanguages_By_PkArgs = {
  language_id: Scalars['Int']['input'];
};


export type Query_RootLead_Property_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Lead_Property_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Property_Category_Order_By>>;
  where?: InputMaybe<Lead_Property_Category_Bool_Exp>;
};


export type Query_RootLead_Property_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Property_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Property_Category_Order_By>>;
  where?: InputMaybe<Lead_Property_Category_Bool_Exp>;
};


export type Query_RootLead_Property_Category_By_PkArgs = {
  category: Scalars['String']['input'];
};


export type Query_RootLead_StatusArgs = {
  distinct_on?: InputMaybe<Array<Lead_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Status_Order_By>>;
  where?: InputMaybe<Lead_Status_Bool_Exp>;
};


export type Query_RootLead_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Status_Order_By>>;
  where?: InputMaybe<Lead_Status_Bool_Exp>;
};


export type Query_RootLead_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootLead_TypeArgs = {
  distinct_on?: InputMaybe<Array<Lead_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Type_Order_By>>;
  where?: InputMaybe<Lead_Type_Bool_Exp>;
};


export type Query_RootLead_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Type_Order_By>>;
  where?: InputMaybe<Lead_Type_Bool_Exp>;
};


export type Query_RootLead_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootLeads_StatisticsArgs = {
  args: Leads_Statistics_Arguments;
  distinct_on?: InputMaybe<Array<Leads_Statistics_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Statistics_Model_Order_By>>;
  where?: InputMaybe<Leads_Statistics_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootLister_Claim_RequestArgs = {
  distinct_on?: InputMaybe<Array<Lister_Claim_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Claim_Request_Order_By>>;
  where?: InputMaybe<Lister_Claim_Request_Bool_Exp>;
};


export type Query_RootLister_Claim_Request_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Lister_Claim_Request_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Claim_Request_Activity_Order_By>>;
  where?: InputMaybe<Lister_Claim_Request_Activity_Bool_Exp>;
};


export type Query_RootLister_Claim_Request_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Claim_Request_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Claim_Request_Activity_Order_By>>;
  where?: InputMaybe<Lister_Claim_Request_Activity_Bool_Exp>;
};


export type Query_RootLister_Claim_Request_Activity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLister_Claim_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Claim_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Claim_Request_Order_By>>;
  where?: InputMaybe<Lister_Claim_Request_Bool_Exp>;
};


export type Query_RootLister_Claim_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLister_ContactArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Order_By>>;
  where?: InputMaybe<Lister_Contact_Bool_Exp>;
};


export type Query_RootLister_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Order_By>>;
  where?: InputMaybe<Lister_Contact_Bool_Exp>;
};


export type Query_RootLister_Contact_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLister_Contact_MeetingArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Meeting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Meeting_Order_By>>;
  where?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
};


export type Query_RootLister_Contact_Meeting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Meeting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Meeting_Order_By>>;
  where?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
};


export type Query_RootLister_Contact_Meeting_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLister_Contact_SourceArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Source_Order_By>>;
  where?: InputMaybe<Lister_Contact_Source_Bool_Exp>;
};


export type Query_RootLister_Contact_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Source_Order_By>>;
  where?: InputMaybe<Lister_Contact_Source_Bool_Exp>;
};


export type Query_RootLister_Contact_Source_By_PkArgs = {
  source: Scalars['String']['input'];
};


export type Query_RootLister_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Lister_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Leads_Order_By>>;
  where?: InputMaybe<Lister_Leads_Bool_Exp>;
};


export type Query_RootLister_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Leads_Order_By>>;
  where?: InputMaybe<Lister_Leads_Bool_Exp>;
};


export type Query_RootLister_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLister_MeetingArgs = {
  distinct_on?: InputMaybe<Array<Lister_Meeting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Meeting_Order_By>>;
  where?: InputMaybe<Lister_Meeting_Bool_Exp>;
};


export type Query_RootLister_Meeting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Meeting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Meeting_Order_By>>;
  where?: InputMaybe<Lister_Meeting_Bool_Exp>;
};


export type Query_RootLister_Meeting_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLister_RoleArgs = {
  distinct_on?: InputMaybe<Array<Lister_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Role_Order_By>>;
  where?: InputMaybe<Lister_Role_Bool_Exp>;
};


export type Query_RootLister_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Role_Order_By>>;
  where?: InputMaybe<Lister_Role_Bool_Exp>;
};


export type Query_RootLister_Role_By_PkArgs = {
  role: Scalars['String']['input'];
};


export type Query_RootLocationArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Query_RootLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Query_RootLocation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLocation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Location_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Type_Order_By>>;
  where?: InputMaybe<Location_Type_Bool_Exp>;
};


export type Query_RootLocation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Type_Order_By>>;
  where?: InputMaybe<Location_Type_Bool_Exp>;
};


export type Query_RootLocation_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootMain_CurrencyArgs = {
  distinct_on?: InputMaybe<Array<Main_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Main_Currency_Order_By>>;
  where?: InputMaybe<Main_Currency_Bool_Exp>;
};


export type Query_RootMain_Currency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Main_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Main_Currency_Order_By>>;
  where?: InputMaybe<Main_Currency_Bool_Exp>;
};


export type Query_RootMain_Currency_By_PkArgs = {
  currency: Scalars['String']['input'];
};


export type Query_RootNatural_Language_QueriesArgs = {
  distinct_on?: InputMaybe<Array<Natural_Language_Queries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Natural_Language_Queries_Order_By>>;
  where?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
};


export type Query_RootNatural_Language_Queries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Natural_Language_Queries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Natural_Language_Queries_Order_By>>;
  where?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
};


export type Query_RootNatural_Language_Queries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootNotificationArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Query_RootNotification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Query_RootNotification_AmenitiesArgs = {
  distinct_on?: InputMaybe<Array<Notification_Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Amenities_Order_By>>;
  where?: InputMaybe<Notification_Amenities_Bool_Exp>;
};


export type Query_RootNotification_Amenities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Amenities_Order_By>>;
  where?: InputMaybe<Notification_Amenities_Bool_Exp>;
};


export type Query_RootNotification_Amenities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootNotification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootNotification_FeatureArgs = {
  distinct_on?: InputMaybe<Array<Notification_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Feature_Order_By>>;
  where?: InputMaybe<Notification_Feature_Bool_Exp>;
};


export type Query_RootNotification_Feature_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Feature_Order_By>>;
  where?: InputMaybe<Notification_Feature_Bool_Exp>;
};


export type Query_RootNotification_Feature_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootNotification_Property_TypeArgs = {
  distinct_on?: InputMaybe<Array<Notification_Property_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Property_Type_Order_By>>;
  where?: InputMaybe<Notification_Property_Type_Bool_Exp>;
};


export type Query_RootNotification_Property_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Property_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Property_Type_Order_By>>;
  where?: InputMaybe<Notification_Property_Type_Bool_Exp>;
};


export type Query_RootNotification_Property_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootNotification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Type_Order_By>>;
  where?: InputMaybe<Notification_Type_Bool_Exp>;
};


export type Query_RootNotification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Type_Order_By>>;
  where?: InputMaybe<Notification_Type_Bool_Exp>;
};


export type Query_RootNotification_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrder_StatusArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Status_Order_By>>;
  where?: InputMaybe<Order_Status_Bool_Exp>;
};


export type Query_RootOrder_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Status_Order_By>>;
  where?: InputMaybe<Order_Status_Bool_Exp>;
};


export type Query_RootOrder_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganizationDashboardStatisticsArgs = {
  args: OrganizationDashboardStatistics_Arguments;
  distinct_on?: InputMaybe<Array<Lister_Dashboard_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Dashboard_Model_Order_By>>;
  where?: InputMaybe<Lister_Dashboard_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootOrganizationViewsGraphicArgs = {
  args: OrganizationViewsGraphic_Arguments;
  distinct_on?: InputMaybe<Array<Daily_Views_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Views_Order_By>>;
  where?: InputMaybe<Daily_Views_Bool_Exp_Bool_Exp>;
};


export type Query_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganization_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_Lead_LocationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Lead_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Lead_Location_Order_By>>;
  where?: InputMaybe<Organization_Lead_Location_Bool_Exp>;
};


export type Query_RootOrganization_Lead_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Lead_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Lead_Location_Order_By>>;
  where?: InputMaybe<Organization_Lead_Location_Bool_Exp>;
};


export type Query_RootOrganization_Lead_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_Lead_PropertyArgs = {
  distinct_on?: InputMaybe<Array<Organization_Lead_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Lead_Property_Order_By>>;
  where?: InputMaybe<Organization_Lead_Property_Bool_Exp>;
};


export type Query_RootOrganization_Lead_Property_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Lead_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Lead_Property_Order_By>>;
  where?: InputMaybe<Organization_Lead_Property_Bool_Exp>;
};


export type Query_RootOrganization_Lead_Property_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Leads_Order_By>>;
  where?: InputMaybe<Organization_Leads_Bool_Exp>;
};


export type Query_RootOrganization_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Leads_Order_By>>;
  where?: InputMaybe<Organization_Leads_Bool_Exp>;
};


export type Query_RootOrganization_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_RoleArgs = {
  distinct_on?: InputMaybe<Array<Organization_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Role_Order_By>>;
  where?: InputMaybe<Organization_Role_Bool_Exp>;
};


export type Query_RootOrganization_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Role_Order_By>>;
  where?: InputMaybe<Organization_Role_Bool_Exp>;
};


export type Query_RootOrganization_Role_By_PkArgs = {
  role: Scalars['String']['input'];
};


export type Query_RootOrganization_StatusArgs = {
  distinct_on?: InputMaybe<Array<Organization_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Status_Order_By>>;
  where?: InputMaybe<Organization_Status_Bool_Exp>;
};


export type Query_RootOrganization_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Status_Order_By>>;
  where?: InputMaybe<Organization_Status_Bool_Exp>;
};


export type Query_RootOrganization_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootOrganization_Telegram_Agent_LinkArgs = {
  distinct_on?: InputMaybe<Array<Organization_Telegram_Agent_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Telegram_Agent_Link_Order_By>>;
  where?: InputMaybe<Organization_Telegram_Agent_Link_Bool_Exp>;
};


export type Query_RootOrganization_Telegram_Agent_Link_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Telegram_Agent_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Telegram_Agent_Link_Order_By>>;
  where?: InputMaybe<Organization_Telegram_Agent_Link_Bool_Exp>;
};


export type Query_RootOrganization_Telegram_Agent_Link_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organization_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Type_Order_By>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Query_RootOrganization_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Type_Order_By>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Query_RootOrganization_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootOrganization_Whatsapp_Ai_AllowlistArgs = {
  distinct_on?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Order_By>>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>;
};


export type Query_RootOrganization_Whatsapp_Ai_Allowlist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Order_By>>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>;
};


export type Query_RootOrganization_Whatsapp_Ai_Allowlist_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_Whatsapp_Ai_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Organization_Whatsapp_Ai_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Whatsapp_Ai_Config_Order_By>>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Config_Bool_Exp>;
};


export type Query_RootOrganization_Whatsapp_Ai_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Whatsapp_Ai_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Whatsapp_Ai_Config_Order_By>>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Config_Bool_Exp>;
};


export type Query_RootOrganization_Whatsapp_Ai_Config_By_PkArgs = {
  organization_id: Scalars['uuid']['input'];
};


export type Query_RootParking_TypeArgs = {
  distinct_on?: InputMaybe<Array<Parking_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Type_Order_By>>;
  where?: InputMaybe<Parking_Type_Bool_Exp>;
};


export type Query_RootParking_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Type_Order_By>>;
  where?: InputMaybe<Parking_Type_Bool_Exp>;
};


export type Query_RootParking_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootPhone_Number_TypeArgs = {
  distinct_on?: InputMaybe<Array<Phone_Number_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Number_Type_Order_By>>;
  where?: InputMaybe<Phone_Number_Type_Bool_Exp>;
};


export type Query_RootPhone_Number_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Number_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Number_Type_Order_By>>;
  where?: InputMaybe<Phone_Number_Type_Bool_Exp>;
};


export type Query_RootPhone_Number_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootPlace_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Order_By>>;
  where?: InputMaybe<Place_Reference_Bool_Exp>;
};


export type Query_RootPlace_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Order_By>>;
  where?: InputMaybe<Place_Reference_Bool_Exp>;
};


export type Query_RootPlace_Reference_AliasArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Alias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Alias_Order_By>>;
  where?: InputMaybe<Place_Reference_Alias_Bool_Exp>;
};


export type Query_RootPlace_Reference_Alias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Alias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Alias_Order_By>>;
  where?: InputMaybe<Place_Reference_Alias_Bool_Exp>;
};


export type Query_RootPlace_Reference_Alias_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPlace_Reference_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPlace_Reference_ProposalArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Proposal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Proposal_Order_By>>;
  where?: InputMaybe<Place_Reference_Proposal_Bool_Exp>;
};


export type Query_RootPlace_Reference_Proposal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Proposal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Proposal_Order_By>>;
  where?: InputMaybe<Place_Reference_Proposal_Bool_Exp>;
};


export type Query_RootPlace_Reference_Proposal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPlanArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Query_RootPlan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Query_RootPlan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPlan_TypeArgs = {
  distinct_on?: InputMaybe<Array<Plan_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Type_Order_By>>;
  where?: InputMaybe<Plan_Type_Bool_Exp>;
};


export type Query_RootPlan_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Type_Order_By>>;
  where?: InputMaybe<Plan_Type_Bool_Exp>;
};


export type Query_RootPlan_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_PurchaseArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


export type Query_RootProduct_Purchase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


export type Query_RootProduct_Purchase_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_TypeArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Query_RootProduct_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Query_RootProduct_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootPropertyArgs = {
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


export type Query_RootPropertyDailyViewsArgs = {
  args: PropertyDailyViews_Arguments;
  distinct_on?: InputMaybe<Array<Property_Views_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Views_Model_Order_By>>;
  where?: InputMaybe<Property_Views_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootPropertyTypesDistributionArgs = {
  distinct_on?: InputMaybe<Array<Property_Types_Distribution_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Types_Distribution_Model_Order_By>>;
  where?: InputMaybe<Property_Types_Distribution_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootProperty_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


export type Query_RootProperty_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_ClusterArgs = {
  distinct_on?: InputMaybe<Array<Property_Cluster_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Cluster_Order_By>>;
  where?: InputMaybe<Property_Cluster_Bool_Exp>;
};


export type Query_RootProperty_Cluster_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Cluster_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Cluster_Order_By>>;
  where?: InputMaybe<Property_Cluster_Bool_Exp>;
};


export type Query_RootProperty_Cluster_By_PkArgs = {
  cluster: Scalars['String']['input'];
};


export type Query_RootProperty_CompositionArgs = {
  distinct_on?: InputMaybe<Array<Property_Composition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Composition_Order_By>>;
  where?: InputMaybe<Property_Composition_Bool_Exp>;
};


export type Query_RootProperty_Composition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Composition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Composition_Order_By>>;
  where?: InputMaybe<Property_Composition_Bool_Exp>;
};


export type Query_RootProperty_Composition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_FeatureArgs = {
  distinct_on?: InputMaybe<Array<Property_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Feature_Order_By>>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};


export type Query_RootProperty_Feature_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Feature_Order_By>>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};


export type Query_RootProperty_Feature_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_FolderArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Order_By>>;
  where?: InputMaybe<Property_Folder_Bool_Exp>;
};


export type Query_RootProperty_Folder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Order_By>>;
  where?: InputMaybe<Property_Folder_Bool_Exp>;
};


export type Query_RootProperty_Folder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Folder_Public_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Folder_Public_Profile_FaqArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Faq_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_Faq_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Faq_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_Faq_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Folder_Public_Profile_HighlightArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Highlight_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_Highlight_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Highlight_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_Highlight_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Folder_Public_Profile_Listing_ExampleArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_Listing_Example_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_Listing_Example_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Folder_Public_Profile_Nearby_PlaceArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_Nearby_Place_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_Nearby_Place_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Folder_Public_Profile_RelatedArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Related_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_Related_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Related_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_Related_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Folder_Public_Profile_TranslationArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Translation_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_Translation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Translation_Bool_Exp>;
};


export type Query_RootProperty_Folder_Public_Profile_Translation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_ImageArgs = {
  distinct_on?: InputMaybe<Array<Property_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Image_Order_By>>;
  where?: InputMaybe<Property_Image_Bool_Exp>;
};


export type Query_RootProperty_Image_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Image_Order_By>>;
  where?: InputMaybe<Property_Image_Bool_Exp>;
};


export type Query_RootProperty_Image_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_ListArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


export type Query_RootProperty_List_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Activity_Order_By>>;
  where?: InputMaybe<Property_List_Activity_Bool_Exp>;
};


export type Query_RootProperty_List_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Activity_Order_By>>;
  where?: InputMaybe<Property_List_Activity_Bool_Exp>;
};


export type Query_RootProperty_List_Activity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


export type Query_RootProperty_List_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_List_FolderArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Folder_Order_By>>;
  where?: InputMaybe<Property_List_Folder_Bool_Exp>;
};


export type Query_RootProperty_List_Folder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Folder_Order_By>>;
  where?: InputMaybe<Property_List_Folder_Bool_Exp>;
};


export type Query_RootProperty_List_Folder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_List_ReportArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Report_Order_By>>;
  where?: InputMaybe<Property_List_Report_Bool_Exp>;
};


export type Query_RootProperty_List_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Report_Order_By>>;
  where?: InputMaybe<Property_List_Report_Bool_Exp>;
};


export type Query_RootProperty_List_Report_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_OriginArgs = {
  distinct_on?: InputMaybe<Array<Property_Origin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Origin_Order_By>>;
  where?: InputMaybe<Property_Origin_Bool_Exp>;
};


export type Query_RootProperty_Origin_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Origin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Origin_Order_By>>;
  where?: InputMaybe<Property_Origin_Bool_Exp>;
};


export type Query_RootProperty_Origin_By_PkArgs = {
  origin: Scalars['String']['input'];
};


export type Query_RootProperty_Origin_TypeArgs = {
  distinct_on?: InputMaybe<Array<Property_Origin_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Origin_Type_Order_By>>;
  where?: InputMaybe<Property_Origin_Type_Bool_Exp>;
};


export type Query_RootProperty_Origin_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Origin_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Origin_Type_Order_By>>;
  where?: InputMaybe<Property_Origin_Type_Bool_Exp>;
};


export type Query_RootProperty_Origin_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootProperty_OwnerArgs = {
  distinct_on?: InputMaybe<Array<Property_Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Owner_Order_By>>;
  where?: InputMaybe<Property_Owner_Bool_Exp>;
};


export type Query_RootProperty_Owner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Owner_Order_By>>;
  where?: InputMaybe<Property_Owner_Bool_Exp>;
};


export type Query_RootProperty_Owner_By_PkArgs = {
  owner: Scalars['String']['input'];
};


export type Query_RootProperty_Place_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<Property_Place_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Place_Reference_Order_By>>;
  where?: InputMaybe<Property_Place_Reference_Bool_Exp>;
};


export type Query_RootProperty_Place_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Place_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Place_Reference_Order_By>>;
  where?: InputMaybe<Property_Place_Reference_Bool_Exp>;
};


export type Query_RootProperty_Place_Reference_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Price_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Property_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Price_History_Order_By>>;
  where?: InputMaybe<Property_Price_History_Bool_Exp>;
};


export type Query_RootProperty_Price_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Price_History_Order_By>>;
  where?: InputMaybe<Property_Price_History_Bool_Exp>;
};


export type Query_RootProperty_Price_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Report_TypeArgs = {
  distinct_on?: InputMaybe<Array<Property_Report_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Report_Type_Order_By>>;
  where?: InputMaybe<Property_Report_Type_Bool_Exp>;
};


export type Query_RootProperty_Report_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Report_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Report_Type_Order_By>>;
  where?: InputMaybe<Property_Report_Type_Bool_Exp>;
};


export type Query_RootProperty_Report_Type_By_PkArgs = {
  report_type: Scalars['String']['input'];
};


export type Query_RootProperty_SourceArgs = {
  distinct_on?: InputMaybe<Array<Property_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Source_Order_By>>;
  where?: InputMaybe<Property_Source_Bool_Exp>;
};


export type Query_RootProperty_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Source_Order_By>>;
  where?: InputMaybe<Property_Source_Bool_Exp>;
};


export type Query_RootProperty_Source_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_StatusArgs = {
  distinct_on?: InputMaybe<Array<Property_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Status_Order_By>>;
  where?: InputMaybe<Property_Status_Bool_Exp>;
};


export type Query_RootProperty_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Status_Order_By>>;
  where?: InputMaybe<Property_Status_Bool_Exp>;
};


export type Query_RootProperty_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootProperty_TypeArgs = {
  distinct_on?: InputMaybe<Array<Property_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Type_Order_By>>;
  where?: InputMaybe<Property_Type_Bool_Exp>;
};


export type Query_RootProperty_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Type_Order_By>>;
  where?: InputMaybe<Property_Type_Bool_Exp>;
};


export type Query_RootProperty_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootProperty_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Property_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Views_Order_By>>;
  where?: InputMaybe<Property_Views_Bool_Exp>;
};


export type Query_RootProperty_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Views_Order_By>>;
  where?: InputMaybe<Property_Views_Bool_Exp>;
};


export type Query_RootProperty_Views_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQueries_Property_ResultArgs = {
  distinct_on?: InputMaybe<Array<Queries_Property_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queries_Property_Result_Order_By>>;
  where?: InputMaybe<Queries_Property_Result_Bool_Exp>;
};


export type Query_RootQueries_Property_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queries_Property_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queries_Property_Result_Order_By>>;
  where?: InputMaybe<Queries_Property_Result_Bool_Exp>;
};


export type Query_RootQueries_Property_Result_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQueries_Property_Result_ReArgs = {
  distinct_on?: InputMaybe<Array<Queries_Property_Result_Re_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queries_Property_Result_Re_Order_By>>;
  where?: InputMaybe<Queries_Property_Result_Re_Bool_Exp>;
};


export type Query_RootQueries_Property_Result_Re_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queries_Property_Result_Re_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queries_Property_Result_Re_Order_By>>;
  where?: InputMaybe<Queries_Property_Result_Re_Bool_Exp>;
};


export type Query_RootQueries_Property_Result_Re_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuery_ClassificationArgs = {
  distinct_on?: InputMaybe<Array<Query_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Query_Classification_Order_By>>;
  where?: InputMaybe<Query_Classification_Bool_Exp>;
};


export type Query_RootQuery_Classification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Query_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Query_Classification_Order_By>>;
  where?: InputMaybe<Query_Classification_Bool_Exp>;
};


export type Query_RootQuery_Classification_By_PkArgs = {
  class: Scalars['String']['input'];
};


export type Query_RootQuery_Classification_ReArgs = {
  distinct_on?: InputMaybe<Array<Query_Classification_Re_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Query_Classification_Re_Order_By>>;
  where?: InputMaybe<Query_Classification_Re_Bool_Exp>;
};


export type Query_RootQuery_Classification_Re_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Query_Classification_Re_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Query_Classification_Re_Order_By>>;
  where?: InputMaybe<Query_Classification_Re_Bool_Exp>;
};


export type Query_RootQuery_Classification_Re_By_PkArgs = {
  class: Scalars['String']['input'];
};


export type Query_RootRaw_LocationArgs = {
  distinct_on?: InputMaybe<Array<Raw_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Raw_Location_Order_By>>;
  where?: InputMaybe<Raw_Location_Bool_Exp>;
};


export type Query_RootRaw_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Raw_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Raw_Location_Order_By>>;
  where?: InputMaybe<Raw_Location_Bool_Exp>;
};


export type Query_RootRaw_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRedirectArgs = {
  distinct_on?: InputMaybe<Array<Redirect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Redirect_Order_By>>;
  where?: InputMaybe<Redirect_Bool_Exp>;
};


export type Query_RootRedirect_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Redirect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Redirect_Order_By>>;
  where?: InputMaybe<Redirect_Bool_Exp>;
};


export type Query_RootRedirect_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReference_Price_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Reference_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reference_Price_History_Order_By>>;
  where?: InputMaybe<Reference_Price_History_Bool_Exp>;
};


export type Query_RootReference_Price_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reference_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reference_Price_History_Order_By>>;
  where?: InputMaybe<Reference_Price_History_Bool_Exp>;
};


export type Query_RootReference_Price_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReference_ZoneArgs = {
  distinct_on?: InputMaybe<Array<Reference_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reference_Zone_Order_By>>;
  where?: InputMaybe<Reference_Zone_Bool_Exp>;
};


export type Query_RootReference_Zone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reference_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reference_Zone_Order_By>>;
  where?: InputMaybe<Reference_Zone_Bool_Exp>;
};


export type Query_RootReference_Zone_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRegionalPropertyDistributionArgs = {
  args: RegionalPropertyDistribution_Arguments;
  distinct_on?: InputMaybe<Array<Regional_Property_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Regional_Property_Model_Order_By>>;
  where?: InputMaybe<Regional_Property_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootSearch_ContextArgs = {
  distinct_on?: InputMaybe<Array<Search_Context_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Context_Order_By>>;
  where?: InputMaybe<Search_Context_Bool_Exp>;
};


export type Query_RootSearch_Context_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Context_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Context_Order_By>>;
  where?: InputMaybe<Search_Context_Bool_Exp>;
};


export type Query_RootSearch_Context_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSearch_Context_LocationArgs = {
  distinct_on?: InputMaybe<Array<Search_Context_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Context_Location_Order_By>>;
  where?: InputMaybe<Search_Context_Location_Bool_Exp>;
};


export type Query_RootSearch_Context_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Context_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Context_Location_Order_By>>;
  where?: InputMaybe<Search_Context_Location_Bool_Exp>;
};


export type Query_RootSearch_Context_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSearch_DomainArgs = {
  distinct_on?: InputMaybe<Array<Search_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Domain_Order_By>>;
  where?: InputMaybe<Search_Domain_Bool_Exp>;
};


export type Query_RootSearch_Domain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Domain_Order_By>>;
  where?: InputMaybe<Search_Domain_Bool_Exp>;
};


export type Query_RootSearch_Domain_By_PkArgs = {
  domain: Scalars['String']['input'];
};


export type Query_RootSearch_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


export type Query_RootSearch_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


export type Query_RootSearch_Sessions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSearch_Sessions_Sorted_By_Last_QueryArgs = {
  args: Search_Sessions_Sorted_By_Last_Query_Args;
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


export type Query_RootSearch_Sessions_Sorted_By_Last_Query_AggregateArgs = {
  args: Search_Sessions_Sorted_By_Last_Query_Args;
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


export type Query_RootSearch_SlugsArgs = {
  distinct_on?: InputMaybe<Array<Search_Slugs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Slugs_Order_By>>;
  where?: InputMaybe<Search_Slugs_Bool_Exp>;
};


export type Query_RootSearch_Slugs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Slugs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Slugs_Order_By>>;
  where?: InputMaybe<Search_Slugs_Bool_Exp>;
};


export type Query_RootSearch_Slugs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSeo_CityArgs = {
  distinct_on?: InputMaybe<Array<Seo_City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seo_City_Order_By>>;
  where?: InputMaybe<Seo_City_Bool_Exp>;
};


export type Query_RootSeo_City_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seo_City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seo_City_Order_By>>;
  where?: InputMaybe<Seo_City_Bool_Exp>;
};


export type Query_RootSeo_City_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSession_OriginArgs = {
  distinct_on?: InputMaybe<Array<Session_Origin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_Origin_Order_By>>;
  where?: InputMaybe<Session_Origin_Bool_Exp>;
};


export type Query_RootSession_Origin_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Session_Origin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_Origin_Order_By>>;
  where?: InputMaybe<Session_Origin_Bool_Exp>;
};


export type Query_RootSession_Origin_By_PkArgs = {
  origin: Scalars['String']['input'];
};


export type Query_RootSponsored_Property_ListArgs = {
  distinct_on?: InputMaybe<Array<Sponsored_Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sponsored_Property_List_Order_By>>;
  where?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
};


export type Query_RootSponsored_Property_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsored_Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sponsored_Property_List_Order_By>>;
  where?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
};


export type Query_RootSponsored_Property_List_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Order_By>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};


export type Query_RootSubscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Order_By>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};


export type Query_RootSubscription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSubscription_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Invoice_Order_By>>;
  where?: InputMaybe<Subscription_Invoice_Bool_Exp>;
};


export type Query_RootSubscription_Invoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Invoice_Order_By>>;
  where?: InputMaybe<Subscription_Invoice_Bool_Exp>;
};


export type Query_RootSubscription_Invoice_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSubscription_SourceArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Source_Order_By>>;
  where?: InputMaybe<Subscription_Source_Bool_Exp>;
};


export type Query_RootSubscription_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Source_Order_By>>;
  where?: InputMaybe<Subscription_Source_Bool_Exp>;
};


export type Query_RootSubscription_Source_By_PkArgs = {
  source: Scalars['String']['input'];
};


export type Query_RootSubscription_StatusArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Status_Order_By>>;
  where?: InputMaybe<Subscription_Status_Bool_Exp>;
};


export type Query_RootSubscription_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Status_Order_By>>;
  where?: InputMaybe<Subscription_Status_Bool_Exp>;
};


export type Query_RootSubscription_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootText_ContentArgs = {
  distinct_on?: InputMaybe<Array<Text_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Text_Content_Order_By>>;
  where?: InputMaybe<Text_Content_Bool_Exp>;
};


export type Query_RootText_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Text_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Text_Content_Order_By>>;
  where?: InputMaybe<Text_Content_Bool_Exp>;
};


export type Query_RootText_Content_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTranslationsArgs = {
  distinct_on?: InputMaybe<Array<Translations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translations_Order_By>>;
  where?: InputMaybe<Translations_Bool_Exp>;
};


export type Query_RootTranslations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Translations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translations_Order_By>>;
  where?: InputMaybe<Translations_Bool_Exp>;
};


export type Query_RootTranslations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUrl_SlugArgs = {
  distinct_on?: InputMaybe<Array<Url_Slug_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Url_Slug_Order_By>>;
  where?: InputMaybe<Url_Slug_Bool_Exp>;
};


export type Query_RootUrl_Slug_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Url_Slug_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Url_Slug_Order_By>>;
  where?: InputMaybe<Url_Slug_Bool_Exp>;
};


export type Query_RootUrl_Slug_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUserArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_FiltersArgs = {
  distinct_on?: InputMaybe<Array<User_Filters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Filters_Order_By>>;
  where?: InputMaybe<User_Filters_Bool_Exp>;
};


export type Query_RootUser_Filters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Filters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Filters_Order_By>>;
  where?: InputMaybe<User_Filters_Bool_Exp>;
};


export type Query_RootUser_Filters_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Filters_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<User_Filters_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Filters_Features_Order_By>>;
  where?: InputMaybe<User_Filters_Features_Bool_Exp>;
};


export type Query_RootUser_Filters_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Filters_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Filters_Features_Order_By>>;
  where?: InputMaybe<User_Filters_Features_Bool_Exp>;
};


export type Query_RootUser_Filters_Features_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_OrganizationArgs = {
  distinct_on?: InputMaybe<Array<User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Organization_Order_By>>;
  where?: InputMaybe<User_Organization_Bool_Exp>;
};


export type Query_RootUser_Organization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Organization_Order_By>>;
  where?: InputMaybe<User_Organization_Bool_Exp>;
};


export type Query_RootUser_Organization_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<User_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Preferences_Order_By>>;
  where?: InputMaybe<User_Preferences_Bool_Exp>;
};


export type Query_RootUser_Preferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Preferences_Order_By>>;
  where?: InputMaybe<User_Preferences_Bool_Exp>;
};


export type Query_RootUser_Preferences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Property_NotifiationArgs = {
  distinct_on?: InputMaybe<Array<User_Property_Notifiation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Property_Notifiation_Order_By>>;
  where?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
};


export type Query_RootUser_Property_Notifiation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Property_Notifiation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Property_Notifiation_Order_By>>;
  where?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
};


export type Query_RootUser_Property_Notifiation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Saved_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<User_Saved_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Saved_Properties_Order_By>>;
  where?: InputMaybe<User_Saved_Properties_Bool_Exp>;
};


export type Query_RootUser_Saved_Properties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Saved_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Saved_Properties_Order_By>>;
  where?: InputMaybe<User_Saved_Properties_Bool_Exp>;
};


export type Query_RootUser_Saved_Properties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Seen_PropertyArgs = {
  distinct_on?: InputMaybe<Array<User_Seen_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Seen_Property_Order_By>>;
  where?: InputMaybe<User_Seen_Property_Bool_Exp>;
};


export type Query_RootUser_Seen_Property_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Seen_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Seen_Property_Order_By>>;
  where?: InputMaybe<User_Seen_Property_Bool_Exp>;
};


export type Query_RootUser_Seen_Property_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_Activity_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Users_Activity_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Activity_Summary_Order_By>>;
  where?: InputMaybe<Users_Activity_Summary_Bool_Exp>;
};


export type Query_RootUsers_Activity_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Activity_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Activity_Summary_Order_By>>;
  where?: InputMaybe<Users_Activity_Summary_Bool_Exp>;
};


export type Query_RootUsers_Activity_Summary_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Query_RootVirusArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Query_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Query_RootVisibility_StatusArgs = {
  distinct_on?: InputMaybe<Array<Visibility_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visibility_Status_Order_By>>;
  where?: InputMaybe<Visibility_Status_Bool_Exp>;
};


export type Query_RootVisibility_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visibility_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visibility_Status_Order_By>>;
  where?: InputMaybe<Visibility_Status_Bool_Exp>;
};


export type Query_RootVisibility_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootWhatsapp_Ai_Inbound_MessageArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Inbound_Message_Bool_Exp>;
};


export type Query_RootWhatsapp_Ai_Inbound_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Inbound_Message_Bool_Exp>;
};


export type Query_RootWhatsapp_Ai_Inbound_Message_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWhatsapp_Ai_Outbox_PartArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


export type Query_RootWhatsapp_Ai_Outbox_Part_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


export type Query_RootWhatsapp_Ai_Outbox_Part_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWhatsapp_Ai_TurnArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Turn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Turn_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
};


export type Query_RootWhatsapp_Ai_Turn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Turn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Turn_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
};


export type Query_RootWhatsapp_Ai_Turn_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWhatsapp_ChatArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Chat_Order_By>>;
  where?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
};


export type Query_RootWhatsapp_Chat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Chat_Order_By>>;
  where?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
};


export type Query_RootWhatsapp_Chat_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWhatsapp_HumanArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Human_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Human_Order_By>>;
  where?: InputMaybe<Whatsapp_Human_Bool_Exp>;
};


export type Query_RootWhatsapp_Human_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Human_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Human_Order_By>>;
  where?: InputMaybe<Whatsapp_Human_Bool_Exp>;
};


export type Query_RootWhatsapp_Human_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootZone_ContainsArgs = {
  distinct_on?: InputMaybe<Array<Zone_Contains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Contains_Order_By>>;
  where?: InputMaybe<Zone_Contains_Bool_Exp>;
};


export type Query_RootZone_Contains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Zone_Contains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Contains_Order_By>>;
  where?: InputMaybe<Zone_Contains_Bool_Exp>;
};


export type Query_RootZone_Contains_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootZone_Data_MethodArgs = {
  distinct_on?: InputMaybe<Array<Zone_Data_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Data_Method_Order_By>>;
  where?: InputMaybe<Zone_Data_Method_Bool_Exp>;
};


export type Query_RootZone_Data_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Zone_Data_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Data_Method_Order_By>>;
  where?: InputMaybe<Zone_Data_Method_Bool_Exp>;
};


export type Query_RootZone_Data_Method_By_PkArgs = {
  method: Scalars['String']['input'];
};

/** location as it is published,raw */
export type Raw_Location = {
  __typename?: 'raw_location';
  created_at: Scalars['timestamptz']['output'];
  extracted_locations?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  raw_property_id?: Maybe<Scalars['String']['output']>;
  task_id?: Maybe<Scalars['String']['output']>;
};


/** location as it is published,raw */
export type Raw_LocationExtracted_LocationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "raw_location" */
export type Raw_Location_Aggregate = {
  __typename?: 'raw_location_aggregate';
  aggregate?: Maybe<Raw_Location_Aggregate_Fields>;
  nodes: Array<Raw_Location>;
};

/** aggregate fields of "raw_location" */
export type Raw_Location_Aggregate_Fields = {
  __typename?: 'raw_location_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Raw_Location_Max_Fields>;
  min?: Maybe<Raw_Location_Min_Fields>;
};


/** aggregate fields of "raw_location" */
export type Raw_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Raw_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Raw_Location_Append_Input = {
  extracted_locations?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "raw_location". All fields are combined with a logical 'AND'. */
export type Raw_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Raw_Location_Bool_Exp>>;
  _not?: InputMaybe<Raw_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Raw_Location_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  extracted_locations?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  raw_property_id?: InputMaybe<String_Comparison_Exp>;
  task_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "raw_location" */
export enum Raw_Location_Constraint {
  /** unique or primary key constraint on columns "id" */
  RawLocationPkey = 'raw_location_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Raw_Location_Delete_At_Path_Input = {
  extracted_locations?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Raw_Location_Delete_Elem_Input = {
  extracted_locations?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Raw_Location_Delete_Key_Input = {
  extracted_locations?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "raw_location" */
export type Raw_Location_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  extracted_locations?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  raw_property_id?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Raw_Location_Max_Fields = {
  __typename?: 'raw_location_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  raw_property_id?: Maybe<Scalars['String']['output']>;
  task_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Raw_Location_Min_Fields = {
  __typename?: 'raw_location_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  raw_property_id?: Maybe<Scalars['String']['output']>;
  task_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "raw_location" */
export type Raw_Location_Mutation_Response = {
  __typename?: 'raw_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Raw_Location>;
};

/** on_conflict condition type for table "raw_location" */
export type Raw_Location_On_Conflict = {
  constraint: Raw_Location_Constraint;
  update_columns?: Array<Raw_Location_Update_Column>;
  where?: InputMaybe<Raw_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "raw_location". */
export type Raw_Location_Order_By = {
  created_at?: InputMaybe<Order_By>;
  extracted_locations?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  raw_property_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: raw_location */
export type Raw_Location_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Raw_Location_Prepend_Input = {
  extracted_locations?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "raw_location" */
export enum Raw_Location_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExtractedLocations = 'extracted_locations',
  /** column name */
  Id = 'id',
  /** column name */
  RawPropertyId = 'raw_property_id',
  /** column name */
  TaskId = 'task_id'
}

/** input type for updating data in table "raw_location" */
export type Raw_Location_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  extracted_locations?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  raw_property_id?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "raw_location" */
export type Raw_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Raw_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Raw_Location_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  extracted_locations?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  raw_property_id?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "raw_location" */
export enum Raw_Location_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExtractedLocations = 'extracted_locations',
  /** column name */
  Id = 'id',
  /** column name */
  RawPropertyId = 'raw_property_id',
  /** column name */
  TaskId = 'task_id'
}

export type Raw_Location_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Raw_Location_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Raw_Location_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Raw_Location_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Raw_Location_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Raw_Location_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Raw_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Raw_Location_Bool_Exp;
};

export type Rebuild_Zone_Contains_For_Zone_Args = {
  min_overlap?: InputMaybe<Scalars['float8']['input']>;
  source_label?: InputMaybe<Scalars['String']['input']>;
  zone_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Reconcile_Whatsapp_Ai_Outbox_Echo_Args = {
  p_evolution_instance?: InputMaybe<Scalars['String']['input']>;
  p_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  p_payload_match_hash?: InputMaybe<Scalars['String']['input']>;
  p_provider_message_id?: InputMaybe<Scalars['String']['input']>;
  p_provider_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  p_remote_identity_hash?: InputMaybe<Scalars['String']['input']>;
  p_window_seconds?: InputMaybe<Scalars['Int']['input']>;
};

export type Reconcile_Whatsapp_Ai_Outbox_Part_Args = {
  p_part_id?: InputMaybe<Scalars['uuid']['input']>;
  p_provider_message_id?: InputMaybe<Scalars['String']['input']>;
  p_resolution?: InputMaybe<Scalars['String']['input']>;
  p_worker_id?: InputMaybe<Scalars['String']['input']>;
};

export type Redact_Expired_Whatsapp_Ai_Inbound_Metadata_Args = {
  p_limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Redact_Expired_Whatsapp_Ai_Outbox_Payloads_Args = {
  p_limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Redact_Expired_Whatsapp_Ai_Turn_Metadata_Args = {
  p_limit?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "redirect" */
export type Redirect = {
  __typename?: 'redirect';
  from_url: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  redirect_type?: Maybe<Scalars['Int']['output']>;
  to_url: Scalars['String']['output'];
};

/** aggregated selection of "redirect" */
export type Redirect_Aggregate = {
  __typename?: 'redirect_aggregate';
  aggregate?: Maybe<Redirect_Aggregate_Fields>;
  nodes: Array<Redirect>;
};

/** aggregate fields of "redirect" */
export type Redirect_Aggregate_Fields = {
  __typename?: 'redirect_aggregate_fields';
  avg?: Maybe<Redirect_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Redirect_Max_Fields>;
  min?: Maybe<Redirect_Min_Fields>;
  stddev?: Maybe<Redirect_Stddev_Fields>;
  stddev_pop?: Maybe<Redirect_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Redirect_Stddev_Samp_Fields>;
  sum?: Maybe<Redirect_Sum_Fields>;
  var_pop?: Maybe<Redirect_Var_Pop_Fields>;
  var_samp?: Maybe<Redirect_Var_Samp_Fields>;
  variance?: Maybe<Redirect_Variance_Fields>;
};


/** aggregate fields of "redirect" */
export type Redirect_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Redirect_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Redirect_Avg_Fields = {
  __typename?: 'redirect_avg_fields';
  redirect_type?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "redirect". All fields are combined with a logical 'AND'. */
export type Redirect_Bool_Exp = {
  _and?: InputMaybe<Array<Redirect_Bool_Exp>>;
  _not?: InputMaybe<Redirect_Bool_Exp>;
  _or?: InputMaybe<Array<Redirect_Bool_Exp>>;
  from_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  redirect_type?: InputMaybe<Int_Comparison_Exp>;
  to_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "redirect" */
export enum Redirect_Constraint {
  /** unique or primary key constraint on columns "id" */
  RedirectPkey = 'redirect_pkey'
}

/** input type for incrementing numeric columns in table "redirect" */
export type Redirect_Inc_Input = {
  redirect_type?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "redirect" */
export type Redirect_Insert_Input = {
  from_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  redirect_type?: InputMaybe<Scalars['Int']['input']>;
  to_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Redirect_Max_Fields = {
  __typename?: 'redirect_max_fields';
  from_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  redirect_type?: Maybe<Scalars['Int']['output']>;
  to_url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Redirect_Min_Fields = {
  __typename?: 'redirect_min_fields';
  from_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  redirect_type?: Maybe<Scalars['Int']['output']>;
  to_url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "redirect" */
export type Redirect_Mutation_Response = {
  __typename?: 'redirect_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Redirect>;
};

/** on_conflict condition type for table "redirect" */
export type Redirect_On_Conflict = {
  constraint: Redirect_Constraint;
  update_columns?: Array<Redirect_Update_Column>;
  where?: InputMaybe<Redirect_Bool_Exp>;
};

/** Ordering options when selecting data from "redirect". */
export type Redirect_Order_By = {
  from_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  redirect_type?: InputMaybe<Order_By>;
  to_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: redirect */
export type Redirect_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "redirect" */
export enum Redirect_Select_Column {
  /** column name */
  FromUrl = 'from_url',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  RedirectType = 'redirect_type',
  /** column name */
  ToUrl = 'to_url'
}

/** input type for updating data in table "redirect" */
export type Redirect_Set_Input = {
  from_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  redirect_type?: InputMaybe<Scalars['Int']['input']>;
  to_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Redirect_Stddev_Fields = {
  __typename?: 'redirect_stddev_fields';
  redirect_type?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Redirect_Stddev_Pop_Fields = {
  __typename?: 'redirect_stddev_pop_fields';
  redirect_type?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Redirect_Stddev_Samp_Fields = {
  __typename?: 'redirect_stddev_samp_fields';
  redirect_type?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "redirect" */
export type Redirect_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Redirect_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Redirect_Stream_Cursor_Value_Input = {
  from_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  redirect_type?: InputMaybe<Scalars['Int']['input']>;
  to_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Redirect_Sum_Fields = {
  __typename?: 'redirect_sum_fields';
  redirect_type?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "redirect" */
export enum Redirect_Update_Column {
  /** column name */
  FromUrl = 'from_url',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  RedirectType = 'redirect_type',
  /** column name */
  ToUrl = 'to_url'
}

export type Redirect_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Redirect_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Redirect_Set_Input>;
  /** filter the rows which have to be updated */
  where: Redirect_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Redirect_Var_Pop_Fields = {
  __typename?: 'redirect_var_pop_fields';
  redirect_type?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Redirect_Var_Samp_Fields = {
  __typename?: 'redirect_var_samp_fields';
  redirect_type?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Redirect_Variance_Fields = {
  __typename?: 'redirect_variance_fields';
  redirect_type?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "reference_price_history" */
export type Reference_Price_History = {
  __typename?: 'reference_price_history';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  price_sqm2: Scalars['float8']['output'];
  reference_zone_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  year: Scalars['Int']['output'];
};

/** aggregated selection of "reference_price_history" */
export type Reference_Price_History_Aggregate = {
  __typename?: 'reference_price_history_aggregate';
  aggregate?: Maybe<Reference_Price_History_Aggregate_Fields>;
  nodes: Array<Reference_Price_History>;
};

export type Reference_Price_History_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Reference_Price_History_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Reference_Price_History_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Reference_Price_History_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Reference_Price_History_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Reference_Price_History_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Reference_Price_History_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Reference_Price_History_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Reference_Price_History_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Reference_Price_History_Aggregate_Bool_Exp_Var_Samp>;
};

export type Reference_Price_History_Aggregate_Bool_Exp_Avg = {
  arguments: Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reference_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reference_Price_History_Aggregate_Bool_Exp_Corr = {
  arguments: Reference_Price_History_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reference_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reference_Price_History_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Reference_Price_History_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reference_Price_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reference_Price_History_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Reference_Price_History_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Reference_Price_History_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reference_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reference_Price_History_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Reference_Price_History_Aggregate_Bool_Exp_Max = {
  arguments: Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reference_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reference_Price_History_Aggregate_Bool_Exp_Min = {
  arguments: Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reference_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reference_Price_History_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reference_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reference_Price_History_Aggregate_Bool_Exp_Sum = {
  arguments: Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reference_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Reference_Price_History_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reference_Price_History_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "reference_price_history" */
export type Reference_Price_History_Aggregate_Fields = {
  __typename?: 'reference_price_history_aggregate_fields';
  avg?: Maybe<Reference_Price_History_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Reference_Price_History_Max_Fields>;
  min?: Maybe<Reference_Price_History_Min_Fields>;
  stddev?: Maybe<Reference_Price_History_Stddev_Fields>;
  stddev_pop?: Maybe<Reference_Price_History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reference_Price_History_Stddev_Samp_Fields>;
  sum?: Maybe<Reference_Price_History_Sum_Fields>;
  var_pop?: Maybe<Reference_Price_History_Var_Pop_Fields>;
  var_samp?: Maybe<Reference_Price_History_Var_Samp_Fields>;
  variance?: Maybe<Reference_Price_History_Variance_Fields>;
};


/** aggregate fields of "reference_price_history" */
export type Reference_Price_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reference_Price_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reference_price_history" */
export type Reference_Price_History_Aggregate_Order_By = {
  avg?: InputMaybe<Reference_Price_History_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reference_Price_History_Max_Order_By>;
  min?: InputMaybe<Reference_Price_History_Min_Order_By>;
  stddev?: InputMaybe<Reference_Price_History_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reference_Price_History_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reference_Price_History_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reference_Price_History_Sum_Order_By>;
  var_pop?: InputMaybe<Reference_Price_History_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reference_Price_History_Var_Samp_Order_By>;
  variance?: InputMaybe<Reference_Price_History_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reference_price_history" */
export type Reference_Price_History_Arr_Rel_Insert_Input = {
  data: Array<Reference_Price_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reference_Price_History_On_Conflict>;
};

/** aggregate avg on columns */
export type Reference_Price_History_Avg_Fields = {
  __typename?: 'reference_price_history_avg_fields';
  price_sqm2?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "reference_price_history" */
export type Reference_Price_History_Avg_Order_By = {
  price_sqm2?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reference_price_history". All fields are combined with a logical 'AND'. */
export type Reference_Price_History_Bool_Exp = {
  _and?: InputMaybe<Array<Reference_Price_History_Bool_Exp>>;
  _not?: InputMaybe<Reference_Price_History_Bool_Exp>;
  _or?: InputMaybe<Array<Reference_Price_History_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  price_sqm2?: InputMaybe<Float8_Comparison_Exp>;
  reference_zone_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "reference_price_history" */
export enum Reference_Price_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReferencePriceHistoryPkey = 'reference_price_history_pkey',
  /** unique or primary key constraint on columns "year", "reference_zone_id" */
  ReferencePriceHistoryYearReferenceZoneIdKey = 'reference_price_history_year_reference_zone_id_key'
}

/** input type for incrementing numeric columns in table "reference_price_history" */
export type Reference_Price_History_Inc_Input = {
  price_sqm2?: InputMaybe<Scalars['float8']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "reference_price_history" */
export type Reference_Price_History_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price_sqm2?: InputMaybe<Scalars['float8']['input']>;
  reference_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Reference_Price_History_Max_Fields = {
  __typename?: 'reference_price_history_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  price_sqm2?: Maybe<Scalars['float8']['output']>;
  reference_zone_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "reference_price_history" */
export type Reference_Price_History_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price_sqm2?: InputMaybe<Order_By>;
  reference_zone_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reference_Price_History_Min_Fields = {
  __typename?: 'reference_price_history_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  price_sqm2?: Maybe<Scalars['float8']['output']>;
  reference_zone_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "reference_price_history" */
export type Reference_Price_History_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price_sqm2?: InputMaybe<Order_By>;
  reference_zone_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reference_price_history" */
export type Reference_Price_History_Mutation_Response = {
  __typename?: 'reference_price_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reference_Price_History>;
};

/** on_conflict condition type for table "reference_price_history" */
export type Reference_Price_History_On_Conflict = {
  constraint: Reference_Price_History_Constraint;
  update_columns?: Array<Reference_Price_History_Update_Column>;
  where?: InputMaybe<Reference_Price_History_Bool_Exp>;
};

/** Ordering options when selecting data from "reference_price_history". */
export type Reference_Price_History_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price_sqm2?: InputMaybe<Order_By>;
  reference_zone_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reference_price_history */
export type Reference_Price_History_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "reference_price_history" */
export enum Reference_Price_History_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PriceSqm2 = 'price_sqm2',
  /** column name */
  ReferenceZoneId = 'reference_zone_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Year = 'year'
}

/** select "reference_price_history_aggregate_bool_exp_avg_arguments_columns" columns of table "reference_price_history" */
export enum Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  PriceSqm2 = 'price_sqm2'
}

/** select "reference_price_history_aggregate_bool_exp_corr_arguments_columns" columns of table "reference_price_history" */
export enum Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  PriceSqm2 = 'price_sqm2'
}

/** select "reference_price_history_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "reference_price_history" */
export enum Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  PriceSqm2 = 'price_sqm2'
}

/** select "reference_price_history_aggregate_bool_exp_max_arguments_columns" columns of table "reference_price_history" */
export enum Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  PriceSqm2 = 'price_sqm2'
}

/** select "reference_price_history_aggregate_bool_exp_min_arguments_columns" columns of table "reference_price_history" */
export enum Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  PriceSqm2 = 'price_sqm2'
}

/** select "reference_price_history_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "reference_price_history" */
export enum Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  PriceSqm2 = 'price_sqm2'
}

/** select "reference_price_history_aggregate_bool_exp_sum_arguments_columns" columns of table "reference_price_history" */
export enum Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  PriceSqm2 = 'price_sqm2'
}

/** select "reference_price_history_aggregate_bool_exp_var_samp_arguments_columns" columns of table "reference_price_history" */
export enum Reference_Price_History_Select_Column_Reference_Price_History_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  PriceSqm2 = 'price_sqm2'
}

/** input type for updating data in table "reference_price_history" */
export type Reference_Price_History_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price_sqm2?: InputMaybe<Scalars['float8']['input']>;
  reference_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Reference_Price_History_Stddev_Fields = {
  __typename?: 'reference_price_history_stddev_fields';
  price_sqm2?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "reference_price_history" */
export type Reference_Price_History_Stddev_Order_By = {
  price_sqm2?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reference_Price_History_Stddev_Pop_Fields = {
  __typename?: 'reference_price_history_stddev_pop_fields';
  price_sqm2?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "reference_price_history" */
export type Reference_Price_History_Stddev_Pop_Order_By = {
  price_sqm2?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reference_Price_History_Stddev_Samp_Fields = {
  __typename?: 'reference_price_history_stddev_samp_fields';
  price_sqm2?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "reference_price_history" */
export type Reference_Price_History_Stddev_Samp_Order_By = {
  price_sqm2?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reference_price_history" */
export type Reference_Price_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reference_Price_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reference_Price_History_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price_sqm2?: InputMaybe<Scalars['float8']['input']>;
  reference_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Reference_Price_History_Sum_Fields = {
  __typename?: 'reference_price_history_sum_fields';
  price_sqm2?: Maybe<Scalars['float8']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "reference_price_history" */
export type Reference_Price_History_Sum_Order_By = {
  price_sqm2?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** update columns of table "reference_price_history" */
export enum Reference_Price_History_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PriceSqm2 = 'price_sqm2',
  /** column name */
  ReferenceZoneId = 'reference_zone_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Year = 'year'
}

export type Reference_Price_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reference_Price_History_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reference_Price_History_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reference_Price_History_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reference_Price_History_Var_Pop_Fields = {
  __typename?: 'reference_price_history_var_pop_fields';
  price_sqm2?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "reference_price_history" */
export type Reference_Price_History_Var_Pop_Order_By = {
  price_sqm2?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reference_Price_History_Var_Samp_Fields = {
  __typename?: 'reference_price_history_var_samp_fields';
  price_sqm2?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "reference_price_history" */
export type Reference_Price_History_Var_Samp_Order_By = {
  price_sqm2?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reference_Price_History_Variance_Fields = {
  __typename?: 'reference_price_history_variance_fields';
  price_sqm2?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "reference_price_history" */
export type Reference_Price_History_Variance_Order_By = {
  price_sqm2?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** columns and relationships of "reference_zone" */
export type Reference_Zone = {
  __typename?: 'reference_zone';
  bounds: Scalars['jsonb']['output'];
  /** An array relationship */
  children: Array<Reference_Zone>;
  /** An aggregate relationship */
  children_aggregate: Reference_Zone_Aggregate;
  city?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  geom: Scalars['geography']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  parent?: Maybe<Reference_Zone>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  reference_price_histories: Array<Reference_Price_History>;
  /** An aggregate relationship */
  reference_price_histories_aggregate: Reference_Price_History_Aggregate;
  /** An array relationship */
  search_slugs: Array<Search_Slugs>;
  /** An aggregate relationship */
  search_slugs_aggregate: Search_Slugs_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "reference_zone" */
export type Reference_ZoneBoundsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "reference_zone" */
export type Reference_ZoneChildrenArgs = {
  distinct_on?: InputMaybe<Array<Reference_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reference_Zone_Order_By>>;
  where?: InputMaybe<Reference_Zone_Bool_Exp>;
};


/** columns and relationships of "reference_zone" */
export type Reference_ZoneChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reference_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reference_Zone_Order_By>>;
  where?: InputMaybe<Reference_Zone_Bool_Exp>;
};


/** columns and relationships of "reference_zone" */
export type Reference_ZoneReference_Price_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Reference_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reference_Price_History_Order_By>>;
  where?: InputMaybe<Reference_Price_History_Bool_Exp>;
};


/** columns and relationships of "reference_zone" */
export type Reference_ZoneReference_Price_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reference_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reference_Price_History_Order_By>>;
  where?: InputMaybe<Reference_Price_History_Bool_Exp>;
};


/** columns and relationships of "reference_zone" */
export type Reference_ZoneSearch_SlugsArgs = {
  distinct_on?: InputMaybe<Array<Search_Slugs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Slugs_Order_By>>;
  where?: InputMaybe<Search_Slugs_Bool_Exp>;
};


/** columns and relationships of "reference_zone" */
export type Reference_ZoneSearch_Slugs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Slugs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Slugs_Order_By>>;
  where?: InputMaybe<Search_Slugs_Bool_Exp>;
};

/** aggregated selection of "reference_zone" */
export type Reference_Zone_Aggregate = {
  __typename?: 'reference_zone_aggregate';
  aggregate?: Maybe<Reference_Zone_Aggregate_Fields>;
  nodes: Array<Reference_Zone>;
};

export type Reference_Zone_Aggregate_Bool_Exp = {
  count?: InputMaybe<Reference_Zone_Aggregate_Bool_Exp_Count>;
};

export type Reference_Zone_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reference_Zone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reference_Zone_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reference_zone" */
export type Reference_Zone_Aggregate_Fields = {
  __typename?: 'reference_zone_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Reference_Zone_Max_Fields>;
  min?: Maybe<Reference_Zone_Min_Fields>;
};


/** aggregate fields of "reference_zone" */
export type Reference_Zone_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reference_Zone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reference_zone" */
export type Reference_Zone_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reference_Zone_Max_Order_By>;
  min?: InputMaybe<Reference_Zone_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Reference_Zone_Append_Input = {
  bounds?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "reference_zone" */
export type Reference_Zone_Arr_Rel_Insert_Input = {
  data: Array<Reference_Zone_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reference_Zone_On_Conflict>;
};

/** Boolean expression to filter rows from the table "reference_zone". All fields are combined with a logical 'AND'. */
export type Reference_Zone_Bool_Exp = {
  _and?: InputMaybe<Array<Reference_Zone_Bool_Exp>>;
  _not?: InputMaybe<Reference_Zone_Bool_Exp>;
  _or?: InputMaybe<Array<Reference_Zone_Bool_Exp>>;
  bounds?: InputMaybe<Jsonb_Comparison_Exp>;
  children?: InputMaybe<Reference_Zone_Bool_Exp>;
  children_aggregate?: InputMaybe<Reference_Zone_Aggregate_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  geom?: InputMaybe<Geography_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent?: InputMaybe<Reference_Zone_Bool_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  reference_price_histories?: InputMaybe<Reference_Price_History_Bool_Exp>;
  reference_price_histories_aggregate?: InputMaybe<Reference_Price_History_Aggregate_Bool_Exp>;
  search_slugs?: InputMaybe<Search_Slugs_Bool_Exp>;
  search_slugs_aggregate?: InputMaybe<Search_Slugs_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "reference_zone" */
export enum Reference_Zone_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReferenceZonePkey = 'reference_zone_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Reference_Zone_Delete_At_Path_Input = {
  bounds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Reference_Zone_Delete_Elem_Input = {
  bounds?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Reference_Zone_Delete_Key_Input = {
  bounds?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "reference_zone" */
export type Reference_Zone_Insert_Input = {
  bounds?: InputMaybe<Scalars['jsonb']['input']>;
  children?: InputMaybe<Reference_Zone_Arr_Rel_Insert_Input>;
  city?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  geom?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Reference_Zone_Obj_Rel_Insert_Input>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  reference_price_histories?: InputMaybe<Reference_Price_History_Arr_Rel_Insert_Input>;
  search_slugs?: InputMaybe<Search_Slugs_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Reference_Zone_Max_Fields = {
  __typename?: 'reference_zone_max_fields';
  city?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "reference_zone" */
export type Reference_Zone_Max_Order_By = {
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reference_Zone_Min_Fields = {
  __typename?: 'reference_zone_min_fields';
  city?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "reference_zone" */
export type Reference_Zone_Min_Order_By = {
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reference_zone" */
export type Reference_Zone_Mutation_Response = {
  __typename?: 'reference_zone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reference_Zone>;
};

/** input type for inserting object relation for remote table "reference_zone" */
export type Reference_Zone_Obj_Rel_Insert_Input = {
  data: Reference_Zone_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Reference_Zone_On_Conflict>;
};

/** on_conflict condition type for table "reference_zone" */
export type Reference_Zone_On_Conflict = {
  constraint: Reference_Zone_Constraint;
  update_columns?: Array<Reference_Zone_Update_Column>;
  where?: InputMaybe<Reference_Zone_Bool_Exp>;
};

/** Ordering options when selecting data from "reference_zone". */
export type Reference_Zone_Order_By = {
  bounds?: InputMaybe<Order_By>;
  children_aggregate?: InputMaybe<Reference_Zone_Aggregate_Order_By>;
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent?: InputMaybe<Reference_Zone_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  reference_price_histories_aggregate?: InputMaybe<Reference_Price_History_Aggregate_Order_By>;
  search_slugs_aggregate?: InputMaybe<Search_Slugs_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reference_zone */
export type Reference_Zone_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Reference_Zone_Prepend_Input = {
  bounds?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "reference_zone" */
export enum Reference_Zone_Select_Column {
  /** column name */
  Bounds = 'bounds',
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "reference_zone" */
export type Reference_Zone_Set_Input = {
  bounds?: InputMaybe<Scalars['jsonb']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  geom?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "reference_zone" */
export type Reference_Zone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reference_Zone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reference_Zone_Stream_Cursor_Value_Input = {
  bounds?: InputMaybe<Scalars['jsonb']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  geom?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "reference_zone" */
export enum Reference_Zone_Update_Column {
  /** column name */
  Bounds = 'bounds',
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Reference_Zone_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Reference_Zone_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Reference_Zone_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Reference_Zone_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Reference_Zone_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Reference_Zone_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reference_Zone_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reference_Zone_Bool_Exp;
};

/** regionalPropertyDistributionNative Query Arguments */
export type RegionalPropertyDistribution_Arguments = {
  property_status: Scalars['String']['input'];
  property_type: Scalars['String']['input'];
};

export type Regional_Property_Model = {
  __typename?: 'regional_property_model';
  avg_price_eur?: Maybe<Scalars['numeric']['output']>;
  city_name?: Maybe<Scalars['String']['output']>;
  total_properties?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the logical model for "regional_property_model". All fields are combined with a logical 'AND'. */
export type Regional_Property_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Regional_Property_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Regional_Property_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Regional_Property_Model_Bool_Exp_Bool_Exp>>;
  avg_price_eur?: InputMaybe<Numeric_Comparison_Exp>;
  city_name?: InputMaybe<String_Comparison_Exp>;
  total_properties?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Regional_Property_Model_Enum_Name {
  /** column name */
  AvgPriceEur = 'avg_price_eur',
  /** column name */
  CityName = 'city_name',
  /** column name */
  TotalProperties = 'total_properties'
}

/** Ordering options when selecting data from "regional_property_model". */
export type Regional_Property_Model_Order_By = {
  avg_price_eur?: InputMaybe<Order_By>;
  city_name?: InputMaybe<Order_By>;
  total_properties?: InputMaybe<Order_By>;
};

export type Register_Whatsapp_Ai_Turn_Args = {
  p_build_version?: InputMaybe<Scalars['String']['input']>;
  p_contract_version?: InputMaybe<Scalars['Int']['input']>;
  p_deadline_at?: InputMaybe<Scalars['timestamptz']['input']>;
  p_evolution_instance?: InputMaybe<Scalars['String']['input']>;
  p_inbound_messages?: InputMaybe<Scalars['jsonb']['input']>;
  p_lease_seconds?: InputMaybe<Scalars['Int']['input']>;
  p_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  p_model_policy_version?: InputMaybe<Scalars['String']['input']>;
  p_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  p_organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  p_remote_identity_hash?: InputMaybe<Scalars['String']['input']>;
  p_thread_id?: InputMaybe<Scalars['String']['input']>;
  p_turn_inbound_at?: InputMaybe<Scalars['timestamptz']['input']>;
  p_worker_id?: InputMaybe<Scalars['String']['input']>;
};

export type Renew_Whatsapp_Ai_Turn_Lease_Args = {
  p_lease_seconds?: InputMaybe<Scalars['Int']['input']>;
  p_turn_id?: InputMaybe<Scalars['uuid']['input']>;
  p_worker_id?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "search_context" */
export type Search_Context = {
  __typename?: 'search_context';
  area_range?: Maybe<Scalars['jsonb']['output']>;
  bathrooms_range?: Maybe<Scalars['jsonb']['output']>;
  cluster?: Maybe<Property_Cluster>;
  construction_status?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  currency_rel?: Maybe<Currency>;
  extracted_filters: Scalars['jsonb']['output'];
  floor_range?: Maybe<Scalars['jsonb']['output']>;
  furnishing_status?: Maybe<Scalars['jsonb']['output']>;
  geo_location_draw?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  location_zone?: Maybe<City_Zone>;
  location_zone_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  natural_language_query?: Maybe<Natural_Language_Queries>;
  price_range?: Maybe<Scalars['jsonb']['output']>;
  property_cluster?: Maybe<Scalars['String']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['jsonb']['output']>;
  query_id?: Maybe<Scalars['uuid']['output']>;
  rooms_range?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  search_context_locations: Array<Search_Context_Location>;
  /** An aggregate relationship */
  search_context_locations_aggregate: Search_Context_Location_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "search_context" */
export type Search_ContextArea_RangeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "search_context" */
export type Search_ContextBathrooms_RangeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "search_context" */
export type Search_ContextConstruction_StatusArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "search_context" */
export type Search_ContextExtracted_FiltersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "search_context" */
export type Search_ContextFloor_RangeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "search_context" */
export type Search_ContextFurnishing_StatusArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "search_context" */
export type Search_ContextGeo_Location_DrawArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "search_context" */
export type Search_ContextPrice_RangeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "search_context" */
export type Search_ContextProperty_TypeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "search_context" */
export type Search_ContextRooms_RangeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "search_context" */
export type Search_ContextSearch_Context_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Search_Context_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Context_Location_Order_By>>;
  where?: InputMaybe<Search_Context_Location_Bool_Exp>;
};


/** columns and relationships of "search_context" */
export type Search_ContextSearch_Context_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Context_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Context_Location_Order_By>>;
  where?: InputMaybe<Search_Context_Location_Bool_Exp>;
};

/** aggregated selection of "search_context" */
export type Search_Context_Aggregate = {
  __typename?: 'search_context_aggregate';
  aggregate?: Maybe<Search_Context_Aggregate_Fields>;
  nodes: Array<Search_Context>;
};

export type Search_Context_Aggregate_Bool_Exp = {
  count?: InputMaybe<Search_Context_Aggregate_Bool_Exp_Count>;
};

export type Search_Context_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Search_Context_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Search_Context_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "search_context" */
export type Search_Context_Aggregate_Fields = {
  __typename?: 'search_context_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Search_Context_Max_Fields>;
  min?: Maybe<Search_Context_Min_Fields>;
};


/** aggregate fields of "search_context" */
export type Search_Context_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Context_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "search_context" */
export type Search_Context_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Search_Context_Max_Order_By>;
  min?: InputMaybe<Search_Context_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Search_Context_Append_Input = {
  area_range?: InputMaybe<Scalars['jsonb']['input']>;
  bathrooms_range?: InputMaybe<Scalars['jsonb']['input']>;
  construction_status?: InputMaybe<Scalars['jsonb']['input']>;
  extracted_filters?: InputMaybe<Scalars['jsonb']['input']>;
  floor_range?: InputMaybe<Scalars['jsonb']['input']>;
  furnishing_status?: InputMaybe<Scalars['jsonb']['input']>;
  geo_location_draw?: InputMaybe<Scalars['jsonb']['input']>;
  price_range?: InputMaybe<Scalars['jsonb']['input']>;
  property_type?: InputMaybe<Scalars['jsonb']['input']>;
  rooms_range?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "search_context" */
export type Search_Context_Arr_Rel_Insert_Input = {
  data: Array<Search_Context_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Search_Context_On_Conflict>;
};

/** Boolean expression to filter rows from the table "search_context". All fields are combined with a logical 'AND'. */
export type Search_Context_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Context_Bool_Exp>>;
  _not?: InputMaybe<Search_Context_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Context_Bool_Exp>>;
  area_range?: InputMaybe<Jsonb_Comparison_Exp>;
  bathrooms_range?: InputMaybe<Jsonb_Comparison_Exp>;
  construction_status?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  extracted_filters?: InputMaybe<Jsonb_Comparison_Exp>;
  floor_range?: InputMaybe<Jsonb_Comparison_Exp>;
  furnishing_status?: InputMaybe<Jsonb_Comparison_Exp>;
  geo_location_draw?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location_zone_id?: InputMaybe<Uuid_Comparison_Exp>;
  natural_language_query?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
  price_range?: InputMaybe<Jsonb_Comparison_Exp>;
  property_cluster?: InputMaybe<String_Comparison_Exp>;
  property_status?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<Jsonb_Comparison_Exp>;
  query_id?: InputMaybe<Uuid_Comparison_Exp>;
  rooms_range?: InputMaybe<Jsonb_Comparison_Exp>;
  search_context_locations?: InputMaybe<Search_Context_Location_Bool_Exp>;
  search_context_locations_aggregate?: InputMaybe<Search_Context_Location_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "search_context" */
export enum Search_Context_Constraint {
  /** unique or primary key constraint on columns "id" */
  SearchContextPkey = 'search_context_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Search_Context_Delete_At_Path_Input = {
  area_range?: InputMaybe<Array<Scalars['String']['input']>>;
  bathrooms_range?: InputMaybe<Array<Scalars['String']['input']>>;
  construction_status?: InputMaybe<Array<Scalars['String']['input']>>;
  extracted_filters?: InputMaybe<Array<Scalars['String']['input']>>;
  floor_range?: InputMaybe<Array<Scalars['String']['input']>>;
  furnishing_status?: InputMaybe<Array<Scalars['String']['input']>>;
  geo_location_draw?: InputMaybe<Array<Scalars['String']['input']>>;
  price_range?: InputMaybe<Array<Scalars['String']['input']>>;
  property_type?: InputMaybe<Array<Scalars['String']['input']>>;
  rooms_range?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Search_Context_Delete_Elem_Input = {
  area_range?: InputMaybe<Scalars['Int']['input']>;
  bathrooms_range?: InputMaybe<Scalars['Int']['input']>;
  construction_status?: InputMaybe<Scalars['Int']['input']>;
  extracted_filters?: InputMaybe<Scalars['Int']['input']>;
  floor_range?: InputMaybe<Scalars['Int']['input']>;
  furnishing_status?: InputMaybe<Scalars['Int']['input']>;
  geo_location_draw?: InputMaybe<Scalars['Int']['input']>;
  price_range?: InputMaybe<Scalars['Int']['input']>;
  property_type?: InputMaybe<Scalars['Int']['input']>;
  rooms_range?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Search_Context_Delete_Key_Input = {
  area_range?: InputMaybe<Scalars['String']['input']>;
  bathrooms_range?: InputMaybe<Scalars['String']['input']>;
  construction_status?: InputMaybe<Scalars['String']['input']>;
  extracted_filters?: InputMaybe<Scalars['String']['input']>;
  floor_range?: InputMaybe<Scalars['String']['input']>;
  furnishing_status?: InputMaybe<Scalars['String']['input']>;
  geo_location_draw?: InputMaybe<Scalars['String']['input']>;
  price_range?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
  rooms_range?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "search_context" */
export type Search_Context_Insert_Input = {
  area_range?: InputMaybe<Scalars['jsonb']['input']>;
  bathrooms_range?: InputMaybe<Scalars['jsonb']['input']>;
  construction_status?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  extracted_filters?: InputMaybe<Scalars['jsonb']['input']>;
  floor_range?: InputMaybe<Scalars['jsonb']['input']>;
  furnishing_status?: InputMaybe<Scalars['jsonb']['input']>;
  geo_location_draw?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  natural_language_query?: InputMaybe<Natural_Language_Queries_Obj_Rel_Insert_Input>;
  price_range?: InputMaybe<Scalars['jsonb']['input']>;
  property_cluster?: InputMaybe<Scalars['String']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['jsonb']['input']>;
  query_id?: InputMaybe<Scalars['uuid']['input']>;
  rooms_range?: InputMaybe<Scalars['jsonb']['input']>;
  search_context_locations?: InputMaybe<Search_Context_Location_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "search_context_location" */
export type Search_Context_Location = {
  __typename?: 'search_context_location';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  location_zone?: Maybe<City_Zone>;
  location_zone_id: Scalars['uuid']['output'];
  /** An object relationship */
  search_context: Search_Context;
  search_context_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "search_context_location" */
export type Search_Context_Location_Aggregate = {
  __typename?: 'search_context_location_aggregate';
  aggregate?: Maybe<Search_Context_Location_Aggregate_Fields>;
  nodes: Array<Search_Context_Location>;
};

export type Search_Context_Location_Aggregate_Bool_Exp = {
  count?: InputMaybe<Search_Context_Location_Aggregate_Bool_Exp_Count>;
};

export type Search_Context_Location_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Search_Context_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Search_Context_Location_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "search_context_location" */
export type Search_Context_Location_Aggregate_Fields = {
  __typename?: 'search_context_location_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Search_Context_Location_Max_Fields>;
  min?: Maybe<Search_Context_Location_Min_Fields>;
};


/** aggregate fields of "search_context_location" */
export type Search_Context_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Context_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "search_context_location" */
export type Search_Context_Location_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Search_Context_Location_Max_Order_By>;
  min?: InputMaybe<Search_Context_Location_Min_Order_By>;
};

/** input type for inserting array relation for remote table "search_context_location" */
export type Search_Context_Location_Arr_Rel_Insert_Input = {
  data: Array<Search_Context_Location_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Search_Context_Location_On_Conflict>;
};

/** Boolean expression to filter rows from the table "search_context_location". All fields are combined with a logical 'AND'. */
export type Search_Context_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Context_Location_Bool_Exp>>;
  _not?: InputMaybe<Search_Context_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Context_Location_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location_zone_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_context?: InputMaybe<Search_Context_Bool_Exp>;
  search_context_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "search_context_location" */
export enum Search_Context_Location_Constraint {
  /** unique or primary key constraint on columns "id" */
  SearchContextLocationPkey = 'search_context_location_pkey',
  /** unique or primary key constraint on columns "location_zone_id", "search_context_id" */
  SearchContextLocationSearchContextIdLocationZoneIdKey = 'search_context_location_search_context_id_location_zone_id_key'
}

/** input type for inserting data into table "search_context_location" */
export type Search_Context_Location_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  search_context?: InputMaybe<Search_Context_Obj_Rel_Insert_Input>;
  search_context_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Search_Context_Location_Max_Fields = {
  __typename?: 'search_context_location_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_zone_id?: Maybe<Scalars['uuid']['output']>;
  search_context_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "search_context_location" */
export type Search_Context_Location_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_zone_id?: InputMaybe<Order_By>;
  search_context_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Search_Context_Location_Min_Fields = {
  __typename?: 'search_context_location_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_zone_id?: Maybe<Scalars['uuid']['output']>;
  search_context_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "search_context_location" */
export type Search_Context_Location_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_zone_id?: InputMaybe<Order_By>;
  search_context_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "search_context_location" */
export type Search_Context_Location_Mutation_Response = {
  __typename?: 'search_context_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Context_Location>;
};

/** on_conflict condition type for table "search_context_location" */
export type Search_Context_Location_On_Conflict = {
  constraint: Search_Context_Location_Constraint;
  update_columns?: Array<Search_Context_Location_Update_Column>;
  where?: InputMaybe<Search_Context_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "search_context_location". */
export type Search_Context_Location_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_zone_id?: InputMaybe<Order_By>;
  search_context?: InputMaybe<Search_Context_Order_By>;
  search_context_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: search_context_location */
export type Search_Context_Location_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "search_context_location" */
export enum Search_Context_Location_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocationZoneId = 'location_zone_id',
  /** column name */
  SearchContextId = 'search_context_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "search_context_location" */
export type Search_Context_Location_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  search_context_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "search_context_location" */
export type Search_Context_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Context_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Context_Location_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  search_context_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "search_context_location" */
export enum Search_Context_Location_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocationZoneId = 'location_zone_id',
  /** column name */
  SearchContextId = 'search_context_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Search_Context_Location_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Context_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Context_Location_Bool_Exp;
};

/** aggregate max on columns */
export type Search_Context_Max_Fields = {
  __typename?: 'search_context_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_zone_id?: Maybe<Scalars['uuid']['output']>;
  property_cluster?: Maybe<Scalars['String']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  query_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "search_context" */
export type Search_Context_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_zone_id?: InputMaybe<Order_By>;
  property_cluster?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  query_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Search_Context_Min_Fields = {
  __typename?: 'search_context_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_zone_id?: Maybe<Scalars['uuid']['output']>;
  property_cluster?: Maybe<Scalars['String']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  query_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "search_context" */
export type Search_Context_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_zone_id?: InputMaybe<Order_By>;
  property_cluster?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  query_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "search_context" */
export type Search_Context_Mutation_Response = {
  __typename?: 'search_context_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Context>;
};

/** input type for inserting object relation for remote table "search_context" */
export type Search_Context_Obj_Rel_Insert_Input = {
  data: Search_Context_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Search_Context_On_Conflict>;
};

/** on_conflict condition type for table "search_context" */
export type Search_Context_On_Conflict = {
  constraint: Search_Context_Constraint;
  update_columns?: Array<Search_Context_Update_Column>;
  where?: InputMaybe<Search_Context_Bool_Exp>;
};

/** Ordering options when selecting data from "search_context". */
export type Search_Context_Order_By = {
  area_range?: InputMaybe<Order_By>;
  bathrooms_range?: InputMaybe<Order_By>;
  construction_status?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  extracted_filters?: InputMaybe<Order_By>;
  floor_range?: InputMaybe<Order_By>;
  furnishing_status?: InputMaybe<Order_By>;
  geo_location_draw?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_zone_id?: InputMaybe<Order_By>;
  natural_language_query?: InputMaybe<Natural_Language_Queries_Order_By>;
  price_range?: InputMaybe<Order_By>;
  property_cluster?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  query_id?: InputMaybe<Order_By>;
  rooms_range?: InputMaybe<Order_By>;
  search_context_locations_aggregate?: InputMaybe<Search_Context_Location_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: search_context */
export type Search_Context_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Search_Context_Prepend_Input = {
  area_range?: InputMaybe<Scalars['jsonb']['input']>;
  bathrooms_range?: InputMaybe<Scalars['jsonb']['input']>;
  construction_status?: InputMaybe<Scalars['jsonb']['input']>;
  extracted_filters?: InputMaybe<Scalars['jsonb']['input']>;
  floor_range?: InputMaybe<Scalars['jsonb']['input']>;
  furnishing_status?: InputMaybe<Scalars['jsonb']['input']>;
  geo_location_draw?: InputMaybe<Scalars['jsonb']['input']>;
  price_range?: InputMaybe<Scalars['jsonb']['input']>;
  property_type?: InputMaybe<Scalars['jsonb']['input']>;
  rooms_range?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "search_context" */
export enum Search_Context_Select_Column {
  /** column name */
  AreaRange = 'area_range',
  /** column name */
  BathroomsRange = 'bathrooms_range',
  /** column name */
  ConstructionStatus = 'construction_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  ExtractedFilters = 'extracted_filters',
  /** column name */
  FloorRange = 'floor_range',
  /** column name */
  FurnishingStatus = 'furnishing_status',
  /** column name */
  GeoLocationDraw = 'geo_location_draw',
  /** column name */
  Id = 'id',
  /** column name */
  LocationZoneId = 'location_zone_id',
  /** column name */
  PriceRange = 'price_range',
  /** column name */
  PropertyCluster = 'property_cluster',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  QueryId = 'query_id',
  /** column name */
  RoomsRange = 'rooms_range',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "search_context" */
export type Search_Context_Set_Input = {
  area_range?: InputMaybe<Scalars['jsonb']['input']>;
  bathrooms_range?: InputMaybe<Scalars['jsonb']['input']>;
  construction_status?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  extracted_filters?: InputMaybe<Scalars['jsonb']['input']>;
  floor_range?: InputMaybe<Scalars['jsonb']['input']>;
  furnishing_status?: InputMaybe<Scalars['jsonb']['input']>;
  geo_location_draw?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  price_range?: InputMaybe<Scalars['jsonb']['input']>;
  property_cluster?: InputMaybe<Scalars['String']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['jsonb']['input']>;
  query_id?: InputMaybe<Scalars['uuid']['input']>;
  rooms_range?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "search_context" */
export type Search_Context_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Context_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Context_Stream_Cursor_Value_Input = {
  area_range?: InputMaybe<Scalars['jsonb']['input']>;
  bathrooms_range?: InputMaybe<Scalars['jsonb']['input']>;
  construction_status?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  extracted_filters?: InputMaybe<Scalars['jsonb']['input']>;
  floor_range?: InputMaybe<Scalars['jsonb']['input']>;
  furnishing_status?: InputMaybe<Scalars['jsonb']['input']>;
  geo_location_draw?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  price_range?: InputMaybe<Scalars['jsonb']['input']>;
  property_cluster?: InputMaybe<Scalars['String']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['jsonb']['input']>;
  query_id?: InputMaybe<Scalars['uuid']['input']>;
  rooms_range?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "search_context" */
export enum Search_Context_Update_Column {
  /** column name */
  AreaRange = 'area_range',
  /** column name */
  BathroomsRange = 'bathrooms_range',
  /** column name */
  ConstructionStatus = 'construction_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  ExtractedFilters = 'extracted_filters',
  /** column name */
  FloorRange = 'floor_range',
  /** column name */
  FurnishingStatus = 'furnishing_status',
  /** column name */
  GeoLocationDraw = 'geo_location_draw',
  /** column name */
  Id = 'id',
  /** column name */
  LocationZoneId = 'location_zone_id',
  /** column name */
  PriceRange = 'price_range',
  /** column name */
  PropertyCluster = 'property_cluster',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  QueryId = 'query_id',
  /** column name */
  RoomsRange = 'rooms_range',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Search_Context_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Search_Context_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Search_Context_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Search_Context_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Search_Context_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Search_Context_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Context_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Context_Bool_Exp;
};

/** Contains the type of tailored search offered by the platform */
export type Search_Domain = {
  __typename?: 'search_domain';
  domain: Scalars['String']['output'];
};

/** aggregated selection of "search_domain" */
export type Search_Domain_Aggregate = {
  __typename?: 'search_domain_aggregate';
  aggregate?: Maybe<Search_Domain_Aggregate_Fields>;
  nodes: Array<Search_Domain>;
};

/** aggregate fields of "search_domain" */
export type Search_Domain_Aggregate_Fields = {
  __typename?: 'search_domain_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Search_Domain_Max_Fields>;
  min?: Maybe<Search_Domain_Min_Fields>;
};


/** aggregate fields of "search_domain" */
export type Search_Domain_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Domain_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "search_domain". All fields are combined with a logical 'AND'. */
export type Search_Domain_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Domain_Bool_Exp>>;
  _not?: InputMaybe<Search_Domain_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Domain_Bool_Exp>>;
  domain?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "search_domain" */
export enum Search_Domain_Constraint {
  /** unique or primary key constraint on columns "domain" */
  SearchDomainPkey = 'search_domain_pkey'
}

export enum Search_Domain_Enum {
  RealEstate = 'REAL_ESTATE'
}

/** Boolean expression to compare columns of type "search_domain_enum". All fields are combined with logical 'AND'. */
export type Search_Domain_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Search_Domain_Enum>;
  _in?: InputMaybe<Array<Search_Domain_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Search_Domain_Enum>;
  _nin?: InputMaybe<Array<Search_Domain_Enum>>;
};

/** input type for inserting data into table "search_domain" */
export type Search_Domain_Insert_Input = {
  domain?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Search_Domain_Max_Fields = {
  __typename?: 'search_domain_max_fields';
  domain?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Search_Domain_Min_Fields = {
  __typename?: 'search_domain_min_fields';
  domain?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "search_domain" */
export type Search_Domain_Mutation_Response = {
  __typename?: 'search_domain_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Domain>;
};

/** input type for inserting object relation for remote table "search_domain" */
export type Search_Domain_Obj_Rel_Insert_Input = {
  data: Search_Domain_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Search_Domain_On_Conflict>;
};

/** on_conflict condition type for table "search_domain" */
export type Search_Domain_On_Conflict = {
  constraint: Search_Domain_Constraint;
  update_columns?: Array<Search_Domain_Update_Column>;
  where?: InputMaybe<Search_Domain_Bool_Exp>;
};

/** Ordering options when selecting data from "search_domain". */
export type Search_Domain_Order_By = {
  domain?: InputMaybe<Order_By>;
};

/** primary key columns input for table: search_domain */
export type Search_Domain_Pk_Columns_Input = {
  domain: Scalars['String']['input'];
};

/** select columns of table "search_domain" */
export enum Search_Domain_Select_Column {
  /** column name */
  Domain = 'domain'
}

/** input type for updating data in table "search_domain" */
export type Search_Domain_Set_Input = {
  domain?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "search_domain" */
export type Search_Domain_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Domain_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Domain_Stream_Cursor_Value_Input = {
  domain?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "search_domain" */
export enum Search_Domain_Update_Column {
  /** column name */
  Domain = 'domain'
}

export type Search_Domain_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Domain_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Domain_Bool_Exp;
};

/** one for each conversation session of the user */
export type Search_Sessions = {
  __typename?: 'search_sessions';
  created_at: Scalars['timestamptz']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  domain: Search_Domain_Enum;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  natural_language_queries: Array<Natural_Language_Queries>;
  /** An aggregate relationship */
  natural_language_queries_aggregate: Natural_Language_Queries_Aggregate;
  /** An object relationship */
  organization_lead?: Maybe<Organization_Leads>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  origin?: Maybe<Session_Origin_Enum>;
  real_time_alert: Scalars['Boolean']['output'];
  /** An object relationship */
  search_domain: Search_Domain;
  /** An array relationship */
  search_slugs: Array<Search_Slugs>;
  /** An aggregate relationship */
  search_slugs_aggregate: Search_Slugs_Aggregate;
  /** An object relationship */
  session_origin?: Maybe<Session_Origin>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An array relationship */
  user_filters: Array<User_Filters>;
  /** An aggregate relationship */
  user_filters_aggregate: User_Filters_Aggregate;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** one for each conversation session of the user */
export type Search_SessionsNatural_Language_QueriesArgs = {
  distinct_on?: InputMaybe<Array<Natural_Language_Queries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Natural_Language_Queries_Order_By>>;
  where?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
};


/** one for each conversation session of the user */
export type Search_SessionsNatural_Language_Queries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Natural_Language_Queries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Natural_Language_Queries_Order_By>>;
  where?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
};


/** one for each conversation session of the user */
export type Search_SessionsSearch_SlugsArgs = {
  distinct_on?: InputMaybe<Array<Search_Slugs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Slugs_Order_By>>;
  where?: InputMaybe<Search_Slugs_Bool_Exp>;
};


/** one for each conversation session of the user */
export type Search_SessionsSearch_Slugs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Slugs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Slugs_Order_By>>;
  where?: InputMaybe<Search_Slugs_Bool_Exp>;
};


/** one for each conversation session of the user */
export type Search_SessionsUser_FiltersArgs = {
  distinct_on?: InputMaybe<Array<User_Filters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Filters_Order_By>>;
  where?: InputMaybe<User_Filters_Bool_Exp>;
};


/** one for each conversation session of the user */
export type Search_SessionsUser_Filters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Filters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Filters_Order_By>>;
  where?: InputMaybe<User_Filters_Bool_Exp>;
};

/** aggregated selection of "search_sessions" */
export type Search_Sessions_Aggregate = {
  __typename?: 'search_sessions_aggregate';
  aggregate?: Maybe<Search_Sessions_Aggregate_Fields>;
  nodes: Array<Search_Sessions>;
};

export type Search_Sessions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Search_Sessions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Search_Sessions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Search_Sessions_Aggregate_Bool_Exp_Count>;
};

export type Search_Sessions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Search_Sessions_Select_Column_Search_Sessions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Search_Sessions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Search_Sessions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Search_Sessions_Select_Column_Search_Sessions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Search_Sessions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Search_Sessions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Search_Sessions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "search_sessions" */
export type Search_Sessions_Aggregate_Fields = {
  __typename?: 'search_sessions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Search_Sessions_Max_Fields>;
  min?: Maybe<Search_Sessions_Min_Fields>;
};


/** aggregate fields of "search_sessions" */
export type Search_Sessions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "search_sessions" */
export type Search_Sessions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Search_Sessions_Max_Order_By>;
  min?: InputMaybe<Search_Sessions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "search_sessions" */
export type Search_Sessions_Arr_Rel_Insert_Input = {
  data: Array<Search_Sessions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Search_Sessions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "search_sessions". All fields are combined with a logical 'AND'. */
export type Search_Sessions_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Sessions_Bool_Exp>>;
  _not?: InputMaybe<Search_Sessions_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Sessions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  domain?: InputMaybe<Search_Domain_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  natural_language_queries?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
  natural_language_queries_aggregate?: InputMaybe<Natural_Language_Queries_Aggregate_Bool_Exp>;
  organization_lead?: InputMaybe<Organization_Leads_Bool_Exp>;
  organization_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  origin?: InputMaybe<Session_Origin_Enum_Comparison_Exp>;
  real_time_alert?: InputMaybe<Boolean_Comparison_Exp>;
  search_domain?: InputMaybe<Search_Domain_Bool_Exp>;
  search_slugs?: InputMaybe<Search_Slugs_Bool_Exp>;
  search_slugs_aggregate?: InputMaybe<Search_Slugs_Aggregate_Bool_Exp>;
  session_origin?: InputMaybe<Session_Origin_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_filters?: InputMaybe<User_Filters_Bool_Exp>;
  user_filters_aggregate?: InputMaybe<User_Filters_Aggregate_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "search_sessions" */
export enum Search_Sessions_Constraint {
  /** unique or primary key constraint on columns "id" */
  SearchSessionsPkey = 'search_sessions_pkey'
}

/** input type for inserting data into table "search_sessions" */
export type Search_Sessions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Search_Domain_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  natural_language_queries?: InputMaybe<Natural_Language_Queries_Arr_Rel_Insert_Input>;
  organization_lead?: InputMaybe<Organization_Leads_Obj_Rel_Insert_Input>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  origin?: InputMaybe<Session_Origin_Enum>;
  real_time_alert?: InputMaybe<Scalars['Boolean']['input']>;
  search_domain?: InputMaybe<Search_Domain_Obj_Rel_Insert_Input>;
  search_slugs?: InputMaybe<Search_Slugs_Arr_Rel_Insert_Input>;
  session_origin?: InputMaybe<Session_Origin_Obj_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_filters?: InputMaybe<User_Filters_Arr_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Search_Sessions_Max_Fields = {
  __typename?: 'search_sessions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "search_sessions" */
export type Search_Sessions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_lead_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Search_Sessions_Min_Fields = {
  __typename?: 'search_sessions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "search_sessions" */
export type Search_Sessions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_lead_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "search_sessions" */
export type Search_Sessions_Mutation_Response = {
  __typename?: 'search_sessions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Sessions>;
};

/** input type for inserting object relation for remote table "search_sessions" */
export type Search_Sessions_Obj_Rel_Insert_Input = {
  data: Search_Sessions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Search_Sessions_On_Conflict>;
};

/** on_conflict condition type for table "search_sessions" */
export type Search_Sessions_On_Conflict = {
  constraint: Search_Sessions_Constraint;
  update_columns?: Array<Search_Sessions_Update_Column>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};

/** Ordering options when selecting data from "search_sessions". */
export type Search_Sessions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  natural_language_queries_aggregate?: InputMaybe<Natural_Language_Queries_Aggregate_Order_By>;
  organization_lead?: InputMaybe<Organization_Leads_Order_By>;
  organization_lead_id?: InputMaybe<Order_By>;
  origin?: InputMaybe<Order_By>;
  real_time_alert?: InputMaybe<Order_By>;
  search_domain?: InputMaybe<Search_Domain_Order_By>;
  search_slugs_aggregate?: InputMaybe<Search_Slugs_Aggregate_Order_By>;
  session_origin?: InputMaybe<Session_Origin_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_filters_aggregate?: InputMaybe<User_Filters_Aggregate_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: search_sessions */
export type Search_Sessions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "search_sessions" */
export enum Search_Sessions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Domain = 'domain',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationLeadId = 'organization_lead_id',
  /** column name */
  Origin = 'origin',
  /** column name */
  RealTimeAlert = 'real_time_alert',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "search_sessions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "search_sessions" */
export enum Search_Sessions_Select_Column_Search_Sessions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  RealTimeAlert = 'real_time_alert'
}

/** select "search_sessions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "search_sessions" */
export enum Search_Sessions_Select_Column_Search_Sessions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  RealTimeAlert = 'real_time_alert'
}

/** input type for updating data in table "search_sessions" */
export type Search_Sessions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Search_Domain_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  origin?: InputMaybe<Session_Origin_Enum>;
  real_time_alert?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Search_Sessions_Sorted_By_Last_Query_Args = {
  p_limit?: InputMaybe<Scalars['Int']['input']>;
  p_offset?: InputMaybe<Scalars['Int']['input']>;
  p_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "search_sessions" */
export type Search_Sessions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Sessions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Sessions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Search_Domain_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  origin?: InputMaybe<Session_Origin_Enum>;
  real_time_alert?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "search_sessions" */
export enum Search_Sessions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Domain = 'domain',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationLeadId = 'organization_lead_id',
  /** column name */
  Origin = 'origin',
  /** column name */
  RealTimeAlert = 'real_time_alert',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Search_Sessions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Sessions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Sessions_Bool_Exp;
};

/** columns and relationships of "search_slugs" */
export type Search_Slugs = {
  __typename?: 'search_slugs';
  cluster?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  header_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  image?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Languages>;
  language_id?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  property_cluster?: Maybe<Property_Cluster>;
  questions?: Maybe<Scalars['jsonb']['output']>;
  reference_zone_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  search_session?: Maybe<Search_Sessions>;
  search_text?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['uuid']['output']>;
  sitemap_process?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  style?: Maybe<Scalars['jsonb']['output']>;
  testimonials?: Maybe<Scalars['jsonb']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  zone_name?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "search_slugs" */
export type Search_SlugsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "search_slugs" */
export type Search_SlugsQuestionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "search_slugs" */
export type Search_SlugsStyleArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "search_slugs" */
export type Search_SlugsTestimonialsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "search_slugs" */
export type Search_Slugs_Aggregate = {
  __typename?: 'search_slugs_aggregate';
  aggregate?: Maybe<Search_Slugs_Aggregate_Fields>;
  nodes: Array<Search_Slugs>;
};

export type Search_Slugs_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Search_Slugs_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Search_Slugs_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Search_Slugs_Aggregate_Bool_Exp_Count>;
};

export type Search_Slugs_Aggregate_Bool_Exp_Bool_And = {
  arguments: Search_Slugs_Select_Column_Search_Slugs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Search_Slugs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Search_Slugs_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Search_Slugs_Select_Column_Search_Slugs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Search_Slugs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Search_Slugs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Search_Slugs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Search_Slugs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "search_slugs" */
export type Search_Slugs_Aggregate_Fields = {
  __typename?: 'search_slugs_aggregate_fields';
  avg?: Maybe<Search_Slugs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Search_Slugs_Max_Fields>;
  min?: Maybe<Search_Slugs_Min_Fields>;
  stddev?: Maybe<Search_Slugs_Stddev_Fields>;
  stddev_pop?: Maybe<Search_Slugs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Search_Slugs_Stddev_Samp_Fields>;
  sum?: Maybe<Search_Slugs_Sum_Fields>;
  var_pop?: Maybe<Search_Slugs_Var_Pop_Fields>;
  var_samp?: Maybe<Search_Slugs_Var_Samp_Fields>;
  variance?: Maybe<Search_Slugs_Variance_Fields>;
};


/** aggregate fields of "search_slugs" */
export type Search_Slugs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Slugs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "search_slugs" */
export type Search_Slugs_Aggregate_Order_By = {
  avg?: InputMaybe<Search_Slugs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Search_Slugs_Max_Order_By>;
  min?: InputMaybe<Search_Slugs_Min_Order_By>;
  stddev?: InputMaybe<Search_Slugs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Search_Slugs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Search_Slugs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Search_Slugs_Sum_Order_By>;
  var_pop?: InputMaybe<Search_Slugs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Search_Slugs_Var_Samp_Order_By>;
  variance?: InputMaybe<Search_Slugs_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Search_Slugs_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  questions?: InputMaybe<Scalars['jsonb']['input']>;
  style?: InputMaybe<Scalars['jsonb']['input']>;
  testimonials?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "search_slugs" */
export type Search_Slugs_Arr_Rel_Insert_Input = {
  data: Array<Search_Slugs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Search_Slugs_On_Conflict>;
};

/** aggregate avg on columns */
export type Search_Slugs_Avg_Fields = {
  __typename?: 'search_slugs_avg_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "search_slugs" */
export type Search_Slugs_Avg_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "search_slugs". All fields are combined with a logical 'AND'. */
export type Search_Slugs_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Slugs_Bool_Exp>>;
  _not?: InputMaybe<Search_Slugs_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Slugs_Bool_Exp>>;
  cluster?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  header_text?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  keywords?: InputMaybe<String_Comparison_Exp>;
  language_id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  questions?: InputMaybe<Jsonb_Comparison_Exp>;
  reference_zone_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_session?: InputMaybe<Search_Sessions_Bool_Exp>;
  search_text?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<Uuid_Comparison_Exp>;
  sitemap_process?: InputMaybe<Boolean_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  style?: InputMaybe<Jsonb_Comparison_Exp>;
  testimonials?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  zone_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "search_slugs" */
export enum Search_Slugs_Constraint {
  /** unique or primary key constraint on columns "id" */
  SearchSlugsPkey = 'search_slugs_pkey',
  /** unique or primary key constraint on columns "slug" */
  SearchSlugsSlugKey = 'search_slugs_slug_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Search_Slugs_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  questions?: InputMaybe<Array<Scalars['String']['input']>>;
  style?: InputMaybe<Array<Scalars['String']['input']>>;
  testimonials?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Search_Slugs_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
  questions?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<Scalars['Int']['input']>;
  testimonials?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Search_Slugs_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  testimonials?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "search_slugs" */
export type Search_Slugs_Inc_Input = {
  language_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "search_slugs" */
export type Search_Slugs_Insert_Input = {
  cluster?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  header_text?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  questions?: InputMaybe<Scalars['jsonb']['input']>;
  reference_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  search_session?: InputMaybe<Search_Sessions_Obj_Rel_Insert_Input>;
  search_text?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['uuid']['input']>;
  sitemap_process?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['jsonb']['input']>;
  testimonials?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  zone_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Search_Slugs_Max_Fields = {
  __typename?: 'search_slugs_max_fields';
  cluster?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  header_text?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Scalars['String']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  reference_zone_id?: Maybe<Scalars['uuid']['output']>;
  search_text?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  zone_name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "search_slugs" */
export type Search_Slugs_Max_Order_By = {
  cluster?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  header_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  keywords?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  reference_zone_id?: InputMaybe<Order_By>;
  search_text?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zone_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Search_Slugs_Min_Fields = {
  __typename?: 'search_slugs_min_fields';
  cluster?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  header_text?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Scalars['String']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  reference_zone_id?: Maybe<Scalars['uuid']['output']>;
  search_text?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  zone_name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "search_slugs" */
export type Search_Slugs_Min_Order_By = {
  cluster?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  header_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  keywords?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  reference_zone_id?: InputMaybe<Order_By>;
  search_text?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zone_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "search_slugs" */
export type Search_Slugs_Mutation_Response = {
  __typename?: 'search_slugs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Slugs>;
};

/** on_conflict condition type for table "search_slugs" */
export type Search_Slugs_On_Conflict = {
  constraint: Search_Slugs_Constraint;
  update_columns?: Array<Search_Slugs_Update_Column>;
  where?: InputMaybe<Search_Slugs_Bool_Exp>;
};

/** Ordering options when selecting data from "search_slugs". */
export type Search_Slugs_Order_By = {
  cluster?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  header_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  keywords?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  questions?: InputMaybe<Order_By>;
  reference_zone_id?: InputMaybe<Order_By>;
  search_session?: InputMaybe<Search_Sessions_Order_By>;
  search_text?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  sitemap_process?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  style?: InputMaybe<Order_By>;
  testimonials?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zone_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: search_slugs */
export type Search_Slugs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Search_Slugs_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  questions?: InputMaybe<Scalars['jsonb']['input']>;
  style?: InputMaybe<Scalars['jsonb']['input']>;
  testimonials?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "search_slugs" */
export enum Search_Slugs_Select_Column {
  /** column name */
  Cluster = 'cluster',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HeaderText = 'header_text',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Keywords = 'keywords',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Questions = 'questions',
  /** column name */
  ReferenceZoneId = 'reference_zone_id',
  /** column name */
  SearchText = 'search_text',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  SitemapProcess = 'sitemap_process',
  /** column name */
  Slug = 'slug',
  /** column name */
  Style = 'style',
  /** column name */
  Testimonials = 'testimonials',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZoneName = 'zone_name'
}

/** select "search_slugs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "search_slugs" */
export enum Search_Slugs_Select_Column_Search_Slugs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  SitemapProcess = 'sitemap_process'
}

/** select "search_slugs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "search_slugs" */
export enum Search_Slugs_Select_Column_Search_Slugs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  SitemapProcess = 'sitemap_process'
}

/** input type for updating data in table "search_slugs" */
export type Search_Slugs_Set_Input = {
  cluster?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  header_text?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  questions?: InputMaybe<Scalars['jsonb']['input']>;
  reference_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  search_text?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['uuid']['input']>;
  sitemap_process?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['jsonb']['input']>;
  testimonials?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  zone_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Search_Slugs_Stddev_Fields = {
  __typename?: 'search_slugs_stddev_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "search_slugs" */
export type Search_Slugs_Stddev_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Search_Slugs_Stddev_Pop_Fields = {
  __typename?: 'search_slugs_stddev_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "search_slugs" */
export type Search_Slugs_Stddev_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Search_Slugs_Stddev_Samp_Fields = {
  __typename?: 'search_slugs_stddev_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "search_slugs" */
export type Search_Slugs_Stddev_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "search_slugs" */
export type Search_Slugs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Slugs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Slugs_Stream_Cursor_Value_Input = {
  cluster?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  header_text?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  questions?: InputMaybe<Scalars['jsonb']['input']>;
  reference_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  search_text?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['uuid']['input']>;
  sitemap_process?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['jsonb']['input']>;
  testimonials?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  zone_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Search_Slugs_Sum_Fields = {
  __typename?: 'search_slugs_sum_fields';
  language_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "search_slugs" */
export type Search_Slugs_Sum_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** update columns of table "search_slugs" */
export enum Search_Slugs_Update_Column {
  /** column name */
  Cluster = 'cluster',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HeaderText = 'header_text',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Keywords = 'keywords',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Questions = 'questions',
  /** column name */
  ReferenceZoneId = 'reference_zone_id',
  /** column name */
  SearchText = 'search_text',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  SitemapProcess = 'sitemap_process',
  /** column name */
  Slug = 'slug',
  /** column name */
  Style = 'style',
  /** column name */
  Testimonials = 'testimonials',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZoneName = 'zone_name'
}

export type Search_Slugs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Search_Slugs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Search_Slugs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Search_Slugs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Search_Slugs_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Search_Slugs_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Search_Slugs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Slugs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Slugs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Search_Slugs_Var_Pop_Fields = {
  __typename?: 'search_slugs_var_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "search_slugs" */
export type Search_Slugs_Var_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Search_Slugs_Var_Samp_Fields = {
  __typename?: 'search_slugs_var_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "search_slugs" */
export type Search_Slugs_Var_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Search_Slugs_Variance_Fields = {
  __typename?: 'search_slugs_variance_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "search_slugs" */
export type Search_Slugs_Variance_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "seo_city" */
export type Seo_City = {
  __typename?: 'seo_city';
  al_metadata: Scalars['jsonb']['output'];
  al_sections: Scalars['jsonb']['output'];
  city_name: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  en_metadata: Scalars['jsonb']['output'];
  en_sections: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  slug: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "seo_city" */
export type Seo_CityAl_MetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "seo_city" */
export type Seo_CityAl_SectionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "seo_city" */
export type Seo_CityEn_MetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "seo_city" */
export type Seo_CityEn_SectionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "seo_city" */
export type Seo_City_Aggregate = {
  __typename?: 'seo_city_aggregate';
  aggregate?: Maybe<Seo_City_Aggregate_Fields>;
  nodes: Array<Seo_City>;
};

/** aggregate fields of "seo_city" */
export type Seo_City_Aggregate_Fields = {
  __typename?: 'seo_city_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Seo_City_Max_Fields>;
  min?: Maybe<Seo_City_Min_Fields>;
};


/** aggregate fields of "seo_city" */
export type Seo_City_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Seo_City_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Seo_City_Append_Input = {
  al_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  al_sections?: InputMaybe<Scalars['jsonb']['input']>;
  en_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  en_sections?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "seo_city". All fields are combined with a logical 'AND'. */
export type Seo_City_Bool_Exp = {
  _and?: InputMaybe<Array<Seo_City_Bool_Exp>>;
  _not?: InputMaybe<Seo_City_Bool_Exp>;
  _or?: InputMaybe<Array<Seo_City_Bool_Exp>>;
  al_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  al_sections?: InputMaybe<Jsonb_Comparison_Exp>;
  city_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  en_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  en_sections?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "seo_city" */
export enum Seo_City_Constraint {
  /** unique or primary key constraint on columns "id" */
  SeoCityPkey = 'seo_city_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Seo_City_Delete_At_Path_Input = {
  al_metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  al_sections?: InputMaybe<Array<Scalars['String']['input']>>;
  en_metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  en_sections?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Seo_City_Delete_Elem_Input = {
  al_metadata?: InputMaybe<Scalars['Int']['input']>;
  al_sections?: InputMaybe<Scalars['Int']['input']>;
  en_metadata?: InputMaybe<Scalars['Int']['input']>;
  en_sections?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Seo_City_Delete_Key_Input = {
  al_metadata?: InputMaybe<Scalars['String']['input']>;
  al_sections?: InputMaybe<Scalars['String']['input']>;
  en_metadata?: InputMaybe<Scalars['String']['input']>;
  en_sections?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "seo_city" */
export type Seo_City_Insert_Input = {
  al_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  al_sections?: InputMaybe<Scalars['jsonb']['input']>;
  city_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  en_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  en_sections?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Seo_City_Max_Fields = {
  __typename?: 'seo_city_max_fields';
  city_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Seo_City_Min_Fields = {
  __typename?: 'seo_city_min_fields';
  city_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "seo_city" */
export type Seo_City_Mutation_Response = {
  __typename?: 'seo_city_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Seo_City>;
};

/** on_conflict condition type for table "seo_city" */
export type Seo_City_On_Conflict = {
  constraint: Seo_City_Constraint;
  update_columns?: Array<Seo_City_Update_Column>;
  where?: InputMaybe<Seo_City_Bool_Exp>;
};

/** Ordering options when selecting data from "seo_city". */
export type Seo_City_Order_By = {
  al_metadata?: InputMaybe<Order_By>;
  al_sections?: InputMaybe<Order_By>;
  city_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  en_metadata?: InputMaybe<Order_By>;
  en_sections?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: seo_city */
export type Seo_City_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Seo_City_Prepend_Input = {
  al_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  al_sections?: InputMaybe<Scalars['jsonb']['input']>;
  en_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  en_sections?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "seo_city" */
export enum Seo_City_Select_Column {
  /** column name */
  AlMetadata = 'al_metadata',
  /** column name */
  AlSections = 'al_sections',
  /** column name */
  CityName = 'city_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EnMetadata = 'en_metadata',
  /** column name */
  EnSections = 'en_sections',
  /** column name */
  Id = 'id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "seo_city" */
export type Seo_City_Set_Input = {
  al_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  al_sections?: InputMaybe<Scalars['jsonb']['input']>;
  city_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  en_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  en_sections?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "seo_city" */
export type Seo_City_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seo_City_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seo_City_Stream_Cursor_Value_Input = {
  al_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  al_sections?: InputMaybe<Scalars['jsonb']['input']>;
  city_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  en_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  en_sections?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "seo_city" */
export enum Seo_City_Update_Column {
  /** column name */
  AlMetadata = 'al_metadata',
  /** column name */
  AlSections = 'al_sections',
  /** column name */
  CityName = 'city_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EnMetadata = 'en_metadata',
  /** column name */
  EnSections = 'en_sections',
  /** column name */
  Id = 'id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Seo_City_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Seo_City_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Seo_City_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Seo_City_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Seo_City_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Seo_City_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Seo_City_Set_Input>;
  /** filter the rows which have to be updated */
  where: Seo_City_Bool_Exp;
};

/** columns and relationships of "session_origin" */
export type Session_Origin = {
  __typename?: 'session_origin';
  origin: Scalars['String']['output'];
};

/** aggregated selection of "session_origin" */
export type Session_Origin_Aggregate = {
  __typename?: 'session_origin_aggregate';
  aggregate?: Maybe<Session_Origin_Aggregate_Fields>;
  nodes: Array<Session_Origin>;
};

/** aggregate fields of "session_origin" */
export type Session_Origin_Aggregate_Fields = {
  __typename?: 'session_origin_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Session_Origin_Max_Fields>;
  min?: Maybe<Session_Origin_Min_Fields>;
};


/** aggregate fields of "session_origin" */
export type Session_Origin_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Session_Origin_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "session_origin". All fields are combined with a logical 'AND'. */
export type Session_Origin_Bool_Exp = {
  _and?: InputMaybe<Array<Session_Origin_Bool_Exp>>;
  _not?: InputMaybe<Session_Origin_Bool_Exp>;
  _or?: InputMaybe<Array<Session_Origin_Bool_Exp>>;
  origin?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "session_origin" */
export enum Session_Origin_Constraint {
  /** unique or primary key constraint on columns "origin" */
  SessionOriginPkey = 'session_origin_pkey'
}

export enum Session_Origin_Enum {
  Kaktu = 'KAKTU',
  SearchEngine = 'SEARCH_ENGINE',
  Whatsapp = 'WHATSAPP'
}

/** Boolean expression to compare columns of type "session_origin_enum". All fields are combined with logical 'AND'. */
export type Session_Origin_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Session_Origin_Enum>;
  _in?: InputMaybe<Array<Session_Origin_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Session_Origin_Enum>;
  _nin?: InputMaybe<Array<Session_Origin_Enum>>;
};

/** input type for inserting data into table "session_origin" */
export type Session_Origin_Insert_Input = {
  origin?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Session_Origin_Max_Fields = {
  __typename?: 'session_origin_max_fields';
  origin?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Session_Origin_Min_Fields = {
  __typename?: 'session_origin_min_fields';
  origin?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "session_origin" */
export type Session_Origin_Mutation_Response = {
  __typename?: 'session_origin_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Session_Origin>;
};

/** input type for inserting object relation for remote table "session_origin" */
export type Session_Origin_Obj_Rel_Insert_Input = {
  data: Session_Origin_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Session_Origin_On_Conflict>;
};

/** on_conflict condition type for table "session_origin" */
export type Session_Origin_On_Conflict = {
  constraint: Session_Origin_Constraint;
  update_columns?: Array<Session_Origin_Update_Column>;
  where?: InputMaybe<Session_Origin_Bool_Exp>;
};

/** Ordering options when selecting data from "session_origin". */
export type Session_Origin_Order_By = {
  origin?: InputMaybe<Order_By>;
};

/** primary key columns input for table: session_origin */
export type Session_Origin_Pk_Columns_Input = {
  origin: Scalars['String']['input'];
};

/** select columns of table "session_origin" */
export enum Session_Origin_Select_Column {
  /** column name */
  Origin = 'origin'
}

/** input type for updating data in table "session_origin" */
export type Session_Origin_Set_Input = {
  origin?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "session_origin" */
export type Session_Origin_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Session_Origin_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Session_Origin_Stream_Cursor_Value_Input = {
  origin?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "session_origin" */
export enum Session_Origin_Update_Column {
  /** column name */
  Origin = 'origin'
}

export type Session_Origin_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Session_Origin_Set_Input>;
  /** filter the rows which have to be updated */
  where: Session_Origin_Bool_Exp;
};

/** columns and relationships of "sponsored_property_list" */
export type Sponsored_Property_List = {
  __typename?: 'sponsored_property_list';
  created_at: Scalars['timestamptz']['output'];
  end_date: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  product_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  property_list: Property_List;
  property_list_id: Scalars['uuid']['output'];
  start_date: Scalars['date']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "sponsored_property_list" */
export type Sponsored_Property_List_Aggregate = {
  __typename?: 'sponsored_property_list_aggregate';
  aggregate?: Maybe<Sponsored_Property_List_Aggregate_Fields>;
  nodes: Array<Sponsored_Property_List>;
};

export type Sponsored_Property_List_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sponsored_Property_List_Aggregate_Bool_Exp_Count>;
};

export type Sponsored_Property_List_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sponsored_Property_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sponsored_property_list" */
export type Sponsored_Property_List_Aggregate_Fields = {
  __typename?: 'sponsored_property_list_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sponsored_Property_List_Max_Fields>;
  min?: Maybe<Sponsored_Property_List_Min_Fields>;
};


/** aggregate fields of "sponsored_property_list" */
export type Sponsored_Property_List_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sponsored_Property_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sponsored_property_list" */
export type Sponsored_Property_List_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sponsored_Property_List_Max_Order_By>;
  min?: InputMaybe<Sponsored_Property_List_Min_Order_By>;
};

/** input type for inserting array relation for remote table "sponsored_property_list" */
export type Sponsored_Property_List_Arr_Rel_Insert_Input = {
  data: Array<Sponsored_Property_List_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sponsored_Property_List_On_Conflict>;
};

/** Boolean expression to filter rows from the table "sponsored_property_list". All fields are combined with a logical 'AND'. */
export type Sponsored_Property_List_Bool_Exp = {
  _and?: InputMaybe<Array<Sponsored_Property_List_Bool_Exp>>;
  _not?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
  _or?: InputMaybe<Array<Sponsored_Property_List_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_list?: InputMaybe<Property_List_Bool_Exp>;
  property_list_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sponsored_property_list" */
export enum Sponsored_Property_List_Constraint {
  /** unique or primary key constraint on columns "id" */
  SponsoredPropertyListPkey = 'sponsored_property_list_pkey'
}

/** input type for inserting data into table "sponsored_property_list" */
export type Sponsored_Property_List_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list?: InputMaybe<Property_List_Obj_Rel_Insert_Input>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Sponsored_Property_List_Max_Fields = {
  __typename?: 'sponsored_property_list_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "sponsored_property_list" */
export type Sponsored_Property_List_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sponsored_Property_List_Min_Fields = {
  __typename?: 'sponsored_property_list_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  property_list_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "sponsored_property_list" */
export type Sponsored_Property_List_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sponsored_property_list" */
export type Sponsored_Property_List_Mutation_Response = {
  __typename?: 'sponsored_property_list_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sponsored_Property_List>;
};

/** on_conflict condition type for table "sponsored_property_list" */
export type Sponsored_Property_List_On_Conflict = {
  constraint: Sponsored_Property_List_Constraint;
  update_columns?: Array<Sponsored_Property_List_Update_Column>;
  where?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
};

/** Ordering options when selecting data from "sponsored_property_list". */
export type Sponsored_Property_List_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  property_list?: InputMaybe<Property_List_Order_By>;
  property_list_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sponsored_property_list */
export type Sponsored_Property_List_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "sponsored_property_list" */
export enum Sponsored_Property_List_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "sponsored_property_list" */
export type Sponsored_Property_List_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "sponsored_property_list" */
export type Sponsored_Property_List_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sponsored_Property_List_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sponsored_Property_List_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  property_list_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "sponsored_property_list" */
export enum Sponsored_Property_List_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  PropertyListId = 'property_list_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Sponsored_Property_List_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sponsored_Property_List_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sponsored_Property_List_Bool_Exp;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

/** columns and relationships of "subscription" */
export type Subscription = {
  __typename?: 'subscription';
  active: Scalars['Boolean']['output'];
  /** A computed field, executes function "get_subscription_active_members" */
  active_members?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  cancel_at_period_end?: Maybe<Scalars['Boolean']['output']>;
  cancellation_details?: Maybe<Scalars['jsonb']['output']>;
  cancelled_at?: Maybe<Scalars['date']['output']>;
  created_at: Scalars['timestamptz']['output'];
  end_date: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  max_members?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  parent_subscription_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  plan: Plan;
  plan_id: Scalars['uuid']['output'];
  source?: Maybe<Subscription_Source_Enum>;
  start_date: Scalars['date']['output'];
  status?: Maybe<Subscription_Status_Enum>;
  stripe_subscription_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  subscription_invoices: Array<Subscription_Invoice>;
  /** An aggregate relationship */
  subscription_invoices_aggregate: Subscription_Invoice_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "subscription" */
export type SubscriptionCancellation_DetailsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscription" */
export type SubscriptionSubscription_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Invoice_Order_By>>;
  where?: InputMaybe<Subscription_Invoice_Bool_Exp>;
};


/** columns and relationships of "subscription" */
export type SubscriptionSubscription_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Invoice_Order_By>>;
  where?: InputMaybe<Subscription_Invoice_Bool_Exp>;
};

/** aggregated selection of "subscription" */
export type Subscription_Aggregate = {
  __typename?: 'subscription_aggregate';
  aggregate?: Maybe<Subscription_Aggregate_Fields>;
  nodes: Array<Subscription>;
};

export type Subscription_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Subscription_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Subscription_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Subscription_Aggregate_Bool_Exp_Count>;
};

export type Subscription_Aggregate_Bool_Exp_Bool_And = {
  arguments: Subscription_Select_Column_Subscription_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscription_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscription_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Subscription_Select_Column_Subscription_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscription_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscription_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscription_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscription" */
export type Subscription_Aggregate_Fields = {
  __typename?: 'subscription_aggregate_fields';
  avg?: Maybe<Subscription_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscription_Max_Fields>;
  min?: Maybe<Subscription_Min_Fields>;
  stddev?: Maybe<Subscription_Stddev_Fields>;
  stddev_pop?: Maybe<Subscription_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscription_Stddev_Samp_Fields>;
  sum?: Maybe<Subscription_Sum_Fields>;
  var_pop?: Maybe<Subscription_Var_Pop_Fields>;
  var_samp?: Maybe<Subscription_Var_Samp_Fields>;
  variance?: Maybe<Subscription_Variance_Fields>;
};


/** aggregate fields of "subscription" */
export type Subscription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subscription" */
export type Subscription_Aggregate_Order_By = {
  avg?: InputMaybe<Subscription_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscription_Max_Order_By>;
  min?: InputMaybe<Subscription_Min_Order_By>;
  stddev?: InputMaybe<Subscription_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscription_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscription_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscription_Sum_Order_By>;
  var_pop?: InputMaybe<Subscription_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscription_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscription_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Subscription_Append_Input = {
  cancellation_details?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "subscription" */
export type Subscription_Arr_Rel_Insert_Input = {
  data: Array<Subscription_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscription_Avg_Fields = {
  __typename?: 'subscription_avg_fields';
  /** A computed field, executes function "get_subscription_active_members" */
  active_members?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  max_members?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "subscription" */
export type Subscription_Avg_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  max_members?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscription". All fields are combined with a logical 'AND'. */
export type Subscription_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  active_members?: InputMaybe<Int_Comparison_Exp>;
  amount_paid?: InputMaybe<Numeric_Comparison_Exp>;
  cancel_at_period_end?: InputMaybe<Boolean_Comparison_Exp>;
  cancellation_details?: InputMaybe<Jsonb_Comparison_Exp>;
  cancelled_at?: InputMaybe<Date_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  max_members?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  plan?: InputMaybe<Plan_Bool_Exp>;
  plan_id?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<Subscription_Source_Enum_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Subscription_Status_Enum_Comparison_Exp>;
  stripe_subscription_id?: InputMaybe<String_Comparison_Exp>;
  subscription_invoices?: InputMaybe<Subscription_Invoice_Bool_Exp>;
  subscription_invoices_aggregate?: InputMaybe<Subscription_Invoice_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription" */
export enum Subscription_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationPlanPkey = 'organization_plan_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Subscription_Delete_At_Path_Input = {
  cancellation_details?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Subscription_Delete_Elem_Input = {
  cancellation_details?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Subscription_Delete_Key_Input = {
  cancellation_details?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "subscription" */
export type Subscription_Inc_Input = {
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  max_members?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "subscription" */
export type Subscription_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  cancel_at_period_end?: InputMaybe<Scalars['Boolean']['input']>;
  cancellation_details?: InputMaybe<Scalars['jsonb']['input']>;
  cancelled_at?: InputMaybe<Scalars['date']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  max_members?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  plan?: InputMaybe<Plan_Obj_Rel_Insert_Input>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Subscription_Source_Enum>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Subscription_Status_Enum>;
  stripe_subscription_id?: InputMaybe<Scalars['String']['input']>;
  subscription_invoices?: InputMaybe<Subscription_Invoice_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "subscription_invoice" */
export type Subscription_Invoice = {
  __typename?: 'subscription_invoice';
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  end_date: Scalars['date']['output'];
  free_trial?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  invoice_url?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  number_of_posts?: Maybe<Scalars['Int']['output']>;
  number_of_social_channels?: Maybe<Scalars['Int']['output']>;
  number_of_social_posts?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  order?: Maybe<Order>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  start_date: Scalars['date']['output'];
  status: Scalars['String']['output'];
  stripe_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  subscription: Subscription;
  subscription_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "subscription_invoice" */
export type Subscription_InvoiceMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "subscription_invoice" */
export type Subscription_Invoice_Aggregate = {
  __typename?: 'subscription_invoice_aggregate';
  aggregate?: Maybe<Subscription_Invoice_Aggregate_Fields>;
  nodes: Array<Subscription_Invoice>;
};

export type Subscription_Invoice_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Subscription_Invoice_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Subscription_Invoice_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Subscription_Invoice_Aggregate_Bool_Exp_Count>;
};

export type Subscription_Invoice_Aggregate_Bool_Exp_Bool_And = {
  arguments: Subscription_Invoice_Select_Column_Subscription_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscription_Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscription_Invoice_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Subscription_Invoice_Select_Column_Subscription_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscription_Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscription_Invoice_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscription_Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscription_Invoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscription_invoice" */
export type Subscription_Invoice_Aggregate_Fields = {
  __typename?: 'subscription_invoice_aggregate_fields';
  avg?: Maybe<Subscription_Invoice_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscription_Invoice_Max_Fields>;
  min?: Maybe<Subscription_Invoice_Min_Fields>;
  stddev?: Maybe<Subscription_Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Subscription_Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscription_Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Subscription_Invoice_Sum_Fields>;
  var_pop?: Maybe<Subscription_Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Subscription_Invoice_Var_Samp_Fields>;
  variance?: Maybe<Subscription_Invoice_Variance_Fields>;
};


/** aggregate fields of "subscription_invoice" */
export type Subscription_Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subscription_invoice" */
export type Subscription_Invoice_Aggregate_Order_By = {
  avg?: InputMaybe<Subscription_Invoice_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscription_Invoice_Max_Order_By>;
  min?: InputMaybe<Subscription_Invoice_Min_Order_By>;
  stddev?: InputMaybe<Subscription_Invoice_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscription_Invoice_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscription_Invoice_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscription_Invoice_Sum_Order_By>;
  var_pop?: InputMaybe<Subscription_Invoice_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscription_Invoice_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscription_Invoice_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Subscription_Invoice_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "subscription_invoice" */
export type Subscription_Invoice_Arr_Rel_Insert_Input = {
  data: Array<Subscription_Invoice_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Invoice_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscription_Invoice_Avg_Fields = {
  __typename?: 'subscription_invoice_avg_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "subscription_invoice" */
export type Subscription_Invoice_Avg_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  number_of_posts?: InputMaybe<Order_By>;
  number_of_social_channels?: InputMaybe<Order_By>;
  number_of_social_posts?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscription_invoice". All fields are combined with a logical 'AND'. */
export type Subscription_Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Invoice_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Invoice_Bool_Exp>>;
  amount_paid?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  free_trial?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_url?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  number_of_posts?: InputMaybe<Int_Comparison_Exp>;
  number_of_social_channels?: InputMaybe<Int_Comparison_Exp>;
  number_of_social_posts?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  order_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  stripe_id?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<Subscription_Bool_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_invoice" */
export enum Subscription_Invoice_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionInvoicePkey = 'subscription_invoice_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Subscription_Invoice_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Subscription_Invoice_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Subscription_Invoice_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "subscription_invoice" */
export type Subscription_Invoice_Inc_Input = {
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  number_of_posts?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_channels?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_posts?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "subscription_invoice" */
export type Subscription_Invoice_Insert_Input = {
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  free_trial?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_url?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  number_of_posts?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_channels?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_posts?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Order_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  subscription?: InputMaybe<Subscription_Obj_Rel_Insert_Input>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Subscription_Invoice_Max_Fields = {
  __typename?: 'subscription_invoice_max_fields';
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_url?: Maybe<Scalars['String']['output']>;
  number_of_posts?: Maybe<Scalars['Int']['output']>;
  number_of_social_channels?: Maybe<Scalars['Int']['output']>;
  number_of_social_posts?: Maybe<Scalars['Int']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "subscription_invoice" */
export type Subscription_Invoice_Max_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_url?: InputMaybe<Order_By>;
  number_of_posts?: InputMaybe<Order_By>;
  number_of_social_channels?: InputMaybe<Order_By>;
  number_of_social_posts?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscription_Invoice_Min_Fields = {
  __typename?: 'subscription_invoice_min_fields';
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_url?: Maybe<Scalars['String']['output']>;
  number_of_posts?: Maybe<Scalars['Int']['output']>;
  number_of_social_channels?: Maybe<Scalars['Int']['output']>;
  number_of_social_posts?: Maybe<Scalars['Int']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "subscription_invoice" */
export type Subscription_Invoice_Min_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_url?: InputMaybe<Order_By>;
  number_of_posts?: InputMaybe<Order_By>;
  number_of_social_channels?: InputMaybe<Order_By>;
  number_of_social_posts?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscription_invoice" */
export type Subscription_Invoice_Mutation_Response = {
  __typename?: 'subscription_invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Invoice>;
};

/** on_conflict condition type for table "subscription_invoice" */
export type Subscription_Invoice_On_Conflict = {
  constraint: Subscription_Invoice_Constraint;
  update_columns?: Array<Subscription_Invoice_Update_Column>;
  where?: InputMaybe<Subscription_Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_invoice". */
export type Subscription_Invoice_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  free_trial?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_url?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  number_of_posts?: InputMaybe<Order_By>;
  number_of_social_channels?: InputMaybe<Order_By>;
  number_of_social_posts?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  order_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscription_Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription_invoice */
export type Subscription_Invoice_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Subscription_Invoice_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "subscription_invoice" */
export enum Subscription_Invoice_Select_Column {
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  FreeTrial = 'free_trial',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceUrl = 'invoice_url',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NumberOfPosts = 'number_of_posts',
  /** column name */
  NumberOfSocialChannels = 'number_of_social_channels',
  /** column name */
  NumberOfSocialPosts = 'number_of_social_posts',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "subscription_invoice_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subscription_invoice" */
export enum Subscription_Invoice_Select_Column_Subscription_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FreeTrial = 'free_trial'
}

/** select "subscription_invoice_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subscription_invoice" */
export enum Subscription_Invoice_Select_Column_Subscription_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FreeTrial = 'free_trial'
}

/** input type for updating data in table "subscription_invoice" */
export type Subscription_Invoice_Set_Input = {
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  free_trial?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_url?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  number_of_posts?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_channels?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_posts?: InputMaybe<Scalars['Int']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Subscription_Invoice_Stddev_Fields = {
  __typename?: 'subscription_invoice_stddev_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "subscription_invoice" */
export type Subscription_Invoice_Stddev_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  number_of_posts?: InputMaybe<Order_By>;
  number_of_social_channels?: InputMaybe<Order_By>;
  number_of_social_posts?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscription_Invoice_Stddev_Pop_Fields = {
  __typename?: 'subscription_invoice_stddev_pop_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "subscription_invoice" */
export type Subscription_Invoice_Stddev_Pop_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  number_of_posts?: InputMaybe<Order_By>;
  number_of_social_channels?: InputMaybe<Order_By>;
  number_of_social_posts?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscription_Invoice_Stddev_Samp_Fields = {
  __typename?: 'subscription_invoice_stddev_samp_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "subscription_invoice" */
export type Subscription_Invoice_Stddev_Samp_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  number_of_posts?: InputMaybe<Order_By>;
  number_of_social_channels?: InputMaybe<Order_By>;
  number_of_social_posts?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscription_invoice" */
export type Subscription_Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Invoice_Stream_Cursor_Value_Input = {
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  free_trial?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_url?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  number_of_posts?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_channels?: InputMaybe<Scalars['Int']['input']>;
  number_of_social_posts?: InputMaybe<Scalars['Int']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Subscription_Invoice_Sum_Fields = {
  __typename?: 'subscription_invoice_sum_fields';
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  number_of_posts?: Maybe<Scalars['Int']['output']>;
  number_of_social_channels?: Maybe<Scalars['Int']['output']>;
  number_of_social_posts?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "subscription_invoice" */
export type Subscription_Invoice_Sum_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  number_of_posts?: InputMaybe<Order_By>;
  number_of_social_channels?: InputMaybe<Order_By>;
  number_of_social_posts?: InputMaybe<Order_By>;
};

/** update columns of table "subscription_invoice" */
export enum Subscription_Invoice_Update_Column {
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  FreeTrial = 'free_trial',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceUrl = 'invoice_url',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NumberOfPosts = 'number_of_posts',
  /** column name */
  NumberOfSocialChannels = 'number_of_social_channels',
  /** column name */
  NumberOfSocialPosts = 'number_of_social_posts',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscription_Invoice_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Subscription_Invoice_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Subscription_Invoice_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Subscription_Invoice_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Subscription_Invoice_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscription_Invoice_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Subscription_Invoice_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscription_Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscription_Invoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscription_Invoice_Var_Pop_Fields = {
  __typename?: 'subscription_invoice_var_pop_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "subscription_invoice" */
export type Subscription_Invoice_Var_Pop_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  number_of_posts?: InputMaybe<Order_By>;
  number_of_social_channels?: InputMaybe<Order_By>;
  number_of_social_posts?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscription_Invoice_Var_Samp_Fields = {
  __typename?: 'subscription_invoice_var_samp_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "subscription_invoice" */
export type Subscription_Invoice_Var_Samp_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  number_of_posts?: InputMaybe<Order_By>;
  number_of_social_channels?: InputMaybe<Order_By>;
  number_of_social_posts?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscription_Invoice_Variance_Fields = {
  __typename?: 'subscription_invoice_variance_fields';
  amount_paid?: Maybe<Scalars['Float']['output']>;
  number_of_posts?: Maybe<Scalars['Float']['output']>;
  number_of_social_channels?: Maybe<Scalars['Float']['output']>;
  number_of_social_posts?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "subscription_invoice" */
export type Subscription_Invoice_Variance_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  number_of_posts?: InputMaybe<Order_By>;
  number_of_social_channels?: InputMaybe<Order_By>;
  number_of_social_posts?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Subscription_Max_Fields = {
  __typename?: 'subscription_max_fields';
  /** A computed field, executes function "get_subscription_active_members" */
  active_members?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  cancelled_at?: Maybe<Scalars['date']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  max_members?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  parent_subscription_id?: Maybe<Scalars['uuid']['output']>;
  plan_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  stripe_subscription_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "subscription" */
export type Subscription_Max_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_members?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parent_subscription_id?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  stripe_subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscription_Min_Fields = {
  __typename?: 'subscription_min_fields';
  /** A computed field, executes function "get_subscription_active_members" */
  active_members?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  cancelled_at?: Maybe<Scalars['date']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  max_members?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  parent_subscription_id?: Maybe<Scalars['uuid']['output']>;
  plan_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  stripe_subscription_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "subscription" */
export type Subscription_Min_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_members?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parent_subscription_id?: InputMaybe<Order_By>;
  plan_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  stripe_subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscription" */
export type Subscription_Mutation_Response = {
  __typename?: 'subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription>;
};

/** input type for inserting object relation for remote table "subscription" */
export type Subscription_Obj_Rel_Insert_Input = {
  data: Subscription_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_On_Conflict>;
};

/** on_conflict condition type for table "subscription" */
export type Subscription_On_Conflict = {
  constraint: Subscription_Constraint;
  update_columns?: Array<Subscription_Update_Column>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription". */
export type Subscription_Order_By = {
  active?: InputMaybe<Order_By>;
  active_members?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  cancel_at_period_end?: InputMaybe<Order_By>;
  cancellation_details?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_members?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parent_subscription_id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Plan_Order_By>;
  plan_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_subscription_id?: InputMaybe<Order_By>;
  subscription_invoices_aggregate?: InputMaybe<Subscription_Invoice_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription */
export type Subscription_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Subscription_Prepend_Input = {
  cancellation_details?: InputMaybe<Scalars['jsonb']['input']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "address_types" */
  address_types: Array<Address_Types>;
  /** fetch aggregated fields from the table: "address_types" */
  address_types_aggregate: Address_Types_Aggregate;
  /** fetch data from the table: "address_types" using primary key columns */
  address_types_by_pk?: Maybe<Address_Types>;
  /** fetch data from the table in a streaming manner: "address_types" */
  address_types_stream: Array<Address_Types>;
  /** fetch data from the table: "agency" */
  agency: Array<Agency>;
  agencyDashboardStatistics: Array<Lister_Dashboard_Model>;
  agencyScrapedProperties: Array<Agency_Properties_Model>;
  agencyViewsGraphic: Array<Daily_Views>;
  /** fetch aggregated fields from the table: "agency" */
  agency_aggregate: Agency_Aggregate;
  /** fetch data from the table: "agency" using primary key columns */
  agency_by_pk?: Maybe<Agency>;
  /** fetch data from the table: "agency_health" */
  agency_health: Array<Agency_Health>;
  /** fetch aggregated fields from the table: "agency_health" */
  agency_health_aggregate: Agency_Health_Aggregate;
  /** fetch data from the table in a streaming manner: "agency_health" */
  agency_health_stream: Array<Agency_Health>;
  /** fetch data from the table in a streaming manner: "agency" */
  agency_stream: Array<Agency>;
  /** fetch data from the table: "agency_type" */
  agency_type: Array<Agency_Type>;
  /** fetch aggregated fields from the table: "agency_type" */
  agency_type_aggregate: Agency_Type_Aggregate;
  /** fetch data from the table: "agency_type" using primary key columns */
  agency_type_by_pk?: Maybe<Agency_Type>;
  /** fetch data from the table in a streaming manner: "agency_type" */
  agency_type_stream: Array<Agency_Type>;
  /** fetch data from the table: "agent_action" */
  agent_action: Array<Agent_Action>;
  /** fetch aggregated fields from the table: "agent_action" */
  agent_action_aggregate: Agent_Action_Aggregate;
  /** fetch data from the table: "agent_action" using primary key columns */
  agent_action_by_pk?: Maybe<Agent_Action>;
  /** fetch data from the table in a streaming manner: "agent_action" */
  agent_action_stream: Array<Agent_Action>;
  /** fetch data from the table: "agent_task" */
  agent_task: Array<Agent_Task>;
  /** fetch aggregated fields from the table: "agent_task" */
  agent_task_aggregate: Agent_Task_Aggregate;
  /** fetch data from the table: "agent_task" using primary key columns */
  agent_task_by_pk?: Maybe<Agent_Task>;
  /** fetch data from the table in a streaming manner: "agent_task" */
  agent_task_stream: Array<Agent_Task>;
  /** fetch data from the table: "amenities" */
  amenities: Array<Amenities>;
  /** fetch aggregated fields from the table: "amenities" */
  amenities_aggregate: Amenities_Aggregate;
  /** fetch data from the table: "amenities" using primary key columns */
  amenities_by_pk?: Maybe<Amenities>;
  /** fetch data from the table in a streaming manner: "amenities" */
  amenities_stream: Array<Amenities>;
  /** fetch data from the table: "app_config" */
  app_config: Array<App_Config>;
  /** fetch aggregated fields from the table: "app_config" */
  app_config_aggregate: App_Config_Aggregate;
  /** fetch data from the table: "app_config" using primary key columns */
  app_config_by_pk?: Maybe<App_Config>;
  /** fetch data from the table in a streaming manner: "app_config" */
  app_config_stream: Array<App_Config>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.provider_requests" */
  authProviderRequests_stream: Array<AuthProviderRequests>;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.providers" */
  authProviders_stream: Array<AuthProviders>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes>;
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.refresh_token_types" */
  authRefreshTokenTypes_stream: Array<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.refresh_tokens" */
  authRefreshTokens_stream: Array<AuthRefreshTokens>;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.roles" */
  authRoles_stream: Array<AuthRoles>;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_providers" */
  authUserProviders_stream: Array<AuthUserProviders>;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_roles" */
  authUserRoles_stream: Array<AuthUserRoles>;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_security_keys" */
  authUserSecurityKeys_stream: Array<AuthUserSecurityKeys>;
  /** fetch data from the table: "blog" */
  blog: Array<Blog>;
  /** fetch aggregated fields from the table: "blog" */
  blog_aggregate: Blog_Aggregate;
  /** fetch data from the table: "blog" using primary key columns */
  blog_by_pk?: Maybe<Blog>;
  /** fetch data from the table: "blog_post" */
  blog_post: Array<Blog_Post>;
  /** fetch aggregated fields from the table: "blog_post" */
  blog_post_aggregate: Blog_Post_Aggregate;
  /** fetch data from the table: "blog_post" using primary key columns */
  blog_post_by_pk?: Maybe<Blog_Post>;
  /** fetch data from the table in a streaming manner: "blog_post" */
  blog_post_stream: Array<Blog_Post>;
  /** fetch data from the table: "blog_section" */
  blog_section: Array<Blog_Section>;
  /** fetch aggregated fields from the table: "blog_section" */
  blog_section_aggregate: Blog_Section_Aggregate;
  /** fetch data from the table: "blog_section" using primary key columns */
  blog_section_by_pk?: Maybe<Blog_Section>;
  /** fetch data from the table in a streaming manner: "blog_section" */
  blog_section_stream: Array<Blog_Section>;
  /** fetch data from the table: "blog_status" */
  blog_status: Array<Blog_Status>;
  /** fetch aggregated fields from the table: "blog_status" */
  blog_status_aggregate: Blog_Status_Aggregate;
  /** fetch data from the table: "blog_status" using primary key columns */
  blog_status_by_pk?: Maybe<Blog_Status>;
  /** fetch data from the table in a streaming manner: "blog_status" */
  blog_status_stream: Array<Blog_Status>;
  /** fetch data from the table in a streaming manner: "blog" */
  blog_stream: Array<Blog>;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.buckets" */
  buckets_stream: Array<Buckets>;
  /** fetch data from the table: "builder" */
  builder: Array<Builder>;
  /** fetch aggregated fields from the table: "builder" */
  builder_aggregate: Builder_Aggregate;
  /** fetch data from the table: "builder" using primary key columns */
  builder_by_pk?: Maybe<Builder>;
  /** fetch data from the table in a streaming manner: "builder" */
  builder_stream: Array<Builder>;
  /** fetch data from the table: "certified_agent" */
  certified_agent: Array<Certified_Agent>;
  /** fetch aggregated fields from the table: "certified_agent" */
  certified_agent_aggregate: Certified_Agent_Aggregate;
  /** fetch data from the table: "certified_agent" using primary key columns */
  certified_agent_by_pk?: Maybe<Certified_Agent>;
  /** fetch data from the table in a streaming manner: "certified_agent" */
  certified_agent_stream: Array<Certified_Agent>;
  /** fetch data from the table: "chat_response_type" */
  chat_response_type: Array<Chat_Response_Type>;
  /** fetch aggregated fields from the table: "chat_response_type" */
  chat_response_type_aggregate: Chat_Response_Type_Aggregate;
  /** fetch data from the table: "chat_response_type" using primary key columns */
  chat_response_type_by_pk?: Maybe<Chat_Response_Type>;
  /** fetch data from the table in a streaming manner: "chat_response_type" */
  chat_response_type_stream: Array<Chat_Response_Type>;
  /** fetch data from the table: "citizens_property_list_view" */
  citizens_property_list_view: Array<Citizens_Property_List_View>;
  /** fetch aggregated fields from the table: "citizens_property_list_view" */
  citizens_property_list_view_aggregate: Citizens_Property_List_View_Aggregate;
  /** fetch data from the table in a streaming manner: "citizens_property_list_view" */
  citizens_property_list_view_stream: Array<Citizens_Property_List_View>;
  /** fetch data from the table: "city" */
  city: Array<City>;
  /** fetch aggregated fields from the table: "city" */
  city_aggregate: City_Aggregate;
  /** fetch data from the table: "city" using primary key columns */
  city_by_pk?: Maybe<City>;
  /** fetch data from the table in a streaming manner: "city" */
  city_stream: Array<City>;
  /** fetch data from the table: "city_zone" */
  city_zone: Array<City_Zone>;
  /** fetch aggregated fields from the table: "city_zone" */
  city_zone_aggregate: City_Zone_Aggregate;
  /** fetch data from the table: "city_zone" using primary key columns */
  city_zone_by_pk?: Maybe<City_Zone>;
  /** fetch data from the table: "city_zone_origin" */
  city_zone_origin: Array<City_Zone_Origin>;
  /** fetch aggregated fields from the table: "city_zone_origin" */
  city_zone_origin_aggregate: City_Zone_Origin_Aggregate;
  /** fetch data from the table: "city_zone_origin" using primary key columns */
  city_zone_origin_by_pk?: Maybe<City_Zone_Origin>;
  /** fetch data from the table in a streaming manner: "city_zone_origin" */
  city_zone_origin_stream: Array<City_Zone_Origin>;
  /** fetch data from the table in a streaming manner: "city_zone" */
  city_zone_stream: Array<City_Zone>;
  /** fetch data from the table: "claim_request_status" */
  claim_request_status: Array<Claim_Request_Status>;
  /** fetch aggregated fields from the table: "claim_request_status" */
  claim_request_status_aggregate: Claim_Request_Status_Aggregate;
  /** fetch data from the table: "claim_request_status" using primary key columns */
  claim_request_status_by_pk?: Maybe<Claim_Request_Status>;
  /** fetch data from the table in a streaming manner: "claim_request_status" */
  claim_request_status_stream: Array<Claim_Request_Status>;
  classifiedProperties: Array<Classified_Properties_Model>;
  /** fetch data from the table: "clering" */
  clering: Array<Clering>;
  /** fetch aggregated fields from the table: "clering" */
  clering_aggregate: Clering_Aggregate;
  /** fetch data from the table: "clering" using primary key columns */
  clering_by_pk?: Maybe<Clering>;
  /** fetch data from the table in a streaming manner: "clering" */
  clering_stream: Array<Clering>;
  /** fetch data from the table: "construction_status" */
  construction_status: Array<Construction_Status>;
  /** fetch aggregated fields from the table: "construction_status" */
  construction_status_aggregate: Construction_Status_Aggregate;
  /** fetch data from the table: "construction_status" using primary key columns */
  construction_status_by_pk?: Maybe<Construction_Status>;
  /** fetch data from the table in a streaming manner: "construction_status" */
  construction_status_stream: Array<Construction_Status>;
  /** fetch data from the table: "contact" */
  contact: Array<Contact>;
  /** fetch aggregated fields from the table: "contact" */
  contact_aggregate: Contact_Aggregate;
  /** fetch data from the table: "contact" using primary key columns */
  contact_by_pk?: Maybe<Contact>;
  /** fetch data from the table: "contact_health" */
  contact_health: Array<Contact_Health>;
  /** fetch aggregated fields from the table: "contact_health" */
  contact_health_aggregate: Contact_Health_Aggregate;
  /** fetch data from the table in a streaming manner: "contact_health" */
  contact_health_stream: Array<Contact_Health>;
  /** fetch data from the table: "contact_phone_number" */
  contact_phone_number: Array<Contact_Phone_Number>;
  /** fetch aggregated fields from the table: "contact_phone_number" */
  contact_phone_number_aggregate: Contact_Phone_Number_Aggregate;
  /** fetch data from the table: "contact_phone_number" using primary key columns */
  contact_phone_number_by_pk?: Maybe<Contact_Phone_Number>;
  /** fetch data from the table in a streaming manner: "contact_phone_number" */
  contact_phone_number_stream: Array<Contact_Phone_Number>;
  /** fetch data from the table in a streaming manner: "contact" */
  contact_stream: Array<Contact>;
  /** fetch data from the table: "contact_type" */
  contact_type: Array<Contact_Type>;
  /** fetch aggregated fields from the table: "contact_type" */
  contact_type_aggregate: Contact_Type_Aggregate;
  /** fetch data from the table: "contact_type" using primary key columns */
  contact_type_by_pk?: Maybe<Contact_Type>;
  /** fetch data from the table in a streaming manner: "contact_type" */
  contact_type_stream: Array<Contact_Type>;
  /** fetch data from the table: "content_type" */
  content_type: Array<Content_Type>;
  /** fetch aggregated fields from the table: "content_type" */
  content_type_aggregate: Content_Type_Aggregate;
  /** fetch data from the table: "content_type" using primary key columns */
  content_type_by_pk?: Maybe<Content_Type>;
  /** fetch data from the table in a streaming manner: "content_type" */
  content_type_stream: Array<Content_Type>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch aggregated fields from the table: "countries" */
  countries_aggregate: Countries_Aggregate;
  /** fetch data from the table: "countries" using primary key columns */
  countries_by_pk?: Maybe<Countries>;
  /** fetch data from the table in a streaming manner: "countries" */
  countries_stream: Array<Countries>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table in a streaming manner: "country" */
  country_stream: Array<Country>;
  /** fetch data from the table: "currency" */
  currency: Array<Currency>;
  /** fetch aggregated fields from the table: "currency" */
  currency_aggregate: Currency_Aggregate;
  /** fetch data from the table: "currency" using primary key columns */
  currency_by_pk?: Maybe<Currency>;
  /** fetch data from the table: "currency_exchange_rates" */
  currency_exchange_rates: Array<Currency_Exchange_Rates>;
  /** fetch aggregated fields from the table: "currency_exchange_rates" */
  currency_exchange_rates_aggregate: Currency_Exchange_Rates_Aggregate;
  /** fetch data from the table: "currency_exchange_rates" using primary key columns */
  currency_exchange_rates_by_pk?: Maybe<Currency_Exchange_Rates>;
  /** fetch data from the table in a streaming manner: "currency_exchange_rates" */
  currency_exchange_rates_stream: Array<Currency_Exchange_Rates>;
  /** fetch data from the table in a streaming manner: "currency" */
  currency_stream: Array<Currency>;
  dailyRegisteredUsers: Array<Daily_Active_Users_Model>;
  daliyActiveUsers: Array<Daily_Active_Users_Model>;
  daliyQueriesStatistics: Array<Daliy_Queries_Statistics_Model>;
  /** fetch data from the table: "duplicate_cfn_with_null_cname" */
  duplicate_cfn_with_null_cname: Array<Duplicate_Cfn_With_Null_Cname>;
  /** fetch aggregated fields from the table: "duplicate_cfn_with_null_cname" */
  duplicate_cfn_with_null_cname_aggregate: Duplicate_Cfn_With_Null_Cname_Aggregate;
  /** fetch data from the table in a streaming manner: "duplicate_cfn_with_null_cname" */
  duplicate_cfn_with_null_cname_stream: Array<Duplicate_Cfn_With_Null_Cname>;
  /** fetch data from the table: "duplicate_phone_numbers" */
  duplicate_phone_numbers: Array<Duplicate_Phone_Numbers>;
  /** fetch aggregated fields from the table: "duplicate_phone_numbers" */
  duplicate_phone_numbers_aggregate: Duplicate_Phone_Numbers_Aggregate;
  /** fetch data from the table in a streaming manner: "duplicate_phone_numbers" */
  duplicate_phone_numbers_stream: Array<Duplicate_Phone_Numbers>;
  /** fetch data from the table: "entities" */
  entities: Array<Entities>;
  /** fetch aggregated fields from the table: "entities" */
  entities_aggregate: Entities_Aggregate;
  /** fetch data from the table: "entities" using primary key columns */
  entities_by_pk?: Maybe<Entities>;
  /** fetch data from the table in a streaming manner: "entities" */
  entities_stream: Array<Entities>;
  /** fetch data from the table: "exchange_rates" */
  exchange_rates: Array<Exchange_Rates>;
  /** fetch aggregated fields from the table: "exchange_rates" */
  exchange_rates_aggregate: Exchange_Rates_Aggregate;
  /** fetch data from the table: "exchange_rates" using primary key columns */
  exchange_rates_by_pk?: Maybe<Exchange_Rates>;
  /** fetch data from the table in a streaming manner: "exchange_rates" */
  exchange_rates_stream: Array<Exchange_Rates>;
  favouritePropertiesTrend: Array<Favourite_Properties_Trend_Model>;
  /** fetch data from the table: "feature" */
  feature: Array<Feature>;
  /** fetch aggregated fields from the table: "feature" */
  feature_aggregate: Feature_Aggregate;
  /** fetch data from the table: "feature" using primary key columns */
  feature_by_pk?: Maybe<Feature>;
  /** fetch data from the table in a streaming manner: "feature" */
  feature_stream: Array<Feature>;
  /** fetch data from the table: "feature_type" */
  feature_type: Array<Feature_Type>;
  /** fetch aggregated fields from the table: "feature_type" */
  feature_type_aggregate: Feature_Type_Aggregate;
  /** fetch data from the table: "feature_type" using primary key columns */
  feature_type_by_pk?: Maybe<Feature_Type>;
  /** fetch data from the table in a streaming manner: "feature_type" */
  feature_type_stream: Array<Feature_Type>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** fetch data from the table: "file_type" */
  file_type: Array<File_Type>;
  /** fetch aggregated fields from the table: "file_type" */
  file_type_aggregate: File_Type_Aggregate;
  /** fetch data from the table: "file_type" using primary key columns */
  file_type_by_pk?: Maybe<File_Type>;
  /** fetch data from the table in a streaming manner: "file_type" */
  file_type_stream: Array<File_Type>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.files" */
  files_stream: Array<Files>;
  /** An array relationship */
  folder_amenities: Array<Folder_Amenities>;
  /** An aggregate relationship */
  folder_amenities_aggregate: Folder_Amenities_Aggregate;
  /** fetch data from the table: "folder_amenities" using primary key columns */
  folder_amenities_by_pk?: Maybe<Folder_Amenities>;
  /** fetch data from the table in a streaming manner: "folder_amenities" */
  folder_amenities_stream: Array<Folder_Amenities>;
  /** fetch data from the table: "folder_image" */
  folder_image: Array<Folder_Image>;
  /** fetch aggregated fields from the table: "folder_image" */
  folder_image_aggregate: Folder_Image_Aggregate;
  /** fetch data from the table: "folder_image" using primary key columns */
  folder_image_by_pk?: Maybe<Folder_Image>;
  /** fetch data from the table in a streaming manner: "folder_image" */
  folder_image_stream: Array<Folder_Image>;
  /** fetch data from the table: "folder_properties_type" */
  folder_properties_type: Array<Folder_Properties_Type>;
  /** fetch aggregated fields from the table: "folder_properties_type" */
  folder_properties_type_aggregate: Folder_Properties_Type_Aggregate;
  /** fetch data from the table: "folder_properties_type" using primary key columns */
  folder_properties_type_by_pk?: Maybe<Folder_Properties_Type>;
  /** fetch data from the table in a streaming manner: "folder_properties_type" */
  folder_properties_type_stream: Array<Folder_Properties_Type>;
  /** fetch data from the table: "folder_status" */
  folder_status: Array<Folder_Status>;
  /** fetch aggregated fields from the table: "folder_status" */
  folder_status_aggregate: Folder_Status_Aggregate;
  /** fetch data from the table: "folder_status" using primary key columns */
  folder_status_by_pk?: Maybe<Folder_Status>;
  /** fetch data from the table in a streaming manner: "folder_status" */
  folder_status_stream: Array<Folder_Status>;
  /** fetch data from the table: "folder_type" */
  folder_type: Array<Folder_Type>;
  /** fetch aggregated fields from the table: "folder_type" */
  folder_type_aggregate: Folder_Type_Aggregate;
  /** fetch data from the table: "folder_type" using primary key columns */
  folder_type_by_pk?: Maybe<Folder_Type>;
  /** fetch data from the table in a streaming manner: "folder_type" */
  folder_type_stream: Array<Folder_Type>;
  /** fetch data from the table: "furnishing_status" */
  furnishing_status: Array<Furnishing_Status>;
  /** fetch aggregated fields from the table: "furnishing_status" */
  furnishing_status_aggregate: Furnishing_Status_Aggregate;
  /** fetch data from the table: "furnishing_status" using primary key columns */
  furnishing_status_by_pk?: Maybe<Furnishing_Status>;
  /** fetch data from the table in a streaming manner: "furnishing_status" */
  furnishing_status_stream: Array<Furnishing_Status>;
  getCityZoneForCoords: Array<City_Zone_Object>;
  getOrderByRelevanceCityZones: Array<City_Zone_Object>;
  getOrderByRelevanceFormattedAddressCityZones: Array<City_Zone_Object>;
  /** execute function "get_citizens_property_list_function" which returns "property_list" */
  get_citizens_property_list_function: Array<Property_List>;
  /** execute function "get_citizens_property_list_function" and query aggregates on result of table type "property_list" */
  get_citizens_property_list_function_aggregate: Property_List_Aggregate;
  /** execute function "get_folders_without_property_list" which returns "property_folder" */
  get_folders_without_property_list: Array<Property_Folder>;
  /** execute function "get_folders_without_property_list" and query aggregates on result of table type "property_folder" */
  get_folders_without_property_list_aggregate: Property_Folder_Aggregate;
  /** execute function "get_search_sessions_sorted_by_last_query" which returns "search_sessions" */
  get_search_sessions_sorted_by_last_query: Array<Search_Sessions>;
  /** execute function "get_search_sessions_sorted_by_last_query" and query aggregates on result of table type "search_sessions" */
  get_search_sessions_sorted_by_last_query_aggregate: Search_Sessions_Aggregate;
  /** execute function "get_similar_agencies_by_name" which returns "agency" */
  get_similar_agencies_by_name: Array<Agency>;
  /** execute function "get_similar_agencies_by_name" and query aggregates on result of table type "agency" */
  get_similar_agencies_by_name_aggregate: Agency_Aggregate;
  /** execute function "get_similar_properties" which returns "property" */
  get_similar_properties: Array<Property>;
  /** execute function "get_similar_properties" and query aggregates on result of table type "property" */
  get_similar_properties_aggregate: Property_Aggregate;
  /** execute function "get_similar_properties_by_slug" which returns "property" */
  get_similar_properties_by_slug: Array<Property>;
  /** execute function "get_similar_properties_by_slug" and query aggregates on result of table type "property" */
  get_similar_properties_by_slug_aggregate: Property_Aggregate;
  /** execute function "get_top_neighborhood_for_city_zone" which returns "city_zone" */
  get_top_neighborhood_for_city_zone: Array<City_Zone>;
  /** execute function "get_top_neighborhood_for_city_zone" and query aggregates on result of table type "city_zone" */
  get_top_neighborhood_for_city_zone_aggregate: City_Zone_Aggregate;
  /** execute function "get_user_activity" which returns "users_activity_summary" */
  get_user_activity: Array<Users_Activity_Summary>;
  /** execute function "get_user_activity" and query aggregates on result of table type "users_activity_summary" */
  get_user_activity_aggregate: Users_Activity_Summary_Aggregate;
  /** fetch data from the table: "google_calendar" */
  google_calendar: Array<Google_Calendar>;
  /** fetch aggregated fields from the table: "google_calendar" */
  google_calendar_aggregate: Google_Calendar_Aggregate;
  /** fetch data from the table: "google_calendar" using primary key columns */
  google_calendar_by_pk?: Maybe<Google_Calendar>;
  /** fetch data from the table in a streaming manner: "google_calendar" */
  google_calendar_stream: Array<Google_Calendar>;
  /** fetch data from the table: "heatingType" */
  heatingType: Array<HeatingType>;
  /** fetch aggregated fields from the table: "heatingType" */
  heatingType_aggregate: HeatingType_Aggregate;
  /** fetch data from the table: "heatingType" using primary key columns */
  heatingType_by_pk?: Maybe<HeatingType>;
  /** fetch data from the table in a streaming manner: "heatingType" */
  heatingType_stream: Array<HeatingType>;
  /** fetch data from the table: "image" */
  image: Array<Image>;
  /** fetch aggregated fields from the table: "image" */
  image_aggregate: Image_Aggregate;
  /** fetch data from the table: "image" using primary key columns */
  image_by_pk?: Maybe<Image>;
  /** fetch data from the table in a streaming manner: "image" */
  image_stream: Array<Image>;
  /** fetch data from the table: "invoice_status" */
  invoice_status: Array<Invoice_Status>;
  /** fetch aggregated fields from the table: "invoice_status" */
  invoice_status_aggregate: Invoice_Status_Aggregate;
  /** fetch data from the table: "invoice_status" using primary key columns */
  invoice_status_by_pk?: Maybe<Invoice_Status>;
  /** fetch data from the table in a streaming manner: "invoice_status" */
  invoice_status_stream: Array<Invoice_Status>;
  /** fetch data from the table: "languages" */
  languages: Array<Languages>;
  /** fetch aggregated fields from the table: "languages" */
  languages_aggregate: Languages_Aggregate;
  /** fetch data from the table: "languages" using primary key columns */
  languages_by_pk?: Maybe<Languages>;
  /** fetch data from the table in a streaming manner: "languages" */
  languages_stream: Array<Languages>;
  /** fetch data from the table: "lead_property_category" */
  lead_property_category: Array<Lead_Property_Category>;
  /** fetch aggregated fields from the table: "lead_property_category" */
  lead_property_category_aggregate: Lead_Property_Category_Aggregate;
  /** fetch data from the table: "lead_property_category" using primary key columns */
  lead_property_category_by_pk?: Maybe<Lead_Property_Category>;
  /** fetch data from the table in a streaming manner: "lead_property_category" */
  lead_property_category_stream: Array<Lead_Property_Category>;
  /** fetch data from the table: "lead_status" */
  lead_status: Array<Lead_Status>;
  /** fetch aggregated fields from the table: "lead_status" */
  lead_status_aggregate: Lead_Status_Aggregate;
  /** fetch data from the table: "lead_status" using primary key columns */
  lead_status_by_pk?: Maybe<Lead_Status>;
  /** fetch data from the table in a streaming manner: "lead_status" */
  lead_status_stream: Array<Lead_Status>;
  /** fetch data from the table: "lead_type" */
  lead_type: Array<Lead_Type>;
  /** fetch aggregated fields from the table: "lead_type" */
  lead_type_aggregate: Lead_Type_Aggregate;
  /** fetch data from the table: "lead_type" using primary key columns */
  lead_type_by_pk?: Maybe<Lead_Type>;
  /** fetch data from the table in a streaming manner: "lead_type" */
  lead_type_stream: Array<Lead_Type>;
  leads_statistics: Array<Leads_Statistics_Model>;
  /** fetch data from the table: "lister_claim_request" */
  lister_claim_request: Array<Lister_Claim_Request>;
  /** fetch data from the table: "lister_claim_request_activity" */
  lister_claim_request_activity: Array<Lister_Claim_Request_Activity>;
  /** fetch aggregated fields from the table: "lister_claim_request_activity" */
  lister_claim_request_activity_aggregate: Lister_Claim_Request_Activity_Aggregate;
  /** fetch data from the table: "lister_claim_request_activity" using primary key columns */
  lister_claim_request_activity_by_pk?: Maybe<Lister_Claim_Request_Activity>;
  /** fetch data from the table in a streaming manner: "lister_claim_request_activity" */
  lister_claim_request_activity_stream: Array<Lister_Claim_Request_Activity>;
  /** fetch aggregated fields from the table: "lister_claim_request" */
  lister_claim_request_aggregate: Lister_Claim_Request_Aggregate;
  /** fetch data from the table: "lister_claim_request" using primary key columns */
  lister_claim_request_by_pk?: Maybe<Lister_Claim_Request>;
  /** fetch data from the table in a streaming manner: "lister_claim_request" */
  lister_claim_request_stream: Array<Lister_Claim_Request>;
  /** fetch data from the table: "lister_contact" */
  lister_contact: Array<Lister_Contact>;
  /** fetch aggregated fields from the table: "lister_contact" */
  lister_contact_aggregate: Lister_Contact_Aggregate;
  /** fetch data from the table: "lister_contact" using primary key columns */
  lister_contact_by_pk?: Maybe<Lister_Contact>;
  /** fetch data from the table: "lister_contact_meeting" */
  lister_contact_meeting: Array<Lister_Contact_Meeting>;
  /** fetch aggregated fields from the table: "lister_contact_meeting" */
  lister_contact_meeting_aggregate: Lister_Contact_Meeting_Aggregate;
  /** fetch data from the table: "lister_contact_meeting" using primary key columns */
  lister_contact_meeting_by_pk?: Maybe<Lister_Contact_Meeting>;
  /** fetch data from the table in a streaming manner: "lister_contact_meeting" */
  lister_contact_meeting_stream: Array<Lister_Contact_Meeting>;
  /** fetch data from the table: "lister_contact_source" */
  lister_contact_source: Array<Lister_Contact_Source>;
  /** fetch aggregated fields from the table: "lister_contact_source" */
  lister_contact_source_aggregate: Lister_Contact_Source_Aggregate;
  /** fetch data from the table: "lister_contact_source" using primary key columns */
  lister_contact_source_by_pk?: Maybe<Lister_Contact_Source>;
  /** fetch data from the table in a streaming manner: "lister_contact_source" */
  lister_contact_source_stream: Array<Lister_Contact_Source>;
  /** fetch data from the table in a streaming manner: "lister_contact" */
  lister_contact_stream: Array<Lister_Contact>;
  /** fetch data from the table: "lister_leads" */
  lister_leads: Array<Lister_Leads>;
  /** fetch aggregated fields from the table: "lister_leads" */
  lister_leads_aggregate: Lister_Leads_Aggregate;
  /** fetch data from the table: "lister_leads" using primary key columns */
  lister_leads_by_pk?: Maybe<Lister_Leads>;
  /** fetch data from the table in a streaming manner: "lister_leads" */
  lister_leads_stream: Array<Lister_Leads>;
  /** fetch data from the table: "lister_meeting" */
  lister_meeting: Array<Lister_Meeting>;
  /** fetch aggregated fields from the table: "lister_meeting" */
  lister_meeting_aggregate: Lister_Meeting_Aggregate;
  /** fetch data from the table: "lister_meeting" using primary key columns */
  lister_meeting_by_pk?: Maybe<Lister_Meeting>;
  /** fetch data from the table in a streaming manner: "lister_meeting" */
  lister_meeting_stream: Array<Lister_Meeting>;
  /** fetch data from the table: "lister_role" */
  lister_role: Array<Lister_Role>;
  /** fetch aggregated fields from the table: "lister_role" */
  lister_role_aggregate: Lister_Role_Aggregate;
  /** fetch data from the table: "lister_role" using primary key columns */
  lister_role_by_pk?: Maybe<Lister_Role>;
  /** fetch data from the table in a streaming manner: "lister_role" */
  lister_role_stream: Array<Lister_Role>;
  /** fetch data from the table: "location" */
  location: Array<Location>;
  /** fetch aggregated fields from the table: "location" */
  location_aggregate: Location_Aggregate;
  /** fetch data from the table: "location" using primary key columns */
  location_by_pk?: Maybe<Location>;
  /** fetch data from the table in a streaming manner: "location" */
  location_stream: Array<Location>;
  /** fetch data from the table: "location_type" */
  location_type: Array<Location_Type>;
  /** fetch aggregated fields from the table: "location_type" */
  location_type_aggregate: Location_Type_Aggregate;
  /** fetch data from the table: "location_type" using primary key columns */
  location_type_by_pk?: Maybe<Location_Type>;
  /** fetch data from the table in a streaming manner: "location_type" */
  location_type_stream: Array<Location_Type>;
  /** fetch data from the table: "main_currency" */
  main_currency: Array<Main_Currency>;
  /** fetch aggregated fields from the table: "main_currency" */
  main_currency_aggregate: Main_Currency_Aggregate;
  /** fetch data from the table: "main_currency" using primary key columns */
  main_currency_by_pk?: Maybe<Main_Currency>;
  /** fetch data from the table in a streaming manner: "main_currency" */
  main_currency_stream: Array<Main_Currency>;
  /** An array relationship */
  natural_language_queries: Array<Natural_Language_Queries>;
  /** An aggregate relationship */
  natural_language_queries_aggregate: Natural_Language_Queries_Aggregate;
  /** fetch data from the table: "natural_language_queries" using primary key columns */
  natural_language_queries_by_pk?: Maybe<Natural_Language_Queries>;
  /** fetch data from the table in a streaming manner: "natural_language_queries" */
  natural_language_queries_stream: Array<Natural_Language_Queries>;
  /** fetch data from the table: "notification" */
  notification: Array<Notification>;
  /** fetch aggregated fields from the table: "notification" */
  notification_aggregate: Notification_Aggregate;
  /** An array relationship */
  notification_amenities: Array<Notification_Amenities>;
  /** An aggregate relationship */
  notification_amenities_aggregate: Notification_Amenities_Aggregate;
  /** fetch data from the table: "notification_amenities" using primary key columns */
  notification_amenities_by_pk?: Maybe<Notification_Amenities>;
  /** fetch data from the table in a streaming manner: "notification_amenities" */
  notification_amenities_stream: Array<Notification_Amenities>;
  /** fetch data from the table: "notification" using primary key columns */
  notification_by_pk?: Maybe<Notification>;
  /** fetch data from the table: "notification_feature" */
  notification_feature: Array<Notification_Feature>;
  /** fetch aggregated fields from the table: "notification_feature" */
  notification_feature_aggregate: Notification_Feature_Aggregate;
  /** fetch data from the table: "notification_feature" using primary key columns */
  notification_feature_by_pk?: Maybe<Notification_Feature>;
  /** fetch data from the table in a streaming manner: "notification_feature" */
  notification_feature_stream: Array<Notification_Feature>;
  /** fetch data from the table: "notification_property_type" */
  notification_property_type: Array<Notification_Property_Type>;
  /** fetch aggregated fields from the table: "notification_property_type" */
  notification_property_type_aggregate: Notification_Property_Type_Aggregate;
  /** fetch data from the table: "notification_property_type" using primary key columns */
  notification_property_type_by_pk?: Maybe<Notification_Property_Type>;
  /** fetch data from the table in a streaming manner: "notification_property_type" */
  notification_property_type_stream: Array<Notification_Property_Type>;
  /** fetch data from the table in a streaming manner: "notification" */
  notification_stream: Array<Notification>;
  /** fetch data from the table: "notification_type" */
  notification_type: Array<Notification_Type>;
  /** fetch aggregated fields from the table: "notification_type" */
  notification_type_aggregate: Notification_Type_Aggregate;
  /** fetch data from the table: "notification_type" using primary key columns */
  notification_type_by_pk?: Maybe<Notification_Type>;
  /** fetch data from the table in a streaming manner: "notification_type" */
  notification_type_stream: Array<Notification_Type>;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** fetch data from the table: "order_status" */
  order_status: Array<Order_Status>;
  /** fetch aggregated fields from the table: "order_status" */
  order_status_aggregate: Order_Status_Aggregate;
  /** fetch data from the table: "order_status" using primary key columns */
  order_status_by_pk?: Maybe<Order_Status>;
  /** fetch data from the table in a streaming manner: "order_status" */
  order_status_stream: Array<Order_Status>;
  /** fetch data from the table in a streaming manner: "order" */
  order_stream: Array<Order>;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  organizationDashboardStatistics: Array<Lister_Dashboard_Model>;
  organizationViewsGraphic: Array<Daily_Views>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table: "organization_lead_location" */
  organization_lead_location: Array<Organization_Lead_Location>;
  /** fetch aggregated fields from the table: "organization_lead_location" */
  organization_lead_location_aggregate: Organization_Lead_Location_Aggregate;
  /** fetch data from the table: "organization_lead_location" using primary key columns */
  organization_lead_location_by_pk?: Maybe<Organization_Lead_Location>;
  /** fetch data from the table in a streaming manner: "organization_lead_location" */
  organization_lead_location_stream: Array<Organization_Lead_Location>;
  /** fetch data from the table: "organization_lead_property" */
  organization_lead_property: Array<Organization_Lead_Property>;
  /** fetch aggregated fields from the table: "organization_lead_property" */
  organization_lead_property_aggregate: Organization_Lead_Property_Aggregate;
  /** fetch data from the table: "organization_lead_property" using primary key columns */
  organization_lead_property_by_pk?: Maybe<Organization_Lead_Property>;
  /** fetch data from the table in a streaming manner: "organization_lead_property" */
  organization_lead_property_stream: Array<Organization_Lead_Property>;
  /** An array relationship */
  organization_leads: Array<Organization_Leads>;
  /** An aggregate relationship */
  organization_leads_aggregate: Organization_Leads_Aggregate;
  /** fetch data from the table: "organization_leads" using primary key columns */
  organization_leads_by_pk?: Maybe<Organization_Leads>;
  /** fetch data from the table in a streaming manner: "organization_leads" */
  organization_leads_stream: Array<Organization_Leads>;
  /** fetch data from the table: "organization_role" */
  organization_role: Array<Organization_Role>;
  /** fetch aggregated fields from the table: "organization_role" */
  organization_role_aggregate: Organization_Role_Aggregate;
  /** fetch data from the table: "organization_role" using primary key columns */
  organization_role_by_pk?: Maybe<Organization_Role>;
  /** fetch data from the table in a streaming manner: "organization_role" */
  organization_role_stream: Array<Organization_Role>;
  /** fetch data from the table: "organization_status" */
  organization_status: Array<Organization_Status>;
  /** fetch aggregated fields from the table: "organization_status" */
  organization_status_aggregate: Organization_Status_Aggregate;
  /** fetch data from the table: "organization_status" using primary key columns */
  organization_status_by_pk?: Maybe<Organization_Status>;
  /** fetch data from the table in a streaming manner: "organization_status" */
  organization_status_stream: Array<Organization_Status>;
  /** fetch data from the table in a streaming manner: "organization" */
  organization_stream: Array<Organization>;
  /** fetch data from the table: "organization_telegram_agent_link" */
  organization_telegram_agent_link: Array<Organization_Telegram_Agent_Link>;
  /** fetch aggregated fields from the table: "organization_telegram_agent_link" */
  organization_telegram_agent_link_aggregate: Organization_Telegram_Agent_Link_Aggregate;
  /** fetch data from the table: "organization_telegram_agent_link" using primary key columns */
  organization_telegram_agent_link_by_pk?: Maybe<Organization_Telegram_Agent_Link>;
  /** fetch data from the table in a streaming manner: "organization_telegram_agent_link" */
  organization_telegram_agent_link_stream: Array<Organization_Telegram_Agent_Link>;
  /** fetch data from the table: "organization_type" */
  organization_type: Array<Organization_Type>;
  /** fetch aggregated fields from the table: "organization_type" */
  organization_type_aggregate: Organization_Type_Aggregate;
  /** fetch data from the table: "organization_type" using primary key columns */
  organization_type_by_pk?: Maybe<Organization_Type>;
  /** fetch data from the table in a streaming manner: "organization_type" */
  organization_type_stream: Array<Organization_Type>;
  /** fetch data from the table: "organization_whatsapp_ai_allowlist" */
  organization_whatsapp_ai_allowlist: Array<Organization_Whatsapp_Ai_Allowlist>;
  /** fetch aggregated fields from the table: "organization_whatsapp_ai_allowlist" */
  organization_whatsapp_ai_allowlist_aggregate: Organization_Whatsapp_Ai_Allowlist_Aggregate;
  /** fetch data from the table: "organization_whatsapp_ai_allowlist" using primary key columns */
  organization_whatsapp_ai_allowlist_by_pk?: Maybe<Organization_Whatsapp_Ai_Allowlist>;
  /** fetch data from the table in a streaming manner: "organization_whatsapp_ai_allowlist" */
  organization_whatsapp_ai_allowlist_stream: Array<Organization_Whatsapp_Ai_Allowlist>;
  /** fetch data from the table: "organization_whatsapp_ai_config" */
  organization_whatsapp_ai_config: Array<Organization_Whatsapp_Ai_Config>;
  /** fetch aggregated fields from the table: "organization_whatsapp_ai_config" */
  organization_whatsapp_ai_config_aggregate: Organization_Whatsapp_Ai_Config_Aggregate;
  /** fetch data from the table: "organization_whatsapp_ai_config" using primary key columns */
  organization_whatsapp_ai_config_by_pk?: Maybe<Organization_Whatsapp_Ai_Config>;
  /** fetch data from the table in a streaming manner: "organization_whatsapp_ai_config" */
  organization_whatsapp_ai_config_stream: Array<Organization_Whatsapp_Ai_Config>;
  /** fetch data from the table: "parking_type" */
  parking_type: Array<Parking_Type>;
  /** fetch aggregated fields from the table: "parking_type" */
  parking_type_aggregate: Parking_Type_Aggregate;
  /** fetch data from the table: "parking_type" using primary key columns */
  parking_type_by_pk?: Maybe<Parking_Type>;
  /** fetch data from the table in a streaming manner: "parking_type" */
  parking_type_stream: Array<Parking_Type>;
  /** fetch data from the table: "phone_number_type" */
  phone_number_type: Array<Phone_Number_Type>;
  /** fetch aggregated fields from the table: "phone_number_type" */
  phone_number_type_aggregate: Phone_Number_Type_Aggregate;
  /** fetch data from the table: "phone_number_type" using primary key columns */
  phone_number_type_by_pk?: Maybe<Phone_Number_Type>;
  /** fetch data from the table in a streaming manner: "phone_number_type" */
  phone_number_type_stream: Array<Phone_Number_Type>;
  /** fetch data from the table: "place_reference" */
  place_reference: Array<Place_Reference>;
  /** fetch aggregated fields from the table: "place_reference" */
  place_reference_aggregate: Place_Reference_Aggregate;
  /** fetch data from the table: "place_reference_alias" */
  place_reference_alias: Array<Place_Reference_Alias>;
  /** fetch aggregated fields from the table: "place_reference_alias" */
  place_reference_alias_aggregate: Place_Reference_Alias_Aggregate;
  /** fetch data from the table: "place_reference_alias" using primary key columns */
  place_reference_alias_by_pk?: Maybe<Place_Reference_Alias>;
  /** fetch data from the table in a streaming manner: "place_reference_alias" */
  place_reference_alias_stream: Array<Place_Reference_Alias>;
  /** fetch data from the table: "place_reference" using primary key columns */
  place_reference_by_pk?: Maybe<Place_Reference>;
  /** fetch data from the table: "place_reference_proposal" */
  place_reference_proposal: Array<Place_Reference_Proposal>;
  /** fetch aggregated fields from the table: "place_reference_proposal" */
  place_reference_proposal_aggregate: Place_Reference_Proposal_Aggregate;
  /** fetch data from the table: "place_reference_proposal" using primary key columns */
  place_reference_proposal_by_pk?: Maybe<Place_Reference_Proposal>;
  /** fetch data from the table in a streaming manner: "place_reference_proposal" */
  place_reference_proposal_stream: Array<Place_Reference_Proposal>;
  /** fetch data from the table in a streaming manner: "place_reference" */
  place_reference_stream: Array<Place_Reference>;
  /** fetch data from the table: "plan" */
  plan: Array<Plan>;
  /** fetch aggregated fields from the table: "plan" */
  plan_aggregate: Plan_Aggregate;
  /** fetch data from the table: "plan" using primary key columns */
  plan_by_pk?: Maybe<Plan>;
  /** fetch data from the table in a streaming manner: "plan" */
  plan_stream: Array<Plan>;
  /** fetch data from the table: "plan_type" */
  plan_type: Array<Plan_Type>;
  /** fetch aggregated fields from the table: "plan_type" */
  plan_type_aggregate: Plan_Type_Aggregate;
  /** fetch data from the table: "plan_type" using primary key columns */
  plan_type_by_pk?: Maybe<Plan_Type>;
  /** fetch data from the table in a streaming manner: "plan_type" */
  plan_type_stream: Array<Plan_Type>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_purchase" */
  product_purchase: Array<Product_Purchase>;
  /** fetch aggregated fields from the table: "product_purchase" */
  product_purchase_aggregate: Product_Purchase_Aggregate;
  /** fetch data from the table: "product_purchase" using primary key columns */
  product_purchase_by_pk?: Maybe<Product_Purchase>;
  /** fetch data from the table in a streaming manner: "product_purchase" */
  product_purchase_stream: Array<Product_Purchase>;
  /** fetch data from the table in a streaming manner: "product" */
  product_stream: Array<Product>;
  /** fetch data from the table: "product_type" */
  product_type: Array<Product_Type>;
  /** fetch aggregated fields from the table: "product_type" */
  product_type_aggregate: Product_Type_Aggregate;
  /** fetch data from the table: "product_type" using primary key columns */
  product_type_by_pk?: Maybe<Product_Type>;
  /** fetch data from the table in a streaming manner: "product_type" */
  product_type_stream: Array<Product_Type>;
  /** fetch data from the table: "property" */
  property: Array<Property>;
  propertyDailyViews: Array<Property_Views_Model>;
  propertyTypesDistribution: Array<Property_Types_Distribution_Model>;
  /** fetch aggregated fields from the table: "property" */
  property_aggregate: Property_Aggregate;
  /** fetch data from the table: "property" using primary key columns */
  property_by_pk?: Maybe<Property>;
  /** fetch data from the table: "property_cluster" */
  property_cluster: Array<Property_Cluster>;
  /** fetch aggregated fields from the table: "property_cluster" */
  property_cluster_aggregate: Property_Cluster_Aggregate;
  /** fetch data from the table: "property_cluster" using primary key columns */
  property_cluster_by_pk?: Maybe<Property_Cluster>;
  /** fetch data from the table in a streaming manner: "property_cluster" */
  property_cluster_stream: Array<Property_Cluster>;
  /** fetch data from the table: "property_composition" */
  property_composition: Array<Property_Composition>;
  /** fetch aggregated fields from the table: "property_composition" */
  property_composition_aggregate: Property_Composition_Aggregate;
  /** fetch data from the table: "property_composition" using primary key columns */
  property_composition_by_pk?: Maybe<Property_Composition>;
  /** fetch data from the table in a streaming manner: "property_composition" */
  property_composition_stream: Array<Property_Composition>;
  /** fetch data from the table: "property_feature" */
  property_feature: Array<Property_Feature>;
  /** fetch aggregated fields from the table: "property_feature" */
  property_feature_aggregate: Property_Feature_Aggregate;
  /** fetch data from the table: "property_feature" using primary key columns */
  property_feature_by_pk?: Maybe<Property_Feature>;
  /** fetch data from the table in a streaming manner: "property_feature" */
  property_feature_stream: Array<Property_Feature>;
  /** fetch data from the table: "property_folder" */
  property_folder: Array<Property_Folder>;
  /** fetch aggregated fields from the table: "property_folder" */
  property_folder_aggregate: Property_Folder_Aggregate;
  /** fetch data from the table: "property_folder" using primary key columns */
  property_folder_by_pk?: Maybe<Property_Folder>;
  /** fetch data from the table: "property_folder_public_profile" */
  property_folder_public_profile: Array<Property_Folder_Public_Profile>;
  /** fetch aggregated fields from the table: "property_folder_public_profile" */
  property_folder_public_profile_aggregate: Property_Folder_Public_Profile_Aggregate;
  /** fetch data from the table: "property_folder_public_profile" using primary key columns */
  property_folder_public_profile_by_pk?: Maybe<Property_Folder_Public_Profile>;
  /** fetch data from the table: "property_folder_public_profile_faq" */
  property_folder_public_profile_faq: Array<Property_Folder_Public_Profile_Faq>;
  /** fetch aggregated fields from the table: "property_folder_public_profile_faq" */
  property_folder_public_profile_faq_aggregate: Property_Folder_Public_Profile_Faq_Aggregate;
  /** fetch data from the table: "property_folder_public_profile_faq" using primary key columns */
  property_folder_public_profile_faq_by_pk?: Maybe<Property_Folder_Public_Profile_Faq>;
  /** fetch data from the table in a streaming manner: "property_folder_public_profile_faq" */
  property_folder_public_profile_faq_stream: Array<Property_Folder_Public_Profile_Faq>;
  /** fetch data from the table: "property_folder_public_profile_highlight" */
  property_folder_public_profile_highlight: Array<Property_Folder_Public_Profile_Highlight>;
  /** fetch aggregated fields from the table: "property_folder_public_profile_highlight" */
  property_folder_public_profile_highlight_aggregate: Property_Folder_Public_Profile_Highlight_Aggregate;
  /** fetch data from the table: "property_folder_public_profile_highlight" using primary key columns */
  property_folder_public_profile_highlight_by_pk?: Maybe<Property_Folder_Public_Profile_Highlight>;
  /** fetch data from the table in a streaming manner: "property_folder_public_profile_highlight" */
  property_folder_public_profile_highlight_stream: Array<Property_Folder_Public_Profile_Highlight>;
  /** fetch data from the table: "property_folder_public_profile_listing_example" */
  property_folder_public_profile_listing_example: Array<Property_Folder_Public_Profile_Listing_Example>;
  /** fetch aggregated fields from the table: "property_folder_public_profile_listing_example" */
  property_folder_public_profile_listing_example_aggregate: Property_Folder_Public_Profile_Listing_Example_Aggregate;
  /** fetch data from the table: "property_folder_public_profile_listing_example" using primary key columns */
  property_folder_public_profile_listing_example_by_pk?: Maybe<Property_Folder_Public_Profile_Listing_Example>;
  /** fetch data from the table in a streaming manner: "property_folder_public_profile_listing_example" */
  property_folder_public_profile_listing_example_stream: Array<Property_Folder_Public_Profile_Listing_Example>;
  /** fetch data from the table: "property_folder_public_profile_nearby_place" */
  property_folder_public_profile_nearby_place: Array<Property_Folder_Public_Profile_Nearby_Place>;
  /** fetch aggregated fields from the table: "property_folder_public_profile_nearby_place" */
  property_folder_public_profile_nearby_place_aggregate: Property_Folder_Public_Profile_Nearby_Place_Aggregate;
  /** fetch data from the table: "property_folder_public_profile_nearby_place" using primary key columns */
  property_folder_public_profile_nearby_place_by_pk?: Maybe<Property_Folder_Public_Profile_Nearby_Place>;
  /** fetch data from the table in a streaming manner: "property_folder_public_profile_nearby_place" */
  property_folder_public_profile_nearby_place_stream: Array<Property_Folder_Public_Profile_Nearby_Place>;
  /** fetch data from the table: "property_folder_public_profile_related" */
  property_folder_public_profile_related: Array<Property_Folder_Public_Profile_Related>;
  /** fetch aggregated fields from the table: "property_folder_public_profile_related" */
  property_folder_public_profile_related_aggregate: Property_Folder_Public_Profile_Related_Aggregate;
  /** fetch data from the table: "property_folder_public_profile_related" using primary key columns */
  property_folder_public_profile_related_by_pk?: Maybe<Property_Folder_Public_Profile_Related>;
  /** fetch data from the table in a streaming manner: "property_folder_public_profile_related" */
  property_folder_public_profile_related_stream: Array<Property_Folder_Public_Profile_Related>;
  /** fetch data from the table in a streaming manner: "property_folder_public_profile" */
  property_folder_public_profile_stream: Array<Property_Folder_Public_Profile>;
  /** fetch data from the table: "property_folder_public_profile_translation" */
  property_folder_public_profile_translation: Array<Property_Folder_Public_Profile_Translation>;
  /** fetch aggregated fields from the table: "property_folder_public_profile_translation" */
  property_folder_public_profile_translation_aggregate: Property_Folder_Public_Profile_Translation_Aggregate;
  /** fetch data from the table: "property_folder_public_profile_translation" using primary key columns */
  property_folder_public_profile_translation_by_pk?: Maybe<Property_Folder_Public_Profile_Translation>;
  /** fetch data from the table in a streaming manner: "property_folder_public_profile_translation" */
  property_folder_public_profile_translation_stream: Array<Property_Folder_Public_Profile_Translation>;
  /** fetch data from the table in a streaming manner: "property_folder" */
  property_folder_stream: Array<Property_Folder>;
  /** fetch data from the table: "property_image" */
  property_image: Array<Property_Image>;
  /** fetch aggregated fields from the table: "property_image" */
  property_image_aggregate: Property_Image_Aggregate;
  /** fetch data from the table: "property_image" using primary key columns */
  property_image_by_pk?: Maybe<Property_Image>;
  /** fetch data from the table in a streaming manner: "property_image" */
  property_image_stream: Array<Property_Image>;
  /** fetch data from the table: "property_list" */
  property_list: Array<Property_List>;
  /** fetch data from the table: "property_list_activity" */
  property_list_activity: Array<Property_List_Activity>;
  /** fetch aggregated fields from the table: "property_list_activity" */
  property_list_activity_aggregate: Property_List_Activity_Aggregate;
  /** fetch data from the table: "property_list_activity" using primary key columns */
  property_list_activity_by_pk?: Maybe<Property_List_Activity>;
  /** fetch data from the table in a streaming manner: "property_list_activity" */
  property_list_activity_stream: Array<Property_List_Activity>;
  /** fetch aggregated fields from the table: "property_list" */
  property_list_aggregate: Property_List_Aggregate;
  /** fetch data from the table: "property_list" using primary key columns */
  property_list_by_pk?: Maybe<Property_List>;
  /** fetch data from the table: "property_list_folder" */
  property_list_folder: Array<Property_List_Folder>;
  /** fetch aggregated fields from the table: "property_list_folder" */
  property_list_folder_aggregate: Property_List_Folder_Aggregate;
  /** fetch data from the table: "property_list_folder" using primary key columns */
  property_list_folder_by_pk?: Maybe<Property_List_Folder>;
  /** fetch data from the table in a streaming manner: "property_list_folder" */
  property_list_folder_stream: Array<Property_List_Folder>;
  /** fetch data from the table: "property_list_report" */
  property_list_report: Array<Property_List_Report>;
  /** fetch aggregated fields from the table: "property_list_report" */
  property_list_report_aggregate: Property_List_Report_Aggregate;
  /** fetch data from the table: "property_list_report" using primary key columns */
  property_list_report_by_pk?: Maybe<Property_List_Report>;
  /** fetch data from the table in a streaming manner: "property_list_report" */
  property_list_report_stream: Array<Property_List_Report>;
  /** fetch data from the table in a streaming manner: "property_list" */
  property_list_stream: Array<Property_List>;
  /** fetch data from the table: "property_origin" */
  property_origin: Array<Property_Origin>;
  /** fetch aggregated fields from the table: "property_origin" */
  property_origin_aggregate: Property_Origin_Aggregate;
  /** fetch data from the table: "property_origin" using primary key columns */
  property_origin_by_pk?: Maybe<Property_Origin>;
  /** fetch data from the table in a streaming manner: "property_origin" */
  property_origin_stream: Array<Property_Origin>;
  /** fetch data from the table: "property_origin_type" */
  property_origin_type: Array<Property_Origin_Type>;
  /** fetch aggregated fields from the table: "property_origin_type" */
  property_origin_type_aggregate: Property_Origin_Type_Aggregate;
  /** fetch data from the table: "property_origin_type" using primary key columns */
  property_origin_type_by_pk?: Maybe<Property_Origin_Type>;
  /** fetch data from the table in a streaming manner: "property_origin_type" */
  property_origin_type_stream: Array<Property_Origin_Type>;
  /** fetch data from the table: "property_owner" */
  property_owner: Array<Property_Owner>;
  /** fetch aggregated fields from the table: "property_owner" */
  property_owner_aggregate: Property_Owner_Aggregate;
  /** fetch data from the table: "property_owner" using primary key columns */
  property_owner_by_pk?: Maybe<Property_Owner>;
  /** fetch data from the table in a streaming manner: "property_owner" */
  property_owner_stream: Array<Property_Owner>;
  /** fetch data from the table: "property_place_reference" */
  property_place_reference: Array<Property_Place_Reference>;
  /** fetch aggregated fields from the table: "property_place_reference" */
  property_place_reference_aggregate: Property_Place_Reference_Aggregate;
  /** fetch data from the table: "property_place_reference" using primary key columns */
  property_place_reference_by_pk?: Maybe<Property_Place_Reference>;
  /** fetch data from the table in a streaming manner: "property_place_reference" */
  property_place_reference_stream: Array<Property_Place_Reference>;
  /** fetch data from the table: "property_price_history" */
  property_price_history: Array<Property_Price_History>;
  /** fetch aggregated fields from the table: "property_price_history" */
  property_price_history_aggregate: Property_Price_History_Aggregate;
  /** fetch data from the table: "property_price_history" using primary key columns */
  property_price_history_by_pk?: Maybe<Property_Price_History>;
  /** fetch data from the table in a streaming manner: "property_price_history" */
  property_price_history_stream: Array<Property_Price_History>;
  /** fetch data from the table: "property_report_type" */
  property_report_type: Array<Property_Report_Type>;
  /** fetch aggregated fields from the table: "property_report_type" */
  property_report_type_aggregate: Property_Report_Type_Aggregate;
  /** fetch data from the table: "property_report_type" using primary key columns */
  property_report_type_by_pk?: Maybe<Property_Report_Type>;
  /** fetch data from the table in a streaming manner: "property_report_type" */
  property_report_type_stream: Array<Property_Report_Type>;
  /** fetch data from the table: "property_source" */
  property_source: Array<Property_Source>;
  /** fetch aggregated fields from the table: "property_source" */
  property_source_aggregate: Property_Source_Aggregate;
  /** fetch data from the table: "property_source" using primary key columns */
  property_source_by_pk?: Maybe<Property_Source>;
  /** fetch data from the table in a streaming manner: "property_source" */
  property_source_stream: Array<Property_Source>;
  /** fetch data from the table: "property_status" */
  property_status: Array<Property_Status>;
  /** fetch aggregated fields from the table: "property_status" */
  property_status_aggregate: Property_Status_Aggregate;
  /** fetch data from the table: "property_status" using primary key columns */
  property_status_by_pk?: Maybe<Property_Status>;
  /** fetch data from the table in a streaming manner: "property_status" */
  property_status_stream: Array<Property_Status>;
  /** fetch data from the table in a streaming manner: "property" */
  property_stream: Array<Property>;
  /** fetch data from the table: "property_type" */
  property_type: Array<Property_Type>;
  /** fetch aggregated fields from the table: "property_type" */
  property_type_aggregate: Property_Type_Aggregate;
  /** fetch data from the table: "property_type" using primary key columns */
  property_type_by_pk?: Maybe<Property_Type>;
  /** fetch data from the table in a streaming manner: "property_type" */
  property_type_stream: Array<Property_Type>;
  /** An array relationship */
  property_views: Array<Property_Views>;
  /** An aggregate relationship */
  property_views_aggregate: Property_Views_Aggregate;
  /** fetch data from the table: "property_views" using primary key columns */
  property_views_by_pk?: Maybe<Property_Views>;
  /** fetch data from the table in a streaming manner: "property_views" */
  property_views_stream: Array<Property_Views>;
  /** fetch data from the table: "queries_property_result" */
  queries_property_result: Array<Queries_Property_Result>;
  /** fetch aggregated fields from the table: "queries_property_result" */
  queries_property_result_aggregate: Queries_Property_Result_Aggregate;
  /** fetch data from the table: "queries_property_result" using primary key columns */
  queries_property_result_by_pk?: Maybe<Queries_Property_Result>;
  /** fetch data from the table: "queries_property_result_re" */
  queries_property_result_re: Array<Queries_Property_Result_Re>;
  /** fetch aggregated fields from the table: "queries_property_result_re" */
  queries_property_result_re_aggregate: Queries_Property_Result_Re_Aggregate;
  /** fetch data from the table: "queries_property_result_re" using primary key columns */
  queries_property_result_re_by_pk?: Maybe<Queries_Property_Result_Re>;
  /** fetch data from the table in a streaming manner: "queries_property_result_re" */
  queries_property_result_re_stream: Array<Queries_Property_Result_Re>;
  /** fetch data from the table in a streaming manner: "queries_property_result" */
  queries_property_result_stream: Array<Queries_Property_Result>;
  /** fetch data from the table: "query_classification" */
  query_classification: Array<Query_Classification>;
  /** fetch aggregated fields from the table: "query_classification" */
  query_classification_aggregate: Query_Classification_Aggregate;
  /** fetch data from the table: "query_classification" using primary key columns */
  query_classification_by_pk?: Maybe<Query_Classification>;
  /** fetch data from the table: "query_classification_re" */
  query_classification_re: Array<Query_Classification_Re>;
  /** fetch aggregated fields from the table: "query_classification_re" */
  query_classification_re_aggregate: Query_Classification_Re_Aggregate;
  /** fetch data from the table: "query_classification_re" using primary key columns */
  query_classification_re_by_pk?: Maybe<Query_Classification_Re>;
  /** fetch data from the table in a streaming manner: "query_classification_re" */
  query_classification_re_stream: Array<Query_Classification_Re>;
  /** fetch data from the table in a streaming manner: "query_classification" */
  query_classification_stream: Array<Query_Classification>;
  /** fetch data from the table: "raw_location" */
  raw_location: Array<Raw_Location>;
  /** fetch aggregated fields from the table: "raw_location" */
  raw_location_aggregate: Raw_Location_Aggregate;
  /** fetch data from the table: "raw_location" using primary key columns */
  raw_location_by_pk?: Maybe<Raw_Location>;
  /** fetch data from the table in a streaming manner: "raw_location" */
  raw_location_stream: Array<Raw_Location>;
  /** fetch data from the table: "redirect" */
  redirect: Array<Redirect>;
  /** fetch aggregated fields from the table: "redirect" */
  redirect_aggregate: Redirect_Aggregate;
  /** fetch data from the table: "redirect" using primary key columns */
  redirect_by_pk?: Maybe<Redirect>;
  /** fetch data from the table in a streaming manner: "redirect" */
  redirect_stream: Array<Redirect>;
  /** fetch data from the table: "reference_price_history" */
  reference_price_history: Array<Reference_Price_History>;
  /** fetch aggregated fields from the table: "reference_price_history" */
  reference_price_history_aggregate: Reference_Price_History_Aggregate;
  /** fetch data from the table: "reference_price_history" using primary key columns */
  reference_price_history_by_pk?: Maybe<Reference_Price_History>;
  /** fetch data from the table in a streaming manner: "reference_price_history" */
  reference_price_history_stream: Array<Reference_Price_History>;
  /** fetch data from the table: "reference_zone" */
  reference_zone: Array<Reference_Zone>;
  /** fetch aggregated fields from the table: "reference_zone" */
  reference_zone_aggregate: Reference_Zone_Aggregate;
  /** fetch data from the table: "reference_zone" using primary key columns */
  reference_zone_by_pk?: Maybe<Reference_Zone>;
  /** fetch data from the table in a streaming manner: "reference_zone" */
  reference_zone_stream: Array<Reference_Zone>;
  regionalPropertyDistribution: Array<Regional_Property_Model>;
  /** fetch data from the table: "search_context" */
  search_context: Array<Search_Context>;
  /** fetch aggregated fields from the table: "search_context" */
  search_context_aggregate: Search_Context_Aggregate;
  /** fetch data from the table: "search_context" using primary key columns */
  search_context_by_pk?: Maybe<Search_Context>;
  /** fetch data from the table: "search_context_location" */
  search_context_location: Array<Search_Context_Location>;
  /** fetch aggregated fields from the table: "search_context_location" */
  search_context_location_aggregate: Search_Context_Location_Aggregate;
  /** fetch data from the table: "search_context_location" using primary key columns */
  search_context_location_by_pk?: Maybe<Search_Context_Location>;
  /** fetch data from the table in a streaming manner: "search_context_location" */
  search_context_location_stream: Array<Search_Context_Location>;
  /** fetch data from the table in a streaming manner: "search_context" */
  search_context_stream: Array<Search_Context>;
  /** fetch data from the table: "search_domain" */
  search_domain: Array<Search_Domain>;
  /** fetch aggregated fields from the table: "search_domain" */
  search_domain_aggregate: Search_Domain_Aggregate;
  /** fetch data from the table: "search_domain" using primary key columns */
  search_domain_by_pk?: Maybe<Search_Domain>;
  /** fetch data from the table in a streaming manner: "search_domain" */
  search_domain_stream: Array<Search_Domain>;
  /** An array relationship */
  search_sessions: Array<Search_Sessions>;
  /** An aggregate relationship */
  search_sessions_aggregate: Search_Sessions_Aggregate;
  /** fetch data from the table: "search_sessions" using primary key columns */
  search_sessions_by_pk?: Maybe<Search_Sessions>;
  /** execute function "search_sessions_sorted_by_last_query" which returns "search_sessions" */
  search_sessions_sorted_by_last_query: Array<Search_Sessions>;
  /** execute function "search_sessions_sorted_by_last_query" and query aggregates on result of table type "search_sessions" */
  search_sessions_sorted_by_last_query_aggregate: Search_Sessions_Aggregate;
  /** fetch data from the table in a streaming manner: "search_sessions" */
  search_sessions_stream: Array<Search_Sessions>;
  /** An array relationship */
  search_slugs: Array<Search_Slugs>;
  /** An aggregate relationship */
  search_slugs_aggregate: Search_Slugs_Aggregate;
  /** fetch data from the table: "search_slugs" using primary key columns */
  search_slugs_by_pk?: Maybe<Search_Slugs>;
  /** fetch data from the table in a streaming manner: "search_slugs" */
  search_slugs_stream: Array<Search_Slugs>;
  /** fetch data from the table: "seo_city" */
  seo_city: Array<Seo_City>;
  /** fetch aggregated fields from the table: "seo_city" */
  seo_city_aggregate: Seo_City_Aggregate;
  /** fetch data from the table: "seo_city" using primary key columns */
  seo_city_by_pk?: Maybe<Seo_City>;
  /** fetch data from the table in a streaming manner: "seo_city" */
  seo_city_stream: Array<Seo_City>;
  /** fetch data from the table: "session_origin" */
  session_origin: Array<Session_Origin>;
  /** fetch aggregated fields from the table: "session_origin" */
  session_origin_aggregate: Session_Origin_Aggregate;
  /** fetch data from the table: "session_origin" using primary key columns */
  session_origin_by_pk?: Maybe<Session_Origin>;
  /** fetch data from the table in a streaming manner: "session_origin" */
  session_origin_stream: Array<Session_Origin>;
  /** fetch data from the table: "sponsored_property_list" */
  sponsored_property_list: Array<Sponsored_Property_List>;
  /** fetch aggregated fields from the table: "sponsored_property_list" */
  sponsored_property_list_aggregate: Sponsored_Property_List_Aggregate;
  /** fetch data from the table: "sponsored_property_list" using primary key columns */
  sponsored_property_list_by_pk?: Maybe<Sponsored_Property_List>;
  /** fetch data from the table in a streaming manner: "sponsored_property_list" */
  sponsored_property_list_stream: Array<Sponsored_Property_List>;
  /** fetch data from the table: "subscription" */
  subscription: Array<Subscription>;
  /** fetch aggregated fields from the table: "subscription" */
  subscription_aggregate: Subscription_Aggregate;
  /** fetch data from the table: "subscription" using primary key columns */
  subscription_by_pk?: Maybe<Subscription>;
  /** fetch data from the table: "subscription_invoice" */
  subscription_invoice: Array<Subscription_Invoice>;
  /** fetch aggregated fields from the table: "subscription_invoice" */
  subscription_invoice_aggregate: Subscription_Invoice_Aggregate;
  /** fetch data from the table: "subscription_invoice" using primary key columns */
  subscription_invoice_by_pk?: Maybe<Subscription_Invoice>;
  /** fetch data from the table in a streaming manner: "subscription_invoice" */
  subscription_invoice_stream: Array<Subscription_Invoice>;
  /** fetch data from the table: "subscription_source" */
  subscription_source: Array<Subscription_Source>;
  /** fetch aggregated fields from the table: "subscription_source" */
  subscription_source_aggregate: Subscription_Source_Aggregate;
  /** fetch data from the table: "subscription_source" using primary key columns */
  subscription_source_by_pk?: Maybe<Subscription_Source>;
  /** fetch data from the table in a streaming manner: "subscription_source" */
  subscription_source_stream: Array<Subscription_Source>;
  /** fetch data from the table: "subscription_status" */
  subscription_status: Array<Subscription_Status>;
  /** fetch aggregated fields from the table: "subscription_status" */
  subscription_status_aggregate: Subscription_Status_Aggregate;
  /** fetch data from the table: "subscription_status" using primary key columns */
  subscription_status_by_pk?: Maybe<Subscription_Status>;
  /** fetch data from the table in a streaming manner: "subscription_status" */
  subscription_status_stream: Array<Subscription_Status>;
  /** fetch data from the table in a streaming manner: "subscription" */
  subscription_stream: Array<Subscription>;
  /** fetch data from the table: "text_content" */
  text_content: Array<Text_Content>;
  /** fetch aggregated fields from the table: "text_content" */
  text_content_aggregate: Text_Content_Aggregate;
  /** fetch data from the table: "text_content" using primary key columns */
  text_content_by_pk?: Maybe<Text_Content>;
  /** fetch data from the table in a streaming manner: "text_content" */
  text_content_stream: Array<Text_Content>;
  /** An array relationship */
  translations: Array<Translations>;
  /** An aggregate relationship */
  translations_aggregate: Translations_Aggregate;
  /** fetch data from the table: "translations" using primary key columns */
  translations_by_pk?: Maybe<Translations>;
  /** fetch data from the table in a streaming manner: "translations" */
  translations_stream: Array<Translations>;
  /** fetch data from the table: "url_slug" */
  url_slug: Array<Url_Slug>;
  /** fetch aggregated fields from the table: "url_slug" */
  url_slug_aggregate: Url_Slug_Aggregate;
  /** fetch data from the table: "url_slug" using primary key columns */
  url_slug_by_pk?: Maybe<Url_Slug>;
  /** fetch data from the table in a streaming manner: "url_slug" */
  url_slug_stream: Array<Url_Slug>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** An array relationship */
  user_filters: Array<User_Filters>;
  /** An aggregate relationship */
  user_filters_aggregate: User_Filters_Aggregate;
  /** fetch data from the table: "user_filters" using primary key columns */
  user_filters_by_pk?: Maybe<User_Filters>;
  /** An array relationship */
  user_filters_features: Array<User_Filters_Features>;
  /** An aggregate relationship */
  user_filters_features_aggregate: User_Filters_Features_Aggregate;
  /** fetch data from the table: "user_filters_features" using primary key columns */
  user_filters_features_by_pk?: Maybe<User_Filters_Features>;
  /** fetch data from the table in a streaming manner: "user_filters_features" */
  user_filters_features_stream: Array<User_Filters_Features>;
  /** fetch data from the table in a streaming manner: "user_filters" */
  user_filters_stream: Array<User_Filters>;
  /** fetch data from the table: "user_organization" */
  user_organization: Array<User_Organization>;
  /** fetch aggregated fields from the table: "user_organization" */
  user_organization_aggregate: User_Organization_Aggregate;
  /** fetch data from the table: "user_organization" using primary key columns */
  user_organization_by_pk?: Maybe<User_Organization>;
  /** fetch data from the table in a streaming manner: "user_organization" */
  user_organization_stream: Array<User_Organization>;
  /** An array relationship */
  user_preferences: Array<User_Preferences>;
  /** An aggregate relationship */
  user_preferences_aggregate: User_Preferences_Aggregate;
  /** fetch data from the table: "user_preferences" using primary key columns */
  user_preferences_by_pk?: Maybe<User_Preferences>;
  /** fetch data from the table in a streaming manner: "user_preferences" */
  user_preferences_stream: Array<User_Preferences>;
  /** fetch data from the table: "user_property_notifiation" */
  user_property_notifiation: Array<User_Property_Notifiation>;
  /** fetch aggregated fields from the table: "user_property_notifiation" */
  user_property_notifiation_aggregate: User_Property_Notifiation_Aggregate;
  /** fetch data from the table: "user_property_notifiation" using primary key columns */
  user_property_notifiation_by_pk?: Maybe<User_Property_Notifiation>;
  /** fetch data from the table in a streaming manner: "user_property_notifiation" */
  user_property_notifiation_stream: Array<User_Property_Notifiation>;
  /** An array relationship */
  user_saved_properties: Array<User_Saved_Properties>;
  /** An aggregate relationship */
  user_saved_properties_aggregate: User_Saved_Properties_Aggregate;
  /** fetch data from the table: "user_saved_properties" using primary key columns */
  user_saved_properties_by_pk?: Maybe<User_Saved_Properties>;
  /** fetch data from the table in a streaming manner: "user_saved_properties" */
  user_saved_properties_stream: Array<User_Saved_Properties>;
  /** fetch data from the table: "user_seen_property" */
  user_seen_property: Array<User_Seen_Property>;
  /** fetch aggregated fields from the table: "user_seen_property" */
  user_seen_property_aggregate: User_Seen_Property_Aggregate;
  /** fetch data from the table: "user_seen_property" using primary key columns */
  user_seen_property_by_pk?: Maybe<User_Seen_Property>;
  /** fetch data from the table in a streaming manner: "user_seen_property" */
  user_seen_property_stream: Array<User_Seen_Property>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate;
  /** fetch data from the table: "users_activity_summary" */
  users_activity_summary: Array<Users_Activity_Summary>;
  /** fetch aggregated fields from the table: "users_activity_summary" */
  users_activity_summary_aggregate: Users_Activity_Summary_Aggregate;
  /** fetch data from the table: "users_activity_summary" using primary key columns */
  users_activity_summary_by_pk?: Maybe<Users_Activity_Summary>;
  /** fetch data from the table in a streaming manner: "users_activity_summary" */
  users_activity_summary_stream: Array<Users_Activity_Summary>;
  /** fetch data from the table in a streaming manner: "auth.users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table in a streaming manner: "storage.virus" */
  virus_stream: Array<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
  /** fetch data from the table: "visibility_status" */
  visibility_status: Array<Visibility_Status>;
  /** fetch aggregated fields from the table: "visibility_status" */
  visibility_status_aggregate: Visibility_Status_Aggregate;
  /** fetch data from the table: "visibility_status" using primary key columns */
  visibility_status_by_pk?: Maybe<Visibility_Status>;
  /** fetch data from the table in a streaming manner: "visibility_status" */
  visibility_status_stream: Array<Visibility_Status>;
  /** fetch data from the table: "whatsapp_ai_inbound_message" */
  whatsapp_ai_inbound_message: Array<Whatsapp_Ai_Inbound_Message>;
  /** fetch aggregated fields from the table: "whatsapp_ai_inbound_message" */
  whatsapp_ai_inbound_message_aggregate: Whatsapp_Ai_Inbound_Message_Aggregate;
  /** fetch data from the table: "whatsapp_ai_inbound_message" using primary key columns */
  whatsapp_ai_inbound_message_by_pk?: Maybe<Whatsapp_Ai_Inbound_Message>;
  /** fetch data from the table in a streaming manner: "whatsapp_ai_inbound_message" */
  whatsapp_ai_inbound_message_stream: Array<Whatsapp_Ai_Inbound_Message>;
  /** fetch data from the table: "whatsapp_ai_outbox_part" */
  whatsapp_ai_outbox_part: Array<Whatsapp_Ai_Outbox_Part>;
  /** fetch aggregated fields from the table: "whatsapp_ai_outbox_part" */
  whatsapp_ai_outbox_part_aggregate: Whatsapp_Ai_Outbox_Part_Aggregate;
  /** fetch data from the table: "whatsapp_ai_outbox_part" using primary key columns */
  whatsapp_ai_outbox_part_by_pk?: Maybe<Whatsapp_Ai_Outbox_Part>;
  /** fetch data from the table in a streaming manner: "whatsapp_ai_outbox_part" */
  whatsapp_ai_outbox_part_stream: Array<Whatsapp_Ai_Outbox_Part>;
  /** fetch data from the table: "whatsapp_ai_turn" */
  whatsapp_ai_turn: Array<Whatsapp_Ai_Turn>;
  /** fetch aggregated fields from the table: "whatsapp_ai_turn" */
  whatsapp_ai_turn_aggregate: Whatsapp_Ai_Turn_Aggregate;
  /** fetch data from the table: "whatsapp_ai_turn" using primary key columns */
  whatsapp_ai_turn_by_pk?: Maybe<Whatsapp_Ai_Turn>;
  /** fetch data from the table in a streaming manner: "whatsapp_ai_turn" */
  whatsapp_ai_turn_stream: Array<Whatsapp_Ai_Turn>;
  /** fetch data from the table: "whatsapp_chat" */
  whatsapp_chat: Array<Whatsapp_Chat>;
  /** fetch aggregated fields from the table: "whatsapp_chat" */
  whatsapp_chat_aggregate: Whatsapp_Chat_Aggregate;
  /** fetch data from the table: "whatsapp_chat" using primary key columns */
  whatsapp_chat_by_pk?: Maybe<Whatsapp_Chat>;
  /** fetch data from the table in a streaming manner: "whatsapp_chat" */
  whatsapp_chat_stream: Array<Whatsapp_Chat>;
  /** fetch data from the table: "whatsapp_human" */
  whatsapp_human: Array<Whatsapp_Human>;
  /** fetch aggregated fields from the table: "whatsapp_human" */
  whatsapp_human_aggregate: Whatsapp_Human_Aggregate;
  /** fetch data from the table: "whatsapp_human" using primary key columns */
  whatsapp_human_by_pk?: Maybe<Whatsapp_Human>;
  /** fetch data from the table in a streaming manner: "whatsapp_human" */
  whatsapp_human_stream: Array<Whatsapp_Human>;
  /** fetch data from the table: "zone_contains" */
  zone_contains: Array<Zone_Contains>;
  /** fetch aggregated fields from the table: "zone_contains" */
  zone_contains_aggregate: Zone_Contains_Aggregate;
  /** fetch data from the table: "zone_contains" using primary key columns */
  zone_contains_by_pk?: Maybe<Zone_Contains>;
  /** fetch data from the table in a streaming manner: "zone_contains" */
  zone_contains_stream: Array<Zone_Contains>;
  /** fetch data from the table: "zone_data_method" */
  zone_data_method: Array<Zone_Data_Method>;
  /** fetch aggregated fields from the table: "zone_data_method" */
  zone_data_method_aggregate: Zone_Data_Method_Aggregate;
  /** fetch data from the table: "zone_data_method" using primary key columns */
  zone_data_method_by_pk?: Maybe<Zone_Data_Method>;
  /** fetch data from the table in a streaming manner: "zone_data_method" */
  zone_data_method_stream: Array<Zone_Data_Method>;
};


export type Subscription_RootAddress_TypesArgs = {
  distinct_on?: InputMaybe<Array<Address_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Types_Order_By>>;
  where?: InputMaybe<Address_Types_Bool_Exp>;
};


export type Subscription_RootAddress_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Types_Order_By>>;
  where?: InputMaybe<Address_Types_Bool_Exp>;
};


export type Subscription_RootAddress_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootAddress_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Address_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Types_Bool_Exp>;
};


export type Subscription_RootAgencyArgs = {
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Subscription_RootAgencyDashboardStatisticsArgs = {
  args: AgencyDashboardStatistics_Arguments;
  distinct_on?: InputMaybe<Array<Lister_Dashboard_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Dashboard_Model_Order_By>>;
  where?: InputMaybe<Lister_Dashboard_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootAgencyScrapedPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Agency_Properties_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Properties_Model_Order_By>>;
  where?: InputMaybe<Agency_Properties_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootAgencyViewsGraphicArgs = {
  args: AgencyViewsGraphic_Arguments;
  distinct_on?: InputMaybe<Array<Daily_Views_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Views_Order_By>>;
  where?: InputMaybe<Daily_Views_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootAgency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Subscription_RootAgency_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAgency_HealthArgs = {
  distinct_on?: InputMaybe<Array<Agency_Health_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Health_Order_By>>;
  where?: InputMaybe<Agency_Health_Bool_Exp>;
};


export type Subscription_RootAgency_Health_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agency_Health_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Health_Order_By>>;
  where?: InputMaybe<Agency_Health_Bool_Exp>;
};


export type Subscription_RootAgency_Health_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agency_Health_Stream_Cursor_Input>>;
  where?: InputMaybe<Agency_Health_Bool_Exp>;
};


export type Subscription_RootAgency_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agency_Stream_Cursor_Input>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Subscription_RootAgency_TypeArgs = {
  distinct_on?: InputMaybe<Array<Agency_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Type_Order_By>>;
  where?: InputMaybe<Agency_Type_Bool_Exp>;
};


export type Subscription_RootAgency_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agency_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Type_Order_By>>;
  where?: InputMaybe<Agency_Type_Bool_Exp>;
};


export type Subscription_RootAgency_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootAgency_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agency_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Agency_Type_Bool_Exp>;
};


export type Subscription_RootAgent_ActionArgs = {
  distinct_on?: InputMaybe<Array<Agent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Action_Order_By>>;
  where?: InputMaybe<Agent_Action_Bool_Exp>;
};


export type Subscription_RootAgent_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Action_Order_By>>;
  where?: InputMaybe<Agent_Action_Bool_Exp>;
};


export type Subscription_RootAgent_Action_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAgent_Action_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agent_Action_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_Action_Bool_Exp>;
};


export type Subscription_RootAgent_TaskArgs = {
  distinct_on?: InputMaybe<Array<Agent_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Task_Order_By>>;
  where?: InputMaybe<Agent_Task_Bool_Exp>;
};


export type Subscription_RootAgent_Task_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Task_Order_By>>;
  where?: InputMaybe<Agent_Task_Bool_Exp>;
};


export type Subscription_RootAgent_Task_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAgent_Task_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agent_Task_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_Task_Bool_Exp>;
};


export type Subscription_RootAmenitiesArgs = {
  distinct_on?: InputMaybe<Array<Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Amenities_Order_By>>;
  where?: InputMaybe<Amenities_Bool_Exp>;
};


export type Subscription_RootAmenities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Amenities_Order_By>>;
  where?: InputMaybe<Amenities_Bool_Exp>;
};


export type Subscription_RootAmenities_By_PkArgs = {
  amenity: Scalars['String']['input'];
};


export type Subscription_RootAmenities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Amenities_Stream_Cursor_Input>>;
  where?: InputMaybe<Amenities_Bool_Exp>;
};


export type Subscription_RootApp_ConfigArgs = {
  distinct_on?: InputMaybe<Array<App_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Config_Order_By>>;
  where?: InputMaybe<App_Config_Bool_Exp>;
};


export type Subscription_RootApp_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Config_Order_By>>;
  where?: InputMaybe<App_Config_Bool_Exp>;
};


export type Subscription_RootApp_Config_By_PkArgs = {
  platform: Scalars['String']['input'];
};


export type Subscription_RootApp_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Config_Bool_Exp>;
};


export type Subscription_RootAuthProviderArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootAuthProviderRequestArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthProviderRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProviderRequests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthProviderRequests_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthProviders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthProviders_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAuthRefreshTokenTypesArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenTypes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRefreshTokenTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRefreshTokens_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRoleArgs = {
  role: Scalars['String']['input'];
};


export type Subscription_RootAuthRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthRoles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRoles_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserProviderArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserProviders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserProviders_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserRoleArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserRoles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserRoles_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeys_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserSecurityKeys_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootBlogArgs = {
  distinct_on?: InputMaybe<Array<Blog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Order_By>>;
  where?: InputMaybe<Blog_Bool_Exp>;
};


export type Subscription_RootBlog_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Order_By>>;
  where?: InputMaybe<Blog_Bool_Exp>;
};


export type Subscription_RootBlog_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBlog_PostArgs = {
  distinct_on?: InputMaybe<Array<Blog_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Post_Order_By>>;
  where?: InputMaybe<Blog_Post_Bool_Exp>;
};


export type Subscription_RootBlog_Post_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blog_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Post_Order_By>>;
  where?: InputMaybe<Blog_Post_Bool_Exp>;
};


export type Subscription_RootBlog_Post_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBlog_Post_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Blog_Post_Stream_Cursor_Input>>;
  where?: InputMaybe<Blog_Post_Bool_Exp>;
};


export type Subscription_RootBlog_SectionArgs = {
  distinct_on?: InputMaybe<Array<Blog_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Section_Order_By>>;
  where?: InputMaybe<Blog_Section_Bool_Exp>;
};


export type Subscription_RootBlog_Section_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blog_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Section_Order_By>>;
  where?: InputMaybe<Blog_Section_Bool_Exp>;
};


export type Subscription_RootBlog_Section_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBlog_Section_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Blog_Section_Stream_Cursor_Input>>;
  where?: InputMaybe<Blog_Section_Bool_Exp>;
};


export type Subscription_RootBlog_StatusArgs = {
  distinct_on?: InputMaybe<Array<Blog_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Status_Order_By>>;
  where?: InputMaybe<Blog_Status_Bool_Exp>;
};


export type Subscription_RootBlog_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blog_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blog_Status_Order_By>>;
  where?: InputMaybe<Blog_Status_Bool_Exp>;
};


export type Subscription_RootBlog_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootBlog_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Blog_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Blog_Status_Bool_Exp>;
};


export type Subscription_RootBlog_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Blog_Stream_Cursor_Input>>;
  where?: InputMaybe<Blog_Bool_Exp>;
};


export type Subscription_RootBucketArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBuckets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buckets_Stream_Cursor_Input>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBuilderArgs = {
  distinct_on?: InputMaybe<Array<Builder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Builder_Order_By>>;
  where?: InputMaybe<Builder_Bool_Exp>;
};


export type Subscription_RootBuilder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Builder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Builder_Order_By>>;
  where?: InputMaybe<Builder_Bool_Exp>;
};


export type Subscription_RootBuilder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuilder_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Builder_Stream_Cursor_Input>>;
  where?: InputMaybe<Builder_Bool_Exp>;
};


export type Subscription_RootCertified_AgentArgs = {
  distinct_on?: InputMaybe<Array<Certified_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Certified_Agent_Order_By>>;
  where?: InputMaybe<Certified_Agent_Bool_Exp>;
};


export type Subscription_RootCertified_Agent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certified_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Certified_Agent_Order_By>>;
  where?: InputMaybe<Certified_Agent_Bool_Exp>;
};


export type Subscription_RootCertified_Agent_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCertified_Agent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Certified_Agent_Stream_Cursor_Input>>;
  where?: InputMaybe<Certified_Agent_Bool_Exp>;
};


export type Subscription_RootChat_Response_TypeArgs = {
  distinct_on?: InputMaybe<Array<Chat_Response_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Response_Type_Order_By>>;
  where?: InputMaybe<Chat_Response_Type_Bool_Exp>;
};


export type Subscription_RootChat_Response_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Response_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Response_Type_Order_By>>;
  where?: InputMaybe<Chat_Response_Type_Bool_Exp>;
};


export type Subscription_RootChat_Response_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootChat_Response_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Response_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Response_Type_Bool_Exp>;
};


export type Subscription_RootCitizens_Property_List_ViewArgs = {
  distinct_on?: InputMaybe<Array<Citizens_Property_List_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Citizens_Property_List_View_Order_By>>;
  where?: InputMaybe<Citizens_Property_List_View_Bool_Exp>;
};


export type Subscription_RootCitizens_Property_List_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Citizens_Property_List_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Citizens_Property_List_View_Order_By>>;
  where?: InputMaybe<Citizens_Property_List_View_Bool_Exp>;
};


export type Subscription_RootCitizens_Property_List_View_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Citizens_Property_List_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Citizens_Property_List_View_Bool_Exp>;
};


export type Subscription_RootCityArgs = {
  distinct_on?: InputMaybe<Array<City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Order_By>>;
  where?: InputMaybe<City_Bool_Exp>;
};


export type Subscription_RootCity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Order_By>>;
  where?: InputMaybe<City_Bool_Exp>;
};


export type Subscription_RootCity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<City_Stream_Cursor_Input>>;
  where?: InputMaybe<City_Bool_Exp>;
};


export type Subscription_RootCity_ZoneArgs = {
  distinct_on?: InputMaybe<Array<City_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Order_By>>;
  where?: InputMaybe<City_Zone_Bool_Exp>;
};


export type Subscription_RootCity_Zone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Order_By>>;
  where?: InputMaybe<City_Zone_Bool_Exp>;
};


export type Subscription_RootCity_Zone_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCity_Zone_OriginArgs = {
  distinct_on?: InputMaybe<Array<City_Zone_Origin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Origin_Order_By>>;
  where?: InputMaybe<City_Zone_Origin_Bool_Exp>;
};


export type Subscription_RootCity_Zone_Origin_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Zone_Origin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Origin_Order_By>>;
  where?: InputMaybe<City_Zone_Origin_Bool_Exp>;
};


export type Subscription_RootCity_Zone_Origin_By_PkArgs = {
  origin: Scalars['String']['input'];
};


export type Subscription_RootCity_Zone_Origin_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<City_Zone_Origin_Stream_Cursor_Input>>;
  where?: InputMaybe<City_Zone_Origin_Bool_Exp>;
};


export type Subscription_RootCity_Zone_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<City_Zone_Stream_Cursor_Input>>;
  where?: InputMaybe<City_Zone_Bool_Exp>;
};


export type Subscription_RootClaim_Request_StatusArgs = {
  distinct_on?: InputMaybe<Array<Claim_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Claim_Request_Status_Order_By>>;
  where?: InputMaybe<Claim_Request_Status_Bool_Exp>;
};


export type Subscription_RootClaim_Request_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Claim_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Claim_Request_Status_Order_By>>;
  where?: InputMaybe<Claim_Request_Status_Bool_Exp>;
};


export type Subscription_RootClaim_Request_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootClaim_Request_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Claim_Request_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Claim_Request_Status_Bool_Exp>;
};


export type Subscription_RootClassifiedPropertiesArgs = {
  args: ClassifiedProperties_Arguments;
  distinct_on?: InputMaybe<Array<Classified_Properties_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Classified_Properties_Model_Order_By>>;
  where?: InputMaybe<Classified_Properties_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootCleringArgs = {
  distinct_on?: InputMaybe<Array<Clering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clering_Order_By>>;
  where?: InputMaybe<Clering_Bool_Exp>;
};


export type Subscription_RootClering_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clering_Order_By>>;
  where?: InputMaybe<Clering_Bool_Exp>;
};


export type Subscription_RootClering_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootClering_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Clering_Stream_Cursor_Input>>;
  where?: InputMaybe<Clering_Bool_Exp>;
};


export type Subscription_RootConstruction_StatusArgs = {
  distinct_on?: InputMaybe<Array<Construction_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Status_Order_By>>;
  where?: InputMaybe<Construction_Status_Bool_Exp>;
};


export type Subscription_RootConstruction_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Construction_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Status_Order_By>>;
  where?: InputMaybe<Construction_Status_Bool_Exp>;
};


export type Subscription_RootConstruction_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootConstruction_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Construction_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Construction_Status_Bool_Exp>;
};


export type Subscription_RootContactArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Subscription_RootContact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Subscription_RootContact_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootContact_HealthArgs = {
  distinct_on?: InputMaybe<Array<Contact_Health_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Health_Order_By>>;
  where?: InputMaybe<Contact_Health_Bool_Exp>;
};


export type Subscription_RootContact_Health_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Health_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Health_Order_By>>;
  where?: InputMaybe<Contact_Health_Bool_Exp>;
};


export type Subscription_RootContact_Health_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contact_Health_Stream_Cursor_Input>>;
  where?: InputMaybe<Contact_Health_Bool_Exp>;
};


export type Subscription_RootContact_Phone_NumberArgs = {
  distinct_on?: InputMaybe<Array<Contact_Phone_Number_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Phone_Number_Order_By>>;
  where?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
};


export type Subscription_RootContact_Phone_Number_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Phone_Number_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Phone_Number_Order_By>>;
  where?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
};


export type Subscription_RootContact_Phone_Number_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootContact_Phone_Number_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contact_Phone_Number_Stream_Cursor_Input>>;
  where?: InputMaybe<Contact_Phone_Number_Bool_Exp>;
};


export type Subscription_RootContact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contact_Stream_Cursor_Input>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Subscription_RootContact_TypeArgs = {
  distinct_on?: InputMaybe<Array<Contact_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Type_Order_By>>;
  where?: InputMaybe<Contact_Type_Bool_Exp>;
};


export type Subscription_RootContact_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Type_Order_By>>;
  where?: InputMaybe<Contact_Type_Bool_Exp>;
};


export type Subscription_RootContact_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootContact_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contact_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Contact_Type_Bool_Exp>;
};


export type Subscription_RootContent_TypeArgs = {
  distinct_on?: InputMaybe<Array<Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Content_Type_Order_By>>;
  where?: InputMaybe<Content_Type_Bool_Exp>;
};


export type Subscription_RootContent_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Content_Type_Order_By>>;
  where?: InputMaybe<Content_Type_Bool_Exp>;
};


export type Subscription_RootContent_Type_By_PkArgs = {
  content_type: Scalars['String']['input'];
};


export type Subscription_RootContent_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Content_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Content_Type_Bool_Exp>;
};


export type Subscription_RootCountriesArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootCountries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootCountries_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCountries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Countries_Stream_Cursor_Input>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCountry_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCountry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Country_Stream_Cursor_Input>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCurrencyArgs = {
  distinct_on?: InputMaybe<Array<Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Order_By>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Subscription_RootCurrency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Order_By>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Subscription_RootCurrency_By_PkArgs = {
  currency: Scalars['String']['input'];
};


export type Subscription_RootCurrency_Exchange_RatesArgs = {
  distinct_on?: InputMaybe<Array<Currency_Exchange_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Exchange_Rates_Order_By>>;
  where?: InputMaybe<Currency_Exchange_Rates_Bool_Exp>;
};


export type Subscription_RootCurrency_Exchange_Rates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currency_Exchange_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Exchange_Rates_Order_By>>;
  where?: InputMaybe<Currency_Exchange_Rates_Bool_Exp>;
};


export type Subscription_RootCurrency_Exchange_Rates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCurrency_Exchange_Rates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Currency_Exchange_Rates_Stream_Cursor_Input>>;
  where?: InputMaybe<Currency_Exchange_Rates_Bool_Exp>;
};


export type Subscription_RootCurrency_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Currency_Stream_Cursor_Input>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Subscription_RootDailyRegisteredUsersArgs = {
  args: DailyRegisteredUsers_Arguments;
  distinct_on?: InputMaybe<Array<Daily_Active_Users_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Active_Users_Model_Order_By>>;
  where?: InputMaybe<Daily_Active_Users_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootDaliyActiveUsersArgs = {
  args: DaliyActiveUsers_Arguments;
  distinct_on?: InputMaybe<Array<Daily_Active_Users_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Active_Users_Model_Order_By>>;
  where?: InputMaybe<Daily_Active_Users_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootDaliyQueriesStatisticsArgs = {
  args: DaliyQueriesStatistics_Arguments;
  distinct_on?: InputMaybe<Array<Daliy_Queries_Statistics_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daliy_Queries_Statistics_Model_Order_By>>;
  where?: InputMaybe<Daliy_Queries_Statistics_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootDuplicate_Cfn_With_Null_CnameArgs = {
  distinct_on?: InputMaybe<Array<Duplicate_Cfn_With_Null_Cname_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Duplicate_Cfn_With_Null_Cname_Order_By>>;
  where?: InputMaybe<Duplicate_Cfn_With_Null_Cname_Bool_Exp>;
};


export type Subscription_RootDuplicate_Cfn_With_Null_Cname_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Duplicate_Cfn_With_Null_Cname_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Duplicate_Cfn_With_Null_Cname_Order_By>>;
  where?: InputMaybe<Duplicate_Cfn_With_Null_Cname_Bool_Exp>;
};


export type Subscription_RootDuplicate_Cfn_With_Null_Cname_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Duplicate_Cfn_With_Null_Cname_Stream_Cursor_Input>>;
  where?: InputMaybe<Duplicate_Cfn_With_Null_Cname_Bool_Exp>;
};


export type Subscription_RootDuplicate_Phone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Duplicate_Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Duplicate_Phone_Numbers_Order_By>>;
  where?: InputMaybe<Duplicate_Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootDuplicate_Phone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Duplicate_Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Duplicate_Phone_Numbers_Order_By>>;
  where?: InputMaybe<Duplicate_Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootDuplicate_Phone_Numbers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Duplicate_Phone_Numbers_Stream_Cursor_Input>>;
  where?: InputMaybe<Duplicate_Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootEntitiesArgs = {
  distinct_on?: InputMaybe<Array<Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entities_Order_By>>;
  where?: InputMaybe<Entities_Bool_Exp>;
};


export type Subscription_RootEntities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entities_Order_By>>;
  where?: InputMaybe<Entities_Bool_Exp>;
};


export type Subscription_RootEntities_By_PkArgs = {
  entity_type: Scalars['String']['input'];
};


export type Subscription_RootEntities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Entities_Stream_Cursor_Input>>;
  where?: InputMaybe<Entities_Bool_Exp>;
};


export type Subscription_RootExchange_RatesArgs = {
  distinct_on?: InputMaybe<Array<Exchange_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Exchange_Rates_Order_By>>;
  where?: InputMaybe<Exchange_Rates_Bool_Exp>;
};


export type Subscription_RootExchange_Rates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exchange_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Exchange_Rates_Order_By>>;
  where?: InputMaybe<Exchange_Rates_Bool_Exp>;
};


export type Subscription_RootExchange_Rates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootExchange_Rates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Exchange_Rates_Stream_Cursor_Input>>;
  where?: InputMaybe<Exchange_Rates_Bool_Exp>;
};


export type Subscription_RootFavouritePropertiesTrendArgs = {
  args: FavouritePropertiesTrend_Arguments;
  distinct_on?: InputMaybe<Array<Favourite_Properties_Trend_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favourite_Properties_Trend_Model_Order_By>>;
  where?: InputMaybe<Favourite_Properties_Trend_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootFeatureArgs = {
  distinct_on?: InputMaybe<Array<Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Order_By>>;
  where?: InputMaybe<Feature_Bool_Exp>;
};


export type Subscription_RootFeature_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Order_By>>;
  where?: InputMaybe<Feature_Bool_Exp>;
};


export type Subscription_RootFeature_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFeature_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Feature_Stream_Cursor_Input>>;
  where?: InputMaybe<Feature_Bool_Exp>;
};


export type Subscription_RootFeature_TypeArgs = {
  distinct_on?: InputMaybe<Array<Feature_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Type_Order_By>>;
  where?: InputMaybe<Feature_Type_Bool_Exp>;
};


export type Subscription_RootFeature_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Type_Order_By>>;
  where?: InputMaybe<Feature_Type_Bool_Exp>;
};


export type Subscription_RootFeature_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootFeature_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Feature_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Feature_Type_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_TypeArgs = {
  distinct_on?: InputMaybe<Array<File_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Type_Order_By>>;
  where?: InputMaybe<File_Type_Bool_Exp>;
};


export type Subscription_RootFile_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Type_Order_By>>;
  where?: InputMaybe<File_Type_Bool_Exp>;
};


export type Subscription_RootFile_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootFile_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<File_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Type_Bool_Exp>;
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFolder_AmenitiesArgs = {
  distinct_on?: InputMaybe<Array<Folder_Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Amenities_Order_By>>;
  where?: InputMaybe<Folder_Amenities_Bool_Exp>;
};


export type Subscription_RootFolder_Amenities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Folder_Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Amenities_Order_By>>;
  where?: InputMaybe<Folder_Amenities_Bool_Exp>;
};


export type Subscription_RootFolder_Amenities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFolder_Amenities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Folder_Amenities_Stream_Cursor_Input>>;
  where?: InputMaybe<Folder_Amenities_Bool_Exp>;
};


export type Subscription_RootFolder_ImageArgs = {
  distinct_on?: InputMaybe<Array<Folder_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Image_Order_By>>;
  where?: InputMaybe<Folder_Image_Bool_Exp>;
};


export type Subscription_RootFolder_Image_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Folder_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Image_Order_By>>;
  where?: InputMaybe<Folder_Image_Bool_Exp>;
};


export type Subscription_RootFolder_Image_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFolder_Image_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Folder_Image_Stream_Cursor_Input>>;
  where?: InputMaybe<Folder_Image_Bool_Exp>;
};


export type Subscription_RootFolder_Properties_TypeArgs = {
  distinct_on?: InputMaybe<Array<Folder_Properties_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Properties_Type_Order_By>>;
  where?: InputMaybe<Folder_Properties_Type_Bool_Exp>;
};


export type Subscription_RootFolder_Properties_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Folder_Properties_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Properties_Type_Order_By>>;
  where?: InputMaybe<Folder_Properties_Type_Bool_Exp>;
};


export type Subscription_RootFolder_Properties_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFolder_Properties_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Folder_Properties_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Folder_Properties_Type_Bool_Exp>;
};


export type Subscription_RootFolder_StatusArgs = {
  distinct_on?: InputMaybe<Array<Folder_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Status_Order_By>>;
  where?: InputMaybe<Folder_Status_Bool_Exp>;
};


export type Subscription_RootFolder_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Folder_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Status_Order_By>>;
  where?: InputMaybe<Folder_Status_Bool_Exp>;
};


export type Subscription_RootFolder_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootFolder_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Folder_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Folder_Status_Bool_Exp>;
};


export type Subscription_RootFolder_TypeArgs = {
  distinct_on?: InputMaybe<Array<Folder_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Type_Order_By>>;
  where?: InputMaybe<Folder_Type_Bool_Exp>;
};


export type Subscription_RootFolder_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Folder_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Type_Order_By>>;
  where?: InputMaybe<Folder_Type_Bool_Exp>;
};


export type Subscription_RootFolder_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootFolder_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Folder_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Folder_Type_Bool_Exp>;
};


export type Subscription_RootFurnishing_StatusArgs = {
  distinct_on?: InputMaybe<Array<Furnishing_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Furnishing_Status_Order_By>>;
  where?: InputMaybe<Furnishing_Status_Bool_Exp>;
};


export type Subscription_RootFurnishing_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Furnishing_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Furnishing_Status_Order_By>>;
  where?: InputMaybe<Furnishing_Status_Bool_Exp>;
};


export type Subscription_RootFurnishing_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootFurnishing_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Furnishing_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Furnishing_Status_Bool_Exp>;
};


export type Subscription_RootGetCityZoneForCoordsArgs = {
  args: GetCityZoneForCoords_Arguments;
  distinct_on?: InputMaybe<Array<City_Zone_Object_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Object_Order_By>>;
  where?: InputMaybe<City_Zone_Object_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootGetOrderByRelevanceCityZonesArgs = {
  args: GetOrderByRelevanceCityZones_Arguments;
  distinct_on?: InputMaybe<Array<City_Zone_Object_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Object_Order_By>>;
  where?: InputMaybe<City_Zone_Object_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootGetOrderByRelevanceFormattedAddressCityZonesArgs = {
  args: GetOrderByRelevanceFormattedAddressCityZones_Arguments;
  distinct_on?: InputMaybe<Array<City_Zone_Object_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Object_Order_By>>;
  where?: InputMaybe<City_Zone_Object_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootGet_Citizens_Property_List_FunctionArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


export type Subscription_RootGet_Citizens_Property_List_Function_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


export type Subscription_RootGet_Folders_Without_Property_ListArgs = {
  args: Get_Folders_Without_Property_List_Args;
  distinct_on?: InputMaybe<Array<Property_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Order_By>>;
  where?: InputMaybe<Property_Folder_Bool_Exp>;
};


export type Subscription_RootGet_Folders_Without_Property_List_AggregateArgs = {
  args: Get_Folders_Without_Property_List_Args;
  distinct_on?: InputMaybe<Array<Property_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Order_By>>;
  where?: InputMaybe<Property_Folder_Bool_Exp>;
};


export type Subscription_RootGet_Search_Sessions_Sorted_By_Last_QueryArgs = {
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


export type Subscription_RootGet_Search_Sessions_Sorted_By_Last_Query_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Agencies_By_NameArgs = {
  args: Get_Similar_Agencies_By_Name_Args;
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Agencies_By_Name_AggregateArgs = {
  args: Get_Similar_Agencies_By_Name_Args;
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Subscription_RootGet_Similar_PropertiesArgs = {
  args: Get_Similar_Properties_Args;
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Properties_AggregateArgs = {
  args: Get_Similar_Properties_Args;
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Properties_By_SlugArgs = {
  args: Get_Similar_Properties_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Properties_By_Slug_AggregateArgs = {
  args: Get_Similar_Properties_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


export type Subscription_RootGet_Top_Neighborhood_For_City_ZoneArgs = {
  args: Get_Top_Neighborhood_For_City_Zone_Args;
  distinct_on?: InputMaybe<Array<City_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Order_By>>;
  where?: InputMaybe<City_Zone_Bool_Exp>;
};


export type Subscription_RootGet_Top_Neighborhood_For_City_Zone_AggregateArgs = {
  args: Get_Top_Neighborhood_For_City_Zone_Args;
  distinct_on?: InputMaybe<Array<City_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Zone_Order_By>>;
  where?: InputMaybe<City_Zone_Bool_Exp>;
};


export type Subscription_RootGet_User_ActivityArgs = {
  args: Get_User_Activity_Args;
  distinct_on?: InputMaybe<Array<Users_Activity_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Activity_Summary_Order_By>>;
  where?: InputMaybe<Users_Activity_Summary_Bool_Exp>;
};


export type Subscription_RootGet_User_Activity_AggregateArgs = {
  args: Get_User_Activity_Args;
  distinct_on?: InputMaybe<Array<Users_Activity_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Activity_Summary_Order_By>>;
  where?: InputMaybe<Users_Activity_Summary_Bool_Exp>;
};


export type Subscription_RootGoogle_CalendarArgs = {
  distinct_on?: InputMaybe<Array<Google_Calendar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Calendar_Order_By>>;
  where?: InputMaybe<Google_Calendar_Bool_Exp>;
};


export type Subscription_RootGoogle_Calendar_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Google_Calendar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Calendar_Order_By>>;
  where?: InputMaybe<Google_Calendar_Bool_Exp>;
};


export type Subscription_RootGoogle_Calendar_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootGoogle_Calendar_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Google_Calendar_Stream_Cursor_Input>>;
  where?: InputMaybe<Google_Calendar_Bool_Exp>;
};


export type Subscription_RootHeatingTypeArgs = {
  distinct_on?: InputMaybe<Array<HeatingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<HeatingType_Order_By>>;
  where?: InputMaybe<HeatingType_Bool_Exp>;
};


export type Subscription_RootHeatingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<HeatingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<HeatingType_Order_By>>;
  where?: InputMaybe<HeatingType_Bool_Exp>;
};


export type Subscription_RootHeatingType_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootHeatingType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<HeatingType_Stream_Cursor_Input>>;
  where?: InputMaybe<HeatingType_Bool_Exp>;
};


export type Subscription_RootImageArgs = {
  distinct_on?: InputMaybe<Array<Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_Order_By>>;
  where?: InputMaybe<Image_Bool_Exp>;
};


export type Subscription_RootImage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_Order_By>>;
  where?: InputMaybe<Image_Bool_Exp>;
};


export type Subscription_RootImage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootImage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Image_Stream_Cursor_Input>>;
  where?: InputMaybe<Image_Bool_Exp>;
};


export type Subscription_RootInvoice_StatusArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Status_Order_By>>;
  where?: InputMaybe<Invoice_Status_Bool_Exp>;
};


export type Subscription_RootInvoice_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Status_Order_By>>;
  where?: InputMaybe<Invoice_Status_Bool_Exp>;
};


export type Subscription_RootInvoice_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootInvoice_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invoice_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Status_Bool_Exp>;
};


export type Subscription_RootLanguagesArgs = {
  distinct_on?: InputMaybe<Array<Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Languages_Order_By>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Subscription_RootLanguages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Languages_Order_By>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Subscription_RootLanguages_By_PkArgs = {
  language_id: Scalars['Int']['input'];
};


export type Subscription_RootLanguages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Languages_Stream_Cursor_Input>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Subscription_RootLead_Property_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Lead_Property_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Property_Category_Order_By>>;
  where?: InputMaybe<Lead_Property_Category_Bool_Exp>;
};


export type Subscription_RootLead_Property_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Property_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Property_Category_Order_By>>;
  where?: InputMaybe<Lead_Property_Category_Bool_Exp>;
};


export type Subscription_RootLead_Property_Category_By_PkArgs = {
  category: Scalars['String']['input'];
};


export type Subscription_RootLead_Property_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lead_Property_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Lead_Property_Category_Bool_Exp>;
};


export type Subscription_RootLead_StatusArgs = {
  distinct_on?: InputMaybe<Array<Lead_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Status_Order_By>>;
  where?: InputMaybe<Lead_Status_Bool_Exp>;
};


export type Subscription_RootLead_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Status_Order_By>>;
  where?: InputMaybe<Lead_Status_Bool_Exp>;
};


export type Subscription_RootLead_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootLead_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lead_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Lead_Status_Bool_Exp>;
};


export type Subscription_RootLead_TypeArgs = {
  distinct_on?: InputMaybe<Array<Lead_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Type_Order_By>>;
  where?: InputMaybe<Lead_Type_Bool_Exp>;
};


export type Subscription_RootLead_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Type_Order_By>>;
  where?: InputMaybe<Lead_Type_Bool_Exp>;
};


export type Subscription_RootLead_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootLead_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lead_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Lead_Type_Bool_Exp>;
};


export type Subscription_RootLeads_StatisticsArgs = {
  args: Leads_Statistics_Arguments;
  distinct_on?: InputMaybe<Array<Leads_Statistics_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Statistics_Model_Order_By>>;
  where?: InputMaybe<Leads_Statistics_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootLister_Claim_RequestArgs = {
  distinct_on?: InputMaybe<Array<Lister_Claim_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Claim_Request_Order_By>>;
  where?: InputMaybe<Lister_Claim_Request_Bool_Exp>;
};


export type Subscription_RootLister_Claim_Request_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Lister_Claim_Request_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Claim_Request_Activity_Order_By>>;
  where?: InputMaybe<Lister_Claim_Request_Activity_Bool_Exp>;
};


export type Subscription_RootLister_Claim_Request_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Claim_Request_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Claim_Request_Activity_Order_By>>;
  where?: InputMaybe<Lister_Claim_Request_Activity_Bool_Exp>;
};


export type Subscription_RootLister_Claim_Request_Activity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLister_Claim_Request_Activity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lister_Claim_Request_Activity_Stream_Cursor_Input>>;
  where?: InputMaybe<Lister_Claim_Request_Activity_Bool_Exp>;
};


export type Subscription_RootLister_Claim_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Claim_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Claim_Request_Order_By>>;
  where?: InputMaybe<Lister_Claim_Request_Bool_Exp>;
};


export type Subscription_RootLister_Claim_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLister_Claim_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lister_Claim_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Lister_Claim_Request_Bool_Exp>;
};


export type Subscription_RootLister_ContactArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Order_By>>;
  where?: InputMaybe<Lister_Contact_Bool_Exp>;
};


export type Subscription_RootLister_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Order_By>>;
  where?: InputMaybe<Lister_Contact_Bool_Exp>;
};


export type Subscription_RootLister_Contact_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLister_Contact_MeetingArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Meeting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Meeting_Order_By>>;
  where?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
};


export type Subscription_RootLister_Contact_Meeting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Meeting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Meeting_Order_By>>;
  where?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
};


export type Subscription_RootLister_Contact_Meeting_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLister_Contact_Meeting_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lister_Contact_Meeting_Stream_Cursor_Input>>;
  where?: InputMaybe<Lister_Contact_Meeting_Bool_Exp>;
};


export type Subscription_RootLister_Contact_SourceArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Source_Order_By>>;
  where?: InputMaybe<Lister_Contact_Source_Bool_Exp>;
};


export type Subscription_RootLister_Contact_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Contact_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Contact_Source_Order_By>>;
  where?: InputMaybe<Lister_Contact_Source_Bool_Exp>;
};


export type Subscription_RootLister_Contact_Source_By_PkArgs = {
  source: Scalars['String']['input'];
};


export type Subscription_RootLister_Contact_Source_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lister_Contact_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Lister_Contact_Source_Bool_Exp>;
};


export type Subscription_RootLister_Contact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lister_Contact_Stream_Cursor_Input>>;
  where?: InputMaybe<Lister_Contact_Bool_Exp>;
};


export type Subscription_RootLister_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Lister_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Leads_Order_By>>;
  where?: InputMaybe<Lister_Leads_Bool_Exp>;
};


export type Subscription_RootLister_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Leads_Order_By>>;
  where?: InputMaybe<Lister_Leads_Bool_Exp>;
};


export type Subscription_RootLister_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLister_Leads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lister_Leads_Stream_Cursor_Input>>;
  where?: InputMaybe<Lister_Leads_Bool_Exp>;
};


export type Subscription_RootLister_MeetingArgs = {
  distinct_on?: InputMaybe<Array<Lister_Meeting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Meeting_Order_By>>;
  where?: InputMaybe<Lister_Meeting_Bool_Exp>;
};


export type Subscription_RootLister_Meeting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Meeting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Meeting_Order_By>>;
  where?: InputMaybe<Lister_Meeting_Bool_Exp>;
};


export type Subscription_RootLister_Meeting_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLister_Meeting_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lister_Meeting_Stream_Cursor_Input>>;
  where?: InputMaybe<Lister_Meeting_Bool_Exp>;
};


export type Subscription_RootLister_RoleArgs = {
  distinct_on?: InputMaybe<Array<Lister_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Role_Order_By>>;
  where?: InputMaybe<Lister_Role_Bool_Exp>;
};


export type Subscription_RootLister_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lister_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Role_Order_By>>;
  where?: InputMaybe<Lister_Role_Bool_Exp>;
};


export type Subscription_RootLister_Role_By_PkArgs = {
  role: Scalars['String']['input'];
};


export type Subscription_RootLister_Role_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lister_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Lister_Role_Bool_Exp>;
};


export type Subscription_RootLocationArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Subscription_RootLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Subscription_RootLocation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLocation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Subscription_RootLocation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Location_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Type_Order_By>>;
  where?: InputMaybe<Location_Type_Bool_Exp>;
};


export type Subscription_RootLocation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Type_Order_By>>;
  where?: InputMaybe<Location_Type_Bool_Exp>;
};


export type Subscription_RootLocation_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootLocation_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Location_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Location_Type_Bool_Exp>;
};


export type Subscription_RootMain_CurrencyArgs = {
  distinct_on?: InputMaybe<Array<Main_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Main_Currency_Order_By>>;
  where?: InputMaybe<Main_Currency_Bool_Exp>;
};


export type Subscription_RootMain_Currency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Main_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Main_Currency_Order_By>>;
  where?: InputMaybe<Main_Currency_Bool_Exp>;
};


export type Subscription_RootMain_Currency_By_PkArgs = {
  currency: Scalars['String']['input'];
};


export type Subscription_RootMain_Currency_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Main_Currency_Stream_Cursor_Input>>;
  where?: InputMaybe<Main_Currency_Bool_Exp>;
};


export type Subscription_RootNatural_Language_QueriesArgs = {
  distinct_on?: InputMaybe<Array<Natural_Language_Queries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Natural_Language_Queries_Order_By>>;
  where?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
};


export type Subscription_RootNatural_Language_Queries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Natural_Language_Queries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Natural_Language_Queries_Order_By>>;
  where?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
};


export type Subscription_RootNatural_Language_Queries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNatural_Language_Queries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Natural_Language_Queries_Stream_Cursor_Input>>;
  where?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
};


export type Subscription_RootNotificationArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Subscription_RootNotification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Subscription_RootNotification_AmenitiesArgs = {
  distinct_on?: InputMaybe<Array<Notification_Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Amenities_Order_By>>;
  where?: InputMaybe<Notification_Amenities_Bool_Exp>;
};


export type Subscription_RootNotification_Amenities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Amenities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Amenities_Order_By>>;
  where?: InputMaybe<Notification_Amenities_Bool_Exp>;
};


export type Subscription_RootNotification_Amenities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNotification_Amenities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notification_Amenities_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Amenities_Bool_Exp>;
};


export type Subscription_RootNotification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNotification_FeatureArgs = {
  distinct_on?: InputMaybe<Array<Notification_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Feature_Order_By>>;
  where?: InputMaybe<Notification_Feature_Bool_Exp>;
};


export type Subscription_RootNotification_Feature_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Feature_Order_By>>;
  where?: InputMaybe<Notification_Feature_Bool_Exp>;
};


export type Subscription_RootNotification_Feature_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNotification_Feature_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notification_Feature_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Feature_Bool_Exp>;
};


export type Subscription_RootNotification_Property_TypeArgs = {
  distinct_on?: InputMaybe<Array<Notification_Property_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Property_Type_Order_By>>;
  where?: InputMaybe<Notification_Property_Type_Bool_Exp>;
};


export type Subscription_RootNotification_Property_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Property_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Property_Type_Order_By>>;
  where?: InputMaybe<Notification_Property_Type_Bool_Exp>;
};


export type Subscription_RootNotification_Property_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNotification_Property_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notification_Property_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Property_Type_Bool_Exp>;
};


export type Subscription_RootNotification_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Subscription_RootNotification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Type_Order_By>>;
  where?: InputMaybe<Notification_Type_Bool_Exp>;
};


export type Subscription_RootNotification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Type_Order_By>>;
  where?: InputMaybe<Notification_Type_Bool_Exp>;
};


export type Subscription_RootNotification_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootNotification_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notification_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Type_Bool_Exp>;
};


export type Subscription_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_StatusArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Status_Order_By>>;
  where?: InputMaybe<Order_Status_Bool_Exp>;
};


export type Subscription_RootOrder_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Status_Order_By>>;
  where?: InputMaybe<Order_Status_Bool_Exp>;
};


export type Subscription_RootOrder_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootOrder_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Status_Bool_Exp>;
};


export type Subscription_RootOrder_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganizationDashboardStatisticsArgs = {
  args: OrganizationDashboardStatistics_Arguments;
  distinct_on?: InputMaybe<Array<Lister_Dashboard_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lister_Dashboard_Model_Order_By>>;
  where?: InputMaybe<Lister_Dashboard_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootOrganizationViewsGraphicArgs = {
  args: OrganizationViewsGraphic_Arguments;
  distinct_on?: InputMaybe<Array<Daily_Views_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Views_Order_By>>;
  where?: InputMaybe<Daily_Views_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Lead_LocationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Lead_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Lead_Location_Order_By>>;
  where?: InputMaybe<Organization_Lead_Location_Bool_Exp>;
};


export type Subscription_RootOrganization_Lead_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Lead_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Lead_Location_Order_By>>;
  where?: InputMaybe<Organization_Lead_Location_Bool_Exp>;
};


export type Subscription_RootOrganization_Lead_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Lead_Location_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Lead_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Lead_Location_Bool_Exp>;
};


export type Subscription_RootOrganization_Lead_PropertyArgs = {
  distinct_on?: InputMaybe<Array<Organization_Lead_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Lead_Property_Order_By>>;
  where?: InputMaybe<Organization_Lead_Property_Bool_Exp>;
};


export type Subscription_RootOrganization_Lead_Property_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Lead_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Lead_Property_Order_By>>;
  where?: InputMaybe<Organization_Lead_Property_Bool_Exp>;
};


export type Subscription_RootOrganization_Lead_Property_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Lead_Property_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Lead_Property_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Lead_Property_Bool_Exp>;
};


export type Subscription_RootOrganization_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Leads_Order_By>>;
  where?: InputMaybe<Organization_Leads_Bool_Exp>;
};


export type Subscription_RootOrganization_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Leads_Order_By>>;
  where?: InputMaybe<Organization_Leads_Bool_Exp>;
};


export type Subscription_RootOrganization_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Leads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Leads_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Leads_Bool_Exp>;
};


export type Subscription_RootOrganization_RoleArgs = {
  distinct_on?: InputMaybe<Array<Organization_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Role_Order_By>>;
  where?: InputMaybe<Organization_Role_Bool_Exp>;
};


export type Subscription_RootOrganization_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Role_Order_By>>;
  where?: InputMaybe<Organization_Role_Bool_Exp>;
};


export type Subscription_RootOrganization_Role_By_PkArgs = {
  role: Scalars['String']['input'];
};


export type Subscription_RootOrganization_Role_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Role_Bool_Exp>;
};


export type Subscription_RootOrganization_StatusArgs = {
  distinct_on?: InputMaybe<Array<Organization_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Status_Order_By>>;
  where?: InputMaybe<Organization_Status_Bool_Exp>;
};


export type Subscription_RootOrganization_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Status_Order_By>>;
  where?: InputMaybe<Organization_Status_Bool_Exp>;
};


export type Subscription_RootOrganization_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootOrganization_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Status_Bool_Exp>;
};


export type Subscription_RootOrganization_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_Telegram_Agent_LinkArgs = {
  distinct_on?: InputMaybe<Array<Organization_Telegram_Agent_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Telegram_Agent_Link_Order_By>>;
  where?: InputMaybe<Organization_Telegram_Agent_Link_Bool_Exp>;
};


export type Subscription_RootOrganization_Telegram_Agent_Link_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Telegram_Agent_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Telegram_Agent_Link_Order_By>>;
  where?: InputMaybe<Organization_Telegram_Agent_Link_Bool_Exp>;
};


export type Subscription_RootOrganization_Telegram_Agent_Link_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Telegram_Agent_Link_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Telegram_Agent_Link_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Telegram_Agent_Link_Bool_Exp>;
};


export type Subscription_RootOrganization_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organization_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Type_Order_By>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Type_Order_By>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootOrganization_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_Whatsapp_Ai_AllowlistArgs = {
  distinct_on?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Order_By>>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>;
};


export type Subscription_RootOrganization_Whatsapp_Ai_Allowlist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Whatsapp_Ai_Allowlist_Order_By>>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>;
};


export type Subscription_RootOrganization_Whatsapp_Ai_Allowlist_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Whatsapp_Ai_Allowlist_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Whatsapp_Ai_Allowlist_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Allowlist_Bool_Exp>;
};


export type Subscription_RootOrganization_Whatsapp_Ai_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Organization_Whatsapp_Ai_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Whatsapp_Ai_Config_Order_By>>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Config_Bool_Exp>;
};


export type Subscription_RootOrganization_Whatsapp_Ai_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Whatsapp_Ai_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Whatsapp_Ai_Config_Order_By>>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Config_Bool_Exp>;
};


export type Subscription_RootOrganization_Whatsapp_Ai_Config_By_PkArgs = {
  organization_id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Whatsapp_Ai_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Whatsapp_Ai_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Whatsapp_Ai_Config_Bool_Exp>;
};


export type Subscription_RootParking_TypeArgs = {
  distinct_on?: InputMaybe<Array<Parking_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Type_Order_By>>;
  where?: InputMaybe<Parking_Type_Bool_Exp>;
};


export type Subscription_RootParking_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Type_Order_By>>;
  where?: InputMaybe<Parking_Type_Bool_Exp>;
};


export type Subscription_RootParking_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootParking_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parking_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Parking_Type_Bool_Exp>;
};


export type Subscription_RootPhone_Number_TypeArgs = {
  distinct_on?: InputMaybe<Array<Phone_Number_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Number_Type_Order_By>>;
  where?: InputMaybe<Phone_Number_Type_Bool_Exp>;
};


export type Subscription_RootPhone_Number_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Number_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Number_Type_Order_By>>;
  where?: InputMaybe<Phone_Number_Type_Bool_Exp>;
};


export type Subscription_RootPhone_Number_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootPhone_Number_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Phone_Number_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Phone_Number_Type_Bool_Exp>;
};


export type Subscription_RootPlace_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Order_By>>;
  where?: InputMaybe<Place_Reference_Bool_Exp>;
};


export type Subscription_RootPlace_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Order_By>>;
  where?: InputMaybe<Place_Reference_Bool_Exp>;
};


export type Subscription_RootPlace_Reference_AliasArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Alias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Alias_Order_By>>;
  where?: InputMaybe<Place_Reference_Alias_Bool_Exp>;
};


export type Subscription_RootPlace_Reference_Alias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Alias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Alias_Order_By>>;
  where?: InputMaybe<Place_Reference_Alias_Bool_Exp>;
};


export type Subscription_RootPlace_Reference_Alias_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPlace_Reference_Alias_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Place_Reference_Alias_Stream_Cursor_Input>>;
  where?: InputMaybe<Place_Reference_Alias_Bool_Exp>;
};


export type Subscription_RootPlace_Reference_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPlace_Reference_ProposalArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Proposal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Proposal_Order_By>>;
  where?: InputMaybe<Place_Reference_Proposal_Bool_Exp>;
};


export type Subscription_RootPlace_Reference_Proposal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Place_Reference_Proposal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Place_Reference_Proposal_Order_By>>;
  where?: InputMaybe<Place_Reference_Proposal_Bool_Exp>;
};


export type Subscription_RootPlace_Reference_Proposal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPlace_Reference_Proposal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Place_Reference_Proposal_Stream_Cursor_Input>>;
  where?: InputMaybe<Place_Reference_Proposal_Bool_Exp>;
};


export type Subscription_RootPlace_Reference_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Place_Reference_Stream_Cursor_Input>>;
  where?: InputMaybe<Place_Reference_Bool_Exp>;
};


export type Subscription_RootPlanArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Subscription_RootPlan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Subscription_RootPlan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPlan_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Plan_Stream_Cursor_Input>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Subscription_RootPlan_TypeArgs = {
  distinct_on?: InputMaybe<Array<Plan_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Type_Order_By>>;
  where?: InputMaybe<Plan_Type_Bool_Exp>;
};


export type Subscription_RootPlan_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Type_Order_By>>;
  where?: InputMaybe<Plan_Type_Bool_Exp>;
};


export type Subscription_RootPlan_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootPlan_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Plan_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Plan_Type_Bool_Exp>;
};


export type Subscription_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_PurchaseArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


export type Subscription_RootProduct_Purchase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


export type Subscription_RootProduct_Purchase_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Purchase_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Purchase_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


export type Subscription_RootProduct_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_TypeArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootProduct_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootPropertyArgs = {
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


export type Subscription_RootPropertyDailyViewsArgs = {
  args: PropertyDailyViews_Arguments;
  distinct_on?: InputMaybe<Array<Property_Views_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Views_Model_Order_By>>;
  where?: InputMaybe<Property_Views_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootPropertyTypesDistributionArgs = {
  distinct_on?: InputMaybe<Array<Property_Types_Distribution_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Types_Distribution_Model_Order_By>>;
  where?: InputMaybe<Property_Types_Distribution_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootProperty_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Order_By>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


export type Subscription_RootProperty_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_ClusterArgs = {
  distinct_on?: InputMaybe<Array<Property_Cluster_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Cluster_Order_By>>;
  where?: InputMaybe<Property_Cluster_Bool_Exp>;
};


export type Subscription_RootProperty_Cluster_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Cluster_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Cluster_Order_By>>;
  where?: InputMaybe<Property_Cluster_Bool_Exp>;
};


export type Subscription_RootProperty_Cluster_By_PkArgs = {
  cluster: Scalars['String']['input'];
};


export type Subscription_RootProperty_Cluster_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Cluster_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Cluster_Bool_Exp>;
};


export type Subscription_RootProperty_CompositionArgs = {
  distinct_on?: InputMaybe<Array<Property_Composition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Composition_Order_By>>;
  where?: InputMaybe<Property_Composition_Bool_Exp>;
};


export type Subscription_RootProperty_Composition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Composition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Composition_Order_By>>;
  where?: InputMaybe<Property_Composition_Bool_Exp>;
};


export type Subscription_RootProperty_Composition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Composition_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Composition_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Composition_Bool_Exp>;
};


export type Subscription_RootProperty_FeatureArgs = {
  distinct_on?: InputMaybe<Array<Property_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Feature_Order_By>>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};


export type Subscription_RootProperty_Feature_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Feature_Order_By>>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};


export type Subscription_RootProperty_Feature_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Feature_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Feature_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Feature_Bool_Exp>;
};


export type Subscription_RootProperty_FolderArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Order_By>>;
  where?: InputMaybe<Property_Folder_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Order_By>>;
  where?: InputMaybe<Property_Folder_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Folder_Public_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Folder_Public_Profile_FaqArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Faq_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Faq_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Faq_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Faq_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Faq_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Folder_Public_Profile_Faq_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Folder_Public_Profile_Faq_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Faq_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_HighlightArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Highlight_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Highlight_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Highlight_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Highlight_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Highlight_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Folder_Public_Profile_Highlight_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Folder_Public_Profile_Highlight_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Highlight_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Listing_ExampleArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Listing_Example_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Listing_Example_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Listing_Example_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Folder_Public_Profile_Listing_Example_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Folder_Public_Profile_Listing_Example_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Listing_Example_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Nearby_PlaceArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Nearby_Place_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Nearby_Place_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Nearby_Place_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Folder_Public_Profile_Nearby_Place_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Nearby_Place_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_RelatedArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Related_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Related_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Related_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Related_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Related_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Folder_Public_Profile_Related_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Folder_Public_Profile_Related_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Related_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Folder_Public_Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_TranslationArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Translation_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Translation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Folder_Public_Profile_Translation_Order_By>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Translation_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_Public_Profile_Translation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Folder_Public_Profile_Translation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Folder_Public_Profile_Translation_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Folder_Public_Profile_Translation_Bool_Exp>;
};


export type Subscription_RootProperty_Folder_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Folder_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Folder_Bool_Exp>;
};


export type Subscription_RootProperty_ImageArgs = {
  distinct_on?: InputMaybe<Array<Property_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Image_Order_By>>;
  where?: InputMaybe<Property_Image_Bool_Exp>;
};


export type Subscription_RootProperty_Image_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Image_Order_By>>;
  where?: InputMaybe<Property_Image_Bool_Exp>;
};


export type Subscription_RootProperty_Image_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Image_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Image_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Image_Bool_Exp>;
};


export type Subscription_RootProperty_ListArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


export type Subscription_RootProperty_List_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Activity_Order_By>>;
  where?: InputMaybe<Property_List_Activity_Bool_Exp>;
};


export type Subscription_RootProperty_List_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Activity_Order_By>>;
  where?: InputMaybe<Property_List_Activity_Bool_Exp>;
};


export type Subscription_RootProperty_List_Activity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_List_Activity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_List_Activity_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_List_Activity_Bool_Exp>;
};


export type Subscription_RootProperty_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Order_By>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


export type Subscription_RootProperty_List_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_List_FolderArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Folder_Order_By>>;
  where?: InputMaybe<Property_List_Folder_Bool_Exp>;
};


export type Subscription_RootProperty_List_Folder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Folder_Order_By>>;
  where?: InputMaybe<Property_List_Folder_Bool_Exp>;
};


export type Subscription_RootProperty_List_Folder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_List_Folder_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_List_Folder_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_List_Folder_Bool_Exp>;
};


export type Subscription_RootProperty_List_ReportArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Report_Order_By>>;
  where?: InputMaybe<Property_List_Report_Bool_Exp>;
};


export type Subscription_RootProperty_List_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_List_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Report_Order_By>>;
  where?: InputMaybe<Property_List_Report_Bool_Exp>;
};


export type Subscription_RootProperty_List_Report_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_List_Report_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_List_Report_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_List_Report_Bool_Exp>;
};


export type Subscription_RootProperty_List_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_List_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_List_Bool_Exp>;
};


export type Subscription_RootProperty_OriginArgs = {
  distinct_on?: InputMaybe<Array<Property_Origin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Origin_Order_By>>;
  where?: InputMaybe<Property_Origin_Bool_Exp>;
};


export type Subscription_RootProperty_Origin_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Origin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Origin_Order_By>>;
  where?: InputMaybe<Property_Origin_Bool_Exp>;
};


export type Subscription_RootProperty_Origin_By_PkArgs = {
  origin: Scalars['String']['input'];
};


export type Subscription_RootProperty_Origin_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Origin_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Origin_Bool_Exp>;
};


export type Subscription_RootProperty_Origin_TypeArgs = {
  distinct_on?: InputMaybe<Array<Property_Origin_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Origin_Type_Order_By>>;
  where?: InputMaybe<Property_Origin_Type_Bool_Exp>;
};


export type Subscription_RootProperty_Origin_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Origin_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Origin_Type_Order_By>>;
  where?: InputMaybe<Property_Origin_Type_Bool_Exp>;
};


export type Subscription_RootProperty_Origin_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootProperty_Origin_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Origin_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Origin_Type_Bool_Exp>;
};


export type Subscription_RootProperty_OwnerArgs = {
  distinct_on?: InputMaybe<Array<Property_Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Owner_Order_By>>;
  where?: InputMaybe<Property_Owner_Bool_Exp>;
};


export type Subscription_RootProperty_Owner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Owner_Order_By>>;
  where?: InputMaybe<Property_Owner_Bool_Exp>;
};


export type Subscription_RootProperty_Owner_By_PkArgs = {
  owner: Scalars['String']['input'];
};


export type Subscription_RootProperty_Owner_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Owner_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Owner_Bool_Exp>;
};


export type Subscription_RootProperty_Place_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<Property_Place_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Place_Reference_Order_By>>;
  where?: InputMaybe<Property_Place_Reference_Bool_Exp>;
};


export type Subscription_RootProperty_Place_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Place_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Place_Reference_Order_By>>;
  where?: InputMaybe<Property_Place_Reference_Bool_Exp>;
};


export type Subscription_RootProperty_Place_Reference_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Place_Reference_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Place_Reference_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Place_Reference_Bool_Exp>;
};


export type Subscription_RootProperty_Price_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Property_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Price_History_Order_By>>;
  where?: InputMaybe<Property_Price_History_Bool_Exp>;
};


export type Subscription_RootProperty_Price_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Price_History_Order_By>>;
  where?: InputMaybe<Property_Price_History_Bool_Exp>;
};


export type Subscription_RootProperty_Price_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Price_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Price_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Price_History_Bool_Exp>;
};


export type Subscription_RootProperty_Report_TypeArgs = {
  distinct_on?: InputMaybe<Array<Property_Report_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Report_Type_Order_By>>;
  where?: InputMaybe<Property_Report_Type_Bool_Exp>;
};


export type Subscription_RootProperty_Report_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Report_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Report_Type_Order_By>>;
  where?: InputMaybe<Property_Report_Type_Bool_Exp>;
};


export type Subscription_RootProperty_Report_Type_By_PkArgs = {
  report_type: Scalars['String']['input'];
};


export type Subscription_RootProperty_Report_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Report_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Report_Type_Bool_Exp>;
};


export type Subscription_RootProperty_SourceArgs = {
  distinct_on?: InputMaybe<Array<Property_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Source_Order_By>>;
  where?: InputMaybe<Property_Source_Bool_Exp>;
};


export type Subscription_RootProperty_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Source_Order_By>>;
  where?: InputMaybe<Property_Source_Bool_Exp>;
};


export type Subscription_RootProperty_Source_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Source_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Source_Bool_Exp>;
};


export type Subscription_RootProperty_StatusArgs = {
  distinct_on?: InputMaybe<Array<Property_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Status_Order_By>>;
  where?: InputMaybe<Property_Status_Bool_Exp>;
};


export type Subscription_RootProperty_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Status_Order_By>>;
  where?: InputMaybe<Property_Status_Bool_Exp>;
};


export type Subscription_RootProperty_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootProperty_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Status_Bool_Exp>;
};


export type Subscription_RootProperty_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Bool_Exp>;
};


export type Subscription_RootProperty_TypeArgs = {
  distinct_on?: InputMaybe<Array<Property_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Type_Order_By>>;
  where?: InputMaybe<Property_Type_Bool_Exp>;
};


export type Subscription_RootProperty_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Type_Order_By>>;
  where?: InputMaybe<Property_Type_Bool_Exp>;
};


export type Subscription_RootProperty_Type_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootProperty_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Type_Bool_Exp>;
};


export type Subscription_RootProperty_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Property_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Views_Order_By>>;
  where?: InputMaybe<Property_Views_Bool_Exp>;
};


export type Subscription_RootProperty_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Views_Order_By>>;
  where?: InputMaybe<Property_Views_Bool_Exp>;
};


export type Subscription_RootProperty_Views_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Views_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Views_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Views_Bool_Exp>;
};


export type Subscription_RootQueries_Property_ResultArgs = {
  distinct_on?: InputMaybe<Array<Queries_Property_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queries_Property_Result_Order_By>>;
  where?: InputMaybe<Queries_Property_Result_Bool_Exp>;
};


export type Subscription_RootQueries_Property_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queries_Property_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queries_Property_Result_Order_By>>;
  where?: InputMaybe<Queries_Property_Result_Bool_Exp>;
};


export type Subscription_RootQueries_Property_Result_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQueries_Property_Result_ReArgs = {
  distinct_on?: InputMaybe<Array<Queries_Property_Result_Re_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queries_Property_Result_Re_Order_By>>;
  where?: InputMaybe<Queries_Property_Result_Re_Bool_Exp>;
};


export type Subscription_RootQueries_Property_Result_Re_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queries_Property_Result_Re_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queries_Property_Result_Re_Order_By>>;
  where?: InputMaybe<Queries_Property_Result_Re_Bool_Exp>;
};


export type Subscription_RootQueries_Property_Result_Re_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQueries_Property_Result_Re_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Queries_Property_Result_Re_Stream_Cursor_Input>>;
  where?: InputMaybe<Queries_Property_Result_Re_Bool_Exp>;
};


export type Subscription_RootQueries_Property_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Queries_Property_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Queries_Property_Result_Bool_Exp>;
};


export type Subscription_RootQuery_ClassificationArgs = {
  distinct_on?: InputMaybe<Array<Query_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Query_Classification_Order_By>>;
  where?: InputMaybe<Query_Classification_Bool_Exp>;
};


export type Subscription_RootQuery_Classification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Query_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Query_Classification_Order_By>>;
  where?: InputMaybe<Query_Classification_Bool_Exp>;
};


export type Subscription_RootQuery_Classification_By_PkArgs = {
  class: Scalars['String']['input'];
};


export type Subscription_RootQuery_Classification_ReArgs = {
  distinct_on?: InputMaybe<Array<Query_Classification_Re_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Query_Classification_Re_Order_By>>;
  where?: InputMaybe<Query_Classification_Re_Bool_Exp>;
};


export type Subscription_RootQuery_Classification_Re_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Query_Classification_Re_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Query_Classification_Re_Order_By>>;
  where?: InputMaybe<Query_Classification_Re_Bool_Exp>;
};


export type Subscription_RootQuery_Classification_Re_By_PkArgs = {
  class: Scalars['String']['input'];
};


export type Subscription_RootQuery_Classification_Re_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Query_Classification_Re_Stream_Cursor_Input>>;
  where?: InputMaybe<Query_Classification_Re_Bool_Exp>;
};


export type Subscription_RootQuery_Classification_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Query_Classification_Stream_Cursor_Input>>;
  where?: InputMaybe<Query_Classification_Bool_Exp>;
};


export type Subscription_RootRaw_LocationArgs = {
  distinct_on?: InputMaybe<Array<Raw_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Raw_Location_Order_By>>;
  where?: InputMaybe<Raw_Location_Bool_Exp>;
};


export type Subscription_RootRaw_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Raw_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Raw_Location_Order_By>>;
  where?: InputMaybe<Raw_Location_Bool_Exp>;
};


export type Subscription_RootRaw_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRaw_Location_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Raw_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Raw_Location_Bool_Exp>;
};


export type Subscription_RootRedirectArgs = {
  distinct_on?: InputMaybe<Array<Redirect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Redirect_Order_By>>;
  where?: InputMaybe<Redirect_Bool_Exp>;
};


export type Subscription_RootRedirect_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Redirect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Redirect_Order_By>>;
  where?: InputMaybe<Redirect_Bool_Exp>;
};


export type Subscription_RootRedirect_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRedirect_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Redirect_Stream_Cursor_Input>>;
  where?: InputMaybe<Redirect_Bool_Exp>;
};


export type Subscription_RootReference_Price_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Reference_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reference_Price_History_Order_By>>;
  where?: InputMaybe<Reference_Price_History_Bool_Exp>;
};


export type Subscription_RootReference_Price_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reference_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reference_Price_History_Order_By>>;
  where?: InputMaybe<Reference_Price_History_Bool_Exp>;
};


export type Subscription_RootReference_Price_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReference_Price_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reference_Price_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Reference_Price_History_Bool_Exp>;
};


export type Subscription_RootReference_ZoneArgs = {
  distinct_on?: InputMaybe<Array<Reference_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reference_Zone_Order_By>>;
  where?: InputMaybe<Reference_Zone_Bool_Exp>;
};


export type Subscription_RootReference_Zone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reference_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reference_Zone_Order_By>>;
  where?: InputMaybe<Reference_Zone_Bool_Exp>;
};


export type Subscription_RootReference_Zone_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReference_Zone_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reference_Zone_Stream_Cursor_Input>>;
  where?: InputMaybe<Reference_Zone_Bool_Exp>;
};


export type Subscription_RootRegionalPropertyDistributionArgs = {
  args: RegionalPropertyDistribution_Arguments;
  distinct_on?: InputMaybe<Array<Regional_Property_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Regional_Property_Model_Order_By>>;
  where?: InputMaybe<Regional_Property_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootSearch_ContextArgs = {
  distinct_on?: InputMaybe<Array<Search_Context_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Context_Order_By>>;
  where?: InputMaybe<Search_Context_Bool_Exp>;
};


export type Subscription_RootSearch_Context_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Context_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Context_Order_By>>;
  where?: InputMaybe<Search_Context_Bool_Exp>;
};


export type Subscription_RootSearch_Context_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSearch_Context_LocationArgs = {
  distinct_on?: InputMaybe<Array<Search_Context_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Context_Location_Order_By>>;
  where?: InputMaybe<Search_Context_Location_Bool_Exp>;
};


export type Subscription_RootSearch_Context_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Context_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Context_Location_Order_By>>;
  where?: InputMaybe<Search_Context_Location_Bool_Exp>;
};


export type Subscription_RootSearch_Context_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSearch_Context_Location_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Search_Context_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Context_Location_Bool_Exp>;
};


export type Subscription_RootSearch_Context_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Search_Context_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Context_Bool_Exp>;
};


export type Subscription_RootSearch_DomainArgs = {
  distinct_on?: InputMaybe<Array<Search_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Domain_Order_By>>;
  where?: InputMaybe<Search_Domain_Bool_Exp>;
};


export type Subscription_RootSearch_Domain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Domain_Order_By>>;
  where?: InputMaybe<Search_Domain_Bool_Exp>;
};


export type Subscription_RootSearch_Domain_By_PkArgs = {
  domain: Scalars['String']['input'];
};


export type Subscription_RootSearch_Domain_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Search_Domain_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Domain_Bool_Exp>;
};


export type Subscription_RootSearch_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


export type Subscription_RootSearch_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


export type Subscription_RootSearch_Sessions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSearch_Sessions_Sorted_By_Last_QueryArgs = {
  args: Search_Sessions_Sorted_By_Last_Query_Args;
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


export type Subscription_RootSearch_Sessions_Sorted_By_Last_Query_AggregateArgs = {
  args: Search_Sessions_Sorted_By_Last_Query_Args;
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


export type Subscription_RootSearch_Sessions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Search_Sessions_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


export type Subscription_RootSearch_SlugsArgs = {
  distinct_on?: InputMaybe<Array<Search_Slugs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Slugs_Order_By>>;
  where?: InputMaybe<Search_Slugs_Bool_Exp>;
};


export type Subscription_RootSearch_Slugs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Slugs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Slugs_Order_By>>;
  where?: InputMaybe<Search_Slugs_Bool_Exp>;
};


export type Subscription_RootSearch_Slugs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSearch_Slugs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Search_Slugs_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Slugs_Bool_Exp>;
};


export type Subscription_RootSeo_CityArgs = {
  distinct_on?: InputMaybe<Array<Seo_City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seo_City_Order_By>>;
  where?: InputMaybe<Seo_City_Bool_Exp>;
};


export type Subscription_RootSeo_City_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seo_City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seo_City_Order_By>>;
  where?: InputMaybe<Seo_City_Bool_Exp>;
};


export type Subscription_RootSeo_City_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSeo_City_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Seo_City_Stream_Cursor_Input>>;
  where?: InputMaybe<Seo_City_Bool_Exp>;
};


export type Subscription_RootSession_OriginArgs = {
  distinct_on?: InputMaybe<Array<Session_Origin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_Origin_Order_By>>;
  where?: InputMaybe<Session_Origin_Bool_Exp>;
};


export type Subscription_RootSession_Origin_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Session_Origin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_Origin_Order_By>>;
  where?: InputMaybe<Session_Origin_Bool_Exp>;
};


export type Subscription_RootSession_Origin_By_PkArgs = {
  origin: Scalars['String']['input'];
};


export type Subscription_RootSession_Origin_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Session_Origin_Stream_Cursor_Input>>;
  where?: InputMaybe<Session_Origin_Bool_Exp>;
};


export type Subscription_RootSponsored_Property_ListArgs = {
  distinct_on?: InputMaybe<Array<Sponsored_Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sponsored_Property_List_Order_By>>;
  where?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
};


export type Subscription_RootSponsored_Property_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsored_Property_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sponsored_Property_List_Order_By>>;
  where?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
};


export type Subscription_RootSponsored_Property_List_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSponsored_Property_List_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sponsored_Property_List_Stream_Cursor_Input>>;
  where?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
};


export type Subscription_RootSubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Order_By>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};


export type Subscription_RootSubscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Order_By>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};


export type Subscription_RootSubscription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSubscription_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Invoice_Order_By>>;
  where?: InputMaybe<Subscription_Invoice_Bool_Exp>;
};


export type Subscription_RootSubscription_Invoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Invoice_Order_By>>;
  where?: InputMaybe<Subscription_Invoice_Bool_Exp>;
};


export type Subscription_RootSubscription_Invoice_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSubscription_Invoice_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscription_Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscription_Invoice_Bool_Exp>;
};


export type Subscription_RootSubscription_SourceArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Source_Order_By>>;
  where?: InputMaybe<Subscription_Source_Bool_Exp>;
};


export type Subscription_RootSubscription_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Source_Order_By>>;
  where?: InputMaybe<Subscription_Source_Bool_Exp>;
};


export type Subscription_RootSubscription_Source_By_PkArgs = {
  source: Scalars['String']['input'];
};


export type Subscription_RootSubscription_Source_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscription_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscription_Source_Bool_Exp>;
};


export type Subscription_RootSubscription_StatusArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Status_Order_By>>;
  where?: InputMaybe<Subscription_Status_Bool_Exp>;
};


export type Subscription_RootSubscription_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Status_Order_By>>;
  where?: InputMaybe<Subscription_Status_Bool_Exp>;
};


export type Subscription_RootSubscription_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootSubscription_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscription_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscription_Status_Bool_Exp>;
};


export type Subscription_RootSubscription_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscription_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};


export type Subscription_RootText_ContentArgs = {
  distinct_on?: InputMaybe<Array<Text_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Text_Content_Order_By>>;
  where?: InputMaybe<Text_Content_Bool_Exp>;
};


export type Subscription_RootText_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Text_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Text_Content_Order_By>>;
  where?: InputMaybe<Text_Content_Bool_Exp>;
};


export type Subscription_RootText_Content_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootText_Content_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Text_Content_Stream_Cursor_Input>>;
  where?: InputMaybe<Text_Content_Bool_Exp>;
};


export type Subscription_RootTranslationsArgs = {
  distinct_on?: InputMaybe<Array<Translations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translations_Order_By>>;
  where?: InputMaybe<Translations_Bool_Exp>;
};


export type Subscription_RootTranslations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Translations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translations_Order_By>>;
  where?: InputMaybe<Translations_Bool_Exp>;
};


export type Subscription_RootTranslations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTranslations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Translations_Stream_Cursor_Input>>;
  where?: InputMaybe<Translations_Bool_Exp>;
};


export type Subscription_RootUrl_SlugArgs = {
  distinct_on?: InputMaybe<Array<Url_Slug_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Url_Slug_Order_By>>;
  where?: InputMaybe<Url_Slug_Bool_Exp>;
};


export type Subscription_RootUrl_Slug_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Url_Slug_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Url_Slug_Order_By>>;
  where?: InputMaybe<Url_Slug_Bool_Exp>;
};


export type Subscription_RootUrl_Slug_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUrl_Slug_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Url_Slug_Stream_Cursor_Input>>;
  where?: InputMaybe<Url_Slug_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_FiltersArgs = {
  distinct_on?: InputMaybe<Array<User_Filters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Filters_Order_By>>;
  where?: InputMaybe<User_Filters_Bool_Exp>;
};


export type Subscription_RootUser_Filters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Filters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Filters_Order_By>>;
  where?: InputMaybe<User_Filters_Bool_Exp>;
};


export type Subscription_RootUser_Filters_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Filters_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<User_Filters_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Filters_Features_Order_By>>;
  where?: InputMaybe<User_Filters_Features_Bool_Exp>;
};


export type Subscription_RootUser_Filters_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Filters_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Filters_Features_Order_By>>;
  where?: InputMaybe<User_Filters_Features_Bool_Exp>;
};


export type Subscription_RootUser_Filters_Features_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Filters_Features_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Filters_Features_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Filters_Features_Bool_Exp>;
};


export type Subscription_RootUser_Filters_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Filters_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Filters_Bool_Exp>;
};


export type Subscription_RootUser_OrganizationArgs = {
  distinct_on?: InputMaybe<Array<User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Organization_Order_By>>;
  where?: InputMaybe<User_Organization_Bool_Exp>;
};


export type Subscription_RootUser_Organization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Organization_Order_By>>;
  where?: InputMaybe<User_Organization_Bool_Exp>;
};


export type Subscription_RootUser_Organization_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Organization_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Organization_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Organization_Bool_Exp>;
};


export type Subscription_RootUser_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<User_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Preferences_Order_By>>;
  where?: InputMaybe<User_Preferences_Bool_Exp>;
};


export type Subscription_RootUser_Preferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Preferences_Order_By>>;
  where?: InputMaybe<User_Preferences_Bool_Exp>;
};


export type Subscription_RootUser_Preferences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Preferences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Preferences_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Preferences_Bool_Exp>;
};


export type Subscription_RootUser_Property_NotifiationArgs = {
  distinct_on?: InputMaybe<Array<User_Property_Notifiation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Property_Notifiation_Order_By>>;
  where?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
};


export type Subscription_RootUser_Property_Notifiation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Property_Notifiation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Property_Notifiation_Order_By>>;
  where?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
};


export type Subscription_RootUser_Property_Notifiation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Property_Notifiation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Property_Notifiation_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
};


export type Subscription_RootUser_Saved_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<User_Saved_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Saved_Properties_Order_By>>;
  where?: InputMaybe<User_Saved_Properties_Bool_Exp>;
};


export type Subscription_RootUser_Saved_Properties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Saved_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Saved_Properties_Order_By>>;
  where?: InputMaybe<User_Saved_Properties_Bool_Exp>;
};


export type Subscription_RootUser_Saved_Properties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Saved_Properties_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Saved_Properties_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Saved_Properties_Bool_Exp>;
};


export type Subscription_RootUser_Seen_PropertyArgs = {
  distinct_on?: InputMaybe<Array<User_Seen_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Seen_Property_Order_By>>;
  where?: InputMaybe<User_Seen_Property_Bool_Exp>;
};


export type Subscription_RootUser_Seen_Property_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Seen_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Seen_Property_Order_By>>;
  where?: InputMaybe<User_Seen_Property_Bool_Exp>;
};


export type Subscription_RootUser_Seen_Property_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Seen_Property_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Seen_Property_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Seen_Property_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_Activity_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Users_Activity_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Activity_Summary_Order_By>>;
  where?: InputMaybe<Users_Activity_Summary_Bool_Exp>;
};


export type Subscription_RootUsers_Activity_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Activity_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Activity_Summary_Order_By>>;
  where?: InputMaybe<Users_Activity_Summary_Bool_Exp>;
};


export type Subscription_RootUsers_Activity_Summary_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootUsers_Activity_Summary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Activity_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Activity_Summary_Bool_Exp>;
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootVirusArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVirus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Virus_Stream_Cursor_Input>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVisibility_StatusArgs = {
  distinct_on?: InputMaybe<Array<Visibility_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visibility_Status_Order_By>>;
  where?: InputMaybe<Visibility_Status_Bool_Exp>;
};


export type Subscription_RootVisibility_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visibility_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visibility_Status_Order_By>>;
  where?: InputMaybe<Visibility_Status_Bool_Exp>;
};


export type Subscription_RootVisibility_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootVisibility_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Visibility_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Visibility_Status_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Ai_Inbound_MessageArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Inbound_Message_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Ai_Inbound_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Inbound_Message_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Ai_Inbound_Message_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWhatsapp_Ai_Inbound_Message_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Whatsapp_Ai_Inbound_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp_Ai_Inbound_Message_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Ai_Outbox_PartArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Ai_Outbox_Part_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Ai_Outbox_Part_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWhatsapp_Ai_Outbox_Part_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Whatsapp_Ai_Outbox_Part_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Ai_TurnArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Turn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Turn_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Ai_Turn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Turn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Turn_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Ai_Turn_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWhatsapp_Ai_Turn_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Whatsapp_Ai_Turn_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
};


export type Subscription_RootWhatsapp_ChatArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Chat_Order_By>>;
  where?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Chat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Chat_Order_By>>;
  where?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Chat_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWhatsapp_Chat_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Whatsapp_Chat_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
};


export type Subscription_RootWhatsapp_HumanArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Human_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Human_Order_By>>;
  where?: InputMaybe<Whatsapp_Human_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Human_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Human_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Human_Order_By>>;
  where?: InputMaybe<Whatsapp_Human_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Human_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWhatsapp_Human_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Whatsapp_Human_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp_Human_Bool_Exp>;
};


export type Subscription_RootZone_ContainsArgs = {
  distinct_on?: InputMaybe<Array<Zone_Contains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Contains_Order_By>>;
  where?: InputMaybe<Zone_Contains_Bool_Exp>;
};


export type Subscription_RootZone_Contains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Zone_Contains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Contains_Order_By>>;
  where?: InputMaybe<Zone_Contains_Bool_Exp>;
};


export type Subscription_RootZone_Contains_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootZone_Contains_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Zone_Contains_Stream_Cursor_Input>>;
  where?: InputMaybe<Zone_Contains_Bool_Exp>;
};


export type Subscription_RootZone_Data_MethodArgs = {
  distinct_on?: InputMaybe<Array<Zone_Data_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Data_Method_Order_By>>;
  where?: InputMaybe<Zone_Data_Method_Bool_Exp>;
};


export type Subscription_RootZone_Data_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Zone_Data_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Data_Method_Order_By>>;
  where?: InputMaybe<Zone_Data_Method_Bool_Exp>;
};


export type Subscription_RootZone_Data_Method_By_PkArgs = {
  method: Scalars['String']['input'];
};


export type Subscription_RootZone_Data_Method_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Zone_Data_Method_Stream_Cursor_Input>>;
  where?: InputMaybe<Zone_Data_Method_Bool_Exp>;
};

/** select columns of table "subscription" */
export enum Subscription_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  CancellationDetails = 'cancellation_details',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  MaxMembers = 'max_members',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ParentSubscriptionId = 'parent_subscription_id',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  Source = 'source',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionId = 'stripe_subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "subscription_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subscription" */
export enum Subscription_Select_Column_Subscription_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end'
}

/** select "subscription_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subscription" */
export enum Subscription_Select_Column_Subscription_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end'
}

/** input type for updating data in table "subscription" */
export type Subscription_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  cancel_at_period_end?: InputMaybe<Scalars['Boolean']['input']>;
  cancellation_details?: InputMaybe<Scalars['jsonb']['input']>;
  cancelled_at?: InputMaybe<Scalars['date']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  max_members?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Subscription_Source_Enum>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Subscription_Status_Enum>;
  stripe_subscription_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "subscription_source" */
export type Subscription_Source = {
  __typename?: 'subscription_source';
  source: Scalars['String']['output'];
};

/** aggregated selection of "subscription_source" */
export type Subscription_Source_Aggregate = {
  __typename?: 'subscription_source_aggregate';
  aggregate?: Maybe<Subscription_Source_Aggregate_Fields>;
  nodes: Array<Subscription_Source>;
};

/** aggregate fields of "subscription_source" */
export type Subscription_Source_Aggregate_Fields = {
  __typename?: 'subscription_source_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Subscription_Source_Max_Fields>;
  min?: Maybe<Subscription_Source_Min_Fields>;
};


/** aggregate fields of "subscription_source" */
export type Subscription_Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "subscription_source". All fields are combined with a logical 'AND'. */
export type Subscription_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Source_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Source_Bool_Exp>>;
  source?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_source" */
export enum Subscription_Source_Constraint {
  /** unique or primary key constraint on columns "source" */
  SubscriptionSourcePkey = 'subscription_source_pkey'
}

export enum Subscription_Source_Enum {
  Custom = 'custom',
  Stripe = 'stripe'
}

/** Boolean expression to compare columns of type "subscription_source_enum". All fields are combined with logical 'AND'. */
export type Subscription_Source_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Subscription_Source_Enum>;
  _in?: InputMaybe<Array<Subscription_Source_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Subscription_Source_Enum>;
  _nin?: InputMaybe<Array<Subscription_Source_Enum>>;
};

/** input type for inserting data into table "subscription_source" */
export type Subscription_Source_Insert_Input = {
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Subscription_Source_Max_Fields = {
  __typename?: 'subscription_source_max_fields';
  source?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Subscription_Source_Min_Fields = {
  __typename?: 'subscription_source_min_fields';
  source?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "subscription_source" */
export type Subscription_Source_Mutation_Response = {
  __typename?: 'subscription_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Source>;
};

/** on_conflict condition type for table "subscription_source" */
export type Subscription_Source_On_Conflict = {
  constraint: Subscription_Source_Constraint;
  update_columns?: Array<Subscription_Source_Update_Column>;
  where?: InputMaybe<Subscription_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_source". */
export type Subscription_Source_Order_By = {
  source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription_source */
export type Subscription_Source_Pk_Columns_Input = {
  source: Scalars['String']['input'];
};

/** select columns of table "subscription_source" */
export enum Subscription_Source_Select_Column {
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "subscription_source" */
export type Subscription_Source_Set_Input = {
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "subscription_source" */
export type Subscription_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Source_Stream_Cursor_Value_Input = {
  source?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "subscription_source" */
export enum Subscription_Source_Update_Column {
  /** column name */
  Source = 'source'
}

export type Subscription_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscription_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscription_Source_Bool_Exp;
};

/** columns and relationships of "subscription_status" */
export type Subscription_Status = {
  __typename?: 'subscription_status';
  status: Scalars['String']['output'];
};

/** aggregated selection of "subscription_status" */
export type Subscription_Status_Aggregate = {
  __typename?: 'subscription_status_aggregate';
  aggregate?: Maybe<Subscription_Status_Aggregate_Fields>;
  nodes: Array<Subscription_Status>;
};

/** aggregate fields of "subscription_status" */
export type Subscription_Status_Aggregate_Fields = {
  __typename?: 'subscription_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Subscription_Status_Max_Fields>;
  min?: Maybe<Subscription_Status_Min_Fields>;
};


/** aggregate fields of "subscription_status" */
export type Subscription_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "subscription_status". All fields are combined with a logical 'AND'. */
export type Subscription_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Status_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_status" */
export enum Subscription_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  SubscriptionStatusPkey = 'subscription_status_pkey'
}

export enum Subscription_Status_Enum {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Paused = 'paused',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

/** Boolean expression to compare columns of type "subscription_status_enum". All fields are combined with logical 'AND'. */
export type Subscription_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Subscription_Status_Enum>;
  _in?: InputMaybe<Array<Subscription_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Subscription_Status_Enum>;
  _nin?: InputMaybe<Array<Subscription_Status_Enum>>;
};

/** input type for inserting data into table "subscription_status" */
export type Subscription_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Subscription_Status_Max_Fields = {
  __typename?: 'subscription_status_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Subscription_Status_Min_Fields = {
  __typename?: 'subscription_status_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "subscription_status" */
export type Subscription_Status_Mutation_Response = {
  __typename?: 'subscription_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Status>;
};

/** on_conflict condition type for table "subscription_status" */
export type Subscription_Status_On_Conflict = {
  constraint: Subscription_Status_Constraint;
  update_columns?: Array<Subscription_Status_Update_Column>;
  where?: InputMaybe<Subscription_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_status". */
export type Subscription_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription_status */
export type Subscription_Status_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "subscription_status" */
export enum Subscription_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "subscription_status" */
export type Subscription_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "subscription_status" */
export type Subscription_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "subscription_status" */
export enum Subscription_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Subscription_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscription_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscription_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Subscription_Stddev_Fields = {
  __typename?: 'subscription_stddev_fields';
  /** A computed field, executes function "get_subscription_active_members" */
  active_members?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  max_members?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "subscription" */
export type Subscription_Stddev_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  max_members?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscription_Stddev_Pop_Fields = {
  __typename?: 'subscription_stddev_pop_fields';
  /** A computed field, executes function "get_subscription_active_members" */
  active_members?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  max_members?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "subscription" */
export type Subscription_Stddev_Pop_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  max_members?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscription_Stddev_Samp_Fields = {
  __typename?: 'subscription_stddev_samp_fields';
  /** A computed field, executes function "get_subscription_active_members" */
  active_members?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  max_members?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "subscription" */
export type Subscription_Stddev_Samp_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  max_members?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscription" */
export type Subscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  cancel_at_period_end?: InputMaybe<Scalars['Boolean']['input']>;
  cancellation_details?: InputMaybe<Scalars['jsonb']['input']>;
  cancelled_at?: InputMaybe<Scalars['date']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  max_members?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  plan_id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Subscription_Source_Enum>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Subscription_Status_Enum>;
  stripe_subscription_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Subscription_Sum_Fields = {
  __typename?: 'subscription_sum_fields';
  /** A computed field, executes function "get_subscription_active_members" */
  active_members?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  max_members?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "subscription" */
export type Subscription_Sum_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  max_members?: InputMaybe<Order_By>;
};

/** update columns of table "subscription" */
export enum Subscription_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  CancellationDetails = 'cancellation_details',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  MaxMembers = 'max_members',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ParentSubscriptionId = 'parent_subscription_id',
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  Source = 'source',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionId = 'stripe_subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscription_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Subscription_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Subscription_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Subscription_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Subscription_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscription_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Subscription_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscription_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscription_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscription_Var_Pop_Fields = {
  __typename?: 'subscription_var_pop_fields';
  /** A computed field, executes function "get_subscription_active_members" */
  active_members?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  max_members?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "subscription" */
export type Subscription_Var_Pop_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  max_members?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscription_Var_Samp_Fields = {
  __typename?: 'subscription_var_samp_fields';
  /** A computed field, executes function "get_subscription_active_members" */
  active_members?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  max_members?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "subscription" */
export type Subscription_Var_Samp_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  max_members?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscription_Variance_Fields = {
  __typename?: 'subscription_variance_fields';
  /** A computed field, executes function "get_subscription_active_members" */
  active_members?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  max_members?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "subscription" */
export type Subscription_Variance_Order_By = {
  amount_paid?: InputMaybe<Order_By>;
  max_members?: InputMaybe<Order_By>;
};

/** columns and relationships of "text_content" */
export type Text_Content = {
  __typename?: 'text_content';
  content_type?: Maybe<Content_Type_Enum>;
  entity_type: Entities_Enum;
  id: Scalars['uuid']['output'];
  original_language_id: Scalars['Int']['output'];
  original_text: Scalars['String']['output'];
  seo_meta?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  translations: Array<Translations>;
  /** An aggregate relationship */
  translations_aggregate: Translations_Aggregate;
};


/** columns and relationships of "text_content" */
export type Text_ContentTranslationsArgs = {
  distinct_on?: InputMaybe<Array<Translations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translations_Order_By>>;
  where?: InputMaybe<Translations_Bool_Exp>;
};


/** columns and relationships of "text_content" */
export type Text_ContentTranslations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Translations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translations_Order_By>>;
  where?: InputMaybe<Translations_Bool_Exp>;
};

/** aggregated selection of "text_content" */
export type Text_Content_Aggregate = {
  __typename?: 'text_content_aggregate';
  aggregate?: Maybe<Text_Content_Aggregate_Fields>;
  nodes: Array<Text_Content>;
};

/** aggregate fields of "text_content" */
export type Text_Content_Aggregate_Fields = {
  __typename?: 'text_content_aggregate_fields';
  avg?: Maybe<Text_Content_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Text_Content_Max_Fields>;
  min?: Maybe<Text_Content_Min_Fields>;
  stddev?: Maybe<Text_Content_Stddev_Fields>;
  stddev_pop?: Maybe<Text_Content_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Text_Content_Stddev_Samp_Fields>;
  sum?: Maybe<Text_Content_Sum_Fields>;
  var_pop?: Maybe<Text_Content_Var_Pop_Fields>;
  var_samp?: Maybe<Text_Content_Var_Samp_Fields>;
  variance?: Maybe<Text_Content_Variance_Fields>;
};


/** aggregate fields of "text_content" */
export type Text_Content_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Text_Content_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Text_Content_Avg_Fields = {
  __typename?: 'text_content_avg_fields';
  original_language_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "text_content". All fields are combined with a logical 'AND'. */
export type Text_Content_Bool_Exp = {
  _and?: InputMaybe<Array<Text_Content_Bool_Exp>>;
  _not?: InputMaybe<Text_Content_Bool_Exp>;
  _or?: InputMaybe<Array<Text_Content_Bool_Exp>>;
  content_type?: InputMaybe<Content_Type_Enum_Comparison_Exp>;
  entity_type?: InputMaybe<Entities_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  original_language_id?: InputMaybe<Int_Comparison_Exp>;
  original_text?: InputMaybe<String_Comparison_Exp>;
  seo_meta?: InputMaybe<String_Comparison_Exp>;
  translations?: InputMaybe<Translations_Bool_Exp>;
  translations_aggregate?: InputMaybe<Translations_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "text_content" */
export enum Text_Content_Constraint {
  /** unique or primary key constraint on columns "id" */
  TextContentPkey = 'text_content_pkey'
}

/** input type for incrementing numeric columns in table "text_content" */
export type Text_Content_Inc_Input = {
  original_language_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "text_content" */
export type Text_Content_Insert_Input = {
  content_type?: InputMaybe<Content_Type_Enum>;
  entity_type?: InputMaybe<Entities_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  original_language_id?: InputMaybe<Scalars['Int']['input']>;
  original_text?: InputMaybe<Scalars['String']['input']>;
  seo_meta?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Translations_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Text_Content_Max_Fields = {
  __typename?: 'text_content_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  original_language_id?: Maybe<Scalars['Int']['output']>;
  original_text?: Maybe<Scalars['String']['output']>;
  seo_meta?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Text_Content_Min_Fields = {
  __typename?: 'text_content_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  original_language_id?: Maybe<Scalars['Int']['output']>;
  original_text?: Maybe<Scalars['String']['output']>;
  seo_meta?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "text_content" */
export type Text_Content_Mutation_Response = {
  __typename?: 'text_content_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Text_Content>;
};

/** input type for inserting object relation for remote table "text_content" */
export type Text_Content_Obj_Rel_Insert_Input = {
  data: Text_Content_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Text_Content_On_Conflict>;
};

/** on_conflict condition type for table "text_content" */
export type Text_Content_On_Conflict = {
  constraint: Text_Content_Constraint;
  update_columns?: Array<Text_Content_Update_Column>;
  where?: InputMaybe<Text_Content_Bool_Exp>;
};

/** Ordering options when selecting data from "text_content". */
export type Text_Content_Order_By = {
  content_type?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  original_language_id?: InputMaybe<Order_By>;
  original_text?: InputMaybe<Order_By>;
  seo_meta?: InputMaybe<Order_By>;
  translations_aggregate?: InputMaybe<Translations_Aggregate_Order_By>;
};

/** primary key columns input for table: text_content */
export type Text_Content_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "text_content" */
export enum Text_Content_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalLanguageId = 'original_language_id',
  /** column name */
  OriginalText = 'original_text',
  /** column name */
  SeoMeta = 'seo_meta'
}

/** input type for updating data in table "text_content" */
export type Text_Content_Set_Input = {
  content_type?: InputMaybe<Content_Type_Enum>;
  entity_type?: InputMaybe<Entities_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  original_language_id?: InputMaybe<Scalars['Int']['input']>;
  original_text?: InputMaybe<Scalars['String']['input']>;
  seo_meta?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Text_Content_Stddev_Fields = {
  __typename?: 'text_content_stddev_fields';
  original_language_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Text_Content_Stddev_Pop_Fields = {
  __typename?: 'text_content_stddev_pop_fields';
  original_language_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Text_Content_Stddev_Samp_Fields = {
  __typename?: 'text_content_stddev_samp_fields';
  original_language_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "text_content" */
export type Text_Content_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Text_Content_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Text_Content_Stream_Cursor_Value_Input = {
  content_type?: InputMaybe<Content_Type_Enum>;
  entity_type?: InputMaybe<Entities_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  original_language_id?: InputMaybe<Scalars['Int']['input']>;
  original_text?: InputMaybe<Scalars['String']['input']>;
  seo_meta?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Text_Content_Sum_Fields = {
  __typename?: 'text_content_sum_fields';
  original_language_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "text_content" */
export enum Text_Content_Update_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalLanguageId = 'original_language_id',
  /** column name */
  OriginalText = 'original_text',
  /** column name */
  SeoMeta = 'seo_meta'
}

export type Text_Content_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Text_Content_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Text_Content_Set_Input>;
  /** filter the rows which have to be updated */
  where: Text_Content_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Text_Content_Var_Pop_Fields = {
  __typename?: 'text_content_var_pop_fields';
  original_language_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Text_Content_Var_Samp_Fields = {
  __typename?: 'text_content_var_samp_fields';
  original_language_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Text_Content_Variance_Fields = {
  __typename?: 'text_content_variance_fields';
  original_language_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "translations" */
export type Translations = {
  __typename?: 'translations';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  language: Languages;
  language_id: Scalars['Int']['output'];
  seo_meta?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  text_content: Text_Content;
  text_content_id: Scalars['uuid']['output'];
  translation: Scalars['String']['output'];
};

/** aggregated selection of "translations" */
export type Translations_Aggregate = {
  __typename?: 'translations_aggregate';
  aggregate?: Maybe<Translations_Aggregate_Fields>;
  nodes: Array<Translations>;
};

export type Translations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Translations_Aggregate_Bool_Exp_Count>;
};

export type Translations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Translations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Translations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "translations" */
export type Translations_Aggregate_Fields = {
  __typename?: 'translations_aggregate_fields';
  avg?: Maybe<Translations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Translations_Max_Fields>;
  min?: Maybe<Translations_Min_Fields>;
  stddev?: Maybe<Translations_Stddev_Fields>;
  stddev_pop?: Maybe<Translations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Translations_Stddev_Samp_Fields>;
  sum?: Maybe<Translations_Sum_Fields>;
  var_pop?: Maybe<Translations_Var_Pop_Fields>;
  var_samp?: Maybe<Translations_Var_Samp_Fields>;
  variance?: Maybe<Translations_Variance_Fields>;
};


/** aggregate fields of "translations" */
export type Translations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Translations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "translations" */
export type Translations_Aggregate_Order_By = {
  avg?: InputMaybe<Translations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Translations_Max_Order_By>;
  min?: InputMaybe<Translations_Min_Order_By>;
  stddev?: InputMaybe<Translations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Translations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Translations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Translations_Sum_Order_By>;
  var_pop?: InputMaybe<Translations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Translations_Var_Samp_Order_By>;
  variance?: InputMaybe<Translations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "translations" */
export type Translations_Arr_Rel_Insert_Input = {
  data: Array<Translations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Translations_On_Conflict>;
};

/** aggregate avg on columns */
export type Translations_Avg_Fields = {
  __typename?: 'translations_avg_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "translations" */
export type Translations_Avg_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "translations". All fields are combined with a logical 'AND'. */
export type Translations_Bool_Exp = {
  _and?: InputMaybe<Array<Translations_Bool_Exp>>;
  _not?: InputMaybe<Translations_Bool_Exp>;
  _or?: InputMaybe<Array<Translations_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<Languages_Bool_Exp>;
  language_id?: InputMaybe<Int_Comparison_Exp>;
  seo_meta?: InputMaybe<String_Comparison_Exp>;
  text_content?: InputMaybe<Text_Content_Bool_Exp>;
  text_content_id?: InputMaybe<Uuid_Comparison_Exp>;
  translation?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "translations" */
export enum Translations_Constraint {
  /** unique or primary key constraint on columns "text_content_id", "language_id" */
  TranslationsLanguageIdTextContentIdKey = 'translations_language_id_text_content_id_key',
  /** unique or primary key constraint on columns "id" */
  TranslationsPkey = 'translations_pkey'
}

/** input type for incrementing numeric columns in table "translations" */
export type Translations_Inc_Input = {
  language_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "translations" */
export type Translations_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Languages_Obj_Rel_Insert_Input>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  seo_meta?: InputMaybe<Scalars['String']['input']>;
  text_content?: InputMaybe<Text_Content_Obj_Rel_Insert_Input>;
  text_content_id?: InputMaybe<Scalars['uuid']['input']>;
  translation?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Translations_Max_Fields = {
  __typename?: 'translations_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  seo_meta?: Maybe<Scalars['String']['output']>;
  text_content_id?: Maybe<Scalars['uuid']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "translations" */
export type Translations_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  seo_meta?: InputMaybe<Order_By>;
  text_content_id?: InputMaybe<Order_By>;
  translation?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Translations_Min_Fields = {
  __typename?: 'translations_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  seo_meta?: Maybe<Scalars['String']['output']>;
  text_content_id?: Maybe<Scalars['uuid']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "translations" */
export type Translations_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  seo_meta?: InputMaybe<Order_By>;
  text_content_id?: InputMaybe<Order_By>;
  translation?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "translations" */
export type Translations_Mutation_Response = {
  __typename?: 'translations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Translations>;
};

/** on_conflict condition type for table "translations" */
export type Translations_On_Conflict = {
  constraint: Translations_Constraint;
  update_columns?: Array<Translations_Update_Column>;
  where?: InputMaybe<Translations_Bool_Exp>;
};

/** Ordering options when selecting data from "translations". */
export type Translations_Order_By = {
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Languages_Order_By>;
  language_id?: InputMaybe<Order_By>;
  seo_meta?: InputMaybe<Order_By>;
  text_content?: InputMaybe<Text_Content_Order_By>;
  text_content_id?: InputMaybe<Order_By>;
  translation?: InputMaybe<Order_By>;
};

/** primary key columns input for table: translations */
export type Translations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "translations" */
export enum Translations_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  SeoMeta = 'seo_meta',
  /** column name */
  TextContentId = 'text_content_id',
  /** column name */
  Translation = 'translation'
}

/** input type for updating data in table "translations" */
export type Translations_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  seo_meta?: InputMaybe<Scalars['String']['input']>;
  text_content_id?: InputMaybe<Scalars['uuid']['input']>;
  translation?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Translations_Stddev_Fields = {
  __typename?: 'translations_stddev_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "translations" */
export type Translations_Stddev_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Translations_Stddev_Pop_Fields = {
  __typename?: 'translations_stddev_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "translations" */
export type Translations_Stddev_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Translations_Stddev_Samp_Fields = {
  __typename?: 'translations_stddev_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "translations" */
export type Translations_Stddev_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "translations" */
export type Translations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Translations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Translations_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  seo_meta?: InputMaybe<Scalars['String']['input']>;
  text_content_id?: InputMaybe<Scalars['uuid']['input']>;
  translation?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Translations_Sum_Fields = {
  __typename?: 'translations_sum_fields';
  language_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "translations" */
export type Translations_Sum_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** update columns of table "translations" */
export enum Translations_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  SeoMeta = 'seo_meta',
  /** column name */
  TextContentId = 'text_content_id',
  /** column name */
  Translation = 'translation'
}

export type Translations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Translations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Translations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Translations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Translations_Var_Pop_Fields = {
  __typename?: 'translations_var_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "translations" */
export type Translations_Var_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Translations_Var_Samp_Fields = {
  __typename?: 'translations_var_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "translations" */
export type Translations_Var_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Translations_Variance_Fields = {
  __typename?: 'translations_variance_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "translations" */
export type Translations_Variance_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "url_slug" */
export type Url_Slug = {
  __typename?: 'url_slug';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An object relationship */
  language?: Maybe<Languages>;
  language_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  property: Property;
  property_id: Scalars['uuid']['output'];
  redirect_to?: Maybe<Scalars['uuid']['output']>;
  redirect_to_slug?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

export type Url_Slug_ActionType = {
  __typename?: 'url_slug_ActionType';
  id: Scalars['uuid']['output'];
  language_id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "url_slug" */
export type Url_Slug_Aggregate = {
  __typename?: 'url_slug_aggregate';
  aggregate?: Maybe<Url_Slug_Aggregate_Fields>;
  nodes: Array<Url_Slug>;
};

export type Url_Slug_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Url_Slug_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Url_Slug_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Url_Slug_Aggregate_Bool_Exp_Count>;
};

export type Url_Slug_Aggregate_Bool_Exp_Bool_And = {
  arguments: Url_Slug_Select_Column_Url_Slug_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Url_Slug_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Url_Slug_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Url_Slug_Select_Column_Url_Slug_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Url_Slug_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Url_Slug_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Url_Slug_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Url_Slug_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "url_slug" */
export type Url_Slug_Aggregate_Fields = {
  __typename?: 'url_slug_aggregate_fields';
  avg?: Maybe<Url_Slug_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Url_Slug_Max_Fields>;
  min?: Maybe<Url_Slug_Min_Fields>;
  stddev?: Maybe<Url_Slug_Stddev_Fields>;
  stddev_pop?: Maybe<Url_Slug_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Url_Slug_Stddev_Samp_Fields>;
  sum?: Maybe<Url_Slug_Sum_Fields>;
  var_pop?: Maybe<Url_Slug_Var_Pop_Fields>;
  var_samp?: Maybe<Url_Slug_Var_Samp_Fields>;
  variance?: Maybe<Url_Slug_Variance_Fields>;
};


/** aggregate fields of "url_slug" */
export type Url_Slug_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Url_Slug_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "url_slug" */
export type Url_Slug_Aggregate_Order_By = {
  avg?: InputMaybe<Url_Slug_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Url_Slug_Max_Order_By>;
  min?: InputMaybe<Url_Slug_Min_Order_By>;
  stddev?: InputMaybe<Url_Slug_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Url_Slug_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Url_Slug_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Url_Slug_Sum_Order_By>;
  var_pop?: InputMaybe<Url_Slug_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Url_Slug_Var_Samp_Order_By>;
  variance?: InputMaybe<Url_Slug_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "url_slug" */
export type Url_Slug_Arr_Rel_Insert_Input = {
  data: Array<Url_Slug_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Url_Slug_On_Conflict>;
};

/** aggregate avg on columns */
export type Url_Slug_Avg_Fields = {
  __typename?: 'url_slug_avg_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "url_slug" */
export type Url_Slug_Avg_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "url_slug". All fields are combined with a logical 'AND'. */
export type Url_Slug_Bool_Exp = {
  _and?: InputMaybe<Array<Url_Slug_Bool_Exp>>;
  _not?: InputMaybe<Url_Slug_Bool_Exp>;
  _or?: InputMaybe<Array<Url_Slug_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<Languages_Bool_Exp>;
  language_id?: InputMaybe<Int_Comparison_Exp>;
  property?: InputMaybe<Property_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  redirect_to?: InputMaybe<Uuid_Comparison_Exp>;
  redirect_to_slug?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "url_slug" */
export enum Url_Slug_Constraint {
  /** unique or primary key constraint on columns "id" */
  UrlSlugPkey = 'url_slug_pkey',
  /** unique or primary key constraint on columns "slug" */
  UrlSlugSlugIdx = 'url_slug_slug_idx',
  /** unique or primary key constraint on columns "slug" */
  UrlSlugSlugKey = 'url_slug_slug_key'
}

/** input type for incrementing numeric columns in table "url_slug" */
export type Url_Slug_Inc_Input = {
  language_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "url_slug" */
export type Url_Slug_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Languages_Obj_Rel_Insert_Input>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<Property_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  redirect_to?: InputMaybe<Scalars['uuid']['input']>;
  redirect_to_slug?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Url_Slug_Max_Fields = {
  __typename?: 'url_slug_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  redirect_to?: Maybe<Scalars['uuid']['output']>;
  redirect_to_slug?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "url_slug" */
export type Url_Slug_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  redirect_to?: InputMaybe<Order_By>;
  redirect_to_slug?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Url_Slug_Min_Fields = {
  __typename?: 'url_slug_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  redirect_to?: Maybe<Scalars['uuid']['output']>;
  redirect_to_slug?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "url_slug" */
export type Url_Slug_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  redirect_to?: InputMaybe<Order_By>;
  redirect_to_slug?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "url_slug" */
export type Url_Slug_Mutation_Response = {
  __typename?: 'url_slug_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Url_Slug>;
};

/** on_conflict condition type for table "url_slug" */
export type Url_Slug_On_Conflict = {
  constraint: Url_Slug_Constraint;
  update_columns?: Array<Url_Slug_Update_Column>;
  where?: InputMaybe<Url_Slug_Bool_Exp>;
};

/** Ordering options when selecting data from "url_slug". */
export type Url_Slug_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  language?: InputMaybe<Languages_Order_By>;
  language_id?: InputMaybe<Order_By>;
  property?: InputMaybe<Property_Order_By>;
  property_id?: InputMaybe<Order_By>;
  redirect_to?: InputMaybe<Order_By>;
  redirect_to_slug?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: url_slug */
export type Url_Slug_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "url_slug" */
export enum Url_Slug_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  RedirectTo = 'redirect_to',
  /** column name */
  RedirectToSlug = 'redirect_to_slug',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "url_slug_aggregate_bool_exp_bool_and_arguments_columns" columns of table "url_slug" */
export enum Url_Slug_Select_Column_Url_Slug_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "url_slug_aggregate_bool_exp_bool_or_arguments_columns" columns of table "url_slug" */
export enum Url_Slug_Select_Column_Url_Slug_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "url_slug" */
export type Url_Slug_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  redirect_to?: InputMaybe<Scalars['uuid']['input']>;
  redirect_to_slug?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Url_Slug_Stddev_Fields = {
  __typename?: 'url_slug_stddev_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "url_slug" */
export type Url_Slug_Stddev_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Url_Slug_Stddev_Pop_Fields = {
  __typename?: 'url_slug_stddev_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "url_slug" */
export type Url_Slug_Stddev_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Url_Slug_Stddev_Samp_Fields = {
  __typename?: 'url_slug_stddev_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "url_slug" */
export type Url_Slug_Stddev_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "url_slug" */
export type Url_Slug_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Url_Slug_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Url_Slug_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  redirect_to?: InputMaybe<Scalars['uuid']['input']>;
  redirect_to_slug?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Url_Slug_Sum_Fields = {
  __typename?: 'url_slug_sum_fields';
  language_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "url_slug" */
export type Url_Slug_Sum_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** update columns of table "url_slug" */
export enum Url_Slug_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  RedirectTo = 'redirect_to',
  /** column name */
  RedirectToSlug = 'redirect_to_slug',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Url_Slug_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Url_Slug_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Url_Slug_Set_Input>;
  /** filter the rows which have to be updated */
  where: Url_Slug_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Url_Slug_Var_Pop_Fields = {
  __typename?: 'url_slug_var_pop_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "url_slug" */
export type Url_Slug_Var_Pop_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Url_Slug_Var_Samp_Fields = {
  __typename?: 'url_slug_var_samp_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "url_slug" */
export type Url_Slug_Var_Samp_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Url_Slug_Variance_Fields = {
  __typename?: 'url_slug_variance_fields';
  language_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "url_slug" */
export type Url_Slug_Variance_Order_By = {
  language_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_filters" */
export type User_Filters = {
  __typename?: 'user_filters';
  city?: Maybe<City>;
  city_id?: Maybe<Scalars['uuid']['output']>;
  city_zone?: Maybe<City_Zone>;
  city_zone_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  price_max?: Maybe<Scalars['float8']['output']>;
  price_min?: Maybe<Scalars['float8']['output']>;
  property_composition_id?: Maybe<Scalars['uuid']['output']>;
  property_origin?: Maybe<Property_Origin_Type>;
  property_origin_type?: Maybe<Scalars['String']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  search_session: Search_Sessions;
  search_session_id: Scalars['uuid']['output'];
  sq_max?: Maybe<Scalars['float8']['output']>;
  sq_min?: Maybe<Scalars['float8']['output']>;
  status_property?: Maybe<Property_Status>;
  type_property?: Maybe<Property_Type>;
  /** An array relationship */
  user_filters_features: Array<User_Filters_Features>;
  /** An aggregate relationship */
  user_filters_features_aggregate: User_Filters_Features_Aggregate;
};


/** columns and relationships of "user_filters" */
export type User_FiltersUser_Filters_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<User_Filters_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Filters_Features_Order_By>>;
  where?: InputMaybe<User_Filters_Features_Bool_Exp>;
};


/** columns and relationships of "user_filters" */
export type User_FiltersUser_Filters_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Filters_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Filters_Features_Order_By>>;
  where?: InputMaybe<User_Filters_Features_Bool_Exp>;
};

/** aggregated selection of "user_filters" */
export type User_Filters_Aggregate = {
  __typename?: 'user_filters_aggregate';
  aggregate?: Maybe<User_Filters_Aggregate_Fields>;
  nodes: Array<User_Filters>;
};

export type User_Filters_Aggregate_Bool_Exp = {
  avg?: InputMaybe<User_Filters_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<User_Filters_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<User_Filters_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<User_Filters_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<User_Filters_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<User_Filters_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<User_Filters_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<User_Filters_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<User_Filters_Aggregate_Bool_Exp_Var_Samp>;
};

export type User_Filters_Aggregate_Bool_Exp_Avg = {
  arguments: User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Filters_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Filters_Aggregate_Bool_Exp_Corr = {
  arguments: User_Filters_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Filters_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Filters_Aggregate_Bool_Exp_Corr_Arguments = {
  X: User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type User_Filters_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Filters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Filters_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type User_Filters_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: User_Filters_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Filters_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Filters_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type User_Filters_Aggregate_Bool_Exp_Max = {
  arguments: User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Filters_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Filters_Aggregate_Bool_Exp_Min = {
  arguments: User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Filters_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Filters_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Filters_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Filters_Aggregate_Bool_Exp_Sum = {
  arguments: User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Filters_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type User_Filters_Aggregate_Bool_Exp_Var_Samp = {
  arguments: User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Filters_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "user_filters" */
export type User_Filters_Aggregate_Fields = {
  __typename?: 'user_filters_aggregate_fields';
  avg?: Maybe<User_Filters_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Filters_Max_Fields>;
  min?: Maybe<User_Filters_Min_Fields>;
  stddev?: Maybe<User_Filters_Stddev_Fields>;
  stddev_pop?: Maybe<User_Filters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Filters_Stddev_Samp_Fields>;
  sum?: Maybe<User_Filters_Sum_Fields>;
  var_pop?: Maybe<User_Filters_Var_Pop_Fields>;
  var_samp?: Maybe<User_Filters_Var_Samp_Fields>;
  variance?: Maybe<User_Filters_Variance_Fields>;
};


/** aggregate fields of "user_filters" */
export type User_Filters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Filters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_filters" */
export type User_Filters_Aggregate_Order_By = {
  avg?: InputMaybe<User_Filters_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Filters_Max_Order_By>;
  min?: InputMaybe<User_Filters_Min_Order_By>;
  stddev?: InputMaybe<User_Filters_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Filters_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Filters_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Filters_Sum_Order_By>;
  var_pop?: InputMaybe<User_Filters_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Filters_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Filters_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_filters" */
export type User_Filters_Arr_Rel_Insert_Input = {
  data: Array<User_Filters_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Filters_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Filters_Avg_Fields = {
  __typename?: 'user_filters_avg_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_filters" */
export type User_Filters_Avg_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_filters". All fields are combined with a logical 'AND'. */
export type User_Filters_Bool_Exp = {
  _and?: InputMaybe<Array<User_Filters_Bool_Exp>>;
  _not?: InputMaybe<User_Filters_Bool_Exp>;
  _or?: InputMaybe<Array<User_Filters_Bool_Exp>>;
  city_id?: InputMaybe<Uuid_Comparison_Exp>;
  city_zone_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  price_max?: InputMaybe<Float8_Comparison_Exp>;
  price_min?: InputMaybe<Float8_Comparison_Exp>;
  property_composition_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_origin_type?: InputMaybe<String_Comparison_Exp>;
  property_status?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  search_session?: InputMaybe<Search_Sessions_Bool_Exp>;
  search_session_id?: InputMaybe<Uuid_Comparison_Exp>;
  sq_max?: InputMaybe<Float8_Comparison_Exp>;
  sq_min?: InputMaybe<Float8_Comparison_Exp>;
  user_filters_features?: InputMaybe<User_Filters_Features_Bool_Exp>;
  user_filters_features_aggregate?: InputMaybe<User_Filters_Features_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "user_filters" */
export enum User_Filters_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserFiltersPkey = 'user_filters_pkey'
}

/** columns and relationships of "user_filters_features" */
export type User_Filters_Features = {
  __typename?: 'user_filters_features';
  feature?: Maybe<Feature>;
  feature_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  user_filter: User_Filters;
  user_filters_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_filters_features" */
export type User_Filters_Features_Aggregate = {
  __typename?: 'user_filters_features_aggregate';
  aggregate?: Maybe<User_Filters_Features_Aggregate_Fields>;
  nodes: Array<User_Filters_Features>;
};

export type User_Filters_Features_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Filters_Features_Aggregate_Bool_Exp_Count>;
};

export type User_Filters_Features_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Filters_Features_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Filters_Features_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_filters_features" */
export type User_Filters_Features_Aggregate_Fields = {
  __typename?: 'user_filters_features_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Filters_Features_Max_Fields>;
  min?: Maybe<User_Filters_Features_Min_Fields>;
};


/** aggregate fields of "user_filters_features" */
export type User_Filters_Features_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Filters_Features_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_filters_features" */
export type User_Filters_Features_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Filters_Features_Max_Order_By>;
  min?: InputMaybe<User_Filters_Features_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_filters_features" */
export type User_Filters_Features_Arr_Rel_Insert_Input = {
  data: Array<User_Filters_Features_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Filters_Features_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_filters_features". All fields are combined with a logical 'AND'. */
export type User_Filters_Features_Bool_Exp = {
  _and?: InputMaybe<Array<User_Filters_Features_Bool_Exp>>;
  _not?: InputMaybe<User_Filters_Features_Bool_Exp>;
  _or?: InputMaybe<Array<User_Filters_Features_Bool_Exp>>;
  feature_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  user_filter?: InputMaybe<User_Filters_Bool_Exp>;
  user_filters_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_filters_features" */
export enum User_Filters_Features_Constraint {
  /** unique or primary key constraint on columns "feature_id", "user_filters_id" */
  UserFiltersFeaturesFeatureIdUserFiltersIdKey = 'user_filters_features_feature_id_user_filters_id_key',
  /** unique or primary key constraint on columns "id" */
  UserFiltersFeaturesPkey = 'user_filters_features_pkey'
}

/** input type for inserting data into table "user_filters_features" */
export type User_Filters_Features_Insert_Input = {
  feature_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_filter?: InputMaybe<User_Filters_Obj_Rel_Insert_Input>;
  user_filters_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Filters_Features_Max_Fields = {
  __typename?: 'user_filters_features_max_fields';
  feature_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  user_filters_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_filters_features" */
export type User_Filters_Features_Max_Order_By = {
  feature_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_filters_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Filters_Features_Min_Fields = {
  __typename?: 'user_filters_features_min_fields';
  feature_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  user_filters_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_filters_features" */
export type User_Filters_Features_Min_Order_By = {
  feature_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_filters_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_filters_features" */
export type User_Filters_Features_Mutation_Response = {
  __typename?: 'user_filters_features_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Filters_Features>;
};

/** on_conflict condition type for table "user_filters_features" */
export type User_Filters_Features_On_Conflict = {
  constraint: User_Filters_Features_Constraint;
  update_columns?: Array<User_Filters_Features_Update_Column>;
  where?: InputMaybe<User_Filters_Features_Bool_Exp>;
};

/** Ordering options when selecting data from "user_filters_features". */
export type User_Filters_Features_Order_By = {
  feature_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_filter?: InputMaybe<User_Filters_Order_By>;
  user_filters_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_filters_features */
export type User_Filters_Features_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_filters_features" */
export enum User_Filters_Features_Select_Column {
  /** column name */
  FeatureId = 'feature_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserFiltersId = 'user_filters_id'
}

/** input type for updating data in table "user_filters_features" */
export type User_Filters_Features_Set_Input = {
  feature_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_filters_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_filters_features" */
export type User_Filters_Features_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Filters_Features_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Filters_Features_Stream_Cursor_Value_Input = {
  feature_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_filters_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_filters_features" */
export enum User_Filters_Features_Update_Column {
  /** column name */
  FeatureId = 'feature_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserFiltersId = 'user_filters_id'
}

export type User_Filters_Features_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Filters_Features_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Filters_Features_Bool_Exp;
};

/** input type for incrementing numeric columns in table "user_filters" */
export type User_Filters_Inc_Input = {
  price_max?: InputMaybe<Scalars['float8']['input']>;
  price_min?: InputMaybe<Scalars['float8']['input']>;
  sq_max?: InputMaybe<Scalars['float8']['input']>;
  sq_min?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "user_filters" */
export type User_Filters_Insert_Input = {
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price_max?: InputMaybe<Scalars['float8']['input']>;
  price_min?: InputMaybe<Scalars['float8']['input']>;
  property_composition_id?: InputMaybe<Scalars['uuid']['input']>;
  property_origin_type?: InputMaybe<Scalars['String']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
  search_session?: InputMaybe<Search_Sessions_Obj_Rel_Insert_Input>;
  search_session_id?: InputMaybe<Scalars['uuid']['input']>;
  sq_max?: InputMaybe<Scalars['float8']['input']>;
  sq_min?: InputMaybe<Scalars['float8']['input']>;
  user_filters_features?: InputMaybe<User_Filters_Features_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Filters_Max_Fields = {
  __typename?: 'user_filters_max_fields';
  city_id?: Maybe<Scalars['uuid']['output']>;
  city_zone_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  price_max?: Maybe<Scalars['float8']['output']>;
  price_min?: Maybe<Scalars['float8']['output']>;
  property_composition_id?: Maybe<Scalars['uuid']['output']>;
  property_origin_type?: Maybe<Scalars['String']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  search_session_id?: Maybe<Scalars['uuid']['output']>;
  sq_max?: Maybe<Scalars['float8']['output']>;
  sq_min?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "user_filters" */
export type User_Filters_Max_Order_By = {
  city_id?: InputMaybe<Order_By>;
  city_zone_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  property_composition_id?: InputMaybe<Order_By>;
  property_origin_type?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  search_session_id?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Filters_Min_Fields = {
  __typename?: 'user_filters_min_fields';
  city_id?: Maybe<Scalars['uuid']['output']>;
  city_zone_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  price_max?: Maybe<Scalars['float8']['output']>;
  price_min?: Maybe<Scalars['float8']['output']>;
  property_composition_id?: Maybe<Scalars['uuid']['output']>;
  property_origin_type?: Maybe<Scalars['String']['output']>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  search_session_id?: Maybe<Scalars['uuid']['output']>;
  sq_max?: Maybe<Scalars['float8']['output']>;
  sq_min?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "user_filters" */
export type User_Filters_Min_Order_By = {
  city_id?: InputMaybe<Order_By>;
  city_zone_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  property_composition_id?: InputMaybe<Order_By>;
  property_origin_type?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  search_session_id?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_filters" */
export type User_Filters_Mutation_Response = {
  __typename?: 'user_filters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Filters>;
};

/** input type for inserting object relation for remote table "user_filters" */
export type User_Filters_Obj_Rel_Insert_Input = {
  data: User_Filters_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Filters_On_Conflict>;
};

/** on_conflict condition type for table "user_filters" */
export type User_Filters_On_Conflict = {
  constraint: User_Filters_Constraint;
  update_columns?: Array<User_Filters_Update_Column>;
  where?: InputMaybe<User_Filters_Bool_Exp>;
};

/** Ordering options when selecting data from "user_filters". */
export type User_Filters_Order_By = {
  city_id?: InputMaybe<Order_By>;
  city_zone_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  property_composition_id?: InputMaybe<Order_By>;
  property_origin_type?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  search_session?: InputMaybe<Search_Sessions_Order_By>;
  search_session_id?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
  user_filters_features_aggregate?: InputMaybe<User_Filters_Features_Aggregate_Order_By>;
};

/** primary key columns input for table: user_filters */
export type User_Filters_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_filters" */
export enum User_Filters_Select_Column {
  /** column name */
  CityId = 'city_id',
  /** column name */
  CityZoneId = 'city_zone_id',
  /** column name */
  Id = 'id',
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  PropertyCompositionId = 'property_composition_id',
  /** column name */
  PropertyOriginType = 'property_origin_type',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  SearchSessionId = 'search_session_id',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "user_filters_aggregate_bool_exp_avg_arguments_columns" columns of table "user_filters" */
export enum User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "user_filters_aggregate_bool_exp_corr_arguments_columns" columns of table "user_filters" */
export enum User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "user_filters_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "user_filters" */
export enum User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "user_filters_aggregate_bool_exp_max_arguments_columns" columns of table "user_filters" */
export enum User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "user_filters_aggregate_bool_exp_min_arguments_columns" columns of table "user_filters" */
export enum User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "user_filters_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "user_filters" */
export enum User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "user_filters_aggregate_bool_exp_sum_arguments_columns" columns of table "user_filters" */
export enum User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** select "user_filters_aggregate_bool_exp_var_samp_arguments_columns" columns of table "user_filters" */
export enum User_Filters_Select_Column_User_Filters_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

/** input type for updating data in table "user_filters" */
export type User_Filters_Set_Input = {
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price_max?: InputMaybe<Scalars['float8']['input']>;
  price_min?: InputMaybe<Scalars['float8']['input']>;
  property_composition_id?: InputMaybe<Scalars['uuid']['input']>;
  property_origin_type?: InputMaybe<Scalars['String']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
  search_session_id?: InputMaybe<Scalars['uuid']['input']>;
  sq_max?: InputMaybe<Scalars['float8']['input']>;
  sq_min?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate stddev on columns */
export type User_Filters_Stddev_Fields = {
  __typename?: 'user_filters_stddev_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_filters" */
export type User_Filters_Stddev_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Filters_Stddev_Pop_Fields = {
  __typename?: 'user_filters_stddev_pop_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_filters" */
export type User_Filters_Stddev_Pop_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Filters_Stddev_Samp_Fields = {
  __typename?: 'user_filters_stddev_samp_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_filters" */
export type User_Filters_Stddev_Samp_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_filters" */
export type User_Filters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Filters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Filters_Stream_Cursor_Value_Input = {
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  city_zone_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price_max?: InputMaybe<Scalars['float8']['input']>;
  price_min?: InputMaybe<Scalars['float8']['input']>;
  property_composition_id?: InputMaybe<Scalars['uuid']['input']>;
  property_origin_type?: InputMaybe<Scalars['String']['input']>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
  search_session_id?: InputMaybe<Scalars['uuid']['input']>;
  sq_max?: InputMaybe<Scalars['float8']['input']>;
  sq_min?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type User_Filters_Sum_Fields = {
  __typename?: 'user_filters_sum_fields';
  price_max?: Maybe<Scalars['float8']['output']>;
  price_min?: Maybe<Scalars['float8']['output']>;
  sq_max?: Maybe<Scalars['float8']['output']>;
  sq_min?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "user_filters" */
export type User_Filters_Sum_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** update columns of table "user_filters" */
export enum User_Filters_Update_Column {
  /** column name */
  CityId = 'city_id',
  /** column name */
  CityZoneId = 'city_zone_id',
  /** column name */
  Id = 'id',
  /** column name */
  PriceMax = 'price_max',
  /** column name */
  PriceMin = 'price_min',
  /** column name */
  PropertyCompositionId = 'property_composition_id',
  /** column name */
  PropertyOriginType = 'property_origin_type',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  SearchSessionId = 'search_session_id',
  /** column name */
  SqMax = 'sq_max',
  /** column name */
  SqMin = 'sq_min'
}

export type User_Filters_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Filters_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Filters_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Filters_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Filters_Var_Pop_Fields = {
  __typename?: 'user_filters_var_pop_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_filters" */
export type User_Filters_Var_Pop_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Filters_Var_Samp_Fields = {
  __typename?: 'user_filters_var_samp_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_filters" */
export type User_Filters_Var_Samp_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Filters_Variance_Fields = {
  __typename?: 'user_filters_variance_fields';
  price_max?: Maybe<Scalars['Float']['output']>;
  price_min?: Maybe<Scalars['Float']['output']>;
  sq_max?: Maybe<Scalars['Float']['output']>;
  sq_min?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_filters" */
export type User_Filters_Variance_Order_By = {
  price_max?: InputMaybe<Order_By>;
  price_min?: InputMaybe<Order_By>;
  sq_max?: InputMaybe<Order_By>;
  sq_min?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_organization" */
export type User_Organization = {
  __typename?: 'user_organization';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  role?: Maybe<Organization_Role_Enum>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_organization" */
export type User_Organization_Aggregate = {
  __typename?: 'user_organization_aggregate';
  aggregate?: Maybe<User_Organization_Aggregate_Fields>;
  nodes: Array<User_Organization>;
};

export type User_Organization_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Organization_Aggregate_Bool_Exp_Count>;
};

export type User_Organization_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Organization_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_organization" */
export type User_Organization_Aggregate_Fields = {
  __typename?: 'user_organization_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Organization_Max_Fields>;
  min?: Maybe<User_Organization_Min_Fields>;
};


/** aggregate fields of "user_organization" */
export type User_Organization_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_organization" */
export type User_Organization_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Organization_Max_Order_By>;
  min?: InputMaybe<User_Organization_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_organization" */
export type User_Organization_Arr_Rel_Insert_Input = {
  data: Array<User_Organization_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Organization_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_organization". All fields are combined with a logical 'AND'. */
export type User_Organization_Bool_Exp = {
  _and?: InputMaybe<Array<User_Organization_Bool_Exp>>;
  _not?: InputMaybe<User_Organization_Bool_Exp>;
  _or?: InputMaybe<Array<User_Organization_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Organization_Role_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_organization" */
export enum User_Organization_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserOrganizationPkey = 'user_organization_pkey',
  /** unique or primary key constraint on columns "user_id", "organization_id" */
  UserOrganizationUserIdOrganizationIdKey = 'user_organization_user_id_organization_id_key'
}

/** input type for inserting data into table "user_organization" */
export type User_Organization_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Organization_Role_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Organization_Max_Fields = {
  __typename?: 'user_organization_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_organization" */
export type User_Organization_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Organization_Min_Fields = {
  __typename?: 'user_organization_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_organization" */
export type User_Organization_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_organization" */
export type User_Organization_Mutation_Response = {
  __typename?: 'user_organization_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Organization>;
};

/** on_conflict condition type for table "user_organization" */
export type User_Organization_On_Conflict = {
  constraint: User_Organization_Constraint;
  update_columns?: Array<User_Organization_Update_Column>;
  where?: InputMaybe<User_Organization_Bool_Exp>;
};

/** Ordering options when selecting data from "user_organization". */
export type User_Organization_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_organization */
export type User_Organization_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_organization" */
export enum User_Organization_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_organization" */
export type User_Organization_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Organization_Role_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_organization" */
export type User_Organization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Organization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Organization_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Organization_Role_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_organization" */
export enum User_Organization_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Organization_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Organization_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Organization_Bool_Exp;
};

/** general user platform preferences */
export type User_Preferences = {
  __typename?: 'user_preferences';
  currency?: Maybe<Main_Currency_Enum>;
  email_notifications: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  language?: Maybe<Scalars['String']['output']>;
  push_notifications: Scalars['Boolean']['output'];
  selected_organization_id?: Maybe<Scalars['uuid']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_preferences" */
export type User_Preferences_Aggregate = {
  __typename?: 'user_preferences_aggregate';
  aggregate?: Maybe<User_Preferences_Aggregate_Fields>;
  nodes: Array<User_Preferences>;
};

export type User_Preferences_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Preferences_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Preferences_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Preferences_Aggregate_Bool_Exp_Count>;
};

export type User_Preferences_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Preferences_Select_Column_User_Preferences_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Preferences_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Preferences_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Preferences_Select_Column_User_Preferences_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Preferences_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Preferences_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Preferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Preferences_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_preferences" */
export type User_Preferences_Aggregate_Fields = {
  __typename?: 'user_preferences_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Preferences_Max_Fields>;
  min?: Maybe<User_Preferences_Min_Fields>;
};


/** aggregate fields of "user_preferences" */
export type User_Preferences_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Preferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_preferences" */
export type User_Preferences_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Preferences_Max_Order_By>;
  min?: InputMaybe<User_Preferences_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_preferences" */
export type User_Preferences_Arr_Rel_Insert_Input = {
  data: Array<User_Preferences_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Preferences_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_preferences". All fields are combined with a logical 'AND'. */
export type User_Preferences_Bool_Exp = {
  _and?: InputMaybe<Array<User_Preferences_Bool_Exp>>;
  _not?: InputMaybe<User_Preferences_Bool_Exp>;
  _or?: InputMaybe<Array<User_Preferences_Bool_Exp>>;
  currency?: InputMaybe<Main_Currency_Enum_Comparison_Exp>;
  email_notifications?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  push_notifications?: InputMaybe<Boolean_Comparison_Exp>;
  selected_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  theme?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_preferences" */
export enum User_Preferences_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserPreferencesPkey = 'user_preferences_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserPreferencesUserIdKey = 'user_preferences_user_id_key'
}

/** input type for inserting data into table "user_preferences" */
export type User_Preferences_Insert_Input = {
  currency?: InputMaybe<Main_Currency_Enum>;
  email_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  push_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  selected_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Preferences_Max_Fields = {
  __typename?: 'user_preferences_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  selected_organization_id?: Maybe<Scalars['uuid']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_preferences" */
export type User_Preferences_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  selected_organization_id?: InputMaybe<Order_By>;
  theme?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Preferences_Min_Fields = {
  __typename?: 'user_preferences_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  selected_organization_id?: Maybe<Scalars['uuid']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_preferences" */
export type User_Preferences_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  selected_organization_id?: InputMaybe<Order_By>;
  theme?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_preferences" */
export type User_Preferences_Mutation_Response = {
  __typename?: 'user_preferences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Preferences>;
};

/** input type for inserting object relation for remote table "user_preferences" */
export type User_Preferences_Obj_Rel_Insert_Input = {
  data: User_Preferences_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Preferences_On_Conflict>;
};

/** on_conflict condition type for table "user_preferences" */
export type User_Preferences_On_Conflict = {
  constraint: User_Preferences_Constraint;
  update_columns?: Array<User_Preferences_Update_Column>;
  where?: InputMaybe<User_Preferences_Bool_Exp>;
};

/** Ordering options when selecting data from "user_preferences". */
export type User_Preferences_Order_By = {
  currency?: InputMaybe<Order_By>;
  email_notifications?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  push_notifications?: InputMaybe<Order_By>;
  selected_organization_id?: InputMaybe<Order_By>;
  theme?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_preferences */
export type User_Preferences_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_preferences" */
export enum User_Preferences_Select_Column {
  /** column name */
  Currency = 'currency',
  /** column name */
  EmailNotifications = 'email_notifications',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  PushNotifications = 'push_notifications',
  /** column name */
  SelectedOrganizationId = 'selected_organization_id',
  /** column name */
  Theme = 'theme',
  /** column name */
  UserId = 'user_id'
}

/** select "user_preferences_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_preferences" */
export enum User_Preferences_Select_Column_User_Preferences_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  EmailNotifications = 'email_notifications',
  /** column name */
  PushNotifications = 'push_notifications'
}

/** select "user_preferences_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_preferences" */
export enum User_Preferences_Select_Column_User_Preferences_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  EmailNotifications = 'email_notifications',
  /** column name */
  PushNotifications = 'push_notifications'
}

/** input type for updating data in table "user_preferences" */
export type User_Preferences_Set_Input = {
  currency?: InputMaybe<Main_Currency_Enum>;
  email_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  push_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  selected_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_preferences" */
export type User_Preferences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Preferences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Preferences_Stream_Cursor_Value_Input = {
  currency?: InputMaybe<Main_Currency_Enum>;
  email_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  push_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  selected_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_preferences" */
export enum User_Preferences_Update_Column {
  /** column name */
  Currency = 'currency',
  /** column name */
  EmailNotifications = 'email_notifications',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  PushNotifications = 'push_notifications',
  /** column name */
  SelectedOrganizationId = 'selected_organization_id',
  /** column name */
  Theme = 'theme',
  /** column name */
  UserId = 'user_id'
}

export type User_Preferences_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Preferences_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Preferences_Bool_Exp;
};

/** columns and relationships of "user_property_notifiation" */
export type User_Property_Notifiation = {
  __typename?: 'user_property_notifiation';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  natural_language_query?: Maybe<Natural_Language_Queries>;
  /** An object relationship */
  notification?: Maybe<Notification>;
  notification_id?: Maybe<Scalars['uuid']['output']>;
  property?: Maybe<Property>;
  property_id: Scalars['uuid']['output'];
  query_id?: Maybe<Scalars['uuid']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  sent_date?: Maybe<Scalars['date']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "user_property_notifiation" */
export type User_Property_Notifiation_Aggregate = {
  __typename?: 'user_property_notifiation_aggregate';
  aggregate?: Maybe<User_Property_Notifiation_Aggregate_Fields>;
  nodes: Array<User_Property_Notifiation>;
};

export type User_Property_Notifiation_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Property_Notifiation_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Property_Notifiation_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Property_Notifiation_Aggregate_Bool_Exp_Count>;
};

export type User_Property_Notifiation_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Property_Notifiation_Select_Column_User_Property_Notifiation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Property_Notifiation_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Property_Notifiation_Select_Column_User_Property_Notifiation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Property_Notifiation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Property_Notifiation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_property_notifiation" */
export type User_Property_Notifiation_Aggregate_Fields = {
  __typename?: 'user_property_notifiation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Property_Notifiation_Max_Fields>;
  min?: Maybe<User_Property_Notifiation_Min_Fields>;
};


/** aggregate fields of "user_property_notifiation" */
export type User_Property_Notifiation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Property_Notifiation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_property_notifiation" */
export type User_Property_Notifiation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Property_Notifiation_Max_Order_By>;
  min?: InputMaybe<User_Property_Notifiation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_property_notifiation" */
export type User_Property_Notifiation_Arr_Rel_Insert_Input = {
  data: Array<User_Property_Notifiation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Property_Notifiation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_property_notifiation". All fields are combined with a logical 'AND'. */
export type User_Property_Notifiation_Bool_Exp = {
  _and?: InputMaybe<Array<User_Property_Notifiation_Bool_Exp>>;
  _not?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
  _or?: InputMaybe<Array<User_Property_Notifiation_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  natural_language_query?: InputMaybe<Natural_Language_Queries_Bool_Exp>;
  notification?: InputMaybe<Notification_Bool_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  query_id?: InputMaybe<Uuid_Comparison_Exp>;
  read?: InputMaybe<Boolean_Comparison_Exp>;
  sent_date?: InputMaybe<Date_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_property_notifiation" */
export enum User_Property_Notifiation_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserNotifiationsPkey = 'user_notifiations_pkey'
}

/** input type for inserting data into table "user_property_notifiation" */
export type User_Property_Notifiation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  natural_language_query?: InputMaybe<Natural_Language_Queries_Obj_Rel_Insert_Input>;
  notification?: InputMaybe<Notification_Obj_Rel_Insert_Input>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  query_id?: InputMaybe<Scalars['uuid']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  sent_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type User_Property_Notifiation_Max_Fields = {
  __typename?: 'user_property_notifiation_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notification_id?: Maybe<Scalars['uuid']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  query_id?: Maybe<Scalars['uuid']['output']>;
  sent_date?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "user_property_notifiation" */
export type User_Property_Notifiation_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  query_id?: InputMaybe<Order_By>;
  sent_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Property_Notifiation_Min_Fields = {
  __typename?: 'user_property_notifiation_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notification_id?: Maybe<Scalars['uuid']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  query_id?: Maybe<Scalars['uuid']['output']>;
  sent_date?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "user_property_notifiation" */
export type User_Property_Notifiation_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  query_id?: InputMaybe<Order_By>;
  sent_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_property_notifiation" */
export type User_Property_Notifiation_Mutation_Response = {
  __typename?: 'user_property_notifiation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Property_Notifiation>;
};

/** on_conflict condition type for table "user_property_notifiation" */
export type User_Property_Notifiation_On_Conflict = {
  constraint: User_Property_Notifiation_Constraint;
  update_columns?: Array<User_Property_Notifiation_Update_Column>;
  where?: InputMaybe<User_Property_Notifiation_Bool_Exp>;
};

/** Ordering options when selecting data from "user_property_notifiation". */
export type User_Property_Notifiation_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  natural_language_query?: InputMaybe<Natural_Language_Queries_Order_By>;
  notification?: InputMaybe<Notification_Order_By>;
  notification_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  query_id?: InputMaybe<Order_By>;
  read?: InputMaybe<Order_By>;
  sent_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_property_notifiation */
export type User_Property_Notifiation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_property_notifiation" */
export enum User_Property_Notifiation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  QueryId = 'query_id',
  /** column name */
  Read = 'read',
  /** column name */
  SentDate = 'sent_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "user_property_notifiation_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_property_notifiation" */
export enum User_Property_Notifiation_Select_Column_User_Property_Notifiation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Read = 'read'
}

/** select "user_property_notifiation_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_property_notifiation" */
export enum User_Property_Notifiation_Select_Column_User_Property_Notifiation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Read = 'read'
}

/** input type for updating data in table "user_property_notifiation" */
export type User_Property_Notifiation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  query_id?: InputMaybe<Scalars['uuid']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  sent_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "user_property_notifiation" */
export type User_Property_Notifiation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Property_Notifiation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Property_Notifiation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  query_id?: InputMaybe<Scalars['uuid']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  sent_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "user_property_notifiation" */
export enum User_Property_Notifiation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  QueryId = 'query_id',
  /** column name */
  Read = 'read',
  /** column name */
  SentDate = 'sent_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type User_Property_Notifiation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Property_Notifiation_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Property_Notifiation_Bool_Exp;
};

/** saved properties of a user */
export type User_Saved_Properties = {
  __typename?: 'user_saved_properties';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_deleted: Scalars['Boolean']['output'];
  /** An object relationship */
  property: Property;
  property_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user: Array<Users>;
  user_aggregate: Users_Aggregate;
  user_id: Scalars['uuid']['output'];
};


/** saved properties of a user */
export type User_Saved_PropertiesUserArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** saved properties of a user */
export type User_Saved_PropertiesUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "user_saved_properties" */
export type User_Saved_Properties_Aggregate = {
  __typename?: 'user_saved_properties_aggregate';
  aggregate?: Maybe<User_Saved_Properties_Aggregate_Fields>;
  nodes: Array<User_Saved_Properties>;
};

export type User_Saved_Properties_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Saved_Properties_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Saved_Properties_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Saved_Properties_Aggregate_Bool_Exp_Count>;
};

export type User_Saved_Properties_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Saved_Properties_Select_Column_User_Saved_Properties_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Saved_Properties_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Saved_Properties_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Saved_Properties_Select_Column_User_Saved_Properties_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Saved_Properties_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Saved_Properties_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Saved_Properties_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Saved_Properties_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_saved_properties" */
export type User_Saved_Properties_Aggregate_Fields = {
  __typename?: 'user_saved_properties_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Saved_Properties_Max_Fields>;
  min?: Maybe<User_Saved_Properties_Min_Fields>;
};


/** aggregate fields of "user_saved_properties" */
export type User_Saved_Properties_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Saved_Properties_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_saved_properties" */
export type User_Saved_Properties_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Saved_Properties_Max_Order_By>;
  min?: InputMaybe<User_Saved_Properties_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_saved_properties" */
export type User_Saved_Properties_Arr_Rel_Insert_Input = {
  data: Array<User_Saved_Properties_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Saved_Properties_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_saved_properties". All fields are combined with a logical 'AND'. */
export type User_Saved_Properties_Bool_Exp = {
  _and?: InputMaybe<Array<User_Saved_Properties_Bool_Exp>>;
  _not?: InputMaybe<User_Saved_Properties_Bool_Exp>;
  _or?: InputMaybe<Array<User_Saved_Properties_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  property?: InputMaybe<Property_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_saved_properties" */
export enum User_Saved_Properties_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSavedPropertiesIdKey = 'user_saved_properties_id_key',
  /** unique or primary key constraint on columns "id" */
  UserSavedPropertiesPkey = 'user_saved_properties_pkey',
  /** unique or primary key constraint on columns "user_id", "property_id" */
  UserSavedPropertiesPropertyIdUserIdKey = 'user_saved_properties_property_id_user_id_key'
}

/** input type for inserting data into table "user_saved_properties" */
export type User_Saved_Properties_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  property?: InputMaybe<Property_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Saved_Properties_Max_Fields = {
  __typename?: 'user_saved_properties_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_saved_properties" */
export type User_Saved_Properties_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Saved_Properties_Min_Fields = {
  __typename?: 'user_saved_properties_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_saved_properties" */
export type User_Saved_Properties_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_saved_properties" */
export type User_Saved_Properties_Mutation_Response = {
  __typename?: 'user_saved_properties_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Saved_Properties>;
};

/** on_conflict condition type for table "user_saved_properties" */
export type User_Saved_Properties_On_Conflict = {
  constraint: User_Saved_Properties_Constraint;
  update_columns?: Array<User_Saved_Properties_Update_Column>;
  where?: InputMaybe<User_Saved_Properties_Bool_Exp>;
};

/** Ordering options when selecting data from "user_saved_properties". */
export type User_Saved_Properties_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  property?: InputMaybe<Property_Order_By>;
  property_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_saved_properties */
export type User_Saved_Properties_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_saved_properties" */
export enum User_Saved_Properties_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "user_saved_properties_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_saved_properties" */
export enum User_Saved_Properties_Select_Column_User_Saved_Properties_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "user_saved_properties_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_saved_properties" */
export enum User_Saved_Properties_Select_Column_User_Saved_Properties_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** input type for updating data in table "user_saved_properties" */
export type User_Saved_Properties_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_saved_properties" */
export type User_Saved_Properties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Saved_Properties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Saved_Properties_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_saved_properties" */
export enum User_Saved_Properties_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Saved_Properties_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Saved_Properties_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Saved_Properties_Bool_Exp;
};

/** columns and relationships of "user_seen_property" */
export type User_Seen_Property = {
  __typename?: 'user_seen_property';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  property: Property;
  property_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user?: Maybe<Users>;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_seen_property" */
export type User_Seen_Property_Aggregate = {
  __typename?: 'user_seen_property_aggregate';
  aggregate?: Maybe<User_Seen_Property_Aggregate_Fields>;
  nodes: Array<User_Seen_Property>;
};

export type User_Seen_Property_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Seen_Property_Aggregate_Bool_Exp_Count>;
};

export type User_Seen_Property_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Seen_Property_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Seen_Property_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_seen_property" */
export type User_Seen_Property_Aggregate_Fields = {
  __typename?: 'user_seen_property_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Seen_Property_Max_Fields>;
  min?: Maybe<User_Seen_Property_Min_Fields>;
};


/** aggregate fields of "user_seen_property" */
export type User_Seen_Property_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Seen_Property_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_seen_property" */
export type User_Seen_Property_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Seen_Property_Max_Order_By>;
  min?: InputMaybe<User_Seen_Property_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_seen_property" */
export type User_Seen_Property_Arr_Rel_Insert_Input = {
  data: Array<User_Seen_Property_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Seen_Property_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_seen_property". All fields are combined with a logical 'AND'. */
export type User_Seen_Property_Bool_Exp = {
  _and?: InputMaybe<Array<User_Seen_Property_Bool_Exp>>;
  _not?: InputMaybe<User_Seen_Property_Bool_Exp>;
  _or?: InputMaybe<Array<User_Seen_Property_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  property?: InputMaybe<Property_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_seen_property" */
export enum User_Seen_Property_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSeenPropertyPkey = 'user_seen_property_pkey',
  /** unique or primary key constraint on columns "user_id", "property_id" */
  UserSeenPropertyUserIdPropertyIdKey = 'user_seen_property_user_id_property_id_key'
}

/** input type for inserting data into table "user_seen_property" */
export type User_Seen_Property_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property?: InputMaybe<Property_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Seen_Property_Max_Fields = {
  __typename?: 'user_seen_property_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_seen_property" */
export type User_Seen_Property_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Seen_Property_Min_Fields = {
  __typename?: 'user_seen_property_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_seen_property" */
export type User_Seen_Property_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_seen_property" */
export type User_Seen_Property_Mutation_Response = {
  __typename?: 'user_seen_property_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Seen_Property>;
};

/** on_conflict condition type for table "user_seen_property" */
export type User_Seen_Property_On_Conflict = {
  constraint: User_Seen_Property_Constraint;
  update_columns?: Array<User_Seen_Property_Update_Column>;
  where?: InputMaybe<User_Seen_Property_Bool_Exp>;
};

/** Ordering options when selecting data from "user_seen_property". */
export type User_Seen_Property_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  property?: InputMaybe<Property_Order_By>;
  property_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_seen_property */
export type User_Seen_Property_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_seen_property" */
export enum User_Seen_Property_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_seen_property" */
export type User_Seen_Property_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_seen_property" */
export type User_Seen_Property_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Seen_Property_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Seen_Property_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_seen_property" */
export enum User_Seen_Property_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Seen_Property_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Seen_Property_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Seen_Property_Bool_Exp;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type Users = {
  __typename?: 'users';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  currentChallenge?: Maybe<Scalars['String']['output']>;
  defaultRole: AuthRoles_Enum;
  /** An object relationship */
  defaultRoleByRole: AuthRoles;
  disabled: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['citext']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale: Scalars['String']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  /** An array relationship */
  notifications: Array<Notification>;
  /** An aggregate relationship */
  notifications_aggregate: Notification_Aggregate;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt: Scalars['timestamptz']['output'];
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerified: Scalars['Boolean']['output'];
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate;
  /** An array relationship */
  roles: Array<AuthUserRoles>;
  /** An aggregate relationship */
  roles_aggregate: AuthUserRoles_Aggregate;
  /** An array relationship */
  search_sessions: Array<Search_Sessions>;
  /** An aggregate relationship */
  search_sessions_aggregate: Search_Sessions_Aggregate;
  /** An array relationship */
  securityKeys: Array<AuthUserSecurityKeys>;
  /** An aggregate relationship */
  securityKeys_aggregate: AuthUserSecurityKeys_Aggregate;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt: Scalars['timestamptz']['output'];
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate;
  /** An array relationship */
  user_organizations: Array<User_Organization>;
  /** An aggregate relationship */
  user_organizations_aggregate: User_Organization_Aggregate;
  /** An object relationship */
  user_preference?: Maybe<User_Preferences>;
  /** An array relationship */
  user_preferences: Array<User_Preferences>;
  /** An aggregate relationship */
  user_preferences_aggregate: User_Preferences_Aggregate;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSearch_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSearch_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Search_Sessions_Order_By>>;
  where?: InputMaybe<Search_Sessions_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUser_OrganizationsArgs = {
  distinct_on?: InputMaybe<Array<User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Organization_Order_By>>;
  where?: InputMaybe<User_Organization_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUser_Organizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Organization_Order_By>>;
  where?: InputMaybe<User_Organization_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUser_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<User_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Preferences_Order_By>>;
  where?: InputMaybe<User_Preferences_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUser_Preferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Preferences_Order_By>>;
  where?: InputMaybe<User_Preferences_Bool_Exp>;
};

/** columns and relationships of "users_activity_summary" */
export type Users_Activity_Summary = {
  __typename?: 'users_activity_summary';
  display_name: Scalars['String']['output'];
  email: Scalars['String']['output'];
  last_seen: Scalars['timestamptz']['output'];
  nr_notifications: Scalars['bigint']['output'];
  nr_sessions: Scalars['bigint']['output'];
  user_id: Scalars['uuid']['output'];
};

export type Users_Activity_Summary_Aggregate = {
  __typename?: 'users_activity_summary_aggregate';
  aggregate?: Maybe<Users_Activity_Summary_Aggregate_Fields>;
  nodes: Array<Users_Activity_Summary>;
};

/** aggregate fields of "users_activity_summary" */
export type Users_Activity_Summary_Aggregate_Fields = {
  __typename?: 'users_activity_summary_aggregate_fields';
  avg?: Maybe<Users_Activity_Summary_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Activity_Summary_Max_Fields>;
  min?: Maybe<Users_Activity_Summary_Min_Fields>;
  stddev?: Maybe<Users_Activity_Summary_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Activity_Summary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Activity_Summary_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Activity_Summary_Sum_Fields>;
  var_pop?: Maybe<Users_Activity_Summary_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Activity_Summary_Var_Samp_Fields>;
  variance?: Maybe<Users_Activity_Summary_Variance_Fields>;
};


/** aggregate fields of "users_activity_summary" */
export type Users_Activity_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Activity_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Users_Activity_Summary_Avg_Fields = {
  __typename?: 'users_activity_summary_avg_fields';
  nr_notifications?: Maybe<Scalars['Float']['output']>;
  nr_sessions?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "users_activity_summary". All fields are combined with a logical 'AND'. */
export type Users_Activity_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Activity_Summary_Bool_Exp>>;
  _not?: InputMaybe<Users_Activity_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Activity_Summary_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  last_seen?: InputMaybe<Timestamptz_Comparison_Exp>;
  nr_notifications?: InputMaybe<Bigint_Comparison_Exp>;
  nr_sessions?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "users_activity_summary" */
export enum Users_Activity_Summary_Constraint {
  /** unique or primary key constraint on columns "user_id" */
  UsersActivitySummaryPkey = 'users_activity_summary_pkey'
}

/** input type for incrementing numeric columns in table "users_activity_summary" */
export type Users_Activity_Summary_Inc_Input = {
  nr_notifications?: InputMaybe<Scalars['bigint']['input']>;
  nr_sessions?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "users_activity_summary" */
export type Users_Activity_Summary_Insert_Input = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  nr_notifications?: InputMaybe<Scalars['bigint']['input']>;
  nr_sessions?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Users_Activity_Summary_Max_Fields = {
  __typename?: 'users_activity_summary_max_fields';
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  nr_notifications?: Maybe<Scalars['bigint']['output']>;
  nr_sessions?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Users_Activity_Summary_Min_Fields = {
  __typename?: 'users_activity_summary_min_fields';
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  nr_notifications?: Maybe<Scalars['bigint']['output']>;
  nr_sessions?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "users_activity_summary" */
export type Users_Activity_Summary_Mutation_Response = {
  __typename?: 'users_activity_summary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_Activity_Summary>;
};

/** on_conflict condition type for table "users_activity_summary" */
export type Users_Activity_Summary_On_Conflict = {
  constraint: Users_Activity_Summary_Constraint;
  update_columns?: Array<Users_Activity_Summary_Update_Column>;
  where?: InputMaybe<Users_Activity_Summary_Bool_Exp>;
};

/** Ordering options when selecting data from "users_activity_summary". */
export type Users_Activity_Summary_Order_By = {
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  last_seen?: InputMaybe<Order_By>;
  nr_notifications?: InputMaybe<Order_By>;
  nr_sessions?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users_activity_summary */
export type Users_Activity_Summary_Pk_Columns_Input = {
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "users_activity_summary" */
export enum Users_Activity_Summary_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  NrNotifications = 'nr_notifications',
  /** column name */
  NrSessions = 'nr_sessions',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "users_activity_summary" */
export type Users_Activity_Summary_Set_Input = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  nr_notifications?: InputMaybe<Scalars['bigint']['input']>;
  nr_sessions?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Users_Activity_Summary_Stddev_Fields = {
  __typename?: 'users_activity_summary_stddev_fields';
  nr_notifications?: Maybe<Scalars['Float']['output']>;
  nr_sessions?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Users_Activity_Summary_Stddev_Pop_Fields = {
  __typename?: 'users_activity_summary_stddev_pop_fields';
  nr_notifications?: Maybe<Scalars['Float']['output']>;
  nr_sessions?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Users_Activity_Summary_Stddev_Samp_Fields = {
  __typename?: 'users_activity_summary_stddev_samp_fields';
  nr_notifications?: Maybe<Scalars['Float']['output']>;
  nr_sessions?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "users_activity_summary" */
export type Users_Activity_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Activity_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Activity_Summary_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  nr_notifications?: InputMaybe<Scalars['bigint']['input']>;
  nr_sessions?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Users_Activity_Summary_Sum_Fields = {
  __typename?: 'users_activity_summary_sum_fields';
  nr_notifications?: Maybe<Scalars['bigint']['output']>;
  nr_sessions?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "users_activity_summary" */
export enum Users_Activity_Summary_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  NrNotifications = 'nr_notifications',
  /** column name */
  NrSessions = 'nr_sessions',
  /** column name */
  UserId = 'user_id'
}

export type Users_Activity_Summary_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Activity_Summary_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Activity_Summary_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Activity_Summary_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Activity_Summary_Var_Pop_Fields = {
  __typename?: 'users_activity_summary_var_pop_fields';
  nr_notifications?: Maybe<Scalars['Float']['output']>;
  nr_sessions?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Users_Activity_Summary_Var_Samp_Fields = {
  __typename?: 'users_activity_summary_var_samp_fields';
  nr_notifications?: Maybe<Scalars['Float']['output']>;
  nr_sessions?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Users_Activity_Summary_Variance_Fields = {
  __typename?: 'users_activity_summary_variance_fields';
  nr_notifications?: Maybe<Scalars['Float']['output']>;
  nr_sessions?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "auth.users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "auth.users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.users" */
export type Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "auth.users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  activeMfaType?: InputMaybe<String_Comparison_Exp>;
  avatarUrl?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentChallenge?: InputMaybe<String_Comparison_Exp>;
  defaultRole?: InputMaybe<AuthRoles_Enum_Comparison_Exp>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Bool_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  emailVerified?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isAnonymous?: InputMaybe<Boolean_Comparison_Exp>;
  lastSeen?: InputMaybe<Timestamptz_Comparison_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  newEmail?: InputMaybe<Citext_Comparison_Exp>;
  notifications?: InputMaybe<Notification_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notification_Aggregate_Bool_Exp>;
  otpHash?: InputMaybe<String_Comparison_Exp>;
  otpHashExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  otpMethodLastUsed?: InputMaybe<String_Comparison_Exp>;
  passwordHash?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  phoneNumberVerified?: InputMaybe<Boolean_Comparison_Exp>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp>;
  roles?: InputMaybe<AuthUserRoles_Bool_Exp>;
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp>;
  search_sessions?: InputMaybe<Search_Sessions_Bool_Exp>;
  search_sessions_aggregate?: InputMaybe<Search_Sessions_Aggregate_Bool_Exp>;
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp>;
  ticket?: InputMaybe<String_Comparison_Exp>;
  ticketExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  totpSecret?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp>;
  user_organizations?: InputMaybe<User_Organization_Bool_Exp>;
  user_organizations_aggregate?: InputMaybe<User_Organization_Aggregate_Bool_Exp>;
  user_preference?: InputMaybe<User_Preferences_Bool_Exp>;
  user_preferences?: InputMaybe<User_Preferences_Bool_Exp>;
  user_preferences_aggregate?: InputMaybe<User_Preferences_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "phone_number" */
  UsersPhoneNumberKey = 'users_phone_number_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.users" */
export type Users_Insert_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<AuthRoles_Enum>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  notifications?: InputMaybe<Notification_Arr_Rel_Insert_Input>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input>;
  roles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input>;
  search_sessions?: InputMaybe<Search_Sessions_Arr_Rel_Insert_Input>;
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Arr_Rel_Insert_Input>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input>;
  user_organizations?: InputMaybe<User_Organization_Arr_Rel_Insert_Input>;
  user_preference?: InputMaybe<User_Preferences_Obj_Rel_Insert_Input>;
  user_preferences?: InputMaybe<User_Preferences_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currentChallenge?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "auth.users" */
export type Users_Max_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currentChallenge?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "auth.users" */
export type Users_Min_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "auth.users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "auth.users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.users". */
export type Users_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  defaultRole?: InputMaybe<Order_By>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Order_By>;
  disabled?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emailVerified?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isAnonymous?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notification_Aggregate_Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  phoneNumberVerified?: InputMaybe<Order_By>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By>;
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By>;
  search_sessions_aggregate?: InputMaybe<Search_Sessions_Aggregate_Order_By>;
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By>;
  user_organizations_aggregate?: InputMaybe<User_Organization_Aggregate_Order_By>;
  user_preference?: InputMaybe<User_Preferences_Order_By>;
  user_preferences_aggregate?: InputMaybe<User_Preferences_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.users" */
export enum Users_Select_Column {
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified'
}

/** input type for updating data in table "auth.users" */
export type Users_Set_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<AuthRoles_Enum>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<AuthRoles_Enum>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "auth.users" */
export enum Users_Update_Column {
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _eq?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _gt?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _gte?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['uuid']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _lte?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _neq?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['uuid']['input']>>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp_Remote_Rel_Organization_Leadslocations = {
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp_Remote_Rel_Organization_Leadsproperties_Matched = {
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp_Remote_Rel_Organization_Leadsproperties_Matched_Aggregate = {
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp_Remote_Rel_Organizationproperties = {
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp_Remote_Rel_Organizationproperties_Aggregate = {
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "storage.virus" */
export type Virus = {
  __typename?: 'virus';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  fileId: Scalars['uuid']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userSession: Scalars['jsonb']['output'];
  virus: Scalars['String']['output'];
};


/** columns and relationships of "storage.virus" */
export type VirusUserSessionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.virus" */
export type Virus_Aggregate = {
  __typename?: 'virus_aggregate';
  aggregate?: Maybe<Virus_Aggregate_Fields>;
  nodes: Array<Virus>;
};

/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_Fields = {
  __typename?: 'virus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Virus_Max_Fields>;
  min?: Maybe<Virus_Min_Fields>;
};


/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Virus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Virus_Append_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "storage.virus". All fields are combined with a logical 'AND'. */
export type Virus_Bool_Exp = {
  _and?: InputMaybe<Array<Virus_Bool_Exp>>;
  _not?: InputMaybe<Virus_Bool_Exp>;
  _or?: InputMaybe<Array<Virus_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userSession?: InputMaybe<Jsonb_Comparison_Exp>;
  virus?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.virus" */
export enum Virus_Constraint {
  /** unique or primary key constraint on columns "id" */
  VirusPkey = 'virus_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Virus_Delete_At_Path_Input = {
  userSession?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Virus_Delete_Elem_Input = {
  userSession?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Virus_Delete_Key_Input = {
  userSession?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "storage.virus" */
export type Virus_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Virus_Max_Fields = {
  __typename?: 'virus_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Virus_Min_Fields = {
  __typename?: 'virus_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storage.virus" */
export type Virus_Mutation_Response = {
  __typename?: 'virus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Virus>;
};

/** on_conflict condition type for table "storage.virus" */
export type Virus_On_Conflict = {
  constraint: Virus_Constraint;
  update_columns?: Array<Virus_Update_Column>;
  where?: InputMaybe<Virus_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.virus". */
export type Virus_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userSession?: InputMaybe<Order_By>;
  virus?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.virus */
export type Virus_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Virus_Prepend_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.virus" */
export enum Virus_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

/** input type for updating data in table "storage.virus" */
export type Virus_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "virus" */
export type Virus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Virus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Virus_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storage.virus" */
export enum Virus_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

export type Virus_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Virus_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Virus_Set_Input>;
  /** filter the rows which have to be updated */
  where: Virus_Bool_Exp;
};

/** columns and relationships of "visibility_status" */
export type Visibility_Status = {
  __typename?: 'visibility_status';
  status: Scalars['String']['output'];
};

/** aggregated selection of "visibility_status" */
export type Visibility_Status_Aggregate = {
  __typename?: 'visibility_status_aggregate';
  aggregate?: Maybe<Visibility_Status_Aggregate_Fields>;
  nodes: Array<Visibility_Status>;
};

/** aggregate fields of "visibility_status" */
export type Visibility_Status_Aggregate_Fields = {
  __typename?: 'visibility_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Visibility_Status_Max_Fields>;
  min?: Maybe<Visibility_Status_Min_Fields>;
};


/** aggregate fields of "visibility_status" */
export type Visibility_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Visibility_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "visibility_status". All fields are combined with a logical 'AND'. */
export type Visibility_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Visibility_Status_Bool_Exp>>;
  _not?: InputMaybe<Visibility_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Visibility_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "visibility_status" */
export enum Visibility_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  VisibilityStatusPkey = 'visibility_status_pkey'
}

export enum Visibility_Status_Enum {
  Active = 'active',
  Archived = 'archived',
  Deleted = 'deleted',
  Disapproved = 'disapproved',
  Draft = 'draft',
  Private = 'private',
  Review = 'review'
}

/** Boolean expression to compare columns of type "visibility_status_enum". All fields are combined with logical 'AND'. */
export type Visibility_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Visibility_Status_Enum>;
  _in?: InputMaybe<Array<Visibility_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Visibility_Status_Enum>;
  _nin?: InputMaybe<Array<Visibility_Status_Enum>>;
};

/** input type for inserting data into table "visibility_status" */
export type Visibility_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Visibility_Status_Max_Fields = {
  __typename?: 'visibility_status_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Visibility_Status_Min_Fields = {
  __typename?: 'visibility_status_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "visibility_status" */
export type Visibility_Status_Mutation_Response = {
  __typename?: 'visibility_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Visibility_Status>;
};

/** on_conflict condition type for table "visibility_status" */
export type Visibility_Status_On_Conflict = {
  constraint: Visibility_Status_Constraint;
  update_columns?: Array<Visibility_Status_Update_Column>;
  where?: InputMaybe<Visibility_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "visibility_status". */
export type Visibility_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: visibility_status */
export type Visibility_Status_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "visibility_status" */
export enum Visibility_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "visibility_status" */
export type Visibility_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "visibility_status" */
export type Visibility_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Visibility_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Visibility_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "visibility_status" */
export enum Visibility_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Visibility_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Visibility_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Visibility_Status_Bool_Exp;
};

/** Idempotency ledger for inbound provider messages. Raw message content must not be stored in this table. */
export type Whatsapp_Ai_Inbound_Message = {
  __typename?: 'whatsapp_ai_inbound_message';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  last_error_code?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['jsonb']['output'];
  metadata_redacted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  payload_hash: Scalars['String']['output'];
  provider_message_id: Scalars['String']['output'];
  provider_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  received_at: Scalars['timestamptz']['output'];
  remote_identity_hash: Scalars['String']['output'];
  retention_expires_at: Scalars['timestamptz']['output'];
  status: Scalars['String']['output'];
  /** An object relationship */
  turn?: Maybe<Whatsapp_Ai_Turn>;
  turn_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** Idempotency ledger for inbound provider messages. Raw message content must not be stored in this table. */
export type Whatsapp_Ai_Inbound_MessageMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "whatsapp_ai_inbound_message" */
export type Whatsapp_Ai_Inbound_Message_Aggregate = {
  __typename?: 'whatsapp_ai_inbound_message_aggregate';
  aggregate?: Maybe<Whatsapp_Ai_Inbound_Message_Aggregate_Fields>;
  nodes: Array<Whatsapp_Ai_Inbound_Message>;
};

export type Whatsapp_Ai_Inbound_Message_Aggregate_Bool_Exp = {
  count?: InputMaybe<Whatsapp_Ai_Inbound_Message_Aggregate_Bool_Exp_Count>;
};

export type Whatsapp_Ai_Inbound_Message_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Whatsapp_Ai_Inbound_Message_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "whatsapp_ai_inbound_message" */
export type Whatsapp_Ai_Inbound_Message_Aggregate_Fields = {
  __typename?: 'whatsapp_ai_inbound_message_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Whatsapp_Ai_Inbound_Message_Max_Fields>;
  min?: Maybe<Whatsapp_Ai_Inbound_Message_Min_Fields>;
};


/** aggregate fields of "whatsapp_ai_inbound_message" */
export type Whatsapp_Ai_Inbound_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "whatsapp_ai_inbound_message" */
export type Whatsapp_Ai_Inbound_Message_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Whatsapp_Ai_Inbound_Message_Max_Order_By>;
  min?: InputMaybe<Whatsapp_Ai_Inbound_Message_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Whatsapp_Ai_Inbound_Message_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "whatsapp_ai_inbound_message" */
export type Whatsapp_Ai_Inbound_Message_Arr_Rel_Insert_Input = {
  data: Array<Whatsapp_Ai_Inbound_Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Whatsapp_Ai_Inbound_Message_On_Conflict>;
};

/** Boolean expression to filter rows from the table "whatsapp_ai_inbound_message". All fields are combined with a logical 'AND'. */
export type Whatsapp_Ai_Inbound_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp_Ai_Inbound_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_error_code?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  metadata_redacted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  payload_hash?: InputMaybe<String_Comparison_Exp>;
  provider_message_id?: InputMaybe<String_Comparison_Exp>;
  provider_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  received_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  remote_identity_hash?: InputMaybe<String_Comparison_Exp>;
  retention_expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  turn?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
  turn_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "whatsapp_ai_inbound_message" */
export enum Whatsapp_Ai_Inbound_Message_Constraint {
  /** unique or primary key constraint on columns "provider_message_id", "organization_id", "remote_identity_hash" */
  WhatsappAiInboundMessageOrganizationIdRemoteIdentityHas = 'whatsapp_ai_inbound_message_organization_id_remote_identity_has',
  /** unique or primary key constraint on columns "id" */
  WhatsappAiInboundMessagePkey = 'whatsapp_ai_inbound_message_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Whatsapp_Ai_Inbound_Message_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Whatsapp_Ai_Inbound_Message_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Whatsapp_Ai_Inbound_Message_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "whatsapp_ai_inbound_message" */
export type Whatsapp_Ai_Inbound_Message_Insert_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_error_code?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  metadata_redacted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  payload_hash?: InputMaybe<Scalars['String']['input']>;
  provider_message_id?: InputMaybe<Scalars['String']['input']>;
  provider_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  remote_identity_hash?: InputMaybe<Scalars['String']['input']>;
  retention_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  turn?: InputMaybe<Whatsapp_Ai_Turn_Obj_Rel_Insert_Input>;
  turn_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Whatsapp_Ai_Inbound_Message_Max_Fields = {
  __typename?: 'whatsapp_ai_inbound_message_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_error_code?: Maybe<Scalars['String']['output']>;
  metadata_redacted_at?: Maybe<Scalars['timestamptz']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  payload_hash?: Maybe<Scalars['String']['output']>;
  provider_message_id?: Maybe<Scalars['String']['output']>;
  provider_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  received_at?: Maybe<Scalars['timestamptz']['output']>;
  remote_identity_hash?: Maybe<Scalars['String']['output']>;
  retention_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  turn_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "whatsapp_ai_inbound_message" */
export type Whatsapp_Ai_Inbound_Message_Max_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_error_code?: InputMaybe<Order_By>;
  metadata_redacted_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  payload_hash?: InputMaybe<Order_By>;
  provider_message_id?: InputMaybe<Order_By>;
  provider_sent_at?: InputMaybe<Order_By>;
  received_at?: InputMaybe<Order_By>;
  remote_identity_hash?: InputMaybe<Order_By>;
  retention_expires_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  turn_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Whatsapp_Ai_Inbound_Message_Min_Fields = {
  __typename?: 'whatsapp_ai_inbound_message_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_error_code?: Maybe<Scalars['String']['output']>;
  metadata_redacted_at?: Maybe<Scalars['timestamptz']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  payload_hash?: Maybe<Scalars['String']['output']>;
  provider_message_id?: Maybe<Scalars['String']['output']>;
  provider_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  received_at?: Maybe<Scalars['timestamptz']['output']>;
  remote_identity_hash?: Maybe<Scalars['String']['output']>;
  retention_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  turn_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "whatsapp_ai_inbound_message" */
export type Whatsapp_Ai_Inbound_Message_Min_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_error_code?: InputMaybe<Order_By>;
  metadata_redacted_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  payload_hash?: InputMaybe<Order_By>;
  provider_message_id?: InputMaybe<Order_By>;
  provider_sent_at?: InputMaybe<Order_By>;
  received_at?: InputMaybe<Order_By>;
  remote_identity_hash?: InputMaybe<Order_By>;
  retention_expires_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  turn_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "whatsapp_ai_inbound_message" */
export type Whatsapp_Ai_Inbound_Message_Mutation_Response = {
  __typename?: 'whatsapp_ai_inbound_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp_Ai_Inbound_Message>;
};

/** on_conflict condition type for table "whatsapp_ai_inbound_message" */
export type Whatsapp_Ai_Inbound_Message_On_Conflict = {
  constraint: Whatsapp_Ai_Inbound_Message_Constraint;
  update_columns?: Array<Whatsapp_Ai_Inbound_Message_Update_Column>;
  where?: InputMaybe<Whatsapp_Ai_Inbound_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp_ai_inbound_message". */
export type Whatsapp_Ai_Inbound_Message_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_error_code?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  metadata_redacted_at?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  payload_hash?: InputMaybe<Order_By>;
  provider_message_id?: InputMaybe<Order_By>;
  provider_sent_at?: InputMaybe<Order_By>;
  received_at?: InputMaybe<Order_By>;
  remote_identity_hash?: InputMaybe<Order_By>;
  retention_expires_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  turn?: InputMaybe<Whatsapp_Ai_Turn_Order_By>;
  turn_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: whatsapp_ai_inbound_message */
export type Whatsapp_Ai_Inbound_Message_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Whatsapp_Ai_Inbound_Message_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "whatsapp_ai_inbound_message" */
export enum Whatsapp_Ai_Inbound_Message_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastErrorCode = 'last_error_code',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MetadataRedactedAt = 'metadata_redacted_at',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PayloadHash = 'payload_hash',
  /** column name */
  ProviderMessageId = 'provider_message_id',
  /** column name */
  ProviderSentAt = 'provider_sent_at',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  RemoteIdentityHash = 'remote_identity_hash',
  /** column name */
  RetentionExpiresAt = 'retention_expires_at',
  /** column name */
  Status = 'status',
  /** column name */
  TurnId = 'turn_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "whatsapp_ai_inbound_message" */
export type Whatsapp_Ai_Inbound_Message_Set_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_error_code?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  metadata_redacted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  payload_hash?: InputMaybe<Scalars['String']['input']>;
  provider_message_id?: InputMaybe<Scalars['String']['input']>;
  provider_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  remote_identity_hash?: InputMaybe<Scalars['String']['input']>;
  retention_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  turn_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "whatsapp_ai_inbound_message" */
export type Whatsapp_Ai_Inbound_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp_Ai_Inbound_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp_Ai_Inbound_Message_Stream_Cursor_Value_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_error_code?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  metadata_redacted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  payload_hash?: InputMaybe<Scalars['String']['input']>;
  provider_message_id?: InputMaybe<Scalars['String']['input']>;
  provider_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  remote_identity_hash?: InputMaybe<Scalars['String']['input']>;
  retention_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  turn_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "whatsapp_ai_inbound_message" */
export enum Whatsapp_Ai_Inbound_Message_Update_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastErrorCode = 'last_error_code',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MetadataRedactedAt = 'metadata_redacted_at',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PayloadHash = 'payload_hash',
  /** column name */
  ProviderMessageId = 'provider_message_id',
  /** column name */
  ProviderSentAt = 'provider_sent_at',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  RemoteIdentityHash = 'remote_identity_hash',
  /** column name */
  RetentionExpiresAt = 'retention_expires_at',
  /** column name */
  Status = 'status',
  /** column name */
  TurnId = 'turn_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Whatsapp_Ai_Inbound_Message_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Whatsapp_Ai_Inbound_Message_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Whatsapp_Ai_Inbound_Message_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Whatsapp_Ai_Inbound_Message_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Whatsapp_Ai_Inbound_Message_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Whatsapp_Ai_Inbound_Message_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp_Ai_Inbound_Message_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp_Ai_Inbound_Message_Bool_Exp;
};

/** Ordered durable WhatsApp delivery outbox. Payload bodies are redacted after their delivery retention window. */
export type Whatsapp_Ai_Outbox_Part = {
  __typename?: 'whatsapp_ai_outbox_part';
  attempt_count: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  dispatched_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  kind: Scalars['String']['output'];
  last_error_code?: Maybe<Scalars['String']['output']>;
  last_reconciliation_outcome?: Maybe<Scalars['String']['output']>;
  lease_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  lease_owner?: Maybe<Scalars['String']['output']>;
  part_id: Scalars['String']['output'];
  part_index: Scalars['Int']['output'];
  payload?: Maybe<Scalars['jsonb']['output']>;
  payload_hash: Scalars['String']['output'];
  payload_match_hash: Scalars['String']['output'];
  payload_redact_after: Scalars['timestamptz']['output'];
  payload_redacted_at?: Maybe<Scalars['timestamptz']['output']>;
  provider_message_id?: Maybe<Scalars['String']['output']>;
  reconciled_at?: Maybe<Scalars['timestamptz']['output']>;
  reconciliation_attempt_count: Scalars['Int']['output'];
  reconciliation_lease_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  reconciliation_lease_owner?: Maybe<Scalars['String']['output']>;
  sent_at?: Maybe<Scalars['timestamptz']['output']>;
  status: Scalars['String']['output'];
  /** An object relationship */
  turn: Whatsapp_Ai_Turn;
  turn_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** Ordered durable WhatsApp delivery outbox. Payload bodies are redacted after their delivery retention window. */
export type Whatsapp_Ai_Outbox_PartPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Aggregate = {
  __typename?: 'whatsapp_ai_outbox_part_aggregate';
  aggregate?: Maybe<Whatsapp_Ai_Outbox_Part_Aggregate_Fields>;
  nodes: Array<Whatsapp_Ai_Outbox_Part>;
};

export type Whatsapp_Ai_Outbox_Part_Aggregate_Bool_Exp = {
  count?: InputMaybe<Whatsapp_Ai_Outbox_Part_Aggregate_Bool_Exp_Count>;
};

export type Whatsapp_Ai_Outbox_Part_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Aggregate_Fields = {
  __typename?: 'whatsapp_ai_outbox_part_aggregate_fields';
  avg?: Maybe<Whatsapp_Ai_Outbox_Part_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Whatsapp_Ai_Outbox_Part_Max_Fields>;
  min?: Maybe<Whatsapp_Ai_Outbox_Part_Min_Fields>;
  stddev?: Maybe<Whatsapp_Ai_Outbox_Part_Stddev_Fields>;
  stddev_pop?: Maybe<Whatsapp_Ai_Outbox_Part_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Whatsapp_Ai_Outbox_Part_Stddev_Samp_Fields>;
  sum?: Maybe<Whatsapp_Ai_Outbox_Part_Sum_Fields>;
  var_pop?: Maybe<Whatsapp_Ai_Outbox_Part_Var_Pop_Fields>;
  var_samp?: Maybe<Whatsapp_Ai_Outbox_Part_Var_Samp_Fields>;
  variance?: Maybe<Whatsapp_Ai_Outbox_Part_Variance_Fields>;
};


/** aggregate fields of "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Aggregate_Order_By = {
  avg?: InputMaybe<Whatsapp_Ai_Outbox_Part_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Whatsapp_Ai_Outbox_Part_Max_Order_By>;
  min?: InputMaybe<Whatsapp_Ai_Outbox_Part_Min_Order_By>;
  stddev?: InputMaybe<Whatsapp_Ai_Outbox_Part_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Whatsapp_Ai_Outbox_Part_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Whatsapp_Ai_Outbox_Part_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Whatsapp_Ai_Outbox_Part_Sum_Order_By>;
  var_pop?: InputMaybe<Whatsapp_Ai_Outbox_Part_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Whatsapp_Ai_Outbox_Part_Var_Samp_Order_By>;
  variance?: InputMaybe<Whatsapp_Ai_Outbox_Part_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Whatsapp_Ai_Outbox_Part_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Arr_Rel_Insert_Input = {
  data: Array<Whatsapp_Ai_Outbox_Part_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Whatsapp_Ai_Outbox_Part_On_Conflict>;
};

/** aggregate avg on columns */
export type Whatsapp_Ai_Outbox_Part_Avg_Fields = {
  __typename?: 'whatsapp_ai_outbox_part_avg_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  part_index?: Maybe<Scalars['Float']['output']>;
  reconciliation_attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Avg_Order_By = {
  attempt_count?: InputMaybe<Order_By>;
  part_index?: InputMaybe<Order_By>;
  reconciliation_attempt_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "whatsapp_ai_outbox_part". All fields are combined with a logical 'AND'. */
export type Whatsapp_Ai_Outbox_Part_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Bool_Exp>>;
  attempt_count?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dispatched_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  last_error_code?: InputMaybe<String_Comparison_Exp>;
  last_reconciliation_outcome?: InputMaybe<String_Comparison_Exp>;
  lease_expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lease_owner?: InputMaybe<String_Comparison_Exp>;
  part_id?: InputMaybe<String_Comparison_Exp>;
  part_index?: InputMaybe<Int_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  payload_hash?: InputMaybe<String_Comparison_Exp>;
  payload_match_hash?: InputMaybe<String_Comparison_Exp>;
  payload_redact_after?: InputMaybe<Timestamptz_Comparison_Exp>;
  payload_redacted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  provider_message_id?: InputMaybe<String_Comparison_Exp>;
  reconciled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reconciliation_attempt_count?: InputMaybe<Int_Comparison_Exp>;
  reconciliation_lease_expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reconciliation_lease_owner?: InputMaybe<String_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  turn?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
  turn_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "whatsapp_ai_outbox_part" */
export enum Whatsapp_Ai_Outbox_Part_Constraint {
  /** unique or primary key constraint on columns "id" */
  WhatsappAiOutboxPartPkey = 'whatsapp_ai_outbox_part_pkey',
  /** unique or primary key constraint on columns "part_id", "turn_id" */
  WhatsappAiOutboxPartTurnIdPartIdKey = 'whatsapp_ai_outbox_part_turn_id_part_id_key',
  /** unique or primary key constraint on columns "part_index", "turn_id" */
  WhatsappAiOutboxPartTurnIdPartIndexKey = 'whatsapp_ai_outbox_part_turn_id_part_index_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Whatsapp_Ai_Outbox_Part_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Whatsapp_Ai_Outbox_Part_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Whatsapp_Ai_Outbox_Part_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Inc_Input = {
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  part_index?: InputMaybe<Scalars['Int']['input']>;
  reconciliation_attempt_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Insert_Input = {
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dispatched_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  last_error_code?: InputMaybe<Scalars['String']['input']>;
  last_reconciliation_outcome?: InputMaybe<Scalars['String']['input']>;
  lease_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lease_owner?: InputMaybe<Scalars['String']['input']>;
  part_id?: InputMaybe<Scalars['String']['input']>;
  part_index?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  payload_hash?: InputMaybe<Scalars['String']['input']>;
  payload_match_hash?: InputMaybe<Scalars['String']['input']>;
  payload_redact_after?: InputMaybe<Scalars['timestamptz']['input']>;
  payload_redacted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  provider_message_id?: InputMaybe<Scalars['String']['input']>;
  reconciled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reconciliation_attempt_count?: InputMaybe<Scalars['Int']['input']>;
  reconciliation_lease_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reconciliation_lease_owner?: InputMaybe<Scalars['String']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  turn?: InputMaybe<Whatsapp_Ai_Turn_Obj_Rel_Insert_Input>;
  turn_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Whatsapp_Ai_Outbox_Part_Max_Fields = {
  __typename?: 'whatsapp_ai_outbox_part_max_fields';
  attempt_count?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dispatched_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  last_error_code?: Maybe<Scalars['String']['output']>;
  last_reconciliation_outcome?: Maybe<Scalars['String']['output']>;
  lease_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  lease_owner?: Maybe<Scalars['String']['output']>;
  part_id?: Maybe<Scalars['String']['output']>;
  part_index?: Maybe<Scalars['Int']['output']>;
  payload_hash?: Maybe<Scalars['String']['output']>;
  payload_match_hash?: Maybe<Scalars['String']['output']>;
  payload_redact_after?: Maybe<Scalars['timestamptz']['output']>;
  payload_redacted_at?: Maybe<Scalars['timestamptz']['output']>;
  provider_message_id?: Maybe<Scalars['String']['output']>;
  reconciled_at?: Maybe<Scalars['timestamptz']['output']>;
  reconciliation_attempt_count?: Maybe<Scalars['Int']['output']>;
  reconciliation_lease_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  reconciliation_lease_owner?: Maybe<Scalars['String']['output']>;
  sent_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  turn_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Max_Order_By = {
  attempt_count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dispatched_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  last_error_code?: InputMaybe<Order_By>;
  last_reconciliation_outcome?: InputMaybe<Order_By>;
  lease_expires_at?: InputMaybe<Order_By>;
  lease_owner?: InputMaybe<Order_By>;
  part_id?: InputMaybe<Order_By>;
  part_index?: InputMaybe<Order_By>;
  payload_hash?: InputMaybe<Order_By>;
  payload_match_hash?: InputMaybe<Order_By>;
  payload_redact_after?: InputMaybe<Order_By>;
  payload_redacted_at?: InputMaybe<Order_By>;
  provider_message_id?: InputMaybe<Order_By>;
  reconciled_at?: InputMaybe<Order_By>;
  reconciliation_attempt_count?: InputMaybe<Order_By>;
  reconciliation_lease_expires_at?: InputMaybe<Order_By>;
  reconciliation_lease_owner?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  turn_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Whatsapp_Ai_Outbox_Part_Min_Fields = {
  __typename?: 'whatsapp_ai_outbox_part_min_fields';
  attempt_count?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dispatched_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  last_error_code?: Maybe<Scalars['String']['output']>;
  last_reconciliation_outcome?: Maybe<Scalars['String']['output']>;
  lease_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  lease_owner?: Maybe<Scalars['String']['output']>;
  part_id?: Maybe<Scalars['String']['output']>;
  part_index?: Maybe<Scalars['Int']['output']>;
  payload_hash?: Maybe<Scalars['String']['output']>;
  payload_match_hash?: Maybe<Scalars['String']['output']>;
  payload_redact_after?: Maybe<Scalars['timestamptz']['output']>;
  payload_redacted_at?: Maybe<Scalars['timestamptz']['output']>;
  provider_message_id?: Maybe<Scalars['String']['output']>;
  reconciled_at?: Maybe<Scalars['timestamptz']['output']>;
  reconciliation_attempt_count?: Maybe<Scalars['Int']['output']>;
  reconciliation_lease_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  reconciliation_lease_owner?: Maybe<Scalars['String']['output']>;
  sent_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  turn_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Min_Order_By = {
  attempt_count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dispatched_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  last_error_code?: InputMaybe<Order_By>;
  last_reconciliation_outcome?: InputMaybe<Order_By>;
  lease_expires_at?: InputMaybe<Order_By>;
  lease_owner?: InputMaybe<Order_By>;
  part_id?: InputMaybe<Order_By>;
  part_index?: InputMaybe<Order_By>;
  payload_hash?: InputMaybe<Order_By>;
  payload_match_hash?: InputMaybe<Order_By>;
  payload_redact_after?: InputMaybe<Order_By>;
  payload_redacted_at?: InputMaybe<Order_By>;
  provider_message_id?: InputMaybe<Order_By>;
  reconciled_at?: InputMaybe<Order_By>;
  reconciliation_attempt_count?: InputMaybe<Order_By>;
  reconciliation_lease_expires_at?: InputMaybe<Order_By>;
  reconciliation_lease_owner?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  turn_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Mutation_Response = {
  __typename?: 'whatsapp_ai_outbox_part_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp_Ai_Outbox_Part>;
};

/** on_conflict condition type for table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_On_Conflict = {
  constraint: Whatsapp_Ai_Outbox_Part_Constraint;
  update_columns?: Array<Whatsapp_Ai_Outbox_Part_Update_Column>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp_ai_outbox_part". */
export type Whatsapp_Ai_Outbox_Part_Order_By = {
  attempt_count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dispatched_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  last_error_code?: InputMaybe<Order_By>;
  last_reconciliation_outcome?: InputMaybe<Order_By>;
  lease_expires_at?: InputMaybe<Order_By>;
  lease_owner?: InputMaybe<Order_By>;
  part_id?: InputMaybe<Order_By>;
  part_index?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  payload_hash?: InputMaybe<Order_By>;
  payload_match_hash?: InputMaybe<Order_By>;
  payload_redact_after?: InputMaybe<Order_By>;
  payload_redacted_at?: InputMaybe<Order_By>;
  provider_message_id?: InputMaybe<Order_By>;
  reconciled_at?: InputMaybe<Order_By>;
  reconciliation_attempt_count?: InputMaybe<Order_By>;
  reconciliation_lease_expires_at?: InputMaybe<Order_By>;
  reconciliation_lease_owner?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  turn?: InputMaybe<Whatsapp_Ai_Turn_Order_By>;
  turn_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: whatsapp_ai_outbox_part */
export type Whatsapp_Ai_Outbox_Part_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Whatsapp_Ai_Outbox_Part_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "whatsapp_ai_outbox_part" */
export enum Whatsapp_Ai_Outbox_Part_Select_Column {
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DispatchedAt = 'dispatched_at',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  LastErrorCode = 'last_error_code',
  /** column name */
  LastReconciliationOutcome = 'last_reconciliation_outcome',
  /** column name */
  LeaseExpiresAt = 'lease_expires_at',
  /** column name */
  LeaseOwner = 'lease_owner',
  /** column name */
  PartId = 'part_id',
  /** column name */
  PartIndex = 'part_index',
  /** column name */
  Payload = 'payload',
  /** column name */
  PayloadHash = 'payload_hash',
  /** column name */
  PayloadMatchHash = 'payload_match_hash',
  /** column name */
  PayloadRedactAfter = 'payload_redact_after',
  /** column name */
  PayloadRedactedAt = 'payload_redacted_at',
  /** column name */
  ProviderMessageId = 'provider_message_id',
  /** column name */
  ReconciledAt = 'reconciled_at',
  /** column name */
  ReconciliationAttemptCount = 'reconciliation_attempt_count',
  /** column name */
  ReconciliationLeaseExpiresAt = 'reconciliation_lease_expires_at',
  /** column name */
  ReconciliationLeaseOwner = 'reconciliation_lease_owner',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  Status = 'status',
  /** column name */
  TurnId = 'turn_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Set_Input = {
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dispatched_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  last_error_code?: InputMaybe<Scalars['String']['input']>;
  last_reconciliation_outcome?: InputMaybe<Scalars['String']['input']>;
  lease_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lease_owner?: InputMaybe<Scalars['String']['input']>;
  part_id?: InputMaybe<Scalars['String']['input']>;
  part_index?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  payload_hash?: InputMaybe<Scalars['String']['input']>;
  payload_match_hash?: InputMaybe<Scalars['String']['input']>;
  payload_redact_after?: InputMaybe<Scalars['timestamptz']['input']>;
  payload_redacted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  provider_message_id?: InputMaybe<Scalars['String']['input']>;
  reconciled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reconciliation_attempt_count?: InputMaybe<Scalars['Int']['input']>;
  reconciliation_lease_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reconciliation_lease_owner?: InputMaybe<Scalars['String']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  turn_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Whatsapp_Ai_Outbox_Part_Stddev_Fields = {
  __typename?: 'whatsapp_ai_outbox_part_stddev_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  part_index?: Maybe<Scalars['Float']['output']>;
  reconciliation_attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Stddev_Order_By = {
  attempt_count?: InputMaybe<Order_By>;
  part_index?: InputMaybe<Order_By>;
  reconciliation_attempt_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Whatsapp_Ai_Outbox_Part_Stddev_Pop_Fields = {
  __typename?: 'whatsapp_ai_outbox_part_stddev_pop_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  part_index?: Maybe<Scalars['Float']['output']>;
  reconciliation_attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Stddev_Pop_Order_By = {
  attempt_count?: InputMaybe<Order_By>;
  part_index?: InputMaybe<Order_By>;
  reconciliation_attempt_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Whatsapp_Ai_Outbox_Part_Stddev_Samp_Fields = {
  __typename?: 'whatsapp_ai_outbox_part_stddev_samp_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  part_index?: Maybe<Scalars['Float']['output']>;
  reconciliation_attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Stddev_Samp_Order_By = {
  attempt_count?: InputMaybe<Order_By>;
  part_index?: InputMaybe<Order_By>;
  reconciliation_attempt_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp_Ai_Outbox_Part_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp_Ai_Outbox_Part_Stream_Cursor_Value_Input = {
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dispatched_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  last_error_code?: InputMaybe<Scalars['String']['input']>;
  last_reconciliation_outcome?: InputMaybe<Scalars['String']['input']>;
  lease_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lease_owner?: InputMaybe<Scalars['String']['input']>;
  part_id?: InputMaybe<Scalars['String']['input']>;
  part_index?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  payload_hash?: InputMaybe<Scalars['String']['input']>;
  payload_match_hash?: InputMaybe<Scalars['String']['input']>;
  payload_redact_after?: InputMaybe<Scalars['timestamptz']['input']>;
  payload_redacted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  provider_message_id?: InputMaybe<Scalars['String']['input']>;
  reconciled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reconciliation_attempt_count?: InputMaybe<Scalars['Int']['input']>;
  reconciliation_lease_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reconciliation_lease_owner?: InputMaybe<Scalars['String']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  turn_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Whatsapp_Ai_Outbox_Part_Sum_Fields = {
  __typename?: 'whatsapp_ai_outbox_part_sum_fields';
  attempt_count?: Maybe<Scalars['Int']['output']>;
  part_index?: Maybe<Scalars['Int']['output']>;
  reconciliation_attempt_count?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Sum_Order_By = {
  attempt_count?: InputMaybe<Order_By>;
  part_index?: InputMaybe<Order_By>;
  reconciliation_attempt_count?: InputMaybe<Order_By>;
};

/** update columns of table "whatsapp_ai_outbox_part" */
export enum Whatsapp_Ai_Outbox_Part_Update_Column {
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DispatchedAt = 'dispatched_at',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  LastErrorCode = 'last_error_code',
  /** column name */
  LastReconciliationOutcome = 'last_reconciliation_outcome',
  /** column name */
  LeaseExpiresAt = 'lease_expires_at',
  /** column name */
  LeaseOwner = 'lease_owner',
  /** column name */
  PartId = 'part_id',
  /** column name */
  PartIndex = 'part_index',
  /** column name */
  Payload = 'payload',
  /** column name */
  PayloadHash = 'payload_hash',
  /** column name */
  PayloadMatchHash = 'payload_match_hash',
  /** column name */
  PayloadRedactAfter = 'payload_redact_after',
  /** column name */
  PayloadRedactedAt = 'payload_redacted_at',
  /** column name */
  ProviderMessageId = 'provider_message_id',
  /** column name */
  ReconciledAt = 'reconciled_at',
  /** column name */
  ReconciliationAttemptCount = 'reconciliation_attempt_count',
  /** column name */
  ReconciliationLeaseExpiresAt = 'reconciliation_lease_expires_at',
  /** column name */
  ReconciliationLeaseOwner = 'reconciliation_lease_owner',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  Status = 'status',
  /** column name */
  TurnId = 'turn_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Whatsapp_Ai_Outbox_Part_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Whatsapp_Ai_Outbox_Part_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Whatsapp_Ai_Outbox_Part_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Whatsapp_Ai_Outbox_Part_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Whatsapp_Ai_Outbox_Part_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Whatsapp_Ai_Outbox_Part_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Whatsapp_Ai_Outbox_Part_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp_Ai_Outbox_Part_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp_Ai_Outbox_Part_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Whatsapp_Ai_Outbox_Part_Var_Pop_Fields = {
  __typename?: 'whatsapp_ai_outbox_part_var_pop_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  part_index?: Maybe<Scalars['Float']['output']>;
  reconciliation_attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Var_Pop_Order_By = {
  attempt_count?: InputMaybe<Order_By>;
  part_index?: InputMaybe<Order_By>;
  reconciliation_attempt_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Whatsapp_Ai_Outbox_Part_Var_Samp_Fields = {
  __typename?: 'whatsapp_ai_outbox_part_var_samp_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  part_index?: Maybe<Scalars['Float']['output']>;
  reconciliation_attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Var_Samp_Order_By = {
  attempt_count?: InputMaybe<Order_By>;
  part_index?: InputMaybe<Order_By>;
  reconciliation_attempt_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Whatsapp_Ai_Outbox_Part_Variance_Fields = {
  __typename?: 'whatsapp_ai_outbox_part_variance_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  part_index?: Maybe<Scalars['Float']['output']>;
  reconciliation_attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "whatsapp_ai_outbox_part" */
export type Whatsapp_Ai_Outbox_Part_Variance_Order_By = {
  attempt_count?: InputMaybe<Order_By>;
  part_index?: InputMaybe<Order_By>;
  reconciliation_attempt_count?: InputMaybe<Order_By>;
};

/** Durable unit of WhatsApp AI processing. Contains hashed remote identity and operational metadata, not raw message content. */
export type Whatsapp_Ai_Turn = {
  __typename?: 'whatsapp_ai_turn';
  attempt_count: Scalars['Int']['output'];
  build_version?: Maybe<Scalars['String']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  contract_version: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  deadline_at?: Maybe<Scalars['timestamptz']['output']>;
  evolution_instance: Scalars['String']['output'];
  graph_run_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  inbound_messages: Array<Whatsapp_Ai_Inbound_Message>;
  /** An aggregate relationship */
  inbound_messages_aggregate: Whatsapp_Ai_Inbound_Message_Aggregate;
  last_error_code?: Maybe<Scalars['String']['output']>;
  last_registered_at?: Maybe<Scalars['timestamptz']['output']>;
  last_registration_claimed: Scalars['Boolean']['output'];
  last_registration_outcome?: Maybe<Scalars['String']['output']>;
  lease_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  lease_owner?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['jsonb']['output'];
  metadata_redacted_at?: Maybe<Scalars['timestamptz']['output']>;
  model_policy_version?: Maybe<Scalars['String']['output']>;
  no_reply_reason?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  organization_lead?: Maybe<Organization_Leads>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  outbox_parts: Array<Whatsapp_Ai_Outbox_Part>;
  /** An aggregate relationship */
  outbox_parts_aggregate: Whatsapp_Ai_Outbox_Part_Aggregate;
  outcome?: Maybe<Scalars['String']['output']>;
  registration_count: Scalars['Int']['output'];
  remote_identity_hash: Scalars['String']['output'];
  retention_expires_at: Scalars['timestamptz']['output'];
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  status: Scalars['String']['output'];
  thread_id: Scalars['String']['output'];
  turn_inbound_at: Scalars['timestamptz']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** Durable unit of WhatsApp AI processing. Contains hashed remote identity and operational metadata, not raw message content. */
export type Whatsapp_Ai_TurnInbound_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Inbound_Message_Bool_Exp>;
};


/** Durable unit of WhatsApp AI processing. Contains hashed remote identity and operational metadata, not raw message content. */
export type Whatsapp_Ai_TurnInbound_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Inbound_Message_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Inbound_Message_Bool_Exp>;
};


/** Durable unit of WhatsApp AI processing. Contains hashed remote identity and operational metadata, not raw message content. */
export type Whatsapp_Ai_TurnMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Durable unit of WhatsApp AI processing. Contains hashed remote identity and operational metadata, not raw message content. */
export type Whatsapp_Ai_TurnOutbox_PartsArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};


/** Durable unit of WhatsApp AI processing. Contains hashed remote identity and operational metadata, not raw message content. */
export type Whatsapp_Ai_TurnOutbox_Parts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whatsapp_Ai_Outbox_Part_Order_By>>;
  where?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
};

/** aggregated selection of "whatsapp_ai_turn" */
export type Whatsapp_Ai_Turn_Aggregate = {
  __typename?: 'whatsapp_ai_turn_aggregate';
  aggregate?: Maybe<Whatsapp_Ai_Turn_Aggregate_Fields>;
  nodes: Array<Whatsapp_Ai_Turn>;
};

/** aggregate fields of "whatsapp_ai_turn" */
export type Whatsapp_Ai_Turn_Aggregate_Fields = {
  __typename?: 'whatsapp_ai_turn_aggregate_fields';
  avg?: Maybe<Whatsapp_Ai_Turn_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Whatsapp_Ai_Turn_Max_Fields>;
  min?: Maybe<Whatsapp_Ai_Turn_Min_Fields>;
  stddev?: Maybe<Whatsapp_Ai_Turn_Stddev_Fields>;
  stddev_pop?: Maybe<Whatsapp_Ai_Turn_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Whatsapp_Ai_Turn_Stddev_Samp_Fields>;
  sum?: Maybe<Whatsapp_Ai_Turn_Sum_Fields>;
  var_pop?: Maybe<Whatsapp_Ai_Turn_Var_Pop_Fields>;
  var_samp?: Maybe<Whatsapp_Ai_Turn_Var_Samp_Fields>;
  variance?: Maybe<Whatsapp_Ai_Turn_Variance_Fields>;
};


/** aggregate fields of "whatsapp_ai_turn" */
export type Whatsapp_Ai_Turn_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp_Ai_Turn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Whatsapp_Ai_Turn_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Whatsapp_Ai_Turn_Avg_Fields = {
  __typename?: 'whatsapp_ai_turn_avg_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  contract_version?: Maybe<Scalars['Float']['output']>;
  registration_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "whatsapp_ai_turn". All fields are combined with a logical 'AND'. */
export type Whatsapp_Ai_Turn_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsapp_Ai_Turn_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp_Ai_Turn_Bool_Exp>>;
  attempt_count?: InputMaybe<Int_Comparison_Exp>;
  build_version?: InputMaybe<String_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  contract_version?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deadline_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  evolution_instance?: InputMaybe<String_Comparison_Exp>;
  graph_run_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inbound_messages?: InputMaybe<Whatsapp_Ai_Inbound_Message_Bool_Exp>;
  inbound_messages_aggregate?: InputMaybe<Whatsapp_Ai_Inbound_Message_Aggregate_Bool_Exp>;
  last_error_code?: InputMaybe<String_Comparison_Exp>;
  last_registered_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_registration_claimed?: InputMaybe<Boolean_Comparison_Exp>;
  last_registration_outcome?: InputMaybe<String_Comparison_Exp>;
  lease_expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lease_owner?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  metadata_redacted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  model_policy_version?: InputMaybe<String_Comparison_Exp>;
  no_reply_reason?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_lead?: InputMaybe<Organization_Leads_Bool_Exp>;
  organization_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  outbox_parts?: InputMaybe<Whatsapp_Ai_Outbox_Part_Bool_Exp>;
  outbox_parts_aggregate?: InputMaybe<Whatsapp_Ai_Outbox_Part_Aggregate_Bool_Exp>;
  outcome?: InputMaybe<String_Comparison_Exp>;
  registration_count?: InputMaybe<Int_Comparison_Exp>;
  remote_identity_hash?: InputMaybe<String_Comparison_Exp>;
  retention_expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  started_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  thread_id?: InputMaybe<String_Comparison_Exp>;
  turn_inbound_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "whatsapp_ai_turn" */
export enum Whatsapp_Ai_Turn_Constraint {
  /** unique or primary key constraint on columns "id", "organization_id" */
  WhatsappAiTurnIdOrganizationIdKey = 'whatsapp_ai_turn_id_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  WhatsappAiTurnPkey = 'whatsapp_ai_turn_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Whatsapp_Ai_Turn_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Whatsapp_Ai_Turn_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Whatsapp_Ai_Turn_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "whatsapp_ai_turn" */
export type Whatsapp_Ai_Turn_Inc_Input = {
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  contract_version?: InputMaybe<Scalars['Int']['input']>;
  registration_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "whatsapp_ai_turn" */
export type Whatsapp_Ai_Turn_Insert_Input = {
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  build_version?: InputMaybe<Scalars['String']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  contract_version?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deadline_at?: InputMaybe<Scalars['timestamptz']['input']>;
  evolution_instance?: InputMaybe<Scalars['String']['input']>;
  graph_run_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inbound_messages?: InputMaybe<Whatsapp_Ai_Inbound_Message_Arr_Rel_Insert_Input>;
  last_error_code?: InputMaybe<Scalars['String']['input']>;
  last_registered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_registration_claimed?: InputMaybe<Scalars['Boolean']['input']>;
  last_registration_outcome?: InputMaybe<Scalars['String']['input']>;
  lease_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lease_owner?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  metadata_redacted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  model_policy_version?: InputMaybe<Scalars['String']['input']>;
  no_reply_reason?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_lead?: InputMaybe<Organization_Leads_Obj_Rel_Insert_Input>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  outbox_parts?: InputMaybe<Whatsapp_Ai_Outbox_Part_Arr_Rel_Insert_Input>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  registration_count?: InputMaybe<Scalars['Int']['input']>;
  remote_identity_hash?: InputMaybe<Scalars['String']['input']>;
  retention_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  thread_id?: InputMaybe<Scalars['String']['input']>;
  turn_inbound_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Whatsapp_Ai_Turn_Max_Fields = {
  __typename?: 'whatsapp_ai_turn_max_fields';
  attempt_count?: Maybe<Scalars['Int']['output']>;
  build_version?: Maybe<Scalars['String']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  contract_version?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deadline_at?: Maybe<Scalars['timestamptz']['output']>;
  evolution_instance?: Maybe<Scalars['String']['output']>;
  graph_run_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_error_code?: Maybe<Scalars['String']['output']>;
  last_registered_at?: Maybe<Scalars['timestamptz']['output']>;
  last_registration_outcome?: Maybe<Scalars['String']['output']>;
  lease_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  lease_owner?: Maybe<Scalars['String']['output']>;
  metadata_redacted_at?: Maybe<Scalars['timestamptz']['output']>;
  model_policy_version?: Maybe<Scalars['String']['output']>;
  no_reply_reason?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  registration_count?: Maybe<Scalars['Int']['output']>;
  remote_identity_hash?: Maybe<Scalars['String']['output']>;
  retention_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  thread_id?: Maybe<Scalars['String']['output']>;
  turn_inbound_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Whatsapp_Ai_Turn_Min_Fields = {
  __typename?: 'whatsapp_ai_turn_min_fields';
  attempt_count?: Maybe<Scalars['Int']['output']>;
  build_version?: Maybe<Scalars['String']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  contract_version?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deadline_at?: Maybe<Scalars['timestamptz']['output']>;
  evolution_instance?: Maybe<Scalars['String']['output']>;
  graph_run_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_error_code?: Maybe<Scalars['String']['output']>;
  last_registered_at?: Maybe<Scalars['timestamptz']['output']>;
  last_registration_outcome?: Maybe<Scalars['String']['output']>;
  lease_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  lease_owner?: Maybe<Scalars['String']['output']>;
  metadata_redacted_at?: Maybe<Scalars['timestamptz']['output']>;
  model_policy_version?: Maybe<Scalars['String']['output']>;
  no_reply_reason?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_lead_id?: Maybe<Scalars['uuid']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  registration_count?: Maybe<Scalars['Int']['output']>;
  remote_identity_hash?: Maybe<Scalars['String']['output']>;
  retention_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  thread_id?: Maybe<Scalars['String']['output']>;
  turn_inbound_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "whatsapp_ai_turn" */
export type Whatsapp_Ai_Turn_Mutation_Response = {
  __typename?: 'whatsapp_ai_turn_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp_Ai_Turn>;
};

/** input type for inserting object relation for remote table "whatsapp_ai_turn" */
export type Whatsapp_Ai_Turn_Obj_Rel_Insert_Input = {
  data: Whatsapp_Ai_Turn_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Whatsapp_Ai_Turn_On_Conflict>;
};

/** on_conflict condition type for table "whatsapp_ai_turn" */
export type Whatsapp_Ai_Turn_On_Conflict = {
  constraint: Whatsapp_Ai_Turn_Constraint;
  update_columns?: Array<Whatsapp_Ai_Turn_Update_Column>;
  where?: InputMaybe<Whatsapp_Ai_Turn_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp_ai_turn". */
export type Whatsapp_Ai_Turn_Order_By = {
  attempt_count?: InputMaybe<Order_By>;
  build_version?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  contract_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deadline_at?: InputMaybe<Order_By>;
  evolution_instance?: InputMaybe<Order_By>;
  graph_run_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inbound_messages_aggregate?: InputMaybe<Whatsapp_Ai_Inbound_Message_Aggregate_Order_By>;
  last_error_code?: InputMaybe<Order_By>;
  last_registered_at?: InputMaybe<Order_By>;
  last_registration_claimed?: InputMaybe<Order_By>;
  last_registration_outcome?: InputMaybe<Order_By>;
  lease_expires_at?: InputMaybe<Order_By>;
  lease_owner?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  metadata_redacted_at?: InputMaybe<Order_By>;
  model_policy_version?: InputMaybe<Order_By>;
  no_reply_reason?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_lead?: InputMaybe<Organization_Leads_Order_By>;
  organization_lead_id?: InputMaybe<Order_By>;
  outbox_parts_aggregate?: InputMaybe<Whatsapp_Ai_Outbox_Part_Aggregate_Order_By>;
  outcome?: InputMaybe<Order_By>;
  registration_count?: InputMaybe<Order_By>;
  remote_identity_hash?: InputMaybe<Order_By>;
  retention_expires_at?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  turn_inbound_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: whatsapp_ai_turn */
export type Whatsapp_Ai_Turn_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Whatsapp_Ai_Turn_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "whatsapp_ai_turn" */
export enum Whatsapp_Ai_Turn_Select_Column {
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  BuildVersion = 'build_version',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  ContractVersion = 'contract_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeadlineAt = 'deadline_at',
  /** column name */
  EvolutionInstance = 'evolution_instance',
  /** column name */
  GraphRunId = 'graph_run_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastErrorCode = 'last_error_code',
  /** column name */
  LastRegisteredAt = 'last_registered_at',
  /** column name */
  LastRegistrationClaimed = 'last_registration_claimed',
  /** column name */
  LastRegistrationOutcome = 'last_registration_outcome',
  /** column name */
  LeaseExpiresAt = 'lease_expires_at',
  /** column name */
  LeaseOwner = 'lease_owner',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MetadataRedactedAt = 'metadata_redacted_at',
  /** column name */
  ModelPolicyVersion = 'model_policy_version',
  /** column name */
  NoReplyReason = 'no_reply_reason',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationLeadId = 'organization_lead_id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  RegistrationCount = 'registration_count',
  /** column name */
  RemoteIdentityHash = 'remote_identity_hash',
  /** column name */
  RetentionExpiresAt = 'retention_expires_at',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  Status = 'status',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  TurnInboundAt = 'turn_inbound_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "whatsapp_ai_turn" */
export type Whatsapp_Ai_Turn_Set_Input = {
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  build_version?: InputMaybe<Scalars['String']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  contract_version?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deadline_at?: InputMaybe<Scalars['timestamptz']['input']>;
  evolution_instance?: InputMaybe<Scalars['String']['input']>;
  graph_run_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_error_code?: InputMaybe<Scalars['String']['input']>;
  last_registered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_registration_claimed?: InputMaybe<Scalars['Boolean']['input']>;
  last_registration_outcome?: InputMaybe<Scalars['String']['input']>;
  lease_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lease_owner?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  metadata_redacted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  model_policy_version?: InputMaybe<Scalars['String']['input']>;
  no_reply_reason?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  registration_count?: InputMaybe<Scalars['Int']['input']>;
  remote_identity_hash?: InputMaybe<Scalars['String']['input']>;
  retention_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  thread_id?: InputMaybe<Scalars['String']['input']>;
  turn_inbound_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Whatsapp_Ai_Turn_Stddev_Fields = {
  __typename?: 'whatsapp_ai_turn_stddev_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  contract_version?: Maybe<Scalars['Float']['output']>;
  registration_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Whatsapp_Ai_Turn_Stddev_Pop_Fields = {
  __typename?: 'whatsapp_ai_turn_stddev_pop_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  contract_version?: Maybe<Scalars['Float']['output']>;
  registration_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Whatsapp_Ai_Turn_Stddev_Samp_Fields = {
  __typename?: 'whatsapp_ai_turn_stddev_samp_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  contract_version?: Maybe<Scalars['Float']['output']>;
  registration_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "whatsapp_ai_turn" */
export type Whatsapp_Ai_Turn_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp_Ai_Turn_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp_Ai_Turn_Stream_Cursor_Value_Input = {
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  build_version?: InputMaybe<Scalars['String']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  contract_version?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deadline_at?: InputMaybe<Scalars['timestamptz']['input']>;
  evolution_instance?: InputMaybe<Scalars['String']['input']>;
  graph_run_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_error_code?: InputMaybe<Scalars['String']['input']>;
  last_registered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_registration_claimed?: InputMaybe<Scalars['Boolean']['input']>;
  last_registration_outcome?: InputMaybe<Scalars['String']['input']>;
  lease_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lease_owner?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  metadata_redacted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  model_policy_version?: InputMaybe<Scalars['String']['input']>;
  no_reply_reason?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  registration_count?: InputMaybe<Scalars['Int']['input']>;
  remote_identity_hash?: InputMaybe<Scalars['String']['input']>;
  retention_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  thread_id?: InputMaybe<Scalars['String']['input']>;
  turn_inbound_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Whatsapp_Ai_Turn_Sum_Fields = {
  __typename?: 'whatsapp_ai_turn_sum_fields';
  attempt_count?: Maybe<Scalars['Int']['output']>;
  contract_version?: Maybe<Scalars['Int']['output']>;
  registration_count?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "whatsapp_ai_turn" */
export enum Whatsapp_Ai_Turn_Update_Column {
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  BuildVersion = 'build_version',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  ContractVersion = 'contract_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeadlineAt = 'deadline_at',
  /** column name */
  EvolutionInstance = 'evolution_instance',
  /** column name */
  GraphRunId = 'graph_run_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastErrorCode = 'last_error_code',
  /** column name */
  LastRegisteredAt = 'last_registered_at',
  /** column name */
  LastRegistrationClaimed = 'last_registration_claimed',
  /** column name */
  LastRegistrationOutcome = 'last_registration_outcome',
  /** column name */
  LeaseExpiresAt = 'lease_expires_at',
  /** column name */
  LeaseOwner = 'lease_owner',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MetadataRedactedAt = 'metadata_redacted_at',
  /** column name */
  ModelPolicyVersion = 'model_policy_version',
  /** column name */
  NoReplyReason = 'no_reply_reason',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationLeadId = 'organization_lead_id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  RegistrationCount = 'registration_count',
  /** column name */
  RemoteIdentityHash = 'remote_identity_hash',
  /** column name */
  RetentionExpiresAt = 'retention_expires_at',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  Status = 'status',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  TurnInboundAt = 'turn_inbound_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Whatsapp_Ai_Turn_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Whatsapp_Ai_Turn_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Whatsapp_Ai_Turn_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Whatsapp_Ai_Turn_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Whatsapp_Ai_Turn_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Whatsapp_Ai_Turn_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Whatsapp_Ai_Turn_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp_Ai_Turn_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp_Ai_Turn_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Whatsapp_Ai_Turn_Var_Pop_Fields = {
  __typename?: 'whatsapp_ai_turn_var_pop_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  contract_version?: Maybe<Scalars['Float']['output']>;
  registration_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Whatsapp_Ai_Turn_Var_Samp_Fields = {
  __typename?: 'whatsapp_ai_turn_var_samp_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  contract_version?: Maybe<Scalars['Float']['output']>;
  registration_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Whatsapp_Ai_Turn_Variance_Fields = {
  __typename?: 'whatsapp_ai_turn_variance_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
  contract_version?: Maybe<Scalars['Float']['output']>;
  registration_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "whatsapp_chat" */
export type Whatsapp_Chat = {
  __typename?: 'whatsapp_chat';
  created_at: Scalars['timestamptz']['output'];
  from: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  message: Scalars['String']['output'];
  session_id: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  whatsapp_id: Scalars['String']['output'];
};

/** aggregated selection of "whatsapp_chat" */
export type Whatsapp_Chat_Aggregate = {
  __typename?: 'whatsapp_chat_aggregate';
  aggregate?: Maybe<Whatsapp_Chat_Aggregate_Fields>;
  nodes: Array<Whatsapp_Chat>;
};

/** aggregate fields of "whatsapp_chat" */
export type Whatsapp_Chat_Aggregate_Fields = {
  __typename?: 'whatsapp_chat_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Whatsapp_Chat_Max_Fields>;
  min?: Maybe<Whatsapp_Chat_Min_Fields>;
};


/** aggregate fields of "whatsapp_chat" */
export type Whatsapp_Chat_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp_Chat_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "whatsapp_chat". All fields are combined with a logical 'AND'. */
export type Whatsapp_Chat_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsapp_Chat_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp_Chat_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  from?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  whatsapp_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "whatsapp_chat" */
export enum Whatsapp_Chat_Constraint {
  /** unique or primary key constraint on columns "id" */
  WhatsappChatPkey = 'whatsapp_chat_pkey',
  /** unique or primary key constraint on columns "session_id" */
  WhatsappChatSessionIdKey = 'whatsapp_chat_session_id_key'
}

/** input type for inserting data into table "whatsapp_chat" */
export type Whatsapp_Chat_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  whatsapp_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Whatsapp_Chat_Max_Fields = {
  __typename?: 'whatsapp_chat_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whatsapp_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Whatsapp_Chat_Min_Fields = {
  __typename?: 'whatsapp_chat_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whatsapp_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "whatsapp_chat" */
export type Whatsapp_Chat_Mutation_Response = {
  __typename?: 'whatsapp_chat_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp_Chat>;
};

/** on_conflict condition type for table "whatsapp_chat" */
export type Whatsapp_Chat_On_Conflict = {
  constraint: Whatsapp_Chat_Constraint;
  update_columns?: Array<Whatsapp_Chat_Update_Column>;
  where?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp_chat". */
export type Whatsapp_Chat_Order_By = {
  created_at?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whatsapp_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: whatsapp_chat */
export type Whatsapp_Chat_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "whatsapp_chat" */
export enum Whatsapp_Chat_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  From = 'from',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WhatsappId = 'whatsapp_id'
}

/** input type for updating data in table "whatsapp_chat" */
export type Whatsapp_Chat_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  whatsapp_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "whatsapp_chat" */
export type Whatsapp_Chat_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp_Chat_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp_Chat_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  whatsapp_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "whatsapp_chat" */
export enum Whatsapp_Chat_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  From = 'from',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WhatsappId = 'whatsapp_id'
}

export type Whatsapp_Chat_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp_Chat_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp_Chat_Bool_Exp;
};

/** columns and relationships of "whatsapp_human" */
export type Whatsapp_Human = {
  __typename?: 'whatsapp_human';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  resolved: Scalars['Boolean']['output'];
  session_id: Scalars['String']['output'];
  summary_convo?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_question: Scalars['String']['output'];
};

/** aggregated selection of "whatsapp_human" */
export type Whatsapp_Human_Aggregate = {
  __typename?: 'whatsapp_human_aggregate';
  aggregate?: Maybe<Whatsapp_Human_Aggregate_Fields>;
  nodes: Array<Whatsapp_Human>;
};

/** aggregate fields of "whatsapp_human" */
export type Whatsapp_Human_Aggregate_Fields = {
  __typename?: 'whatsapp_human_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Whatsapp_Human_Max_Fields>;
  min?: Maybe<Whatsapp_Human_Min_Fields>;
};


/** aggregate fields of "whatsapp_human" */
export type Whatsapp_Human_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp_Human_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "whatsapp_human". All fields are combined with a logical 'AND'. */
export type Whatsapp_Human_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsapp_Human_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp_Human_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp_Human_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  resolved?: InputMaybe<Boolean_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  summary_convo?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_question?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "whatsapp_human" */
export enum Whatsapp_Human_Constraint {
  /** unique or primary key constraint on columns "id" */
  WhatsappHumanPkey = 'whatsapp_human_pkey'
}

/** input type for inserting data into table "whatsapp_human" */
export type Whatsapp_Human_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  summary_convo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_question?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Whatsapp_Human_Max_Fields = {
  __typename?: 'whatsapp_human_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  summary_convo?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_question?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Whatsapp_Human_Min_Fields = {
  __typename?: 'whatsapp_human_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  summary_convo?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_question?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "whatsapp_human" */
export type Whatsapp_Human_Mutation_Response = {
  __typename?: 'whatsapp_human_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp_Human>;
};

/** on_conflict condition type for table "whatsapp_human" */
export type Whatsapp_Human_On_Conflict = {
  constraint: Whatsapp_Human_Constraint;
  update_columns?: Array<Whatsapp_Human_Update_Column>;
  where?: InputMaybe<Whatsapp_Human_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp_human". */
export type Whatsapp_Human_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resolved?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  summary_convo?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_question?: InputMaybe<Order_By>;
};

/** primary key columns input for table: whatsapp_human */
export type Whatsapp_Human_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "whatsapp_human" */
export enum Whatsapp_Human_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Resolved = 'resolved',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  SummaryConvo = 'summary_convo',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserQuestion = 'user_question'
}

/** input type for updating data in table "whatsapp_human" */
export type Whatsapp_Human_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  summary_convo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_question?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "whatsapp_human" */
export type Whatsapp_Human_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp_Human_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp_Human_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  summary_convo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_question?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "whatsapp_human" */
export enum Whatsapp_Human_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Resolved = 'resolved',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  SummaryConvo = 'summary_convo',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserQuestion = 'user_question'
}

export type Whatsapp_Human_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp_Human_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp_Human_Bool_Exp;
};

/** Spatial containment edges between city_zone nodes */
export type Zone_Contains = {
  __typename?: 'zone_contains';
  /** Contained zone (e.g. street/sub-area) */
  contained_id: Scalars['uuid']['output'];
  /** An object relationship */
  contained_zone: City_Zone;
  /** Containing zone (e.g. neighborhood/region) */
  container_id: Scalars['uuid']['output'];
  /** An object relationship */
  container_zone: City_Zone;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: Maybe<Scalars['float8']['output']>;
  /** Origin of the edge: PIPELINE, IMPORT_YYYY_MM, MANUAL, EVENT_TRIGGER */
  source?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "zone_contains" */
export type Zone_Contains_Aggregate = {
  __typename?: 'zone_contains_aggregate';
  aggregate?: Maybe<Zone_Contains_Aggregate_Fields>;
  nodes: Array<Zone_Contains>;
};

/** aggregate fields of "zone_contains" */
export type Zone_Contains_Aggregate_Fields = {
  __typename?: 'zone_contains_aggregate_fields';
  avg?: Maybe<Zone_Contains_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Zone_Contains_Max_Fields>;
  min?: Maybe<Zone_Contains_Min_Fields>;
  stddev?: Maybe<Zone_Contains_Stddev_Fields>;
  stddev_pop?: Maybe<Zone_Contains_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Zone_Contains_Stddev_Samp_Fields>;
  sum?: Maybe<Zone_Contains_Sum_Fields>;
  var_pop?: Maybe<Zone_Contains_Var_Pop_Fields>;
  var_samp?: Maybe<Zone_Contains_Var_Samp_Fields>;
  variance?: Maybe<Zone_Contains_Variance_Fields>;
};


/** aggregate fields of "zone_contains" */
export type Zone_Contains_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Zone_Contains_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Zone_Contains_Avg_Fields = {
  __typename?: 'zone_contains_avg_fields';
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "zone_contains". All fields are combined with a logical 'AND'. */
export type Zone_Contains_Bool_Exp = {
  _and?: InputMaybe<Array<Zone_Contains_Bool_Exp>>;
  _not?: InputMaybe<Zone_Contains_Bool_Exp>;
  _or?: InputMaybe<Array<Zone_Contains_Bool_Exp>>;
  contained_id?: InputMaybe<Uuid_Comparison_Exp>;
  contained_zone?: InputMaybe<City_Zone_Bool_Exp>;
  container_id?: InputMaybe<Uuid_Comparison_Exp>;
  container_zone?: InputMaybe<City_Zone_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  overlap_ratio?: InputMaybe<Float8_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "zone_contains" */
export enum Zone_Contains_Constraint {
  /** unique or primary key constraint on columns "id" */
  ZoneContainsPkey = 'zone_contains_pkey',
  /** unique or primary key constraint on columns "container_id", "contained_id" */
  ZoneContainsUnique = 'zone_contains_unique'
}

/** input type for incrementing numeric columns in table "zone_contains" */
export type Zone_Contains_Inc_Input = {
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "zone_contains" */
export type Zone_Contains_Insert_Input = {
  /** Contained zone (e.g. street/sub-area) */
  contained_id?: InputMaybe<Scalars['uuid']['input']>;
  contained_zone?: InputMaybe<City_Zone_Obj_Rel_Insert_Input>;
  /** Containing zone (e.g. neighborhood/region) */
  container_id?: InputMaybe<Scalars['uuid']['input']>;
  container_zone?: InputMaybe<City_Zone_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: InputMaybe<Scalars['float8']['input']>;
  /** Origin of the edge: PIPELINE, IMPORT_YYYY_MM, MANUAL, EVENT_TRIGGER */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Zone_Contains_Max_Fields = {
  __typename?: 'zone_contains_max_fields';
  /** Contained zone (e.g. street/sub-area) */
  contained_id?: Maybe<Scalars['uuid']['output']>;
  /** Containing zone (e.g. neighborhood/region) */
  container_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: Maybe<Scalars['float8']['output']>;
  /** Origin of the edge: PIPELINE, IMPORT_YYYY_MM, MANUAL, EVENT_TRIGGER */
  source?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Zone_Contains_Min_Fields = {
  __typename?: 'zone_contains_min_fields';
  /** Contained zone (e.g. street/sub-area) */
  contained_id?: Maybe<Scalars['uuid']['output']>;
  /** Containing zone (e.g. neighborhood/region) */
  container_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: Maybe<Scalars['float8']['output']>;
  /** Origin of the edge: PIPELINE, IMPORT_YYYY_MM, MANUAL, EVENT_TRIGGER */
  source?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "zone_contains" */
export type Zone_Contains_Mutation_Response = {
  __typename?: 'zone_contains_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Zone_Contains>;
};

/** on_conflict condition type for table "zone_contains" */
export type Zone_Contains_On_Conflict = {
  constraint: Zone_Contains_Constraint;
  update_columns?: Array<Zone_Contains_Update_Column>;
  where?: InputMaybe<Zone_Contains_Bool_Exp>;
};

/** Ordering options when selecting data from "zone_contains". */
export type Zone_Contains_Order_By = {
  contained_id?: InputMaybe<Order_By>;
  contained_zone?: InputMaybe<City_Zone_Order_By>;
  container_id?: InputMaybe<Order_By>;
  container_zone?: InputMaybe<City_Zone_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  overlap_ratio?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: zone_contains */
export type Zone_Contains_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "zone_contains" */
export enum Zone_Contains_Select_Column {
  /** column name */
  ContainedId = 'contained_id',
  /** column name */
  ContainerId = 'container_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OverlapRatio = 'overlap_ratio',
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "zone_contains" */
export type Zone_Contains_Set_Input = {
  /** Contained zone (e.g. street/sub-area) */
  contained_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Containing zone (e.g. neighborhood/region) */
  container_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: InputMaybe<Scalars['float8']['input']>;
  /** Origin of the edge: PIPELINE, IMPORT_YYYY_MM, MANUAL, EVENT_TRIGGER */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Zone_Contains_Stddev_Fields = {
  __typename?: 'zone_contains_stddev_fields';
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Zone_Contains_Stddev_Pop_Fields = {
  __typename?: 'zone_contains_stddev_pop_fields';
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Zone_Contains_Stddev_Samp_Fields = {
  __typename?: 'zone_contains_stddev_samp_fields';
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "zone_contains" */
export type Zone_Contains_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Zone_Contains_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Zone_Contains_Stream_Cursor_Value_Input = {
  /** Contained zone (e.g. street/sub-area) */
  contained_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Containing zone (e.g. neighborhood/region) */
  container_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: InputMaybe<Scalars['float8']['input']>;
  /** Origin of the edge: PIPELINE, IMPORT_YYYY_MM, MANUAL, EVENT_TRIGGER */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Zone_Contains_Sum_Fields = {
  __typename?: 'zone_contains_sum_fields';
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "zone_contains" */
export enum Zone_Contains_Update_Column {
  /** column name */
  ContainedId = 'contained_id',
  /** column name */
  ContainerId = 'container_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OverlapRatio = 'overlap_ratio',
  /** column name */
  Source = 'source'
}

export type Zone_Contains_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Zone_Contains_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Zone_Contains_Set_Input>;
  /** filter the rows which have to be updated */
  where: Zone_Contains_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Zone_Contains_Var_Pop_Fields = {
  __typename?: 'zone_contains_var_pop_fields';
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Zone_Contains_Var_Samp_Fields = {
  __typename?: 'zone_contains_var_samp_fields';
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Zone_Contains_Variance_Fields = {
  __typename?: 'zone_contains_variance_fields';
  /** Area(child ∩ container) / Area(child) */
  overlap_ratio?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "zone_data_method" */
export type Zone_Data_Method = {
  __typename?: 'zone_data_method';
  method: Scalars['String']['output'];
};

/** aggregated selection of "zone_data_method" */
export type Zone_Data_Method_Aggregate = {
  __typename?: 'zone_data_method_aggregate';
  aggregate?: Maybe<Zone_Data_Method_Aggregate_Fields>;
  nodes: Array<Zone_Data_Method>;
};

/** aggregate fields of "zone_data_method" */
export type Zone_Data_Method_Aggregate_Fields = {
  __typename?: 'zone_data_method_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Zone_Data_Method_Max_Fields>;
  min?: Maybe<Zone_Data_Method_Min_Fields>;
};


/** aggregate fields of "zone_data_method" */
export type Zone_Data_Method_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Zone_Data_Method_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "zone_data_method". All fields are combined with a logical 'AND'. */
export type Zone_Data_Method_Bool_Exp = {
  _and?: InputMaybe<Array<Zone_Data_Method_Bool_Exp>>;
  _not?: InputMaybe<Zone_Data_Method_Bool_Exp>;
  _or?: InputMaybe<Array<Zone_Data_Method_Bool_Exp>>;
  method?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "zone_data_method" */
export enum Zone_Data_Method_Constraint {
  /** unique or primary key constraint on columns "method" */
  ZoneDataMethodPkey = 'zone_data_method_pkey'
}

export enum Zone_Data_Method_Enum {
  Custom = 'custom',
  GoogleMapsGeocodingApi = 'google_maps_geocoding_api',
  GoogleMapsPlacesApi = 'google_maps_places_api'
}

/** Boolean expression to compare columns of type "zone_data_method_enum". All fields are combined with logical 'AND'. */
export type Zone_Data_Method_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Zone_Data_Method_Enum>;
  _in?: InputMaybe<Array<Zone_Data_Method_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Zone_Data_Method_Enum>;
  _nin?: InputMaybe<Array<Zone_Data_Method_Enum>>;
};

/** input type for inserting data into table "zone_data_method" */
export type Zone_Data_Method_Insert_Input = {
  method?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Zone_Data_Method_Max_Fields = {
  __typename?: 'zone_data_method_max_fields';
  method?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Zone_Data_Method_Min_Fields = {
  __typename?: 'zone_data_method_min_fields';
  method?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "zone_data_method" */
export type Zone_Data_Method_Mutation_Response = {
  __typename?: 'zone_data_method_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Zone_Data_Method>;
};

/** input type for inserting object relation for remote table "zone_data_method" */
export type Zone_Data_Method_Obj_Rel_Insert_Input = {
  data: Zone_Data_Method_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Zone_Data_Method_On_Conflict>;
};

/** on_conflict condition type for table "zone_data_method" */
export type Zone_Data_Method_On_Conflict = {
  constraint: Zone_Data_Method_Constraint;
  update_columns?: Array<Zone_Data_Method_Update_Column>;
  where?: InputMaybe<Zone_Data_Method_Bool_Exp>;
};

/** Ordering options when selecting data from "zone_data_method". */
export type Zone_Data_Method_Order_By = {
  method?: InputMaybe<Order_By>;
};

/** primary key columns input for table: zone_data_method */
export type Zone_Data_Method_Pk_Columns_Input = {
  method: Scalars['String']['input'];
};

/** select columns of table "zone_data_method" */
export enum Zone_Data_Method_Select_Column {
  /** column name */
  Method = 'method'
}

/** input type for updating data in table "zone_data_method" */
export type Zone_Data_Method_Set_Input = {
  method?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "zone_data_method" */
export type Zone_Data_Method_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Zone_Data_Method_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Zone_Data_Method_Stream_Cursor_Value_Input = {
  method?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "zone_data_method" */
export enum Zone_Data_Method_Update_Column {
  /** column name */
  Method = 'method'
}

export type Zone_Data_Method_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Zone_Data_Method_Set_Input>;
  /** filter the rows which have to be updated */
  where: Zone_Data_Method_Bool_Exp;
};

export type BlogPostFragment = { __typename?: 'blog_post', id: any, author: string, colorPalette?: string | null, created_at: any, metaDescription?: string | null, publishDate?: string | null, readingTime?: string | null, targetAudience?: string | null, title: string, tone?: string | null, updated_at: any, tags?: any | null, sections: Array<{ __typename?: 'blog_section', id: any, type: string, heading?: string | null, content?: string | null, imageUrl?: string | null, imageAlt?: string | null, imageCaption?: string | null }> };

export type OrganizationFragmentFragment = { __typename?: 'organization', id: any, type?: Organization_Type_Enum | null, display_name: string, origin?: string | null, slug?: string | null, description?: string | null, phone_number?: string | null, email?: string | null, profile_image_url?: string | null, subscriptions: Array<{ __typename?: 'subscription', start_date: any, end_date: any, active: boolean, plan: { __typename?: 'plan', id: any, name: string, description: string, type?: Plan_Type_Enum | null } }>, properties_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null }, user_organizations: Array<{ __typename?: 'user_organization', id: any, role?: Organization_Role_Enum | null, user: { __typename?: 'users', avatarUrl: string, displayName: string, id: any } }> };

export type UpdateCityZoneByPkMutationVariables = Exact<{
  set?: InputMaybe<City_Zone_Set_Input>;
  id: Scalars['uuid']['input'];
}>;


export type UpdateCityZoneByPkMutation = { __typename?: 'mutation_root', update_city_zone_by_pk?: { __typename?: 'city_zone', id: any, bounds?: any | null, created_at?: any | null, formatted_address?: string | null, location?: any | null, location_type?: string | null, place_id?: string | null, data_method?: Zone_Data_Method_Enum | null, surface_area?: any | null, types?: any | null, updated_at?: any | null, viewport?: any | null, zone_name: string, city: { __typename?: 'city', city_name: string } } | null };

export type UpdateLocationByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Location_Set_Input;
}>;


export type UpdateLocationByPkMutation = { __typename?: 'mutation_root', update_location_by_pk?: { __typename?: 'location', id: any } | null };

export type ApprovePlaceReferenceProposalMutationVariables = Exact<{
  proposalId: Scalars['uuid']['input'];
  reviewer?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApprovePlaceReferenceProposalMutation = { __typename?: 'mutation_root', approve_place_reference_proposal: Array<{ __typename?: 'place_reference', id: any, canonical_name: string, kind: string }> };

export type RejectPlaceReferenceProposalMutationVariables = Exact<{
  proposalId: Scalars['uuid']['input'];
  reviewer?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  reviewedAt: Scalars['timestamptz']['input'];
}>;


export type RejectPlaceReferenceProposalMutation = { __typename?: 'mutation_root', update_place_reference_proposal_by_pk?: { __typename?: 'place_reference_proposal', id: any, status: string } | null };

export type UpdatePlaceReferenceProposalMutationVariables = Exact<{
  proposalId: Scalars['uuid']['input'];
  set: Place_Reference_Proposal_Set_Input;
}>;


export type UpdatePlaceReferenceProposalMutation = { __typename?: 'mutation_root', update_place_reference_proposal_by_pk?: { __typename?: 'place_reference_proposal', id: any, canonical_name: string, kind: string, parent_city_zone_id?: any | null, default_radius_m?: number | null } | null };

export type UpdayePropertyVisibilityMutationVariables = Exact<{
  visibility_status: Visibility_Status_Enum;
  id: Scalars['uuid']['input'];
}>;


export type UpdayePropertyVisibilityMutation = { __typename?: 'mutation_root', update_property_list_by_pk?: { __typename?: 'property_list', id: any } | null };

export type UpdateSeoSlugByPkMutationVariables = Exact<{
  pk_columns: Search_Slugs_Pk_Columns_Input;
  _set: Search_Slugs_Set_Input;
}>;


export type UpdateSeoSlugByPkMutation = { __typename?: 'mutation_root', update_search_slugs_by_pk?: { __typename?: 'search_slugs', id: any, slug: string, header_text?: string | null, image?: string | null, zone_name?: string | null, keywords?: string | null, language_id?: number | null, updated_at?: any | null, description?: string | null, metadata?: any | null, questions?: any | null, style?: any | null, testimonials?: any | null, search_text?: string | null } | null };

export type UpdateSeoCityByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: Seo_City_Set_Input;
}>;


export type UpdateSeoCityByPkMutation = { __typename?: 'mutation_root', update_seo_city_by_pk?: { __typename?: 'seo_city', id: any, slug: string, city_name: string, al_metadata: any, en_metadata: any, al_sections: any, en_sections: any, updated_at: any } | null };

export type InsertSeoCityMutationVariables = Exact<{
  objects?: InputMaybe<Array<Seo_City_Insert_Input> | Seo_City_Insert_Input>;
}>;


export type InsertSeoCityMutation = { __typename?: 'mutation_root', insert_seo_city?: { __typename?: 'seo_city_mutation_response', affected_rows: number } | null };

export type InsertBlogPostMutationVariables = Exact<{
  objects?: InputMaybe<Array<Blog_Post_Insert_Input> | Blog_Post_Insert_Input>;
}>;


export type InsertBlogPostMutation = { __typename?: 'mutation_root', insert_blog_post?: { __typename?: 'blog_post_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'blog_post', id: any, author: string, colorPalette?: string | null, created_at: any, metaDescription?: string | null, publishDate?: string | null, readingTime?: string | null, targetAudience?: string | null, title: string, tone?: string | null, updated_at: any, tags?: any | null, sections: Array<{ __typename?: 'blog_section', id: any, type: string, heading?: string | null, content?: string | null, imageUrl?: string | null, imageAlt?: string | null, imageCaption?: string | null }> }> } | null };

export type UpdateBlogPostMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Blog_Post_Set_Input;
}>;


export type UpdateBlogPostMutation = { __typename?: 'mutation_root', update_blog_post_by_pk?: { __typename?: 'blog_post', id: any } | null };

export type DeleteBlogPostMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteBlogPostMutation = { __typename?: 'mutation_root', delete_blog_post_by_pk?: { __typename?: 'blog_post', id: any } | null };

export type SaveBlogPreviewMutationVariables = Exact<{
  objects?: InputMaybe<Array<Blog_Post_Insert_Input> | Blog_Post_Insert_Input>;
}>;


export type SaveBlogPreviewMutation = { __typename?: 'mutation_root', insert_blog_post?: { __typename?: 'blog_post_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'blog_post', id: any, author: string, colorPalette?: string | null, created_at: any, metaDescription?: string | null, publishDate?: string | null, readingTime?: string | null, targetAudience?: string | null, title: string, tone?: string | null, updated_at: any, tags?: any | null, sections: Array<{ __typename?: 'blog_section', id: any, type: string, heading?: string | null, content?: string | null, imageUrl?: string | null, imageAlt?: string | null, imageCaption?: string | null }> }> } | null };

export type UpdateBlogByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: Blog_Set_Input;
}>;


export type UpdateBlogByPkMutation = { __typename?: 'mutation_root', update_blog_by_pk?: { __typename?: 'blog', id: any, slug: string, status?: Blog_Status_Enum | null, al_metadata: any, al_sections: any, updated_at: any } | null };

export type InsertSearchSlugMutationVariables = Exact<{
  object: Search_Slugs_Insert_Input;
}>;


export type InsertSearchSlugMutation = { __typename?: 'mutation_root', insert_search_slugs_one?: { __typename?: 'search_slugs', image?: string | null, id: any, slug: string, session_id?: any | null, search_session?: { __typename?: 'search_sessions', natural_language_queries: Array<{ __typename?: 'natural_language_queries', id: any, query: string }> } | null } | null };

export type PromptSearchForSearchSlugMutationVariables = Exact<{
  body: QuestionInput;
}>;


export type PromptSearchForSearchSlugMutation = { __typename?: 'mutation_root', promptSearch?: { __typename?: 'QuestionOutput', success?: boolean | null, message?: string | null, nlq_id?: string | null, total_found_properties?: number | null, natural_language_query?: { __typename?: 'natural_language_queries', id: any, session_id: any } | null } | null };

export type DeleteSearchSlugMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteSearchSlugMutation = { __typename?: 'mutation_root', delete_search_slugs_by_pk?: { __typename?: 'search_slugs', id: any } | null };

export type InsertQueriesPropertyResultMutationVariables = Exact<{
  object: Queries_Property_Result_Insert_Input;
}>;


export type InsertQueriesPropertyResultMutation = { __typename?: 'mutation_root', insert_queries_property_result_one?: { __typename?: 'queries_property_result', id: any } | null };

export type DeleteQueriesPropertyResultMutationVariables = Exact<{
  where: Queries_Property_Result_Bool_Exp;
}>;


export type DeleteQueriesPropertyResultMutation = { __typename?: 'mutation_root', delete_queries_property_result?: { __typename?: 'queries_property_result_mutation_response', affected_rows: number } | null };

export type UpdateSearchSlugByPkMutationVariables = Exact<{
  slugId: Scalars['uuid']['input'];
  slugSet: Search_Slugs_Set_Input;
}>;


export type UpdateSearchSlugByPkMutation = { __typename?: 'mutation_root', update_search_slugs_by_pk?: { __typename?: 'search_slugs', id: any } | null };

export type UpdateSearchSessionByPkMutationVariables = Exact<{
  sessionId: Scalars['uuid']['input'];
  sessionSet: Search_Sessions_Set_Input;
}>;


export type UpdateSearchSessionByPkMutation = { __typename?: 'mutation_root', update_search_sessions_by_pk?: { __typename?: 'search_sessions', id: any } | null };

export type UpdateNaturalLanguageQueryByPkMutationVariables = Exact<{
  nlqId: Scalars['uuid']['input'];
  nlqSet: Natural_Language_Queries_Set_Input;
}>;


export type UpdateNaturalLanguageQueryByPkMutation = { __typename?: 'mutation_root', update_natural_language_queries_by_pk?: { __typename?: 'natural_language_queries', id: any } | null };

export type InsertBlogMutationVariables = Exact<{
  objects?: InputMaybe<Array<Blog_Insert_Input> | Blog_Insert_Input>;
}>;


export type InsertBlogMutation = { __typename?: 'mutation_root', insert_blog?: { __typename?: 'blog_mutation_response', affected_rows: number } | null };

export type UpdateContactPhoneNumberContactByIdsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  target_contact_id: Scalars['uuid']['input'];
}>;


export type UpdateContactPhoneNumberContactByIdsMutation = { __typename?: 'mutation_root', update_contact_phone_number?: { __typename?: 'contact_phone_number_mutation_response', affected_rows: number } | null };

export type ReassignPropertyListsToContactMutationVariables = Exact<{
  contact_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  target_contact_id: Scalars['uuid']['input'];
}>;


export type ReassignPropertyListsToContactMutation = { __typename?: 'mutation_root', update_property_list?: { __typename?: 'property_list_mutation_response', affected_rows: number } | null };

export type ReassignPropertyListsByPhoneToContactMutationVariables = Exact<{
  phone_number: Scalars['String']['input'];
  contact_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  target_contact_id: Scalars['uuid']['input'];
}>;


export type ReassignPropertyListsByPhoneToContactMutation = { __typename?: 'mutation_root', update_property_list?: { __typename?: 'property_list_mutation_response', affected_rows: number } | null };

export type DeleteContactsByIdsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteContactsByIdsMutation = { __typename?: 'mutation_root', delete_contact?: { __typename?: 'contact_mutation_response', affected_rows: number } | null };

export type DeleteContactPhoneNumbersByIdsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteContactPhoneNumbersByIdsMutation = { __typename?: 'mutation_root', delete_contact_phone_number?: { __typename?: 'contact_phone_number_mutation_response', affected_rows: number } | null };

export type UpdateContactPhoneNumberAgencyByIdsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  target_agency_id: Scalars['uuid']['input'];
}>;


export type UpdateContactPhoneNumberAgencyByIdsMutation = { __typename?: 'mutation_root', update_contact_phone_number?: { __typename?: 'contact_phone_number_mutation_response', affected_rows: number } | null };

export type ReassignPropertySourcesByPhoneToAgencyMutationVariables = Exact<{
  phone_number: Scalars['String']['input'];
  target_agency_id: Scalars['uuid']['input'];
}>;


export type ReassignPropertySourcesByPhoneToAgencyMutation = { __typename?: 'mutation_root', update_property_source?: { __typename?: 'property_source_mutation_response', affected_rows: number } | null };

export type UpdatePropertySourceAgencyByIdsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  target_agency_id: Scalars['uuid']['input'];
}>;


export type UpdatePropertySourceAgencyByIdsMutation = { __typename?: 'mutation_root', update_property_source?: { __typename?: 'property_source_mutation_response', affected_rows: number } | null };

export type ReassignPropertyListsToSourceMutationVariables = Exact<{
  source_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  target_source_id: Scalars['uuid']['input'];
  phone_number: Scalars['String']['input'];
}>;


export type ReassignPropertyListsToSourceMutation = { __typename?: 'mutation_root', update_property_list?: { __typename?: 'property_list_mutation_response', affected_rows: number } | null };

export type DeletePropertySourcesByIdsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeletePropertySourcesByIdsMutation = { __typename?: 'mutation_root', delete_property_source?: { __typename?: 'property_source_mutation_response', affected_rows: number } | null };

export type UpdateAgencyParentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpdateAgencyParentMutation = { __typename?: 'mutation_root', update_agency_by_pk?: { __typename?: 'agency', id: any, parent_id?: any | null } | null };

export type GetSubscriptionsQueryVariables = Exact<{
  where?: InputMaybe<Subscription_Bool_Exp>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Order_By> | Subscription_Order_By>;
}>;


export type GetSubscriptionsQuery = { __typename?: 'query_root', subscription: Array<{ __typename?: 'subscription', id: any, active: boolean, active_members?: number | null, cancel_at_period_end?: boolean | null, cancelled_at?: any | null, created_at: any, start_date: any, end_date: any, status?: Subscription_Status_Enum | null, stripe_subscription_id?: string | null, max_members?: number | null, cancellation_details?: any | null, plan: { __typename?: 'plan', id: any, name: string }, subscription_invoices: Array<{ __typename?: 'subscription_invoice', id: any, created_at: any, end_date: any, free_trial?: boolean | null, invoice_url?: string | null, number_of_posts?: number | null, number_of_social_channels?: number | null, number_of_social_posts?: number | null, order_id?: any | null, start_date: any, status: string }> }> };

export type GetOrganizationsQueryVariables = Exact<{
  where?: InputMaybe<Organization_Bool_Exp>;
  order_by?: InputMaybe<Array<Organization_Order_By> | Organization_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetOrganizationsQuery = { __typename?: 'query_root', organization: Array<{ __typename?: 'organization', id: any, type?: Organization_Type_Enum | null, display_name: string, origin?: string | null, slug?: string | null, description?: string | null, phone_number?: string | null, email?: string | null, profile_image_url?: string | null, children: Array<{ __typename?: 'organization', id: any, type?: Organization_Type_Enum | null, display_name: string, origin?: string | null, slug?: string | null, description?: string | null, phone_number?: string | null, email?: string | null, profile_image_url?: string | null, subscriptions: Array<{ __typename?: 'subscription', start_date: any, end_date: any, active: boolean, plan: { __typename?: 'plan', id: any, name: string, description: string, type?: Plan_Type_Enum | null } }>, properties_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null }, user_organizations: Array<{ __typename?: 'user_organization', id: any, role?: Organization_Role_Enum | null, user: { __typename?: 'users', avatarUrl: string, displayName: string, id: any } }> }>, subscriptions: Array<{ __typename?: 'subscription', start_date: any, end_date: any, active: boolean, plan: { __typename?: 'plan', id: any, name: string, description: string, type?: Plan_Type_Enum | null } }>, properties_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null }, user_organizations: Array<{ __typename?: 'user_organization', id: any, role?: Organization_Role_Enum | null, user: { __typename?: 'users', avatarUrl: string, displayName: string, id: any } }> }>, organization_aggregate: { __typename?: 'organization_aggregate', aggregate?: { __typename?: 'organization_aggregate_fields', count: number } | null } };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrganizationQuery = { __typename?: 'query_root', organization_by_pk?: { __typename?: 'organization', id: any, type?: Organization_Type_Enum | null, display_name: string, origin?: string | null, slug?: string | null, description?: string | null, phone_number?: string | null, email?: string | null, profile_image_url?: string | null, subscriptions: Array<{ __typename?: 'subscription', start_date: any, end_date: any, active: boolean, plan: { __typename?: 'plan', id: any, name: string, description: string, type?: Plan_Type_Enum | null } }>, properties_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null }, user_organizations: Array<{ __typename?: 'user_organization', id: any, role?: Organization_Role_Enum | null, user: { __typename?: 'users', avatarUrl: string, displayName: string, id: any } }> } | null };

export type GetUserOrganizationsQueryVariables = Exact<{
  where?: InputMaybe<User_Organization_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserOrganizationsQuery = { __typename?: 'query_root', user_organization: Array<{ __typename?: 'user_organization', id: any, name: string, role?: Organization_Role_Enum | null, organization_id: any, user: { __typename?: 'users', id: any, displayName: string, avatarUrl: string, email?: any | null, lastSeen?: any | null }, organization: { __typename?: 'organization', parent_organization_id?: any | null, free_trial_activated?: boolean | null, cover_image_url?: string | null, description?: string | null, display_name: string, id: any, status?: Organization_Status_Enum | null, profile_image_url?: string | null, type?: Organization_Type_Enum | null, properties_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null }, organization_leads_aggregate: { __typename?: 'organization_leads_aggregate', aggregate?: { __typename?: 'organization_leads_aggregate_fields', count: number } | null } } }>, user_organization_aggregate: { __typename?: 'user_organization_aggregate', aggregate?: { __typename?: 'user_organization_aggregate_fields', count: number } | null } };

export type GetUsersQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By> | Users_Order_By>;
}>;


export type GetUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, displayName: string, avatarUrl: string, email?: any | null }> };

export type CreateAgencyContractMutationVariables = Exact<{
  body: ManualSubscriptionInput;
}>;


export type CreateAgencyContractMutation = { __typename?: 'mutation_root', create_manual_subscription?: { __typename?: 'ManualSubscriptionOutput', subscription_id?: string | null, success?: boolean | null } | null };

export type GetPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlansQuery = { __typename?: 'query_root', plan: Array<{ __typename?: 'plan', id: any, name: string, description: string, type?: Plan_Type_Enum | null, organization_type?: Organization_Type_Enum | null, min_members?: number | null }> };

export type GetCityZoneQueryVariables = Exact<{
  where: City_Zone_Bool_Exp;
}>;


export type GetCityZoneQuery = { __typename?: 'query_root', city_zone: Array<{ __typename?: 'city_zone', id: any, bounds?: any | null, geometry?: any | null, created_at?: any | null, updated_at?: any | null, formatted_address?: string | null, location?: any | null, location_type?: string | null, place_id?: string | null, data_method?: Zone_Data_Method_Enum | null, surface_area?: any | null, types?: any | null, viewport?: any | null, zone_name: string, is_problematic?: boolean | null, origin?: City_Zone_Origin_Enum | null, property_count?: boolean | null, city: { __typename?: 'city', city_name: string } }> };

export type GetAddressTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddressTypesQuery = { __typename?: 'query_root', address_types: Array<{ __typename?: 'address_types', type: string }> };

export type GetCitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCitiesQuery = { __typename?: 'query_root', city: Array<{ __typename?: 'city', id: any, city_name: string }> };

export type GetPendingPlaceReferenceProposalsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type GetPendingPlaceReferenceProposalsQuery = { __typename?: 'query_root', place_reference_proposal: Array<{ __typename?: 'place_reference_proposal', id: any, kind: string, canonical_name: string, normalized_name: string, center_lat?: any | null, center_lng?: any | null, default_radius_m?: number | null, confidence?: any | null, aliases: any, evidence: any, provenance: any, created_at: any, parent_city_zone?: { __typename?: 'city_zone', id: any, zone_name: string, city: { __typename?: 'city', id: any, city_name: string } } | null }> };

export type GetCitySearchAreasQueryVariables = Exact<{
  cityId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetCitySearchAreasQuery = { __typename?: 'query_root', city_zone: Array<{ __typename?: 'city_zone', id: any, zone_name: string }> };

export type GetAllPropertiesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: Property_List_Bool_Exp;
}>;


export type GetAllPropertiesQuery = { __typename?: 'query_root', property_list: Array<{ __typename?: 'property_list', id: any, source_url?: string | null, price?: any | null, location?: { __typename?: 'location', id: any, geom?: any | null, city_zone?: { __typename?: 'city_zone', id: any, zone_name: string, formatted_address?: string | null, bounds?: any | null, city: { __typename?: 'city', city_name: string } } | null } | null }>, property_list_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null } };

export type GetCityZonePropertiesQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCityZonePropertiesQuery = { __typename?: 'query_root', property_list: Array<{ __typename?: 'property_list', id: any, source_url?: string | null, location?: { __typename?: 'location', id: any, geom?: any | null, city_zone?: { __typename?: 'city_zone', zone_name: string, formatted_address?: string | null } | null } | null }> };

export type GetZonesQueryVariables = Exact<{
  search_term: Scalars['String']['input'];
  is_problematic: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetZonesQuery = { __typename?: 'query_root', getOrderByRelevanceCityZones: Array<{ __typename?: 'city_zone_object', id?: any | null, zone_name?: string | null, city_name?: string | null }> };

export type GetPropertyListsQueryVariables = Exact<{
  where: Property_List_Bool_Exp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetPropertyListsQuery = { __typename?: 'query_root', property_list: Array<{ __typename?: 'property_list', id: any, updated_at: any, price?: any | null, sponsored?: boolean | null, price_currency?: Currency_Enum | null, property_status?: Property_Status_Enum | null, property_type?: Property_Type_Enum | null, featured?: boolean | null, title_text_content?: { __typename?: 'text_content', original_text: string } | null, main_image?: { __typename?: 'property_image', image: string } | null, property?: { __typename?: 'property', main_listing_id: any, url_slugs: Array<{ __typename?: 'url_slug', slug: string }> } | null, organization?: { __typename?: 'organization', id: any, display_name: string, parent?: { __typename?: 'organization', id: any, display_name: string } | null } | null, property_source?: { __typename?: 'property_source', id: any, agency?: { __typename?: 'agency', id: any, name: string } | null } | null, location?: { __typename?: 'location', id: any, city_zone?: { __typename?: 'city_zone', id: any, formatted_address?: string | null } | null } | null }>, property_list_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null } };

export type GetPropertyByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPropertyByPkQuery = { __typename?: 'query_root', property_list_by_pk?: { __typename?: 'property_list', id: any, created_at: any, price?: any | null, price_currency?: Currency_Enum | null, property_status?: Property_Status_Enum | null, parent_property?: any | null, visibility_status?: Visibility_Status_Enum | null, living_area?: any | null, total_area?: any | null, floor?: number | null, construction_status?: Construction_Status_Enum | null, furnishing_status?: Furnishing_Status_Enum | null, contact_name?: string | null, features_array?: any | null, organization?: { __typename?: 'organization', id: any, profile_image_url?: string | null, display_name: string, phone_number?: string | null, parent?: { __typename?: 'organization', id: any, display_name: string } | null } | null, title_text_content?: { __typename?: 'text_content', original_text: string } | null, description_text_content?: { __typename?: 'text_content', original_text: string } | null, main_image?: { __typename?: 'property_image', id: any, image: string, blurhash?: string | null } | null, property_images: Array<{ __typename?: 'property_image', id: any, image: string, blurhash?: string | null }>, location?: { __typename?: 'location', lat: any, lng: any, country?: string | null, geom?: any | null, city_zone?: { __typename?: 'city_zone', id: any, formatted_address?: string | null, bounds?: any | null, city: { __typename?: 'city', display_name?: string | null } } | null } | null, property_composition?: { __typename?: 'property_composition', bedrooms?: number | null, bathrooms: number, living_rooms: number } | null, property_source?: { __typename?: 'property_source', id: any, origin?: Property_Origin_Enum | null, agency?: { __typename?: 'agency', id: any, name: string } | null } | null } | null, property_list_activity: Array<{ __typename?: 'property_list_activity', old_json?: any | null, new_json?: any | null }> };

export type GetSeoContentQueryVariables = Exact<{
  where?: InputMaybe<Search_Slugs_Bool_Exp>;
  order_by?: InputMaybe<Array<Search_Slugs_Order_By> | Search_Slugs_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSeoContentQuery = { __typename?: 'query_root', search_slugs: Array<{ __typename?: 'search_slugs', id: any, slug: string, header_text?: string | null, image?: string | null, zone_name?: string | null, keywords?: string | null, language_id?: number | null, updated_at?: any | null, description?: string | null, metadata?: any | null, questions?: any | null, style?: any | null, testimonials?: any | null, search_text?: string | null }>, search_slugs_aggregate: { __typename?: 'search_slugs_aggregate', aggregate?: { __typename?: 'search_slugs_aggregate_fields', count: number } | null } };

export type GetPropertyReportsPaginatedQueryVariables = Exact<{
  where?: InputMaybe<Property_List_Report_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_List_Report_Order_By> | Property_List_Report_Order_By>;
}>;


export type GetPropertyReportsPaginatedQuery = { __typename?: 'query_root', property_list_report: Array<{ __typename?: 'property_list_report', id: any, created_at?: any | null, phone?: string | null, email?: string | null, description: string, reporty_type: Property_Report_Type_Enum, user?: { __typename?: 'users', id: any, displayName: string, email?: any | null, avatarUrl: string } | null, property_list?: { __typename?: 'property_list', id: any, visibility_status?: Visibility_Status_Enum | null, main_image?: { __typename?: 'property_image', image: string } | null, title_text_content?: { __typename?: 'text_content', translations: Array<{ __typename?: 'translations', translation: string }> } | null, property?: { __typename?: 'property', url_slugs: Array<{ __typename?: 'url_slug', slug: string }> } | null } | null }>, property_list_report_aggregate: { __typename?: 'property_list_report_aggregate', aggregate?: { __typename?: 'property_list_report_aggregate_fields', count: number } | null } };

export type GetSeoCityQueryVariables = Exact<{
  where: Seo_City_Bool_Exp;
  order_by?: InputMaybe<Array<Seo_City_Order_By> | Seo_City_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSeoCityQuery = { __typename?: 'query_root', seo_city: Array<{ __typename?: 'seo_city', id: any, slug: string, city_name: string, al_metadata: any, en_metadata: any, al_sections: any, en_sections: any, updated_at: any }>, seo_city_aggregate: { __typename?: 'seo_city_aggregate', aggregate?: { __typename?: 'seo_city_aggregate_fields', count: number } | null } };

export type GetBlogPostsQueryVariables = Exact<{
  where: Blog_Post_Bool_Exp;
  order_by?: InputMaybe<Array<Blog_Post_Order_By> | Blog_Post_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBlogPostsQuery = { __typename?: 'query_root', blog_post: Array<{ __typename?: 'blog_post', id: any, author: string, colorPalette?: string | null, created_at: any, metaDescription?: string | null, publishDate?: string | null, readingTime?: string | null, targetAudience?: string | null, title: string, tone?: string | null, updated_at: any, tags?: any | null, sections: Array<{ __typename?: 'blog_section', id: any, type: string, heading?: string | null, content?: string | null, imageUrl?: string | null, imageAlt?: string | null, imageCaption?: string | null }> }>, blog_post_aggregate: { __typename?: 'blog_post_aggregate', aggregate?: { __typename?: 'blog_post_aggregate_fields', count: number } | null } };

export type GetBlogPostByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetBlogPostByIdQuery = { __typename?: 'query_root', blog_post_by_pk?: { __typename?: 'blog_post', id: any, author: string, colorPalette?: string | null, created_at: any, metaDescription?: string | null, publishDate?: string | null, readingTime?: string | null, targetAudience?: string | null, title: string, tone?: string | null, updated_at: any, tags?: any | null, sections: Array<{ __typename?: 'blog_section', id: any, type: string, heading?: string | null, content?: string | null, imageUrl?: string | null, imageAlt?: string | null, imageCaption?: string | null }> } | null };

export type GetBlogPostsPaginatedQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<Blog_Post_Bool_Exp>;
}>;


export type GetBlogPostsPaginatedQuery = { __typename?: 'query_root', blog_post: Array<{ __typename?: 'blog_post', id: any, author: string, colorPalette?: string | null, created_at: any, metaDescription?: string | null, publishDate?: string | null, readingTime?: string | null, targetAudience?: string | null, title: string, tone?: string | null, updated_at: any, tags?: any | null, sections: Array<{ __typename?: 'blog_section', id: any, type: string, heading?: string | null, content?: string | null, imageUrl?: string | null, imageAlt?: string | null, imageCaption?: string | null }> }>, blog_post_aggregate: { __typename?: 'blog_post_aggregate', aggregate?: { __typename?: 'blog_post_aggregate_fields', count: number } | null } };

export type GetSeoBlogsQueryVariables = Exact<{
  where: Blog_Bool_Exp;
  order_by?: InputMaybe<Array<Blog_Order_By> | Blog_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSeoBlogsQuery = { __typename?: 'query_root', blog: Array<{ __typename?: 'blog', id: any, slug: string, status?: Blog_Status_Enum | null, al_metadata: any, al_sections: any, updated_at: any }>, blog_aggregate: { __typename?: 'blog_aggregate', aggregate?: { __typename?: 'blog_aggregate_fields', count: number } | null } };

export type GetPropertyBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPropertyBySlugQuery = { __typename?: 'query_root', url_slug: Array<{ __typename?: 'url_slug', slug: string, property: { __typename?: 'property', id: any, main_property: { __typename?: 'property_list', id: any }, property_lists_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null }, property_lists: Array<{ __typename?: 'property_list', id: any, price?: any | null, price_currency?: Currency_Enum | null, last_seen?: any | null, property_type?: Property_Type_Enum | null, property_status?: Property_Status_Enum | null, featured?: boolean | null, property_source?: { __typename?: 'property_source', id: any, agency?: { __typename?: 'agency', id: any, name: string } | null } | null, property?: { __typename?: 'property', id: any, main_listing_id: any, url_slugs: Array<{ __typename?: 'url_slug', slug: string }> } | null }> } }> };

export type GetSearchSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSearchSlugsQuery = { __typename?: 'query_root', search_slugs: Array<{ __typename?: 'search_slugs', id: any, image?: string | null, description?: string | null, language_id?: number | null, slug: string, header_text?: string | null, search_session?: { __typename?: 'search_sessions', id: any, title?: string | null, natural_language_queries: Array<{ __typename?: 'natural_language_queries', id: any, query: string, queries_property_results_aggregate: { __typename?: 'queries_property_result_aggregate', aggregate?: { __typename?: 'queries_property_result_aggregate_fields', count: number } | null } }> } | null }> };

export type GetSearchSlugByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetSearchSlugByIdQuery = { __typename?: 'query_root', search_slugs_by_pk?: { __typename?: 'search_slugs', id: any, slug: string, description?: string | null, image?: string | null, header_text?: string | null, language_id?: number | null, metadata?: any | null, style?: any | null, questions?: any | null, session_id?: any | null, search_session?: { __typename?: 'search_sessions', id: any, title?: string | null, natural_language_queries: Array<{ __typename?: 'natural_language_queries', id: any, query: string, queries_property_results: Array<{ __typename?: 'queries_property_result', property?: { __typename?: 'property', id: any, main_property: { __typename?: 'property_list', id: any, price?: any | null, price_currency?: Currency_Enum | null, property_type?: Property_Type_Enum | null, property_status?: Property_Status_Enum | null, featured?: boolean | null, property_source?: { __typename?: 'property_source', id: any, agency?: { __typename?: 'agency', id: any, name: string } | null } | null, property?: { __typename?: 'property', id: any, main_listing_id: any, url_slugs: Array<{ __typename?: 'url_slug', slug: string }> } | null } } | null }>, queries_property_results_aggregate: { __typename?: 'queries_property_result_aggregate', aggregate?: { __typename?: 'queries_property_result_aggregate_fields', count: number } | null } }> } | null } | null };

export type GetPropertyResultAggregateForNlqQueryVariables = Exact<{
  nlqId: Scalars['uuid']['input'];
  propertyId: Scalars['uuid']['input'];
}>;


export type GetPropertyResultAggregateForNlqQuery = { __typename?: 'query_root', queries_property_result_aggregate: { __typename?: 'queries_property_result_aggregate', aggregate?: { __typename?: 'queries_property_result_aggregate_fields', count: number } | null } };

export type PlatformOverviewQueryVariables = Exact<{
  usersWhere?: InputMaybe<Users_Bool_Exp>;
  propertiesWhere?: InputMaybe<Property_Bool_Exp>;
}>;


export type PlatformOverviewQuery = { __typename?: 'query_root', usersAggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null }, property_aggregate: { __typename?: 'property_aggregate', aggregate?: { __typename?: 'property_aggregate_fields', count: number } | null }, natural_language_queries_aggregate: { __typename?: 'natural_language_queries_aggregate', aggregate?: { __typename?: 'natural_language_queries_aggregate_fields', count: number } | null } };

export type GetClassifiedPropertiesQueryVariables = Exact<{
  start_date: Scalars['date']['input'];
  end_date: Scalars['date']['input'];
}>;


export type GetClassifiedPropertiesQuery = { __typename?: 'query_root', classifiedProperties: Array<{ __typename?: 'classified_properties_model', report_date?: any | null, scraped_properties?: any | null, kaktu_properties?: any | null }> };

export type GetDailyActiveUsersQueryVariables = Exact<{
  start_date: Scalars['date']['input'];
  end_date: Scalars['date']['input'];
}>;


export type GetDailyActiveUsersQuery = { __typename?: 'query_root', daliyActiveUsers: Array<{ __typename?: 'daily_active_users_model', agencies_nr?: any | null, listers_nr?: any | null, seeker_nr?: any | null, report_date?: any | null }> };

export type GetDailyRegisteredUsersQueryVariables = Exact<{
  start_date: Scalars['date']['input'];
  end_date: Scalars['date']['input'];
}>;


export type GetDailyRegisteredUsersQuery = { __typename?: 'query_root', dailyRegisteredUsers: Array<{ __typename?: 'daily_active_users_model', agencies_nr?: any | null, listers_nr?: any | null, seeker_nr?: any | null, report_date?: any | null }> };

export type GetRegionalPropertyDistributionQueryVariables = Exact<{
  property_status: Scalars['String']['input'];
  property_type: Scalars['String']['input'];
}>;


export type GetRegionalPropertyDistributionQuery = { __typename?: 'query_root', regionalPropertyDistribution: Array<{ __typename?: 'regional_property_model', city_name?: string | null, avg_price_eur?: any | null, total_properties?: any | null }> };

export type GetPropertyTypesDistributionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPropertyTypesDistributionQuery = { __typename?: 'query_root', propertyTypesDistribution: Array<{ __typename?: 'property_types_distribution_model', total_properties?: any | null, percentage?: any | null, cluster?: string | null }> };

export type GetAgencyScrapedPropertiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgencyScrapedPropertiesQuery = { __typename?: 'query_root', agencyScrapedProperties: Array<{ __typename?: 'agency_properties_model', total_properties?: any | null, agency_name?: string | null }> };

export type GetFavoritePropertiesTrendQueryVariables = Exact<{
  start_date: Scalars['date']['input'];
  end_date: Scalars['date']['input'];
}>;


export type GetFavoritePropertiesTrendQuery = { __typename?: 'query_root', favouritePropertiesTrend: Array<{ __typename?: 'favourite_properties_trend_model', report_date?: any | null, properties_added?: any | null, properties_removed?: any | null }> };

export type GetDailyQueriesStatisticsQueryVariables = Exact<{
  start_date: Scalars['date']['input'];
  end_date: Scalars['date']['input'];
}>;


export type GetDailyQueriesStatisticsQuery = { __typename?: 'query_root', daliyQueriesStatistics: Array<{ __typename?: 'daliy_queries_statistics_model', total_queries?: any | null, report_date?: any | null }> };

export type GetUsersDashboardQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order_by_type: Scalars['String']['input'];
}>;


export type GetUsersDashboardQuery = { __typename?: 'query_root', get_user_activity: Array<{ __typename?: 'users_activity_summary', user_id: any, display_name: string, email: string, last_seen: any, nr_sessions: any, nr_notifications: any }>, get_user_activity_aggregate: { __typename?: 'users_activity_summary_aggregate', aggregate?: { __typename?: 'users_activity_summary_aggregate_fields', count: number } | null } };

export type GetSearchSessionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['uuid']['input'];
}>;


export type GetSearchSessionsQuery = { __typename?: 'query_root', search_sessions_sorted_by_last_query: Array<{ __typename?: 'search_sessions', id: any, title?: string | null, created_at: any, natural_language_queries_aggregate: { __typename?: 'natural_language_queries_aggregate', aggregate?: { __typename?: 'natural_language_queries_aggregate_fields', count: number } | null } }>, search_sessions_aggregate: { __typename?: 'search_sessions_aggregate', aggregate?: { __typename?: 'search_sessions_aggregate_fields', count: number } | null } };

export type GetNlqsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  session_id: Scalars['uuid']['input'];
}>;


export type GetNlqsQuery = { __typename?: 'query_root', natural_language_queries: Array<{ __typename?: 'natural_language_queries', query: string, created_at: any, total_found_properties?: number | null }>, natural_language_queries_aggregate: { __typename?: 'natural_language_queries_aggregate', aggregate?: { __typename?: 'natural_language_queries_aggregate_fields', count: number } | null } };

export type UserEngagementStatsQueryVariables = Exact<{
  excludedEmails: Array<Scalars['citext']['input']> | Scalars['citext']['input'];
}>;


export type UserEngagementStatsQuery = { __typename?: 'query_root', q1: { __typename?: 'natural_language_queries_aggregate', aggregate?: { __typename?: 'natural_language_queries_aggregate_fields', count: number } | null }, q2: { __typename?: 'user_saved_properties_aggregate', aggregate?: { __typename?: 'user_saved_properties_aggregate_fields', count: number } | null }, q3: { __typename?: 'notification_aggregate', aggregate?: { __typename?: 'notification_aggregate_fields', count: number } | null }, q4: { __typename?: 'notification_aggregate', aggregate?: { __typename?: 'notification_aggregate_fields', count: number } | null } };

export type PropertyAnalyticsOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type PropertyAnalyticsOverviewQuery = { __typename?: 'query_root', totalScrapedProperties: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null }, acctiveSponsoredProperties: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null }, acctiveScrappedProperties: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null }, property_list_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null } };

export type GetAgencyHealthPaginatedQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Health_Order_By> | Agency_Health_Order_By>;
  where?: InputMaybe<Agency_Health_Bool_Exp>;
}>;


export type GetAgencyHealthPaginatedQuery = { __typename?: 'query_root', agency_health: Array<{ __typename?: 'agency_health', id?: any | null, name?: string | null, display_name?: string | null, total_phone_numbers?: any | null, total_contacts?: any | null, shared_phone_numbers?: any | null, shared_contacts?: any | null, created_at?: any | null }>, agency_health_aggregate: { __typename?: 'agency_health_aggregate', aggregate?: { __typename?: 'agency_health_aggregate_fields', count: number } | null } };

export type GetContactHealthPaginatedQueryVariables = Exact<{
  where?: InputMaybe<Contact_Health_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contact_Health_Order_By> | Contact_Health_Order_By>;
}>;


export type GetContactHealthPaginatedQuery = { __typename?: 'query_root', contact_health: Array<{ __typename?: 'contact_health', id?: any | null, full_name?: string | null, total_phone_numbers?: any | null, unique_agencies?: any | null, unassigned_phones?: any | null, invalid_phones?: any | null, created_at?: any | null }>, contact_health_aggregate: { __typename?: 'contact_health_aggregate', aggregate?: { __typename?: 'contact_health_aggregate_fields', count: number } | null } };

export type GetDuplicatePhoneNumbersPaginatedQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Duplicate_Phone_Numbers_Order_By> | Duplicate_Phone_Numbers_Order_By>;
  where?: InputMaybe<Duplicate_Phone_Numbers_Bool_Exp>;
}>;


export type GetDuplicatePhoneNumbersPaginatedQuery = { __typename?: 'query_root', duplicate_phone_numbers: Array<{ __typename?: 'duplicate_phone_numbers', phone_number?: string | null, agency_count?: any | null, contact_count?: any | null, agency_ids?: Array<any> | null, contact_ids?: Array<any> | null, first_created?: any | null, last_created?: any | null }>, duplicate_phone_numbers_aggregate: { __typename?: 'duplicate_phone_numbers_aggregate', aggregate?: { __typename?: 'duplicate_phone_numbers_aggregate_fields', count: number } | null } };

export type GetContactsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetContactsByIdsQuery = { __typename?: 'query_root', contact: Array<{ __typename?: 'contact', id: any, full_name?: string | null, property_lists_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null } }> };

export type GetAgenciesHierarchyQueryVariables = Exact<{
  namePattern: Scalars['String']['input'];
}>;


export type GetAgenciesHierarchyQuery = { __typename?: 'query_root', agency: Array<{ __typename?: 'agency', id: any, name: string, display_name?: string | null, parent_id?: any | null, property_sources: Array<{ __typename?: 'property_source', property_lists_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null } }> }> };

export type GetAgenciesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetAgenciesByIdsQuery = { __typename?: 'query_root', agency: Array<{ __typename?: 'agency', id: any, name: string, display_name?: string | null, property_sources_aggregate: { __typename?: 'property_source_aggregate', aggregate?: { __typename?: 'property_source_aggregate_fields', count: number } | null }, property_sources: Array<{ __typename?: 'property_source', property_lists_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null } }> }> };

export type SearchAgenciesQueryVariables = Exact<{
  search_pattern: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchAgenciesQuery = { __typename?: 'query_root', agency: Array<{ __typename?: 'agency', id: any, name: string, display_name?: string | null, property_sources_aggregate: { __typename?: 'property_source_aggregate', aggregate?: { __typename?: 'property_source_aggregate_fields', count: number } | null }, property_sources: Array<{ __typename?: 'property_source', property_lists_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null } }> }> };

export type GetContactPhoneNumbersByPhoneAndAgenciesQueryVariables = Exact<{
  phone_number: Scalars['String']['input'];
  agency_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetContactPhoneNumbersByPhoneAndAgenciesQuery = { __typename?: 'query_root', contact_phone_number: Array<{ __typename?: 'contact_phone_number', id: any, contact_id?: any | null, agency_id: any }> };

export type GetContactPhoneNumbersByPhoneAndContactIdsQueryVariables = Exact<{
  phone_number: Scalars['String']['input'];
  contact_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetContactPhoneNumbersByPhoneAndContactIdsQuery = { __typename?: 'query_root', contact_phone_number: Array<{ __typename?: 'contact_phone_number', id: any, contact_id?: any | null, agency_id: any }> };

export type GetContactPhoneNumbersByContactIdsQueryVariables = Exact<{
  contact_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetContactPhoneNumbersByContactIdsQuery = { __typename?: 'query_root', contact_phone_number: Array<{ __typename?: 'contact_phone_number', id: any, contact_id?: any | null, agency_id: any, phone_number: string }> };

export type GetPropertyListsByPhoneQueryVariables = Exact<{
  phone_number: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPropertyListsByPhoneQuery = { __typename?: 'query_root', property_list: Array<{ __typename?: 'property_list', id: any, source_url?: string | null, price?: any | null, price_currency?: Currency_Enum | null, property_status?: Property_Status_Enum | null, created_at: any, contact_name?: string | null, visibility_status?: Visibility_Status_Enum | null, title_text_content?: { __typename?: 'text_content', original_text: string } | null, main_image?: { __typename?: 'property_image', image: string } | null, property_source?: { __typename?: 'property_source', id: any, agency?: { __typename?: 'agency', id: any, name: string } | null } | null, property?: { __typename?: 'property', url_slugs: Array<{ __typename?: 'url_slug', slug: string }> } | null }>, property_list_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null } };

export type GetPropertySourcesByPhoneQueryVariables = Exact<{
  phone_number: Scalars['String']['input'];
}>;


export type GetPropertySourcesByPhoneQuery = { __typename?: 'query_root', property_source: Array<{ __typename?: 'property_source', id: any, origin?: Property_Origin_Enum | null, agency_id?: any | null, property_lists: Array<{ __typename?: 'property_list', id: any }> }> };

export type GetPropertySourcesByAgencyAndOriginsQueryVariables = Exact<{
  agency_id: Scalars['uuid']['input'];
  origins: Array<Property_Origin_Enum> | Property_Origin_Enum;
}>;


export type GetPropertySourcesByAgencyAndOriginsQuery = { __typename?: 'query_root', property_source: Array<{ __typename?: 'property_source', id: any, origin?: Property_Origin_Enum | null }> };

export type GetAnonymousSearchSessionsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order_by?: InputMaybe<Array<Search_Sessions_Order_By> | Search_Sessions_Order_By>;
}>;


export type GetAnonymousSearchSessionsQuery = { __typename?: 'query_root', search_sessions: Array<{ __typename?: 'search_sessions', id: any, title?: string | null, created_at: any, updated_at: any, origin?: Session_Origin_Enum | null, natural_language_queries_aggregate: { __typename?: 'natural_language_queries_aggregate', aggregate?: { __typename?: 'natural_language_queries_aggregate_fields', count: number } | null }, natural_language_queries: Array<{ __typename?: 'natural_language_queries', created_at: any }> }>, search_sessions_aggregate: { __typename?: 'search_sessions_aggregate', aggregate?: { __typename?: 'search_sessions_aggregate_fields', count: number } | null } };

export type GetOrganizationsForKaKtuPropertyFilterQueryVariables = Exact<{
  where: Property_List_Bool_Exp;
}>;


export type GetOrganizationsForKaKtuPropertyFilterQuery = { __typename?: 'query_root', property_list: Array<{ __typename?: 'property_list', organization?: { __typename?: 'organization', id: any, display_name: string, parent_organization_id?: any | null, parent?: { __typename?: 'organization', id: any, display_name: string } | null } | null }> };

export type SponsoredPropertyListsQueryVariables = Exact<{
  where?: InputMaybe<Sponsored_Property_List_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sponsored_Property_List_Order_By> | Sponsored_Property_List_Order_By>;
}>;


export type SponsoredPropertyListsQuery = { __typename?: 'query_root', sponsored_property_list: Array<{ __typename?: 'sponsored_property_list', id: any, created_at: any, start_date: any, end_date: any, property_list: { __typename?: 'property_list', id: any, main_image?: { __typename?: 'property_image', image: string } | null, title_text_content?: { __typename?: 'text_content', original_text: string } | null, property?: { __typename?: 'property', url_slugs: Array<{ __typename?: 'url_slug', slug: string }> } | null, organization?: { __typename?: 'organization', display_name: string, parent?: { __typename?: 'organization', display_name: string } | null } | null } }>, sponsored_property_list_aggregate: { __typename?: 'sponsored_property_list_aggregate', aggregate?: { __typename?: 'sponsored_property_list_aggregate_fields', count: number } | null } };

export type GetUserNotificationsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type GetUserNotificationsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, displayName: string, notifications: Array<{ __typename?: 'notification', title?: string | null, deleted?: boolean | null, opened?: boolean | null }> }>, usersAggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null } };

export type GetUsersDataQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order_by?: InputMaybe<Array<Users_Order_By> | Users_Order_By>;
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type GetUsersDataQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, createdAt: any, displayName: string, email?: any | null, phoneNumber?: string | null, roles: Array<{ __typename?: 'authUserRoles', role: AuthRoles_Enum }>, user_organizations: Array<{ __typename?: 'user_organization', organization: { __typename?: 'organization', display_name: string, status?: Organization_Status_Enum | null, parent?: { __typename?: 'organization', display_name: string, status?: Organization_Status_Enum | null } | null, subscriptions: Array<{ __typename?: 'subscription', start_date: any, end_date: any, status?: Subscription_Status_Enum | null }> } }> }>, usersAggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null } };

export type GetPropertyEngagementQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order_by?: InputMaybe<Array<Property_List_Order_By> | Property_List_Order_By>;
  where?: InputMaybe<Property_List_Bool_Exp>;
}>;


export type GetPropertyEngagementQuery = { __typename?: 'query_root', property_list: Array<{ __typename?: 'property_list', id: any, views?: number | null, source_url_clicked?: number | null, contact_phone_clicked?: number | null, total_activity?: number | null, title_text_content?: { __typename?: 'text_content', original_text: string } | null, main_image?: { __typename?: 'property_image', image: string } | null, property?: { __typename?: 'property', url_slugs: Array<{ __typename?: 'url_slug', slug: string }> } | null }>, property_list_aggregate: { __typename?: 'property_list_aggregate', aggregate?: { __typename?: 'property_list_aggregate_fields', count: number } | null } };

export const BlogPostFragmentDoc = gql`
    fragment BlogPost on blog_post {
  id
  author
  colorPalette
  created_at
  metaDescription
  publishDate
  readingTime
  targetAudience
  title
  tone
  updated_at
  tags
  sections {
    id
    type
    heading
    content
    imageUrl
    imageAlt
    imageCaption
  }
}
    `;
export const OrganizationFragmentFragmentDoc = gql`
    fragment OrganizationFragment on organization {
  id
  type
  display_name
  origin
  slug
  subscriptions(where: {active: {_eq: true}}) {
    start_date
    end_date
    active
    plan {
      id
      name
      description
      type
    }
  }
  description
  phone_number
  email
  profile_image_url
  properties_aggregate {
    aggregate {
      count
    }
  }
  user_organizations(where: {role: {_eq: account_holder}}) {
    id
    role
    user {
      avatarUrl
      displayName
      id
    }
  }
}
    `;
export const UpdateCityZoneByPkDocument = gql`
    mutation updateCityZoneByPk($set: city_zone_set_input, $id: uuid!) {
  update_city_zone_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
    bounds
    city {
      city_name
    }
    created_at
    formatted_address
    location
    location_type
    place_id
    data_method
    surface_area
    types
    updated_at
    viewport
    zone_name
  }
}
    `;
export type UpdateCityZoneByPkMutationFn = Apollo.MutationFunction<UpdateCityZoneByPkMutation, UpdateCityZoneByPkMutationVariables>;

/**
 * __useUpdateCityZoneByPkMutation__
 *
 * To run a mutation, you first call `useUpdateCityZoneByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCityZoneByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCityZoneByPkMutation, { data, loading, error }] = useUpdateCityZoneByPkMutation({
 *   variables: {
 *      set: // value for 'set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCityZoneByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCityZoneByPkMutation, UpdateCityZoneByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCityZoneByPkMutation, UpdateCityZoneByPkMutationVariables>(UpdateCityZoneByPkDocument, options);
      }
export type UpdateCityZoneByPkMutationHookResult = ReturnType<typeof useUpdateCityZoneByPkMutation>;
export type UpdateCityZoneByPkMutationResult = Apollo.MutationResult<UpdateCityZoneByPkMutation>;
export type UpdateCityZoneByPkMutationOptions = Apollo.BaseMutationOptions<UpdateCityZoneByPkMutation, UpdateCityZoneByPkMutationVariables>;
export const UpdateLocationByPkDocument = gql`
    mutation updateLocationByPk($id: uuid!, $set: location_set_input!) {
  update_location_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
}
    `;
export type UpdateLocationByPkMutationFn = Apollo.MutationFunction<UpdateLocationByPkMutation, UpdateLocationByPkMutationVariables>;

/**
 * __useUpdateLocationByPkMutation__
 *
 * To run a mutation, you first call `useUpdateLocationByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationByPkMutation, { data, loading, error }] = useUpdateLocationByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateLocationByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationByPkMutation, UpdateLocationByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationByPkMutation, UpdateLocationByPkMutationVariables>(UpdateLocationByPkDocument, options);
      }
export type UpdateLocationByPkMutationHookResult = ReturnType<typeof useUpdateLocationByPkMutation>;
export type UpdateLocationByPkMutationResult = Apollo.MutationResult<UpdateLocationByPkMutation>;
export type UpdateLocationByPkMutationOptions = Apollo.BaseMutationOptions<UpdateLocationByPkMutation, UpdateLocationByPkMutationVariables>;
export const ApprovePlaceReferenceProposalDocument = gql`
    mutation approvePlaceReferenceProposal($proposalId: uuid!, $reviewer: String) {
  approve_place_reference_proposal(
    args: {proposal_id: $proposalId, reviewer: $reviewer}
  ) {
    id
    canonical_name
    kind
  }
}
    `;
export type ApprovePlaceReferenceProposalMutationFn = Apollo.MutationFunction<ApprovePlaceReferenceProposalMutation, ApprovePlaceReferenceProposalMutationVariables>;

/**
 * __useApprovePlaceReferenceProposalMutation__
 *
 * To run a mutation, you first call `useApprovePlaceReferenceProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePlaceReferenceProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePlaceReferenceProposalMutation, { data, loading, error }] = useApprovePlaceReferenceProposalMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      reviewer: // value for 'reviewer'
 *   },
 * });
 */
export function useApprovePlaceReferenceProposalMutation(baseOptions?: Apollo.MutationHookOptions<ApprovePlaceReferenceProposalMutation, ApprovePlaceReferenceProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovePlaceReferenceProposalMutation, ApprovePlaceReferenceProposalMutationVariables>(ApprovePlaceReferenceProposalDocument, options);
      }
export type ApprovePlaceReferenceProposalMutationHookResult = ReturnType<typeof useApprovePlaceReferenceProposalMutation>;
export type ApprovePlaceReferenceProposalMutationResult = Apollo.MutationResult<ApprovePlaceReferenceProposalMutation>;
export type ApprovePlaceReferenceProposalMutationOptions = Apollo.BaseMutationOptions<ApprovePlaceReferenceProposalMutation, ApprovePlaceReferenceProposalMutationVariables>;
export const RejectPlaceReferenceProposalDocument = gql`
    mutation rejectPlaceReferenceProposal($proposalId: uuid!, $reviewer: String, $reason: String!, $reviewedAt: timestamptz!) {
  update_place_reference_proposal_by_pk(
    pk_columns: {id: $proposalId}
    _set: {status: "rejected", reviewed_by: $reviewer, reviewed_at: $reviewedAt, review_reason: $reason}
  ) {
    id
    status
  }
}
    `;
export type RejectPlaceReferenceProposalMutationFn = Apollo.MutationFunction<RejectPlaceReferenceProposalMutation, RejectPlaceReferenceProposalMutationVariables>;

/**
 * __useRejectPlaceReferenceProposalMutation__
 *
 * To run a mutation, you first call `useRejectPlaceReferenceProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectPlaceReferenceProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectPlaceReferenceProposalMutation, { data, loading, error }] = useRejectPlaceReferenceProposalMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      reviewer: // value for 'reviewer'
 *      reason: // value for 'reason'
 *      reviewedAt: // value for 'reviewedAt'
 *   },
 * });
 */
export function useRejectPlaceReferenceProposalMutation(baseOptions?: Apollo.MutationHookOptions<RejectPlaceReferenceProposalMutation, RejectPlaceReferenceProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectPlaceReferenceProposalMutation, RejectPlaceReferenceProposalMutationVariables>(RejectPlaceReferenceProposalDocument, options);
      }
export type RejectPlaceReferenceProposalMutationHookResult = ReturnType<typeof useRejectPlaceReferenceProposalMutation>;
export type RejectPlaceReferenceProposalMutationResult = Apollo.MutationResult<RejectPlaceReferenceProposalMutation>;
export type RejectPlaceReferenceProposalMutationOptions = Apollo.BaseMutationOptions<RejectPlaceReferenceProposalMutation, RejectPlaceReferenceProposalMutationVariables>;
export const UpdatePlaceReferenceProposalDocument = gql`
    mutation updatePlaceReferenceProposal($proposalId: uuid!, $set: place_reference_proposal_set_input!) {
  update_place_reference_proposal_by_pk(pk_columns: {id: $proposalId}, _set: $set) {
    id
    canonical_name
    kind
    parent_city_zone_id
    default_radius_m
  }
}
    `;
export type UpdatePlaceReferenceProposalMutationFn = Apollo.MutationFunction<UpdatePlaceReferenceProposalMutation, UpdatePlaceReferenceProposalMutationVariables>;

/**
 * __useUpdatePlaceReferenceProposalMutation__
 *
 * To run a mutation, you first call `useUpdatePlaceReferenceProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaceReferenceProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaceReferenceProposalMutation, { data, loading, error }] = useUpdatePlaceReferenceProposalMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdatePlaceReferenceProposalMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaceReferenceProposalMutation, UpdatePlaceReferenceProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaceReferenceProposalMutation, UpdatePlaceReferenceProposalMutationVariables>(UpdatePlaceReferenceProposalDocument, options);
      }
export type UpdatePlaceReferenceProposalMutationHookResult = ReturnType<typeof useUpdatePlaceReferenceProposalMutation>;
export type UpdatePlaceReferenceProposalMutationResult = Apollo.MutationResult<UpdatePlaceReferenceProposalMutation>;
export type UpdatePlaceReferenceProposalMutationOptions = Apollo.BaseMutationOptions<UpdatePlaceReferenceProposalMutation, UpdatePlaceReferenceProposalMutationVariables>;
export const UpdayePropertyVisibilityDocument = gql`
    mutation updayePropertyVisibility($visibility_status: visibility_status_enum!, $id: uuid!) {
  update_property_list_by_pk(
    pk_columns: {id: $id}
    _set: {visibility_status: $visibility_status}
  ) {
    id
  }
}
    `;
export type UpdayePropertyVisibilityMutationFn = Apollo.MutationFunction<UpdayePropertyVisibilityMutation, UpdayePropertyVisibilityMutationVariables>;

/**
 * __useUpdayePropertyVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdayePropertyVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdayePropertyVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updayePropertyVisibilityMutation, { data, loading, error }] = useUpdayePropertyVisibilityMutation({
 *   variables: {
 *      visibility_status: // value for 'visibility_status'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdayePropertyVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdayePropertyVisibilityMutation, UpdayePropertyVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdayePropertyVisibilityMutation, UpdayePropertyVisibilityMutationVariables>(UpdayePropertyVisibilityDocument, options);
      }
export type UpdayePropertyVisibilityMutationHookResult = ReturnType<typeof useUpdayePropertyVisibilityMutation>;
export type UpdayePropertyVisibilityMutationResult = Apollo.MutationResult<UpdayePropertyVisibilityMutation>;
export type UpdayePropertyVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdayePropertyVisibilityMutation, UpdayePropertyVisibilityMutationVariables>;
export const UpdateSeoSlugByPkDocument = gql`
    mutation updateSEOSlugByPK($pk_columns: search_slugs_pk_columns_input!, $_set: search_slugs_set_input!) {
  update_search_slugs_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    slug
    header_text
    image
    zone_name
    keywords
    language_id
    updated_at
    description
    metadata
    questions
    style
    testimonials
    search_text
  }
}
    `;
export type UpdateSeoSlugByPkMutationFn = Apollo.MutationFunction<UpdateSeoSlugByPkMutation, UpdateSeoSlugByPkMutationVariables>;

/**
 * __useUpdateSeoSlugByPkMutation__
 *
 * To run a mutation, you first call `useUpdateSeoSlugByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeoSlugByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeoSlugByPkMutation, { data, loading, error }] = useUpdateSeoSlugByPkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateSeoSlugByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSeoSlugByPkMutation, UpdateSeoSlugByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSeoSlugByPkMutation, UpdateSeoSlugByPkMutationVariables>(UpdateSeoSlugByPkDocument, options);
      }
export type UpdateSeoSlugByPkMutationHookResult = ReturnType<typeof useUpdateSeoSlugByPkMutation>;
export type UpdateSeoSlugByPkMutationResult = Apollo.MutationResult<UpdateSeoSlugByPkMutation>;
export type UpdateSeoSlugByPkMutationOptions = Apollo.BaseMutationOptions<UpdateSeoSlugByPkMutation, UpdateSeoSlugByPkMutationVariables>;
export const UpdateSeoCityByPkDocument = gql`
    mutation updateSEOCityByPK($id: uuid!, $_set: seo_city_set_input!) {
  update_seo_city_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
    slug
    city_name
    al_metadata
    en_metadata
    al_sections
    en_sections
    updated_at
  }
}
    `;
export type UpdateSeoCityByPkMutationFn = Apollo.MutationFunction<UpdateSeoCityByPkMutation, UpdateSeoCityByPkMutationVariables>;

/**
 * __useUpdateSeoCityByPkMutation__
 *
 * To run a mutation, you first call `useUpdateSeoCityByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeoCityByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeoCityByPkMutation, { data, loading, error }] = useUpdateSeoCityByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateSeoCityByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSeoCityByPkMutation, UpdateSeoCityByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSeoCityByPkMutation, UpdateSeoCityByPkMutationVariables>(UpdateSeoCityByPkDocument, options);
      }
export type UpdateSeoCityByPkMutationHookResult = ReturnType<typeof useUpdateSeoCityByPkMutation>;
export type UpdateSeoCityByPkMutationResult = Apollo.MutationResult<UpdateSeoCityByPkMutation>;
export type UpdateSeoCityByPkMutationOptions = Apollo.BaseMutationOptions<UpdateSeoCityByPkMutation, UpdateSeoCityByPkMutationVariables>;
export const InsertSeoCityDocument = gql`
    mutation insertSEOCity($objects: [seo_city_insert_input!] = {}) {
  insert_seo_city(objects: $objects) {
    affected_rows
  }
}
    `;
export type InsertSeoCityMutationFn = Apollo.MutationFunction<InsertSeoCityMutation, InsertSeoCityMutationVariables>;

/**
 * __useInsertSeoCityMutation__
 *
 * To run a mutation, you first call `useInsertSeoCityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSeoCityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSeoCityMutation, { data, loading, error }] = useInsertSeoCityMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertSeoCityMutation(baseOptions?: Apollo.MutationHookOptions<InsertSeoCityMutation, InsertSeoCityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSeoCityMutation, InsertSeoCityMutationVariables>(InsertSeoCityDocument, options);
      }
export type InsertSeoCityMutationHookResult = ReturnType<typeof useInsertSeoCityMutation>;
export type InsertSeoCityMutationResult = Apollo.MutationResult<InsertSeoCityMutation>;
export type InsertSeoCityMutationOptions = Apollo.BaseMutationOptions<InsertSeoCityMutation, InsertSeoCityMutationVariables>;
export const InsertBlogPostDocument = gql`
    mutation insertBlogPost($objects: [blog_post_insert_input!] = {}) {
  insert_blog_post(objects: $objects) {
    affected_rows
    returning {
      ...BlogPost
    }
  }
}
    ${BlogPostFragmentDoc}`;
export type InsertBlogPostMutationFn = Apollo.MutationFunction<InsertBlogPostMutation, InsertBlogPostMutationVariables>;

/**
 * __useInsertBlogPostMutation__
 *
 * To run a mutation, you first call `useInsertBlogPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertBlogPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertBlogPostMutation, { data, loading, error }] = useInsertBlogPostMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertBlogPostMutation(baseOptions?: Apollo.MutationHookOptions<InsertBlogPostMutation, InsertBlogPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertBlogPostMutation, InsertBlogPostMutationVariables>(InsertBlogPostDocument, options);
      }
export type InsertBlogPostMutationHookResult = ReturnType<typeof useInsertBlogPostMutation>;
export type InsertBlogPostMutationResult = Apollo.MutationResult<InsertBlogPostMutation>;
export type InsertBlogPostMutationOptions = Apollo.BaseMutationOptions<InsertBlogPostMutation, InsertBlogPostMutationVariables>;
export const UpdateBlogPostDocument = gql`
    mutation updateBlogPost($id: uuid!, $set: blog_post_set_input!) {
  update_blog_post_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
}
    `;
export type UpdateBlogPostMutationFn = Apollo.MutationFunction<UpdateBlogPostMutation, UpdateBlogPostMutationVariables>;

/**
 * __useUpdateBlogPostMutation__
 *
 * To run a mutation, you first call `useUpdateBlogPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlogPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlogPostMutation, { data, loading, error }] = useUpdateBlogPostMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateBlogPostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlogPostMutation, UpdateBlogPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlogPostMutation, UpdateBlogPostMutationVariables>(UpdateBlogPostDocument, options);
      }
export type UpdateBlogPostMutationHookResult = ReturnType<typeof useUpdateBlogPostMutation>;
export type UpdateBlogPostMutationResult = Apollo.MutationResult<UpdateBlogPostMutation>;
export type UpdateBlogPostMutationOptions = Apollo.BaseMutationOptions<UpdateBlogPostMutation, UpdateBlogPostMutationVariables>;
export const DeleteBlogPostDocument = gql`
    mutation deleteBlogPost($id: uuid!) {
  delete_blog_post_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteBlogPostMutationFn = Apollo.MutationFunction<DeleteBlogPostMutation, DeleteBlogPostMutationVariables>;

/**
 * __useDeleteBlogPostMutation__
 *
 * To run a mutation, you first call `useDeleteBlogPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBlogPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlogPostMutation, { data, loading, error }] = useDeleteBlogPostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBlogPostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBlogPostMutation, DeleteBlogPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBlogPostMutation, DeleteBlogPostMutationVariables>(DeleteBlogPostDocument, options);
      }
export type DeleteBlogPostMutationHookResult = ReturnType<typeof useDeleteBlogPostMutation>;
export type DeleteBlogPostMutationResult = Apollo.MutationResult<DeleteBlogPostMutation>;
export type DeleteBlogPostMutationOptions = Apollo.BaseMutationOptions<DeleteBlogPostMutation, DeleteBlogPostMutationVariables>;
export const SaveBlogPreviewDocument = gql`
    mutation saveBlogPreview($objects: [blog_post_insert_input!] = {}) {
  insert_blog_post(
    objects: $objects
    on_conflict: {constraint: blog_post_pkey, update_columns: [title, metaDescription, author, publishDate, readingTime, tags, colorPalette, tone, targetAudience, updated_at]}
  ) {
    affected_rows
    returning {
      ...BlogPost
    }
  }
}
    ${BlogPostFragmentDoc}`;
export type SaveBlogPreviewMutationFn = Apollo.MutationFunction<SaveBlogPreviewMutation, SaveBlogPreviewMutationVariables>;

/**
 * __useSaveBlogPreviewMutation__
 *
 * To run a mutation, you first call `useSaveBlogPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBlogPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBlogPreviewMutation, { data, loading, error }] = useSaveBlogPreviewMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useSaveBlogPreviewMutation(baseOptions?: Apollo.MutationHookOptions<SaveBlogPreviewMutation, SaveBlogPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBlogPreviewMutation, SaveBlogPreviewMutationVariables>(SaveBlogPreviewDocument, options);
      }
export type SaveBlogPreviewMutationHookResult = ReturnType<typeof useSaveBlogPreviewMutation>;
export type SaveBlogPreviewMutationResult = Apollo.MutationResult<SaveBlogPreviewMutation>;
export type SaveBlogPreviewMutationOptions = Apollo.BaseMutationOptions<SaveBlogPreviewMutation, SaveBlogPreviewMutationVariables>;
export const UpdateBlogByPkDocument = gql`
    mutation updateBlogByPK($id: uuid!, $_set: blog_set_input!) {
  update_blog_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
    slug
    status
    al_metadata
    al_sections
    updated_at
  }
}
    `;
export type UpdateBlogByPkMutationFn = Apollo.MutationFunction<UpdateBlogByPkMutation, UpdateBlogByPkMutationVariables>;

/**
 * __useUpdateBlogByPkMutation__
 *
 * To run a mutation, you first call `useUpdateBlogByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlogByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlogByPkMutation, { data, loading, error }] = useUpdateBlogByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateBlogByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlogByPkMutation, UpdateBlogByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlogByPkMutation, UpdateBlogByPkMutationVariables>(UpdateBlogByPkDocument, options);
      }
export type UpdateBlogByPkMutationHookResult = ReturnType<typeof useUpdateBlogByPkMutation>;
export type UpdateBlogByPkMutationResult = Apollo.MutationResult<UpdateBlogByPkMutation>;
export type UpdateBlogByPkMutationOptions = Apollo.BaseMutationOptions<UpdateBlogByPkMutation, UpdateBlogByPkMutationVariables>;
export const InsertSearchSlugDocument = gql`
    mutation insertSearchSlug($object: search_slugs_insert_input!) {
  insert_search_slugs_one(object: $object) {
    image
    id
    slug
    session_id
    search_session {
      natural_language_queries(order_by: {created_at: desc}, limit: 1) {
        id
        query
      }
    }
  }
}
    `;
export type InsertSearchSlugMutationFn = Apollo.MutationFunction<InsertSearchSlugMutation, InsertSearchSlugMutationVariables>;

/**
 * __useInsertSearchSlugMutation__
 *
 * To run a mutation, you first call `useInsertSearchSlugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSearchSlugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSearchSlugMutation, { data, loading, error }] = useInsertSearchSlugMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertSearchSlugMutation(baseOptions?: Apollo.MutationHookOptions<InsertSearchSlugMutation, InsertSearchSlugMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSearchSlugMutation, InsertSearchSlugMutationVariables>(InsertSearchSlugDocument, options);
      }
export type InsertSearchSlugMutationHookResult = ReturnType<typeof useInsertSearchSlugMutation>;
export type InsertSearchSlugMutationResult = Apollo.MutationResult<InsertSearchSlugMutation>;
export type InsertSearchSlugMutationOptions = Apollo.BaseMutationOptions<InsertSearchSlugMutation, InsertSearchSlugMutationVariables>;
export const PromptSearchForSearchSlugDocument = gql`
    mutation promptSearchForSearchSlug($body: QuestionInput!) {
  promptSearch(body: $body) {
    success
    message
    nlq_id
    total_found_properties
    natural_language_query {
      id
      session_id
    }
  }
}
    `;
export type PromptSearchForSearchSlugMutationFn = Apollo.MutationFunction<PromptSearchForSearchSlugMutation, PromptSearchForSearchSlugMutationVariables>;

/**
 * __usePromptSearchForSearchSlugMutation__
 *
 * To run a mutation, you first call `usePromptSearchForSearchSlugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromptSearchForSearchSlugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promptSearchForSearchSlugMutation, { data, loading, error }] = usePromptSearchForSearchSlugMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function usePromptSearchForSearchSlugMutation(baseOptions?: Apollo.MutationHookOptions<PromptSearchForSearchSlugMutation, PromptSearchForSearchSlugMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromptSearchForSearchSlugMutation, PromptSearchForSearchSlugMutationVariables>(PromptSearchForSearchSlugDocument, options);
      }
export type PromptSearchForSearchSlugMutationHookResult = ReturnType<typeof usePromptSearchForSearchSlugMutation>;
export type PromptSearchForSearchSlugMutationResult = Apollo.MutationResult<PromptSearchForSearchSlugMutation>;
export type PromptSearchForSearchSlugMutationOptions = Apollo.BaseMutationOptions<PromptSearchForSearchSlugMutation, PromptSearchForSearchSlugMutationVariables>;
export const DeleteSearchSlugDocument = gql`
    mutation deleteSearchSlug($id: uuid!) {
  delete_search_slugs_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteSearchSlugMutationFn = Apollo.MutationFunction<DeleteSearchSlugMutation, DeleteSearchSlugMutationVariables>;

/**
 * __useDeleteSearchSlugMutation__
 *
 * To run a mutation, you first call `useDeleteSearchSlugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSearchSlugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSearchSlugMutation, { data, loading, error }] = useDeleteSearchSlugMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSearchSlugMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSearchSlugMutation, DeleteSearchSlugMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSearchSlugMutation, DeleteSearchSlugMutationVariables>(DeleteSearchSlugDocument, options);
      }
export type DeleteSearchSlugMutationHookResult = ReturnType<typeof useDeleteSearchSlugMutation>;
export type DeleteSearchSlugMutationResult = Apollo.MutationResult<DeleteSearchSlugMutation>;
export type DeleteSearchSlugMutationOptions = Apollo.BaseMutationOptions<DeleteSearchSlugMutation, DeleteSearchSlugMutationVariables>;
export const InsertQueriesPropertyResultDocument = gql`
    mutation insertQueriesPropertyResult($object: queries_property_result_insert_input!) {
  insert_queries_property_result_one(object: $object) {
    id
  }
}
    `;
export type InsertQueriesPropertyResultMutationFn = Apollo.MutationFunction<InsertQueriesPropertyResultMutation, InsertQueriesPropertyResultMutationVariables>;

/**
 * __useInsertQueriesPropertyResultMutation__
 *
 * To run a mutation, you first call `useInsertQueriesPropertyResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertQueriesPropertyResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertQueriesPropertyResultMutation, { data, loading, error }] = useInsertQueriesPropertyResultMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertQueriesPropertyResultMutation(baseOptions?: Apollo.MutationHookOptions<InsertQueriesPropertyResultMutation, InsertQueriesPropertyResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertQueriesPropertyResultMutation, InsertQueriesPropertyResultMutationVariables>(InsertQueriesPropertyResultDocument, options);
      }
export type InsertQueriesPropertyResultMutationHookResult = ReturnType<typeof useInsertQueriesPropertyResultMutation>;
export type InsertQueriesPropertyResultMutationResult = Apollo.MutationResult<InsertQueriesPropertyResultMutation>;
export type InsertQueriesPropertyResultMutationOptions = Apollo.BaseMutationOptions<InsertQueriesPropertyResultMutation, InsertQueriesPropertyResultMutationVariables>;
export const DeleteQueriesPropertyResultDocument = gql`
    mutation deleteQueriesPropertyResult($where: queries_property_result_bool_exp!) {
  delete_queries_property_result(where: $where) {
    affected_rows
  }
}
    `;
export type DeleteQueriesPropertyResultMutationFn = Apollo.MutationFunction<DeleteQueriesPropertyResultMutation, DeleteQueriesPropertyResultMutationVariables>;

/**
 * __useDeleteQueriesPropertyResultMutation__
 *
 * To run a mutation, you first call `useDeleteQueriesPropertyResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQueriesPropertyResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQueriesPropertyResultMutation, { data, loading, error }] = useDeleteQueriesPropertyResultMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteQueriesPropertyResultMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQueriesPropertyResultMutation, DeleteQueriesPropertyResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQueriesPropertyResultMutation, DeleteQueriesPropertyResultMutationVariables>(DeleteQueriesPropertyResultDocument, options);
      }
export type DeleteQueriesPropertyResultMutationHookResult = ReturnType<typeof useDeleteQueriesPropertyResultMutation>;
export type DeleteQueriesPropertyResultMutationResult = Apollo.MutationResult<DeleteQueriesPropertyResultMutation>;
export type DeleteQueriesPropertyResultMutationOptions = Apollo.BaseMutationOptions<DeleteQueriesPropertyResultMutation, DeleteQueriesPropertyResultMutationVariables>;
export const UpdateSearchSlugByPkDocument = gql`
    mutation updateSearchSlugByPk($slugId: uuid!, $slugSet: search_slugs_set_input!) {
  update_search_slugs_by_pk(pk_columns: {id: $slugId}, _set: $slugSet) {
    id
  }
}
    `;
export type UpdateSearchSlugByPkMutationFn = Apollo.MutationFunction<UpdateSearchSlugByPkMutation, UpdateSearchSlugByPkMutationVariables>;

/**
 * __useUpdateSearchSlugByPkMutation__
 *
 * To run a mutation, you first call `useUpdateSearchSlugByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSearchSlugByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSearchSlugByPkMutation, { data, loading, error }] = useUpdateSearchSlugByPkMutation({
 *   variables: {
 *      slugId: // value for 'slugId'
 *      slugSet: // value for 'slugSet'
 *   },
 * });
 */
export function useUpdateSearchSlugByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSearchSlugByPkMutation, UpdateSearchSlugByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSearchSlugByPkMutation, UpdateSearchSlugByPkMutationVariables>(UpdateSearchSlugByPkDocument, options);
      }
export type UpdateSearchSlugByPkMutationHookResult = ReturnType<typeof useUpdateSearchSlugByPkMutation>;
export type UpdateSearchSlugByPkMutationResult = Apollo.MutationResult<UpdateSearchSlugByPkMutation>;
export type UpdateSearchSlugByPkMutationOptions = Apollo.BaseMutationOptions<UpdateSearchSlugByPkMutation, UpdateSearchSlugByPkMutationVariables>;
export const UpdateSearchSessionByPkDocument = gql`
    mutation updateSearchSessionByPk($sessionId: uuid!, $sessionSet: search_sessions_set_input!) {
  update_search_sessions_by_pk(pk_columns: {id: $sessionId}, _set: $sessionSet) {
    id
  }
}
    `;
export type UpdateSearchSessionByPkMutationFn = Apollo.MutationFunction<UpdateSearchSessionByPkMutation, UpdateSearchSessionByPkMutationVariables>;

/**
 * __useUpdateSearchSessionByPkMutation__
 *
 * To run a mutation, you first call `useUpdateSearchSessionByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSearchSessionByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSearchSessionByPkMutation, { data, loading, error }] = useUpdateSearchSessionByPkMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      sessionSet: // value for 'sessionSet'
 *   },
 * });
 */
export function useUpdateSearchSessionByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSearchSessionByPkMutation, UpdateSearchSessionByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSearchSessionByPkMutation, UpdateSearchSessionByPkMutationVariables>(UpdateSearchSessionByPkDocument, options);
      }
export type UpdateSearchSessionByPkMutationHookResult = ReturnType<typeof useUpdateSearchSessionByPkMutation>;
export type UpdateSearchSessionByPkMutationResult = Apollo.MutationResult<UpdateSearchSessionByPkMutation>;
export type UpdateSearchSessionByPkMutationOptions = Apollo.BaseMutationOptions<UpdateSearchSessionByPkMutation, UpdateSearchSessionByPkMutationVariables>;
export const UpdateNaturalLanguageQueryByPkDocument = gql`
    mutation updateNaturalLanguageQueryByPk($nlqId: uuid!, $nlqSet: natural_language_queries_set_input!) {
  update_natural_language_queries_by_pk(pk_columns: {id: $nlqId}, _set: $nlqSet) {
    id
  }
}
    `;
export type UpdateNaturalLanguageQueryByPkMutationFn = Apollo.MutationFunction<UpdateNaturalLanguageQueryByPkMutation, UpdateNaturalLanguageQueryByPkMutationVariables>;

/**
 * __useUpdateNaturalLanguageQueryByPkMutation__
 *
 * To run a mutation, you first call `useUpdateNaturalLanguageQueryByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNaturalLanguageQueryByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNaturalLanguageQueryByPkMutation, { data, loading, error }] = useUpdateNaturalLanguageQueryByPkMutation({
 *   variables: {
 *      nlqId: // value for 'nlqId'
 *      nlqSet: // value for 'nlqSet'
 *   },
 * });
 */
export function useUpdateNaturalLanguageQueryByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNaturalLanguageQueryByPkMutation, UpdateNaturalLanguageQueryByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNaturalLanguageQueryByPkMutation, UpdateNaturalLanguageQueryByPkMutationVariables>(UpdateNaturalLanguageQueryByPkDocument, options);
      }
export type UpdateNaturalLanguageQueryByPkMutationHookResult = ReturnType<typeof useUpdateNaturalLanguageQueryByPkMutation>;
export type UpdateNaturalLanguageQueryByPkMutationResult = Apollo.MutationResult<UpdateNaturalLanguageQueryByPkMutation>;
export type UpdateNaturalLanguageQueryByPkMutationOptions = Apollo.BaseMutationOptions<UpdateNaturalLanguageQueryByPkMutation, UpdateNaturalLanguageQueryByPkMutationVariables>;
export const InsertBlogDocument = gql`
    mutation insertBlog($objects: [blog_insert_input!] = {}) {
  insert_blog(objects: $objects) {
    affected_rows
  }
}
    `;
export type InsertBlogMutationFn = Apollo.MutationFunction<InsertBlogMutation, InsertBlogMutationVariables>;

/**
 * __useInsertBlogMutation__
 *
 * To run a mutation, you first call `useInsertBlogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertBlogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertBlogMutation, { data, loading, error }] = useInsertBlogMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertBlogMutation(baseOptions?: Apollo.MutationHookOptions<InsertBlogMutation, InsertBlogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertBlogMutation, InsertBlogMutationVariables>(InsertBlogDocument, options);
      }
export type InsertBlogMutationHookResult = ReturnType<typeof useInsertBlogMutation>;
export type InsertBlogMutationResult = Apollo.MutationResult<InsertBlogMutation>;
export type InsertBlogMutationOptions = Apollo.BaseMutationOptions<InsertBlogMutation, InsertBlogMutationVariables>;
export const UpdateContactPhoneNumberContactByIdsDocument = gql`
    mutation updateContactPhoneNumberContactByIds($ids: [uuid!]!, $target_contact_id: uuid!) {
  update_contact_phone_number(
    where: {id: {_in: $ids}}
    _set: {contact_id: $target_contact_id}
  ) {
    affected_rows
  }
}
    `;
export type UpdateContactPhoneNumberContactByIdsMutationFn = Apollo.MutationFunction<UpdateContactPhoneNumberContactByIdsMutation, UpdateContactPhoneNumberContactByIdsMutationVariables>;

/**
 * __useUpdateContactPhoneNumberContactByIdsMutation__
 *
 * To run a mutation, you first call `useUpdateContactPhoneNumberContactByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactPhoneNumberContactByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactPhoneNumberContactByIdsMutation, { data, loading, error }] = useUpdateContactPhoneNumberContactByIdsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      target_contact_id: // value for 'target_contact_id'
 *   },
 * });
 */
export function useUpdateContactPhoneNumberContactByIdsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactPhoneNumberContactByIdsMutation, UpdateContactPhoneNumberContactByIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactPhoneNumberContactByIdsMutation, UpdateContactPhoneNumberContactByIdsMutationVariables>(UpdateContactPhoneNumberContactByIdsDocument, options);
      }
export type UpdateContactPhoneNumberContactByIdsMutationHookResult = ReturnType<typeof useUpdateContactPhoneNumberContactByIdsMutation>;
export type UpdateContactPhoneNumberContactByIdsMutationResult = Apollo.MutationResult<UpdateContactPhoneNumberContactByIdsMutation>;
export type UpdateContactPhoneNumberContactByIdsMutationOptions = Apollo.BaseMutationOptions<UpdateContactPhoneNumberContactByIdsMutation, UpdateContactPhoneNumberContactByIdsMutationVariables>;
export const ReassignPropertyListsToContactDocument = gql`
    mutation reassignPropertyListsToContact($contact_ids: [uuid!]!, $target_contact_id: uuid!) {
  update_property_list(
    where: {contact_id: {_in: $contact_ids}}
    _set: {contact_id: $target_contact_id}
  ) {
    affected_rows
  }
}
    `;
export type ReassignPropertyListsToContactMutationFn = Apollo.MutationFunction<ReassignPropertyListsToContactMutation, ReassignPropertyListsToContactMutationVariables>;

/**
 * __useReassignPropertyListsToContactMutation__
 *
 * To run a mutation, you first call `useReassignPropertyListsToContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignPropertyListsToContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignPropertyListsToContactMutation, { data, loading, error }] = useReassignPropertyListsToContactMutation({
 *   variables: {
 *      contact_ids: // value for 'contact_ids'
 *      target_contact_id: // value for 'target_contact_id'
 *   },
 * });
 */
export function useReassignPropertyListsToContactMutation(baseOptions?: Apollo.MutationHookOptions<ReassignPropertyListsToContactMutation, ReassignPropertyListsToContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignPropertyListsToContactMutation, ReassignPropertyListsToContactMutationVariables>(ReassignPropertyListsToContactDocument, options);
      }
export type ReassignPropertyListsToContactMutationHookResult = ReturnType<typeof useReassignPropertyListsToContactMutation>;
export type ReassignPropertyListsToContactMutationResult = Apollo.MutationResult<ReassignPropertyListsToContactMutation>;
export type ReassignPropertyListsToContactMutationOptions = Apollo.BaseMutationOptions<ReassignPropertyListsToContactMutation, ReassignPropertyListsToContactMutationVariables>;
export const ReassignPropertyListsByPhoneToContactDocument = gql`
    mutation reassignPropertyListsByPhoneToContact($phone_number: String!, $contact_ids: [uuid!]!, $target_contact_id: uuid!) {
  update_property_list(
    where: {contact_phone_1: {_eq: $phone_number}, contact_id: {_in: $contact_ids}}
    _set: {contact_id: $target_contact_id}
  ) {
    affected_rows
  }
}
    `;
export type ReassignPropertyListsByPhoneToContactMutationFn = Apollo.MutationFunction<ReassignPropertyListsByPhoneToContactMutation, ReassignPropertyListsByPhoneToContactMutationVariables>;

/**
 * __useReassignPropertyListsByPhoneToContactMutation__
 *
 * To run a mutation, you first call `useReassignPropertyListsByPhoneToContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignPropertyListsByPhoneToContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignPropertyListsByPhoneToContactMutation, { data, loading, error }] = useReassignPropertyListsByPhoneToContactMutation({
 *   variables: {
 *      phone_number: // value for 'phone_number'
 *      contact_ids: // value for 'contact_ids'
 *      target_contact_id: // value for 'target_contact_id'
 *   },
 * });
 */
export function useReassignPropertyListsByPhoneToContactMutation(baseOptions?: Apollo.MutationHookOptions<ReassignPropertyListsByPhoneToContactMutation, ReassignPropertyListsByPhoneToContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignPropertyListsByPhoneToContactMutation, ReassignPropertyListsByPhoneToContactMutationVariables>(ReassignPropertyListsByPhoneToContactDocument, options);
      }
export type ReassignPropertyListsByPhoneToContactMutationHookResult = ReturnType<typeof useReassignPropertyListsByPhoneToContactMutation>;
export type ReassignPropertyListsByPhoneToContactMutationResult = Apollo.MutationResult<ReassignPropertyListsByPhoneToContactMutation>;
export type ReassignPropertyListsByPhoneToContactMutationOptions = Apollo.BaseMutationOptions<ReassignPropertyListsByPhoneToContactMutation, ReassignPropertyListsByPhoneToContactMutationVariables>;
export const DeleteContactsByIdsDocument = gql`
    mutation deleteContactsByIds($ids: [uuid!]!) {
  delete_contact(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;
export type DeleteContactsByIdsMutationFn = Apollo.MutationFunction<DeleteContactsByIdsMutation, DeleteContactsByIdsMutationVariables>;

/**
 * __useDeleteContactsByIdsMutation__
 *
 * To run a mutation, you first call `useDeleteContactsByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactsByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactsByIdsMutation, { data, loading, error }] = useDeleteContactsByIdsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteContactsByIdsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactsByIdsMutation, DeleteContactsByIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactsByIdsMutation, DeleteContactsByIdsMutationVariables>(DeleteContactsByIdsDocument, options);
      }
export type DeleteContactsByIdsMutationHookResult = ReturnType<typeof useDeleteContactsByIdsMutation>;
export type DeleteContactsByIdsMutationResult = Apollo.MutationResult<DeleteContactsByIdsMutation>;
export type DeleteContactsByIdsMutationOptions = Apollo.BaseMutationOptions<DeleteContactsByIdsMutation, DeleteContactsByIdsMutationVariables>;
export const DeleteContactPhoneNumbersByIdsDocument = gql`
    mutation deleteContactPhoneNumbersByIds($ids: [uuid!]!) {
  delete_contact_phone_number(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;
export type DeleteContactPhoneNumbersByIdsMutationFn = Apollo.MutationFunction<DeleteContactPhoneNumbersByIdsMutation, DeleteContactPhoneNumbersByIdsMutationVariables>;

/**
 * __useDeleteContactPhoneNumbersByIdsMutation__
 *
 * To run a mutation, you first call `useDeleteContactPhoneNumbersByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactPhoneNumbersByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactPhoneNumbersByIdsMutation, { data, loading, error }] = useDeleteContactPhoneNumbersByIdsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteContactPhoneNumbersByIdsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactPhoneNumbersByIdsMutation, DeleteContactPhoneNumbersByIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactPhoneNumbersByIdsMutation, DeleteContactPhoneNumbersByIdsMutationVariables>(DeleteContactPhoneNumbersByIdsDocument, options);
      }
export type DeleteContactPhoneNumbersByIdsMutationHookResult = ReturnType<typeof useDeleteContactPhoneNumbersByIdsMutation>;
export type DeleteContactPhoneNumbersByIdsMutationResult = Apollo.MutationResult<DeleteContactPhoneNumbersByIdsMutation>;
export type DeleteContactPhoneNumbersByIdsMutationOptions = Apollo.BaseMutationOptions<DeleteContactPhoneNumbersByIdsMutation, DeleteContactPhoneNumbersByIdsMutationVariables>;
export const UpdateContactPhoneNumberAgencyByIdsDocument = gql`
    mutation updateContactPhoneNumberAgencyByIds($ids: [uuid!]!, $target_agency_id: uuid!) {
  update_contact_phone_number(
    where: {id: {_in: $ids}}
    _set: {agency_id: $target_agency_id}
  ) {
    affected_rows
  }
}
    `;
export type UpdateContactPhoneNumberAgencyByIdsMutationFn = Apollo.MutationFunction<UpdateContactPhoneNumberAgencyByIdsMutation, UpdateContactPhoneNumberAgencyByIdsMutationVariables>;

/**
 * __useUpdateContactPhoneNumberAgencyByIdsMutation__
 *
 * To run a mutation, you first call `useUpdateContactPhoneNumberAgencyByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactPhoneNumberAgencyByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactPhoneNumberAgencyByIdsMutation, { data, loading, error }] = useUpdateContactPhoneNumberAgencyByIdsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      target_agency_id: // value for 'target_agency_id'
 *   },
 * });
 */
export function useUpdateContactPhoneNumberAgencyByIdsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactPhoneNumberAgencyByIdsMutation, UpdateContactPhoneNumberAgencyByIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactPhoneNumberAgencyByIdsMutation, UpdateContactPhoneNumberAgencyByIdsMutationVariables>(UpdateContactPhoneNumberAgencyByIdsDocument, options);
      }
export type UpdateContactPhoneNumberAgencyByIdsMutationHookResult = ReturnType<typeof useUpdateContactPhoneNumberAgencyByIdsMutation>;
export type UpdateContactPhoneNumberAgencyByIdsMutationResult = Apollo.MutationResult<UpdateContactPhoneNumberAgencyByIdsMutation>;
export type UpdateContactPhoneNumberAgencyByIdsMutationOptions = Apollo.BaseMutationOptions<UpdateContactPhoneNumberAgencyByIdsMutation, UpdateContactPhoneNumberAgencyByIdsMutationVariables>;
export const ReassignPropertySourcesByPhoneToAgencyDocument = gql`
    mutation reassignPropertySourcesByPhoneToAgency($phone_number: String!, $target_agency_id: uuid!) {
  update_property_source(
    where: {property_lists: {contact_phone_1: {_eq: $phone_number}}}
    _set: {agency_id: $target_agency_id}
  ) {
    affected_rows
  }
}
    `;
export type ReassignPropertySourcesByPhoneToAgencyMutationFn = Apollo.MutationFunction<ReassignPropertySourcesByPhoneToAgencyMutation, ReassignPropertySourcesByPhoneToAgencyMutationVariables>;

/**
 * __useReassignPropertySourcesByPhoneToAgencyMutation__
 *
 * To run a mutation, you first call `useReassignPropertySourcesByPhoneToAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignPropertySourcesByPhoneToAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignPropertySourcesByPhoneToAgencyMutation, { data, loading, error }] = useReassignPropertySourcesByPhoneToAgencyMutation({
 *   variables: {
 *      phone_number: // value for 'phone_number'
 *      target_agency_id: // value for 'target_agency_id'
 *   },
 * });
 */
export function useReassignPropertySourcesByPhoneToAgencyMutation(baseOptions?: Apollo.MutationHookOptions<ReassignPropertySourcesByPhoneToAgencyMutation, ReassignPropertySourcesByPhoneToAgencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignPropertySourcesByPhoneToAgencyMutation, ReassignPropertySourcesByPhoneToAgencyMutationVariables>(ReassignPropertySourcesByPhoneToAgencyDocument, options);
      }
export type ReassignPropertySourcesByPhoneToAgencyMutationHookResult = ReturnType<typeof useReassignPropertySourcesByPhoneToAgencyMutation>;
export type ReassignPropertySourcesByPhoneToAgencyMutationResult = Apollo.MutationResult<ReassignPropertySourcesByPhoneToAgencyMutation>;
export type ReassignPropertySourcesByPhoneToAgencyMutationOptions = Apollo.BaseMutationOptions<ReassignPropertySourcesByPhoneToAgencyMutation, ReassignPropertySourcesByPhoneToAgencyMutationVariables>;
export const UpdatePropertySourceAgencyByIdsDocument = gql`
    mutation updatePropertySourceAgencyByIds($ids: [uuid!]!, $target_agency_id: uuid!) {
  update_property_source(
    where: {id: {_in: $ids}}
    _set: {agency_id: $target_agency_id}
  ) {
    affected_rows
  }
}
    `;
export type UpdatePropertySourceAgencyByIdsMutationFn = Apollo.MutationFunction<UpdatePropertySourceAgencyByIdsMutation, UpdatePropertySourceAgencyByIdsMutationVariables>;

/**
 * __useUpdatePropertySourceAgencyByIdsMutation__
 *
 * To run a mutation, you first call `useUpdatePropertySourceAgencyByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertySourceAgencyByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertySourceAgencyByIdsMutation, { data, loading, error }] = useUpdatePropertySourceAgencyByIdsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      target_agency_id: // value for 'target_agency_id'
 *   },
 * });
 */
export function useUpdatePropertySourceAgencyByIdsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertySourceAgencyByIdsMutation, UpdatePropertySourceAgencyByIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertySourceAgencyByIdsMutation, UpdatePropertySourceAgencyByIdsMutationVariables>(UpdatePropertySourceAgencyByIdsDocument, options);
      }
export type UpdatePropertySourceAgencyByIdsMutationHookResult = ReturnType<typeof useUpdatePropertySourceAgencyByIdsMutation>;
export type UpdatePropertySourceAgencyByIdsMutationResult = Apollo.MutationResult<UpdatePropertySourceAgencyByIdsMutation>;
export type UpdatePropertySourceAgencyByIdsMutationOptions = Apollo.BaseMutationOptions<UpdatePropertySourceAgencyByIdsMutation, UpdatePropertySourceAgencyByIdsMutationVariables>;
export const ReassignPropertyListsToSourceDocument = gql`
    mutation reassignPropertyListsToSource($source_ids: [uuid!]!, $target_source_id: uuid!, $phone_number: String!) {
  update_property_list(
    where: {source_id: {_in: $source_ids}, contact_phone_1: {_eq: $phone_number}}
    _set: {source_id: $target_source_id}
  ) {
    affected_rows
  }
}
    `;
export type ReassignPropertyListsToSourceMutationFn = Apollo.MutationFunction<ReassignPropertyListsToSourceMutation, ReassignPropertyListsToSourceMutationVariables>;

/**
 * __useReassignPropertyListsToSourceMutation__
 *
 * To run a mutation, you first call `useReassignPropertyListsToSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignPropertyListsToSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignPropertyListsToSourceMutation, { data, loading, error }] = useReassignPropertyListsToSourceMutation({
 *   variables: {
 *      source_ids: // value for 'source_ids'
 *      target_source_id: // value for 'target_source_id'
 *      phone_number: // value for 'phone_number'
 *   },
 * });
 */
export function useReassignPropertyListsToSourceMutation(baseOptions?: Apollo.MutationHookOptions<ReassignPropertyListsToSourceMutation, ReassignPropertyListsToSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignPropertyListsToSourceMutation, ReassignPropertyListsToSourceMutationVariables>(ReassignPropertyListsToSourceDocument, options);
      }
export type ReassignPropertyListsToSourceMutationHookResult = ReturnType<typeof useReassignPropertyListsToSourceMutation>;
export type ReassignPropertyListsToSourceMutationResult = Apollo.MutationResult<ReassignPropertyListsToSourceMutation>;
export type ReassignPropertyListsToSourceMutationOptions = Apollo.BaseMutationOptions<ReassignPropertyListsToSourceMutation, ReassignPropertyListsToSourceMutationVariables>;
export const DeletePropertySourcesByIdsDocument = gql`
    mutation deletePropertySourcesByIds($ids: [uuid!]!) {
  delete_property_source(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;
export type DeletePropertySourcesByIdsMutationFn = Apollo.MutationFunction<DeletePropertySourcesByIdsMutation, DeletePropertySourcesByIdsMutationVariables>;

/**
 * __useDeletePropertySourcesByIdsMutation__
 *
 * To run a mutation, you first call `useDeletePropertySourcesByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePropertySourcesByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePropertySourcesByIdsMutation, { data, loading, error }] = useDeletePropertySourcesByIdsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeletePropertySourcesByIdsMutation(baseOptions?: Apollo.MutationHookOptions<DeletePropertySourcesByIdsMutation, DeletePropertySourcesByIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePropertySourcesByIdsMutation, DeletePropertySourcesByIdsMutationVariables>(DeletePropertySourcesByIdsDocument, options);
      }
export type DeletePropertySourcesByIdsMutationHookResult = ReturnType<typeof useDeletePropertySourcesByIdsMutation>;
export type DeletePropertySourcesByIdsMutationResult = Apollo.MutationResult<DeletePropertySourcesByIdsMutation>;
export type DeletePropertySourcesByIdsMutationOptions = Apollo.BaseMutationOptions<DeletePropertySourcesByIdsMutation, DeletePropertySourcesByIdsMutationVariables>;
export const UpdateAgencyParentDocument = gql`
    mutation updateAgencyParent($id: uuid!, $parent_id: uuid) {
  update_agency_by_pk(pk_columns: {id: $id}, _set: {parent_id: $parent_id}) {
    id
    parent_id
  }
}
    `;
export type UpdateAgencyParentMutationFn = Apollo.MutationFunction<UpdateAgencyParentMutation, UpdateAgencyParentMutationVariables>;

/**
 * __useUpdateAgencyParentMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyParentMutation, { data, loading, error }] = useUpdateAgencyParentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      parent_id: // value for 'parent_id'
 *   },
 * });
 */
export function useUpdateAgencyParentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencyParentMutation, UpdateAgencyParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencyParentMutation, UpdateAgencyParentMutationVariables>(UpdateAgencyParentDocument, options);
      }
export type UpdateAgencyParentMutationHookResult = ReturnType<typeof useUpdateAgencyParentMutation>;
export type UpdateAgencyParentMutationResult = Apollo.MutationResult<UpdateAgencyParentMutation>;
export type UpdateAgencyParentMutationOptions = Apollo.BaseMutationOptions<UpdateAgencyParentMutation, UpdateAgencyParentMutationVariables>;
export const GetSubscriptionsDocument = gql`
    query getSubscriptions($where: subscription_bool_exp, $offset: Int, $limit: Int, $order_by: [subscription_order_by!]) {
  subscription(where: $where, offset: $offset, limit: $limit, order_by: $order_by) {
    id
    active
    active_members
    cancel_at_period_end
    cancelled_at
    created_at
    start_date
    end_date
    plan {
      id
      name
    }
    status
    stripe_subscription_id
    max_members
    cancellation_details
    subscription_invoices(order_by: {created_at: desc}) {
      id
      created_at
      end_date
      free_trial
      invoice_url
      number_of_posts
      number_of_social_channels
      number_of_social_posts
      order_id
      start_date
      status
    }
  }
}
    `;

/**
 * __useGetSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
      }
export function useGetSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
        }
export function useGetSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
        }
export type GetSubscriptionsQueryHookResult = ReturnType<typeof useGetSubscriptionsQuery>;
export type GetSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsLazyQuery>;
export type GetSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionsSuspenseQuery>;
export type GetSubscriptionsQueryResult = Apollo.QueryResult<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>;
export const GetOrganizationsDocument = gql`
    query getOrganizations($where: organization_bool_exp, $order_by: [organization_order_by!], $limit: Int!, $offset: Int!) {
  organization(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...OrganizationFragment
    children {
      ...OrganizationFragment
    }
  }
  organization_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${OrganizationFragmentFragmentDoc}`;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables> & ({ variables: GetOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsSuspenseQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetOrganizationDocument = gql`
    query getOrganization($id: uuid!) {
  organization_by_pk(id: $id) {
    ...OrganizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables> & ({ variables: GetOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSuspenseQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GetUserOrganizationsDocument = gql`
    query getUserOrganizations($where: user_organization_bool_exp, $limit: Int, $offset: Int) {
  user_organization(where: $where, limit: $limit, offset: $offset) {
    id
    name
    role
    organization_id
    user {
      id
      displayName
      avatarUrl
      email
      lastSeen
    }
    organization {
      properties_aggregate {
        aggregate {
          count
        }
      }
      organization_leads_aggregate {
        aggregate {
          count
        }
      }
      parent_organization_id
      free_trial_activated
      cover_image_url
      description
      display_name
      id
      status
      profile_image_url
      type
    }
  }
  user_organization_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUserOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetUserOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrganizationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetUserOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserOrganizationsQuery, GetUserOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserOrganizationsQuery, GetUserOrganizationsQueryVariables>(GetUserOrganizationsDocument, options);
      }
export function useGetUserOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserOrganizationsQuery, GetUserOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserOrganizationsQuery, GetUserOrganizationsQueryVariables>(GetUserOrganizationsDocument, options);
        }
export function useGetUserOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserOrganizationsQuery, GetUserOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserOrganizationsQuery, GetUserOrganizationsQueryVariables>(GetUserOrganizationsDocument, options);
        }
export type GetUserOrganizationsQueryHookResult = ReturnType<typeof useGetUserOrganizationsQuery>;
export type GetUserOrganizationsLazyQueryHookResult = ReturnType<typeof useGetUserOrganizationsLazyQuery>;
export type GetUserOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetUserOrganizationsSuspenseQuery>;
export type GetUserOrganizationsQueryResult = Apollo.QueryResult<GetUserOrganizationsQuery, GetUserOrganizationsQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers($name: String, $email: citext, $order_by: [users_order_by!]) {
  users(
    where: {defaultRole: {_eq: SEEKER}, phoneNumber: {_is_null: false}, phoneNumberVerified: {_eq: true}, _not: {user_organizations: {}}, _or: [{displayName: {_ilike: $name}}, {email: {_ilike: $email}}]}
    limit: 10
    order_by: $order_by
  ) {
    id
    displayName
    avatarUrl
    email
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const CreateAgencyContractDocument = gql`
    mutation createAgencyContract($body: ManualSubscriptionInput!) {
  create_manual_subscription(body: $body) {
    subscription_id
    success
  }
}
    `;
export type CreateAgencyContractMutationFn = Apollo.MutationFunction<CreateAgencyContractMutation, CreateAgencyContractMutationVariables>;

/**
 * __useCreateAgencyContractMutation__
 *
 * To run a mutation, you first call `useCreateAgencyContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyContractMutation, { data, loading, error }] = useCreateAgencyContractMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateAgencyContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgencyContractMutation, CreateAgencyContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgencyContractMutation, CreateAgencyContractMutationVariables>(CreateAgencyContractDocument, options);
      }
export type CreateAgencyContractMutationHookResult = ReturnType<typeof useCreateAgencyContractMutation>;
export type CreateAgencyContractMutationResult = Apollo.MutationResult<CreateAgencyContractMutation>;
export type CreateAgencyContractMutationOptions = Apollo.BaseMutationOptions<CreateAgencyContractMutation, CreateAgencyContractMutationVariables>;
export const GetPlansDocument = gql`
    query getPlans {
  plan {
    id
    name
    description
    type
    organization_type
    min_members
  }
}
    `;

/**
 * __useGetPlansQuery__
 *
 * To run a query within a React component, call `useGetPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlansQuery(baseOptions?: Apollo.QueryHookOptions<GetPlansQuery, GetPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlansQuery, GetPlansQueryVariables>(GetPlansDocument, options);
      }
export function useGetPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlansQuery, GetPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlansQuery, GetPlansQueryVariables>(GetPlansDocument, options);
        }
export function useGetPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlansQuery, GetPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlansQuery, GetPlansQueryVariables>(GetPlansDocument, options);
        }
export type GetPlansQueryHookResult = ReturnType<typeof useGetPlansQuery>;
export type GetPlansLazyQueryHookResult = ReturnType<typeof useGetPlansLazyQuery>;
export type GetPlansSuspenseQueryHookResult = ReturnType<typeof useGetPlansSuspenseQuery>;
export type GetPlansQueryResult = Apollo.QueryResult<GetPlansQuery, GetPlansQueryVariables>;
export const GetCityZoneDocument = gql`
    query getCityZone($where: city_zone_bool_exp!) {
  city_zone(where: $where, order_by: {surface_area: desc}) {
    id
    bounds
    geometry
    city {
      city_name
    }
    created_at
    updated_at
    formatted_address
    location
    location_type
    place_id
    data_method
    surface_area
    types
    updated_at
    viewport
    zone_name
    is_problematic
    origin
    property_count
  }
}
    `;

/**
 * __useGetCityZoneQuery__
 *
 * To run a query within a React component, call `useGetCityZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityZoneQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCityZoneQuery(baseOptions: Apollo.QueryHookOptions<GetCityZoneQuery, GetCityZoneQueryVariables> & ({ variables: GetCityZoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCityZoneQuery, GetCityZoneQueryVariables>(GetCityZoneDocument, options);
      }
export function useGetCityZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCityZoneQuery, GetCityZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCityZoneQuery, GetCityZoneQueryVariables>(GetCityZoneDocument, options);
        }
export function useGetCityZoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCityZoneQuery, GetCityZoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCityZoneQuery, GetCityZoneQueryVariables>(GetCityZoneDocument, options);
        }
export type GetCityZoneQueryHookResult = ReturnType<typeof useGetCityZoneQuery>;
export type GetCityZoneLazyQueryHookResult = ReturnType<typeof useGetCityZoneLazyQuery>;
export type GetCityZoneSuspenseQueryHookResult = ReturnType<typeof useGetCityZoneSuspenseQuery>;
export type GetCityZoneQueryResult = Apollo.QueryResult<GetCityZoneQuery, GetCityZoneQueryVariables>;
export const GetAddressTypesDocument = gql`
    query getAddressTypes {
  address_types {
    type
  }
}
    `;

/**
 * __useGetAddressTypesQuery__
 *
 * To run a query within a React component, call `useGetAddressTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAddressTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAddressTypesQuery, GetAddressTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressTypesQuery, GetAddressTypesQueryVariables>(GetAddressTypesDocument, options);
      }
export function useGetAddressTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressTypesQuery, GetAddressTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressTypesQuery, GetAddressTypesQueryVariables>(GetAddressTypesDocument, options);
        }
export function useGetAddressTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressTypesQuery, GetAddressTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddressTypesQuery, GetAddressTypesQueryVariables>(GetAddressTypesDocument, options);
        }
export type GetAddressTypesQueryHookResult = ReturnType<typeof useGetAddressTypesQuery>;
export type GetAddressTypesLazyQueryHookResult = ReturnType<typeof useGetAddressTypesLazyQuery>;
export type GetAddressTypesSuspenseQueryHookResult = ReturnType<typeof useGetAddressTypesSuspenseQuery>;
export type GetAddressTypesQueryResult = Apollo.QueryResult<GetAddressTypesQuery, GetAddressTypesQueryVariables>;
export const GetCitiesDocument = gql`
    query getCities {
  city {
    id
    city_name
  }
}
    `;

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a React component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
      }
export function useGetCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
        }
export function useGetCitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
        }
export type GetCitiesQueryHookResult = ReturnType<typeof useGetCitiesQuery>;
export type GetCitiesLazyQueryHookResult = ReturnType<typeof useGetCitiesLazyQuery>;
export type GetCitiesSuspenseQueryHookResult = ReturnType<typeof useGetCitiesSuspenseQuery>;
export type GetCitiesQueryResult = Apollo.QueryResult<GetCitiesQuery, GetCitiesQueryVariables>;
export const GetPendingPlaceReferenceProposalsDocument = gql`
    query getPendingPlaceReferenceProposals($limit: Int!) {
  place_reference_proposal(
    where: {status: {_eq: "pending"}}
    order_by: {created_at: asc}
    limit: $limit
  ) {
    id
    kind
    canonical_name
    normalized_name
    center_lat
    center_lng
    default_radius_m
    confidence
    aliases
    evidence
    provenance
    created_at
    parent_city_zone {
      id
      zone_name
      city {
        id
        city_name
      }
    }
  }
}
    `;

/**
 * __useGetPendingPlaceReferenceProposalsQuery__
 *
 * To run a query within a React component, call `useGetPendingPlaceReferenceProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingPlaceReferenceProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingPlaceReferenceProposalsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPendingPlaceReferenceProposalsQuery(baseOptions: Apollo.QueryHookOptions<GetPendingPlaceReferenceProposalsQuery, GetPendingPlaceReferenceProposalsQueryVariables> & ({ variables: GetPendingPlaceReferenceProposalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingPlaceReferenceProposalsQuery, GetPendingPlaceReferenceProposalsQueryVariables>(GetPendingPlaceReferenceProposalsDocument, options);
      }
export function useGetPendingPlaceReferenceProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingPlaceReferenceProposalsQuery, GetPendingPlaceReferenceProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingPlaceReferenceProposalsQuery, GetPendingPlaceReferenceProposalsQueryVariables>(GetPendingPlaceReferenceProposalsDocument, options);
        }
export function useGetPendingPlaceReferenceProposalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingPlaceReferenceProposalsQuery, GetPendingPlaceReferenceProposalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingPlaceReferenceProposalsQuery, GetPendingPlaceReferenceProposalsQueryVariables>(GetPendingPlaceReferenceProposalsDocument, options);
        }
export type GetPendingPlaceReferenceProposalsQueryHookResult = ReturnType<typeof useGetPendingPlaceReferenceProposalsQuery>;
export type GetPendingPlaceReferenceProposalsLazyQueryHookResult = ReturnType<typeof useGetPendingPlaceReferenceProposalsLazyQuery>;
export type GetPendingPlaceReferenceProposalsSuspenseQueryHookResult = ReturnType<typeof useGetPendingPlaceReferenceProposalsSuspenseQuery>;
export type GetPendingPlaceReferenceProposalsQueryResult = Apollo.QueryResult<GetPendingPlaceReferenceProposalsQuery, GetPendingPlaceReferenceProposalsQueryVariables>;
export const GetCitySearchAreasDocument = gql`
    query getCitySearchAreas($cityId: uuid!, $limit: Int!) {
  city_zone(
    where: {city_id: {_eq: $cityId}, is_search_area: {_eq: true}}
    order_by: {zone_name: asc}
    limit: $limit
  ) {
    id
    zone_name
  }
}
    `;

/**
 * __useGetCitySearchAreasQuery__
 *
 * To run a query within a React component, call `useGetCitySearchAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitySearchAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitySearchAreasQuery({
 *   variables: {
 *      cityId: // value for 'cityId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCitySearchAreasQuery(baseOptions: Apollo.QueryHookOptions<GetCitySearchAreasQuery, GetCitySearchAreasQueryVariables> & ({ variables: GetCitySearchAreasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCitySearchAreasQuery, GetCitySearchAreasQueryVariables>(GetCitySearchAreasDocument, options);
      }
export function useGetCitySearchAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCitySearchAreasQuery, GetCitySearchAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCitySearchAreasQuery, GetCitySearchAreasQueryVariables>(GetCitySearchAreasDocument, options);
        }
export function useGetCitySearchAreasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCitySearchAreasQuery, GetCitySearchAreasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCitySearchAreasQuery, GetCitySearchAreasQueryVariables>(GetCitySearchAreasDocument, options);
        }
export type GetCitySearchAreasQueryHookResult = ReturnType<typeof useGetCitySearchAreasQuery>;
export type GetCitySearchAreasLazyQueryHookResult = ReturnType<typeof useGetCitySearchAreasLazyQuery>;
export type GetCitySearchAreasSuspenseQueryHookResult = ReturnType<typeof useGetCitySearchAreasSuspenseQuery>;
export type GetCitySearchAreasQueryResult = Apollo.QueryResult<GetCitySearchAreasQuery, GetCitySearchAreasQueryVariables>;
export const GetAllPropertiesDocument = gql`
    query getAllProperties($limit: Int!, $offset: Int!, $where: property_list_bool_exp!) {
  property_list(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {created_at: desc}
  ) {
    id
    source_url
    location {
      id
      geom
      city_zone {
        id
        zone_name
        city {
          city_name
        }
        formatted_address
        bounds
      }
    }
    price
  }
  property_list_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetAllPropertiesQuery__
 *
 * To run a query within a React component, call `useGetAllPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPropertiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllPropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetAllPropertiesQuery, GetAllPropertiesQueryVariables> & ({ variables: GetAllPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPropertiesQuery, GetAllPropertiesQueryVariables>(GetAllPropertiesDocument, options);
      }
export function useGetAllPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPropertiesQuery, GetAllPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPropertiesQuery, GetAllPropertiesQueryVariables>(GetAllPropertiesDocument, options);
        }
export function useGetAllPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllPropertiesQuery, GetAllPropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllPropertiesQuery, GetAllPropertiesQueryVariables>(GetAllPropertiesDocument, options);
        }
export type GetAllPropertiesQueryHookResult = ReturnType<typeof useGetAllPropertiesQuery>;
export type GetAllPropertiesLazyQueryHookResult = ReturnType<typeof useGetAllPropertiesLazyQuery>;
export type GetAllPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetAllPropertiesSuspenseQuery>;
export type GetAllPropertiesQueryResult = Apollo.QueryResult<GetAllPropertiesQuery, GetAllPropertiesQueryVariables>;
export const GetCityZonePropertiesDocument = gql`
    query getCityZoneProperties($id: uuid!) {
  property_list(where: {location: {city_zone_id: {_eq: $id}}}) {
    id
    source_url
    location {
      id
      geom
      city_zone {
        zone_name
        formatted_address
      }
    }
  }
}
    `;

/**
 * __useGetCityZonePropertiesQuery__
 *
 * To run a query within a React component, call `useGetCityZonePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityZonePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityZonePropertiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCityZonePropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetCityZonePropertiesQuery, GetCityZonePropertiesQueryVariables> & ({ variables: GetCityZonePropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCityZonePropertiesQuery, GetCityZonePropertiesQueryVariables>(GetCityZonePropertiesDocument, options);
      }
export function useGetCityZonePropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCityZonePropertiesQuery, GetCityZonePropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCityZonePropertiesQuery, GetCityZonePropertiesQueryVariables>(GetCityZonePropertiesDocument, options);
        }
export function useGetCityZonePropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCityZonePropertiesQuery, GetCityZonePropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCityZonePropertiesQuery, GetCityZonePropertiesQueryVariables>(GetCityZonePropertiesDocument, options);
        }
export type GetCityZonePropertiesQueryHookResult = ReturnType<typeof useGetCityZonePropertiesQuery>;
export type GetCityZonePropertiesLazyQueryHookResult = ReturnType<typeof useGetCityZonePropertiesLazyQuery>;
export type GetCityZonePropertiesSuspenseQueryHookResult = ReturnType<typeof useGetCityZonePropertiesSuspenseQuery>;
export type GetCityZonePropertiesQueryResult = Apollo.QueryResult<GetCityZonePropertiesQuery, GetCityZonePropertiesQueryVariables>;
export const GetZonesDocument = gql`
    query getZones($search_term: String!, $is_problematic: Boolean!, $limit: Int, $offset: Int) {
  getOrderByRelevanceCityZones(
    args: {search_term: $search_term, is_problematic: $is_problematic}
    limit: $limit
    offset: $offset
  ) {
    id
    zone_name
    city_name
  }
}
    `;

/**
 * __useGetZonesQuery__
 *
 * To run a query within a React component, call `useGetZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZonesQuery({
 *   variables: {
 *      search_term: // value for 'search_term'
 *      is_problematic: // value for 'is_problematic'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetZonesQuery(baseOptions: Apollo.QueryHookOptions<GetZonesQuery, GetZonesQueryVariables> & ({ variables: GetZonesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZonesQuery, GetZonesQueryVariables>(GetZonesDocument, options);
      }
export function useGetZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZonesQuery, GetZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZonesQuery, GetZonesQueryVariables>(GetZonesDocument, options);
        }
export function useGetZonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetZonesQuery, GetZonesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetZonesQuery, GetZonesQueryVariables>(GetZonesDocument, options);
        }
export type GetZonesQueryHookResult = ReturnType<typeof useGetZonesQuery>;
export type GetZonesLazyQueryHookResult = ReturnType<typeof useGetZonesLazyQuery>;
export type GetZonesSuspenseQueryHookResult = ReturnType<typeof useGetZonesSuspenseQuery>;
export type GetZonesQueryResult = Apollo.QueryResult<GetZonesQuery, GetZonesQueryVariables>;
export const GetPropertyListsDocument = gql`
    query getPropertyLists($where: property_list_bool_exp!, $limit: Int!, $offset: Int!) {
  property_list(where: $where, limit: $limit, offset: $offset) {
    id
    updated_at
    title_text_content {
      original_text
    }
    main_image {
      image
    }
    property {
      main_listing_id
      url_slugs {
        slug
      }
    }
    organization {
      id
      display_name
      parent {
        id
        display_name
      }
    }
    price
    sponsored
    price_currency
    property_status
    property_type
    featured
    property_source {
      id
      agency {
        id
        name
      }
    }
    location {
      id
      city_zone {
        id
        formatted_address
      }
    }
  }
  property_list_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPropertyListsQuery__
 *
 * To run a query within a React component, call `useGetPropertyListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyListsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPropertyListsQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyListsQuery, GetPropertyListsQueryVariables> & ({ variables: GetPropertyListsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyListsQuery, GetPropertyListsQueryVariables>(GetPropertyListsDocument, options);
      }
export function useGetPropertyListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyListsQuery, GetPropertyListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyListsQuery, GetPropertyListsQueryVariables>(GetPropertyListsDocument, options);
        }
export function useGetPropertyListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyListsQuery, GetPropertyListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyListsQuery, GetPropertyListsQueryVariables>(GetPropertyListsDocument, options);
        }
export type GetPropertyListsQueryHookResult = ReturnType<typeof useGetPropertyListsQuery>;
export type GetPropertyListsLazyQueryHookResult = ReturnType<typeof useGetPropertyListsLazyQuery>;
export type GetPropertyListsSuspenseQueryHookResult = ReturnType<typeof useGetPropertyListsSuspenseQuery>;
export type GetPropertyListsQueryResult = Apollo.QueryResult<GetPropertyListsQuery, GetPropertyListsQueryVariables>;
export const GetPropertyByPkDocument = gql`
    query getPropertyByPk($id: uuid!) {
  property_list_by_pk(id: $id) {
    id
    created_at
    price
    price_currency
    property_status
    parent_property
    visibility_status
    living_area
    total_area
    floor
    construction_status
    furnishing_status
    contact_name
    organization {
      id
      profile_image_url
      display_name
      phone_number
      parent {
        id
        display_name
      }
    }
    title_text_content {
      original_text
    }
    description_text_content {
      original_text
    }
    main_image {
      id
      image
      blurhash
    }
    property_images {
      id
      image
      blurhash
    }
    location {
      lat
      lng
      country
      geom
      city_zone {
        id
        formatted_address
        bounds
        city {
          display_name
        }
      }
    }
    property_composition {
      bedrooms
      bathrooms
      living_rooms
    }
    property_source {
      id
      origin
      agency {
        id
        name
      }
    }
    features_array
  }
  property_list_activity(
    where: {property_list_id: {_eq: $id}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    old_json
    new_json
  }
}
    `;

/**
 * __useGetPropertyByPkQuery__
 *
 * To run a query within a React component, call `useGetPropertyByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyByPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPropertyByPkQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyByPkQuery, GetPropertyByPkQueryVariables> & ({ variables: GetPropertyByPkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyByPkQuery, GetPropertyByPkQueryVariables>(GetPropertyByPkDocument, options);
      }
export function useGetPropertyByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyByPkQuery, GetPropertyByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyByPkQuery, GetPropertyByPkQueryVariables>(GetPropertyByPkDocument, options);
        }
export function useGetPropertyByPkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyByPkQuery, GetPropertyByPkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyByPkQuery, GetPropertyByPkQueryVariables>(GetPropertyByPkDocument, options);
        }
export type GetPropertyByPkQueryHookResult = ReturnType<typeof useGetPropertyByPkQuery>;
export type GetPropertyByPkLazyQueryHookResult = ReturnType<typeof useGetPropertyByPkLazyQuery>;
export type GetPropertyByPkSuspenseQueryHookResult = ReturnType<typeof useGetPropertyByPkSuspenseQuery>;
export type GetPropertyByPkQueryResult = Apollo.QueryResult<GetPropertyByPkQuery, GetPropertyByPkQueryVariables>;
export const GetSeoContentDocument = gql`
    query getSEOContent($where: search_slugs_bool_exp, $order_by: [search_slugs_order_by!], $offset: Int, $limit: Int) {
  search_slugs(where: $where, order_by: $order_by, offset: $offset, limit: $limit) {
    id
    slug
    header_text
    image
    zone_name
    keywords
    language_id
    updated_at
    description
    metadata
    questions
    style
    testimonials
    search_text
  }
  search_slugs_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetSeoContentQuery__
 *
 * To run a query within a React component, call `useGetSeoContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeoContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeoContentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSeoContentQuery(baseOptions?: Apollo.QueryHookOptions<GetSeoContentQuery, GetSeoContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeoContentQuery, GetSeoContentQueryVariables>(GetSeoContentDocument, options);
      }
export function useGetSeoContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeoContentQuery, GetSeoContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeoContentQuery, GetSeoContentQueryVariables>(GetSeoContentDocument, options);
        }
export function useGetSeoContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSeoContentQuery, GetSeoContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSeoContentQuery, GetSeoContentQueryVariables>(GetSeoContentDocument, options);
        }
export type GetSeoContentQueryHookResult = ReturnType<typeof useGetSeoContentQuery>;
export type GetSeoContentLazyQueryHookResult = ReturnType<typeof useGetSeoContentLazyQuery>;
export type GetSeoContentSuspenseQueryHookResult = ReturnType<typeof useGetSeoContentSuspenseQuery>;
export type GetSeoContentQueryResult = Apollo.QueryResult<GetSeoContentQuery, GetSeoContentQueryVariables>;
export const GetPropertyReportsPaginatedDocument = gql`
    query getPropertyReportsPaginated($where: property_list_report_bool_exp, $limit: Int, $offset: Int, $order_by: [property_list_report_order_by!]) {
  property_list_report(
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    id
    created_at
    phone
    email
    description
    reporty_type
    user {
      id
      displayName
      email
      avatarUrl
    }
    property_list {
      id
      visibility_status
      main_image {
        image
      }
      title_text_content {
        translations {
          translation
        }
      }
      property {
        url_slugs {
          slug
        }
      }
    }
  }
  property_list_report_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPropertyReportsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetPropertyReportsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyReportsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyReportsPaginatedQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetPropertyReportsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertyReportsPaginatedQuery, GetPropertyReportsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyReportsPaginatedQuery, GetPropertyReportsPaginatedQueryVariables>(GetPropertyReportsPaginatedDocument, options);
      }
export function useGetPropertyReportsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyReportsPaginatedQuery, GetPropertyReportsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyReportsPaginatedQuery, GetPropertyReportsPaginatedQueryVariables>(GetPropertyReportsPaginatedDocument, options);
        }
export function useGetPropertyReportsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyReportsPaginatedQuery, GetPropertyReportsPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyReportsPaginatedQuery, GetPropertyReportsPaginatedQueryVariables>(GetPropertyReportsPaginatedDocument, options);
        }
export type GetPropertyReportsPaginatedQueryHookResult = ReturnType<typeof useGetPropertyReportsPaginatedQuery>;
export type GetPropertyReportsPaginatedLazyQueryHookResult = ReturnType<typeof useGetPropertyReportsPaginatedLazyQuery>;
export type GetPropertyReportsPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetPropertyReportsPaginatedSuspenseQuery>;
export type GetPropertyReportsPaginatedQueryResult = Apollo.QueryResult<GetPropertyReportsPaginatedQuery, GetPropertyReportsPaginatedQueryVariables>;
export const GetSeoCityDocument = gql`
    query getSEOCity($where: seo_city_bool_exp!, $order_by: [seo_city_order_by!], $offset: Int, $limit: Int) {
  seo_city(where: $where, order_by: $order_by, offset: $offset, limit: $limit) {
    id
    slug
    city_name
    al_metadata
    en_metadata
    al_sections
    en_sections
    updated_at
  }
  seo_city_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetSeoCityQuery__
 *
 * To run a query within a React component, call `useGetSeoCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeoCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeoCityQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSeoCityQuery(baseOptions: Apollo.QueryHookOptions<GetSeoCityQuery, GetSeoCityQueryVariables> & ({ variables: GetSeoCityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeoCityQuery, GetSeoCityQueryVariables>(GetSeoCityDocument, options);
      }
export function useGetSeoCityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeoCityQuery, GetSeoCityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeoCityQuery, GetSeoCityQueryVariables>(GetSeoCityDocument, options);
        }
export function useGetSeoCitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSeoCityQuery, GetSeoCityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSeoCityQuery, GetSeoCityQueryVariables>(GetSeoCityDocument, options);
        }
export type GetSeoCityQueryHookResult = ReturnType<typeof useGetSeoCityQuery>;
export type GetSeoCityLazyQueryHookResult = ReturnType<typeof useGetSeoCityLazyQuery>;
export type GetSeoCitySuspenseQueryHookResult = ReturnType<typeof useGetSeoCitySuspenseQuery>;
export type GetSeoCityQueryResult = Apollo.QueryResult<GetSeoCityQuery, GetSeoCityQueryVariables>;
export const GetBlogPostsDocument = gql`
    query getBlogPosts($where: blog_post_bool_exp!, $order_by: [blog_post_order_by!], $offset: Int, $limit: Int) {
  blog_post(where: $where, order_by: $order_by, offset: $offset, limit: $limit) {
    ...BlogPost
  }
  blog_post_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${BlogPostFragmentDoc}`;

/**
 * __useGetBlogPostsQuery__
 *
 * To run a query within a React component, call `useGetBlogPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlogPostsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBlogPostsQuery(baseOptions: Apollo.QueryHookOptions<GetBlogPostsQuery, GetBlogPostsQueryVariables> & ({ variables: GetBlogPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlogPostsQuery, GetBlogPostsQueryVariables>(GetBlogPostsDocument, options);
      }
export function useGetBlogPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlogPostsQuery, GetBlogPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlogPostsQuery, GetBlogPostsQueryVariables>(GetBlogPostsDocument, options);
        }
export function useGetBlogPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBlogPostsQuery, GetBlogPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlogPostsQuery, GetBlogPostsQueryVariables>(GetBlogPostsDocument, options);
        }
export type GetBlogPostsQueryHookResult = ReturnType<typeof useGetBlogPostsQuery>;
export type GetBlogPostsLazyQueryHookResult = ReturnType<typeof useGetBlogPostsLazyQuery>;
export type GetBlogPostsSuspenseQueryHookResult = ReturnType<typeof useGetBlogPostsSuspenseQuery>;
export type GetBlogPostsQueryResult = Apollo.QueryResult<GetBlogPostsQuery, GetBlogPostsQueryVariables>;
export const GetBlogPostByIdDocument = gql`
    query getBlogPostById($id: uuid!) {
  blog_post_by_pk(id: $id) {
    ...BlogPost
  }
}
    ${BlogPostFragmentDoc}`;

/**
 * __useGetBlogPostByIdQuery__
 *
 * To run a query within a React component, call `useGetBlogPostByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogPostByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlogPostByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlogPostByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBlogPostByIdQuery, GetBlogPostByIdQueryVariables> & ({ variables: GetBlogPostByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlogPostByIdQuery, GetBlogPostByIdQueryVariables>(GetBlogPostByIdDocument, options);
      }
export function useGetBlogPostByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlogPostByIdQuery, GetBlogPostByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlogPostByIdQuery, GetBlogPostByIdQueryVariables>(GetBlogPostByIdDocument, options);
        }
export function useGetBlogPostByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBlogPostByIdQuery, GetBlogPostByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlogPostByIdQuery, GetBlogPostByIdQueryVariables>(GetBlogPostByIdDocument, options);
        }
export type GetBlogPostByIdQueryHookResult = ReturnType<typeof useGetBlogPostByIdQuery>;
export type GetBlogPostByIdLazyQueryHookResult = ReturnType<typeof useGetBlogPostByIdLazyQuery>;
export type GetBlogPostByIdSuspenseQueryHookResult = ReturnType<typeof useGetBlogPostByIdSuspenseQuery>;
export type GetBlogPostByIdQueryResult = Apollo.QueryResult<GetBlogPostByIdQuery, GetBlogPostByIdQueryVariables>;
export const GetBlogPostsPaginatedDocument = gql`
    query getBlogPostsPaginated($limit: Int!, $offset: Int!, $where: blog_post_bool_exp = {}) {
  blog_post(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {created_at: desc}
  ) {
    ...BlogPost
  }
  blog_post_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${BlogPostFragmentDoc}`;

/**
 * __useGetBlogPostsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetBlogPostsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogPostsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlogPostsPaginatedQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetBlogPostsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetBlogPostsPaginatedQuery, GetBlogPostsPaginatedQueryVariables> & ({ variables: GetBlogPostsPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlogPostsPaginatedQuery, GetBlogPostsPaginatedQueryVariables>(GetBlogPostsPaginatedDocument, options);
      }
export function useGetBlogPostsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlogPostsPaginatedQuery, GetBlogPostsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlogPostsPaginatedQuery, GetBlogPostsPaginatedQueryVariables>(GetBlogPostsPaginatedDocument, options);
        }
export function useGetBlogPostsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBlogPostsPaginatedQuery, GetBlogPostsPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlogPostsPaginatedQuery, GetBlogPostsPaginatedQueryVariables>(GetBlogPostsPaginatedDocument, options);
        }
export type GetBlogPostsPaginatedQueryHookResult = ReturnType<typeof useGetBlogPostsPaginatedQuery>;
export type GetBlogPostsPaginatedLazyQueryHookResult = ReturnType<typeof useGetBlogPostsPaginatedLazyQuery>;
export type GetBlogPostsPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetBlogPostsPaginatedSuspenseQuery>;
export type GetBlogPostsPaginatedQueryResult = Apollo.QueryResult<GetBlogPostsPaginatedQuery, GetBlogPostsPaginatedQueryVariables>;
export const GetSeoBlogsDocument = gql`
    query getSEOBlogs($where: blog_bool_exp!, $order_by: [blog_order_by!], $offset: Int, $limit: Int) {
  blog(where: $where, order_by: $order_by, offset: $offset, limit: $limit) {
    id
    slug
    status
    al_metadata
    al_sections
    updated_at
  }
  blog_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetSeoBlogsQuery__
 *
 * To run a query within a React component, call `useGetSeoBlogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeoBlogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeoBlogsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSeoBlogsQuery(baseOptions: Apollo.QueryHookOptions<GetSeoBlogsQuery, GetSeoBlogsQueryVariables> & ({ variables: GetSeoBlogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeoBlogsQuery, GetSeoBlogsQueryVariables>(GetSeoBlogsDocument, options);
      }
export function useGetSeoBlogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeoBlogsQuery, GetSeoBlogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeoBlogsQuery, GetSeoBlogsQueryVariables>(GetSeoBlogsDocument, options);
        }
export function useGetSeoBlogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSeoBlogsQuery, GetSeoBlogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSeoBlogsQuery, GetSeoBlogsQueryVariables>(GetSeoBlogsDocument, options);
        }
export type GetSeoBlogsQueryHookResult = ReturnType<typeof useGetSeoBlogsQuery>;
export type GetSeoBlogsLazyQueryHookResult = ReturnType<typeof useGetSeoBlogsLazyQuery>;
export type GetSeoBlogsSuspenseQueryHookResult = ReturnType<typeof useGetSeoBlogsSuspenseQuery>;
export type GetSeoBlogsQueryResult = Apollo.QueryResult<GetSeoBlogsQuery, GetSeoBlogsQueryVariables>;
export const GetPropertyBySlugDocument = gql`
    query getPropertyBySlug($slug: String!, $limit: Int, $offset: Int) {
  url_slug(where: {slug: {_eq: $slug}}) {
    slug
    property {
      id
      main_property {
        id
      }
      property_lists_aggregate(where: {visibility_status: {_eq: active}}) {
        aggregate {
          count
        }
      }
      property_lists(
        where: {visibility_status: {_eq: active}}
        order_by: {created_at: desc}
        limit: $limit
        offset: $offset
      ) {
        id
        price
        price_currency
        last_seen
        property_type
        property_status
        featured
        property_source {
          id
          agency {
            id
            name
          }
        }
        property {
          id
          main_listing_id
          url_slugs {
            slug
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPropertyBySlugQuery__
 *
 * To run a query within a React component, call `useGetPropertyBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPropertyBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyBySlugQuery, GetPropertyBySlugQueryVariables> & ({ variables: GetPropertyBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyBySlugQuery, GetPropertyBySlugQueryVariables>(GetPropertyBySlugDocument, options);
      }
export function useGetPropertyBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyBySlugQuery, GetPropertyBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyBySlugQuery, GetPropertyBySlugQueryVariables>(GetPropertyBySlugDocument, options);
        }
export function useGetPropertyBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyBySlugQuery, GetPropertyBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyBySlugQuery, GetPropertyBySlugQueryVariables>(GetPropertyBySlugDocument, options);
        }
export type GetPropertyBySlugQueryHookResult = ReturnType<typeof useGetPropertyBySlugQuery>;
export type GetPropertyBySlugLazyQueryHookResult = ReturnType<typeof useGetPropertyBySlugLazyQuery>;
export type GetPropertyBySlugSuspenseQueryHookResult = ReturnType<typeof useGetPropertyBySlugSuspenseQuery>;
export type GetPropertyBySlugQueryResult = Apollo.QueryResult<GetPropertyBySlugQuery, GetPropertyBySlugQueryVariables>;
export const GetSearchSlugsDocument = gql`
    query getSearchSlugs {
  search_slugs(where: {sitemap_process: {_eq: false}}) {
    id
    image
    description
    language_id
    slug
    header_text
    search_session {
      id
      title
      natural_language_queries(order_by: {created_at: desc}, limit: 1) {
        id
        query
        queries_property_results_aggregate {
          aggregate {
            count
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSearchSlugsQuery__
 *
 * To run a query within a React component, call `useGetSearchSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchSlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSearchSlugsQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchSlugsQuery, GetSearchSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchSlugsQuery, GetSearchSlugsQueryVariables>(GetSearchSlugsDocument, options);
      }
export function useGetSearchSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchSlugsQuery, GetSearchSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchSlugsQuery, GetSearchSlugsQueryVariables>(GetSearchSlugsDocument, options);
        }
export function useGetSearchSlugsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchSlugsQuery, GetSearchSlugsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchSlugsQuery, GetSearchSlugsQueryVariables>(GetSearchSlugsDocument, options);
        }
export type GetSearchSlugsQueryHookResult = ReturnType<typeof useGetSearchSlugsQuery>;
export type GetSearchSlugsLazyQueryHookResult = ReturnType<typeof useGetSearchSlugsLazyQuery>;
export type GetSearchSlugsSuspenseQueryHookResult = ReturnType<typeof useGetSearchSlugsSuspenseQuery>;
export type GetSearchSlugsQueryResult = Apollo.QueryResult<GetSearchSlugsQuery, GetSearchSlugsQueryVariables>;
export const GetSearchSlugByIdDocument = gql`
    query getSearchSlugById($id: uuid!, $limit: Int!, $offset: Int!) {
  search_slugs_by_pk(id: $id) {
    id
    slug
    description
    image
    header_text
    language_id
    metadata
    style
    questions
    session_id
    search_session {
      id
      title
      natural_language_queries(order_by: {created_at: desc}, limit: 1) {
        id
        query
        queries_property_results(
          limit: $limit
          offset: $offset
          order_by: {created_at: desc}
        ) {
          property {
            id
            main_property {
              id
              price
              price_currency
              property_type
              property_status
              featured
              property_source {
                id
                agency {
                  id
                  name
                }
              }
              property {
                id
                main_listing_id
                url_slugs {
                  slug
                }
              }
            }
          }
        }
        queries_property_results_aggregate {
          aggregate {
            count
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSearchSlugByIdQuery__
 *
 * To run a query within a React component, call `useGetSearchSlugByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchSlugByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchSlugByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSearchSlugByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSearchSlugByIdQuery, GetSearchSlugByIdQueryVariables> & ({ variables: GetSearchSlugByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchSlugByIdQuery, GetSearchSlugByIdQueryVariables>(GetSearchSlugByIdDocument, options);
      }
export function useGetSearchSlugByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchSlugByIdQuery, GetSearchSlugByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchSlugByIdQuery, GetSearchSlugByIdQueryVariables>(GetSearchSlugByIdDocument, options);
        }
export function useGetSearchSlugByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchSlugByIdQuery, GetSearchSlugByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchSlugByIdQuery, GetSearchSlugByIdQueryVariables>(GetSearchSlugByIdDocument, options);
        }
export type GetSearchSlugByIdQueryHookResult = ReturnType<typeof useGetSearchSlugByIdQuery>;
export type GetSearchSlugByIdLazyQueryHookResult = ReturnType<typeof useGetSearchSlugByIdLazyQuery>;
export type GetSearchSlugByIdSuspenseQueryHookResult = ReturnType<typeof useGetSearchSlugByIdSuspenseQuery>;
export type GetSearchSlugByIdQueryResult = Apollo.QueryResult<GetSearchSlugByIdQuery, GetSearchSlugByIdQueryVariables>;
export const GetPropertyResultAggregateForNlqDocument = gql`
    query getPropertyResultAggregateForNlq($nlqId: uuid!, $propertyId: uuid!) {
  queries_property_result_aggregate(
    where: {natural_language_query_id: {_eq: $nlqId}, property_id: {_eq: $propertyId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPropertyResultAggregateForNlqQuery__
 *
 * To run a query within a React component, call `useGetPropertyResultAggregateForNlqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyResultAggregateForNlqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyResultAggregateForNlqQuery({
 *   variables: {
 *      nlqId: // value for 'nlqId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetPropertyResultAggregateForNlqQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyResultAggregateForNlqQuery, GetPropertyResultAggregateForNlqQueryVariables> & ({ variables: GetPropertyResultAggregateForNlqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyResultAggregateForNlqQuery, GetPropertyResultAggregateForNlqQueryVariables>(GetPropertyResultAggregateForNlqDocument, options);
      }
export function useGetPropertyResultAggregateForNlqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyResultAggregateForNlqQuery, GetPropertyResultAggregateForNlqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyResultAggregateForNlqQuery, GetPropertyResultAggregateForNlqQueryVariables>(GetPropertyResultAggregateForNlqDocument, options);
        }
export function useGetPropertyResultAggregateForNlqSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyResultAggregateForNlqQuery, GetPropertyResultAggregateForNlqQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyResultAggregateForNlqQuery, GetPropertyResultAggregateForNlqQueryVariables>(GetPropertyResultAggregateForNlqDocument, options);
        }
export type GetPropertyResultAggregateForNlqQueryHookResult = ReturnType<typeof useGetPropertyResultAggregateForNlqQuery>;
export type GetPropertyResultAggregateForNlqLazyQueryHookResult = ReturnType<typeof useGetPropertyResultAggregateForNlqLazyQuery>;
export type GetPropertyResultAggregateForNlqSuspenseQueryHookResult = ReturnType<typeof useGetPropertyResultAggregateForNlqSuspenseQuery>;
export type GetPropertyResultAggregateForNlqQueryResult = Apollo.QueryResult<GetPropertyResultAggregateForNlqQuery, GetPropertyResultAggregateForNlqQueryVariables>;
export const PlatformOverviewDocument = gql`
    query platformOverview($usersWhere: users_bool_exp, $propertiesWhere: property_bool_exp) {
  usersAggregate(where: $usersWhere) {
    aggregate {
      count
    }
  }
  property_aggregate(where: $propertiesWhere) {
    aggregate {
      count
    }
  }
  natural_language_queries_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __usePlatformOverviewQuery__
 *
 * To run a query within a React component, call `usePlatformOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformOverviewQuery({
 *   variables: {
 *      usersWhere: // value for 'usersWhere'
 *      propertiesWhere: // value for 'propertiesWhere'
 *   },
 * });
 */
export function usePlatformOverviewQuery(baseOptions?: Apollo.QueryHookOptions<PlatformOverviewQuery, PlatformOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformOverviewQuery, PlatformOverviewQueryVariables>(PlatformOverviewDocument, options);
      }
export function usePlatformOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformOverviewQuery, PlatformOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformOverviewQuery, PlatformOverviewQueryVariables>(PlatformOverviewDocument, options);
        }
export function usePlatformOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformOverviewQuery, PlatformOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformOverviewQuery, PlatformOverviewQueryVariables>(PlatformOverviewDocument, options);
        }
export type PlatformOverviewQueryHookResult = ReturnType<typeof usePlatformOverviewQuery>;
export type PlatformOverviewLazyQueryHookResult = ReturnType<typeof usePlatformOverviewLazyQuery>;
export type PlatformOverviewSuspenseQueryHookResult = ReturnType<typeof usePlatformOverviewSuspenseQuery>;
export type PlatformOverviewQueryResult = Apollo.QueryResult<PlatformOverviewQuery, PlatformOverviewQueryVariables>;
export const GetClassifiedPropertiesDocument = gql`
    query getClassifiedProperties($start_date: date!, $end_date: date!) {
  classifiedProperties(args: {start_date: $start_date, end_date: $end_date}) {
    report_date
    scraped_properties
    kaktu_properties
  }
}
    `;

/**
 * __useGetClassifiedPropertiesQuery__
 *
 * To run a query within a React component, call `useGetClassifiedPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassifiedPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassifiedPropertiesQuery({
 *   variables: {
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *   },
 * });
 */
export function useGetClassifiedPropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetClassifiedPropertiesQuery, GetClassifiedPropertiesQueryVariables> & ({ variables: GetClassifiedPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassifiedPropertiesQuery, GetClassifiedPropertiesQueryVariables>(GetClassifiedPropertiesDocument, options);
      }
export function useGetClassifiedPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassifiedPropertiesQuery, GetClassifiedPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassifiedPropertiesQuery, GetClassifiedPropertiesQueryVariables>(GetClassifiedPropertiesDocument, options);
        }
export function useGetClassifiedPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassifiedPropertiesQuery, GetClassifiedPropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClassifiedPropertiesQuery, GetClassifiedPropertiesQueryVariables>(GetClassifiedPropertiesDocument, options);
        }
export type GetClassifiedPropertiesQueryHookResult = ReturnType<typeof useGetClassifiedPropertiesQuery>;
export type GetClassifiedPropertiesLazyQueryHookResult = ReturnType<typeof useGetClassifiedPropertiesLazyQuery>;
export type GetClassifiedPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetClassifiedPropertiesSuspenseQuery>;
export type GetClassifiedPropertiesQueryResult = Apollo.QueryResult<GetClassifiedPropertiesQuery, GetClassifiedPropertiesQueryVariables>;
export const GetDailyActiveUsersDocument = gql`
    query getDailyActiveUsers($start_date: date!, $end_date: date!) {
  daliyActiveUsers(args: {start_date: $start_date, end_date: $end_date}) {
    agencies_nr
    listers_nr
    seeker_nr
    report_date
  }
}
    `;

/**
 * __useGetDailyActiveUsersQuery__
 *
 * To run a query within a React component, call `useGetDailyActiveUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyActiveUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyActiveUsersQuery({
 *   variables: {
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *   },
 * });
 */
export function useGetDailyActiveUsersQuery(baseOptions: Apollo.QueryHookOptions<GetDailyActiveUsersQuery, GetDailyActiveUsersQueryVariables> & ({ variables: GetDailyActiveUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyActiveUsersQuery, GetDailyActiveUsersQueryVariables>(GetDailyActiveUsersDocument, options);
      }
export function useGetDailyActiveUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyActiveUsersQuery, GetDailyActiveUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyActiveUsersQuery, GetDailyActiveUsersQueryVariables>(GetDailyActiveUsersDocument, options);
        }
export function useGetDailyActiveUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDailyActiveUsersQuery, GetDailyActiveUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDailyActiveUsersQuery, GetDailyActiveUsersQueryVariables>(GetDailyActiveUsersDocument, options);
        }
export type GetDailyActiveUsersQueryHookResult = ReturnType<typeof useGetDailyActiveUsersQuery>;
export type GetDailyActiveUsersLazyQueryHookResult = ReturnType<typeof useGetDailyActiveUsersLazyQuery>;
export type GetDailyActiveUsersSuspenseQueryHookResult = ReturnType<typeof useGetDailyActiveUsersSuspenseQuery>;
export type GetDailyActiveUsersQueryResult = Apollo.QueryResult<GetDailyActiveUsersQuery, GetDailyActiveUsersQueryVariables>;
export const GetDailyRegisteredUsersDocument = gql`
    query getDailyRegisteredUsers($start_date: date!, $end_date: date!) {
  dailyRegisteredUsers(args: {start_date: $start_date, end_date: $end_date}) {
    agencies_nr
    listers_nr
    seeker_nr
    report_date
  }
}
    `;

/**
 * __useGetDailyRegisteredUsersQuery__
 *
 * To run a query within a React component, call `useGetDailyRegisteredUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyRegisteredUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyRegisteredUsersQuery({
 *   variables: {
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *   },
 * });
 */
export function useGetDailyRegisteredUsersQuery(baseOptions: Apollo.QueryHookOptions<GetDailyRegisteredUsersQuery, GetDailyRegisteredUsersQueryVariables> & ({ variables: GetDailyRegisteredUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyRegisteredUsersQuery, GetDailyRegisteredUsersQueryVariables>(GetDailyRegisteredUsersDocument, options);
      }
export function useGetDailyRegisteredUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyRegisteredUsersQuery, GetDailyRegisteredUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyRegisteredUsersQuery, GetDailyRegisteredUsersQueryVariables>(GetDailyRegisteredUsersDocument, options);
        }
export function useGetDailyRegisteredUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDailyRegisteredUsersQuery, GetDailyRegisteredUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDailyRegisteredUsersQuery, GetDailyRegisteredUsersQueryVariables>(GetDailyRegisteredUsersDocument, options);
        }
export type GetDailyRegisteredUsersQueryHookResult = ReturnType<typeof useGetDailyRegisteredUsersQuery>;
export type GetDailyRegisteredUsersLazyQueryHookResult = ReturnType<typeof useGetDailyRegisteredUsersLazyQuery>;
export type GetDailyRegisteredUsersSuspenseQueryHookResult = ReturnType<typeof useGetDailyRegisteredUsersSuspenseQuery>;
export type GetDailyRegisteredUsersQueryResult = Apollo.QueryResult<GetDailyRegisteredUsersQuery, GetDailyRegisteredUsersQueryVariables>;
export const GetRegionalPropertyDistributionDocument = gql`
    query getRegionalPropertyDistribution($property_status: String!, $property_type: String!) {
  regionalPropertyDistribution(
    args: {property_status: $property_status, property_type: $property_type}
  ) {
    city_name
    avg_price_eur
    total_properties
  }
}
    `;

/**
 * __useGetRegionalPropertyDistributionQuery__
 *
 * To run a query within a React component, call `useGetRegionalPropertyDistributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionalPropertyDistributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionalPropertyDistributionQuery({
 *   variables: {
 *      property_status: // value for 'property_status'
 *      property_type: // value for 'property_type'
 *   },
 * });
 */
export function useGetRegionalPropertyDistributionQuery(baseOptions: Apollo.QueryHookOptions<GetRegionalPropertyDistributionQuery, GetRegionalPropertyDistributionQueryVariables> & ({ variables: GetRegionalPropertyDistributionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionalPropertyDistributionQuery, GetRegionalPropertyDistributionQueryVariables>(GetRegionalPropertyDistributionDocument, options);
      }
export function useGetRegionalPropertyDistributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionalPropertyDistributionQuery, GetRegionalPropertyDistributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionalPropertyDistributionQuery, GetRegionalPropertyDistributionQueryVariables>(GetRegionalPropertyDistributionDocument, options);
        }
export function useGetRegionalPropertyDistributionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionalPropertyDistributionQuery, GetRegionalPropertyDistributionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionalPropertyDistributionQuery, GetRegionalPropertyDistributionQueryVariables>(GetRegionalPropertyDistributionDocument, options);
        }
export type GetRegionalPropertyDistributionQueryHookResult = ReturnType<typeof useGetRegionalPropertyDistributionQuery>;
export type GetRegionalPropertyDistributionLazyQueryHookResult = ReturnType<typeof useGetRegionalPropertyDistributionLazyQuery>;
export type GetRegionalPropertyDistributionSuspenseQueryHookResult = ReturnType<typeof useGetRegionalPropertyDistributionSuspenseQuery>;
export type GetRegionalPropertyDistributionQueryResult = Apollo.QueryResult<GetRegionalPropertyDistributionQuery, GetRegionalPropertyDistributionQueryVariables>;
export const GetPropertyTypesDistributionDocument = gql`
    query getPropertyTypesDistribution {
  propertyTypesDistribution {
    total_properties
    percentage
    cluster
  }
}
    `;

/**
 * __useGetPropertyTypesDistributionQuery__
 *
 * To run a query within a React component, call `useGetPropertyTypesDistributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyTypesDistributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyTypesDistributionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPropertyTypesDistributionQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertyTypesDistributionQuery, GetPropertyTypesDistributionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyTypesDistributionQuery, GetPropertyTypesDistributionQueryVariables>(GetPropertyTypesDistributionDocument, options);
      }
export function useGetPropertyTypesDistributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyTypesDistributionQuery, GetPropertyTypesDistributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyTypesDistributionQuery, GetPropertyTypesDistributionQueryVariables>(GetPropertyTypesDistributionDocument, options);
        }
export function useGetPropertyTypesDistributionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyTypesDistributionQuery, GetPropertyTypesDistributionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyTypesDistributionQuery, GetPropertyTypesDistributionQueryVariables>(GetPropertyTypesDistributionDocument, options);
        }
export type GetPropertyTypesDistributionQueryHookResult = ReturnType<typeof useGetPropertyTypesDistributionQuery>;
export type GetPropertyTypesDistributionLazyQueryHookResult = ReturnType<typeof useGetPropertyTypesDistributionLazyQuery>;
export type GetPropertyTypesDistributionSuspenseQueryHookResult = ReturnType<typeof useGetPropertyTypesDistributionSuspenseQuery>;
export type GetPropertyTypesDistributionQueryResult = Apollo.QueryResult<GetPropertyTypesDistributionQuery, GetPropertyTypesDistributionQueryVariables>;
export const GetAgencyScrapedPropertiesDocument = gql`
    query getAgencyScrapedProperties {
  agencyScrapedProperties {
    total_properties
    agency_name
  }
}
    `;

/**
 * __useGetAgencyScrapedPropertiesQuery__
 *
 * To run a query within a React component, call `useGetAgencyScrapedPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyScrapedPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyScrapedPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyScrapedPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyScrapedPropertiesQuery, GetAgencyScrapedPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyScrapedPropertiesQuery, GetAgencyScrapedPropertiesQueryVariables>(GetAgencyScrapedPropertiesDocument, options);
      }
export function useGetAgencyScrapedPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyScrapedPropertiesQuery, GetAgencyScrapedPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyScrapedPropertiesQuery, GetAgencyScrapedPropertiesQueryVariables>(GetAgencyScrapedPropertiesDocument, options);
        }
export function useGetAgencyScrapedPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyScrapedPropertiesQuery, GetAgencyScrapedPropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyScrapedPropertiesQuery, GetAgencyScrapedPropertiesQueryVariables>(GetAgencyScrapedPropertiesDocument, options);
        }
export type GetAgencyScrapedPropertiesQueryHookResult = ReturnType<typeof useGetAgencyScrapedPropertiesQuery>;
export type GetAgencyScrapedPropertiesLazyQueryHookResult = ReturnType<typeof useGetAgencyScrapedPropertiesLazyQuery>;
export type GetAgencyScrapedPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetAgencyScrapedPropertiesSuspenseQuery>;
export type GetAgencyScrapedPropertiesQueryResult = Apollo.QueryResult<GetAgencyScrapedPropertiesQuery, GetAgencyScrapedPropertiesQueryVariables>;
export const GetFavoritePropertiesTrendDocument = gql`
    query getFavoritePropertiesTrend($start_date: date!, $end_date: date!) {
  favouritePropertiesTrend(args: {start_date: $start_date, end_date: $end_date}) {
    report_date
    properties_added
    properties_removed
  }
}
    `;

/**
 * __useGetFavoritePropertiesTrendQuery__
 *
 * To run a query within a React component, call `useGetFavoritePropertiesTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritePropertiesTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritePropertiesTrendQuery({
 *   variables: {
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *   },
 * });
 */
export function useGetFavoritePropertiesTrendQuery(baseOptions: Apollo.QueryHookOptions<GetFavoritePropertiesTrendQuery, GetFavoritePropertiesTrendQueryVariables> & ({ variables: GetFavoritePropertiesTrendQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoritePropertiesTrendQuery, GetFavoritePropertiesTrendQueryVariables>(GetFavoritePropertiesTrendDocument, options);
      }
export function useGetFavoritePropertiesTrendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoritePropertiesTrendQuery, GetFavoritePropertiesTrendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoritePropertiesTrendQuery, GetFavoritePropertiesTrendQueryVariables>(GetFavoritePropertiesTrendDocument, options);
        }
export function useGetFavoritePropertiesTrendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFavoritePropertiesTrendQuery, GetFavoritePropertiesTrendQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFavoritePropertiesTrendQuery, GetFavoritePropertiesTrendQueryVariables>(GetFavoritePropertiesTrendDocument, options);
        }
export type GetFavoritePropertiesTrendQueryHookResult = ReturnType<typeof useGetFavoritePropertiesTrendQuery>;
export type GetFavoritePropertiesTrendLazyQueryHookResult = ReturnType<typeof useGetFavoritePropertiesTrendLazyQuery>;
export type GetFavoritePropertiesTrendSuspenseQueryHookResult = ReturnType<typeof useGetFavoritePropertiesTrendSuspenseQuery>;
export type GetFavoritePropertiesTrendQueryResult = Apollo.QueryResult<GetFavoritePropertiesTrendQuery, GetFavoritePropertiesTrendQueryVariables>;
export const GetDailyQueriesStatisticsDocument = gql`
    query getDailyQueriesStatistics($start_date: date!, $end_date: date!) {
  daliyQueriesStatistics(args: {start_date: $start_date, end_date: $end_date}) {
    total_queries
    report_date
  }
}
    `;

/**
 * __useGetDailyQueriesStatisticsQuery__
 *
 * To run a query within a React component, call `useGetDailyQueriesStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyQueriesStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyQueriesStatisticsQuery({
 *   variables: {
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *   },
 * });
 */
export function useGetDailyQueriesStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyQueriesStatisticsQuery, GetDailyQueriesStatisticsQueryVariables> & ({ variables: GetDailyQueriesStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyQueriesStatisticsQuery, GetDailyQueriesStatisticsQueryVariables>(GetDailyQueriesStatisticsDocument, options);
      }
export function useGetDailyQueriesStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyQueriesStatisticsQuery, GetDailyQueriesStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyQueriesStatisticsQuery, GetDailyQueriesStatisticsQueryVariables>(GetDailyQueriesStatisticsDocument, options);
        }
export function useGetDailyQueriesStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDailyQueriesStatisticsQuery, GetDailyQueriesStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDailyQueriesStatisticsQuery, GetDailyQueriesStatisticsQueryVariables>(GetDailyQueriesStatisticsDocument, options);
        }
export type GetDailyQueriesStatisticsQueryHookResult = ReturnType<typeof useGetDailyQueriesStatisticsQuery>;
export type GetDailyQueriesStatisticsLazyQueryHookResult = ReturnType<typeof useGetDailyQueriesStatisticsLazyQuery>;
export type GetDailyQueriesStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetDailyQueriesStatisticsSuspenseQuery>;
export type GetDailyQueriesStatisticsQueryResult = Apollo.QueryResult<GetDailyQueriesStatisticsQuery, GetDailyQueriesStatisticsQueryVariables>;
export const GetUsersDashboardDocument = gql`
    query getUsersDashboard($limit: Int!, $offset: Int!, $order_by_type: String!) {
  get_user_activity(
    args: {order_by_type: $order_by_type}
    limit: $limit
    offset: $offset
  ) {
    user_id
    display_name
    email
    last_seen
    nr_sessions
    nr_notifications
  }
  get_user_activity_aggregate(args: {order_by_type: $order_by_type}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUsersDashboardQuery__
 *
 * To run a query within a React component, call `useGetUsersDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersDashboardQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by_type: // value for 'order_by_type'
 *   },
 * });
 */
export function useGetUsersDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetUsersDashboardQuery, GetUsersDashboardQueryVariables> & ({ variables: GetUsersDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersDashboardQuery, GetUsersDashboardQueryVariables>(GetUsersDashboardDocument, options);
      }
export function useGetUsersDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersDashboardQuery, GetUsersDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersDashboardQuery, GetUsersDashboardQueryVariables>(GetUsersDashboardDocument, options);
        }
export function useGetUsersDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersDashboardQuery, GetUsersDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersDashboardQuery, GetUsersDashboardQueryVariables>(GetUsersDashboardDocument, options);
        }
export type GetUsersDashboardQueryHookResult = ReturnType<typeof useGetUsersDashboardQuery>;
export type GetUsersDashboardLazyQueryHookResult = ReturnType<typeof useGetUsersDashboardLazyQuery>;
export type GetUsersDashboardSuspenseQueryHookResult = ReturnType<typeof useGetUsersDashboardSuspenseQuery>;
export type GetUsersDashboardQueryResult = Apollo.QueryResult<GetUsersDashboardQuery, GetUsersDashboardQueryVariables>;
export const GetSearchSessionsDocument = gql`
    query getSearchSessions($limit: Int, $offset: Int, $user_id: uuid!) {
  search_sessions_sorted_by_last_query(
    args: {p_limit: $limit, p_offset: $offset, p_user_id: $user_id}
  ) {
    id
    natural_language_queries_aggregate {
      aggregate {
        count
      }
    }
    title
    created_at
  }
  search_sessions_aggregate(where: {user_id: {_eq: $user_id}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetSearchSessionsQuery__
 *
 * To run a query within a React component, call `useGetSearchSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchSessionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetSearchSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetSearchSessionsQuery, GetSearchSessionsQueryVariables> & ({ variables: GetSearchSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchSessionsQuery, GetSearchSessionsQueryVariables>(GetSearchSessionsDocument, options);
      }
export function useGetSearchSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchSessionsQuery, GetSearchSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchSessionsQuery, GetSearchSessionsQueryVariables>(GetSearchSessionsDocument, options);
        }
export function useGetSearchSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchSessionsQuery, GetSearchSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchSessionsQuery, GetSearchSessionsQueryVariables>(GetSearchSessionsDocument, options);
        }
export type GetSearchSessionsQueryHookResult = ReturnType<typeof useGetSearchSessionsQuery>;
export type GetSearchSessionsLazyQueryHookResult = ReturnType<typeof useGetSearchSessionsLazyQuery>;
export type GetSearchSessionsSuspenseQueryHookResult = ReturnType<typeof useGetSearchSessionsSuspenseQuery>;
export type GetSearchSessionsQueryResult = Apollo.QueryResult<GetSearchSessionsQuery, GetSearchSessionsQueryVariables>;
export const GetNlqsDocument = gql`
    query getNlqs($limit: Int, $offset: Int, $session_id: uuid!) {
  natural_language_queries(
    where: {session_id: {_eq: $session_id}}
    order_by: {created_at: desc}
    limit: $limit
    offset: $offset
  ) {
    query
    created_at
    total_found_properties
  }
  natural_language_queries_aggregate(where: {session_id: {_eq: $session_id}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetNlqsQuery__
 *
 * To run a query within a React component, call `useGetNlqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNlqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNlqsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      session_id: // value for 'session_id'
 *   },
 * });
 */
export function useGetNlqsQuery(baseOptions: Apollo.QueryHookOptions<GetNlqsQuery, GetNlqsQueryVariables> & ({ variables: GetNlqsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNlqsQuery, GetNlqsQueryVariables>(GetNlqsDocument, options);
      }
export function useGetNlqsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNlqsQuery, GetNlqsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNlqsQuery, GetNlqsQueryVariables>(GetNlqsDocument, options);
        }
export function useGetNlqsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNlqsQuery, GetNlqsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNlqsQuery, GetNlqsQueryVariables>(GetNlqsDocument, options);
        }
export type GetNlqsQueryHookResult = ReturnType<typeof useGetNlqsQuery>;
export type GetNlqsLazyQueryHookResult = ReturnType<typeof useGetNlqsLazyQuery>;
export type GetNlqsSuspenseQueryHookResult = ReturnType<typeof useGetNlqsSuspenseQuery>;
export type GetNlqsQueryResult = Apollo.QueryResult<GetNlqsQuery, GetNlqsQueryVariables>;
export const UserEngagementStatsDocument = gql`
    query userEngagementStats($excludedEmails: [citext!]!) {
  q1: natural_language_queries_aggregate(
    where: {search_session: {origin: {_eq: KAKTU}, user: {email: {_nin: $excludedEmails}}}}
  ) {
    aggregate {
      count
    }
  }
  q2: user_saved_properties_aggregate {
    aggregate {
      count
    }
  }
  q3: notification_aggregate(
    where: {deleted: {_eq: false}, user: {email: {_nin: $excludedEmails}}}
  ) {
    aggregate {
      count
    }
  }
  q4: notification_aggregate(where: {user: {email: {_nin: $excludedEmails}}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useUserEngagementStatsQuery__
 *
 * To run a query within a React component, call `useUserEngagementStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEngagementStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEngagementStatsQuery({
 *   variables: {
 *      excludedEmails: // value for 'excludedEmails'
 *   },
 * });
 */
export function useUserEngagementStatsQuery(baseOptions: Apollo.QueryHookOptions<UserEngagementStatsQuery, UserEngagementStatsQueryVariables> & ({ variables: UserEngagementStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserEngagementStatsQuery, UserEngagementStatsQueryVariables>(UserEngagementStatsDocument, options);
      }
export function useUserEngagementStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserEngagementStatsQuery, UserEngagementStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserEngagementStatsQuery, UserEngagementStatsQueryVariables>(UserEngagementStatsDocument, options);
        }
export function useUserEngagementStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserEngagementStatsQuery, UserEngagementStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserEngagementStatsQuery, UserEngagementStatsQueryVariables>(UserEngagementStatsDocument, options);
        }
export type UserEngagementStatsQueryHookResult = ReturnType<typeof useUserEngagementStatsQuery>;
export type UserEngagementStatsLazyQueryHookResult = ReturnType<typeof useUserEngagementStatsLazyQuery>;
export type UserEngagementStatsSuspenseQueryHookResult = ReturnType<typeof useUserEngagementStatsSuspenseQuery>;
export type UserEngagementStatsQueryResult = Apollo.QueryResult<UserEngagementStatsQuery, UserEngagementStatsQueryVariables>;
export const PropertyAnalyticsOverviewDocument = gql`
    query propertyAnalyticsOverview {
  totalScrapedProperties: property_list_aggregate(
    where: {source_id: {_is_null: false}}
  ) {
    aggregate {
      count
    }
  }
  acctiveSponsoredProperties: property_list_aggregate(
    where: {sponsored: {_eq: true}, visibility_status: {_eq: active}}
  ) {
    aggregate {
      count
    }
  }
  acctiveScrappedProperties: property_list_aggregate(
    where: {visibility_status: {_eq: active}}
  ) {
    aggregate {
      count
    }
  }
  property_list_aggregate(
    where: {visibility_status: {_eq: active}, property_origin_type: {_eq: kaktu}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __usePropertyAnalyticsOverviewQuery__
 *
 * To run a query within a React component, call `usePropertyAnalyticsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyAnalyticsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyAnalyticsOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function usePropertyAnalyticsOverviewQuery(baseOptions?: Apollo.QueryHookOptions<PropertyAnalyticsOverviewQuery, PropertyAnalyticsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyAnalyticsOverviewQuery, PropertyAnalyticsOverviewQueryVariables>(PropertyAnalyticsOverviewDocument, options);
      }
export function usePropertyAnalyticsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyAnalyticsOverviewQuery, PropertyAnalyticsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyAnalyticsOverviewQuery, PropertyAnalyticsOverviewQueryVariables>(PropertyAnalyticsOverviewDocument, options);
        }
export function usePropertyAnalyticsOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PropertyAnalyticsOverviewQuery, PropertyAnalyticsOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PropertyAnalyticsOverviewQuery, PropertyAnalyticsOverviewQueryVariables>(PropertyAnalyticsOverviewDocument, options);
        }
export type PropertyAnalyticsOverviewQueryHookResult = ReturnType<typeof usePropertyAnalyticsOverviewQuery>;
export type PropertyAnalyticsOverviewLazyQueryHookResult = ReturnType<typeof usePropertyAnalyticsOverviewLazyQuery>;
export type PropertyAnalyticsOverviewSuspenseQueryHookResult = ReturnType<typeof usePropertyAnalyticsOverviewSuspenseQuery>;
export type PropertyAnalyticsOverviewQueryResult = Apollo.QueryResult<PropertyAnalyticsOverviewQuery, PropertyAnalyticsOverviewQueryVariables>;
export const GetAgencyHealthPaginatedDocument = gql`
    query getAgencyHealthPaginated($limit: Int, $offset: Int, $order_by: [agency_health_order_by!], $where: agency_health_bool_exp) {
  agency_health(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    name
    display_name
    total_phone_numbers
    total_contacts
    shared_phone_numbers
    shared_contacts
    created_at
  }
  agency_health_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetAgencyHealthPaginatedQuery__
 *
 * To run a query within a React component, call `useGetAgencyHealthPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyHealthPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyHealthPaginatedQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAgencyHealthPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyHealthPaginatedQuery, GetAgencyHealthPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyHealthPaginatedQuery, GetAgencyHealthPaginatedQueryVariables>(GetAgencyHealthPaginatedDocument, options);
      }
export function useGetAgencyHealthPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyHealthPaginatedQuery, GetAgencyHealthPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyHealthPaginatedQuery, GetAgencyHealthPaginatedQueryVariables>(GetAgencyHealthPaginatedDocument, options);
        }
export function useGetAgencyHealthPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyHealthPaginatedQuery, GetAgencyHealthPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyHealthPaginatedQuery, GetAgencyHealthPaginatedQueryVariables>(GetAgencyHealthPaginatedDocument, options);
        }
export type GetAgencyHealthPaginatedQueryHookResult = ReturnType<typeof useGetAgencyHealthPaginatedQuery>;
export type GetAgencyHealthPaginatedLazyQueryHookResult = ReturnType<typeof useGetAgencyHealthPaginatedLazyQuery>;
export type GetAgencyHealthPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetAgencyHealthPaginatedSuspenseQuery>;
export type GetAgencyHealthPaginatedQueryResult = Apollo.QueryResult<GetAgencyHealthPaginatedQuery, GetAgencyHealthPaginatedQueryVariables>;
export const GetContactHealthPaginatedDocument = gql`
    query getContactHealthPaginated($where: contact_health_bool_exp, $limit: Int, $offset: Int, $order_by: [contact_health_order_by!]) {
  contact_health(
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    id
    full_name
    total_phone_numbers
    unique_agencies
    unassigned_phones
    invalid_phones
    created_at
  }
  contact_health_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetContactHealthPaginatedQuery__
 *
 * To run a query within a React component, call `useGetContactHealthPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactHealthPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactHealthPaginatedQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetContactHealthPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<GetContactHealthPaginatedQuery, GetContactHealthPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactHealthPaginatedQuery, GetContactHealthPaginatedQueryVariables>(GetContactHealthPaginatedDocument, options);
      }
export function useGetContactHealthPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactHealthPaginatedQuery, GetContactHealthPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactHealthPaginatedQuery, GetContactHealthPaginatedQueryVariables>(GetContactHealthPaginatedDocument, options);
        }
export function useGetContactHealthPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactHealthPaginatedQuery, GetContactHealthPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactHealthPaginatedQuery, GetContactHealthPaginatedQueryVariables>(GetContactHealthPaginatedDocument, options);
        }
export type GetContactHealthPaginatedQueryHookResult = ReturnType<typeof useGetContactHealthPaginatedQuery>;
export type GetContactHealthPaginatedLazyQueryHookResult = ReturnType<typeof useGetContactHealthPaginatedLazyQuery>;
export type GetContactHealthPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetContactHealthPaginatedSuspenseQuery>;
export type GetContactHealthPaginatedQueryResult = Apollo.QueryResult<GetContactHealthPaginatedQuery, GetContactHealthPaginatedQueryVariables>;
export const GetDuplicatePhoneNumbersPaginatedDocument = gql`
    query getDuplicatePhoneNumbersPaginated($limit: Int, $offset: Int, $order_by: [duplicate_phone_numbers_order_by!], $where: duplicate_phone_numbers_bool_exp) {
  duplicate_phone_numbers(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    phone_number
    agency_count
    contact_count
    agency_ids
    contact_ids
    first_created
    last_created
  }
  duplicate_phone_numbers_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetDuplicatePhoneNumbersPaginatedQuery__
 *
 * To run a query within a React component, call `useGetDuplicatePhoneNumbersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuplicatePhoneNumbersPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuplicatePhoneNumbersPaginatedQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDuplicatePhoneNumbersPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<GetDuplicatePhoneNumbersPaginatedQuery, GetDuplicatePhoneNumbersPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDuplicatePhoneNumbersPaginatedQuery, GetDuplicatePhoneNumbersPaginatedQueryVariables>(GetDuplicatePhoneNumbersPaginatedDocument, options);
      }
export function useGetDuplicatePhoneNumbersPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDuplicatePhoneNumbersPaginatedQuery, GetDuplicatePhoneNumbersPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDuplicatePhoneNumbersPaginatedQuery, GetDuplicatePhoneNumbersPaginatedQueryVariables>(GetDuplicatePhoneNumbersPaginatedDocument, options);
        }
export function useGetDuplicatePhoneNumbersPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDuplicatePhoneNumbersPaginatedQuery, GetDuplicatePhoneNumbersPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDuplicatePhoneNumbersPaginatedQuery, GetDuplicatePhoneNumbersPaginatedQueryVariables>(GetDuplicatePhoneNumbersPaginatedDocument, options);
        }
export type GetDuplicatePhoneNumbersPaginatedQueryHookResult = ReturnType<typeof useGetDuplicatePhoneNumbersPaginatedQuery>;
export type GetDuplicatePhoneNumbersPaginatedLazyQueryHookResult = ReturnType<typeof useGetDuplicatePhoneNumbersPaginatedLazyQuery>;
export type GetDuplicatePhoneNumbersPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetDuplicatePhoneNumbersPaginatedSuspenseQuery>;
export type GetDuplicatePhoneNumbersPaginatedQueryResult = Apollo.QueryResult<GetDuplicatePhoneNumbersPaginatedQuery, GetDuplicatePhoneNumbersPaginatedQueryVariables>;
export const GetContactsByIdsDocument = gql`
    query getContactsByIds($ids: [uuid!]!) {
  contact(where: {id: {_in: $ids}}) {
    id
    full_name
    property_lists_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetContactsByIdsQuery__
 *
 * To run a query within a React component, call `useGetContactsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetContactsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetContactsByIdsQuery, GetContactsByIdsQueryVariables> & ({ variables: GetContactsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactsByIdsQuery, GetContactsByIdsQueryVariables>(GetContactsByIdsDocument, options);
      }
export function useGetContactsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactsByIdsQuery, GetContactsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactsByIdsQuery, GetContactsByIdsQueryVariables>(GetContactsByIdsDocument, options);
        }
export function useGetContactsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactsByIdsQuery, GetContactsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactsByIdsQuery, GetContactsByIdsQueryVariables>(GetContactsByIdsDocument, options);
        }
export type GetContactsByIdsQueryHookResult = ReturnType<typeof useGetContactsByIdsQuery>;
export type GetContactsByIdsLazyQueryHookResult = ReturnType<typeof useGetContactsByIdsLazyQuery>;
export type GetContactsByIdsSuspenseQueryHookResult = ReturnType<typeof useGetContactsByIdsSuspenseQuery>;
export type GetContactsByIdsQueryResult = Apollo.QueryResult<GetContactsByIdsQuery, GetContactsByIdsQueryVariables>;
export const GetAgenciesHierarchyDocument = gql`
    query getAgenciesHierarchy($namePattern: String!) {
  agency(where: {name: {_ilike: $namePattern}}, order_by: [{name: asc}]) {
    id
    name
    display_name
    parent_id
    property_sources {
      property_lists_aggregate {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

/**
 * __useGetAgenciesHierarchyQuery__
 *
 * To run a query within a React component, call `useGetAgenciesHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgenciesHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgenciesHierarchyQuery({
 *   variables: {
 *      namePattern: // value for 'namePattern'
 *   },
 * });
 */
export function useGetAgenciesHierarchyQuery(baseOptions: Apollo.QueryHookOptions<GetAgenciesHierarchyQuery, GetAgenciesHierarchyQueryVariables> & ({ variables: GetAgenciesHierarchyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgenciesHierarchyQuery, GetAgenciesHierarchyQueryVariables>(GetAgenciesHierarchyDocument, options);
      }
export function useGetAgenciesHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgenciesHierarchyQuery, GetAgenciesHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgenciesHierarchyQuery, GetAgenciesHierarchyQueryVariables>(GetAgenciesHierarchyDocument, options);
        }
export function useGetAgenciesHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgenciesHierarchyQuery, GetAgenciesHierarchyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgenciesHierarchyQuery, GetAgenciesHierarchyQueryVariables>(GetAgenciesHierarchyDocument, options);
        }
export type GetAgenciesHierarchyQueryHookResult = ReturnType<typeof useGetAgenciesHierarchyQuery>;
export type GetAgenciesHierarchyLazyQueryHookResult = ReturnType<typeof useGetAgenciesHierarchyLazyQuery>;
export type GetAgenciesHierarchySuspenseQueryHookResult = ReturnType<typeof useGetAgenciesHierarchySuspenseQuery>;
export type GetAgenciesHierarchyQueryResult = Apollo.QueryResult<GetAgenciesHierarchyQuery, GetAgenciesHierarchyQueryVariables>;
export const GetAgenciesByIdsDocument = gql`
    query getAgenciesByIds($ids: [uuid!]!) {
  agency(where: {id: {_in: $ids}}) {
    id
    name
    display_name
    property_sources_aggregate {
      aggregate {
        count
      }
    }
    property_sources {
      property_lists_aggregate {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

/**
 * __useGetAgenciesByIdsQuery__
 *
 * To run a query within a React component, call `useGetAgenciesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgenciesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgenciesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetAgenciesByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetAgenciesByIdsQuery, GetAgenciesByIdsQueryVariables> & ({ variables: GetAgenciesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgenciesByIdsQuery, GetAgenciesByIdsQueryVariables>(GetAgenciesByIdsDocument, options);
      }
export function useGetAgenciesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgenciesByIdsQuery, GetAgenciesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgenciesByIdsQuery, GetAgenciesByIdsQueryVariables>(GetAgenciesByIdsDocument, options);
        }
export function useGetAgenciesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgenciesByIdsQuery, GetAgenciesByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgenciesByIdsQuery, GetAgenciesByIdsQueryVariables>(GetAgenciesByIdsDocument, options);
        }
export type GetAgenciesByIdsQueryHookResult = ReturnType<typeof useGetAgenciesByIdsQuery>;
export type GetAgenciesByIdsLazyQueryHookResult = ReturnType<typeof useGetAgenciesByIdsLazyQuery>;
export type GetAgenciesByIdsSuspenseQueryHookResult = ReturnType<typeof useGetAgenciesByIdsSuspenseQuery>;
export type GetAgenciesByIdsQueryResult = Apollo.QueryResult<GetAgenciesByIdsQuery, GetAgenciesByIdsQueryVariables>;
export const SearchAgenciesDocument = gql`
    query searchAgencies($search_pattern: String!, $limit: Int) {
  agency(
    where: {_or: [{name: {_ilike: $search_pattern}}, {display_name: {_ilike: $search_pattern}}]}
    limit: $limit
  ) {
    id
    name
    display_name
    property_sources_aggregate {
      aggregate {
        count
      }
    }
    property_sources {
      property_lists_aggregate {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

/**
 * __useSearchAgenciesQuery__
 *
 * To run a query within a React component, call `useSearchAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAgenciesQuery({
 *   variables: {
 *      search_pattern: // value for 'search_pattern'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchAgenciesQuery(baseOptions: Apollo.QueryHookOptions<SearchAgenciesQuery, SearchAgenciesQueryVariables> & ({ variables: SearchAgenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAgenciesQuery, SearchAgenciesQueryVariables>(SearchAgenciesDocument, options);
      }
export function useSearchAgenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAgenciesQuery, SearchAgenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAgenciesQuery, SearchAgenciesQueryVariables>(SearchAgenciesDocument, options);
        }
export function useSearchAgenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAgenciesQuery, SearchAgenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAgenciesQuery, SearchAgenciesQueryVariables>(SearchAgenciesDocument, options);
        }
export type SearchAgenciesQueryHookResult = ReturnType<typeof useSearchAgenciesQuery>;
export type SearchAgenciesLazyQueryHookResult = ReturnType<typeof useSearchAgenciesLazyQuery>;
export type SearchAgenciesSuspenseQueryHookResult = ReturnType<typeof useSearchAgenciesSuspenseQuery>;
export type SearchAgenciesQueryResult = Apollo.QueryResult<SearchAgenciesQuery, SearchAgenciesQueryVariables>;
export const GetContactPhoneNumbersByPhoneAndAgenciesDocument = gql`
    query getContactPhoneNumbersByPhoneAndAgencies($phone_number: String!, $agency_ids: [uuid!]!) {
  contact_phone_number(
    where: {_and: [{phone_number: {_eq: $phone_number}}, {agency_id: {_in: $agency_ids}}]}
  ) {
    id
    contact_id
    agency_id
  }
}
    `;

/**
 * __useGetContactPhoneNumbersByPhoneAndAgenciesQuery__
 *
 * To run a query within a React component, call `useGetContactPhoneNumbersByPhoneAndAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactPhoneNumbersByPhoneAndAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactPhoneNumbersByPhoneAndAgenciesQuery({
 *   variables: {
 *      phone_number: // value for 'phone_number'
 *      agency_ids: // value for 'agency_ids'
 *   },
 * });
 */
export function useGetContactPhoneNumbersByPhoneAndAgenciesQuery(baseOptions: Apollo.QueryHookOptions<GetContactPhoneNumbersByPhoneAndAgenciesQuery, GetContactPhoneNumbersByPhoneAndAgenciesQueryVariables> & ({ variables: GetContactPhoneNumbersByPhoneAndAgenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactPhoneNumbersByPhoneAndAgenciesQuery, GetContactPhoneNumbersByPhoneAndAgenciesQueryVariables>(GetContactPhoneNumbersByPhoneAndAgenciesDocument, options);
      }
export function useGetContactPhoneNumbersByPhoneAndAgenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactPhoneNumbersByPhoneAndAgenciesQuery, GetContactPhoneNumbersByPhoneAndAgenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactPhoneNumbersByPhoneAndAgenciesQuery, GetContactPhoneNumbersByPhoneAndAgenciesQueryVariables>(GetContactPhoneNumbersByPhoneAndAgenciesDocument, options);
        }
export function useGetContactPhoneNumbersByPhoneAndAgenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactPhoneNumbersByPhoneAndAgenciesQuery, GetContactPhoneNumbersByPhoneAndAgenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactPhoneNumbersByPhoneAndAgenciesQuery, GetContactPhoneNumbersByPhoneAndAgenciesQueryVariables>(GetContactPhoneNumbersByPhoneAndAgenciesDocument, options);
        }
export type GetContactPhoneNumbersByPhoneAndAgenciesQueryHookResult = ReturnType<typeof useGetContactPhoneNumbersByPhoneAndAgenciesQuery>;
export type GetContactPhoneNumbersByPhoneAndAgenciesLazyQueryHookResult = ReturnType<typeof useGetContactPhoneNumbersByPhoneAndAgenciesLazyQuery>;
export type GetContactPhoneNumbersByPhoneAndAgenciesSuspenseQueryHookResult = ReturnType<typeof useGetContactPhoneNumbersByPhoneAndAgenciesSuspenseQuery>;
export type GetContactPhoneNumbersByPhoneAndAgenciesQueryResult = Apollo.QueryResult<GetContactPhoneNumbersByPhoneAndAgenciesQuery, GetContactPhoneNumbersByPhoneAndAgenciesQueryVariables>;
export const GetContactPhoneNumbersByPhoneAndContactIdsDocument = gql`
    query getContactPhoneNumbersByPhoneAndContactIds($phone_number: String!, $contact_ids: [uuid!]!) {
  contact_phone_number(
    where: {_and: [{phone_number: {_eq: $phone_number}}, {contact_id: {_in: $contact_ids}}]}
  ) {
    id
    contact_id
    agency_id
  }
}
    `;

/**
 * __useGetContactPhoneNumbersByPhoneAndContactIdsQuery__
 *
 * To run a query within a React component, call `useGetContactPhoneNumbersByPhoneAndContactIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactPhoneNumbersByPhoneAndContactIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactPhoneNumbersByPhoneAndContactIdsQuery({
 *   variables: {
 *      phone_number: // value for 'phone_number'
 *      contact_ids: // value for 'contact_ids'
 *   },
 * });
 */
export function useGetContactPhoneNumbersByPhoneAndContactIdsQuery(baseOptions: Apollo.QueryHookOptions<GetContactPhoneNumbersByPhoneAndContactIdsQuery, GetContactPhoneNumbersByPhoneAndContactIdsQueryVariables> & ({ variables: GetContactPhoneNumbersByPhoneAndContactIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactPhoneNumbersByPhoneAndContactIdsQuery, GetContactPhoneNumbersByPhoneAndContactIdsQueryVariables>(GetContactPhoneNumbersByPhoneAndContactIdsDocument, options);
      }
export function useGetContactPhoneNumbersByPhoneAndContactIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactPhoneNumbersByPhoneAndContactIdsQuery, GetContactPhoneNumbersByPhoneAndContactIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactPhoneNumbersByPhoneAndContactIdsQuery, GetContactPhoneNumbersByPhoneAndContactIdsQueryVariables>(GetContactPhoneNumbersByPhoneAndContactIdsDocument, options);
        }
export function useGetContactPhoneNumbersByPhoneAndContactIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactPhoneNumbersByPhoneAndContactIdsQuery, GetContactPhoneNumbersByPhoneAndContactIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactPhoneNumbersByPhoneAndContactIdsQuery, GetContactPhoneNumbersByPhoneAndContactIdsQueryVariables>(GetContactPhoneNumbersByPhoneAndContactIdsDocument, options);
        }
export type GetContactPhoneNumbersByPhoneAndContactIdsQueryHookResult = ReturnType<typeof useGetContactPhoneNumbersByPhoneAndContactIdsQuery>;
export type GetContactPhoneNumbersByPhoneAndContactIdsLazyQueryHookResult = ReturnType<typeof useGetContactPhoneNumbersByPhoneAndContactIdsLazyQuery>;
export type GetContactPhoneNumbersByPhoneAndContactIdsSuspenseQueryHookResult = ReturnType<typeof useGetContactPhoneNumbersByPhoneAndContactIdsSuspenseQuery>;
export type GetContactPhoneNumbersByPhoneAndContactIdsQueryResult = Apollo.QueryResult<GetContactPhoneNumbersByPhoneAndContactIdsQuery, GetContactPhoneNumbersByPhoneAndContactIdsQueryVariables>;
export const GetContactPhoneNumbersByContactIdsDocument = gql`
    query getContactPhoneNumbersByContactIds($contact_ids: [uuid!]!) {
  contact_phone_number(where: {contact_id: {_in: $contact_ids}}) {
    id
    contact_id
    agency_id
    phone_number
  }
}
    `;

/**
 * __useGetContactPhoneNumbersByContactIdsQuery__
 *
 * To run a query within a React component, call `useGetContactPhoneNumbersByContactIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactPhoneNumbersByContactIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactPhoneNumbersByContactIdsQuery({
 *   variables: {
 *      contact_ids: // value for 'contact_ids'
 *   },
 * });
 */
export function useGetContactPhoneNumbersByContactIdsQuery(baseOptions: Apollo.QueryHookOptions<GetContactPhoneNumbersByContactIdsQuery, GetContactPhoneNumbersByContactIdsQueryVariables> & ({ variables: GetContactPhoneNumbersByContactIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactPhoneNumbersByContactIdsQuery, GetContactPhoneNumbersByContactIdsQueryVariables>(GetContactPhoneNumbersByContactIdsDocument, options);
      }
export function useGetContactPhoneNumbersByContactIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactPhoneNumbersByContactIdsQuery, GetContactPhoneNumbersByContactIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactPhoneNumbersByContactIdsQuery, GetContactPhoneNumbersByContactIdsQueryVariables>(GetContactPhoneNumbersByContactIdsDocument, options);
        }
export function useGetContactPhoneNumbersByContactIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactPhoneNumbersByContactIdsQuery, GetContactPhoneNumbersByContactIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactPhoneNumbersByContactIdsQuery, GetContactPhoneNumbersByContactIdsQueryVariables>(GetContactPhoneNumbersByContactIdsDocument, options);
        }
export type GetContactPhoneNumbersByContactIdsQueryHookResult = ReturnType<typeof useGetContactPhoneNumbersByContactIdsQuery>;
export type GetContactPhoneNumbersByContactIdsLazyQueryHookResult = ReturnType<typeof useGetContactPhoneNumbersByContactIdsLazyQuery>;
export type GetContactPhoneNumbersByContactIdsSuspenseQueryHookResult = ReturnType<typeof useGetContactPhoneNumbersByContactIdsSuspenseQuery>;
export type GetContactPhoneNumbersByContactIdsQueryResult = Apollo.QueryResult<GetContactPhoneNumbersByContactIdsQuery, GetContactPhoneNumbersByContactIdsQueryVariables>;
export const GetPropertyListsByPhoneDocument = gql`
    query getPropertyListsByPhone($phone_number: String!, $limit: Int, $offset: Int) {
  property_list(
    where: {contact_phone_1: {_eq: $phone_number}}
    limit: $limit
    offset: $offset
    order_by: {created_at: desc}
  ) {
    id
    source_url
    title_text_content {
      original_text
    }
    main_image {
      image
    }
    price
    price_currency
    property_status
    created_at
    contact_name
    visibility_status
    property_source {
      id
      agency {
        id
        name
      }
    }
    property {
      url_slugs {
        slug
      }
    }
  }
  property_list_aggregate(
    where: {contact_phone_1: {_eq: $phone_number}, visibility_status: {_eq: active}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPropertyListsByPhoneQuery__
 *
 * To run a query within a React component, call `useGetPropertyListsByPhoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyListsByPhoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyListsByPhoneQuery({
 *   variables: {
 *      phone_number: // value for 'phone_number'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPropertyListsByPhoneQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyListsByPhoneQuery, GetPropertyListsByPhoneQueryVariables> & ({ variables: GetPropertyListsByPhoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyListsByPhoneQuery, GetPropertyListsByPhoneQueryVariables>(GetPropertyListsByPhoneDocument, options);
      }
export function useGetPropertyListsByPhoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyListsByPhoneQuery, GetPropertyListsByPhoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyListsByPhoneQuery, GetPropertyListsByPhoneQueryVariables>(GetPropertyListsByPhoneDocument, options);
        }
export function useGetPropertyListsByPhoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyListsByPhoneQuery, GetPropertyListsByPhoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyListsByPhoneQuery, GetPropertyListsByPhoneQueryVariables>(GetPropertyListsByPhoneDocument, options);
        }
export type GetPropertyListsByPhoneQueryHookResult = ReturnType<typeof useGetPropertyListsByPhoneQuery>;
export type GetPropertyListsByPhoneLazyQueryHookResult = ReturnType<typeof useGetPropertyListsByPhoneLazyQuery>;
export type GetPropertyListsByPhoneSuspenseQueryHookResult = ReturnType<typeof useGetPropertyListsByPhoneSuspenseQuery>;
export type GetPropertyListsByPhoneQueryResult = Apollo.QueryResult<GetPropertyListsByPhoneQuery, GetPropertyListsByPhoneQueryVariables>;
export const GetPropertySourcesByPhoneDocument = gql`
    query getPropertySourcesByPhone($phone_number: String!) {
  property_source(
    where: {property_lists: {contact_phone_1: {_eq: $phone_number}}}
  ) {
    id
    origin
    agency_id
    property_lists(where: {contact_phone_1: {_eq: $phone_number}}) {
      id
    }
  }
}
    `;

/**
 * __useGetPropertySourcesByPhoneQuery__
 *
 * To run a query within a React component, call `useGetPropertySourcesByPhoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertySourcesByPhoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertySourcesByPhoneQuery({
 *   variables: {
 *      phone_number: // value for 'phone_number'
 *   },
 * });
 */
export function useGetPropertySourcesByPhoneQuery(baseOptions: Apollo.QueryHookOptions<GetPropertySourcesByPhoneQuery, GetPropertySourcesByPhoneQueryVariables> & ({ variables: GetPropertySourcesByPhoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertySourcesByPhoneQuery, GetPropertySourcesByPhoneQueryVariables>(GetPropertySourcesByPhoneDocument, options);
      }
export function useGetPropertySourcesByPhoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertySourcesByPhoneQuery, GetPropertySourcesByPhoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertySourcesByPhoneQuery, GetPropertySourcesByPhoneQueryVariables>(GetPropertySourcesByPhoneDocument, options);
        }
export function useGetPropertySourcesByPhoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertySourcesByPhoneQuery, GetPropertySourcesByPhoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertySourcesByPhoneQuery, GetPropertySourcesByPhoneQueryVariables>(GetPropertySourcesByPhoneDocument, options);
        }
export type GetPropertySourcesByPhoneQueryHookResult = ReturnType<typeof useGetPropertySourcesByPhoneQuery>;
export type GetPropertySourcesByPhoneLazyQueryHookResult = ReturnType<typeof useGetPropertySourcesByPhoneLazyQuery>;
export type GetPropertySourcesByPhoneSuspenseQueryHookResult = ReturnType<typeof useGetPropertySourcesByPhoneSuspenseQuery>;
export type GetPropertySourcesByPhoneQueryResult = Apollo.QueryResult<GetPropertySourcesByPhoneQuery, GetPropertySourcesByPhoneQueryVariables>;
export const GetPropertySourcesByAgencyAndOriginsDocument = gql`
    query getPropertySourcesByAgencyAndOrigins($agency_id: uuid!, $origins: [property_origin_enum!]!) {
  property_source(where: {agency_id: {_eq: $agency_id}, origin: {_in: $origins}}) {
    id
    origin
  }
}
    `;

/**
 * __useGetPropertySourcesByAgencyAndOriginsQuery__
 *
 * To run a query within a React component, call `useGetPropertySourcesByAgencyAndOriginsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertySourcesByAgencyAndOriginsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertySourcesByAgencyAndOriginsQuery({
 *   variables: {
 *      agency_id: // value for 'agency_id'
 *      origins: // value for 'origins'
 *   },
 * });
 */
export function useGetPropertySourcesByAgencyAndOriginsQuery(baseOptions: Apollo.QueryHookOptions<GetPropertySourcesByAgencyAndOriginsQuery, GetPropertySourcesByAgencyAndOriginsQueryVariables> & ({ variables: GetPropertySourcesByAgencyAndOriginsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertySourcesByAgencyAndOriginsQuery, GetPropertySourcesByAgencyAndOriginsQueryVariables>(GetPropertySourcesByAgencyAndOriginsDocument, options);
      }
export function useGetPropertySourcesByAgencyAndOriginsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertySourcesByAgencyAndOriginsQuery, GetPropertySourcesByAgencyAndOriginsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertySourcesByAgencyAndOriginsQuery, GetPropertySourcesByAgencyAndOriginsQueryVariables>(GetPropertySourcesByAgencyAndOriginsDocument, options);
        }
export function useGetPropertySourcesByAgencyAndOriginsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertySourcesByAgencyAndOriginsQuery, GetPropertySourcesByAgencyAndOriginsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertySourcesByAgencyAndOriginsQuery, GetPropertySourcesByAgencyAndOriginsQueryVariables>(GetPropertySourcesByAgencyAndOriginsDocument, options);
        }
export type GetPropertySourcesByAgencyAndOriginsQueryHookResult = ReturnType<typeof useGetPropertySourcesByAgencyAndOriginsQuery>;
export type GetPropertySourcesByAgencyAndOriginsLazyQueryHookResult = ReturnType<typeof useGetPropertySourcesByAgencyAndOriginsLazyQuery>;
export type GetPropertySourcesByAgencyAndOriginsSuspenseQueryHookResult = ReturnType<typeof useGetPropertySourcesByAgencyAndOriginsSuspenseQuery>;
export type GetPropertySourcesByAgencyAndOriginsQueryResult = Apollo.QueryResult<GetPropertySourcesByAgencyAndOriginsQuery, GetPropertySourcesByAgencyAndOriginsQueryVariables>;
export const GetAnonymousSearchSessionsDocument = gql`
    query getAnonymousSearchSessions($limit: Int!, $offset: Int!, $order_by: [search_sessions_order_by!]) {
  search_sessions(
    where: {user_id: {_is_null: true}}
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    id
    title
    created_at
    updated_at
    origin
    natural_language_queries_aggregate {
      aggregate {
        count
      }
    }
    natural_language_queries(limit: 1, order_by: {created_at: desc}) {
      created_at
    }
  }
  search_sessions_aggregate(where: {user_id: {_is_null: true}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetAnonymousSearchSessionsQuery__
 *
 * To run a query within a React component, call `useGetAnonymousSearchSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnonymousSearchSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnonymousSearchSessionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetAnonymousSearchSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetAnonymousSearchSessionsQuery, GetAnonymousSearchSessionsQueryVariables> & ({ variables: GetAnonymousSearchSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnonymousSearchSessionsQuery, GetAnonymousSearchSessionsQueryVariables>(GetAnonymousSearchSessionsDocument, options);
      }
export function useGetAnonymousSearchSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnonymousSearchSessionsQuery, GetAnonymousSearchSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnonymousSearchSessionsQuery, GetAnonymousSearchSessionsQueryVariables>(GetAnonymousSearchSessionsDocument, options);
        }
export function useGetAnonymousSearchSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnonymousSearchSessionsQuery, GetAnonymousSearchSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnonymousSearchSessionsQuery, GetAnonymousSearchSessionsQueryVariables>(GetAnonymousSearchSessionsDocument, options);
        }
export type GetAnonymousSearchSessionsQueryHookResult = ReturnType<typeof useGetAnonymousSearchSessionsQuery>;
export type GetAnonymousSearchSessionsLazyQueryHookResult = ReturnType<typeof useGetAnonymousSearchSessionsLazyQuery>;
export type GetAnonymousSearchSessionsSuspenseQueryHookResult = ReturnType<typeof useGetAnonymousSearchSessionsSuspenseQuery>;
export type GetAnonymousSearchSessionsQueryResult = Apollo.QueryResult<GetAnonymousSearchSessionsQuery, GetAnonymousSearchSessionsQueryVariables>;
export const GetOrganizationsForKaKtuPropertyFilterDocument = gql`
    query getOrganizationsForKaKtuPropertyFilter($where: property_list_bool_exp!) {
  property_list(
    where: $where
    distinct_on: [organization_id]
    order_by: [{organization_id: asc}]
  ) {
    organization {
      id
      display_name
      parent_organization_id
      parent {
        id
        display_name
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationsForKaKtuPropertyFilterQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsForKaKtuPropertyFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsForKaKtuPropertyFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsForKaKtuPropertyFilterQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetOrganizationsForKaKtuPropertyFilterQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationsForKaKtuPropertyFilterQuery, GetOrganizationsForKaKtuPropertyFilterQueryVariables> & ({ variables: GetOrganizationsForKaKtuPropertyFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsForKaKtuPropertyFilterQuery, GetOrganizationsForKaKtuPropertyFilterQueryVariables>(GetOrganizationsForKaKtuPropertyFilterDocument, options);
      }
export function useGetOrganizationsForKaKtuPropertyFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsForKaKtuPropertyFilterQuery, GetOrganizationsForKaKtuPropertyFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsForKaKtuPropertyFilterQuery, GetOrganizationsForKaKtuPropertyFilterQueryVariables>(GetOrganizationsForKaKtuPropertyFilterDocument, options);
        }
export function useGetOrganizationsForKaKtuPropertyFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsForKaKtuPropertyFilterQuery, GetOrganizationsForKaKtuPropertyFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsForKaKtuPropertyFilterQuery, GetOrganizationsForKaKtuPropertyFilterQueryVariables>(GetOrganizationsForKaKtuPropertyFilterDocument, options);
        }
export type GetOrganizationsForKaKtuPropertyFilterQueryHookResult = ReturnType<typeof useGetOrganizationsForKaKtuPropertyFilterQuery>;
export type GetOrganizationsForKaKtuPropertyFilterLazyQueryHookResult = ReturnType<typeof useGetOrganizationsForKaKtuPropertyFilterLazyQuery>;
export type GetOrganizationsForKaKtuPropertyFilterSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsForKaKtuPropertyFilterSuspenseQuery>;
export type GetOrganizationsForKaKtuPropertyFilterQueryResult = Apollo.QueryResult<GetOrganizationsForKaKtuPropertyFilterQuery, GetOrganizationsForKaKtuPropertyFilterQueryVariables>;
export const SponsoredPropertyListsDocument = gql`
    query sponsoredPropertyLists($where: sponsored_property_list_bool_exp, $limit: Int, $offset: Int, $order_by: [sponsored_property_list_order_by!] = {}) {
  sponsored_property_list(
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    id
    created_at
    property_list {
      id
      main_image {
        image
      }
      title_text_content {
        original_text
      }
      property {
        url_slugs {
          slug
        }
      }
      organization {
        display_name
        parent {
          display_name
        }
      }
    }
    start_date
    end_date
  }
  sponsored_property_list_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useSponsoredPropertyListsQuery__
 *
 * To run a query within a React component, call `useSponsoredPropertyListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSponsoredPropertyListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSponsoredPropertyListsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useSponsoredPropertyListsQuery(baseOptions?: Apollo.QueryHookOptions<SponsoredPropertyListsQuery, SponsoredPropertyListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SponsoredPropertyListsQuery, SponsoredPropertyListsQueryVariables>(SponsoredPropertyListsDocument, options);
      }
export function useSponsoredPropertyListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SponsoredPropertyListsQuery, SponsoredPropertyListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SponsoredPropertyListsQuery, SponsoredPropertyListsQueryVariables>(SponsoredPropertyListsDocument, options);
        }
export function useSponsoredPropertyListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SponsoredPropertyListsQuery, SponsoredPropertyListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SponsoredPropertyListsQuery, SponsoredPropertyListsQueryVariables>(SponsoredPropertyListsDocument, options);
        }
export type SponsoredPropertyListsQueryHookResult = ReturnType<typeof useSponsoredPropertyListsQuery>;
export type SponsoredPropertyListsLazyQueryHookResult = ReturnType<typeof useSponsoredPropertyListsLazyQuery>;
export type SponsoredPropertyListsSuspenseQueryHookResult = ReturnType<typeof useSponsoredPropertyListsSuspenseQuery>;
export type SponsoredPropertyListsQueryResult = Apollo.QueryResult<SponsoredPropertyListsQuery, SponsoredPropertyListsQueryVariables>;
export const GetUserNotificationsDocument = gql`
    query getUserNotifications($offset: Int, $limit: Int, $where: users_bool_exp = {}) {
  users(offset: $offset, limit: $limit, where: $where) {
    id
    displayName
    notifications {
      title
      deleted
      opened
    }
  }
  usersAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUserNotificationsQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
      }
export function useGetUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
        }
export function useGetUserNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
        }
export type GetUserNotificationsQueryHookResult = ReturnType<typeof useGetUserNotificationsQuery>;
export type GetUserNotificationsLazyQueryHookResult = ReturnType<typeof useGetUserNotificationsLazyQuery>;
export type GetUserNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetUserNotificationsSuspenseQuery>;
export type GetUserNotificationsQueryResult = Apollo.QueryResult<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>;
export const GetUsersDataDocument = gql`
    query getUsersData($limit: Int!, $offset: Int!, $order_by: [users_order_by!], $where: users_bool_exp = {}) {
  users(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    id
    createdAt
    displayName
    email
    phoneNumber
    roles(where: {role: {_in: [INVESTOR, AGENCY, LISTER, SEEKER]}}) {
      role
    }
    user_organizations {
      organization {
        parent {
          display_name
          status
        }
        subscriptions {
          start_date
          end_date
          status
        }
        display_name
        status
      }
    }
  }
  usersAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUsersDataQuery__
 *
 * To run a query within a React component, call `useGetUsersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersDataQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUsersDataQuery(baseOptions: Apollo.QueryHookOptions<GetUsersDataQuery, GetUsersDataQueryVariables> & ({ variables: GetUsersDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersDataQuery, GetUsersDataQueryVariables>(GetUsersDataDocument, options);
      }
export function useGetUsersDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersDataQuery, GetUsersDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersDataQuery, GetUsersDataQueryVariables>(GetUsersDataDocument, options);
        }
export function useGetUsersDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersDataQuery, GetUsersDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersDataQuery, GetUsersDataQueryVariables>(GetUsersDataDocument, options);
        }
export type GetUsersDataQueryHookResult = ReturnType<typeof useGetUsersDataQuery>;
export type GetUsersDataLazyQueryHookResult = ReturnType<typeof useGetUsersDataLazyQuery>;
export type GetUsersDataSuspenseQueryHookResult = ReturnType<typeof useGetUsersDataSuspenseQuery>;
export type GetUsersDataQueryResult = Apollo.QueryResult<GetUsersDataQuery, GetUsersDataQueryVariables>;
export const GetPropertyEngagementDocument = gql`
    query getPropertyEngagement($limit: Int!, $offset: Int!, $order_by: [property_list_order_by!], $where: property_list_bool_exp = {}) {
  property_list(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    id
    views
    source_url_clicked
    contact_phone_clicked
    total_activity
    title_text_content {
      original_text
    }
    main_image {
      image
    }
    property {
      url_slugs(limit: 1) {
        slug
      }
    }
  }
  property_list_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPropertyEngagementQuery__
 *
 * To run a query within a React component, call `useGetPropertyEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyEngagementQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPropertyEngagementQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyEngagementQuery, GetPropertyEngagementQueryVariables> & ({ variables: GetPropertyEngagementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyEngagementQuery, GetPropertyEngagementQueryVariables>(GetPropertyEngagementDocument, options);
      }
export function useGetPropertyEngagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyEngagementQuery, GetPropertyEngagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyEngagementQuery, GetPropertyEngagementQueryVariables>(GetPropertyEngagementDocument, options);
        }
export function useGetPropertyEngagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyEngagementQuery, GetPropertyEngagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyEngagementQuery, GetPropertyEngagementQueryVariables>(GetPropertyEngagementDocument, options);
        }
export type GetPropertyEngagementQueryHookResult = ReturnType<typeof useGetPropertyEngagementQuery>;
export type GetPropertyEngagementLazyQueryHookResult = ReturnType<typeof useGetPropertyEngagementLazyQuery>;
export type GetPropertyEngagementSuspenseQueryHookResult = ReturnType<typeof useGetPropertyEngagementSuspenseQuery>;
export type GetPropertyEngagementQueryResult = Apollo.QueryResult<GetPropertyEngagementQuery, GetPropertyEngagementQueryVariables>;